import * as _path2 from "path";
var _path = "default" in _path2 ? _path2.default : _path2;
import * as _fs2 from "fs";
var _fs = "default" in _fs2 ? _fs2.default : _fs2;
import * as _vm2 from "vm";
var _vm = "default" in _vm2 ? _vm2.default : _vm2;
import * as _child_process2 from "child_process";
var _child_process = "default" in _child_process2 ? _child_process2.default : _child_process2;
import * as _http2 from "http";
var _http = "default" in _http2 ? _http2.default : _http2;
import * as _crypto2 from "crypto";
var _crypto = "default" in _crypto2 ? _crypto2.default : _crypto2;
import * as _events2 from "events";
var _events = "default" in _events2 ? _events2.default : _events2;
import * as _https2 from "https";
var _https = "default" in _https2 ? _https2.default : _https2;
import * as _stream2 from "stream";
var _stream = "default" in _stream2 ? _stream2.default : _stream2;
import * as _util2 from "util";
var _util = "default" in _util2 ? _util2.default : _util2;
import * as _net2 from "net";
var _net = "default" in _net2 ? _net2.default : _net2;
import * as _tls2 from "tls";
var _tls = "default" in _tls2 ? _tls2.default : _tls2;
import * as _url2 from "url";
var _url = "default" in _url2 ? _url2.default : _url2;
import * as _zlib2 from "zlib";
var _zlib = "default" in _zlib2 ? _zlib2.default : _zlib2;
import _process from "process";
import _buffer from "buffer";
var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
var Buffer = _buffer.Buffer;
var process = _process;
exports = function (e) {
  var r = {},
    t = {
      1: 0
    };
  function n(t) {
    if (r[t]) return r[t].exports;
    var a = r[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return e[t].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
  }
  return n.e = function (r) {
    var n = [],
      a = t[r];
    if (0 !== a) if (a) n.push(a[2]);else {
      var i = new Promise(function (n, i) {
        a = t[r] = [n, i];
        var o = _path.join(new URL(import.meta.url.slice(0, import.meta.url.lastIndexOf("/"))).pathname, "/" + ({
          0: "parseHookNames"
        }[r] || r) + ".chunk.js");
        _fs.readFile(o, "utf-8", function (r, n) {
          if (r) return i(r);
          var a = {};
          _vm.runInThisContext("(function(exports, require, __dirname, __filename) {" + n + "\n})", o)(a, null, _path.dirname(o), o);
          var s = a.modules,
            l = a.ids;
          for (var c in s) e[c] = s[c];
          for (var u = [], f = 0; f < l.length; f++) t[l[f]] && (u = u.concat(t[l[f]][0])), t[l[f]] = 0;
          for (f = 0; f < u.length; f++) u[f]();
        });
      });
      n.push(a[2] = i);
    }
    return Promise.all(n);
  }, n.m = e, n.c = r, n.d = function (e, r, t) {
    n.o(e, r) || Object.defineProperty(e, r, {
      enumerable: !0,
      get: t
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, r) {
    if (1 & r && (e = n(e)), 8 & r) return e;
    if (4 & r && "object" == typeof e && e && e.__esModule) return e;
    var t = Object.create(null);
    if (n.r(t), Object.defineProperty(t, "default", {
      enumerable: !0,
      value: e
    }), 2 & r && "string" != typeof e) for (var a in e) n.d(t, a, function (r) {
      return e[r];
    }.bind(null, a));
    return t;
  }, n.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(r, "a", r), r;
  }, n.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, n.p = "", n.oe = function (e) {
    process.nextTick(function () {
      throw e;
    });
  }, n(n.s = 208);
}([function (e, r, t) {
  "use strict";

  e.exports = t(110);
}, function (e, r, t) {
  "use strict";

  t.d(r, "b", function () {
    return n;
  }), t.d(r, "e", function () {
    return a;
  }), t.d(r, "f", function () {
    return i;
  }), t.d(r, "F", function () {
    return o;
  }), t.d(r, "G", function () {
    return s;
  }), t.d(r, "x", function () {
    return l;
  }), t.d(r, "y", function () {
    return c;
  }), t.d(r, "A", function () {
    return u;
  }), t.d(r, "D", function () {
    return f;
  }), t.d(r, "C", function () {
    return d;
  }), t.d(r, "z", function () {
    return v;
  }), t.d(r, "B", function () {
    return h;
  }), t.d(r, "r", function () {
    return m;
  }), t.d(r, "s", function () {
    return _;
  }), t.d(r, "i", function () {
    return p;
  }), t.d(r, "h", function () {
    return g;
  }), t.d(r, "k", function () {
    return b;
  }), t.d(r, "l", function () {
    return S;
  }), t.d(r, "u", function () {
    return E;
  }), t.d(r, "v", function () {
    return w;
  }), t.d(r, "n", function () {
    return y;
  }), t.d(r, "g", function () {
    return k;
  }), t.d(r, "m", function () {
    return C;
  }), t.d(r, "o", function () {
    return D;
  }), t.d(r, "p", function () {
    return A;
  }), t.d(r, "j", function () {
    return M;
  }), t.d(r, "q", function () {
    return x;
  }), t.d(r, "a", function () {
    return O;
  }), t.d(r, "E", function () {
    return T;
  }), t.d(r, "t", function () {
    return N;
  }), t.d(r, "w", function () {
    return R;
  }), t.d(r, "c", function () {
    return I;
  }), t.d(r, "d", function () {
    return H;
  });
  const n = "fmkadmapgofadopljbjfkapdkoienihi",
    a = "dnjnjgbfilfphmojnmhliehogmojhclc",
    i = "ikiahnapldjmdmpkmfhjdjilojjhgcbf",
    o = !1,
    s = !1,
    l = 1,
    c = 2,
    u = 3,
    f = 4,
    d = 5,
    v = 6,
    h = 7,
    m = 1,
    _ = 2,
    p = "React::DevTools::defaultTab",
    g = "React::DevTools::componentFilters",
    b = "React::DevTools::openInEditorUrl",
    S = "React::DevTools::parseHookNames",
    E = "React::DevTools::recordChangeDescriptions",
    w = "React::DevTools::reloadAndProfile",
    y = "React::DevTools::breakOnConsoleErrors",
    k = "React::DevTools::theme",
    C = "React::DevTools::appendComponentStack",
    D = "React::DevTools::showInlineWarningsAndErrors",
    A = "React::DevTools::traceUpdatesEnabled",
    M = "React::DevTools::hideConsoleLogsInStrictMode",
    x = 5,
    O = "https://github.com/facebook/react/blob/main/packages/react-devtools/CHANGELOG.md",
    T = "https://reactjs.org/blog/2019/08/15/new-react-devtools.html#how-do-i-get-the-old-version-back",
    N = "https://fburl.com/react-devtools-workplace-group",
    R = {
      light: {
        "--color-attribute-name": "#ef6632",
        "--color-attribute-name-not-editable": "#23272f",
        "--color-attribute-name-inverted": "rgba(255, 255, 255, 0.7)",
        "--color-attribute-value": "#1a1aa6",
        "--color-attribute-value-inverted": "#ffffff",
        "--color-attribute-editable-value": "#1a1aa6",
        "--color-background": "#ffffff",
        "--color-background-hover": "rgba(0, 136, 250, 0.1)",
        "--color-background-inactive": "#e5e5e5",
        "--color-background-invalid": "#fff0f0",
        "--color-background-selected": "#0088fa",
        "--color-button-background": "#ffffff",
        "--color-button-background-focus": "#ededed",
        "--color-button": "#5f6673",
        "--color-button-disabled": "#cfd1d5",
        "--color-button-active": "#0088fa",
        "--color-button-focus": "#23272f",
        "--color-button-hover": "#23272f",
        "--color-border": "#eeeeee",
        "--color-commit-did-not-render-fill": "#cfd1d5",
        "--color-commit-did-not-render-fill-text": "#000000",
        "--color-commit-did-not-render-pattern": "#cfd1d5",
        "--color-commit-did-not-render-pattern-text": "#333333",
        "--color-commit-gradient-0": "#37afa9",
        "--color-commit-gradient-1": "#63b19e",
        "--color-commit-gradient-2": "#80b393",
        "--color-commit-gradient-3": "#97b488",
        "--color-commit-gradient-4": "#abb67d",
        "--color-commit-gradient-5": "#beb771",
        "--color-commit-gradient-6": "#cfb965",
        "--color-commit-gradient-7": "#dfba57",
        "--color-commit-gradient-8": "#efbb49",
        "--color-commit-gradient-9": "#febc38",
        "--color-commit-gradient-text": "#000000",
        "--color-component-name": "#6a51b2",
        "--color-component-name-inverted": "#ffffff",
        "--color-component-badge-background": "rgba(0, 0, 0, 0.1)",
        "--color-component-badge-background-inverted": "rgba(255, 255, 255, 0.25)",
        "--color-component-badge-count": "#777d88",
        "--color-component-badge-count-inverted": "rgba(255, 255, 255, 0.7)",
        "--color-console-error-badge-text": "#ffffff",
        "--color-console-error-background": "#fff0f0",
        "--color-console-error-border": "#ffd6d6",
        "--color-console-error-icon": "#eb3941",
        "--color-console-error-text": "#fe2e31",
        "--color-console-warning-badge-text": "#000000",
        "--color-console-warning-background": "#fffbe5",
        "--color-console-warning-border": "#fff5c1",
        "--color-console-warning-icon": "#f4bd00",
        "--color-console-warning-text": "#64460c",
        "--color-context-background": "rgba(0,0,0,.9)",
        "--color-context-background-hover": "rgba(255, 255, 255, 0.1)",
        "--color-context-background-selected": "#178fb9",
        "--color-context-border": "#3d424a",
        "--color-context-text": "#ffffff",
        "--color-context-text-selected": "#ffffff",
        "--color-dim": "#777d88",
        "--color-dimmer": "#cfd1d5",
        "--color-dimmest": "#eff0f1",
        "--color-error-background": "hsl(0, 100%, 97%)",
        "--color-error-border": "hsl(0, 100%, 92%)",
        "--color-error-text": "#ff0000",
        "--color-expand-collapse-toggle": "#777d88",
        "--color-link": "#0000ff",
        "--color-modal-background": "rgba(255, 255, 255, 0.75)",
        "--color-bridge-version-npm-background": "#eff0f1",
        "--color-bridge-version-npm-text": "#000000",
        "--color-bridge-version-number": "#0088fa",
        "--color-primitive-hook-badge-background": "#e5e5e5",
        "--color-primitive-hook-badge-text": "#5f6673",
        "--color-record-active": "#fc3a4b",
        "--color-record-hover": "#3578e5",
        "--color-record-inactive": "#0088fa",
        "--color-resize-bar": "#eeeeee",
        "--color-resize-bar-active": "#dcdcdc",
        "--color-resize-bar-border": "#d1d1d1",
        "--color-resize-bar-dot": "#333333",
        "--color-timeline-internal-module": "#d1d1d1",
        "--color-timeline-internal-module-hover": "#c9c9c9",
        "--color-timeline-internal-module-text": "#444",
        "--color-timeline-native-event": "#ccc",
        "--color-timeline-native-event-hover": "#aaa",
        "--color-timeline-network-primary": "#fcf3dc",
        "--color-timeline-network-primary-hover": "#f0e7d1",
        "--color-timeline-network-secondary": "#efc457",
        "--color-timeline-network-secondary-hover": "#e3ba52",
        "--color-timeline-priority-background": "#f6f6f6",
        "--color-timeline-priority-border": "#eeeeee",
        "--color-timeline-user-timing": "#c9cacd",
        "--color-timeline-user-timing-hover": "#93959a",
        "--color-timeline-react-idle": "#d3e5f6",
        "--color-timeline-react-idle-hover": "#c3d9ef",
        "--color-timeline-react-render": "#9fc3f3",
        "--color-timeline-react-render-hover": "#83afe9",
        "--color-timeline-react-render-text": "#11365e",
        "--color-timeline-react-commit": "#c88ff0",
        "--color-timeline-react-commit-hover": "#b281d6",
        "--color-timeline-react-commit-text": "#3e2c4a",
        "--color-timeline-react-layout-effects": "#b281d6",
        "--color-timeline-react-layout-effects-hover": "#9d71bd",
        "--color-timeline-react-layout-effects-text": "#3e2c4a",
        "--color-timeline-react-passive-effects": "#b281d6",
        "--color-timeline-react-passive-effects-hover": "#9d71bd",
        "--color-timeline-react-passive-effects-text": "#3e2c4a",
        "--color-timeline-react-schedule": "#9fc3f3",
        "--color-timeline-react-schedule-hover": "#2683E2",
        "--color-timeline-react-suspense-rejected": "#f1cc14",
        "--color-timeline-react-suspense-rejected-hover": "#ffdf37",
        "--color-timeline-react-suspense-resolved": "#a6e59f",
        "--color-timeline-react-suspense-resolved-hover": "#89d281",
        "--color-timeline-react-suspense-unresolved": "#c9cacd",
        "--color-timeline-react-suspense-unresolved-hover": "#93959a",
        "--color-timeline-thrown-error": "#ee1638",
        "--color-timeline-thrown-error-hover": "#da1030",
        "--color-timeline-text-color": "#000000",
        "--color-timeline-text-dim-color": "#ccc",
        "--color-timeline-react-work-border": "#eeeeee",
        "--color-search-match": "yellow",
        "--color-search-match-current": "#f7923b",
        "--color-selected-tree-highlight-active": "rgba(0, 136, 250, 0.1)",
        "--color-selected-tree-highlight-inactive": "rgba(0, 0, 0, 0.05)",
        "--color-scroll-caret": "rgba(150, 150, 150, 0.5)",
        "--color-tab-selected-border": "#0088fa",
        "--color-text": "#000000",
        "--color-text-invalid": "#ff0000",
        "--color-text-selected": "#ffffff",
        "--color-toggle-background-invalid": "#fc3a4b",
        "--color-toggle-background-on": "#0088fa",
        "--color-toggle-background-off": "#cfd1d5",
        "--color-toggle-text": "#ffffff",
        "--color-warning-background": "#fb3655",
        "--color-warning-background-hover": "#f82042",
        "--color-warning-text-color": "#ffffff",
        "--color-warning-text-color-inverted": "#fd4d69",
        "--color-scroll-thumb": "#c2c2c2",
        "--color-scroll-track": "#fafafa",
        "--color-tooltip-background": "rgba(0, 0, 0, 0.9)",
        "--color-tooltip-text": "#ffffff"
      },
      dark: {
        "--color-attribute-name": "#9d87d2",
        "--color-attribute-name-not-editable": "#ededed",
        "--color-attribute-name-inverted": "#282828",
        "--color-attribute-value": "#cedae0",
        "--color-attribute-value-inverted": "#ffffff",
        "--color-attribute-editable-value": "yellow",
        "--color-background": "#282c34",
        "--color-background-hover": "rgba(255, 255, 255, 0.1)",
        "--color-background-inactive": "#3d424a",
        "--color-background-invalid": "#5c0000",
        "--color-background-selected": "#178fb9",
        "--color-button-background": "#282c34",
        "--color-button-background-focus": "#3d424a",
        "--color-button": "#afb3b9",
        "--color-button-active": "#61dafb",
        "--color-button-disabled": "#4f5766",
        "--color-button-focus": "#a2e9fc",
        "--color-button-hover": "#ededed",
        "--color-border": "#3d424a",
        "--color-commit-did-not-render-fill": "#777d88",
        "--color-commit-did-not-render-fill-text": "#000000",
        "--color-commit-did-not-render-pattern": "#666c77",
        "--color-commit-did-not-render-pattern-text": "#ffffff",
        "--color-commit-gradient-0": "#37afa9",
        "--color-commit-gradient-1": "#63b19e",
        "--color-commit-gradient-2": "#80b393",
        "--color-commit-gradient-3": "#97b488",
        "--color-commit-gradient-4": "#abb67d",
        "--color-commit-gradient-5": "#beb771",
        "--color-commit-gradient-6": "#cfb965",
        "--color-commit-gradient-7": "#dfba57",
        "--color-commit-gradient-8": "#efbb49",
        "--color-commit-gradient-9": "#febc38",
        "--color-commit-gradient-text": "#000000",
        "--color-component-name": "#61dafb",
        "--color-component-name-inverted": "#282828",
        "--color-component-badge-background": "rgba(255, 255, 255, 0.25)",
        "--color-component-badge-background-inverted": "rgba(0, 0, 0, 0.25)",
        "--color-component-badge-count": "#8f949d",
        "--color-component-badge-count-inverted": "rgba(255, 255, 255, 0.7)",
        "--color-console-error-badge-text": "#000000",
        "--color-console-error-background": "#290000",
        "--color-console-error-border": "#5c0000",
        "--color-console-error-icon": "#eb3941",
        "--color-console-error-text": "#fc7f7f",
        "--color-console-warning-badge-text": "#000000",
        "--color-console-warning-background": "#332b00",
        "--color-console-warning-border": "#665500",
        "--color-console-warning-icon": "#f4bd00",
        "--color-console-warning-text": "#f5f2ed",
        "--color-context-background": "rgba(255,255,255,.95)",
        "--color-context-background-hover": "rgba(0, 136, 250, 0.1)",
        "--color-context-background-selected": "#0088fa",
        "--color-context-border": "#eeeeee",
        "--color-context-text": "#000000",
        "--color-context-text-selected": "#ffffff",
        "--color-dim": "#8f949d",
        "--color-dimmer": "#777d88",
        "--color-dimmest": "#4f5766",
        "--color-error-background": "#200",
        "--color-error-border": "#900",
        "--color-error-text": "#f55",
        "--color-expand-collapse-toggle": "#8f949d",
        "--color-link": "#61dafb",
        "--color-modal-background": "rgba(0, 0, 0, 0.75)",
        "--color-bridge-version-npm-background": "rgba(0, 0, 0, 0.25)",
        "--color-bridge-version-npm-text": "#ffffff",
        "--color-bridge-version-number": "yellow",
        "--color-primitive-hook-badge-background": "rgba(0, 0, 0, 0.25)",
        "--color-primitive-hook-badge-text": "rgba(255, 255, 255, 0.7)",
        "--color-record-active": "#fc3a4b",
        "--color-record-hover": "#a2e9fc",
        "--color-record-inactive": "#61dafb",
        "--color-resize-bar": "#282c34",
        "--color-resize-bar-active": "#31363f",
        "--color-resize-bar-border": "#3d424a",
        "--color-resize-bar-dot": "#cfd1d5",
        "--color-timeline-internal-module": "#303542",
        "--color-timeline-internal-module-hover": "#363b4a",
        "--color-timeline-internal-module-text": "#7f8899",
        "--color-timeline-native-event": "#b2b2b2",
        "--color-timeline-native-event-hover": "#949494",
        "--color-timeline-network-primary": "#fcf3dc",
        "--color-timeline-network-primary-hover": "#e3dbc5",
        "--color-timeline-network-secondary": "#efc457",
        "--color-timeline-network-secondary-hover": "#d6af4d",
        "--color-timeline-priority-background": "#1d2129",
        "--color-timeline-priority-border": "#282c34",
        "--color-timeline-user-timing": "#c9cacd",
        "--color-timeline-user-timing-hover": "#93959a",
        "--color-timeline-react-idle": "#3d485b",
        "--color-timeline-react-idle-hover": "#465269",
        "--color-timeline-react-render": "#2683E2",
        "--color-timeline-react-render-hover": "#1a76d4",
        "--color-timeline-react-render-text": "#11365e",
        "--color-timeline-react-commit": "#731fad",
        "--color-timeline-react-commit-hover": "#611b94",
        "--color-timeline-react-commit-text": "#e5c1ff",
        "--color-timeline-react-layout-effects": "#611b94",
        "--color-timeline-react-layout-effects-hover": "#51167a",
        "--color-timeline-react-layout-effects-text": "#e5c1ff",
        "--color-timeline-react-passive-effects": "#611b94",
        "--color-timeline-react-passive-effects-hover": "#51167a",
        "--color-timeline-react-passive-effects-text": "#e5c1ff",
        "--color-timeline-react-schedule": "#2683E2",
        "--color-timeline-react-schedule-hover": "#1a76d4",
        "--color-timeline-react-suspense-rejected": "#f1cc14",
        "--color-timeline-react-suspense-rejected-hover": "#e4c00f",
        "--color-timeline-react-suspense-resolved": "#a6e59f",
        "--color-timeline-react-suspense-resolved-hover": "#89d281",
        "--color-timeline-react-suspense-unresolved": "#c9cacd",
        "--color-timeline-react-suspense-unresolved-hover": "#93959a",
        "--color-timeline-thrown-error": "#fb3655",
        "--color-timeline-thrown-error-hover": "#f82042",
        "--color-timeline-text-color": "#282c34",
        "--color-timeline-text-dim-color": "#555b66",
        "--color-timeline-react-work-border": "#3d424a",
        "--color-search-match": "yellow",
        "--color-search-match-current": "#f7923b",
        "--color-selected-tree-highlight-active": "rgba(23, 143, 185, 0.15)",
        "--color-selected-tree-highlight-inactive": "rgba(255, 255, 255, 0.05)",
        "--color-scroll-caret": "#4f5766",
        "--color-shadow": "rgba(0, 0, 0, 0.5)",
        "--color-tab-selected-border": "#178fb9",
        "--color-text": "#ffffff",
        "--color-text-invalid": "#ff8080",
        "--color-text-selected": "#ffffff",
        "--color-toggle-background-invalid": "#fc3a4b",
        "--color-toggle-background-on": "#178fb9",
        "--color-toggle-background-off": "#777d88",
        "--color-toggle-text": "#ffffff",
        "--color-warning-background": "#ee1638",
        "--color-warning-background-hover": "#da1030",
        "--color-warning-text-color": "#ffffff",
        "--color-warning-text-color-inverted": "#ee1638",
        "--color-scroll-thumb": "#afb3b9",
        "--color-scroll-track": "#313640",
        "--color-tooltip-background": "rgba(255, 255, 255, 0.95)",
        "--color-tooltip-text": "#000000"
      },
      compact: {
        "--font-size-monospace-small": "9px",
        "--font-size-monospace-normal": "11px",
        "--font-size-monospace-large": "15px",
        "--font-size-sans-small": "10px",
        "--font-size-sans-normal": "12px",
        "--font-size-sans-large": "14px",
        "--line-height-data": "18px"
      },
      comfortable: {
        "--font-size-monospace-small": "10px",
        "--font-size-monospace-normal": "13px",
        "--font-size-monospace-large": "17px",
        "--font-size-sans-small": "12px",
        "--font-size-sans-normal": "14px",
        "--font-size-sans-large": "16px",
        "--line-height-data": "22px"
      }
    },
    I = parseInt(R.comfortable["--line-height-data"], 10),
    H = parseInt(R.compact["--line-height-data"], 10);
}, function (e, r) {
  e.exports = function (e) {
    var r = [];
    return r.toString = function () {
      return this.map(function (r) {
        var t = function (e, r) {
          var t = e[1] || "",
            n = e[3];
          if (!n) return t;
          if (r && "function" == typeof btoa) {
            var a = (o = n, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */"),
              i = n.sources.map(function (e) {
                return "/*# sourceURL=" + n.sourceRoot + e + " */";
              });
            return [t].concat(i).concat([a]).join("\n");
          }
          var o;
          return [t].join("\n");
        }(r, e);
        return r[2] ? "@media " + r[2] + "{" + t + "}" : t;
      }).join("");
    }, r.i = function (e, t) {
      "string" == typeof e && (e = [[null, e, ""]]);
      for (var n = {}, a = 0; a < (this || _global).length; a++) {
        var i = (this || _global)[a][0];
        "number" == typeof i && (n[i] = !0);
      }
      for (a = 0; a < e.length; a++) {
        var o = e[a];
        "number" == typeof o[0] && n[o[0]] || (t && !o[2] ? o[2] = t : t && (o[2] = "(" + o[2] + ") and (" + t + ")"), r.push(o));
      }
    }, r;
  };
}, function (e, r, t) {
  var n,
    a,
    i = {},
    o = (n = function () {
      return window && document && document.all && !window.atob;
    }, function () {
      return void 0 === a && (a = n.apply(this || _global, arguments)), a;
    }),
    s = function (e, r) {
      return r ? r.querySelector(e) : document.querySelector(e);
    },
    l = function (e) {
      var r = {};
      return function (e, t) {
        if ("function" == typeof e) return e();
        if (void 0 === r[e]) {
          var n = s.call(this || _global, e, t);
          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (e) {
            n = null;
          }
          r[e] = n;
        }
        return r[e];
      };
    }(),
    c = null,
    u = 0,
    f = [],
    d = t(129);
  function v(e, r) {
    for (var t = 0; t < e.length; t++) {
      var n = e[t],
        a = i[n.id];
      if (a) {
        a.refs++;
        for (var o = 0; o < a.parts.length; o++) a.parts[o](n.parts[o]);
        for (; o < n.parts.length; o++) a.parts.push(b(n.parts[o], r));
      } else {
        var s = [];
        for (o = 0; o < n.parts.length; o++) s.push(b(n.parts[o], r));
        i[n.id] = {
          id: n.id,
          refs: 1,
          parts: s
        };
      }
    }
  }
  function h(e, r) {
    for (var t = [], n = {}, a = 0; a < e.length; a++) {
      var i = e[a],
        o = r.base ? i[0] + r.base : i[0],
        s = {
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
      n[o] ? n[o].parts.push(s) : t.push(n[o] = {
        id: o,
        parts: [s]
      });
    }
    return t;
  }
  function m(e, r) {
    var t = l(e.insertInto);
    if (!t) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var n = f[f.length - 1];
    if ("top" === e.insertAt) n ? n.nextSibling ? t.insertBefore(r, n.nextSibling) : t.appendChild(r) : t.insertBefore(r, t.firstChild), f.push(r);else if ("bottom" === e.insertAt) t.appendChild(r);else {
      if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var a = l(e.insertAt.before, t);
      t.insertBefore(r, a);
    }
  }
  function _(e) {
    if (null === e.parentNode) return !1;
    e.parentNode.removeChild(e);
    var r = f.indexOf(e);
    r >= 0 && f.splice(r, 1);
  }
  function p(e) {
    var r = document.createElement("style");
    if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
      var n = function () {
        0;
        return t.nc;
      }();
      n && (e.attrs.nonce = n);
    }
    return g(r, e.attrs), m(e, r), r;
  }
  function g(e, r) {
    Object.keys(r).forEach(function (t) {
      e.setAttribute(t, r[t]);
    });
  }
  function b(e, r) {
    var t, n, a, i;
    if (r.transform && e.css) {
      if (!(i = "function" == typeof r.transform ? r.transform(e.css) : r.transform.default(e.css))) return function () {};
      e.css = i;
    }
    if (r.singleton) {
      var o = u++;
      t = c || (c = p(r)), n = w.bind(null, t, o, !1), a = w.bind(null, t, o, !0);
    } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (t = function (e) {
      var r = document.createElement("link");
      return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", g(r, e.attrs), m(e, r), r;
    }(r), n = k.bind(null, t, r), a = function () {
      _(t), t.href && URL.revokeObjectURL(t.href);
    }) : (t = p(r), n = y.bind(null, t), a = function () {
      _(t);
    });
    return n(e), function (r) {
      if (r) {
        if (r.css === e.css && r.media === e.media && r.sourceMap === e.sourceMap) return;
        n(e = r);
      } else a();
    };
  }
  e.exports = function (e, r) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (r = r || {}).attrs = "object" == typeof r.attrs ? r.attrs : {}, r.singleton || "boolean" == typeof r.singleton || (r.singleton = o()), r.insertInto || (r.insertInto = "head"), r.insertAt || (r.insertAt = "bottom");
    var t = h(e, r);
    return v(t, r), function (e) {
      for (var n = [], a = 0; a < t.length; a++) {
        var o = t[a];
        (s = i[o.id]).refs--, n.push(s);
      }
      e && v(h(e, r), r);
      for (a = 0; a < n.length; a++) {
        var s;
        if (0 === (s = n[a]).refs) {
          for (var l = 0; l < s.parts.length; l++) s.parts[l]();
          delete i[s.id];
        }
      }
    };
  };
  var S,
    E = (S = [], function (e, r) {
      return S[e] = r, S.filter(Boolean).join("\n");
    });
  function w(e, r, t, n) {
    var a = t ? "" : n.css;
    if (e.styleSheet) e.styleSheet.cssText = E(r, a);else {
      var i = document.createTextNode(a),
        o = e.childNodes;
      o[r] && e.removeChild(o[r]), o.length ? e.insertBefore(i, o[r]) : e.appendChild(i);
    }
  }
  function y(e, r) {
    var t = r.css,
      n = r.media;
    if (n && e.setAttribute("media", n), e.styleSheet) e.styleSheet.cssText = t;else {
      for (; e.firstChild;) e.removeChild(e.firstChild);
      e.appendChild(document.createTextNode(t));
    }
  }
  function k(e, r, t) {
    var n = t.css,
      a = t.sourceMap,
      i = void 0 === r.convertToAbsoluteUrls && a;
    (r.convertToAbsoluteUrls || i) && (n = d(n)), a && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(a)))) + " */");
    var o = new Blob([n], {
        type: "text/css"
      }),
      s = e.href;
    e.href = URL.createObjectURL(o), s && URL.revokeObjectURL(s);
  }
}, function (e, r, t) {
  var n = t(182);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(168);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(145);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(180);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  "use strict";

  t.d(r, "a", function () {
    return n;
  }), t.d(r, "b", function () {
    return a;
  }), t.d(r, "c", function () {
    return i;
  }), t.d(r, "d", function () {
    return o;
  }), t.d(r, "f", function () {
    return s;
  }), t.d(r, "g", function () {
    return l;
  }), t.d(r, "e", function () {
    return c;
  });
  const n = !1,
    a = !1,
    i = !0,
    o = !0,
    s = !1,
    l = !1,
    c = !0;
}, function (e, r, t) {
  var n = t(159);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(199);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  e.exports = function () {
    if ("undefined" == typeof document || !document.addEventListener) return null;
    var r,
      t,
      n,
      a = {};
    return a.copy = function () {
      var e = !1,
        r = null,
        t = !1;
      function n() {
        e = !1, r = null, t && window.getSelection().removeAllRanges(), t = !1;
      }
      return document.addEventListener("copy", function (t) {
        if (e) {
          for (var n in r) t.clipboardData.setData(n, r[n]);
          t.preventDefault();
        }
      }), function (a) {
        return new Promise(function (i, o) {
          e = !0, "string" == typeof a ? r = {
            "text/plain": a
          } : a instanceof Node ? r = {
            "text/html": new XMLSerializer().serializeToString(a)
          } : a instanceof Object ? r = a : o("Invalid data type. Must be string, DOM node, or an object mapping MIME types to strings."), function e(r) {
            try {
              if (document.execCommand("copy")) n(), i();else {
                if (r) throw n(), new Error("Unable to copy. Perhaps it's not available in your browser?");
                !function () {
                  var e = document.getSelection();
                  if (!document.queryCommandEnabled("copy") && e.isCollapsed) {
                    var r = document.createRange();
                    r.selectNodeContents(document.body), e.removeAllRanges(), e.addRange(r), t = !0;
                  }
                }(), e(!0);
              }
            } catch (e) {
              n(), o(e);
            }
          }(!1);
        });
      };
    }(), a.paste = (n = !1, document.addEventListener("paste", function (e) {
      if (n) {
        n = !1, e.preventDefault();
        var a = r;
        r = null, a(e.clipboardData.getData(t));
      }
    }), function (e) {
      return new Promise(function (a, i) {
        n = !0, r = a, t = e || "text/plain";
        try {
          document.execCommand("paste") || (n = !1, i(new Error("Unable to paste. Pasting only works in Internet Explorer at the moment.")));
        } catch (e) {
          n = !1, i(new Error(e));
        }
      });
    }), "undefined" == typeof ClipboardEvent && void 0 !== window.clipboardData && void 0 !== window.clipboardData.setData && ( /*! promise-polyfill 2.0.1 */
    function (r) {
      function t(e, r) {
        return function () {
          e.apply(r, arguments);
        };
      }
      function n(e) {
        if ("object" != typeof (this || _global)) throw new TypeError("Promises must be constructed via new");
        if ("function" != typeof e) throw new TypeError("not a function");
        (this || _global)._state = null, (this || _global)._value = null, (this || _global)._deferreds = [], c(e, t(i, this || _global), t(o, this || _global));
      }
      function a(e) {
        var r = this || _global;
        return null === (this || _global)._state ? void (this || _global)._deferreds.push(e) : void u(function () {
          var t = r._state ? e.onFulfilled : e.onRejected;
          if (null !== t) {
            var n;
            try {
              n = t(r._value);
            } catch (r) {
              return void e.reject(r);
            }
            e.resolve(n);
          } else (r._state ? e.resolve : e.reject)(r._value);
        });
      }
      function i(e) {
        try {
          if (e === (this || _global)) throw new TypeError("A promise cannot be resolved with itself.");
          if (e && ("object" == typeof e || "function" == typeof e)) {
            var r = e.then;
            if ("function" == typeof r) return void c(t(r, e), t(i, this || _global), t(o, this || _global));
          }
          (this || _global)._state = !0, (this || _global)._value = e, s.call(this || _global);
        } catch (e) {
          o.call(this || _global, e);
        }
      }
      function o(e) {
        (this || _global)._state = !1, (this || _global)._value = e, s.call(this || _global);
      }
      function s() {
        for (var e = 0, r = (this || _global)._deferreds.length; r > e; e++) a.call(this || _global, (this || _global)._deferreds[e]);
        (this || _global)._deferreds = null;
      }
      function l(e, r, t, n) {
        (this || _global).onFulfilled = "function" == typeof e ? e : null, (this || _global).onRejected = "function" == typeof r ? r : null, (this || _global).resolve = t, (this || _global).reject = n;
      }
      function c(e, r, t) {
        var n = !1;
        try {
          e(function (e) {
            n || (n = !0, r(e));
          }, function (e) {
            n || (n = !0, t(e));
          });
        } catch (e) {
          if (n) return;
          n = !0, t(e);
        }
      }
      var u = n.immediateFn || "function" == typeof process.nextTick && process.nextTick || function (e) {
          setTimeout(e, 1);
        },
        f = Array.isArray || function (e) {
          return "[object Array]" === Object.prototype.toString.call(e);
        };
      n.prototype.catch = function (e) {
        return this.then(null, e);
      }, n.prototype.then = function (e, r) {
        var t = this || _global;
        return new n(function (n, i) {
          a.call(t, new l(e, r, n, i));
        });
      }, n.all = function () {
        var e = Array.prototype.slice.call(1 === arguments.length && f(arguments[0]) ? arguments[0] : arguments);
        return new n(function (r, t) {
          function n(i, o) {
            try {
              if (o && ("object" == typeof o || "function" == typeof o)) {
                var s = o.then;
                if ("function" == typeof s) return void s.call(o, function (e) {
                  n(i, e);
                }, t);
              }
              e[i] = o, 0 == --a && r(e);
            } catch (e) {
              t(e);
            }
          }
          if (0 === e.length) return r([]);
          for (var a = e.length, i = 0; i < e.length; i++) n(i, e[i]);
        });
      }, n.resolve = function (e) {
        return e && "object" == typeof e && e.constructor === n ? e : new n(function (r) {
          r(e);
        });
      }, n.reject = function (e) {
        return new n(function (r, t) {
          t(e);
        });
      }, n.race = function (e) {
        return new n(function (r, t) {
          for (var n = 0, a = e.length; a > n; n++) e[n].then(r, t);
        });
      }, e.exports ? e.exports = n : r.Promise || (r.Promise = n);
    }(this || _global), a.copy = function (e) {
      return new Promise(function (r, t) {
        if ("string" != typeof e && !("text/plain" in e)) throw new Error("You must provide a text/plain type.");
        var n = "string" == typeof e ? e : e["text/plain"];
        window.clipboardData.setData("Text", n) ? r() : t(new Error("Copying was rejected."));
      });
    }, a.paste = function () {
      return new Promise(function (e, r) {
        var t = window.clipboardData.getData("Text");
        t ? e(t) : r(new Error("Pasting was rejected."));
      });
    }), a;
  }();
}, function (e, r, t) {
  var n = t(158);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  "use strict";

  !function e() {
    if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) {
      0;
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
      } catch (e) {
        console.error(e);
      }
    }
  }(), e.exports = t(111);
}, function (e, r, t) {
  var n = t(161);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  "use strict";

  t.d(r, "a", function () {
    return i;
  }), t.d(r, "b", function () {
    return o;
  });
  var n = t(8);
  let a = [];
  const i = !0 === n.b ? function (e) {
      a.forEach(r => {
        r(e);
      });
    } : function () {},
    o = !0 === n.b ? function (e) {
      return n.b ? (a.push(e), function () {
        a = a.filter(r => r !== e);
      }) : () => {};
    } : function (e) {
      return () => {};
    };
}, function (e, r, t) {
  var n = t(196);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(135);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(166);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(165);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(144);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(167);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(173);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  "use strict";

  e.exports = t(116);
}, function (e, r, t) {
  var n = t(141);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(202);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(163);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(193);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(164);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(192);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r) {
  var t = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", "[contenteditable]:not([contenteditable=\"false\"])"],
    n = t.join(","),
    a = "undefined" == typeof Element ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  function i(e, r) {
    r = r || {};
    var t,
      i,
      s,
      l = [],
      f = [],
      d = e.querySelectorAll(n);
    for (r.includeContainer && a.call(e, n) && (d = Array.prototype.slice.apply(d)).unshift(e), t = 0; t < d.length; t++) o(i = d[t]) && (0 === (s = c(i)) ? l.push(i) : f.push({
      documentOrder: t,
      tabIndex: s,
      node: i
    }));
    return f.sort(u).map(function (e) {
      return e.node;
    }).concat(l);
  }
  function o(e) {
    return !(!s(e) || function (e) {
      return function (e) {
        return f(e) && "radio" === e.type;
      }(e) && !function (e) {
        if (!e.name) return !0;
        var r = function (e) {
          for (var r = 0; r < e.length; r++) if (e[r].checked) return e[r];
        }(e.ownerDocument.querySelectorAll("input[type=\"radio\"][name=\"" + e.name + "\"]"));
        return !r || r === e;
      }(e);
    }(e) || c(e) < 0);
  }
  function s(e) {
    return !(e.disabled || function (e) {
      return f(e) && "hidden" === e.type;
    }(e) || function (e) {
      return null === e.offsetParent || "hidden" === getComputedStyle(e).visibility;
    }(e));
  }
  i.isTabbable = function (e) {
    if (!e) throw new Error("No node provided");
    return !1 !== a.call(e, n) && o(e);
  }, i.isFocusable = function (e) {
    if (!e) throw new Error("No node provided");
    return !1 !== a.call(e, l) && s(e);
  };
  var l = t.concat("iframe").join(",");
  function c(e) {
    var r = parseInt(e.getAttribute("tabindex"), 10);
    return isNaN(r) ? function (e) {
      return "true" === e.contentEditable;
    }(e) ? 0 : e.tabIndex : r;
  }
  function u(e, r) {
    return e.tabIndex === r.tabIndex ? e.documentOrder - r.documentOrder : e.tabIndex - r.tabIndex;
  }
  function f(e) {
    return "INPUT" === e.tagName;
  }
  e.exports = i;
}, function (e, r, t) {
  var n = t(142);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(160);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(191);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(200);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(170);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(197);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(205);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  "use strict";

  e.exports = {
    BINARY_TYPES: ["nodebuffer", "arraybuffer", "fragments"],
    GUID: "258EAFA5-E914-47DA-95CA-C5AB0DC85B11",
    kStatusCode: Symbol("status-code"),
    kWebSocket: Symbol("websocket"),
    EMPTY_BUFFER: Buffer.alloc(0),
    NOOP: () => {}
  };
}, function (e, r, t) {
  "use strict";

  t.d(r, "c", function () {
    return s;
  }), t.d(r, "d", function () {
    return l;
  }), t.d(r, "b", function () {
    return c;
  }), t.d(r, "a", function () {
    return u;
  });
  var n = t(1),
    a = t(73),
    i = t(15);
  let o = new WeakMap();
  function s(e) {
    const r = o.get(e);
    return null != r && 1 === r.status;
  }
  function l(e, r, t, s) {
    let l = o.get(e);
    if (n.F && (console.groupCollapsed("loadHookNames() record:"), console.log(l), console.groupEnd()), !l) {
      const c = new Set(),
        u = {
          then(e) {
            c.add(e);
          },
          displayName: "Loading hook names for " + (e.displayName || "Unknown")
        };
      let f,
        d = !1,
        v = "unknown",
        h = null;
      const m = () => {
          f && (clearTimeout(f), f = null), c.forEach(e => e()), c.clear();
        },
        _ = r => {
          var t, n;
          Object(i.a)({
            event_name: "load-hook-names",
            event_status: v,
            duration_ms: r,
            inspected_element_display_name: e.displayName,
            inspected_element_number_of_hooks: null !== (t = null === (n = h) || void 0 === n ? void 0 : n.size) && void 0 !== t ? t : null
          });
        },
        p = l = {
          status: 0,
          value: u
        };
      Object(a.b)("loadHookNames", e => {
        t(r, s).then(function (r) {
          if (!d) {
            if (n.F && console.log("[hookNamesCache] onSuccess() hookNames:", r), r) {
              const e = p;
              e.status = 1, e.value = r;
            } else {
              const e = p;
              e.status = 2, e.value = null;
            }
            v = "success", h = r, e(), m();
          }
        }, function (r) {
          if (d) return;
          n.F && console.log("[hookNamesCache] onError()"), console.error(r);
          const t = p;
          t.status = 2, t.value = null, v = "error", e(), m();
        }), f = setTimeout(function () {
          n.F && console.log("[hookNamesCache] onTimeout()"), f = null, d = !0;
          const r = p;
          r.status = 2, r.value = null, v = "timeout", e(), m();
        }, 30000);
      }, _), o.set(e, l);
    }
    return function (e) {
      if (1 === e.status) return e;
      if (2 === e.status) return e;
      throw e.value;
    }(l).value;
  }
  function c({
    fileName: e,
    lineNumber: r,
    columnNumber: t
  }) {
    if (null == e || null == r || null == t) throw Error("Hook source code location not found.");
    return `${e}:${r}:${t}`;
  }
  function u() {
    o = new WeakMap();
  }
}, function (e, r) {
  e.exports = _path;
}, function (e, r, t) {
  "use strict";

  const n = t(181);
  e.exports = (e, r = {}) => {
    if (!Number.isFinite(e)) throw new TypeError("Expected a finite number");
    r.colonNotation && (r.compact = !1, r.formatSubMilliseconds = !1, r.separateMilliseconds = !1, r.verbose = !1), r.compact && (r.secondsDecimalDigits = 0, r.millisecondsDecimalDigits = 0);
    const t = [],
      a = (e, n, a, i) => {
        if (!(0 !== t.length && r.colonNotation || 0 !== e || r.colonNotation && "m" === a)) return;
        let o, s;
        if (i = (i || e || "0").toString(), r.colonNotation) {
          o = t.length > 0 ? ":" : "", s = "";
          const e = i.includes(".") ? i.split(".")[0].length : i.length,
            r = t.length > 0 ? 2 : 1;
          i = "0".repeat(Math.max(0, r - e)) + i;
        } else o = "", s = r.verbose ? " " + (l = n, 1 === e ? l : l + "s") : a;
        var l;
        t.push(o + i + s);
      },
      i = n(e);
    if (a(Math.trunc(i.days / 365), "year", "y"), a(i.days % 365, "day", "d"), a(i.hours, "hour", "h"), a(i.minutes, "minute", "m"), r.separateMilliseconds || r.formatSubMilliseconds || e < 1000) {
      if (a(i.seconds, "second", "s"), r.formatSubMilliseconds) a(i.milliseconds, "millisecond", "ms"), a(i.microseconds, "microsecond", "\xB5s"), a(i.nanoseconds, "nanosecond", "ns");else {
        const e = i.milliseconds + i.microseconds / 1000 + i.nanoseconds / 1000000,
          t = "number" == typeof r.millisecondsDecimalDigits ? r.millisecondsDecimalDigits : 0,
          n = e >= 1 ? Math.round(e) : Math.ceil(e),
          o = t ? e.toFixed(t) : n;
        a(Number.parseFloat(o, 10), "millisecond", "ms", o);
      }
    } else {
      const t = ((e, r) => {
          const t = Math.floor(e * 10 ** r + 1e-7);
          return (Math.round(t) / 10 ** r).toFixed(r);
        })(e / 1000 % 60, "number" == typeof r.secondsDecimalDigits ? r.secondsDecimalDigits : 1),
        n = r.keepDecimalsOnWholeSeconds ? t : t.replace(/\.0+$/, "");
      a(Number.parseFloat(n, 10), "second", "s", n);
    }
    if (0 === t.length) return "0" + (r.verbose ? " milliseconds" : "ms");
    if (r.compact) return t[0];
    if ("number" == typeof r.unitCount) {
      const e = r.colonNotation ? "" : " ";
      return t.slice(0, Math.max(r.unitCount, 1)).join(e);
    }
    return r.colonNotation ? t.join("") : t.join(" ");
  };
}, function (e, r, t) {
  var n = t(148);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(169);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r) {
  e.exports = _fs;
}, function (e, r, t) {
  var n = t(136);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(172);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(174);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(194);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(198);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  "use strict";

  const n = t(120),
    a = t(51),
    i = t(121),
    {
      kStatusCode: o,
      NOOP: s
    } = t(38),
    l = Buffer.from([0, 0, 255, 255]),
    c = Symbol("permessage-deflate"),
    u = Symbol("total-length"),
    f = Symbol("callback"),
    d = Symbol("buffers"),
    v = Symbol("error");
  let h;
  function m(e) {
    (this || _global)[d].push(e), (this || _global)[u] += e.length;
  }
  function _(e) {
    (this || _global)[u] += e.length, (this || _global)[c]._maxPayload < 1 || (this || _global)[u] <= (this || _global)[c]._maxPayload ? (this || _global)[d].push(e) : ((this || _global)[v] = new RangeError("Max payload size exceeded"), (this || _global)[v][o] = 1009, this.removeListener("data", _), this.reset());
  }
  function p(e) {
    (this || _global)[c]._inflate = null, e[o] = 1007, this[f](e);
  }
  e.exports = class {
    constructor(e, r, t) {
      if (this._maxPayload = 0 | t, this._options = e || {}, this._threshold = void 0 !== this._options.threshold ? this._options.threshold : 1024, this._isServer = !!r, this._deflate = null, this._inflate = null, this.params = null, !h) {
        const e = void 0 !== this._options.concurrencyLimit ? this._options.concurrencyLimit : 10;
        h = new i(e);
      }
    }
    static get extensionName() {
      return "permessage-deflate";
    }
    offer() {
      const e = {};
      return this._options.serverNoContextTakeover && (e.server_no_context_takeover = !0), this._options.clientNoContextTakeover && (e.client_no_context_takeover = !0), this._options.serverMaxWindowBits && (e.server_max_window_bits = this._options.serverMaxWindowBits), this._options.clientMaxWindowBits ? e.client_max_window_bits = this._options.clientMaxWindowBits : null == this._options.clientMaxWindowBits && (e.client_max_window_bits = !0), e;
    }
    accept(e) {
      return e = this.normalizeParams(e), this.params = this._isServer ? this.acceptAsServer(e) : this.acceptAsClient(e), this.params;
    }
    cleanup() {
      this._inflate && (this._inflate.close(), this._inflate = null), this._deflate && (this._deflate[f] && this._deflate[f](), this._deflate.close(), this._deflate = null);
    }
    acceptAsServer(e) {
      const r = this._options,
        t = e.find(e => !(!1 === r.serverNoContextTakeover && e.server_no_context_takeover || e.server_max_window_bits && (!1 === r.serverMaxWindowBits || "number" == typeof r.serverMaxWindowBits && r.serverMaxWindowBits > e.server_max_window_bits) || "number" == typeof r.clientMaxWindowBits && !e.client_max_window_bits));
      if (!t) throw new Error("None of the extension offers can be accepted");
      return r.serverNoContextTakeover && (t.server_no_context_takeover = !0), r.clientNoContextTakeover && (t.client_no_context_takeover = !0), "number" == typeof r.serverMaxWindowBits && (t.server_max_window_bits = r.serverMaxWindowBits), "number" == typeof r.clientMaxWindowBits ? t.client_max_window_bits = r.clientMaxWindowBits : !0 !== t.client_max_window_bits && !1 !== r.clientMaxWindowBits || delete t.client_max_window_bits, t;
    }
    acceptAsClient(e) {
      const r = e[0];
      if (!1 === this._options.clientNoContextTakeover && r.client_no_context_takeover) throw new Error("Unexpected parameter \"client_no_context_takeover\"");
      if (r.client_max_window_bits) {
        if (!1 === this._options.clientMaxWindowBits || "number" == typeof this._options.clientMaxWindowBits && r.client_max_window_bits > this._options.clientMaxWindowBits) throw new Error("Unexpected or invalid parameter \"client_max_window_bits\"");
      } else "number" == typeof this._options.clientMaxWindowBits && (r.client_max_window_bits = this._options.clientMaxWindowBits);
      return r;
    }
    normalizeParams(e) {
      return e.forEach(e => {
        Object.keys(e).forEach(r => {
          let t = e[r];
          if (t.length > 1) throw new Error(`Parameter "${r}" must have only a single value`);
          if (t = t[0], "client_max_window_bits" === r) {
            if (!0 !== t) {
              const e = +t;
              if (!Number.isInteger(e) || e < 8 || e > 15) throw new TypeError(`Invalid value for parameter "${r}": ${t}`);
              t = e;
            } else if (!this._isServer) throw new TypeError(`Invalid value for parameter "${r}": ${t}`);
          } else if ("server_max_window_bits" === r) {
            const e = +t;
            if (!Number.isInteger(e) || e < 8 || e > 15) throw new TypeError(`Invalid value for parameter "${r}": ${t}`);
            t = e;
          } else {
            if ("client_no_context_takeover" !== r && "server_no_context_takeover" !== r) throw new Error(`Unknown parameter "${r}"`);
            if (!0 !== t) throw new TypeError(`Invalid value for parameter "${r}": ${t}`);
          }
          e[r] = t;
        });
      }), e;
    }
    decompress(e, r, t) {
      h.add(n => {
        this._decompress(e, r, (e, r) => {
          n(), t(e, r);
        });
      });
    }
    compress(e, r, t) {
      h.add(n => {
        this._compress(e, r, (e, r) => {
          n(), (e || r) && t(e, r);
        });
      });
    }
    _decompress(e, r, t) {
      const i = this._isServer ? "client" : "server";
      if (!this._inflate) {
        const e = i + "_max_window_bits",
          r = "number" != typeof this.params[e] ? n.Z_DEFAULT_WINDOWBITS : this.params[e];
        this._inflate = n.createInflateRaw({
          ...this._options.zlibInflateOptions,
          windowBits: r
        }), this._inflate[c] = this, this._inflate[u] = 0, this._inflate[d] = [], this._inflate.on("error", p), this._inflate.on("data", _);
      }
      this._inflate[f] = t, this._inflate.write(e), r && this._inflate.write(l), this._inflate.flush(() => {
        const e = this._inflate[v];
        if (e) return this._inflate.close(), this._inflate = null, void t(e);
        const n = a.concat(this._inflate[d], this._inflate[u]);
        r && this.params[i + "_no_context_takeover"] ? (this._inflate.close(), this._inflate = null) : (this._inflate[u] = 0, this._inflate[d] = []), t(null, n);
      });
    }
    _compress(e, r, t) {
      const i = this._isServer ? "server" : "client";
      if (!this._deflate) {
        const e = i + "_max_window_bits",
          r = "number" != typeof this.params[e] ? n.Z_DEFAULT_WINDOWBITS : this.params[e];
        this._deflate = n.createDeflateRaw({
          ...this._options.zlibDeflateOptions,
          windowBits: r
        }), this._deflate[u] = 0, this._deflate[d] = [], this._deflate.on("error", s), this._deflate.on("data", m);
      }
      this._deflate[f] = t, this._deflate.write(e), this._deflate.flush(n.Z_SYNC_FLUSH, () => {
        if (!this._deflate) return;
        let e = a.concat(this._deflate[d], this._deflate[u]);
        r && (e = e.slice(0, e.length - 4)), this._deflate[f] = null, r && this.params[i + "_no_context_takeover"] ? (this._deflate.close(), this._deflate = null) : (this._deflate[u] = 0, this._deflate[d] = []), t(null, e);
      });
    }
  };
}, function (e, r, t) {
  "use strict";

  const {
    EMPTY_BUFFER: n
  } = t(38);
  function a(e, r) {
    if (0 === e.length) return n;
    if (1 === e.length) return e[0];
    const t = Buffer.allocUnsafe(r);
    let a = 0;
    for (let r = 0; r < e.length; r++) {
      const n = e[r];
      t.set(n, a), a += n.length;
    }
    return a < r ? t.slice(0, a) : t;
  }
  function i(e, r, t, n, a) {
    for (let i = 0; i < a; i++) t[n + i] = e[i] ^ r[3 & i];
  }
  function o(e, r) {
    const t = e.length;
    for (let n = 0; n < t; n++) e[n] ^= r[3 & n];
  }
  function s(e) {
    return e.byteLength === e.buffer.byteLength ? e.buffer : e.buffer.slice(e.byteOffset, e.byteOffset + e.byteLength);
  }
  function l(e) {
    if (l.readOnly = !0, Buffer.isBuffer(e)) return e;
    let r;
    return e instanceof ArrayBuffer ? r = Buffer.from(e) : ArrayBuffer.isView(e) ? r = function (e) {
      const r = Buffer.from(e.buffer);
      if (e.byteLength !== e.buffer.byteLength) return r.slice(e.byteOffset, e.byteOffset + e.byteLength);
      return r;
    }(e) : (r = Buffer.from(e), l.readOnly = !1), r;
  }
  try {
    const r = t(!function () {
        var e = new Error("Cannot find module 'bufferutil'");
        throw e.code = "MODULE_NOT_FOUND", e;
      }()),
      n = r.BufferUtil || r;
    e.exports = {
      concat: a,
      mask(e, r, t, a, o) {
        o < 48 ? i(e, r, t, a, o) : n.mask(e, r, t, a, o);
      },
      toArrayBuffer: s,
      toBuffer: l,
      unmask(e, r) {
        e.length < 32 ? o(e, r) : n.unmask(e, r);
      }
    };
  } catch (r) {
    e.exports = {
      concat: a,
      mask: i,
      toArrayBuffer: s,
      toBuffer: l,
      unmask: o
    };
  }
}, function (e, r, t) {
  e.exports = t(138)();
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.decodeBase64 = r.lazyStatic = r.memoizeByReference = r.memoizeByShallowEquality = r.objectsHaveShallowEquality = r.noop = r.binarySearch = r.triangle = r.fract = r.formatPercent = r.zeroPad = r.itReduce = r.itForEach = r.itMap = r.KeyedSet = r.getOrThrow = r.getOrElse = r.getOrInsert = r.sortBy = r.lastOf = void 0, r.lastOf = function (e) {
    return e[e.length - 1] || null;
  }, r.sortBy = function (e, r) {
    e.sort(function (e, t) {
      const n = r(e),
        a = r(t);
      return n < a ? -1 : n > a ? 1 : 0;
    });
  }, r.getOrInsert = function (e, r, t) {
    return e.has(r) || e.set(r, t(r)), e.get(r);
  }, r.getOrElse = function (e, r, t) {
    return e.has(r) ? e.get(r) : t(r);
  }, r.getOrThrow = function (e, r) {
    if (!e.has(r)) throw new Error("Expected key " + r);
    return e.get(r);
  };
  class n {
    constructor() {
      this.map = new Map();
    }
    getOrInsert(e) {
      const r = e.key,
        t = this.map.get(r);
      return t || (this.map.set(r, e), e);
    }
    forEach(e) {
      this.map.forEach(e);
    }
    [Symbol.iterator]() {
      return this.map.values();
    }
  }
  function a(e) {
    return e - Math.floor(e);
  }
  function i(e, r) {
    for (let t in e) if (e[t] !== r[t]) return !1;
    for (let t in r) if (e[t] !== r[t]) return !1;
    return !0;
  }
  function o(e) {
    let r = null;
    return () => (null == r && (r = {
      result: e()
    }), r.result);
  }
  r.KeyedSet = n, r.itMap = function* (e, r) {
    for (let t of e) yield r(t);
  }, r.itForEach = function (e, r) {
    for (let t of e) r(t);
  }, r.itReduce = function (e, r, t) {
    let n = t;
    for (let t of e) n = r(n, t);
    return n;
  }, r.zeroPad = function (e, r) {
    return new Array(Math.max(r - e.length, 0) + 1).join("0") + e;
  }, r.formatPercent = function (e) {
    let r = e.toFixed(0) + "%";
    return 100 === e ? r = "100%" : e > 99 ? r = ">99%" : e < 0.01 ? r = "<0.01%" : e < 1 ? r = e.toFixed(2) + "%" : e < 10 && (r = e.toFixed(1) + "%"), r;
  }, r.fract = a, r.triangle = function (e) {
    return 2 * Math.abs(a(e) - 0.5) - 1;
  }, r.binarySearch = function (e, r, t, n, a = 1) {
    for (console.assert(!isNaN(a) && !isNaN(n));;) {
      if (r - e <= a) return [e, r];
      const i = (r + e) / 2;
      t(i) < n ? e = i : r = i;
    }
  }, r.noop = function (...e) {}, r.objectsHaveShallowEquality = i, r.memoizeByShallowEquality = function (e) {
    let r = null;
    return t => {
      let n;
      return null == r ? (n = e(t), r = {
        args: t,
        result: n
      }, n) : (i(r.args, t) || (r.args = t, r.result = e(t)), r.result);
    };
  }, r.memoizeByReference = function (e) {
    let r = null;
    return t => {
      let n;
      return null == r ? (n = e(t), r = {
        args: t,
        result: n
      }, n) : (r.args === t || (r.args = t, r.result = e(t)), r.result);
    };
  }, r.lazyStatic = o;
  const s = o(() => {
    const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
      r = new Map();
    for (let t = 0; t < e.length; t++) r.set(e.charAt(t), t);
    return r.set("=", -1), r;
  });
  r.decodeBase64 = function (e) {
    const r = s();
    if (e.length % 4 != 0) throw new Error("Invalid length for base64 encoded string. Expected length % 4 = 0, got length = " + e.length);
    const t = e.length / 4;
    let n;
    n = e.length >= 4 && "=" === e.charAt(e.length - 1) ? "=" === e.charAt(e.length - 2) ? 3 * t - 2 : 3 * t - 1 : 3 * t;
    const a = new Uint8Array(n);
    let i = 0;
    for (let n = 0; n < t; n++) {
      const t = e.charAt(4 * n + 0),
        o = e.charAt(4 * n + 1),
        s = e.charAt(4 * n + 2),
        l = e.charAt(4 * n + 3),
        c = r.get(t),
        u = r.get(o),
        f = r.get(s),
        d = r.get(l);
      if (null == c || null == u || null == f || null == d) throw new Error(`Invalid quartet at indices ${4 * n} .. ${4 * n + 3}: ${e.substring(4 * n, 4 * n + 3)}`);
      a[i++] = c << 2 | u >> 4, "=" !== s && (a[i++] = (15 & u) << 4 | f >> 2), "=" !== l && (a[i++] = (7 & f) << 6 | d);
    }
    if (i !== n) throw new Error(`Expected to decode ${n} bytes, but only decoded ${i})`);
    return a;
  };
}, function (e, r, t) {
  "use strict";

  const n = t(114),
    a = Symbol("max"),
    i = Symbol("length"),
    o = Symbol("lengthCalculator"),
    s = Symbol("allowStale"),
    l = Symbol("maxAge"),
    c = Symbol("dispose"),
    u = Symbol("noDisposeOnSet"),
    f = Symbol("lruList"),
    d = Symbol("cache"),
    v = Symbol("updateAgeOnGet"),
    h = () => 1;
  const m = (e, r, t) => {
      const n = e[d].get(r);
      if (n) {
        const r = n.value;
        if (_(e, r)) {
          if (g(e, n), !e[s]) return;
        } else t && (e[v] && (n.value.now = Date.now()), e[f].unshiftNode(n));
        return r.value;
      }
    },
    _ = (e, r) => {
      if (!r || !r.maxAge && !e[l]) return !1;
      const t = Date.now() - r.now;
      return r.maxAge ? t > r.maxAge : e[l] && t > e[l];
    },
    p = e => {
      if (e[i] > e[a]) for (let r = e[f].tail; e[i] > e[a] && null !== r;) {
        const t = r.prev;
        g(e, r), r = t;
      }
    },
    g = (e, r) => {
      if (r) {
        const t = r.value;
        e[c] && e[c](t.key, t.value), e[i] -= t.length, e[d].delete(t.key), e[f].removeNode(r);
      }
    };
  class b {
    constructor(e, r, t, n, a) {
      this.key = e, this.value = r, this.length = t, this.now = n, this.maxAge = a || 0;
    }
  }
  const S = (e, r, t, n) => {
    let a = t.value;
    _(e, a) && (g(e, t), e[s] || (a = void 0)), a && r.call(n, a.value, a.key, e);
  };
  e.exports = class {
    constructor(e) {
      if ("number" == typeof e && (e = {
        max: e
      }), e || (e = {}), e.max && ("number" != typeof e.max || e.max < 0)) throw new TypeError("max must be a non-negative number");
      this[a] = e.max || 1 / 0;
      const r = e.length || h;
      if (this[o] = "function" != typeof r ? h : r, this[s] = e.stale || !1, e.maxAge && "number" != typeof e.maxAge) throw new TypeError("maxAge must be a number");
      this[l] = e.maxAge || 0, this[c] = e.dispose, this[u] = e.noDisposeOnSet || !1, this[v] = e.updateAgeOnGet || !1, this.reset();
    }
    set max(e) {
      if ("number" != typeof e || e < 0) throw new TypeError("max must be a non-negative number");
      this[a] = e || 1 / 0, p(this);
    }
    get max() {
      return this[a];
    }
    set allowStale(e) {
      this[s] = !!e;
    }
    get allowStale() {
      return this[s];
    }
    set maxAge(e) {
      if ("number" != typeof e) throw new TypeError("maxAge must be a non-negative number");
      this[l] = e, p(this);
    }
    get maxAge() {
      return this[l];
    }
    set lengthCalculator(e) {
      "function" != typeof e && (e = h), e !== this[o] && (this[o] = e, this[i] = 0, this[f].forEach(e => {
        e.length = this[o](e.value, e.key), this[i] += e.length;
      })), p(this);
    }
    get lengthCalculator() {
      return this[o];
    }
    get length() {
      return this[i];
    }
    get itemCount() {
      return this[f].length;
    }
    rforEach(e, r) {
      r = r || this;
      for (let t = this[f].tail; null !== t;) {
        const n = t.prev;
        S(this, e, t, r), t = n;
      }
    }
    forEach(e, r) {
      r = r || this;
      for (let t = this[f].head; null !== t;) {
        const n = t.next;
        S(this, e, t, r), t = n;
      }
    }
    keys() {
      return this[f].toArray().map(e => e.key);
    }
    values() {
      return this[f].toArray().map(e => e.value);
    }
    reset() {
      this[c] && this[f] && this[f].length && this[f].forEach(e => this[c](e.key, e.value)), this[d] = new Map(), this[f] = new n(), this[i] = 0;
    }
    dump() {
      return this[f].map(e => !_(this, e) && {
        k: e.key,
        v: e.value,
        e: e.now + (e.maxAge || 0)
      }).toArray().filter(e => e);
    }
    dumpLru() {
      return this[f];
    }
    set(e, r, t) {
      if ((t = t || this[l]) && "number" != typeof t) throw new TypeError("maxAge must be a number");
      const n = t ? Date.now() : 0,
        s = this[o](r, e);
      if (this[d].has(e)) {
        if (s > this[a]) return g(this, this[d].get(e)), !1;
        const o = this[d].get(e).value;
        return this[c] && (this[u] || this[c](e, o.value)), o.now = n, o.maxAge = t, o.value = r, this[i] += s - o.length, o.length = s, this.get(e), p(this), !0;
      }
      const v = new b(e, r, s, n, t);
      return v.length > this[a] ? (this[c] && this[c](e, r), !1) : (this[i] += v.length, this[f].unshift(v), this[d].set(e, this[f].head), p(this), !0);
    }
    has(e) {
      if (!this[d].has(e)) return !1;
      const r = this[d].get(e).value;
      return !_(this, r);
    }
    get(e) {
      return m(this, e, !0);
    }
    peek(e) {
      return m(this, e, !1);
    }
    pop() {
      const e = this[f].tail;
      return e ? (g(this, e), e.value) : null;
    }
    del(e) {
      g(this, this[d].get(e));
    }
    load(e) {
      this.reset();
      const r = Date.now();
      for (let t = e.length - 1; t >= 0; t--) {
        const n = e[t],
          a = n.e || 0;
        if (0 === a) this.set(n.k, n.v);else {
          const e = a - r;
          e > 0 && this.set(n.k, n.v, e);
        }
      }
    }
    prune() {
      this[d].forEach((e, r) => m(this, r, !1));
    }
  };
}, function (e, r, t) {
  var n = t(154);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(155);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(156);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(171);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(175);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(179);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(195);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(203);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r) {
  e.exports = _child_process;
}, function (e, r) {
  e.exports = _http;
}, function (e, r) {
  e.exports = _crypto;
}, function (e, r, t) {
  var n, a, i;
  !function (o, s) {
    "use strict";

    a = [t(126)], void 0 === (i = "function" == typeof (n = function (e) {
      var r = /(^|@)\S+:\d+/,
        t = /^\s*at .*(\S+:\d+|\(native\))/m,
        n = /^(eval@)?(\[native code])?$/;
      return {
        parse: function (e) {
          if (void 0 !== e.stacktrace || void 0 !== e["opera#sourceloc"]) return this.parseOpera(e);
          if (e.stack && e.stack.match(t)) return this.parseV8OrIE(e);
          if (e.stack) return this.parseFFOrSafari(e);
          throw new Error("Cannot parse given Error object");
        },
        extractLocation: function (e) {
          if (-1 === e.indexOf(":")) return [e];
          var r = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(e.replace(/[()]/g, ""));
          return [r[1], r[2] || void 0, r[3] || void 0];
        },
        parseV8OrIE: function (r) {
          return r.stack.split("\n").filter(function (e) {
            return !!e.match(t);
          }, this || _global).map(function (r) {
            r.indexOf("(eval ") > -1 && (r = r.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
            var t = r.replace(/^\s+/, "").replace(/\(eval code/g, "("),
              n = t.match(/ (\((.+):(\d+):(\d+)\)$)/),
              a = (t = n ? t.replace(n[0], "") : t).split(/\s+/).slice(1),
              i = this.extractLocation(n ? n[1] : a.pop()),
              o = a.join(" ") || void 0,
              s = ["eval", "<anonymous>"].indexOf(i[0]) > -1 ? void 0 : i[0];
            return new e({
              functionName: o,
              fileName: s,
              lineNumber: i[1],
              columnNumber: i[2],
              source: r
            });
          }, this || _global);
        },
        parseFFOrSafari: function (r) {
          return r.stack.split("\n").filter(function (e) {
            return !e.match(n);
          }, this || _global).map(function (r) {
            if (r.indexOf(" > eval") > -1 && (r = r.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), -1 === r.indexOf("@") && -1 === r.indexOf(":")) return new e({
              functionName: r
            });
            var t = /((.*".+"[^@]*)?[^@]*)(?:@)/,
              n = r.match(t),
              a = n && n[1] ? n[1] : void 0,
              i = this.extractLocation(r.replace(t, ""));
            return new e({
              functionName: a,
              fileName: i[0],
              lineNumber: i[1],
              columnNumber: i[2],
              source: r
            });
          }, this || _global);
        },
        parseOpera: function (e) {
          return !e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length ? this.parseOpera9(e) : e.stack ? this.parseOpera11(e) : this.parseOpera10(e);
        },
        parseOpera9: function (r) {
          for (var t = /Line (\d+).*script (?:in )?(\S+)/i, n = r.message.split("\n"), a = [], i = 2, o = n.length; i < o; i += 2) {
            var s = t.exec(n[i]);
            s && a.push(new e({
              fileName: s[2],
              lineNumber: s[1],
              source: n[i]
            }));
          }
          return a;
        },
        parseOpera10: function (r) {
          for (var t = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, n = r.stacktrace.split("\n"), a = [], i = 0, o = n.length; i < o; i += 2) {
            var s = t.exec(n[i]);
            s && a.push(new e({
              functionName: s[3] || void 0,
              fileName: s[2],
              lineNumber: s[1],
              source: n[i]
            }));
          }
          return a;
        },
        parseOpera11: function (t) {
          return t.stack.split("\n").filter(function (e) {
            return !!e.match(r) && !e.match(/^Error created at/);
          }, this || _global).map(function (r) {
            var t,
              n = r.split("@"),
              a = this.extractLocation(n.pop()),
              i = n.shift() || "",
              o = i.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
            i.match(/\(([^)]*)\)/) && (t = i.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
            var s = void 0 === t || "[arguments not available]" === t ? void 0 : t.split(",");
            return new e({
              functionName: o,
              args: s,
              fileName: a[0],
              lineNumber: a[1],
              columnNumber: a[2],
              source: r
            });
          }, this || _global);
        }
      };
    }) ? n.apply(r, a) : n) || (e.exports = i);
  }();
}, function (e, r, t) {
  var n = t(133);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(140);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(143);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(151);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(176);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  "use strict";

  var n = (this || _global) && (this || _global).__createBinding || (Object.create ? function (e, r, t, n) {
      void 0 === n && (n = t), Object.defineProperty(e, n, {
        enumerable: !0,
        get: function () {
          return r[t];
        }
      });
    } : function (e, r, t, n) {
      void 0 === n && (n = t), e[n] = r[t];
    }),
    a = (this || _global) && (this || _global).__exportStar || function (e, r) {
      for (var t in e) "default" === t || r.hasOwnProperty(t) || n(r, e, t);
    };
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), a(t(185), r), a(t(189), r);
}, function (e, r, t) {
  "use strict";

  t.d(r, "a", function () {
    return c;
  }), t.d(r, "c", function () {
    return u;
  }), t.d(r, "b", function () {
    return f;
  });
  var n = t(1);
  const a = "undefined" != typeof performance && "function" == typeof performance.mark && "function" == typeof performance.clearMarks,
    i = "undefined" != typeof performance && "function" == typeof performance.now;
  function o(e) {
    a && performance.mark(e + "-start");
  }
  function s(e) {
    a && (performance.mark(e + "-end"), performance.measure(e, e + "-start", e + "-end"), performance.clearMarks(e + "-start"), performance.clearMarks(e + "-end"));
  }
  function l() {
    return i ? performance.now() : Date.now();
  }
  async function c(e, r, t) {
    const a = l();
    n.G && o(e);
    const i = await r();
    if (n.G && s(e), null != t) {
      t(l() - a);
    }
    return i;
  }
  function u(e, r, t) {
    const a = l();
    n.G && o(e);
    const i = r();
    if (n.G && s(e), null != t) {
      t(l() - a);
    }
    return i;
  }
  function f(e, r, t) {
    const a = l();
    n.G && o(e);
    return r(() => {
      if (n.G && s(e), null != t) {
        const e = l() - a;
        t(e);
      }
    });
  }
},, function (e, r, t) {
  "use strict";

  const n = t(76),
    a = t(77),
    i = t(64),
    o = t(117),
    s = t(118),
    {
      randomBytes: l,
      createHash: c
    } = t(65),
    {
      URL: u
    } = t(119),
    f = t(50),
    d = t(78),
    v = t(81),
    {
      BINARY_TYPES: h,
      EMPTY_BUFFER: m,
      GUID: _,
      kStatusCode: p,
      kWebSocket: g,
      NOOP: b
    } = t(38),
    {
      addEventListener: S,
      removeEventListener: E
    } = t(122),
    {
      format: w,
      parse: y
    } = t(82),
    {
      toBuffer: k
    } = t(51),
    C = ["CONNECTING", "OPEN", "CLOSING", "CLOSED"],
    D = [8, 13];
  class A extends n {
    constructor(e, r, t) {
      super(), this.readyState = A.CONNECTING, this.protocol = "", this._binaryType = h[0], this._closeFrameReceived = !1, this._closeFrameSent = !1, this._closeMessage = "", this._closeTimer = null, this._closeCode = 1006, this._extensions = {}, this._receiver = null, this._sender = null, this._socket = null, null !== e ? (this._bufferedAmount = 0, this._isServer = !1, this._redirects = 0, Array.isArray(r) ? r = r.join(", ") : "object" == typeof r && null !== r && (t = r, r = void 0), function e(r, t, n, o) {
        const s = {
          protocolVersion: D[1],
          maxPayload: 104857600,
          perMessageDeflate: !0,
          followRedirects: !1,
          maxRedirects: 10,
          ...o,
          createConnection: void 0,
          socketPath: void 0,
          hostname: void 0,
          protocol: void 0,
          timeout: void 0,
          method: void 0,
          auth: void 0,
          host: void 0,
          path: void 0,
          port: void 0
        };
        if (!D.includes(s.protocolVersion)) throw new RangeError(`Unsupported protocol version: ${s.protocolVersion} (supported versions: ${D.join(", ")})`);
        let d;
        t instanceof u ? (d = t, r.url = t.href) : (d = new u(t), r.url = t);
        const v = "ws+unix:" === d.protocol;
        if (!(d.host || v && d.pathname)) throw new Error("Invalid URL: " + r.url);
        const h = "wss:" === d.protocol || "https:" === d.protocol,
          m = h ? 443 : 80,
          p = l(16).toString("base64"),
          g = h ? a.get : i.get;
        let b;
        s.createConnection = h ? x : M, s.defaultPort = s.defaultPort || m, s.port = d.port || m, s.host = d.hostname.startsWith("[") ? d.hostname.slice(1, -1) : d.hostname, s.headers = {
          "Sec-WebSocket-Version": s.protocolVersion,
          "Sec-WebSocket-Key": p,
          Connection: "Upgrade",
          Upgrade: "websocket",
          ...s.headers
        }, s.path = d.pathname + d.search, s.timeout = s.handshakeTimeout, s.perMessageDeflate && (b = new f(!0 !== s.perMessageDeflate ? s.perMessageDeflate : {}, !1, s.maxPayload), s.headers["Sec-WebSocket-Extensions"] = w({
          [f.extensionName]: b.offer()
        }));
        n && (s.headers["Sec-WebSocket-Protocol"] = n);
        s.origin && (s.protocolVersion < 13 ? s.headers["Sec-WebSocket-Origin"] = s.origin : s.headers.Origin = s.origin);
        (d.username || d.password) && (s.auth = `${d.username}:${d.password}`);
        if (v) {
          const e = s.path.split(":");
          s.socketPath = e[0], s.path = e[1];
        }
        let S = r._req = g(s);
        s.timeout && S.on("timeout", () => {
          O(r, S, "Opening handshake has timed out");
        });
        S.on("error", e => {
          r._req.aborted || (S = r._req = null, r.readyState = A.CLOSING, r.emit("error", e), r.emitClose());
        }), S.on("response", a => {
          const i = a.headers.location,
            l = a.statusCode;
          if (i && s.followRedirects && l >= 300 && l < 400) {
            if (++r._redirects > s.maxRedirects) return void O(r, S, "Maximum redirects exceeded");
            S.abort();
            const a = new u(i, t);
            e(r, a, n, o);
          } else r.emit("unexpected-response", S, a) || O(r, S, "Unexpected server response: " + a.statusCode);
        }), S.on("upgrade", (e, t, a) => {
          if (r.emit("upgrade", e), r.readyState !== A.CONNECTING) return;
          S = r._req = null;
          const i = c("sha1").update(p + _).digest("base64");
          if (e.headers["sec-websocket-accept"] !== i) return void O(r, t, "Invalid Sec-WebSocket-Accept header");
          const o = e.headers["sec-websocket-protocol"],
            l = (n || "").split(/, */);
          let u;
          if (!n && o ? u = "Server sent a subprotocol but none was requested" : n && !o ? u = "Server sent no subprotocol" : o && !l.includes(o) && (u = "Server sent an invalid subprotocol"), u) O(r, t, u);else {
            if (o && (r.protocol = o), b) try {
              const t = y(e.headers["sec-websocket-extensions"]);
              t[f.extensionName] && (b.accept(t[f.extensionName]), r._extensions[f.extensionName] = b);
            } catch (e) {
              return void O(r, t, "Invalid Sec-WebSocket-Extensions header");
            }
            r.setSocket(t, a, s.maxPayload);
          }
        });
      }(this, e, r, t)) : this._isServer = !0;
    }
    get CONNECTING() {
      return A.CONNECTING;
    }
    get CLOSING() {
      return A.CLOSING;
    }
    get CLOSED() {
      return A.CLOSED;
    }
    get OPEN() {
      return A.OPEN;
    }
    get binaryType() {
      return this._binaryType;
    }
    set binaryType(e) {
      h.includes(e) && (this._binaryType = e, this._receiver && (this._receiver._binaryType = e));
    }
    get bufferedAmount() {
      return this._socket ? (this._socket.bufferSize || 0) + this._sender._bufferedBytes : this._bufferedAmount;
    }
    get extensions() {
      return Object.keys(this._extensions).join();
    }
    setSocket(e, r, t) {
      const n = new d(this._binaryType, this._extensions, t);
      this._sender = new v(e, this._extensions), this._receiver = n, this._socket = e, n[g] = this, e[g] = this, n.on("conclude", N), n.on("drain", R), n.on("error", I), n.on("message", F), n.on("ping", L), n.on("pong", P), e.setTimeout(0), e.setNoDelay(), r.length > 0 && e.unshift(r), e.on("close", z), e.on("data", B), e.on("end", j), e.on("error", V), this.readyState = A.OPEN, this.emit("open");
    }
    emitClose() {
      this.readyState = A.CLOSED, this._socket ? (this._extensions[f.extensionName] && this._extensions[f.extensionName].cleanup(), this._receiver.removeAllListeners(), this.emit("close", this._closeCode, this._closeMessage)) : this.emit("close", this._closeCode, this._closeMessage);
    }
    close(e, r) {
      if (this.readyState !== A.CLOSED) {
        if (this.readyState === A.CONNECTING) {
          const e = "WebSocket was closed before the connection was established";
          return O(this, this._req, e);
        }
        this.readyState !== A.CLOSING ? (this.readyState = A.CLOSING, this._sender.close(e, r, !this._isServer, e => {
          e || (this._closeFrameSent = !0, this._closeFrameReceived && this._socket.end());
        }), this._closeTimer = setTimeout(this._socket.destroy.bind(this._socket), 30000)) : this._closeFrameSent && this._closeFrameReceived && this._socket.end();
      }
    }
    ping(e, r, t) {
      if (this.readyState === A.CONNECTING) throw new Error("WebSocket is not open: readyState 0 (CONNECTING)");
      "function" == typeof e ? (t = e, e = r = void 0) : "function" == typeof r && (t = r, r = void 0), "number" == typeof e && (e = e.toString()), this.readyState === A.OPEN ? (void 0 === r && (r = !this._isServer), this._sender.ping(e || m, r, t)) : T(this, e, t);
    }
    pong(e, r, t) {
      if (this.readyState === A.CONNECTING) throw new Error("WebSocket is not open: readyState 0 (CONNECTING)");
      "function" == typeof e ? (t = e, e = r = void 0) : "function" == typeof r && (t = r, r = void 0), "number" == typeof e && (e = e.toString()), this.readyState === A.OPEN ? (void 0 === r && (r = !this._isServer), this._sender.pong(e || m, r, t)) : T(this, e, t);
    }
    send(e, r, t) {
      if (this.readyState === A.CONNECTING) throw new Error("WebSocket is not open: readyState 0 (CONNECTING)");
      if ("function" == typeof r && (t = r, r = {}), "number" == typeof e && (e = e.toString()), this.readyState !== A.OPEN) return void T(this, e, t);
      const n = {
        binary: "string" != typeof e,
        mask: !this._isServer,
        compress: !0,
        fin: !0,
        ...r
      };
      this._extensions[f.extensionName] || (n.compress = !1), this._sender.send(e || m, n, t);
    }
    terminate() {
      if (this.readyState !== A.CLOSED) {
        if (this.readyState === A.CONNECTING) {
          const e = "WebSocket was closed before the connection was established";
          return O(this, this._req, e);
        }
        this._socket && (this.readyState = A.CLOSING, this._socket.destroy());
      }
    }
  }
  function M(e) {
    return e.path = e.socketPath, o.connect(e);
  }
  function x(e) {
    return e.path = void 0, e.servername || "" === e.servername || (e.servername = e.host), s.connect(e);
  }
  function O(e, r, t) {
    e.readyState = A.CLOSING;
    const n = new Error(t);
    Error.captureStackTrace(n, O), r.setHeader ? (r.abort(), r.once("abort", e.emitClose.bind(e)), e.emit("error", n)) : (r.destroy(n), r.once("error", e.emit.bind(e, "error")), r.once("close", e.emitClose.bind(e)));
  }
  function T(e, r, t) {
    if (r) {
      const t = k(r).length;
      e._socket ? e._sender._bufferedBytes += t : e._bufferedAmount += t;
    }
    if (t) {
      t(new Error(`WebSocket is not open: readyState ${e.readyState} (${C[e.readyState]})`));
    }
  }
  function N(e, r) {
    const t = (this || _global)[g];
    t._socket.removeListener("data", B), t._socket.resume(), t._closeFrameReceived = !0, t._closeMessage = r, t._closeCode = e, 1005 === e ? t.close() : t.close(e, r);
  }
  function R() {
    (this || _global)[g]._socket.resume();
  }
  function I(e) {
    const r = (this || _global)[g];
    r._socket.removeListener("data", B), r.readyState = A.CLOSING, r._closeCode = e[p], r.emit("error", e), r._socket.destroy();
  }
  function H() {
    (this || _global)[g].emitClose();
  }
  function F(e) {
    (this || _global)[g].emit("message", e);
  }
  function L(e) {
    const r = (this || _global)[g];
    r.pong(e, !r._isServer, b), r.emit("ping", e);
  }
  function P(e) {
    (this || _global)[g].emit("pong", e);
  }
  function z() {
    const e = (this || _global)[g];
    this.removeListener("close", z), this.removeListener("end", j), e.readyState = A.CLOSING, e._socket.read(), e._receiver.end(), this.removeListener("data", B), (this || _global)[g] = void 0, clearTimeout(e._closeTimer), e._receiver._writableState.finished || e._receiver._writableState.errorEmitted ? e.emitClose() : (e._receiver.on("error", H), e._receiver.on("finish", H));
  }
  function B(e) {
    (this || _global)[g]._receiver.write(e) || this.pause();
  }
  function j() {
    const e = (this || _global)[g];
    e.readyState = A.CLOSING, e._receiver.end(), this.end();
  }
  function V() {
    const e = (this || _global)[g];
    this.removeListener("error", V), this.on("error", b), e && (e.readyState = A.CLOSING, this.destroy());
  }
  C.forEach((e, r) => {
    A[e] = r;
  }), ["open", "error", "close", "message"].forEach(e => {
    Object.defineProperty(A.prototype, "on" + e, {
      get() {
        const r = this.listeners(e);
        for (let e = 0; e < r.length; e++) if (r[e]._listener) return r[e]._listener;
      },
      set(r) {
        const t = this.listeners(e);
        for (let r = 0; r < t.length; r++) t[r]._listener && this.removeListener(e, t[r]);
        this.addEventListener(e, r);
      }
    });
  }), A.prototype.addEventListener = S, A.prototype.removeEventListener = E, e.exports = A;
}, function (e, r) {
  e.exports = _events;
}, function (e, r) {
  e.exports = _https;
}, function (e, r, t) {
  "use strict";

  const {
      Writable: n
    } = t(79),
    a = t(50),
    {
      BINARY_TYPES: i,
      EMPTY_BUFFER: o,
      kStatusCode: s,
      kWebSocket: l
    } = t(38),
    {
      concat: c,
      toArrayBuffer: u,
      unmask: f
    } = t(51),
    {
      isValidStatusCode: d,
      isValidUTF8: v
    } = t(80);
  function h(e, r, t, n) {
    const a = new e(t ? "Invalid WebSocket frame: " + r : r);
    return Error.captureStackTrace(a, h), a[s] = n, a;
  }
  e.exports = class extends n {
    constructor(e, r, t) {
      super(), this._binaryType = e || i[0], this[l] = void 0, this._extensions = r || {}, this._maxPayload = 0 | t, this._bufferedBytes = 0, this._buffers = [], this._compressed = !1, this._payloadLength = 0, this._mask = void 0, this._fragmented = 0, this._masked = !1, this._fin = !1, this._opcode = 0, this._totalPayloadLength = 0, this._messageLength = 0, this._fragments = [], this._state = 0, this._loop = !1;
    }
    _write(e, r, t) {
      if (8 === this._opcode && 0 == this._state) return t();
      this._bufferedBytes += e.length, this._buffers.push(e), this.startLoop(t);
    }
    consume(e) {
      if (this._bufferedBytes -= e, e === this._buffers[0].length) return this._buffers.shift();
      if (e < this._buffers[0].length) {
        const r = this._buffers[0];
        return this._buffers[0] = r.slice(e), r.slice(0, e);
      }
      const r = Buffer.allocUnsafe(e);
      do {
        const t = this._buffers[0],
          n = r.length - e;
        e >= t.length ? r.set(this._buffers.shift(), n) : (r.set(new Uint8Array(t.buffer, t.byteOffset, e), n), this._buffers[0] = t.slice(e)), e -= t.length;
      } while (e > 0);
      return r;
    }
    startLoop(e) {
      let r;
      this._loop = !0;
      do {
        switch (this._state) {
          case 0:
            r = this.getInfo();
            break;
          case 1:
            r = this.getPayloadLength16();
            break;
          case 2:
            r = this.getPayloadLength64();
            break;
          case 3:
            this.getMask();
            break;
          case 4:
            r = this.getData(e);
            break;
          default:
            return void (this._loop = !1);
        }
      } while (this._loop);
      e(r);
    }
    getInfo() {
      if (this._bufferedBytes < 2) return void (this._loop = !1);
      const e = this.consume(2);
      if (0 != (48 & e[0])) return this._loop = !1, h(RangeError, "RSV2 and RSV3 must be clear", !0, 1002);
      const r = 64 == (64 & e[0]);
      if (r && !this._extensions[a.extensionName]) return this._loop = !1, h(RangeError, "RSV1 must be clear", !0, 1002);
      if (this._fin = 128 == (128 & e[0]), this._opcode = 15 & e[0], this._payloadLength = 127 & e[1], 0 === this._opcode) {
        if (r) return this._loop = !1, h(RangeError, "RSV1 must be clear", !0, 1002);
        if (!this._fragmented) return this._loop = !1, h(RangeError, "invalid opcode 0", !0, 1002);
        this._opcode = this._fragmented;
      } else if (1 === this._opcode || 2 === this._opcode) {
        if (this._fragmented) return this._loop = !1, h(RangeError, "invalid opcode " + this._opcode, !0, 1002);
        this._compressed = r;
      } else {
        if (!(this._opcode > 7 && this._opcode < 11)) return this._loop = !1, h(RangeError, "invalid opcode " + this._opcode, !0, 1002);
        if (!this._fin) return this._loop = !1, h(RangeError, "FIN must be set", !0, 1002);
        if (r) return this._loop = !1, h(RangeError, "RSV1 must be clear", !0, 1002);
        if (this._payloadLength > 125) return this._loop = !1, h(RangeError, "invalid payload length " + this._payloadLength, !0, 1002);
      }
      if (this._fin || this._fragmented || (this._fragmented = this._opcode), this._masked = 128 == (128 & e[1]), 126 === this._payloadLength) this._state = 1;else {
        if (127 !== this._payloadLength) return this.haveLength();
        this._state = 2;
      }
    }
    getPayloadLength16() {
      if (!(this._bufferedBytes < 2)) return this._payloadLength = this.consume(2).readUInt16BE(0), this.haveLength();
      this._loop = !1;
    }
    getPayloadLength64() {
      if (this._bufferedBytes < 8) return void (this._loop = !1);
      const e = this.consume(8),
        r = e.readUInt32BE(0);
      return r > Math.pow(2, 21) - 1 ? (this._loop = !1, h(RangeError, "Unsupported WebSocket frame: payload length > 2^53 - 1", !1, 1009)) : (this._payloadLength = r * Math.pow(2, 32) + e.readUInt32BE(4), this.haveLength());
    }
    haveLength() {
      if (this._payloadLength && this._opcode < 8 && (this._totalPayloadLength += this._payloadLength, this._totalPayloadLength > this._maxPayload && this._maxPayload > 0)) return this._loop = !1, h(RangeError, "Max payload size exceeded", !1, 1009);
      this._masked ? this._state = 3 : this._state = 4;
    }
    getMask() {
      this._bufferedBytes < 4 ? this._loop = !1 : (this._mask = this.consume(4), this._state = 4);
    }
    getData(e) {
      let r = o;
      if (this._payloadLength) {
        if (this._bufferedBytes < this._payloadLength) return void (this._loop = !1);
        r = this.consume(this._payloadLength), this._masked && f(r, this._mask);
      }
      return this._opcode > 7 ? this.controlMessage(r) : this._compressed ? (this._state = 5, void this.decompress(r, e)) : (r.length && (this._messageLength = this._totalPayloadLength, this._fragments.push(r)), this.dataMessage());
    }
    decompress(e, r) {
      this._extensions[a.extensionName].decompress(e, this._fin, (e, t) => {
        if (e) return r(e);
        if (t.length) {
          if (this._messageLength += t.length, this._messageLength > this._maxPayload && this._maxPayload > 0) return r(h(RangeError, "Max payload size exceeded", !1, 1009));
          this._fragments.push(t);
        }
        const n = this.dataMessage();
        if (n) return r(n);
        this.startLoop(r);
      });
    }
    dataMessage() {
      if (this._fin) {
        const e = this._messageLength,
          r = this._fragments;
        if (this._totalPayloadLength = 0, this._messageLength = 0, this._fragmented = 0, this._fragments = [], 2 === this._opcode) {
          let t;
          t = "nodebuffer" === this._binaryType ? c(r, e) : "arraybuffer" === this._binaryType ? u(c(r, e)) : r, this.emit("message", t);
        } else {
          const t = c(r, e);
          if (!v(t)) return this._loop = !1, h(Error, "invalid UTF-8 sequence", !0, 1007);
          this.emit("message", t.toString());
        }
      }
      this._state = 0;
    }
    controlMessage(e) {
      if (8 === this._opcode) {
        if (this._loop = !1, 0 === e.length) this.emit("conclude", 1005, ""), this.end();else {
          if (1 === e.length) return h(RangeError, "invalid payload length 1", !0, 1002);
          {
            const r = e.readUInt16BE(0);
            if (!d(r)) return h(RangeError, "invalid status code " + r, !0, 1002);
            const t = e.slice(2);
            if (!v(t)) return h(Error, "invalid UTF-8 sequence", !0, 1007);
            this.emit("conclude", r, t.toString()), this.end();
          }
        }
      } else 9 === this._opcode ? this.emit("ping", e) : this.emit("pong", e);
      this._state = 0;
    }
  };
}, function (e, r) {
  e.exports = _stream;
}, function (e, r, t) {
  "use strict";

  try {
    const e = t(!function () {
      var e = new Error("Cannot find module 'utf-8-validate'");
      throw e.code = "MODULE_NOT_FOUND", e;
    }());
    r.isValidUTF8 = "object" == typeof e ? e.Validation.isValidUTF8 : e;
  } catch (e) {
    r.isValidUTF8 = () => !0;
  }
  r.isValidStatusCode = e => e >= 1000 && e <= 1013 && 1004 !== e && 1005 !== e && 1006 !== e || e >= 3000 && e <= 4999;
}, function (e, r, t) {
  "use strict";

  const {
      randomFillSync: n
    } = t(65),
    a = t(50),
    {
      EMPTY_BUFFER: i
    } = t(38),
    {
      isValidStatusCode: o
    } = t(80),
    {
      mask: s,
      toBuffer: l
    } = t(51),
    c = Buffer.alloc(4);
  class u {
    constructor(e, r) {
      this._extensions = r || {}, this._socket = e, this._firstFragment = !0, this._compress = !1, this._bufferedBytes = 0, this._deflating = !1, this._queue = [];
    }
    static frame(e, r) {
      const t = r.mask && r.readOnly;
      let a = r.mask ? 6 : 2,
        i = e.length;
      e.length >= 65536 ? (a += 8, i = 127) : e.length > 125 && (a += 2, i = 126);
      const o = Buffer.allocUnsafe(t ? e.length + a : a);
      return o[0] = r.fin ? 128 | r.opcode : r.opcode, r.rsv1 && (o[0] |= 64), o[1] = i, 126 === i ? o.writeUInt16BE(e.length, 2) : 127 === i && (o.writeUInt32BE(0, 2), o.writeUInt32BE(e.length, 6)), r.mask ? (n(c, 0, 4), o[1] |= 128, o[a - 4] = c[0], o[a - 3] = c[1], o[a - 2] = c[2], o[a - 1] = c[3], t ? (s(e, c, o, a, e.length), [o]) : (s(e, c, e, 0, e.length), [o, e])) : [o, e];
    }
    close(e, r, t, n) {
      let a;
      if (void 0 === e) a = i;else {
        if ("number" != typeof e || !o(e)) throw new TypeError("First argument must be a valid error code number");
        void 0 === r || "" === r ? (a = Buffer.allocUnsafe(2), a.writeUInt16BE(e, 0)) : (a = Buffer.allocUnsafe(2 + Buffer.byteLength(r)), a.writeUInt16BE(e, 0), a.write(r, 2));
      }
      this._deflating ? this.enqueue([this.doClose, a, t, n]) : this.doClose(a, t, n);
    }
    doClose(e, r, t) {
      this.sendFrame(u.frame(e, {
        fin: !0,
        rsv1: !1,
        opcode: 8,
        mask: r,
        readOnly: !1
      }), t);
    }
    ping(e, r, t) {
      const n = l(e);
      this._deflating ? this.enqueue([this.doPing, n, r, l.readOnly, t]) : this.doPing(n, r, l.readOnly, t);
    }
    doPing(e, r, t, n) {
      this.sendFrame(u.frame(e, {
        fin: !0,
        rsv1: !1,
        opcode: 9,
        mask: r,
        readOnly: t
      }), n);
    }
    pong(e, r, t) {
      const n = l(e);
      this._deflating ? this.enqueue([this.doPong, n, r, l.readOnly, t]) : this.doPong(n, r, l.readOnly, t);
    }
    doPong(e, r, t, n) {
      this.sendFrame(u.frame(e, {
        fin: !0,
        rsv1: !1,
        opcode: 10,
        mask: r,
        readOnly: t
      }), n);
    }
    send(e, r, t) {
      const n = l(e),
        i = this._extensions[a.extensionName];
      let o = r.binary ? 2 : 1,
        s = r.compress;
      if (this._firstFragment ? (this._firstFragment = !1, s && i && (s = n.length >= i._threshold), this._compress = s) : (s = !1, o = 0), r.fin && (this._firstFragment = !0), i) {
        const e = {
          fin: r.fin,
          rsv1: s,
          opcode: o,
          mask: r.mask,
          readOnly: l.readOnly
        };
        this._deflating ? this.enqueue([this.dispatch, n, this._compress, e, t]) : this.dispatch(n, this._compress, e, t);
      } else this.sendFrame(u.frame(n, {
        fin: r.fin,
        rsv1: !1,
        opcode: o,
        mask: r.mask,
        readOnly: l.readOnly
      }), t);
    }
    dispatch(e, r, t, n) {
      if (!r) return void this.sendFrame(u.frame(e, t), n);
      const i = this._extensions[a.extensionName];
      this._deflating = !0, i.compress(e, t.fin, (e, r) => {
        this._deflating = !1, t.readOnly = !1, this.sendFrame(u.frame(r, t), n), this.dequeue();
      });
    }
    dequeue() {
      for (; !this._deflating && this._queue.length;) {
        const e = this._queue.shift();
        this._bufferedBytes -= e[1].length, Reflect.apply(e[0], this, e.slice(1));
      }
    }
    enqueue(e) {
      this._bufferedBytes += e[1].length, this._queue.push(e);
    }
    sendFrame(e, r) {
      2 === e.length ? (this._socket.cork(), this._socket.write(e[0]), this._socket.write(e[1], r), this._socket.uncork()) : this._socket.write(e[0], r);
    }
  }
  e.exports = u;
}, function (e, r, t) {
  "use strict";

  const n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 1, 1, 1, 0, 0, 1, 1, 0, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0];
  function a(e, r, t) {
    void 0 === e[r] ? e[r] = [t] : e[r].push(t);
  }
  e.exports = {
    format: function (e) {
      return Object.keys(e).map(r => {
        let t = e[r];
        return Array.isArray(t) || (t = [t]), t.map(e => [r].concat(Object.keys(e).map(r => {
          let t = e[r];
          return Array.isArray(t) || (t = [t]), t.map(e => !0 === e ? r : `${r}=${e}`).join("; ");
        })).join("; ")).join(", ");
      }).join(", ");
    },
    parse: function (e) {
      const r = Object.create(null);
      if (void 0 === e || "" === e) return r;
      let t,
        i,
        o = Object.create(null),
        s = !1,
        l = !1,
        c = !1,
        u = -1,
        f = -1,
        d = 0;
      for (; d < e.length; d++) {
        const v = e.charCodeAt(d);
        if (void 0 === t) {
          if (-1 === f && 1 === n[v]) -1 === u && (u = d);else if (32 === v || 9 === v) -1 === f && -1 !== u && (f = d);else {
            if (59 !== v && 44 !== v) throw new SyntaxError("Unexpected character at index " + d);
            {
              if (-1 === u) throw new SyntaxError("Unexpected character at index " + d);
              -1 === f && (f = d);
              const n = e.slice(u, f);
              44 === v ? (a(r, n, o), o = Object.create(null)) : t = n, u = f = -1;
            }
          }
        } else if (void 0 === i) {
          if (-1 === f && 1 === n[v]) -1 === u && (u = d);else if (32 === v || 9 === v) -1 === f && -1 !== u && (f = d);else if (59 === v || 44 === v) {
            if (-1 === u) throw new SyntaxError("Unexpected character at index " + d);
            -1 === f && (f = d), a(o, e.slice(u, f), !0), 44 === v && (a(r, t, o), o = Object.create(null), t = void 0), u = f = -1;
          } else {
            if (61 !== v || -1 === u || -1 !== f) throw new SyntaxError("Unexpected character at index " + d);
            i = e.slice(u, d), u = f = -1;
          }
        } else if (l) {
          if (1 !== n[v]) throw new SyntaxError("Unexpected character at index " + d);
          -1 === u ? u = d : s || (s = !0), l = !1;
        } else if (c) {
          if (1 === n[v]) -1 === u && (u = d);else if (34 === v && -1 !== u) c = !1, f = d;else {
            if (92 !== v) throw new SyntaxError("Unexpected character at index " + d);
            l = !0;
          }
        } else if (34 === v && 61 === e.charCodeAt(d - 1)) c = !0;else if (-1 === f && 1 === n[v]) -1 === u && (u = d);else if (-1 === u || 32 !== v && 9 !== v) {
          if (59 !== v && 44 !== v) throw new SyntaxError("Unexpected character at index " + d);
          {
            if (-1 === u) throw new SyntaxError("Unexpected character at index " + d);
            -1 === f && (f = d);
            let n = e.slice(u, f);
            s && (n = n.replace(/\\/g, ""), s = !1), a(o, i, n), 44 === v && (a(r, t, o), o = Object.create(null), t = void 0), i = void 0, u = f = -1;
          }
        } else -1 === f && (f = d);
      }
      if (-1 === u || c) throw new SyntaxError("Unexpected end of input");
      -1 === f && (f = d);
      const v = e.slice(u, f);
      return void 0 === t ? a(r, v, o) : (void 0 === i ? a(o, v, !0) : a(o, i, s ? v.replace(/\\/g, "") : v), a(r, t, o)), r;
    }
  };
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.ByteFormatter = r.TimeFormatter = r.RawValueFormatter = void 0;
  const n = t(53);
  r.RawValueFormatter = class {
    constructor() {
      this.unit = "none";
    }
    format(e) {
      return e.toLocaleString();
    }
  };
  r.TimeFormatter = class {
    constructor(e) {
      this.unit = e, this.multiplier = "nanoseconds" === e ? 1e-9 : "microseconds" === e ? 0.000001 : "milliseconds" === e ? 0.001 : 1;
    }
    formatUnsigned(e) {
      const r = e * this.multiplier;
      if (r / 60 >= 1) {
        const e = Math.floor(r / 60),
          t = Math.floor(r - 60 * e).toString();
        return `${e}:${n.zeroPad(t, 2)}`;
      }
      return r / 1 >= 1 ? r.toFixed(2) + "s" : r / 0.001 >= 1 ? (r / 0.001).toFixed(2) + "ms" : r / 0.000001 >= 1 ? (r / 0.000001).toFixed(2) + "\xB5s" : (r / 1e-9).toFixed(2) + "ns";
    }
    format(e) {
      return `${e < 0 ? "-" : ""}${this.formatUnsigned(Math.abs(e))}`;
    }
  };
  r.ByteFormatter = class {
    constructor() {
      this.unit = "bytes";
    }
    format(e) {
      return e < 1024 ? e.toFixed(0) + " B" : (e /= 1024) < 1024 ? e.toFixed(2) + " KB" : (e /= 1024) < 1024 ? e.toFixed(2) + " MB" : (e /= 1024).toFixed(2) + " GB";
    }
  };
}, function (e, r, t) {
  "use strict";

  var n = t(13);
  r.createRoot = n.createRoot, r.hydrateRoot = n.hydrateRoot;
}, function (e, r) {
  e.exports = _util;
}, function (e, r, t) {
  "use strict";

  const n = t(75);
  n.createWebSocketStream = t(123), n.Server = t(124), n.Receiver = t(78), n.Sender = t(81), e.exports = n;
}, function (e, r, t) {
  "use strict";

  e.exports = t(125);
}, function (e, r, t) {
  "use strict";

  var n = /[|\\{}()[\]^$+*?.]/g;
  e.exports = function (e) {
    if ("string" != typeof e) throw new TypeError("Expected a string");
    return e.replace(n, "\\$&");
  };
}, function (e, r, t) {
  var n = t(132);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r) {
  var t = /^\s+|\s+$/g,
    n = /^[-+]0x[0-9a-f]+$/i,
    a = /^0b[01]+$/i,
    i = /^0o[0-7]+$/i,
    o = parseInt,
    s = "object" == typeof _global && _global && _global.Object === Object && _global,
    l = "object" == typeof self && self && self.Object === Object && self,
    c = s || l || Function("return this")(),
    u = Object.prototype.toString,
    f = Math.max,
    d = Math.min,
    v = function () {
      return c.Date.now();
    };
  function h(e, r, t) {
    var n,
      a,
      i,
      o,
      s,
      l,
      c = 0,
      u = !1,
      h = !1,
      p = !0;
    if ("function" != typeof e) throw new TypeError("Expected a function");
    function g(r) {
      var t = n,
        i = a;
      return n = a = void 0, c = r, o = e.apply(i, t);
    }
    function b(e) {
      return c = e, s = setTimeout(E, r), u ? g(e) : o;
    }
    function S(e) {
      var t = e - l;
      return void 0 === l || t >= r || t < 0 || h && e - c >= i;
    }
    function E() {
      var e = v();
      if (S(e)) return w(e);
      s = setTimeout(E, function (e) {
        var t = r - (e - l);
        return h ? d(t, i - (e - c)) : t;
      }(e));
    }
    function w(e) {
      return s = void 0, p && n ? g(e) : (n = a = void 0, o);
    }
    function y() {
      var e = v(),
        t = S(e);
      if (n = arguments, a = this || _global, l = e, t) {
        if (void 0 === s) return b(l);
        if (h) return s = setTimeout(E, r), g(l);
      }
      return void 0 === s && (s = setTimeout(E, r)), o;
    }
    return r = _(r) || 0, m(t) && (u = !!t.leading, i = (h = "maxWait" in t) ? f(_(t.maxWait) || 0, r) : i, p = "trailing" in t ? !!t.trailing : p), y.cancel = function () {
      void 0 !== s && clearTimeout(s), c = 0, n = l = a = s = void 0;
    }, y.flush = function () {
      return void 0 === s ? o : w(v());
    }, y;
  }
  function m(e) {
    var r = typeof e;
    return !!e && ("object" == r || "function" == r);
  }
  function _(e) {
    if ("number" == typeof e) return e;
    if (function (e) {
      return "symbol" == typeof e || function (e) {
        return !!e && "object" == typeof e;
      }(e) && "[object Symbol]" == u.call(e);
    }(e)) return NaN;
    if (m(e)) {
      var r = "function" == typeof e.valueOf ? e.valueOf() : e;
      e = m(r) ? r + "" : r;
    }
    if ("string" != typeof e) return 0 === e ? e : +e;
    e = e.replace(t, "");
    var s = a.test(e);
    return s || i.test(e) ? o(e.slice(2), s ? 2 : 8) : n.test(e) ? NaN : +e;
  }
  e.exports = function (e, r, t) {
    var n = !0,
      a = !0;
    if ("function" != typeof e) throw new TypeError("Expected a function");
    return m(t) && (n = "leading" in t ? !!t.leading : n, a = "trailing" in t ? !!t.trailing : a), h(e, r, {
      leading: n,
      maxWait: r,
      trailing: a
    });
  };
}, function (e, r, t) {
  var n = t(134);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(137);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(146);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(147);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(149);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(150);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(152);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(153);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(157);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(162);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(177);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(178);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(183);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  "use strict";

  function n(e, r) {
    if (null != e) return e;
    var t = new Error(void 0 !== r ? r : "Got unexpected " + e);
    throw t.framesToPop = 1, t;
  }
  e.exports = n, e.exports.default = n, Object.defineProperty(e.exports, "__esModule", {
    value: !0
  });
}, function (e, r, t) {
  var n = t(109),
    a = ["importFile"];
  e.exports = function () {
    var e = new Worker(URL.createObjectURL(new Blob(["!function(e){var r={};function a(t){if(r[t])return r[t].exports;var i=r[t]={i:t,l:!1,exports:{}};return e[t].call(i.exports,i,i.exports,a),i.l=!0,i.exports}a.m=e,a.c=r,a.d=function(e,r,t){a.o(e,r)||Object.defineProperty(e,r,{enumerable:!0,get:t})},a.r=function(e){\"undefined\"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:\"Module\"}),Object.defineProperty(e,\"__esModule\",{value:!0})},a.t=function(e,r){if(1&r&&(e=a(e)),8&r)return e;if(4&r&&\"object\"==typeof e&&e&&e.__esModule)return e;var t=Object.create(null);if(a.r(t),Object.defineProperty(t,\"default\",{enumerable:!0,value:e}),2&r&&\"string\"!=typeof e)for(var i in e)a.d(t,i,function(r){return e[r]}.bind(null,i));return t},a.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return a.d(r,\"a\",r),r},a.o=function(e,r){return Object.prototype.hasOwnProperty.call(e,r)},a.p=\"\",a(a.s=13)}([function(e,r,a){\"use strict\";Object.defineProperty(r,\"__esModule\",{value:!0}),r.decodeBase64=r.lazyStatic=r.memoizeByReference=r.memoizeByShallowEquality=r.objectsHaveShallowEquality=r.noop=r.binarySearch=r.triangle=r.fract=r.formatPercent=r.zeroPad=r.itReduce=r.itForEach=r.itMap=r.KeyedSet=r.getOrThrow=r.getOrElse=r.getOrInsert=r.sortBy=r.lastOf=void 0,r.lastOf=function(e){return e[e.length-1]||null},r.sortBy=function(e,r){e.sort((function(e,a){const t=r(e),i=r(a);return t<i?-1:t>i?1:0}))},r.getOrInsert=function(e,r,a){return e.has(r)||e.set(r,a(r)),e.get(r)},r.getOrElse=function(e,r,a){return e.has(r)?e.get(r):a(r)},r.getOrThrow=function(e,r){if(!e.has(r))throw new Error(\"Expected key \"+r);return e.get(r)};class t{constructor(){this.map=new Map}getOrInsert(e){const r=e.key,a=this.map.get(r);return a||(this.map.set(r,e),e)}forEach(e){this.map.forEach(e)}[Symbol.iterator](){return this.map.values()}}function i(e){return e-Math.floor(e)}function n(e,r){for(let a in e)if(e[a]!==r[a])return!1;for(let a in r)if(e[a]!==r[a])return!1;return!0}function s(e){let r=null;return()=>(null==r&&(r={result:e()}),r.result)}r.KeyedSet=t,r.itMap=function*(e,r){for(let a of e)yield r(a)},r.itForEach=function(e,r){for(let a of e)r(a)},r.itReduce=function(e,r,a){let t=a;for(let a of e)t=r(t,a);return t},r.zeroPad=function(e,r){return new Array(Math.max(r-e.length,0)+1).join(\"0\")+e},r.formatPercent=function(e){let r=e.toFixed(0)+\"%\";return 100===e?r=\"100%\":e>99?r=\">99%\":e<.01?r=\"<0.01%\":e<1?r=e.toFixed(2)+\"%\":e<10&&(r=e.toFixed(1)+\"%\"),r},r.fract=i,r.triangle=function(e){return 2*Math.abs(i(e)-.5)-1},r.binarySearch=function(e,r,a,t,i=1){for(console.assert(!isNaN(i)&&!isNaN(t));;){if(r-e<=i)return[e,r];const n=(r+e)/2;a(n)<t?e=n:r=n}},r.noop=function(...e){},r.objectsHaveShallowEquality=n,r.memoizeByShallowEquality=function(e){let r=null;return a=>{let t;return null==r?(t=e(a),r={args:a,result:t},t):(n(r.args,a)||(r.args=a,r.result=e(a)),r.result)}},r.memoizeByReference=function(e){let r=null;return a=>{let t;return null==r?(t=e(a),r={args:a,result:t},t):(r.args===a||(r.args=a,r.result=e(a)),r.result)}},r.lazyStatic=s;const v=s(()=>{const e=\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/\",r=new Map;for(let a=0;a<e.length;a++)r.set(e.charAt(a),a);return r.set(\"=\",-1),r});r.decodeBase64=function(e){const r=v();if(e.length%4!=0)throw new Error(\"Invalid length for base64 encoded string. Expected length % 4 = 0, got length = \"+e.length);const a=e.length/4;let t;t=e.length>=4&&\"=\"===e.charAt(e.length-1)?\"=\"===e.charAt(e.length-2)?3*a-2:3*a-1:3*a;const i=new Uint8Array(t);let n=0;for(let t=0;t<a;t++){const a=e.charAt(4*t+0),s=e.charAt(4*t+1),v=e.charAt(4*t+2),o=e.charAt(4*t+3),f=r.get(a),l=r.get(s),_=r.get(v),u=r.get(o);if(null==f||null==l||null==_||null==u)throw new Error(`Invalid quartet at indices ${4*t} .. ${4*t+3}: ${e.substring(4*t,4*t+3)}`);i[n++]=f<<2|l>>4,\"=\"!==v&&(i[n++]=(15&l)<<4|_>>2),\"=\"!==o&&(i[n++]=(7&_)<<6|u)}if(n!==t)throw new Error(`Expected to decode ${t} bytes, but only decoded ${n})`);return i}},function(e,r,a){\"use strict\";var t=this&&this.__createBinding||(Object.create?function(e,r,a,t){void 0===t&&(t=a),Object.defineProperty(e,t,{enumerable:!0,get:function(){return r[a]}})}:function(e,r,a,t){void 0===t&&(t=a),e[t]=r[a]}),i=this&&this.__exportStar||function(e,r){for(var a in e)\"default\"===a||r.hasOwnProperty(a)||t(r,e,a)};Object.defineProperty(r,\"__esModule\",{value:!0}),i(a(6),r),i(a(10),r)},function(e,r,a){\"use strict\";Object.defineProperty(r,\"__esModule\",{value:!0}),r.ByteFormatter=r.TimeFormatter=r.RawValueFormatter=void 0;const t=a(0);r.RawValueFormatter=class{constructor(){this.unit=\"none\"}format(e){return e.toLocaleString()}};r.TimeFormatter=class{constructor(e){this.unit=e,this.multiplier=\"nanoseconds\"===e?1e-9:\"microseconds\"===e?1e-6:\"milliseconds\"===e?.001:1}formatUnsigned(e){const r=e*this.multiplier;if(r/60>=1){const e=Math.floor(r/60),a=Math.floor(r-60*e).toString();return`${e}:${t.zeroPad(a,2)}`}return r/1>=1?r.toFixed(2)+\"s\":r/.001>=1?(r/.001).toFixed(2)+\"ms\":r/1e-6>=1?(r/1e-6).toFixed(2)+\"\xB5s\":(r/1e-9).toFixed(2)+\"ns\"}format(e){return`${e<0?\"-\":\"\"}${this.formatUnsigned(Math.abs(e))}`}};r.ByteFormatter=class{constructor(){this.unit=\"bytes\"}format(e){return e<1024?e.toFixed(0)+\" B\":(e/=1024)<1024?e.toFixed(2)+\" KB\":(e/=1024)<1024?e.toFixed(2)+\" MB\":(e/=1024).toFixed(2)+\" GB\"}}},function(e,r,a){var t,i,n;!function(s,v){\"use strict\";i=[a(12)],void 0===(n=\"function\"==typeof(t=function(e){var r=/(^|@)\\S+:\\d+/,a=/^\\s*at .*(\\S+:\\d+|\\(native\\))/m,t=/^(eval@)?(\\[native code])?$/;return{parse:function(e){if(void 0!==e.stacktrace||void 0!==e[\"opera#sourceloc\"])return this.parseOpera(e);if(e.stack&&e.stack.match(a))return this.parseV8OrIE(e);if(e.stack)return this.parseFFOrSafari(e);throw new Error(\"Cannot parse given Error object\")},extractLocation:function(e){if(-1===e.indexOf(\":\"))return[e];var r=/(.+?)(?::(\\d+))?(?::(\\d+))?$/.exec(e.replace(/[()]/g,\"\"));return[r[1],r[2]||void 0,r[3]||void 0]},parseV8OrIE:function(r){return r.stack.split(\"\\n\").filter((function(e){return!!e.match(a)}),this).map((function(r){r.indexOf(\"(eval \")>-1&&(r=r.replace(/eval code/g,\"eval\").replace(/(\\(eval at [^()]*)|(\\),.*$)/g,\"\"));var a=r.replace(/^\\s+/,\"\").replace(/\\(eval code/g,\"(\"),t=a.match(/ (\\((.+):(\\d+):(\\d+)\\)$)/),i=(a=t?a.replace(t[0],\"\"):a).split(/\\s+/).slice(1),n=this.extractLocation(t?t[1]:i.pop()),s=i.join(\" \")||void 0,v=[\"eval\",\"<anonymous>\"].indexOf(n[0])>-1?void 0:n[0];return new e({functionName:s,fileName:v,lineNumber:n[1],columnNumber:n[2],source:r})}),this)},parseFFOrSafari:function(r){return r.stack.split(\"\\n\").filter((function(e){return!e.match(t)}),this).map((function(r){if(r.indexOf(\" > eval\")>-1&&(r=r.replace(/ line (\\d+)(?: > eval line \\d+)* > eval:\\d+:\\d+/g,\":$1\")),-1===r.indexOf(\"@\")&&-1===r.indexOf(\":\"))return new e({functionName:r});var a=/((.*\".+\"[^@]*)?[^@]*)(?:@)/,t=r.match(a),i=t&&t[1]?t[1]:void 0,n=this.extractLocation(r.replace(a,\"\"));return new e({functionName:i,fileName:n[0],lineNumber:n[1],columnNumber:n[2],source:r})}),this)},parseOpera:function(e){return!e.stacktrace||e.message.indexOf(\"\\n\")>-1&&e.message.split(\"\\n\").length>e.stacktrace.split(\"\\n\").length?this.parseOpera9(e):e.stack?this.parseOpera11(e):this.parseOpera10(e)},parseOpera9:function(r){for(var a=/Line (\\d+).*script (?:in )?(\\S+)/i,t=r.message.split(\"\\n\"),i=[],n=2,s=t.length;n<s;n+=2){var v=a.exec(t[n]);v&&i.push(new e({fileName:v[2],lineNumber:v[1],source:t[n]}))}return i},parseOpera10:function(r){for(var a=/Line (\\d+).*script (?:in )?(\\S+)(?:: In function (\\S+))?$/i,t=r.stacktrace.split(\"\\n\"),i=[],n=0,s=t.length;n<s;n+=2){var v=a.exec(t[n]);v&&i.push(new e({functionName:v[3]||void 0,fileName:v[2],lineNumber:v[1],source:t[n]}))}return i},parseOpera11:function(a){return a.stack.split(\"\\n\").filter((function(e){return!!e.match(r)&&!e.match(/^Error created at/)}),this).map((function(r){var a,t=r.split(\"@\"),i=this.extractLocation(t.pop()),n=t.shift()||\"\",s=n.replace(/<anonymous function(: (\\w+))?>/,\"$2\").replace(/\\([^)]*\\)/g,\"\")||void 0;n.match(/\\(([^)]*)\\)/)&&(a=n.replace(/^[^(]+\\(([^)]*)\\)$/,\"$1\"));var v=void 0===a||\"[arguments not available]\"===a?void 0:a.split(\",\");return new e({functionName:s,args:v,fileName:i[0],lineNumber:i[1],columnNumber:i[2],source:r})}),this)}}})?t.apply(r,i):t)||(e.exports=n)}()},function(e,r,a){\"use strict\";function t(e,r){if(null!=e)return e;var a=new Error(void 0!==r?r:\"Got unexpected \"+e);throw a.framesToPop=1,a}e.exports=t,e.exports.default=t,Object.defineProperty(e.exports,\"__esModule\",{value:!0})},function(e,r,a){var t=function(e){\"use strict\";var r=Object.prototype,a=r.hasOwnProperty,t=\"function\"==typeof Symbol?Symbol:{},i=t.iterator||\"@@iterator\",n=t.asyncIterator||\"@@asyncIterator\",s=t.toStringTag||\"@@toStringTag\";function v(e,r,a){return Object.defineProperty(e,r,{value:a,enumerable:!0,configurable:!0,writable:!0}),e[r]}try{v({},\"\")}catch(e){v=function(e,r,a){return e[r]=a}}function o(e,r,a,t){var i=r&&r.prototype instanceof _?r:_,n=Object.create(i.prototype),s=new M(t||[]);return n._invoke=function(e,r,a){var t=\"suspendedStart\";return function(i,n){if(\"executing\"===t)throw new Error(\"Generator is already running\");if(\"completed\"===t){if(\"throw\"===i)throw n;return A()}for(a.method=i,a.arg=n;;){var s=a.delegate;if(s){var v=k(s,a);if(v){if(v===l)continue;return v}}if(\"next\"===a.method)a.sent=a._sent=a.arg;else if(\"throw\"===a.method){if(\"suspendedStart\"===t)throw t=\"completed\",a.arg;a.dispatchException(a.arg)}else\"return\"===a.method&&a.abrupt(\"return\",a.arg);t=\"executing\";var o=f(e,r,a);if(\"normal\"===o.type){if(t=a.done?\"completed\":\"suspendedYield\",o.arg===l)continue;return{value:o.arg,done:a.done}}\"throw\"===o.type&&(t=\"completed\",a.method=\"throw\",a.arg=o.arg)}}}(e,a,s),n}function f(e,r,a){try{return{type:\"normal\",arg:e.call(r,a)}}catch(e){return{type:\"throw\",arg:e}}}e.wrap=o;var l={};function _(){}function u(){}function S(){}var c={};c[i]=function(){return this};var h=Object.getPrototypeOf,d=h&&h(h(H([])));d&&d!==r&&a.call(d,i)&&(c=d);var b=S.prototype=_.prototype=Object.create(c);function p(e){[\"next\",\"throw\",\"return\"].forEach((function(r){v(e,r,(function(e){return this._invoke(r,e)}))}))}function m(e,r){var t;this._invoke=function(i,n){function s(){return new r((function(t,s){!function t(i,n,s,v){var o=f(e[i],e,n);if(\"throw\"!==o.type){var l=o.arg,_=l.value;return _&&\"object\"==typeof _&&a.call(_,\"__await\")?r.resolve(_.__await).then((function(e){t(\"next\",e,s,v)}),(function(e){t(\"throw\",e,s,v)})):r.resolve(_).then((function(e){l.value=e,s(l)}),(function(e){return t(\"throw\",e,s,v)}))}v(o.arg)}(i,n,t,s)}))}return t=t?t.then(s,s):s()}}function k(e,r){var a=e.iterator[r.method];if(void 0===a){if(r.delegate=null,\"throw\"===r.method){if(e.iterator.return&&(r.method=\"return\",r.arg=void 0,k(e,r),\"throw\"===r.method))return l;r.method=\"throw\",r.arg=new TypeError(\"The iterator does not provide a 'throw' method\")}return l}var t=f(a,e.iterator,r.arg);if(\"throw\"===t.type)return r.method=\"throw\",r.arg=t.arg,r.delegate=null,l;var i=t.arg;return i?i.done?(r[e.resultName]=i.value,r.next=e.nextLoc,\"return\"!==r.method&&(r.method=\"next\",r.arg=void 0),r.delegate=null,l):i:(r.method=\"throw\",r.arg=new TypeError(\"iterator result is not an object\"),r.delegate=null,l)}function w(e){var r={tryLoc:e[0]};1 in e&&(r.catchLoc=e[1]),2 in e&&(r.finallyLoc=e[2],r.afterLoc=e[3]),this.tryEntries.push(r)}function g(e){var r=e.completion||{};r.type=\"normal\",delete r.arg,e.completion=r}function M(e){this.tryEntries=[{tryLoc:\"root\"}],e.forEach(w,this),this.reset(!0)}function H(e){if(e){var r=e[i];if(r)return r.call(e);if(\"function\"==typeof e.next)return e;if(!isNaN(e.length)){var t=-1,n=function r(){for(;++t<e.length;)if(a.call(e,t))return r.value=e[t],r.done=!1,r;return r.value=void 0,r.done=!0,r};return n.next=n}}return{next:A}}function A(){return{value:void 0,done:!0}}return u.prototype=b.constructor=S,S.constructor=u,u.displayName=v(S,s,\"GeneratorFunction\"),e.isGeneratorFunction=function(e){var r=\"function\"==typeof e&&e.constructor;return!!r&&(r===u||\"GeneratorFunction\"===(r.displayName||r.name))},e.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,S):(e.__proto__=S,v(e,s,\"GeneratorFunction\")),e.prototype=Object.create(b),e},e.awrap=function(e){return{__await:e}},p(m.prototype),m.prototype[n]=function(){return this},e.AsyncIterator=m,e.async=function(r,a,t,i,n){void 0===n&&(n=Promise);var s=new m(o(r,a,t,i),n);return e.isGeneratorFunction(a)?s:s.next().then((function(e){return e.done?e.value:s.next()}))},p(b),v(b,s,\"Generator\"),b[i]=function(){return this},b.toString=function(){return\"[object Generator]\"},e.keys=function(e){var r=[];for(var a in e)r.push(a);return r.reverse(),function a(){for(;r.length;){var t=r.pop();if(t in e)return a.value=t,a.done=!1,a}return a.done=!0,a}},e.values=H,M.prototype={constructor:M,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method=\"next\",this.arg=void 0,this.tryEntries.forEach(g),!e)for(var r in this)\"t\"===r.charAt(0)&&a.call(this,r)&&!isNaN(+r.slice(1))&&(this[r]=void 0)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if(\"throw\"===e.type)throw e.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var r=this;function t(a,t){return s.type=\"throw\",s.arg=e,r.next=a,t&&(r.method=\"next\",r.arg=void 0),!!t}for(var i=this.tryEntries.length-1;i>=0;--i){var n=this.tryEntries[i],s=n.completion;if(\"root\"===n.tryLoc)return t(\"end\");if(n.tryLoc<=this.prev){var v=a.call(n,\"catchLoc\"),o=a.call(n,\"finallyLoc\");if(v&&o){if(this.prev<n.catchLoc)return t(n.catchLoc,!0);if(this.prev<n.finallyLoc)return t(n.finallyLoc)}else if(v){if(this.prev<n.catchLoc)return t(n.catchLoc,!0)}else{if(!o)throw new Error(\"try statement without catch or finally\");if(this.prev<n.finallyLoc)return t(n.finallyLoc)}}}},abrupt:function(e,r){for(var t=this.tryEntries.length-1;t>=0;--t){var i=this.tryEntries[t];if(i.tryLoc<=this.prev&&a.call(i,\"finallyLoc\")&&this.prev<i.finallyLoc){var n=i;break}}n&&(\"break\"===e||\"continue\"===e)&&n.tryLoc<=r&&r<=n.finallyLoc&&(n=null);var s=n?n.completion:{};return s.type=e,s.arg=r,n?(this.method=\"next\",this.next=n.finallyLoc,l):this.complete(s)},complete:function(e,r){if(\"throw\"===e.type)throw e.arg;return\"break\"===e.type||\"continue\"===e.type?this.next=e.arg:\"return\"===e.type?(this.rval=this.arg=e.arg,this.method=\"return\",this.next=\"end\"):\"normal\"===e.type&&r&&(this.next=r),l},finish:function(e){for(var r=this.tryEntries.length-1;r>=0;--r){var a=this.tryEntries[r];if(a.finallyLoc===e)return this.complete(a.completion,a.afterLoc),g(a),l}},catch:function(e){for(var r=this.tryEntries.length-1;r>=0;--r){var a=this.tryEntries[r];if(a.tryLoc===e){var t=a.completion;if(\"throw\"===t.type){var i=t.arg;g(a)}return i}}throw new Error(\"illegal catch attempt\")},delegateYield:function(e,r,a){return this.delegate={iterator:H(e),resultName:r,nextLoc:a},\"next\"===this.method&&(this.arg=void 0),l}},e}(e.exports);try{regeneratorRuntime=t}catch(e){Function(\"r\",\"regeneratorRuntime = r\")(t)}},function(e,r,a){\"use strict\";Object.defineProperty(r,\"__esModule\",{value:!0}),r.importFromOldV8CPUProfile=r.importFromChromeCPUProfile=r.importFromChromeTimeline=r.isChromeTimeline=void 0;const t=a(7),i=a(0),n=a(2),s=a(9);r.isChromeTimeline=function(e){if(!Array.isArray(e))return!1;if(e.length<1)return!1;const r=e[0];return\"pid\"in r&&\"tid\"in r&&\"ph\"in r&&\"cat\"in r&&!!e.find(e=>\"CpuProfile\"===e.name||\"Profile\"===e.name||\"ProfileChunk\"===e.name)},r.importFromChromeTimeline=function(e,r){const a=new Map,t=new Map,n=new Map;i.sortBy(e,e=>e.ts);for(let r of e){if(\"CpuProfile\"===r.name){const e=`${r.pid}:${r.tid}`,i=r.id||e;a.set(i,r.args.data.cpuProfile),t.set(i,e)}if(\"Profile\"===r.name){const e=`${r.pid}:${r.tid}`;a.set(r.id||e,Object.assign({startTime:0,endTime:0,nodes:[],samples:[],timeDeltas:[]},r.args.data)),r.id&&t.set(r.id,`${r.pid}:${r.tid}`)}if(\"thread_name\"===r.name&&n.set(`${r.pid}:${r.tid}`,r.args.name),\"ProfileChunk\"===r.name){const e=`${r.pid}:${r.tid}`,t=a.get(r.id||e);if(t){const e=r.args.data;e.cpuProfile&&(e.cpuProfile.nodes&&(t.nodes=t.nodes.concat(e.cpuProfile.nodes)),e.cpuProfile.samples&&(t.samples=t.samples.concat(e.cpuProfile.samples))),e.timeDeltas&&(t.timeDeltas=t.timeDeltas.concat(e.timeDeltas)),null!=e.startTime&&(t.startTime=e.startTime),null!=e.endTime&&(t.endTime=e.endTime)}else console.warn(\"Ignoring ProfileChunk for undeclared Profile with id \"+(r.id||e))}}if(a.size>0){const e=[];let s=0;return i.itForEach(a.keys(),i=>{let v=null,o=t.get(i);o&&(v=n.get(o)||null);const f=_(a.get(i));v&&a.size>1?(f.setName(`${r} - ${v}`),\"CrRendererMain\"===v&&(s=e.length)):f.setName(\"\"+r),e.push(f)}),{name:r,indexToView:s,profiles:e}}throw new Error(\"Could not find CPU profile in Timeline\")};const v=new Map;function o(e){return i.getOrInsert(v,e,e=>{const r=e.functionName||\"(anonymous)\",a=e.url,t=e.lineNumber,i=e.columnNumber;return{key:`${r}:${a}:${t}:${i}`,name:r,file:a,line:t,col:i}})}function f(e){const{functionName:r,url:a}=e;return\"native dummy.js\"===a||(\"(root)\"===r||\"(idle)\"===r)}function l(e){return\"(garbage collector)\"===e||\"(program)\"===e}function _(e){const r=new t.CallTreeProfileBuilder(e.endTime-e.startTime),a=new Map;for(let r of e.nodes)a.set(r.id,r);for(let r of e.nodes)if(\"number\"==typeof r.parent&&(r.parent=a.get(r.parent)),r.children)for(let e of r.children){const t=a.get(e);t&&(t.parent=r)}const s=[],v=[];let _=e.timeDeltas[0],u=_,S=NaN;for(let r=0;r<e.samples.length;r++){const a=e.samples[r];if(a!=S&&(s.push(a),_<u?v.push(u):(v.push(_),u=_)),r===e.samples.length-1)isNaN(S)||(s.push(S),_<u?v.push(u):(v.push(_),u=_));else{_+=e.timeDeltas[r+1],S=a}}let c=[];for(let e=0;e<s.length;e++){const t=v[e],n=s[e];let _=a.get(n);if(!_)continue;let u=null;for(u=_;u&&-1===c.indexOf(u);u=l(u.callFrame.functionName)?i.lastOf(c):u.parent||null);for(;c.length>0&&i.lastOf(c)!=u;){const e=o(c.pop().callFrame);r.leaveFrame(e,t)}const S=[];for(let e=_;e&&e!=u&&!f(e.callFrame);e=l(e.callFrame.functionName)?i.lastOf(c):e.parent||null)S.push(e);S.reverse();for(let e of S)r.enterFrame(o(e.callFrame),t);c=c.concat(S)}for(let e=c.length-1;e>=0;e--)r.leaveFrame(o(c[e].callFrame),i.lastOf(v));return r.setValueFormatter(new n.TimeFormatter(\"microseconds\")),r.build()}r.importFromChromeCPUProfile=_,r.importFromOldV8CPUProfile=function(e){return _(s.chromeTreeToNodes(e))}},function(e,r,a){\"use strict\";var t=this&&this.__createBinding||(Object.create?function(e,r,a,t){void 0===t&&(t=a),Object.defineProperty(e,t,{enumerable:!0,get:function(){return r[a]}})}:function(e,r,a,t){void 0===t&&(t=a),e[t]=r[a]}),i=this&&this.__setModuleDefault||(Object.create?function(e,r){Object.defineProperty(e,\"default\",{enumerable:!0,value:r})}:function(e,r){e.default=r}),n=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var r={};if(null!=e)for(var a in e)Object.hasOwnProperty.call(e,a)&&t(r,e,a);return i(r,e),r},s=this&&this.__awaiter||function(e,r,a,t){return new(a||(a=Promise))((function(i,n){function s(e){try{o(t.next(e))}catch(e){n(e)}}function v(e){try{o(t.throw(e))}catch(e){n(e)}}function o(e){var r;e.done?i(e.value):(r=e.value,r instanceof a?r:new a((function(e){e(r)}))).then(s,v)}o((t=t.apply(e,r||[])).next())}))};Object.defineProperty(r,\"__esModule\",{value:!0}),r.CallTreeProfileBuilder=r.StackListProfileBuilder=r.Profile=r.CallTreeNode=r.Frame=r.HasWeights=void 0;const v=a(0),o=a(2),f=Promise.resolve().then(()=>n(a(8)));f.then(()=>{});class l{constructor(){this.selfWeight=0,this.totalWeight=0}getSelfWeight(){return this.selfWeight}getTotalWeight(){return this.totalWeight}addToTotalWeight(e){this.totalWeight+=e}addToSelfWeight(e){this.selfWeight+=e}overwriteWeightWith(e){this.selfWeight=e.selfWeight,this.totalWeight=e.totalWeight}}r.HasWeights=l;let _=(()=>{class e extends l{constructor(e){super(),this.key=e.key,this.name=e.name,this.file=e.file,this.line=e.line,this.col=e.col}static getOrInsert(r,a){return r.getOrInsert(new e(a))}}return e.root=new e({key:\"(speedscope root)\",name:\"(speedscope root)\"}),e})();r.Frame=_;class u extends l{constructor(e,r){super(),this.frame=e,this.parent=r,this.children=[],this.frozen=!1}isRoot(){return this.frame===_.root}isFrozen(){return this.frozen}freeze(){this.frozen=!0}}r.CallTreeNode=u;class S{constructor(e=0){this.name=\"\",this.frames=new v.KeyedSet,this.appendOrderCalltreeRoot=new u(_.root,null),this.groupedCalltreeRoot=new u(_.root,null),this.samples=[],this.weights=[],this.valueFormatter=new o.RawValueFormatter,this.totalNonIdleWeight=null,this.totalWeight=e}getAppendOrderCalltreeRoot(){return this.appendOrderCalltreeRoot}getGroupedCalltreeRoot(){return this.groupedCalltreeRoot}formatValue(e){return this.valueFormatter.format(e)}setValueFormatter(e){this.valueFormatter=e}getWeightUnit(){return this.valueFormatter.unit}getName(){return this.name}setName(e){this.name=e}getTotalWeight(){return this.totalWeight}getTotalNonIdleWeight(){return null===this.totalNonIdleWeight&&(this.totalNonIdleWeight=this.groupedCalltreeRoot.children.reduce((e,r)=>e+r.getTotalWeight(),0)),this.totalNonIdleWeight}sortGroupedCallTree(){!function e(r){r.children.sort((e,r)=>-(e.getTotalWeight()-r.getTotalWeight())),r.children.forEach(e)}(this.groupedCalltreeRoot)}forEachCallGrouped(e,r){!function a(t,i){t.frame!==_.root&&e(t,i);let n=0;t.children.forEach((function(e){a(e,i+n),n+=e.getTotalWeight()})),t.frame!==_.root&&r(t,i+t.getTotalWeight())}(this.groupedCalltreeRoot,0)}forEachCall(e,r){let a=[],t=0,i=0;for(let n of this.samples){let s=null;for(s=n;s&&s.frame!=_.root&&-1===a.indexOf(s);s=s.parent);for(;a.length>0&&v.lastOf(a)!=s;){r(a.pop(),t)}const o=[];for(let e=n;e&&e.frame!=_.root&&e!=s;e=e.parent)o.push(e);o.reverse();for(let r of o)e(r,t);a=a.concat(o),t+=this.weights[i++]}for(let e=a.length-1;e>=0;e--)r(a[e],t)}forEachFrame(e){this.frames.forEach(e)}getProfileWithRecursionFlattened(){const e=new h,r=[],a=new Set;this.forEachCall((function(t,i){a.has(t.frame)?r.push(null):(a.add(t.frame),r.push(t),e.enterFrame(t.frame,i))}),(function(t,i){const n=r.pop();n&&(a.delete(n.frame),e.leaveFrame(n.frame,i))}));const t=e.build();return t.name=this.name,t.valueFormatter=this.valueFormatter,this.forEachFrame(e=>{t.frames.getOrInsert(e).overwriteWeightWith(e)}),t}getInvertedProfileForCallersOf(e){const r=_.getOrInsert(this.frames,e),a=new c,t=[];!function e(a){if(a.frame===r)t.push(a);else for(let r of a.children)e(r)}(this.appendOrderCalltreeRoot);for(let e of t){const r=[];for(let a=e;null!=a&&a.frame!==_.root;a=a.parent)r.push(a.frame);a.appendSampleWithWeight(r,e.getTotalWeight())}const i=a.build();return i.name=this.name,i.valueFormatter=this.valueFormatter,i}getProfileForCalleesOf(e){const r=_.getOrInsert(this.frames,e),a=new c;!function e(t){if(t.frame===r)!function(e){const r=[];!function e(t){r.push(t.frame),a.appendSampleWithWeight(r,t.getSelfWeight());for(let r of t.children)e(r);r.pop()}(e)}(t);else for(let r of t.children)e(r)}(this.appendOrderCalltreeRoot);const t=a.build();return t.name=this.name,t.valueFormatter=this.valueFormatter,t}demangle(){return s(this,void 0,void 0,(function*(){let e=null;for(let r of this.frames)r.name.startsWith(\"__Z\")&&(e||(e=(yield f).demangleCpp),r.name=e(r.name))}))}remapNames(e){for(let r of this.frames)r.name=e(r.name)}}r.Profile=S;class c extends S{constructor(){super(...arguments),this.pendingSample=null}_appendSample(e,r,a){if(isNaN(r))throw new Error(\"invalid weight\");let t=a?this.appendOrderCalltreeRoot:this.groupedCalltreeRoot,i=new Set;for(let n of e){const e=_.getOrInsert(this.frames,n),s=a?v.lastOf(t.children):t.children.find(r=>r.frame===e);if(s&&!s.isFrozen()&&s.frame==e)t=s;else{const r=t;t=new u(e,t),r.children.push(t)}t.addToTotalWeight(r),i.add(t.frame)}if(t.addToSelfWeight(r),a)for(let e of t.children)e.freeze();if(a){t.frame.addToSelfWeight(r);for(let e of i)e.addToTotalWeight(r);t===v.lastOf(this.samples)?this.weights[this.weights.length-1]+=r:(this.samples.push(t),this.weights.push(r))}}appendSampleWithWeight(e,r){if(0!==r){if(r<0)throw new Error(\"Samples must have positive weights\");this._appendSample(e,r,!0),this._appendSample(e,r,!1)}}appendSampleWithTimestamp(e,r){if(this.pendingSample){if(r<this.pendingSample.centralTimestamp)throw new Error(\"Timestamps received out of order\");const a=(r+this.pendingSample.centralTimestamp)/2;this.appendSampleWithWeight(this.pendingSample.stack,a-this.pendingSample.startTimestamp),this.pendingSample={stack:e,startTimestamp:a,centralTimestamp:r}}else this.pendingSample={stack:e,startTimestamp:r,centralTimestamp:r}}build(){return this.pendingSample&&(this.samples.length>0?this.appendSampleWithWeight(this.pendingSample.stack,this.pendingSample.centralTimestamp-this.pendingSample.startTimestamp):(this.appendSampleWithWeight(this.pendingSample.stack,1),this.setValueFormatter(new o.RawValueFormatter))),this.totalWeight=Math.max(this.totalWeight,this.weights.reduce((e,r)=>e+r,0)),this.sortGroupedCallTree(),this}}r.StackListProfileBuilder=c;class h extends S{constructor(){super(...arguments),this.appendOrderStack=[this.appendOrderCalltreeRoot],this.groupedOrderStack=[this.groupedCalltreeRoot],this.framesInStack=new Map,this.stack=[],this.lastValue=0}addWeightsToFrames(e){const r=e-this.lastValue;for(let e of this.framesInStack.keys())e.addToTotalWeight(r);const a=v.lastOf(this.stack);a&&a.addToSelfWeight(r)}addWeightsToNodes(e,r){const a=e-this.lastValue;for(let e of r)e.addToTotalWeight(a);const t=v.lastOf(r);t&&t.addToSelfWeight(a)}_enterFrame(e,r,a){let t=a?this.appendOrderStack:this.groupedOrderStack;this.addWeightsToNodes(r,t);let i=v.lastOf(t);if(i){if(a){const e=r-this.lastValue;if(e>0)this.samples.push(i),this.weights.push(r-this.lastValue);else if(e<0)throw new Error(`Samples must be provided in increasing order of cumulative value. Last sample was ${this.lastValue}, this sample was ${r}`)}const n=a?v.lastOf(i.children):i.children.find(r=>r.frame===e);let s;n&&!n.isFrozen()&&n.frame==e?s=n:(s=new u(e,i),i.children.push(s)),t.push(s)}}enterFrame(e,r){const a=_.getOrInsert(this.frames,e);this.addWeightsToFrames(r),this._enterFrame(a,r,!0),this._enterFrame(a,r,!1),this.stack.push(a);const t=this.framesInStack.get(a)||0;this.framesInStack.set(a,t+1),this.lastValue=r}_leaveFrame(e,r,a){let t=a?this.appendOrderStack:this.groupedOrderStack;if(this.addWeightsToNodes(r,t),a){const a=this.appendOrderStack.pop();if(null==a)throw new Error(`Trying to leave ${e.key} when stack is empty`);if(null==this.lastValue)throw new Error(`Trying to leave a ${e.key} before any have been entered`);if(a.freeze(),a.frame.key!==e.key)throw new Error(`Tried to leave frame \"${e.name}\" while frame \"${a.frame.name}\" was at the top at ${r}`);const t=r-this.lastValue;if(t>0)this.samples.push(a),this.weights.push(r-this.lastValue);else if(t<0)throw new Error(`Samples must be provided in increasing order of cumulative value. Last sample was ${this.lastValue}, this sample was ${r}`)}else this.groupedOrderStack.pop()}leaveFrame(e,r){const a=_.getOrInsert(this.frames,e);this.addWeightsToFrames(r),this._leaveFrame(a,r,!0),this._leaveFrame(a,r,!1),this.stack.pop();const t=this.framesInStack.get(a);null!=t&&(1===t?this.framesInStack.delete(a):this.framesInStack.set(a,t-1),this.lastValue=r,this.totalWeight=Math.max(this.totalWeight,this.lastValue))}build(){if(this.appendOrderStack.length>1||this.groupedOrderStack.length>1)throw new Error(\"Tried to complete profile construction with a non-empty stack\");return this.sortGroupedCallTree(),this}}r.CallTreeProfileBuilder=h},function(e,r,a){\"use strict\";let t;Object.defineProperty(r,\"__esModule\",{value:!0}),r.demangleCpp=void 0;const i=new Map;r.demangleCpp=function(e){if(e.startsWith(\"__Z\")){let r=i.get(e);void 0!==r||(t||(t=new Function(\"exports\",n)()),r=t(e.slice(1)),r=\"(null)\"===r?e:r,i.set(e,r)),e=r}return e};const n='\\nreturn function(){function r(r){eval.call(null,r)}function a(r){throw print(r+\":\\\\n\"+(new Error).stack),ke=!0,\"Assertion: \"+r}function e(r,e){r||a(\"Assertion failed: \"+e)}function i(r,a,i,v){function t(r,a){if(\"string\"==a){var e=Oe;return le.stackAlloc(r.length+1),A(r,e),e}return r}function f(r,a){return\"string\"==a?s(r):r}try{func=ce.Module[\"_\"+r]}catch(r){}e(func,\"Cannot call unknown function \"+r+\" (perhaps LLVM optimizations or closure removed it?)\");var _=0,n=v?v.map(function(r){return t(r,i[_++])}):[];return f(func.apply(null,n),a)}function v(r,a,e){return function(){return i(r,a,e,Array.prototype.slice.call(arguments))}}function t(r,e,i,v){switch(i=i||\"i8\",\"*\"===i[i.length-1]&&(i=\"i32\"),i){case\"i1\":Ae[r]=e;break;case\"i8\":Ae[r]=e;break;case\"i16\":ye[r>>1]=e;break;case\"i32\":Se[r>>2]=e;break;case\"i64\":Se[r>>2]=e;break;case\"float\":Ce[r>>2]=e;break;case\"double\":ze[0]=e,Se[r>>2]=xe[0],Se[r+4>>2]=xe[1];break;default:a(\"invalid type for setValue: \"+i)}}function f(r,e,i){switch(e=e||\"i8\",\"*\"===e[e.length-1]&&(e=\"i32\"),e){case\"i1\":return Ae[r];case\"i8\":return Ae[r];case\"i16\":return ye[r>>1];case\"i32\":return Se[r>>2];case\"i64\":return Se[r>>2];case\"float\":return Ce[r>>2];case\"double\":return xe[0]=Se[r>>2],xe[1]=Se[r+4>>2],ze[0];default:a(\"invalid type for setValue: \"+e)}return null}function _(r,a,e){var i,v;\"number\"==typeof r?(i=!0,v=r):(i=!1,v=r.length);var f=\"string\"==typeof a?a:null,_=[Jr,le.stackAlloc,le.staticAlloc][void 0===e?we:e](Math.max(v,f?1:a.length));if(i)return Fa(_,0,v),_;for(var s,n=0;n<v;){var o=r[n];\"function\"==typeof o&&(o=le.getFunctionIndex(o)),s=f||a[n],0!==s?(\"i64\"==s&&(s=\"i32\"),t(_+n,o,s),n+=le.getNativeTypeSize(s)):n++}return _}function s(r,a){for(var e,i=\"undefined\"==typeof a,v=\"\",t=0,f=String.fromCharCode(0);;){if(e=String.fromCharCode(ge[r+t]),i&&e==f)break;if(v+=e,t+=1,!i&&t==a)break}return v}function n(r){for(var a=\"\",e=0;e<r.length;e++)a+=String.fromCharCode(r[e]);return a}function o(r){return r+4095>>12<<12}function l(){for(;Le<=Ie;)Le=o(2*Le);var r=Ae,a=new ArrayBuffer(Le);Ae=new Int8Array(a),ye=new Int16Array(a),Se=new Int32Array(a),ge=new Uint8Array(a),me=new Uint16Array(a),Me=new Uint32Array(a),Ce=new Float32Array(a),Re=new Float64Array(a),Ae.set(r)}function b(r){for(;r.length>0;){var a=r.shift(),e=a.func;\"number\"==typeof e&&(e=pe[e]),e(void 0===a.arg?null:a.arg)}}function k(){b(Ve)}function u(){b(Be),be.print()}function c(r,a){return Array.prototype.slice.call(Ae.subarray(r,r+a))}function h(r,a){for(var e=new Uint8Array(a),i=0;i<a;++i)e[i]=Ae[r+i];return e.buffer}function d(r){for(var a=0;Ae[r+a];)a++;return a}function w(r,a){var e=d(r);a&&e++;var i=c(r,e);return a&&(i[e-1]=0),i}function p(r,a){for(var e=[],i=0;i<r.length;){var v=r.charCodeAt(i);v>255&&(v&=255),e.push(v),i+=1}return a||e.push(0),e}function E(r){for(var a=[],e=0;e<r.length;e++){var i=r[e];i>255&&(i&=255),a.push(String.fromCharCode(i))}return a.join(\"\")}function A(r,a,e){for(var i=0;i<r.length;){var v=r.charCodeAt(i);v>255&&(v&=255),Ae[a+i]=v,i+=1}e||(Ae[a+i]=0)}function g(r,a,e,i){return r>=0?r:a<=32?2*Math.abs(1<<a-1)+r:Math.pow(2,a)+r}function y(r,a,e,i){if(r<=0)return r;var v=a<=32?Math.abs(1<<a-1):Math.pow(2,a-1);return r>=v&&(a<=32||r>v)&&(r=-2*v+r),r}function m(r,a,e){if(0==(0|r)|0==(0|a)|0==(0|e))var i=0;else{Se[r>>2]=0,Se[r+4>>2]=a,Se[r+8>>2]=e;var i=1}var i;return i}function S(r,a,e){if(0==(0|r)|(0|a)<0|0==(0|e))var i=0;else{Se[r>>2]=41,Se[r+4>>2]=a,Se[r+8>>2]=e;var i=1}var i;return i}function M(r,a,e){if(0==(0|r)|0==(0|e))var i=0;else{Se[r>>2]=6,Se[r+4>>2]=a,Se[r+8>>2]=e;var i=1}var i;return i}function C(r,a,e){if(0==(0|r)|0==(0|e))var i=0;else{Se[r>>2]=7,Se[r+4>>2]=a,Se[r+8>>2]=e;var i=1}var i;return i}function R(r,a){var e,i=0==(0|a);do if(i)var v=0;else{var e=(r+32|0)>>2,t=Se[e];if((0|t)>=(0|Se[r+36>>2])){var v=0;break}var f=(t<<2)+Se[r+28>>2]|0;Se[f>>2]=a;var _=Se[e]+1|0;Se[e]=_;var v=1}while(0);var v;return v}function T(r,a){var e,e=(r+12|0)>>2,i=Se[e],v=i+1|0;Se[e]=v;var t=Ae[i]<<24>>24==95;do if(t){var f=i+2|0;if(Se[e]=f,Ae[v]<<24>>24!=90){var _=0;break}var s=O(r,a),_=s}else var _=0;while(0);var _;return _}function O(r,a){var e=r+12|0,i=Ae[Se[e>>2]];r:do if(i<<24>>24==71||i<<24>>24==84)var v=Tr(r),t=v;else{var f=Ar(r),_=0==(0|f)|0==(0|a);do if(!_){if(0!=(1&Se[r+8>>2]|0))break;var s=Me[f>>2],n=(s-25|0)>>>0<3;a:do if(n)for(var o=f;;){var o,l=Me[o+4>>2],b=Me[l>>2];if((b-25|0)>>>0>=3){var k=l,u=b;break a}var o=l}else var k=f,u=s;while(0);var u,k;if(2!=(0|u)){var t=k;break r}var c=k+8|0,h=Me[c>>2],d=(Se[h>>2]-25|0)>>>0<3;a:do if(d)for(var w=h;;){var w,p=Me[w+4>>2];if((Se[p>>2]-25|0)>>>0>=3){var E=p;break a}var w=p}else var E=h;while(0);var E;Se[c>>2]=E;var t=k;break r}while(0);var A=Ae[Se[e>>2]];if(A<<24>>24==0||A<<24>>24==69){var t=f;break}var g=Or(f),y=Sr(r,g),m=D(r,3,f,y),t=m}while(0);var t;return t}function N(r){var a,e,i=Oe;Oe+=4;var v=i,e=v>>2,a=(r+12|0)>>2,t=Me[a],f=Ae[t],_=f<<24>>24;r:do if(f<<24>>24==114||f<<24>>24==86||f<<24>>24==75){var s=I(r,v,0);if(0==(0|s)){var n=0;break}var o=N(r);Se[s>>2]=o;var l=Se[e],b=R(r,l);if(0==(0|b)){var n=0;break}var n=Se[e]}else{do{if(97==(0|_)||98==(0|_)||99==(0|_)||100==(0|_)||101==(0|_)||102==(0|_)||103==(0|_)||104==(0|_)||105==(0|_)||106==(0|_)||108==(0|_)||109==(0|_)||110==(0|_)||111==(0|_)||115==(0|_)||116==(0|_)||118==(0|_)||119==(0|_)||120==(0|_)||121==(0|_)||122==(0|_)){var k=ai+20*(_-97)|0,u=P(r,k);Se[e]=u;var c=r+48|0,h=Se[c>>2]+Se[Se[u+4>>2]+4>>2]|0;Se[c>>2]=h;var d=Se[a]+1|0;Se[a]=d;var n=u;break r}if(117==(0|_)){Se[a]=t+1|0;var w=L(r),p=D(r,34,w,0);Se[e]=p;var E=p}else if(70==(0|_)){var A=F(r);Se[e]=A;var E=A}else if(48==(0|_)||49==(0|_)||50==(0|_)||51==(0|_)||52==(0|_)||53==(0|_)||54==(0|_)||55==(0|_)||56==(0|_)||57==(0|_)||78==(0|_)||90==(0|_)){var g=X(r);Se[e]=g;var E=g}else if(65==(0|_)){var y=j(r);Se[e]=y;var E=y}else if(77==(0|_)){var m=U(r);Se[e]=m;var E=m}else if(84==(0|_)){var S=x(r);if(Se[e]=S,Ae[Se[a]]<<24>>24!=73){var E=S;break}var M=R(r,S);if(0==(0|M)){var n=0;break r}var C=Se[e],T=z(r),O=D(r,4,C,T);Se[e]=O;var E=O}else if(83==(0|_)){var B=ge[t+1|0];if((B-48&255&255)<10|B<<24>>24==95|(B-65&255&255)<26){var H=V(r,0);if(Se[e]=H,Ae[Se[a]]<<24>>24!=73){var n=H;break r}var K=z(r),Y=D(r,4,H,K);Se[e]=Y;var E=Y}else{var G=X(r);if(Se[e]=G,0==(0|G)){var E=0;break}if(21==(0|Se[G>>2])){var n=G;break r}var E=G}}else if(80==(0|_)){Se[a]=t+1|0;var W=N(r),Z=D(r,29,W,0);Se[e]=Z;var E=Z}else if(82==(0|_)){Se[a]=t+1|0;var Q=N(r),q=D(r,30,Q,0);Se[e]=q;var E=q}else if(67==(0|_)){Se[a]=t+1|0;var $=N(r),J=D(r,31,$,0);Se[e]=J;var E=J}else if(71==(0|_)){Se[a]=t+1|0;var rr=N(r),ar=D(r,32,rr,0);Se[e]=ar;var E=ar}else{if(85!=(0|_)){var n=0;break r}Se[a]=t+1|0;var er=L(r);Se[e]=er;var ir=N(r),vr=Se[e],tr=D(r,28,ir,vr);Se[e]=tr;var E=tr}}while(0);var E,fr=R(r,E);if(0==(0|fr)){var n=0;break}var n=Se[e]}while(0);var n;return Oe=i,n}function I(r,a,e){for(var i,v=r+12|0,t=0!=(0|e),f=t?25:22,i=(r+48|0)>>2,_=t?26:23,s=t?27:24,n=a;;){var n,o=Se[v>>2],l=Ae[o];if(l<<24>>24!=114&&l<<24>>24!=86&&l<<24>>24!=75){var b=n;break}var k=o+1|0;if(Se[v>>2]=k,l<<24>>24==114){var u=Se[i]+9|0;Se[i]=u;var c=f}else if(l<<24>>24==86){var h=Se[i]+9|0;Se[i]=h;var c=_}else{var d=Se[i]+6|0;Se[i]=d;var c=s}var c,w=D(r,c,0,0);if(Se[n>>2]=w,0==(0|w)){var b=0;break}var n=w+4|0}var b;return b}function P(r,a){var e=0==(0|a);do if(e)var i=0;else{var v=J(r);if(0==(0|v)){var i=0;break}Se[v>>2]=33,Se[v+4>>2]=a;var i=v}while(0);var i;return i}function D(r,a,e,i){var v,t;do{if(1==(0|a)||2==(0|a)||3==(0|a)||4==(0|a)||10==(0|a)||28==(0|a)||37==(0|a)||43==(0|a)||44==(0|a)||45==(0|a)||46==(0|a)||47==(0|a)||48==(0|a)||49==(0|a)||50==(0|a)){if(0==(0|e)|0==(0|i)){var f=0;t=7;break}t=5;break}if(8==(0|a)||9==(0|a)||11==(0|a)||12==(0|a)||13==(0|a)||14==(0|a)||15==(0|a)||16==(0|a)||17==(0|a)||18==(0|a)||19==(0|a)||20==(0|a)||29==(0|a)||30==(0|a)||31==(0|a)||32==(0|a)||34==(0|a)||38==(0|a)||39==(0|a)||42==(0|a)){if(0==(0|e)){var f=0;t=7;break}t=5;break}if(36==(0|a)){if(0==(0|i)){var f=0;t=7;break}t=5;break}if(35==(0|a)||22==(0|a)||23==(0|a)||24==(0|a)||25==(0|a)||26==(0|a)||27==(0|a))t=5;else{var f=0;t=7}}while(0);do if(5==t){var _=J(r),v=_>>2;if(0==(0|_)){var f=0;break}Se[v]=a,Se[v+1]=e,Se[v+2]=i;var f=_}while(0);var f;return f}function L(r){var a=sr(r);if((0|a)<1)var e=0;else{var i=Rr(r,a);Se[r+44>>2]=i;var e=i}var e;return e}function F(r){var a,a=(r+12|0)>>2,e=Se[a],i=e+1|0;if(Se[a]=i,Ae[e]<<24>>24==70){if(Ae[i]<<24>>24==89){var v=e+2|0;Se[a]=v}var t=Sr(r,1),f=Se[a],_=f+1|0;Se[a]=_;var s=Ae[f]<<24>>24==69?t:0,n=s}else var n=0;var n;return n}function X(r){var a=Ar(r);return a}function j(r){var a,a=(r+12|0)>>2,e=Se[a],i=e+1|0;Se[a]=i;var v=Ae[e]<<24>>24==65;do if(v){var t=Ae[i];if(t<<24>>24==95)var f=0;else if((t-48&255&255)<10){for(var _=i;;){var _,s=_+1|0;if(Se[a]=s,(Ae[s]-48&255&255)>=10)break;var _=s}var n=s-i|0,o=lr(r,i,n);if(0==(0|o)){var l=0;break}var f=o}else{var b=nr(r);if(0==(0|b)){var l=0;break}var f=b}var f,k=Se[a],u=k+1|0;if(Se[a]=u,Ae[k]<<24>>24!=95){var l=0;break}var c=N(r),h=D(r,36,f,c),l=h}else var l=0;while(0);var l;return l}function U(r){var a=Oe;Oe+=4;var e=a,i=r+12|0,v=Se[i>>2],t=v+1|0;Se[i>>2]=t;var f=Ae[v]<<24>>24==77;r:do if(f){var _=N(r),s=I(r,e,1);if(0==(0|s)){var n=0;break}var o=N(r);Se[s>>2]=o;var l=(0|s)==(0|e);do if(!l){if(35==(0|Se[o>>2]))break;var b=Se[e>>2],k=R(r,b);if(0==(0|k)){var n=0;break r}}while(0);var u=Se[e>>2],c=D(r,37,_,u),n=c}else var n=0;while(0);var n;return Oe=a,n}function x(r){var a,a=(r+12|0)>>2,e=Se[a],i=e+1|0;Se[a]=i;var v=Ae[e]<<24>>24==84;do if(v){if(Ae[i]<<24>>24==95)var t=0,f=i;else{var _=sr(r);if((0|_)<0){var s=0;break}var t=_+1|0,f=Se[a]}var f,t;if(Se[a]=f+1|0,Ae[f]<<24>>24!=95){var s=0;break}var n=r+40|0,o=Se[n>>2]+1|0;Se[n>>2]=o;var l=Er(r,t),s=l}else var s=0;while(0);var s;return s}function z(r){var a,e=Oe;Oe+=4;var i=e,v=r+44|0,t=Se[v>>2],a=(r+12|0)>>2,f=Se[a],_=f+1|0;Se[a]=_;var s=Ae[f]<<24>>24==73;r:do if(s){Se[i>>2]=0;for(var n=i;;){var n,o=_r(r);if(0==(0|o)){var l=0;break r}var b=D(r,39,o,0);if(Se[n>>2]=b,0==(0|b)){var l=0;break r}var k=Se[a];if(Ae[k]<<24>>24==69)break;var n=b+8|0}var u=k+1|0;Se[a]=u,Se[v>>2]=t;var l=Se[i>>2]}else var l=0;while(0);var l;return Oe=e,l}function V(r,a){var e,e=(r+12|0)>>2,i=Se[e],v=i+1|0;Se[e]=v;var t=Ae[i]<<24>>24==83;r:do if(t){var f=i+2|0;Se[e]=f;var _=ge[v];if(_<<24>>24==95)var s=0;else{if(!((_-48&255&255)<10|(_-65&255&255)<26)){var n=8&Se[r+8>>2],o=n>>>3,l=0!=(0|n)|0==(0|a);do if(l)var b=o;else{if((Ae[f]-67&255&255)>=2){var b=o;break}var b=1}while(0);for(var b,k=0|ei;;){var k;if(k>>>0>=(ei+196|0)>>>0){var u=0;break r}if(_<<24>>24==Ae[0|k]<<24>>24)break;var k=k+28|0}var c=Se[k+20>>2];if(0!=(0|c)){var h=Se[k+24>>2],d=fr(r,c,h);Se[r+44>>2]=d}if(0==(0|b))var w=k+8|0,p=k+4|0;else var w=k+16|0,p=k+12|0;var p,w,E=Se[w>>2],A=Se[p>>2],g=r+48|0,y=Se[g>>2]+E|0;Se[g>>2]=y;var m=fr(r,A,E),u=m;break}for(var S=_,M=0,C=f;;){var C,M,S;if((S-48&255&255)<10)var R=36*M-48|0;else{if((S-65&255&255)>=26){var u=0;break r}var R=36*M-55|0}var R,T=(S<<24>>24)+R|0;if((0|T)<0){var u=0;break r}var O=C+1|0;Se[e]=O;var N=ge[C];if(N<<24>>24==95)break;var S=N,M=T,C=O}var s=T+1|0}var s;if((0|s)>=(0|Se[r+32>>2])){var u=0;break}var I=r+40|0,P=Se[I>>2]+1|0;Se[I>>2]=P;var u=Se[Se[r+28>>2]+(s<<2)>>2]}else var u=0;while(0);var u;return u}function B(r,a,e,i){var v,t,f,_,s=Oe;Oe+=28;var n,o=s,_=o>>2;Se[_]=r;var l=e+1|0,f=(o+12|0)>>2;Se[f]=l;var b=Jr(l),t=(o+4|0)>>2;if(Se[t]=b,0==(0|b))var k=0,u=1;else{var v=(o+8|0)>>2;Se[v]=0,Se[_+4]=0,Se[_+5]=0;var c=o+24|0;Se[c>>2]=0,H(o,a);var h=Me[t],d=0==(0|h);do{if(!d){var w=Me[v];if(w>>>0>=Me[f]>>>0){n=5;break}Se[v]=w+1|0,Ae[h+w|0]=0,n=6;break}n=5}while(0);5==n&&Y(o,0);var p=Se[t],E=0==(0|p)?Se[c>>2]:Se[f],k=p,u=E}var u,k;return Se[i>>2]=u,Oe=s,k}function H(r,a){var e,i,v,t,f,_,s,n,o,l,b,k,u,c,h,d,w,p,E,A,g,y,m,S,M,C,R,T,O,N,I,P,D,L,F,X,j,U,x,z,V,B,K,G,W,J,vr,tr,fr,_r,sr,nr,or,lr,br,kr,ur,cr,hr,dr,wr,pr=a>>2,Er=r>>2,Ar=Oe;Oe+=184;var gr,yr=Ar,wr=yr>>2,mr=Ar+64,dr=mr>>2,Sr=Ar+72,Mr=Ar+88,Cr=Ar+104,hr=Cr>>2,Rr=Ar+168,Tr=0==(0|a);r:do if(Tr)Z(r);else{var cr=(r+4|0)>>2,Or=Me[cr];if(0==(0|Or))break;var Nr=0|a,Ir=Me[Nr>>2];a:do{if(0==(0|Ir)){if(0!=(4&Se[Er]|0)){var Pr=Se[pr+1],Dr=Se[pr+2];q(r,Pr,Dr);break r}var ur=(r+8|0)>>2,Lr=Me[ur],Fr=a+8|0,Xr=Me[Fr>>2];if((Xr+Lr|0)>>>0>Me[Er+3]>>>0){var jr=Se[pr+1];Q(r,jr,Xr);break r}var Ur=Or+Lr|0,xr=Se[pr+1];Pa(Ur,xr,Xr,1);var zr=Se[ur]+Se[Fr>>2]|0;Se[ur]=zr;break r}if(1==(0|Ir)||2==(0|Ir)){var Vr=Se[pr+1];H(r,Vr);var Br=0==(4&Se[Er]|0),Hr=Me[cr],Kr=0!=(0|Hr);e:do if(Br){do if(Kr){var kr=(r+8|0)>>2,Yr=Me[kr];if((Yr+2|0)>>>0>Me[Er+3]>>>0)break;var Gr=Hr+Yr|0;oe=14906,Ae[Gr]=255&oe,oe>>=8,Ae[Gr+1]=255&oe;var Wr=Se[kr]+2|0;Se[kr]=Wr;break e}while(0);Q(r,0|He.__str120,2)}else{do if(Kr){var Zr=r+8|0,Qr=Me[Zr>>2];if(Qr>>>0>=Me[Er+3]>>>0)break;Se[Zr>>2]=Qr+1|0,Ae[Hr+Qr|0]=46;break e}while(0);Y(r,46)}while(0);var qr=Se[pr+2];H(r,qr);break r}if(3==(0|Ir)){for(var br=(r+20|0)>>2,$r=Me[br],lr=(r+16|0)>>2,Jr=a,ra=0,aa=$r;;){var aa,ra,Jr,ea=Me[Jr+4>>2];if(0==(0|ea)){var ia=ra,va=0;gr=33;break}if(ra>>>0>3){Z(r);break r}var ta=(ra<<4)+yr|0;Se[ta>>2]=aa,Se[br]=ta,Se[((ra<<4)+4>>2)+wr]=ea,Se[((ra<<4)+8>>2)+wr]=0;var fa=Me[lr];Se[((ra<<4)+12>>2)+wr]=fa;var _a=ra+1|0,sa=0|ea,na=Me[sa>>2];if((na-25|0)>>>0>=3){gr=25;break}var Jr=ea,ra=_a,aa=ta}e:do if(25==gr){if(4==(0|na)){Se[dr]=fa,Se[lr]=mr,Se[dr+1]=ea;var oa=Se[sa>>2],la=mr}else var oa=na,la=fa;var la,oa;if(2!=(0|oa)){var ia=_a,va=sa;break}for(var ba=_a,ka=ea+8|0;;){var ka,ba,ua=Me[ka>>2];if((Se[ua>>2]-25|0)>>>0>=3){var ia=ba,va=sa;break e}if(ba>>>0>3)break;var ca=(ba<<4)+yr|0,ha=ba-1|0,da=(ha<<4)+yr|0,or=ca>>2,nr=da>>2;Se[or]=Se[nr],Se[or+1]=Se[nr+1],Se[or+2]=Se[nr+2],Se[or+3]=Se[nr+3],Se[ca>>2]=da,Se[br]=ca,Se[((ha<<4)+4>>2)+wr]=ua,Se[((ha<<4)+8>>2)+wr]=0,Se[((ha<<4)+12>>2)+wr]=la;var ba=ba+1|0,ka=ua+4|0}Z(r);break r}while(0);var va,ia,wa=Se[pr+2];if(H(r,wa),4==(0|Se[va>>2])){var pa=Se[dr];Se[lr]=pa}var Ea=0==(0|ia);e:do if(!Ea)for(var Aa=r+8|0,ga=r+12|0,ya=ia;;){var ya,ma=ya-1|0;if(0==(0|Se[((ma<<4)+8>>2)+wr])){var Sa=Me[cr],Ma=0==(0|Sa);do{if(!Ma){var Ca=Me[Aa>>2];if(Ca>>>0>=Me[ga>>2]>>>0){gr=41;break}Se[Aa>>2]=Ca+1|0,Ae[Sa+Ca|0]=32,gr=42;break}gr=41}while(0);41==gr&&Y(r,32);var Ra=Se[((ma<<4)+4>>2)+wr];$(r,Ra)}if(0==(0|ma))break e;var ya=ma}while(0);Se[br]=$r;break r}if(4==(0|Ir)){var sr=(r+20|0)>>2,Ta=Se[sr];Se[sr]=0;var Oa=Se[pr+1];H(r,Oa);var Na=Me[cr],Ia=0==(0|Na);do{if(!Ia){var _r=(r+8|0)>>2,Da=Me[_r],La=0==(0|Da);do if(!La){if(Ae[Na+(Da-1)|0]<<24>>24!=60)break;Da>>>0<Me[Er+3]>>>0?(Se[_r]=Da+1|0,Ae[Na+Da|0]=32):Y(r,32)}while(0);var Fa=Me[cr];if(0==(0|Fa)){gr=54;break}var Xa=Me[_r];if(Xa>>>0>=Me[Er+3]>>>0){gr=54;break}Se[_r]=Xa+1|0,Ae[Fa+Xa|0]=60,gr=55;break}gr=54}while(0);54==gr&&Y(r,60);var ja=Se[pr+2];H(r,ja);var Ua=Me[cr],xa=0==(0|Ua);do{if(!xa){var fr=(r+8|0)>>2,za=Me[fr],Va=0==(0|za);do if(!Va){if(Ae[Ua+(za-1)|0]<<24>>24!=62)break;za>>>0<Me[Er+3]>>>0?(Se[fr]=za+1|0,Ae[Ua+za|0]=32):Y(r,32)}while(0);var Ba=Me[cr];if(0==(0|Ba)){gr=64;break}var Ha=Me[fr];if(Ha>>>0>=Me[Er+3]>>>0){gr=64;break}Se[fr]=Ha+1|0,Ae[Ba+Ha|0]=62,gr=65;break}gr=64}while(0);64==gr&&Y(r,62),Se[sr]=Ta;break r}if(5==(0|Ir)){var tr=(r+16|0)>>2,Ka=Me[tr];if(0==(0|Ka)){Z(r);break r}for(var Ya=Se[pr+1],Ga=Se[Ka+4>>2];;){var Ga,Ya,Wa=Se[Ga+8>>2];if(0==(0|Wa))break;if(39!=(0|Se[Wa>>2])){Z(r);break r}if((0|Ya)<1){if(0!=(0|Ya))break;var Za=Se[Ka>>2];Se[tr]=Za;var Qa=Se[Wa+4>>2];H(r,Qa),Se[tr]=Ka;break r}var Ya=Ya-1|0,Ga=Wa}Z(r);break r}if(6==(0|Ir)){var qa=Se[pr+2];H(r,qa);break r}if(7==(0|Ir)){var $a=r+8|0,Ja=Me[$a>>2];Ja>>>0<Me[Er+3]>>>0?(Se[$a>>2]=Ja+1|0,Ae[Or+Ja|0]=126):Y(r,126);var re=Se[pr+2];H(r,re);break r}if(8==(0|Ir)){var vr=(r+8|0)>>2,ae=Me[vr];if((ae+11|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str121,11);else{for(var ee=Or+ae|0,ie=0|He.__str121,ve=ee,te=ie+11;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var fe=Se[vr]+11|0;Se[vr]=fe}var _e=Se[pr+1];H(r,_e);break r}if(9==(0|Ir)){var J=(r+8|0)>>2,se=Me[J];if((se+8|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str122,8);else{var ne=Or+se|0,le=0|ne;oe=542397526,Ae[le]=255&oe,oe>>=8,Ae[le+1]=255&oe,oe>>=8,Ae[le+2]=255&oe,oe>>=8,Ae[le+3]=255&oe;var be=ne+4|0;oe=544370534,Ae[be]=255&oe,oe>>=8,Ae[be+1]=255&oe,oe>>=8,Ae[be+2]=255&oe,oe>>=8,Ae[be+3]=255&oe;var ke=Se[J]+8|0;Se[J]=ke}var ue=Se[pr+1];H(r,ue);break r}if(10==(0|Ir)){var W=(r+8|0)>>2,ce=Me[W],he=r+12|0;if((ce+24|0)>>>0>Me[he>>2]>>>0)Q(r,0|He.__str123,24);else{var de=Or+ce|0;Pa(de,0|He.__str123,24,1);var we=Se[W]+24|0;Se[W]=we}var pe=Se[pr+1];H(r,pe);var Ee=Me[cr],ge=0==(0|Ee);do{if(!ge){var ye=Me[W];if((ye+4|0)>>>0>Me[he>>2]>>>0){gr=96;break}var me=Ee+ye|0;oe=762210605,Ae[me]=255&oe,oe>>=8,Ae[me+1]=255&oe,oe>>=8,Ae[me+2]=255&oe,oe>>=8,Ae[me+3]=255&oe;var Ce=Se[W]+4|0;Se[W]=Ce,gr=97;break}gr=96}while(0);96==gr&&Q(r,0|He.__str124,4);var Re=Se[pr+2];H(r,Re);break r}if(11==(0|Ir)){var G=(r+8|0)>>2,Te=Me[G];if((Te+13|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str125,13);else{for(var Ne=Or+Te|0,ie=0|He.__str125,ve=Ne,te=ie+13;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var Ie=Se[G]+13|0;Se[G]=Ie}var Pe=Se[pr+1];H(r,Pe);break r}if(12==(0|Ir)){var K=(r+8|0)>>2,De=Me[K];if((De+18|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str126,18);else{for(var Le=Or+De|0,ie=0|He.__str126,ve=Le,te=ie+18;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var Fe=Se[K]+18|0;Se[K]=Fe}var Xe=Se[pr+1];H(r,Xe);break r}if(13==(0|Ir)){var B=(r+8|0)>>2,je=Me[B];if((je+16|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str127,16);else{for(var Ue=Or+je|0,ie=0|He.__str127,ve=Ue,te=ie+16;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var xe=Se[B]+16|0;Se[B]=xe}var ze=Se[pr+1];H(r,ze);break r}if(14==(0|Ir)){var V=(r+8|0)>>2,Ve=Me[V];if((Ve+21|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str128,21);else{var Be=Or+Ve|0;Pa(Be,0|He.__str128,21,1);var Ke=Se[V]+21|0;Se[V]=Ke}var Ye=Se[pr+1];H(r,Ye);break r}if(15==(0|Ir)){var z=(r+8|0)>>2,Ge=Me[z];if((Ge+17|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str129,17);else{for(var We=Or+Ge|0,ie=0|He.__str129,ve=We,te=ie+17;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var Ze=Se[z]+17|0;Se[z]=Ze}var Qe=Se[pr+1];H(r,Qe);break r}if(16==(0|Ir)){var x=(r+8|0)>>2,qe=Me[x];if((qe+26|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str130,26);else{var $e=Or+qe|0;Pa($e,0|He.__str130,26,1);var Je=Se[x]+26|0;Se[x]=Je}var ri=Se[pr+1];H(r,ri);break r}if(17==(0|Ir)){var U=(r+8|0)>>2,ai=Me[U];if((ai+15|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str131,15);else{for(var ei=Or+ai|0,ie=0|He.__str131,ve=ei,te=ie+15;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var ii=Se[U]+15|0;Se[U]=ii}var vi=Se[pr+1];H(r,vi);break r}if(18==(0|Ir)){var j=(r+8|0)>>2,ti=Me[j];if((ti+19|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str132,19);else{for(var fi=Or+ti|0,ie=0|He.__str132,ve=fi,te=ie+19;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var _i=Se[j]+19|0;Se[j]=_i}var si=Se[pr+1];H(r,si);break r}if(19==(0|Ir)){var X=(r+8|0)>>2,ni=Me[X];if((ni+24|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str133,24);else{var oi=Or+ni|0;Pa(oi,0|He.__str133,24,1);var li=Se[X]+24|0;Se[X]=li}var bi=Se[pr+1];H(r,bi);break r}if(20==(0|Ir)){var F=(r+8|0)>>2,ki=Me[F];if((ki+17|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str134,17);else{for(var ui=Or+ki|0,ie=0|He.__str134,ve=ui,te=ie+17;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var ci=Se[F]+17|0;Se[F]=ci}var hi=Se[pr+1];H(r,hi);break r}if(21==(0|Ir)){var L=(r+8|0)>>2,di=Me[L],wi=a+8|0,pi=Me[wi>>2];if((pi+di|0)>>>0>Me[Er+3]>>>0){var Ei=Se[pr+1];Q(r,Ei,pi);break r}var Ai=Or+di|0,gi=Se[pr+1];Pa(Ai,gi,pi,1);var yi=Se[L]+Se[wi>>2]|0;Se[L]=yi;break r}if(22==(0|Ir)||23==(0|Ir)||24==(0|Ir)){for(var mi=r+20|0;;){var mi,Si=Me[mi>>2];if(0==(0|Si))break a;if(0==(0|Se[Si+8>>2])){var Mi=Me[Se[Si+4>>2]>>2];if((Mi-22|0)>>>0>=3)break a;if((0|Mi)==(0|Ir))break}var mi=0|Si}var Ci=Se[pr+1];H(r,Ci);break r}if(25!=(0|Ir)&&26!=(0|Ir)&&27!=(0|Ir)&&28!=(0|Ir)&&29!=(0|Ir)&&30!=(0|Ir)&&31!=(0|Ir)&&32!=(0|Ir)){if(33==(0|Ir)){var D=(r+8|0)>>2,Ri=Me[D],P=(a+4|0)>>2,I=Me[P]>>2;if(0==(4&Se[Er]|0)){var Ti=Me[I+1];if((Ti+Ri|0)>>>0>Me[Er+3]>>>0){var Oi=Se[I];Q(r,Oi,Ti);break r}var Ni=Or+Ri|0,Ii=Se[I];Pa(Ni,Ii,Ti,1);var Pi=Se[D]+Se[Se[P]+4>>2]|0;Se[D]=Pi;break r}var Di=Me[I+3];if((Di+Ri|0)>>>0>Me[Er+3]>>>0){var Li=Se[I+2];Q(r,Li,Di);break r}var Fi=Or+Ri|0,Xi=Se[I+2];Pa(Fi,Xi,Di,1);var ji=Se[D]+Se[Se[P]+12>>2]|0;Se[D]=ji;break r}if(34==(0|Ir)){var Ui=Se[pr+1];H(r,Ui);break r}if(35==(0|Ir)){var N=(0|r)>>2;if(0!=(32&Se[N]|0)){var xi=Se[Er+5];rr(r,a,xi)}var zi=a+4|0,Vi=0==(0|Se[zi>>2]);e:do if(!Vi){var O=(r+20|0)>>2,Bi=Se[O],Hi=0|Mr;Se[Hi>>2]=Bi,Se[O]=Mr,Se[Mr+4>>2]=a;var Ki=Mr+8|0;Se[Ki>>2]=0;var Yi=Se[Er+4];Se[Mr+12>>2]=Yi;var Gi=Se[zi>>2];H(r,Gi);var Wi=Se[Hi>>2];if(Se[O]=Wi,0!=(0|Se[Ki>>2]))break r;if(0!=(32&Se[N]|0))break;var Zi=Me[cr],Qi=0==(0|Zi);do if(!Qi){var qi=r+8|0,$i=Me[qi>>2];if($i>>>0>=Me[Er+3]>>>0)break;Se[qi>>2]=$i+1|0,Ae[Zi+$i|0]=32;break e}while(0);Y(r,32)}while(0);if(0!=(32&Se[N]|0))break r;var Ji=Se[Er+5];rr(r,a,Ji);break r}if(36==(0|Ir)){var T=(r+20|0)>>2,rv=Me[T],av=0|Cr;Se[hr]=rv,Se[T]=av,Se[hr+1]=a;var ev=Cr+8|0;Se[ev>>2]=0;var iv=Se[Er+4];Se[hr+3]=iv;for(var vv=rv,tv=1;;){var tv,vv;if(0==(0|vv))break;if((Se[Se[vv+4>>2]>>2]-22|0)>>>0>=3)break;var fv=vv+8|0;if(0==(0|Se[fv>>2])){if(tv>>>0>3){Z(r);break r}var _v=(tv<<4)+Cr|0,R=_v>>2,C=vv>>2;Se[R]=Se[C],Se[R+1]=Se[C+1],Se[R+2]=Se[C+2],Se[R+3]=Se[C+3];var sv=Se[T];Se[_v>>2]=sv,Se[T]=_v,Se[fv>>2]=1;var nv=tv+1|0}else var nv=tv;var nv,vv=Se[vv>>2],tv=nv}var ov=Se[pr+2];if(H(r,ov),Se[T]=rv,0!=(0|Se[ev>>2]))break r;if(tv>>>0>1){for(var lv=tv;;){var lv,bv=lv-1|0,kv=Se[((bv<<4)+4>>2)+hr];if($(r,kv),bv>>>0<=1)break;var lv=bv}var uv=Se[T]}else var uv=rv;var uv;ar(r,a,uv);break r}if(37==(0|Ir)){var M=(r+20|0)>>2,cv=Se[M],hv=0|Rr;Se[hv>>2]=cv,Se[M]=Rr,Se[Rr+4>>2]=a;var dv=Rr+8|0;Se[dv>>2]=0;var wv=Se[Er+4];Se[Rr+12>>2]=wv;var pv=a+4|0,Ev=Se[pr+2];H(r,Ev);var Av=0==(0|Se[dv>>2]);e:do if(Av){var gv=Me[cr],yv=0==(0|gv);do{if(!yv){var mv=r+8|0,Sv=Me[mv>>2];if(Sv>>>0>=Me[Er+3]>>>0){gr=187;break}Se[mv>>2]=Sv+1|0,Ae[gv+Sv|0]=32,gr=188;break}gr=187}while(0);187==gr&&Y(r,32);var Mv=Se[pv>>2];H(r,Mv);var Cv=Me[cr],Rv=0==(0|Cv);do if(!Rv){var S=(r+8|0)>>2,Tv=Me[S];if((Tv+3|0)>>>0>Me[Er+3]>>>0)break;var Ov=Cv+Tv|0;Ae[Ov]=Ae[0|He.__str135],Ae[Ov+1]=Ae[(0|He.__str135)+1],Ae[Ov+2]=Ae[(0|He.__str135)+2];var Nv=Se[S]+3|0;Se[S]=Nv;break e}while(0);Q(r,0|He.__str135,3)}while(0);var Iv=Se[hv>>2];Se[M]=Iv;break r}if(38==(0|Ir)||39==(0|Ir)){var Pv=Se[pr+1];H(r,Pv);var Dv=a+8|0;if(0==(0|Se[Dv>>2]))break r;var Lv=Me[cr],Fv=0==(0|Lv);do{if(!Fv){var m=(r+8|0)>>2,Xv=Me[m];if((Xv+2|0)>>>0>Me[Er+3]>>>0){gr=197;break}var jv=Lv+Xv|0;oe=8236,Ae[jv]=255&oe,oe>>=8,Ae[jv+1]=255&oe;var Uv=Se[m]+2|0;Se[m]=Uv,gr=198;break}gr=197}while(0);197==gr&&Q(r,0|He.__str136,2);var xv=Se[Dv>>2];H(r,xv);break r}if(40==(0|Ir)){var y=(r+8|0)>>2,zv=Me[y],g=(r+12|0)>>2;if((zv+8|0)>>>0>Me[g]>>>0)Q(r,0|He.__str137,8);else{var Vv=Or+zv|0,le=0|Vv;oe=1919250543,Ae[le]=255&oe,oe>>=8,Ae[le+1]=255&oe,oe>>=8,Ae[le+2]=255&oe,oe>>=8,Ae[le+3]=255&oe;var be=Vv+4|0;oe=1919906913,Ae[be]=255&oe,oe>>=8,Ae[be+1]=255&oe,oe>>=8,Ae[be+2]=255&oe,oe>>=8,Ae[be+3]=255&oe;var Bv=Se[y]+8|0;Se[y]=Bv}var A=(a+4|0)>>2,Hv=(Ae[Se[Se[A]+4>>2]]-97&255&255)<26;e:do if(Hv){var Kv=Me[cr],Yv=0==(0|Kv);do if(!Yv){var Gv=Me[y];if(Gv>>>0>=Me[g]>>>0)break;Se[y]=Gv+1|0,Ae[Kv+Gv|0]=32;break e}while(0);Y(r,32)}while(0);var Wv=Me[cr],Zv=0==(0|Wv);do{if(!Zv){var Qv=Me[y],qv=Me[A],$v=Me[qv+8>>2];if(($v+Qv|0)>>>0>Me[g]>>>0){var Jv=qv,rt=$v;break}var at=Wv+Qv|0,et=Se[qv+4>>2];Pa(at,et,$v,1);var it=Se[y]+Se[Se[A]+8>>2]|0;Se[y]=it;break r}var vt=Me[A],Jv=vt,rt=Se[vt+8>>2]}while(0);var rt,Jv,tt=Se[Jv+4>>2];Q(r,tt,rt);break r}if(41==(0|Ir)){var E=(r+8|0)>>2,ft=Me[E];if((ft+9|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str10180,9);else{for(var _t=Or+ft|0,ie=0|He.__str10180,ve=_t,te=ie+9;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var st=Se[E]+9|0;Se[E]=st}var nt=Se[pr+2];H(r,nt);break r}if(42==(0|Ir)){var p=(r+8|0)>>2,ot=Me[p];if((ot+9|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str10180,9);else{for(var lt=Or+ot|0,ie=0|He.__str10180,ve=lt,te=ie+9;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var bt=Se[p]+9|0;Se[p]=bt}er(r,a);break r}if(43==(0|Ir)){var kt=a+4|0,ut=Se[kt>>2],ct=42==(0|Se[ut>>2]);e:do if(ct){var w=(r+8|0)>>2,ht=Me[w],dt=r+12|0;ht>>>0<Me[dt>>2]>>>0?(Se[w]=ht+1|0,Ae[Or+ht|0]=40):Y(r,40);var wt=Se[kt>>2];er(r,wt);var pt=Me[cr],Et=0==(0|pt);do if(!Et){var At=Me[w];if(At>>>0>=Me[dt>>2]>>>0)break;Se[w]=At+1|0,Ae[pt+At|0]=41;break e}while(0);Y(r,41)}else ir(r,ut);while(0);var gt=Me[cr],yt=0==(0|gt);do{if(!yt){var mt=r+8|0,St=Me[mt>>2];if(St>>>0>=Me[Er+3]>>>0){gr=232;break}Se[mt>>2]=St+1|0,Ae[gt+St|0]=40,gr=233;break}gr=232}while(0);232==gr&&Y(r,40);var Mt=Se[pr+2];H(r,Mt);var Ct=Me[cr],Rt=0==(0|Ct);do if(!Rt){var Tt=r+8|0,Ot=Me[Tt>>2];if(Ot>>>0>=Me[Er+3]>>>0)break;Se[Tt>>2]=Ot+1|0,Ae[Ct+Ot|0]=41;break r}while(0);Y(r,41);break r}if(44==(0|Ir)){var d=(a+8|0)>>2;if(45==(0|Se[Se[d]>>2])){var h=(a+4|0)>>2,Nt=Se[h],It=40==(0|Se[Nt>>2]);do if(It){var Pt=Se[Nt+4>>2];if(1!=(0|Se[Pt+8>>2]))break;if(Ae[Se[Pt+4>>2]]<<24>>24!=62)break;var Dt=r+8|0,Lt=Me[Dt>>2];Lt>>>0<Me[Er+3]>>>0?(Se[Dt>>2]=Lt+1|0,Ae[Or+Lt|0]=40):Y(r,40)}while(0);var Ft=Me[cr],Xt=0==(0|Ft);do{if(!Xt){var jt=r+8|0,Ut=Me[jt>>2];if(Ut>>>0>=Me[Er+3]>>>0){gr=248;break}Se[jt>>2]=Ut+1|0,Ae[Ft+Ut|0]=40,gr=249;break}gr=248}while(0);248==gr&&Y(r,40);var xt=Se[Se[d]+4>>2];H(r,xt);var zt=Me[cr],Vt=0==(0|zt);do{if(!Vt){var c=(r+8|0)>>2,Bt=Me[c];if((Bt+2|0)>>>0>Me[Er+3]>>>0){gr=252;break}var Ht=zt+Bt|0;oe=8233,Ae[Ht]=255&oe,oe>>=8,Ae[Ht+1]=255&oe;var Kt=Se[c]+2|0;Se[c]=Kt,gr=253;break}gr=252}while(0);252==gr&&Q(r,0|He.__str139,2);var Yt=Se[h];ir(r,Yt);var Gt=Me[cr],Wt=0==(0|Gt);do{if(!Wt){var u=(r+8|0)>>2,Zt=Me[u];if((Zt+2|0)>>>0>Me[Er+3]>>>0){gr=256;break}var Qt=Gt+Zt|0;oe=10272,Ae[Qt]=255&oe,oe>>=8,Ae[Qt+1]=255&oe;var qt=Se[u]+2|0;Se[u]=qt,gr=257;break}gr=256}while(0);256==gr&&Q(r,0|He.__str140,2);var $t=Se[Se[d]+8>>2];H(r,$t);var Jt=Me[cr],rf=0==(0|Jt);do{if(!rf){var af=r+8|0,ef=Me[af>>2];if(ef>>>0>=Me[Er+3]>>>0){gr=260;break}Se[af>>2]=ef+1|0,Ae[Jt+ef|0]=41,gr=261;break}gr=260}while(0);260==gr&&Y(r,41);var vf=Se[h];if(40!=(0|Se[vf>>2]))break r;var tf=Se[vf+4>>2];if(1!=(0|Se[tf+8>>2]))break r;if(Ae[Se[tf+4>>2]]<<24>>24!=62)break r;var ff=Me[cr],_f=0==(0|ff);do if(!_f){var sf=r+8|0,nf=Me[sf>>2];if(nf>>>0>=Me[Er+3]>>>0)break;Se[sf>>2]=nf+1|0,Ae[ff+nf|0]=41;break r}while(0);Y(r,41);break r}Z(r);break r}if(45==(0|Ir)){Z(r);break r}if(46==(0|Ir)){var of=a+4|0,k=(a+8|0)>>2,lf=Se[k],bf=47==(0|Se[lf>>2]);do if(bf){if(48!=(0|Se[Se[lf+8>>2]>>2]))break;var b=(r+8|0)>>2,kf=Me[b],l=(r+12|0)>>2;kf>>>0<Me[l]>>>0?(Se[b]=kf+1|0,Ae[Or+kf|0]=40):Y(r,40);var uf=Se[Se[k]+4>>2];H(r,uf);var cf=Me[cr],hf=0==(0|cf);do{if(!hf){var df=Me[b];if((df+2|0)>>>0>Me[l]>>>0){gr=278;break}var wf=cf+df|0;oe=8233,Ae[wf]=255&oe,oe>>=8,Ae[wf+1]=255&oe;var pf=Se[b]+2|0;Se[b]=pf,gr=279;break}gr=278}while(0);278==gr&&Q(r,0|He.__str139,2);var Ef=Se[of>>2];ir(r,Ef);var Af=Me[cr],gf=0==(0|Af);do{if(!gf){var yf=Me[b];if((yf+2|0)>>>0>Me[l]>>>0){gr=282;break}var mf=Af+yf|0;oe=10272,Ae[mf]=255&oe,oe>>=8,Ae[mf+1]=255&oe;var Sf=Se[b]+2|0;Se[b]=Sf,gr=283;break}gr=282}while(0);282==gr&&Q(r,0|He.__str140,2);var Mf=Se[Se[Se[k]+8>>2]+4>>2];H(r,Mf);var Cf=Me[cr],Rf=0==(0|Cf);do{if(!Rf){var Tf=Me[b];if((Tf+5|0)>>>0>Me[l]>>>0){gr=286;break}var Of=Cf+Tf|0;Ae[Of]=Ae[0|He.__str141],Ae[Of+1]=Ae[(0|He.__str141)+1],Ae[Of+2]=Ae[(0|He.__str141)+2],Ae[Of+3]=Ae[(0|He.__str141)+3],Ae[Of+4]=Ae[(0|He.__str141)+4];var Nf=Se[b]+5|0;Se[b]=Nf,gr=287;break}gr=286}while(0);286==gr&&Q(r,0|He.__str141,5);var If=Se[Se[Se[k]+8>>2]+8>>2];H(r,If);var Pf=Me[cr],Df=0==(0|Pf);do if(!Df){var Lf=Me[b];if(Lf>>>0>=Me[l]>>>0)break;Se[b]=Lf+1|0,Ae[Pf+Lf|0]=41;break r}while(0);Y(r,41);break r}while(0);Z(r);break r}if(47==(0|Ir)||48==(0|Ir)){Z(r);break r}if(49==(0|Ir)||50==(0|Ir)){var Ff=a+4|0,Xf=Se[Ff>>2],jf=33==(0|Se[Xf>>2]);do{if(jf){var Uf=Me[Se[Xf+4>>2]+16>>2];if(1==(0|Uf)||2==(0|Uf)||3==(0|Uf)||4==(0|Uf)||5==(0|Uf)||6==(0|Uf)){var xf=a+8|0;if(0!=(0|Se[Se[xf>>2]>>2])){var zf=Uf;break}if(50==(0|Ir)){var Vf=r+8|0,Bf=Me[Vf>>2];Bf>>>0<Me[Er+3]>>>0?(Se[Vf>>2]=Bf+1|0,Ae[Or+Bf|0]=45):Y(r,45)}var Hf=Se[xf>>2];if(H(r,Hf),2==(0|Uf)){var Kf=Me[cr],Yf=0==(0|Kf);do if(!Yf){var Gf=r+8|0,Wf=Me[Gf>>2];if(Wf>>>0>=Me[Er+3]>>>0)break;Se[Gf>>2]=Wf+1|0,Ae[Kf+Wf|0]=117;break r}while(0);Y(r,117);break r}if(3==(0|Uf)){var Zf=Me[cr],Qf=0==(0|Zf);do if(!Qf){var qf=r+8|0,$f=Me[qf>>2];if($f>>>0>=Me[Er+3]>>>0)break;Se[qf>>2]=$f+1|0,Ae[Zf+$f|0]=108;break r}while(0);Y(r,108);break r}if(4==(0|Uf)){var Jf=Me[cr],r_=0==(0|Jf);do if(!r_){var o=(r+8|0)>>2,a_=Me[o];if((a_+2|0)>>>0>Me[Er+3]>>>0)break;var e_=Jf+a_|0;oe=27765,Ae[e_]=255&oe,oe>>=8,Ae[e_+1]=255&oe;var i_=Se[o]+2|0;Se[o]=i_;break r}while(0);Q(r,0|He.__str142,2);break r}if(5==(0|Uf)){var v_=Me[cr],t_=0==(0|v_);do if(!t_){var n=(r+8|0)>>2,f_=Me[n];if((f_+2|0)>>>0>Me[Er+3]>>>0)break;var __=v_+f_|0;oe=27756,Ae[__]=255&oe,oe>>=8,Ae[__+1]=255&oe;var s_=Se[n]+2|0;Se[n]=s_;break r}while(0);Q(r,0|He.__str143,2);break r}if(6==(0|Uf)){var n_=Me[cr],o_=0==(0|n_);do if(!o_){var s=(r+8|0)>>2,l_=Me[s];if((l_+3|0)>>>0>Me[Er+3]>>>0)break;var b_=n_+l_|0;Ae[b_]=Ae[0|He.__str144],Ae[b_+1]=Ae[(0|He.__str144)+1],Ae[b_+2]=Ae[(0|He.__str144)+2];var k_=Se[s]+3|0;Se[s]=k_;break r}while(0);Q(r,0|He.__str144,3);break r}break r}if(7==(0|Uf)){var _=Se[pr+2]>>2;if(0!=(0|Se[_])){var zf=7;break}if(!(1==(0|Se[_+2])&49==(0|Ir))){var zf=Uf;break}var u_=Ae[Se[_+1]]<<24>>24;if(48==(0|u_)){var f=(r+8|0)>>2,c_=Me[f];if((c_+5|0)>>>0>Me[Er+3]>>>0){Q(r,0|He.__str145,5);break r}var h_=Or+c_|0;Ae[h_]=Ae[0|He.__str145],Ae[h_+1]=Ae[(0|He.__str145)+1],Ae[h_+2]=Ae[(0|He.__str145)+2],Ae[h_+3]=Ae[(0|He.__str145)+3],Ae[h_+4]=Ae[(0|He.__str145)+4];var d_=Se[f]+5|0;Se[f]=d_;break r}if(49==(0|u_)){var t=(r+8|0)>>2,w_=Me[t];if((w_+4|0)>>>0>Me[Er+3]>>>0){Q(r,0|He.__str146,4);break r}var p_=Or+w_|0;oe=1702195828,Ae[p_]=255&oe,oe>>=8,Ae[p_+1]=255&oe,oe>>=8,Ae[p_+2]=255&oe,oe>>=8,Ae[p_+3]=255&oe;var E_=Se[t]+4|0;Se[t]=E_;break r}var zf=Uf;break}var zf=Uf;break}var zf=0}while(0);var zf,v=(r+8|0)>>2,A_=Me[v],i=(r+12|0)>>2;A_>>>0<Me[i]>>>0?(Se[v]=A_+1|0,Ae[Or+A_|0]=40):Y(r,40);var g_=Se[Ff>>2];H(r,g_);var y_=Me[cr],m_=0==(0|y_);do{if(!m_){var S_=Me[v];if(S_>>>0>=Me[i]>>>0){gr=335;break}Se[v]=S_+1|0,Ae[y_+S_|0]=41,gr=336;break}gr=335}while(0);335==gr&&Y(r,41);var M_=50==(0|Se[Nr>>2]);e:do if(M_){var C_=Me[cr],R_=0==(0|C_);do if(!R_){var T_=Me[v];if(T_>>>0>=Me[i]>>>0)break;Se[v]=T_+1|0,Ae[C_+T_|0]=45;break e}while(0);Y(r,45)}while(0);if(8==(0|zf)){var O_=Me[cr],N_=0==(0|O_);do{if(!N_){var I_=Me[v];if(I_>>>0>=Me[i]>>>0){gr=345;break}Se[v]=I_+1|0,Ae[O_+I_|0]=91,gr=346;break}gr=345}while(0);345==gr&&Y(r,91);var P_=Se[pr+2];H(r,P_);var D_=Me[cr],L_=0==(0|D_);do if(!L_){var F_=Me[v];if(F_>>>0>=Me[i]>>>0)break;Se[v]=F_+1|0,Ae[D_+F_|0]=93;break r}while(0);Y(r,93);break r}var X_=Se[pr+2];H(r,X_);break r}Z(r);break r}}while(0);var e=(r+20|0)>>2,j_=Se[e],U_=0|Sr;Se[U_>>2]=j_,Se[e]=Sr,Se[Sr+4>>2]=a;var x_=Sr+8|0;Se[x_>>2]=0;var z_=Se[Er+4];Se[Sr+12>>2]=z_;var V_=Se[pr+1];H(r,V_),0==(0|Se[x_>>2])&&$(r,a);var B_=Se[U_>>2];Se[e]=B_}while(0);Oe=Ar}function K(r,a,e,i){var v=i>>2;Se[v]=r,Se[v+1]=r+e|0,Se[v+2]=a,Se[v+3]=r,Se[v+6]=e<<1,Se[v+5]=0,Se[v+9]=e,Se[v+8]=0,Se[v+10]=0,Se[v+11]=0,Se[v+12]=0}function Y(r,a){var e,i=r+4|0,v=Me[i>>2],t=0==(0|v);do if(!t){var e=(r+8|0)>>2,f=Me[e];if(f>>>0<Me[r+12>>2]>>>0)var _=v,s=f;else{tr(r,1);var n=Me[i>>2];if(0==(0|n))break;var _=n,s=Se[e]}var s,_;Ae[_+s|0]=255&a;var o=Se[e]+1|0;Se[e]=o}while(0)}function G(r,a,e,i){var v,t=i>>2,f=Oe;Oe+=4;var _=f,v=_>>2,s=0==(0|r);do if(s){if(0==(0|i)){var n=0;break}Se[t]=-3;var n=0}else{var o=0==(0|e);if(0!=(0|a)&o){if(0==(0|i)){var n=0;break}Se[t]=-3;var n=0}else{var l=W(r,_);if(0==(0|l)){if(0==(0|i)){var n=0;break}if(1==(0|Se[v])){Se[t]=-1;var n=0}else{Se[t]=-2;var n=0}}else{var b=0==(0|a);do if(b){if(o){var k=l;break}var u=Se[v];Se[e>>2]=u;var k=l}else{var c=Ca(l);if(c>>>0<Me[e>>2]>>>0){Ra(a,l);va(l);var k=a}else{va(a);var h=Se[v];Se[e>>2]=h;var k=l}}while(0);var k;if(0==(0|i)){var n=k;break}Se[t]=0;var n=k}}}while(0);var n;return Oe=f,n}function W(r,a){var e,i=Oe;Oe+=52;var v,t=i,e=t>>2;Se[a>>2]=0;var f=Ca(r),_=Ae[r]<<24>>24==95;do{if(_){if(Ae[r+1|0]<<24>>24==90){var s=0;v=13;break}v=3;break}v=3}while(0);do if(3==v){var n=Na(r,0|He.__str117,8);if(0!=(0|n)){var s=1;v=13;break}var o=Ae[r+8|0];if(o<<24>>24!=46&&o<<24>>24!=95&&o<<24>>24!=36){var s=1;v=13;break}var l=r+9|0,b=Ae[l];if(b<<24>>24!=68&&b<<24>>24!=73){\\nvar s=1;v=13;break}if(Ae[r+10|0]<<24>>24!=95){var s=1;v=13;break}var k=f+29|0,u=Jr(k);if(0==(0|u)){Se[a>>2]=1;var c=0;v=19;break}Ae[l]<<24>>24==73?Pa(u,0|He.__str118,30,1):Pa(u,0|He.__str119,29,1);var h=r+11|0,c=(Ia(u,h),u);v=19;break}while(0);if(13==v){var s;K(r,17,f,t);var d=Se[e+6],w=Ta(),p=Oe;Oe+=12*d,Oe=Oe+3>>2<<2;var E=Oe;if(Oe+=4*Se[e+9],Oe=Oe+3>>2<<2,Se[e+4]=p,Se[e+7]=E,s)var A=N(t),g=A;else var y=T(t,1),g=y;var g,m=Ae[Se[e+3]]<<24>>24==0?g:0,S=Se[e+12]+f+10*Se[e+10]|0;if(0==(0|m))var M=0;else var C=S/8+S|0,R=B(17,m,C,a),M=R;var M;Oa(w);var c=M}var c;return Oe=i,c}function Z(r){var a=r+4|0,e=Se[a>>2];va(e),Se[a>>2]=0}function Q(r,a,e){var i,v=r+4|0,t=Me[v>>2],f=0==(0|t);do if(!f){var i=(r+8|0)>>2,_=Me[i];if((_+e|0)>>>0>Me[r+12>>2]>>>0){tr(r,e);var s=Me[v>>2];if(0==(0|s))break;var n=s,o=Se[i]}else var n=t,o=_;var o,n;Pa(n+o|0,a,e,1);var l=Se[i]+e|0;Se[i]=l}while(0)}function q(r,a,e){var i,v,t=a+e|0,f=(0|e)>0;r:do if(f)for(var _=t,s=r+4|0,i=(r+8|0)>>2,n=r+12|0,o=a;;){var o,l=(_-o|0)>3;a:do{if(l){if(Ae[o]<<24>>24!=95){v=21;break}if(Ae[o+1|0]<<24>>24!=95){v=21;break}if(Ae[o+2|0]<<24>>24!=85){v=21;break}for(var b=o+3|0,k=0;;){var k,b;if(b>>>0>=t>>>0){v=21;break a}var u=ge[b],c=u<<24>>24;if((u-48&255&255)<10)var h=c-48|0;else if((u-65&255&255)<6)var h=c-55|0;else{if((u-97&255&255)>=6)break;var h=c-87|0}var h,b=b+1|0,k=(k<<4)+h|0}if(!(u<<24>>24==95&k>>>0<256)){v=21;break}var d=Me[s>>2],w=0==(0|d);do if(!w){var p=Me[i];if(p>>>0>=Me[n>>2]>>>0)break;Se[i]=p+1|0,Ae[d+p|0]=255&k;var E=b;v=25;break a}while(0);Y(r,k);var E=b;v=25;break}v=21}while(0);a:do if(21==v){var A=Me[s>>2],g=0==(0|A);do if(!g){var y=Me[i];if(y>>>0>=Me[n>>2]>>>0)break;var m=Ae[o];Se[i]=y+1|0,Ae[A+y|0]=m;var E=o;break a}while(0);var S=Ae[o]<<24>>24;Y(r,S);var E=o}while(0);var E,M=E+1|0;if(M>>>0>=t>>>0)break r;var o=M}while(0)}function $(r,a){var e,i,v,t,f,_,s,n=r>>2,o=Se[a>>2];r:do if(22==(0|o)||25==(0|o)){var l=Me[n+1],b=0==(0|l);do if(!b){var _=(r+8|0)>>2,k=Me[_];if((k+9|0)>>>0>Me[n+3]>>>0)break;for(var u=l+k|0,c=0|He.__str147,h=u,d=c+9;c<d;c++,h++)Ae[h]=Ae[c];var w=Se[_]+9|0;Se[_]=w;break r}while(0);Q(r,0|He.__str147,9)}else if(23==(0|o)||26==(0|o)){var p=Me[n+1],E=0==(0|p);do if(!E){var f=(r+8|0)>>2,A=Me[f];if((A+9|0)>>>0>Me[n+3]>>>0)break;for(var g=p+A|0,c=0|He.__str148,h=g,d=c+9;c<d;c++,h++)Ae[h]=Ae[c];var y=Se[f]+9|0;Se[f]=y;break r}while(0);Q(r,0|He.__str148,9)}else if(24==(0|o)||27==(0|o)){var m=Me[n+1],S=0==(0|m);do if(!S){var t=(r+8|0)>>2,M=Me[t];if((M+6|0)>>>0>Me[n+3]>>>0)break;var C=m+M|0;Ae[C]=Ae[0|He.__str149],Ae[C+1]=Ae[(0|He.__str149)+1],Ae[C+2]=Ae[(0|He.__str149)+2],Ae[C+3]=Ae[(0|He.__str149)+3],Ae[C+4]=Ae[(0|He.__str149)+4],Ae[C+5]=Ae[(0|He.__str149)+5];var R=Se[t]+6|0;Se[t]=R;break r}while(0);Q(r,0|He.__str149,6)}else if(28==(0|o)){var T=Me[n+1],O=0==(0|T);do{if(!O){var N=r+8|0,I=Me[N>>2];if(I>>>0>=Me[n+3]>>>0){s=17;break}Se[N>>2]=I+1|0,Ae[T+I|0]=32,s=18;break}s=17}while(0);17==s&&Y(r,32);var P=Se[a+8>>2];H(r,P)}else if(29==(0|o)){if(0!=(4&Se[n]|0))break;var D=Me[n+1],L=0==(0|D);do if(!L){var F=r+8|0,X=Me[F>>2];if(X>>>0>=Me[n+3]>>>0)break;Se[F>>2]=X+1|0,Ae[D+X|0]=42;break r}while(0);Y(r,42)}else if(30==(0|o)){var j=Me[n+1],U=0==(0|j);do if(!U){var x=r+8|0,z=Me[x>>2];if(z>>>0>=Me[n+3]>>>0)break;Se[x>>2]=z+1|0,Ae[j+z|0]=38;break r}while(0);Y(r,38)}else if(31==(0|o)){var V=Me[n+1],B=0==(0|V);do if(!B){var v=(r+8|0)>>2,K=Me[v];if((K+8|0)>>>0>Me[n+3]>>>0)break;var G=V+K|0,W=0|G;oe=1886220131,Ae[W]=255&oe,oe>>=8,Ae[W+1]=255&oe,oe>>=8,Ae[W+2]=255&oe,oe>>=8,Ae[W+3]=255&oe;var Z=G+4|0;oe=544761196,Ae[Z]=255&oe,oe>>=8,Ae[Z+1]=255&oe,oe>>=8,Ae[Z+2]=255&oe,oe>>=8,Ae[Z+3]=255&oe;var q=Se[v]+8|0;Se[v]=q;break r}while(0);Q(r,0|He.__str150,8)}else if(32==(0|o)){var $=Me[n+1],J=0==(0|$);do if(!J){var i=(r+8|0)>>2,rr=Me[i];if((rr+10|0)>>>0>Me[n+3]>>>0)break;for(var ar=$+rr|0,c=0|He.__str151,h=ar,d=c+10;c<d;c++,h++)Ae[h]=Ae[c];var er=Se[i]+10|0;Se[i]=er;break r}while(0);Q(r,0|He.__str151,10)}else if(37==(0|o)){var ir=r+4|0,vr=Me[ir>>2],tr=0==(0|vr);do{if(!tr){var fr=r+8|0,_r=Me[fr>>2];if(0!=(0|_r)&&Ae[vr+(_r-1)|0]<<24>>24==40){s=42;break}if(_r>>>0>=Me[n+3]>>>0){s=41;break}Se[fr>>2]=_r+1|0,Ae[vr+_r|0]=32,s=42;break}s=41}while(0);41==s&&Y(r,32);var sr=Se[a+4>>2];H(r,sr);var nr=Me[ir>>2],or=0==(0|nr);do if(!or){var e=(r+8|0)>>2,lr=Me[e];if((lr+3|0)>>>0>Me[n+3]>>>0)break;var br=nr+lr|0;Ae[br]=Ae[0|He.__str135],Ae[br+1]=Ae[(0|He.__str135)+1],Ae[br+2]=Ae[(0|He.__str135)+2];var kr=Se[e]+3|0;Se[e]=kr;break r}while(0);Q(r,0|He.__str135,3)}else if(3==(0|o)){var ur=Se[a+4>>2];H(r,ur)}else H(r,a);while(0)}function J(r){var a=r+20|0,e=Se[a>>2];if((0|e)<(0|Se[r+24>>2])){var i=Se[r+16>>2]+12*e|0,v=e+1|0;Se[a>>2]=v;var t=i}else var t=0;var t;return t}function rr(r,a,e){var i,v,t,f,_=r>>2,s=e,t=s>>2,n=0;r:for(;;){var n,s,o=0==(0|s);do if(!o){if(0!=(0|Se[t+2]))break;var l=Se[Se[t+1]>>2];if(29==(0|l)||30==(0|l)){f=9;break r}if(22==(0|l)||23==(0|l)||24==(0|l)||28==(0|l)||31==(0|l)||32==(0|l)||37==(0|l)){var b=Se[_+1];f=12;break r}var s=Se[t],t=s>>2,n=1;continue r}while(0);if(0!=(0|Se[a+4>>2])&0==(0|n)){f=9;break}var k=0,u=r+4|0,v=u>>2;f=22;break}do if(9==f){var c=Se[_+1];if(0==(0|c)){f=17;break}var h=Se[_+2];if(0==(0|h)){var d=c;f=13;break}var w=Ae[c+(h-1)|0];if(w<<24>>24==40||w<<24>>24==42){f=18;break}var b=c;f=12;break}while(0);do if(12==f){var b;if(0==(0|b)){f=17;break}var d=b;f=13;break}while(0);do if(13==f){var d,p=r+8|0,E=Me[p>>2];if(0!=(0|E)&&Ae[d+(E-1)|0]<<24>>24==32){f=18;break}if(E>>>0>=Me[_+3]>>>0){f=17;break}Se[p>>2]=E+1|0,Ae[d+E|0]=32,f=18;break}while(0);do if(17==f){Y(r,32),f=18;break}while(0);r:do if(18==f){var A=r+4|0,g=Me[A>>2],y=0==(0|g);do if(!y){var m=r+8|0,S=Me[m>>2];if(S>>>0>=Me[_+3]>>>0)break;Se[m>>2]=S+1|0,Ae[g+S|0]=40;var k=1,u=A,v=u>>2;break r}while(0);Y(r,40);var k=1,u=A,v=u>>2}while(0);var u,k,i=(r+20|0)>>2,M=Se[i];Se[i]=0,vr(r,e,0);r:do if(k){var C=Me[v],R=0==(0|C);do if(!R){var T=r+8|0,O=Me[T>>2];if(O>>>0>=Me[_+3]>>>0)break;Se[T>>2]=O+1|0,Ae[C+O|0]=41;break r}while(0);Y(r,41)}while(0);var N=Me[v],I=0==(0|N);do{if(!I){var P=r+8|0,D=Me[P>>2];if(D>>>0>=Me[_+3]>>>0){f=30;break}Se[P>>2]=D+1|0,Ae[N+D|0]=40,f=31;break}f=30}while(0);30==f&&Y(r,40);var L=Se[a+8>>2];0!=(0|L)&&H(r,L);var F=Me[v],X=0==(0|F);do{if(!X){var j=r+8|0,U=Me[j>>2];if(U>>>0>=Me[_+3]>>>0){f=36;break}Se[j>>2]=U+1|0,Ae[F+U|0]=41,f=37;break}f=36}while(0);36==f&&Y(r,41),vr(r,e,1),Se[i]=M}function ar(r,a,e){var i,v,t,f=r>>2,_=0==(0|e);do{if(!_){var s=e,v=s>>2;r:for(;;){var s;if(0==(0|s)){var n=1;t=14;break}if(0==(0|Se[v+2])){var o=36==(0|Se[Se[v+1]>>2]),l=1&o^1;if(o){var n=l;t=14;break}var b=r+4|0,k=Me[b>>2],u=0==(0|k);do{if(!u){var i=(r+8|0)>>2,c=Me[i];if((c+2|0)>>>0>Me[f+3]>>>0){t=9;break}var h=k+c|0;oe=10272,Ae[h]=255&oe,oe>>=8,Ae[h+1]=255&oe;var d=Se[i]+2|0;Se[i]=d,vr(r,e,0),t=10;break}t=9}while(0);9==t&&(Q(r,0|He.__str140,2),vr(r,e,0));var w=Me[b>>2],p=0==(0|w);do if(!p){var E=r+8|0,A=Me[E>>2];if(A>>>0>=Me[f+3]>>>0)break;Se[E>>2]=A+1|0,Ae[w+A|0]=41;var g=l;t=15;break r}while(0);Y(r,41);var g=l;t=15;break}var s=Se[v],v=s>>2}if(14==t){var n;vr(r,e,0);var g=n}var g;if(0!=(0|g)){t=17;break}var y=r+4|0;t=21;break}t=17}while(0);r:do if(17==t){var m=r+4|0,S=Me[m>>2],M=0==(0|S);do if(!M){var C=r+8|0,R=Me[C>>2];if(R>>>0>=Me[f+3]>>>0)break;Se[C>>2]=R+1|0,Ae[S+R|0]=32;var y=m;break r}while(0);Y(r,32);var y=m}while(0);var y,T=Me[y>>2],O=0==(0|T);do{if(!O){var N=r+8|0,I=Me[N>>2];if(I>>>0>=Me[f+3]>>>0){t=24;break}Se[N>>2]=I+1|0,Ae[T+I|0]=91,t=25;break}t=24}while(0);24==t&&Y(r,91);var P=Se[a+4>>2];0!=(0|P)&&H(r,P);var D=Me[y>>2],L=0==(0|D);do{if(!L){var F=r+8|0,X=Me[F>>2];if(X>>>0>=Me[f+3]>>>0){t=30;break}Se[F>>2]=X+1|0,Ae[D+X|0]=93,t=31;break}t=30}while(0);30==t&&Y(r,93)}function er(r,a){var e,i,v,t,f,_,s=Oe;Oe+=8;var n,o=s,_=(a+4|0)>>2,l=Se[_];if(4==(0|Se[l>>2])){var f=(r+20|0)>>2,b=Se[f];Se[f]=0;var t=(r+16|0)>>2,k=Se[t],u=0|o;Se[u>>2]=k,Se[t]=o;var c=Se[_];Se[o+4>>2]=c;var h=Se[c+4>>2];H(r,h);var d=Se[u>>2];Se[t]=d;var v=(r+4|0)>>2,w=Me[v],p=0==(0|w);do{if(!p){var i=(r+8|0)>>2,E=Me[i],A=0==(0|E);do if(!A){if(Ae[w+(E-1)|0]<<24>>24!=60)break;E>>>0<Me[r+12>>2]>>>0?(Se[i]=E+1|0,Ae[w+E|0]=32):Y(r,32)}while(0);var g=Me[v];if(0==(0|g)){n=12;break}var y=Me[i];if(y>>>0>=Me[r+12>>2]>>>0){n=12;break}Se[i]=y+1|0,Ae[g+y|0]=60,n=13;break}n=12}while(0);12==n&&Y(r,60);var m=Se[Se[_]+8>>2];H(r,m);var S=Me[v],M=0==(0|S);do{if(!M){var e=(r+8|0)>>2,C=Me[e],R=0==(0|C);do if(!R){if(Ae[S+(C-1)|0]<<24>>24!=62)break;C>>>0<Me[r+12>>2]>>>0?(Se[e]=C+1|0,Ae[S+C|0]=32):Y(r,32)}while(0);var T=Me[v];if(0==(0|T)){n=22;break}var O=Me[e];if(O>>>0>=Me[r+12>>2]>>>0){n=22;break}Se[e]=O+1|0,Ae[T+O|0]=62,n=23;break}n=22}while(0);22==n&&Y(r,62),Se[f]=b}else H(r,l);Oe=s}function ir(r,a){var e,i=40==(0|Se[a>>2]);r:do if(i){var v=Me[r+4>>2],t=0==(0|v);do{if(!t){var e=(r+8|0)>>2,f=Me[e],_=a+4|0,s=Me[_>>2],n=Me[s+8>>2];if((n+f|0)>>>0>Me[r+12>>2]>>>0){var o=s,l=n;break}var b=v+f|0,k=Se[s+4>>2];Pa(b,k,n,1);var u=Se[e]+Se[Se[_>>2]+8>>2]|0;Se[e]=u;break r}var c=Me[a+4>>2],o=c,l=Se[c+8>>2]}while(0);var l,o,h=Se[o+4>>2];Q(r,h,l)}else H(r,a);while(0)}function vr(r,a,e){var i,v,t,f,_,f=(r+4|0)>>2,s=0==(0|e),t=(r+16|0)>>2;r:do if(s)for(var n=a;;){var n;if(0==(0|n)){_=29;break r}if(0==(0|Se[f])){_=29;break r}var o=n+8|0,l=0==(0|Se[o>>2]);do if(l){var b=n+4|0;if((Se[Se[b>>2]>>2]-25|0)>>>0<3)break;Se[o>>2]=1;var k=Me[t],u=Se[n+12>>2];Se[t]=u;var c=Me[b>>2],h=Se[c>>2];if(35==(0|h)){var d=n,w=k,p=c;_=14;break r}if(36==(0|h)){var E=n,A=k,g=c;_=15;break r}if(2==(0|h)){var y=k,m=b;_=16;break r}$(r,c),Se[t]=k}while(0);var n=Se[n>>2]}else for(var S=a;;){var S;if(0==(0|S)){_=29;break r}if(0==(0|Se[f])){_=29;break r}var M=S+8|0;if(0==(0|Se[M>>2])){Se[M>>2]=1;var C=Me[t],R=Se[S+12>>2];Se[t]=R;var T=S+4|0,O=Me[T>>2],N=Se[O>>2];if(35==(0|N)){var d=S,w=C,p=O;_=14;break r}if(36==(0|N)){var E=S,A=C,g=O;_=15;break r}if(2==(0|N)){var y=C,m=T;_=16;break r}$(r,O),Se[t]=C}var S=Se[S>>2]}while(0);if(14==_){var p,w,d,I=Se[d>>2];rr(r,p,I),Se[t]=w}else if(15==_){var g,A,E,P=Se[E>>2];ar(r,g,P),Se[t]=A}else if(16==_){var m,y,v=(r+20|0)>>2,D=Se[v];Se[v]=0;var L=Se[Se[m>>2]+4>>2];H(r,L),Se[v]=D;var F=0==(4&Se[r>>2]|0),X=Me[f],j=0!=(0|X);r:do if(F){do if(j){var i=(r+8|0)>>2,U=Me[i];if((U+2|0)>>>0>Me[r+12>>2]>>>0)break;var x=X+U|0;oe=14906,Ae[x]=255&oe,oe>>=8,Ae[x+1]=255&oe;var z=Se[i]+2|0;Se[i]=z;break r}while(0);Q(r,0|He.__str120,2)}else{do if(j){var V=r+8|0,B=Me[V>>2];if(B>>>0>=Me[r+12>>2]>>>0)break;Se[V>>2]=B+1|0,Ae[X+B|0]=46;break r}while(0);Y(r,46)}while(0);var K=Me[Se[m>>2]+8>>2],G=(Se[K>>2]-25|0)>>>0<3;r:do if(G)for(var W=K;;){var W,Z=Me[W+4>>2];if((Se[Z>>2]-25|0)>>>0>=3){var q=Z;break r}var W=Z}else var q=K;while(0);var q;H(r,q),Se[t]=y}}function tr(r,a){var e,e=(r+4|0)>>2,i=Se[e],v=0==(0|i);r:do if(!v){for(var t=Se[r+8>>2]+a|0,f=r+12|0,_=Se[f>>2],s=i;;){var s,_;if(t>>>0<=_>>>0)break r;var n=_<<1,o=fa(s,n);if(0==(0|o))break;Se[e]=o,Se[f>>2]=n;var _=n,s=o}var l=Se[e];va(l),Se[e]=0,Se[r+24>>2]=1}while(0)}function fr(r,a,e){var i,v=J(r),i=v>>2;return 0!=(0|v)&&(Se[i]=21,Se[i+1]=a,Se[i+2]=e),v}function _r(r){var a,a=(r+12|0)>>2,e=Se[a],i=Ae[e]<<24>>24;if(88==(0|i)){var v=e+1|0;Se[a]=v;var t=nr(r),f=Se[a],_=f+1|0;Se[a]=_;var s=Ae[f]<<24>>24==69?t:0,n=s}else if(76==(0|i))var o=or(r),n=o;else var l=N(r),n=l;var n;return n}function sr(r){var a,a=(r+12|0)>>2,e=Se[a],i=Ae[e];if(i<<24>>24==110){var v=e+1|0;Se[a]=v;var t=1,f=Ae[v],_=v}else var t=0,f=i,_=e;var _,f,t,s=(f-48&255&255)<10;r:do if(s)for(var n=f,o=0,l=_;;){var l,o,n,b=(n<<24>>24)-48+10*o|0,k=l+1|0;Se[a]=k;var u=ge[k];if((u-48&255&255)>=10){var c=b;break r}var n=u,o=b,l=k}else var c=0;while(0);var c,h=0==(0|t)?c:0|-c;return h}function nr(r){var a,e,a=(r+12|0)>>2,i=Se[a],v=Ae[i];do{if(v<<24>>24==76){var t=or(r),f=t;e=21;break}if(v<<24>>24==84){var _=x(r),f=_;e=21;break}if(v<<24>>24==115){if(Ae[i+1|0]<<24>>24!=114){e=8;break}var s=i+2|0;Se[a]=s;var n=N(r),o=br(r);if(Ae[Se[a]]<<24>>24==73){var l=z(r),b=D(r,4,o,l),k=D(r,1,n,b),f=k;e=21;break}var u=D(r,1,n,o),f=u;e=21;break}e=8}while(0);r:do if(8==e){var c=kr(r);if(0==(0|c)){var f=0;break}var h=0|c,d=Se[h>>2],w=40==(0|d);do{if(w){var p=c+4|0,E=r+48|0,A=Se[Se[p>>2]+8>>2]-2+Se[E>>2]|0;Se[E>>2]=A;var g=Se[h>>2];if(40!=(0|g)){var y=g;e=13;break}var m=Se[p>>2],S=Se[m>>2],M=Da(S,0|He.__str90);if(0!=(0|M)){var C=m;e=15;break}var R=N(r),T=D(r,43,c,R),f=T;break r}var y=d;e=13}while(0);do if(13==e){var y;if(40==(0|y)){var C=Se[c+4>>2];e=15;break}if(41==(0|y)){var O=c+4|0;e=17;break}if(42==(0|y)){e=18;break}var f=0;break r}while(0);do if(15==e){var C,O=C+12|0;e=17;break}while(0);do if(17==e){var O,I=Se[O>>2];if(1==(0|I))break;if(2==(0|I)){var P=nr(r),L=nr(r),F=D(r,45,P,L),X=D(r,44,c,F);return X}if(3==(0|I)){var j=nr(r),U=nr(r),V=nr(r),B=D(r,48,U,V),H=D(r,47,j,B),K=D(r,46,c,H);return K}var f=0;break r}while(0);var Y=nr(r),G=D(r,43,c,Y);return G}while(0);var f;return f}function or(r){var a,a=(r+12|0)>>2,e=Se[a],i=e+1|0;Se[a]=i;var v=Ae[e]<<24>>24==76;r:do if(v){if(Ae[i]<<24>>24==95)var t=T(r,0),f=t;else{var _=N(r);if(0==(0|_)){var s=0;break}var n=33==(0|Se[_>>2]);do if(n){var o=Se[_+4>>2];if(0==(0|Se[o+16>>2]))break;var l=r+48|0,b=Se[l>>2]-Se[o+4>>2]|0;Se[l>>2]=b}while(0);var k=Se[a];if(Ae[k]<<24>>24==110){var u=k+1|0;Se[a]=u;var c=50,h=u}else var c=49,h=k;for(var h,c,d=h;;){var d,w=Ae[d];if(w<<24>>24==69)break;if(w<<24>>24==0){var s=0;break r}var p=d+1|0;Se[a]=p;var d=p}var E=lr(r,h,d-h|0),A=D(r,c,_,E),f=A}var f,g=Se[a],y=g+1|0;Se[a]=y;var m=Ae[g]<<24>>24==69?f:0,s=m}else var s=0;while(0);var s;return s}function lr(r,a,e){var i=J(r),v=m(i,a,e),t=0==(0|v)?0:i;return t}function br(r){var a=r+12|0,e=Me[a>>2],i=ge[e],v=(i-48&255&255)<10;do if(v)var t=L(r),f=t;else if((i-97&255&255)<26){var _=kr(r);if(0==(0|_)){var f=0;break}if(40!=(0|Se[_>>2])){var f=_;break}var s=r+48|0,n=Se[Se[_+4>>2]+8>>2]+Se[s>>2]+7|0;Se[s>>2]=n;var f=_}else if(i<<24>>24==67||i<<24>>24==68)var o=hr(r),f=o;else{if(i<<24>>24!=76){var f=0;break}Se[a>>2]=e+1|0;var l=L(r);if(0==(0|l)){var f=0;break}var b=dr(r),k=0==(0|b)?0:l,f=k}while(0);var f;return f}function kr(r){var a,e,a=(r+12|0)>>2,i=Se[a],v=i+1|0;Se[a]=v;var t=ge[i],f=i+2|0;Se[a]=f;var _=ge[v];do{if(t<<24>>24==118){if((_-48&255&255)>=10){var s=49,n=0;e=6;break}var o=(_<<24>>24)-48|0,l=L(r),b=ur(r,o,l),k=b;e=14;break}if(t<<24>>24==99){if(_<<24>>24!=118){var s=49,n=0;e=6;break}var u=N(r),c=D(r,42,u,0),k=c;e=14;break}var s=49,n=0;e=6}while(0);r:do if(6==e){for(;;){var n,s,h=(s-n)/2+n|0,d=(h<<4)+ri|0,w=Se[d>>2],p=Ae[w],E=t<<24>>24==p<<24>>24;if(E&&_<<24>>24==Ae[w+1|0]<<24>>24)break;var A=t<<24>>24<p<<24>>24;do if(A)var g=h,y=n;else{if(E&&_<<24>>24<Ae[w+1|0]<<24>>24){var g=h,y=n;break}var g=s,y=h+1|0}while(0);var y,g;if((0|y)==(0|g)){var k=0;break r}var s=g,n=y}var m=cr(r,d),k=m}while(0);var k;return k}function ur(r,a,e){var i=J(r),v=S(i,a,e),t=0==(0|v)?0:i;return t}function cr(r,a){var e=J(r);return 0!=(0|e)&&(Se[e>>2]=40,Se[e+4>>2]=a),e}function hr(r){var a,e,i=Se[r+44>>2],e=i>>2,v=0==(0|i);do if(!v){var t=Se[e];if(0==(0|t)){var f=r+48|0,_=Se[f>>2]+Se[e+2]|0;Se[f>>2]=_}else{if(21!=(0|t))break;var s=r+48|0,n=Se[s>>2]+Se[e+2]|0;Se[s>>2]=n}}while(0);var a=(r+12|0)>>2,o=Se[a],l=o+1|0;Se[a]=l;var b=Ae[o]<<24>>24;do if(67==(0|b)){var k=o+2|0;Se[a]=k;var u=Ae[l]<<24>>24;if(49==(0|u))var c=1;else if(50==(0|u))var c=2;else{if(51!=(0|u)){var h=0;break}var c=3}var c,d=wr(r,c,i),h=d}else if(68==(0|b)){var w=o+2|0;Se[a]=w;var p=Ae[l]<<24>>24;if(48==(0|p))var E=1;else if(49==(0|p))var E=2;else{if(50!=(0|p)){var h=0;break}var E=3}var E,A=pr(r,E,i),h=A}else var h=0;while(0);var h;return h}function dr(r){var a=r+12|0,e=Se[a>>2];if(Ae[e]<<24>>24==95){var i=e+1|0;Se[a>>2]=i;var v=sr(r),t=v>>>31^1}else var t=1;var t;return t}function wr(r,a,e){var i=J(r),v=M(i,a,e),t=0==(0|v)?0:i;return t}function pr(r,a,e){var i=J(r),v=C(i,a,e),t=0==(0|v)?0:i;return t}function Er(r,a){var e=J(r);return 0!=(0|e)&&(Se[e>>2]=5,Se[e+4>>2]=a),e}function Ar(r){var a,a=(r+12|0)>>2,e=Se[a],i=Ae[e]<<24>>24;do if(78==(0|i))var v=gr(r),t=v;else if(90==(0|i))var f=yr(r),t=f;else if(76==(0|i))var _=br(r),t=_;else if(83==(0|i)){if(Ae[e+1|0]<<24>>24==116){var s=e+2|0;Se[a]=s;var n=lr(r,0|He.__str152,3),o=br(r),l=D(r,1,n,o),b=r+48|0,k=Se[b>>2]+3|0;Se[b>>2]=k;var u=0,c=l}else var h=V(r,0),u=1,c=h;var c,u;if(Ae[Se[a]]<<24>>24!=73){var t=c;break}if(0==(0|u)){var d=R(r,c);if(0==(0|d)){var t=0;break}}var w=z(r),p=D(r,4,c,w),t=p}else{var E=br(r);if(Ae[Se[a]]<<24>>24!=73){var t=E;break}var A=R(r,E);if(0==(0|A)){var t=0;break}var g=z(r),y=D(r,4,E,g),t=y}while(0);var t;return t}function gr(r){var a,e=Oe;Oe+=4;var i=e,a=(r+12|0)>>2,v=Se[a],t=v+1|0;Se[a]=t;var f=Ae[v]<<24>>24==78;do if(f){var _=I(r,i,1);if(0==(0|_)){var s=0;break}var n=mr(r);if(Se[_>>2]=n,0==(0|n)){var s=0;break}var o=Se[a],l=o+1|0;if(Se[a]=l,Ae[o]<<24>>24!=69){var s=0;break}var s=Se[i>>2]}else var s=0;while(0);var s;return Oe=e,s}function yr(r){var a,a=(r+12|0)>>2,e=Se[a],i=e+1|0;Se[a]=i;var v=Ae[e]<<24>>24==90;do if(v){var t=O(r,0),f=Se[a],_=f+1|0;if(Se[a]=_,Ae[f]<<24>>24!=69){var s=0;break}if(Ae[_]<<24>>24==115){var n=f+2|0;Se[a]=n;var o=dr(r);if(0==(0|o)){var s=0;break}var l=lr(r,0|He.__str168,14),b=D(r,2,t,l),s=b}else{var k=Ar(r),u=dr(r);if(0==(0|u)){var s=0;break}var c=D(r,2,t,k),s=c}}else var s=0;while(0);var s;return s}function mr(r){var a,e=r+12|0,i=0;r:for(;;){var i,v=ge[Se[e>>2]];if(v<<24>>24==0){var t=0;break}var f=(v-48&255&255)<10|(v-97&255&255)<26;do{if(!f){if(v<<24>>24==76||v<<24>>24==68||v<<24>>24==67){a=5;break}if(v<<24>>24==83){var _=V(r,1),s=_;a=10;break}if(v<<24>>24==73){if(0==(0|i)){var t=0;break r}var n=z(r),o=4,l=n;a=11;break}if(v<<24>>24==84){var b=x(r),s=b;a=10;break}if(v<<24>>24==69){var t=i;break r}var t=0;break r}a=5}while(0);do if(5==a){var k=br(r),s=k;a=10;break}while(0);do if(10==a){var s;if(0==(0|i)){var u=s;a=12;break}var o=1,l=s;a=11;break}while(0);if(11==a)var l,o,c=D(r,o,i,l),u=c;var u;if(v<<24>>24!=83)if(Ae[Se[e>>2]]<<24>>24!=69){var h=R(r,u);if(0==(0|h)){var t=0;break}var i=u}else var i=u;else var i=u}var t;return t}function Sr(r,a){var e,i,v=Oe;Oe+=4;var t=v,i=t>>2,e=(r+12|0)>>2,f=Se[e];if(Ae[f]<<24>>24==74){var _=f+1|0;Se[e]=_;var s=1}else var s=a;var s;Se[i]=0;var n=s,o=0,l=t;r:for(;;)for(var l,o,n,b=n,k=o;;){var k,b,u=Ae[Se[e]];if(u<<24>>24==0||u<<24>>24==69){var c=Se[i];if(0==(0|c)){var h=0;break r}var d=0==(0|Se[c+8>>2]);do if(d){var w=Se[c+4>>2];if(33!=(0|Se[w>>2])){var p=c;break}var E=Se[w+4>>2];if(9!=(0|Se[E+16>>2])){var p=c;break}var A=r+48|0,g=Se[A>>2]-Se[E+4>>2]|0;Se[A>>2]=g,Se[i]=0;var p=0}else var p=c;while(0);var p,y=D(r,35,k,p),h=y;break r}var m=N(r);if(0==(0|m)){var h=0;break r}if(0==(0|b)){var S=D(r,38,m,0);if(Se[l>>2]=S,0==(0|S)){var h=0;break r}var n=0,o=k,l=S+8|0;continue r}var b=0,k=m}var h;return Oe=v,h}function Mr(r){for(var a=r;;){var a;if(0==(0|a)){var e=0;break}var i=Se[a>>2];if(1!=(0|i)&&2!=(0|i)){if(6==(0|i)||7==(0|i)||42==(0|i)){var e=1;break}var e=0;break}var a=Se[a+8>>2]}var e;return e}function Cr(r){var a=r>>2;Se[a+3]=0,Se[a+2]=0,Se[a+1]=0,Se[a]=0,Se[a+4]=0}function Rr(r,a){var e,e=(r+12|0)>>2,i=Se[e],v=(Se[r+4>>2]-i|0)<(0|a);r:do if(v)var t=0;else{var f=i+a|0;Se[e]=f;var _=0==(4&Se[r+8>>2]|0);do if(!_){if(Ae[f]<<24>>24!=36)break;var s=a+(i+1)|0;Se[e]=s}while(0);var n=(0|a)>9;do if(n){var o=La(i,0|He.__str117,8);if(0!=(0|o))break;var l=Ae[i+8|0];if(l<<24>>24!=46&&l<<24>>24!=95&&l<<24>>24!=36)break;if(Ae[i+9|0]<<24>>24!=78)break;var b=r+48|0,k=22-a+Se[b>>2]|0;Se[b>>2]=k;var u=lr(r,0|He.__str169,21),t=u;break r}while(0);var c=lr(r,i,a),t=c}while(0);var t;return t}function Tr(r){var a,e,e=(r+48|0)>>2,i=Se[e],v=i+20|0;Se[e]=v;var a=(r+12|0)>>2,t=Se[a],f=t+1|0;Se[a]=f;var _=Ae[t];do if(_<<24>>24==84){var s=t+2|0;Se[a]=s;var n=Ae[f]<<24>>24;if(86==(0|n)){var o=i+15|0;Se[e]=o;var l=N(r),b=D(r,8,l,0),k=b}else if(84==(0|n)){var u=i+10|0;Se[e]=u;var c=N(r),h=D(r,9,c,0),k=h}else if(73==(0|n))var d=N(r),w=D(r,11,d,0),k=w;else if(83==(0|n))var p=N(r),E=D(r,12,p,0),k=E;else if(104==(0|n)){var A=Nr(r,104);if(0==(0|A)){var k=0;break}var g=O(r,0),y=D(r,14,g,0),k=y}else if(118==(0|n)){var m=Nr(r,118);if(0==(0|m)){var k=0;break}var S=O(r,0),M=D(r,15,S,0),k=M}else if(99==(0|n)){var C=Nr(r,0);if(0==(0|C)){var k=0;break}var R=Nr(r,0);if(0==(0|R)){var k=0;break}var T=O(r,0),I=D(r,16,T,0),k=I}else if(67==(0|n)){var P=N(r),L=sr(r);if((0|L)<0){var k=0;break}var F=Se[a],X=F+1|0;if(Se[a]=X,Ae[F]<<24>>24!=95){var k=0;break}var j=N(r),U=Se[e]+5|0;Se[e]=U;var x=D(r,10,j,P),k=x}else if(70==(0|n))var z=N(r),V=D(r,13,z,0),k=V;else{if(74!=(0|n)){var k=0;break}var B=N(r),H=D(r,17,B,0),k=H}}else if(_<<24>>24==71){var K=t+2|0;Se[a]=K;var Y=Ae[f]<<24>>24;if(86==(0|Y))var G=Ar(r),W=D(r,18,G,0),k=W;else if(82==(0|Y))var Z=Ar(r),Q=D(r,19,Z,0),k=Q;else{if(65!=(0|Y)){var k=0;break}var q=O(r,0),$=D(r,20,q,0),k=$}}else var k=0;while(0);var k;return k}function Or(r){for(var a,e=r,a=e>>2;;){var e;if(0==(0|e)){var i=0;break}var v=Se[a];if(4==(0|v)){var t=Se[a+1],f=Mr(t),i=0==(0|f)&1;break}if(25!=(0|v)&&26!=(0|v)&&27!=(0|v)){var i=0;break}var e=Se[a+1],a=e>>2}var i;return i}function Nr(r,a){var e;if(0==(0|a)){var i=r+12|0,v=Se[i>>2],t=v+1|0;Se[i>>2]=t;var f=Ae[v]<<24>>24}else var f=a;var f;do{if(104==(0|f)){var _=(sr(r),r+12|0);e=7;break}if(118==(0|f)){var s=(sr(r),r+12|0),n=Se[s>>2],o=n+1|0;if(Se[s>>2]=o,Ae[n]<<24>>24!=95){var l=0;e=8;break}var _=(sr(r),s);e=7;break}var l=0;e=8}while(0);if(7==e){var _,b=Se[_>>2],k=b+1|0;Se[_>>2]=k;var l=Ae[b]<<24>>24==95&1}var l;return l}function Ir(r){var a,e,i=r>>2,v=Oe;Oe+=56;var t,f=v,_=v+8,s=v+16,n=v+36,e=(0|r)>>2,o=Se[e],l=0==(8192&o|0);r:do{if(l){var a=(r+12|0)>>2,b=Se[a];if(Ae[b]<<24>>24!=63){var k=0;t=111;break}var u=b+1|0;Se[a]=u;var c=Ae[u];do if(c<<24>>24==63){if(Ae[b+2|0]<<24>>24==36){var h=b+3|0;if(Ae[h]<<24>>24!=63){var d=5;t=90;break}Se[a]=h;var w=6,p=h}else var w=0,p=u;var p,w,E=p+1|0;Se[a]=E;var A=Ae[E]<<24>>24;do if(48==(0|A)){var g=1;t=81}else{if(49==(0|A)){var g=2;t=81;break}if(50!=(0|A)){if(51==(0|A)){var y=0|He.__str2172,m=E;t=82;break}if(52==(0|A)){var y=0|He.__str3173,m=E;t=82;break}if(53==(0|A)){var y=0|He.__str4174,m=E;t=82;break}if(54==(0|A)){var y=0|He.__str5175,m=E;t=82;break}if(55==(0|A)){var y=0|He.__str6176,m=E;t=82;break}if(56==(0|A)){var y=0|He.__str7177,m=E;t=82;break}if(57==(0|A)){var y=0|He.__str8178,m=E;t=82;break}if(65==(0|A)){var y=0|He.__str9179,m=E;t=82;break}if(66==(0|A)){Se[a]=p+2|0;var S=0|He.__str10180,M=3;t=88;break}if(67==(0|A)){var y=0|He.__str11181,m=E;t=82;break}if(68==(0|A)){var y=0|He.__str12182,m=E;t=82;break}if(69==(0|A)){var y=0|He.__str13183,m=E;t=82;break}if(70==(0|A)){var y=0|He.__str14184,m=E;t=82;break}if(71==(0|A)){var y=0|He.__str15185,m=E;t=82;break}if(72==(0|A)){var y=0|He.__str16186,m=E;t=82;break}if(73==(0|A)){var y=0|He.__str17187,m=E;t=82;break}if(74==(0|A)){var y=0|He.__str18188,m=E;t=82;break}if(75==(0|A)){var y=0|He.__str19189,m=E;t=82;break}if(76==(0|A)){var y=0|He.__str20190,m=E;t=82;break}if(77==(0|A)){var y=0|He.__str21191,m=E;t=82;break}if(78==(0|A)){var y=0|He.__str22192,m=E;t=82;break}if(79==(0|A)){var y=0|He.__str23193,m=E;t=82;break}if(80==(0|A)){var y=0|He.__str24194,m=E;t=82;break}if(81==(0|A)){var y=0|He.__str25195,m=E;t=82;break}if(82==(0|A)){var y=0|He.__str26196,m=E;t=82;break}if(83==(0|A)){var y=0|He.__str27197,m=E;t=82;break}if(84==(0|A)){var y=0|He.__str28198,m=E;t=82;break}if(85==(0|A)){var y=0|He.__str29199,m=E;t=82;break}if(86==(0|A)){var y=0|He.__str30200,m=E;t=82;break}if(87==(0|A)){var y=0|He.__str31201,m=E;t=82;break}if(88==(0|A)){var y=0|He.__str32202,m=E;t=82;break}if(89==(0|A)){var y=0|He.__str33203,m=E;t=82;break}if(90==(0|A)){var y=0|He.__str34204,m=E;t=82;break}if(95==(0|A)){var C=p+2|0;Se[a]=C;var R=Ae[C]<<24>>24;if(48==(0|R)){var y=0|He.__str35205,m=C;t=82;break}if(49==(0|R)){var y=0|He.__str36206,m=C;t=82;break}if(50==(0|R)){var y=0|He.__str37207,m=C;t=82;break}if(51==(0|R)){var y=0|He.__str38208,m=C;t=82;break}if(52==(0|R)){var y=0|He.__str39209,m=C;t=82;break}if(53==(0|R)){var y=0|He.__str40210,m=C;t=82;break}if(54==(0|R)){var y=0|He.__str41211,m=C;t=82;break}if(55==(0|R)){var y=0|He.__str42212,m=C;t=82;break}if(56==(0|R)){var y=0|He.__str43213,m=C;t=82;break}if(57==(0|R)){var y=0|He.__str44214,m=C;t=82;break}if(65==(0|R)){var y=0|He.__str45215,m=C;t=82;break}if(66==(0|R)){var y=0|He.__str46216,m=C;t=82;break}if(67==(0|R)){Se[a]=p+3|0;var T=0|He.__str47217;t=84;break}if(68==(0|R)){var y=0|He.__str48218,m=C;t=82;break}if(69==(0|R)){var y=0|He.__str49219,m=C;t=82;break}if(70==(0|R)){var y=0|He.__str50220,m=C;t=82;break}if(71==(0|R)){var y=0|He.__str51221,m=C;t=82;break}if(72==(0|R)){var y=0|He.__str52222,m=C;t=82;break}if(73==(0|R)){var y=0|He.__str53223,m=C;t=82;break}if(74==(0|R)){var y=0|He.__str54224,m=C;t=82;break}if(75==(0|R)){var y=0|He.__str55225,m=C;t=82;break}if(76==(0|R)){var y=0|He.__str56226,m=C;t=82;break}if(77==(0|R)){var y=0|He.__str57227,m=C;t=82;break}if(78==(0|R)){var y=0|He.__str58228,m=C;t=82;break}if(79==(0|R)){var y=0|He.__str59229,m=C;t=82;break}if(82==(0|R)){var O=4|o;Se[e]=O;var N=p+3|0;Se[a]=N;var I=Ae[N]<<24>>24;if(48==(0|I)){Se[a]=p+4|0,Cr(s);var P=(Pr(r,_,s,0),Se[_>>2]),D=Se[_+4>>2],L=Dr(r,0|He.__str60230,(ne=Oe,Oe+=8,Se[ne>>2]=P,Se[ne+4>>2]=D,ne)),F=Se[a]-1|0;Se[a]=F;var y=L,m=F;t=82;break}if(49==(0|I)){Se[a]=p+4|0;var X=Lr(r),j=Lr(r),U=Lr(r),x=Lr(r),z=Se[a]-1|0;Se[a]=z;var V=Dr(r,0|He.__str61231,(ne=Oe,Oe+=16,Se[ne>>2]=X,Se[ne+4>>2]=j,Se[ne+8>>2]=U,Se[ne+12>>2]=x,ne)),y=V,m=Se[a];t=82;break}if(50==(0|I)){var y=0|He.__str62232,m=N;t=82;break}if(51==(0|I)){var y=0|He.__str63233,m=N;t=82;break}if(52==(0|I)){var y=0|He.__str64234,m=N;t=82;break}var y=0,m=N;t=82;break}if(83==(0|R)){var y=0|He.__str65235,m=C;t=82;break}if(84==(0|R)){var y=0|He.__str66236,m=C;t=82;break}if(85==(0|R)){var y=0|He.__str67237,m=C;t=82;break}if(86==(0|R)){var y=0|He.__str68238,m=C;t=82;break}if(88==(0|R)){var y=0|He.__str69239,m=C;t=82;break}if(89==(0|R)){var y=0|He.__str70240,m=C;t=82;break}var k=0;t=111;break r}var k=0;t=111;break r}var y=0|He.__str1171,m=E;t=82}while(0);do{if(81==t){var g;Se[a]=p+2|0;var B=g;t=83;break}if(82==t){var m,y;if(Se[a]=m+1|0,1==(0|w)||2==(0|w)){var B=w;t=83;break}if(4==(0|w)){var T=y;t=84;break}if(6!=(0|w)){var S=y,M=w;t=88;break}Cr(n);var H=Xr(r,n,0,60,62);if(0==(0|H))var K=y;else var Y=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=y,Se[ne+4>>2]=H,ne)),K=Y;var K;Se[i+6]=0;var S=K,M=w;t=88;break}}while(0);if(83==t){var B,G=r+40|0,W=Fr(r,0|He._symbol_demangle_dashed_null,-1,G);if(0==(0|W)){var k=0;t=111;break r}var d=B;t=90;break}if(84==t){var T;Se[i+4]=T;var Z=1,Q=T;t=109;break r}if(88==t){var M,S,q=r+40|0,$=Fr(r,S,-1,q);if(0==(0|$)){var k=0;t=111;break r}var d=M;t=90;break}}else{if(c<<24>>24==36){var J=b+2|0;Se[a]=J;var rr=jr(r);Se[i+4]=rr;var ar=0!=(0|rr)&1;t=107;break}var d=0;t=90}while(0);if(90==t){var d,er=Me[a],ir=Ae[er]<<24>>24;if(64==(0|ir))Se[a]=er+1|0;else if(36==(0|ir))t=93;else{var vr=zr(r);if(0==(0|vr)){var k=-1;t=111;break}}if(5==(0|d)){var tr=r+20|0,fr=Se[tr>>2]+1|0;Se[tr>>2]=fr}else if(1==(0|d)||2==(0|d)){if(Me[i+11]>>>0<2){var k=-1;t=111;break}var _r=r+56|0,sr=Me[_r>>2],nr=Se[sr+4>>2];if(1==(0|d))Se[sr>>2]=nr;else{var or=Dr(r,0|He.__str71241,(ne=Oe,Oe+=4,Se[ne>>2]=nr,ne)),lr=Se[_r>>2];Se[lr>>2]=or}var br=4|Se[e];Se[e]=br}else if(3==(0|d)){var kr=Se[e]&-5;Se[e]=kr}var ur=ge[Se[a]];if((ur-48&255&255)<10)var cr=Vr(r),ar=cr;else if((ur-65&255&255)<26)var hr=Br(r,3==(0|d)&1),ar=hr;else{if(ur<<24>>24!=36){var k=-1;t=111;break}var dr=Hr(r),ar=dr}}var ar;if(0==(0|ar)){var k=-1;t=111;break}var Z=ar,Q=Se[i+4];t=109;break}var wr=Pr(r,f,0,0);if(0==(0|wr)){var k=-1;t=111;break}var pr=Se[f>>2],Er=Se[f+4>>2],Ar=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=pr,Se[ne+4>>2]=Er,ne));Se[i+4]=Ar;var Z=1,Q=Ar;t=109;break}while(0);do if(109==t){var Q,Z;if(0!=(0|Q)){var k=Z;break}Xa(0|He.__str72242,1499,0|He.___func___symbol_demangle,0|He.__str73243);var k=Z}while(0);var k;return Oe=v,k}function Pr(r,a,e,i){var v,t,f,_=Oe;Oe+=24;var s=_,n=_+4,o=_+8,l=_+16,b=_+20;0==(0|a)&&Xa(0|He.__str72242,829,0|He.___func___demangle_datatype,0|He.__str121291);var f=(a+4|0)>>2;Se[f]=0;var t=(0|a)>>2;Se[t]=0;var v=(r+12|0)>>2,k=Me[v],u=k+1|0;Se[v]=u;var c=Ae[k],h=c<<24>>24;do if(95==(0|h)){Se[v]=k+2|0;var d=Ae[u],w=Zr(d);Se[t]=w}else if(67==(0|h)||68==(0|h)||69==(0|h)||70==(0|h)||71==(0|h)||72==(0|h)||73==(0|h)||74==(0|h)||75==(0|h)||77==(0|h)||78==(0|h)||79==(0|h)||88==(0|h)||90==(0|h)){var p=Qr(c);Se[t]=p}else if(84==(0|h)||85==(0|h)||86==(0|h)||89==(0|h)){var E=qr(r);if(0==(0|E))break;var A=0==(32768&Se[r>>2]|0);do if(A)if(84==(0|h))var g=0|He.__str122292;else if(85==(0|h))var g=0|He.__str123293;else if(86==(0|h))var g=0|He.__str124294;else{if(89!=(0|h)){var g=0;break}var g=0|He.__str125295}else var g=0;while(0);var g,y=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=g,Se[ne+4>>2]=E,ne));Se[t]=y}else if(63==(0|h))if(0==(0|i))$r(a,r,e,63,0);else{var m=Lr(r);if(0==(0|m))break;var S=Dr(r,0|He.__str126296,(ne=Oe,Oe+=4,Se[ne>>2]=m,ne));Se[t]=S}else if(65==(0|h)||66==(0|h))$r(a,r,e,c,i);else if(81==(0|h)||82==(0|h)||83==(0|h)){var M=0==(0|i)?80:c;$r(a,r,e,M,i)}else if(80==(0|h))if(((Ae[u]<<24>>24)-48|0)>>>0<10){var C=k+2|0;if(Se[v]=C,Ae[u]<<24>>24!=54)break;var R=r+44|0,T=Se[R>>2];Se[v]=k+3|0;var O=Ae[C],N=Se[r>>2]&-17,I=Ur(O,s,n,N);if(0==(0|I))break;var P=Pr(r,o,e,0);if(0==(0|P))break;var D=Xr(r,e,1,40,41);if(0==(0|D))break;Se[R>>2]=T;var L=Se[o>>2],F=Se[o+4>>2],X=Se[s>>2],j=Dr(r,0|He.__str127297,(ne=Oe,Oe+=12,Se[ne>>2]=L,Se[ne+4>>2]=F,Se[ne+8>>2]=X,ne));Se[t]=j;var U=Dr(r,0|He.__str128298,(ne=Oe,Oe+=4,Se[ne>>2]=D,ne));Se[f]=U}else $r(a,r,e,80,i);else if(87==(0|h)){if(Ae[u]<<24>>24!=52)break;Se[v]=k+2|0;var x=qr(r);if(0==(0|x))break;if(0==(32768&Se[r>>2]|0)){var z=Dr(r,0|He.__str129299,(ne=Oe,Oe+=4,Se[ne>>2]=x,ne));Se[t]=z}else Se[t]=x}else if(48==(0|h)||49==(0|h)||50==(0|h)||51==(0|h)||52==(0|h)||53==(0|h)||54==(0|h)||55==(0|h)||56==(0|h)||57==(0|h)){var V=h<<1,B=V-96|0,H=Yr(e,B);Se[t]=H;var K=V-95|0,Y=Yr(e,K);Se[f]=Y}else if(36==(0|h)){var G=k+2|0;Se[v]=G;var W=Ae[u]<<24>>24;if(48==(0|W)){var Z=Lr(r);Se[t]=Z}else if(68==(0|W)){var Q=Lr(r);if(0==(0|Q))break;var q=Dr(r,0|He.__str130300,(ne=Oe,Oe+=4,Se[ne>>2]=Q,ne));Se[t]=q}else if(70==(0|W)){var $=Lr(r);if(0==(0|$))break;var J=Lr(r);if(0==(0|J))break;var rr=Dr(r,0|He.__str131301,(ne=Oe,Oe+=8,Se[ne>>2]=$,Se[ne+4>>2]=J,ne));Se[t]=rr}else if(71==(0|W)){var ar=Lr(r);if(0==(0|ar))break;var er=Lr(r);if(0==(0|er))break;var ir=Lr(r);if(0==(0|ir))break;var vr=Dr(r,0|He.__str132302,(ne=Oe,Oe+=12,Se[ne>>2]=ar,Se[ne+4>>2]=er,Se[ne+8>>2]=ir,ne));Se[t]=vr}else if(81==(0|W)){var tr=Lr(r);if(0==(0|tr))break;var fr=Dr(r,0|He.__str133303,(ne=Oe,Oe+=4,Se[ne>>2]=tr,ne));Se[t]=fr}else{if(36!=(0|W))break;if(Ae[G]<<24>>24!=67)break;Se[v]=k+3|0;var _r=xr(r,l,b);if(0==(0|_r))break;var sr=Pr(r,a,e,i);if(0==(0|sr))break;var nr=Se[t],or=Se[l>>2],lr=Dr(r,0|He.__str83253,(ne=Oe,Oe+=8,Se[ne>>2]=nr,Se[ne+4>>2]=or,ne));Se[t]=lr}}while(0);var br=0!=(0|Se[t])&1;return Oe=_,br}function Dr(r,a){var e,i=Oe;Oe+=4;var v=i,e=v>>2,t=v;Se[t>>2]=arguments[Dr.length];var f=1,_=0;r:for(;;){var _,f,s=Ae[a+_|0];do{if(s<<24>>24==0)break r;if(s<<24>>24==37){var n=_+1|0,o=Ae[a+n|0]<<24>>24;if(115==(0|o)){var l=Se[e],b=l,k=l+4|0;Se[e]=k;var u=Se[b>>2];if(0==(0|u)){var c=f,h=n;break}var d=Ca(u),c=d+f|0,h=n;break}if(99==(0|o)){var w=Se[e]+4|0;Se[e]=w;var c=f+1|0,h=n;break}if(37==(0|o))var p=n;else var p=_;var p,c=f+1|0,h=p}else var c=f+1|0,h=_}while(0);var h,c,f=c,_=h+1|0}var E=Wr(r,f);if(0==(0|E))var A=0;else{Se[t>>2]=arguments[Dr.length];var g=E,y=0;r:for(;;){var y,g,m=Ae[a+y|0];do{if(m<<24>>24==0)break r;if(m<<24>>24==37){var S=y+1|0,M=Ae[a+S|0]<<24>>24;if(115==(0|M)){var C=Se[e],R=C,T=C+4|0;Se[e]=T;var O=Se[R>>2];if(0==(0|O)){var N=g,I=S;break}var P=Ca(O);Pa(g,O,P,1);var N=g+P|0,I=S;break}if(99==(0|M)){var D=Se[e],L=D,F=D+4|0;Se[e]=F,Ae[g]=255&Se[L>>2];var N=g+1|0,I=S;break}if(37==(0|M))var X=S;else var X=y;var X;Ae[g]=37;var N=g+1|0,I=X}else{Ae[g]=m;var N=g+1|0,I=y}}while(0);var I,N,g=N,y=I+1|0}Ae[g]=0;var A=E}var A;return Oe=i,A}function Lr(r){var a,a=(r+12|0)>>2,e=Se[a],i=Ae[e];if(i<<24>>24==63){var v=e+1|0;Se[a]=v;var t=1,f=v,_=Ae[v]}else var t=0,f=e,_=i;var _,f,t,s=(_-48&255&255)<9;do if(s){var n=Wr(r,3),o=0!=(0|t);o&&(Ae[n]=45);var l=Ae[Se[a]]+1&255;Ae[n+t|0]=l;var b=o?2:1;\\nAe[n+b|0]=0;var k=Se[a]+1|0;Se[a]=k;var u=n}else if(_<<24>>24==57){var c=Wr(r,4),h=0!=(0|t);h&&(Ae[c]=45),Ae[c+t|0]=49;var d=h?2:1;Ae[c+d|0]=48;var w=h?3:2;Ae[c+w|0]=0;var p=Se[a]+1|0;Se[a]=p;var u=c}else{if((_-65&255&255)>=16){var u=0;break}for(var E=0,A=f;;){var A,E,g=A+1|0;Se[a]=g;var y=(Ae[A]<<24>>24)+((E<<4)-65)|0,m=ge[g];if((m-65&255&255)>=16)break;var E=y,A=g}if(m<<24>>24!=64){var u=0;break}var S=Wr(r,17),M=0!=(0|t)?0|He.__str119289:0|ii,C=(za(S,0|He.__str118288,(ne=Oe,Oe+=8,Se[ne>>2]=M,Se[ne+4>>2]=y,ne)),Se[a]+1|0);Se[a]=C;var u=S}while(0);var u;return u}function Fr(r,a,e,i){var v,t,f,_;0==(0|a)&&Xa(0|He.__str72242,212,0|He.___func___str_array_push,0|He.__str115285),0==(0|i)&&Xa(0|He.__str72242,213,0|He.___func___str_array_push,0|He.__str116286);var f=(i+12|0)>>2,s=Me[f],n=0==(0|s);do{if(n){Se[f]=32;var o=Wr(r,128);if(0==(0|o)){var l=0;_=17;break}Se[i+16>>2]=o,_=11;break}if(Me[i+8>>2]>>>0<s>>>0){_=11;break}var b=s<<3,k=Wr(r,b);if(0==(0|k)){var l=0;_=17;break}var u=k,c=i+16|0,h=Se[c>>2],d=Se[f]<<2;Pa(k,h,d,1);var w=Se[f]<<1;Se[f]=w,Se[c>>2]=u,_=11;break}while(0);do if(11==_){if((0|e)==-1)var p=Ca(a),E=p;else var E=e;var E,A=ja(a),g=E+1|0,y=Wr(r,g),t=(i+4|0)>>2,v=(i+16|0)>>2,m=(Se[t]<<2)+Se[v]|0;Se[m>>2]=y;var S=Se[Se[v]+(Se[t]<<2)>>2];if(0==(0|S)){Xa(0|He.__str72242,233,0|He.___func___str_array_push,0|He.__str117287);var M=Se[Se[v]+(Se[t]<<2)>>2]}else var M=S;var M;Pa(M,A,E,1),va(A),Ae[Se[Se[v]+(Se[t]<<2)>>2]+g|0]=0;var C=Se[t]+1|0;Se[t]=C;var R=i+8|0;if(C>>>0<Me[R>>2]>>>0){var l=1;break}Se[R>>2]=C;var l=1}while(0);var l;return l}function Xr(r,a,e,i,v){var t,f,_=Oe;Oe+=28;var s,n=_,o=_+8;Cr(o);var f=(r+12|0)>>2,l=0==(0|e),t=(0|n)>>2,b=n+4|0;r:do if(l)for(;;){var k=Se[f],u=Ae[k];if(u<<24>>24==0){s=12;break r}if(u<<24>>24==64){var c=k;s=7;break r}var h=Pr(r,n,a,1);if(0==(0|h)){var d=0;s=25;break r}var w=Se[t],p=Se[b>>2],E=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=w,Se[ne+4>>2]=p,ne)),A=Fr(r,E,-1,o);if(0==(0|A)){var d=0;s=25;break r}var g=Se[t],y=Da(g,0|He.__str110280);if(0==(0|y)){s=12;break r}}else for(;;){var m=Se[f],S=Ae[m];if(S<<24>>24==0){s=12;break r}if(S<<24>>24==64){var c=m;s=7;break r}var M=Pr(r,n,a,1);if(0==(0|M)){var d=0;s=25;break r}var C=Se[t],R=Da(C,0|He.__str84254);if(0==(0|R)){s=13;break r}var T=Se[b>>2],O=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=C,Se[ne+4>>2]=T,ne)),N=Fr(r,O,-1,o);if(0==(0|N)){var d=0;s=25;break r}var I=Se[t],P=Da(I,0|He.__str110280);if(0==(0|P)){s=12;break r}}while(0);do if(7==s){var c;Se[f]=c+1|0,s=12;break}while(0);do if(12==s){if(l){s=14;break}s=13;break}while(0);do if(13==s){var D=Se[f],L=D+1|0;if(Se[f]=L,Ae[D]<<24>>24==90){s=14;break}var d=0;s=25;break}while(0);r:do if(14==s){var F=o+4|0,X=Me[F>>2];do{if(0!=(0|X)){if(1==(0|X)){var j=o+16|0,U=Se[Se[j>>2]>>2],x=Da(U,0|He.__str84254);if(0==(0|x)){s=17;break}var z=j;s=20;break}var V=o+16|0;if(X>>>0<=1){var z=V;s=20;break}for(var B=0,H=1;;){var H,B,K=Se[Se[V>>2]+(H<<2)>>2],Y=Dr(r,0|He.__str112282,(ne=Oe,Oe+=8,Se[ne>>2]=B,Se[ne+4>>2]=K,ne)),G=H+1|0;if(G>>>0>=Me[F>>2]>>>0)break;var B=Y,H=G}if(0==(0|Y)){var z=V;s=20;break}var W=Y,Z=Y;s=21;break}s=17}while(0);if(17==s){var Q=i<<24>>24,q=v<<24>>24,$=Dr(r,0|He.__str111281,(ne=Oe,Oe+=8,Se[ne>>2]=Q,Se[ne+4>>2]=q,ne)),d=$;break}if(20==s)var z,W=Se[Se[z>>2]>>2],Z=0;var Z,W,J=v<<24>>24,rr=v<<24>>24==62;do if(rr){var ar=Ca(W);if(Ae[W+(ar-1)|0]<<24>>24!=62)break;var er=i<<24>>24,ir=Se[Se[o+16>>2]>>2],vr=Dr(r,0|He.__str113283,(ne=Oe,Oe+=16,Se[ne>>2]=er,Se[ne+4>>2]=ir,Se[ne+8>>2]=Z,Se[ne+12>>2]=J,ne)),d=vr;break r}while(0);var tr=i<<24>>24,fr=Se[Se[o+16>>2]>>2],_r=Dr(r,0|He.__str114284,(ne=Oe,Oe+=16,Se[ne>>2]=tr,Se[ne+4>>2]=fr,Se[ne+8>>2]=Z,Se[ne+12>>2]=J,ne)),d=_r}while(0);var d;return Oe=_,d}function jr(r){var a,e=Oe;Oe+=20;var i=e,v=r+24|0,t=Se[v>>2],a=(r+20|0)>>2,f=Se[a],_=r+44|0,s=Se[_>>2];Se[a]=t;var n=Kr(r);if(0==(0|n))var o=0;else{Cr(i);var l=Xr(r,i,0,60,62);if(0==(0|l))var b=n;else var k=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=n,Se[ne+4>>2]=l,ne)),b=k;var b;Se[v>>2]=t,Se[a]=f,Se[_>>2]=s;var o=b}var o;return Oe=e,o}function Ur(r,a,e,i){var v,t=a>>2;Se[e>>2]=0,Se[t]=0;var f=0==(18&i|0);do{if(f){var _=r<<24>>24,s=1==((_-65)%2|0);if(0==(1&i|0)){if(s?Se[e>>2]=0|He.__str95265:v=14,65==(0|_)||66==(0|_)){Se[t]=0|He.__str96266,v=21;break}if(67==(0|_)||68==(0|_)){Se[t]=0|He.__str97267,v=21;break}if(69==(0|_)||70==(0|_)){Se[t]=0|He.__str98268,v=21;break}if(71==(0|_)||72==(0|_)){Se[t]=0|He.__str99269,v=21;break}if(73==(0|_)||74==(0|_)){Se[t]=0|He.__str100270,v=21;break}if(75==(0|_)||76==(0|_)){v=21;break}if(77==(0|_)){Se[t]=0|He.__str101271,v=21;break}var n=0;v=22;break}if(s?Se[e>>2]=0|He.__str88258:v=5,65==(0|_)||66==(0|_)){Se[t]=0|He.__str89259,v=21;break}if(67==(0|_)||68==(0|_)){Se[t]=0|He.__str90260,v=21;break}if(69==(0|_)||70==(0|_)){Se[t]=0|He.__str91261,v=21;break}if(71==(0|_)||72==(0|_)){Se[t]=0|He.__str92262,v=21;break}if(73==(0|_)||74==(0|_)){Se[t]=0|He.__str93263,v=21;break}if(75==(0|_)||76==(0|_)){v=21;break}if(77==(0|_)){Se[t]=0|He.__str94264,v=21;break}var n=0;v=22;break}v=21}while(0);if(21==v)var n=1;var n;return n}function xr(r,a,e){var i;Se[e>>2]=0;var i=(r+12|0)>>2,v=Se[i];if(Ae[v]<<24>>24==69){Se[e>>2]=0|He.__str102272;var t=Se[i]+1|0;Se[i]=t;var f=t}else var f=v;var f;Se[i]=f+1|0;var _=Ae[f]<<24>>24;if(65==(0|_)){Se[a>>2]=0;var s=1}else if(66==(0|_)){Se[a>>2]=0|He.__str103273;var s=1}else if(67==(0|_)){Se[a>>2]=0|He.__str104274;var s=1}else if(68==(0|_)){Se[a>>2]=0|He.__str105275;var s=1}else var s=0;var s;return s}function zr(r){var a,e,a=(r+12|0)>>2,i=r+40|0,v=r+20|0,t=0|i,f=r+44|0,_=r+48|0,s=r+52|0,n=r+56|0,o=r+20|0,l=r+24|0,b=r+16|0,k=0;r:for(;;){var k,u=Se[a],c=Ae[u];if(c<<24>>24==64){var h=u+1|0;Se[a]=h;var d=1;break}var w=c<<24>>24;do{if(0==(0|w)){var d=0;break r}if(48==(0|w)||49==(0|w)||50==(0|w)||51==(0|w)||52==(0|w)||53==(0|w)||54==(0|w)||55==(0|w)||56==(0|w)||57==(0|w)){var p=u+1|0;Se[a]=p;var E=(Ae[u]<<24>>24)-48|0,A=Yr(v,E),g=A;e=14;break}if(63==(0|w)){var y=u+1|0;Se[a]=y;var m=Ae[y]<<24>>24;if(36==(0|m)){var S=u+2|0;Se[a]=S;var M=jr(r);if(0==(0|M)){var d=0;break r}var C=Fr(r,M,-1,v);if(0==(0|C)){var d=0;break r}var R=M;e=15;break}if(63==(0|m)){var T=Se[t>>2],O=Se[f>>2],N=Se[_>>2],I=Se[s>>2],P=Se[n>>2],D=Se[o>>2],L=Se[l>>2];Cr(i);var F=Ir(r);if(0==(0|F))var X=k;else var j=Se[b>>2],U=Dr(r,0|He.__str109279,(ne=Oe,Oe+=4,Se[ne>>2]=j,ne)),X=U;var X;Se[o>>2]=D,Se[l>>2]=L,Se[t>>2]=T,Se[f>>2]=O,Se[_>>2]=N,Se[s>>2]=I,Se[n>>2]=P;var g=X;e=14;break}var x=Lr(r);if(0==(0|x)){var d=0;break r}var z=Dr(r,0|He.__str109279,(ne=Oe,Oe+=4,Se[ne>>2]=x,ne)),g=z;e=14;break}var V=Kr(r),g=V;e=14;break}while(0);if(14==e){var g;if(0==(0|g)){var d=0;break}var R=g}var R,B=Fr(r,R,-1,i);if(0==(0|B)){var d=0;break}var k=R}var d;return d}function Vr(r){var a,e,i,v=Oe;Oe+=36;var t,f=v,i=f>>2,_=v+4,s=v+8,e=s>>2,n=v+16;Se[i]=0;var o=0|r,l=Se[o>>2],b=0==(128&l|0),k=r+12|0;do if(b){var u=Ae[Se[k>>2]]<<24>>24;if(48==(0|u))var c=0|He.__str76246,h=k,a=h>>2;else if(49==(0|u))var c=0|He.__str77247,h=k,a=h>>2;else{if(50!=(0|u)){var c=0,h=k,a=h>>2;break}var c=0|He.__str78248,h=k,a=h>>2}}else var c=0,h=k,a=h>>2;while(0);var h,c,d=0==(512&l|0);do if(d){if((Ae[Se[a]]-48&255&255)>=3){var w=0;break}var w=0|He.__str79249}else var w=0;while(0);var w,p=Gr(r,0),E=Se[a],A=E+1|0;Se[a]=A;var g=Ae[E]<<24>>24;do{if(48==(0|g)||49==(0|g)||50==(0|g)||51==(0|g)||52==(0|g)||53==(0|g)){var y=r+44|0,m=Se[y>>2];Cr(n);var S=Pr(r,s,n,0);if(0==(0|S)){var M=0;t=28;break}var C=xr(r,f,_);if(0==(0|C)){var M=0;t=28;break}var R=Se[i],T=0==(0|R),O=Se[_>>2];do if(T)Se[i]=O;else{if(0==(0|O))break;var N=Dr(r,0|He.__str83253,(ne=Oe,Oe+=8,Se[ne>>2]=R,Se[ne+4>>2]=O,ne));Se[i]=N}while(0);Se[y>>2]=m,t=22;break}if(54==(0|g)||55==(0|g)){var I=s+4|0;Se[I>>2]=0,Se[e]=0;var P=xr(r,f,_);if(0==(0|P)){var M=0;t=28;break}if(Ae[Se[a]]<<24>>24==64){t=22;break}var D=qr(r);if(0==(0|D)){var M=0;t=28;break}var L=Dr(r,0|He.__str107277,(ne=Oe,Oe+=4,Se[ne>>2]=D,ne));Se[I>>2]=L,t=22;break}if(56==(0|g)||57==(0|g)){Se[e+1]=0,Se[e]=0,Se[i]=0,t=22;break}var M=0;t=28}while(0);if(22==t){var F=0==(4096&Se[o>>2]|0);do{if(F){var X=Se[e],j=Se[i];if(0==(0|j)){var U=X;t=26;break}var x=0!=(0|X)?0|He.__str87257:0,z=0|He.__str87257,V=j,B=x,H=X;t=27;break}Se[i]=0,Se[e+1]=0,Se[e]=0;var U=0;t=26;break}while(0);if(26==t)var U,K=0!=(0|U)?0|He.__str87257:0,z=K,V=0,B=0,H=U;var H,B,V,z,Y=Se[e+1],G=Dr(r,0|He.__str108278,(ne=Oe,Oe+=32,Se[ne>>2]=c,Se[ne+4>>2]=w,Se[ne+8>>2]=H,Se[ne+12>>2]=B,Se[ne+16>>2]=V,Se[ne+20>>2]=z,Se[ne+24>>2]=p,Se[ne+28>>2]=Y,ne));Se[r+16>>2]=G;var M=1}var M;return Oe=v,M}function Br(r,a){var e,i,v,t,f=Oe;Oe+=44;var _,s=f,t=s>>2,n=f+8,o=f+12,v=o>>2,l=f+16,b=f+20,k=f+40;Se[v]=0;var i=(r+12|0)>>2,u=Se[i],c=u+1|0;Se[i]=c;var h=ge[u],d=h<<24>>24,w=(h-65&255&255)>25;r:do if(w)var p=0;else{var e=(0|r)>>2,E=Me[e],A=0==(128&E|0),g=d-65|0;do if(A){var y=g/8|0;if(0==(0|y))var m=0|He.__str76246,S=g;else if(1==(0|y))var m=0|He.__str77247,S=g;else{if(2!=(0|y)){var m=0,S=g;break}var m=0|He.__str78248,S=g}}else var m=0,S=g;while(0);var S,m,M=0==(512&E|0)&h<<24>>24<89,C=(0|S)%8;do if(M)if(2==(0|C)||3==(0|C))var R=m,T=0|He.__str79249;else if(4==(0|C)||5==(0|C))var R=m,T=0|He.__str80250;else{if(6!=(0|C)&&7!=(0|C)){var R=m,T=0;break}var O=Dr(r,0|He.__str81251,(ne=Oe,Oe+=4,Se[ne>>2]=m,ne)),R=O,T=0|He.__str80250}else var R=m,T=0;while(0);var T,R,N=Gr(r,0),I=6==(0|C);do{if(!I){if(7==((d-56)%8|0)){_=14;break}var P=N;_=15;break}_=14}while(0);if(14==_)var D=Lr(r),L=Dr(r,0|He.__str82252,(ne=Oe,Oe+=8,Se[ne>>2]=N,Se[ne+4>>2]=D,ne)),P=L;var P,F=h<<24>>24>88;do if(F)var X=0;else{if((C-2|0)>>>0<2){var X=0;break}var j=xr(r,o,k);if(0==(0|j)){var p=0;break r}var U=Me[v],x=Se[k>>2];if(0==(0|U)&0==(0|x)){var X=0;break}var z=Dr(r,0|He.__str83253,(ne=Oe,Oe+=8,Se[ne>>2]=U,Se[ne+4>>2]=x,ne));Se[v]=z;var X=z}while(0);var X,V=Se[i],B=V+1|0;Se[i]=B;var H=Ae[V],K=Se[e],Y=Ur(H,n,l,K);if(0==(0|Y)){var p=0;break}Cr(b);var G=Se[i];if(Ae[G]<<24>>24==64){Se[t]=0|He.__str84254,Se[t+1]=0;var W=G+1|0;Se[i]=W}else{var Z=Pr(r,s,b,0);if(0==(0|Z)){var p=0;break}}if(0!=(4&Se[e]|0)&&(Se[t+1]=0,Se[t]=0),0==(0|a))var Q=P;else{var q=0|s,$=Se[q>>2],J=s+4|0,rr=Se[J>>2],ar=Dr(r,0|He.__str85255,(ne=Oe,Oe+=12,Se[ne>>2]=P,Se[ne+4>>2]=$,Se[ne+8>>2]=rr,ne));Se[J>>2]=0,Se[q>>2]=0;var Q=ar}var Q,er=r+44|0,ir=Se[er>>2],vr=Xr(r,b,1,40,41);if(0==(0|vr)){var p=0;break}if(0==(4096&Se[e]|0))var tr=vr,fr=X;else{Se[v]=0;var tr=0,fr=0}var fr,tr;Se[er>>2]=ir;var _r=Se[t],sr=Se[t+1];if(0==(0|_r))var nr=0;else var or=0!=(0|sr)?0:0|He.__str87257,nr=or;var nr,lr=Se[n>>2],br=0!=(0|lr)?0|He.__str87257:0,kr=Se[l>>2],ur=Dr(r,0|He.__str86256,(ne=Oe,Oe+=44,Se[ne>>2]=R,Se[ne+4>>2]=T,Se[ne+8>>2]=_r,Se[ne+12>>2]=nr,Se[ne+16>>2]=lr,Se[ne+20>>2]=br,Se[ne+24>>2]=kr,Se[ne+28>>2]=Q,Se[ne+32>>2]=tr,Se[ne+36>>2]=fr,Se[ne+40>>2]=sr,ne));Se[r+16>>2]=ur;var p=1}while(0);var p;return Oe=f,p}function Hr(r){var a,a=(r+12|0)>>2,e=Se[a];if(Ae[e]<<24>>24==36)var i=e;else{Xa(0|He.__str72242,1252,0|He.___func___handle_template,0|He.__str74244);var i=Se[a]}var i;Se[a]=i+1|0;var v=Kr(r),t=0==(0|v);do if(t)var f=0;else{var _=Xr(r,0,0,60,62);if(0==(0|_)){var f=0;break}var s=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=v,Se[ne+4>>2]=_,ne));Se[r+16>>2]=s;var f=1}while(0);var f;return f}function Kr(r){for(var a,a=(r+12|0)>>2,e=Me[a],i=e,v=Ae[e];;){var v,i;if(!((v-65&255&255)<26|(v-97&255&255)<26|(v-48&255&255)<10)&&v<<24>>24!=95&&v<<24>>24!=36){var t=0;break}var f=i+1|0;Se[a]=f;var _=ge[f];if(_<<24>>24==64){Se[a]=i+2|0;var s=f-e|0,n=r+20|0,o=Fr(r,e,s,n);if(0==(0|o)){var t=0;break}var l=Se[r+24>>2]-1-Se[n>>2]|0,b=Yr(n,l),t=b;break}var i=f,v=_}var t;return t}function Yr(r,a){0==(0|r)&&Xa(0|He.__str72242,263,0|He.___func___str_array_get_ref,0|He.__str75245);var e=Se[r>>2]+a|0;if(e>>>0<Me[r+8>>2]>>>0)var i=Se[Se[r+16>>2]+(e<<2)>>2];else var i=0;var i;return i}function Gr(r,a){var e,e=(r+44|0)>>2,i=Me[e];if(i>>>0>a>>>0){for(var v=r+56|0,t=a,f=0,_=Se[v>>2],s=i;;){var s,_,f,t,n=Me[_+(t<<2)>>2];if(0==(0|n)){Xa(0|He.__str72242,680,0|He.___func___get_class_string,0|He.__str106276);var o=Se[v>>2],l=o,b=Se[o+(t<<2)>>2],k=Se[e]}else var l=_,b=n,k=s;var k,b,l,u=Ca(b),c=u+(f+2)|0,h=t+1|0;if(h>>>0>=k>>>0)break;var t=h,f=c,_=l,s=k}var d=c-1|0}else var d=-1;var d,w=Wr(r,d);if(0==(0|w))var p=0;else{var E=Se[e]-1|0,A=(0|E)<(0|a);r:do if(A)var g=0;else for(var y=r+56|0,m=0,S=E;;){var S,m,M=Se[Se[y>>2]+(S<<2)>>2],C=Ca(M),R=w+m|0;Pa(R,M,C,1);var T=C+m|0;if((0|S)>(0|a)){var O=T+1|0;Ae[w+T|0]=58;var N=T+2|0;Ae[w+O|0]=58;var I=N}else var I=T;var I,P=S-1|0;if((0|P)<(0|a)){var g=I;break r}var m=I,S=P}while(0);var g;Ae[w+g|0]=0;var p=w}var p;return p}function Wr(r,a){var e,i=a>>>0>1020;do if(i){var v=Se[r+4>>2],t=a+4|0,f=pe[v](t);if(0==(0|f)){var _=0;break}var s=r+60|0,n=Se[s>>2],o=f;Se[o>>2]=n,Se[s>>2]=f,Se[r+64>>2]=0;var _=f+4|0}else{var e=(r+64|0)>>2,l=Me[e];if(l>>>0<a>>>0){var b=Se[r+4>>2],k=pe[b](1024);if(0==(0|k)){var _=0;break}var u=r+60|0,c=Se[u>>2],h=k;Se[h>>2]=c,Se[u>>2]=k,Se[e]=1020;var d=1020,w=k}else var d=l,w=Se[r+60>>2];var w,d;Se[e]=d-a|0;var _=w+(1024-d)|0}while(0);var _;return _}function Zr(r){var a=r<<24>>24;if(68==(0|a))var e=0|He.__str157327;else if(69==(0|a))var e=0|He.__str158328;else if(70==(0|a))var e=0|He.__str159329;else if(71==(0|a))var e=0|He.__str160330;else if(72==(0|a))var e=0|He.__str161331;else if(73==(0|a))var e=0|He.__str162332;else if(74==(0|a))var e=0|He.__str163333;else if(75==(0|a))var e=0|He.__str164334;else if(76==(0|a))var e=0|He.__str165335;else if(77==(0|a))var e=0|He.__str166336;else if(78==(0|a))var e=0|He.__str167337;else if(87==(0|a))var e=0|He.__str168338;else var e=0;var e;return e}function Qr(r){var a=r<<24>>24;if(67==(0|a))var e=0|He.__str145315;else if(68==(0|a))var e=0|He.__str146316;else if(69==(0|a))var e=0|He.__str147317;else if(70==(0|a))var e=0|He.__str148318;else if(71==(0|a))var e=0|He.__str149319;else if(72==(0|a))var e=0|He.__str150320;else if(73==(0|a))var e=0|He.__str151321;else if(74==(0|a))var e=0|He.__str152322;else if(75==(0|a))var e=0|He.__str153323;else if(77==(0|a))var e=0|He.__str154324;else if(78==(0|a))var e=0|He.__str155325;else if(79==(0|a))var e=0|He.__str156326;else if(88==(0|a))var e=0|He.__str84254;else if(90==(0|a))var e=0|He.__str110280;else var e=0;var e;return e}function qr(r){var a=r+44|0,e=Se[a>>2],i=zr(r);if(0==(0|i))var v=0;else var t=Gr(r,e),v=t;var v;return Se[a>>2]=e,v}function $r(r,a,e,i,v){var t,f,_,s=Oe;Oe+=16;var n,o=s,_=o>>2,l=s+4,b=s+8,f=b>>2;Se[l>>2]=0|ii;var t=(a+12|0)>>2,k=Se[t];if(Ae[k]<<24>>24==69){Se[l>>2]=0|He.__str134304;var u=k+1|0;Se[t]=u;var c=0|He.__str134304}else var c=0|ii;var c,h=i<<24>>24;do{if(65==(0|h)){var d=Dr(a,0|He.__str135305,(ne=Oe,Oe+=4,Se[ne>>2]=c,ne)),w=d;n=10;break}if(66==(0|h)){var p=Dr(a,0|He.__str136306,(ne=Oe,Oe+=4,Se[ne>>2]=c,ne)),w=p;n=10;break}if(80==(0|h)){var E=Dr(a,0|He.__str137307,(ne=Oe,Oe+=4,Se[ne>>2]=c,ne)),w=E;n=10;break}if(81==(0|h)){var A=Dr(a,0|He.__str138308,(ne=Oe,Oe+=4,Se[ne>>2]=c,ne)),w=A;n=10;break}if(82==(0|h)){var g=Dr(a,0|He.__str139309,(ne=Oe,Oe+=4,Se[ne>>2]=c,ne)),w=g;n=10;break}if(83==(0|h)){var y=Dr(a,0|He.__str140310,(ne=Oe,Oe+=4,Se[ne>>2]=c,ne)),w=y;n=10;break}if(63==(0|h)){var w=0|ii;n=10}else n=31}while(0);r:do if(10==n){var w,m=xr(a,o,l);if(0==(0|m))break;var S=a+44|0,M=Se[S>>2],C=Se[t],R=Ae[C]<<24>>24==89;a:do if(R){var T=C+1|0;Se[t]=T;var O=Lr(a);if(0==(0|O))break r;var N=Ha(O),I=Ae[w]<<24>>24==32,P=Se[_],D=0==(0|P);do{if(I){if(!D){n=17;break}var L=w+1|0;n=18;break}if(D){var L=w;n=18;break}n=17;break}while(0);if(17==n){var F=Dr(a,0|He.__str141311,(ne=Oe,Oe+=8,Se[ne>>2]=P,Se[ne+4>>2]=w,ne));Se[_]=0;var X=F}else if(18==n)var L,j=Dr(a,0|He.__str142312,(ne=Oe,Oe+=4,Se[ne>>2]=L,ne)),X=j;var X;if(0==(0|N)){var U=X;break}for(var x=X,z=N;;){var z,x,V=z-1|0,B=Lr(a),H=Dr(a,0|He.__str143313,(ne=Oe,Oe+=8,Se[ne>>2]=x,Se[ne+4>>2]=B,ne));if(0==(0|V)){var U=H;break a}var x=H,z=V}}else var U=w;while(0);var U,K=Pr(a,b,e,0);if(0==(0|K))break;var Y=Se[_];if(0==(0|Y)){var G=0==(0|v);do if(G){if(Ae[U]<<24>>24==0){var W=U;break}var Z=U+1|0;if(Ae[Z]<<24>>24!=42){var W=U;break}var Q=Se[f],q=Ca(Q);if(Ae[Q+(q-1)|0]<<24>>24!=42){var W=U;break}var W=Z}else var W=U;while(0);var W,$=Se[f],J=Dr(a,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=$,Se[ne+4>>2]=W,ne));Se[r>>2]=J}else{var rr=Se[f],ar=Dr(a,0|He.__str144314,(ne=Oe,Oe+=12,Se[ne>>2]=rr,Se[ne+4>>2]=Y,Se[ne+8>>2]=U,ne));Se[r>>2]=ar}var er=Se[f+1];Se[r+4>>2]=er,Se[S>>2]=M}while(0);Oe=s}function Jr(r){var a,e=r>>>0<245;do{if(e){if(r>>>0<11)var i=16;else var i=r+11&-8;var i,v=i>>>3,t=Me[vi>>2],f=t>>>(v>>>0);if(0!=(3&f|0)){var _=(1&f^1)+v|0,s=_<<1,n=(s<<2)+vi+40|0,o=(s+2<<2)+vi+40|0,l=Me[o>>2],b=l+8|0,k=Me[b>>2];if((0|n)==(0|k))Se[vi>>2]=t&(1<<_^-1);else{if(k>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[o>>2]=k,Se[k+12>>2]=n}var u=_<<3;Se[l+4>>2]=3|u;var c=l+(4|u)|0,h=1|Se[c>>2];Se[c>>2]=h;var d=b;a=38;break}if(i>>>0<=Me[vi+8>>2]>>>0){var w=i;a=30;break}if(0!=(0|f)){var p=2<<v,E=f<<v&(p|-p),A=(E&-E)-1|0,g=A>>>12&16,y=A>>>(g>>>0),m=y>>>5&8,S=y>>>(m>>>0),M=S>>>2&4,C=S>>>(M>>>0),R=C>>>1&2,T=C>>>(R>>>0),O=T>>>1&1,N=(m|g|M|R|O)+(T>>>(O>>>0))|0,I=N<<1,P=(I<<2)+vi+40|0,D=(I+2<<2)+vi+40|0,L=Me[D>>2],F=L+8|0,X=Me[F>>2];if((0|P)==(0|X))Se[vi>>2]=t&(1<<N^-1);else{if(X>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[D>>2]=X,Se[X+12>>2]=P}var j=N<<3,U=j-i|0;Se[L+4>>2]=3|i;var x=L,z=x+i|0;Se[x+(4|i)>>2]=1|U,Se[x+j>>2]=U;var V=Me[vi+8>>2];if(0!=(0|V)){var B=Se[vi+20>>2],H=V>>>2&1073741822,K=(H<<2)+vi+40|0,Y=Me[vi>>2],G=1<<(V>>>3),W=0==(Y&G|0);do{if(!W){var Z=(H+2<<2)+vi+40|0,Q=Me[Z>>2];if(Q>>>0>=Me[vi+16>>2]>>>0){var q=Q,$=Z;break}throw Ka(),\"Reached an unreachable!\"}Se[vi>>2]=Y|G;var q=K,$=(H+2<<2)+vi+40|0}while(0);var $,q;Se[$>>2]=B,Se[q+12>>2]=B;var J=B+8|0;Se[J>>2]=q;var rr=B+12|0;Se[rr>>2]=K}Se[vi+8>>2]=U,Se[vi+20>>2]=z;var d=F;a=38;break}if(0==(0|Se[vi+4>>2])){var w=i;a=30;break}var ar=ra(i);if(0==(0|ar)){var w=i;a=30;break}var d=ar;a=38;break}if(r>>>0>4294967231){var w=-1;a=30;break}var er=r+11&-8;if(0==(0|Se[vi+4>>2])){var w=er;a=30;break}var ir=ea(er);if(0==(0|ir)){var w=er;a=30;break}var d=ir;a=38;break}while(0);if(30==a){var w,vr=Me[vi+8>>2];if(w>>>0>vr>>>0){var tr=Me[vi+12>>2];if(w>>>0<tr>>>0){var fr=tr-w|0;Se[vi+12>>2]=fr;var _r=Me[vi+24>>2],sr=_r;Se[vi+24>>2]=sr+w|0,Se[w+(sr+4)>>2]=1|fr,Se[_r+4>>2]=3|w;var d=_r+8|0}else var nr=aa(w),d=nr}else{var or=vr-w|0,lr=Me[vi+20>>2];if(or>>>0>15){var br=lr;Se[vi+20>>2]=br+w|0,Se[vi+8>>2]=or,Se[w+(br+4)>>2]=1|or,Se[br+vr>>2]=or,Se[lr+4>>2]=3|w}else{Se[vi+8>>2]=0,Se[vi+20>>2]=0,Se[lr+4>>2]=3|vr;var kr=vr+(lr+4)|0,ur=1|Se[kr>>2];Se[kr>>2]=ur}var d=lr+8|0}}var d;return d}function ra(r){var a,e,i,v=Se[vi+4>>2],t=(v&-v)-1|0,f=t>>>12&16,_=t>>>(f>>>0),s=_>>>5&8,n=_>>>(s>>>0),o=n>>>2&4,l=n>>>(o>>>0),b=l>>>1&2,k=l>>>(b>>>0),u=k>>>1&1,c=Me[vi+((s|f|o|b|u)+(k>>>(u>>>0))<<2)+304>>2],h=c,e=h>>2,d=(Se[c+4>>2]&-8)-r|0;r:for(;;)for(var d,h,w=h;;){var w,p=Se[w+16>>2];if(0==(0|p)){var E=Se[w+20>>2];if(0==(0|E))break r;var A=E}else var A=p;var A,g=(Se[A+4>>2]&-8)-r|0;if(g>>>0<d>>>0){var h=A,e=h>>2,d=g;continue r}var w=A}var y=h,m=Me[vi+16>>2],S=y>>>0<m>>>0;do if(!S){var M=y+r|0,C=M;if(y>>>0>=M>>>0)break;var R=Me[e+6],T=Me[e+3],O=(0|T)==(0|h);do if(O){var N=h+20|0,I=Se[N>>2];if(0==(0|I)){var P=h+16|0,D=Se[P>>2];if(0==(0|D)){var L=0,a=L>>2;break}var F=P,X=D}else{var F=N,X=I;i=14}for(;;){var X,F,j=X+20|0,U=Se[j>>2];if(0==(0|U)){var x=X+16|0,z=Me[x>>2];if(0==(0|z))break;var F=x,X=z}else var F=j,X=U}if(F>>>0<m>>>0)throw Ka(),\"Reached an unreachable!\";Se[F>>2]=0;var L=X,a=L>>2}else{var V=Me[e+2];if(V>>>0<m>>>0)throw Ka(),\"Reached an unreachable!\";Se[V+12>>2]=T,Se[T+8>>2]=V;var L=T,a=L>>2}while(0);var L,B=0==(0|R);r:do if(!B){var H=h+28|0,K=(Se[H>>2]<<2)+vi+304|0,Y=(0|h)==(0|Se[K>>2]);do{if(Y){if(Se[K>>2]=L,0!=(0|L))break;var G=Se[vi+4>>2]&(1<<Se[H>>2]^-1);Se[vi+4>>2]=G;break r}if(R>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";var W=R+16|0;if((0|Se[W>>2])==(0|h)?Se[W>>2]=L:Se[R+20>>2]=L,0==(0|L))break r}while(0);if(L>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+6]=R;var Z=Me[e+4];if(0!=(0|Z)){if(Z>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+4]=Z,Se[Z+24>>2]=L}var Q=Me[e+5];if(0==(0|Q))break;if(Q>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+5]=Q,Se[Q+24>>2]=L}while(0);if(d>>>0<16){var q=d+r|0;Se[e+1]=3|q;var $=q+(y+4)|0,J=1|Se[$>>2];Se[$>>2]=J}else{Se[e+1]=3|r,Se[r+(y+4)>>2]=1|d,Se[y+d+r>>2]=d;var rr=Me[vi+8>>2];if(0!=(0|rr)){var ar=Me[vi+20>>2],er=rr>>>2&1073741822,ir=(er<<2)+vi+40|0,vr=Me[vi>>2],tr=1<<(rr>>>3),fr=0==(vr&tr|0);do{if(!fr){var _r=(er+2<<2)+vi+40|0,sr=Me[_r>>2];if(sr>>>0>=Me[vi+16>>2]>>>0){var nr=sr,or=_r;break}throw Ka(),\"Reached an unreachable!\"}Se[vi>>2]=vr|tr;var nr=ir,or=(er+2<<2)+vi+40|0}while(0);var or,nr;Se[or>>2]=ar,Se[nr+12>>2]=ar,Se[ar+8>>2]=nr,Se[ar+12>>2]=ir}Se[vi+8>>2]=d,Se[vi+20>>2]=C}return h+8|0}while(0);throw Ka(),\"Reached an unreachable!\"}function aa(r){var a,e;0==(0|Se[ti>>2])&&ba();var i=0==(4&Se[vi+440>>2]|0);do{if(i){var v=Se[vi+24>>2],t=0==(0|v);do{if(!t){var f=v,_=ua(f);if(0==(0|_)){e=6;break}var s=Se[ti+8>>2],n=r+47-Se[vi+12>>2]+s&-s;if(n>>>0>=2147483647){e=14;break}var o=re(n);if((0|o)==(Se[_>>2]+Se[_+4>>2]|0)){var l=o,b=n,k=o;e=13;break}var u=o,c=n;e=15;break}e=6}while(0);do if(6==e){var h=re(0);if((0|h)==-1){e=14;break}var d=Se[ti+8>>2],w=d+(r+47)&-d,p=h,E=Se[ti+4>>2],A=E-1|0;if(0==(A&p|0))var g=w;else var g=w-p+(A+p&-E)|0;var g;if(g>>>0>=2147483647){e=14;break}var y=re(g);if((0|y)==(0|h)){var l=h,b=g,k=y;e=13;break}var u=y,c=g;e=15;break}while(0);if(13==e){var k,b,l;if((0|l)!=-1){var m=b,S=l;e=26;break}var u=k,c=b}else if(14==e){var M=4|Se[vi+440>>2];Se[vi+440>>2]=M,e=23;break}var c,u,C=0|-c,R=(0|u)!=-1&c>>>0<2147483647;do{if(R){if(c>>>0>=(r+48|0)>>>0){var T=c;e=21;break}var O=Se[ti+8>>2],N=r+47-c+O&-O;if(N>>>0>=2147483647){var T=c;e=21;break}var I=re(N);if((0|I)==-1){re(C);e=22;break}var T=N+c|0;e=21;break}var T=c;e=21}while(0);if(21==e){var T;if((0|u)!=-1){var m=T,S=u;e=26;break}}var P=4|Se[vi+440>>2];Se[vi+440>>2]=P,e=23;break}e=23}while(0);do if(23==e){var D=Se[ti+8>>2],L=D+(r+47)&-D;if(L>>>0>=2147483647){e=49;break}var F=re(L),X=re(0);if(!((0|X)!=-1&(0|F)!=-1&F>>>0<X>>>0)){e=49;break}var j=X-F|0;if(j>>>0<=(r+40|0)>>>0|(0|F)==-1){e=49;break}var m=j,S=F;e=26;break}while(0);r:do if(26==e){var S,m,U=Se[vi+432>>2]+m|0;Se[vi+432>>2]=U,U>>>0>Me[vi+436>>2]>>>0&&(Se[vi+436>>2]=U);var x=Me[vi+24>>2],z=0==(0|x);a:do if(z){var V=Me[vi+16>>2];0==(0|V)|S>>>0<V>>>0&&(Se[vi+16>>2]=S),Se[vi+444>>2]=S,Se[vi+448>>2]=m,Se[vi+456>>2]=0;var B=Se[ti>>2];Se[vi+36>>2]=B,Se[vi+32>>2]=-1,ha(),ca(S,m-40|0)}else{for(var H=vi+444|0,a=H>>2;;){var H;if(0==(0|H))break;var K=Me[a],Y=H+4|0,G=Me[Y>>2],W=K+G|0;if((0|S)==(0|W)){if(0!=(8&Se[a+3]|0))break;var Z=x;if(!(Z>>>0>=K>>>0&Z>>>0<W>>>0))break;Se[Y>>2]=G+m|0;var Q=Se[vi+24>>2],q=Se[vi+12>>2]+m|0;ca(Q,q);break a}var H=Se[a+2],a=H>>2}S>>>0<Me[vi+16>>2]>>>0&&(Se[vi+16>>2]=S);for(var $=S+m|0,J=vi+444|0;;){var J;if(0==(0|J))break;var rr=0|J,ar=Me[rr>>2];if((0|ar)==(0|$)){if(0!=(8&Se[J+12>>2]|0))break;Se[rr>>2]=S;var er=J+4|0,ir=Se[er>>2]+m|0;Se[er>>2]=ir;var vr=da(S,ar,r),tr=vr;e=50;break r}var J=Se[J+8>>2]}Ma(S,m)}while(0);var fr=Me[vi+12>>2];if(fr>>>0<=r>>>0){e=49;break}var _r=fr-r|0;Se[vi+12>>2]=_r;var sr=Me[vi+24>>2],nr=sr;Se[vi+24>>2]=nr+r|0,Se[r+(nr+4)>>2]=1|_r,Se[sr+4>>2]=3|r;var tr=sr+8|0;e=50;break}while(0);if(49==e){var or=Je();Se[or>>2]=12;var tr=0}var tr;return tr}function ea(r){var a,e,i,v,t,f,_=r>>2,s=0|-r,n=r>>>8,o=0==(0|n);do if(o)var l=0;else{if(r>>>0>16777215){var l=31;break}var b=(n+1048320|0)>>>16&8,k=n<<b,u=(k+520192|0)>>>16&4,c=k<<u,h=(c+245760|0)>>>16&2,d=14-(u|b|h)+(c<<h>>>15)|0,l=r>>>((d+7|0)>>>0)&1|d<<1}while(0);var l,w=Me[vi+(l<<2)+304>>2],p=0==(0|w);r:do if(p)var E=0,A=s,g=0;else{if(31==(0|l))var y=0;else var y=25-(l>>>1)|0;for(var y,m=0,S=s,M=w,t=M>>2,C=r<<y,R=0;;){var R,C,M,S,m,T=Se[t+1]&-8,O=T-r|0;if(O>>>0<S>>>0){if((0|T)==(0|r)){var E=M,A=O,g=M;break r}var N=M,I=O}else var N=m,I=S;var I,N,P=Me[t+5],D=Me[((C>>>31<<2)+16>>2)+t],L=0==(0|P)|(0|P)==(0|D)?R:P;if(0==(0|D)){var E=N,A=I,g=L;break r}var m=N,S=I,M=D,t=M>>2,C=C<<1,R=L}}while(0);var g,A,E,F=0==(0|g)&0==(0|E);do if(F){var X=2<<l,j=Se[vi+4>>2]&(X|-X);if(0==(0|j)){var U=g;break}var x=(j&-j)-1|0,z=x>>>12&16,V=x>>>(z>>>0),B=V>>>5&8,H=V>>>(B>>>0),K=H>>>2&4,Y=H>>>(K>>>0),G=Y>>>1&2,W=Y>>>(G>>>0),Z=W>>>1&1,U=Se[vi+((B|z|K|G|Z)+(W>>>(Z>>>0))<<2)+304>>2]}else var U=g;while(0);var U,Q=0==(0|U);r:do if(Q)var q=A,$=E,v=$>>2;else for(var J=U,i=J>>2,rr=A,ar=E;;){var ar,rr,J,er=(Se[i+1]&-8)-r|0,ir=er>>>0<rr>>>0,vr=ir?er:rr,tr=ir?J:ar,fr=Me[i+4];if(0==(0|fr)){var _r=Me[i+5];if(0==(0|_r)){var q=vr,$=tr,v=$>>2;break r}var J=_r,i=J>>2,rr=vr,ar=tr}else var J=fr,i=J>>2,rr=vr,ar=tr}while(0);var $,q,sr=0==(0|$);r:do{if(!sr){if(q>>>0>=(Se[vi+8>>2]-r|0)>>>0){var nr=0;break}var or=$,e=or>>2,lr=Me[vi+16>>2],br=or>>>0<lr>>>0;do if(!br){var kr=or+r|0,ur=kr;if(or>>>0>=kr>>>0)break;var cr=Me[v+6],hr=Me[v+3],dr=(0|hr)==(0|$);do if(dr){var wr=$+20|0,pr=Se[wr>>2];if(0==(0|pr)){var Er=$+16|0,Ar=Se[Er>>2];if(0==(0|Ar)){var gr=0,a=gr>>2;break}var yr=Er,mr=Ar}else{var yr=wr,mr=pr;f=28}for(;;){var mr,yr,Sr=mr+20|0,Mr=Se[Sr>>2];if(0==(0|Mr)){var Cr=mr+16|0,Rr=Me[Cr>>2];if(0==(0|Rr))break;var yr=Cr,mr=Rr}else var yr=Sr,mr=Mr}if(yr>>>0<lr>>>0)throw Ka(),\"Reached an unreachable!\";Se[yr>>2]=0;var gr=mr,a=gr>>2}else{var Tr=Me[v+2];if(Tr>>>0<lr>>>0)throw Ka(),\"Reached an unreachable!\";Se[Tr+12>>2]=hr,Se[hr+8>>2]=Tr;var gr=hr,a=gr>>2}while(0);var gr,Or=0==(0|cr);a:do if(!Or){var Nr=$+28|0,Ir=(Se[Nr>>2]<<2)+vi+304|0,Pr=(0|$)==(0|Se[Ir>>2]);do{if(Pr){if(Se[Ir>>2]=gr,0!=(0|gr))break;var Dr=Se[vi+4>>2]&(1<<Se[Nr>>2]^-1);Se[vi+4>>2]=Dr;break a}if(cr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";var Lr=cr+16|0;if((0|Se[Lr>>2])==(0|$)?Se[Lr>>2]=gr:Se[cr+20>>2]=gr,0==(0|gr))break a}while(0);if(gr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+6]=cr;var Fr=Me[v+4];if(0!=(0|Fr)){if(Fr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+4]=Fr,Se[Fr+24>>2]=gr}var Xr=Me[v+5];if(0==(0|Xr))break;if(Xr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+5]=Xr,Se[Xr+24>>2]=gr}while(0);var jr=q>>>0<16;a:do if(jr){var Ur=q+r|0;Se[v+1]=3|Ur;var xr=Ur+(or+4)|0,zr=1|Se[xr>>2];Se[xr>>2]=zr}else if(Se[v+1]=3|r,Se[_+(e+1)]=1|q,Se[(q>>2)+e+_]=q,q>>>0<256){var Vr=q>>>2&1073741822,Br=(Vr<<2)+vi+40|0,Hr=Me[vi>>2],Kr=1<<(q>>>3),Yr=0==(Hr&Kr|0);do{if(!Yr){var Gr=(Vr+2<<2)+vi+40|0,Wr=Me[Gr>>2];if(Wr>>>0>=Me[vi+16>>2]>>>0){var Zr=Wr,Qr=Gr;break}throw Ka(),\"Reached an unreachable!\"}Se[vi>>2]=Hr|Kr;var Zr=Br,Qr=(Vr+2<<2)+vi+40|0}while(0);var Qr,Zr;Se[Qr>>2]=ur,Se[Zr+12>>2]=ur,Se[_+(e+2)]=Zr,Se[_+(e+3)]=Br}else{var qr=kr,$r=q>>>8,Jr=0==(0|$r);do if(Jr)var ra=0;else{if(q>>>0>16777215){var ra=31;break}var aa=($r+1048320|0)>>>16&8,ea=$r<<aa,ia=(ea+520192|0)>>>16&4,va=ea<<ia,ta=(va+245760|0)>>>16&2,fa=14-(ia|aa|ta)+(va<<ta>>>15)|0,ra=q>>>((fa+7|0)>>>0)&1|fa<<1}while(0);var ra,_a=(ra<<2)+vi+304|0;Se[_+(e+7)]=ra;var sa=r+(or+16)|0;Se[_+(e+5)]=0,Se[sa>>2]=0;var na=Se[vi+4>>2],oa=1<<ra;if(0==(na&oa|0)){var la=na|oa;Se[vi+4>>2]=la,Se[_a>>2]=qr,Se[_+(e+6)]=_a,Se[_+(e+3)]=qr,Se[_+(e+2)]=qr}else{if(31==(0|ra))var ba=0;else var ba=25-(ra>>>1)|0;for(var ba,ka=q<<ba,ua=Se[_a>>2];;){var ua,ka;if((Se[ua+4>>2]&-8|0)==(0|q)){var ca=ua+8|0,ha=Me[ca>>2],da=Me[vi+16>>2],wa=ua>>>0<da>>>0;do if(!wa){if(ha>>>0<da>>>0)break;Se[ha+12>>2]=qr,Se[ca>>2]=qr,Se[_+(e+2)]=ha,Se[_+(e+3)]=ua,Se[_+(e+6)]=0;break a}while(0);throw Ka(),\"Reached an unreachable!\"}var pa=(ka>>>31<<2)+ua+16|0,Ea=Me[pa>>2];if(0==(0|Ea)){if(pa>>>0>=Me[vi+16>>2]>>>0){Se[pa>>2]=qr,Se[_+(e+6)]=ua,Se[_+(e+3)]=qr,Se[_+(e+2)]=qr;break a}throw Ka(),\"Reached an unreachable!\"}var ka=ka<<1,ua=Ea}}}while(0);var nr=$+8|0;break r}while(0);throw Ka(),\"Reached an unreachable!\"}var nr=0}while(0);var nr;return nr}function ia(r){var a;0==(0|Se[ti>>2])&&ba();var e=r>>>0<4294967232;r:do if(e){var i=Me[vi+24>>2];if(0==(0|i)){var v=0;break}var t=Me[vi+12>>2],f=t>>>0>(r+40|0)>>>0;do if(f){var _=Me[ti+8>>2],s=-40-r-1+t+_|0,n=Math.floor((s>>>0)/(_>>>0)),o=(n-1)*_|0,l=i,b=ua(l);if(0!=(8&Se[b+12>>2]|0))break;var k=re(0),a=(b+4|0)>>2;if((0|k)!=(Se[b>>2]+Se[a]|0))break;var u=o>>>0>2147483646?-2147483648-_|0:o,c=0|-u,h=re(c),d=re(0);if(!((0|h)!=-1&d>>>0<k>>>0))break;var w=k-d|0;if((0|k)==(0|d))break;var p=Se[a]-w|0;Se[a]=p;var E=Se[vi+432>>2]-w|0;Se[vi+432>>2]=E;var A=Se[vi+24>>2],g=Se[vi+12>>2]-w|0;ca(A,g);var v=(0|k)!=(0|d);break r}while(0);if(Me[vi+12>>2]>>>0<=Me[vi+28>>2]>>>0){var v=0;break}Se[vi+28>>2]=-1;var v=0}else var v=0;while(0);var v;return 1&v}function va(r){var a,e,i,v,t,f,_,s=r>>2,n=0==(0|r);r:do if(!n){var o=r-8|0,l=o,b=Me[vi+16>>2],k=o>>>0<b>>>0;a:do if(!k){var u=Me[r-4>>2],c=3&u;if(1==(0|c))break;var h=u&-8,f=h>>2,d=r+(h-8)|0,w=d,p=0==(1&u|0);e:do if(p){var E=Me[o>>2];if(0==(0|c))break r;var A=-8-E|0,t=A>>2,g=r+A|0,y=g,m=E+h|0;if(g>>>0<b>>>0)break a;if((0|y)==(0|Se[vi+20>>2])){var v=(r+(h-4)|0)>>2;if(3!=(3&Se[v]|0)){var S=y,i=S>>2,M=m;break}Se[vi+8>>2]=m;var C=Se[v]&-2;Se[v]=C,Se[t+(s+1)]=1|m,Se[d>>2]=m;break r}if(E>>>0<256){var R=Me[t+(s+2)],T=Me[t+(s+3)];if((0|R)!=(0|T)){var O=((E>>>2&1073741822)<<2)+vi+40|0,N=(0|R)!=(0|O)&R>>>0<b>>>0;do if(!N){if(!((0|T)==(0|O)|T>>>0>=b>>>0))break;Se[R+12>>2]=T,Se[T+8>>2]=R;var S=y,i=S>>2,M=m;break e}while(0);throw Ka(),\"Reached an unreachable!\"}var I=Se[vi>>2]&(1<<(E>>>3)^-1);Se[vi>>2]=I;var S=y,i=S>>2,M=m}else{var P=g,D=Me[t+(s+6)],L=Me[t+(s+3)],F=(0|L)==(0|P);do if(F){var X=A+(r+20)|0,j=Se[X>>2];if(0==(0|j)){var U=A+(r+16)|0,x=Se[U>>2];if(0==(0|x)){var z=0,e=z>>2;break}var V=U,B=x}else{var V=X,B=j;_=21}for(;;){var B,V,H=B+20|0,K=Se[H>>2];if(0==(0|K)){var Y=B+16|0,G=Me[Y>>2];if(0==(0|G))break;var V=Y,B=G}else var V=H,B=K}if(V>>>0<b>>>0)throw Ka(),\"Reached an unreachable!\";Se[V>>2]=0;var z=B,e=z>>2}else{var W=Me[t+(s+2)];if(W>>>0<b>>>0)throw Ka(),\"Reached an unreachable!\";Se[W+12>>2]=L,Se[L+8>>2]=W;var z=L,e=z>>2}while(0);var z;if(0==(0|D)){var S=y,i=S>>2,M=m;break}var Z=A+(r+28)|0,Q=(Se[Z>>2]<<2)+vi+304|0,q=(0|P)==(0|Se[Q>>2]);do{if(q){if(Se[Q>>2]=z,0!=(0|z))break;var $=Se[vi+4>>2]&(1<<Se[Z>>2]^-1);Se[vi+4>>2]=$;var S=y,i=S>>2,M=m;break e}if(D>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";var J=D+16|0;if((0|Se[J>>2])==(0|P)?Se[J>>2]=z:Se[D+20>>2]=z,0==(0|z)){var S=y,i=S>>2,M=m;break e}}while(0);if(z>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[e+6]=D;var rr=Me[t+(s+4)];if(0!=(0|rr)){if(rr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[e+4]=rr,Se[rr+24>>2]=z}var ar=Me[t+(s+5)];if(0==(0|ar)){var S=y,i=S>>2,M=m;break}if(ar>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[e+5]=ar,Se[ar+24>>2]=z;var S=y,i=S>>2,M=m}}else var S=l,i=S>>2,M=h;while(0);var M,S,er=S;if(er>>>0>=d>>>0)break;var ir=r+(h-4)|0,vr=Me[ir>>2];if(0==(1&vr|0))break;var tr=0==(2&vr|0);do{if(tr){if((0|w)==(0|Se[vi+24>>2])){var fr=Se[vi+12>>2]+M|0;Se[vi+12>>2]=fr,Se[vi+24>>2]=S;var _r=1|fr;if(Se[i+1]=_r,(0|S)==(0|Se[vi+20>>2])&&(Se[vi+20>>2]=0,Se[vi+8>>2]=0),fr>>>0<=Me[vi+28>>2]>>>0)break r;ia(0);break r}if((0|w)==(0|Se[vi+20>>2])){var sr=Se[vi+8>>2]+M|0;Se[vi+8>>2]=sr,Se[vi+20>>2]=S;var nr=1|sr;Se[i+1]=nr;var or=er+sr|0;Se[or>>2]=sr;break r}var lr=(vr&-8)+M|0,br=vr>>>3,kr=vr>>>0<256;e:do if(kr){var ur=Me[s+f],cr=Me[((4|h)>>2)+s];if((0|ur)!=(0|cr)){var hr=((vr>>>2&1073741822)<<2)+vi+40|0,dr=(0|ur)==(0|hr);do{if(!dr){if(ur>>>0<Me[vi+16>>2]>>>0){_=66;break}_=63;break}_=63}while(0);do if(63==_){if((0|cr)!=(0|hr)&&cr>>>0<Me[vi+16>>2]>>>0)break;Se[ur+12>>2]=cr,Se[cr+8>>2]=ur;break e}while(0);throw Ka(),\"Reached an unreachable!\"}var wr=Se[vi>>2]&(1<<br^-1);Se[vi>>2]=wr}else{var pr=d,Er=Me[f+(s+4)],Ar=Me[((4|h)>>2)+s],gr=(0|Ar)==(0|pr);do if(gr){var yr=h+(r+12)|0,mr=Se[yr>>2];if(0==(0|mr)){var Sr=h+(r+8)|0,Mr=Se[Sr>>2];if(0==(0|Mr)){var Cr=0,a=Cr>>2;break}var Rr=Sr,Tr=Mr}else{var Rr=yr,Tr=mr;_=73}for(;;){var Tr,Rr,Or=Tr+20|0,Nr=Se[Or>>2];if(0==(0|Nr)){var Ir=Tr+16|0,Pr=Me[Ir>>2];if(0==(0|Pr))break;var Rr=Ir,Tr=Pr}else var Rr=Or,Tr=Nr}if(Rr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[Rr>>2]=0;var Cr=Tr,a=Cr>>2}else{var Dr=Me[s+f];if(Dr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[Dr+12>>2]=Ar,\\nSe[Ar+8>>2]=Dr;var Cr=Ar,a=Cr>>2}while(0);var Cr;if(0==(0|Er))break;var Lr=h+(r+20)|0,Fr=(Se[Lr>>2]<<2)+vi+304|0,Xr=(0|pr)==(0|Se[Fr>>2]);do{if(Xr){if(Se[Fr>>2]=Cr,0!=(0|Cr))break;var jr=Se[vi+4>>2]&(1<<Se[Lr>>2]^-1);Se[vi+4>>2]=jr;break e}if(Er>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";var Ur=Er+16|0;if((0|Se[Ur>>2])==(0|pr)?Se[Ur>>2]=Cr:Se[Er+20>>2]=Cr,0==(0|Cr))break e}while(0);if(Cr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+6]=Er;var xr=Me[f+(s+2)];if(0!=(0|xr)){if(xr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+4]=xr,Se[xr+24>>2]=Cr}var zr=Me[f+(s+3)];if(0==(0|zr))break;if(zr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+5]=zr,Se[zr+24>>2]=Cr}while(0);if(Se[i+1]=1|lr,Se[er+lr>>2]=lr,(0|S)!=(0|Se[vi+20>>2])){var Vr=lr;break}Se[vi+8>>2]=lr;break r}Se[ir>>2]=vr&-2,Se[i+1]=1|M,Se[er+M>>2]=M;var Vr=M}while(0);var Vr;if(Vr>>>0<256){var Br=Vr>>>2&1073741822,Hr=(Br<<2)+vi+40|0,Kr=Me[vi>>2],Yr=1<<(Vr>>>3),Gr=0==(Kr&Yr|0);do{if(!Gr){var Wr=(Br+2<<2)+vi+40|0,Zr=Me[Wr>>2];if(Zr>>>0>=Me[vi+16>>2]>>>0){var Qr=Zr,qr=Wr;break}throw Ka(),\"Reached an unreachable!\"}Se[vi>>2]=Kr|Yr;var Qr=Hr,qr=(Br+2<<2)+vi+40|0}while(0);var qr,Qr;Se[qr>>2]=S,Se[Qr+12>>2]=S,Se[i+2]=Qr,Se[i+3]=Hr;break r}var $r=S,Jr=Vr>>>8,ra=0==(0|Jr);do if(ra)var aa=0;else{if(Vr>>>0>16777215){var aa=31;break}var ea=(Jr+1048320|0)>>>16&8,va=Jr<<ea,fa=(va+520192|0)>>>16&4,_a=va<<fa,sa=(_a+245760|0)>>>16&2,na=14-(fa|ea|sa)+(_a<<sa>>>15)|0,aa=Vr>>>((na+7|0)>>>0)&1|na<<1}while(0);var aa,oa=(aa<<2)+vi+304|0;Se[i+7]=aa,Se[i+5]=0,Se[i+4]=0;var la=Se[vi+4>>2],ba=1<<aa,ka=0==(la&ba|0);e:do if(ka){var ua=la|ba;Se[vi+4>>2]=ua,Se[oa>>2]=$r,Se[i+6]=oa,Se[i+3]=S,Se[i+2]=S}else{if(31==(0|aa))var ca=0;else var ca=25-(aa>>>1)|0;for(var ca,ha=Vr<<ca,da=Se[oa>>2];;){var da,ha;if((Se[da+4>>2]&-8|0)==(0|Vr)){var wa=da+8|0,pa=Me[wa>>2],Ea=Me[vi+16>>2],Aa=da>>>0<Ea>>>0;do if(!Aa){if(pa>>>0<Ea>>>0)break;Se[pa+12>>2]=$r,Se[wa>>2]=$r,Se[i+2]=pa,Se[i+3]=da,Se[i+6]=0;break e}while(0);throw Ka(),\"Reached an unreachable!\"}var ga=(ha>>>31<<2)+da+16|0,ya=Me[ga>>2];if(0==(0|ya)){if(ga>>>0>=Me[vi+16>>2]>>>0){Se[ga>>2]=$r,Se[i+6]=da,Se[i+3]=S,Se[i+2]=S;break e}throw Ka(),\"Reached an unreachable!\"}var ha=ha<<1,da=ya}}while(0);var ma=Se[vi+32>>2]-1|0;if(Se[vi+32>>2]=ma,0!=(0|ma))break r;ta();break r}while(0);throw Ka(),\"Reached an unreachable!\"}while(0)}function ta(){var r=Se[vi+452>>2],a=0==(0|r);r:do if(!a)for(var e=r;;){var e,i=Se[e+8>>2];if(0==(0|i))break r;var e=i}while(0);Se[vi+32>>2]=-1}function fa(r,a){if(0==(0|r))var e=Jr(a),i=e;else var v=la(r,a),i=v;var i;return i}function _a(r,a){var e,i=r>>>0<9;do if(i)var v=Jr(a),t=v;else{var f=r>>>0<16?16:r,_=0==(f-1&f|0);r:do if(_)var s=f;else{if(f>>>0<=16){var s=16;break}for(var n=16;;){var n,o=n<<1;if(o>>>0>=f>>>0){var s=o;break r}var n=o}}while(0);var s;if((-64-s|0)>>>0>a>>>0){if(a>>>0<11)var l=16;else var l=a+11&-8;var l,b=Jr(l+(s+12)|0);if(0==(0|b)){var t=0;break}var k=b-8|0;if(0==((b>>>0)%(s>>>0)|0))var u=k,c=0;else{var h=b+(s-1)&-s,d=h-8|0,w=k;if((d-w|0)>>>0>15)var p=d;else var p=h+(s-8)|0;var p,E=p-w|0,e=(b-4|0)>>2,A=Se[e],g=(A&-8)-E|0;if(0==(3&A|0)){var y=Se[k>>2]+E|0;Se[p>>2]=y,Se[p+4>>2]=g;var u=p,c=0}else{var m=p+4|0,S=g|1&Se[m>>2]|2;Se[m>>2]=S;var M=g+(p+4)|0,C=1|Se[M>>2];Se[M>>2]=C;var R=E|1&Se[e]|2;Se[e]=R;var T=b+(E-4)|0,O=1|Se[T>>2];Se[T>>2]=O;var u=p,c=b}}var c,u,N=u+4|0,I=Me[N>>2],P=0==(3&I|0);do if(P)var D=0;else{var L=I&-8;if(L>>>0<=(l+16|0)>>>0){var D=0;break}var F=L-l|0;Se[N>>2]=l|1&I|2,Se[u+(4|l)>>2]=3|F;var X=u+(4|L)|0,j=1|Se[X>>2];Se[X>>2]=j;var D=l+(u+8)|0}while(0);var D;0!=(0|c)&&va(c),0!=(0|D)&&va(D);var t=u+8|0}else{var U=Je();Se[U>>2]=12;var t=0}}while(0);var t;return t}function sa(r,a,e,i){var v,t;0==(0|Se[ti>>2])&&ba();var f=0==(0|i),_=0==(0|r);do{if(f){if(_){var s=Jr(0),n=s;t=30;break}var o=r<<2;if(o>>>0<11){var l=0,b=16;t=9;break}var l=0,b=o+11&-8;t=9;break}if(_){var n=i;t=30;break}var l=i,b=0;t=9;break}while(0);do if(9==t){var b,l,k=0==(1&e|0);r:do if(k){if(_){var u=0,c=0;break}for(var h=0,d=0;;){var d,h,w=Me[a+(d<<2)>>2];if(w>>>0<11)var p=16;else var p=w+11&-8;var p,E=p+h|0,A=d+1|0;if((0|A)==(0|r)){var u=0,c=E;break r}var h=E,d=A}}else{var g=Me[a>>2];if(g>>>0<11)var y=16;else var y=g+11&-8;var y,u=y,c=y*r|0}while(0);var c,u,m=Jr(b-4+c|0);if(0==(0|m)){var n=0;break}var S=m-8|0,M=Se[m-4>>2]&-8;if(0!=(2&e|0)){var C=-4-b+M|0;Fa(m,0,C,1)}if(0==(0|l)){var R=m+c|0,T=M-c|3;Se[m+(c-4)>>2]=T;var O=R,v=O>>2,N=c}else var O=l,v=O>>2,N=M;var N,O;Se[v]=m;var I=r-1|0,P=0==(0|I);r:do if(P)var D=S,L=N;else if(0==(0|u))for(var F=S,X=N,j=0;;){var j,X,F,U=Me[a+(j<<2)>>2];if(U>>>0<11)var x=16;else var x=U+11&-8;var x,z=X-x|0;Se[F+4>>2]=3|x;var V=F+x|0,B=j+1|0;if(Se[(B<<2>>2)+v]=x+(F+8)|0,(0|B)==(0|I)){var D=V,L=z;break r}var F=V,X=z,j=B}else for(var H=3|u,K=u+8|0,Y=S,G=N,W=0;;){var W,G,Y,Z=G-u|0;Se[Y+4>>2]=H;var Q=Y+u|0,q=W+1|0;if(Se[(q<<2>>2)+v]=Y+K|0,(0|q)==(0|I)){var D=Q,L=Z;break r}var Y=Q,G=Z,W=q}while(0);var L,D;Se[D+4>>2]=3|L;var n=O}while(0);var n;return n}function na(r){var a=r>>2;0==(0|Se[ti>>2])&&ba();var e=Me[vi+24>>2];if(0==(0|e))var i=0,v=0,t=0,f=0,_=0,s=0,n=0;else{for(var o=Me[vi+12>>2],l=o+40|0,b=vi+444|0,k=l,u=l,c=1;;){var c,u,k,b,h=Me[b>>2],d=h+8|0;if(0==(7&d|0))var w=0;else var w=7&-d;for(var w,p=b+4|0,E=h+w|0,A=c,g=u,y=k;;){var y,g,A,E;if(E>>>0<h>>>0)break;if(E>>>0>=(h+Se[p>>2]|0)>>>0|(0|E)==(0|e))break;var m=Se[E+4>>2];if(7==(0|m))break;var S=m&-8,M=S+y|0;if(1==(3&m|0))var C=A+1|0,R=S+g|0;else var C=A,R=g;var R,C,E=E+S|0,A=C,g=R,y=M}var T=Me[b+8>>2];if(0==(0|T))break;var b=T,k=y,u=g,c=A}var O=Se[vi+432>>2],i=y,v=A,t=o,f=g,_=O-y|0,s=Se[vi+436>>2],n=O-g|0}var n,s,_,f,t,v,i;Se[a]=i,Se[a+1]=v,Se[a+2]=0,Se[a+3]=0,Se[a+4]=_,Se[a+5]=s,Se[a+6]=0,Se[a+7]=n,Se[a+8]=f,Se[a+9]=t}function oa(){0==(0|Se[ti>>2])&&ba();var r=Me[vi+24>>2],a=0==(0|r);r:do if(a)var e=0,i=0,v=0;else for(var t=Se[vi+436>>2],f=Me[vi+432>>2],_=vi+444|0,s=f-40-Se[vi+12>>2]|0;;){var s,_,n=Me[_>>2],o=n+8|0;if(0==(7&o|0))var l=0;else var l=7&-o;for(var l,b=_+4|0,k=n+l|0,u=s;;){var u,k;if(k>>>0<n>>>0)break;if(k>>>0>=(n+Se[b>>2]|0)>>>0|(0|k)==(0|r))break;var c=Se[k+4>>2];if(7==(0|c))break;var h=c&-8,d=1==(3&c|0)?h:0,w=u-d|0,k=k+h|0,u=w}var p=Me[_+8>>2];if(0==(0|p)){var e=t,i=f,v=u;break r}var _=p,s=u}while(0);var v,i,e,E=Se[Se[qe>>2]+12>>2],A=(Qa(E,0|He.__str339,(ne=Oe,Oe+=4,Se[ne>>2]=e,ne)),Se[Se[qe>>2]+12>>2]),g=(Qa(A,0|He.__str1340,(ne=Oe,Oe+=4,Se[ne>>2]=i,ne)),Se[Se[qe>>2]+12>>2]);Qa(g,0|He.__str2341,(ne=Oe,Oe+=4,Se[ne>>2]=v,ne))}function la(r,a){var e,i,v,t=a>>>0>4294967231;r:do{if(!t){var f=r-8|0,_=f,i=(r-4|0)>>2,s=Me[i],n=s&-8,o=n-8|0,l=r+o|0,b=f>>>0<Me[vi+16>>2]>>>0;do if(!b){var k=3&s;if(!(1!=(0|k)&(0|o)>-8))break;var e=(r+(n-4)|0)>>2;if(0==(1&Se[e]|0))break;if(a>>>0<11)var u=16;else var u=a+11&-8;var u,c=0==(0|k);do{if(c){var h=ka(_,u),d=0,w=h;v=17;break}if(n>>>0<u>>>0){if((0|l)!=(0|Se[vi+24>>2])){v=21;break}var p=Se[vi+12>>2]+n|0;if(p>>>0<=u>>>0){v=21;break}var E=p-u|0,A=r+(u-8)|0;Se[i]=u|1&s|2;var g=1|E;Se[r+(u-4)>>2]=g,Se[vi+24>>2]=A,Se[vi+12>>2]=E;var d=0,w=_;v=17;break}var y=n-u|0;if(y>>>0<=15){var d=0,w=_;v=17;break}Se[i]=u|1&s|2,Se[r+(u-4)>>2]=3|y;var m=1|Se[e];Se[e]=m;var d=r+u|0,w=_;v=17;break}while(0);do if(17==v){var w,d;if(0==(0|w))break;0!=(0|d)&&va(d);var S=w+8|0;break r}while(0);var M=Jr(a);if(0==(0|M)){var S=0;break r}var C=0==(3&Se[i]|0)?8:4,R=n-C|0,T=R>>>0<a>>>0?R:a;Pa(M,r,T,1),va(r);var S=M;break r}while(0);throw Ka(),\"Reached an unreachable!\"}var O=Je();Se[O>>2]=12;var S=0}while(0);var S;return S}function ba(){if(0==(0|Se[ti>>2])){var r=qa(8);if(0!=(r-1&r|0))throw Ka(),\"Reached an unreachable!\";Se[ti+8>>2]=r,Se[ti+4>>2]=r,Se[ti+12>>2]=-1,Se[ti+16>>2]=2097152,Se[ti+20>>2]=0,Se[vi+440>>2]=0;var a=$a(0);Se[ti>>2]=a&-16^1431655768}}function ka(r,a){var e=Se[r+4>>2]&-8,i=a>>>0<256;do if(i)var v=0;else{if(e>>>0>=(a+4|0)>>>0&&(e-a|0)>>>0<=Se[ti+8>>2]<<1>>>0){var v=r;break}var v=0}while(0);var v;return v}function ua(r){for(var a,e=vi+444|0,a=e>>2;;){var e,i=Me[a];if(i>>>0<=r>>>0&&(i+Se[a+1]|0)>>>0>r>>>0){var v=e;break}var t=Me[a+2];if(0==(0|t)){var v=0;break}var e=t,a=e>>2}var v;return v}function ca(r,a){var e=r,i=r+8|0;if(0==(7&i|0))var v=0;else var v=7&-i;var v,t=a-v|0;Se[vi+24>>2]=e+v|0,Se[vi+12>>2]=t,Se[v+(e+4)>>2]=1|t,Se[a+(e+4)>>2]=40;var f=Se[ti+16>>2];Se[vi+28>>2]=f}function ha(){for(var r=0;;){var r,a=r<<1,e=(a<<2)+vi+40|0;Se[vi+(a+3<<2)+40>>2]=e,Se[vi+(a+2<<2)+40>>2]=e;var i=r+1|0;if(32==(0|i))break;var r=i}}function da(r,a,e){var i,v,t,f,_=a>>2,s=r>>2,n=r+8|0;if(0==(7&n|0))var o=0;else var o=7&-n;var o,l=a+8|0;if(0==(7&l|0))var b=0,t=b>>2;else var b=7&-l,t=b>>2;var b,k=a+b|0,u=k,c=o+e|0,v=c>>2,h=r+c|0,d=h,w=k-(r+o)-e|0;Se[(o+4>>2)+s]=3|e;var p=(0|u)==(0|Se[vi+24>>2]);r:do if(p){var E=Se[vi+12>>2]+w|0;Se[vi+12>>2]=E,Se[vi+24>>2]=d;var A=1|E;Se[v+(s+1)]=A}else if((0|u)==(0|Se[vi+20>>2])){var g=Se[vi+8>>2]+w|0;Se[vi+8>>2]=g,Se[vi+20>>2]=d;var y=1|g;Se[v+(s+1)]=y;var m=r+g+c|0;Se[m>>2]=g}else{var S=Me[t+(_+1)];if(1==(3&S|0)){var M=S&-8,C=S>>>3,R=S>>>0<256;a:do if(R){var T=Me[((8|b)>>2)+_],O=Me[t+(_+3)];if((0|T)!=(0|O)){var N=((S>>>2&1073741822)<<2)+vi+40|0,I=(0|T)==(0|N);do{if(!I){if(T>>>0<Me[vi+16>>2]>>>0){f=18;break}f=15;break}f=15}while(0);do if(15==f){if((0|O)!=(0|N)&&O>>>0<Me[vi+16>>2]>>>0)break;Se[T+12>>2]=O,Se[O+8>>2]=T;break a}while(0);throw Ka(),\"Reached an unreachable!\"}var P=Se[vi>>2]&(1<<C^-1);Se[vi>>2]=P}else{var D=k,L=Me[((24|b)>>2)+_],F=Me[t+(_+3)],X=(0|F)==(0|D);do if(X){var j=16|b,U=j+(a+4)|0,x=Se[U>>2];if(0==(0|x)){var z=a+j|0,V=Se[z>>2];if(0==(0|V)){var B=0,i=B>>2;break}var H=z,K=V}else{var H=U,K=x;f=25}for(;;){var K,H,Y=K+20|0,G=Se[Y>>2];if(0==(0|G)){var W=K+16|0,Z=Me[W>>2];if(0==(0|Z))break;var H=W,K=Z}else var H=Y,K=G}if(H>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[H>>2]=0;var B=K,i=B>>2}else{var Q=Me[((8|b)>>2)+_];if(Q>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[Q+12>>2]=F,Se[F+8>>2]=Q;var B=F,i=B>>2}while(0);var B;if(0==(0|L))break;var q=b+(a+28)|0,$=(Se[q>>2]<<2)+vi+304|0,J=(0|D)==(0|Se[$>>2]);do{if(J){if(Se[$>>2]=B,0!=(0|B))break;var rr=Se[vi+4>>2]&(1<<Se[q>>2]^-1);Se[vi+4>>2]=rr;break a}if(L>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";var ar=L+16|0;if((0|Se[ar>>2])==(0|D)?Se[ar>>2]=B:Se[L+20>>2]=B,0==(0|B))break a}while(0);if(B>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[i+6]=L;var er=16|b,ir=Me[(er>>2)+_];if(0!=(0|ir)){if(ir>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[i+4]=ir,Se[ir+24>>2]=B}var vr=Me[(er+4>>2)+_];if(0==(0|vr))break;if(vr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[i+5]=vr,Se[vr+24>>2]=B}while(0);var tr=a+(M|b)|0,fr=M+w|0}else var tr=u,fr=w;var fr,tr,_r=tr+4|0,sr=Se[_r>>2]&-2;if(Se[_r>>2]=sr,Se[v+(s+1)]=1|fr,Se[(fr>>2)+s+v]=fr,fr>>>0<256){var nr=fr>>>2&1073741822,or=(nr<<2)+vi+40|0,lr=Me[vi>>2],br=1<<(fr>>>3),kr=0==(lr&br|0);do{if(!kr){var ur=(nr+2<<2)+vi+40|0,cr=Me[ur>>2];if(cr>>>0>=Me[vi+16>>2]>>>0){var hr=cr,dr=ur;break}throw Ka(),\"Reached an unreachable!\"}Se[vi>>2]=lr|br;var hr=or,dr=(nr+2<<2)+vi+40|0}while(0);var dr,hr;Se[dr>>2]=d,Se[hr+12>>2]=d,Se[v+(s+2)]=hr,Se[v+(s+3)]=or}else{var wr=h,pr=fr>>>8,Er=0==(0|pr);do if(Er)var Ar=0;else{if(fr>>>0>16777215){var Ar=31;break}var gr=(pr+1048320|0)>>>16&8,yr=pr<<gr,mr=(yr+520192|0)>>>16&4,Sr=yr<<mr,Mr=(Sr+245760|0)>>>16&2,Cr=14-(mr|gr|Mr)+(Sr<<Mr>>>15)|0,Ar=fr>>>((Cr+7|0)>>>0)&1|Cr<<1}while(0);var Ar,Rr=(Ar<<2)+vi+304|0;Se[v+(s+7)]=Ar;var Tr=c+(r+16)|0;Se[v+(s+5)]=0,Se[Tr>>2]=0;var Or=Se[vi+4>>2],Nr=1<<Ar;if(0==(Or&Nr|0)){var Ir=Or|Nr;Se[vi+4>>2]=Ir,Se[Rr>>2]=wr,Se[v+(s+6)]=Rr,Se[v+(s+3)]=wr,Se[v+(s+2)]=wr}else{if(31==(0|Ar))var Pr=0;else var Pr=25-(Ar>>>1)|0;for(var Pr,Dr=fr<<Pr,Lr=Se[Rr>>2];;){var Lr,Dr;if((Se[Lr+4>>2]&-8|0)==(0|fr)){var Fr=Lr+8|0,Xr=Me[Fr>>2],jr=Me[vi+16>>2],Ur=Lr>>>0<jr>>>0;do if(!Ur){if(Xr>>>0<jr>>>0)break;Se[Xr+12>>2]=wr,Se[Fr>>2]=wr,Se[v+(s+2)]=Xr,Se[v+(s+3)]=Lr,Se[v+(s+6)]=0;break r}while(0);throw Ka(),\"Reached an unreachable!\"}var xr=(Dr>>>31<<2)+Lr+16|0,zr=Me[xr>>2];if(0==(0|zr)){if(xr>>>0>=Me[vi+16>>2]>>>0){Se[xr>>2]=wr,Se[v+(s+6)]=Lr,Se[v+(s+3)]=wr,Se[v+(s+2)]=wr;break r}throw Ka(),\"Reached an unreachable!\"}var Dr=Dr<<1,Lr=zr}}}}while(0);return r+(8|o)|0}function wa(r){return 0|He.__str3342}function pa(r){return 0|He.__str14343}function Ea(r){Se[r>>2]=si+8|0}function Aa(r){0!=(0|r)&&va(r)}function ga(r){ya(r);var a=r;Aa(a)}function ya(r){var a=0|r;Ye(a)}function ma(r){var a=0|r;Ea(a),Se[r>>2]=ni+8|0}function Sa(r){var a=0|r;ya(a);var e=r;Aa(e)}function Ma(r,a){var e,i,v=Me[vi+24>>2],i=v>>2,t=v,f=ua(t),_=Se[f>>2],s=Se[f+4>>2],n=_+s|0,o=_+(s-39)|0;if(0==(7&o|0))var l=0;else var l=7&-o;var l,b=_+(s-47)+l|0,k=b>>>0<(v+16|0)>>>0?t:b,u=k+8|0,e=u>>2,c=u,h=r,d=a-40|0;ca(h,d);var w=k+4|0;Se[w>>2]=27,Se[e]=Se[vi+444>>2],Se[e+1]=Se[vi+448>>2],Se[e+2]=Se[vi+452>>2],Se[e+3]=Se[vi+456>>2],Se[vi+444>>2]=r,Se[vi+448>>2]=a,Se[vi+456>>2]=0,Se[vi+452>>2]=c;var p=k+28|0;Se[p>>2]=7;var E=(k+32|0)>>>0<n>>>0;r:do if(E)for(var A=p;;){var A,g=A+4|0;if(Se[g>>2]=7,(A+8|0)>>>0>=n>>>0)break r;var A=g}while(0);var y=(0|k)==(0|t);r:do if(!y){var m=k-v|0,S=t+m|0,M=m+(t+4)|0,C=Se[M>>2]&-2;Se[M>>2]=C;var R=1|m;Se[i+1]=R;var T=S;if(Se[T>>2]=m,m>>>0<256){var O=m>>>2&1073741822,N=(O<<2)+vi+40|0,I=Me[vi>>2],P=1<<(m>>>3),D=0==(I&P|0);do{if(!D){var L=(O+2<<2)+vi+40|0,F=Me[L>>2];if(F>>>0>=Me[vi+16>>2]>>>0){var X=F,j=L;break}throw Ka(),\"Reached an unreachable!\"}var U=I|P;Se[vi>>2]=U;var X=N,j=(O+2<<2)+vi+40|0}while(0);var j,X;Se[j>>2]=v,Se[X+12>>2]=v,Se[i+2]=X,Se[i+3]=N}else{var x=v,z=m>>>8,V=0==(0|z);do if(V)var B=0;else{if(m>>>0>16777215){var B=31;break}var H=(z+1048320|0)>>>16&8,K=z<<H,Y=(K+520192|0)>>>16&4,G=K<<Y,W=(G+245760|0)>>>16&2,Z=14-(Y|H|W)+(G<<W>>>15)|0,B=m>>>((Z+7|0)>>>0)&1|Z<<1}while(0);var B,Q=(B<<2)+vi+304|0;Se[i+7]=B,Se[i+5]=0,Se[i+4]=0;var q=Se[vi+4>>2],$=1<<B;if(0==(q&$|0)){var J=q|$;Se[vi+4>>2]=J,Se[Q>>2]=x,Se[i+6]=Q,Se[i+3]=v,Se[i+2]=v}else{if(31==(0|B))var rr=0;else var rr=25-(B>>>1)|0;for(var rr,ar=m<<rr,er=Se[Q>>2];;){var er,ar;if((Se[er+4>>2]&-8|0)==(0|m)){var ir=er+8|0,vr=Me[ir>>2],tr=Me[vi+16>>2],fr=er>>>0<tr>>>0;do if(!fr){if(vr>>>0<tr>>>0)break;Se[vr+12>>2]=x,Se[ir>>2]=x,Se[i+2]=vr,Se[i+3]=er,Se[i+6]=0;break r}while(0);throw Ka(),\"Reached an unreachable!\"}var _r=(ar>>>31<<2)+er+16|0,sr=Me[_r>>2];if(0==(0|sr)){if(_r>>>0>=Me[vi+16>>2]>>>0){Se[_r>>2]=x,Se[i+6]=er,Se[i+3]=v,Se[i+2]=v;break r}throw Ka(),\"Reached an unreachable!\"}var ar=ar<<1,er=sr}}}}while(0)}function Ca(r){return d(r)}function Ra(r,a){var e=0;do Ae[r+e]=Ae[a+e],e++;while(0!=Ae[a+e-1]);return r}function Ta(){var r=Ta;return r.LLVM_SAVEDSTACKS||(r.LLVM_SAVEDSTACKS=[]),r.LLVM_SAVEDSTACKS.push(le.stackSave()),r.LLVM_SAVEDSTACKS.length-1}function Oa(r){var a=Ta,e=a.LLVM_SAVEDSTACKS[r];a.LLVM_SAVEDSTACKS.splice(r,1),le.stackRestore(e)}function Na(r,a,e){for(var i=0;i<e;){var v=Ae[r+i],t=Ae[a+i];if(v==t&&0==v)return 0;if(0==v)return-1;if(0==t)return 1;if(v!=t)return v>t?1:-1;i++}return 0}function Ia(r,a){var e=Ca(r),i=0;do Ae[r+e+i]=Ae[a+i],i++;while(0!=Ae[a+i-1]);return r}function Pa(r,a,e,i){if(e>=20&&a%2==r%2)if(a%4==r%4){for(var v=a+e;a%4;)Ae[r++]=Ae[a++];for(var t=a>>2,f=r>>2,_=v>>2;t<_;)Se[f++]=Se[t++];for(a=t<<2,r=f<<2;a<v;)Ae[r++]=Ae[a++]}else{var v=a+e;a%2&&(Ae[r++]=Ae[a++]);for(var s=a>>1,n=r>>1,o=v>>1;s<o;)ye[n++]=ye[s++];a=s<<1,r=n<<1,a<v&&(Ae[r++]=Ae[a++])}else for(;e--;)Ae[r++]=Ae[a++]}function Da(r,a){return Na(r,a,Le)}function La(r,a,e){for(var i=0;i<e;i++){var v=Ae[r+i],t=Ae[a+i];if(v!=t)return v>t?1:-1}return 0}function Fa(r,a,e,i){if(e>=20){for(var v=r+e;r%4;)Ae[r++]=a;a<0&&(a+=256);for(var t=r>>2,f=v>>2,_=a|a<<8|a<<16|a<<24;t<f;)Se[t++]=_;for(r=t<<2;r<v;)Ae[r++]=a}else for(;e--;)Ae[r++]=a}function Xa(r,a,e,i){throw\"Assertion failed: \"+s(i)+\", at: \"+[s(r),a,s(e)]}function ja(r){var a=d(r),e=Jr(a+1);return Pa(e,r,a,1),Ae[e+a]=0,e}function Ua(r,a){function e(r){var e;return\"double\"===r?(xe[0]=Se[a+_>>2],xe[1]=Se[a+_+4>>2],e=ze[0]):\"i64\"==r?e=[Se[a+_>>2],Se[a+_+4>>2]]:(r=\"i32\",e=Se[a+_>>2]),_+=le.getNativeFieldSize(r),e}for(var i,v,t,f=r,_=0,s=[];;){var n=f;if(i=Ae[f],0===i)break;if(v=Ae[f+1],i==\"%\".charCodeAt(0)){var o=!1,l=!1,b=!1,k=!1;r:for(;;){switch(v){case\"+\".charCodeAt(0):o=!0;break;case\"-\".charCodeAt(0):l=!0;break;case\"#\".charCodeAt(0):b=!0;break;case\"0\".charCodeAt(0):if(k)break r;k=!0;break;default:break r}f++,v=Ae[f+1]}var u=0;if(v==\"*\".charCodeAt(0))u=e(\"i32\"),f++,v=Ae[f+1];else for(;v>=\"0\".charCodeAt(0)&&v<=\"9\".charCodeAt(0);)u=10*u+(v-\"0\".charCodeAt(0)),f++,v=Ae[f+1];var c=!1;if(v==\".\".charCodeAt(0)){var h=0;if(c=!0,f++,v=Ae[f+1],v==\"*\".charCodeAt(0))h=e(\"i32\"),f++;else for(;;){var d=Ae[f+1];if(d<\"0\".charCodeAt(0)||d>\"9\".charCodeAt(0))break;h=10*h+(d-\"0\".charCodeAt(0)),f++}v=Ae[f+1]}else var h=6;var E;switch(String.fromCharCode(v)){case\"h\":var A=Ae[f+2];A==\"h\".charCodeAt(0)?(f++,E=1):E=2;break;case\"l\":var A=Ae[f+2];A==\"l\".charCodeAt(0)?(f++,E=8):E=4;break;case\"L\":case\"q\":case\"j\":E=8;break;case\"z\":case\"t\":case\"I\":E=4;break;default:E=null}if(E&&f++,v=Ae[f+1],[\"d\",\"i\",\"u\",\"o\",\"x\",\"X\",\"p\"].indexOf(String.fromCharCode(v))!=-1){var m=v==\"d\".charCodeAt(0)||v==\"i\".charCodeAt(0);E=E||4;var t=e(\"i\"+8*E);if(8==E&&(t=le.makeBigInt(t[0],t[1],v==\"u\".charCodeAt(0))),E<=4){var S=Math.pow(256,E)-1;t=(m?y:g)(t&S,8*E)}var M,C=Math.abs(t),R=\"\";if(v==\"d\".charCodeAt(0)||v==\"i\".charCodeAt(0))M=y(t,8*E,1).toString(10);else if(v==\"u\".charCodeAt(0))M=g(t,8*E,1).toString(10),t=Math.abs(t);else if(v==\"o\".charCodeAt(0))M=(b?\"0\":\"\")+C.toString(8);else if(v==\"x\".charCodeAt(0)||v==\"X\".charCodeAt(0)){if(R=b?\"0x\":\"\",t<0){t=-t,M=(C-1).toString(16);for(var T=[],O=0;O<M.length;O++)T.push((15-parseInt(M[O],16)).toString(16));for(M=T.join(\"\");M.length<2*E;)M=\"f\"+M}else M=C.toString(16);v==\"X\".charCodeAt(0)&&(R=R.toUpperCase(),M=M.toUpperCase())}else v==\"p\".charCodeAt(0)&&(0===C?M=\"(nil)\":(R=\"0x\",M=C.toString(16)));if(c)for(;M.length<h;)M=\"0\"+M;for(o&&(R=t<0?\"-\"+R:\"+\"+R);R.length+M.length<u;)l?M+=\" \":k?M=\"0\"+M:R=\" \"+R;M=R+M,M.split(\"\").forEach(function(r){s.push(r.charCodeAt(0))})}else if([\"f\",\"F\",\"e\",\"E\",\"g\",\"G\"].indexOf(String.fromCharCode(v))!=-1){var M,t=e(\"double\");if(isNaN(t))M=\"nan\",k=!1;else if(isFinite(t)){var N=!1,I=Math.min(h,20);if(v==\"g\".charCodeAt(0)||v==\"G\".charCodeAt(0)){N=!0,h=h||1;var P=parseInt(t.toExponential(I).split(\"e\")[1],10);h>P&&P>=-4?(v=(v==\"g\".charCodeAt(0)?\"f\":\"F\").charCodeAt(0),h-=P+1):(v=(v==\"g\".charCodeAt(0)?\"e\":\"E\").charCodeAt(0),h--),I=Math.min(h,20)}v==\"e\".charCodeAt(0)||v==\"E\".charCodeAt(0)?(M=t.toExponential(I),/[eE][-+]\\\\d$/.test(M)&&(M=M.slice(0,-1)+\"0\"+M.slice(-1))):v!=\"f\".charCodeAt(0)&&v!=\"F\".charCodeAt(0)||(M=t.toFixed(I));var D=M.split(\"e\");if(N&&!b)for(;D[0].length>1&&D[0].indexOf(\".\")!=-1&&(\"0\"==D[0].slice(-1)||\".\"==D[0].slice(-1));)D[0]=D[0].slice(0,-1);else for(b&&M.indexOf(\".\")==-1&&(D[0]+=\".\");h>I++;)D[0]+=\"0\";M=D[0]+(D.length>1?\"e\"+D[1]:\"\"),v==\"E\".charCodeAt(0)&&(M=M.toUpperCase()),o&&t>=0&&(M=\"+\"+M)}else M=(t<0?\"-\":\"\")+\"inf\",k=!1;for(;M.length<u;)l?M+=\" \":M=!k||\"-\"!=M[0]&&\"+\"!=M[0]?(k?\"0\":\" \")+M:M[0]+\"0\"+M.slice(1);v<\"a\".charCodeAt(0)&&(M=M.toUpperCase()),M.split(\"\").forEach(function(r){s.push(r.charCodeAt(0))})}else if(v==\"s\".charCodeAt(0)){var L,F=e(\"i8*\");if(F?(L=w(F),c&&L.length>h&&(L=L.slice(0,h))):L=p(\"(null)\",!0),!l)for(;L.length<u--;)s.push(\" \".charCodeAt(0));if(s=s.concat(L),l)for(;L.length<u--;)s.push(\" \".charCodeAt(0))}else if(v==\"c\".charCodeAt(0)){for(l&&s.push(e(\"i8\"));--u>0;)s.push(\" \".charCodeAt(0));l||s.push(e(\"i8\"))}else if(v==\"n\".charCodeAt(0)){var X=e(\"i32*\");Se[X>>2]=s.length}else if(v==\"%\".charCodeAt(0))s.push(i);else for(var O=n;O<f+2;O++)s.push(Ae[O]);f+=2}else s.push(i),f+=1}return s}function xa(r,a,e,i){for(var v=Ua(e,i),t=void 0===a?v.length:Math.min(v.length,a-1),f=0;f<t;f++)Ae[r+f]=v[f];return Ae[r+f]=0,v.length}function za(r,a,e){return xa(r,void 0,a,e)}function Va(r){return r in{32:0,9:0,10:0,11:0,12:0,13:0}}function Ba(r){return r>=\"0\".charCodeAt(0)&&r<=\"9\".charCodeAt(0)}function Ha(r){for(var a;(a=Ae[r])&&Va(a);)r++;if(!a||!Ba(a))return 0;for(var e=r;(a=Ae[e])&&Ba(a);)e++;return Math.floor(Number(s(r).substr(0,e-r)))}function Ka(r){throw ke=!0,\"ABORT: \"+r+\", at \"+(new Error).stack}function Ya(r){return Ya.ret||(Ya.ret=_([0],\"i32\",we)),Se[Ya.ret>>2]=r,r}function Ga(r,a,e,i){var v=$e.streams[r];if(!v||v.object.isDevice)return Ya(Ge.EBADF),-1;if(v.isWrite){if(v.object.isFolder)return Ya(Ge.EISDIR),-1;if(e<0||i<0)return Ya(Ge.EINVAL),-1;for(var t=v.object.contents;t.length<i;)t.push(0);for(var f=0;f<e;f++)t[i+f]=ge[a+f];return v.object.timestamp=Date.now(),f}return Ya(Ge.EACCES),-1}function Wa(r,a,e){var i=$e.streams[r];if(i){if(i.isWrite){if(e<0)return Ya(Ge.EINVAL),-1;if(i.object.isDevice){if(i.object.output){for(var v=0;v<e;v++)try{i.object.output(Ae[a+v])}catch(r){return Ya(Ge.EIO),-1}return i.object.timestamp=Date.now(),v}return Ya(Ge.ENXIO),-1}var t=Ga(r,a,e,i.position);return t!=-1&&(i.position+=t),t}return Ya(Ge.EACCES),-1}return Ya(Ge.EBADF),-1}function Za(r,a,e,i){var v=e*a;if(0==v)return 0;var t=Wa(i,r,v);return t==-1?($e.streams[i]&&($e.streams[i].error=!0),-1):Math.floor(t/a)}function Qa(r,a,e){var i=Ua(a,e),v=le.stackSave(),t=Za(_(i,\"i8\",de),1,i.length,r);return le.stackRestore(v),t}function qa(r){switch(r){case 8:return Pe;case 54:case 56:case 21:case 61:case 63:case 22:case 67:case 23:case 24:case 25:case 26:case 27:case 69:case 28:case 101:case 70:case 71:case 29:case 30:case 199:case 75:case 76:case 32:case 43:case 44:case 80:case 46:case 47:case 45:case 48:case 49:case 42:case 82:case 33:case 7:case 108:case 109:case 107:case 112:case 119:case 121:return 200809;case 13:case 104:case 94:case 95:case 34:case 35:case 77:case 81:case 83:case 84:case 85:case 86:case 87:case 88:case 89:case 90:case 91:case 94:case 95:case 110:case 111:case 113:case 114:case 115:case 116:case 117:case 118:case 120:case 40:case 16:case 79:case 19:return-1;case 92:case 93:case 5:case 72:case 6:case 74:case 92:case 93:case 96:case 97:case 98:case 99:case 102:case 103:case 105:return 1;case 38:case 66:case 50:case 51:case 4:return 1024;case 15:case 64:case 41:return 32;case 55:case 37:case 17:return 2147483647;case 18:case 1:return 47839;case 59:case 57:return 99;case 68:case 58:return 2048;case 0:return 2097152;case 3:return 65536;case 14:return 32768;case 73:return 32767;case 39:return 16384;case 60:return 1e3;case 106:return 700;case 52:return 256;case 62:return 255;case 2:return 100;case 65:return 64;case 36:return 20;case 100:return 16;case 20:return 6;case 53:return 4}return Ya(Ge.EINVAL),-1}function $a(r){var a=Math.floor(Date.now()/1e3);return r&&(Se[r>>2]=a),a}function Ja(){return Ya.ret}function re(r){var a=re;a.called||(Ie=o(Ie),a.called=!0);var e=Ie;return 0!=r&&le.staticAlloc(r),e}function ae(){return Se[ae.buf>>2]}function ee(r){r=r||Module.arguments,k();var a=null;return Module._main&&(a=Module.callMain(r),Module.noExitRuntime||u()),a}var ie=[],ve=false,te=\"object\"==typeof window,fe=\"function\"==typeof importScripts,_e=!te&&!ve&&!fe;if(ve){print=function(r){process.stdout.write(r+\"\\\\n\")},printErr=function(r){process.stderr.write(r+\"\\\\n\")};var se=require(\"fs\");read=function(r){var a=se.readFileSync(r).toString();return a||\"/\"==r[0]||(r=__dirname.split(\"/\").slice(0,-1).join(\"/\")+\"/src/\"+r,a=se.readFileSync(r).toString()),a},load=function(a){r(read(a))},ie=process.argv.slice(2)}else if(_e)this.read||(this.read=function(r){snarf(r)}),\"undefined\"!=typeof scriptArgs?ie=scriptArgs:\"undefined\"!=typeof arguments&&(ie=arguments);else if(te)this.print=printErr=function(r){console.log(r)},this.read=function(r){var a=new XMLHttpRequest;return a.open(\"GET\",r,!1),a.send(null),a.responseText},this.arguments&&(ie=arguments);else{if(!fe)throw\"Unknown runtime environment. Where are we?\";this.load=importScripts}\"undefined\"==typeof load&&\"undefined\"!=typeof read&&(this.load=function(a){r(read(a))}),\"undefined\"==typeof printErr&&(this.printErr=function(){}),\"undefined\"==typeof print&&(this.print=printErr);try{this.Module=Module}catch(r){this.Module=Module={}}Module.arguments||(Module.arguments=ie),Module.print&&(print=Module.print);var ne,oe,le={stackSave:function(){return Oe},stackRestore:function(r){Oe=r},forceAlign:function(r,a){if(a=a||4,1==a)return r;if(isNumber(r)&&isNumber(a))return Math.ceil(r/a)*a;if(isNumber(a)&&isPowerOfTwo(a)){var e=log2(a);return\"((((\"+r+\")+\"+(a-1)+\")>>\"+e+\")<<\"+e+\")\"}return\"Math.ceil((\"+r+\")/\"+a+\")*\"+a},isNumberType:function(r){return r in le.INT_TYPES||r in le.FLOAT_TYPES},isPointerType:function(r){return\"*\"==r[r.length-1]},isStructType:function(r){return!isPointerType(r)&&(!!/^\\\\[\\\\d+\\\\ x\\\\ (.*)\\\\]/.test(r)||(!!/<?{ [^}]* }>?/.test(r)||\"%\"==r[0]))},INT_TYPES:{i1:0,i8:0,i16:0,i32:0,i64:0},FLOAT_TYPES:{float:0,double:0},bitshift64:function(r,e,i,v){var t=Math.pow(2,v)-1;if(v<32)switch(i){case\"shl\":return[r<<v,e<<v|(r&t<<32-v)>>>32-v];case\"ashr\":return[(r>>>v|(e&t)<<32-v)>>0>>>0,e>>v>>>0];case\"lshr\":return[(r>>>v|(e&t)<<32-v)>>>0,e>>>v]}else if(32==v)switch(i){case\"shl\":return[0,r];case\"ashr\":return[e,(0|e)<0?t:0];case\"lshr\":return[e,0]}else switch(i){case\"shl\":return[0,r<<v-32];case\"ashr\":return[e>>v-32>>>0,(0|e)<0?t:0];case\"lshr\":return[e>>>v-32,0]}a(\"unknown bitshift64 op: \"+[value,i,v])},or64:function(r,a){var e=0|r|(0|a),i=4294967296*(Math.round(r/4294967296)|Math.round(a/4294967296));return e+i},and64:function(r,a){var e=(0|r)&(0|a),i=4294967296*(Math.round(r/4294967296)&Math.round(a/4294967296));return e+i},xor64:function(r,a){var e=(0|r)^(0|a),i=4294967296*(Math.round(r/4294967296)^Math.round(a/4294967296));return e+i},getNativeTypeSize:function(r,a){if(1==le.QUANTUM_SIZE)return 1;var i={\"%i1\":1,\"%i8\":1,\"%i16\":2,\"%i32\":4,\"%i64\":8,\"%float\":4,\"%double\":8}[\"%\"+r];if(!i)if(\"*\"==r[r.length-1])i=le.QUANTUM_SIZE;else if(\"i\"==r[0]){var v=parseInt(r.substr(1));e(v%8==0),i=v/8}return i},getNativeFieldSize:function(r){return Math.max(le.getNativeTypeSize(r),le.QUANTUM_SIZE)},dedup:function(r,a){var e={};return a?r.filter(function(r){return!e[r[a]]&&(e[r[a]]=!0,!0)}):r.filter(function(r){return!e[r]&&(e[r]=!0,!0)})},set:function(){for(var r=\"object\"==typeof arguments[0]?arguments[0]:arguments,a={},e=0;e<r.length;e++)a[r[e]]=0;return a},calculateStructAlignment:function(r){r.flatSize=0,r.alignSize=0;var a=[],e=-1;return r.flatIndexes=r.fields.map(function(i){var v,t;if(le.isNumberType(i)||le.isPointerType(i))v=le.getNativeTypeSize(i),t=v;else{if(!le.isStructType(i))throw\"Unclear type in struct: \"+i+\", in \"+r.name_+\" :: \"+dump(Types.types[r.name_]);v=Types.types[i].flatSize,t=Types.types[i].alignSize}t=r.packed?1:Math.min(t,le.QUANTUM_SIZE),r.alignSize=Math.max(r.alignSize,t);var f=le.alignMemory(r.flatSize,t);return r.flatSize=f+v,e>=0&&a.push(f-e),e=f,f}),r.flatSize=le.alignMemory(r.flatSize,r.alignSize),0==a.length?r.flatFactor=r.flatSize:1==le.dedup(a).length&&(r.flatFactor=a[0]),r.needsFlattening=1!=r.flatFactor,r.flatIndexes},generateStructInfo:function(r,a,i){var v,t;if(a){if(i=i||0,v=(\"undefined\"==typeof Types?le.typeInfo:Types.types)[a],!v)return null;e(v.fields.length===r.length,\"Number of named fields must match the type for \"+a),t=v.flatIndexes}else{var v={fields:r.map(function(r){return r[0]})};t=le.calculateStructAlignment(v)}var f={__size__:v.flatSize};return a?r.forEach(function(r,a){if(\"string\"==typeof r)f[r]=t[a]+i;else{var e;for(var _ in r)e=_;f[e]=le.generateStructInfo(r[e],v.fields[a],t[a])}}):r.forEach(function(r,a){f[r[1]]=t[a]}),f},stackAlloc:function(r){var a=Oe;return Oe+=r,Oe=Oe+3>>2<<2,a},staticAlloc:function(r){var a=Ie;return Ie+=r,Ie=Ie+3>>2<<2,Ie>=Le&&l(),a},alignMemory:function(r,a){var e=r=Math.ceil(r/(a?a:4))*(a?a:4);return e},makeBigInt:function(r,a,e){var i=e?(r>>>0)+4294967296*(a>>>0):(r>>>0)+4294967296*(0|a);return i},QUANTUM_SIZE:4,__dummy__:0},be={MAX_ALLOWED:0,corrections:0,sigs:{},note:function(r,e,i){e||(this.corrections++,this.corrections>=this.MAX_ALLOWED&&a(\"\\\\n\\\\nToo many corrections!\"))},print:function(){}},ke=!1,ue=0,ce=this;Module.ccall=i,Module.setValue=t,Module.getValue=f;var he=0,de=1,we=2;Module.ALLOC_NORMAL=he,Module.ALLOC_STACK=de,Module.ALLOC_STATIC=we,Module.allocate=_,Module.Pointer_stringify=s,Module.Array_stringify=n;var pe,Ee,Ae,ge,ye,me,Se,Me,Ce,Re,Te,Oe,Ne,Ie,Pe=4096,De=Module.TOTAL_STACK||5242880,Le=Module.TOTAL_MEMORY||10485760;Module.FAST_MEMORY||2097152;e(!!(Int32Array&&Float64Array&&new Int32Array(1).subarray&&new Int32Array(1).set),\"Cannot fallback to non-typed array case: Code is too specialized\");var Fe=new ArrayBuffer(Le);Ae=new Int8Array(Fe),ye=new Int16Array(Fe),Se=new Int32Array(Fe),ge=new Uint8Array(Fe),me=new Uint16Array(Fe),Me=new Uint32Array(Fe),Ce=new Float32Array(Fe),Re=new Float64Array(Fe),Se[0]=255,e(255===ge[0]&&0===ge[3],\"Typed arrays 2 must be run on a little-endian system\");var Xe=p(\"(null)\");Ie=Xe.length;for(var je=0;je<Xe.length;je++)Ae[je]=Xe[je];Module.HEAP=Ee,Module.HEAP8=Ae,Module.HEAP16=ye,Module.HEAP32=Se,Module.HEAPU8=ge,Module.HEAPU16=me,Module.HEAPU32=Me,Module.HEAPF32=Ce,Module.HEAPF64=Re,Te=Oe=le.alignMemory(Ie),Ne=Te+De;var Ue=le.alignMemory(Ne,8),xe=(Ae.subarray(Ue),Se.subarray(Ue>>2)),ze=(Ce.subarray(Ue>>2),Re.subarray(Ue>>3));Ne=Ue+8,Ie=o(Ne);var Ve=[],Be=[];Module.Array_copy=c,Module.TypedArray_copy=h,Module.String_len=d,Module.String_copy=w,Module.intArrayFromString=p,Module.intArrayToString=E,Module.writeStringToMemory=A;var He=[],Ke=0;O.X=1,N.X=1,V.X=1,H.X=1,G.X=1,W.X=1,q.X=1,$.X=1,rr.X=1,ar.X=1,er.X=1,vr.X=1,nr.X=1,or.X=1,kr.X=1,hr.X=1,Ar.X=1,Sr.X=1,Tr.X=1,Ir.X=1,Pr.X=1,Dr.X=1,Lr.X=1,Fr.X=1,Xr.X=1,zr.X=1,Vr.X=1,Br.X=1,Gr.X=1,$r.X=1,Module._malloc=Jr,Jr.X=1,ra.X=1,aa.X=1,ea.X=1,ia.X=1,Module._free=va,va.X=1,_a.X=1,sa.X=1,na.X=1,oa.X=1,la.X=1,da.X=1,Ma.X=1;var Ye,Ge={E2BIG:7,EACCES:13,EADDRINUSE:98,EADDRNOTAVAIL:99,EAFNOSUPPORT:97,EAGAIN:11,EALREADY:114,EBADF:9,EBADMSG:74,EBUSY:16,ECANCELED:125,ECHILD:10,ECONNABORTED:103,ECONNREFUSED:111,ECONNRESET:104,EDEADLK:35,EDESTADDRREQ:89,EDOM:33,EDQUOT:122,EEXIST:17,EFAULT:14,EFBIG:27,EHOSTUNREACH:113,EIDRM:43,EILSEQ:84,EINPROGRESS:115,EINTR:4,EINVAL:22,EIO:5,EISCONN:106,EISDIR:21,ELOOP:40,EMFILE:24,EMLINK:31,EMSGSIZE:90,EMULTIHOP:72,ENAMETOOLONG:36,ENETDOWN:100,ENETRESET:102,ENETUNREACH:101,ENFILE:23,ENOBUFS:105,ENODATA:61,ENODEV:19,ENOENT:2,ENOEXEC:8,ENOLCK:37,ENOLINK:67,ENOMEM:12,ENOMSG:42,ENOPROTOOPT:92,ENOSPC:28,ENOSR:63,ENOSTR:60,ENOSYS:38,ENOTCONN:107,ENOTDIR:20,ENOTEMPTY:39,ENOTRECOVERABLE:131,ENOTSOCK:88,ENOTSUP:95,ENOTTY:25,ENXIO:6,EOVERFLOW:75,EOWNERDEAD:130,EPERM:1,EPIPE:32,EPROTO:71,EPROTONOSUPPORT:93,EPROTOTYPE:91,ERANGE:34,EROFS:30,ESPIPE:29,ESRCH:3,ESTALE:116,ETIME:62,ETIMEDOUT:110,ETXTBSY:26,EWOULDBLOCK:11,EXDEV:18},We=0,Ze=0,Qe=0,qe=0,$e={currentPath:\"/\",nextInode:2,streams:[null],ignorePermissions:!0,absolutePath:function(r,a){if(\"string\"!=typeof r)return null;void 0===a&&(a=$e.currentPath),r&&\"/\"==r[0]&&(a=\"\");for(var e=a+\"/\"+r,i=e.split(\"/\").reverse(),v=[\"\"];i.length;){var t=i.pop();\"\"==t||\".\"==t||(\"..\"==t?v.length>1&&v.pop():v.push(t))}return 1==v.length?\"/\":v.join(\"/\")},analyzePath:function(r,a,e){var i={isRoot:!1,exists:!1,error:0,name:null,path:null,object:null,parentExists:!1,parentPath:null,parentObject:null};if(r=$e.absolutePath(r),\"/\"==r)i.isRoot=!0,i.exists=i.parentExists=!0,i.name=\"/\",i.path=i.parentPath=\"/\",i.object=i.parentObject=$e.root;else if(null!==r){e=e||0,r=r.slice(1).split(\"/\");for(var v=$e.root,t=[\"\"];r.length;){1==r.length&&v.isFolder&&(i.parentExists=!0,i.parentPath=1==t.length?\"/\":t.join(\"/\"),i.parentObject=v,i.name=r[0]);var f=r.shift();if(!v.isFolder){i.error=Ge.ENOTDIR;break}if(!v.read){i.error=Ge.EACCES;break}if(!v.contents.hasOwnProperty(f)){i.error=Ge.ENOENT;break}if(v=v.contents[f],v.link&&(!a||0!=r.length)){if(e>40){i.error=Ge.ELOOP;break}var _=$e.absolutePath(v.link,t.join(\"/\"));return $e.analyzePath([_].concat(r).join(\"/\"),a,e+1)}t.push(f),0==r.length&&(i.exists=!0,i.path=t.join(\"/\"),i.object=v)}return i}return i},findObject:function(r,a){$e.ensureRoot();var e=$e.analyzePath(r,a);return e.exists?e.object:(Ya(e.error),null)},createObject:function(r,a,e,i,v){if(r||(r=\"/\"),\"string\"==typeof r&&(r=$e.findObject(r)),!r)throw Ya(Ge.EACCES),new Error(\"Parent path must exist.\");if(!r.isFolder)throw Ya(Ge.ENOTDIR),\\nnew Error(\"Parent must be a folder.\");if(!r.write&&!$e.ignorePermissions)throw Ya(Ge.EACCES),new Error(\"Parent folder must be writeable.\");if(!a||\".\"==a||\"..\"==a)throw Ya(Ge.ENOENT),new Error(\"Name must not be empty.\");if(r.contents.hasOwnProperty(a))throw Ya(Ge.EEXIST),new Error(\"Can\\'t overwrite object.\");r.contents[a]={read:void 0===i||i,write:void 0!==v&&v,timestamp:Date.now(),inodeNumber:$e.nextInode++};for(var t in e)e.hasOwnProperty(t)&&(r.contents[a][t]=e[t]);return r.contents[a]},createFolder:function(r,a,e,i){var v={isFolder:!0,isDevice:!1,contents:{}};return $e.createObject(r,a,v,e,i)},createPath:function(r,a,e,i){var v=$e.findObject(r);if(null===v)throw new Error(\"Invalid parent.\");for(a=a.split(\"/\").reverse();a.length;){var t=a.pop();t&&(v.contents.hasOwnProperty(t)||$e.createFolder(v,t,e,i),v=v.contents[t])}return v},createFile:function(r,a,e,i,v){return e.isFolder=!1,$e.createObject(r,a,e,i,v)},createDataFile:function(r,a,e,i,v){if(\"string\"==typeof e){for(var t=new Array(e.length),f=0,_=e.length;f<_;++f)t[f]=e.charCodeAt(f);e=t}var s={isDevice:!1,contents:e};return $e.createFile(r,a,s,i,v)},createLazyFile:function(r,a,e,i,v){var t={isDevice:!1,url:e};return $e.createFile(r,a,t,i,v)},createLink:function(r,a,e,i,v){var t={isDevice:!1,link:e};return $e.createFile(r,a,t,i,v)},createDevice:function(r,a,e,i){if(!e&&!i)throw new Error(\"A device must have at least one callback defined.\");var v={isDevice:!0,input:e,output:i};return $e.createFile(r,a,v,Boolean(e),Boolean(i))},forceLoadFile:function(r){if(r.isDevice||r.isFolder||r.link||r.contents)return!0;var a=!0;if(\"undefined\"!=typeof XMLHttpRequest)e(\"Cannot do synchronous binary XHRs in modern browsers. Use --embed-file or --preload-file in emcc\");else{if(\"undefined\"==typeof read)throw new Error(\"Cannot load without read() or XMLHttpRequest.\");try{r.contents=p(read(r.url),!0)}catch(r){a=!1}}return a||Ya(Ge.EIO),a},ensureRoot:function(){$e.root||($e.root={read:!0,write:!0,isFolder:!0,isDevice:!1,timestamp:Date.now(),inodeNumber:1,contents:{}})},init:function(r,a,i){function v(r){null===r||r===\"\\\\n\".charCodeAt(0)?(a.printer(a.buffer.join(\"\")),a.buffer=[]):a.buffer.push(String.fromCharCode(r))}e(!$e.init.initialized,\"FS.init was previously called. If you want to initialize later with custom parameters, remove any earlier calls (note that one is automatically added to the generated code)\"),$e.init.initialized=!0,$e.ensureRoot(),r=r||Module.stdin,a=a||Module.stdout,i=i||Module.stderr;var t=!0,f=!0,s=!0;r||(t=!1,r=function(){if(!r.cache||!r.cache.length){var a;\"undefined\"!=typeof window&&\"function\"==typeof window.prompt?a=window.prompt(\"Input: \"):\"function\"==typeof readline&&(a=readline()),a||(a=\"\"),r.cache=p(a+\"\\\\n\",!0)}return r.cache.shift()}),a||(f=!1,a=v),a.printer||(a.printer=print),a.buffer||(a.buffer=[]),i||(s=!1,i=v),i.printer||(i.printer=print),i.buffer||(i.buffer=[]),$e.createFolder(\"/\",\"tmp\",!0,!0);var n=$e.createFolder(\"/\",\"dev\",!0,!0),o=$e.createDevice(n,\"stdin\",r),l=$e.createDevice(n,\"stdout\",null,a),b=$e.createDevice(n,\"stderr\",null,i);$e.createDevice(n,\"tty\",r,a),$e.streams[1]={path:\"/dev/stdin\",object:o,position:0,isRead:!0,isWrite:!1,isAppend:!1,isTerminal:!t,error:!1,eof:!1,ungotten:[]},$e.streams[2]={path:\"/dev/stdout\",object:l,position:0,isRead:!1,isWrite:!0,isAppend:!1,isTerminal:!f,error:!1,eof:!1,ungotten:[]},$e.streams[3]={path:\"/dev/stderr\",object:b,position:0,isRead:!1,isWrite:!0,isAppend:!1,isTerminal:!s,error:!1,eof:!1,ungotten:[]},We=_([1],\"void*\",we),Ze=_([2],\"void*\",we),Qe=_([3],\"void*\",we),$e.createPath(\"/\",\"dev/shm/tmp\",!0,!0),$e.streams[We]=$e.streams[1],$e.streams[Ze]=$e.streams[2],$e.streams[Qe]=$e.streams[3],qe=_([_([0,0,0,0,We,0,0,0,Ze,0,0,0,Qe,0,0,0],\"void*\",we)],\"void*\",we)},quit:function(){$e.init.initialized&&($e.streams[2]&&$e.streams[2].object.output.buffer.length>0&&$e.streams[2].object.output(\"\\\\n\".charCodeAt(0)),$e.streams[3]&&$e.streams[3].object.output.buffer.length>0&&$e.streams[3].object.output(\"\\\\n\".charCodeAt(0)))}},Je=Ja;Ve.unshift({func:function(){$e.ignorePermissions=!1,$e.init.initialized||$e.init()}}),Be.push({func:function(){$e.quit()}}),Ya(0),ae.buf=_(12,\"void*\",we),Module.callMain=function(r){function a(){for(var r=0;r<3;r++)i.push(0)}var e=r.length+1,i=[_(p(\"/bin/this.program\"),\"i8\",we)];a();for(var v=0;v<e-1;v+=1)i.push(_(p(r[v]),\"i8\",we)),a();return i.push(0),i=_(i,\"i32\",we),_main(e,i,0)};var ri,ai,ei,ii,vi,ti,qe,fi,_i,si,ni,oi,li,bi,ki,ui,ci,hi,di,wi;if(He.__str=_([97,78,0],\"i8\",we),He.__str1=_([38,61,0],\"i8\",we),He.__str2=_([97,83,0],\"i8\",we),He.__str3=_([61,0],\"i8\",we),He.__str4=_([97,97,0],\"i8\",we),He.__str5=_([38,38,0],\"i8\",we),He.__str6=_([97,100,0],\"i8\",we),He.__str7=_([38,0],\"i8\",we),He.__str8=_([97,110,0],\"i8\",we),He.__str9=_([99,108,0],\"i8\",we),He.__str10=_([40,41,0],\"i8\",we),He.__str11=_([99,109,0],\"i8\",we),He.__str12=_([44,0],\"i8\",we),He.__str13=_([99,111,0],\"i8\",we),He.__str14=_([126,0],\"i8\",we),He.__str15=_([100,86,0],\"i8\",we),He.__str16=_([47,61,0],\"i8\",we),He.__str17=_([100,97,0],\"i8\",we),He.__str18=_([100,101,108,101,116,101,91,93,0],\"i8\",we),He.__str19=_([100,101,0],\"i8\",we),He.__str20=_([42,0],\"i8\",we),He.__str21=_([100,108,0],\"i8\",we),He.__str22=_([100,101,108,101,116,101,0],\"i8\",we),He.__str23=_([100,118,0],\"i8\",we),He.__str24=_([47,0],\"i8\",we),He.__str25=_([101,79,0],\"i8\",we),He.__str26=_([94,61,0],\"i8\",we),He.__str27=_([101,111,0],\"i8\",we),He.__str28=_([94,0],\"i8\",we),He.__str29=_([101,113,0],\"i8\",we),He.__str30=_([61,61,0],\"i8\",we),He.__str31=_([103,101,0],\"i8\",we),He.__str32=_([62,61,0],\"i8\",we),He.__str33=_([103,116,0],\"i8\",we),He.__str34=_([62,0],\"i8\",we),He.__str35=_([105,120,0],\"i8\",we),He.__str36=_([91,93,0],\"i8\",we),He.__str37=_([108,83,0],\"i8\",we),He.__str38=_([60,60,61,0],\"i8\",we),He.__str39=_([108,101,0],\"i8\",we),He.__str40=_([60,61,0],\"i8\",we),He.__str41=_([108,115,0],\"i8\",we),He.__str42=_([60,60,0],\"i8\",we),He.__str43=_([108,116,0],\"i8\",we),He.__str44=_([60,0],\"i8\",we),He.__str45=_([109,73,0],\"i8\",we),He.__str46=_([45,61,0],\"i8\",we),He.__str47=_([109,76,0],\"i8\",we),He.__str48=_([42,61,0],\"i8\",we),He.__str49=_([109,105,0],\"i8\",we),He.__str51=_([109,108,0],\"i8\",we),He.__str52=_([109,109,0],\"i8\",we),He.__str53=_([45,45,0],\"i8\",we),He.__str54=_([110,97,0],\"i8\",we),He.__str55=_([110,101,119,91,93,0],\"i8\",we),He.__str56=_([110,101,0],\"i8\",we),He.__str57=_([33,61,0],\"i8\",we),He.__str58=_([110,103,0],\"i8\",we),He.__str59=_([110,116,0],\"i8\",we),He.__str60=_([33,0],\"i8\",we),He.__str61=_([110,119,0],\"i8\",we),He.__str62=_([110,101,119,0],\"i8\",we),He.__str63=_([111,82,0],\"i8\",we),He.__str64=_([124,61,0],\"i8\",we),He.__str65=_([111,111,0],\"i8\",we),He.__str66=_([124,124,0],\"i8\",we),He.__str67=_([111,114,0],\"i8\",we),He.__str68=_([124,0],\"i8\",we),He.__str69=_([112,76,0],\"i8\",we),He.__str70=_([43,61,0],\"i8\",we),He.__str71=_([112,108,0],\"i8\",we),He.__str72=_([43,0],\"i8\",we),He.__str73=_([112,109,0],\"i8\",we),He.__str74=_([45,62,42,0],\"i8\",we),He.__str75=_([112,112,0],\"i8\",we),He.__str76=_([43,43,0],\"i8\",we),He.__str77=_([112,115,0],\"i8\",we),He.__str78=_([112,116,0],\"i8\",we),He.__str79=_([45,62,0],\"i8\",we),He.__str80=_([113,117,0],\"i8\",we),He.__str81=_([63,0],\"i8\",we),He.__str82=_([114,77,0],\"i8\",we),He.__str83=_([37,61,0],\"i8\",we),He.__str84=_([114,83,0],\"i8\",we),He.__str85=_([62,62,61,0],\"i8\",we),He.__str86=_([114,109,0],\"i8\",we),He.__str87=_([37,0],\"i8\",we),He.__str88=_([114,115,0],\"i8\",we),He.__str89=_([62,62,0],\"i8\",we),He.__str90=_([115,116,0],\"i8\",we),He.__str91=_([115,105,122,101,111,102,32,0],\"i8\",we),He.__str92=_([115,122,0],\"i8\",we),ri=_([0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,6,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,3,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,5,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,3,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,3,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,3,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,3,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,7,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,7,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0],we),He.__str95=_([98,111,111,108,101,97,110,0],\"i8\",we),He.__str97=_([98,121,116,101,0],\"i8\",we),He.__str101=_([95,95,102,108,111,97,116,49,50,56,0],\"i8\",we),He.__str105=_([117,110,115,105,103,110,101,100,0],\"i8\",we),He.__str114=_([108,111,110,103,32,108,111,110,103,0],\"i8\",we),He.__str115=_([117,110,115,105,103,110,101,100,32,108,111,110,103,32,108,111,110,103,0],\"i8\",we),ai=_([0,0,0,0,11,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,7,0,0,0,7,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,6,0,0,0,8,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,0,0,0,8,0,0,0,0,0,0,0,5,0,0,0,0,0,0,0,5,0,0,0,8,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,10,0,0,0,8,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,0,0,3,0,0,0,0,0,0,0,3,0,0,0,1,0,0,0,0,0,0,0,12,0,0,0,0,0,0,0,8,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,4,0,0,0,3,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,13,0,0,0,4,0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,0,0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,4,0,0,0,9,0,0,0,0,0,0,0,7,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,4,0,0,0,5,0,0,0,0,0,0,0,18,0,0,0,0,0,0,0,18,0,0,0,6,0,0,0,0,0,0,0,3,0,0,0,0,0,0,0,3,0,0,0,0,0,0,0],[\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0],we),He.__str117=_([95,71,76,79,66,65,76,95,0],\"i8\",we),He.__str118=_([103,108,111,98,97,108,32,99,111,110,115,116,114,117,99,116,111,114,115,32,107,101,121,101,100,32,116,111,32,0],\"i8\",we),He.__str119=_([103,108,111,98,97,108,32,100,101,115,116,114,117,99,116,111,114,115,32,107,101,121,101,100,32,116,111,32,0],\"i8\",we),He.__str120=_([58,58,0],\"i8\",we),He.__str121=_([118,116,97,98,108,101,32,102,111,114,32,0],\"i8\",we),He.__str122=_([86,84,84,32,102,111,114,32,0],\"i8\",we),He.__str123=_([99,111,110,115,116,114,117,99,116,105,111,110,32,118,116,97,98,108,101,32,102,111,114,32,0],\"i8\",we),He.__str124=_([45,105,110,45,0],\"i8\",we),He.__str125=_([116,121,112,101,105,110,102,111,32,102,111,114,32,0],\"i8\",we),He.__str126=_([116,121,112,101,105,110,102,111,32,110,97,109,101,32,102,111,114,32,0],\"i8\",we),He.__str127=_([116,121,112,101,105,110,102,111,32,102,110,32,102,111,114,32,0],\"i8\",we),He.__str128=_([110,111,110,45,118,105,114,116,117,97,108,32,116,104,117,110,107,32,116,111,32,0],\"i8\",we),He.__str129=_([118,105,114,116,117,97,108,32,116,104,117,110,107,32,116,111,32,0],\"i8\",we),He.__str130=_([99,111,118,97,114,105,97,110,116,32,114,101,116,117,114,110,32,116,104,117,110,107,32,116,111,32,0],\"i8\",we),He.__str131=_([106,97,118,97,32,67,108,97,115,115,32,102,111,114,32,0],\"i8\",we),He.__str132=_([103,117,97,114,100,32,118,97,114,105,97,98,108,101,32,102,111,114,32,0],\"i8\",we),He.__str133=_([114,101,102,101,114,101,110,99,101,32,116,101,109,112,111,114,97,114,121,32,102,111,114,32,0],\"i8\",we),He.__str134=_([104,105,100,100,101,110,32,97,108,105,97,115,32,102,111,114,32,0],\"i8\",we),He.__str135=_([58,58,42,0],\"i8\",we),He.__str136=_([44,32,0],\"i8\",we),He.__str137=_([111,112,101,114,97,116,111,114,0],\"i8\",we),He.__str139=_([41,32,0],\"i8\",we),He.__str140=_([32,40,0],\"i8\",we),He.__str141=_([41,32,58,32,40,0],\"i8\",we),He.__str142=_([117,108,0],\"i8\",we),He.__str143=_([108,108,0],\"i8\",we),He.__str144=_([117,108,108,0],\"i8\",we),He.__str145=_([102,97,108,115,101,0],\"i8\",we),He.__str146=_([116,114,117,101,0],\"i8\",we),He.__str147=_([32,114,101,115,116,114,105,99,116,0],\"i8\",we),He.__str148=_([32,118,111,108,97,116,105,108,101,0],\"i8\",we),He.__str149=_([32,99,111,110,115,116,0],\"i8\",we),He.__str150=_([99,111,109,112,108,101,120,32,0],\"i8\",we),He.__str151=_([105,109,97,103,105,110,97,114,121,32,0],\"i8\",we),ei=_([116,0,0,0,0,0,0,0,3,0,0,0,0,0,0,0,3,0,0,0,0,0,0,0,0,0,0,0,97,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,9,0,0,0,98,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,12,0,0,0,115,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,70,0,0,0,0,0,0,0,12,0,0,0,105,0,0,0,0,0,0,0,12,0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,13,0,0,0,111,0,0,0,0,0,0,0,12,0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,13,0,0,0,100,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,50,0,0,0,0,0,0,0,14,0,0,0],[\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0],we),He.__str152=_([115,116,100,0],\"i8\",we),He.__str153=_([115,116,100,58,58,97,108,108,111,99,97,116,111,114,0],\"i8\",we),He.__str154=_([97,108,108,111,99,97,116,111,114,0],\"i8\",we),He.__str155=_([115,116,100,58,58,98,97,115,105,99,95,115,116,114,105,110,103,0],\"i8\",we),He.__str156=_([98,97,115,105,99,95,115,116,114,105,110,103,0],\"i8\",we),He.__str157=_([115,116,100,58,58,115,116,114,105,110,103,0],\"i8\",we),He.__str158=_([115,116,100,58,58,98,97,115,105,99,95,115,116,114,105,110,103,60,99,104,97,114,44,32,115,116,100,58,58,99,104,97,114,95,116,114,97,105,116,115,60,99,104,97,114,62,44,32,115,116,100,58,58,97,108,108,111,99,97,116,111,114,60,99,104,97,114,62,32,62,0],\"i8\",we),He.__str159=_([115,116,100,58,58,105,115,116,114,101,97,109,0],\"i8\",we),He.__str160=_([115,116,100,58,58,98,97,115,105,99,95,105,115,116,114,101,97,109,60,99,104,97,114,44,32,115,116,100,58,58,99,104,97,114,95,116,114,97,105,116,115,60,99,104,97,114,62,32,62,0],\"i8\",we),He.__str161=_([98,97,115,105,99,95,105,115,116,114,101,97,109,0],\"i8\",we),He.__str162=_([115,116,100,58,58,111,115,116,114,101,97,109,0],\"i8\",we),He.__str163=_([115,116,100,58,58,98,97,115,105,99,95,111,115,116,114,101,97,109,60,99,104,97,114,44,32,115,116,100,58,58,99,104,97,114,95,116,114,97,105,116,115,60,99,104,97,114,62,32,62,0],\"i8\",we),He.__str164=_([98,97,115,105,99,95,111,115,116,114,101,97,109,0],\"i8\",we),He.__str165=_([115,116,100,58,58,105,111,115,116,114,101,97,109,0],\"i8\",we),He.__str166=_([115,116,100,58,58,98,97,115,105,99,95,105,111,115,116,114,101,97,109,60,99,104,97,114,44,32,115,116,100,58,58,99,104,97,114,95,116,114,97,105,116,115,60,99,104,97,114,62,32,62,0],\"i8\",we),He.__str167=_([98,97,115,105,99,95,105,111,115,116,114,101,97,109,0],\"i8\",we),He.__str168=_([115,116,114,105,110,103,32,108,105,116,101,114,97,108,0],\"i8\",we),He.__str169=_([40,97,110,111,110,121,109,111,117,115,32,110,97,109,101,115,112,97,99,101,41,0],\"i8\",we),He._symbol_demangle_dashed_null=_([45,45,110,117,108,108,45,45,0],\"i8\",we),He.__str170=_([37,115,37,115,0],\"i8\",we),He.__str1171=_([111,112,101,114,97,116,111,114,32,110,101,119,0],\"i8\",we),He.__str2172=_([111,112,101,114,97,116,111,114,32,100,101,108,101,116,101,0],\"i8\",we),He.__str3173=_([111,112,101,114,97,116,111,114,61,0],\"i8\",we),He.__str4174=_([111,112,101,114,97,116,111,114,62,62,0],\"i8\",we),He.__str5175=_([111,112,101,114,97,116,111,114,60,60,0],\"i8\",we),He.__str6176=_([111,112,101,114,97,116,111,114,33,0],\"i8\",we),He.__str7177=_([111,112,101,114,97,116,111,114,61,61,0],\"i8\",we),He.__str8178=_([111,112,101,114,97,116,111,114,33,61,0],\"i8\",we),He.__str9179=_([111,112,101,114,97,116,111,114,91,93,0],\"i8\",we),He.__str10180=_([111,112,101,114,97,116,111,114,32,0],\"i8\",we),He.__str11181=_([111,112,101,114,97,116,111,114,45,62,0],\"i8\",we),He.__str12182=_([111,112,101,114,97,116,111,114,42,0],\"i8\",we),He.__str13183=_([111,112,101,114,97,116,111,114,43,43,0],\"i8\",we),He.__str14184=_([111,112,101,114,97,116,111,114,45,45,0],\"i8\",we),He.__str15185=_([111,112,101,114,97,116,111,114,45,0],\"i8\",we),He.__str16186=_([111,112,101,114,97,116,111,114,43,0],\"i8\",we),He.__str17187=_([111,112,101,114,97,116,111,114,38,0],\"i8\",we),He.__str18188=_([111,112,101,114,97,116,111,114,45,62,42,0],\"i8\",we),He.__str19189=_([111,112,101,114,97,116,111,114,47,0],\"i8\",we),He.__str20190=_([111,112,101,114,97,116,111,114,37,0],\"i8\",we),He.__str21191=_([111,112,101,114,97,116,111,114,60,0],\"i8\",we),He.__str22192=_([111,112,101,114,97,116,111,114,60,61,0],\"i8\",we),He.__str23193=_([111,112,101,114,97,116,111,114,62,0],\"i8\",we),He.__str24194=_([111,112,101,114,97,116,111,114,62,61,0],\"i8\",we),He.__str25195=_([111,112,101,114,97,116,111,114,44,0],\"i8\",we),He.__str26196=_([111,112,101,114,97,116,111,114,40,41,0],\"i8\",we),He.__str27197=_([111,112,101,114,97,116,111,114,126,0],\"i8\",we),He.__str28198=_([111,112,101,114,97,116,111,114,94,0],\"i8\",we),He.__str29199=_([111,112,101,114,97,116,111,114,124,0],\"i8\",we),He.__str30200=_([111,112,101,114,97,116,111,114,38,38,0],\"i8\",we),He.__str31201=_([111,112,101,114,97,116,111,114,124,124,0],\"i8\",we),He.__str32202=_([111,112,101,114,97,116,111,114,42,61,0],\"i8\",we),He.__str33203=_([111,112,101,114,97,116,111,114,43,61,0],\"i8\",we),He.__str34204=_([111,112,101,114,97,116,111,114,45,61,0],\"i8\",we),He.__str35205=_([111,112,101,114,97,116,111,114,47,61,0],\"i8\",we),He.__str36206=_([111,112,101,114,97,116,111,114,37,61,0],\"i8\",we),He.__str37207=_([111,112,101,114,97,116,111,114,62,62,61,0],\"i8\",we),He.__str38208=_([111,112,101,114,97,116,111,114,60,60,61,0],\"i8\",we),He.__str39209=_([111,112,101,114,97,116,111,114,38,61,0],\"i8\",we),He.__str40210=_([111,112,101,114,97,116,111,114,124,61,0],\"i8\",we),He.__str41211=_([111,112,101,114,97,116,111,114,94,61,0],\"i8\",we),He.__str42212=_([96,118,102,116,97,98,108,101,39,0],\"i8\",we),He.__str43213=_([96,118,98,116,97,98,108,101,39,0],\"i8\",we),He.__str44214=_([96,118,99,97,108,108,39,0],\"i8\",we),He.__str45215=_([96,116,121,112,101,111,102,39,0],\"i8\",we),He.__str46216=_([96,108,111,99,97,108,32,115,116,97,116,105,99,32,103,117,97,114,100,39,0],\"i8\",we),He.__str47217=_([96,115,116,114,105,110,103,39,0],\"i8\",we),He.__str48218=_([96,118,98,97,115,101,32,100,101,115,116,114,117,99,116,111,114,39,0],\"i8\",we),He.__str49219=_([96,118,101,99,116,111,114,32,100,101,108,101,116,105,110,103,32,100,101,115,116,114,117,99,116,111,114,39,0],\"i8\",we),He.__str50220=_([96,100,101,102,97,117,108,116,32,99,111,110,115,116,114,117,99,116,111,114,32,99,108,111,115,117,114,101,39,0],\"i8\",we),He.__str51221=_([96,115,99,97,108,97,114,32,100,101,108,101,116,105,110,103,32,100,101,115,116,114,117,99,116,111,114,39,0],\"i8\",we),He.__str52222=_([96,118,101,99,116,111,114,32,99,111,110,115,116,114,117,99,116,111,114,32,105,116,101,114,97,116,111,114,39,0],\"i8\",we),He.__str53223=_([96,118,101,99,116,111,114,32,100,101,115,116,114,117,99,116,111,114,32,105,116,101,114,97,116,111,114,39,0],\"i8\",we),He.__str54224=_([96,118,101,99,116,111,114,32,118,98,97,115,101,32,99,111,110,115,116,114,117,99,116,111,114,32,105,116,101,114,97,116,111,114,39,0],\"i8\",we),He.__str55225=_([96,118,105,114,116,117,97,108,32,100,105,115,112,108,97,99,101,109,101,110,116,32,109,97,112,39,0],\"i8\",we),He.__str56226=_([96,101,104,32,118,101,99,116,111,114,32,99,111,110,115,116,114,117,99,116,111,114,32,105,116,101,114,97,116,111,114,39,0],\"i8\",we),He.__str57227=_([96,101,104,32,118,101,99,116,111,114,32,100,101,115,116,114,117,99,116,111,114,32,105,116,101,114,97,116,111,114,39,0],\"i8\",we),He.__str58228=_([96,101,104,32,118,101,99,116,111,114,32,118,98,97,115,101,32,99,111,110,115,116,114,117,99,116,111,114,32,105,116,101,114,97,116,111,114,39,0],\"i8\",we),He.__str59229=_([96,99,111,112,121,32,99,111,110,115,116,114,117,99,116,111,114,32,99,108,111,115,117,114,101,39,0],\"i8\",we),He.__str60230=_([37,115,37,115,32,96,82,84,84,73,32,84,121,112,101,32,68,101,115,99,114,105,112,116,111,114,39,0],\"i8\",we),He.__str61231=_([96,82,84,84,73,32,66,97,115,101,32,67,108,97,115,115,32,68,101,115,99,114,105,112,116,111,114,32,97,116,32,40,37,115,44,37,115,44,37,115,44,37,115,41,39,0],\"i8\",we),He.__str62232=_([96,82,84,84,73,32,66,97,115,101,32,67,108,97,115,115,32,65,114,114,97,121,39,0],\"i8\",we),He.__str63233=_([96,82,84,84,73,32,67,108,97,115,115,32,72,105,101,114,97,114,99,104,121,32,68,101,115,99,114,105,112,116,111,114,39,0],\"i8\",we),He.__str64234=_([96,82,84,84,73,32,67,111,109,112,108,101,116,101,32,79,98,106,101,99,116,32,76,111,99,97,116,111,114,39,0],\"i8\",we),He.__str65235=_([96,108,111,99,97,108,32,118,102,116,97,98,108,101,39,0],\"i8\",we),He.__str66236=_([96,108,111,99,97,108,32,118,102,116,97,98,108,101,32,99,111,110,115,116,114,117,99,116,111,114,32,99,108,111,115,117,114,101,39,0],\"i8\",we),He.__str67237=_([111,112,101,114,97,116,111,114,32,110,101,119,91,93,0],\"i8\",we),He.__str68238=_([111,112,101,114,97,116,111,114,32,100,101,108,101,116,101,91,93,0],\"i8\",we),He.__str69239=_([96,112,108,97,99,101,109,101,110,116,32,100,101,108,101,116,101,32,99,108,111,115,117,114,101,39,0],\"i8\",we),He.__str70240=_([96,112,108,97,99,101,109,101,110,116,32,100,101,108,101,116,101,91,93,32,99,108,111,115,117,114,101,39,0],\"i8\",we),He.__str71241=_([126,37,115,0],\"i8\",we),He.__str72242=_([117,110,100,110,97,109,101,46,99,0],\"i8\",we),He.___func___symbol_demangle=_([115,121,109,98,111,108,95,100,101,109,97,110,103,108,101,0],\"i8\",we),He.__str73243=_([115,121,109,45,62,114,101,115,117,108,116,0],\"i8\",we),He.___func___handle_template=_([104,97,110,100,108,101,95,116,101,109,112,108,97,116,101,0],\"i8\",we),He.__str74244=_([42,115,121,109,45,62,99,117,114,114,101,110,116,32,61,61,32,39,36,39,0],\"i8\",we),He.___func___str_array_get_ref=_([115,116,114,95,97,114,114,97,121,95,103,101,116,95,114,101,102,0],\"i8\",we),He.__str75245=_([99,114,101,102,0],\"i8\",we),He.__str76246=_([112,114,105,118,97,116,101,58,32,0],\"i8\",we),He.__str77247=_([112,114,111,116,101,99,116,101,100,58,32,0],\"i8\",we),He.__str78248=_([112,117,98,108,105,99,58,32,0],\"i8\",we),He.__str79249=_([115,116,97,116,105,99,32,0],\"i8\",we),He.__str80250=_([118,105,114,116,117,97,108,32,0],\"i8\",we),He.__str81251=_([91,116,104,117,110,107,93,58,37,115,0],\"i8\",we),He.__str82252=_([37,115,96,97,100,106,117,115,116,111,114,123,37,115,125,39,32,0],\"i8\",we),He.__str83253=_([37,115,32,37,115,0],\"i8\",we),He.__str84254=_([118,111,105,100,0],\"i8\",we),He.__str85255=_([37,115,37,115,37,115,0],\"i8\",we),He.__str86256=_([37,115,37,115,37,115,37,115,37,115,37,115,37,115,37,115,37,115,37,115,37,115,0],\"i8\",we),He.__str87257=_([32,0],\"i8\",we),He.__str88258=_([100,108,108,95,101,120,112,111,114,116,32,0],\"i8\",we),He.__str89259=_([99,100,101,99,108,0],\"i8\",we),He.__str90260=_([112,97,115,99,97,108,0],\"i8\",we),He.__str91261=_([116,104,105,115,99,97,108,108,0],\"i8\",we),He.__str92262=_([115,116,100,99,97,108,108,0],\"i8\",we),He.__str93263=_([102,97,115,116,99,97,108,108,0],\"i8\",we),He.__str94264=_([99,108,114,99,97,108,108,0],\"i8\",we),He.__str95265=_([95,95,100,108,108,95,101,120,112,111,114,116,32,0],\"i8\",we),He.__str96266=_([95,95,99,100,101,99,108,0],\"i8\",we),He.__str97267=_([95,95,112,97,115,99,97,108,0],\"i8\",we),He.__str98268=_([95,95,116,104,105,115,99,97,108,108,0],\"i8\",we),He.__str99269=_([95,95,115,116,100,99,97,108,108,0],\"i8\",we),He.__str100270=_([95,95,102,97,115,116,99,97,108,108,0],\"i8\",we),He.__str101271=_([95,95,99,108,114,99,97,108,108,0],\"i8\",we),He.__str102272=_([95,95,112,116,114,54,52,0],\"i8\",we),He.__str103273=_([99,111,110,115,116,0],\"i8\",we),He.__str104274=_([118,111,108,97,116,105,108,101,0],\"i8\",we),He.__str105275=_([99,111,110,115,116,32,118,111,108,97,116,105,108,101,0],\"i8\",we),He.___func___get_class_string=_([103,101,116,95,99,108,97,115,115,95,115,116,114,105,110,103,0],\"i8\",we),He.__str106276=_([97,45,62,101,108,116,115,91,105,93,0],\"i8\",we),He.__str107277=_([123,102,111,114,32,96,37,115,39,125,0],\"i8\",we),He.__str108278=_([37,115,37,115,37,115,37,115,37,115,37,115,37,115,37,115,0],\"i8\",we),He.__str109279=_([96,37,115,39,0],\"i8\",we),He.__str110280=_([46,46,46,0],\"i8\",we),He.__str111281=_([37,99,118,111,105,100,37,99,0],\"i8\",we),He.__str112282=_([37,115,44,37,115,0],\"i8\",we),He.__str113283=_([37,99,37,115,37,115,32,37,99,0],\"i8\",we),He.__str114284=_([37,99,37,115,37,115,37,99,0],\"i8\",we),He.___func___str_array_push=_([115,116,114,95,97,114,114,97,121,95,112,117,115,104,0],\"i8\",we),He.__str115285=_([112,116,114,0],\"i8\",we),He.__str116286=_([97,0],\"i8\",we),He.__str117287=_([97,45,62,101,108,116,115,91,97,45,62,110,117,109,93,0],\"i8\",we),He.__str118288=_([37,115,37,100,0],\"i8\",we),He.__str119289=_([45,0],\"i8\",we),ii=_(1,\"i8\",we),He.___func___demangle_datatype=_([100,101,109,97,110,103,108,101,95,100,97,116,97,116,121,112,101,0],\"i8\",we),He.__str121291=_([99,116,0],\"i8\",we),He.__str122292=_([117,110,105,111,110,32,0],\"i8\",we),He.__str123293=_([115,116,114,117,99,116,32,0],\"i8\",we),He.__str124294=_([99,108,97,115,115,32,0],\"i8\",we),He.__str125295=_([99,111,105,110,116,101,114,102,97,99,101,32,0],\"i8\",we),He.__str126296=_([96,116,101,109,112,108,97,116,101,45,112,97,114,97,109,101,116,101,114,45,37,115,39,0],\"i8\",we),He.__str127297=_([37,115,37,115,32,40,37,115,42,0],\"i8\",we),He.__str128298=_([41,37,115,0],\"i8\",we),He.__str129299=_([101,110,117,109,32,37,115,0],\"i8\",we),He.__str130300=_([96,116,101,109,112,108,97,116,101,45,112,97,114,97,109,101,116,101,114,37,115,39,0],\"i8\",we),He.__str131301=_([123,37,115,44,37,115,125,0],\"i8\",we),He.__str132302=_([123,37,115,44,37,115,44,37,115,125,0],\"i8\",we),He.__str133303=_([96,110,111,110,45,116,121,112,101,45,116,101,109,112,108,97,116,101,45,112,97,114,97,109,101,116,101,114,37,115,39,0],\"i8\",we),He.__str134304=_([32,95,95,112,116,114,54,52,0],\"i8\",we),He.__str135305=_([32,38,37,115,0],\"i8\",we),He.__str136306=_([32,38,37,115,32,118,111,108,97,116,105,108,101,0],\"i8\",we),He.__str137307=_([32,42,37,115,0],\"i8\",we),He.__str138308=_([32,42,37,115,32,99,111,110,115,116,0],\"i8\",we),He.__str139309=_([32,42,37,115,32,118,111,108,97,116,105,108,101,0],\"i8\",we),He.__str140310=_([32,42,37,115,32,99,111,110,115,116,32,118,111,108,97,116,105,108,101,0],\"i8\",we),He.__str141311=_([32,40,37,115,37,115,41,0],\"i8\",we),He.__str142312=_([32,40,37,115,41,0],\"i8\",we),He.__str143313=_([37,115,91,37,115,93,0],\"i8\",we),He.__str144314=_([37,115,32,37,115,37,115,0],\"i8\",we),He.__str145315=_([115,105,103,110,101,100,32,99,104,97,114,0],\"i8\",we),He.__str146316=_([99,104,97,114,0],\"i8\",we),He.__str147317=_([117,110,115,105,103,110,101,100,32,99,104,97,114,0],\"i8\",we),He.__str148318=_([115,104,111,114,116,0],\"i8\",we),He.__str149319=_([117,110,115,105,103,110,101,100,32,115,104,111,114,116,0],\"i8\",we),He.__str150320=_([105,110,116,0],\"i8\",we),He.__str151321=_([117,110,115,105,103,110,101,100,32,105,110,116,0],\"i8\",we),He.__str152322=_([108,111,110,103,0],\"i8\",we),He.__str153323=_([117,110,115,105,103,110,101,100,32,108,111,110,103,0],\"i8\",we),He.__str154324=_([102,108,111,97,116,0],\"i8\",we),He.__str155325=_([100,111,117,98,108,101,0],\"i8\",we),He.__str156326=_([108,111,110,103,32,100,111,117,98,108,101,0],\"i8\",we),He.__str157327=_([95,95,105,110,116,56,0],\"i8\",we),He.__str158328=_([117,110,115,105,103,110,101,100,32,95,95,105,110,116,56,0],\"i8\",we),He.__str159329=_([95,95,105,110,116,49,54,0],\"i8\",we),He.__str160330=_([117,110,115,105,103,110,101,100,32,95,95,105,110,116,49,54,0],\"i8\",we),He.__str161331=_([95,95,105,110,116,51,50,0],\"i8\",we),He.__str162332=_([117,110,115,105,103,110,101,100,32,95,95,105,110,116,51,50,0],\"i8\",we),He.__str163333=_([95,95,105,110,116,54,52,0],\"i8\",we),He.__str164334=_([117,110,115,105,103,110,101,100,32,95,95,105,110,116,54,52,0],\"i8\",we),\\nHe.__str165335=_([95,95,105,110,116,49,50,56,0],\"i8\",we),He.__str166336=_([117,110,115,105,103,110,101,100,32,95,95,105,110,116,49,50,56,0],\"i8\",we),He.__str167337=_([98,111,111,108,0],\"i8\",we),He.__str168338=_([119,99,104,97,114,95,116,0],\"i8\",we),vi=_(468,[\"i32\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0],we),ti=_(24,\"i32\",we),He.__str339=_([109,97,120,32,115,121,115,116,101,109,32,98,121,116,101,115,32,61,32,37,49,48,108,117,10,0],\"i8\",we),He.__str1340=_([115,121,115,116,101,109,32,98,121,116,101,115,32,32,32,32,32,61,32,37,49,48,108,117,10,0],\"i8\",we),He.__str2341=_([105,110,32,117,115,101,32,98,121,116,101,115,32,32,32,32,32,61,32,37,49,48,108,117,10,0],\"i8\",we),fi=_([ue],\"i8\",we),_i=_(1,\"void ()*\",we),si=_([0,0,0,0,0,0,0,0,6,0,0,0,8,0,0,0,10,0,0,0],[\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0],we),_(1,\"void*\",we),He.__str3342=_([115,116,100,58,58,98,97,100,95,97,108,108,111,99,0],\"i8\",we),ni=_([0,0,0,0,0,0,0,0,6,0,0,0,12,0,0,0,14,0,0,0],[\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0],we),_(1,\"void*\",we),He.__str14343=_([98,97,100,95,97,114,114,97,121,95,110,101,119,95,108,101,110,103,116,104,0],\"i8\",we),He.__ZTSSt9bad_alloc=_([83,116,57,98,97,100,95,97,108,108,111,99,0],\"i8\",we),bi=_(12,\"*\",we),He.__ZTSSt20bad_array_new_length=_([83,116,50,48,98,97,100,95,97,114,114,97,121,95,110,101,119,95,108,101,110,103,116,104,0],\"i8\",we),ki=_(12,\"*\",we),Se[ri>>2]=0|He.__str,Se[ri+4>>2]=0|He.__str1,Se[ri+16>>2]=0|He.__str2,Se[ri+20>>2]=0|He.__str3,Se[ri+32>>2]=0|He.__str4,Se[ri+36>>2]=0|He.__str5,Se[ri+48>>2]=0|He.__str6,Se[ri+52>>2]=0|He.__str7,Se[ri+64>>2]=0|He.__str8,Se[ri+68>>2]=0|He.__str7,Se[ri+80>>2]=0|He.__str9,Se[ri+84>>2]=0|He.__str10,Se[ri+96>>2]=0|He.__str11,Se[ri+100>>2]=0|He.__str12,Se[ri+112>>2]=0|He.__str13,Se[ri+116>>2]=0|He.__str14,Se[ri+128>>2]=0|He.__str15,Se[ri+132>>2]=0|He.__str16,Se[ri+144>>2]=0|He.__str17,Se[ri+148>>2]=0|He.__str18,Se[ri+160>>2]=0|He.__str19,Se[ri+164>>2]=0|He.__str20,Se[ri+176>>2]=0|He.__str21,Se[ri+180>>2]=0|He.__str22,Se[ri+192>>2]=0|He.__str23,Se[ri+196>>2]=0|He.__str24,Se[ri+208>>2]=0|He.__str25,Se[ri+212>>2]=0|He.__str26,Se[ri+224>>2]=0|He.__str27,Se[ri+228>>2]=0|He.__str28,Se[ri+240>>2]=0|He.__str29,Se[ri+244>>2]=0|He.__str30,Se[ri+256>>2]=0|He.__str31,Se[ri+260>>2]=0|He.__str32,Se[ri+272>>2]=0|He.__str33,Se[ri+276>>2]=0|He.__str34,Se[ri+288>>2]=0|He.__str35,Se[ri+292>>2]=0|He.__str36,Se[ri+304>>2]=0|He.__str37,Se[ri+308>>2]=0|He.__str38,Se[ri+320>>2]=0|He.__str39,Se[ri+324>>2]=0|He.__str40,Se[ri+336>>2]=0|He.__str41,Se[ri+340>>2]=0|He.__str42,Se[ri+352>>2]=0|He.__str43,Se[ri+356>>2]=0|He.__str44,Se[ri+368>>2]=0|He.__str45,Se[ri+372>>2]=0|He.__str46,Se[ri+384>>2]=0|He.__str47,Se[ri+388>>2]=0|He.__str48,Se[ri+400>>2]=0|He.__str49,Se[ri+404>>2]=0|He.__str119289,Se[ri+416>>2]=0|He.__str51,Se[ri+420>>2]=0|He.__str20,Se[ri+432>>2]=0|He.__str52,Se[ri+436>>2]=0|He.__str53,Se[ri+448>>2]=0|He.__str54,Se[ri+452>>2]=0|He.__str55,Se[ri+464>>2]=0|He.__str56,Se[ri+468>>2]=0|He.__str57,Se[ri+480>>2]=0|He.__str58,Se[ri+484>>2]=0|He.__str119289,Se[ri+496>>2]=0|He.__str59,Se[ri+500>>2]=0|He.__str60,Se[ri+512>>2]=0|He.__str61,Se[ri+516>>2]=0|He.__str62,Se[ri+528>>2]=0|He.__str63,Se[ri+532>>2]=0|He.__str64,Se[ri+544>>2]=0|He.__str65,Se[ri+548>>2]=0|He.__str66,Se[ri+560>>2]=0|He.__str67,Se[ri+564>>2]=0|He.__str68,Se[ri+576>>2]=0|He.__str69,Se[ri+580>>2]=0|He.__str70,Se[ri+592>>2]=0|He.__str71,Se[ri+596>>2]=0|He.__str72,Se[ri+608>>2]=0|He.__str73,Se[ri+612>>2]=0|He.__str74,Se[ri+624>>2]=0|He.__str75,Se[ri+628>>2]=0|He.__str76,Se[ri+640>>2]=0|He.__str77,Se[ri+644>>2]=0|He.__str72,Se[ri+656>>2]=0|He.__str78,Se[ri+660>>2]=0|He.__str79,Se[ri+672>>2]=0|He.__str80,Se[ri+676>>2]=0|He.__str81,Se[ri+688>>2]=0|He.__str82,Se[ri+692>>2]=0|He.__str83,Se[ri+704>>2]=0|He.__str84,Se[ri+708>>2]=0|He.__str85,Se[ri+720>>2]=0|He.__str86,Se[ri+724>>2]=0|He.__str87,Se[ri+736>>2]=0|He.__str88,Se[ri+740>>2]=0|He.__str89,Se[ri+752>>2]=0|He.__str90,Se[ri+756>>2]=0|He.__str91,Se[ri+768>>2]=0|He.__str92,Se[ri+772>>2]=0|He.__str91,Se[ai>>2]=0|He.__str145315,Se[ai+8>>2]=0|He.__str145315,Se[ai+20>>2]=0|He.__str167337,Se[ai+28>>2]=0|He.__str95,Se[ai+40>>2]=0|He.__str146316,Se[ai+48>>2]=0|He.__str97,Se[ai+60>>2]=0|He.__str155325,Se[ai+68>>2]=0|He.__str155325,Se[ai+80>>2]=0|He.__str156326,Se[ai+88>>2]=0|He.__str156326,Se[ai+100>>2]=0|He.__str154324,Se[ai+108>>2]=0|He.__str154324,Se[ai+120>>2]=0|He.__str101,Se[ai+128>>2]=0|He.__str101,Se[ai+140>>2]=0|He.__str147317,Se[ai+148>>2]=0|He.__str147317,Se[ai+160>>2]=0|He.__str150320,Se[ai+168>>2]=0|He.__str150320,Se[ai+180>>2]=0|He.__str151321,Se[ai+188>>2]=0|He.__str105,Se[ai+220>>2]=0|He.__str152322,Se[ai+228>>2]=0|He.__str152322,Se[ai+240>>2]=0|He.__str153323,Se[ai+248>>2]=0|He.__str153323,Se[ai+260>>2]=0|He.__str165335,Se[ai+268>>2]=0|He.__str165335,Se[ai+280>>2]=0|He.__str166336,Se[ai+288>>2]=0|He.__str166336,Se[ai+360>>2]=0|He.__str148318,Se[ai+368>>2]=0|He.__str148318,Se[ai+380>>2]=0|He.__str149319,Se[ai+388>>2]=0|He.__str149319,Se[ai+420>>2]=0|He.__str84254,Se[ai+428>>2]=0|He.__str84254,Se[ai+440>>2]=0|He.__str168338,Se[ai+448>>2]=0|He.__str146316,Se[ai+460>>2]=0|He.__str114,Se[ai+468>>2]=0|He.__str152322,Se[ai+480>>2]=0|He.__str115,Se[ai+488>>2]=0|He.__str115,Se[ai+500>>2]=0|He.__str110280,Se[ai+508>>2]=0|He.__str110280,Se[ei+4>>2]=0|He.__str152,Se[ei+12>>2]=0|He.__str152,Se[ei+32>>2]=0|He.__str153,Se[ei+40>>2]=0|He.__str153,Se[ei+48>>2]=0|He.__str154,Se[ei+60>>2]=0|He.__str155,Se[ei+68>>2]=0|He.__str155,Se[ei+76>>2]=0|He.__str156,Se[ei+88>>2]=0|He.__str157,Se[ei+96>>2]=0|He.__str158,Se[ei+104>>2]=0|He.__str156,Se[ei+116>>2]=0|He.__str159,Se[ei+124>>2]=0|He.__str160,Se[ei+132>>2]=0|He.__str161,Se[ei+144>>2]=0|He.__str162,Se[ei+152>>2]=0|He.__str163,Se[ei+160>>2]=0|He.__str164,Se[ei+172>>2]=0|He.__str165,Se[ei+180>>2]=0|He.__str166,Se[ei+188>>2]=0|He.__str167,Se[si+4>>2]=bi,Se[ni+4>>2]=ki,oi=_([2,0,0,0,0],[\"i8*\",0,0,0,0],we),Se[bi>>2]=oi+8|0,Se[bi+4>>2]=0|He.__ZTSSt9bad_alloc,Se[bi+8>>2]=li,Se[ki>>2]=oi+8|0,Se[ki+4>>2]=0|He.__ZTSSt20bad_array_new_length,Se[ki+8>>2]=bi,ui=16,ci=6,hi=18,di=6,wi=6,pe=[0,0,Jr,0,va,0,ya,0,ga,0,wa,0,Sa,0,pa,0,Ea,0,ma,0],Module.FUNCTION_TABLE=pe,Module.run=ee,Module.preRun&&Module.preRun(),0==Ke){ee()}Module.postRun&&Module.postRun(),Module.___cxa_demangle=G;var pi=v(\"__cxa_demangle\",\"string\",[\"string\",\"string\",\"number\",\"number\"]);return function(r){return pi(r,\"\",1,0)}}();\\n'},function(e,r,a){\"use strict\";function t(e){const r=[];return function e(a){r.push({id:a.id,callFrame:{columnNumber:0,functionName:a.functionName,lineNumber:a.lineNumber,scriptId:a.scriptId,url:a.url},hitCount:a.hitCount,children:a.children.map(e=>e.id)}),a.children.forEach(e)}(e),r}Object.defineProperty(r,\"__esModule\",{value:!0}),r.chromeTreeToNodes=void 0,r.chromeTreeToNodes=function(e){return{samples:e.samples,startTime:1e6*e.startTime,endTime:1e6*e.endTime,nodes:t(e.head),timeDeltas:(r=e.timestamps,a=e.startTime,r.map((e,t)=>e-(0===t?1e6*a:r[t-1])))};var r,a}},function(e,r,a){\"use strict\";Object.defineProperty(r,\"__esModule\",{value:!0}),r.Flamechart=void 0;const t=a(0),i=a(11);r.Flamechart=class{constructor(e){this.source=e,this.layers=[],this.totalWeight=0,this.minFrameWidth=1;const r=[];this.minFrameWidth=1/0;this.totalWeight=e.getTotalWeight(),e.forEachCall((e,a)=>{const i=t.lastOf(r),n={node:e,parent:i,children:[],start:a,end:a};i&&i.children.push(n),r.push(n)},(e,a)=>{console.assert(r.length>0);const t=r.pop();if(t.end=a,t.end-t.start==0)return;const i=r.length;for(;this.layers.length<=i;)this.layers.push([]);this.layers[i].push(t),this.minFrameWidth=Math.min(this.minFrameWidth,t.end-t.start)}),isFinite(this.minFrameWidth)||(this.minFrameWidth=1)}getTotalWeight(){return this.totalWeight}getLayers(){return this.layers}getColorBucketForFrame(e){return this.source.getColorBucketForFrame(e)}getMinFrameWidth(){return this.minFrameWidth}formatValue(e){return this.source.formatValue(e)}getClampedViewportWidth(e){const r=this.getTotalWeight(),a=Math.pow(2,40),t=i.clamp(3*this.getMinFrameWidth(),r/a,r);return i.clamp(e,t,r)}getClampedConfigSpaceViewportRect({configSpaceViewportRect:e,renderInverted:r}){const a=new i.Vec2(this.getTotalWeight(),this.getLayers().length),t=this.getClampedViewportWidth(e.size.x),n=e.size.withX(t),s=i.Vec2.clamp(e.origin,new i.Vec2(0,r?0:-1),i.Vec2.max(i.Vec2.zero,a.minus(n).plus(new i.Vec2(0,1))));return new i.Rect(s,e.size.withX(t))}}},function(e,r,a){\"use strict\";function t(e,r,a){return e<r?r:e>a?a:e}Object.defineProperty(r,\"__esModule\",{value:!0}),r.Rect=r.AffineTransform=r.Vec2=r.clamp=void 0,r.clamp=t;let i=(()=>{class e{constructor(e,r){this.x=e,this.y=r}withX(r){return new e(r,this.y)}withY(r){return new e(this.x,r)}plus(r){return new e(this.x+r.x,this.y+r.y)}minus(r){return new e(this.x-r.x,this.y-r.y)}times(r){return new e(this.x*r,this.y*r)}timesPointwise(r){return new e(this.x*r.x,this.y*r.y)}dividedByPointwise(r){return new e(this.x/r.x,this.y/r.y)}dot(e){return this.x*e.x+this.y*e.y}equals(e){return this.x===e.x&&this.y===e.y}approxEquals(e,r=1e-9){return Math.abs(this.x-e.x)<r&&Math.abs(this.y-e.y)<r}length2(){return this.dot(this)}length(){return Math.sqrt(this.length2())}abs(){return new e(Math.abs(this.x),Math.abs(this.y))}static min(r,a){return new e(Math.min(r.x,a.x),Math.min(r.y,a.y))}static max(r,a){return new e(Math.max(r.x,a.x),Math.max(r.y,a.y))}static clamp(r,a,i){return new e(t(r.x,a.x,i.x),t(r.y,a.y,i.y))}flatten(){return[this.x,this.y]}}return e.zero=new e(0,0),e.unit=new e(1,1),e})();r.Vec2=i;class n{constructor(e=1,r=0,a=0,t=0,i=1,n=0){this.m00=e,this.m01=r,this.m02=a,this.m10=t,this.m11=i,this.m12=n}withScale(e){let{m00:r,m01:a,m02:t,m10:i,m11:s,m12:v}=this;return r=e.x,s=e.y,new n(r,a,t,i,s,v)}static withScale(e){return(new n).withScale(e)}scaledBy(e){return n.withScale(e).times(this)}getScale(){return new i(this.m00,this.m11)}withTranslation(e){let{m00:r,m01:a,m02:t,m10:i,m11:s,m12:v}=this;return t=e.x,v=e.y,new n(r,a,t,i,s,v)}static withTranslation(e){return(new n).withTranslation(e)}getTranslation(){return new i(this.m02,this.m12)}translatedBy(e){return n.withTranslation(e).times(this)}static betweenRects(e,r){return n.withTranslation(e.origin.times(-1)).scaledBy(new i(r.size.x/e.size.x,r.size.y/e.size.y)).translatedBy(r.origin)}times(e){const r=this.m00*e.m00+this.m01*e.m10,a=this.m00*e.m01+this.m01*e.m11,t=this.m00*e.m02+this.m01*e.m12+this.m02,i=this.m10*e.m00+this.m11*e.m10,s=this.m10*e.m01+this.m11*e.m11,v=this.m10*e.m02+this.m11*e.m12+this.m12;return new n(r,a,t,i,s,v)}equals(e){return this.m00==e.m00&&this.m01==e.m01&&this.m02==e.m02&&this.m10==e.m10&&this.m11==e.m11&&this.m12==e.m12}approxEquals(e,r=1e-9){return Math.abs(this.m00-e.m00)<r&&Math.abs(this.m01-e.m01)<r&&Math.abs(this.m02-e.m02)<r&&Math.abs(this.m10-e.m10)<r&&Math.abs(this.m11-e.m11)<r&&Math.abs(this.m12-e.m12)<r}timesScalar(e){const{m00:r,m01:a,m02:t,m10:i,m11:s,m12:v}=this;return new n(e*r,e*a,e*t,e*i,e*s,e*v)}det(){const{m00:e,m01:r,m02:a,m10:t,m11:i,m12:n}=this;return e*(1*i-0*n)-r*(1*t-0*n)+a*(0*t-0*i)}adj(){const{m00:e,m01:r,m02:a,m10:t,m11:i,m12:s}=this;return new n(+(1*i-0*s),-(1*r-0*a),+(r*s-a*i),-(1*t-0*s),+(1*e-0*a),-(e*s-a*t))}inverted(){const e=this.det();if(0===e)return null;return this.adj().timesScalar(1/e)}transformVector(e){return new i(e.x*this.m00+e.y*this.m01,e.x*this.m10+e.y*this.m11)}inverseTransformVector(e){const r=this.inverted();return r?r.transformVector(e):null}transformPosition(e){return new i(e.x*this.m00+e.y*this.m01+this.m02,e.x*this.m10+e.y*this.m11+this.m12)}inverseTransformPosition(e){const r=this.inverted();return r?r.transformPosition(e):null}transformRect(e){const r=this.transformVector(e.size),a=this.transformPosition(e.origin);return r.x<0&&r.y<0?new s(a.plus(r),r.abs()):r.x<0?new s(a.withX(a.x+r.x),r.abs()):r.y<0?new s(a.withY(a.y+r.y),r.abs()):new s(a,r)}inverseTransformRect(e){const r=this.inverted();return r?r.transformRect(e):null}flatten(){return[this.m00,this.m10,0,this.m01,this.m11,0,this.m02,this.m12,1]}}r.AffineTransform=n;let s=(()=>{class e{constructor(e,r){this.origin=e,this.size=r}isEmpty(){return 0==this.width()||0==this.height()}width(){return this.size.x}height(){return this.size.y}left(){return this.origin.x}right(){return this.left()+this.width()}top(){return this.origin.y}bottom(){return this.top()+this.height()}topLeft(){return this.origin}topRight(){return this.origin.plus(new i(this.width(),0))}bottomRight(){return this.origin.plus(this.size)}bottomLeft(){return this.origin.plus(new i(0,this.height()))}withOrigin(r){return new e(r,this.size)}withSize(r){return new e(this.origin,r)}closestPointTo(e){return new i(t(e.x,this.left(),this.right()),t(e.y,this.top(),this.bottom()))}distanceFrom(e){return e.minus(this.closestPointTo(e)).length()}contains(e){return 0===this.distanceFrom(e)}hasIntersectionWith(e){const r=Math.max(this.top(),e.top());if(Math.max(r,Math.min(this.bottom(),e.bottom()))-r==0)return!1;const a=Math.max(this.left(),e.left());return Math.max(a,Math.min(this.right(),e.right()))-a!=0}intersectWith(r){const a=i.max(this.topLeft(),r.topLeft()),t=i.max(a,i.min(this.bottomRight(),r.bottomRight()));return new e(a,t.minus(a))}equals(e){return this.origin.equals(e.origin)&&this.size.equals(e.size)}approxEquals(e){return this.origin.approxEquals(e.origin)&&this.size.approxEquals(e.size)}area(){return this.size.x*this.size.y}}return e.empty=new e(i.zero,i.zero),e.unit=new e(i.zero,i.unit),e.NDC=new e(new i(-1,-1),new i(2,2)),e})();r.Rect=s},function(e,r,a){var t,i,n;!function(a,s){\"use strict\";i=[],void 0===(n=\"function\"==typeof(t=function(){function e(e){return e.charAt(0).toUpperCase()+e.substring(1)}function r(e){return function(){return this[e]}}var a=[\"isConstructor\",\"isEval\",\"isNative\",\"isToplevel\"],t=[\"columnNumber\",\"lineNumber\"],i=[\"fileName\",\"functionName\",\"source\"],n=a.concat(t,i,[\"args\"]);function s(r){if(r)for(var a=0;a<n.length;a++)void 0!==r[n[a]]&&this[\"set\"+e(n[a])](r[n[a]])}s.prototype={getArgs:function(){return this.args},setArgs:function(e){if(\"[object Array]\"!==Object.prototype.toString.call(e))throw new TypeError(\"Args must be an Array\");this.args=e},getEvalOrigin:function(){return this.evalOrigin},setEvalOrigin:function(e){if(e instanceof s)this.evalOrigin=e;else{if(!(e instanceof Object))throw new TypeError(\"Eval Origin must be an Object or StackFrame\");this.evalOrigin=new s(e)}},toString:function(){var e=this.getFileName()||\"\",r=this.getLineNumber()||\"\",a=this.getColumnNumber()||\"\",t=this.getFunctionName()||\"\";return this.getIsEval()?e?\"[eval] (\"+e+\":\"+r+\":\"+a+\")\":\"[eval]:\"+r+\":\"+a:t?t+\" (\"+e+\":\"+r+\":\"+a+\")\":e+\":\"+r+\":\"+a}},s.fromString=function(e){var r=e.indexOf(\"(\"),a=e.lastIndexOf(\")\"),t=e.substring(0,r),i=e.substring(r+1,a).split(\",\"),n=e.substring(a+1);if(0===n.indexOf(\"@\"))var v=/@(.+?)(?::(\\d+))?(?::(\\d+))?$/.exec(n,\"\"),o=v[1],f=v[2],l=v[3];return new s({functionName:t,args:i||void 0,fileName:o,lineNumber:f||void 0,columnNumber:l||void 0})};for(var v=0;v<a.length;v++)s.prototype[\"get\"+e(a[v])]=r(a[v]),s.prototype[\"set\"+e(a[v])]=function(e){return function(r){this[e]=Boolean(r)}}(a[v]);for(var o=0;o<t.length;o++)s.prototype[\"get\"+e(t[o])]=r(t[o]),s.prototype[\"set\"+e(t[o])]=function(e){return function(r){if(a=r,isNaN(parseFloat(a))||!isFinite(a))throw new TypeError(e+\" must be a Number\");var a;this[e]=Number(r)}}(t[o]);for(var f=0;f<i.length;f++)s.prototype[\"get\"+e(i[f])]=r(i[f]),s.prototype[\"set\"+e(i[f])]=function(e){return function(r){this[e]=String(r)}}(i[f]);return s})?t.apply(r,i):t)||(e.exports=n)}()},function(e,r,a){\"use strict\";a.r(r),a.d(r,\"importFile\",(function(){return M}));a(5);var t=a(1);const i={\"--font-size-monospace-small\":\"9px\",\"--font-size-monospace-normal\":\"11px\",\"--font-size-monospace-large\":\"15px\",\"--font-size-sans-small\":\"10px\",\"--font-size-sans-normal\":\"12px\",\"--font-size-sans-large\":\"14px\",\"--line-height-data\":\"18px\"};parseInt({\"--font-size-monospace-small\":\"10px\",\"--font-size-monospace-normal\":\"13px\",\"--font-size-monospace-large\":\"17px\",\"--font-size-sans-small\":\"12px\",\"--font-size-sans-normal\":\"14px\",\"--font-size-sans-large\":\"16px\",\"--line-height-data\":\"22px\"}[\"--line-height-data\"],10),parseInt(i[\"--line-height-data\"],10);class n extends Error{}function s(e,r){if(e.length!==r.length)return!1;for(var a=0;a<e.length;a++)if(e[a]!==r[a])return!1;return!0}const v=function(e,r){var a;void 0===r&&(r=s);var t,i=[],n=!1;return function(){for(var s=[],v=0;v<arguments.length;v++)s[v]=arguments[v];return n&&a===this&&r(s,i)||(t=e.apply(this,s),n=!0,a=this,i=s),t}}((function(e,r,a=0){const t=r.batchUIDToMeasuresMap.get(e);if(null==t||0===t.length)throw Error(`Could not find measures with batch UID \"${e}\"`);const i=t[t.length-1],n=i.timestamp+i.duration;if(n<a)return[0,0];let s=a;for(let e=0;e<t.length;e++){const r=t[e];if(r.timestamp>=a){s=r.timestamp;break}}return[s,n]}));var o=a(3),f=a.n(o);const l=\"An event handler scheduled a big update with React. Consider using the Transition API to defer some of this work.\",_=\"A component suspended during an update which caused a fallback to be shown. Consider using the Transition API to avoid hiding components after they've been mounted.\";function u(e){const r=parseInt(e,10);if(r<0)return[];const a=[];let t=0;for(;t<=31;)1<<t&r&&a.push(t),t++;return a}let S=null;function c(e,r,a,t,i){const{batchUID:n,measureStack:s}=i,v=function(e){if(e.length>0){const{depth:r,type:a}=e[e.length-1];return\"render-idle\"===a?r:r+1}return 0}(s),o={type:e,batchUID:n,depth:v,lanes:a,timestamp:r,duration:0};i.measureStack.push({depth:v,measure:o,startTime:r,type:e});const f=t.batchUIDToMeasuresMap.get(n);null!=f?f.push(o):t.batchUIDToMeasuresMap.set(i.batchUID,[o]),a.forEach(e=>{t.laneToReactMeasureMap.get(e).push(o)})}function h(e,r,a,t){if(0===t.length)return void console.error('Unexpected type \"%s\" completed at %sms while stack is empty.',e,r);const i=t[t.length-1];i.type!==e&&console.error('Unexpected type \"%s\" completed at %sms before \"%s\" completed.',e,r,i.type);const{measure:n,startTime:s}=t.pop();n||console.error('Could not find matching measure for type \"%s\".',e),n.duration=r-s}function d(e,r,a){const{cat:t,name:i,ts:s,ph:v}=e,o=(s-r.startTime)/1e3;switch(t){case\"disabled-by-default-devtools.screenshot\":!function(e,r,a,t){const i={height:0,image:null,imageSource:\"data:image/png;base64,\"+e.args.snapshot,timestamp:r,width:0};let n=null;t.asyncProcessingPromises.push(new Promise(e=>{n=e})),fetch(i.imageSource).then(e=>e.blob()).then(e=>{createImageBitmap(e).then(e=>{i.height=e.height,i.width=e.width,n()})}),a.snapshots.push(i)}(e,o,r,a);break;case\"devtools.timeline\":switch(i){case\"EventDispatch\":!function(e,r,a,t){const i=e.args.data,n=i.type;if(n.startsWith(\"react-\")){const e=i.stackTrace;if(e){if(e[e.length-1].url.includes(\"/react-dom.\"))return}}if(\"blur\"===n||\"click\"===n||\"input\"===n||n.startsWith(\"focus\")||n.startsWith(\"key\")||n.startsWith(\"mouse\")||n.startsWith(\"pointer\")){const i=e.dur/1e3;let s=0;for(;t.nativeEventStack.length>0;){const e=t.nativeEventStack[t.nativeEventStack.length-1];if(r<e.timestamp+e.duration){s=e.depth+1;break}t.nativeEventStack.pop()}const v={depth:s,duration:i,timestamp:r,type:n,warning:null};a.nativeEvents.push(v),t.nativeEventStack.push(v)}}(e,o,r,a);break;case\"ResourceFinish\":!function(e,r,a,t){const i=e.args.data.requestId,n=t.requestIdToNetworkMeasureMap.get(i);null!=n&&(n.finishTimestamp=r,0===n.firstReceivedDataTimestamp&&(n.firstReceivedDataTimestamp=r),0===n.lastReceivedDataTimestamp&&(n.lastReceivedDataTimestamp=r),t.requestIdToNetworkMeasureMap.delete(e.args.data.requestId))}(e,o,0,a);break;case\"ResourceReceivedData\":!function(e,r,a,t){const i=e.args.data.requestId,n=t.requestIdToNetworkMeasureMap.get(i);null!=n&&(0===n.firstReceivedDataTimestamp&&(n.firstReceivedDataTimestamp=r),n.lastReceivedDataTimestamp=r,n.finishTimestamp=r)}(e,o,0,a);break;case\"ResourceReceiveResponse\":!function(e,r,a,t){const i=e.args.data.requestId,n=t.requestIdToNetworkMeasureMap.get(i);null!=n&&(n.receiveResponseTimestamp=r)}(e,o,0,a);break;case\"ResourceSendRequest\":!function(e,r,a,t){const i=e.args.data,n=i.requestId,s=new Array(t.requestIdToNetworkMeasureMap.size+1).fill(!0);t.requestIdToNetworkMeasureMap.forEach(({depth:e})=>{s[e]=!1});let v=0;for(let e=0;e<s.length;e++)if(s[e]){v=e;break}const o={depth:v,finishTimestamp:0,firstReceivedDataTimestamp:0,lastReceivedDataTimestamp:0,requestId:n,requestMethod:i.requestMethod,priority:i.priority,sendRequestTimestamp:r,receiveResponseTimestamp:0,url:i.url};t.requestIdToNetworkMeasureMap.set(n,o),a.networkMeasures.push(o),o.sendRequestTimestamp=r}(e,o,r,a)}break;case\"blink.user_timing\":if(i.startsWith(\"--react-version-\")){const[e]=i.substr(16).split(\"-\");r.reactVersion=e}else if(i.startsWith(\"--profiler-version-\")){const[e]=i.substr(19).split(\"-\");if(S=parseInt(e,10),1!==S)throw new n(`This version of profiling data (${e}) is not supported by the current profiler.`)}else if(i.startsWith(\"--react-lane-labels-\")){const[e]=i.substr(20).split(\"-\");!function(e,r){if(0===e.laneToLabelMap.size){const a=r.split(\",\");for(let r=0;r<a.length;r++)e.laneToLabelMap.set(r,a[r])}}(r,e)}else if(i.startsWith(\"--component-\"))!function(e,r,a,t){if(e.startsWith(\"--component-render-start-\")){const[a]=e.substr(25).split(\"-\");b(t),t.currentReactComponentMeasure={componentName:a,timestamp:r,duration:0,type:\"render\",warning:null}}else if(\"--component-render-stop\"===e){if(p(t,\"render\"),null!==t.currentReactComponentMeasure){const e=t.currentReactComponentMeasure;e.duration=r-e.timestamp,t.currentReactComponentMeasure=null,a.componentMeasures.push(e)}}else if(e.startsWith(\"--component-layout-effect-mount-start-\")){const[a]=e.substr(38).split(\"-\");b(t),t.currentReactComponentMeasure={componentName:a,timestamp:r,duration:0,type:\"layout-effect-mount\",warning:null}}else if(\"--component-layout-effect-mount-stop\"===e){if(p(t,\"layout-effect-mount\"),null!==t.currentReactComponentMeasure){const e=t.currentReactComponentMeasure;e.duration=r-e.timestamp,t.currentReactComponentMeasure=null,a.componentMeasures.push(e)}}else if(e.startsWith(\"--component-layout-effect-unmount-start-\")){const[a]=e.substr(40).split(\"-\");b(t),t.currentReactComponentMeasure={componentName:a,timestamp:r,duration:0,type:\"layout-effect-unmount\",warning:null}}else if(\"--component-layout-effect-unmount-stop\"===e){if(p(t,\"layout-effect-unmount\"),null!==t.currentReactComponentMeasure){const e=t.currentReactComponentMeasure;e.duration=r-e.timestamp,t.currentReactComponentMeasure=null,a.componentMeasures.push(e)}}else if(e.startsWith(\"--component-passive-effect-mount-start-\")){const[a]=e.substr(39).split(\"-\");b(t),t.currentReactComponentMeasure={componentName:a,timestamp:r,duration:0,type:\"passive-effect-mount\",warning:null}}else if(\"--component-passive-effect-mount-stop\"===e){if(p(t,\"passive-effect-mount\"),null!==t.currentReactComponentMeasure){const e=t.currentReactComponentMeasure;e.duration=r-e.timestamp,t.currentReactComponentMeasure=null,a.componentMeasures.push(e)}}else if(e.startsWith(\"--component-passive-effect-unmount-start-\")){const[a]=e.substr(41).split(\"-\");b(t),t.currentReactComponentMeasure={componentName:a,timestamp:r,duration:0,type:\"passive-effect-unmount\",warning:null}}else if(\"--component-passive-effect-unmount-stop\"===e&&(p(t,\"passive-effect-unmount\"),null!==t.currentReactComponentMeasure)){const e=t.currentReactComponentMeasure;e.duration=r-e.timestamp,t.currentReactComponentMeasure=null,a.componentMeasures.push(e)}}(i,o,r,a);else if(i.startsWith(\"--schedule-render-\")){const[e]=i.substr(18).split(\"-\");r.schedulingEvents.push({type:\"schedule-render\",lanes:u(e),timestamp:o,warning:null})}else if(i.startsWith(\"--schedule-forced-update-\")){const[e,t]=i.substr(25).split(\"-\"),n={type:\"schedule-force-update\",lanes:u(e),componentName:t,timestamp:o,warning:null};a.measureStack.find(({type:e})=>\"commit\"===e)&&(a.potentialLongNestedUpdate=n),r.schedulingEvents.push(n)}else if(i.startsWith(\"--schedule-state-update-\")){const[e,t]=i.substr(24).split(\"-\"),n={type:\"schedule-state-update\",lanes:u(e),componentName:t,timestamp:o,warning:null};a.measureStack.find(({type:e})=>\"commit\"===e)&&(a.potentialLongNestedUpdate=n),r.schedulingEvents.push(n)}else if(i.startsWith(\"--error-\")){const[e,a,t]=i.substr(8).split(\"-\");r.thrownErrors.push({componentName:e,message:t,phase:a,timestamp:o,type:\"thrown-error\"})}else if(i.startsWith(\"--suspense-suspend-\")){const[e,t,n,s,v]=i.substr(19).split(\"-\"),f=u(s),l=new Array(a.unresolvedSuspenseEvents.size+1).fill(!0);a.unresolvedSuspenseEvents.forEach(({depth:e})=>{l[e]=!1});let _=0;for(let e=0;e<l.length;e++)if(l[e]){_=e;break}const S={componentName:t,depth:_,duration:null,id:e,phase:n,promiseName:v||null,resolution:\"unresolved\",timestamp:o,type:\"suspense\",warning:null};\"update\"===n&&a.potentialSuspenseEventsOutsideOfTransition.push([S,f]),r.suspenseEvents.push(S),a.unresolvedSuspenseEvents.set(e,S)}else if(i.startsWith(\"--suspense-resolved-\")){const[e]=i.substr(20).split(\"-\"),r=a.unresolvedSuspenseEvents.get(e);null!=r&&(a.unresolvedSuspenseEvents.delete(e),r.duration=o-r.timestamp,r.resolution=\"resolved\")}else if(i.startsWith(\"--suspense-rejected-\")){const[e]=i.substr(20).split(\"-\"),r=a.unresolvedSuspenseEvents.get(e);null!=r&&(a.unresolvedSuspenseEvents.delete(e),r.duration=o-r.timestamp,r.resolution=\"rejected\")}else if(i.startsWith(\"--render-start-\")){a.nextRenderShouldGenerateNewBatchID&&(a.nextRenderShouldGenerateNewBatchID=!1,a.batchUID=a.uidCounter++),null!==a.potentialLongNestedUpdate&&(a.potentialLongNestedUpdates.push([a.potentialLongNestedUpdate,a.batchUID]),a.potentialLongNestedUpdate=null);const[e]=i.substr(15).split(\"-\");!function(e,r){const a=r.length-1;if(a>=0){const t=r[a];if(void 0===t.stopTime&&t.type===e)throw new n(`Unexpected type \"${e}\" started before \"${t.type}\" completed.`)}}(\"render\",a.measureStack),\"render-idle\"!==function(e){if(e.length>0){const{type:r}=e[e.length-1];return r}return null}(a.measureStack)&&c(\"render-idle\",o,u(e),r,a),c(\"render\",o,u(e),r,a);for(let e=0;e<a.nativeEventStack.length;e++){const r=a.nativeEventStack[e];r.timestamp+r.duration>o&&a.potentialLongEvents.push([r,a.batchUID])}}else if(i.startsWith(\"--render-stop\")||i.startsWith(\"--render-yield\"))h(\"render\",o,0,a.measureStack);else if(i.startsWith(\"--commit-start-\")){a.nextRenderShouldGenerateNewBatchID=!0;const[e]=i.substr(15).split(\"-\");c(\"commit\",o,u(e),r,a)}else if(i.startsWith(\"--commit-stop\"))h(\"commit\",o,0,a.measureStack),h(\"render-idle\",o,0,a.measureStack);else if(i.startsWith(\"--layout-effects-start-\")){const[e]=i.substr(23).split(\"-\");c(\"layout-effects\",o,u(e),r,a)}else if(i.startsWith(\"--layout-effects-stop\"))h(\"layout-effects\",o,0,a.measureStack);else if(i.startsWith(\"--passive-effects-start-\")){const[e]=i.substr(24).split(\"-\");c(\"passive-effects\",o,u(e),r,a)}else if(i.startsWith(\"--passive-effects-stop\"))h(\"passive-effects\",o,0,a.measureStack);else if(i.startsWith(\"--react-internal-module-start-\")){const e=i.substr(30);if(!a.internalModuleStackStringSet.has(e)){a.internalModuleStackStringSet.add(e);const r=m(e);a.internalModuleCurrentStackFrame=r}}else if(i.startsWith(\"--react-internal-module-stop-\")){const e=i.substr(29);if(!a.internalModuleStackStringSet.has(e)){a.internalModuleStackStringSet.add(e);const t=m(e);if(null!==t&&null!==a.internalModuleCurrentStackFrame){const e=a.internalModuleCurrentStackFrame;a.internalModuleCurrentStackFrame=null;const i=[e,t],n=r.internalModuleSourceToRanges.get(e.fileName);null==n?r.internalModuleSourceToRanges.set(e.fileName,[i]):n.push(i)}}}else if(\"R\"===v||\"n\"===v)r.otherUserTimingMarks.push({name:i,timestamp:o});else if(\"b\"===v);else if(\"e\"===v);else if(\"i\"!==v&&\"I\"!==v)throw new n(`Unrecognized event ${JSON.stringify(e)}! This is likely a bug in this profiler tool.`)}}function b(e){null!==e.currentReactComponentMeasure&&console.error(\"Component measure started while another measure in progress:\",e.currentReactComponentMeasure)}function p(e,r){null===e.currentReactComponentMeasure?console.error(`Component measure type \"${r}\" stopped while no measure was in progress`):e.currentReactComponentMeasure.type!==r&&console.error(`Component measure type \"${r}\" stopped while type ${e.currentReactComponentMeasure.type} in progress`)}function m(e){const r=new Error;r.stack=e;const a=f.a.parse(r);return 1===a.length?a[0]:null}async function k(e){const r=function(e){let r;try{r=Object(t.importFromChromeTimeline)(e,\"react-devtools\")}catch(e){const r=new n(e.message);throw r.stack=e.stack,r}const a=r.profiles[0];return new t.Flamechart({getTotalWeight:a.getTotalWeight.bind(a),forEachCall:a.forEachCall.bind(a),formatValue:a.formatValue.bind(a),getColorBucketForFrame:()=>0}).getLayers().map(e=>e.map(({start:e,end:r,node:{frame:{name:a,file:t,line:i,col:n}}})=>({name:a,timestamp:e/1e3,duration:(r-e)/1e3,scriptUrl:t,locationLine:i,locationColumn:n})))}(e),a=new Map;for(let e=0;e<31;e++)a.set(e,[]);const i={batchUIDToMeasuresMap:new Map,componentMeasures:[],duration:0,flamechart:r,internalModuleSourceToRanges:new Map,laneToLabelMap:new Map,laneToReactMeasureMap:a,nativeEvents:[],networkMeasures:[],otherUserTimingMarks:[],reactVersion:null,schedulingEvents:[],snapshots:[],snapshotHeight:0,startTime:0,suspenseEvents:[],thrownErrors:[]},s=(e=e.filter(Boolean).sort((e,r)=>e.ts>r.ts?1:-1)).findIndex(e=>\"Profile\"===e.name);if(-1===s)return i;i.startTime=e[s].args.data.startTime,i.duration=(e[e.length-1].ts-i.startTime)/1e3;const o={asyncProcessingPromises:[],batchUID:0,currentReactComponentMeasure:null,internalModuleCurrentStackFrame:null,internalModuleStackStringSet:new Set,measureStack:[],nativeEventStack:[],nextRenderShouldGenerateNewBatchID:!0,potentialLongEvents:[],potentialLongNestedUpdate:null,potentialLongNestedUpdates:[],potentialSuspenseEventsOutsideOfTransition:[],requestIdToNetworkMeasureMap:new Map,uidCounter:0,unresolvedSuspenseEvents:new Map};if(e.forEach(e=>d(e,i,o)),null===S){if(0===i.schedulingEvents.length&&0===i.batchUIDToMeasuresMap.size)throw new n(\"No React marks were found in the provided profile. Please provide profiling data from an React application running in development or profiling mode.\");throw new n(\"This version of profiling data is not supported by the current profiler.\")}const{measureStack:f}=o;if(f.length>0&&console.error(\"Incomplete events or measures\",f),o.potentialLongEvents.forEach(([e,r])=>{const[a,t]=v(r,i,e.timestamp);t-a>20&&(e.warning=l)}),o.potentialLongNestedUpdates.forEach(([e,r])=>{const[a,t]=v(r,i);t-a>20&&e.lanes.some(e=>\"Transition\"===i.laneToLabelMap.get(e))}),o.potentialSuspenseEventsOutsideOfTransition.forEach(([e,r])=>{r.some(e=>\"Transition\"===i.laneToLabelMap.get(e))||(e.warning=_)}),await Promise.all(o.asyncProcessingPromises),i.snapshots.length>0){const e=i.snapshots[0];i.snapshotHeight=Math.min(e.height,60)}return i}var w=a(4),g=a.n(w);const M=async function(e){try{const r=await(e=>{if(!e.name.endsWith(\".json\"))throw new n(\"Invalid file type. Only JSON performance profiles are supported\");const r=new FileReader;return new Promise((a,t)=>{r.onload=()=>{const e=g()(r.result);\"string\"==typeof e&&a(e),t(new n(\"Input file was not read as a string\"))},r.onerror=()=>t(r.error),r.readAsText(e)})})(e),a=JSON.parse(r);if(0===a.length)throw new n(\"No profiling data found in file.\");return{status:\"SUCCESS\",processedData:await k(a)}}catch(e){return e instanceof n?{status:\"INVALID_PROFILE_ERROR\",error:e}:{status:\"UNEXPECTED_ERROR\",error:e}}};addEventListener(\"message\",(function(e){var a,t=e.data,i=t.type,n=t.method,s=t.id,v=t.params;\"RPC\"===i&&n&&((a=r[n])?Promise.resolve().then((function(){return a.apply(r,v)})):Promise.reject(\"No such method\")).then((function(e){postMessage({type:\"RPC\",id:s,result:e})})).catch((function(e){var r={message:e};e.stack&&(r.message=e.message,r.stack=e.stack,r.name=e.name),postMessage({type:\"RPC\",id:s,error:r})}))})),postMessage({type:\"RPC\",method:\"ready\"})}]);\n//# sourceMappingURL=importFile.worker.worker.js.map"])), {
      name: "importFile.worker.worker.js"
    });
    return n(e, a), e;
  };
}, function (e, r, t) {
  var n = t(201);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  var n = t(204);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r) {
  r.quote = function (e) {
    return e.map(function (e) {
      return e && "object" == typeof e ? e.op.replace(/(.)/g, "\\$1") : /["\s]/.test(e) && !/'/.test(e) ? "'" + e.replace(/(['\\])/g, "\\$1") + "'" : /["'\s]/.test(e) ? "\"" + e.replace(/(["\\$`!])/g, "\\$1") + "\"" : e = (e = String(e).replace(/([A-z]:)?([#!"$&'()*,:;<=>?@\[\\\]^`{|}])/g, "$1\\$2")).replace(/\\\\/g, "\\");
    }).join(" ");
  };
  for (var t = "(?:" + ["\\|\\|", "\\&\\&", ";;", "\\|\\&", "\\<\\(", ">>", ">\\&", "[&;()|<>]"].join("|") + ")", n = "", a = 0; a < 4; a++) n += (Math.pow(16, 8) * Math.random()).toString(16);
  r.parse = function (e, r, a) {
    var i = function (e, r, a) {
      var i = new RegExp(["(" + t + ")", "((\\\\['\"|&;()<> \\t]|[^\\s'\"|&;()<> \\t])+|\"((\\\\\"|[^\"])*?)\"|'((\\\\'|[^'])*?)')*"].join("|"), "g"),
        o = e.match(i).filter(Boolean),
        s = !1;
      if (!o) return [];
      r || (r = {});
      a || (a = {});
      return o.map(function (e, i) {
        if (!s) {
          if (RegExp("^" + t + "$").test(e)) return {
            op: e
          };
          for (var l = a.escape || "\\", c = !1, u = !1, f = "", d = !1, v = 0, h = e.length; v < h; v++) {
            var m = e.charAt(v);
            if (d = d || !c && ("*" === m || "?" === m), u) f += m, u = !1;else if (c) m === c ? c = !1 : "'" == c ? f += m : m === l ? (v += 1, f += "\"" === (m = e.charAt(v)) || m === l || "$" === m ? m : l + m) : f += "$" === m ? _() : m;else if ("\"" === m || "'" === m) c = m;else {
              if (RegExp("^" + t + "$").test(m)) return {
                op: e
              };
              if (RegExp("^#$").test(m)) return s = !0, f.length ? [f, {
                comment: e.slice(v + 1) + o.slice(i + 1).join(" ")
              }] : [{
                comment: e.slice(v + 1) + o.slice(i + 1).join(" ")
              }];
              m === l ? u = !0 : f += "$" === m ? _() : m;
            }
          }
          return d ? {
            op: "glob",
            pattern: f
          } : f;
        }
        function _() {
          var t, a;
          if (v += 1, "{" === e.charAt(v)) {
            if (v += 1, "}" === e.charAt(v)) throw new Error("Bad substitution: " + e.substr(v - 2, 3));
            if ((t = e.indexOf("}", v)) < 0) throw new Error("Bad substitution: " + e.substr(v));
            a = e.substr(v, t - v), v = t;
          } else /[*@#?$!_\-]/.test(e.charAt(v)) ? (a = e.charAt(v), v += 1) : (t = e.substr(v).match(/[^\w\d_]/)) ? (a = e.substr(v, t.index), v += t.index - 1) : (a = e.substr(v), v = e.length);
          return function (e, t, a) {
            var i = "function" == typeof r ? r(a) : r[a];
            void 0 === i && "" != a ? i = "" : void 0 === i && (i = "$");
            return "object" == typeof i ? t + n + JSON.stringify(i) + n : t + i;
          }(0, "", a);
        }
      }).reduce(function (e, r) {
        return void 0 === r ? e : e.concat(r);
      }, []);
    }(e, r, a);
    return "function" != typeof r ? i : i.reduce(function (e, r) {
      if ("object" == typeof r) return e.concat(r);
      var t = r.split(RegExp("(" + n + ".*?" + n + ")", "g"));
      return 1 === t.length ? e.concat(t[0]) : e.concat(t.filter(Boolean).map(function (e) {
        return RegExp("^" + n).test(e) ? JSON.parse(e.split(n)[1]) : e;
      }));
    }, []);
  };
}, function (e, r) {
  e.exports = function (e, r) {
    var t = 0,
      n = {};
    e.addEventListener("message", function (r) {
      var t = r.data;
      if ("RPC" === t.type) if (t.id) {
        var a = n[t.id];
        a && (delete n[t.id], t.error ? a[1](Object.assign(Error(t.error.message), t.error)) : a[0](t.result));
      } else {
        var i = document.createEvent("Event");
        i.initEvent(t.method, !1, !1), i.data = t.params, e.dispatchEvent(i);
      }
    }), r.forEach(function (r) {
      e[r] = function () {
        var a = arguments;
        return new Promise(function (i, o) {
          var s = ++t;
          n[s] = [i, o], e.postMessage({
            type: "RPC",
            id: s,
            method: r,
            params: [].slice.call(a)
          });
        });
      };
    });
  };
}, function (e, r, t) {
  "use strict";

  /**
   * @license React
   * react.production.min.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var n = Symbol.for("react.element"),
    a = Symbol.for("react.portal"),
    i = Symbol.for("react.fragment"),
    o = Symbol.for("react.strict_mode"),
    s = Symbol.for("react.profiler"),
    l = Symbol.for("react.provider"),
    c = Symbol.for("react.context"),
    u = Symbol.for("react.server_context"),
    f = Symbol.for("react.forward_ref"),
    d = Symbol.for("react.suspense"),
    v = Symbol.for("react.suspense_list"),
    h = Symbol.for("react.memo"),
    m = Symbol.for("react.lazy"),
    _ = Symbol.for("react.debug_trace_mode"),
    p = Symbol.for("react.offscreen"),
    g = Symbol.for("react.cache"),
    b = Symbol.for("react.default_value"),
    S = Symbol.iterator;
  var E = {
      isMounted: function () {
        return !1;
      },
      enqueueForceUpdate: function () {},
      enqueueReplaceState: function () {},
      enqueueSetState: function () {}
    },
    w = Object.assign,
    y = {};
  function k(e, r, t) {
    (this || _global).props = e, (this || _global).context = r, (this || _global).refs = y, (this || _global).updater = t || E;
  }
  function C() {}
  function D(e, r, t) {
    (this || _global).props = e, (this || _global).context = r, (this || _global).refs = y, (this || _global).updater = t || E;
  }
  k.prototype.isReactComponent = {}, k.prototype.setState = function (e, r) {
    if ("object" != typeof e && "function" != typeof e && null != e) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    (this || _global).updater.enqueueSetState(this || _global, e, r, "setState");
  }, k.prototype.forceUpdate = function (e) {
    (this || _global).updater.enqueueForceUpdate(this || _global, e, "forceUpdate");
  }, C.prototype = k.prototype;
  var A = D.prototype = new C();
  A.constructor = D, w(A, k.prototype), A.isPureReactComponent = !0;
  var M = Array.isArray,
    x = Object.prototype.hasOwnProperty,
    O = {
      current: null
    },
    T = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function N(e, r, t) {
    var a,
      i = {},
      o = null,
      s = null;
    if (null != r) for (a in void 0 !== r.ref && (s = r.ref), void 0 !== r.key && (o = "" + r.key), r) x.call(r, a) && !T.hasOwnProperty(a) && (i[a] = r[a]);
    var l = arguments.length - 2;
    if (1 === l) i.children = t;else if (1 < l) {
      for (var c = Array(l), u = 0; u < l; u++) c[u] = arguments[u + 2];
      i.children = c;
    }
    if (e && e.defaultProps) for (a in l = e.defaultProps) void 0 === i[a] && (i[a] = l[a]);
    return {
      $$typeof: n,
      type: e,
      key: o,
      ref: s,
      props: i,
      _owner: O.current
    };
  }
  function R(e) {
    return "object" == typeof e && null !== e && e.$$typeof === n;
  }
  var I = /\/+/g;
  function H(e, r) {
    return "object" == typeof e && null !== e && null != e.key ? function (e) {
      var r = {
        "=": "=0",
        ":": "=2"
      };
      return "$" + e.replace(/[=:]/g, function (e) {
        return r[e];
      });
    }("" + e.key) : r.toString(36);
  }
  function F(e, r, t, i, o) {
    var s = typeof e;
    "undefined" !== s && "boolean" !== s || (e = null);
    var l = !1;
    if (null === e) l = !0;else switch (s) {
      case "string":
      case "number":
        l = !0;
        break;
      case "object":
        switch (e.$$typeof) {
          case n:
          case a:
            l = !0;
        }
    }
    if (l) return o = o(l = e), e = "" === i ? "." + H(l, 0) : i, M(o) ? (t = "", null != e && (t = e.replace(I, "$&/") + "/"), F(o, r, t, "", function (e) {
      return e;
    })) : null != o && (R(o) && (o = function (e, r) {
      return {
        $$typeof: n,
        type: e.type,
        key: r,
        ref: e.ref,
        props: e.props,
        _owner: e._owner
      };
    }(o, t + (!o.key || l && l.key === o.key ? "" : ("" + o.key).replace(I, "$&/") + "/") + e)), r.push(o)), 1;
    if (l = 0, i = "" === i ? "." : i + ":", M(e)) for (var c = 0; c < e.length; c++) {
      var u = i + H(s = e[c], c);
      l += F(s, r, t, u, o);
    } else if ("function" == typeof (u = function (e) {
      return null === e || "object" != typeof e ? null : "function" == typeof (e = S && e[S] || e["@@iterator"]) ? e : null;
    }(e))) for (e = u.call(e), c = 0; !(s = e.next()).done;) l += F(s = s.value, r, t, u = i + H(s, c++), o);else if ("object" === s) throw r = String(e), Error("Objects are not valid as a React child (found: " + ("[object Object]" === r ? "object with keys {" + Object.keys(e).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
    return l;
  }
  function L(e, r, t) {
    if (null == e) return e;
    var n = [],
      a = 0;
    return F(e, n, "", "", function (e) {
      return r.call(t, e, a++);
    }), n;
  }
  function P(e) {
    if (-1 === e._status) {
      var r = e._result;
      (r = r()).then(function (r) {
        0 !== e._status && -1 !== e._status || (e._status = 1, e._result = r);
      }, function (r) {
        0 !== e._status && -1 !== e._status || (e._status = 2, e._result = r);
      }), -1 === e._status && (e._status = 0, e._result = r);
    }
    if (1 === e._status) return e._result.default;
    throw e._result;
  }
  var z = {
    current: null
  };
  function B() {
    return new WeakMap();
  }
  var j = {
      current: null
    },
    V = {
      transition: null
    },
    U = {
      ReactCurrentDispatcher: j,
      ReactCurrentCache: z,
      ReactCurrentBatchConfig: V,
      ReactCurrentOwner: O,
      ContextRegistry: {}
    },
    W = U.ContextRegistry;
  r.Children = {
    map: L,
    forEach: function (e, r, t) {
      L(e, function () {
        r.apply(this || _global, arguments);
      }, t);
    },
    count: function (e) {
      var r = 0;
      return L(e, function () {
        r++;
      }), r;
    },
    toArray: function (e) {
      return L(e, function (e) {
        return e;
      }) || [];
    },
    only: function (e) {
      if (!R(e)) throw Error("React.Children.only expected to receive a single React element child.");
      return e;
    }
  }, r.Component = k, r.Fragment = i, r.Profiler = s, r.PureComponent = D, r.StrictMode = o, r.Suspense = d, r.SuspenseList = v, r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = U, r.cache = function (e) {
    return function () {
      var r = z.current;
      if (!r) return e.apply(null, arguments);
      var t = r.getCacheForType(B);
      void 0 === (r = t.get(e)) && (r = {
        s: 0,
        v: void 0,
        o: null,
        p: null
      }, t.set(e, r)), t = 0;
      for (var n = arguments.length; t < n; t++) {
        var a = arguments[t];
        if ("function" == typeof a || "object" == typeof a && null !== a) {
          var i = r.o;
          null === i && (r.o = i = new WeakMap()), void 0 === (r = i.get(a)) && (r = {
            s: 0,
            v: void 0,
            o: null,
            p: null
          }, i.set(a, r));
        } else null === (i = r.p) && (r.p = i = new Map()), void 0 === (r = i.get(a)) && (r = {
          s: 0,
          v: void 0,
          o: null,
          p: null
        }, i.set(a, r));
      }
      if (1 === r.s) return r.v;
      if (2 === r.s) throw r.v;
      try {
        var o = e.apply(null, arguments);
        return (t = r).s = 1, t.v = o;
      } catch (e) {
        throw (o = r).s = 2, o.v = e, e;
      }
    };
  }, r.cloneElement = function (e, r, t) {
    if (null == e) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
    var a = w({}, e.props),
      i = e.key,
      o = e.ref,
      s = e._owner;
    if (null != r) {
      if (void 0 !== r.ref && (o = r.ref, s = O.current), void 0 !== r.key && (i = "" + r.key), e.type && e.type.defaultProps) var l = e.type.defaultProps;
      for (c in r) x.call(r, c) && !T.hasOwnProperty(c) && (a[c] = void 0 === r[c] && void 0 !== l ? l[c] : r[c]);
    }
    var c = arguments.length - 2;
    if (1 === c) a.children = t;else if (1 < c) {
      l = Array(c);
      for (var u = 0; u < c; u++) l[u] = arguments[u + 2];
      a.children = l;
    }
    return {
      $$typeof: n,
      type: e.type,
      key: i,
      ref: o,
      props: a,
      _owner: s
    };
  }, r.createContext = function (e) {
    return (e = {
      $$typeof: c,
      _currentValue: e,
      _currentValue2: e,
      _threadCount: 0,
      Provider: null,
      Consumer: null,
      _defaultValue: null,
      _globalName: null
    }).Provider = {
      $$typeof: l,
      _context: e
    }, e.Consumer = e;
  }, r.createElement = N, r.createFactory = function (e) {
    var r = N.bind(null, e);
    return r.type = e, r;
  }, r.createRef = function () {
    return {
      current: null
    };
  }, r.createServerContext = function (e, r) {
    var t = !0;
    if (!W[e]) {
      t = !1;
      var n = {
        $$typeof: u,
        _currentValue: r,
        _currentValue2: r,
        _defaultValue: r,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _globalName: e
      };
      n.Provider = {
        $$typeof: l,
        _context: n
      }, W[e] = n;
    }
    if ((n = W[e])._defaultValue === b) n._defaultValue = r, n._currentValue === b && (n._currentValue = r), n._currentValue2 === b && (n._currentValue2 = r);else if (t) throw Error("ServerContext: " + e + " already defined");
    return n;
  }, r.experimental_useEffectEvent = function (e) {
    return j.current.useEffectEvent(e);
  }, r.forwardRef = function (e) {
    return {
      $$typeof: f,
      render: e
    };
  }, r.isValidElement = R, r.lazy = function (e) {
    return {
      $$typeof: m,
      _payload: {
        _status: -1,
        _result: e
      },
      _init: P
    };
  }, r.memo = function (e, r) {
    return {
      $$typeof: h,
      type: e,
      compare: void 0 === r ? null : r
    };
  }, r.startTransition = function (e) {
    var r = V.transition;
    V.transition = {};
    try {
      e();
    } finally {
      V.transition = r;
    }
  }, r.unstable_Cache = g, r.unstable_DebugTracingMode = _, r.unstable_Offscreen = p, r.unstable_act = function () {
    throw Error("act(...) is not supported in production builds of React.");
  }, r.unstable_getCacheForType = function (e) {
    var r = z.current;
    return r ? r.getCacheForType(e) : e();
  }, r.unstable_getCacheSignal = function () {
    var e = z.current;
    return e ? e.getCacheSignal() : ((e = new AbortController()).abort(Error("This CacheSignal was requested outside React which means that it is immediately aborted.")), e.signal);
  }, r.unstable_useCacheRefresh = function () {
    return j.current.useCacheRefresh();
  }, r.unstable_useMemoCache = function (e) {
    return j.current.useMemoCache(e);
  }, r.use = function (e) {
    return j.current.use(e);
  }, r.useCallback = function (e, r) {
    return j.current.useCallback(e, r);
  }, r.useContext = function (e) {
    return j.current.useContext(e);
  }, r.useDebugValue = function () {}, r.useDeferredValue = function (e) {
    return j.current.useDeferredValue(e);
  }, r.useEffect = function (e, r) {
    return j.current.useEffect(e, r);
  }, r.useId = function () {
    return j.current.useId();
  }, r.useImperativeHandle = function (e, r, t) {
    return j.current.useImperativeHandle(e, r, t);
  }, r.useInsertionEffect = function (e, r) {
    return j.current.useInsertionEffect(e, r);
  }, r.useLayoutEffect = function (e, r) {
    return j.current.useLayoutEffect(e, r);
  }, r.useMemo = function (e, r) {
    return j.current.useMemo(e, r);
  }, r.useReducer = function (e, r, t) {
    return j.current.useReducer(e, r, t);
  }, r.useRef = function (e) {
    return j.current.useRef(e);
  }, r.useState = function (e) {
    return j.current.useState(e);
  }, r.useSyncExternalStore = function (e, r, t) {
    return j.current.useSyncExternalStore(e, r, t);
  }, r.useTransition = function () {
    return j.current.useTransition();
  }, r.version = "18.3.0-experimental-53b1f69ba-20230209";
}, function (e, r, t) {
  "use strict";

  /**
   * @license React
   * react-dom.production.min.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var n = t(0),
    a = t(112),
    i = {
      usingClientEntryPoint: !1,
      Events: null,
      Dispatcher: {
        current: null
      }
    };
  function o(e) {
    for (var r = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, t = 1; t < arguments.length; t++) r += "&args[]=" + encodeURIComponent(arguments[t]);
    return "Minified React error #" + e + "; visit " + r + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var s = Math.random().toString(36).slice(2),
    l = "__reactFiber$" + s,
    c = "__reactProps$" + s,
    u = "__reactContainer$" + s,
    f = "__reactEvents$" + s,
    d = "__reactListeners$" + s,
    v = "__reactHandles$" + s,
    h = "__reactResources$" + s,
    m = "__reactMarker$" + s;
  function _(e) {
    delete e[l], delete e[c], delete e[f], delete e[d], delete e[v];
  }
  function p(e) {
    var r = e[l];
    if (r) return r;
    for (var t = e.parentNode; t;) {
      if (r = t[u] || t[l]) {
        if (t = r.alternate, null !== r.child || null !== t && null !== t.child) for (e = vi(e); null !== e;) {
          if (t = e[l]) return t;
          e = vi(e);
        }
        return r;
      }
      t = (e = t).parentNode;
    }
    return null;
  }
  function g(e) {
    if (e = e[l] || e[u]) {
      var r = e.tag;
      if (5 === r || 6 === r || 13 === r || 26 === r || 27 === r || 3 === r) return e;
    }
    return null;
  }
  function b(e) {
    var r = e.tag;
    if (5 === r || 26 === r || 27 === r || 6 === r) return e.stateNode;
    throw Error(o(33));
  }
  function S(e) {
    return e[c] || null;
  }
  function E(e) {
    var r = e[h];
    return r || (r = e[h] = {
      styles: new Map(),
      scripts: new Map(),
      head: new Map(),
      lastStructuredMeta: new Map()
    }), r;
  }
  var w = new Set(),
    y = {};
  function k(e, r) {
    C(e, r), C(e + "Capture", r);
  }
  function C(e, r) {
    for (y[e] = r, e = 0; e < r.length; e++) w.add(r[e]);
  }
  var D = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement),
    A = Object.prototype.hasOwnProperty,
    M = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    x = {},
    O = {};
  function T(e, r, t, n, a, i, o) {
    (this || _global).acceptsBooleans = 2 === r || 3 === r || 4 === r, (this || _global).attributeName = n, (this || _global).attributeNamespace = a, (this || _global).mustUseProperty = t, (this || _global).propertyName = e, (this || _global).type = r, (this || _global).sanitizeURL = i, (this || _global).removeEmptyString = o;
  }
  var N = {},
    R = "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ");
  R.push("innerText", "textContent"), R.forEach(function (e) {
    N[e] = new T(e, 0, !1, e, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (e) {
    var r = e[0];
    N[r] = new T(r, 1, !1, e[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
    N[e] = new T(e, 2, !1, e.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
    N[e] = new T(e, 2, !1, e, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (e) {
    N[e] = new T(e, 3, !1, e.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function (e) {
    N[e] = new T(e, 3, !0, e, null, !1, !1);
  }), ["capture", "download"].forEach(function (e) {
    N[e] = new T(e, 4, !1, e, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function (e) {
    N[e] = new T(e, 6, !1, e, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function (e) {
    N[e] = new T(e, 5, !1, e.toLowerCase(), null, !1, !1);
  });
  var I = /[\-:]([a-z])/g;
  function H(e) {
    return e[1].toUpperCase();
  }
  function F(e, r, t, n) {
    var a = N.hasOwnProperty(r) ? N[r] : null;
    if (null !== a ? 0 !== a.type : n || !(2 < r.length) || "o" !== r[0] && "O" !== r[0] || "n" !== r[1] && "N" !== r[1]) {
      if (n && "o" === r[0] && "n" === r[1]) {
        var i = r.replace(/Capture$/, ""),
          o = r !== i;
        i = i.slice(2);
        var s = S(e);
        if ("function" == typeof (s = null != s ? s[r] : null) && e.removeEventListener(i, s, o), "function" == typeof t) return "function" != typeof s && null !== s && (r in e ? e[r] = null : e.hasAttribute(r) && e.removeAttribute(r)), void e.addEventListener(i, t, o);
      }
      n && r in e ? e[r] = t : (function (e, r, t, n) {
        if (null == r || function (e, r, t, n) {
          if (null !== t && 0 === t.type) return !1;
          switch (typeof r) {
            case "function":
            case "symbol":
              return !0;
            case "boolean":
              return !n && (null !== t ? !t.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);
            default:
              return !1;
          }
        }(e, r, t, n)) return !0;
        if (n) return !1 === r;
        if (null !== t) switch (t.type) {
          case 3:
            return !r;
          case 4:
            return !1 === r;
          case 5:
            return isNaN(r);
          case 6:
            return isNaN(r) || 1 > r;
        }
        return !1;
      }(r, t, a, n) && (t = null), n && !0 === t && (t = ""), n || null === a ? function (e) {
        return !!A.call(O, e) || !A.call(x, e) && (M.test(e) ? O[e] = !0 : (x[e] = !0, !1));
      }(r) && (null === t ? e.removeAttribute(r) : e.setAttribute(r, "" + t)) : a.mustUseProperty ? e[a.propertyName] = null === t ? 3 !== a.type && "" : t : (r = a.attributeName, n = a.attributeNamespace, null === t ? e.removeAttribute(r) : (t = 3 === (a = a.type) || 4 === a && !0 === t ? "" : "" + t, n ? e.setAttributeNS(n, r, t) : e.setAttribute(r, t))));
    }
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering transform-origin underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (e) {
    var r = e.replace(I, H);
    N[r] = new T(r, 1, !1, e, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (e) {
    var r = e.replace(I, H);
    N[r] = new T(r, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
    var r = e.replace(I, H);
    N[r] = new T(r, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function (e) {
    N[e] = new T(e, 1, !1, e.toLowerCase(), null, !1, !1);
  }), N.xlinkHref = new T("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function (e) {
    N[e] = new T(e, 1, !1, e.toLowerCase(), null, !0, !0);
  });
  var L = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    P = Symbol.for("react.element"),
    z = Symbol.for("react.portal"),
    B = Symbol.for("react.fragment"),
    j = Symbol.for("react.strict_mode"),
    V = Symbol.for("react.profiler"),
    U = Symbol.for("react.provider"),
    W = Symbol.for("react.context"),
    $ = Symbol.for("react.server_context"),
    X = Symbol.for("react.forward_ref"),
    G = Symbol.for("react.suspense"),
    K = Symbol.for("react.suspense_list"),
    Y = Symbol.for("react.memo"),
    q = Symbol.for("react.lazy"),
    Q = Symbol.for("react.scope");
  Symbol.for("react.debug_trace_mode");
  var Z = Symbol.for("react.offscreen"),
    J = Symbol.for("react.legacy_hidden"),
    ee = Symbol.for("react.cache");
  Symbol.for("react.tracing_marker");
  var re = Symbol.for("react.default_value"),
    te = Symbol.for("react.memo_cache_sentinel"),
    ne = Symbol.iterator;
  function ae(e) {
    return null === e || "object" != typeof e ? null : "function" == typeof (e = ne && e[ne] || e["@@iterator"]) ? e : null;
  }
  var ie,
    oe = Object.assign;
  function se(e) {
    if (void 0 === ie) try {
      throw Error();
    } catch (e) {
      var r = e.stack.trim().match(/\n( *(at )?)/);
      ie = r && r[1] || "";
    }
    return "\n" + ie + e;
  }
  var le = !1;
  function ce(e, r) {
    if (!e || le) return "";
    le = !0;
    var t = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (r) {
        if (r = function () {
          throw Error();
        }, Object.defineProperty(r.prototype, "props", {
          set: function () {
            throw Error();
          }
        }), "object" == typeof Reflect && Reflect.construct) {
          try {
            Reflect.construct(r, []);
          } catch (e) {
            var n = e;
          }
          Reflect.construct(e, [], r);
        } else {
          try {
            r.call();
          } catch (e) {
            n = e;
          }
          e.call(r.prototype);
        }
      } else {
        try {
          throw Error();
        } catch (e) {
          n = e;
        }
        e();
      }
    } catch (r) {
      if (r && n && "string" == typeof r.stack) {
        for (var a = r.stack.split("\n"), i = n.stack.split("\n"), o = a.length - 1, s = i.length - 1; 1 <= o && 0 <= s && a[o] !== i[s];) s--;
        for (; 1 <= o && 0 <= s; o--, s--) if (a[o] !== i[s]) {
          if (1 !== o || 1 !== s) do {
            if (o--, 0 > --s || a[o] !== i[s]) {
              var l = "\n" + a[o].replace(" at new ", " at ");
              return e.displayName && l.includes("<anonymous>") && (l = l.replace("<anonymous>", e.displayName)), l;
            }
          } while (1 <= o && 0 <= s);
          break;
        }
      }
    } finally {
      le = !1, Error.prepareStackTrace = t;
    }
    return (e = e ? e.displayName || e.name : "") ? se(e) : "";
  }
  function ue(e) {
    switch (e.tag) {
      case 26:
      case 27:
      case 5:
        return se(e.type);
      case 16:
        return se("Lazy");
      case 13:
        return se("Suspense");
      case 19:
        return se("SuspenseList");
      case 0:
      case 2:
      case 15:
        return e = ce(e.type, !1);
      case 11:
        return e = ce(e.type.render, !1);
      case 1:
        return e = ce(e.type, !0);
      default:
        return "";
    }
  }
  function fe(e) {
    var r = e.type;
    switch (e.tag) {
      case 24:
        return "Cache";
      case 9:
        return (r.displayName || "Context") + ".Consumer";
      case 10:
        return (r._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return e = (e = r.render).displayName || e.name || "", r.displayName || ("" !== e ? "ForwardRef(" + e + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 26:
      case 27:
      case 5:
        return r;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return function e(r) {
          if (null == r) return null;
          if ("function" == typeof r) return r.displayName || r.name || null;
          if ("string" == typeof r) return r;
          switch (r) {
            case B:
              return "Fragment";
            case z:
              return "Portal";
            case V:
              return "Profiler";
            case j:
              return "StrictMode";
            case G:
              return "Suspense";
            case K:
              return "SuspenseList";
            case ee:
              return "Cache";
          }
          if ("object" == typeof r) switch (r.$$typeof) {
            case W:
              return (r.displayName || "Context") + ".Consumer";
            case U:
              return (r._context.displayName || "Context") + ".Provider";
            case X:
              var t = r.render;
              return (r = r.displayName) || (r = "" !== (r = t.displayName || t.name || "") ? "ForwardRef(" + r + ")" : "ForwardRef"), r;
            case Y:
              return null !== (t = r.displayName || null) ? t : e(r.type) || "Memo";
            case q:
              t = r._payload, r = r._init;
              try {
                return e(r(t));
              } catch (e) {
                break;
              }
            case $:
              return (r.displayName || r._globalName) + ".Provider";
          }
          return null;
        }(r);
      case 8:
        return r === j ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if ("function" == typeof r) return r.displayName || r.name || null;
        if ("string" == typeof r) return r;
    }
    return null;
  }
  function de(e) {
    switch (typeof e) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
      case "object":
        return e;
      default:
        return "";
    }
  }
  function ve(e) {
    var r = e.type;
    return (e = e.nodeName) && "input" === e.toLowerCase() && ("checkbox" === r || "radio" === r);
  }
  function he(e) {
    e._valueTracker || (e._valueTracker = function (e) {
      var r = ve(e) ? "checked" : "value",
        t = Object.getOwnPropertyDescriptor(e.constructor.prototype, r),
        n = "" + e[r];
      if (!e.hasOwnProperty(r) && void 0 !== t && "function" == typeof t.get && "function" == typeof t.set) {
        var a = t.get,
          i = t.set;
        return Object.defineProperty(e, r, {
          configurable: !0,
          get: function () {
            return a.call(this || _global);
          },
          set: function (e) {
            n = "" + e, i.call(this || _global, e);
          }
        }), Object.defineProperty(e, r, {
          enumerable: t.enumerable
        }), {
          getValue: function () {
            return n;
          },
          setValue: function (e) {
            n = "" + e;
          },
          stopTracking: function () {
            e._valueTracker = null, delete e[r];
          }
        };
      }
    }(e));
  }
  function me(e) {
    if (!e) return !1;
    var r = e._valueTracker;
    if (!r) return !0;
    var t = r.getValue(),
      n = "";
    return e && (n = ve(e) ? e.checked ? "true" : "false" : e.value), (e = n) !== t && (r.setValue(e), !0);
  }
  function _e(e) {
    if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;
    try {
      return e.activeElement || e.body;
    } catch (r) {
      return e.body;
    }
  }
  function pe(e, r) {
    var t = r.checked;
    return oe({}, r, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: null != t ? t : e._wrapperState.initialChecked
    });
  }
  function ge(e, r) {
    var t = null == r.defaultValue ? "" : r.defaultValue,
      n = null != r.checked ? r.checked : r.defaultChecked;
    t = de(null != r.value ? r.value : t), e._wrapperState = {
      initialChecked: n,
      initialValue: t,
      controlled: "checkbox" === r.type || "radio" === r.type ? null != r.checked : null != r.value
    };
  }
  function be(e, r) {
    null != (r = r.checked) && F(e, "checked", r, !1);
  }
  function Se(e, r) {
    be(e, r);
    var t = de(r.value),
      n = r.type;
    if (null != t) "number" === n ? (0 === t && "" === e.value || e.value != t) && (e.value = "" + t) : e.value !== "" + t && (e.value = "" + t);else if ("submit" === n || "reset" === n) return void e.removeAttribute("value");
    r.hasOwnProperty("value") ? we(e, r.type, t) : r.hasOwnProperty("defaultValue") && we(e, r.type, de(r.defaultValue)), null == r.checked && null != r.defaultChecked && (e.defaultChecked = !!r.defaultChecked);
  }
  function Ee(e, r, t) {
    if (r.hasOwnProperty("value") || r.hasOwnProperty("defaultValue")) {
      var n = r.type;
      if (!("submit" !== n && "reset" !== n || void 0 !== r.value && null !== r.value)) return;
      r = "" + e._wrapperState.initialValue, t || r === e.value || (e.value = r), e.defaultValue = r;
    }
    "" !== (t = e.name) && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, "" !== t && (e.name = t);
  }
  function we(e, r, t) {
    "number" === r && _e(e.ownerDocument) === e || (null == t ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + t && (e.defaultValue = "" + t));
  }
  var ye = Array.isArray;
  function ke(e, r, t, n) {
    if (e = e.options, r) {
      r = {};
      for (var a = 0; a < t.length; a++) r["$" + t[a]] = !0;
      for (t = 0; t < e.length; t++) a = r.hasOwnProperty("$" + e[t].value), e[t].selected !== a && (e[t].selected = a), a && n && (e[t].defaultSelected = !0);
    } else {
      for (t = "" + de(t), r = null, a = 0; a < e.length; a++) {
        if (e[a].value === t) return e[a].selected = !0, void (n && (e[a].defaultSelected = !0));
        null !== r || e[a].disabled || (r = e[a]);
      }
      null !== r && (r.selected = !0);
    }
  }
  function Ce(e, r) {
    if (null != r.dangerouslySetInnerHTML) throw Error(o(91));
    return oe({}, r, {
      value: void 0,
      defaultValue: void 0,
      children: "" + e._wrapperState.initialValue
    });
  }
  function De(e, r) {
    var t = r.value;
    if (null == t) {
      if (t = r.children, r = r.defaultValue, null != t) {
        if (null != r) throw Error(o(92));
        if (ye(t)) {
          if (1 < t.length) throw Error(o(93));
          t = t[0];
        }
        r = t;
      }
      null == r && (r = ""), t = r;
    }
    e._wrapperState = {
      initialValue: de(t)
    };
  }
  function Ae(e, r) {
    var t = de(r.value),
      n = de(r.defaultValue);
    null != t && ((t = "" + t) !== e.value && (e.value = t), null == r.defaultValue && e.defaultValue !== t && (e.defaultValue = t)), null != n && (e.defaultValue = "" + n);
  }
  function Me(e) {
    var r = e.textContent;
    r === e._wrapperState.initialValue && "" !== r && null !== r && (e.value = r);
  }
  function xe(e) {
    switch (e) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Oe(e, r) {
    return null == e || "http://www.w3.org/1999/xhtml" === e ? xe(r) : "http://www.w3.org/2000/svg" === e && "foreignObject" === r ? "http://www.w3.org/1999/xhtml" : e;
  }
  var Te,
    Ne = function (e) {
      return "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function (r, t, n, a) {
        MSApp.execUnsafeLocalFunction(function () {
          return e(r, t);
        });
      } : e;
    }(function (e, r) {
      if ("http://www.w3.org/2000/svg" !== e.namespaceURI || "innerHTML" in e) e.innerHTML = r;else {
        for ((Te = Te || document.createElement("div")).innerHTML = "<svg>" + r.valueOf().toString() + "</svg>", r = Te.firstChild; e.firstChild;) e.removeChild(e.firstChild);
        for (; r.firstChild;) e.appendChild(r.firstChild);
      }
    });
  function Re(e, r) {
    if (r) {
      var t = e.firstChild;
      if (t && t === e.lastChild && 3 === t.nodeType) return void (t.nodeValue = r);
    }
    e.textContent = r;
  }
  var Ie = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    },
    He = ["Webkit", "ms", "Moz", "O"];
  function Fe(e, r, t) {
    return null == r || "boolean" == typeof r || "" === r ? "" : t || "number" != typeof r || 0 === r || Ie.hasOwnProperty(e) && Ie[e] ? ("" + r).trim() : r + "px";
  }
  function Le(e, r) {
    for (var t in e = e.style, r) if (r.hasOwnProperty(t)) {
      var n = 0 === t.indexOf("--"),
        a = Fe(t, r[t], n);
      "float" === t && (t = "cssFloat"), n ? e.setProperty(t, a) : e[t] = a;
    }
  }
  Object.keys(Ie).forEach(function (e) {
    He.forEach(function (r) {
      r = r + e.charAt(0).toUpperCase() + e.substring(1), Ie[r] = Ie[e];
    });
  });
  var Pe = oe({
    menuitem: !0
  }, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  });
  function ze(e, r) {
    if (r) {
      if (Pe[e] && (null != r.children || null != r.dangerouslySetInnerHTML)) throw Error(o(137, e));
      if (null != r.dangerouslySetInnerHTML) {
        if (null != r.children) throw Error(o(60));
        if ("object" != typeof r.dangerouslySetInnerHTML || !("__html" in r.dangerouslySetInnerHTML)) throw Error(o(61));
      }
      if (null != r.style && "object" != typeof r.style) throw Error(o(62));
    }
  }
  function Be(e, r) {
    if (-1 === e.indexOf("-")) return "string" == typeof r.is;
    switch (e) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var je = null;
  function Ve(e) {
    return (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement), 3 === e.nodeType ? e.parentNode : e;
  }
  var Ue = null,
    We = null,
    $e = null;
  function Xe(e) {
    if (e = g(e)) {
      if ("function" != typeof Ue) throw Error(o(280));
      var r = e.stateNode;
      r && (r = S(r), Ue(e.stateNode, e.type, r));
    }
  }
  function Ge(e) {
    We ? $e ? $e.push(e) : $e = [e] : We = e;
  }
  function Ke() {
    if (We) {
      var e = We,
        r = $e;
      if ($e = We = null, Xe(e), r) for (e = 0; e < r.length; e++) Xe(r[e]);
    }
  }
  function Ye(e, r) {
    return e(r);
  }
  function qe() {}
  var Qe = !1;
  function Ze(e, r, t) {
    if (Qe) return e(r, t);
    Qe = !0;
    try {
      return Ye(e, r, t);
    } finally {
      Qe = !1, (null !== We || null !== $e) && (qe(), Ke());
    }
  }
  function Je(e, r) {
    var t = e.stateNode;
    if (null === t) return null;
    var n = S(t);
    if (null === n) return null;
    t = n[r];
    e: switch (r) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (n = !n.disabled) || (n = !("button" === (e = e.type) || "input" === e || "select" === e || "textarea" === e)), e = !n;
        break e;
      default:
        e = !1;
    }
    if (e) return null;
    if (t && "function" != typeof t) throw Error(o(231, r, typeof t));
    return t;
  }
  var er = !1;
  if (D) try {
    var rr = {};
    Object.defineProperty(rr, "passive", {
      get: function () {
        er = !0;
      }
    }), window.addEventListener("test", rr, rr), window.removeEventListener("test", rr, rr);
  } catch (e) {
    er = !1;
  }
  function tr(e, r, t) {
    var n = Array.prototype.slice.call(arguments, 3);
    try {
      r.apply(t, n);
    } catch (e) {
      this.onError(e);
    }
  }
  var nr = !1,
    ar = null,
    ir = !1,
    or = null,
    sr = {
      onError: function (e) {
        nr = !0, ar = e;
      }
    };
  function lr(e, r, t, n, a, i, o, s, l) {
    nr = !1, ar = null, tr.apply(sr, arguments);
  }
  function cr(e) {
    var r = e,
      t = e;
    if (e.alternate) for (; r.return;) r = r.return;else {
      e = r;
      do {
        0 != (4098 & (r = e).flags) && (t = r.return), e = r.return;
      } while (e);
    }
    return 3 === r.tag ? t : null;
  }
  function ur(e) {
    if (13 === e.tag) {
      var r = e.memoizedState;
      if (null === r && null !== (e = e.alternate) && (r = e.memoizedState), null !== r) return r.dehydrated;
    }
    return null;
  }
  function fr(e) {
    if (cr(e) !== e) throw Error(o(188));
  }
  function dr(e) {
    return null !== (e = function (e) {
      var r = e.alternate;
      if (!r) {
        if (null === (r = cr(e))) throw Error(o(188));
        return r !== e ? null : e;
      }
      for (var t = e, n = r;;) {
        var a = t.return;
        if (null === a) break;
        var i = a.alternate;
        if (null === i) {
          if (null !== (n = a.return)) {
            t = n;
            continue;
          }
          break;
        }
        if (a.child === i.child) {
          for (i = a.child; i;) {
            if (i === t) return fr(a), e;
            if (i === n) return fr(a), r;
            i = i.sibling;
          }
          throw Error(o(188));
        }
        if (t.return !== n.return) t = a, n = i;else {
          for (var s = !1, l = a.child; l;) {
            if (l === t) {
              s = !0, t = a, n = i;
              break;
            }
            if (l === n) {
              s = !0, n = a, t = i;
              break;
            }
            l = l.sibling;
          }
          if (!s) {
            for (l = i.child; l;) {
              if (l === t) {
                s = !0, t = i, n = a;
                break;
              }
              if (l === n) {
                s = !0, n = i, t = a;
                break;
              }
              l = l.sibling;
            }
            if (!s) throw Error(o(189));
          }
        }
        if (t.alternate !== n) throw Error(o(190));
      }
      if (3 !== t.tag) throw Error(o(188));
      return t.stateNode.current === t ? e : r;
    }(e)) ? function e(r) {
      var t = r.tag;
      if (5 === t || 26 === t || 27 === t || 6 === t) return r;
      for (r = r.child; null !== r;) {
        if (null !== (t = e(r))) return t;
        r = r.sibling;
      }
      return null;
    }(e) : null;
  }
  var vr = a.unstable_scheduleCallback,
    hr = a.unstable_cancelCallback,
    mr = a.unstable_shouldYield,
    _r = a.unstable_requestPaint,
    pr = a.unstable_now,
    gr = a.unstable_getCurrentPriorityLevel,
    br = a.unstable_ImmediatePriority,
    Sr = a.unstable_UserBlockingPriority,
    Er = a.unstable_NormalPriority,
    wr = a.unstable_LowPriority,
    yr = a.unstable_IdlePriority,
    kr = null,
    Cr = null;
  var Dr = Math.clz32 ? Math.clz32 : function (e) {
      return 0 === (e >>>= 0) ? 32 : 31 - (Ar(e) / Mr | 0) | 0;
    },
    Ar = Math.log,
    Mr = Math.LN2;
  var xr = 128,
    Or = 8388608;
  function Tr(e) {
    var r = 42 & e;
    if (0 !== r) return r;
    switch (e & -e) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
        return 8388480 & e;
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return 125829120 & e;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return e;
    }
  }
  function Nr(e, r) {
    var t = e.pendingLanes;
    if (0 === t) return 0;
    var n = 0,
      a = e.suspendedLanes,
      i = e.pingedLanes,
      o = 268435455 & t;
    if (0 !== o) {
      var s = o & ~a;
      0 !== s ? n = Tr(s) : 0 !== (i &= o) && (n = Tr(i));
    } else 0 !== (o = t & ~a) ? n = Tr(o) : 0 !== i && (n = Tr(i));
    if (0 === n) return 0;
    if (0 !== r && r !== n && 0 == (r & a) && ((a = n & -n) >= (i = r & -r) || 32 === a && 0 != (8388480 & i))) return r;
    if (0 != (8 & n) && (n |= 32 & t), 0 !== (r = e.entangledLanes)) for (e = e.entanglements, r &= n; 0 < r;) a = 1 << (t = 31 - Dr(r)), n |= e[t], r &= ~a;
    return n;
  }
  function Rr(e, r) {
    switch (e) {
      case 1:
      case 2:
      case 4:
      case 8:
        return r + 250;
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
        return r + 5000;
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
      default:
        return -1;
    }
  }
  function Ir(e, r) {
    return e.errorRecoveryDisabledLanes & r ? 0 : 0 !== (e = -1073741825 & e.pendingLanes) ? e : 1073741824 & e ? 1073741824 : 0;
  }
  function Hr() {
    var e = xr;
    return 0 == (8388480 & (xr <<= 1)) && (xr = 128), e;
  }
  function Fr(e) {
    for (var r = [], t = 0; 31 > t; t++) r.push(e);
    return r;
  }
  function Lr(e, r, t) {
    e.pendingLanes |= r, 536870912 !== r && (e.suspendedLanes = 0, e.pingedLanes = 0), (e = e.eventTimes)[r = 31 - Dr(r)] = t;
  }
  function Pr(e, r) {
    var t = e.entangledLanes |= r;
    for (e = e.entanglements; t;) {
      var n = 31 - Dr(t),
        a = 1 << n;
      a & r | e[n] & r && (e[n] |= r), t &= ~a;
    }
  }
  var zr = 0;
  function Br(e, r) {
    var t = zr;
    try {
      return zr = e, r();
    } finally {
      zr = t;
    }
  }
  function jr(e) {
    return 2 < (e &= -e) ? 8 < e ? 0 != (268435455 & e) ? 32 : 536870912 : 8 : 2;
  }
  var Vr,
    Ur,
    Wr,
    $r,
    Xr,
    Gr = !1,
    Kr = [],
    Yr = null,
    qr = null,
    Qr = null,
    Zr = new Map(),
    Jr = new Map(),
    et = [],
    rt = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function tt(e, r) {
    switch (e) {
      case "focusin":
      case "focusout":
        Yr = null;
        break;
      case "dragenter":
      case "dragleave":
        qr = null;
        break;
      case "mouseover":
      case "mouseout":
        Qr = null;
        break;
      case "pointerover":
      case "pointerout":
        Zr.delete(r.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Jr.delete(r.pointerId);
    }
  }
  function nt(e, r, t, n, a, i) {
    return null === e || e.nativeEvent !== i ? (e = {
      blockedOn: r,
      domEventName: t,
      eventSystemFlags: n,
      nativeEvent: i,
      targetContainers: [a]
    }, null !== r && null !== (r = g(r)) && Ur(r), e) : (e.eventSystemFlags |= n, r = e.targetContainers, null !== a && -1 === r.indexOf(a) && r.push(a), e);
  }
  function at(e) {
    var r = p(e.target);
    if (null !== r) {
      var t = cr(r);
      if (null !== t) if (13 === (r = t.tag)) {
        if (null !== (r = ur(t))) return e.blockedOn = r, void Xr(e.priority, function () {
          Wr(t);
        });
      } else if (3 === r && t.stateNode.current.memoizedState.isDehydrated) return void (e.blockedOn = 3 === t.tag ? t.stateNode.containerInfo : null);
    }
    e.blockedOn = null;
  }
  function it(e) {
    if (null !== e.blockedOn) return !1;
    for (var r = e.targetContainers; 0 < r.length;) {
      var t = _t(e.domEventName, e.eventSystemFlags, r[0], e.nativeEvent);
      if (null !== t) return null !== (r = g(t)) && Ur(r), e.blockedOn = t, !1;
      var n = new (t = e.nativeEvent).constructor(t.type, t);
      je = n, t.target.dispatchEvent(n), je = null, r.shift();
    }
    return !0;
  }
  function ot(e, r, t) {
    it(e) && t.delete(r);
  }
  function st() {
    Gr = !1, null !== Yr && it(Yr) && (Yr = null), null !== qr && it(qr) && (qr = null), null !== Qr && it(Qr) && (Qr = null), Zr.forEach(ot), Jr.forEach(ot);
  }
  function lt(e, r) {
    e.blockedOn === r && (e.blockedOn = null, Gr || (Gr = !0, a.unstable_scheduleCallback(a.unstable_NormalPriority, st)));
  }
  function ct(e) {
    function r(r) {
      return lt(r, e);
    }
    if (0 < Kr.length) {
      lt(Kr[0], e);
      for (var t = 1; t < Kr.length; t++) {
        var n = Kr[t];
        n.blockedOn === e && (n.blockedOn = null);
      }
    }
    for (null !== Yr && lt(Yr, e), null !== qr && lt(qr, e), null !== Qr && lt(Qr, e), Zr.forEach(r), Jr.forEach(r), t = 0; t < et.length; t++) (n = et[t]).blockedOn === e && (n.blockedOn = null);
    for (; 0 < et.length && null === (t = et[0]).blockedOn;) at(t), null === t.blockedOn && et.shift();
  }
  var ut = L.ReactCurrentBatchConfig,
    ft = !0;
  function dt(e, r, t, n) {
    var a = zr,
      i = ut.transition;
    ut.transition = null;
    try {
      zr = 2, ht(e, r, t, n);
    } finally {
      zr = a, ut.transition = i;
    }
  }
  function vt(e, r, t, n) {
    var a = zr,
      i = ut.transition;
    ut.transition = null;
    try {
      zr = 8, ht(e, r, t, n);
    } finally {
      zr = a, ut.transition = i;
    }
  }
  function ht(e, r, t, n) {
    if (ft) {
      var a = _t(e, r, t, n);
      if (null === a) sa(e, r, n, mt, t), tt(e, n);else if (function (e, r, t, n, a) {
        switch (r) {
          case "focusin":
            return Yr = nt(Yr, e, r, t, n, a), !0;
          case "dragenter":
            return qr = nt(qr, e, r, t, n, a), !0;
          case "mouseover":
            return Qr = nt(Qr, e, r, t, n, a), !0;
          case "pointerover":
            var i = a.pointerId;
            return Zr.set(i, nt(Zr.get(i) || null, e, r, t, n, a)), !0;
          case "gotpointercapture":
            return i = a.pointerId, Jr.set(i, nt(Jr.get(i) || null, e, r, t, n, a)), !0;
        }
        return !1;
      }(a, e, r, t, n)) n.stopPropagation();else if (tt(e, n), 4 & r && -1 < rt.indexOf(e)) {
        for (; null !== a;) {
          var i = g(a);
          if (null !== i && Vr(i), null === (i = _t(e, r, t, n)) && sa(e, r, n, mt, t), i === a) break;
          a = i;
        }
        null !== a && n.stopPropagation();
      } else sa(e, r, n, null, t);
    }
  }
  var mt = null;
  function _t(e, r, t, n) {
    if (mt = null, null !== (e = p(e = Ve(n)))) if (null === (r = cr(e))) e = null;else if (13 === (t = r.tag)) {
      if (null !== (e = ur(r))) return e;
      e = null;
    } else if (3 === t) {
      if (r.stateNode.current.memoizedState.isDehydrated) return 3 === r.tag ? r.stateNode.containerInfo : null;
      e = null;
    } else r !== e && (e = null);
    return mt = e, null;
  }
  function pt(e) {
    switch (e) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (gr()) {
          case br:
            return 2;
          case Sr:
            return 8;
          case Er:
          case wr:
            return 32;
          case yr:
            return 536870912;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var gt = null,
    bt = null,
    St = null;
  function Et() {
    if (St) return St;
    var e,
      r,
      t = bt,
      n = t.length,
      a = "value" in gt ? gt.value : gt.textContent,
      i = a.length;
    for (e = 0; e < n && t[e] === a[e]; e++);
    var o = n - e;
    for (r = 1; r <= o && t[n - r] === a[i - r]; r++);
    return St = a.slice(e, 1 < r ? 1 - r : void 0);
  }
  function wt(e) {
    var r = e.keyCode;
    return "charCode" in e ? 0 === (e = e.charCode) && 13 === r && (e = 13) : e = r, 10 === e && (e = 13), 32 <= e || 13 === e ? e : 0;
  }
  function yt() {
    return !0;
  }
  function kt() {
    return !1;
  }
  function Ct(e) {
    function r(r, t, n, a, i) {
      for (var o in (this || _global)._reactName = r, (this || _global)._targetInst = n, (this || _global).type = t, (this || _global).nativeEvent = a, (this || _global).target = i, (this || _global).currentTarget = null, e) e.hasOwnProperty(o) && (r = e[o], (this || _global)[o] = r ? r(a) : a[o]);
      return (this || _global).isDefaultPrevented = (null != a.defaultPrevented ? a.defaultPrevented : !1 === a.returnValue) ? yt : kt, (this || _global).isPropagationStopped = kt, this || _global;
    }
    return oe(r.prototype, {
      preventDefault: function () {
        (this || _global).defaultPrevented = !0;
        var e = (this || _global).nativeEvent;
        e && (e.preventDefault ? e.preventDefault() : "unknown" != typeof e.returnValue && (e.returnValue = !1), (this || _global).isDefaultPrevented = yt);
      },
      stopPropagation: function () {
        var e = (this || _global).nativeEvent;
        e && (e.stopPropagation ? e.stopPropagation() : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0), (this || _global).isPropagationStopped = yt);
      },
      persist: function () {},
      isPersistent: yt
    }), r;
  }
  var Dt,
    At,
    Mt,
    xt = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function (e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    },
    Ot = Ct(xt),
    Tt = oe({}, xt, {
      view: 0,
      detail: 0
    }),
    Nt = Ct(Tt),
    Rt = oe({}, Tt, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Wt,
      button: 0,
      buttons: 0,
      relatedTarget: function (e) {
        return void 0 === e.relatedTarget ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function (e) {
        return "movementX" in e ? e.movementX : (e !== Mt && (Mt && "mousemove" === e.type ? (Dt = e.screenX - Mt.screenX, At = e.screenY - Mt.screenY) : At = Dt = 0, Mt = e), Dt);
      },
      movementY: function (e) {
        return "movementY" in e ? e.movementY : At;
      }
    }),
    It = Ct(Rt),
    Ht = Ct(oe({}, Rt, {
      dataTransfer: 0
    })),
    Ft = Ct(oe({}, Tt, {
      relatedTarget: 0
    })),
    Lt = Ct(oe({}, xt, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    })),
    Pt = Ct(oe({}, xt, {
      clipboardData: function (e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    })),
    zt = Ct(oe({}, xt, {
      data: 0
    })),
    Bt = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    },
    jt = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    },
    Vt = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
  function Ut(e) {
    var r = (this || _global).nativeEvent;
    return r.getModifierState ? r.getModifierState(e) : !!(e = Vt[e]) && !!r[e];
  }
  function Wt() {
    return Ut;
  }
  var $t = Ct(oe({}, Tt, {
      key: function (e) {
        if (e.key) {
          var r = Bt[e.key] || e.key;
          if ("Unidentified" !== r) return r;
        }
        return "keypress" === e.type ? 13 === (e = wt(e)) ? "Enter" : String.fromCharCode(e) : "keydown" === e.type || "keyup" === e.type ? jt[e.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Wt,
      charCode: function (e) {
        return "keypress" === e.type ? wt(e) : 0;
      },
      keyCode: function (e) {
        return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
      },
      which: function (e) {
        return "keypress" === e.type ? wt(e) : "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
      }
    })),
    Xt = Ct(oe({}, Rt, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    })),
    Gt = Ct(oe({}, Tt, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Wt
    })),
    Kt = Ct(oe({}, xt, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    })),
    Yt = Ct(oe({}, Rt, {
      deltaX: function (e) {
        return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
      },
      deltaY: function (e) {
        return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    })),
    qt = [9, 13, 27, 32],
    Qt = D && "CompositionEvent" in window,
    Zt = null;
  D && "documentMode" in document && (Zt = document.documentMode);
  var Jt = D && "TextEvent" in window && !Zt,
    en = D && (!Qt || Zt && 8 < Zt && 11 >= Zt),
    rn = String.fromCharCode(32),
    tn = !1;
  function nn(e, r) {
    switch (e) {
      case "keyup":
        return -1 !== qt.indexOf(r.keyCode);
      case "keydown":
        return 229 !== r.keyCode;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function an(e) {
    return "object" == typeof (e = e.detail) && "data" in e ? e.data : null;
  }
  var on = !1;
  var sn = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function ln(e) {
    var r = e && e.nodeName && e.nodeName.toLowerCase();
    return "input" === r ? !!sn[e.type] : "textarea" === r;
  }
  function cn(e, r, t, n) {
    Ge(n), 0 < (r = ca(r, "onChange")).length && (t = new Ot("onChange", "change", null, t, n), e.push({
      event: t,
      listeners: r
    }));
  }
  var un = null,
    fn = null;
  function dn(e) {
    ra(e, 0);
  }
  function vn(e) {
    if (me(b(e))) return e;
  }
  function hn(e, r) {
    if ("change" === e) return r;
  }
  var mn = !1;
  if (D) {
    var _n;
    if (D) {
      var pn = ("oninput" in document);
      if (!pn) {
        var gn = document.createElement("div");
        gn.setAttribute("oninput", "return;"), pn = "function" == typeof gn.oninput;
      }
      _n = pn;
    } else _n = !1;
    mn = _n && (!document.documentMode || 9 < document.documentMode);
  }
  function bn() {
    un && (un.detachEvent("onpropertychange", Sn), fn = un = null);
  }
  function Sn(e) {
    if ("value" === e.propertyName && vn(fn)) {
      var r = [];
      cn(r, fn, e, Ve(e)), Ze(dn, r);
    }
  }
  function En(e, r, t) {
    "focusin" === e ? (bn(), fn = t, (un = r).attachEvent("onpropertychange", Sn)) : "focusout" === e && bn();
  }
  function wn(e) {
    if ("selectionchange" === e || "keyup" === e || "keydown" === e) return vn(fn);
  }
  function yn(e, r) {
    if ("click" === e) return vn(r);
  }
  function kn(e, r) {
    if ("input" === e || "change" === e) return vn(r);
  }
  var Cn = "function" == typeof Object.is ? Object.is : function (e, r) {
    return e === r && (0 !== e || 1 / e == 1 / r) || e != e && r != r;
  };
  function Dn(e, r) {
    if (Cn(e, r)) return !0;
    if ("object" != typeof e || null === e || "object" != typeof r || null === r) return !1;
    var t = Object.keys(e),
      n = Object.keys(r);
    if (t.length !== n.length) return !1;
    for (n = 0; n < t.length; n++) {
      var a = t[n];
      if (!A.call(r, a) || !Cn(e[a], r[a])) return !1;
    }
    return !0;
  }
  function An(e) {
    for (; e && e.firstChild;) e = e.firstChild;
    return e;
  }
  function Mn(e, r) {
    var t,
      n = An(e);
    for (e = 0; n;) {
      if (3 === n.nodeType) {
        if (t = e + n.textContent.length, e <= r && t >= r) return {
          node: n,
          offset: r - e
        };
        e = t;
      }
      e: {
        for (; n;) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break e;
          }
          n = n.parentNode;
        }
        n = void 0;
      }
      n = An(n);
    }
  }
  function xn() {
    for (var e = window, r = _e(); r instanceof e.HTMLIFrameElement;) {
      try {
        var t = "string" == typeof r.contentWindow.location.href;
      } catch (e) {
        t = !1;
      }
      if (!t) break;
      r = _e((e = r.contentWindow).document);
    }
    return r;
  }
  function On(e) {
    var r = e && e.nodeName && e.nodeName.toLowerCase();
    return r && ("input" === r && ("text" === e.type || "search" === e.type || "tel" === e.type || "url" === e.type || "password" === e.type) || "textarea" === r || "true" === e.contentEditable);
  }
  function Tn(e) {
    var r = xn(),
      t = e.focusedElem,
      n = e.selectionRange;
    if (r !== t && t && t.ownerDocument && function e(r, t) {
      return !(!r || !t) && (r === t || (!r || 3 !== r.nodeType) && (t && 3 === t.nodeType ? e(r, t.parentNode) : "contains" in r ? r.contains(t) : !!r.compareDocumentPosition && !!(16 & r.compareDocumentPosition(t))));
    }(t.ownerDocument.documentElement, t)) {
      if (null !== n && On(t)) if (r = n.start, void 0 === (e = n.end) && (e = r), "selectionStart" in t) t.selectionStart = r, t.selectionEnd = Math.min(e, t.value.length);else if ((e = (r = t.ownerDocument || document) && r.defaultView || window).getSelection) {
        e = e.getSelection();
        var a = t.textContent.length,
          i = Math.min(n.start, a);
        n = void 0 === n.end ? i : Math.min(n.end, a), !e.extend && i > n && (a = n, n = i, i = a), a = Mn(t, i);
        var o = Mn(t, n);
        a && o && (1 !== e.rangeCount || e.anchorNode !== a.node || e.anchorOffset !== a.offset || e.focusNode !== o.node || e.focusOffset !== o.offset) && ((r = r.createRange()).setStart(a.node, a.offset), e.removeAllRanges(), i > n ? (e.addRange(r), e.extend(o.node, o.offset)) : (r.setEnd(o.node, o.offset), e.addRange(r)));
      }
      for (r = [], e = t; e = e.parentNode;) 1 === e.nodeType && r.push({
        element: e,
        left: e.scrollLeft,
        top: e.scrollTop
      });
      for ("function" == typeof t.focus && t.focus(), t = 0; t < r.length; t++) (e = r[t]).element.scrollLeft = e.left, e.element.scrollTop = e.top;
    }
  }
  var Nn = D && "documentMode" in document && 11 >= document.documentMode,
    Rn = null,
    In = null,
    Hn = null,
    Fn = !1;
  function Ln(e, r, t) {
    var n = t.window === t ? t.document : 9 === t.nodeType ? t : t.ownerDocument;
    Fn || null == Rn || Rn !== _e(n) || ("selectionStart" in (n = Rn) && On(n) ? n = {
      start: n.selectionStart,
      end: n.selectionEnd
    } : n = {
      anchorNode: (n = (n.ownerDocument && n.ownerDocument.defaultView || window).getSelection()).anchorNode,
      anchorOffset: n.anchorOffset,
      focusNode: n.focusNode,
      focusOffset: n.focusOffset
    }, Hn && Dn(Hn, n) || (Hn = n, 0 < (n = ca(In, "onSelect")).length && (r = new Ot("onSelect", "select", null, r, t), e.push({
      event: r,
      listeners: n
    }), r.target = Rn)));
  }
  function Pn(e, r) {
    var t = {};
    return t[e.toLowerCase()] = r.toLowerCase(), t["Webkit" + e] = "webkit" + r, t["Moz" + e] = "moz" + r, t;
  }
  var zn = {
      animationend: Pn("Animation", "AnimationEnd"),
      animationiteration: Pn("Animation", "AnimationIteration"),
      animationstart: Pn("Animation", "AnimationStart"),
      transitionend: Pn("Transition", "TransitionEnd")
    },
    Bn = {},
    jn = {};
  function Vn(e) {
    if (Bn[e]) return Bn[e];
    if (!zn[e]) return e;
    var r,
      t = zn[e];
    for (r in t) if (t.hasOwnProperty(r) && r in jn) return Bn[e] = t[r];
    return e;
  }
  D && (jn = document.createElement("div").style, "AnimationEvent" in window || (delete zn.animationend.animation, delete zn.animationiteration.animation, delete zn.animationstart.animation), "TransitionEvent" in window || delete zn.transitionend.transition);
  var Un = Vn("animationend"),
    Wn = Vn("animationiteration"),
    $n = Vn("animationstart"),
    Xn = Vn("transitionend"),
    Gn = new Map(),
    Kn = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Yn(e, r) {
    Gn.set(e, r), k(r, [e]);
  }
  for (var qn = 0; qn < Kn.length; qn++) {
    var Qn = Kn[qn];
    Yn(Qn.toLowerCase(), "on" + (Qn[0].toUpperCase() + Qn.slice(1)));
  }
  Yn(Un, "onAnimationEnd"), Yn(Wn, "onAnimationIteration"), Yn($n, "onAnimationStart"), Yn("dblclick", "onDoubleClick"), Yn("focusin", "onFocus"), Yn("focusout", "onBlur"), Yn(Xn, "onTransitionEnd"), C("onMouseEnter", ["mouseout", "mouseover"]), C("onMouseLeave", ["mouseout", "mouseover"]), C("onPointerEnter", ["pointerout", "pointerover"]), C("onPointerLeave", ["pointerout", "pointerover"]), k("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), k("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), k("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), k("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), k("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), k("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Zn = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
    Jn = new Set("cancel close invalid load scroll toggle".split(" ").concat(Zn));
  function ea(e, r, t) {
    var n = e.type || "unknown-event";
    e.currentTarget = t, function (e, r, t, n, a, i, s, l, c) {
      if (lr.apply(this || _global, arguments), nr) {
        if (!nr) throw Error(o(198));
        var u = ar;
        nr = !1, ar = null, ir || (ir = !0, or = u);
      }
    }(n, r, void 0, e), e.currentTarget = null;
  }
  function ra(e, r) {
    r = 0 != (4 & r);
    for (var t = 0; t < e.length; t++) {
      var n = e[t],
        a = n.event;
      n = n.listeners;
      e: {
        var i = void 0;
        if (r) for (var o = n.length - 1; 0 <= o; o--) {
          var s = n[o],
            l = s.instance,
            c = s.currentTarget;
          if (s = s.listener, l !== i && a.isPropagationStopped()) break e;
          ea(a, s, c), i = l;
        } else for (o = 0; o < n.length; o++) {
          if (l = (s = n[o]).instance, c = s.currentTarget, s = s.listener, l !== i && a.isPropagationStopped()) break e;
          ea(a, s, c), i = l;
        }
      }
    }
    if (ir) throw e = or, ir = !1, or = null, e;
  }
  function ta(e, r) {
    var t = r[f];
    void 0 === t && (t = r[f] = new Set());
    var n = e + "__bubble";
    t.has(n) || (oa(r, e, 2, !1), t.add(n));
  }
  function na(e, r, t) {
    var n = 0;
    r && (n |= 4), oa(t, e, n, r);
  }
  var aa = "_reactListening" + Math.random().toString(36).slice(2);
  function ia(e) {
    if (!e[aa]) {
      e[aa] = !0, w.forEach(function (r) {
        "selectionchange" !== r && (Jn.has(r) || na(r, !1, e), na(r, !0, e));
      });
      var r = 9 === e.nodeType ? e : e.ownerDocument;
      null === r || r[aa] || (r[aa] = !0, na("selectionchange", !1, r));
    }
  }
  function oa(e, r, t, n) {
    switch (pt(r)) {
      case 2:
        var a = dt;
        break;
      case 8:
        a = vt;
        break;
      default:
        a = ht;
    }
    t = a.bind(null, r, t, e), a = void 0, !er || "touchstart" !== r && "touchmove" !== r && "wheel" !== r || (a = !0), n ? void 0 !== a ? e.addEventListener(r, t, {
      capture: !0,
      passive: a
    }) : e.addEventListener(r, t, !0) : void 0 !== a ? e.addEventListener(r, t, {
      passive: a
    }) : e.addEventListener(r, t, !1);
  }
  function sa(e, r, t, n, a) {
    var i = n;
    if (0 == (1 & r) && 0 == (2 & r) && null !== n) e: for (;;) {
      if (null === n) return;
      var o = n.tag;
      if (3 === o || 4 === o) {
        var s = n.stateNode.containerInfo;
        if (s === a || 8 === s.nodeType && s.parentNode === a) break;
        if (4 === o) for (o = n.return; null !== o;) {
          var l = o.tag;
          if ((3 === l || 4 === l) && ((l = o.stateNode.containerInfo) === a || 8 === l.nodeType && l.parentNode === a)) return;
          o = o.return;
        }
        for (; null !== s;) {
          if (null === (o = p(s))) return;
          if (5 === (l = o.tag) || 6 === l || 26 === l || 27 === l) {
            n = i = o;
            continue e;
          }
          s = s.parentNode;
        }
      }
      n = n.return;
    }
    Ze(function () {
      var n = i,
        a = Ve(t),
        o = [];
      e: {
        var s = Gn.get(e);
        if (void 0 !== s) {
          var l = Ot,
            c = e;
          switch (e) {
            case "keypress":
              if (0 === wt(t)) break e;
            case "keydown":
            case "keyup":
              l = $t;
              break;
            case "focusin":
              c = "focus", l = Ft;
              break;
            case "focusout":
              c = "blur", l = Ft;
              break;
            case "beforeblur":
            case "afterblur":
              l = Ft;
              break;
            case "click":
              if (2 === t.button) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              l = It;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              l = Ht;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              l = Gt;
              break;
            case Un:
            case Wn:
            case $n:
              l = Lt;
              break;
            case Xn:
              l = Kt;
              break;
            case "scroll":
              l = Nt;
              break;
            case "wheel":
              l = Yt;
              break;
            case "copy":
            case "cut":
            case "paste":
              l = Pt;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              l = Xt;
          }
          var f = 0 != (4 & r),
            d = !f && "scroll" === e,
            v = f ? null !== s ? s + "Capture" : null : s;
          f = [];
          for (var h, m = n; null !== m;) {
            var _ = m;
            if (h = _.stateNode, 5 !== (_ = _.tag) && 26 !== _ && 27 !== _ || null === h || null === v || null != (_ = Je(m, v)) && f.push(la(m, _, h)), d) break;
            m = m.return;
          }
          0 < f.length && (s = new l(s, c, null, t, a), o.push({
            event: s,
            listeners: f
          }));
        }
      }
      if (0 == (7 & r)) {
        if (l = "mouseout" === e || "pointerout" === e, (!(s = "mouseover" === e || "pointerover" === e) || t === je || !(c = t.relatedTarget || t.fromElement) || !p(c) && !c[u]) && (l || s) && (s = a.window === a ? a : (s = a.ownerDocument) ? s.defaultView || s.parentWindow : window, l ? (l = n, null !== (c = (c = t.relatedTarget || t.toElement) ? p(c) : null) && (d = cr(c), f = c.tag, c !== d || 5 !== f && 27 !== f && 6 !== f) && (c = null)) : (l = null, c = n), l !== c)) {
          if (f = It, _ = "onMouseLeave", v = "onMouseEnter", m = "mouse", "pointerout" !== e && "pointerover" !== e || (f = Xt, _ = "onPointerLeave", v = "onPointerEnter", m = "pointer"), d = null == l ? s : b(l), h = null == c ? s : b(c), (s = new f(_, m + "leave", l, t, a)).target = d, s.relatedTarget = h, _ = null, p(a) === n && ((f = new f(v, m + "enter", c, t, a)).target = h, f.relatedTarget = d, _ = f), d = _, l && c) e: {
            for (v = c, m = 0, h = f = l; h; h = ua(h)) m++;
            for (h = 0, _ = v; _; _ = ua(_)) h++;
            for (; 0 < m - h;) f = ua(f), m--;
            for (; 0 < h - m;) v = ua(v), h--;
            for (; m--;) {
              if (f === v || null !== v && f === v.alternate) break e;
              f = ua(f), v = ua(v);
            }
            f = null;
          } else f = null;
          null !== l && fa(o, s, l, f, !1), null !== c && null !== d && fa(o, d, c, f, !0);
        }
        if ("select" === (l = (s = n ? b(n) : window).nodeName && s.nodeName.toLowerCase()) || "input" === l && "file" === s.type) var g = hn;else if (ln(s)) {
          if (mn) g = kn;else {
            g = wn;
            var S = En;
          }
        } else !(l = s.nodeName) || "input" !== l.toLowerCase() || "checkbox" !== s.type && "radio" !== s.type ? n && Be(n.elementType, n.memoizedProps) && (g = hn) : g = yn;
        switch (g && (g = g(e, n)) ? cn(o, g, t, a) : (S && S(e, s, n), "focusout" === e && (S = s._wrapperState) && S.controlled && "number" === s.type && we(s, "number", s.value)), S = n ? b(n) : window, e) {
          case "focusin":
            (ln(S) || "true" === S.contentEditable) && (Rn = S, In = n, Hn = null);
            break;
          case "focusout":
            Hn = In = Rn = null;
            break;
          case "mousedown":
            Fn = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Fn = !1, Ln(o, t, a);
            break;
          case "selectionchange":
            if (Nn) break;
          case "keydown":
          case "keyup":
            Ln(o, t, a);
        }
        var E;
        if (Qt) e: {
          switch (e) {
            case "compositionstart":
              var w = "onCompositionStart";
              break e;
            case "compositionend":
              w = "onCompositionEnd";
              break e;
            case "compositionupdate":
              w = "onCompositionUpdate";
              break e;
          }
          w = void 0;
        } else on ? nn(e, t) && (w = "onCompositionEnd") : "keydown" === e && 229 === t.keyCode && (w = "onCompositionStart");
        w && (en && "ko" !== t.locale && (on || "onCompositionStart" !== w ? "onCompositionEnd" === w && on && (E = Et()) : (bt = "value" in (gt = a) ? gt.value : gt.textContent, on = !0)), 0 < (S = ca(n, w)).length && (w = new zt(w, e, null, t, a), o.push({
          event: w,
          listeners: S
        }), E ? w.data = E : null !== (E = an(t)) && (w.data = E))), (E = Jt ? function (e, r) {
          switch (e) {
            case "compositionend":
              return an(r);
            case "keypress":
              return 32 !== r.which ? null : (tn = !0, rn);
            case "textInput":
              return (e = r.data) === rn && tn ? null : e;
            default:
              return null;
          }
        }(e, t) : function (e, r) {
          if (on) return "compositionend" === e || !Qt && nn(e, r) ? (e = Et(), St = bt = gt = null, on = !1, e) : null;
          switch (e) {
            case "paste":
              return null;
            case "keypress":
              if (!(r.ctrlKey || r.altKey || r.metaKey) || r.ctrlKey && r.altKey) {
                if (r.char && 1 < r.char.length) return r.char;
                if (r.which) return String.fromCharCode(r.which);
              }
              return null;
            case "compositionend":
              return en && "ko" !== r.locale ? null : r.data;
            default:
              return null;
          }
        }(e, t)) && 0 < (n = ca(n, "onBeforeInput")).length && (a = new zt("onBeforeInput", "beforeinput", null, t, a), o.push({
          event: a,
          listeners: n
        }), a.data = E);
      }
      ra(o, r);
    });
  }
  function la(e, r, t) {
    return {
      instance: e,
      listener: r,
      currentTarget: t
    };
  }
  function ca(e, r) {
    for (var t = r + "Capture", n = []; null !== e;) {
      var a = e,
        i = a.stateNode;
      5 !== (a = a.tag) && 26 !== a && 27 !== a || null === i || (null != (a = Je(e, t)) && n.unshift(la(e, a, i)), null != (a = Je(e, r)) && n.push(la(e, a, i))), e = e.return;
    }
    return n;
  }
  function ua(e) {
    if (null === e) return null;
    do {
      e = e.return;
    } while (e && 5 !== e.tag && 27 !== e.tag);
    return e || null;
  }
  function fa(e, r, t, n, a) {
    for (var i = r._reactName, o = []; null !== t && t !== n;) {
      var s = t,
        l = s.alternate,
        c = s.stateNode;
      if (s = s.tag, null !== l && l === n) break;
      5 !== s && 26 !== s && 27 !== s || null === c || (l = c, a ? null != (c = Je(t, i)) && o.unshift(la(t, c, l)) : a || null != (c = Je(t, i)) && o.push(la(t, c, l))), t = t.return;
    }
    0 !== o.length && e.push({
      event: r,
      listeners: o
    });
  }
  var da = /\r\n?/g,
    va = /\u0000|\uFFFD/g;
  function ha(e) {
    return ("string" == typeof e ? e : "" + e).replace(da, "\n").replace(va, "");
  }
  function ma(e, r, t) {
    if (r = ha(r), ha(e) !== r && t) throw Error(o(425));
  }
  function _a() {}
  function pa(e, r, t, n) {
    return t = 9 === t.nodeType ? t : t.ownerDocument, "http://www.w3.org/1999/xhtml" === n && (n = xe(e)), "http://www.w3.org/1999/xhtml" === n ? "script" === e ? ((r = t.createElement("div")).innerHTML = "<script></script>", n = r.removeChild(r.firstChild)) : "string" == typeof r.is ? n = t.createElement(e, {
      is: r.is
    }) : (n = t.createElement(e), "select" === e && (e = n, r.multiple ? e.multiple = !0 : r.size && (e.size = r.size))) : n = t.createElementNS(n, e), n;
  }
  function ga(e, r, t) {
    var n = Be(r, t);
    switch (r) {
      case "dialog":
        ta("cancel", e), ta("close", e);
        var a = t;
        break;
      case "iframe":
      case "object":
      case "embed":
        ta("load", e), a = t;
        break;
      case "video":
      case "audio":
        for (a = 0; a < Zn.length; a++) ta(Zn[a], e);
        a = t;
        break;
      case "source":
        ta("error", e), a = t;
        break;
      case "img":
      case "image":
      case "link":
        ta("error", e), ta("load", e), a = t;
        break;
      case "details":
        ta("toggle", e), a = t;
        break;
      case "input":
        ge(e, t), a = pe(e, t), ta("invalid", e);
        break;
      case "option":
        a = t;
        break;
      case "select":
        e._wrapperState = {
          wasMultiple: !!t.multiple
        }, a = oe({}, t, {
          value: void 0
        }), ta("invalid", e);
        break;
      case "textarea":
        De(e, t), a = Ce(e, t), ta("invalid", e);
        break;
      default:
        a = t;
    }
    ze(r, a);
    var i,
      o = a;
    for (i in o) if (o.hasOwnProperty(i)) {
      var s = o[i];
      "style" === i ? Le(e, s) : "dangerouslySetInnerHTML" === i ? null != (s = s ? s.__html : void 0) && Ne(e, s) : "children" === i ? "string" == typeof s ? "body" === r || "textarea" === r && "" === s || Re(e, s) : "number" == typeof s && "body" !== r && Re(e, "" + s) : "suppressContentEditableWarning" !== i && "suppressHydrationWarning" !== i && "autoFocus" !== i && (y.hasOwnProperty(i) ? null != s && "onScroll" === i && ta("scroll", e) : null != s && F(e, i, s, n));
    }
    switch (r) {
      case "input":
        he(e), Ee(e, t, !1);
        break;
      case "textarea":
        he(e), Me(e);
        break;
      case "option":
        null != t.value && e.setAttribute("value", "" + de(t.value));
        break;
      case "select":
        e.multiple = !!t.multiple, null != (r = t.value) ? ke(e, !!t.multiple, r, !1) : null != t.defaultValue && ke(e, !!t.multiple, t.defaultValue, !0);
        break;
      default:
        "function" == typeof a.onClick && (e.onclick = _a);
    }
  }
  var ba = [],
    Sa = -1;
  function Ea(e) {
    return {
      current: e
    };
  }
  function wa(e) {
    0 > Sa || (e.current = ba[Sa], ba[Sa] = null, Sa--);
  }
  function ya(e, r) {
    Sa++, ba[Sa] = e.current, e.current = r;
  }
  var ka = Ea(null),
    Ca = Ea(null),
    Da = Ea(null);
  function Aa(e, r) {
    switch (ya(Da, r), ya(Ca, e), ya(ka, null), e = r.nodeType) {
      case 9:
      case 11:
        r = (r = r.documentElement) ? r.namespaceURI : Oe(null, "");
        break;
      default:
        r = Oe(r = (e = 8 === e ? r.parentNode : r).namespaceURI || null, e = e.tagName);
    }
    wa(ka), ya(ka, r);
  }
  function Ma() {
    wa(ka), wa(Ca), wa(Da);
  }
  function xa(e) {
    var r = ka.current,
      t = Oe(r, e.type);
    r !== t && (ya(Ca, e), ya(ka, t));
  }
  function Oa(e) {
    Ca.current === e && (wa(ka), wa(Ca));
  }
  var Ta = i.Dispatcher,
    Na = null,
    Ra = null,
    Ia = {
      preload: function (e, r) {
        var t = Ba();
        if ("string" == typeof e && e && "object" == typeof r && null !== r && t) {
          var n = r.as;
          Ha.get(e) || Ga(t, e, {
            href: e,
            rel: "preload",
            as: n,
            crossOrigin: "font" === n ? "" : r.crossOrigin,
            integrity: r.integrity
          });
        }
      },
      preinit: function (e, r) {
        if ("string" == typeof e && e && "object" == typeof r && null !== r) {
          var t = La(),
            n = r.as;
          if (t) switch (n) {
            case "style":
              n = E(t).styles;
              var a = r.precedence || "default",
                i = n.get(e);
              i || (i = $a(n, t, e, a, {
                rel: "stylesheet",
                href: e,
                "data-precedence": a,
                crossOrigin: r.crossOrigin
              })), Va(i);
              break;
            case "script":
              n = E(t).scripts, (a = n.get(e)) || (a = Xa(n, t, e, {
                src: e,
                async: !0,
                crossOrigin: r.crossOrigin,
                integrity: r.integrity
              })), Va(a);
          } else (t = Ba()) && (Ha.get(e) || Ga(t, e, {
            href: e,
            rel: "preload",
            as: n,
            crossOrigin: "font" === n ? "" : r.crossOrigin,
            integrity: r.integrity
          }));
        }
      }
    },
    Ha = new Map();
  function Fa(e) {
    return "function" == typeof e.getRootNode ? e.getRootNode() : e.ownerDocument;
  }
  function La() {
    var e = Da.current;
    return e ? Fa(e) : null;
  }
  function Pa(e) {
    e.instance = void 0;
  }
  function za(e) {
    (e = E(e = Fa(e))).scripts.forEach(Pa), e.head.forEach(Pa);
  }
  function Ba() {
    var e = La();
    if (e) return e.ownerDocument || e;
    try {
      return Na || window.document;
    } catch (e) {
      return null;
    }
  }
  function ja(e) {
    return e.ownerDocument || e;
  }
  function Va(e) {
    switch (e.type) {
      case "base":
      case "title":
      case "link":
      case "meta":
        e: {
          e.count++;
          var r = e.instance;
          if (!r) {
            var t = e.props,
              n = e.root,
              a = e.type;
            switch (a) {
              case "title":
                var i = n.querySelectorAll("title");
                for (r = 0; r < i.length; r++) if (i[r].textContent === t.children) {
                  (r = e.instance = i[r])[m] = !0, e = r;
                  break e;
                }
                Za(n, r = e.instance = Wa(a, t, n), (e = i[0]) && "http://www.w3.org/2000/svg" !== e.namespaceURI ? e : null);
                break;
              case "meta":
                i = null;
                var s = e.matcher;
                r = e.property;
                var l = e.parentResource;
                if (l && "string" == typeof r) {
                  if (s = l.instance) for (s = i = s.nextSibling; l = s;) if (s = l.nextSibling, "META" === l.nodeName) {
                    var c = l.getAttribute("property");
                    if ("string" == typeof c) {
                      if (c === r && l.getAttribute("content") === t.content) {
                        e.instance = l, l[m] = !0, e = l;
                        break e;
                      }
                      if (r.startsWith(c + ":")) break;
                    }
                  }
                } else if (r = n.querySelector(s)) {
                  e.instance = r, r[m] = !0;
                  break;
                }
                Za(n, r = e.instance = Wa(a, t, n), i);
                break;
              case "link":
                if (i = "link[rel=\"" + (i = ei(t.rel)) + "\"][href=\"" + (r = ei(t.href)) + "\"]", "string" == typeof t.sizes && (i += "[sizes=\"" + (r = ei(t.sizes)) + "\"]"), "string" == typeof t.media && (i += "[media=\"" + (r = ei(t.media)) + "\"]"), i = n.querySelector(i)) {
                  (r = e.instance = i)[m] = !0;
                  break;
                }
                Za(n, r = e.instance = Wa(a, t, n), null);
                break;
              case "base":
                (i = n.querySelector(e.matcher)) ? (r = e.instance = i)[m] = !0 : Za(n, r = e.instance = Wa(a, t, n), n.querySelector("base"));
                break;
              default:
                throw Error(o(457, a));
            }
          }
          e = r;
        }
        return e;
      case "style":
        if (!(n = e.instance)) if (t = e.root, a = e.precedence, n = ei(e.props.href), i = t.querySelector("link[rel=\"stylesheet\"][data-precedence][href=\"" + n + "\"]")) {
          if ((n = e.instance = i)[m] = !0, e.preloaded = !0, t = i._p) switch (t.s) {
            case "l":
              e.loaded = !0, e.error = !1;
              break;
            case "e":
              e.error = !0;
              break;
            default:
              Ka(i, e);
          } else e.loaded = !0;
        } else {
          for (Ka(n = e.instance = Wa("link", e.props, ja(t)), e), i = n, l = s = (r = t.querySelectorAll("link[rel=\"stylesheet\"][data-precedence]")).length ? r[r.length - 1] : null, c = 0; c < r.length; c++) {
            var u = r[c];
            if (u.dataset.precedence === a) l = u;else if (l !== s) break;
          }
          if (l) l.parentNode.insertBefore(i, l.nextSibling);else {
            if (!(t = 9 === t.nodeType ? t.head : t)) throw Error(o(447));
            t.insertBefore(i, t.firstChild);
          }
        }
        return e.count++, n;
      case "script":
        return (t = e.instance) || (n = e.root, t = ei(e.props.src), (t = n.querySelector("script[async][src=\"" + t + "\"]")) ? (t = e.instance = t)[m] = !0 : (t = e.instance = Wa("script", e.props, ja(n)), Za(ja(n), t, null))), t;
      case "preload":
        return e.instance;
      default:
        throw Error(o(443, e.type));
    }
  }
  function Ua(e) {
    switch (e.type) {
      case "link":
      case "title":
      case "meta":
        if (0 == --e.count) {
          var r = e.instance,
            t = r.parentNode;
          t && t.removeChild(r), e.instance = null;
        }
        break;
      case "style":
        e.count--;
    }
  }
  function Wa(e, r, t) {
    return ga(t = pa(e, r, t, "http://www.w3.org/1999/xhtml"), e, r), t[m] = !0, t;
  }
  function $a(e, r, t, n, a) {
    var i = ei(t);
    if (i = r.querySelector("link[rel=\"stylesheet\"][href=\"" + i + "\"]"), r = {
      type: "style",
      count: 0,
      href: t,
      precedence: n,
      props: a,
      hint: null,
      preloaded: !1,
      loaded: !1,
      error: !1,
      root: r,
      instance: null
    }, e.set(t, r), i) {
      if (e = i._p) switch (e.s) {
        case "l":
          r.loaded = !0;
          break;
        case "e":
          r.error = !0;
          break;
        default:
          Ka(i, r);
      } else r.loaded = !0;
    } else (t = Ha.get(t)) && (r.hint = t, e = r.props, t = t.props, null == e.crossOrigin && (e.crossOrigin = t.crossOrigin), null == e.referrerPolicy && (e.referrerPolicy = t.referrerPolicy), null == e.title && (e.title = t.title));
    return r;
  }
  function Xa(e, r, t, n) {
    var a = ei(t);
    return a = r.querySelector("script[async][src=\"" + a + "\"]"), r = {
      type: "script",
      src: t,
      props: n,
      root: r,
      instance: a || null
    }, e.set(t, r), a ? a[m] = !0 : (e = Ha.get(t)) && (e = e.props, null == n.crossOrigin && (n.crossOrigin = e.crossOrigin), null == n.referrerPolicy && (n.referrerPolicy = e.referrerPolicy), null == n.integrity && (n.referrerPolicy = e.integrity)), r;
  }
  function Ga(e, r, t) {
    var n = ei(r);
    return (n = e.querySelector("link[rel=\"preload\"][href=\"" + n + "\"]")) ? n[m] = !0 : Za(e, n = Wa("link", t, e), null), {
      type: "preload",
      href: r,
      ownerDocument: e,
      props: t,
      instance: n
    };
  }
  function Ka(e, r) {
    var t = {};
    t.load = qa.bind(null, e, r, t, Ya), t.error = Qa.bind(null, e, r, t, Ya), e.addEventListener("load", t.load, Ya), e.addEventListener("error", t.error, Ya);
  }
  var Ya = {
    passive: !0
  };
  function qa(e, r, t, n) {
    for (var a in r.loaded = !0, r.error = !1, t) e.removeEventListener(a, t[a], n);
  }
  function Qa(e, r, t, n) {
    for (var a in r.loaded = !1, r.error = !0, t) e.removeEventListener(a, t[a], n);
  }
  function Za(e, r, t) {
    if (!(e = t && t.parentNode || e.head)) throw Error(o(447));
    e.insertBefore(r, t);
  }
  var Ja = /[\n"\\]/g;
  function ei(e) {
    return e.replace(Ja, function (e) {
      return "\\" + e.charCodeAt(0).toString(16);
    });
  }
  var ri = null,
    ti = null;
  function ni(e, r) {
    return "textarea" === e || "noscript" === e || "string" == typeof r.children || "number" == typeof r.children || "object" == typeof r.dangerouslySetInnerHTML && null !== r.dangerouslySetInnerHTML && null != r.dangerouslySetInnerHTML.__html;
  }
  var ai = "function" == typeof setTimeout ? setTimeout : void 0,
    ii = "function" == typeof clearTimeout ? clearTimeout : void 0,
    oi = "function" == typeof Promise ? Promise : void 0,
    si = "function" == typeof queueMicrotask ? queueMicrotask : void 0 !== oi ? function (e) {
      return oi.resolve(null).then(e).catch(li);
    } : ai;
  function li(e) {
    setTimeout(function () {
      throw e;
    });
  }
  function ci(e, r) {
    var t = r,
      n = 0;
    do {
      var a = t.nextSibling;
      if (e.removeChild(t), a && 8 === a.nodeType) if ("/$" === (t = a.data)) {
        if (0 === n) return e.removeChild(a), void ct(r);
        n--;
      } else "$" !== t && "$?" !== t && "$!" !== t || n++;
      t = a;
    } while (t);
    ct(r);
  }
  function ui(e) {
    var r = e.nodeType;
    if (9 === r) za(e), fi(e);else if (1 === r) switch (e.nodeName) {
      case "HEAD":
        za(e);
      case "HTML":
      case "BODY":
        fi(e);
        break;
      default:
        e.textContent = "";
    }
  }
  function fi(e) {
    var r = e.firstChild;
    for (r && 10 === r.nodeType && (r = r.nextSibling); r;) {
      var t = r;
      switch (r = r.nextSibling, t.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          fi(t), _(t);
          continue;
        case "STYLE":
          continue;
        case "LINK":
          if ("stylesheet" === t.rel.toLowerCase()) continue;
      }
      e.removeChild(t);
    }
  }
  function di(e) {
    for (; null != e; e = e.nextSibling) {
      var r = e.nodeType;
      if (1 === r) {
        switch ((r = e).tagName) {
          case "TITLE":
          case "META":
          case "BASE":
          case "HTML":
          case "HEAD":
          case "BODY":
            continue;
          case "LINK":
            if ("stylesheet" === r.rel && !r.hasAttribute("data-precedence")) break;
            continue;
          case "STYLE":
            if (r.hasAttribute("data-precedence")) continue;
            break;
          case "SCRIPT":
            if (r.hasAttribute("async")) continue;
        }
        break;
      }
      if (3 === r) break;
      if (8 === r) {
        if ("$" === (r = e.data) || "$!" === r || "$?" === r) break;
        if ("/$" === r) return null;
      }
    }
    return e;
  }
  function vi(e) {
    e = e.previousSibling;
    for (var r = 0; e;) {
      if (8 === e.nodeType) {
        var t = e.data;
        if ("$" === t || "$!" === t || "$?" === t) {
          if (0 === r) return e;
          r--;
        } else "/$" === t && r++;
      }
      e = e.previousSibling;
    }
    return null;
  }
  function hi(e, r, t) {
    switch (r = 9 === t.nodeType ? t : t.ownerDocument, e) {
      case "html":
        if (!(e = r.documentElement)) throw Error(o(452));
        return e;
      case "head":
        if (!(e = r.head)) throw Error(o(453));
        return e;
      case "body":
        if (!(e = r.body)) throw Error(o(454));
        return e;
      default:
        throw Error(o(451));
    }
  }
  var mi = {},
    _i = Ea(mi),
    pi = Ea(!1),
    gi = mi;
  function bi(e, r) {
    var t = e.type.contextTypes;
    if (!t) return mi;
    var n = e.stateNode;
    if (n && n.__reactInternalMemoizedUnmaskedChildContext === r) return n.__reactInternalMemoizedMaskedChildContext;
    var a,
      i = {};
    for (a in t) i[a] = r[a];
    return n && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = r, e.__reactInternalMemoizedMaskedChildContext = i), i;
  }
  function Si(e) {
    return null != (e = e.childContextTypes);
  }
  function Ei() {
    wa(pi), wa(_i);
  }
  function wi(e, r, t) {
    if (_i.current !== mi) throw Error(o(168));
    ya(_i, r), ya(pi, t);
  }
  function yi(e, r, t) {
    var n = e.stateNode;
    if (r = r.childContextTypes, "function" != typeof n.getChildContext) return t;
    for (var a in n = n.getChildContext()) if (!(a in r)) throw Error(o(108, fe(e) || "Unknown", a));
    return oe({}, t, n);
  }
  function ki(e) {
    return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || mi, gi = _i.current, ya(_i, e), ya(pi, pi.current), !0;
  }
  function Ci(e, r, t) {
    var n = e.stateNode;
    if (!n) throw Error(o(169));
    t ? (e = yi(e, r, gi), n.__reactInternalMemoizedMergedChildContext = e, wa(pi), wa(_i), ya(_i, e)) : wa(pi), ya(pi, t);
  }
  var Di = null,
    Ai = !1,
    Mi = !1;
  function xi(e) {
    null === Di ? Di = [e] : Di.push(e);
  }
  function Oi() {
    if (!Mi && null !== Di) {
      Mi = !0;
      var e = 0,
        r = zr;
      try {
        var t = Di;
        for (zr = 2; e < t.length; e++) {
          var n = t[e];
          do {
            n = n(!0);
          } while (null !== n);
        }
        Di = null, Ai = !1;
      } catch (r) {
        throw null !== Di && (Di = Di.slice(e + 1)), vr(br, Oi), r;
      } finally {
        zr = r, Mi = !1;
      }
    }
    return null;
  }
  var Ti = [],
    Ni = 0,
    Ri = null,
    Ii = 0,
    Hi = [],
    Fi = 0,
    Li = null,
    Pi = 1,
    zi = "";
  function Bi(e, r) {
    Ti[Ni++] = Ii, Ti[Ni++] = Ri, Ri = e, Ii = r;
  }
  function ji(e, r, t) {
    Hi[Fi++] = Pi, Hi[Fi++] = zi, Hi[Fi++] = Li, Li = e;
    var n = Pi;
    e = zi;
    var a = 32 - Dr(n) - 1;
    n &= ~(1 << a), t += 1;
    var i = 32 - Dr(r) + a;
    if (30 < i) {
      var o = a - a % 5;
      i = (n & (1 << o) - 1).toString(32), n >>= o, a -= o, Pi = 1 << 32 - Dr(r) + a | t << a | n, zi = i + e;
    } else Pi = 1 << i | t << a | n, zi = e;
  }
  function Vi(e) {
    null !== e.return && (Bi(e, 1), ji(e, 1, 0));
  }
  function Ui(e) {
    for (; e === Ri;) Ri = Ti[--Ni], Ti[Ni] = null, Ii = Ti[--Ni], Ti[Ni] = null;
    for (; e === Li;) Li = Hi[--Fi], Hi[Fi] = null, zi = Hi[--Fi], Hi[Fi] = null, Pi = Hi[--Fi], Hi[Fi] = null;
  }
  var Wi = null,
    $i = null,
    Xi = !1,
    Gi = null;
  function Ki(e, r) {
    var t = Df(5, null, null, 0);
    t.elementType = "DELETED", t.stateNode = r, t.return = e, null === (r = e.deletions) ? (e.deletions = [t], e.flags |= 16) : r.push(t);
  }
  function Yi(e, r) {
    switch (e.tag) {
      case 5:
        var t = e.type;
        return null !== (r = 1 !== r.nodeType || t.toLowerCase() !== r.nodeName.toLowerCase() ? null : r) && (e.stateNode = r, Wi = e, $i = di(r.firstChild), !0);
      case 6:
        return null !== (r = "" === e.pendingProps || 3 !== r.nodeType ? null : r) && (e.stateNode = r, Wi = e, $i = null, !0);
      case 13:
        return null !== (r = 8 !== r.nodeType ? null : r) && (t = null !== Li ? {
          id: Pi,
          overflow: zi
        } : null, e.memoizedState = {
          dehydrated: r,
          treeContext: t,
          retryLane: 1073741824
        }, (t = Df(18, null, null, 0)).stateNode = r, t.return = e, e.child = t, Wi = e, $i = null, !0);
      default:
        return !1;
    }
  }
  function qi(e) {
    return 0 != (1 & e.mode) && 0 == (128 & e.flags);
  }
  function Qi(e) {
    if (Xi) {
      var r = e.type,
        t = e.pendingProps;
      if ("link" === r) t = "stylesheet" === t.rel && "string" != typeof t.precedence;else if ("script" === r) {
        r = t.onLoad;
        var n = t.onError;
        t = !(t.async && (r || n));
      } else t = !0;
      if (t) {
        if (t = $i) {
          if (r = t, !Yi(e, t)) {
            if (qi(e)) throw Error(o(418));
            t = di(r.nextSibling), n = Wi, t && Yi(e, t) ? Ki(n, r) : (e.flags = -4097 & e.flags | 2, Xi = !1, Wi = e);
          }
        } else {
          if (qi(e)) throw Error(o(418));
          e.flags = -4097 & e.flags | 2, Xi = !1, Wi = e;
        }
      } else e.flags = -4097 & e.flags | 2, Xi = !1, Wi = e;
    }
  }
  function Zi(e) {
    var r = e.stateNode,
      t = e.type,
      n = e.memoizedProps;
    r[l] = e, r[c] = n;
    var a = 0 != (1 & e.mode);
    switch (t) {
      case "dialog":
        ta("cancel", r), ta("close", r);
        break;
      case "iframe":
      case "object":
      case "embed":
        ta("load", r);
        break;
      case "video":
      case "audio":
        for (var i = 0; i < Zn.length; i++) ta(Zn[i], r);
        break;
      case "source":
        ta("error", r);
        break;
      case "img":
      case "image":
      case "link":
        ta("error", r), ta("load", r);
        break;
      case "details":
        ta("toggle", r);
        break;
      case "input":
        ge(r, n), ta("invalid", r);
        break;
      case "select":
        r._wrapperState = {
          wasMultiple: !!n.multiple
        }, ta("invalid", r);
        break;
      case "textarea":
        De(r, n), ta("invalid", r);
    }
    for (var o in ze(t, n), i = null, n) if (n.hasOwnProperty(o)) {
      var s = n[o];
      "children" === o ? "string" == typeof s ? r.textContent !== s && (!0 !== n.suppressHydrationWarning && ma(r.textContent, s, a), i = ["children", s]) : "number" == typeof s && r.textContent !== "" + s && (!0 !== n.suppressHydrationWarning && ma(r.textContent, s, a), i = ["children", "" + s]) : y.hasOwnProperty(o) && null != s && "onScroll" === o && ta("scroll", r);
    }
    switch (t) {
      case "input":
        he(r), Ee(r, n, !0);
        break;
      case "textarea":
        he(r), Me(r);
        break;
      case "select":
      case "option":
        break;
      default:
        "function" == typeof n.onClick && (r.onclick = _a);
    }
    return r = i, e.updateQueue = r, null !== r;
  }
  function Ji(e) {
    for (e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag && 27 !== e.tag;) e = e.return;
    Wi = e;
  }
  function eo(e) {
    if (e !== Wi) return !1;
    if (!Xi) return Ji(e), Xi = !0, !1;
    var r = !1;
    if (3 === e.tag || 27 === e.tag || 5 === e.tag && ni(e.type, e.memoizedProps) || (r = !0), r && (r = $i)) {
      if (qi(e)) throw ro(), Error(o(418));
      for (; r;) Ki(e, r), r = di(r.nextSibling);
    }
    if (Ji(e), 13 === e.tag) {
      if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(o(317));
      e: {
        for (e = e.nextSibling, r = 0; e;) {
          if (8 === e.nodeType) {
            var t = e.data;
            if ("/$" === t) {
              if (0 === r) {
                $i = di(e.nextSibling);
                break e;
              }
              r--;
            } else "$" !== t && "$!" !== t && "$?" !== t || r++;
          }
          e = e.nextSibling;
        }
        $i = null;
      }
    } else $i = Wi ? di(e.stateNode.nextSibling) : null;
    return !0;
  }
  function ro() {
    for (var e = $i; e;) e = di(e.nextSibling);
  }
  function to() {
    $i = Wi = null, Xi = !1;
  }
  function no(e) {
    null === Gi ? Gi = [e] : Gi.push(e);
  }
  var ao = [],
    io = 0,
    oo = 0;
  function so() {
    for (var e = io, r = oo = io = 0; r < e;) {
      var t = ao[r];
      ao[r++] = null;
      var n = ao[r];
      ao[r++] = null;
      var a = ao[r];
      ao[r++] = null;
      var i = ao[r];
      if (ao[r++] = null, null !== n && null !== a) {
        var o = n.pending;
        null === o ? a.next = a : (a.next = o.next, o.next = a), n.pending = a;
      }
      0 !== i && uo(t, a, i);
    }
  }
  function lo(e, r, t, n) {
    ao[io++] = e, ao[io++] = r, ao[io++] = t, ao[io++] = n, oo |= n, e.lanes |= n, null !== (e = e.alternate) && (e.lanes |= n);
  }
  function co(e, r) {
    return lo(e, null, null, r), fo(e);
  }
  function uo(e, r, t) {
    e.lanes |= t;
    var n = e.alternate;
    null !== n && (n.lanes |= t);
    for (var a = !1, i = e.return; null !== i;) i.childLanes |= t, null !== (n = i.alternate) && (n.childLanes |= t), 22 === i.tag && (null === (e = i.stateNode) || 1 & e._visibility || (a = !0)), e = i, i = i.return;
    a && null !== r && 3 === e.tag && (i = e.stateNode, a = 31 - Dr(t), null === (e = (i = i.hiddenUpdates)[a]) ? i[a] = [r] : e.push(r), r.lane = 1073741824 | t);
  }
  function fo(e) {
    if (50 < zu) throw zu = 0, Bu = null, Error(o(185));
    for (var r = e.return; null !== r;) r = (e = r).return;
    return 3 === e.tag ? e.stateNode : null;
  }
  var vo = !1;
  function ho(e) {
    e.updateQueue = {
      baseState: e.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: {
        pending: null,
        lanes: 0,
        hiddenCallbacks: null
      },
      callbacks: null
    };
  }
  function mo(e, r) {
    e = e.updateQueue, r.updateQueue === e && (r.updateQueue = {
      baseState: e.baseState,
      firstBaseUpdate: e.firstBaseUpdate,
      lastBaseUpdate: e.lastBaseUpdate,
      shared: e.shared,
      callbacks: null
    });
  }
  function _o(e, r) {
    return {
      eventTime: e,
      lane: r,
      tag: 0,
      payload: null,
      callback: null,
      next: null
    };
  }
  function po(e, r, t) {
    var n = e.updateQueue;
    if (null === n) return null;
    if (n = n.shared, 0 != (2 & vu)) {
      var a = n.pending;
      return null === a ? r.next = r : (r.next = a.next, a.next = r), n.pending = r, r = fo(e), uo(e, null, t), r;
    }
    return lo(e, n, r, t), fo(e);
  }
  function go(e, r, t) {
    if (null !== (r = r.updateQueue) && (r = r.shared, 0 != (8388480 & t))) {
      var n = r.lanes;
      t |= n &= e.pendingLanes, r.lanes = t, Pr(e, t);
    }
  }
  function bo(e, r) {
    var t = e.updateQueue,
      n = e.alternate;
    if (null !== n && t === (n = n.updateQueue)) {
      var a = null,
        i = null;
      if (null !== (t = t.firstBaseUpdate)) {
        do {
          var o = {
            eventTime: t.eventTime,
            lane: t.lane,
            tag: t.tag,
            payload: t.payload,
            callback: null,
            next: null
          };
          null === i ? a = i = o : i = i.next = o, t = t.next;
        } while (null !== t);
        null === i ? a = i = r : i = i.next = r;
      } else a = i = r;
      return t = {
        baseState: n.baseState,
        firstBaseUpdate: a,
        lastBaseUpdate: i,
        shared: n.shared,
        callbacks: n.callbacks
      }, void (e.updateQueue = t);
    }
    null === (e = t.lastBaseUpdate) ? t.firstBaseUpdate = r : e.next = r, t.lastBaseUpdate = r;
  }
  function So(e, r, t, n) {
    var a = e.updateQueue;
    vo = !1;
    var i = a.firstBaseUpdate,
      o = a.lastBaseUpdate,
      s = a.shared.pending;
    if (null !== s) {
      a.shared.pending = null;
      var l = s,
        c = l.next;
      l.next = null, null === o ? i = c : o.next = c, o = l;
      var u = e.alternate;
      null !== u && (s = (u = u.updateQueue).lastBaseUpdate) !== o && (null === s ? u.firstBaseUpdate = c : s.next = c, u.lastBaseUpdate = l);
    }
    if (null !== i) {
      var f = a.baseState;
      for (o = 0, u = c = l = null, s = i;;) {
        var d = s.eventTime,
          v = -1073741825 & s.lane,
          h = v !== s.lane;
        if (h ? (_u & v) === v : (n & v) === v) {
          null !== u && (u = u.next = {
            eventTime: d,
            lane: 0,
            tag: s.tag,
            payload: s.payload,
            callback: null,
            next: null
          });
          e: {
            var m = e,
              _ = s;
            switch (v = r, d = t, _.tag) {
              case 1:
                if ("function" == typeof (m = _.payload)) {
                  f = m.call(d, f, v);
                  break e;
                }
                f = m;
                break e;
              case 3:
                m.flags = -65537 & m.flags | 128;
              case 0:
                if (null == (v = "function" == typeof (m = _.payload) ? m.call(d, f, v) : m)) break e;
                f = oe({}, f, v);
                break e;
              case 2:
                vo = !0;
            }
          }
          null !== (v = s.callback) && (e.flags |= 64, h && (e.flags |= 8192), null === (h = a.callbacks) ? a.callbacks = [v] : h.push(v));
        } else h = {
          eventTime: d,
          lane: v,
          tag: s.tag,
          payload: s.payload,
          callback: s.callback,
          next: null
        }, null === u ? (c = u = h, l = f) : u = u.next = h, o |= v;
        if (null === (s = s.next)) {
          if (null === (s = a.shared.pending)) break;
          s = (h = s).next, h.next = null, a.lastBaseUpdate = h, a.shared.pending = null;
        }
      }
      null === u && (l = f), a.baseState = l, a.firstBaseUpdate = c, a.lastBaseUpdate = u, null === i && (a.shared.lanes = 0), yu |= o, e.lanes = o, e.memoizedState = f;
    }
  }
  function Eo(e, r) {
    if ("function" != typeof e) throw Error(o(191, e));
    e.call(r);
  }
  function wo(e, r) {
    var t = e.callbacks;
    if (null !== t) for (e.callbacks = null, e = 0; e < t.length; e++) Eo(t[e], r);
  }
  function yo(e, r, t) {
    if (null !== (e = t.ref) && "function" != typeof e && "object" != typeof e) {
      if (t._owner) {
        if (t = t._owner) {
          if (1 !== t.tag) throw Error(o(309));
          var n = t.stateNode;
        }
        if (!n) throw Error(o(147, e));
        var a = n,
          i = "" + e;
        return null !== r && null !== r.ref && "function" == typeof r.ref && r.ref._stringRef === i ? r.ref : ((r = function (e) {
          var r = a.refs;
          null === e ? delete r[i] : r[i] = e;
        })._stringRef = i, r);
      }
      if ("string" != typeof e) throw Error(o(284));
      if (!t._owner) throw Error(o(290, e));
    }
    return e;
  }
  function ko(e, r) {
    throw e = Object.prototype.toString.call(r), Error(o(31, "[object Object]" === e ? "object with keys {" + Object.keys(r).join(", ") + "}" : e));
  }
  function Co(e) {
    return (0, e._init)(e._payload);
  }
  function Do(e) {
    function r(r, t) {
      if (e) {
        var n = r.deletions;
        null === n ? (r.deletions = [t], r.flags |= 16) : n.push(t);
      }
    }
    function t(t, n) {
      if (!e) return null;
      for (; null !== n;) r(t, n), n = n.sibling;
      return null;
    }
    function n(e, r) {
      for (e = new Map(); null !== r;) null !== r.key ? e.set(r.key, r) : e.set(r.index, r), r = r.sibling;
      return e;
    }
    function a(e, r) {
      return (e = Mf(e, r)).index = 0, e.sibling = null, e;
    }
    function i(r, t, n) {
      return r.index = n, e ? null !== (n = r.alternate) ? (n = n.index) < t ? (r.flags |= 16777218, t) : n : (r.flags |= 16777218, t) : (r.flags |= 1048576, t);
    }
    function s(r) {
      return e && null === r.alternate && (r.flags |= 16777218), r;
    }
    function l(e, r, t, n) {
      return null === r || 6 !== r.tag ? ((r = Rf(t, e.mode, n)).return = e, r) : ((r = a(r, t)).return = e, r);
    }
    function c(e, r, t, n) {
      var i = t.type;
      return i === B ? f(e, r, t.props.children, n, t.key) : null !== r && (r.elementType === i || "object" == typeof i && null !== i && i.$$typeof === q && Co(i) === r.type) ? ((n = a(r, t.props)).ref = yo(e, r, t), n.return = e, n) : ((n = Of(t.type, t.key, t.props, null, e.mode, n)).ref = yo(e, r, t), n.return = e, n);
    }
    function u(e, r, t, n) {
      return null === r || 4 !== r.tag || r.stateNode.containerInfo !== t.containerInfo || r.stateNode.implementation !== t.implementation ? ((r = If(t, e.mode, n)).return = e, r) : ((r = a(r, t.children || [])).return = e, r);
    }
    function f(e, r, t, n, i) {
      return null === r || 7 !== r.tag ? ((r = Tf(t, e.mode, n, i)).return = e, r) : ((r = a(r, t)).return = e, r);
    }
    function d(e, r, t) {
      if ("string" == typeof r && "" !== r || "number" == typeof r) return (r = Rf("" + r, e.mode, t)).return = e, r;
      if ("object" == typeof r && null !== r) {
        switch (r.$$typeof) {
          case P:
            return (t = Of(r.type, r.key, r.props, null, e.mode, t)).ref = yo(e, null, r), t.return = e, t;
          case z:
            return (r = If(r, e.mode, t)).return = e, r;
          case q:
            return d(e, (0, r._init)(r._payload), t);
        }
        if (ye(r) || ae(r)) return (r = Tf(r, e.mode, t, null)).return = e, r;
        ko(e, r);
      }
      return null;
    }
    function v(e, r, t, n) {
      var a = null !== r ? r.key : null;
      if ("string" == typeof t && "" !== t || "number" == typeof t) return null !== a ? null : l(e, r, "" + t, n);
      if ("object" == typeof t && null !== t) {
        switch (t.$$typeof) {
          case P:
            return t.key === a ? c(e, r, t, n) : null;
          case z:
            return t.key === a ? u(e, r, t, n) : null;
          case q:
            return v(e, r, (a = t._init)(t._payload), n);
        }
        if (ye(t) || ae(t)) return null !== a ? null : f(e, r, t, n, null);
        ko(e, t);
      }
      return null;
    }
    function h(e, r, t, n, a) {
      if ("string" == typeof n && "" !== n || "number" == typeof n) return l(r, e = e.get(t) || null, "" + n, a);
      if ("object" == typeof n && null !== n) {
        switch (n.$$typeof) {
          case P:
            return c(r, e = e.get(null === n.key ? t : n.key) || null, n, a);
          case z:
            return u(r, e = e.get(null === n.key ? t : n.key) || null, n, a);
          case q:
            return h(e, r, t, (0, n._init)(n._payload), a);
        }
        if (ye(n) || ae(n)) return f(r, e = e.get(t) || null, n, a, null);
        ko(r, n);
      }
      return null;
    }
    function m(a, o, s, l) {
      for (var c = null, u = null, f = o, m = o = 0, _ = null; null !== f && m < s.length; m++) {
        f.index > m ? (_ = f, f = null) : _ = f.sibling;
        var p = v(a, f, s[m], l);
        if (null === p) {
          null === f && (f = _);
          break;
        }
        e && f && null === p.alternate && r(a, f), o = i(p, o, m), null === u ? c = p : u.sibling = p, u = p, f = _;
      }
      if (m === s.length) return t(a, f), Xi && Bi(a, m), c;
      if (null === f) {
        for (; m < s.length; m++) null !== (f = d(a, s[m], l)) && (o = i(f, o, m), null === u ? c = f : u.sibling = f, u = f);
        return Xi && Bi(a, m), c;
      }
      for (f = n(a, f); m < s.length; m++) null !== (_ = h(f, a, m, s[m], l)) && (e && null !== _.alternate && f.delete(null === _.key ? m : _.key), o = i(_, o, m), null === u ? c = _ : u.sibling = _, u = _);
      return e && f.forEach(function (e) {
        return r(a, e);
      }), Xi && Bi(a, m), c;
    }
    function _(a, s, l, c) {
      var u = ae(l);
      if ("function" != typeof u) throw Error(o(150));
      if (null == (l = u.call(l))) throw Error(o(151));
      for (var f = u = null, m = s, _ = s = 0, p = null, g = l.next(); null !== m && !g.done; _++, g = l.next()) {
        m.index > _ ? (p = m, m = null) : p = m.sibling;
        var b = v(a, m, g.value, c);
        if (null === b) {
          null === m && (m = p);
          break;
        }
        e && m && null === b.alternate && r(a, m), s = i(b, s, _), null === f ? u = b : f.sibling = b, f = b, m = p;
      }
      if (g.done) return t(a, m), Xi && Bi(a, _), u;
      if (null === m) {
        for (; !g.done; _++, g = l.next()) null !== (g = d(a, g.value, c)) && (s = i(g, s, _), null === f ? u = g : f.sibling = g, f = g);
        return Xi && Bi(a, _), u;
      }
      for (m = n(a, m); !g.done; _++, g = l.next()) null !== (g = h(m, a, _, g.value, c)) && (e && null !== g.alternate && m.delete(null === g.key ? _ : g.key), s = i(g, s, _), null === f ? u = g : f.sibling = g, f = g);
      return e && m.forEach(function (e) {
        return r(a, e);
      }), Xi && Bi(a, _), u;
    }
    return function e(n, i, o, l) {
      if ("object" == typeof o && null !== o && o.type === B && null === o.key && (o = o.props.children), "object" == typeof o && null !== o) {
        switch (o.$$typeof) {
          case P:
            e: {
              for (var c = o.key, u = i; null !== u;) {
                if (u.key === c) {
                  if ((c = o.type) === B) {
                    if (7 === u.tag) {
                      t(n, u.sibling), (i = a(u, o.props.children)).return = n, n = i;
                      break e;
                    }
                  } else if (u.elementType === c || "object" == typeof c && null !== c && c.$$typeof === q && Co(c) === u.type) {
                    t(n, u.sibling), (i = a(u, o.props)).ref = yo(n, u, o), i.return = n, n = i;
                    break e;
                  }
                  t(n, u);
                  break;
                }
                r(n, u), u = u.sibling;
              }
              o.type === B ? ((i = Tf(o.props.children, n.mode, l, o.key)).return = n, n = i) : ((l = Of(o.type, o.key, o.props, null, n.mode, l)).ref = yo(n, i, o), l.return = n, n = l);
            }
            return s(n);
          case z:
            e: {
              for (u = o.key; null !== i;) {
                if (i.key === u) {
                  if (4 === i.tag && i.stateNode.containerInfo === o.containerInfo && i.stateNode.implementation === o.implementation) {
                    t(n, i.sibling), (i = a(i, o.children || [])).return = n, n = i;
                    break e;
                  }
                  t(n, i);
                  break;
                }
                r(n, i), i = i.sibling;
              }
              (i = If(o, n.mode, l)).return = n, n = i;
            }
            return s(n);
          case q:
            return e(n, i, (u = o._init)(o._payload), l);
        }
        if (ye(o)) return m(n, i, o, l);
        if (ae(o)) return _(n, i, o, l);
        ko(n, o);
      }
      return "string" == typeof o && "" !== o || "number" == typeof o ? (o = "" + o, null !== i && 6 === i.tag ? (t(n, i.sibling), (i = a(i, o)).return = n, n = i) : (t(n, i), (i = Rf(o, n.mode, l)).return = n, n = i), s(n)) : t(n, i);
    };
  }
  var Ao = Do(!0),
    Mo = Do(!1),
    xo = Ea(null),
    Oo = Ea(0);
  function To(e, r) {
    ya(Oo, e = Su), ya(xo, r), Su = e | r.baseLanes;
  }
  function No() {
    ya(Oo, Su), ya(xo, xo.current);
  }
  function Ro() {
    Su = Oo.current, wa(xo), wa(Oo);
  }
  var Io = Ea(null),
    Ho = null;
  function Fo(e) {
    var r = e.alternate;
    ya(Io, e), null === Ho && (null === r || null !== xo.current || null !== r.memoizedState) && (Ho = e);
  }
  function Lo(e) {
    if (22 === e.tag) {
      if (ya(Io, e), null === Ho) {
        var r = e.alternate;
        null !== r && null !== r.memoizedState && (Ho = e);
      }
    } else Po();
  }
  function Po() {
    ya(Io, Io.current);
  }
  function zo(e) {
    wa(Io), Ho === e && (Ho = null);
  }
  var Bo = Ea(0);
  function jo(e) {
    for (var r = e; null !== r;) {
      if (13 === r.tag) {
        var t = r.memoizedState;
        if (null !== t && (null === (t = t.dehydrated) || "$?" === t.data || "$!" === t.data)) return r;
      } else if (19 === r.tag && void 0 !== r.memoizedProps.revealOrder) {
        if (0 != (128 & r.flags)) return r;
      } else if (null !== r.child) {
        r.child.return = r, r = r.child;
        continue;
      }
      if (r === e) break;
      for (; null === r.sibling;) {
        if (null === r.return || r.return === e) return null;
        r = r.return;
      }
      r.sibling.return = r.return, r = r.sibling;
    }
    return null;
  }
  var Vo = [];
  function Uo() {
    for (var e = 0; e < Vo.length; e++) Vo[e]._workInProgressVersionPrimary = null;
    Vo.length = 0;
  }
  var Wo = Error(o(460));
  function $o(e) {
    return "fulfilled" === (e = e.status) || "rejected" === e;
  }
  function Xo() {}
  var Go = null,
    Ko = L.ReactCurrentDispatcher,
    Yo = L.ReactCurrentBatchConfig,
    qo = 0,
    Qo = null,
    Zo = null,
    Jo = null,
    es = !1,
    rs = !1,
    ts = !1,
    ns = 0,
    as = 0,
    is = null,
    os = 0;
  function ss() {
    throw Error(o(321));
  }
  function ls(e, r) {
    if (null === r) return !1;
    for (var t = 0; t < r.length && t < e.length; t++) if (!Cn(e[t], r[t])) return !1;
    return !0;
  }
  function cs(e, r, t, n, a, i) {
    return qo = i, Qo = r, r.memoizedState = null, r.updateQueue = null, r.lanes = 0, Ko.current = null === e || null === e.memoizedState ? rl : tl, ts = !1, e = t(n, a), ts = !1, rs && (e = fs(r, t, n, a)), us(), e;
  }
  function us() {
    Ko.current = el;
    var e = null !== Zo && null !== Zo.next;
    if (qo = 0, Jo = Zo = Qo = null, es = !1, as = 0, is = null, e) throw Error(o(300));
  }
  function fs(e, r, t, n) {
    var a = 0;
    do {
      if (rs = !1, as = 0, 25 <= a) throw Error(o(301));
      a += 1, Jo = Zo = null, e.updateQueue = null, Ko.current = nl;
      var i = r(t, n);
    } while (rs);
    return i;
  }
  function ds() {
    var e = 0 !== ns;
    return ns = 0, e;
  }
  function vs(e, r, t) {
    r.updateQueue = e.updateQueue, r.flags &= -2053, e.lanes &= ~t;
  }
  function hs() {
    if (es) {
      for (var e = Qo.memoizedState; null !== e;) {
        var r = e.queue;
        null !== r && (r.pending = null), e = e.next;
      }
      es = !1;
    }
    qo = 0, Jo = Zo = Qo = null, rs = !1, as = ns = 0, is = null;
  }
  function ms() {
    var e = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return null === Jo ? Qo.memoizedState = Jo = e : Jo = Jo.next = e, Jo;
  }
  function _s() {
    if (null === Zo) {
      var e = Qo.alternate;
      e = null !== e ? e.memoizedState : null;
    } else e = Zo.next;
    var r = null === Jo ? Qo.memoizedState : Jo.next;
    if (null !== r) Jo = r, Zo = e;else {
      if (null === e) {
        if (null !== Qo.alternate) throw Error(o(310));
        e = {
          memoizedState: null,
          baseState: null,
          baseQueue: null,
          queue: null,
          next: null
        };
      }
      e = {
        memoizedState: (Zo = e).memoizedState,
        baseState: Zo.baseState,
        baseQueue: Zo.baseQueue,
        queue: Zo.queue,
        next: null
      }, null === Jo ? Qo.memoizedState = Jo = e : Jo = Jo.next = e;
    }
    return Jo;
  }
  function ps(e) {
    if (null !== e && "object" == typeof e) {
      if ("function" == typeof e.then) {
        var r = as;
        return as += 1, null === is && (is = []), function (e, r, t) {
          switch (void 0 === (t = e[t]) ? e.push(r) : t !== r && (r.then(Xo, Xo), r = t), r.status) {
            case "fulfilled":
              return r.value;
            case "rejected":
              throw r.reason;
            default:
              switch ("string" == typeof r.status ? r.then(Xo, Xo) : ((e = r).status = "pending", e.then(function (e) {
                if ("pending" === r.status) {
                  var t = r;
                  t.status = "fulfilled", t.value = e;
                }
              }, function (e) {
                if ("pending" === r.status) {
                  var t = r;
                  t.status = "rejected", t.reason = e;
                }
              })), r.status) {
                case "fulfilled":
                  return r.value;
                case "rejected":
                  throw r.reason;
              }
              throw Go = r, Wo;
          }
        }(is, e, r);
      }
      if (e.$$typeof === W || e.$$typeof === $) return ec(e);
    }
    throw Error(o(438, String(e)));
  }
  function gs(e) {
    var r = null,
      t = Qo.updateQueue;
    if (null !== t && (r = t.memoCache), null == r) {
      var n = Qo.alternate;
      null !== n && null !== (n = n.updateQueue) && null != (n = n.memoCache) && (r = {
        data: n.data.map(function (e) {
          return e.slice();
        }),
        index: 0
      });
    }
    if (null == r && (r = {
      data: [],
      index: 0
    }), null === t && (t = {
      lastEffect: null,
      events: null,
      stores: null,
      memoCache: null
    }, Qo.updateQueue = t), t.memoCache = r, void 0 === (t = r.data[r.index])) for (t = r.data[r.index] = Array(e), n = 0; n < e; n++) t[n] = te;
    return r.index++, t;
  }
  function bs(e, r) {
    return "function" == typeof r ? r(e) : r;
  }
  function Ss(e) {
    var r = _s(),
      t = r.queue;
    if (null === t) throw Error(o(311));
    t.lastRenderedReducer = e;
    var n = Zo,
      a = n.baseQueue,
      i = t.pending;
    if (null !== i) {
      if (null !== a) {
        var s = a.next;
        a.next = i.next, i.next = s;
      }
      n.baseQueue = a = i, t.pending = null;
    }
    if (null !== a) {
      i = a.next, n = n.baseState;
      var l = s = null,
        c = null,
        u = i;
      do {
        var f = -1073741825 & u.lane;
        if (f !== u.lane ? (_u & f) === f : (qo & f) === f) null !== c && (c = c.next = {
          lane: 0,
          action: u.action,
          hasEagerState: u.hasEagerState,
          eagerState: u.eagerState,
          next: null
        }), f = u.action, ts && e(n, f), n = u.hasEagerState ? u.eagerState : e(n, f);else {
          var d = {
            lane: f,
            action: u.action,
            hasEagerState: u.hasEagerState,
            eagerState: u.eagerState,
            next: null
          };
          null === c ? (l = c = d, s = n) : c = c.next = d, Qo.lanes |= f, yu |= f;
        }
        u = u.next;
      } while (null !== u && u !== i);
      null === c ? s = n : c.next = l, Cn(n, r.memoizedState) || (bl = !0), r.memoizedState = n, r.baseState = s, r.baseQueue = c, t.lastRenderedState = n;
    }
    return null === a && (t.lanes = 0), [r.memoizedState, t.dispatch];
  }
  function Es(e) {
    var r = _s(),
      t = r.queue;
    if (null === t) throw Error(o(311));
    t.lastRenderedReducer = e;
    var n = t.dispatch,
      a = t.pending,
      i = r.memoizedState;
    if (null !== a) {
      t.pending = null;
      var s = a = a.next;
      do {
        i = e(i, s.action), s = s.next;
      } while (s !== a);
      Cn(i, r.memoizedState) || (bl = !0), r.memoizedState = i, null === r.baseQueue && (r.baseState = i), t.lastRenderedState = i;
    }
    return [i, n];
  }
  function ws() {}
  function ys(e, r) {
    var t = Qo,
      n = _s(),
      a = r(),
      i = !Cn((Zo || n).memoizedState, a);
    if (i && (n.memoizedState = a, bl = !0), n = n.queue, Hs(Ds.bind(null, t, n, e), [e]), n.getSnapshot !== r || i || null !== Jo && 1 & Jo.memoizedState.tag) {
      if (t.flags |= 2048, Os(9, Cs.bind(null, t, n, a, r), void 0, null), null === hu) throw Error(o(349));
      0 != (60 & qo) || ks(t, r, a);
    }
    return a;
  }
  function ks(e, r, t) {
    e.flags |= 16384, e = {
      getSnapshot: r,
      value: t
    }, null === (r = Qo.updateQueue) ? (r = {
      lastEffect: null,
      events: null,
      stores: null,
      memoCache: null
    }, Qo.updateQueue = r, r.stores = [e]) : null === (t = r.stores) ? r.stores = [e] : t.push(e);
  }
  function Cs(e, r, t, n) {
    r.value = t, r.getSnapshot = n, As(r) && Ms(e);
  }
  function Ds(e, r, t) {
    return t(function () {
      As(r) && Ms(e);
    });
  }
  function As(e) {
    var r = e.getSnapshot;
    e = e.value;
    try {
      var t = r();
      return !Cn(e, t);
    } catch (e) {
      return !0;
    }
  }
  function Ms(e) {
    var r = co(e, 2);
    null !== r && $u(r, e, 2, -1);
  }
  function xs(e) {
    var r = ms();
    return "function" == typeof e && (e = e()), r.memoizedState = r.baseState = e, e = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: bs,
      lastRenderedState: e
    }, r.queue = e, e = e.dispatch = qs.bind(null, Qo, e), [r.memoizedState, e];
  }
  function Os(e, r, t, n) {
    return e = {
      tag: e,
      create: r,
      destroy: t,
      deps: n,
      next: null
    }, null === (r = Qo.updateQueue) ? (r = {
      lastEffect: null,
      events: null,
      stores: null,
      memoCache: null
    }, Qo.updateQueue = r, r.lastEffect = e.next = e) : null === (t = r.lastEffect) ? r.lastEffect = e.next = e : (n = t.next, t.next = e, e.next = n, r.lastEffect = e), e;
  }
  function Ts() {
    return _s().memoizedState;
  }
  function Ns(e, r, t, n) {
    var a = ms();
    Qo.flags |= e, a.memoizedState = Os(1 | r, t, void 0, void 0 === n ? null : n);
  }
  function Rs(e, r, t, n) {
    var a = _s();
    n = void 0 === n ? null : n;
    var i = void 0;
    if (null !== Zo) {
      var o = Zo.memoizedState;
      if (i = o.destroy, null !== n && ls(n, o.deps)) return void (a.memoizedState = Os(r, t, i, n));
    }
    Qo.flags |= e, a.memoizedState = Os(1 | r, t, i, n);
  }
  function Is(e, r) {
    Ns(8390656, 8, e, r);
  }
  function Hs(e, r) {
    Rs(2048, 8, e, r);
  }
  function Fs(e) {
    var r = _s().memoizedState;
    return function (e) {
      Qo.flags |= 4;
      var r = Qo.updateQueue;
      if (null === r) r = {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
      }, Qo.updateQueue = r, r.events = [e];else {
        var t = r.events;
        null === t ? r.events = [e] : t.push(e);
      }
    }({
      ref: r,
      nextImpl: e
    }), function () {
      if (0 != (2 & vu)) throw Error(o(440));
      return r.impl.apply(void 0, arguments);
    };
  }
  function Ls(e, r) {
    return Rs(4, 2, e, r);
  }
  function Ps(e, r) {
    return Rs(4, 4, e, r);
  }
  function zs(e, r) {
    return "function" == typeof r ? (e = e(), r(e), function () {
      r(null);
    }) : null != r ? (e = e(), r.current = e, function () {
      r.current = null;
    }) : void 0;
  }
  function Bs(e, r, t) {
    t = null != t ? t.concat([e]) : null, Rs(4, 4, zs.bind(null, r, e), t);
  }
  function js() {}
  function Vs(e, r) {
    var t = _s();
    r = void 0 === r ? null : r;
    var n = t.memoizedState;
    return null !== n && null !== r && ls(r, n[1]) ? n[0] : (t.memoizedState = [e, r], e);
  }
  function Us(e, r) {
    var t = _s();
    r = void 0 === r ? null : r;
    var n = t.memoizedState;
    return null !== n && null !== r && ls(r, n[1]) ? n[0] : (ts && e(), e = e(), t.memoizedState = [e, r], e);
  }
  function Ws(e, r, t) {
    return 0 == (42 & qo) ? (e.baseState && (e.baseState = !1, bl = !0), e.memoizedState = t) : (Cn(t, r) || (t = Hr(), Qo.lanes |= t, yu |= t, e.baseState = !0), r);
  }
  function $s(e, r) {
    var t = zr;
    zr = 0 !== t && 8 > t ? t : 8, e(!0);
    var n = Yo.transition;
    Yo.transition = {};
    try {
      e(!1), r();
    } finally {
      zr = t, Yo.transition = n;
    }
  }
  function Xs() {
    return _s().memoizedState;
  }
  function Gs() {
    return _s().memoizedState;
  }
  function Ks(e, r, t) {
    for (var n = e.return; null !== n;) {
      switch (n.tag) {
        case 24:
        case 3:
          var a = Wu(n),
            i = Uu(),
            o = po(n, e = _o(i, a), a);
          return null !== o && ($u(o, n, a, i), go(o, n, a)), n = ic(), null != r && null !== o && n.data.set(r, t), void (e.payload = {
            cache: n
          });
      }
      n = n.return;
    }
  }
  function Ys(e, r, t) {
    var n = Wu(e);
    if (t = {
      lane: n,
      action: t,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, Qs(e)) Zs(r, t);else if (lo(e, r, t, n), null !== (t = fo(e))) {
      $u(t, e, n, Uu()), Js(t, r, n);
    }
  }
  function qs(e, r, t) {
    var n = Wu(e),
      a = {
        lane: n,
        action: t,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
    if (Qs(e)) Zs(r, a);else {
      var i = e.alternate;
      if (0 === e.lanes && (null === i || 0 === i.lanes) && null !== (i = r.lastRenderedReducer)) try {
        var o = r.lastRenderedState,
          s = i(o, t);
        if (a.hasEagerState = !0, a.eagerState = s, Cn(s, o)) return lo(e, r, a, 0), void (null === hu && so());
      } catch (e) {}
      lo(e, r, a, n), null !== (t = fo(e)) && ($u(t, e, n, a = Uu()), Js(t, r, n));
    }
  }
  function Qs(e) {
    var r = e.alternate;
    return e === Qo || null !== r && r === Qo;
  }
  function Zs(e, r) {
    rs = es = !0;
    var t = e.pending;
    null === t ? r.next = r : (r.next = t.next, t.next = r), e.pending = r;
  }
  function Js(e, r, t) {
    if (0 != (8388480 & t)) {
      var n = r.lanes;
      t |= n &= e.pendingLanes, r.lanes = t, Pr(e, t);
    }
  }
  var el = {
    readContext: ec,
    useCallback: ss,
    useContext: ss,
    useEffect: ss,
    useImperativeHandle: ss,
    useInsertionEffect: ss,
    useLayoutEffect: ss,
    useMemo: ss,
    useReducer: ss,
    useRef: ss,
    useState: ss,
    useDebugValue: ss,
    useDeferredValue: ss,
    useTransition: ss,
    useMutableSource: ss,
    useSyncExternalStore: ss,
    useId: ss
  };
  el.useCacheRefresh = ss, el.use = ss, el.useMemoCache = ss, el.useEffectEvent = ss;
  var rl = {
    readContext: ec,
    useCallback: function (e, r) {
      return ms().memoizedState = [e, void 0 === r ? null : r], e;
    },
    useContext: ec,
    useEffect: Is,
    useImperativeHandle: function (e, r, t) {
      t = null != t ? t.concat([e]) : null, Ns(4194308, 4, zs.bind(null, r, e), t);
    },
    useLayoutEffect: function (e, r) {
      return Ns(4194308, 4, e, r);
    },
    useInsertionEffect: function (e, r) {
      Ns(4, 2, e, r);
    },
    useMemo: function (e, r) {
      var t = ms();
      return r = void 0 === r ? null : r, ts && e(), e = e(), t.memoizedState = [e, r], e;
    },
    useReducer: function (e, r, t) {
      var n = ms();
      return r = void 0 !== t ? t(r) : r, n.memoizedState = n.baseState = r, e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: r
      }, n.queue = e, e = e.dispatch = Ys.bind(null, Qo, e), [n.memoizedState, e];
    },
    useRef: function (e) {
      return e = {
        current: e
      }, ms().memoizedState = e;
    },
    useState: xs,
    useDebugValue: js,
    useDeferredValue: function (e) {
      return ms().memoizedState = e;
    },
    useTransition: function () {
      var e = xs(!1),
        r = e[0];
      return e = $s.bind(null, e[1]), ms().memoizedState = e, [r, e];
    },
    useMutableSource: function () {},
    useSyncExternalStore: function (e, r, t) {
      var n = Qo,
        a = ms();
      if (Xi) {
        if (void 0 === t) throw Error(o(407));
        t = t();
      } else {
        if (t = r(), null === hu) throw Error(o(349));
        0 != (60 & qo) || ks(n, r, t);
      }
      a.memoizedState = t;
      var i = {
        value: t,
        getSnapshot: r
      };
      return a.queue = i, Is(Ds.bind(null, n, i, e), [e]), n.flags |= 2048, Os(9, Cs.bind(null, n, i, t, r), void 0, null), t;
    },
    useId: function () {
      var e = ms(),
        r = hu.identifierPrefix;
      if (Xi) {
        var t = zi;
        r = ":" + r + "R" + (t = (Pi & ~(1 << 32 - Dr(Pi) - 1)).toString(32) + t), 0 < (t = ns++) && (r += "H" + t.toString(32)), r += ":";
      } else r = ":" + r + "r" + (t = os++).toString(32) + ":";
      return e.memoizedState = r;
    },
    useCacheRefresh: function () {
      return ms().memoizedState = Ks.bind(null, Qo);
    }
  };
  rl.use = ps, rl.useMemoCache = gs, rl.useEffectEvent = function (e) {
    var r = ms(),
      t = {
        impl: e
      };
    return r.memoizedState = t, function () {
      if (0 != (2 & vu)) throw Error(o(440));
      return t.impl.apply(void 0, arguments);
    };
  };
  var tl = {
    readContext: ec,
    useCallback: Vs,
    useContext: ec,
    useEffect: Hs,
    useImperativeHandle: Bs,
    useInsertionEffect: Ls,
    useLayoutEffect: Ps,
    useMemo: Us,
    useReducer: Ss,
    useRef: Ts,
    useState: function () {
      return Ss(bs);
    },
    useDebugValue: js,
    useDeferredValue: function (e) {
      return Ws(_s(), Zo.memoizedState, e);
    },
    useTransition: function () {
      return [Ss(bs)[0], _s().memoizedState];
    },
    useMutableSource: ws,
    useSyncExternalStore: ys,
    useId: Xs
  };
  tl.useCacheRefresh = Gs, tl.useMemoCache = gs, tl.use = ps, tl.useEffectEvent = Fs;
  var nl = {
    readContext: ec,
    useCallback: Vs,
    useContext: ec,
    useEffect: Hs,
    useImperativeHandle: Bs,
    useInsertionEffect: Ls,
    useLayoutEffect: Ps,
    useMemo: Us,
    useReducer: Es,
    useRef: Ts,
    useState: function () {
      return Es(bs);
    },
    useDebugValue: js,
    useDeferredValue: function (e) {
      var r = _s();
      return null === Zo ? r.memoizedState = e : Ws(r, Zo.memoizedState, e);
    },
    useTransition: function () {
      return [Es(bs)[0], _s().memoizedState];
    },
    useMutableSource: ws,
    useSyncExternalStore: ys,
    useId: Xs
  };
  function al(e, r) {
    if (e && e.defaultProps) {
      for (var t in r = oe({}, r), e = e.defaultProps) void 0 === r[t] && (r[t] = e[t]);
      return r;
    }
    return r;
  }
  function il(e, r, t, n) {
    t = null == (t = t(n, r = e.memoizedState)) ? r : oe({}, r, t), e.memoizedState = t, 0 === e.lanes && (e.updateQueue.baseState = t);
  }
  nl.useCacheRefresh = Gs, nl.use = ps, nl.useMemoCache = gs, nl.useEffectEvent = Fs;
  var ol = {
    isMounted: function (e) {
      return !!(e = e._reactInternals) && cr(e) === e;
    },
    enqueueSetState: function (e, r, t) {
      e = e._reactInternals;
      var n = Uu(),
        a = Wu(e),
        i = _o(n, a);
      i.payload = r, null != t && (i.callback = t), null !== (r = po(e, i, a)) && ($u(r, e, a, n), go(r, e, a));
    },
    enqueueReplaceState: function (e, r, t) {
      e = e._reactInternals;
      var n = Uu(),
        a = Wu(e),
        i = _o(n, a);
      i.tag = 1, i.payload = r, null != t && (i.callback = t), null !== (r = po(e, i, a)) && ($u(r, e, a, n), go(r, e, a));
    },
    enqueueForceUpdate: function (e, r) {
      e = e._reactInternals;
      var t = Uu(),
        n = Wu(e),
        a = _o(t, n);
      a.tag = 2, null != r && (a.callback = r), null !== (r = po(e, a, n)) && ($u(r, e, n, t), go(r, e, n));
    }
  };
  function sl(e, r, t, n, a, i, o) {
    return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(n, i, o) : !r.prototype || !r.prototype.isPureReactComponent || !Dn(t, n) || !Dn(a, i);
  }
  function ll(e, r, t) {
    var n = !1,
      a = mi,
      i = r.contextType;
    return "object" == typeof i && null !== i ? i = ec(i) : (a = Si(r) ? gi : _i.current, i = (n = null != (n = r.contextTypes)) ? bi(e, a) : mi), r = new r(t, i), e.memoizedState = null !== r.state && void 0 !== r.state ? r.state : null, r.updater = ol, e.stateNode = r, r._reactInternals = e, n && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = a, e.__reactInternalMemoizedMaskedChildContext = i), r;
  }
  function cl(e, r, t, n) {
    e = r.state, "function" == typeof r.componentWillReceiveProps && r.componentWillReceiveProps(t, n), "function" == typeof r.UNSAFE_componentWillReceiveProps && r.UNSAFE_componentWillReceiveProps(t, n), r.state !== e && ol.enqueueReplaceState(r, r.state, null);
  }
  function ul(e, r, t, n) {
    var a = e.stateNode;
    a.props = t, a.state = e.memoizedState, a.refs = {}, ho(e);
    var i = r.contextType;
    "object" == typeof i && null !== i ? a.context = ec(i) : (i = Si(r) ? gi : _i.current, a.context = bi(e, i)), a.state = e.memoizedState, "function" == typeof (i = r.getDerivedStateFromProps) && (il(e, r, i, t), a.state = e.memoizedState), "function" == typeof r.getDerivedStateFromProps || "function" == typeof a.getSnapshotBeforeUpdate || "function" != typeof a.UNSAFE_componentWillMount && "function" != typeof a.componentWillMount || (r = a.state, "function" == typeof a.componentWillMount && a.componentWillMount(), "function" == typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), r !== a.state && ol.enqueueReplaceState(a, a.state, null), So(e, t, a, n), a.state = e.memoizedState), "function" == typeof a.componentDidMount && (e.flags |= 4194308);
  }
  function fl(e, r) {
    try {
      var t = "",
        n = r;
      do {
        t += ue(n), n = n.return;
      } while (n);
      var a = t;
    } catch (e) {
      a = "\nError generating stack: " + e.message + "\n" + e.stack;
    }
    return {
      value: e,
      source: r,
      stack: a,
      digest: null
    };
  }
  function dl(e, r, t) {
    return {
      value: e,
      source: null,
      stack: null != t ? t : null,
      digest: null != r ? r : null
    };
  }
  function vl(e, r) {
    try {
      console.error(r.value);
    } catch (e) {
      setTimeout(function () {
        throw e;
      });
    }
  }
  function hl(e, r, t) {
    (t = _o(-1, t)).tag = 3, t.payload = {
      element: null
    };
    var n = r.value;
    return t.callback = function () {
      Tu || (Tu = !0, Nu = n), vl(0, r);
    }, t;
  }
  function ml(e, r, t) {
    (t = _o(-1, t)).tag = 3;
    var n = e.type.getDerivedStateFromError;
    if ("function" == typeof n) {
      var a = r.value;
      t.payload = function () {
        return n(a);
      }, t.callback = function () {
        vl(0, r);
      };
    }
    var i = e.stateNode;
    return null !== i && "function" == typeof i.componentDidCatch && (t.callback = function () {
      vl(0, r), "function" != typeof n && (null === Ru ? Ru = new Set([this || _global]) : Ru.add(this || _global));
      var e = r.stack;
      this.componentDidCatch(r.value, {
        componentStack: null !== e ? e : ""
      });
    }), t;
  }
  function _l(e, r, t, n, a) {
    return 0 == (1 & e.mode) ? (e === r ? e.flags |= 65536 : (e.flags |= 128, t.flags |= 131072, t.flags &= -52805, 1 === t.tag && (null === t.alternate ? t.tag = 17 : ((r = _o(-1, 2)).tag = 2, po(t, r, 2))), t.lanes |= 2), e) : (e.flags |= 65536, e.lanes = a, e);
  }
  var pl = L.ReactCurrentOwner,
    gl = Error(o(461)),
    bl = !1;
  function Sl(e, r, t, n) {
    r.child = null === e ? Mo(r, null, t, n) : Ao(r, e.child, t, n);
  }
  function El(e, r, t, n, a) {
    t = t.render;
    var i = r.ref;
    return Jl(r, a), n = cs(e, r, t, n, i, a), t = ds(), null === e || bl ? (Xi && t && Vi(r), r.flags |= 1, Sl(e, r, n, a), r.child) : (vs(e, r, a), Ul(e, r, a));
  }
  function wl(e, r, t, n, a) {
    if (null === e) {
      var i = t.type;
      return "function" != typeof i || Af(i) || void 0 !== i.defaultProps || null !== t.compare || void 0 !== t.defaultProps ? ((e = Of(t.type, null, n, r, r.mode, a)).ref = r.ref, e.return = r, r.child = e) : (r.tag = 15, r.type = i, yl(e, r, i, n, a));
    }
    if (i = e.child, 0 == (e.lanes & a)) {
      var o = i.memoizedProps;
      if ((t = null !== (t = t.compare) ? t : Dn)(o, n) && e.ref === r.ref) return Ul(e, r, a);
    }
    return r.flags |= 1, (e = Mf(i, n)).ref = r.ref, e.return = r, r.child = e;
  }
  function yl(e, r, t, n, a) {
    if (null !== e) {
      var i = e.memoizedProps;
      if (Dn(i, n) && e.ref === r.ref) {
        if (bl = !1, r.pendingProps = n = i, 0 == (e.lanes & a)) return r.lanes = e.lanes, Ul(e, r, a);
        0 != (131072 & e.flags) && (bl = !0);
      }
    }
    return Al(e, r, t, n, a);
  }
  function kl(e, r, t) {
    var n = r.pendingProps,
      a = n.children,
      i = 0 != (2 & r.stateNode._pendingVisibility),
      o = null !== e ? e.memoizedState : null;
    if (Dl(e, r), "hidden" === n.mode || i) {
      if (0 != (128 & r.flags)) {
        if (t = null !== o ? o.baseLanes | t : t, null !== e) {
          for (n = r.child = e.child, a = 0; null !== n;) a = a | n.lanes | n.childLanes, n = n.sibling;
          r.childLanes = a & ~t;
        } else r.childLanes = 0, r.child = null;
        return Cl(e, r, t);
      }
      if (0 == (1 & r.mode)) r.memoizedState = {
        baseLanes: 0,
        cachePool: null
      }, null !== e && vc(r, null), No(), Lo(r);else {
        if (0 == (1073741824 & t)) return r.lanes = r.childLanes = 1073741824, Cl(e, r, null !== o ? o.baseLanes | t : t);
        r.memoizedState = {
          baseLanes: 0,
          cachePool: null
        }, null !== e && vc(r, null !== o ? o.cachePool : null), null !== o ? To(r, o) : No(), Lo(r);
      }
    } else null !== o ? (vc(r, o.cachePool), To(r, o), Po(), r.memoizedState = null) : (null !== e && vc(r, null), No(), Po());
    return Sl(e, r, a, t), r.child;
  }
  function Cl(e, r, t) {
    var n = dc();
    return n = null === n ? null : {
      parent: ac._currentValue,
      pool: n
    }, r.memoizedState = {
      baseLanes: t,
      cachePool: n
    }, null !== e && vc(r, null), No(), Lo(r), null;
  }
  function Dl(e, r) {
    var t = r.ref;
    (null === e && null !== t || null !== e && e.ref !== t) && (r.flags |= 512, r.flags |= 2097152);
  }
  function Al(e, r, t, n, a) {
    var i = Si(t) ? gi : _i.current;
    return i = bi(r, i), Jl(r, a), t = cs(e, r, t, n, i, a), n = ds(), null === e || bl ? (Xi && n && Vi(r), r.flags |= 1, Sl(e, r, t, a), r.child) : (vs(e, r, a), Ul(e, r, a));
  }
  function Ml(e, r, t, n, a) {
    var i = Si(n) ? gi : _i.current;
    return i = bi(r, i), Jl(r, a), t = fs(r, n, t, i), us(), n = ds(), null === e || bl ? (Xi && n && Vi(r), r.flags |= 1, Sl(e, r, t, a), r.child) : (vs(e, r, a), Ul(e, r, a));
  }
  function xl(e, r, t, n, a) {
    if (Si(t)) {
      var i = !0;
      ki(r);
    } else i = !1;
    if (Jl(r, a), null === r.stateNode) Vl(e, r), ll(r, t, n), ul(r, t, n, a), n = !0;else if (null === e) {
      var o = r.stateNode,
        s = r.memoizedProps;
      o.props = s;
      var l = o.context,
        c = t.contextType;
      "object" == typeof c && null !== c ? c = ec(c) : c = bi(r, c = Si(t) ? gi : _i.current);
      var u = t.getDerivedStateFromProps,
        f = "function" == typeof u || "function" == typeof o.getSnapshotBeforeUpdate;
      f || "function" != typeof o.UNSAFE_componentWillReceiveProps && "function" != typeof o.componentWillReceiveProps || (s !== n || l !== c) && cl(r, o, n, c), vo = !1;
      var d = r.memoizedState;
      o.state = d, So(r, n, o, a), l = r.memoizedState, s !== n || d !== l || pi.current || vo ? ("function" == typeof u && (il(r, t, u, n), l = r.memoizedState), (s = vo || sl(r, t, s, n, d, l, c)) ? (f || "function" != typeof o.UNSAFE_componentWillMount && "function" != typeof o.componentWillMount || ("function" == typeof o.componentWillMount && o.componentWillMount(), "function" == typeof o.UNSAFE_componentWillMount && o.UNSAFE_componentWillMount()), "function" == typeof o.componentDidMount && (r.flags |= 4194308)) : ("function" == typeof o.componentDidMount && (r.flags |= 4194308), r.memoizedProps = n, r.memoizedState = l), o.props = n, o.state = l, o.context = c, n = s) : ("function" == typeof o.componentDidMount && (r.flags |= 4194308), n = !1);
    } else {
      o = r.stateNode, mo(e, r), s = r.memoizedProps, c = r.type === r.elementType ? s : al(r.type, s), o.props = c, f = r.pendingProps, d = o.context, "object" == typeof (l = t.contextType) && null !== l ? l = ec(l) : l = bi(r, l = Si(t) ? gi : _i.current);
      var v = t.getDerivedStateFromProps;
      (u = "function" == typeof v || "function" == typeof o.getSnapshotBeforeUpdate) || "function" != typeof o.UNSAFE_componentWillReceiveProps && "function" != typeof o.componentWillReceiveProps || (s !== f || d !== l) && cl(r, o, n, l), vo = !1, d = r.memoizedState, o.state = d, So(r, n, o, a);
      var h = r.memoizedState;
      s !== f || d !== h || pi.current || vo ? ("function" == typeof v && (il(r, t, v, n), h = r.memoizedState), (c = vo || sl(r, t, c, n, d, h, l) || !1) ? (u || "function" != typeof o.UNSAFE_componentWillUpdate && "function" != typeof o.componentWillUpdate || ("function" == typeof o.componentWillUpdate && o.componentWillUpdate(n, h, l), "function" == typeof o.UNSAFE_componentWillUpdate && o.UNSAFE_componentWillUpdate(n, h, l)), "function" == typeof o.componentDidUpdate && (r.flags |= 4), "function" == typeof o.getSnapshotBeforeUpdate && (r.flags |= 1024)) : ("function" != typeof o.componentDidUpdate || s === e.memoizedProps && d === e.memoizedState || (r.flags |= 4), "function" != typeof o.getSnapshotBeforeUpdate || s === e.memoizedProps && d === e.memoizedState || (r.flags |= 1024), r.memoizedProps = n, r.memoizedState = h), o.props = n, o.state = h, o.context = l, n = c) : ("function" != typeof o.componentDidUpdate || s === e.memoizedProps && d === e.memoizedState || (r.flags |= 4), "function" != typeof o.getSnapshotBeforeUpdate || s === e.memoizedProps && d === e.memoizedState || (r.flags |= 1024), n = !1);
    }
    return Ol(e, r, t, n, i, a);
  }
  function Ol(e, r, t, n, a, i) {
    Dl(e, r);
    var o = 0 != (128 & r.flags);
    if (!n && !o) return a && Ci(r, t, !1), Ul(e, r, i);
    n = r.stateNode, pl.current = r;
    var s = o && "function" != typeof t.getDerivedStateFromError ? null : n.render();
    return r.flags |= 1, null !== e && o ? (r.child = Ao(r, e.child, null, i), r.child = Ao(r, null, s, i)) : Sl(e, r, s, i), r.memoizedState = n.state, a && Ci(r, t, !0), r.child;
  }
  function Tl(e) {
    var r = e.stateNode;
    r.pendingContext ? wi(0, r.pendingContext, r.pendingContext !== r.context) : r.context && wi(0, r.context, !1), Aa(e, r.containerInfo);
  }
  function Nl(e, r, t, n, a) {
    return to(), no(a), r.flags |= 256, Sl(e, r, t, n), r.child;
  }
  var Rl = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
  };
  function Il(e) {
    return {
      baseLanes: e,
      cachePool: hc()
    };
  }
  function Hl(e, r, t) {
    var n,
      a = r.pendingProps,
      i = !1,
      s = 0 != (128 & r.flags);
    if ((n = s) || (n = (null === e || null !== e.memoizedState) && 0 != (2 & Bo.current)), n && (i = !0, r.flags &= -129), null === e) {
      if (Xi) {
        if (i ? Fo(r) : Po(), Qi(r), null !== (e = r.memoizedState) && null !== (e = e.dehydrated)) return 0 == (1 & r.mode) ? r.lanes = 2 : "$!" === e.data ? r.lanes = 16 : r.lanes = 1073741824, null;
        zo(r);
      }
      return e = a.children, s = a.fallback, i ? (Po(), e = Ll(r, e, s, t), r.child.memoizedState = Il(t), r.memoizedState = Rl, e) : "number" == typeof a.unstable_expectedLoadTime ? (Po(), e = Ll(r, e, s, t), r.child.memoizedState = Il(t), r.memoizedState = Rl, r.lanes = 8388608, e) : (Fo(r), Fl(r, e));
    }
    if (null !== (n = e.memoizedState)) {
      var l = n.dehydrated;
      if (null !== l) return function (e, r, t, n, a, i, s) {
        if (t) return 256 & r.flags ? (Fo(r), r.flags &= -257, i = dl(Error(o(422))), Pl(e, r, s, i)) : null !== r.memoizedState ? (Po(), r.child = e.child, r.flags |= 128, null) : (Po(), i = n.fallback, a = r.mode, n = Nf({
          mode: "visible",
          children: n.children
        }, a, 0, null), (i = Tf(i, a, s, null)).flags |= 2, n.return = r, i.return = r, n.sibling = i, r.child = n, 0 != (1 & r.mode) && Ao(r, e.child, null, s), r.child.memoizedState = Il(s), r.memoizedState = Rl, i);
        if (Fo(r), 0 == (1 & r.mode)) return Pl(e, r, s, null);
        if ("$!" === a.data) {
          if (i = a.nextSibling && a.nextSibling.dataset) var l = i.dgst;
          return i = l, (n = Error(o(419))).digest = i, i = dl(n, i, void 0), Pl(e, r, s, i);
        }
        if (l = 0 != (s & e.childLanes), bl || l) {
          if (null !== (n = hu)) {
            if (0 != (42 & (a = s & -s))) a = 1;else switch (a) {
              case 2:
                a = 1;
                break;
              case 8:
                a = 4;
                break;
              case 32:
                a = 16;
                break;
              case 128:
              case 256:
              case 512:
              case 1024:
              case 2048:
              case 4096:
              case 8192:
              case 16384:
              case 32768:
              case 65536:
              case 131072:
              case 262144:
              case 524288:
              case 1048576:
              case 2097152:
              case 4194304:
              case 8388608:
              case 16777216:
              case 33554432:
              case 67108864:
                a = 64;
                break;
              case 536870912:
                a = 268435456;
                break;
              default:
                a = 0;
            }
            if (0 !== (a = 0 != (a & (n.suspendedLanes | s)) ? 0 : a) && a !== i.retryLane) throw i.retryLane = a, co(e, a), $u(n, e, a, -1), gl;
          }
          return of(), Pl(e, r, s, null);
        }
        return "$?" === a.data ? (r.flags |= 128, r.child = e.child, r = wf.bind(null, e), a._reactRetry = r, null) : (e = i.treeContext, $i = di(a.nextSibling), Wi = r, Xi = !0, Gi = null, null !== e && (Hi[Fi++] = Pi, Hi[Fi++] = zi, Hi[Fi++] = Li, Pi = e.id, zi = e.overflow, Li = r), (r = Fl(r, n.children)).flags |= 4096, r);
      }(e, r, s, a, l, n, t);
    }
    if (i) {
      Po(), i = a.fallback, s = r.mode, l = (n = e.child).sibling;
      var c = {
        mode: "hidden",
        children: a.children
      };
      return 0 == (1 & s) && r.child !== n ? ((a = r.child).childLanes = 0, a.pendingProps = c, r.deletions = null) : (a = Mf(n, c)).subtreeFlags = 14680064 & n.subtreeFlags, null !== l ? i = Mf(l, i) : (i = Tf(i, s, t, null)).flags |= 2, i.return = r, a.return = r, a.sibling = i, r.child = a, a = i, i = r.child, null === (s = e.child.memoizedState) ? s = Il(t) : (null !== (n = s.cachePool) ? (l = ac._currentValue, n = n.parent !== l ? {
        parent: l,
        pool: l
      } : n) : n = hc(), s = {
        baseLanes: s.baseLanes | t,
        cachePool: n
      }), i.memoizedState = s, i.childLanes = e.childLanes & ~t, r.memoizedState = Rl, a;
    }
    return Fo(r), e = (i = e.child).sibling, a = Mf(i, {
      mode: "visible",
      children: a.children
    }), 0 == (1 & r.mode) && (a.lanes = t), a.return = r, a.sibling = null, null !== e && (null === (t = r.deletions) ? (r.deletions = [e], r.flags |= 16) : t.push(e)), r.child = a, r.memoizedState = null, a;
  }
  function Fl(e, r) {
    return (r = Nf({
      mode: "visible",
      children: r
    }, e.mode, 0, null)).return = e, e.child = r;
  }
  function Ll(e, r, t, n) {
    var a = e.mode,
      i = e.child;
    return r = {
      mode: "hidden",
      children: r
    }, 0 == (1 & a) && null !== i ? (i.childLanes = 0, i.pendingProps = r) : i = Nf(r, a, 0, null), t = Tf(t, a, n, null), i.return = e, t.return = e, i.sibling = t, e.child = i, t;
  }
  function Pl(e, r, t, n) {
    return null !== n && no(n), Ao(r, e.child, null, t), (e = Fl(r, r.pendingProps.children)).flags |= 2, r.memoizedState = null, e;
  }
  function zl(e, r, t) {
    e.lanes |= r;
    var n = e.alternate;
    null !== n && (n.lanes |= r), Ql(e.return, r, t);
  }
  function Bl(e, r, t, n, a) {
    var i = e.memoizedState;
    null === i ? e.memoizedState = {
      isBackwards: r,
      rendering: null,
      renderingStartTime: 0,
      last: n,
      tail: t,
      tailMode: a
    } : (i.isBackwards = r, i.rendering = null, i.renderingStartTime = 0, i.last = n, i.tail = t, i.tailMode = a);
  }
  function jl(e, r, t) {
    var n = r.pendingProps,
      a = n.revealOrder,
      i = n.tail;
    if (Sl(e, r, n.children, t), 0 != (2 & (n = Bo.current))) n = 1 & n | 2, r.flags |= 128;else {
      if (null !== e && 0 != (128 & e.flags)) e: for (e = r.child; null !== e;) {
        if (13 === e.tag) null !== e.memoizedState && zl(e, t, r);else if (19 === e.tag) zl(e, t, r);else if (null !== e.child) {
          e.child.return = e, e = e.child;
          continue;
        }
        if (e === r) break e;
        for (; null === e.sibling;) {
          if (null === e.return || e.return === r) break e;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
      n &= 1;
    }
    if (ya(Bo, n), 0 == (1 & r.mode)) r.memoizedState = null;else switch (a) {
      case "forwards":
        for (t = r.child, a = null; null !== t;) null !== (e = t.alternate) && null === jo(e) && (a = t), t = t.sibling;
        null === (t = a) ? (a = r.child, r.child = null) : (a = t.sibling, t.sibling = null), Bl(r, !1, a, t, i);
        break;
      case "backwards":
        for (t = null, a = r.child, r.child = null; null !== a;) {
          if (null !== (e = a.alternate) && null === jo(e)) {
            r.child = a;
            break;
          }
          e = a.sibling, a.sibling = t, t = a, a = e;
        }
        Bl(r, !0, t, null, i);
        break;
      case "together":
        Bl(r, !1, null, null, void 0);
        break;
      default:
        r.memoizedState = null;
    }
    return r.child;
  }
  function Vl(e, r) {
    0 == (1 & r.mode) && null !== e && (e.alternate = null, r.alternate = null, r.flags |= 2);
  }
  function Ul(e, r, t) {
    if (null !== e && (r.dependencies = e.dependencies), yu |= r.lanes, 0 == (t & r.childLanes)) return null;
    if (null !== e && r.child !== e.child) throw Error(o(153));
    if (null !== r.child) {
      for (t = Mf(e = r.child, e.pendingProps), r.child = t, t.return = r; null !== e.sibling;) e = e.sibling, (t = t.sibling = Mf(e, e.pendingProps)).return = r;
      t.sibling = null;
    }
    return r.child;
  }
  var Wl = Ea(null),
    $l = null,
    Xl = null,
    Gl = null;
  function Kl() {
    Gl = Xl = $l = null;
  }
  function Yl(e, r, t) {
    ya(Wl, r._currentValue), r._currentValue = t;
  }
  function ql(e) {
    var r = Wl.current;
    e._currentValue = r === re ? e._defaultValue : r, wa(Wl);
  }
  function Ql(e, r, t) {
    for (; null !== e;) {
      var n = e.alternate;
      if ((e.childLanes & r) !== r ? (e.childLanes |= r, null !== n && (n.childLanes |= r)) : null !== n && (n.childLanes & r) !== r && (n.childLanes |= r), e === t) break;
      e = e.return;
    }
  }
  function Zl(e, r, t) {
    var n = e.child;
    for (null !== n && (n.return = e); null !== n;) {
      var a = n.dependencies;
      if (null !== a) for (var i = n.child, s = a.firstContext; null !== s;) {
        if (s.context === r) {
          if (1 === n.tag) {
            (s = _o(-1, t & -t)).tag = 2;
            var l = n.updateQueue;
            if (null !== l) {
              var c = (l = l.shared).pending;
              null === c ? s.next = s : (s.next = c.next, c.next = s), l.pending = s;
            }
          }
          n.lanes |= t, null !== (s = n.alternate) && (s.lanes |= t), Ql(n.return, t, e), a.lanes |= t;
          break;
        }
        s = s.next;
      } else if (10 === n.tag) i = n.type === e.type ? null : n.child;else if (18 === n.tag) {
        if (null === (i = n.return)) throw Error(o(341));
        i.lanes |= t, null !== (a = i.alternate) && (a.lanes |= t), Ql(i, t, e), i = n.sibling;
      } else i = n.child;
      if (null !== i) i.return = n;else for (i = n; null !== i;) {
        if (i === e) {
          i = null;
          break;
        }
        if (null !== (n = i.sibling)) {
          n.return = i.return, i = n;
          break;
        }
        i = i.return;
      }
      n = i;
    }
  }
  function Jl(e, r) {
    $l = e, Gl = Xl = null, null !== (e = e.dependencies) && null !== e.firstContext && (0 != (e.lanes & r) && (bl = !0), e.firstContext = null);
  }
  function ec(e) {
    var r = e._currentValue;
    if (Gl !== e) if (e = {
      context: e,
      memoizedValue: r,
      next: null
    }, null === Xl) {
      if (null === $l) throw Error(o(308));
      Xl = e, $l.dependencies = {
        lanes: 0,
        firstContext: e
      };
    } else Xl = Xl.next = e;
    return r;
  }
  var rc = "undefined" != typeof AbortController ? AbortController : function () {
      var e = [],
        r = (this || _global).signal = {
          aborted: !1,
          addEventListener: function (r, t) {
            e.push(t);
          }
        };
      (this || _global).abort = function () {
        r.aborted = !0, e.forEach(function (e) {
          return e();
        });
      };
    },
    tc = a.unstable_scheduleCallback,
    nc = a.unstable_NormalPriority,
    ac = {
      $$typeof: W,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
      _defaultValue: null,
      _globalName: null
    };
  function ic() {
    return {
      controller: new rc(),
      data: new Map(),
      refCount: 0
    };
  }
  function oc(e) {
    e.refCount--, 0 === e.refCount && tc(nc, function () {
      e.controller.abort();
    });
  }
  var sc,
    lc,
    cc,
    uc = L.ReactCurrentBatchConfig,
    fc = Ea(null);
  function dc() {
    var e = fc.current;
    return null !== e ? e : hu.pooledCache;
  }
  function vc(e, r) {
    ya(fc, null === r ? fc.current : r.pool);
  }
  function hc() {
    var e = dc();
    return null === e ? null : {
      parent: ac._currentValue,
      pool: e
    };
  }
  function mc(e) {
    e.flags |= 2097664;
  }
  function _c(e, r) {
    if (!Xi) switch (e.tailMode) {
      case "hidden":
        r = e.tail;
        for (var t = null; null !== r;) null !== r.alternate && (t = r), r = r.sibling;
        null === t ? e.tail = null : t.sibling = null;
        break;
      case "collapsed":
        t = e.tail;
        for (var n = null; null !== t;) null !== t.alternate && (n = t), t = t.sibling;
        null === n ? r || null === e.tail ? e.tail = null : e.tail.sibling = null : n.sibling = null;
    }
  }
  function pc(e) {
    var r = null !== e.alternate && e.alternate.child === e.child,
      t = 0,
      n = 0;
    if (r) for (var a = e.child; null !== a;) t |= a.lanes | a.childLanes, n |= 14680064 & a.subtreeFlags, n |= 14680064 & a.flags, a.return = e, a = a.sibling;else for (a = e.child; null !== a;) t |= a.lanes | a.childLanes, n |= a.subtreeFlags, n |= a.flags, a.return = e, a = a.sibling;
    return e.subtreeFlags |= n, e.childLanes = t, r;
  }
  function gc(e, r, t) {
    var n = r.pendingProps;
    switch (Ui(r), r.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return pc(r), null;
      case 1:
        return Si(r.type) && Ei(), pc(r), null;
      case 3:
        return t = r.stateNode, n = null, null !== e && (n = e.memoizedState.cache), r.memoizedState.cache !== n && (r.flags |= 2048), ql(ac), Ma(), wa(pi), wa(_i), Uo(), t.pendingContext && (t.context = t.pendingContext, t.pendingContext = null), null !== e && null !== e.child || (eo(r) ? r.flags |= 4 : null === e || e.memoizedState.isDehydrated && 0 == (256 & r.flags) || (r.flags |= 1024, null !== Gi && (Yu(Gi), Gi = null))), pc(r), null;
      case 26:
        return Oa(r), (e ? e.ref : null) !== r.ref && mc(r), null !== e && e.memoizedState === r.memoizedState || (r.flags |= 4), pc(r), null;
      case 27:
        Oa(r), t = Da.current;
        var a = r.type;
        if (null !== e && null != r.stateNode) lc(e, r, a, n), e.ref !== r.ref && mc(r);else {
          if (!n) {
            if (null === r.stateNode) throw Error(o(166));
            return pc(r), null;
          }
          e = ka.current, eo(r) ? Zi(r) : (r.stateNode = hi(a, n, t), r.flags |= 4), null !== r.ref && mc(r);
        }
        return pc(r), null;
      case 5:
        if (Oa(r), t = r.type, null !== e && null != r.stateNode) lc(e, r, t, n), e.ref !== r.ref && mc(r);else {
          if (!n) {
            if (null === r.stateNode) throw Error(o(166));
            return pc(r), null;
          }
          if (e = ka.current, eo(r)) Zi(r) && (r.flags |= 4);else {
            (e = pa(t, n, Da.current, e))[l] = r, e[c] = n, sc(e, r), r.stateNode = e;
            e: switch (ga(e, t, n), t) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                e = !!n.autoFocus;
                break e;
              case "img":
                e = !0;
                break e;
              default:
                e = !1;
            }
            e && (r.flags |= 4);
          }
          null !== r.ref && mc(r);
        }
        return pc(r), null;
      case 6:
        if (e && null != r.stateNode) cc(0, r, e.memoizedProps, n);else {
          if ("string" != typeof n && null === r.stateNode) throw Error(o(166));
          if (e = Da.current, eo(r)) {
            if (e = r.stateNode, t = r.memoizedProps, e[l] = r, (n = e.nodeValue !== t) && null !== (a = Wi)) switch (a.tag) {
              case 3:
                ma(e.nodeValue, t, 0 != (1 & a.mode));
                break;
              case 27:
              case 5:
                !0 !== a.memoizedProps.suppressHydrationWarning && ma(e.nodeValue, t, 0 != (1 & a.mode));
            }
            n && (r.flags |= 4);
          } else (e = (9 === e.nodeType ? e : e.ownerDocument).createTextNode(n))[l] = r, r.stateNode = e;
        }
        return pc(r), null;
      case 13:
        if (zo(r), n = r.memoizedState, null === e || null !== e.memoizedState && null !== e.memoizedState.dehydrated) {
          if (Xi && null !== $i && 0 != (1 & r.mode) && 0 == (128 & r.flags)) ro(), to(), r.flags |= 98560, a = !1;else if (a = eo(r), null !== n && null !== n.dehydrated) {
            if (null === e) {
              if (!a) throw Error(o(318));
              if (!(a = null !== (a = r.memoizedState) ? a.dehydrated : null)) throw Error(o(317));
              a[l] = r;
            } else to(), 0 == (128 & r.flags) && (r.memoizedState = null), r.flags |= 4;
            pc(r), a = !1;
          } else null !== Gi && (Yu(Gi), Gi = null), a = !0;
          if (!a) return 65536 & r.flags ? r : null;
        }
        if (0 != (128 & r.flags)) return r.lanes = t, r;
        if (t = null !== n, e = null !== e && null !== e.memoizedState, t) {
          a = null, null !== (n = r.child).alternate && null !== n.alternate.memoizedState && null !== n.alternate.memoizedState.cachePool && (a = n.alternate.memoizedState.cachePool.pool);
          var i = null;
          null !== n.memoizedState && null !== n.memoizedState.cachePool && (i = n.memoizedState.cachePool.pool), i !== a && (n.flags |= 2048);
        }
        return t !== e && t && (r.child.flags |= 8192), null !== r.updateQueue && (r.flags |= 4), pc(r), null;
      case 4:
        return Ma(), null === e && ia(r.stateNode.containerInfo), pc(r), null;
      case 10:
        return ql(r.type._context), pc(r), null;
      case 17:
        return Si(r.type) && Ei(), pc(r), null;
      case 19:
        if (wa(Bo), null === (a = r.memoizedState)) return pc(r), null;
        if (n = 0 != (128 & r.flags), null === (i = a.rendering)) {
          if (n) _c(a, !1);else {
            if (0 !== Eu || null !== e && 0 != (128 & e.flags)) for (e = r.child; null !== e;) {
              if (null !== (i = jo(e))) {
                for (r.flags |= 128, _c(a, !1), null !== (e = i.updateQueue) && (r.updateQueue = e, r.flags |= 4), r.subtreeFlags = 0, e = t, t = r.child; null !== t;) xf(t, e), t = t.sibling;
                return ya(Bo, 1 & Bo.current | 2), r.child;
              }
              e = e.sibling;
            }
            null !== a.tail && pr() > xu && (r.flags |= 128, n = !0, _c(a, !1), r.lanes = 8388608);
          }
        } else {
          if (!n) if (null !== (e = jo(i))) {
            if (r.flags |= 128, n = !0, null !== (e = e.updateQueue) && (r.updateQueue = e, r.flags |= 4), _c(a, !0), null === a.tail && "hidden" === a.tailMode && !i.alternate && !Xi) return pc(r), null;
          } else 2 * pr() - a.renderingStartTime > xu && 1073741824 !== t && (r.flags |= 128, n = !0, _c(a, !1), r.lanes = 8388608);
          a.isBackwards ? (i.sibling = r.child, r.child = i) : (null !== (e = a.last) ? e.sibling = i : r.child = i, a.last = i);
        }
        return null !== a.tail ? (r = a.tail, a.rendering = r, a.tail = r.sibling, a.renderingStartTime = pr(), r.sibling = null, e = Bo.current, ya(Bo, n ? 1 & e | 2 : 1 & e), r) : (pc(r), null);
      case 22:
      case 23:
        return zo(r), Ro(), n = null !== r.memoizedState, null !== e ? null !== e.memoizedState !== n && (r.flags |= 8192) : n && (r.flags |= 8192), n && 0 != (1 & r.mode) ? 0 != (1073741824 & t) && 0 == (128 & r.flags) && (pc(r), 6 & r.subtreeFlags && (r.flags |= 8192)) : pc(r), null !== r.updateQueue && (r.flags |= 4), t = null, null !== e && null !== e.memoizedState && null !== e.memoizedState.cachePool && (t = e.memoizedState.cachePool.pool), n = null, null !== r.memoizedState && null !== r.memoizedState.cachePool && (n = r.memoizedState.cachePool.pool), n !== t && (r.flags |= 2048), null !== e && wa(fc), null;
      case 24:
        return t = null, null !== e && (t = e.memoizedState.cache), r.memoizedState.cache !== t && (r.flags |= 2048), ql(ac), pc(r), null;
      case 25:
        return null;
    }
    throw Error(o(156, r.tag));
  }
  function bc(e, r) {
    switch (Ui(r), r.tag) {
      case 1:
        return Si(r.type) && Ei(), 65536 & (e = r.flags) ? (r.flags = -65537 & e | 128, r) : null;
      case 3:
        return ql(ac), Ma(), wa(pi), wa(_i), Uo(), 0 != (65536 & (e = r.flags)) && 0 == (128 & e) ? (r.flags = -65537 & e | 128, r) : null;
      case 26:
      case 27:
      case 5:
        return Oa(r), null;
      case 13:
        if (zo(r), null !== (e = r.memoizedState) && null !== e.dehydrated) {
          if (null === r.alternate) throw Error(o(340));
          to();
        }
        return 65536 & (e = r.flags) ? (r.flags = -65537 & e | 128, r) : null;
      case 19:
        return wa(Bo), null;
      case 4:
        return Ma(), null;
      case 10:
        return ql(r.type._context), null;
      case 22:
      case 23:
        return zo(r), Ro(), null !== e && wa(fc), 65536 & (e = r.flags) ? (r.flags = -65537 & e | 128, r) : null;
      case 24:
        return ql(ac), null;
      case 25:
      default:
        return null;
    }
  }
  function Sc(e, r) {
    switch (Ui(r), r.tag) {
      case 1:
        null != (e = r.type.childContextTypes) && Ei();
        break;
      case 3:
        ql(ac), Ma(), wa(pi), wa(_i), Uo();
        break;
      case 26:
      case 27:
      case 5:
        Oa(r);
        break;
      case 4:
        Ma();
        break;
      case 13:
        zo(r);
        break;
      case 19:
        wa(Bo);
        break;
      case 10:
        ql(r.type._context);
        break;
      case 22:
      case 23:
        zo(r), Ro(), null !== e && wa(fc);
        break;
      case 24:
        ql(ac);
    }
  }
  sc = function (e, r) {
    for (var t = r.child; null !== t;) {
      if (5 === t.tag || 6 === t.tag) e.appendChild(t.stateNode);else if (4 !== t.tag && 27 !== t.tag && null !== t.child) {
        t.child.return = t, t = t.child;
        continue;
      }
      if (t === r) break;
      for (; null === t.sibling;) {
        if (null === t.return || t.return === r) return;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
  }, lc = function (e, r, t, n) {
    var a = e.memoizedProps;
    if (a !== n) {
      e = r.stateNode;
      var i,
        o = null;
      switch (t) {
        case "input":
          a = pe(e, a), n = pe(e, n), o = [];
          break;
        case "select":
          a = oe({}, a, {
            value: void 0
          }), n = oe({}, n, {
            value: void 0
          }), o = [];
          break;
        case "textarea":
          a = Ce(e, a), n = Ce(e, n), o = [];
          break;
        default:
          "function" != typeof a.onClick && "function" == typeof n.onClick && (e.onclick = _a);
      }
      for (c in ze(t, n), t = null, a) if (!n.hasOwnProperty(c) && a.hasOwnProperty(c) && null != a[c]) if ("style" === c) {
        var s = a[c];
        for (i in s) s.hasOwnProperty(i) && (t || (t = {}), t[i] = "");
      } else "dangerouslySetInnerHTML" !== c && "children" !== c && "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && "autoFocus" !== c && (y.hasOwnProperty(c) ? o || (o = []) : (o = o || []).push(c, null));
      for (c in n) {
        var l = n[c];
        if (s = null != a ? a[c] : void 0, n.hasOwnProperty(c) && l !== s && (null != l || null != s)) if ("style" === c) {
          if (s) {
            for (i in s) !s.hasOwnProperty(i) || l && l.hasOwnProperty(i) || (t || (t = {}), t[i] = "");
            for (i in l) l.hasOwnProperty(i) && s[i] !== l[i] && (t || (t = {}), t[i] = l[i]);
          } else t || (o || (o = []), o.push(c, t)), t = l;
        } else "dangerouslySetInnerHTML" === c ? (l = l ? l.__html : void 0, s = s ? s.__html : void 0, null != l && s !== l && (o = o || []).push(c, l)) : "children" === c ? "string" != typeof l && "number" != typeof l || (o = o || []).push(c, "" + l) : "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && (y.hasOwnProperty(c) ? (null != l && "onScroll" === c && ta("scroll", e), o || s === l || (o = [])) : (o = o || []).push(c, l));
      }
      t && (o = o || []).push("style", t);
      var c = o;
      (r.updateQueue = c) && (r.flags |= 4);
    }
  }, cc = function (e, r, t, n) {
    t !== n && (r.flags |= 4);
  };
  var Ec = !1,
    wc = !1,
    yc = "function" == typeof WeakSet ? WeakSet : Set,
    kc = null;
  function Cc(e, r) {
    try {
      var t = e.ref;
      if (null !== t) {
        var n = e.stateNode;
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var a = n;
            break;
          default:
            a = n;
        }
        "function" == typeof t ? e.refCleanup = t(a) : t.current = a;
      }
    } catch (t) {
      gf(e, r, t);
    }
  }
  function Dc(e, r) {
    var t = e.ref,
      n = e.refCleanup;
    if (null !== t) if ("function" == typeof n) try {
      n();
    } catch (t) {
      gf(e, r, t);
    } finally {
      e.refCleanup = null, null != (e = e.alternate) && (e.refCleanup = null);
    } else if ("function" == typeof t) try {
      t(null);
    } catch (t) {
      gf(e, r, t);
    } else t.current = null;
  }
  function Ac(e, r, t) {
    try {
      t();
    } catch (t) {
      gf(e, r, t);
    }
  }
  var Mc = !1;
  function xc(e, r, t) {
    var n = r.updateQueue;
    if (null !== (n = null !== n ? n.lastEffect : null)) {
      var a = n = n.next;
      do {
        if ((a.tag & e) === e) {
          var i = a.destroy;
          a.destroy = void 0, void 0 !== i && Ac(r, t, i);
        }
        a = a.next;
      } while (a !== n);
    }
  }
  function Oc(e, r) {
    if (null !== (r = null !== (r = r.updateQueue) ? r.lastEffect : null)) {
      var t = r = r.next;
      do {
        if ((t.tag & e) === e) {
          var n = t.create;
          t.destroy = n();
        }
        t = t.next;
      } while (t !== r);
    }
  }
  function Tc(e, r) {
    try {
      Oc(r, e);
    } catch (r) {
      gf(e, e.return, r);
    }
  }
  function Nc(e) {
    var r = e.updateQueue;
    if (null !== r) {
      var t = e.stateNode;
      try {
        wo(r, t);
      } catch (r) {
        gf(e, e.return, r);
      }
    }
  }
  function Rc(e) {
    var r = e.type,
      t = e.memoizedProps,
      n = e.stateNode;
    try {
      e: switch (r) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          t.autoFocus && n.focus();
          break e;
        case "img":
          t.src && (n.src = t.src);
      }
    } catch (r) {
      gf(e, e.return, r);
    }
  }
  function Ic(e, r, t) {
    var n = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Kc(e, t), 4 & n && Tc(t, 5);
        break;
      case 1:
        if (Kc(e, t), 4 & n) if (e = t.stateNode, null === r) try {
          e.componentDidMount();
        } catch (e) {
          gf(t, t.return, e);
        } else {
          var a = t.elementType === t.type ? r.memoizedProps : al(t.type, r.memoizedProps);
          r = r.memoizedState;
          try {
            e.componentDidUpdate(a, r, e.__reactInternalSnapshotBeforeUpdate);
          } catch (e) {
            gf(t, t.return, e);
          }
        }
        64 & n && Nc(t), 512 & n && Cc(t, t.return);
        break;
      case 3:
        if (Kc(e, t), 64 & n && null !== (n = t.updateQueue)) {
          if (e = null, null !== t.child) switch (t.child.tag) {
            case 27:
            case 5:
              e = t.child.stateNode;
              break;
            case 1:
              e = t.child.stateNode;
          }
          try {
            wo(n, e);
          } catch (e) {
            gf(t, t.return, e);
          }
        }
        break;
      case 26:
        Kc(e, t), 512 & n && Cc(t, t.return);
        break;
      case 27:
      case 5:
        Kc(e, t), null === r && 4 & n && Rc(t), 512 & n && Cc(t, t.return);
        break;
      case 12:
        Kc(e, t);
        break;
      case 13:
        Kc(e, t), 4 & n && Uc(e, t);
        break;
      case 22:
        if (0 != (1 & t.mode)) {
          if (!(a = null !== t.memoizedState || Ec)) {
            r = null !== r && null !== r.memoizedState || wc;
            var i = Ec,
              o = wc;
            Ec = a, (wc = r) && !o ? function e(r, t, n) {
              for (n = n && 0 != (8772 & t.subtreeFlags), t = t.child; null !== t;) {
                var a = t.alternate,
                  i = r,
                  o = t,
                  s = o.flags;
                switch (o.tag) {
                  case 0:
                  case 11:
                  case 15:
                    e(i, o, n), Tc(o, 4);
                    break;
                  case 1:
                    if (e(i, o, n), "function" == typeof (i = o.stateNode).componentDidMount) try {
                      i.componentDidMount();
                    } catch (e) {
                      gf(o, o.return, e);
                    }
                    if (null !== (a = o.updateQueue)) {
                      var l = a.shared.hiddenCallbacks;
                      if (null !== l) for (a.shared.hiddenCallbacks = null, a = 0; a < l.length; a++) Eo(l[a], i);
                    }
                    n && 64 & s && Nc(o), Cc(o, o.return);
                    break;
                  case 26:
                  case 27:
                  case 5:
                    e(i, o, n), n && null === a && 4 & s && Rc(o), Cc(o, o.return);
                    break;
                  case 12:
                    e(i, o, n);
                    break;
                  case 13:
                    e(i, o, n), n && 4 & s && Uc(i, o);
                    break;
                  case 22:
                    null === o.memoizedState && e(i, o, n), Cc(o, o.return);
                    break;
                  default:
                    e(i, o, n);
                }
                t = t.sibling;
              }
            }(e, t, 0 != (8772 & t.subtreeFlags)) : Kc(e, t), Ec = i, wc = o;
          }
        } else Kc(e, t);
        512 & n && ("manual" === t.memoizedProps.mode ? Cc(t, t.return) : Dc(t, t.return));
        break;
      default:
        Kc(e, t);
    }
  }
  function Hc(e) {
    var r = e.alternate;
    null !== r && (e.alternate = null, Hc(r)), e.child = null, e.deletions = null, e.sibling = null, 5 === e.tag && null !== (r = e.stateNode) && _(r), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
  }
  function Fc(e) {
    return 5 === e.tag || 3 === e.tag || 26 === e.tag || 27 === e.tag || 4 === e.tag;
  }
  function Lc(e) {
    e: for (;;) {
      for (; null === e.sibling;) {
        if (null === e.return || Fc(e.return)) return null;
        e = e.return;
      }
      for (e.sibling.return = e.return, e = e.sibling; 5 !== e.tag && 6 !== e.tag && 27 !== e.tag && 18 !== e.tag;) {
        if (2 & e.flags) continue e;
        if (null === e.child || 4 === e.tag) continue e;
        e.child.return = e, e = e.child;
      }
      if (!(2 & e.flags)) return e.stateNode;
    }
  }
  function Pc(e, r, t) {
    var n = e.tag;
    if (5 === n || 6 === n) e = e.stateNode, r ? t.insertBefore(e, r) : t.appendChild(e);else if (4 !== n && 27 !== n && null !== (e = e.child)) for (Pc(e, r, t), e = e.sibling; null !== e;) Pc(e, r, t), e = e.sibling;
  }
  var zc = null,
    Bc = !1;
  function jc(e, r, t) {
    for (t = t.child; null !== t;) Vc(e, r, t), t = t.sibling;
  }
  function Vc(e, r, t) {
    if (Cr && "function" == typeof Cr.onCommitFiberUnmount) try {
      Cr.onCommitFiberUnmount(kr, t);
    } catch (e) {}
    switch (t.tag) {
      case 26:
        wc || Dc(t, r), jc(e, r, t), t.memoizedState && Ua(t.memoizedState);
        break;
      case 27:
        wc || Dc(t, r);
        var n = zc,
          a = Bc;
        for (zc = t.stateNode, jc(e, r, t), e = (t = t.stateNode).attributes; e.length;) t.removeAttributeNode(e[0]);
        _(t), zc = n, Bc = a;
        break;
      case 5:
        wc || Dc(t, r);
      case 6:
        n = zc, a = Bc, zc = null, jc(e, r, t), Bc = a, null !== (zc = n) && (Bc ? (e = zc, t = t.stateNode, 8 === e.nodeType ? e.parentNode.removeChild(t) : e.removeChild(t)) : zc.removeChild(t.stateNode));
        break;
      case 18:
        null !== zc && (Bc ? (e = zc, t = t.stateNode, 8 === e.nodeType ? ci(e.parentNode, t) : 1 === e.nodeType && ci(e, t), ct(e)) : ci(zc, t.stateNode));
        break;
      case 4:
        n = zc, a = Bc, zc = t.stateNode.containerInfo, Bc = !0, jc(e, r, t), zc = n, Bc = a;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!wc && null !== (n = t.updateQueue) && null !== (n = n.lastEffect)) {
          a = n = n.next;
          do {
            var i = a,
              o = i.destroy;
            i = i.tag, void 0 !== o && (0 != (2 & i) || 0 != (4 & i)) && Ac(t, r, o), a = a.next;
          } while (a !== n);
        }
        jc(e, r, t);
        break;
      case 1:
        if (!wc && (Dc(t, r), "function" == typeof (n = t.stateNode).componentWillUnmount)) try {
          n.props = t.memoizedProps, n.state = t.memoizedState, n.componentWillUnmount();
        } catch (e) {
          gf(t, r, e);
        }
        jc(e, r, t);
        break;
      case 21:
        jc(e, r, t);
        break;
      case 22:
        Dc(t, r), 1 & t.mode ? (wc = (n = wc) || null !== t.memoizedState, jc(e, r, t), wc = n) : jc(e, r, t);
        break;
      default:
        jc(e, r, t);
    }
  }
  function Uc(e, r) {
    if (null === r.memoizedState && null !== (e = r.alternate) && null !== (e = e.memoizedState) && null !== (e = e.dehydrated)) try {
      ct(e);
    } catch (e) {
      gf(r, r.return, e);
    }
  }
  function Wc(e, r) {
    var t = function (e) {
      switch (e.tag) {
        case 13:
        case 19:
          var r = e.stateNode;
          return null === r && (r = e.stateNode = new yc()), r;
        case 22:
          return null === (r = (e = e.stateNode)._retryCache) && (r = e._retryCache = new yc()), r;
        default:
          throw Error(o(435, e.tag));
      }
    }(e);
    r.forEach(function (r) {
      var n = yf.bind(null, e, r);
      t.has(r) || (t.add(r), r.then(n, n));
    });
  }
  function $c(e, r) {
    var t = r.deletions;
    if (null !== t) for (var n = 0; n < t.length; n++) {
      var a = t[n];
      try {
        var i = e,
          s = r,
          l = s;
        e: for (; null !== l;) {
          switch (l.tag) {
            case 27:
            case 5:
              zc = l.stateNode, Bc = !1;
              break e;
            case 3:
            case 4:
              zc = l.stateNode.containerInfo, Bc = !0;
              break e;
          }
          l = l.return;
        }
        if (null === zc) throw Error(o(160));
        Vc(i, s, a), zc = null, Bc = !1;
        var c = a.alternate;
        null !== c && (c.return = null), a.return = null;
      } catch (e) {
        gf(a, r, e);
      }
    }
    if (12854 & r.subtreeFlags) for (r = r.child; null !== r;) Xc(r, e), r = r.sibling;
  }
  function Xc(e, r) {
    var t = e.alternate,
      n = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if ($c(r, e), Gc(e), 4 & n) {
          try {
            xc(3, e, e.return), Oc(3, e);
          } catch (r) {
            gf(e, e.return, r);
          }
          try {
            xc(5, e, e.return);
          } catch (r) {
            gf(e, e.return, r);
          }
        }
        break;
      case 1:
        $c(r, e), Gc(e), 512 & n && null !== t && Dc(t, t.return), 64 & n && Ec && null !== (e = e.updateQueue) && null !== (t = e.callbacks) && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = null === n ? t : n.concat(t));
        break;
      case 26:
        $c(r, e), Gc(e), 512 & n && null !== t && Dc(t, t.return), 4 & n && (n = e.memoizedState, null !== t && (t = t.memoizedState) !== n && Ua(t), e.stateNode = n ? Va(n) : null);
        break;
      case 27:
        if (4 & n && null === e.alternate) {
          for (var a = e.stateNode, i = e.memoizedProps, s = a.firstChild; s;) {
            var u = s.nextSibling,
              f = s.nodeName;
            s[m] || "HEAD" === f || "BODY" === f || "STYLE" === f || "LINK" === f && "stylesheet" === s.rel.toLowerCase() || a.removeChild(s), s = u;
          }
          for (s = e.type, u = a.attributes; u.length;) a.removeAttributeNode(u[0]);
          ga(a, s, i), a[l] = e, a[c] = i;
        }
      case 5:
        if ($c(r, e), Gc(e), 512 & n && null !== t && Dc(t, t.return), 32 & e.flags) {
          r = e.stateNode;
          try {
            Re(r, "");
          } catch (r) {
            gf(e, e.return, r);
          }
        }
        if (4 & n && null != (n = e.stateNode) && (r = e.memoizedProps, i = null !== t ? t.memoizedProps : r, t = e.type, a = e.updateQueue, e.updateQueue = null, null !== a)) try {
          "input" === t && "radio" === r.type && null != r.name && be(n, r), Be(t, i);
          var d = Be(t, r);
          for (i = 0; i < a.length; i += 2) {
            var v = a[i],
              h = a[i + 1];
            "style" === v ? Le(n, h) : "dangerouslySetInnerHTML" === v ? Ne(n, h) : "children" === v ? Re(n, h) : F(n, v, h, d);
          }
          switch (t) {
            case "input":
              Se(n, r);
              break;
            case "textarea":
              Ae(n, r);
              break;
            case "select":
              var _ = n._wrapperState.wasMultiple;
              n._wrapperState.wasMultiple = !!r.multiple;
              var p = r.value;
              null != p ? ke(n, !!r.multiple, p, !1) : _ !== !!r.multiple && (null != r.defaultValue ? ke(n, !!r.multiple, r.defaultValue, !0) : ke(n, !!r.multiple, r.multiple ? [] : "", !1));
          }
          n[c] = r;
        } catch (r) {
          gf(e, e.return, r);
        }
        break;
      case 6:
        if ($c(r, e), Gc(e), 4 & n) {
          if (null === e.stateNode) throw Error(o(162));
          t = e.stateNode, n = e.memoizedProps;
          try {
            t.nodeValue = n;
          } catch (r) {
            gf(e, e.return, r);
          }
        }
        break;
      case 3:
        if ($c(r, e), Gc(e), 4 & n && null !== t && t.memoizedState.isDehydrated) try {
          ct(r.containerInfo);
        } catch (r) {
          gf(e, e.return, r);
        }
        break;
      case 4:
        $c(r, e), Gc(e);
        break;
      case 13:
        $c(r, e), Gc(e), 8192 & (t = e.child).flags && null !== t.memoizedState && (null === t.alternate || null === t.alternate.memoizedState) && (Mu = pr()), 4 & n && null !== (t = e.updateQueue) && (e.updateQueue = null, Wc(e, t));
        break;
      case 22:
        if (512 & n && null !== t && Dc(t, t.return), d = null !== e.memoizedState, v = null !== t && null !== t.memoizedState, 1 & e.mode ? (Ec = (h = Ec) || d, wc = (_ = wc) || v, $c(r, e), wc = _, Ec = h) : $c(r, e), Gc(e), (h = e.stateNode)._current = e, h._visibility &= -3, h._visibility |= 2 & h._pendingVisibility, 8192 & n && (h._visibility = d ? -2 & h._visibility : 1 | h._visibility, d && (h = Ec || wc, null === t || v || h || 0 != (1 & e.mode) && function e(r) {
          for (r = r.child; null !== r;) {
            var t = r;
            switch (t.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                xc(4, t, t.return), e(t);
                break;
              case 1:
                Dc(t, t.return);
                var n = t.stateNode;
                if ("function" == typeof n.componentWillUnmount) {
                  var a = t,
                    i = t.return;
                  try {
                    var o = a;
                    n.props = o.memoizedProps, n.state = o.memoizedState, n.componentWillUnmount();
                  } catch (e) {
                    gf(a, i, e);
                  }
                }
                e(t);
                break;
              case 26:
              case 27:
              case 5:
                Dc(t, t.return), e(t);
                break;
              case 22:
                Dc(t, t.return), null === t.memoizedState && e(t);
                break;
              default:
                e(t);
            }
            r = r.sibling;
          }
        }(e)), null === e.memoizedProps || "manual" !== e.memoizedProps.mode)) e: for (t = null, v = e;;) {
          if (5 === v.tag || 26 === v.tag || 27 === v.tag) {
            if (null === t) {
              t = v;
              try {
                a = v.stateNode, d ? "function" == typeof (i = a.style).setProperty ? i.setProperty("display", "none", "important") : i.display = "none" : (s = v.stateNode, f = null != (u = v.memoizedProps.style) && u.hasOwnProperty("display") ? u.display : null, s.style.display = Fe("display", f));
              } catch (r) {
                gf(e, e.return, r);
              }
            }
          } else if (6 === v.tag) {
            if (null === t) try {
              v.stateNode.nodeValue = d ? "" : v.memoizedProps;
            } catch (r) {
              gf(e, e.return, r);
            }
          } else if ((22 !== v.tag && 23 !== v.tag || null === v.memoizedState || v === e) && null !== v.child) {
            v.child.return = v, v = v.child;
            continue;
          }
          if (v === e) break e;
          for (; null === v.sibling;) {
            if (null === v.return || v.return === e) break e;
            t === v && (t = null), v = v.return;
          }
          t === v && (t = null), v.sibling.return = v.return, v = v.sibling;
        }
        4 & n && null !== (t = e.updateQueue) && null !== (n = t.wakeables) && (t.wakeables = null, Wc(e, n));
        break;
      case 19:
        $c(r, e), Gc(e), 4 & n && null !== (t = e.updateQueue) && (e.updateQueue = null, Wc(e, t));
        break;
      case 21:
        break;
      default:
        $c(r, e), Gc(e);
    }
  }
  function Gc(e) {
    var r = e.flags;
    if (2 & r) {
      try {
        if (27 !== e.tag) {
          e: {
            for (var t = e.return; null !== t;) {
              if (Fc(t)) {
                var n = t;
                break e;
              }
              t = t.return;
            }
            throw Error(o(160));
          }
          switch (n.tag) {
            case 27:
              var a = n.stateNode;
              Pc(e, Lc(e), a);
              break;
            case 5:
              var i = n.stateNode;
              32 & n.flags && (Re(i, ""), n.flags &= -33), Pc(e, Lc(e), i);
              break;
            case 3:
            case 4:
              var s = n.stateNode.containerInfo;
              !function e(r, t, n) {
                var a = r.tag;
                if (5 === a || 6 === a) r = r.stateNode, t ? 8 === n.nodeType ? n.parentNode.insertBefore(r, t) : n.insertBefore(r, t) : (8 === n.nodeType ? (t = n.parentNode).insertBefore(r, n) : (t = n).appendChild(r), null != (n = n._reactRootContainer) || null !== t.onclick || (t.onclick = _a));else if (4 !== a && 27 !== a && null !== (r = r.child)) for (e(r, t, n), r = r.sibling; null !== r;) e(r, t, n), r = r.sibling;
              }(e, Lc(e), s);
              break;
            default:
              throw Error(o(161));
          }
        }
      } catch (r) {
        gf(e, e.return, r);
      }
      e.flags &= -3;
    }
    4096 & r && (e.flags &= -4097);
  }
  function Kc(e, r) {
    if (8772 & r.subtreeFlags) for (r = r.child; null !== r;) Ic(e, r.alternate, r), r = r.sibling;
  }
  function Yc(e, r) {
    try {
      Oc(r, e);
    } catch (r) {
      gf(e, e.return, r);
    }
  }
  function qc(e, r) {
    var t = null;
    null !== e && null !== e.memoizedState && null !== e.memoizedState.cachePool && (t = e.memoizedState.cachePool.pool), e = null, null !== r.memoizedState && null !== r.memoizedState.cachePool && (e = r.memoizedState.cachePool.pool), e !== t && (null != e && e.refCount++, null != t && oc(t));
  }
  function Qc(e, r) {
    e = null, null !== r.alternate && (e = r.alternate.memoizedState.cache), (r = r.memoizedState.cache) !== e && (r.refCount++, null != e && oc(e));
  }
  function Zc(e, r, t, n) {
    if (10256 & r.subtreeFlags) for (r = r.child; null !== r;) Jc(e, r, t, n), r = r.sibling;
  }
  function Jc(e, r, t, n) {
    var a = r.flags;
    switch (r.tag) {
      case 0:
      case 11:
      case 15:
        Zc(e, r, t, n), 2048 & a && Yc(r, 9);
        break;
      case 3:
        Zc(e, r, t, n), 2048 & a && (e = null, null !== r.alternate && (e = r.alternate.memoizedState.cache), (r = r.memoizedState.cache) !== e && (r.refCount++, null != e && oc(e)));
        break;
      case 23:
        break;
      case 22:
        var i = r.stateNode;
        null !== r.memoizedState ? 4 & i._visibility ? Zc(e, r, t, n) : 1 & r.mode ? eu(e, r) : (i._visibility |= 4, Zc(e, r, t, n)) : 4 & i._visibility ? Zc(e, r, t, n) : (i._visibility |= 4, function e(r, t, n, a, i) {
          for (i = i && 0 != (10256 & t.subtreeFlags), t = t.child; null !== t;) {
            var o = r,
              s = t,
              l = n,
              c = a,
              u = s.flags;
            switch (s.tag) {
              case 0:
              case 11:
              case 15:
                e(o, s, l, c, i), Yc(s, 8);
                break;
              case 23:
                break;
              case 22:
                var f = s.stateNode;
                null !== s.memoizedState ? 4 & f._visibility ? e(o, s, l, c, i) : 1 & s.mode ? eu(o, s) : (f._visibility |= 4, e(o, s, l, c, i)) : (f._visibility |= 4, e(o, s, l, c, i)), i && 2048 & u && qc(s.alternate, s);
                break;
              case 24:
                e(o, s, l, c, i), i && 2048 & u && Qc(s.alternate, s);
                break;
              default:
                e(o, s, l, c, i);
            }
            t = t.sibling;
          }
        }(e, r, t, n, 0 != (10256 & r.subtreeFlags))), 2048 & a && qc(r.alternate, r);
        break;
      case 24:
        Zc(e, r, t, n), 2048 & a && Qc(r.alternate, r);
        break;
      default:
        Zc(e, r, t, n);
    }
  }
  function eu(e, r) {
    if (10256 & r.subtreeFlags) for (r = r.child; null !== r;) {
      var t = e,
        n = r,
        a = n.flags;
      switch (n.tag) {
        case 22:
          eu(t, n), 2048 & a && qc(n.alternate, n);
          break;
        case 24:
          eu(t, n), 2048 & a && Qc(n.alternate, n);
          break;
        default:
          eu(t, n);
      }
      r = r.sibling;
    }
  }
  function ru(e) {
    var r = e.alternate;
    if (null !== r && null !== (e = r.child)) {
      r.child = null;
      do {
        r = e.sibling, e.sibling = null, e = r;
      } while (null !== e);
    }
  }
  function tu(e) {
    var r = e.deletions;
    if (0 != (16 & e.flags)) {
      if (null !== r) for (var t = 0; t < r.length; t++) {
        var n = r[t];
        kc = n, au(n, e);
      }
      ru(e);
    }
    if (10256 & e.subtreeFlags) for (e = e.child; null !== e;) nu(e), e = e.sibling;
  }
  function nu(e) {
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        tu(e), 2048 & e.flags && xc(9, e, e.return);
        break;
      case 22:
        var r = e.stateNode;
        null !== e.memoizedState && 4 & r._visibility && (null === e.return || 13 !== e.return.tag) ? (r._visibility &= -5, function e(r) {
          var t = r.deletions;
          if (0 != (16 & r.flags)) {
            if (null !== t) for (var n = 0; n < t.length; n++) {
              var a = t[n];
              kc = a, au(a, r);
            }
            ru(r);
          }
          for (r = r.child; null !== r;) {
            switch ((t = r).tag) {
              case 0:
              case 11:
              case 15:
                xc(8, t, t.return), e(t);
                break;
              case 22:
                4 & (n = t.stateNode)._visibility && (n._visibility &= -5, e(t));
                break;
              default:
                e(t);
            }
            r = r.sibling;
          }
        }(e)) : tu(e);
        break;
      default:
        tu(e);
    }
  }
  function au(e, r) {
    for (; null !== kc;) {
      var t = kc;
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          xc(8, t, r);
          break;
        case 23:
        case 22:
          if (null !== t.memoizedState && null !== t.memoizedState.cachePool) {
            var n = t.memoizedState.cachePool.pool;
            null != n && n.refCount++;
          }
          break;
        case 24:
          oc(t.memoizedState.cache);
      }
      if (null !== (n = t.child)) n.return = t, kc = n;else e: for (t = e; null !== kc;) {
        var a = (n = kc).sibling,
          i = n.return;
        if (Hc(n), n === t) {
          kc = null;
          break e;
        }
        if (null !== a) {
          a.return = i, kc = a;
          break e;
        }
        kc = i;
      }
    }
  }
  var iu,
    ou = {
      getCacheSignal: function () {
        return ec(ac).controller.signal;
      },
      getCacheForType: function (e) {
        var r = ec(ac),
          t = r.data.get(e);
        return void 0 === t && (t = e(), r.data.set(e, t)), t;
      }
    },
    su = Math.ceil,
    lu = "function" == typeof WeakMap ? WeakMap : Map,
    cu = L.ReactCurrentDispatcher,
    uu = L.ReactCurrentCache,
    fu = L.ReactCurrentOwner,
    du = L.ReactCurrentBatchConfig,
    vu = 0,
    hu = null,
    mu = null,
    _u = 0,
    pu = 0,
    gu = null,
    bu = !1,
    Su = 0,
    Eu = 0,
    wu = null,
    yu = 0,
    ku = 0,
    Cu = 0,
    Du = null,
    Au = null,
    Mu = 0,
    xu = 1 / 0,
    Ou = null,
    Tu = !1,
    Nu = null,
    Ru = null,
    Iu = !1,
    Hu = null,
    Fu = 0,
    Lu = 0,
    Pu = null,
    zu = 0,
    Bu = null,
    ju = -1,
    Vu = 0;
  function Uu() {
    return 0 != (6 & vu) ? pr() : -1 !== ju ? ju : ju = pr();
  }
  function Wu(e) {
    return 0 == (1 & e.mode) ? 2 : 0 != (2 & vu) && 0 !== _u ? _u & -_u : null !== uc.transition ? (0 === Vu && (Vu = Hr()), Vu) : 0 !== (e = zr) ? e : e = void 0 === (e = window.event) ? 32 : pt(e.type);
  }
  function $u(e, r, t, n) {
    2 === pu && e === hu && (rf(e, 0), qu(e, _u)), Lr(e, t, n), 0 != (2 & vu) && e === hu || (e === hu && (0 == (2 & vu) && (ku |= t), 4 === Eu && qu(e, _u)), Xu(e, n), 2 === t && 0 === vu && 0 == (1 & r.mode) && (xu = pr() + 500, Ai && Oi()));
  }
  function Xu(e, r) {
    var t = e.callbackNode;
    !function (e, r) {
      for (var t = e.suspendedLanes, n = e.pingedLanes, a = e.expirationTimes, i = -125829121 & e.pendingLanes; 0 < i;) {
        var o = 31 - Dr(i),
          s = 1 << o,
          l = a[o];
        -1 === l ? 0 != (s & t) && 0 == (s & n) || (a[o] = Rr(s, r)) : l <= r && (e.expiredLanes |= s), i &= ~s;
      }
    }(e, r);
    var n = Nr(e, e === hu ? _u : 0);
    if (0 === n) null !== t && hr(t), e.callbackNode = null, e.callbackPriority = 0;else if (r = n & -n, e.callbackPriority !== r) {
      if (null != t && hr(t), 0 != (3 & r)) 0 === e.tag ? function (e) {
        Ai = !0, xi(e);
      }(Qu.bind(null, e)) : xi(Qu.bind(null, e)), si(function () {
        0 == (6 & vu) && Oi();
      }), t = null;else {
        switch (jr(n)) {
          case 2:
            t = br;
            break;
          case 8:
            t = Sr;
            break;
          case 32:
            t = Er;
            break;
          case 536870912:
            t = yr;
            break;
          default:
            t = Er;
        }
        t = kf(t, Gu.bind(null, e));
      }
      e.callbackPriority = r, e.callbackNode = t;
    }
  }
  function Gu(e, r) {
    if (ju = -1, Vu = 0, 0 != (6 & vu)) throw Error(o(327));
    var t = e.callbackNode;
    if (_f() && e.callbackNode !== t) return null;
    var n = Nr(e, e === hu ? _u : 0);
    if (0 === n) return null;
    if (0 !== (r = 0 != (60 & n) || 0 != (n & e.expiredLanes) || r ? sf(e, n) : function (e, r) {
      var t = vu;
      vu |= 2;
      var n = nf(e.containerInfo),
        a = af();
      hu === e && _u === r || (Ou = null, xu = pr() + 500, rf(e, r));
      e: for (;;) try {
        if (0 !== pu && null !== mu) {
          r = mu;
          var i = gu;
          switch (pu) {
            case 1:
              pu = 0, gu = null, df(r, i);
              break;
            case 2:
              if ($o(i)) {
                pu = 0, gu = null, ff(r);
                break;
              }
              r = function () {
                Xu(e, pr());
              }, i.then(r, r);
              break e;
            case 3:
              pu = 5;
              break e;
            case 5:
              $o(i) ? (pu = 0, gu = null, ff(r)) : (pu = 0, gu = null, df(r, i));
              break;
            case 4:
              pu = 0, gu = null, df(r, i);
              break;
            case 6:
              ef(), Eu = 6;
              break e;
            default:
              throw Error(o(462));
          }
        }
        cf();
        break;
      } catch (r) {
        tf(e, r);
      }
      return Kl(), Ta.current = Ra, Ra = null, cu.current = n, uu.current = a, vu = t, null !== mu ? 0 : (hu = null, _u = 0, so(), Eu);
    }(e, n))) {
      if (2 === r) {
        var a = n,
          i = Ir(e, a);
        0 !== i && (n = i, r = Ku(e, a, i));
      }
      if (1 === r) throw t = wu, rf(e, 0), qu(e, n), Xu(e, pr()), t;
      if (6 === r) qu(e, n);else {
        if (a = e.current.alternate, 0 == (60 & n) && !function (e) {
          for (var r = e;;) {
            if (16384 & r.flags) {
              var t = r.updateQueue;
              if (null !== t && null !== (t = t.stores)) for (var n = 0; n < t.length; n++) {
                var a = t[n],
                  i = a.getSnapshot;
                a = a.value;
                try {
                  if (!Cn(i(), a)) return !1;
                } catch (e) {
                  return !1;
                }
              }
            }
            if (t = r.child, 16384 & r.subtreeFlags && null !== t) t.return = r, r = t;else {
              if (r === e) break;
              for (; null === r.sibling;) {
                if (null === r.return || r.return === e) return !0;
                r = r.return;
              }
              r.sibling.return = r.return, r = r.sibling;
            }
          }
          return !0;
        }(a)) {
          if (2 === (r = sf(e, n))) {
            var s = Ir(e, i = n);
            0 !== s && (n = s, r = Ku(e, i, s));
          }
          if (1 === r) throw t = wu, rf(e, 0), qu(e, n), Xu(e, pr()), t;
        }
        switch (e.finishedWork = a, e.finishedLanes = n, r) {
          case 0:
          case 1:
            throw Error(o(345));
          case 2:
            hf(e, Au, Ou);
            break;
          case 3:
            if (qu(e, n), (125829120 & n) === n && 10 < (n = Mu + 500 - pr())) {
              if (0 !== Nr(e, 0)) break;
              e.timeoutHandle = ai(hf.bind(null, e, Au, Ou), n);
              break;
            }
            hf(e, Au, Ou);
            break;
          case 4:
            if (qu(e, n), (8388480 & n) === n) break;
            for (r = e.eventTimes, a = -1; 0 < n;) i = 1 << (s = 31 - Dr(n)), (s = r[s]) > a && (a = s), n &= ~i;
            if (n = a, 10 < (n = (120 > (n = pr() - n) ? 120 : 480 > n ? 480 : 1080 > n ? 1080 : 1920 > n ? 1920 : 3000 > n ? 3000 : 4320 > n ? 4320 : 1960 * su(n / 1960)) - n)) {
              e.timeoutHandle = ai(hf.bind(null, e, Au, Ou), n);
              break;
            }
            hf(e, Au, Ou);
            break;
          case 5:
            hf(e, Au, Ou);
            break;
          default:
            throw Error(o(329));
        }
      }
    }
    return Xu(e, pr()), e.callbackNode === t ? 2 === pu && hu === e ? (e.callbackPriority = 0, e.callbackNode = null) : Gu.bind(null, e) : null;
  }
  function Ku(e, r, t) {
    var n = Du,
      a = e.current.memoizedState.isDehydrated;
    if (a && (rf(e, t).flags |= 256), 2 !== (t = sf(e, t))) {
      if (bu && !a) return e.errorRecoveryDisabledLanes |= r, ku |= r, 4;
      e = Au, Au = n, null !== e && Yu(e);
    }
    return t;
  }
  function Yu(e) {
    null === Au ? Au = e : Au.push.apply(Au, e);
  }
  function qu(e, r) {
    for (r &= ~Cu, r &= ~ku, e.suspendedLanes |= r, e.pingedLanes &= ~r, e = e.expirationTimes; 0 < r;) {
      var t = 31 - Dr(r),
        n = 1 << t;
      e[t] = -1, r &= ~n;
    }
  }
  function Qu(e) {
    if (0 != (6 & vu)) throw Error(o(327));
    _f();
    var r = Nr(e, 0);
    if (0 == (3 & r)) return Xu(e, pr()), null;
    var t = sf(e, r);
    if (0 !== e.tag && 2 === t) {
      var n = r,
        a = Ir(e, n);
      0 !== a && (r = a, t = Ku(e, n, a));
    }
    if (1 === t) throw t = wu, rf(e, 0), qu(e, r), Xu(e, pr()), t;
    return 6 === t ? (qu(e, r), Xu(e, pr()), null) : (e.finishedWork = e.current.alternate, e.finishedLanes = r, hf(e, Au, Ou), Xu(e, pr()), null);
  }
  function Zu(e, r) {
    var t = vu;
    vu |= 1;
    try {
      return e(r);
    } finally {
      0 === (vu = t) && (xu = pr() + 500, Ai && Oi());
    }
  }
  function Ju(e) {
    null !== Hu && 0 === Hu.tag && 0 == (6 & vu) && _f();
    var r = vu;
    vu |= 1;
    var t = du.transition,
      n = zr;
    try {
      if (du.transition = null, zr = 2, e) return e();
    } finally {
      zr = n, du.transition = t, 0 == (6 & (vu = r)) && Oi();
    }
  }
  function ef() {
    if (null !== mu) {
      if (0 === pu) var e = mu.return;else Kl(), hs(), e = mu;
      for (; null !== e;) Sc(e.alternate, e), e = e.return;
      mu = null;
    }
  }
  function rf(e, r) {
    e.finishedWork = null, e.finishedLanes = 0;
    var t = e.timeoutHandle;
    return -1 !== t && (e.timeoutHandle = -1, ii(t)), ef(), hu = e, mu = e = Mf(e.current, null), _u = Su = r, pu = 0, gu = null, bu = !1, Eu = 0, wu = null, Cu = ku = yu = 0, Au = Du = null, so(), e;
  }
  function tf(e, r) {
    if (Ko.current = el, fu.current = null, r === Wo) {
      if (null === Go) throw Error(o(459));
      e = Go, Go = null, r = e, pu = function () {
        if (0 != (268435455 & yu) || 0 != (268435455 & ku)) return !1;
        if ((8388480 & _u) === _u) return null === Ho;
        var e = Io.current;
        return null !== e && (125829120 & _u) === _u && e === Ho;
      }() ? 2 : 3;
    } else pu = r === gl ? 6 : null !== r && "object" == typeof r && "function" == typeof r.then ? 4 : 1;
    gu = r, null === mu && (Eu = 1, wu = r);
  }
  function nf(e) {
    return e = Fa(e), Na = ja(e), Ra = Ta.current, Ta.current = Ia, e = cu.current, cu.current = el, null === e ? el : e;
  }
  function af() {
    var e = uu.current;
    return uu.current = ou, e;
  }
  function of() {
    Eu = 4, null === hu || 0 == (268435455 & yu) && 0 == (268435455 & ku) || qu(hu, _u);
  }
  function sf(e, r) {
    var t = vu;
    vu |= 2;
    var n = nf(e.containerInfo),
      a = af();
    hu === e && _u === r || (Ou = null, rf(e, r));
    e: for (;;) try {
      if (0 !== pu && null !== mu) {
        r = mu;
        var i = gu;
        switch (pu) {
          case 6:
            ef(), Eu = 6;
            break e;
          default:
            pu = 0, gu = null, df(r, i);
        }
      }
      lf();
      break;
    } catch (r) {
      tf(e, r);
    }
    if (Kl(), vu = t, Ta.current = Ra, Ra = null, cu.current = n, uu.current = a, null !== mu) throw Error(o(261));
    return hu = null, _u = 0, so(), Eu;
  }
  function lf() {
    for (; null !== mu;) uf(mu);
  }
  function cf() {
    for (; null !== mu && !mr();) uf(mu);
  }
  function uf(e) {
    var r = iu(e.alternate, e, Su);
    e.memoizedProps = e.pendingProps, null === r ? vf(e) : mu = r, fu.current = null;
  }
  function ff(e) {
    var r = e.alternate;
    switch (e.tag) {
      case 2:
        e.tag = 0;
      case 0:
      case 11:
        var t = e.type,
          n = e.pendingProps;
        r = Ml(r, e, n = e.elementType === t ? n : al(t, n), t, _u);
        break;
      case 15:
        r = Ml(r, e, e.pendingProps, e.type, _u);
        break;
      default:
        Kl(), hs(), Sc(r, e), e = mu = xf(e, Su), r = iu(r, e, Su);
    }
    e.memoizedProps = e.pendingProps, null === r ? vf(e) : mu = r, fu.current = null;
  }
  function df(e, r) {
    Kl(), hs();
    var t = e.return;
    if (null === t || null === hu) Eu = 1, wu = r, mu = null;else {
      try {
        e: {
          var n = hu,
            a = r;
          if (r = _u, e.flags |= 32768, null !== a && "object" == typeof a && "function" == typeof a.then) {
            var i = a,
              s = e.tag;
            if (0 == (1 & e.mode) && (0 === s || 11 === s || 15 === s)) {
              var l = e.alternate;
              l ? (e.updateQueue = l.updateQueue, e.memoizedState = l.memoizedState, e.lanes = l.lanes) : (e.updateQueue = null, e.memoizedState = null);
            }
            var c = Io.current;
            if (null !== c) {
              switch (c.tag) {
                case 13:
                  1 & e.mode && (null === Ho ? of() : null === c.alternate && 0 === Eu && (Eu = 3)), c.flags &= -257, _l(c, t, e, 0, r);
                  var u = c.updateQueue;
                  null === u ? c.updateQueue = new Set([i]) : u.add(i);
                  break;
                case 22:
                  if (1 & c.mode) {
                    c.flags |= 65536;
                    var f = c.updateQueue;
                    if (null === f) {
                      var d = {
                        transitions: null,
                        markerInstances: null,
                        wakeables: new Set([i])
                      };
                      c.updateQueue = d;
                    } else {
                      var v = f.wakeables;
                      null === v ? f.wakeables = new Set([i]) : v.add(i);
                    }
                    break;
                  }
                default:
                  throw Error(o(435, c.tag));
              }
              1 & c.mode && bf(n, i, r);
              break e;
            }
            if (1 === n.tag) {
              bf(n, i, r), of();
              break e;
            }
            a = Error(o(426));
          } else if (Xi && 1 & e.mode && null !== (i = Io.current)) {
            0 == (65536 & i.flags) && (i.flags |= 256), _l(i, t, e, 0, r), no(fl(a, e));
            break e;
          }
          n = a = fl(a, e), 4 !== Eu && (Eu = 2), null === Du ? Du = [n] : Du.push(n), n = t;
          do {
            switch (n.tag) {
              case 3:
                var h = a;
                n.flags |= 65536, r &= -r, n.lanes |= r;
                var m = hl(0, h, r);
                bo(n, m);
                break e;
              case 1:
                s = a;
                var _ = n.type,
                  p = n.stateNode;
                if (0 == (128 & n.flags) && ("function" == typeof _.getDerivedStateFromError || null !== p && "function" == typeof p.componentDidCatch && (null === Ru || !Ru.has(p)))) {
                  n.flags |= 65536, m = r & -r, n.lanes |= m, bo(n, h = ml(n, s, m));
                  break e;
                }
            }
            n = n.return;
          } while (null !== n);
        }
      } catch (e) {
        throw mu = t, e;
      }
      vf(e);
    }
  }
  function vf(e) {
    var r = e;
    do {
      var t = r.alternate;
      if (e = r.return, 0 == (32768 & r.flags)) {
        if (null !== (t = gc(t, r, Su))) return void (mu = t);
      } else {
        if (null !== (t = bc(t, r))) return t.flags &= 16383, void (mu = t);
        if (null === e) return Eu = 6, void (mu = null);
        e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null;
      }
      if (null !== (r = r.sibling)) return void (mu = r);
      mu = r = e;
    } while (null !== r);
    0 === Eu && (Eu = 5);
  }
  function hf(e, r, t) {
    var n = zr,
      a = du.transition;
    try {
      du.transition = null, zr = 2, function (e, r, t, n) {
        do {
          _f();
        } while (null !== Hu);
        if (0 != (6 & vu)) throw Error(o(327));
        var a = e.finishedWork,
          i = e.finishedLanes;
        if (null === a) return null;
        if (e.finishedWork = null, e.finishedLanes = 0, a === e.current) throw Error(o(177));
        e.callbackNode = null, e.callbackPriority = 0;
        var s = a.lanes | a.childLanes;
        if (function (e, r) {
          var t = e.pendingLanes & ~r;
          e.pendingLanes = r, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= r, e.mutableReadLanes &= r, e.entangledLanes &= r, e.errorRecoveryDisabledLanes &= r, r = e.entanglements;
          var n = e.eventTimes,
            a = e.expirationTimes;
          for (e = e.hiddenUpdates; 0 < t;) {
            var i = 31 - Dr(t),
              o = 1 << i;
            r[i] = 0, n[i] = -1, a[i] = -1;
            var s = e[i];
            if (null !== s) for (e[i] = null, i = 0; i < s.length; i++) {
              var l = s[i];
              null !== l && (l.lane &= -1073741825);
            }
            t &= ~o;
          }
        }(e, s |= oo), e === hu && (mu = hu = null, _u = 0), 0 == (10256 & a.subtreeFlags) && 0 == (10256 & a.flags) || Iu || (Iu = !0, Lu = s, Pu = t, kf(Er, function () {
          return _f(), null;
        })), t = 0 != (15990 & a.flags), 0 != (15990 & a.subtreeFlags) || t) {
          t = du.transition, du.transition = null;
          var l = zr;
          zr = 2;
          var c = vu;
          vu |= 4, fu.current = null, function (e, r) {
            if (ri = ft, On(e = xn())) {
              if ("selectionStart" in e) var t = {
                start: e.selectionStart,
                end: e.selectionEnd
              };else e: {
                var n = (t = (t = e.ownerDocument) && t.defaultView || window).getSelection && t.getSelection();
                if (n && 0 !== n.rangeCount) {
                  t = n.anchorNode;
                  var a = n.anchorOffset,
                    i = n.focusNode;
                  n = n.focusOffset;
                  try {
                    t.nodeType, i.nodeType;
                  } catch (e) {
                    t = null;
                    break e;
                  }
                  var s = 0,
                    l = -1,
                    c = -1,
                    u = 0,
                    f = 0,
                    d = e,
                    v = null;
                  r: for (;;) {
                    for (var h; d !== t || 0 !== a && 3 !== d.nodeType || (l = s + a), d !== i || 0 !== n && 3 !== d.nodeType || (c = s + n), 3 === d.nodeType && (s += d.nodeValue.length), null !== (h = d.firstChild);) v = d, d = h;
                    for (;;) {
                      if (d === e) break r;
                      if (v === t && ++u === a && (l = s), v === i && ++f === n && (c = s), null !== (h = d.nextSibling)) break;
                      v = (d = v).parentNode;
                    }
                    d = h;
                  }
                  t = -1 === l || -1 === c ? null : {
                    start: l,
                    end: c
                  };
                } else t = null;
              }
              t = t || {
                start: 0,
                end: 0
              };
            } else t = null;
            for (ti = {
              focusedElem: e,
              selectionRange: t
            }, ft = !1, kc = r; null !== kc;) if (e = (r = kc).child, 0 != (1028 & r.subtreeFlags) && null !== e) e.return = r, kc = e;else for (; null !== kc;) {
              r = kc;
              try {
                var m = r.alternate,
                  _ = r.flags;
                switch (r.tag) {
                  case 0:
                    if (0 != (4 & _)) {
                      var p = r.updateQueue,
                        g = null !== p ? p.events : null;
                      if (null !== g) for (e = 0; e < g.length; e++) {
                        var b = g[e];
                        b.ref.impl = b.nextImpl;
                      }
                    }
                    break;
                  case 11:
                  case 15:
                    break;
                  case 1:
                    if (0 != (1024 & _) && null !== m) {
                      var S = m.memoizedProps,
                        E = m.memoizedState,
                        w = r.stateNode,
                        y = w.getSnapshotBeforeUpdate(r.elementType === r.type ? S : al(r.type, S), E);
                      w.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                  case 3:
                    0 != (1024 & _) && ui(r.stateNode.containerInfo);
                    break;
                  case 5:
                  case 26:
                  case 27:
                  case 6:
                  case 4:
                  case 17:
                    break;
                  default:
                    if (0 != (1024 & _)) throw Error(o(163));
                }
              } catch (e) {
                gf(r, r.return, e);
              }
              if (null !== (e = r.sibling)) {
                e.return = r.return, kc = e;
                break;
              }
              kc = r.return;
            }
            m = Mc, Mc = !1;
          }(e, a), Xc(a, e), Tn(ti), ft = !!ri, ti = ri = null, e.current = a, Ic(e, a.alternate, a), _r(), vu = c, zr = l, du.transition = t;
        } else e.current = a;
        if (Iu ? (Iu = !1, Hu = e, Fu = i) : mf(e, s), 0 === (s = e.pendingLanes) && (Ru = null), function (e) {
          if (Cr && "function" == typeof Cr.onCommitFiberRoot) try {
            Cr.onCommitFiberRoot(kr, e, void 0, 128 == (128 & e.current.flags));
          } catch (e) {}
        }(a.stateNode), Xu(e, pr()), null !== r) for (n = e.onRecoverableError, a = 0; a < r.length; a++) i = r[a], s = {
          digest: i.digest,
          componentStack: i.stack
        }, n(i.value, s);
        if (Tu) throw Tu = !1, e = Nu, Nu = null, e;
        0 != (3 & Fu) && 0 !== e.tag && _f(), 0 != (3 & (s = e.pendingLanes)) ? e === Bu ? zu++ : (zu = 0, Bu = e) : zu = 0, Oi();
      }(e, r, t, n);
    } finally {
      du.transition = a, zr = n;
    }
    return null;
  }
  function mf(e, r) {
    0 == (e.pooledCacheLanes &= r) && null != (r = e.pooledCache) && (e.pooledCache = null, oc(r));
  }
  function _f() {
    if (null !== Hu) {
      var e = Hu,
        r = Lu;
      Lu = 0;
      var t = jr(Fu),
        n = 32 > t ? 32 : t;
      t = du.transition;
      var a = zr;
      try {
        if (du.transition = null, zr = n, null === Hu) var i = !1;else {
          n = Pu, Pu = null;
          var s = Hu,
            l = Fu;
          if (Hu = null, Fu = 0, 0 != (6 & vu)) throw Error(o(331));
          var c = vu;
          if (vu |= 4, nu(s.current), Jc(s, s.current, l, n), vu = c, Oi(), Cr && "function" == typeof Cr.onPostCommitFiberRoot) try {
            Cr.onPostCommitFiberRoot(kr, s);
          } catch (e) {}
          i = !0;
        }
        return i;
      } finally {
        zr = a, du.transition = t, mf(e, r);
      }
    }
    return !1;
  }
  function pf(e, r, t) {
    e = po(e, r = hl(0, r = fl(t, r), 2), 2), r = Uu(), null !== e && (Lr(e, 2, r), Xu(e, r));
  }
  function gf(e, r, t) {
    if (3 === e.tag) pf(e, e, t);else for (; null !== r;) {
      if (3 === r.tag) {
        pf(r, e, t);
        break;
      }
      if (1 === r.tag) {
        var n = r.stateNode;
        if ("function" == typeof r.type.getDerivedStateFromError || "function" == typeof n.componentDidCatch && (null === Ru || !Ru.has(n))) {
          r = po(r, e = ml(r, e = fl(t, e), 2), 2), e = Uu(), null !== r && (Lr(r, 2, e), Xu(r, e));
          break;
        }
      }
      r = r.return;
    }
  }
  function bf(e, r, t) {
    var n = e.pingCache;
    if (null === n) {
      n = e.pingCache = new lu();
      var a = new Set();
      n.set(r, a);
    } else void 0 === (a = n.get(r)) && (a = new Set(), n.set(r, a));
    a.has(t) || (bu = !0, a.add(t), e = Sf.bind(null, e, r, t), r.then(e, e));
  }
  function Sf(e, r, t) {
    var n = e.pingCache;
    null !== n && n.delete(r), r = Uu(), e.pingedLanes |= e.suspendedLanes & t, hu === e && (_u & t) === t && (4 === Eu || 3 === Eu && (125829120 & _u) === _u && 500 > pr() - Mu ? 0 == (2 & vu) && rf(e, 0) : Cu |= t), Xu(e, r);
  }
  function Ef(e, r) {
    0 === r && (0 == (1 & e.mode) ? r = 2 : (r = Or, 0 == (125829120 & (Or <<= 1)) && (Or = 8388608)));
    var t = Uu();
    null !== (e = co(e, r)) && (Lr(e, r, t), Xu(e, t));
  }
  function wf(e) {
    var r = e.memoizedState,
      t = 0;
    null !== r && (t = r.retryLane), Ef(e, t);
  }
  function yf(e, r) {
    var t = 0;
    switch (e.tag) {
      case 13:
        var n = e.stateNode,
          a = e.memoizedState;
        null !== a && (t = a.retryLane);
        break;
      case 19:
        n = e.stateNode;
        break;
      case 22:
        n = e.stateNode._retryCache;
        break;
      default:
        throw Error(o(314));
    }
    null !== n && n.delete(r), Ef(e, t);
  }
  function kf(e, r) {
    return vr(e, r);
  }
  function Cf(e, r, t, n) {
    (this || _global).tag = e, (this || _global).key = t, (this || _global).sibling = (this || _global).child = (this || _global).return = (this || _global).stateNode = (this || _global).type = (this || _global).elementType = null, (this || _global).index = 0, (this || _global).refCleanup = (this || _global).ref = null, (this || _global).pendingProps = r, (this || _global).dependencies = (this || _global).memoizedState = (this || _global).updateQueue = (this || _global).memoizedProps = null, (this || _global).mode = n, (this || _global).subtreeFlags = (this || _global).flags = 0, (this || _global).deletions = null, (this || _global).childLanes = (this || _global).lanes = 0, (this || _global).alternate = null;
  }
  function Df(e, r, t, n) {
    return new Cf(e, r, t, n);
  }
  function Af(e) {
    return !(!(e = e.prototype) || !e.isReactComponent);
  }
  function Mf(e, r) {
    var t = e.alternate;
    return null === t ? ((t = Df(e.tag, r, e.key, e.mode)).elementType = e.elementType, t.type = e.type, t.stateNode = e.stateNode, t.alternate = e, e.alternate = t) : (t.pendingProps = r, t.type = e.type, t.flags = 0, t.subtreeFlags = 0, t.deletions = null), t.flags = 14680064 & e.flags, t.childLanes = e.childLanes, t.lanes = e.lanes, t.child = e.child, t.memoizedProps = e.memoizedProps, t.memoizedState = e.memoizedState, t.updateQueue = e.updateQueue, r = e.dependencies, t.dependencies = null === r ? null : {
      lanes: r.lanes,
      firstContext: r.firstContext
    }, t.sibling = e.sibling, t.index = e.index, t.ref = e.ref, t.refCleanup = e.refCleanup, t;
  }
  function xf(e, r) {
    e.flags &= 14680066;
    var t = e.alternate;
    return null === t ? (e.childLanes = 0, e.lanes = r, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = t.childLanes, e.lanes = t.lanes, e.child = t.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = t.memoizedProps, e.memoizedState = t.memoizedState, e.updateQueue = t.updateQueue, e.type = t.type, r = t.dependencies, e.dependencies = null === r ? null : {
      lanes: r.lanes,
      firstContext: r.firstContext
    }), e;
  }
  function Of(e, r, t, n, a, i) {
    var s = 2;
    if (n = e, "function" == typeof e) Af(e) && (s = 1);else if ("string" == typeof e) s = function (e, r, t) {
      switch (e) {
        case "base":
        case "meta":
          return !0;
        case "title":
          return "http://www.w3.org/2000/svg" !== t;
        case "link":
          if (e = r.onError, r.onLoad || e) break;
          switch (r.rel) {
            case "stylesheet":
              return e = r.precedence, t = r.disabled, "string" == typeof r.href && "string" == typeof e && null == t;
            default:
              return e = r.rel, "string" == typeof r.href && "string" == typeof e;
          }
        case "script":
          e = r.src, t = r.onLoad;
          var n = r.onError;
          return r.async && "string" == typeof e && !t && !n;
      }
      return !1;
    }(e, t, ka.current) ? 26 : "html" === e || "head" === e || "body" === e ? 27 : 5;else e: switch (e) {
      case B:
        return Tf(t.children, a, i, r);
      case j:
        s = 8, 0 != (1 & (a |= 8)) && (a |= 16);
        break;
      case V:
        return (e = Df(12, t, r, 2 | a)).elementType = V, e.lanes = i, e;
      case G:
        return (e = Df(13, t, r, a)).elementType = G, e.lanes = i, e;
      case K:
        return (e = Df(19, t, r, a)).elementType = K, e.lanes = i, e;
      case Z:
        return Nf(t, a, i, r);
      case J:
      case Q:
      case ee:
        return (e = Df(24, t, r, a)).elementType = ee, e.lanes = i, e;
      default:
        if ("object" == typeof e && null !== e) switch (e.$$typeof) {
          case U:
            s = 10;
            break e;
          case W:
            s = 9;
            break e;
          case X:
            s = 11;
            break e;
          case Y:
            s = 14;
            break e;
          case q:
            s = 16, n = null;
            break e;
        }
        throw Error(o(130, null == e ? e : typeof e, ""));
    }
    return (r = Df(s, t, r, a)).elementType = e, r.type = n, r.lanes = i, r;
  }
  function Tf(e, r, t, n) {
    return (e = Df(7, e, n, r)).lanes = t, e;
  }
  function Nf(e, r, t, n) {
    (e = Df(22, e, n, r)).elementType = Z, e.lanes = t;
    var a = {
      _visibility: 1,
      _pendingVisibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null,
      _current: null,
      detach: function () {
        var e = a._current;
        if (null === e) throw Error(o(456));
        if (0 == (2 & a._pendingVisibility)) {
          var r = co(e, 2);
          null !== r && (a._pendingVisibility |= 2, $u(r, e, 2, -1));
        }
      },
      attach: function () {
        var e = a._current;
        if (null === e) throw Error(o(456));
        if (0 != (2 & a._pendingVisibility)) {
          var r = co(e, 2);
          null !== r && (a._pendingVisibility &= -3, $u(r, e, 2, -1));
        }
      }
    };
    return e.stateNode = a, e;
  }
  function Rf(e, r, t) {
    return (e = Df(6, e, null, r)).lanes = t, e;
  }
  function If(e, r, t) {
    return (r = Df(4, null !== e.children ? e.children : [], e.key, r)).lanes = t, r.stateNode = {
      containerInfo: e.containerInfo,
      pendingChildren: null,
      implementation: e.implementation
    }, r;
  }
  function Hf(e, r, t, n, a) {
    (this || _global).tag = r, (this || _global).containerInfo = e, (this || _global).finishedWork = (this || _global).pingCache = (this || _global).current = (this || _global).pendingChildren = null, (this || _global).timeoutHandle = -1, (this || _global).callbackNode = (this || _global).pendingContext = (this || _global).context = null, (this || _global).callbackPriority = 0, (this || _global).eventTimes = Fr(0), (this || _global).expirationTimes = Fr(-1), (this || _global).entangledLanes = (this || _global).errorRecoveryDisabledLanes = (this || _global).finishedLanes = (this || _global).mutableReadLanes = (this || _global).expiredLanes = (this || _global).pingedLanes = (this || _global).suspendedLanes = (this || _global).pendingLanes = 0, (this || _global).entanglements = Fr(0), (this || _global).hiddenUpdates = Fr(null), (this || _global).identifierPrefix = n, (this || _global).onRecoverableError = a, (this || _global).pooledCache = null, (this || _global).pooledCacheLanes = 0, (this || _global).mutableSourceEagerHydrationData = null, (this || _global).incompleteTransitions = new Map();
  }
  function Ff(e, r, t, n, a, i, o, s, l) {
    return e = new Hf(e, r, t, s, l), 1 === r ? (r = 1, !0 === i && (r |= 24)) : r = 0, i = Df(3, null, null, r), e.current = i, i.stateNode = e, (r = ic()).refCount++, e.pooledCache = r, r.refCount++, i.memoizedState = {
      element: n,
      isDehydrated: t,
      cache: r
    }, ho(i), e;
  }
  function Lf(e, r, t) {
    var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
      $$typeof: z,
      key: null == n ? null : "" + n,
      children: e,
      containerInfo: r,
      implementation: t
    };
  }
  function Pf(e) {
    if (!e) return mi;
    e: {
      if (cr(e = e._reactInternals) !== e || 1 !== e.tag) throw Error(o(170));
      var r = e;
      do {
        switch (r.tag) {
          case 3:
            r = r.stateNode.context;
            break e;
          case 1:
            if (Si(r.type)) {
              r = r.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        r = r.return;
      } while (null !== r);
      throw Error(o(171));
    }
    if (1 === e.tag) {
      var t = e.type;
      if (Si(t)) return yi(e, t, r);
    }
    return r;
  }
  function zf(e, r, t, n, a, i, o, s, l) {
    return (e = Ff(t, n, !0, e, 0, i, 0, s, l)).context = Pf(null), t = e.current, (i = _o(n = Uu(), a = Wu(t))).callback = null != r ? r : null, po(t, i, a), e.current.lanes = a, Lr(e, a, n), Xu(e, n), e;
  }
  function Bf(e, r, t, n) {
    var a = r.current,
      i = Uu(),
      o = Wu(a);
    return t = Pf(t), null === r.context ? r.context = t : r.pendingContext = t, (r = _o(i, o)).payload = {
      element: e
    }, null !== (n = void 0 === n ? null : n) && (r.callback = n), null !== (e = po(a, r, o)) && ($u(e, a, o, i), go(e, a, o)), o;
  }
  function jf(e) {
    if (!(e = e.current).child) return null;
    switch (e.child.tag) {
      case 27:
      case 5:
      default:
        return e.child.stateNode;
    }
  }
  function Vf(e, r) {
    if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
      var t = e.retryLane;
      e.retryLane = 0 !== t && t < r ? t : r;
    }
  }
  function Uf(e, r) {
    Vf(e, r), (e = e.alternate) && Vf(e, r);
  }
  iu = function (e, r, t) {
    if (null !== e) {
      if (e.memoizedProps !== r.pendingProps || pi.current) bl = !0;else {
        if (0 == (e.lanes & t) && 0 == (128 & r.flags)) return bl = !1, function (e, r, t) {
          switch (r.tag) {
            case 3:
              Tl(r), Yl(r, ac, e.memoizedState.cache), to();
              break;
            case 26:
            case 27:
            case 5:
              xa(r);
              break;
            case 1:
              Si(r.type) && ki(r);
              break;
            case 4:
              Aa(r, r.stateNode.containerInfo);
              break;
            case 10:
              Yl(r, r.type._context, r.memoizedProps.value);
              break;
            case 13:
              var n = r.memoizedState;
              if (null !== n) return null !== n.dehydrated ? (Fo(r), r.flags |= 128, null) : 0 != (t & r.child.childLanes) ? Hl(e, r, t) : (Fo(r), null !== (e = Ul(e, r, t)) ? e.sibling : null);
              Fo(r);
              break;
            case 19:
              if (n = 0 != (t & r.childLanes), 0 != (128 & e.flags)) {
                if (n) return jl(e, r, t);
                r.flags |= 128;
              }
              var a = r.memoizedState;
              if (null !== a && (a.rendering = null, a.tail = null, a.lastEffect = null), ya(Bo, Bo.current), n) break;
              return null;
            case 22:
            case 23:
              return r.lanes = 0, kl(e, r, t);
            case 24:
              Yl(r, ac, e.memoizedState.cache);
          }
          return Ul(e, r, t);
        }(e, r, t);
        bl = 0 != (131072 & e.flags);
      }
    } else bl = !1, Xi && 0 != (1048576 & r.flags) && ji(r, Ii, r.index);
    switch (r.lanes = 0, r.tag) {
      case 2:
        var n = r.type;
        Vl(e, r), e = r.pendingProps;
        var a = bi(r, _i.current);
        Jl(r, t), a = cs(null, r, n, e, a, t);
        var i = ds();
        return r.flags |= 1, "object" == typeof a && null !== a && "function" == typeof a.render && void 0 === a.$$typeof ? (r.tag = 1, r.memoizedState = null, r.updateQueue = null, Si(n) ? (i = !0, ki(r)) : i = !1, r.memoizedState = null !== a.state && void 0 !== a.state ? a.state : null, ho(r), a.updater = ol, r.stateNode = a, a._reactInternals = r, ul(r, n, e, t), r = Ol(null, r, n, !0, i, t)) : (r.tag = 0, Xi && i && Vi(r), Sl(null, r, a, t), r = r.child), r;
      case 16:
        n = r.elementType;
        e: {
          switch (Vl(e, r), e = r.pendingProps, n = (a = n._init)(n._payload), r.type = n, a = r.tag = function (e) {
            if ("function" == typeof e) return Af(e) ? 1 : 0;
            if (null != e) {
              if ((e = e.$$typeof) === X) return 11;
              if (e === Y) return 14;
            }
            return 2;
          }(n), e = al(n, e), a) {
            case 0:
              r = Al(null, r, n, e, t);
              break e;
            case 1:
              r = xl(null, r, n, e, t);
              break e;
            case 11:
              r = El(null, r, n, e, t);
              break e;
            case 14:
              r = wl(null, r, n, al(n.type, e), t);
              break e;
          }
          throw Error(o(306, n, ""));
        }
        return r;
      case 0:
        return n = r.type, a = r.pendingProps, Al(e, r, n, a = r.elementType === n ? a : al(n, a), t);
      case 1:
        return n = r.type, a = r.pendingProps, xl(e, r, n, a = r.elementType === n ? a : al(n, a), t);
      case 3:
        e: {
          if (Tl(r), null === e) throw Error(o(387));
          a = r.pendingProps, n = (i = r.memoizedState).element, mo(e, r), So(r, a, null, t);
          var s = r.memoizedState;
          if (a = s.cache, Yl(0, ac, a), a !== i.cache && Zl(r, ac, t), a = s.element, i.isDehydrated) {
            if (i = {
              element: a,
              isDehydrated: !1,
              cache: s.cache
            }, r.updateQueue.baseState = i, r.memoizedState = i, 256 & r.flags) {
              r = Nl(e, r, a, t, n = fl(Error(o(423)), r));
              break e;
            }
            if (a !== n) {
              r = Nl(e, r, a, t, n = fl(Error(o(424)), r));
              break e;
            }
            for ($i = di(r.stateNode.containerInfo.firstChild), Wi = r, Xi = !0, Gi = null, t = Mo(r, null, a, t), r.child = t; t;) t.flags = -3 & t.flags | 4096, t = t.sibling;
          } else {
            if (to(), a === n) {
              r = Ul(e, r, t);
              break e;
            }
            Sl(e, r, a, t);
          }
          r = r.child;
        }
        return r;
      case 26:
        return xa(r), Dl(e, r), r.memoizedState = function (e, r) {
          var t = La();
          if (!t) throw Error(o(446));
          switch (e) {
            case "base":
              var n = E(t = ja(t)).head,
                a = r.target,
                i = r.href;
              return i = "base" + ("string" == typeof i ? "[href=\"" + ei(i) + "\"]" : ":not([href])"), i += "string" == typeof a ? "[target=\"" + ei(a) + "\"]" : ":not([target])", (a = n.get(i)) || (a = {
                type: "base",
                matcher: i,
                props: oe({}, r),
                count: 0,
                instance: null,
                root: t
              }, n.set(i, a)), a;
            case "meta":
              var s = r.charSet,
                l = r.content,
                c = r.httpEquiv,
                u = r.name,
                f = r.itemProp,
                d = r.property,
                v = E(t = ja(t));
              return e = v.head, v = v.lastStructuredMeta, "string" == typeof s ? n = "meta[charset]" : "string" == typeof l && ("string" == typeof c ? n = "meta[http-equiv=\"" + ei(c) + "\"][content=\"" + ei(l) + "\"]" : "string" == typeof d ? (a = d, n = "meta[property=\"" + ei(d) + "\"][content=\"" + ei(l) + "\"]", i = d.split(":").slice(0, -1).join(":"), (i = v.get(i)) && (n = i.matcher + n)) : "string" == typeof u ? n = "meta[name=\"" + ei(u) + "\"][content=\"" + ei(l) + "\"]" : "string" == typeof f && (n = "meta[itemprop=\"" + ei(f) + "\"][content=\"" + ei(l) + "\"]")), n ? ((s = e.get(n)) || (s = {
                type: "meta",
                matcher: n,
                property: a,
                parentResource: i,
                props: oe({}, r),
                count: 0,
                instance: null,
                root: t
              }, e.set(n, s)), "string" == typeof s.property && v.set(s.property, s), s) : null;
            case "title":
              return n = r.children, "function" != typeof (n = Array.isArray(n) ? 1 === n.length ? n[0] : null : n) && "symbol" != typeof n && null != n ? (i = "title:" + (n = "" + n), (e = (a = E(t = ja(t)).head).get(i)) || ((r = oe({}, r)).children = n, e = {
                type: "title",
                props: r,
                count: 0,
                instance: null,
                root: t
              }, a.set(i, e)), e) : null;
            case "link":
              switch (n = r.rel) {
                case "stylesheet":
                  return a = E(t).styles, i = r.precedence, "string" == typeof (e = r.href) && "string" == typeof i ? ((n = a.get(e)) || ((n = oe({}, r))["data-precedence"] = r.precedence, n.precedence = null, !1 === (r = n = $a(a, t, e, i, n)).loaded && null === r.hint && (t = r.href, a = {
                    rel: "preload",
                    as: "style",
                    href: (a = r.props).href,
                    crossOrigin: a.crossOrigin,
                    integrity: a.integrity,
                    media: a.media,
                    hrefLang: a.hrefLang,
                    referrerPolicy: a.referrerPolicy
                  }, r.hint = Ga(ja(r.root), t, a))), n) : null;
                case "preload":
                  return "string" == typeof (n = r.href) ? ((a = Ha.get(n)) || (r = oe({}, r), a = Ga(ja(t), n, r)), a) : null;
                default:
                  return a = r.href, i = r.sizes, e = r.media, "string" == typeof n && "string" == typeof a ? (n = "rel:" + n + "::href:" + a + "::sizes:" + ("string" == typeof i ? i : "") + "::media:" + ("string" == typeof e ? e : ""), (i = (a = E(t = ja(t)).head).get(n)) || (i = {
                    type: "link",
                    props: oe({}, r),
                    count: 0,
                    instance: null,
                    root: t
                  }, a.set(n, i)), i) : null;
              }
            case "script":
              return n = E(t).scripts, a = r.src, r.async && "string" == typeof a ? ((i = n.get(a)) || (i = Xa(n, t, a, r = oe({}, r))), i) : null;
            default:
              throw Error(o(444, e));
          }
        }(r.type, r.pendingProps), null;
      case 27:
        return xa(r), null === e && Xi && (n = r.stateNode = hi(r.type, r.pendingProps, Da.current), Wi = r, $i = di(n.firstChild)), n = r.pendingProps.children, null !== e || Xi ? Sl(e, r, n, t) : r.child = Ao(r, null, n, t), Dl(e, r), r.child;
      case 5:
        return xa(r), null === e && Qi(r), n = r.type, a = r.pendingProps, i = null !== e ? e.memoizedProps : null, s = a.children, ni(n, a) ? s = null : null !== i && ni(n, i) && (r.flags |= 32), Dl(e, r), Sl(e, r, s, t), r.child;
      case 6:
        return null === e && Qi(r), null;
      case 13:
        return Hl(e, r, t);
      case 4:
        return Aa(r, r.stateNode.containerInfo), n = r.pendingProps, null === e ? r.child = Ao(r, null, n, t) : Sl(e, r, n, t), r.child;
      case 11:
        return n = r.type, a = r.pendingProps, El(e, r, n, a = r.elementType === n ? a : al(n, a), t);
      case 7:
        return Sl(e, r, r.pendingProps, t), r.child;
      case 8:
      case 12:
        return Sl(e, r, r.pendingProps.children, t), r.child;
      case 10:
        e: {
          if (n = r.type._context, a = r.pendingProps, i = r.memoizedProps, Yl(0, n, s = a.value), null !== i) if (Cn(i.value, s)) {
            if (i.children === a.children && !pi.current) {
              r = Ul(e, r, t);
              break e;
            }
          } else Zl(r, n, t);
          Sl(e, r, a.children, t), r = r.child;
        }
        return r;
      case 9:
        return a = r.type, n = r.pendingProps.children, Jl(r, t), n = n(a = ec(a)), r.flags |= 1, Sl(e, r, n, t), r.child;
      case 14:
        return a = al(n = r.type, r.pendingProps), wl(e, r, n, a = al(n.type, a), t);
      case 15:
        return yl(e, r, r.type, r.pendingProps, t);
      case 17:
        return n = r.type, a = r.pendingProps, a = r.elementType === n ? a : al(n, a), Vl(e, r), r.tag = 1, Si(n) ? (e = !0, ki(r)) : e = !1, Jl(r, t), ll(r, n, a), ul(r, n, a, t), Ol(null, r, n, !0, e, t);
      case 19:
        return jl(e, r, t);
      case 22:
        return kl(e, r, t);
      case 24:
        return Jl(r, t), n = ec(ac), null === e ? (null === (a = dc()) && (a = hu, i = ic(), a.pooledCache = i, i.refCount++, null !== i && (a.pooledCacheLanes |= t), a = i), r.memoizedState = {
          parent: n,
          cache: a
        }, ho(r), Yl(0, ac, a)) : (0 != (e.lanes & t) && (mo(e, r), So(r, null, null, t)), a = e.memoizedState, i = r.memoizedState, a.parent !== n ? (a = {
          parent: n,
          cache: n
        }, r.memoizedState = a, 0 === r.lanes && (r.memoizedState = r.updateQueue.baseState = a), Yl(0, ac, n)) : (n = i.cache, Yl(0, ac, n), n !== a.cache && Zl(r, ac, t))), Sl(e, r, r.pendingProps.children, t), r.child;
    }
    throw Error(o(156, r.tag));
  };
  var Wf = i.Dispatcher,
    $f = "function" == typeof reportError ? reportError : function (e) {
      console.error(e);
    };
  function Xf(e) {
    (this || _global)._internalRoot = e;
  }
  function Gf(e) {
    (this || _global)._internalRoot = e;
  }
  function Kf(e) {
    return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType);
  }
  function Yf(e) {
    return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType && (8 !== e.nodeType || " react-mount-point-unstable " !== e.nodeValue));
  }
  function qf() {}
  function Qf(e, r, t, n, a) {
    var i = t._reactRootContainer;
    if (i) {
      var o = i;
      if ("function" == typeof a) {
        var s = a;
        a = function () {
          var e = jf(o);
          s.call(e);
        };
      }
      Bf(r, o, e, a);
    } else o = function (e, r, t, n, a) {
      if (a) {
        if ("function" == typeof n) {
          var i = n;
          n = function () {
            var e = jf(o);
            i.call(e);
          };
        }
        var o = zf(r, n, e, 0, null, !1, 0, "", qf);
        return e._reactRootContainer = o, e[u] = o.current, ia(8 === e.nodeType ? e.parentNode : e), Ju(), o;
      }
      if (ui(e), "function" == typeof n) {
        var s = n;
        n = function () {
          var e = jf(l);
          s.call(e);
        };
      }
      var l = Ff(e, 0, !1, null, 0, !1, 0, "", qf);
      return e._reactRootContainer = l, e[u] = l.current, ia(8 === e.nodeType ? e.parentNode : e), Ju(function () {
        Bf(r, l, t, n);
      }), l;
    }(t, r, e, a, n);
    return jf(o);
  }
  Gf.prototype.render = Xf.prototype.render = function (e) {
    var r = (this || _global)._internalRoot;
    if (null === r) throw Error(o(409));
    Bf(e, r, null, null);
  }, Gf.prototype.unmount = Xf.prototype.unmount = function () {
    var e = (this || _global)._internalRoot;
    if (null !== e) {
      (this || _global)._internalRoot = null;
      var r = e.containerInfo;
      Ju(function () {
        Bf(null, e, null, null);
      }), r[u] = null;
    }
  }, Gf.prototype.unstable_scheduleHydration = function (e) {
    if (e) {
      var r = $r();
      e = {
        blockedOn: null,
        target: e,
        priority: r
      };
      for (var t = 0; t < et.length && 0 !== r && r < et[t].priority; t++);
      et.splice(t, 0, e), 0 === t && at(e);
    }
  }, Vr = function (e) {
    switch (e.tag) {
      case 3:
        var r = e.stateNode;
        if (r.current.memoizedState.isDehydrated) {
          var t = Tr(r.pendingLanes);
          0 !== t && (Pr(r, 2 | t), Xu(r, pr()), 0 == (6 & vu) && (xu = pr() + 500, Oi()));
        }
        break;
      case 13:
        Ju(function () {
          var r = co(e, 2);
          if (null !== r) {
            var t = Uu();
            $u(r, e, 2, t);
          }
        }), Uf(e, 2);
    }
  }, Ur = function (e) {
    if (13 === e.tag) {
      var r = co(e, 134217728);
      if (null !== r) $u(r, e, 134217728, Uu());
      Uf(e, 134217728);
    }
  }, Wr = function (e) {
    if (13 === e.tag) {
      var r = Wu(e),
        t = co(e, r);
      if (null !== t) $u(t, e, r, Uu());
      Uf(e, r);
    }
  }, $r = function () {
    return zr;
  }, Xr = Br, Ue = function (e, r, t) {
    switch (r) {
      case "input":
        if (Se(e, t), r = t.name, "radio" === t.type && null != r) {
          for (t = e; t.parentNode;) t = t.parentNode;
          for (t = t.querySelectorAll("input[name=" + JSON.stringify("" + r) + "][type=\"radio\"]"), r = 0; r < t.length; r++) {
            var n = t[r];
            if (n !== e && n.form === e.form) {
              var a = S(n);
              if (!a) throw Error(o(90));
              me(n), Se(n, a);
            }
          }
        }
        break;
      case "textarea":
        Ae(e, t);
        break;
      case "select":
        null != (r = t.value) && ke(e, !!t.multiple, r, !1);
    }
  }, Ye = Zu, qe = Ju, i.Events = [g, b, S, Ge, Ke, Zu];
  var Zf = {
      findFiberByHostInstance: p,
      bundleType: 0,
      version: "18.3.0-experimental-53b1f69ba-20230209",
      rendererPackageName: "react-dom"
    },
    Jf = {
      bundleType: Zf.bundleType,
      version: Zf.version,
      rendererPackageName: Zf.rendererPackageName,
      rendererConfig: Zf.rendererConfig,
      overrideHookState: null,
      overrideHookStateDeletePath: null,
      overrideHookStateRenamePath: null,
      overrideProps: null,
      overridePropsDeletePath: null,
      overridePropsRenamePath: null,
      setErrorHandler: null,
      setSuspenseHandler: null,
      scheduleUpdate: null,
      currentDispatcherRef: L.ReactCurrentDispatcher,
      findHostInstanceByFiber: function (e) {
        return null === (e = dr(e)) ? null : e.stateNode;
      },
      findFiberByHostInstance: Zf.findFiberByHostInstance || function () {
        return null;
      },
      findHostInstancesForRefresh: null,
      scheduleRefresh: null,
      scheduleRoot: null,
      setRefreshHandler: null,
      getCurrentFiber: null,
      reconcilerVersion: "18.3.0-next-53b1f69ba-20230209"
    };
  if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var ed = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!ed.isDisabled && ed.supportsFiber) try {
      kr = ed.inject(Jf), Cr = ed;
    } catch (e) {}
  }
  r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = i, r.createPortal = function (e, r) {
    var t = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!Kf(r)) throw Error(o(200));
    return Lf(e, r, null, t);
  }, r.createRoot = function (e, r) {
    if (!Kf(e)) throw Error(o(299));
    var t = !1,
      n = "",
      a = $f;
    return null != r && (!0 === r.unstable_strictMode && (t = !0), void 0 !== r.identifierPrefix && (n = r.identifierPrefix), void 0 !== r.onRecoverableError && (a = r.onRecoverableError)), r = Ff(e, 1, !1, null, 0, t, 0, n, a), e[u] = r.current, Wf.current = Ia, ia(8 === e.nodeType ? e.parentNode : e), new Xf(r);
  }, r.findDOMNode = function (e) {
    if (null == e) return null;
    if (1 === e.nodeType) return e;
    var r = e._reactInternals;
    if (void 0 === r) {
      if ("function" == typeof e.render) throw Error(o(188));
      throw e = Object.keys(e).join(","), Error(o(268, e));
    }
    return e = null === (e = dr(r)) ? null : e.stateNode;
  }, r.flushSync = function (e) {
    return Ju(e);
  }, r.hydrate = function (e, r, t) {
    if (!Yf(r)) throw Error(o(200));
    return Qf(null, e, r, !0, t);
  }, r.hydrateRoot = function (e, r, t) {
    if (!Kf(e)) throw Error(o(405));
    var n = null != t && t.hydratedSources || null,
      a = !1,
      i = "",
      s = $f;
    if (null != t && (!0 === t.unstable_strictMode && (a = !0), void 0 !== t.identifierPrefix && (i = t.identifierPrefix), void 0 !== t.onRecoverableError && (s = t.onRecoverableError)), r = zf(r, null, e, 1, null != t ? t : null, a, 0, i, s), e[u] = r.current, Wf.current = Ia, ia(e), n) for (e = 0; e < n.length; e++) a = (a = (t = n[e])._getVersion)(t._source), null == r.mutableSourceEagerHydrationData ? r.mutableSourceEagerHydrationData = [t, a] : r.mutableSourceEagerHydrationData.push(t, a);
    return new Gf(r);
  }, r.preinit = function () {
    var e = i.Dispatcher.current;
    e && e.preinit.apply(this || _global, arguments);
  }, r.preload = function () {
    var e = i.Dispatcher.current;
    e && e.preload.apply(this || _global, arguments);
  }, r.render = function (e, r, t) {
    if (!Yf(r)) throw Error(o(200));
    return Qf(null, e, r, !1, t);
  }, r.unmountComponentAtNode = function (e) {
    if (!Yf(e)) throw Error(o(40));
    return !!e._reactRootContainer && (Ju(function () {
      Qf(null, null, e, !1, function () {
        e._reactRootContainer = null, e[u] = null;
      });
    }), !0);
  }, r.unstable_batchedUpdates = Zu, r.unstable_renderSubtreeIntoContainer = function (e, r, t, n) {
    if (!Yf(t)) throw Error(o(200));
    if (null == e || void 0 === e._reactInternals) throw Error(o(38));
    return Qf(e, r, t, !1, n);
  }, r.unstable_runWithPriority = Br, r.version = "18.3.0-next-53b1f69ba-20230209";
}, function (e, r, t) {
  "use strict";

  e.exports = t(113);
}, function (e, r, t) {
  "use strict";

  /**
   * @license React
   * scheduler.production.min.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  function n(e, r) {
    var t = e.length;
    e.push(r);
    e: for (; 0 < t;) {
      var n = t - 1 >>> 1,
        a = e[n];
      if (!(0 < o(a, r))) break e;
      e[n] = r, e[t] = a, t = n;
    }
  }
  function a(e) {
    return 0 === e.length ? null : e[0];
  }
  function i(e) {
    if (0 === e.length) return null;
    var r = e[0],
      t = e.pop();
    if (t !== r) {
      e[0] = t;
      e: for (var n = 0, a = e.length, i = a >>> 1; n < i;) {
        var s = 2 * (n + 1) - 1,
          l = e[s],
          c = s + 1,
          u = e[c];
        if (0 > o(l, t)) c < a && 0 > o(u, l) ? (e[n] = u, e[c] = t, n = c) : (e[n] = l, e[s] = t, n = s);else {
          if (!(c < a && 0 > o(u, t))) break e;
          e[n] = u, e[c] = t, n = c;
        }
      }
    }
    return r;
  }
  function o(e, r) {
    var t = e.sortIndex - r.sortIndex;
    return 0 !== t ? t : e.id - r.id;
  }
  if ("object" == typeof performance && "function" == typeof performance.now) {
    var s = performance;
    r.unstable_now = function () {
      return s.now();
    };
  } else {
    var l = Date,
      c = l.now();
    r.unstable_now = function () {
      return l.now() - c;
    };
  }
  var u = [],
    f = [],
    d = 1,
    v = null,
    h = 3,
    m = !1,
    _ = !1,
    p = !1,
    g = "function" == typeof setTimeout ? setTimeout : null,
    b = "function" == typeof clearTimeout ? clearTimeout : null,
    S = "undefined" != typeof process.nextTick ? process.nextTick : null;
  function E(e) {
    for (var r = a(f); null !== r;) {
      if (null === r.callback) i(f);else {
        if (!(r.startTime <= e)) break;
        i(f), r.sortIndex = r.expirationTime, n(u, r);
      }
      r = a(f);
    }
  }
  function w(e) {
    if (p = !1, E(e), !_) if (null !== a(u)) _ = !0, I(y);else {
      var r = a(f);
      null !== r && H(w, r.startTime - e);
    }
  }
  function y(e, t) {
    _ = !1, p && (p = !1, b(A), A = -1), m = !0;
    var n = h;
    try {
      e: {
        for (E(t), v = a(u); null !== v && (!(v.expirationTime > t) || e && !O());) {
          var o = v.callback;
          if ("function" == typeof o) {
            v.callback = null, h = v.priorityLevel;
            var s = o(v.expirationTime <= t);
            if (t = r.unstable_now(), "function" == typeof s) {
              v.callback = s, E(t);
              var l = !0;
              break e;
            }
            v === a(u) && i(u), E(t);
          } else i(u);
          v = a(u);
        }
        if (null !== v) l = !0;else {
          var c = a(f);
          null !== c && H(w, c.startTime - t), l = !1;
        }
      }
      return l;
    } finally {
      v = null, h = n, m = !1;
    }
  }
  "undefined" != typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
  var k,
    C = !1,
    D = null,
    A = -1,
    M = 5,
    x = -1;
  function O() {
    return !(r.unstable_now() - x < M);
  }
  function T() {
    if (null !== D) {
      var e = r.unstable_now();
      x = e;
      var t = !0;
      try {
        t = D(!0, e);
      } finally {
        t ? k() : (C = !1, D = null);
      }
    } else C = !1;
  }
  if ("function" == typeof S) k = function () {
    S(T);
  };else if ("undefined" != typeof MessageChannel) {
    var N = new MessageChannel(),
      R = N.port2;
    N.port1.onmessage = T, k = function () {
      R.postMessage(null);
    };
  } else k = function () {
    g(T, 0);
  };
  function I(e) {
    D = e, C || (C = !0, k());
  }
  function H(e, t) {
    A = g(function () {
      e(r.unstable_now());
    }, t);
  }
  r.unstable_IdlePriority = 5, r.unstable_ImmediatePriority = 1, r.unstable_LowPriority = 4, r.unstable_NormalPriority = 3, r.unstable_Profiling = null, r.unstable_UserBlockingPriority = 2, r.unstable_cancelCallback = function (e) {
    e.callback = null;
  }, r.unstable_continueExecution = function () {
    _ || m || (_ = !0, I(y));
  }, r.unstable_forceFrameRate = function (e) {
    0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : M = 0 < e ? Math.floor(1000 / e) : 5;
  }, r.unstable_getCurrentPriorityLevel = function () {
    return h;
  }, r.unstable_getFirstCallbackNode = function () {
    return a(u);
  }, r.unstable_next = function (e) {
    switch (h) {
      case 1:
      case 2:
      case 3:
        var r = 3;
        break;
      default:
        r = h;
    }
    var t = h;
    h = r;
    try {
      return e();
    } finally {
      h = t;
    }
  }, r.unstable_pauseExecution = function () {}, r.unstable_requestPaint = function () {}, r.unstable_runWithPriority = function (e, r) {
    switch (e) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        e = 3;
    }
    var t = h;
    h = e;
    try {
      return r();
    } finally {
      h = t;
    }
  }, r.unstable_scheduleCallback = function (e, t, i) {
    var o = r.unstable_now();
    switch ("object" == typeof i && null !== i ? i = "number" == typeof (i = i.delay) && 0 < i ? o + i : o : i = o, e) {
      case 1:
        var s = -1;
        break;
      case 2:
        s = 250;
        break;
      case 5:
        s = 1073741823;
        break;
      case 4:
        s = 10000;
        break;
      default:
        s = 5000;
    }
    return e = {
      id: d++,
      callback: t,
      priorityLevel: e,
      startTime: i,
      expirationTime: s = i + s,
      sortIndex: -1
    }, i > o ? (e.sortIndex = i, n(f, e), null === a(u) && e === a(f) && (p ? (b(A), A = -1) : p = !0, H(w, i - o))) : (e.sortIndex = s, n(u, e), _ || m || (_ = !0, I(y))), e;
  }, r.unstable_shouldYield = O, r.unstable_wrapCallback = function (e) {
    var r = h;
    return function () {
      var t = h;
      h = r;
      try {
        return e.apply(this || _global, arguments);
      } finally {
        h = t;
      }
    };
  };
}, function (e, r, t) {
  "use strict";

  function n(e) {
    var r = this || _global;
    if (r instanceof n || (r = new n()), r.tail = null, r.head = null, r.length = 0, e && "function" == typeof e.forEach) e.forEach(function (e) {
      r.push(e);
    });else if (arguments.length > 0) for (var t = 0, a = arguments.length; t < a; t++) r.push(arguments[t]);
    return r;
  }
  function a(e, r, t) {
    var n = r === e.head ? new s(t, null, r, e) : new s(t, r, r.next, e);
    return null === n.next && (e.tail = n), null === n.prev && (e.head = n), e.length++, n;
  }
  function i(e, r) {
    e.tail = new s(r, e.tail, null, e), e.head || (e.head = e.tail), e.length++;
  }
  function o(e, r) {
    e.head = new s(r, null, e.head, e), e.tail || (e.tail = e.head), e.length++;
  }
  function s(e, r, t, n) {
    if (!((this || _global) instanceof s)) return new s(e, r, t, n);
    (this || _global).list = n, (this || _global).value = e, r ? (r.next = this || _global, (this || _global).prev = r) : (this || _global).prev = null, t ? (t.prev = this || _global, (this || _global).next = t) : (this || _global).next = null;
  }
  e.exports = n, n.Node = s, n.create = n, n.prototype.removeNode = function (e) {
    if (e.list !== (this || _global)) throw new Error("removing node which does not belong to this list");
    var r = e.next,
      t = e.prev;
    return r && (r.prev = t), t && (t.next = r), e === (this || _global).head && ((this || _global).head = r), e === (this || _global).tail && ((this || _global).tail = t), e.list.length--, e.next = null, e.prev = null, e.list = null, r;
  }, n.prototype.unshiftNode = function (e) {
    if (e !== (this || _global).head) {
      e.list && e.list.removeNode(e);
      var r = (this || _global).head;
      e.list = this || _global, e.next = r, r && (r.prev = e), (this || _global).head = e, (this || _global).tail || ((this || _global).tail = e), (this || _global).length++;
    }
  }, n.prototype.pushNode = function (e) {
    if (e !== (this || _global).tail) {
      e.list && e.list.removeNode(e);
      var r = (this || _global).tail;
      e.list = this || _global, e.prev = r, r && (r.next = e), (this || _global).tail = e, (this || _global).head || ((this || _global).head = e), (this || _global).length++;
    }
  }, n.prototype.push = function () {
    for (var e = 0, r = arguments.length; e < r; e++) i(this || _global, arguments[e]);
    return (this || _global).length;
  }, n.prototype.unshift = function () {
    for (var e = 0, r = arguments.length; e < r; e++) o(this || _global, arguments[e]);
    return (this || _global).length;
  }, n.prototype.pop = function () {
    if ((this || _global).tail) {
      var e = (this || _global).tail.value;
      return (this || _global).tail = (this || _global).tail.prev, (this || _global).tail ? (this || _global).tail.next = null : (this || _global).head = null, (this || _global).length--, e;
    }
  }, n.prototype.shift = function () {
    if ((this || _global).head) {
      var e = (this || _global).head.value;
      return (this || _global).head = (this || _global).head.next, (this || _global).head ? (this || _global).head.prev = null : (this || _global).tail = null, (this || _global).length--, e;
    }
  }, n.prototype.forEach = function (e, r) {
    r = r || this || _global;
    for (var t = (this || _global).head, n = 0; null !== t; n++) e.call(r, t.value, n, this || _global), t = t.next;
  }, n.prototype.forEachReverse = function (e, r) {
    r = r || this || _global;
    for (var t = (this || _global).tail, n = (this || _global).length - 1; null !== t; n--) e.call(r, t.value, n, this || _global), t = t.prev;
  }, n.prototype.get = function (e) {
    for (var r = 0, t = (this || _global).head; null !== t && r < e; r++) t = t.next;
    if (r === e && null !== t) return t.value;
  }, n.prototype.getReverse = function (e) {
    for (var r = 0, t = (this || _global).tail; null !== t && r < e; r++) t = t.prev;
    if (r === e && null !== t) return t.value;
  }, n.prototype.map = function (e, r) {
    r = r || this || _global;
    for (var t = new n(), a = (this || _global).head; null !== a;) t.push(e.call(r, a.value, this || _global)), a = a.next;
    return t;
  }, n.prototype.mapReverse = function (e, r) {
    r = r || this || _global;
    for (var t = new n(), a = (this || _global).tail; null !== a;) t.push(e.call(r, a.value, this || _global)), a = a.prev;
    return t;
  }, n.prototype.reduce = function (e, r) {
    var t,
      n = (this || _global).head;
    if (arguments.length > 1) t = r;else {
      if (!(this || _global).head) throw new TypeError("Reduce of empty list with no initial value");
      n = (this || _global).head.next, t = (this || _global).head.value;
    }
    for (var a = 0; null !== n; a++) t = e(t, n.value, a), n = n.next;
    return t;
  }, n.prototype.reduceReverse = function (e, r) {
    var t,
      n = (this || _global).tail;
    if (arguments.length > 1) t = r;else {
      if (!(this || _global).tail) throw new TypeError("Reduce of empty list with no initial value");
      n = (this || _global).tail.prev, t = (this || _global).tail.value;
    }
    for (var a = (this || _global).length - 1; null !== n; a--) t = e(t, n.value, a), n = n.prev;
    return t;
  }, n.prototype.toArray = function () {
    for (var e = new Array((this || _global).length), r = 0, t = (this || _global).head; null !== t; r++) e[r] = t.value, t = t.next;
    return e;
  }, n.prototype.toArrayReverse = function () {
    for (var e = new Array((this || _global).length), r = 0, t = (this || _global).tail; null !== t; r++) e[r] = t.value, t = t.prev;
    return e;
  }, n.prototype.slice = function (e, r) {
    (r = r || (this || _global).length) < 0 && (r += (this || _global).length), (e = e || 0) < 0 && (e += (this || _global).length);
    var t = new n();
    if (r < e || r < 0) return t;
    e < 0 && (e = 0), r > (this || _global).length && (r = (this || _global).length);
    for (var a = 0, i = (this || _global).head; null !== i && a < e; a++) i = i.next;
    for (; null !== i && a < r; a++, i = i.next) t.push(i.value);
    return t;
  }, n.prototype.sliceReverse = function (e, r) {
    (r = r || (this || _global).length) < 0 && (r += (this || _global).length), (e = e || 0) < 0 && (e += (this || _global).length);
    var t = new n();
    if (r < e || r < 0) return t;
    e < 0 && (e = 0), r > (this || _global).length && (r = (this || _global).length);
    for (var a = (this || _global).length, i = (this || _global).tail; null !== i && a > r; a--) i = i.prev;
    for (; null !== i && a > e; a--, i = i.prev) t.push(i.value);
    return t;
  }, n.prototype.splice = function (e, r) {
    e > (this || _global).length && (e = (this || _global).length - 1), e < 0 && (e = (this || _global).length + e);
    for (var t = 0, n = (this || _global).head; null !== n && t < e; t++) n = n.next;
    var i = [];
    for (t = 0; n && t < r; t++) i.push(n.value), n = this.removeNode(n);
    null === n && (n = (this || _global).tail), n !== (this || _global).head && n !== (this || _global).tail && (n = n.prev);
    for (t = 2; t < arguments.length; t++) n = a(this || _global, n, arguments[t]);
    return i;
  }, n.prototype.reverse = function () {
    for (var e = (this || _global).head, r = (this || _global).tail, t = e; null !== t; t = t.prev) {
      var n = t.prev;
      t.prev = t.next, t.next = n;
    }
    return (this || _global).head = r, (this || _global).tail = e, this || _global;
  };
  try {
    t(115)(n);
  } catch (e) {}
}, function (e, r, t) {
  "use strict";

  e.exports = function (e) {
    e.prototype[Symbol.iterator] = function* () {
      for (let e = (this || _global).head; e; e = e.next) yield e.value;
    };
  };
}, function (e, r, t) {
  "use strict";

  /**
   * @license React
   * react-is.production.min.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var n = Symbol.for("react.element"),
    a = Symbol.for("react.portal"),
    i = Symbol.for("react.fragment"),
    o = Symbol.for("react.strict_mode"),
    s = Symbol.for("react.profiler"),
    l = Symbol.for("react.provider"),
    c = Symbol.for("react.context"),
    u = Symbol.for("react.server_context"),
    f = Symbol.for("react.forward_ref"),
    d = Symbol.for("react.suspense"),
    v = Symbol.for("react.suspense_list"),
    h = Symbol.for("react.memo"),
    m = Symbol.for("react.lazy"),
    _ = Symbol.for("react.offscreen"),
    p = Symbol.for("react.cache"),
    g = Symbol.for("react.client.reference");
  function b(e) {
    if ("object" == typeof e && null !== e) {
      var r = e.$$typeof;
      switch (r) {
        case n:
          switch (e = e.type) {
            case i:
            case s:
            case o:
            case d:
            case v:
              return e;
            default:
              switch (e = e && e.$$typeof) {
                case u:
                case c:
                case f:
                case m:
                case h:
                case l:
                  return e;
                default:
                  return r;
              }
          }
        case a:
          return r;
      }
    }
  }
  r.ContextConsumer = c, r.ContextProvider = l, r.Element = n, r.ForwardRef = f, r.Fragment = i, r.Lazy = m, r.Memo = h, r.Portal = a, r.Profiler = s, r.StrictMode = o, r.Suspense = d, r.SuspenseList = v, r.isAsyncMode = function () {
    return !1;
  }, r.isConcurrentMode = function () {
    return !1;
  }, r.isContextConsumer = function (e) {
    return b(e) === c;
  }, r.isContextProvider = function (e) {
    return b(e) === l;
  }, r.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === n;
  }, r.isForwardRef = function (e) {
    return b(e) === f;
  }, r.isFragment = function (e) {
    return b(e) === i;
  }, r.isLazy = function (e) {
    return b(e) === m;
  }, r.isMemo = function (e) {
    return b(e) === h;
  }, r.isPortal = function (e) {
    return b(e) === a;
  }, r.isProfiler = function (e) {
    return b(e) === s;
  }, r.isStrictMode = function (e) {
    return b(e) === o;
  }, r.isSuspense = function (e) {
    return b(e) === d;
  }, r.isSuspenseList = function (e) {
    return b(e) === v;
  }, r.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === i || e === s || e === o || e === d || e === v || e === _ || e === p || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === h || e.$$typeof === l || e.$$typeof === c || e.$$typeof === f || e.$$typeof === g || void 0 !== e.getModuleId);
  }, r.typeOf = b;
}, function (e, r) {
  e.exports = _net;
}, function (e, r) {
  e.exports = _tls;
}, function (e, r) {
  e.exports = _url;
}, function (e, r) {
  e.exports = _zlib;
}, function (e, r, t) {
  "use strict";

  const n = Symbol("kDone"),
    a = Symbol("kRun");
  e.exports = class {
    constructor(e) {
      this[n] = () => {
        this.pending--, this[a]();
      }, this.concurrency = e || 1 / 0, this.jobs = [], this.pending = 0;
    }
    add(e) {
      this.jobs.push(e), this[a]();
    }
    [a]() {
      if (this.pending !== this.concurrency && this.jobs.length) {
        const e = this.jobs.shift();
        this.pending++, e(this[n]);
      }
    }
  };
}, function (e, r, t) {
  "use strict";

  class n {
    constructor(e, r) {
      this.target = r, this.type = e;
    }
  }
  class a extends n {
    constructor(e, r) {
      super("message", r), this.data = e;
    }
  }
  class i extends n {
    constructor(e, r, t) {
      super("close", t), this.wasClean = t._closeFrameReceived && t._closeFrameSent, this.reason = r, this.code = e;
    }
  }
  class o extends n {
    constructor(e) {
      super("open", e);
    }
  }
  class s extends n {
    constructor(e, r) {
      super("error", r), this.message = e.message, this.error = e;
    }
  }
  const l = {
    addEventListener(e, r) {
      function t(e) {
        r.call(this || _global, new a(e, this || _global));
      }
      function n(e, t) {
        r.call(this || _global, new i(e, t, this || _global));
      }
      function l(e) {
        r.call(this || _global, new s(e, this || _global));
      }
      function c() {
        r.call(this || _global, new o(this || _global));
      }
      "function" == typeof r && ("message" === e ? (t._listener = r, this.on(e, t)) : "close" === e ? (n._listener = r, this.on(e, n)) : "error" === e ? (l._listener = r, this.on(e, l)) : "open" === e ? (c._listener = r, this.on(e, c)) : this.on(e, r));
    },
    removeEventListener(e, r) {
      const t = this.listeners(e);
      for (let n = 0; n < t.length; n++) t[n] !== r && t[n]._listener !== r || this.removeListener(e, t[n]);
    }
  };
  e.exports = l;
}, function (e, r, t) {
  "use strict";

  const {
    Duplex: n
  } = t(79);
  function a(e) {
    e.emit("close");
  }
  function i() {
    !(this || _global).destroyed && (this || _global)._writableState.finished && this.destroy();
  }
  function o(e) {
    this.removeListener("error", o), this.destroy(), 0 === this.listenerCount("error") && this.emit("error", e);
  }
  e.exports = function (e, r) {
    let t = !0;
    function s() {
      t && e._socket.resume();
    }
    e.readyState === e.CONNECTING ? e.once("open", function () {
      e._receiver.removeAllListeners("drain"), e._receiver.on("drain", s);
    }) : (e._receiver.removeAllListeners("drain"), e._receiver.on("drain", s));
    const l = new n({
      ...r,
      autoDestroy: !1,
      emitClose: !1,
      objectMode: !1,
      writableObjectMode: !1
    });
    return e.on("message", function (r) {
      l.push(r) || (t = !1, e._socket.pause());
    }), e.once("error", function (e) {
      l.destroy(e);
    }), e.once("close", function () {
      l.destroyed || l.push(null);
    }), l._destroy = function (r, t) {
      if (e.readyState === e.CLOSED) return t(r), void process.nextTick(a, l);
      e.once("close", function () {
        t(r), process.nextTick(a, l);
      }), e.terminate();
    }, l._final = function (r) {
      e.readyState !== e.CONNECTING ? e._socket._writableState.finished ? (l._readableState.endEmitted && l.destroy(), r()) : (e._socket.once("finish", function () {
        r();
      }), e.close()) : e.once("open", function () {
        l._final(r);
      });
    }, l._read = function () {
      e.readyState !== e.OPEN || t || (t = !0, e._receiver._writableState.needDrain || e._socket.resume());
    }, l._write = function (r, t, n) {
      e.readyState !== e.CONNECTING ? e.send(r, n) : e.once("open", function () {
        l._write(r, t, n);
      });
    }, l.on("end", i), l.on("error", o), l;
  };
}, function (e, r, t) {
  "use strict";

  const n = t(76),
    {
      createHash: a
    } = t(65),
    {
      createServer: i,
      STATUS_CODES: o
    } = t(64),
    s = t(50),
    l = t(75),
    {
      format: c,
      parse: u
    } = t(82),
    {
      GUID: f
    } = t(38),
    d = /^[+/0-9A-Za-z]{22}==$/,
    v = Symbol("kUsedByWebSocketServer");
  function h(e) {
    e.emit("close");
  }
  function m() {
    this.destroy();
  }
  function _(e, r, t, n) {
    e.writable && (t = t || o[r], n = {
      Connection: "close",
      "Content-type": "text/html",
      "Content-Length": Buffer.byteLength(t),
      ...n
    }, e.write(`HTTP/1.1 ${r} ${o[r]}\r\n` + Object.keys(n).map(e => `${e}: ${n[e]}`).join("\r\n") + "\r\n\r\n" + t)), e.removeListener("error", m), e.destroy();
  }
  e.exports = class extends n {
    constructor(e, r) {
      if (super(), null == (e = {
        maxPayload: 104857600,
        perMessageDeflate: !1,
        handleProtocols: null,
        clientTracking: !0,
        verifyClient: null,
        noServer: !1,
        backlog: null,
        server: null,
        host: null,
        path: null,
        port: null,
        ...e
      }).port && !e.server && !e.noServer) throw new TypeError("One of the \"port\", \"server\", or \"noServer\" options must be specified");
      if (null != e.port) this._server = i((e, r) => {
        const t = o[426];
        r.writeHead(426, {
          "Content-Length": t.length,
          "Content-Type": "text/plain"
        }), r.end(t);
      }), this._server.listen(e.port, e.host, e.backlog, r);else if (e.server) {
        if (e.server[v]) throw new Error("The HTTP/S server is already being used by another WebSocket server");
        e.server[v] = !0, this._server = e.server;
      }
      this._server && (this._removeListeners = function (e, r) {
        for (const t of Object.keys(r)) e.on(t, r[t]);
        return function () {
          for (const t of Object.keys(r)) e.removeListener(t, r[t]);
        };
      }(this._server, {
        listening: this.emit.bind(this, "listening"),
        error: this.emit.bind(this, "error"),
        upgrade: (e, r, t) => {
          this.handleUpgrade(e, r, t, r => {
            this.emit("connection", r, e);
          });
        }
      })), !0 === e.perMessageDeflate && (e.perMessageDeflate = {}), e.clientTracking && (this.clients = new Set()), this.options = e;
    }
    address() {
      if (this.options.noServer) throw new Error("The server is operating in \"noServer\" mode");
      return this._server ? this._server.address() : null;
    }
    close(e) {
      if (e && this.once("close", e), this.clients) for (const e of this.clients) e.terminate();
      const r = this._server;
      if (r) {
        if (this._removeListeners(), this._removeListeners = this._server = null, null != this.options.port) return void r.close(() => this.emit("close"));
        delete r[v];
      }
      process.nextTick(h, this);
    }
    shouldHandle(e) {
      if (this.options.path) {
        const r = e.url.indexOf("?");
        if ((-1 !== r ? e.url.slice(0, r) : e.url) !== this.options.path) return !1;
      }
      return !0;
    }
    handleUpgrade(e, r, t, n) {
      r.on("error", m);
      const a = void 0 !== e.headers["sec-websocket-key"] && e.headers["sec-websocket-key"].trim(),
        i = +e.headers["sec-websocket-version"],
        o = {};
      if ("GET" !== e.method || "websocket" !== e.headers.upgrade.toLowerCase() || !a || !d.test(a) || 8 !== i && 13 !== i || !this.shouldHandle(e)) return _(r, 400);
      if (this.options.perMessageDeflate) {
        const t = new s(this.options.perMessageDeflate, !0, this.options.maxPayload);
        try {
          const r = u(e.headers["sec-websocket-extensions"]);
          r[s.extensionName] && (t.accept(r[s.extensionName]), o[s.extensionName] = t);
        } catch (e) {
          return _(r, 400);
        }
      }
      if (this.options.verifyClient) {
        const s = {
          origin: e.headers["" + (8 === i ? "sec-websocket-origin" : "origin")],
          secure: !(!e.connection.authorized && !e.connection.encrypted),
          req: e
        };
        if (2 === this.options.verifyClient.length) return void this.options.verifyClient(s, (i, s, l, c) => {
          if (!i) return _(r, s || 401, l, c);
          this.completeUpgrade(a, o, e, r, t, n);
        });
        if (!this.options.verifyClient(s)) return _(r, 401);
      }
      this.completeUpgrade(a, o, e, r, t, n);
    }
    completeUpgrade(e, r, t, n, i, o) {
      if (!n.readable || !n.writable) return n.destroy();
      const u = ["HTTP/1.1 101 Switching Protocols", "Upgrade: websocket", "Connection: Upgrade", "Sec-WebSocket-Accept: " + a("sha1").update(e + f).digest("base64")],
        d = new l(null);
      let v = t.headers["sec-websocket-protocol"];
      if (v && (v = v.trim().split(/ *, */), v = this.options.handleProtocols ? this.options.handleProtocols(v, t) : v[0], v && (u.push("Sec-WebSocket-Protocol: " + v), d.protocol = v)), r[s.extensionName]) {
        const e = r[s.extensionName].params,
          t = c({
            [s.extensionName]: [e]
          });
        u.push("Sec-WebSocket-Extensions: " + t), d._extensions = r;
      }
      this.emit("headers", u, t), n.write(u.concat("\r\n").join("\r\n")), n.removeListener("error", m), d.setSocket(n, i, this.options.maxPayload), this.clients && (this.clients.add(d), d.on("close", () => this.clients.delete(d))), o(d);
    }
  };
}, function (e, r, t) {
  "use strict";

  /**
   * @license React
   * react-debug-tools.production.min.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var n = t(66),
    a = t(0),
    i = Object.assign,
    o = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    s = [],
    l = null;
  function c() {
    if (null === l) {
      var e = new Map();
      try {
        d.useContext({
          _currentValue: null
        }), d.useState(null), d.useReducer(function (e) {
          return e;
        }, null), d.useRef(null), "function" == typeof d.useCacheRefresh && d.useCacheRefresh(), d.useLayoutEffect(function () {}), d.useInsertionEffect(function () {}), d.useEffect(function () {}), d.useImperativeHandle(void 0, function () {
          return null;
        }), d.useDebugValue(null), d.useCallback(function () {}), d.useMemo(function () {
          return null;
        });
      } finally {
        var r = s;
        s = [];
      }
      for (var t = 0; t < r.length; t++) {
        var a = r[t];
        e.set(a.primitive, n.parse(a.stackError));
      }
      l = e;
    }
    return l;
  }
  var u = null;
  function f() {
    var e = u;
    return null !== e && (u = e.next), e;
  }
  var d = {
      readContext: function (e) {
        return e._currentValue;
      },
      useCacheRefresh: function () {
        var e = f();
        return s.push({
          primitive: "CacheRefresh",
          stackError: Error(),
          value: null !== e ? e.memoizedState : function () {}
        }), function () {};
      },
      useCallback: function (e) {
        var r = f();
        return s.push({
          primitive: "Callback",
          stackError: Error(),
          value: null !== r ? r.memoizedState[0] : e
        }), e;
      },
      useContext: function (e) {
        return s.push({
          primitive: "Context",
          stackError: Error(),
          value: e._currentValue
        }), e._currentValue;
      },
      useEffect: function (e) {
        f(), s.push({
          primitive: "Effect",
          stackError: Error(),
          value: e
        });
      },
      useImperativeHandle: function (e) {
        f();
        var r = void 0;
        null !== e && "object" == typeof e && (r = e.current), s.push({
          primitive: "ImperativeHandle",
          stackError: Error(),
          value: r
        });
      },
      useDebugValue: function (e, r) {
        s.push({
          primitive: "DebugValue",
          stackError: Error(),
          value: "function" == typeof r ? r(e) : e
        });
      },
      useLayoutEffect: function (e) {
        f(), s.push({
          primitive: "LayoutEffect",
          stackError: Error(),
          value: e
        });
      },
      useInsertionEffect: function (e) {
        f(), s.push({
          primitive: "InsertionEffect",
          stackError: Error(),
          value: e
        });
      },
      useMemo: function (e) {
        var r = f();
        return e = null !== r ? r.memoizedState[0] : e(), s.push({
          primitive: "Memo",
          stackError: Error(),
          value: e
        }), e;
      },
      useReducer: function (e, r, t) {
        return r = null !== (e = f()) ? e.memoizedState : void 0 !== t ? t(r) : r, s.push({
          primitive: "Reducer",
          stackError: Error(),
          value: r
        }), [r, function () {}];
      },
      useRef: function (e) {
        var r = f();
        return e = null !== r ? r.memoizedState : {
          current: e
        }, s.push({
          primitive: "Ref",
          stackError: Error(),
          value: e.current
        }), e;
      },
      useState: function (e) {
        var r = f();
        return e = null !== r ? r.memoizedState : "function" == typeof e ? e() : e, s.push({
          primitive: "State",
          stackError: Error(),
          value: e
        }), [e, function () {}];
      },
      useTransition: function () {
        return f(), f(), s.push({
          primitive: "Transition",
          stackError: Error(),
          value: void 0
        }), [!1, function () {}];
      },
      useMutableSource: function (e, r) {
        return f(), f(), f(), f(), e = r(e._source), s.push({
          primitive: "MutableSource",
          stackError: Error(),
          value: e
        }), e;
      },
      useSyncExternalStore: function (e, r) {
        return f(), f(), e = r(), s.push({
          primitive: "SyncExternalStore",
          stackError: Error(),
          value: e
        }), e;
      },
      useDeferredValue: function (e) {
        var r = f();
        return s.push({
          primitive: "DeferredValue",
          stackError: Error(),
          value: null !== r ? r.memoizedState : e
        }), e;
      },
      useId: function () {
        var e = f();
        return e = null !== e ? e.memoizedState : "", s.push({
          primitive: "Id",
          stackError: Error(),
          value: e
        }), e;
      }
    },
    v = "undefined" == typeof Proxy ? d : new Proxy(d, {
      get: function (e, r) {
        if (e.hasOwnProperty(r)) return e[r];
        throw (e = Error("Missing method in Dispatcher: " + r)).name = "ReactDebugToolsUnsupportedHookError", e;
      }
    }),
    h = 0;
  function m(e, r, t) {
    var n = r[t].source,
      a = 0;
    e: for (; a < e.length; a++) if (e[a].source === n) {
      for (var i = t + 1, o = a + 1; i < r.length && o < e.length; i++, o++) if (e[o].source !== r[i].source) continue e;
      return a;
    }
    return -1;
  }
  function _(e, r) {
    return !!e && (r = "use" + r, !(e.length < r.length) && e.lastIndexOf(r) === e.length - r.length);
  }
  function p(e, r, t) {
    for (var a = [], i = null, o = a, s = 0, l = [], u = 0; u < r.length; u++) {
      var f = r[u],
        d = e,
        v = n.parse(f.stackError);
      e: {
        var p = v,
          g = m(p, d, h);
        if (-1 !== g) d = g;else {
          for (var b = 0; b < d.length && 5 > b; b++) if (-1 !== (g = m(p, d, b))) {
            h = b, d = g;
            break e;
          }
          d = -1;
        }
      }
      e: {
        if (p = v, void 0 !== (g = c().get(f.primitive))) for (b = 0; b < g.length && b < p.length; b++) if (g[b].source !== p[b].source) {
          b < p.length - 1 && _(p[b].functionName, f.primitive) && b++, b < p.length - 1 && _(p[b].functionName, f.primitive) && b++, p = b;
          break e;
        }
        p = -1;
      }
      if (null !== (v = -1 === d || -1 === p || 2 > d - p ? null : v.slice(p, d - 1))) {
        if (d = 0, null !== i) {
          for (; d < v.length && d < i.length && v[v.length - d - 1].source === i[i.length - d - 1].source;) d++;
          for (i = i.length - 1; i > d; i--) o = l.pop();
        }
        for (i = v.length - d - 1; 1 <= i; i--) d = [], p = v[i], (g = v[i - 1].functionName) ? (-1 === (b = g.lastIndexOf(".")) && (b = 0), "use" === g.substr(b, 3) && (b += 3), g = g.substr(b)) : g = "", g = {
          id: null,
          isStateEditable: !1,
          name: g,
          value: void 0,
          subHooks: d
        }, t && (g.hookSource = {
          lineNumber: p.lineNumber,
          columnNumber: p.columnNumber,
          functionName: p.functionName,
          fileName: p.fileName
        }), o.push(g), l.push(o), o = d;
        i = v;
      }
      f = {
        id: "Context" === (d = f.primitive) || "DebugValue" === d ? null : s++,
        isStateEditable: "Reducer" === d || "State" === d,
        name: d,
        value: f.value,
        subHooks: []
      }, t && (d = {
        lineNumber: null,
        functionName: null,
        fileName: null,
        columnNumber: null
      }, v && 1 <= v.length && (v = v[0], d.lineNumber = v.lineNumber, d.functionName = v.functionName, d.fileName = v.fileName, d.columnNumber = v.columnNumber), f.hookSource = d), o.push(f);
    }
    return function e(r, t) {
      for (var n = [], a = 0; a < r.length; a++) {
        var i = r[a];
        "DebugValue" === i.name && 0 === i.subHooks.length ? (r.splice(a, 1), a--, n.push(i)) : e(i.subHooks, i);
      }
      null !== t && (1 === n.length ? t.value = n[0].value : 1 < n.length && (t.value = n.map(function (e) {
        return e.value;
      })));
    }(a, null), a;
  }
  function g(e) {
    if (e instanceof Error && "ReactDebugToolsUnsupportedHookError" === e.name) throw e;
    var r = Error("Error rendering inspected component", {
      cause: e
    });
    throw r.name = "ReactDebugToolsRenderError", r.cause = e, r;
  }
  function b(e, r, t) {
    var a = 3 < arguments.length && void 0 !== arguments[3] && arguments[3];
    null == t && (t = o.ReactCurrentDispatcher);
    var i = t.current;
    t.current = v;
    try {
      var l = Error();
      e(r);
    } catch (e) {
      g(e);
    } finally {
      var c = s;
      s = [], t.current = i;
    }
    return p(i = n.parse(l), c, a);
  }
  function S(e) {
    e.forEach(function (e, r) {
      return r._currentValue = e;
    });
  }
  r.inspectHooks = b, r.inspectHooksOfFiber = function (e, r) {
    var t = 2 < arguments.length && void 0 !== arguments[2] && arguments[2];
    if (null == r && (r = o.ReactCurrentDispatcher), 0 !== e.tag && 15 !== e.tag && 11 !== e.tag) throw Error("Unknown Fiber. Needs to be a function component to inspect hooks.");
    c();
    var a = e.type,
      l = e.memoizedProps;
    if (a !== e.elementType && a && a.defaultProps) {
      l = i({}, l);
      var f = a.defaultProps;
      for (d in f) void 0 === l[d] && (l[d] = f[d]);
    }
    u = e.memoizedState;
    var d = new Map();
    try {
      for (f = e; f;) {
        if (10 === f.tag) {
          var h = f.type._context;
          d.has(h) || (d.set(h, h._currentValue), h._currentValue = f.memoizedProps.value);
        }
        f = f.return;
      }
      if (11 === e.tag) {
        var m = a.render;
        a = l;
        var _ = e.ref,
          E = (h = r).current;
        h.current = v;
        try {
          var w = Error();
          m(a, _);
        } catch (e) {
          g(e);
        } finally {
          var y = s;
          s = [], h.current = E;
        }
        var k = n.parse(w);
        return p(k, y, t);
      }
      return b(a, l, r, t);
    } finally {
      u = null, S(d);
    }
  };
}, function (e, r, t) {
  var n, a, i;
  !function (t, o) {
    "use strict";

    a = [], void 0 === (i = "function" == typeof (n = function () {
      function e(e) {
        return e.charAt(0).toUpperCase() + e.substring(1);
      }
      function r(e) {
        return function () {
          return (this || _global)[e];
        };
      }
      var t = ["isConstructor", "isEval", "isNative", "isToplevel"],
        n = ["columnNumber", "lineNumber"],
        a = ["fileName", "functionName", "source"],
        i = t.concat(n, a, ["args"]);
      function o(r) {
        if (r) for (var t = 0; t < i.length; t++) void 0 !== r[i[t]] && this["set" + e(i[t])](r[i[t]]);
      }
      o.prototype = {
        getArgs: function () {
          return (this || _global).args;
        },
        setArgs: function (e) {
          if ("[object Array]" !== Object.prototype.toString.call(e)) throw new TypeError("Args must be an Array");
          (this || _global).args = e;
        },
        getEvalOrigin: function () {
          return (this || _global).evalOrigin;
        },
        setEvalOrigin: function (e) {
          if (e instanceof o) (this || _global).evalOrigin = e;else {
            if (!(e instanceof Object)) throw new TypeError("Eval Origin must be an Object or StackFrame");
            (this || _global).evalOrigin = new o(e);
          }
        },
        toString: function () {
          var e = this.getFileName() || "",
            r = this.getLineNumber() || "",
            t = this.getColumnNumber() || "",
            n = this.getFunctionName() || "";
          return this.getIsEval() ? e ? "[eval] (" + e + ":" + r + ":" + t + ")" : "[eval]:" + r + ":" + t : n ? n + " (" + e + ":" + r + ":" + t + ")" : e + ":" + r + ":" + t;
        }
      }, o.fromString = function (e) {
        var r = e.indexOf("("),
          t = e.lastIndexOf(")"),
          n = e.substring(0, r),
          a = e.substring(r + 1, t).split(","),
          i = e.substring(t + 1);
        if (0 === i.indexOf("@")) var s = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(i, ""),
          l = s[1],
          c = s[2],
          u = s[3];
        return new o({
          functionName: n,
          args: a || void 0,
          fileName: l,
          lineNumber: c || void 0,
          columnNumber: u || void 0
        });
      };
      for (var s = 0; s < t.length; s++) o.prototype["get" + e(t[s])] = r(t[s]), o.prototype["set" + e(t[s])] = function (e) {
        return function (r) {
          (this || _global)[e] = Boolean(r);
        };
      }(t[s]);
      for (var l = 0; l < n.length; l++) o.prototype["get" + e(n[l])] = r(n[l]), o.prototype["set" + e(n[l])] = function (e) {
        return function (r) {
          if (t = r, isNaN(parseFloat(t)) || !isFinite(t)) throw new TypeError(e + " must be a Number");
          var t;
          (this || _global)[e] = Number(r);
        };
      }(n[l]);
      for (var c = 0; c < a.length; c++) o.prototype["get" + e(a[c])] = r(a[c]), o.prototype["set" + e(a[c])] = function (e) {
        return function (r) {
          (this || _global)[e] = String(r);
        };
      }(a[c]);
      return o;
    }) ? n.apply(r, a) : n) || (e.exports = i);
  }();
}, function (e, r, t) {
  var n = t(128);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  (e.exports = t(2)(!1)).push([e.i, "/* Used to detect in JavaScript if apps have loaded styles or not. */\n:root {\n  --reach-menu-button: 1;\n}\n\n[data-reach-menu] {\n  position: relative;\n}\n\n[data-reach-menu-popover] {\n  display: block;\n  position: absolute;\n}\n\n[data-reach-menu-popover][hidden] {\n  display: none;\n}\n\n[data-reach-menu-list],\n[data-reach-menu-items] {\n  display: block;\n  white-space: nowrap;\n  border: solid 1px hsla(0, 0%, 0%, 0.25);\n  background: hsla(0, 100%, 100%, 0.99);\n  outline: none;\n  padding: 1rem 0;\n  font-size: 85%;\n}\n\n[data-reach-menu-item] {\n  display: block;\n  user-select: none;\n}\n\n/*\n The dom structure of a MenuLink is reach-menu-item > a,\n so to target all items we can use `data-reach-menu-item`\n*/\n[data-reach-menu-item] {\n  /*\n    These are styled in one rule instead of something like a[data-reach-menu-item]\n    and li[data-reach-menu-item] so that apps don't have to fight specificity and\n    can style both li and a menu items with one rule,\n    ie: `[data-selected] { background: red; }`.\n    Otherwise they'd have to define two styles, one for a and one for li.\n  */\n\n  /* reach-menu-item */\n  cursor: pointer;\n\n  /* a */\n  display: block;\n  color: inherit;\n  font: inherit;\n  text-decoration: initial;\n\n  /* both */\n  padding: 5px 20px;\n}\n\n/* pseudo pseudo selector */\n[data-reach-menu-item][data-selected] {\n  background: hsl(211, 81%, 36%);\n  color: white;\n  outline: none;\n}\n\n[data-reach-menu-item][aria-disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n", ""]);
}, function (e, r) {
  e.exports = function (e) {
    var r = "undefined" != typeof window && window.location;
    if (!r) throw new Error("fixUrls requires window.location");
    if (!e || "string" != typeof e) return e;
    var t = r.protocol + "//" + r.host,
      n = t + r.pathname.replace(/\/[^\/]*$/, "/");
    return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, r) {
      var a,
        i = r.trim().replace(/^"(.*)"$/, function (e, r) {
          return r;
        }).replace(/^'(.*)'$/, function (e, r) {
          return r;
        });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? e : (a = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? t + i : n + i.replace(/^\.\//, ""), "url(" + JSON.stringify(a) + ")");
    });
  };
}, function (e, r, t) {
  var n = t(131);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  (e.exports = t(2)(!1)).push([e.i, ":root {\n  --reach-tooltip: 1;\n}\n\n[data-reach-tooltip] {\n  z-index: 1;\n  pointer-events: none;\n  position: absolute;\n  padding: 0.25em 0.5em;\n  box-shadow: 2px 2px 10px hsla(0, 0%, 0%, 0.1);\n  white-space: nowrap;\n  font-size: 85%;\n  background: #f0f0f0;\n  color: #444;\n  border: solid 1px #ccc;\n}\n", ""]);
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Icon___v5HwN {\n  width: 1rem;\n  height: 1rem;\n  fill: currentColor;\n}\n", ""]), r.locals = {
    Icon: "Icon___v5HwN"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Badge___1D92d {\n  display: inline-block;\n  background-color: var(--color-component-badge-background);\n  color: var(--color-text);\n  padding: 0.125rem 0.25rem;\n  line-height: normal;\n  border-radius: 0.125rem;\n  margin-right: 0.25rem;\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-small);\n}\n\n.ExtraLabel___ktyWc {\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-small);\n  color: var(--color-component-badge-count);\n}\n", ""]), r.locals = {
    Badge: "Badge___1D92d",
    ExtraLabel: "ExtraLabel___ktyWc"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".ButtonIcon___1AgYV {\n  width: 1rem;\n  height: 1rem;\n  fill: currentColor;\n}\n", ""]), r.locals = {
    ButtonIcon: "ButtonIcon___1AgYV"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Element___1PGUo,\n.InactiveSelectedElement___3H2V0,\n.SelectedElement___2BZuq,\n.HoveredElement___4tCuC {\n  color: var(--color-component-name);\n}\n.HoveredElement___4tCuC {\n  background-color: var(--color-background-hover);\n}\n.InactiveSelectedElement___3H2V0 {\n  background-color: var(--color-background-inactive);\n}\n\n.Wrapper___1kRcF {\n  padding: 0 0.25rem;\n  white-space: pre;\n  height: var(--line-height-data);\n  line-height: var(--line-height-data);\n  display: inline-flex;\n  align-items: center;\n  cursor: default;\n  user-select: none;\n}\n\n.ScrollAnchor___31Dc8 {\n  height: 100%;\n  width: 0;\n}\n\n.SelectedElement___2BZuq {\n  background-color: var(--color-background-selected);\n  color: var(--color-text-selected);\n\n  /* Invert colors */\n  --color-component-name: var(--color-component-name-inverted);\n  --color-text: var(--color-text-selected);\n  --color-component-badge-background: var(\n    --color-component-badge-background-inverted\n  );\n  --color-component-badge-count: var(--color-component-badge-count-inverted);\n  --color-attribute-name: var(--color-attribute-name-inverted);\n  --color-attribute-value: var(--color-attribute-value-inverted);\n  --color-expand-collapse-toggle: var(--color-component-name-inverted);\n}\n\n.KeyName___iOoVX {\n  color: var(--color-attribute-name);\n}\n\n.KeyValue___2hQzO {\n  color: var(--color-attribute-value);\n  user-select: text;\n  max-width: 100px;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n.Highlight___OJ7Ox {\n  background-color: var(--color-search-match);\n}\n.CurrentHighlight___3RWa2 {\n  background-color: var(--color-search-match-current);\n}\n\n.ExpandCollapseToggle___3CxPD {\n  display: inline-flex;\n  width: 1rem;\n  height: 1rem;\n  flex: 0 0 1rem;\n  color: var(--color-expand-collapse-toggle);\n}\n\n.Badge___36OB- {\n  margin-left: 0.25rem;\n}\n\n.ErrorIcon___2HE8O,\n.ErrorIconContrast___25w80,\n.StrictMode___3TX6u,\n.StrictModeContrast___f70us,\n.WarningIcon___3s2DR,\n.WarningIconContrast___12tJE {\n  height: 0.75rem !important;\n  width: 0.75rem !important;\n  margin-left: 0.25rem;\n}\n.ErrorIcon___2HE8O {\n  color: var(--color-console-error-icon);\n}\n.StrictMode___3TX6u {\n  color: var(--color-dimmer);\n}\n.WarningIcon___3s2DR {\n  color: var(--color-console-warning-icon);\n}\n.ErrorIconContrast___25w80, .WarningIconContrast___12tJE {\n  color: var(--color-component-name);\n}\n.StrictModeContrast___f70us {\n  color: var(--color-text);\n}\n", ""]), r.locals = {
    Element: "Element___1PGUo",
    InactiveSelectedElement: "InactiveSelectedElement___3H2V0",
    SelectedElement: "SelectedElement___2BZuq",
    HoveredElement: "HoveredElement___4tCuC",
    Wrapper: "Wrapper___1kRcF",
    ScrollAnchor: "ScrollAnchor___31Dc8",
    KeyName: "KeyName___iOoVX",
    KeyValue: "KeyValue___2hQzO",
    Highlight: "Highlight___OJ7Ox",
    CurrentHighlight: "CurrentHighlight___3RWa2",
    ExpandCollapseToggle: "ExpandCollapseToggle___3CxPD",
    Badge: "Badge___36OB-",
    ErrorIcon: "ErrorIcon___2HE8O",
    ErrorIconContrast: "ErrorIconContrast___25w80",
    StrictMode: "StrictMode___3TX6u",
    StrictModeContrast: "StrictModeContrast___f70us",
    WarningIcon: "WarningIcon___3s2DR",
    WarningIconContrast: "WarningIconContrast___12tJE"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".ToggleDisabled___iQeZ3,\n.ToggleOn___3XJTo,\n.ToggleOff___142SC {\n  background: var(--color-button-background);\n  border: none;\n  border-radius: 0.25rem;\n  padding: 0;\n  flex: 0 0 auto;\n}\n\n.ToggleContent___1C-vg {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 0.25rem;\n  padding: 0.25rem;\n}\n\n.ToggleOff___142SC {\n  border: none;\n  background: var(--color-button-background);\n  color: var(--color-button);\n}\n.ToggleOff___142SC:hover {\n  color: var(--color-button-hover);\n}\n\n.ToggleOn___3XJTo,\n.ToggleOn___3XJTo:active {\n  color: var(--color-button-active);\n  outline: none;\n}\n\n.ToggleOn___3XJTo:focus,\n.ToggleOff___142SC:focus,\n.ToggleContent___1C-vg:focus {\n  outline: none;\n}\n\n.ToggleOn___3XJTo:focus > .ToggleContent___1C-vg,\n.ToggleOff___142SC:focus > .ToggleContent___1C-vg {\n  background: var(--color-button-background-focus);\n}\n\n.ToggleDisabled___iQeZ3 {\n  background: var(--color-button-background);\n  color: var(--color-button-disabled);\n  cursor: default;\n}\n\n.Input___ESX-3 {\n  width: 0;\n  margin: 0;\n  opacity: 0;\n}\n", ""]), r.locals = {
    ToggleDisabled: "ToggleDisabled___iQeZ3",
    ToggleOn: "ToggleOn___3XJTo",
    ToggleOff: "ToggleOff___142SC",
    ToggleContent: "ToggleContent___1C-vg",
    Input: "Input___ESX-3"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Tooltip___2QcDY {\n  border: none;\n  border-radius: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  font-family: var(--font-family-sans);\n  font-size: 12px;\n  background-color: var(--color-tooltip-background);\n  color: var(--color-tooltip-text);\n  box-shadow: 1px 1px 2px var(--color-shadow);\n\n  /* Make sure this is above the DevTools, which are above the Overlay */\n  z-index: 10000002;\n}\n", ""]), r.locals = {
    Tooltip: "Tooltip___2QcDY"
  };
}, function (e, r, t) {
  "use strict";

  var n = t(139);
  function a() {}
  function i() {}
  i.resetWarningCache = a, e.exports = function () {
    function e(e, r, t, a, i, o) {
      if (o !== n) {
        var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw s.name = "Invariant Violation", s;
      }
    }
    function r() {
      return e;
    }
    e.isRequired = e;
    var t = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: r,
      element: e,
      elementType: e,
      instanceOf: r,
      node: e,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: i,
      resetWarningCache: a
    };
    return t.PropTypes = t, t;
  };
}, function (e, r, t) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Button___1-PiG {\n  border: none;\n  background: var(--color-button-background);\n  color: var(--color-button);\n  padding: 0;\n  border-radius: 0.25rem;\n  flex: 0 0 auto;\n  cursor: pointer;\n}\n.ButtonContent___2mZ9q {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 0.25rem;\n  padding: 0.25rem;\n}\n\n.Button___1-PiG:hover {\n  color: var(--color-button-hover);\n}\n.Button___1-PiG:active {\n  color: var(--color-button-focus);\n  outline: none;\n}\n.Button___1-PiG:focus,\n.ButtonContent___2mZ9q:focus {\n  outline: none;\n}\n\n.Button___1-PiG:focus > .ButtonContent___2mZ9q {\n  background: var(--color-button-background-focus);\n}\n\n.Button___1-PiG:disabled,\n.Button___1-PiG:disabled:active {\n  background: var(--color-button-background);\n  color: var(--color-button-disabled);\n  cursor: default;\n}\n", ""]), r.locals = {
    Button: "Button___1-PiG",
    ButtonContent: "ButtonContent___2mZ9q"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".OwnerStack___32qwj {\n  max-width: 100%;\n  overflow-x: auto;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.Component___3e3s7,\n.Component___3e3s7[data-reach-menu-item] {\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  user-select: none;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n}\n\n.Component___3e3s7[data-reach-menu-item][data-selected],\n.Component___3e3s7[data-reach-menu-item][data-selected]:hover {\n  color: var(--color-text-selected);\n  background: var(--color-background-selected);\n}\n.Component___3e3s7[data-reach-menu-item][data-selected]:focus {\n  outline: none;\n}\n\n.Bar___3G3dX {\n  display: flex;\n  flex: 1 1 auto;\n  overflow-x: auto;\n}\n\n.VRule___IJYKJ {\n  flex: 0 0 auto;\n  height: 20px;\n  width: 1px;\n  background-color: var(--color-border);\n  margin: 0 0.5rem;\n}\n\n.MenuButton___3te3U {\n  border-radius: 0.25rem;\n  display: inline-flex;\n  align-items: center;\n  padding: 0;\n  flex: 0 0 auto;\n  border: none;\n  background: var(--color-button-background);\n  color: var(--color-button);\n}\n.MenuButtonContent___3VvHH {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 0.25rem;\n  padding: 0.25rem;\n}\n.MenuButton___3te3U:hover {\n  color: var(--color-button-hover);\n}\n.MenuButton___3te3U[aria-expanded='true'],\n.MenuButton___3te3U[aria-expanded='true']:active {\n  color: var(--color-button-active);\n  outline: none;\n}\n\n.MenuButton___3te3U:focus,\n.MenuButtonContent___3VvHH:focus {\n  outline: none;\n}\n.MenuButton___3te3U:focus > .MenuButtonContent___3VvHH {\n  background: var(--color-button-background-focus);\n}\n\n.Modal___8b8bs[data-reach-menu-list] {\n  display: inline-flex;\n  flex-direction: column;\n  background-color: var(--color-background);\n  color: var(--color-button);\n  padding: 0.25rem 0;\n  padding-right: 0;\n  border: 1px solid var(--color-border);\n  border-radius: 0.25rem;\n  max-height: 10rem;\n  overflow: auto;\n\n  /* Make sure this is above the DevTools, which are above the Overlay */\n  z-index: 10000002;\n  position: relative;\n\n  /* Reach UI tries to set its own :( */\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n}\n\n.NotInStore___3Y2P2,\n.NotInStore___3Y2P2:hover {\n  color: var(--color-dimmest);\n}\n\n.Badge___2E6aT {\n  margin-left: 0.25rem;\n}\n", ""]), r.locals = {
    OwnerStack: "OwnerStack___32qwj",
    Component: "Component___3e3s7",
    Bar: "Bar___3G3dX",
    VRule: "VRule___IJYKJ",
    MenuButton: "MenuButton___3te3U",
    MenuButtonContent: "MenuButtonContent___3VvHH",
    Modal: "Modal___8b8bs",
    NotInStore: "NotInStore___3Y2P2",
    Badge: "Badge___2E6aT"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".SearchInput___5BLz9 {\n  flex: 1 1;\n  display: flex;\n  align-items: center;\n}\n\n.Input___15H-Z {\n  flex: 1 1 100px;\n  width: 100px;\n  font-size: var(--font-size-sans-large);\n  outline: none;\n  border: none;\n  background-color: var(--color-background);\n  color: var(--color-text);\n  padding-left: 1.5rem;\n  margin-left: -1rem;\n}\n\n.InputIcon___2jd-q {\n  pointer-events: none;\n  z-index: 2;\n  color: var(--color-dimmer);\n}\n\n.IndexLabel___98Dk_ {\n  color: var(--color-dim);\n  font-size: var(--font-size-sans-normal);\n  white-space: pre;\n}\n\n.LeftVRule___B5avU,\n.RightVRule___1XZ0Q {\n  height: 20px;\n  width: 1px;\n  background-color: var(--color-border);\n}\n.LeftVRule___B5avU {\n  margin: 0 0.25rem 0 0.5rem;\n}\n.RightVRule___1XZ0Q {\n  margin: 0 0.5rem 0 0.25rem;\n}\n", ""]), r.locals = {
    SearchInput: "SearchInput___5BLz9",
    Input: "Input___15H-Z",
    InputIcon: "InputIcon___2jd-q",
    IndexLabel: "IndexLabel___98Dk_",
    LeftVRule: "LeftVRule___B5avU",
    RightVRule: "RightVRule___1XZ0Q"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Active___3Y5D2,\n.Inactive___2Ddkx {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.Active___3Y5D2 {\n  background-color: var(--color-selected-tree-highlight-active);\n}\n\n.Inactive___2Ddkx {\n  background-color: var(--color-selected-tree-highlight-inactive);\n}\n", ""]), r.locals = {
    Active: "Active___3Y5D2",
    Inactive: "Inactive___2Ddkx"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Tree___3Pjje {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  border-top: 1px solid var(--color-border);\n\n  /* Default size will be adjusted by Tree after scrolling */\n  --indentation-size: 12px;\n}\n\n.List___qlOJG {\n  overflow-x: hidden !important;\n}\n\n.InnerElementType___1csGF {\n  overflow-x: hidden;\n}\n\n.SearchInput___1Q2I_ {\n  flex: 0 0 42px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--color-border);\n  padding: 0.5rem;\n}\n\n.AutoSizerWrapper___3IcMr {\n  width: 100%;\n  overflow: hidden;\n  flex: 1 0 auto;\n}\n.AutoSizerWrapper___3IcMr:focus {\n  outline: none;\n}\n\n.List___qlOJG {\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  line-height: var(--line-height-data);\n}\n\n.VRule___3yG5q {\n  height: 20px;\n  width: 1px;\n  flex: 0 0 1px;\n  margin: 0 0.5rem;\n  background-color: var(--color-border);\n}\n\n.Loading___TrqnR {\n  height: 100%;\n  padding-left: 0.5rem;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  justify-content: flex-start;\n  font-size: var(--font-size-sans-large);\n  color: var(--color-dim);\n}\n\n.IconAndCount___1CZUm {\n  display: flex;\n  align-items: center;\n  font-size: var(--font-size-sans-normal);\n}\n\n.ErrorIcon___1SNsZ, .WarningIcon___23GHe {\n  width: 0.75rem;\n  height: 0.75rem;\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n  flex: 0 0 auto;\n}\n.ErrorIcon___1SNsZ {\n  color: var(--color-console-error-icon);\n}\n.WarningIcon___23GHe {\n  color: var(--color-console-warning-icon);\n}\n\n.ZeroElementsNotice___1e7ln {\n  padding-left: 1em;\n  opacity: 0;\n  animation: fadeIn___3yIM4 0.5s forwards;\n  animation-delay: 2s;\n}\n@keyframes fadeIn___3yIM4 {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.Link___wwMB5 {\n  color: var(--color-button-active);\n}", ""]), r.locals = {
    Tree: "Tree___3Pjje",
    List: "List___qlOJG",
    InnerElementType: "InnerElementType___1csGF",
    SearchInput: "SearchInput___1Q2I_",
    AutoSizerWrapper: "AutoSizerWrapper___3IcMr",
    VRule: "VRule___3yG5q",
    Loading: "Loading___TrqnR",
    IconAndCount: "IconAndCount___1CZUm",
    ErrorIcon: "ErrorIcon___1SNsZ",
    WarningIcon: "WarningIcon___23GHe",
    ZeroElementsNotice: "ZeroElementsNotice___1e7ln",
    fadeIn: "fadeIn___3yIM4",
    Link: "Link___wwMB5"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".GitHubLinkRow___1Ubg1 {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: auto;\n  padding: 0.25rem 0.5rem;\n  background: var(--color-console-warning-background);\n  color: var(--color-text);\n  border-bottom: 1px solid var(--color-console-warning-border);\n  border-top: 1px solid var(--color-console-warning-border);\n}\n\n.WorkplaceGroupRow___2bkPD {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: auto;\n  padding: 0.25rem 0.5rem;\n  background: var(--color-background-hover);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.ErrorBoundary___2iFtc {\n  height: 100%;\n  width: 100%;\n  background-color: var(--color-background);\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--color-border);\n}\n\n.ErrorInfo___3rbAr {\n  padding: 0.5rem;\n  overflow: auto;\n}\n\n.HeaderRow___1yCa9 {\n  display: flex;\n  flex-direction: row;\n  font-size: var(--font-size-sans-large);\n  font-weight: bold;\n}\n\n.ErrorHeader___Ck9BV,\n.TimeoutHeader___2_O9L {\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.ErrorHeader___Ck9BV {\n  color: var(--color-error-text);\n}\n.TimeoutHeader___2_O9L {\n  color: var(--color-text);\n}\n\n.ErrorStack___xWW5M,\n.TimeoutStack___31pZb {\n  margin-top: 0.5rem;\n  white-space: pre-wrap;\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  -webkit-font-smoothing: initial;\n  border-radius: 0.25rem;\n  padding: 0.5rem;\n  overflow: auto;\n}\n\n.ErrorStack___xWW5M {\n  background-color: var(--color-error-background);\n  border: 1px solid var(--color-error-border);\n  color: var(--color-error-text);\n}\n\n.TimeoutStack___31pZb {\n  background-color: var(--color-console-warning-background);\n  color: var(--color-console-warning-text);\n  border: var(--color-console-warning-border)\n}\n\n.LoadingIcon___2Ox_q {\n  margin-right: 0.25rem;\n}\n\n.ReportIcon___163qD {\n  margin-right: 0.25rem;\n}\n\n.ReportLink___1RRG6 {\n  color: var(--color-link);\n}\n\n.FacebookOnly___1Q5yi {\n  margin-left: 0.25rem;\n}\n\n.ReproSteps___21X2x {\n  margin-left: 0.25rem;\n  color: var(--color-console-warning-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.UpdateExistingIssuePrompt___1AP89 {\n  margin-right: 0.25rem;\n  color: var(--color-console-warning-text);\n}\n\n.CloseButton___19JNk {\n  font-weight: bold;\n}\n\n.CloseButtonIcon___Fp6qN {\n  margin-left: 0.25rem;\n}\n\n.InfoBox___9MO75 {\n  margin-top: 0.5rem;\n  background: var(--color-console-warning-background);\n  border: 1px solid var(--color-console-warning-border);\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.5rem;\n  color: var(--color-console-warning-text);\n}", ""]), r.locals = {
    GitHubLinkRow: "GitHubLinkRow___1Ubg1",
    WorkplaceGroupRow: "WorkplaceGroupRow___2bkPD",
    ErrorBoundary: "ErrorBoundary___2iFtc",
    ErrorInfo: "ErrorInfo___3rbAr",
    HeaderRow: "HeaderRow___1yCa9",
    ErrorHeader: "ErrorHeader___Ck9BV",
    TimeoutHeader: "TimeoutHeader___2_O9L",
    ErrorStack: "ErrorStack___xWW5M",
    TimeoutStack: "TimeoutStack___31pZb",
    LoadingIcon: "LoadingIcon___2Ox_q",
    ReportIcon: "ReportIcon___163qD",
    ReportLink: "ReportLink___1RRG6",
    FacebookOnly: "FacebookOnly___1Q5yi",
    ReproSteps: "ReproSteps___21X2x",
    UpdateExistingIssuePrompt: "UpdateExistingIssuePrompt___1AP89",
    CloseButton: "CloseButton___19JNk",
    CloseButtonIcon: "CloseButtonIcon___Fp6qN",
    InfoBox: "InfoBox___9MO75"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Icon___2CecY {\n  width: 1rem;\n  height: 1rem;\n  fill: currentColor;\n}\n", ""]), r.locals = {
    Icon: "Icon___2CecY"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Wrapper___15kcB {\n  height: 100%;\n}", ""]), r.locals = {
    Wrapper: "Wrapper___15kcB"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Background___39iOi {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 1rem;\n  background-color: var(--color-modal-background);\n  overflow: auto;\n}\n\n.Dialog___2XI77 {\n  position: relative;\n  z-index: 3;\n  margin: 0 0.25rem;\n  width: 25rem;\n  min-width: 20rem;\n  max-width: 100%;\n  display: inline-block;\n  background-color: var(--color-background);\n  box-shadow: 0 2px 4px var(--color-shadow);\n  padding: 0.5rem;\n  border: 1px solid var(--color-border);\n  border-radius: 0.25rem;\n  font-size: var(--font-size-sans-normal);\n}\n\n.Title___1FtK3 {\n  font-size: var(--font-size-sans-large);\n  margin-bottom: 0.5rem;\n}\n\n.Buttons___3N6w8 {\n  text-align: right;\n  margin-top: 0.5rem;\n}\n\n.Button___3JNc2 {\n  font-size: var(--font-size-sans-large);\n}\n", ""]), r.locals = {
    Background: "Background___39iOi",
    Dialog: "Dialog___2XI77",
    Title: "Title___1FtK3",
    Buttons: "Buttons___3N6w8",
    Button: "Button___3JNc2"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".ContextMenu___3Zn8W {\n  position: absolute;\n  background-color: var(--color-context-background);\n  box-shadow: 1px 1px 2px var(--color-shadow);\n  border-radius: 0.25rem;\n  overflow: hidden;\n  z-index: 10000002;\n  user-select: none;\n}", ""]), r.locals = {
    ContextMenu: "ContextMenu___3Zn8W"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".ContextMenuItem___21C_r {\n  display: flex;\n  align-items: center;\n  color: var(--color-context-text);\n  padding: 0.5rem 0.75rem;\n  cursor: default;\n  border-top: 1px solid var(--color-context-border);\n  font-family: var(--font-family-sans);\n  font-size: var(--font-size-sans-normal);\n}\n.ContextMenuItem___21C_r:first-of-type {\n  border-top: none;\n}\n.ContextMenuItem___21C_r:hover,\n.ContextMenuItem___21C_r:focus {\n  outline: 0;\n  background-color: var(--color-context-background-hover);\n}\n.ContextMenuItem___21C_r:active {\n  background-color: var(--color-context-background-selected);\n  color: var(--color-context-text-selected);\n}", ""]), r.locals = {
    ContextMenuItem: "ContextMenuItem___21C_r"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".HocBadges___3V-9f {\n  padding: 0.125rem 0.25rem;\n  user-select: none;\n}\n\n.Badge___yfw97 {\n  display: inline-block;\n  background-color: var(--color-component-badge-background);\n  color: var(--color-text);\n  padding: 0.125rem 0.25rem;\n  line-height: normal;\n  border-radius: 0.125rem;\n  margin-right: 0.25rem;\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-small);\n}\n", ""]), r.locals = {
    HocBadges: "HocBadges___3V-9f",
    Badge: "Badge___yfw97"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Input___2Lqoc {\n  min-width: 0.5rem;\n  flex: 1 1 auto;\n  border: none;\n  background: transparent;\n  outline: none;\n  padding: 0;\n  border: none;\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n}\n\n.Input___2Lqoc:focus {\n  border-color: var(--color-border);\n}\n", ""]), r.locals = {
    Input: "Input___2Lqoc"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Input___2v7pX {\n  flex: 0 1 auto;\n  box-shadow: 0px 1px 3px transparent;\n  color: var(--color-text);\n}\n.Input___2v7pX:focus {\n  color: var(--color-text);\n  box-shadow: 0px 1px 3px var(--color-shadow);\n}", ""]), r.locals = {
    Input: "Input___2v7pX"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Checkbox___S8zDe {\n  flex: 0 0 auto;\n  align-self: center;\n  margin: 0 0.25rem;\n}\n\n.Input___54okB {\n  flex: 1 1;\n  background: none;\n  border: 1px solid transparent;\n  color: var(--color-attribute-editable-value);\n  border-radius: 0.125rem;\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n}\n\n.Invalid___AR4Hd {\n  flex: 1 1;\n  background: none;\n  border: 1px solid transparent;\n  color: var(--color-attribute-editable-value);\n  border-radius: 0.125rem;\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  background-color: var(--color-background-invalid);\n  color: var(--color-text-invalid);\n\n  --color-border: var(--color-text-invalid);\n}\n\n.Input___54okB:focus,\n.Invalid___AR4Hd:focus {\n  background-color: var(--color-button-background-focus);\n  outline: none;\n}\n\n.ResetButton___k3gxk {\n  flex: 0 0 auto;\n  padding: 0 0.5rem;\n}\n", ""]), r.locals = {
    Checkbox: "Checkbox___S8zDe",
    Input: "Input___54okB",
    Invalid: "Invalid___AR4Hd",
    ResetButton: "ResetButton___k3gxk"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".NewArrayValue___3rHoU {\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n}\n\n.EditableName___3OJ36 {\n  margin-left: 1rem;\n}\n\n.Invalid___1sVw9 {\n  background-color: var(--color-background-invalid);\n  color: var(--color-text-invalid) !important;\n}\n\n.Input___1SYGr:focus,\n.Invalid___1sVw9:focus {\n  background-color: var(--color-button-background-focus);\n}", ""]), r.locals = {
    NewArrayValue: "NewArrayValue___3rHoU",
    EditableName: "EditableName___3OJ36",
    Invalid: "Invalid___1sVw9",
    Input: "Input___1SYGr"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".NewKeyValue___34r7B {\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n}\n\n.EditableName___2W--L {\n  margin-left: 1rem;\n}\n\n.EditableValue___16Q0K {\n  min-width: 1rem;\n}\n", ""]), r.locals = {
    NewKeyValue: "NewKeyValue___34r7B",
    EditableName: "EditableName___2W--L",
    EditableValue: "EditableValue___16Q0K"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".ExpandCollapseToggle___1eSq5 {\n  flex: 0 0 1rem;\n  width: 1rem;\n  height: 1rem;\n  padding: 0;\n  color: var(--color-expand-collapse-toggle);\n}\n", ""]), r.locals = {
    ExpandCollapseToggle: "ExpandCollapseToggle___1eSq5"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Item___2n2qv:not([hidden]) {\n  display: flex;\n}\n\n.DisabledItem___SbUmS {\n  opacity: 0.5;\n}\n\n.Name___3LSJX {\n  color: var(--color-attribute-name-not-editable);\n  flex: 0 0 auto;\n  cursor: default;\n}\n\n.EditableName___2TyRo {\n  color: var(--color-attribute-name);\n  flex: 0 0 auto;\n  cursor: default;\n}\n\n.AfterName___1HlGw {\n  color: var(--color-text);\n  margin-right: 0.5rem;\n}\n\n.Value___7p123 {\n  color: var(--color-attribute-value);\n  white-space: pre;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: default;\n  flex: 1;\n}\n\n.Link___35OsV {\n  color: var(--color-link);\n  white-space: pre;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n}\n\n.None___RYyex {\n  color: var(--color-dimmer);\n  font-style: italic;\n}\n\n.ExpandCollapseToggleSpacer___3KNWO {\n  flex: 0 0 1rem;\n  width: 1rem;\n}\n\n.Empty___1MaDj {\n  color: var(--color-dimmer);\n}\n\n.DeleteArrayItemButton___1R-pd {\n  padding: 0;\n  margin-right: 0.125rem;\n}\n\n.HookName___1ZjVf {\n  color: var(--color-component-name);\n}", ""]), r.locals = {
    Item: "Item___2n2qv",
    DisabledItem: "DisabledItem___SbUmS",
    Name: "Name___3LSJX",
    EditableName: "EditableName___2TyRo",
    AfterName: "AfterName___1HlGw",
    Value: "Value___7p123",
    Link: "Link___35OsV",
    None: "None___RYyex",
    ExpandCollapseToggleSpacer: "ExpandCollapseToggleSpacer___3KNWO",
    Empty: "Empty___1MaDj",
    DeleteArrayItemButton: "DeleteArrayItemButton___1R-pd",
    HookName: "HookName___1ZjVf"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".InspectedElementTree___2_4hD {\n  padding: 0.25rem;\n  border-top: 1px solid var(--color-border);\n}\n.InspectedElementTree___2_4hD:first-of-type {\n  border-top: none;\n}\n\n.HeaderRow___3I5kU {\n  display: flex;\n  align-items: center;\n}\n\n.Header___2LZLy {\n  display: flex;\n  align-items: center;\n  flex: 1 1;\n  font-family: var(--font-family-sans);\n}\n\n.Item___3t7sh {\n  display: flex;\n}\n\n.Name___6619F {\n  color: var(--color-attribute-name);\n  flex: 0 0 auto;\n}\n.Name___6619F:after {\n  content: ': ';\n  color: var(--color-text);\n  margin-right: 0.5rem;\n}\n\n.Value___na2y1 {\n  color: var(--color-attribute-value);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.None___1ezJC {\n  color: var(--color-dimmer);\n  font-style: italic;\n}\n\n.Empty___2hAqe {\n  color: var(--color-dimmer);\n  font-style: italic;\n  padding-left: 0.75rem;\n}\n\n.ToggleSuspenseRow___3Abo4 {\n  padding-left: 1rem;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n}\n\n.EditableValue___2B5lx {\n  min-width: 1rem;\n}\n", ""]), r.locals = {
    InspectedElementTree: "InspectedElementTree___2_4hD",
    HeaderRow: "HeaderRow___3I5kU",
    Header: "Header___2LZLy",
    Item: "Item___3t7sh",
    Name: "Name___6619F",
    Value: "Value___na2y1",
    None: "None___1ezJC",
    Empty: "Empty___2hAqe",
    ToggleSuspenseRow: "ToggleSuspenseRow___3Abo4",
    EditableValue: "EditableValue___2B5lx"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".ErrorTree___OauA_, .WarningTree___2O5xr {\n  padding: 0.25rem 0 0 0;\n}\n\n.HeaderRow___2Y3QM {\n  padding: 0 0.25rem;\n}\n\n.HeaderRow___2Y3QM {\n  padding: 0 0.25rem;\n}\n\n.Error___CORL1, .Warning___zqCFY {\n  padding: 0 0.5rem;\n  display: flex;\n  align-items: center;\n}\n\n.Error___CORL1 {\n  border-top: 1px solid var(--color-console-error-border);\n  background-color: var(--color-console-error-background);\n  color: var(--color-error-text);\n  padding: 0 0.5rem;\n}\n\n.Warning___zqCFY {\n  border-top: 1px solid var(--color-console-warning-border);\n  background-color: var(--color-console-warning-background);\n  color: var(--color-warning-text);\n  padding: 0 0.5rem;\n}\n\n.Message___Ky3Dl {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ErrorBadge___MKpI8,\n.WarningBadge___22U6H {\n  display: inline-block;\n  width: 0.75rem;\n  height: 0.75rem;\n  flex: 0 0 0.75rem;\n  line-height: 0.75rem;\n  text-align: center;\n  border-radius: 0.25rem;\n  margin-right: 0.25rem;\n  font-size: var(--font-size-monospace-small);\n}\n\n.ErrorBadge___MKpI8 {\n  background-color: var(--color-console-error-icon);\n  color: var(--color-console-error-badge-text);\n}\n\n.WarningBadge___22U6H {\n  background-color: var(--color-console-warning-icon);\n  color: var(--color-console-warning-badge-text);\n}\n", ""]), r.locals = {
    ErrorTree: "ErrorTree___OauA_",
    WarningTree: "WarningTree___2O5xr",
    HeaderRow: "HeaderRow___2Y3QM",
    Error: "Error___CORL1",
    Warning: "Warning___zqCFY",
    Message: "Message___Ky3Dl",
    ErrorBadge: "ErrorBadge___MKpI8",
    WarningBadge: "WarningBadge___22U6H"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".HooksTreeView___3YmZw {\n  padding: 0.25rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.Hook___SbvM_ {\n}\n\n.Children___1f8xt {\n  padding-left: 1rem;\n}\n\n.HeaderRow___37mMe {\n  display: flex;\n  align-items: center;\n}\n\n.Header___9n-jL {\n  flex: 1 1;\n  font-family: var(--font-family-sans);\n}\n\n.NameValueRow___1dbuI {\n  display: flex;\n}\n\n.Name___3oYR1,\n.NameAnonymous___W-cy2 {\n  flex: 0 0 auto;\n  cursor: default;\n}\n.Name___3oYR1 {\n  color: var(--color-dim);\n}\n.NameAnonymous___W-cy2 {\n  color: var(--color-dimmer);\n}\n\n.EditableName___1m4Hy {\n  color: var(--color-attribute-name);\n  flex: 0 0 auto;\n  cursor: default;\n}\n.EditableName___1m4Hy:after,\n.Name___3oYR1:after {\n  color: var(--color-text);\n  content: ': ';\n  margin-right: 0.5rem;\n}\n\n.Value___3tDyC {\n  color: var(--color-attribute-value);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: default;\n  white-space: nowrap;\n}\n\n.None___dHntG {\n  color: var(--color-dimmer);\n  font-style: italic;\n}\n\n.TruncationIndicator___fImBc {\n  color: var(--color-dimmer);\n}\n\n.ExpandCollapseToggleSpacer___2RAvX {\n  flex: 0 0 1rem;\n  width: 1rem;\n}\n\n.PrimitiveHookNumber___1ZHtG {\n  background-color: var(--color-primitive-hook-badge-background);\n  color: var(--color-primitive-hook-badge-text);\n  font-size: var(--font-size-monospace-small);\n  margin-right: 0.25rem;\n  border-radius: 0.125rem;\n  padding: 0.125rem 0.25rem;\n}\n\n.HookName___3Pr8I {\n  color: var(--color-component-name);\n}\n\n.ToggleError___2AMCP {\n  color: var(--color-error-text);\n}", ""]), r.locals = {
    HooksTreeView: "HooksTreeView___3YmZw",
    Hook: "Hook___SbvM_",
    Children: "Children___1f8xt",
    HeaderRow: "HeaderRow___37mMe",
    Header: "Header___9n-jL",
    NameValueRow: "NameValueRow___1dbuI",
    Name: "Name___3oYR1",
    NameAnonymous: "NameAnonymous___W-cy2",
    EditableName: "EditableName___1m4Hy",
    Value: "Value___3tDyC",
    None: "None___dHntG",
    TruncationIndicator: "TruncationIndicator___fImBc",
    ExpandCollapseToggleSpacer: "ExpandCollapseToggleSpacer___2RAvX",
    PrimitiveHookNumber: "PrimitiveHookNumber___1ZHtG",
    HookName: "HookName___3Pr8I",
    ToggleError: "ToggleError___2AMCP"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Source___DuiDm {\n  color: var(--color-dim);\n  margin-left: 1rem;\n  overflow: auto;\n  text-overflow: ellipsis;\n}", ""]), r.locals = {
    Source: "Source___DuiDm"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".LayoutViewer___215Ad {\n  padding: 0.25rem;\n  border-top: 1px solid var(--color-border);\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-small);\n}\n\n.Header___YXSRg {\n  font-family: var(--font-family-sans);\n}\n\n.DashedBox___i8dxS,\n.SolidBox___1W-UG {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-width: 1px;\n  border-color: var(--color-dim);\n  padding: 0.25rem;\n  margin: 0.25rem;\n}\n.DashedBox___i8dxS {\n  border-style: dashed;\n}\n.SolidBox___1W-UG {\n  border-style: solid;\n}\n\n.LabelRow___2SQOh {\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.Label___IskVY {\n  position: absolute;\n  left: 0.5rem;\n  flex: 1 0 100px;\n  color: var(--color-attribute-name);\n}\n\n.BoxRow___2_1as {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n", ""]), r.locals = {
    LayoutViewer: "LayoutViewer___215Ad",
    Header: "Header___YXSRg",
    DashedBox: "DashedBox___i8dxS",
    SolidBox: "SolidBox___1W-UG",
    LabelRow: "LabelRow___2SQOh",
    Label: "Label___IskVY",
    BoxRow: "BoxRow___2_1as"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".StyleEditor___1RvzE {\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  padding: 0.25rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.HeaderRow___xyA6t {\n  display: flex;\n  align-items: center;\n}\n\n.Header___2SGfE {\n  flex: 1 1;\n}\n\n.Brackets___2zA4K {\n  font-family: var(--font-family-sans);\n  font-size: var(--font-size-sans-small);\n}\n\n.Row___3v8mp {\n  white-space: nowrap;\n  padding-left: 1rem;\n  display: flex;\n  align-items: center;\n}\n\n.Invalid___3ogBH {\n  background-color: var(--color-background-invalid);\n  color: var(--color-text-invalid);\n\n  --color-border: var(--color-text-invalid);\n}\n.Attribute___2yC0c {\n  color: var(--color-attribute-name);\n}\n\n.Value___1yJUg {\n  color: var(--color-attribute-value);\n}\n\n.Input___3Zdnf {\n  flex: 0 1 auto;\n  padding: 1px;\n  box-shadow: 0px 1px 3px transparent;\n}\n.Input___3Zdnf:focus {\n  color: var(--color-text);\n  box-shadow: 0px 1px 3px var(--color-shadow);\n}\n\n.Empty___3Pi3w {\n  color: var(--color-dimmer);\n  font-style: italic;\n  user-select: none;\n  padding-left: 1rem;\n}\n", ""]), r.locals = {
    StyleEditor: "StyleEditor___1RvzE",
    HeaderRow: "HeaderRow___xyA6t",
    Header: "Header___2SGfE",
    Brackets: "Brackets___2zA4K",
    Row: "Row___3v8mp",
    Invalid: "Invalid___3ogBH",
    Attribute: "Attribute___2yC0c",
    Value: "Value___1yJUg",
    Input: "Input___3Zdnf",
    Empty: "Empty___3Pi3w"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Owners___13tPI {\n  padding: 0.25rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.OwnersHeader___3Yv3d {\n  font-family: var(--font-family-sans);\n}\n\n.Source____5R8o {\n  padding: 0.25rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.SourceHeaderRow___2mf8O {\n  display: flex;\n  align-items: center;\n}\n\n.SourceHeader___3eTnC {\n  flex: 1 1;\n  font-family: var(--font-family-sans);\n}\n\n.SourceOneLiner___1CmzZ {\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  margin-left: 1rem;\n}\n\n.Owner___3pCT- {\n  color: var(--color-component-name);\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.InspectedElement___AIaEa {\n  overflow-x: hidden;\n  overflow-y: auto;\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  line-height: var(--line-height-data);\n}\n\n.Owner___3pCT- {\n  border-radius: 0.25rem;\n  padding: 0.125rem 0.25rem;\n  background: none;\n  border: none;\n  display: block;\n}\n.Owner___3pCT-:focus {\n  outline: none;\n  background-color: var(--color-button-background-focus);\n}\n\n.NotInStore___1AhKj {\n  color: var(--color-dim);\n  cursor: default;\n}\n\n.OwnerButton___1ZvI9 {\n  cursor: pointer;\n  width: 100%;\n  padding: 0;\n}\n\n.OwnerContent___1S1aF {\n  display: flex;\n  align-items: center;\n  padding-left: 1rem;\n  width: 100%;\n  border-radius: 0.25rem;\n}\n\n.OwnerContent___1S1aF:hover {\n  background-color: var(--color-background-hover);\n}\n\n.ContextMenuIcon___2EG7W {\n  margin-right: 0.5rem;\n}\n\n.OwnersMetaField___ot46- {\n  padding-left: 1.25rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}", ""]), r.locals = {
    Owners: "Owners___13tPI",
    OwnersHeader: "OwnersHeader___3Yv3d",
    Source: "Source____5R8o",
    SourceHeaderRow: "SourceHeaderRow___2mf8O",
    SourceHeader: "SourceHeader___3eTnC",
    SourceOneLiner: "SourceOneLiner___1CmzZ",
    Owner: "Owner___3pCT-",
    InspectedElement: "InspectedElement___AIaEa",
    NotInStore: "NotInStore___1AhKj",
    OwnerButton: "OwnerButton___1ZvI9",
    OwnerContent: "OwnerContent___1S1aF",
    ContextMenuIcon: "ContextMenuIcon___2EG7W",
    OwnersMetaField: "OwnersMetaField___ot46-"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".InspectedElement___gy6ot {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  border-left: 1px solid var(--color-border);\n  border-top: 1px solid var(--color-border);\n}\n\n.TitleRow___2UUrj {\n  flex: 0 0 42px;\n  display: flex;\n  align-items: center;\n  font-size: var(--font-size-monospace-large);\n  border-bottom: 1px solid var(--color-border);\n  padding: 0.5rem;\n}\n\n.Key___1eadz {\n  flex: 0 1 auto;\n  padding-left: 0.25rem;\n  padding-right: 0.125rem;\n  line-height: 1rem;\n  border-top-left-radius: 0.125rem;\n  border-bottom-left-radius: 0.125rem;\n  display: inline-block;\n  background-color: var(--color-component-badge-background);\n  color: var(--color-text);\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-small);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.KeyArrow___2TKpc {\n  height: 1rem;\n  width: 1rem;\n  margin-right: -0.25rem;\n  border: 0.5rem solid transparent;\n  border-left: 0.5rem solid var(--color-component-badge-background);\n}\n\n.SelectedComponentName___3ByrZ {\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: normal;\n}\n\n.Component___No3ti {\n  flex: 1 1 auto;\n  color: var(--color-component-name);\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.Loading___1cYSg {\n  padding: 0.25rem;\n  color: var(--color-dimmer);\n  font-style: italic;\n  border-left: 1px solid var(--color-border);\n}\n\n.StrictModeNonCompliant___2P55H {\n  margin-right: 0.25rem;\n  color: var(--color-console-error-icon);\n}", ""]), r.locals = {
    InspectedElement: "InspectedElement___gy6ot",
    TitleRow: "TitleRow___2UUrj",
    Key: "Key___1eadz",
    KeyArrow: "KeyArrow___2TKpc",
    SelectedComponentName: "SelectedComponentName___3ByrZ",
    Component: "Component___No3ti",
    Loading: "Loading___1cYSg",
    StrictModeNonCompliant: "StrictModeNonCompliant___2P55H"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Tab___20JoC,\n.TabCurrent___b4c3L,\n.TabDisabled___l1-ZF {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  border-top: 3px solid transparent;\n  border-bottom: 3px solid transparent;\n  user-select: none;\n  color: var(--color-text);\n\n  /* Hide radio buttons for Firefox too */\n  position:  relative;\n\n  /* Electron drag area */\n  -webkit-app-region: no-drag;\n}\n.Tab___20JoC:hover,\n.TabCurrent___b4c3L:hover {\n  background-color: var(--color-background-hover);\n}\n.Tab___20JoC:focus-within,\n.TabCurrent___b4c3L:focus-within {\n  background-color: var(--color-background-hover);\n}\n\n.TabCurrent___b4c3L {\n  border-bottom: 3px solid var(--color-tab-selected-border);\n}\n\n.TabDisabled___l1-ZF {\n  color: var(--color-dim);\n  cursor: default;\n}\n\n.TabSizeNavigation___2GG1g {\n  font-size: var(--font-size-sans-large);\n  padding: 0.5rem 1rem;\n}\n.TabSizeProfiler___2wFBf {\n  font-size: var(--font-size-sans-normal);\n  padding: 0.25rem 0.5rem;\n}\n.TabSizeSettings___3V4f9 {\n  font-size: var(--font-size-sans-normal);\n  padding: 0.25rem 0.5rem;\n}\n\n.Input___2unCl {\n  width: 0;\n  margin: 0;\n  opacity: 0;\n\n  /* Hide radio buttons for Firefox too */\n  position:  absolute;\n}\n\n.IconSizeNavigation___mZIpl,\n.IconSizeProfiler___1jYXs,\n.IconSizeSettings___1HNRk {\n  margin-right: 0.5rem;\n  color: var(--color-button-active);\n}\n\n.IconDisabled___17Sd2 {\n  color: var(--color-dim);\n}\n\n.IconSizeNavigation___mZIpl {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n.IconSizeProfiler___1jYXs {\n  width: 1rem;\n  height: 1rem;\n}\n.IconSizeSettings___1HNRk {\n  width: 1rem;\n  height: 1rem;\n}\n\n.TabLabelNavigation___2q3j3,\n.TabLabelProfiler___2QHeh,\n.TabLabelSettings___1pDKr {\n}\n\n.VRule___QpkmZ {\n  height: 20px;\n  width: 1px;\n  border-left: 1px solid var(--color-border);\n  padding-left: 0.25rem;\n  margin-left: 0.25rem;\n}\n\n@media screen and (max-width: 525px) {\n  .IconSizeNavigation___mZIpl {\n    margin-right: 0;\n  }\n\n  .TabLabelNavigation___2q3j3 {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 900px) {\n  .TabLabelProfiler___2QHeh {\n    display: none;\n  }\n\n  .IconSizeProfiler___1jYXs {\n    margin-right: 0;\n  }\n}\n\n@media screen and (max-width: 400px) {\n  .TabLabelSettings___1pDKr {\n    display: none;\n  }\n\n  .IconSizeSettings___1HNRk {\n    margin-right: 0;\n  }\n}\n", ""]), r.locals = {
    Tab: "Tab___20JoC",
    TabCurrent: "TabCurrent___b4c3L",
    TabDisabled: "TabDisabled___l1-ZF",
    TabSizeNavigation: "TabSizeNavigation___2GG1g",
    TabSizeProfiler: "TabSizeProfiler___2wFBf",
    TabSizeSettings: "TabSizeSettings___3V4f9",
    Input: "Input___2unCl",
    IconSizeNavigation: "IconSizeNavigation___mZIpl",
    IconSizeProfiler: "IconSizeProfiler___1jYXs",
    IconSizeSettings: "IconSizeSettings___1HNRk",
    IconDisabled: "IconDisabled___17Sd2",
    TabLabelNavigation: "TabLabelNavigation___2q3j3",
    TabLabelProfiler: "TabLabelProfiler___2QHeh",
    TabLabelSettings: "TabLabelSettings___1pDKr",
    VRule: "VRule___QpkmZ"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Settings___29B2k {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  font-family: var(--font-family-sans);\n  font-size: var(--font-size-sans-normal);\n}\n\n.Setting___1NJgU {\n  margin-bottom: 0.5rem;\n}\n.Setting___1NJgU:last-of-type {\n  margin-bottom: 0;\n}\n\n.OpenInURLSetting___2eTwK {\n  margin: 0.5rem 0;\n}\n\n.OptionGroup___2ZgHP {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  user-select: none;\n  margin: 0 1rem 0.5rem 0;\n}\n.OptionGroup___2ZgHP:last-of-type {\n  margin-right: 0;\n}\n\n.RadioLabel___1oyOB {\n  display: inline;\n  margin-right: 0.5rem;\n}\n\n.Spacer___1rTaV {\n  height: 0.5rem;\n}\n\n.Select___1otXV {\n}\n\n.CheckboxOption___2XWVZ {\n  display: block;\n  padding: 0 0 0.5rem;\n}\n\n.HRule___1h4ad {\n  height: 1px;\n  background-color: var(--color-border);\n  width: 100%;\n  border: none;\n  margin: 0.5rem 0;\n}\n\n.Header___NGIlt {\n  font-size: var(--font-size-sans-large);\n  margin-top: 0.5rem;\n}\n\n.ButtonIcon___3ZAjp {\n  margin-right: 0.25rem;\n}\n\n.NoFiltersCell___1WYR2 {\n  padding: 0.25rem 0;\n  color: var(--color-dim);\n}\n\n.Table___2srES {\n  min-width: 20rem;\n  margin-top: 0.5rem;\n  border-spacing: 0;\n}\n\n.TableRow___3kYuW {\n  padding-bottom: 0.5rem;\n}\n\n.TableCell___1yj52 {\n  padding: 0;\n  padding-right: 0.5rem;\n}\n.TableCell___1yj52:last-of-type {\n  text-align: right;\n  padding-right: 0;\n}\n\n.Input___I9AdA {\n  border: 1px solid var(--color-border);\n  border-radius: 0.125rem;\n  padding: 0.125rem;\n}\n\n.InvalidRegExp___35lmE,\n.InvalidRegExp___35lmE:active,\n.InvalidRegExp___35lmE:focus,\n.InvalidRegExp___35lmE:hover {\n  color: var(--color-value-invalid);\n}\n\n.ToggleOffInvalid___2Rg2K,\n.ToggleOnInvalid___1Kamt,\n.ToggleOff___3cr6E,\n.ToggleOn___3KAVB {\n  border-radius: 0.75rem;\n  width: 1rem;\n  height: 0.625rem;\n  display: flex;\n  align-items: center;\n  padding: 0.125rem;\n}\n.ToggleOffInvalid___2Rg2K {\n  background-color: var(--color-toggle-background-invalid);\n  justify-content: flex-start;\n}\n.ToggleOnInvalid___1Kamt {\n  background-color: var(--color-toggle-background-invalid);\n  justify-content: flex-end;\n}\n.ToggleOff___3cr6E {\n  background-color: var(--color-toggle-background-off);\n  justify-content: flex-start;\n}\n.ToggleOn___3KAVB {\n  background-color: var(--color-toggle-background-on);\n  justify-content: flex-end;\n}\n\n.ToggleInsideOff___1pXcm,\n.ToggleInsideOn___3kEsU {\n  border-radius: 0.375rem;\n  width: 0.375rem;\n  height: 0.375rem;\n  background-color: var(--color-toggle-text);\n}\n\n.ReleaseNotes___q8NY1 {\n  width: 100%;\n  background-color: var(--color-background-hover);\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n}\n\n.ReleaseNotesLink___2gjE8 {\n  color: var(--color-button-active);\n}\n\n.Warning___3xUvj {\n  color: var(--color-error-text);\n}\n\n.VersionsList___35cmE {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}", ""]), r.locals = {
    Settings: "Settings___29B2k",
    Setting: "Setting___1NJgU",
    OpenInURLSetting: "OpenInURLSetting___2eTwK",
    OptionGroup: "OptionGroup___2ZgHP",
    RadioLabel: "RadioLabel___1oyOB",
    Spacer: "Spacer___1rTaV",
    Select: "Select___1otXV",
    CheckboxOption: "CheckboxOption___2XWVZ",
    HRule: "HRule___1h4ad",
    Header: "Header___NGIlt",
    ButtonIcon: "ButtonIcon___3ZAjp",
    NoFiltersCell: "NoFiltersCell___1WYR2",
    Table: "Table___2srES",
    TableRow: "TableRow___3kYuW",
    TableCell: "TableCell___1yj52",
    Input: "Input___I9AdA",
    InvalidRegExp: "InvalidRegExp___35lmE",
    ToggleOffInvalid: "ToggleOffInvalid___2Rg2K",
    ToggleOnInvalid: "ToggleOnInvalid___1Kamt",
    ToggleOff: "ToggleOff___3cr6E",
    ToggleOn: "ToggleOn___3KAVB",
    ToggleInsideOff: "ToggleInsideOff___1pXcm",
    ToggleInsideOn: "ToggleInsideOn___3kEsU",
    ReleaseNotes: "ReleaseNotes___q8NY1",
    ReleaseNotesLink: "ReleaseNotesLink___2gjE8",
    Warning: "Warning___3xUvj",
    VersionsList: "VersionsList___35cmE"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Background___3ncIs {\n  position: absolute;\n  z-index: 3;\n  width: 100%;\n  top: 0;\n  bottom: 0;\n  background-color: var(--color-modal-background);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  font-size: var(--font-size-sans-normal);\n  padding: 1rem;\n}\n\n.Modal___rU10h {\n  display: flex;\n  flex-direction: column;\n  flex: 0 1 auto;\n  max-height: 100%;\n  background-color: var(--color-background);\n  border: 1px solid var(--color-border);\n  box-shadow: 0 2px 4px var(--color-shadow);\n  border-radius: 0.25rem;\n  overflow: auto;\n  width: 410px;\n  max-width: 100%;\n}\n\n.Spacer___3_C0y {\n  flex: 1;\n}\n\n.Tabs___3mQky {\n  display: flex;\n  flex-direction: row;\n  border-bottom: 1px solid var(--color-border);\n  padding-right: 0.25rem;\n  flex: 0 0 auto;\n}\n\n.Content___2YU9A {\n  padding: 0.5rem;\n  flex: 0 1 auto;\n  overflow: auto;\n}", ""]), r.locals = {
    Background: "Background___3ncIs",
    Modal: "Modal___rU10h",
    Spacer: "Spacer___3_C0y",
    Tabs: "Tabs___3mQky",
    Content: "Content___2YU9A"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Components___MlQHS {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  background-color: var(--color-background);\n  color: var(--color-text);\n  font-family: var(--font-family-sans);\n}\n\n.Components___MlQHS, .Components___MlQHS * {\n  box-sizing: border-box;\n  -webkit-font-smoothing: var(--font-smoothing);\n}\n\n.TreeWrapper___2uPTC {\n  flex: 0 0 var(--horizontal-resize-percentage);\n  overflow: auto;\n}\n\n.InspectedElementWrapper___Ay-WL {\n  flex: 1 1 35%;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.ResizeBarWrapper___2jVIz {\n  flex: 0 0 0px;\n  position: relative;\n}\n\n.ResizeBar___1o6VK {\n  position: absolute;\n  left: -2px;\n  width: 5px;\n  height: 100%;\n  cursor: ew-resize;\n}\n\n@media screen and (max-width: 600px) {\n  .Components___MlQHS {\n    flex-direction: column;\n  }\n\n  .TreeWrapper___2uPTC {\n    flex: 0 0 var(--vertical-resize-percentage);\n  }\n\n  .InspectedElementWrapper___Ay-WL {\n    flex: 1 1 50%;\n  }\n\n  .ResizeBar___1o6VK {\n    top: -2px;\n    left: 0;\n    width: 100%;\n    height: 5px;\n    cursor: ns-resize;\n  }\n}\n\n.Loading___Slif- {\n  height: 100%;\n  padding-left: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-sans-large);\n  color: var(--color-dim);\n  border-left: 1px solid var(--color-border);\n}\n", ""]), r.locals = {
    Components: "Components___MlQHS",
    TreeWrapper: "TreeWrapper___2uPTC",
    InspectedElementWrapper: "InspectedElementWrapper___Ay-WL",
    ResizeBarWrapper: "ResizeBarWrapper___2jVIz",
    ResizeBar: "ResizeBar___1o6VK",
    Loading: "Loading___Slif-"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".NoCommitData___2oJ_z {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.Header___1oGeD {\n  font-size: var(--font-size-sans-large);\n  margin-bottom: 0.5rem;\n}\n\n.FilterMessage___1Yg5n {\n  display: flex;\n  align-items: center;\n}\n", ""]), r.locals = {
    NoCommitData: "NoCommitData___2oJ_z",
    Header: "Header___1oGeD",
    FilterMessage: "FilterMessage___1Yg5n"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Group___2hArG {\n  transition: all ease-in-out 250ms;\n}\n\n.Rect___fBfs_ {\n  cursor: pointer;\n  stroke: var(--color-background);\n  transition: all ease-in-out 250ms;\n}\n\n.ForeignObject___2EdVc {\n  pointer-events: none;\n  transition: all ease-in-out 250ms;\n}\n\n.Div___1Pgrm {\n  pointer-events: none;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-family: var(--font-family-sans);\n  font-size: var(--font-size-sans-normal);\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n  line-height: 1.5;\n  padding: 0 0 0;\n  font-weight: 400;\n  color: var(--color-commit-gradient-text);\n  text-align: left;\n  transition: all ease-in-out 250ms;\n}\n", ""]), r.locals = {
    Group: "Group___2hArG",
    Rect: "Rect___fBfs_",
    ForeignObject: "ForeignObject___2EdVc",
    Div: "Div___1Pgrm"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Component___3ci_S {\n  margin-bottom: 0.5rem;\n}\n\n.Item___2hxYk {\n  margin-top: 0.25rem;\n}\n\n.Key___1tUd1 {\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-small);\n  line-height: 1;\n}\n\n.Key___1tUd1:first-of-type::before {\n  content: ' (';\n}\n\n.Key___1tUd1::after {\n  content: ', ';\n}\n\n.Key___1tUd1:last-of-type::after {\n  content: ')';\n}\n\n.Label___2zyeV {\n  font-weight: bold;\n}\n", ""]), r.locals = {
    Component: "Component___3ci_S",
    Item: "Item___2hxYk",
    Key: "Key___1tUd1",
    Label: "Label___2zyeV"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Toolbar___3u3I_ {\n  padding: 0.25rem 0;\n  margin-bottom: 0.25rem;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.Content___3i3NJ {\n  user-select: none;\n  overflow-y: auto;\n}\n\n.Component___Y5kFG {\n  flex: 1;\n  font-weight: bold;\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n.Label___3g1xf {\n  font-weight: bold;\n}\n\n.CurrentCommit___21fVV {\n  margin: 0.25rem 0;\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n}\n", ""]), r.locals = {
    Toolbar: "Toolbar___3u3I_",
    Content: "Content___3i3NJ",
    Component: "Component___Y5kFG",
    Label: "Label___3g1xf",
    CurrentCommit: "CurrentCommit___21fVV"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Tooltip___NP68S {\n  position: absolute;\n  pointer-events: none;\n  border: none;\n  border-radius: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  font-family: var(--font-family-sans);\n  font-size: 12px;\n  background-color: var(--color-tooltip-background);\n  color: var(--color-tooltip-text);\n  opacity: 1;\n  white-space: nowrap;\n  /* Make sure this is above the DevTools, which are above the Overlay */\n  z-index: 10000002;\n}\n\n.Tooltip___NP68S.hidden___3rGbV {\n  opacity: 0;\n}\n\n\n.Container___3aJAm {\n  width: -moz-max-content;\n  width: -webkit-max-content;\n}\n", ""]), r.locals = {
    Tooltip: "Tooltip___NP68S",
    hidden: "hidden___3rGbV",
    Container: "Container___3aJAm"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Container___WYOTp {\n  width: 100%;\n  flex: 1;\n  padding: 0.5rem;\n}\n\n.PatternPath___2kgd1 {\n  stroke: var(--color-commit-did-not-render-pattern);\n  stroke-width: 1;\n}\n", ""]), r.locals = {
    Container: "Container___WYOTp",
    PatternPath: "PatternPath___2kgd1"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Container___2D32U {\n  width: 100%;\n  flex: 1;\n  padding: 0.5rem;\n}\n", ""]), r.locals = {
    Container: "Container___2D32U"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Spacer___1c3sH {\n  flex: 1;\n}\n", ""]), r.locals = {
    Spacer: "Spacer___1c3sH"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".ActiveRecordToggle___1Cpcb {\n  color: var(--color-record-active);\n}\n.ActiveRecordToggle___1Cpcb:hover {\n  color: var(--color-record-active);\n}\n.ActiveRecordToggle___1Cpcb:focus {\n  color: var(--color-record-active);\n}\n.ActiveRecordToggle___1Cpcb:active {\n  color: var(--color-record-hover);\n}\n\n.InactiveRecordToggle___2CUtF {\n  color: var(--color-record-inactive);\n}\n.InactiveRecordToggle___2CUtF:hover {\n  color: var(--color-record-hover);\n}\n.InactiveRecordToggle___2CUtF:focus {\n  color: var(--color-record-inactive);\n}\n.InactiveRecordToggle___2CUtF:active {\n  color: var(--color-record-hover);\n}\n\n.DisabledRecordToggle___gcsbF {\n  color: var(--color-button-disabled);\n}\n.DisabledRecordToggle___gcsbF:hover {\n  color: var(--color-button-disabled);\n}\n.DisabledRecordToggle___gcsbF:focus {\n  color: var(--color-button-disabled);\n}\n.DisabledRecordToggle___gcsbF:active {\n  color: var(--color-button-disabled);\n}\n", ""]), r.locals = {
    ActiveRecordToggle: "ActiveRecordToggle___1Cpcb",
    InactiveRecordToggle: "InactiveRecordToggle___2CUtF",
    DisabledRecordToggle: "DisabledRecordToggle___gcsbF"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Profiler___20Ry4 {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  font-family: var(--font-family-sans);\n  font-size: var(--font-size-sans-normal);\n  background-color: var(--color-background);\n  color: var(--color-text);\n}\n\n.Profiler___20Ry4, .Profiler___20Ry4 * {\n  box-sizing: border-box;\n  -webkit-font-smoothing: var(--font-smoothing);\n}\n\n.LeftColumn___3I7-I {\n  display: flex;\n  flex-direction: column;\n  flex: 2 1 200px;\n  border-top: 1px solid var(--color-border);\n}\n\n.RightColumn___3smXD {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 100px;\n  max-width: 300px;\n  overflow-x: hidden;\n  border-left: 1px solid var(--color-border);\n  border-top: 1px solid var(--color-border);\n}\n\n.Content___1LjDy {\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.Column___3WWtw {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0 1rem;\n}\n\n.Paragraph___1HLty {\n  text-align: center;\n}\n\n.Row___1RpSu {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.LearnMoreRow___3lYIu {\n  margin-top: 1rem;\n  color: var(--color-dim);\n  font-size: var(--font-size-sans-small);\n}\n\n.Header___QyJw2 {\n  font-size: var(--font-size-sans-large);\n  margin-bottom: 0.5rem;\n}\n\n.Toolbar___30kHu {\n  height: 2.25rem;\n  padding: 0 0.25rem;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.VRule___2y9G3 {\n  height: 20px;\n  width: 1px;\n  border-left: 1px solid var(--color-border);\n  padding-left: 0.25rem;\n  margin-left: 0.25rem;\n}\n\n.Spacer___1sezP {\n  flex: 1;\n}\n\n.StopRecordingButton___1-ElU {\n  font-size: var(--font-size-sans-large);\n  padding: 0.5rem;\n}\n\n.ContentFallback___2Ata2 {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-sans-large);\n  color: var(--color-dim);\n}\n\n.SnapshotSelectorFallback___3fsFv {\n  height: 100%;\n  padding-left: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-sans-large);\n  color: var(--color-dim);\n}\n\n.Link___mZ2LE {\n  color: var(--color-button);\n}\n\n.TimelineSearchInputContainer___33BJF {\n  flex: 1 1;\n  display: flex;\n  align-items: center;\n}\n\n.LearnMoreLink___7A9ws {\n  color: var(--color-link);\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}", ""]), r.locals = {
    Profiler: "Profiler___20Ry4",
    LeftColumn: "LeftColumn___3I7-I",
    RightColumn: "RightColumn___3smXD",
    Content: "Content___1LjDy",
    Column: "Column___3WWtw",
    Paragraph: "Paragraph___1HLty",
    Row: "Row___1RpSu",
    LearnMoreRow: "LearnMoreRow___3lYIu",
    Header: "Header___QyJw2",
    Toolbar: "Toolbar___30kHu",
    VRule: "VRule___2y9G3",
    Spacer: "Spacer___1sezP",
    StopRecordingButton: "StopRecordingButton___1-ElU",
    ContentFallback: "ContentFallback___2Ata2",
    SnapshotSelectorFallback: "SnapshotSelectorFallback___3fsFv",
    Link: "Link___mZ2LE",
    TimelineSearchInputContainer: "TimelineSearchInputContainer___33BJF",
    LearnMoreLink: "LearnMoreLink___7A9ws"
  };
}, function (e, r, t) {
  "use strict";

  e.exports = e => {
    if ("number" != typeof e) throw new TypeError("Expected a number");
    const r = e > 0 ? Math.floor : Math.ceil;
    return {
      days: r(e / 86400000),
      hours: r(e / 3600000) % 24,
      minutes: r(e / 60000) % 60,
      seconds: r(e / 1000) % 60,
      milliseconds: r(e) % 1000,
      microseconds: r(1000 * e) % 1000,
      nanoseconds: r(1000000 * e) % 1000
    };
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Tooltip___zx7EV {\n  position: fixed;\n}\n\n.TooltipSection___1ymuA,\n.TooltipWarningSection___3NM2z,\n.SingleLineTextSection___Xt1VX {\n  display: block;\n  border-radius: 0.125rem;\n  padding: 0.25rem;\n  user-select: none;\n  pointer-events: none;\n  background-color: var(--color-tooltip-background);\n  box-shadow: 1px 1px 2px var(--color-shadow);\n  color: var(--color-tooltip-text);\n  font-size: 11px;\n}\n.TooltipWarningSection___3NM2z {\n  margin-top: 0.25rem;\n  background-color: var(--color-warning-background);\n}\n.TooltipSection___1ymuA,\n.TooltipWarningSection___3NM2z {\n  max-width: 300px;\n}\n.SingleLineTextSection___Xt1VX {\n  white-space: nowrap;\n}\n\n.Divider___3WRJj {\n  height: 1px;\n  background-color: #aaa;\n  margin: 0.25rem 0;\n}\n\n.DetailsGrid___2geMz {\n  display: grid;\n  padding-top: 5px;\n  grid-gap: 2px 5px;\n  grid-template-columns: min-content auto;\n}\n\n.DetailsGridLabel___Vo1pu {\n  color: var(--color-dim);\n  text-align: right;\n  white-space: nowrap;\n}\n\n.DetailsGridLongValue___3vEFb {\n  word-break: break-all;\n  max-height: 50vh;\n  overflow: hidden;\n}\n\n.FlamechartStackFrameName___15Syk {\n  word-break: break-word;\n}\n\n.ComponentName___M_PGg {\n  font-weight: bold;\n  word-break: break-word;\n  margin-right: 0.25rem;\n}\n\n.ReactMeasureLabel___rpyRN {\n}\n\n.UserTimingLabel___1Fpxr {\n  word-break: break-word;\n}\n\n.NativeEventName___HXtAH {\n  font-weight: bold;\n  word-break: break-word;\n  margin-right: 0.25rem;\n}\n\n.InfoText___1A4gs,\n.WarningText___cf1lY {\n  color: var(--color-warning-text-color);\n}\n\n.Image___3nrFz {\n  border: 1px solid var(--color-border);\n}\n\n.DimText___asq74 {\n  color: var(--color-dim);\n}", ""]), r.locals = {
    Tooltip: "Tooltip___zx7EV",
    TooltipSection: "TooltipSection___1ymuA",
    TooltipWarningSection: "TooltipWarningSection___3NM2z",
    SingleLineTextSection: "SingleLineTextSection___Xt1VX",
    Divider: "Divider___3WRJj",
    DetailsGrid: "DetailsGrid___2geMz",
    DetailsGridLabel: "DetailsGridLabel___Vo1pu",
    DetailsGridLongValue: "DetailsGridLongValue___3vEFb",
    FlamechartStackFrameName: "FlamechartStackFrameName___15Syk",
    ComponentName: "ComponentName___M_PGg",
    ReactMeasureLabel: "ReactMeasureLabel___rpyRN",
    UserTimingLabel: "UserTimingLabel___1Fpxr",
    NativeEventName: "NativeEventName___HXtAH",
    InfoText: "InfoText___1A4gs",
    WarningText: "WarningText___cf1lY",
    Image: "Image___3nrFz",
    DimText: "DimText___asq74"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".CanvasPage___1bMJ5 {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n", ""]), r.locals = {
    CanvasPage: "CanvasPage___1bMJ5"
  };
}, function (e, r, t) {
  var n = function (e) {
    "use strict";

    var r = Object.prototype,
      t = r.hasOwnProperty,
      n = "function" == typeof Symbol ? Symbol : {},
      a = n.iterator || "@@iterator",
      i = n.asyncIterator || "@@asyncIterator",
      o = n.toStringTag || "@@toStringTag";
    function s(e, r, t) {
      return Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), e[r];
    }
    try {
      s({}, "");
    } catch (e) {
      s = function (e, r, t) {
        return e[r] = t;
      };
    }
    function l(e, r, t, n) {
      var a = r && r.prototype instanceof f ? r : f,
        i = Object.create(a.prototype),
        o = new y(n || []);
      return i._invoke = function (e, r, t) {
        var n = "suspendedStart";
        return function (a, i) {
          if ("executing" === n) throw new Error("Generator is already running");
          if ("completed" === n) {
            if ("throw" === a) throw i;
            return C();
          }
          for (t.method = a, t.arg = i;;) {
            var o = t.delegate;
            if (o) {
              var s = S(o, t);
              if (s) {
                if (s === u) continue;
                return s;
              }
            }
            if ("next" === t.method) t.sent = t._sent = t.arg;else if ("throw" === t.method) {
              if ("suspendedStart" === n) throw n = "completed", t.arg;
              t.dispatchException(t.arg);
            } else "return" === t.method && t.abrupt("return", t.arg);
            n = "executing";
            var l = c(e, r, t);
            if ("normal" === l.type) {
              if (n = t.done ? "completed" : "suspendedYield", l.arg === u) continue;
              return {
                value: l.arg,
                done: t.done
              };
            }
            "throw" === l.type && (n = "completed", t.method = "throw", t.arg = l.arg);
          }
        };
      }(e, t, o), i;
    }
    function c(e, r, t) {
      try {
        return {
          type: "normal",
          arg: e.call(r, t)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }
    e.wrap = l;
    var u = {};
    function f() {}
    function d() {}
    function v() {}
    var h = {};
    h[a] = function () {
      return this || _global;
    };
    var m = Object.getPrototypeOf,
      _ = m && m(m(k([])));
    _ && _ !== r && t.call(_, a) && (h = _);
    var p = v.prototype = f.prototype = Object.create(h);
    function g(e) {
      ["next", "throw", "return"].forEach(function (r) {
        s(e, r, function (e) {
          return this._invoke(r, e);
        });
      });
    }
    function b(e, r) {
      var n;
      (this || _global)._invoke = function (a, i) {
        function o() {
          return new r(function (n, o) {
            !function n(a, i, o, s) {
              var l = c(e[a], e, i);
              if ("throw" !== l.type) {
                var u = l.arg,
                  f = u.value;
                return f && "object" == typeof f && t.call(f, "__await") ? r.resolve(f.__await).then(function (e) {
                  n("next", e, o, s);
                }, function (e) {
                  n("throw", e, o, s);
                }) : r.resolve(f).then(function (e) {
                  u.value = e, o(u);
                }, function (e) {
                  return n("throw", e, o, s);
                });
              }
              s(l.arg);
            }(a, i, n, o);
          });
        }
        return n = n ? n.then(o, o) : o();
      };
    }
    function S(e, r) {
      var t = e.iterator[r.method];
      if (void 0 === t) {
        if (r.delegate = null, "throw" === r.method) {
          if (e.iterator.return && (r.method = "return", r.arg = void 0, S(e, r), "throw" === r.method)) return u;
          r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return u;
      }
      var n = c(t, e.iterator, r.arg);
      if ("throw" === n.type) return r.method = "throw", r.arg = n.arg, r.delegate = null, u;
      var a = n.arg;
      return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = void 0), r.delegate = null, u) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, u);
    }
    function E(e) {
      var r = {
        tryLoc: e[0]
      };
      1 in e && (r.catchLoc = e[1]), 2 in e && (r.finallyLoc = e[2], r.afterLoc = e[3]), (this || _global).tryEntries.push(r);
    }
    function w(e) {
      var r = e.completion || {};
      r.type = "normal", delete r.arg, e.completion = r;
    }
    function y(e) {
      (this || _global).tryEntries = [{
        tryLoc: "root"
      }], e.forEach(E, this || _global), this.reset(!0);
    }
    function k(e) {
      if (e) {
        var r = e[a];
        if (r) return r.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) {
          var n = -1,
            i = function r() {
              for (; ++n < e.length;) if (t.call(e, n)) return r.value = e[n], r.done = !1, r;
              return r.value = void 0, r.done = !0, r;
            };
          return i.next = i;
        }
      }
      return {
        next: C
      };
    }
    function C() {
      return {
        value: void 0,
        done: !0
      };
    }
    return d.prototype = p.constructor = v, v.constructor = d, d.displayName = s(v, o, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
      var r = "function" == typeof e && e.constructor;
      return !!r && (r === d || "GeneratorFunction" === (r.displayName || r.name));
    }, e.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, v) : (e.__proto__ = v, s(e, o, "GeneratorFunction")), e.prototype = Object.create(p), e;
    }, e.awrap = function (e) {
      return {
        __await: e
      };
    }, g(b.prototype), b.prototype[i] = function () {
      return this || _global;
    }, e.AsyncIterator = b, e.async = function (r, t, n, a, i) {
      void 0 === i && (i = Promise);
      var o = new b(l(r, t, n, a), i);
      return e.isGeneratorFunction(t) ? o : o.next().then(function (e) {
        return e.done ? e.value : o.next();
      });
    }, g(p), s(p, o, "Generator"), p[a] = function () {
      return this || _global;
    }, p.toString = function () {
      return "[object Generator]";
    }, e.keys = function (e) {
      var r = [];
      for (var t in e) r.push(t);
      return r.reverse(), function t() {
        for (; r.length;) {
          var n = r.pop();
          if (n in e) return t.value = n, t.done = !1, t;
        }
        return t.done = !0, t;
      };
    }, e.values = k, y.prototype = {
      constructor: y,
      reset: function (e) {
        if ((this || _global).prev = 0, (this || _global).next = 0, (this || _global).sent = (this || _global)._sent = void 0, (this || _global).done = !1, (this || _global).delegate = null, (this || _global).method = "next", (this || _global).arg = void 0, (this || _global).tryEntries.forEach(w), !e) for (var r in this || _global) "t" === r.charAt(0) && t.call(this || _global, r) && !isNaN(+r.slice(1)) && ((this || _global)[r] = void 0);
      },
      stop: function () {
        (this || _global).done = !0;
        var e = (this || _global).tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return (this || _global).rval;
      },
      dispatchException: function (e) {
        if ((this || _global).done) throw e;
        var r = this || _global;
        function n(t, n) {
          return o.type = "throw", o.arg = e, r.next = t, n && (r.method = "next", r.arg = void 0), !!n;
        }
        for (var a = (this || _global).tryEntries.length - 1; a >= 0; --a) {
          var i = (this || _global).tryEntries[a],
            o = i.completion;
          if ("root" === i.tryLoc) return n("end");
          if (i.tryLoc <= (this || _global).prev) {
            var s = t.call(i, "catchLoc"),
              l = t.call(i, "finallyLoc");
            if (s && l) {
              if ((this || _global).prev < i.catchLoc) return n(i.catchLoc, !0);
              if ((this || _global).prev < i.finallyLoc) return n(i.finallyLoc);
            } else if (s) {
              if ((this || _global).prev < i.catchLoc) return n(i.catchLoc, !0);
            } else {
              if (!l) throw new Error("try statement without catch or finally");
              if ((this || _global).prev < i.finallyLoc) return n(i.finallyLoc);
            }
          }
        }
      },
      abrupt: function (e, r) {
        for (var n = (this || _global).tryEntries.length - 1; n >= 0; --n) {
          var a = (this || _global).tryEntries[n];
          if (a.tryLoc <= (this || _global).prev && t.call(a, "finallyLoc") && (this || _global).prev < a.finallyLoc) {
            var i = a;
            break;
          }
        }
        i && ("break" === e || "continue" === e) && i.tryLoc <= r && r <= i.finallyLoc && (i = null);
        var o = i ? i.completion : {};
        return o.type = e, o.arg = r, i ? ((this || _global).method = "next", (this || _global).next = i.finallyLoc, u) : this.complete(o);
      },
      complete: function (e, r) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? (this || _global).next = e.arg : "return" === e.type ? ((this || _global).rval = (this || _global).arg = e.arg, (this || _global).method = "return", (this || _global).next = "end") : "normal" === e.type && r && ((this || _global).next = r), u;
      },
      finish: function (e) {
        for (var r = (this || _global).tryEntries.length - 1; r >= 0; --r) {
          var t = (this || _global).tryEntries[r];
          if (t.finallyLoc === e) return this.complete(t.completion, t.afterLoc), w(t), u;
        }
      },
      catch: function (e) {
        for (var r = (this || _global).tryEntries.length - 1; r >= 0; --r) {
          var t = (this || _global).tryEntries[r];
          if (t.tryLoc === e) {
            var n = t.completion;
            if ("throw" === n.type) {
              var a = n.arg;
              w(t);
            }
            return a;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function (e, r, t) {
        return (this || _global).delegate = {
          iterator: k(e),
          resultName: r,
          nextLoc: t
        }, "next" === (this || _global).method && ((this || _global).arg = void 0), u;
      }
    }, e;
  }(e.exports);
  try {
    _global.regeneratorRuntime = n;
  } catch (e) {
    Function("r", "regeneratorRuntime = r")(n);
  }
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.importFromOldV8CPUProfile = r.importFromChromeCPUProfile = r.importFromChromeTimeline = r.isChromeTimeline = void 0;
  const n = t(186),
    a = t(53),
    i = t(83),
    o = t(188);
  r.isChromeTimeline = function (e) {
    if (!Array.isArray(e)) return !1;
    if (e.length < 1) return !1;
    const r = e[0];
    return "pid" in r && "tid" in r && "ph" in r && "cat" in r && !!e.find(e => "CpuProfile" === e.name || "Profile" === e.name || "ProfileChunk" === e.name);
  }, r.importFromChromeTimeline = function (e, r) {
    const t = new Map(),
      n = new Map(),
      i = new Map();
    a.sortBy(e, e => e.ts);
    for (let r of e) {
      if ("CpuProfile" === r.name) {
        const e = `${r.pid}:${r.tid}`,
          a = r.id || e;
        t.set(a, r.args.data.cpuProfile), n.set(a, e);
      }
      if ("Profile" === r.name) {
        const e = `${r.pid}:${r.tid}`;
        t.set(r.id || e, Object.assign({
          startTime: 0,
          endTime: 0,
          nodes: [],
          samples: [],
          timeDeltas: []
        }, r.args.data)), r.id && n.set(r.id, `${r.pid}:${r.tid}`);
      }
      if ("thread_name" === r.name && i.set(`${r.pid}:${r.tid}`, r.args.name), "ProfileChunk" === r.name) {
        const e = `${r.pid}:${r.tid}`,
          n = t.get(r.id || e);
        if (n) {
          const e = r.args.data;
          e.cpuProfile && (e.cpuProfile.nodes && (n.nodes = n.nodes.concat(e.cpuProfile.nodes)), e.cpuProfile.samples && (n.samples = n.samples.concat(e.cpuProfile.samples))), e.timeDeltas && (n.timeDeltas = n.timeDeltas.concat(e.timeDeltas)), null != e.startTime && (n.startTime = e.startTime), null != e.endTime && (n.endTime = e.endTime);
        } else console.warn("Ignoring ProfileChunk for undeclared Profile with id " + (r.id || e));
      }
    }
    if (t.size > 0) {
      const e = [];
      let o = 0;
      return a.itForEach(t.keys(), a => {
        let s = null,
          l = n.get(a);
        l && (s = i.get(l) || null);
        const c = f(t.get(a));
        s && t.size > 1 ? (c.setName(`${r} - ${s}`), "CrRendererMain" === s && (o = e.length)) : c.setName("" + r), e.push(c);
      }), {
        name: r,
        indexToView: o,
        profiles: e
      };
    }
    throw new Error("Could not find CPU profile in Timeline");
  };
  const s = new Map();
  function l(e) {
    return a.getOrInsert(s, e, e => {
      const r = e.functionName || "(anonymous)",
        t = e.url,
        n = e.lineNumber,
        a = e.columnNumber;
      return {
        key: `${r}:${t}:${n}:${a}`,
        name: r,
        file: t,
        line: n,
        col: a
      };
    });
  }
  function c(e) {
    const {
      functionName: r,
      url: t
    } = e;
    return "native dummy.js" === t || "(root)" === r || "(idle)" === r;
  }
  function u(e) {
    return "(garbage collector)" === e || "(program)" === e;
  }
  function f(e) {
    const r = new n.CallTreeProfileBuilder(e.endTime - e.startTime),
      t = new Map();
    for (let r of e.nodes) t.set(r.id, r);
    for (let r of e.nodes) if ("number" == typeof r.parent && (r.parent = t.get(r.parent)), r.children) for (let e of r.children) {
      const n = t.get(e);
      n && (n.parent = r);
    }
    const o = [],
      s = [];
    let f = e.timeDeltas[0],
      d = f,
      v = NaN;
    for (let r = 0; r < e.samples.length; r++) {
      const t = e.samples[r];
      if (t != v && (o.push(t), f < d ? s.push(d) : (s.push(f), d = f)), r === e.samples.length - 1) isNaN(v) || (o.push(v), f < d ? s.push(d) : (s.push(f), d = f));else {
        f += e.timeDeltas[r + 1], v = t;
      }
    }
    let h = [];
    for (let e = 0; e < o.length; e++) {
      const n = s[e],
        i = o[e];
      let f = t.get(i);
      if (!f) continue;
      let d = null;
      for (d = f; d && -1 === h.indexOf(d); d = u(d.callFrame.functionName) ? a.lastOf(h) : d.parent || null);
      for (; h.length > 0 && a.lastOf(h) != d;) {
        const e = l(h.pop().callFrame);
        r.leaveFrame(e, n);
      }
      const v = [];
      for (let e = f; e && e != d && !c(e.callFrame); e = u(e.callFrame.functionName) ? a.lastOf(h) : e.parent || null) v.push(e);
      v.reverse();
      for (let e of v) r.enterFrame(l(e.callFrame), n);
      h = h.concat(v);
    }
    for (let e = h.length - 1; e >= 0; e--) r.leaveFrame(l(h[e].callFrame), a.lastOf(s));
    return r.setValueFormatter(new i.TimeFormatter("microseconds")), r.build();
  }
  r.importFromChromeCPUProfile = f, r.importFromOldV8CPUProfile = function (e) {
    return f(o.chromeTreeToNodes(e));
  };
}, function (e, r, t) {
  "use strict";

  var n = (this || _global) && (this || _global).__createBinding || (Object.create ? function (e, r, t, n) {
      void 0 === n && (n = t), Object.defineProperty(e, n, {
        enumerable: !0,
        get: function () {
          return r[t];
        }
      });
    } : function (e, r, t, n) {
      void 0 === n && (n = t), e[n] = r[t];
    }),
    a = (this || _global) && (this || _global).__setModuleDefault || (Object.create ? function (e, r) {
      Object.defineProperty(e, "default", {
        enumerable: !0,
        value: r
      });
    } : function (e, r) {
      e.default = r;
    }),
    i = (this || _global) && (this || _global).__importStar || function (e) {
      if (e && e.__esModule) return e;
      var r = {};
      if (null != e) for (var t in e) Object.hasOwnProperty.call(e, t) && n(r, e, t);
      return a(r, e), r;
    },
    o = (this || _global) && (this || _global).__awaiter || function (e, r, t, n) {
      return new (t || (t = Promise))(function (a, i) {
        function o(e) {
          try {
            l(n.next(e));
          } catch (e) {
            i(e);
          }
        }
        function s(e) {
          try {
            l(n.throw(e));
          } catch (e) {
            i(e);
          }
        }
        function l(e) {
          var r;
          e.done ? a(e.value) : (r = e.value, r instanceof t ? r : new t(function (e) {
            e(r);
          })).then(o, s);
        }
        l((n = n.apply(e, r || [])).next());
      });
    };
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.CallTreeProfileBuilder = r.StackListProfileBuilder = r.Profile = r.CallTreeNode = r.Frame = r.HasWeights = void 0;
  const s = t(53),
    l = t(83),
    c = Promise.resolve().then(() => i(t(187)));
  c.then(() => {});
  class u {
    constructor() {
      this.selfWeight = 0, this.totalWeight = 0;
    }
    getSelfWeight() {
      return this.selfWeight;
    }
    getTotalWeight() {
      return this.totalWeight;
    }
    addToTotalWeight(e) {
      this.totalWeight += e;
    }
    addToSelfWeight(e) {
      this.selfWeight += e;
    }
    overwriteWeightWith(e) {
      this.selfWeight = e.selfWeight, this.totalWeight = e.totalWeight;
    }
  }
  r.HasWeights = u;
  let f = (() => {
    class e extends u {
      constructor(e) {
        super(), this.key = e.key, this.name = e.name, this.file = e.file, this.line = e.line, this.col = e.col;
      }
      static getOrInsert(r, t) {
        return r.getOrInsert(new e(t));
      }
    }
    return e.root = new e({
      key: "(speedscope root)",
      name: "(speedscope root)"
    }), e;
  })();
  r.Frame = f;
  class d extends u {
    constructor(e, r) {
      super(), this.frame = e, this.parent = r, this.children = [], this.frozen = !1;
    }
    isRoot() {
      return this.frame === f.root;
    }
    isFrozen() {
      return this.frozen;
    }
    freeze() {
      this.frozen = !0;
    }
  }
  r.CallTreeNode = d;
  class v {
    constructor(e = 0) {
      this.name = "", this.frames = new s.KeyedSet(), this.appendOrderCalltreeRoot = new d(f.root, null), this.groupedCalltreeRoot = new d(f.root, null), this.samples = [], this.weights = [], this.valueFormatter = new l.RawValueFormatter(), this.totalNonIdleWeight = null, this.totalWeight = e;
    }
    getAppendOrderCalltreeRoot() {
      return this.appendOrderCalltreeRoot;
    }
    getGroupedCalltreeRoot() {
      return this.groupedCalltreeRoot;
    }
    formatValue(e) {
      return this.valueFormatter.format(e);
    }
    setValueFormatter(e) {
      this.valueFormatter = e;
    }
    getWeightUnit() {
      return this.valueFormatter.unit;
    }
    getName() {
      return this.name;
    }
    setName(e) {
      this.name = e;
    }
    getTotalWeight() {
      return this.totalWeight;
    }
    getTotalNonIdleWeight() {
      return null === this.totalNonIdleWeight && (this.totalNonIdleWeight = this.groupedCalltreeRoot.children.reduce((e, r) => e + r.getTotalWeight(), 0)), this.totalNonIdleWeight;
    }
    sortGroupedCallTree() {
      !function e(r) {
        r.children.sort((e, r) => -(e.getTotalWeight() - r.getTotalWeight())), r.children.forEach(e);
      }(this.groupedCalltreeRoot);
    }
    forEachCallGrouped(e, r) {
      !function t(n, a) {
        n.frame !== f.root && e(n, a);
        let i = 0;
        n.children.forEach(function (e) {
          t(e, a + i), i += e.getTotalWeight();
        }), n.frame !== f.root && r(n, a + n.getTotalWeight());
      }(this.groupedCalltreeRoot, 0);
    }
    forEachCall(e, r) {
      let t = [],
        n = 0,
        a = 0;
      for (let i of this.samples) {
        let o = null;
        for (o = i; o && o.frame != f.root && -1 === t.indexOf(o); o = o.parent);
        for (; t.length > 0 && s.lastOf(t) != o;) {
          r(t.pop(), n);
        }
        const l = [];
        for (let e = i; e && e.frame != f.root && e != o; e = e.parent) l.push(e);
        l.reverse();
        for (let r of l) e(r, n);
        t = t.concat(l), n += this.weights[a++];
      }
      for (let e = t.length - 1; e >= 0; e--) r(t[e], n);
    }
    forEachFrame(e) {
      this.frames.forEach(e);
    }
    getProfileWithRecursionFlattened() {
      const e = new m(),
        r = [],
        t = new Set();
      this.forEachCall(function (n, a) {
        t.has(n.frame) ? r.push(null) : (t.add(n.frame), r.push(n), e.enterFrame(n.frame, a));
      }, function (n, a) {
        const i = r.pop();
        i && (t.delete(i.frame), e.leaveFrame(i.frame, a));
      });
      const n = e.build();
      return n.name = this.name, n.valueFormatter = this.valueFormatter, this.forEachFrame(e => {
        n.frames.getOrInsert(e).overwriteWeightWith(e);
      }), n;
    }
    getInvertedProfileForCallersOf(e) {
      const r = f.getOrInsert(this.frames, e),
        t = new h(),
        n = [];
      !function e(t) {
        if (t.frame === r) n.push(t);else for (let r of t.children) e(r);
      }(this.appendOrderCalltreeRoot);
      for (let e of n) {
        const r = [];
        for (let t = e; null != t && t.frame !== f.root; t = t.parent) r.push(t.frame);
        t.appendSampleWithWeight(r, e.getTotalWeight());
      }
      const a = t.build();
      return a.name = this.name, a.valueFormatter = this.valueFormatter, a;
    }
    getProfileForCalleesOf(e) {
      const r = f.getOrInsert(this.frames, e),
        t = new h();
      !function e(n) {
        if (n.frame === r) !function (e) {
          const r = [];
          !function e(n) {
            r.push(n.frame), t.appendSampleWithWeight(r, n.getSelfWeight());
            for (let r of n.children) e(r);
            r.pop();
          }(e);
        }(n);else for (let r of n.children) e(r);
      }(this.appendOrderCalltreeRoot);
      const n = t.build();
      return n.name = this.name, n.valueFormatter = this.valueFormatter, n;
    }
    demangle() {
      return o(this, void 0, void 0, function* () {
        let e = null;
        for (let r of this.frames) r.name.startsWith("__Z") && (e || (e = (yield c).demangleCpp), r.name = e(r.name));
      });
    }
    remapNames(e) {
      for (let r of this.frames) r.name = e(r.name);
    }
  }
  r.Profile = v;
  class h extends v {
    constructor() {
      super(...arguments), this.pendingSample = null;
    }
    _appendSample(e, r, t) {
      if (isNaN(r)) throw new Error("invalid weight");
      let n = t ? this.appendOrderCalltreeRoot : this.groupedCalltreeRoot,
        a = new Set();
      for (let i of e) {
        const e = f.getOrInsert(this.frames, i),
          o = t ? s.lastOf(n.children) : n.children.find(r => r.frame === e);
        if (o && !o.isFrozen() && o.frame == e) n = o;else {
          const r = n;
          n = new d(e, n), r.children.push(n);
        }
        n.addToTotalWeight(r), a.add(n.frame);
      }
      if (n.addToSelfWeight(r), t) for (let e of n.children) e.freeze();
      if (t) {
        n.frame.addToSelfWeight(r);
        for (let e of a) e.addToTotalWeight(r);
        n === s.lastOf(this.samples) ? this.weights[this.weights.length - 1] += r : (this.samples.push(n), this.weights.push(r));
      }
    }
    appendSampleWithWeight(e, r) {
      if (0 !== r) {
        if (r < 0) throw new Error("Samples must have positive weights");
        this._appendSample(e, r, !0), this._appendSample(e, r, !1);
      }
    }
    appendSampleWithTimestamp(e, r) {
      if (this.pendingSample) {
        if (r < this.pendingSample.centralTimestamp) throw new Error("Timestamps received out of order");
        const t = (r + this.pendingSample.centralTimestamp) / 2;
        this.appendSampleWithWeight(this.pendingSample.stack, t - this.pendingSample.startTimestamp), this.pendingSample = {
          stack: e,
          startTimestamp: t,
          centralTimestamp: r
        };
      } else this.pendingSample = {
        stack: e,
        startTimestamp: r,
        centralTimestamp: r
      };
    }
    build() {
      return this.pendingSample && (this.samples.length > 0 ? this.appendSampleWithWeight(this.pendingSample.stack, this.pendingSample.centralTimestamp - this.pendingSample.startTimestamp) : (this.appendSampleWithWeight(this.pendingSample.stack, 1), this.setValueFormatter(new l.RawValueFormatter()))), this.totalWeight = Math.max(this.totalWeight, this.weights.reduce((e, r) => e + r, 0)), this.sortGroupedCallTree(), this;
    }
  }
  r.StackListProfileBuilder = h;
  class m extends v {
    constructor() {
      super(...arguments), this.appendOrderStack = [this.appendOrderCalltreeRoot], this.groupedOrderStack = [this.groupedCalltreeRoot], this.framesInStack = new Map(), this.stack = [], this.lastValue = 0;
    }
    addWeightsToFrames(e) {
      const r = e - this.lastValue;
      for (let e of this.framesInStack.keys()) e.addToTotalWeight(r);
      const t = s.lastOf(this.stack);
      t && t.addToSelfWeight(r);
    }
    addWeightsToNodes(e, r) {
      const t = e - this.lastValue;
      for (let e of r) e.addToTotalWeight(t);
      const n = s.lastOf(r);
      n && n.addToSelfWeight(t);
    }
    _enterFrame(e, r, t) {
      let n = t ? this.appendOrderStack : this.groupedOrderStack;
      this.addWeightsToNodes(r, n);
      let a = s.lastOf(n);
      if (a) {
        if (t) {
          const e = r - this.lastValue;
          if (e > 0) this.samples.push(a), this.weights.push(r - this.lastValue);else if (e < 0) throw new Error(`Samples must be provided in increasing order of cumulative value. Last sample was ${this.lastValue}, this sample was ${r}`);
        }
        const i = t ? s.lastOf(a.children) : a.children.find(r => r.frame === e);
        let o;
        i && !i.isFrozen() && i.frame == e ? o = i : (o = new d(e, a), a.children.push(o)), n.push(o);
      }
    }
    enterFrame(e, r) {
      const t = f.getOrInsert(this.frames, e);
      this.addWeightsToFrames(r), this._enterFrame(t, r, !0), this._enterFrame(t, r, !1), this.stack.push(t);
      const n = this.framesInStack.get(t) || 0;
      this.framesInStack.set(t, n + 1), this.lastValue = r;
    }
    _leaveFrame(e, r, t) {
      let n = t ? this.appendOrderStack : this.groupedOrderStack;
      if (this.addWeightsToNodes(r, n), t) {
        const t = this.appendOrderStack.pop();
        if (null == t) throw new Error(`Trying to leave ${e.key} when stack is empty`);
        if (null == this.lastValue) throw new Error(`Trying to leave a ${e.key} before any have been entered`);
        if (t.freeze(), t.frame.key !== e.key) throw new Error(`Tried to leave frame "${e.name}" while frame "${t.frame.name}" was at the top at ${r}`);
        const n = r - this.lastValue;
        if (n > 0) this.samples.push(t), this.weights.push(r - this.lastValue);else if (n < 0) throw new Error(`Samples must be provided in increasing order of cumulative value. Last sample was ${this.lastValue}, this sample was ${r}`);
      } else this.groupedOrderStack.pop();
    }
    leaveFrame(e, r) {
      const t = f.getOrInsert(this.frames, e);
      this.addWeightsToFrames(r), this._leaveFrame(t, r, !0), this._leaveFrame(t, r, !1), this.stack.pop();
      const n = this.framesInStack.get(t);
      null != n && (1 === n ? this.framesInStack.delete(t) : this.framesInStack.set(t, n - 1), this.lastValue = r, this.totalWeight = Math.max(this.totalWeight, this.lastValue));
    }
    build() {
      if (this.appendOrderStack.length > 1 || this.groupedOrderStack.length > 1) throw new Error("Tried to complete profile construction with a non-empty stack");
      return this.sortGroupedCallTree(), this;
    }
  }
  r.CallTreeProfileBuilder = m;
}, function (e, r, t) {
  "use strict";

  let n;
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.demangleCpp = void 0;
  const a = new Map();
  r.demangleCpp = function (e) {
    if (e.startsWith("__Z")) {
      let r = a.get(e);
      void 0 !== r || (n || (n = new Function("exports", i)()), r = n(e.slice(1)), r = "(null)" === r ? e : r, a.set(e, r)), e = r;
    }
    return e;
  };
  const i = "\nreturn function(){function r(r){eval.call(null,r)}function a(r){throw print(r+\":\\n\"+(new Error).stack),ke=!0,\"Assertion: \"+r}function e(r,e){r||a(\"Assertion failed: \"+e)}function i(r,a,i,v){function t(r,a){if(\"string\"==a){var e=Oe;return le.stackAlloc(r.length+1),A(r,e),e}return r}function f(r,a){return\"string\"==a?s(r):r}try{func=ce.Module[\"_\"+r]}catch(r){}e(func,\"Cannot call unknown function \"+r+\" (perhaps LLVM optimizations or closure removed it?)\");var _=0,n=v?v.map(function(r){return t(r,i[_++])}):[];return f(func.apply(null,n),a)}function v(r,a,e){return function(){return i(r,a,e,Array.prototype.slice.call(arguments))}}function t(r,e,i,v){switch(i=i||\"i8\",\"*\"===i[i.length-1]&&(i=\"i32\"),i){case\"i1\":Ae[r]=e;break;case\"i8\":Ae[r]=e;break;case\"i16\":ye[r>>1]=e;break;case\"i32\":Se[r>>2]=e;break;case\"i64\":Se[r>>2]=e;break;case\"float\":Ce[r>>2]=e;break;case\"double\":ze[0]=e,Se[r>>2]=xe[0],Se[r+4>>2]=xe[1];break;default:a(\"invalid type for setValue: \"+i)}}function f(r,e,i){switch(e=e||\"i8\",\"*\"===e[e.length-1]&&(e=\"i32\"),e){case\"i1\":return Ae[r];case\"i8\":return Ae[r];case\"i16\":return ye[r>>1];case\"i32\":return Se[r>>2];case\"i64\":return Se[r>>2];case\"float\":return Ce[r>>2];case\"double\":return xe[0]=Se[r>>2],xe[1]=Se[r+4>>2],ze[0];default:a(\"invalid type for setValue: \"+e)}return null}function _(r,a,e){var i,v;\"number\"==typeof r?(i=!0,v=r):(i=!1,v=r.length);var f=\"string\"==typeof a?a:null,_=[Jr,le.stackAlloc,le.staticAlloc][void 0===e?we:e](Math.max(v,f?1:a.length));if(i)return Fa(_,0,v),_;for(var s,n=0;n<v;){var o=r[n];\"function\"==typeof o&&(o=le.getFunctionIndex(o)),s=f||a[n],0!==s?(\"i64\"==s&&(s=\"i32\"),t(_+n,o,s),n+=le.getNativeTypeSize(s)):n++}return _}function s(r,a){for(var e,i=\"undefined\"==typeof a,v=\"\",t=0,f=String.fromCharCode(0);;){if(e=String.fromCharCode(ge[r+t]),i&&e==f)break;if(v+=e,t+=1,!i&&t==a)break}return v}function n(r){for(var a=\"\",e=0;e<r.length;e++)a+=String.fromCharCode(r[e]);return a}function o(r){return r+4095>>12<<12}function l(){for(;Le<=Ie;)Le=o(2*Le);var r=Ae,a=new ArrayBuffer(Le);Ae=new Int8Array(a),ye=new Int16Array(a),Se=new Int32Array(a),ge=new Uint8Array(a),me=new Uint16Array(a),Me=new Uint32Array(a),Ce=new Float32Array(a),Re=new Float64Array(a),Ae.set(r)}function b(r){for(;r.length>0;){var a=r.shift(),e=a.func;\"number\"==typeof e&&(e=pe[e]),e(void 0===a.arg?null:a.arg)}}function k(){b(Ve)}function u(){b(Be),be.print()}function c(r,a){return Array.prototype.slice.call(Ae.subarray(r,r+a))}function h(r,a){for(var e=new Uint8Array(a),i=0;i<a;++i)e[i]=Ae[r+i];return e.buffer}function d(r){for(var a=0;Ae[r+a];)a++;return a}function w(r,a){var e=d(r);a&&e++;var i=c(r,e);return a&&(i[e-1]=0),i}function p(r,a){for(var e=[],i=0;i<r.length;){var v=r.charCodeAt(i);v>255&&(v&=255),e.push(v),i+=1}return a||e.push(0),e}function E(r){for(var a=[],e=0;e<r.length;e++){var i=r[e];i>255&&(i&=255),a.push(String.fromCharCode(i))}return a.join(\"\")}function A(r,a,e){for(var i=0;i<r.length;){var v=r.charCodeAt(i);v>255&&(v&=255),Ae[a+i]=v,i+=1}e||(Ae[a+i]=0)}function g(r,a,e,i){return r>=0?r:a<=32?2*Math.abs(1<<a-1)+r:Math.pow(2,a)+r}function y(r,a,e,i){if(r<=0)return r;var v=a<=32?Math.abs(1<<a-1):Math.pow(2,a-1);return r>=v&&(a<=32||r>v)&&(r=-2*v+r),r}function m(r,a,e){if(0==(0|r)|0==(0|a)|0==(0|e))var i=0;else{Se[r>>2]=0,Se[r+4>>2]=a,Se[r+8>>2]=e;var i=1}var i;return i}function S(r,a,e){if(0==(0|r)|(0|a)<0|0==(0|e))var i=0;else{Se[r>>2]=41,Se[r+4>>2]=a,Se[r+8>>2]=e;var i=1}var i;return i}function M(r,a,e){if(0==(0|r)|0==(0|e))var i=0;else{Se[r>>2]=6,Se[r+4>>2]=a,Se[r+8>>2]=e;var i=1}var i;return i}function C(r,a,e){if(0==(0|r)|0==(0|e))var i=0;else{Se[r>>2]=7,Se[r+4>>2]=a,Se[r+8>>2]=e;var i=1}var i;return i}function R(r,a){var e,i=0==(0|a);do if(i)var v=0;else{var e=(r+32|0)>>2,t=Se[e];if((0|t)>=(0|Se[r+36>>2])){var v=0;break}var f=(t<<2)+Se[r+28>>2]|0;Se[f>>2]=a;var _=Se[e]+1|0;Se[e]=_;var v=1}while(0);var v;return v}function T(r,a){var e,e=(r+12|0)>>2,i=Se[e],v=i+1|0;Se[e]=v;var t=Ae[i]<<24>>24==95;do if(t){var f=i+2|0;if(Se[e]=f,Ae[v]<<24>>24!=90){var _=0;break}var s=O(r,a),_=s}else var _=0;while(0);var _;return _}function O(r,a){var e=r+12|0,i=Ae[Se[e>>2]];r:do if(i<<24>>24==71||i<<24>>24==84)var v=Tr(r),t=v;else{var f=Ar(r),_=0==(0|f)|0==(0|a);do if(!_){if(0!=(1&Se[r+8>>2]|0))break;var s=Me[f>>2],n=(s-25|0)>>>0<3;a:do if(n)for(var o=f;;){var o,l=Me[o+4>>2],b=Me[l>>2];if((b-25|0)>>>0>=3){var k=l,u=b;break a}var o=l}else var k=f,u=s;while(0);var u,k;if(2!=(0|u)){var t=k;break r}var c=k+8|0,h=Me[c>>2],d=(Se[h>>2]-25|0)>>>0<3;a:do if(d)for(var w=h;;){var w,p=Me[w+4>>2];if((Se[p>>2]-25|0)>>>0>=3){var E=p;break a}var w=p}else var E=h;while(0);var E;Se[c>>2]=E;var t=k;break r}while(0);var A=Ae[Se[e>>2]];if(A<<24>>24==0||A<<24>>24==69){var t=f;break}var g=Or(f),y=Sr(r,g),m=D(r,3,f,y),t=m}while(0);var t;return t}function N(r){var a,e,i=Oe;Oe+=4;var v=i,e=v>>2,a=(r+12|0)>>2,t=Me[a],f=Ae[t],_=f<<24>>24;r:do if(f<<24>>24==114||f<<24>>24==86||f<<24>>24==75){var s=I(r,v,0);if(0==(0|s)){var n=0;break}var o=N(r);Se[s>>2]=o;var l=Se[e],b=R(r,l);if(0==(0|b)){var n=0;break}var n=Se[e]}else{do{if(97==(0|_)||98==(0|_)||99==(0|_)||100==(0|_)||101==(0|_)||102==(0|_)||103==(0|_)||104==(0|_)||105==(0|_)||106==(0|_)||108==(0|_)||109==(0|_)||110==(0|_)||111==(0|_)||115==(0|_)||116==(0|_)||118==(0|_)||119==(0|_)||120==(0|_)||121==(0|_)||122==(0|_)){var k=ai+20*(_-97)|0,u=P(r,k);Se[e]=u;var c=r+48|0,h=Se[c>>2]+Se[Se[u+4>>2]+4>>2]|0;Se[c>>2]=h;var d=Se[a]+1|0;Se[a]=d;var n=u;break r}if(117==(0|_)){Se[a]=t+1|0;var w=L(r),p=D(r,34,w,0);Se[e]=p;var E=p}else if(70==(0|_)){var A=F(r);Se[e]=A;var E=A}else if(48==(0|_)||49==(0|_)||50==(0|_)||51==(0|_)||52==(0|_)||53==(0|_)||54==(0|_)||55==(0|_)||56==(0|_)||57==(0|_)||78==(0|_)||90==(0|_)){var g=X(r);Se[e]=g;var E=g}else if(65==(0|_)){var y=j(r);Se[e]=y;var E=y}else if(77==(0|_)){var m=U(r);Se[e]=m;var E=m}else if(84==(0|_)){var S=x(r);if(Se[e]=S,Ae[Se[a]]<<24>>24!=73){var E=S;break}var M=R(r,S);if(0==(0|M)){var n=0;break r}var C=Se[e],T=z(r),O=D(r,4,C,T);Se[e]=O;var E=O}else if(83==(0|_)){var B=ge[t+1|0];if((B-48&255&255)<10|B<<24>>24==95|(B-65&255&255)<26){var H=V(r,0);if(Se[e]=H,Ae[Se[a]]<<24>>24!=73){var n=H;break r}var K=z(r),Y=D(r,4,H,K);Se[e]=Y;var E=Y}else{var G=X(r);if(Se[e]=G,0==(0|G)){var E=0;break}if(21==(0|Se[G>>2])){var n=G;break r}var E=G}}else if(80==(0|_)){Se[a]=t+1|0;var W=N(r),Z=D(r,29,W,0);Se[e]=Z;var E=Z}else if(82==(0|_)){Se[a]=t+1|0;var Q=N(r),q=D(r,30,Q,0);Se[e]=q;var E=q}else if(67==(0|_)){Se[a]=t+1|0;var $=N(r),J=D(r,31,$,0);Se[e]=J;var E=J}else if(71==(0|_)){Se[a]=t+1|0;var rr=N(r),ar=D(r,32,rr,0);Se[e]=ar;var E=ar}else{if(85!=(0|_)){var n=0;break r}Se[a]=t+1|0;var er=L(r);Se[e]=er;var ir=N(r),vr=Se[e],tr=D(r,28,ir,vr);Se[e]=tr;var E=tr}}while(0);var E,fr=R(r,E);if(0==(0|fr)){var n=0;break}var n=Se[e]}while(0);var n;return Oe=i,n}function I(r,a,e){for(var i,v=r+12|0,t=0!=(0|e),f=t?25:22,i=(r+48|0)>>2,_=t?26:23,s=t?27:24,n=a;;){var n,o=Se[v>>2],l=Ae[o];if(l<<24>>24!=114&&l<<24>>24!=86&&l<<24>>24!=75){var b=n;break}var k=o+1|0;if(Se[v>>2]=k,l<<24>>24==114){var u=Se[i]+9|0;Se[i]=u;var c=f}else if(l<<24>>24==86){var h=Se[i]+9|0;Se[i]=h;var c=_}else{var d=Se[i]+6|0;Se[i]=d;var c=s}var c,w=D(r,c,0,0);if(Se[n>>2]=w,0==(0|w)){var b=0;break}var n=w+4|0}var b;return b}function P(r,a){var e=0==(0|a);do if(e)var i=0;else{var v=J(r);if(0==(0|v)){var i=0;break}Se[v>>2]=33,Se[v+4>>2]=a;var i=v}while(0);var i;return i}function D(r,a,e,i){var v,t;do{if(1==(0|a)||2==(0|a)||3==(0|a)||4==(0|a)||10==(0|a)||28==(0|a)||37==(0|a)||43==(0|a)||44==(0|a)||45==(0|a)||46==(0|a)||47==(0|a)||48==(0|a)||49==(0|a)||50==(0|a)){if(0==(0|e)|0==(0|i)){var f=0;t=7;break}t=5;break}if(8==(0|a)||9==(0|a)||11==(0|a)||12==(0|a)||13==(0|a)||14==(0|a)||15==(0|a)||16==(0|a)||17==(0|a)||18==(0|a)||19==(0|a)||20==(0|a)||29==(0|a)||30==(0|a)||31==(0|a)||32==(0|a)||34==(0|a)||38==(0|a)||39==(0|a)||42==(0|a)){if(0==(0|e)){var f=0;t=7;break}t=5;break}if(36==(0|a)){if(0==(0|i)){var f=0;t=7;break}t=5;break}if(35==(0|a)||22==(0|a)||23==(0|a)||24==(0|a)||25==(0|a)||26==(0|a)||27==(0|a))t=5;else{var f=0;t=7}}while(0);do if(5==t){var _=J(r),v=_>>2;if(0==(0|_)){var f=0;break}Se[v]=a,Se[v+1]=e,Se[v+2]=i;var f=_}while(0);var f;return f}function L(r){var a=sr(r);if((0|a)<1)var e=0;else{var i=Rr(r,a);Se[r+44>>2]=i;var e=i}var e;return e}function F(r){var a,a=(r+12|0)>>2,e=Se[a],i=e+1|0;if(Se[a]=i,Ae[e]<<24>>24==70){if(Ae[i]<<24>>24==89){var v=e+2|0;Se[a]=v}var t=Sr(r,1),f=Se[a],_=f+1|0;Se[a]=_;var s=Ae[f]<<24>>24==69?t:0,n=s}else var n=0;var n;return n}function X(r){var a=Ar(r);return a}function j(r){var a,a=(r+12|0)>>2,e=Se[a],i=e+1|0;Se[a]=i;var v=Ae[e]<<24>>24==65;do if(v){var t=Ae[i];if(t<<24>>24==95)var f=0;else if((t-48&255&255)<10){for(var _=i;;){var _,s=_+1|0;if(Se[a]=s,(Ae[s]-48&255&255)>=10)break;var _=s}var n=s-i|0,o=lr(r,i,n);if(0==(0|o)){var l=0;break}var f=o}else{var b=nr(r);if(0==(0|b)){var l=0;break}var f=b}var f,k=Se[a],u=k+1|0;if(Se[a]=u,Ae[k]<<24>>24!=95){var l=0;break}var c=N(r),h=D(r,36,f,c),l=h}else var l=0;while(0);var l;return l}function U(r){var a=Oe;Oe+=4;var e=a,i=r+12|0,v=Se[i>>2],t=v+1|0;Se[i>>2]=t;var f=Ae[v]<<24>>24==77;r:do if(f){var _=N(r),s=I(r,e,1);if(0==(0|s)){var n=0;break}var o=N(r);Se[s>>2]=o;var l=(0|s)==(0|e);do if(!l){if(35==(0|Se[o>>2]))break;var b=Se[e>>2],k=R(r,b);if(0==(0|k)){var n=0;break r}}while(0);var u=Se[e>>2],c=D(r,37,_,u),n=c}else var n=0;while(0);var n;return Oe=a,n}function x(r){var a,a=(r+12|0)>>2,e=Se[a],i=e+1|0;Se[a]=i;var v=Ae[e]<<24>>24==84;do if(v){if(Ae[i]<<24>>24==95)var t=0,f=i;else{var _=sr(r);if((0|_)<0){var s=0;break}var t=_+1|0,f=Se[a]}var f,t;if(Se[a]=f+1|0,Ae[f]<<24>>24!=95){var s=0;break}var n=r+40|0,o=Se[n>>2]+1|0;Se[n>>2]=o;var l=Er(r,t),s=l}else var s=0;while(0);var s;return s}function z(r){var a,e=Oe;Oe+=4;var i=e,v=r+44|0,t=Se[v>>2],a=(r+12|0)>>2,f=Se[a],_=f+1|0;Se[a]=_;var s=Ae[f]<<24>>24==73;r:do if(s){Se[i>>2]=0;for(var n=i;;){var n,o=_r(r);if(0==(0|o)){var l=0;break r}var b=D(r,39,o,0);if(Se[n>>2]=b,0==(0|b)){var l=0;break r}var k=Se[a];if(Ae[k]<<24>>24==69)break;var n=b+8|0}var u=k+1|0;Se[a]=u,Se[v>>2]=t;var l=Se[i>>2]}else var l=0;while(0);var l;return Oe=e,l}function V(r,a){var e,e=(r+12|0)>>2,i=Se[e],v=i+1|0;Se[e]=v;var t=Ae[i]<<24>>24==83;r:do if(t){var f=i+2|0;Se[e]=f;var _=ge[v];if(_<<24>>24==95)var s=0;else{if(!((_-48&255&255)<10|(_-65&255&255)<26)){var n=8&Se[r+8>>2],o=n>>>3,l=0!=(0|n)|0==(0|a);do if(l)var b=o;else{if((Ae[f]-67&255&255)>=2){var b=o;break}var b=1}while(0);for(var b,k=0|ei;;){var k;if(k>>>0>=(ei+196|0)>>>0){var u=0;break r}if(_<<24>>24==Ae[0|k]<<24>>24)break;var k=k+28|0}var c=Se[k+20>>2];if(0!=(0|c)){var h=Se[k+24>>2],d=fr(r,c,h);Se[r+44>>2]=d}if(0==(0|b))var w=k+8|0,p=k+4|0;else var w=k+16|0,p=k+12|0;var p,w,E=Se[w>>2],A=Se[p>>2],g=r+48|0,y=Se[g>>2]+E|0;Se[g>>2]=y;var m=fr(r,A,E),u=m;break}for(var S=_,M=0,C=f;;){var C,M,S;if((S-48&255&255)<10)var R=36*M-48|0;else{if((S-65&255&255)>=26){var u=0;break r}var R=36*M-55|0}var R,T=(S<<24>>24)+R|0;if((0|T)<0){var u=0;break r}var O=C+1|0;Se[e]=O;var N=ge[C];if(N<<24>>24==95)break;var S=N,M=T,C=O}var s=T+1|0}var s;if((0|s)>=(0|Se[r+32>>2])){var u=0;break}var I=r+40|0,P=Se[I>>2]+1|0;Se[I>>2]=P;var u=Se[Se[r+28>>2]+(s<<2)>>2]}else var u=0;while(0);var u;return u}function B(r,a,e,i){var v,t,f,_,s=Oe;Oe+=28;var n,o=s,_=o>>2;Se[_]=r;var l=e+1|0,f=(o+12|0)>>2;Se[f]=l;var b=Jr(l),t=(o+4|0)>>2;if(Se[t]=b,0==(0|b))var k=0,u=1;else{var v=(o+8|0)>>2;Se[v]=0,Se[_+4]=0,Se[_+5]=0;var c=o+24|0;Se[c>>2]=0,H(o,a);var h=Me[t],d=0==(0|h);do{if(!d){var w=Me[v];if(w>>>0>=Me[f]>>>0){n=5;break}Se[v]=w+1|0,Ae[h+w|0]=0,n=6;break}n=5}while(0);5==n&&Y(o,0);var p=Se[t],E=0==(0|p)?Se[c>>2]:Se[f],k=p,u=E}var u,k;return Se[i>>2]=u,Oe=s,k}function H(r,a){var e,i,v,t,f,_,s,n,o,l,b,k,u,c,h,d,w,p,E,A,g,y,m,S,M,C,R,T,O,N,I,P,D,L,F,X,j,U,x,z,V,B,K,G,W,J,vr,tr,fr,_r,sr,nr,or,lr,br,kr,ur,cr,hr,dr,wr,pr=a>>2,Er=r>>2,Ar=Oe;Oe+=184;var gr,yr=Ar,wr=yr>>2,mr=Ar+64,dr=mr>>2,Sr=Ar+72,Mr=Ar+88,Cr=Ar+104,hr=Cr>>2,Rr=Ar+168,Tr=0==(0|a);r:do if(Tr)Z(r);else{var cr=(r+4|0)>>2,Or=Me[cr];if(0==(0|Or))break;var Nr=0|a,Ir=Me[Nr>>2];a:do{if(0==(0|Ir)){if(0!=(4&Se[Er]|0)){var Pr=Se[pr+1],Dr=Se[pr+2];q(r,Pr,Dr);break r}var ur=(r+8|0)>>2,Lr=Me[ur],Fr=a+8|0,Xr=Me[Fr>>2];if((Xr+Lr|0)>>>0>Me[Er+3]>>>0){var jr=Se[pr+1];Q(r,jr,Xr);break r}var Ur=Or+Lr|0,xr=Se[pr+1];Pa(Ur,xr,Xr,1);var zr=Se[ur]+Se[Fr>>2]|0;Se[ur]=zr;break r}if(1==(0|Ir)||2==(0|Ir)){var Vr=Se[pr+1];H(r,Vr);var Br=0==(4&Se[Er]|0),Hr=Me[cr],Kr=0!=(0|Hr);e:do if(Br){do if(Kr){var kr=(r+8|0)>>2,Yr=Me[kr];if((Yr+2|0)>>>0>Me[Er+3]>>>0)break;var Gr=Hr+Yr|0;oe=14906,Ae[Gr]=255&oe,oe>>=8,Ae[Gr+1]=255&oe;var Wr=Se[kr]+2|0;Se[kr]=Wr;break e}while(0);Q(r,0|He.__str120,2)}else{do if(Kr){var Zr=r+8|0,Qr=Me[Zr>>2];if(Qr>>>0>=Me[Er+3]>>>0)break;Se[Zr>>2]=Qr+1|0,Ae[Hr+Qr|0]=46;break e}while(0);Y(r,46)}while(0);var qr=Se[pr+2];H(r,qr);break r}if(3==(0|Ir)){for(var br=(r+20|0)>>2,$r=Me[br],lr=(r+16|0)>>2,Jr=a,ra=0,aa=$r;;){var aa,ra,Jr,ea=Me[Jr+4>>2];if(0==(0|ea)){var ia=ra,va=0;gr=33;break}if(ra>>>0>3){Z(r);break r}var ta=(ra<<4)+yr|0;Se[ta>>2]=aa,Se[br]=ta,Se[((ra<<4)+4>>2)+wr]=ea,Se[((ra<<4)+8>>2)+wr]=0;var fa=Me[lr];Se[((ra<<4)+12>>2)+wr]=fa;var _a=ra+1|0,sa=0|ea,na=Me[sa>>2];if((na-25|0)>>>0>=3){gr=25;break}var Jr=ea,ra=_a,aa=ta}e:do if(25==gr){if(4==(0|na)){Se[dr]=fa,Se[lr]=mr,Se[dr+1]=ea;var oa=Se[sa>>2],la=mr}else var oa=na,la=fa;var la,oa;if(2!=(0|oa)){var ia=_a,va=sa;break}for(var ba=_a,ka=ea+8|0;;){var ka,ba,ua=Me[ka>>2];if((Se[ua>>2]-25|0)>>>0>=3){var ia=ba,va=sa;break e}if(ba>>>0>3)break;var ca=(ba<<4)+yr|0,ha=ba-1|0,da=(ha<<4)+yr|0,or=ca>>2,nr=da>>2;Se[or]=Se[nr],Se[or+1]=Se[nr+1],Se[or+2]=Se[nr+2],Se[or+3]=Se[nr+3],Se[ca>>2]=da,Se[br]=ca,Se[((ha<<4)+4>>2)+wr]=ua,Se[((ha<<4)+8>>2)+wr]=0,Se[((ha<<4)+12>>2)+wr]=la;var ba=ba+1|0,ka=ua+4|0}Z(r);break r}while(0);var va,ia,wa=Se[pr+2];if(H(r,wa),4==(0|Se[va>>2])){var pa=Se[dr];Se[lr]=pa}var Ea=0==(0|ia);e:do if(!Ea)for(var Aa=r+8|0,ga=r+12|0,ya=ia;;){var ya,ma=ya-1|0;if(0==(0|Se[((ma<<4)+8>>2)+wr])){var Sa=Me[cr],Ma=0==(0|Sa);do{if(!Ma){var Ca=Me[Aa>>2];if(Ca>>>0>=Me[ga>>2]>>>0){gr=41;break}Se[Aa>>2]=Ca+1|0,Ae[Sa+Ca|0]=32,gr=42;break}gr=41}while(0);41==gr&&Y(r,32);var Ra=Se[((ma<<4)+4>>2)+wr];$(r,Ra)}if(0==(0|ma))break e;var ya=ma}while(0);Se[br]=$r;break r}if(4==(0|Ir)){var sr=(r+20|0)>>2,Ta=Se[sr];Se[sr]=0;var Oa=Se[pr+1];H(r,Oa);var Na=Me[cr],Ia=0==(0|Na);do{if(!Ia){var _r=(r+8|0)>>2,Da=Me[_r],La=0==(0|Da);do if(!La){if(Ae[Na+(Da-1)|0]<<24>>24!=60)break;Da>>>0<Me[Er+3]>>>0?(Se[_r]=Da+1|0,Ae[Na+Da|0]=32):Y(r,32)}while(0);var Fa=Me[cr];if(0==(0|Fa)){gr=54;break}var Xa=Me[_r];if(Xa>>>0>=Me[Er+3]>>>0){gr=54;break}Se[_r]=Xa+1|0,Ae[Fa+Xa|0]=60,gr=55;break}gr=54}while(0);54==gr&&Y(r,60);var ja=Se[pr+2];H(r,ja);var Ua=Me[cr],xa=0==(0|Ua);do{if(!xa){var fr=(r+8|0)>>2,za=Me[fr],Va=0==(0|za);do if(!Va){if(Ae[Ua+(za-1)|0]<<24>>24!=62)break;za>>>0<Me[Er+3]>>>0?(Se[fr]=za+1|0,Ae[Ua+za|0]=32):Y(r,32)}while(0);var Ba=Me[cr];if(0==(0|Ba)){gr=64;break}var Ha=Me[fr];if(Ha>>>0>=Me[Er+3]>>>0){gr=64;break}Se[fr]=Ha+1|0,Ae[Ba+Ha|0]=62,gr=65;break}gr=64}while(0);64==gr&&Y(r,62),Se[sr]=Ta;break r}if(5==(0|Ir)){var tr=(r+16|0)>>2,Ka=Me[tr];if(0==(0|Ka)){Z(r);break r}for(var Ya=Se[pr+1],Ga=Se[Ka+4>>2];;){var Ga,Ya,Wa=Se[Ga+8>>2];if(0==(0|Wa))break;if(39!=(0|Se[Wa>>2])){Z(r);break r}if((0|Ya)<1){if(0!=(0|Ya))break;var Za=Se[Ka>>2];Se[tr]=Za;var Qa=Se[Wa+4>>2];H(r,Qa),Se[tr]=Ka;break r}var Ya=Ya-1|0,Ga=Wa}Z(r);break r}if(6==(0|Ir)){var qa=Se[pr+2];H(r,qa);break r}if(7==(0|Ir)){var $a=r+8|0,Ja=Me[$a>>2];Ja>>>0<Me[Er+3]>>>0?(Se[$a>>2]=Ja+1|0,Ae[Or+Ja|0]=126):Y(r,126);var re=Se[pr+2];H(r,re);break r}if(8==(0|Ir)){var vr=(r+8|0)>>2,ae=Me[vr];if((ae+11|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str121,11);else{for(var ee=Or+ae|0,ie=0|He.__str121,ve=ee,te=ie+11;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var fe=Se[vr]+11|0;Se[vr]=fe}var _e=Se[pr+1];H(r,_e);break r}if(9==(0|Ir)){var J=(r+8|0)>>2,se=Me[J];if((se+8|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str122,8);else{var ne=Or+se|0,le=0|ne;oe=542397526,Ae[le]=255&oe,oe>>=8,Ae[le+1]=255&oe,oe>>=8,Ae[le+2]=255&oe,oe>>=8,Ae[le+3]=255&oe;var be=ne+4|0;oe=544370534,Ae[be]=255&oe,oe>>=8,Ae[be+1]=255&oe,oe>>=8,Ae[be+2]=255&oe,oe>>=8,Ae[be+3]=255&oe;var ke=Se[J]+8|0;Se[J]=ke}var ue=Se[pr+1];H(r,ue);break r}if(10==(0|Ir)){var W=(r+8|0)>>2,ce=Me[W],he=r+12|0;if((ce+24|0)>>>0>Me[he>>2]>>>0)Q(r,0|He.__str123,24);else{var de=Or+ce|0;Pa(de,0|He.__str123,24,1);var we=Se[W]+24|0;Se[W]=we}var pe=Se[pr+1];H(r,pe);var Ee=Me[cr],ge=0==(0|Ee);do{if(!ge){var ye=Me[W];if((ye+4|0)>>>0>Me[he>>2]>>>0){gr=96;break}var me=Ee+ye|0;oe=762210605,Ae[me]=255&oe,oe>>=8,Ae[me+1]=255&oe,oe>>=8,Ae[me+2]=255&oe,oe>>=8,Ae[me+3]=255&oe;var Ce=Se[W]+4|0;Se[W]=Ce,gr=97;break}gr=96}while(0);96==gr&&Q(r,0|He.__str124,4);var Re=Se[pr+2];H(r,Re);break r}if(11==(0|Ir)){var G=(r+8|0)>>2,Te=Me[G];if((Te+13|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str125,13);else{for(var Ne=Or+Te|0,ie=0|He.__str125,ve=Ne,te=ie+13;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var Ie=Se[G]+13|0;Se[G]=Ie}var Pe=Se[pr+1];H(r,Pe);break r}if(12==(0|Ir)){var K=(r+8|0)>>2,De=Me[K];if((De+18|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str126,18);else{for(var Le=Or+De|0,ie=0|He.__str126,ve=Le,te=ie+18;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var Fe=Se[K]+18|0;Se[K]=Fe}var Xe=Se[pr+1];H(r,Xe);break r}if(13==(0|Ir)){var B=(r+8|0)>>2,je=Me[B];if((je+16|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str127,16);else{for(var Ue=Or+je|0,ie=0|He.__str127,ve=Ue,te=ie+16;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var xe=Se[B]+16|0;Se[B]=xe}var ze=Se[pr+1];H(r,ze);break r}if(14==(0|Ir)){var V=(r+8|0)>>2,Ve=Me[V];if((Ve+21|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str128,21);else{var Be=Or+Ve|0;Pa(Be,0|He.__str128,21,1);var Ke=Se[V]+21|0;Se[V]=Ke}var Ye=Se[pr+1];H(r,Ye);break r}if(15==(0|Ir)){var z=(r+8|0)>>2,Ge=Me[z];if((Ge+17|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str129,17);else{for(var We=Or+Ge|0,ie=0|He.__str129,ve=We,te=ie+17;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var Ze=Se[z]+17|0;Se[z]=Ze}var Qe=Se[pr+1];H(r,Qe);break r}if(16==(0|Ir)){var x=(r+8|0)>>2,qe=Me[x];if((qe+26|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str130,26);else{var $e=Or+qe|0;Pa($e,0|He.__str130,26,1);var Je=Se[x]+26|0;Se[x]=Je}var ri=Se[pr+1];H(r,ri);break r}if(17==(0|Ir)){var U=(r+8|0)>>2,ai=Me[U];if((ai+15|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str131,15);else{for(var ei=Or+ai|0,ie=0|He.__str131,ve=ei,te=ie+15;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var ii=Se[U]+15|0;Se[U]=ii}var vi=Se[pr+1];H(r,vi);break r}if(18==(0|Ir)){var j=(r+8|0)>>2,ti=Me[j];if((ti+19|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str132,19);else{for(var fi=Or+ti|0,ie=0|He.__str132,ve=fi,te=ie+19;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var _i=Se[j]+19|0;Se[j]=_i}var si=Se[pr+1];H(r,si);break r}if(19==(0|Ir)){var X=(r+8|0)>>2,ni=Me[X];if((ni+24|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str133,24);else{var oi=Or+ni|0;Pa(oi,0|He.__str133,24,1);var li=Se[X]+24|0;Se[X]=li}var bi=Se[pr+1];H(r,bi);break r}if(20==(0|Ir)){var F=(r+8|0)>>2,ki=Me[F];if((ki+17|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str134,17);else{for(var ui=Or+ki|0,ie=0|He.__str134,ve=ui,te=ie+17;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var ci=Se[F]+17|0;Se[F]=ci}var hi=Se[pr+1];H(r,hi);break r}if(21==(0|Ir)){var L=(r+8|0)>>2,di=Me[L],wi=a+8|0,pi=Me[wi>>2];if((pi+di|0)>>>0>Me[Er+3]>>>0){var Ei=Se[pr+1];Q(r,Ei,pi);break r}var Ai=Or+di|0,gi=Se[pr+1];Pa(Ai,gi,pi,1);var yi=Se[L]+Se[wi>>2]|0;Se[L]=yi;break r}if(22==(0|Ir)||23==(0|Ir)||24==(0|Ir)){for(var mi=r+20|0;;){var mi,Si=Me[mi>>2];if(0==(0|Si))break a;if(0==(0|Se[Si+8>>2])){var Mi=Me[Se[Si+4>>2]>>2];if((Mi-22|0)>>>0>=3)break a;if((0|Mi)==(0|Ir))break}var mi=0|Si}var Ci=Se[pr+1];H(r,Ci);break r}if(25!=(0|Ir)&&26!=(0|Ir)&&27!=(0|Ir)&&28!=(0|Ir)&&29!=(0|Ir)&&30!=(0|Ir)&&31!=(0|Ir)&&32!=(0|Ir)){if(33==(0|Ir)){var D=(r+8|0)>>2,Ri=Me[D],P=(a+4|0)>>2,I=Me[P]>>2;if(0==(4&Se[Er]|0)){var Ti=Me[I+1];if((Ti+Ri|0)>>>0>Me[Er+3]>>>0){var Oi=Se[I];Q(r,Oi,Ti);break r}var Ni=Or+Ri|0,Ii=Se[I];Pa(Ni,Ii,Ti,1);var Pi=Se[D]+Se[Se[P]+4>>2]|0;Se[D]=Pi;break r}var Di=Me[I+3];if((Di+Ri|0)>>>0>Me[Er+3]>>>0){var Li=Se[I+2];Q(r,Li,Di);break r}var Fi=Or+Ri|0,Xi=Se[I+2];Pa(Fi,Xi,Di,1);var ji=Se[D]+Se[Se[P]+12>>2]|0;Se[D]=ji;break r}if(34==(0|Ir)){var Ui=Se[pr+1];H(r,Ui);break r}if(35==(0|Ir)){var N=(0|r)>>2;if(0!=(32&Se[N]|0)){var xi=Se[Er+5];rr(r,a,xi)}var zi=a+4|0,Vi=0==(0|Se[zi>>2]);e:do if(!Vi){var O=(r+20|0)>>2,Bi=Se[O],Hi=0|Mr;Se[Hi>>2]=Bi,Se[O]=Mr,Se[Mr+4>>2]=a;var Ki=Mr+8|0;Se[Ki>>2]=0;var Yi=Se[Er+4];Se[Mr+12>>2]=Yi;var Gi=Se[zi>>2];H(r,Gi);var Wi=Se[Hi>>2];if(Se[O]=Wi,0!=(0|Se[Ki>>2]))break r;if(0!=(32&Se[N]|0))break;var Zi=Me[cr],Qi=0==(0|Zi);do if(!Qi){var qi=r+8|0,$i=Me[qi>>2];if($i>>>0>=Me[Er+3]>>>0)break;Se[qi>>2]=$i+1|0,Ae[Zi+$i|0]=32;break e}while(0);Y(r,32)}while(0);if(0!=(32&Se[N]|0))break r;var Ji=Se[Er+5];rr(r,a,Ji);break r}if(36==(0|Ir)){var T=(r+20|0)>>2,rv=Me[T],av=0|Cr;Se[hr]=rv,Se[T]=av,Se[hr+1]=a;var ev=Cr+8|0;Se[ev>>2]=0;var iv=Se[Er+4];Se[hr+3]=iv;for(var vv=rv,tv=1;;){var tv,vv;if(0==(0|vv))break;if((Se[Se[vv+4>>2]>>2]-22|0)>>>0>=3)break;var fv=vv+8|0;if(0==(0|Se[fv>>2])){if(tv>>>0>3){Z(r);break r}var _v=(tv<<4)+Cr|0,R=_v>>2,C=vv>>2;Se[R]=Se[C],Se[R+1]=Se[C+1],Se[R+2]=Se[C+2],Se[R+3]=Se[C+3];var sv=Se[T];Se[_v>>2]=sv,Se[T]=_v,Se[fv>>2]=1;var nv=tv+1|0}else var nv=tv;var nv,vv=Se[vv>>2],tv=nv}var ov=Se[pr+2];if(H(r,ov),Se[T]=rv,0!=(0|Se[ev>>2]))break r;if(tv>>>0>1){for(var lv=tv;;){var lv,bv=lv-1|0,kv=Se[((bv<<4)+4>>2)+hr];if($(r,kv),bv>>>0<=1)break;var lv=bv}var uv=Se[T]}else var uv=rv;var uv;ar(r,a,uv);break r}if(37==(0|Ir)){var M=(r+20|0)>>2,cv=Se[M],hv=0|Rr;Se[hv>>2]=cv,Se[M]=Rr,Se[Rr+4>>2]=a;var dv=Rr+8|0;Se[dv>>2]=0;var wv=Se[Er+4];Se[Rr+12>>2]=wv;var pv=a+4|0,Ev=Se[pr+2];H(r,Ev);var Av=0==(0|Se[dv>>2]);e:do if(Av){var gv=Me[cr],yv=0==(0|gv);do{if(!yv){var mv=r+8|0,Sv=Me[mv>>2];if(Sv>>>0>=Me[Er+3]>>>0){gr=187;break}Se[mv>>2]=Sv+1|0,Ae[gv+Sv|0]=32,gr=188;break}gr=187}while(0);187==gr&&Y(r,32);var Mv=Se[pv>>2];H(r,Mv);var Cv=Me[cr],Rv=0==(0|Cv);do if(!Rv){var S=(r+8|0)>>2,Tv=Me[S];if((Tv+3|0)>>>0>Me[Er+3]>>>0)break;var Ov=Cv+Tv|0;Ae[Ov]=Ae[0|He.__str135],Ae[Ov+1]=Ae[(0|He.__str135)+1],Ae[Ov+2]=Ae[(0|He.__str135)+2];var Nv=Se[S]+3|0;Se[S]=Nv;break e}while(0);Q(r,0|He.__str135,3)}while(0);var Iv=Se[hv>>2];Se[M]=Iv;break r}if(38==(0|Ir)||39==(0|Ir)){var Pv=Se[pr+1];H(r,Pv);var Dv=a+8|0;if(0==(0|Se[Dv>>2]))break r;var Lv=Me[cr],Fv=0==(0|Lv);do{if(!Fv){var m=(r+8|0)>>2,Xv=Me[m];if((Xv+2|0)>>>0>Me[Er+3]>>>0){gr=197;break}var jv=Lv+Xv|0;oe=8236,Ae[jv]=255&oe,oe>>=8,Ae[jv+1]=255&oe;var Uv=Se[m]+2|0;Se[m]=Uv,gr=198;break}gr=197}while(0);197==gr&&Q(r,0|He.__str136,2);var xv=Se[Dv>>2];H(r,xv);break r}if(40==(0|Ir)){var y=(r+8|0)>>2,zv=Me[y],g=(r+12|0)>>2;if((zv+8|0)>>>0>Me[g]>>>0)Q(r,0|He.__str137,8);else{var Vv=Or+zv|0,le=0|Vv;oe=1919250543,Ae[le]=255&oe,oe>>=8,Ae[le+1]=255&oe,oe>>=8,Ae[le+2]=255&oe,oe>>=8,Ae[le+3]=255&oe;var be=Vv+4|0;oe=1919906913,Ae[be]=255&oe,oe>>=8,Ae[be+1]=255&oe,oe>>=8,Ae[be+2]=255&oe,oe>>=8,Ae[be+3]=255&oe;var Bv=Se[y]+8|0;Se[y]=Bv}var A=(a+4|0)>>2,Hv=(Ae[Se[Se[A]+4>>2]]-97&255&255)<26;e:do if(Hv){var Kv=Me[cr],Yv=0==(0|Kv);do if(!Yv){var Gv=Me[y];if(Gv>>>0>=Me[g]>>>0)break;Se[y]=Gv+1|0,Ae[Kv+Gv|0]=32;break e}while(0);Y(r,32)}while(0);var Wv=Me[cr],Zv=0==(0|Wv);do{if(!Zv){var Qv=Me[y],qv=Me[A],$v=Me[qv+8>>2];if(($v+Qv|0)>>>0>Me[g]>>>0){var Jv=qv,rt=$v;break}var at=Wv+Qv|0,et=Se[qv+4>>2];Pa(at,et,$v,1);var it=Se[y]+Se[Se[A]+8>>2]|0;Se[y]=it;break r}var vt=Me[A],Jv=vt,rt=Se[vt+8>>2]}while(0);var rt,Jv,tt=Se[Jv+4>>2];Q(r,tt,rt);break r}if(41==(0|Ir)){var E=(r+8|0)>>2,ft=Me[E];if((ft+9|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str10180,9);else{for(var _t=Or+ft|0,ie=0|He.__str10180,ve=_t,te=ie+9;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var st=Se[E]+9|0;Se[E]=st}var nt=Se[pr+2];H(r,nt);break r}if(42==(0|Ir)){var p=(r+8|0)>>2,ot=Me[p];if((ot+9|0)>>>0>Me[Er+3]>>>0)Q(r,0|He.__str10180,9);else{for(var lt=Or+ot|0,ie=0|He.__str10180,ve=lt,te=ie+9;ie<te;ie++,ve++)Ae[ve]=Ae[ie];var bt=Se[p]+9|0;Se[p]=bt}er(r,a);break r}if(43==(0|Ir)){var kt=a+4|0,ut=Se[kt>>2],ct=42==(0|Se[ut>>2]);e:do if(ct){var w=(r+8|0)>>2,ht=Me[w],dt=r+12|0;ht>>>0<Me[dt>>2]>>>0?(Se[w]=ht+1|0,Ae[Or+ht|0]=40):Y(r,40);var wt=Se[kt>>2];er(r,wt);var pt=Me[cr],Et=0==(0|pt);do if(!Et){var At=Me[w];if(At>>>0>=Me[dt>>2]>>>0)break;Se[w]=At+1|0,Ae[pt+At|0]=41;break e}while(0);Y(r,41)}else ir(r,ut);while(0);var gt=Me[cr],yt=0==(0|gt);do{if(!yt){var mt=r+8|0,St=Me[mt>>2];if(St>>>0>=Me[Er+3]>>>0){gr=232;break}Se[mt>>2]=St+1|0,Ae[gt+St|0]=40,gr=233;break}gr=232}while(0);232==gr&&Y(r,40);var Mt=Se[pr+2];H(r,Mt);var Ct=Me[cr],Rt=0==(0|Ct);do if(!Rt){var Tt=r+8|0,Ot=Me[Tt>>2];if(Ot>>>0>=Me[Er+3]>>>0)break;Se[Tt>>2]=Ot+1|0,Ae[Ct+Ot|0]=41;break r}while(0);Y(r,41);break r}if(44==(0|Ir)){var d=(a+8|0)>>2;if(45==(0|Se[Se[d]>>2])){var h=(a+4|0)>>2,Nt=Se[h],It=40==(0|Se[Nt>>2]);do if(It){var Pt=Se[Nt+4>>2];if(1!=(0|Se[Pt+8>>2]))break;if(Ae[Se[Pt+4>>2]]<<24>>24!=62)break;var Dt=r+8|0,Lt=Me[Dt>>2];Lt>>>0<Me[Er+3]>>>0?(Se[Dt>>2]=Lt+1|0,Ae[Or+Lt|0]=40):Y(r,40)}while(0);var Ft=Me[cr],Xt=0==(0|Ft);do{if(!Xt){var jt=r+8|0,Ut=Me[jt>>2];if(Ut>>>0>=Me[Er+3]>>>0){gr=248;break}Se[jt>>2]=Ut+1|0,Ae[Ft+Ut|0]=40,gr=249;break}gr=248}while(0);248==gr&&Y(r,40);var xt=Se[Se[d]+4>>2];H(r,xt);var zt=Me[cr],Vt=0==(0|zt);do{if(!Vt){var c=(r+8|0)>>2,Bt=Me[c];if((Bt+2|0)>>>0>Me[Er+3]>>>0){gr=252;break}var Ht=zt+Bt|0;oe=8233,Ae[Ht]=255&oe,oe>>=8,Ae[Ht+1]=255&oe;var Kt=Se[c]+2|0;Se[c]=Kt,gr=253;break}gr=252}while(0);252==gr&&Q(r,0|He.__str139,2);var Yt=Se[h];ir(r,Yt);var Gt=Me[cr],Wt=0==(0|Gt);do{if(!Wt){var u=(r+8|0)>>2,Zt=Me[u];if((Zt+2|0)>>>0>Me[Er+3]>>>0){gr=256;break}var Qt=Gt+Zt|0;oe=10272,Ae[Qt]=255&oe,oe>>=8,Ae[Qt+1]=255&oe;var qt=Se[u]+2|0;Se[u]=qt,gr=257;break}gr=256}while(0);256==gr&&Q(r,0|He.__str140,2);var $t=Se[Se[d]+8>>2];H(r,$t);var Jt=Me[cr],rf=0==(0|Jt);do{if(!rf){var af=r+8|0,ef=Me[af>>2];if(ef>>>0>=Me[Er+3]>>>0){gr=260;break}Se[af>>2]=ef+1|0,Ae[Jt+ef|0]=41,gr=261;break}gr=260}while(0);260==gr&&Y(r,41);var vf=Se[h];if(40!=(0|Se[vf>>2]))break r;var tf=Se[vf+4>>2];if(1!=(0|Se[tf+8>>2]))break r;if(Ae[Se[tf+4>>2]]<<24>>24!=62)break r;var ff=Me[cr],_f=0==(0|ff);do if(!_f){var sf=r+8|0,nf=Me[sf>>2];if(nf>>>0>=Me[Er+3]>>>0)break;Se[sf>>2]=nf+1|0,Ae[ff+nf|0]=41;break r}while(0);Y(r,41);break r}Z(r);break r}if(45==(0|Ir)){Z(r);break r}if(46==(0|Ir)){var of=a+4|0,k=(a+8|0)>>2,lf=Se[k],bf=47==(0|Se[lf>>2]);do if(bf){if(48!=(0|Se[Se[lf+8>>2]>>2]))break;var b=(r+8|0)>>2,kf=Me[b],l=(r+12|0)>>2;kf>>>0<Me[l]>>>0?(Se[b]=kf+1|0,Ae[Or+kf|0]=40):Y(r,40);var uf=Se[Se[k]+4>>2];H(r,uf);var cf=Me[cr],hf=0==(0|cf);do{if(!hf){var df=Me[b];if((df+2|0)>>>0>Me[l]>>>0){gr=278;break}var wf=cf+df|0;oe=8233,Ae[wf]=255&oe,oe>>=8,Ae[wf+1]=255&oe;var pf=Se[b]+2|0;Se[b]=pf,gr=279;break}gr=278}while(0);278==gr&&Q(r,0|He.__str139,2);var Ef=Se[of>>2];ir(r,Ef);var Af=Me[cr],gf=0==(0|Af);do{if(!gf){var yf=Me[b];if((yf+2|0)>>>0>Me[l]>>>0){gr=282;break}var mf=Af+yf|0;oe=10272,Ae[mf]=255&oe,oe>>=8,Ae[mf+1]=255&oe;var Sf=Se[b]+2|0;Se[b]=Sf,gr=283;break}gr=282}while(0);282==gr&&Q(r,0|He.__str140,2);var Mf=Se[Se[Se[k]+8>>2]+4>>2];H(r,Mf);var Cf=Me[cr],Rf=0==(0|Cf);do{if(!Rf){var Tf=Me[b];if((Tf+5|0)>>>0>Me[l]>>>0){gr=286;break}var Of=Cf+Tf|0;Ae[Of]=Ae[0|He.__str141],Ae[Of+1]=Ae[(0|He.__str141)+1],Ae[Of+2]=Ae[(0|He.__str141)+2],Ae[Of+3]=Ae[(0|He.__str141)+3],Ae[Of+4]=Ae[(0|He.__str141)+4];var Nf=Se[b]+5|0;Se[b]=Nf,gr=287;break}gr=286}while(0);286==gr&&Q(r,0|He.__str141,5);var If=Se[Se[Se[k]+8>>2]+8>>2];H(r,If);var Pf=Me[cr],Df=0==(0|Pf);do if(!Df){var Lf=Me[b];if(Lf>>>0>=Me[l]>>>0)break;Se[b]=Lf+1|0,Ae[Pf+Lf|0]=41;break r}while(0);Y(r,41);break r}while(0);Z(r);break r}if(47==(0|Ir)||48==(0|Ir)){Z(r);break r}if(49==(0|Ir)||50==(0|Ir)){var Ff=a+4|0,Xf=Se[Ff>>2],jf=33==(0|Se[Xf>>2]);do{if(jf){var Uf=Me[Se[Xf+4>>2]+16>>2];if(1==(0|Uf)||2==(0|Uf)||3==(0|Uf)||4==(0|Uf)||5==(0|Uf)||6==(0|Uf)){var xf=a+8|0;if(0!=(0|Se[Se[xf>>2]>>2])){var zf=Uf;break}if(50==(0|Ir)){var Vf=r+8|0,Bf=Me[Vf>>2];Bf>>>0<Me[Er+3]>>>0?(Se[Vf>>2]=Bf+1|0,Ae[Or+Bf|0]=45):Y(r,45)}var Hf=Se[xf>>2];if(H(r,Hf),2==(0|Uf)){var Kf=Me[cr],Yf=0==(0|Kf);do if(!Yf){var Gf=r+8|0,Wf=Me[Gf>>2];if(Wf>>>0>=Me[Er+3]>>>0)break;Se[Gf>>2]=Wf+1|0,Ae[Kf+Wf|0]=117;break r}while(0);Y(r,117);break r}if(3==(0|Uf)){var Zf=Me[cr],Qf=0==(0|Zf);do if(!Qf){var qf=r+8|0,$f=Me[qf>>2];if($f>>>0>=Me[Er+3]>>>0)break;Se[qf>>2]=$f+1|0,Ae[Zf+$f|0]=108;break r}while(0);Y(r,108);break r}if(4==(0|Uf)){var Jf=Me[cr],r_=0==(0|Jf);do if(!r_){var o=(r+8|0)>>2,a_=Me[o];if((a_+2|0)>>>0>Me[Er+3]>>>0)break;var e_=Jf+a_|0;oe=27765,Ae[e_]=255&oe,oe>>=8,Ae[e_+1]=255&oe;var i_=Se[o]+2|0;Se[o]=i_;break r}while(0);Q(r,0|He.__str142,2);break r}if(5==(0|Uf)){var v_=Me[cr],t_=0==(0|v_);do if(!t_){var n=(r+8|0)>>2,f_=Me[n];if((f_+2|0)>>>0>Me[Er+3]>>>0)break;var __=v_+f_|0;oe=27756,Ae[__]=255&oe,oe>>=8,Ae[__+1]=255&oe;var s_=Se[n]+2|0;Se[n]=s_;break r}while(0);Q(r,0|He.__str143,2);break r}if(6==(0|Uf)){var n_=Me[cr],o_=0==(0|n_);do if(!o_){var s=(r+8|0)>>2,l_=Me[s];if((l_+3|0)>>>0>Me[Er+3]>>>0)break;var b_=n_+l_|0;Ae[b_]=Ae[0|He.__str144],Ae[b_+1]=Ae[(0|He.__str144)+1],Ae[b_+2]=Ae[(0|He.__str144)+2];var k_=Se[s]+3|0;Se[s]=k_;break r}while(0);Q(r,0|He.__str144,3);break r}break r}if(7==(0|Uf)){var _=Se[pr+2]>>2;if(0!=(0|Se[_])){var zf=7;break}if(!(1==(0|Se[_+2])&49==(0|Ir))){var zf=Uf;break}var u_=Ae[Se[_+1]]<<24>>24;if(48==(0|u_)){var f=(r+8|0)>>2,c_=Me[f];if((c_+5|0)>>>0>Me[Er+3]>>>0){Q(r,0|He.__str145,5);break r}var h_=Or+c_|0;Ae[h_]=Ae[0|He.__str145],Ae[h_+1]=Ae[(0|He.__str145)+1],Ae[h_+2]=Ae[(0|He.__str145)+2],Ae[h_+3]=Ae[(0|He.__str145)+3],Ae[h_+4]=Ae[(0|He.__str145)+4];var d_=Se[f]+5|0;Se[f]=d_;break r}if(49==(0|u_)){var t=(r+8|0)>>2,w_=Me[t];if((w_+4|0)>>>0>Me[Er+3]>>>0){Q(r,0|He.__str146,4);break r}var p_=Or+w_|0;oe=1702195828,Ae[p_]=255&oe,oe>>=8,Ae[p_+1]=255&oe,oe>>=8,Ae[p_+2]=255&oe,oe>>=8,Ae[p_+3]=255&oe;var E_=Se[t]+4|0;Se[t]=E_;break r}var zf=Uf;break}var zf=Uf;break}var zf=0}while(0);var zf,v=(r+8|0)>>2,A_=Me[v],i=(r+12|0)>>2;A_>>>0<Me[i]>>>0?(Se[v]=A_+1|0,Ae[Or+A_|0]=40):Y(r,40);var g_=Se[Ff>>2];H(r,g_);var y_=Me[cr],m_=0==(0|y_);do{if(!m_){var S_=Me[v];if(S_>>>0>=Me[i]>>>0){gr=335;break}Se[v]=S_+1|0,Ae[y_+S_|0]=41,gr=336;break}gr=335}while(0);335==gr&&Y(r,41);var M_=50==(0|Se[Nr>>2]);e:do if(M_){var C_=Me[cr],R_=0==(0|C_);do if(!R_){var T_=Me[v];if(T_>>>0>=Me[i]>>>0)break;Se[v]=T_+1|0,Ae[C_+T_|0]=45;break e}while(0);Y(r,45)}while(0);if(8==(0|zf)){var O_=Me[cr],N_=0==(0|O_);do{if(!N_){var I_=Me[v];if(I_>>>0>=Me[i]>>>0){gr=345;break}Se[v]=I_+1|0,Ae[O_+I_|0]=91,gr=346;break}gr=345}while(0);345==gr&&Y(r,91);var P_=Se[pr+2];H(r,P_);var D_=Me[cr],L_=0==(0|D_);do if(!L_){var F_=Me[v];if(F_>>>0>=Me[i]>>>0)break;Se[v]=F_+1|0,Ae[D_+F_|0]=93;break r}while(0);Y(r,93);break r}var X_=Se[pr+2];H(r,X_);break r}Z(r);break r}}while(0);var e=(r+20|0)>>2,j_=Se[e],U_=0|Sr;Se[U_>>2]=j_,Se[e]=Sr,Se[Sr+4>>2]=a;var x_=Sr+8|0;Se[x_>>2]=0;var z_=Se[Er+4];Se[Sr+12>>2]=z_;var V_=Se[pr+1];H(r,V_),0==(0|Se[x_>>2])&&$(r,a);var B_=Se[U_>>2];Se[e]=B_}while(0);Oe=Ar}function K(r,a,e,i){var v=i>>2;Se[v]=r,Se[v+1]=r+e|0,Se[v+2]=a,Se[v+3]=r,Se[v+6]=e<<1,Se[v+5]=0,Se[v+9]=e,Se[v+8]=0,Se[v+10]=0,Se[v+11]=0,Se[v+12]=0}function Y(r,a){var e,i=r+4|0,v=Me[i>>2],t=0==(0|v);do if(!t){var e=(r+8|0)>>2,f=Me[e];if(f>>>0<Me[r+12>>2]>>>0)var _=v,s=f;else{tr(r,1);var n=Me[i>>2];if(0==(0|n))break;var _=n,s=Se[e]}var s,_;Ae[_+s|0]=255&a;var o=Se[e]+1|0;Se[e]=o}while(0)}function G(r,a,e,i){var v,t=i>>2,f=Oe;Oe+=4;var _=f,v=_>>2,s=0==(0|r);do if(s){if(0==(0|i)){var n=0;break}Se[t]=-3;var n=0}else{var o=0==(0|e);if(0!=(0|a)&o){if(0==(0|i)){var n=0;break}Se[t]=-3;var n=0}else{var l=W(r,_);if(0==(0|l)){if(0==(0|i)){var n=0;break}if(1==(0|Se[v])){Se[t]=-1;var n=0}else{Se[t]=-2;var n=0}}else{var b=0==(0|a);do if(b){if(o){var k=l;break}var u=Se[v];Se[e>>2]=u;var k=l}else{var c=Ca(l);if(c>>>0<Me[e>>2]>>>0){Ra(a,l);va(l);var k=a}else{va(a);var h=Se[v];Se[e>>2]=h;var k=l}}while(0);var k;if(0==(0|i)){var n=k;break}Se[t]=0;var n=k}}}while(0);var n;return Oe=f,n}function W(r,a){var e,i=Oe;Oe+=52;var v,t=i,e=t>>2;Se[a>>2]=0;var f=Ca(r),_=Ae[r]<<24>>24==95;do{if(_){if(Ae[r+1|0]<<24>>24==90){var s=0;v=13;break}v=3;break}v=3}while(0);do if(3==v){var n=Na(r,0|He.__str117,8);if(0!=(0|n)){var s=1;v=13;break}var o=Ae[r+8|0];if(o<<24>>24!=46&&o<<24>>24!=95&&o<<24>>24!=36){var s=1;v=13;break}var l=r+9|0,b=Ae[l];if(b<<24>>24!=68&&b<<24>>24!=73){\nvar s=1;v=13;break}if(Ae[r+10|0]<<24>>24!=95){var s=1;v=13;break}var k=f+29|0,u=Jr(k);if(0==(0|u)){Se[a>>2]=1;var c=0;v=19;break}Ae[l]<<24>>24==73?Pa(u,0|He.__str118,30,1):Pa(u,0|He.__str119,29,1);var h=r+11|0,c=(Ia(u,h),u);v=19;break}while(0);if(13==v){var s;K(r,17,f,t);var d=Se[e+6],w=Ta(),p=Oe;Oe+=12*d,Oe=Oe+3>>2<<2;var E=Oe;if(Oe+=4*Se[e+9],Oe=Oe+3>>2<<2,Se[e+4]=p,Se[e+7]=E,s)var A=N(t),g=A;else var y=T(t,1),g=y;var g,m=Ae[Se[e+3]]<<24>>24==0?g:0,S=Se[e+12]+f+10*Se[e+10]|0;if(0==(0|m))var M=0;else var C=S/8+S|0,R=B(17,m,C,a),M=R;var M;Oa(w);var c=M}var c;return Oe=i,c}function Z(r){var a=r+4|0,e=Se[a>>2];va(e),Se[a>>2]=0}function Q(r,a,e){var i,v=r+4|0,t=Me[v>>2],f=0==(0|t);do if(!f){var i=(r+8|0)>>2,_=Me[i];if((_+e|0)>>>0>Me[r+12>>2]>>>0){tr(r,e);var s=Me[v>>2];if(0==(0|s))break;var n=s,o=Se[i]}else var n=t,o=_;var o,n;Pa(n+o|0,a,e,1);var l=Se[i]+e|0;Se[i]=l}while(0)}function q(r,a,e){var i,v,t=a+e|0,f=(0|e)>0;r:do if(f)for(var _=t,s=r+4|0,i=(r+8|0)>>2,n=r+12|0,o=a;;){var o,l=(_-o|0)>3;a:do{if(l){if(Ae[o]<<24>>24!=95){v=21;break}if(Ae[o+1|0]<<24>>24!=95){v=21;break}if(Ae[o+2|0]<<24>>24!=85){v=21;break}for(var b=o+3|0,k=0;;){var k,b;if(b>>>0>=t>>>0){v=21;break a}var u=ge[b],c=u<<24>>24;if((u-48&255&255)<10)var h=c-48|0;else if((u-65&255&255)<6)var h=c-55|0;else{if((u-97&255&255)>=6)break;var h=c-87|0}var h,b=b+1|0,k=(k<<4)+h|0}if(!(u<<24>>24==95&k>>>0<256)){v=21;break}var d=Me[s>>2],w=0==(0|d);do if(!w){var p=Me[i];if(p>>>0>=Me[n>>2]>>>0)break;Se[i]=p+1|0,Ae[d+p|0]=255&k;var E=b;v=25;break a}while(0);Y(r,k);var E=b;v=25;break}v=21}while(0);a:do if(21==v){var A=Me[s>>2],g=0==(0|A);do if(!g){var y=Me[i];if(y>>>0>=Me[n>>2]>>>0)break;var m=Ae[o];Se[i]=y+1|0,Ae[A+y|0]=m;var E=o;break a}while(0);var S=Ae[o]<<24>>24;Y(r,S);var E=o}while(0);var E,M=E+1|0;if(M>>>0>=t>>>0)break r;var o=M}while(0)}function $(r,a){var e,i,v,t,f,_,s,n=r>>2,o=Se[a>>2];r:do if(22==(0|o)||25==(0|o)){var l=Me[n+1],b=0==(0|l);do if(!b){var _=(r+8|0)>>2,k=Me[_];if((k+9|0)>>>0>Me[n+3]>>>0)break;for(var u=l+k|0,c=0|He.__str147,h=u,d=c+9;c<d;c++,h++)Ae[h]=Ae[c];var w=Se[_]+9|0;Se[_]=w;break r}while(0);Q(r,0|He.__str147,9)}else if(23==(0|o)||26==(0|o)){var p=Me[n+1],E=0==(0|p);do if(!E){var f=(r+8|0)>>2,A=Me[f];if((A+9|0)>>>0>Me[n+3]>>>0)break;for(var g=p+A|0,c=0|He.__str148,h=g,d=c+9;c<d;c++,h++)Ae[h]=Ae[c];var y=Se[f]+9|0;Se[f]=y;break r}while(0);Q(r,0|He.__str148,9)}else if(24==(0|o)||27==(0|o)){var m=Me[n+1],S=0==(0|m);do if(!S){var t=(r+8|0)>>2,M=Me[t];if((M+6|0)>>>0>Me[n+3]>>>0)break;var C=m+M|0;Ae[C]=Ae[0|He.__str149],Ae[C+1]=Ae[(0|He.__str149)+1],Ae[C+2]=Ae[(0|He.__str149)+2],Ae[C+3]=Ae[(0|He.__str149)+3],Ae[C+4]=Ae[(0|He.__str149)+4],Ae[C+5]=Ae[(0|He.__str149)+5];var R=Se[t]+6|0;Se[t]=R;break r}while(0);Q(r,0|He.__str149,6)}else if(28==(0|o)){var T=Me[n+1],O=0==(0|T);do{if(!O){var N=r+8|0,I=Me[N>>2];if(I>>>0>=Me[n+3]>>>0){s=17;break}Se[N>>2]=I+1|0,Ae[T+I|0]=32,s=18;break}s=17}while(0);17==s&&Y(r,32);var P=Se[a+8>>2];H(r,P)}else if(29==(0|o)){if(0!=(4&Se[n]|0))break;var D=Me[n+1],L=0==(0|D);do if(!L){var F=r+8|0,X=Me[F>>2];if(X>>>0>=Me[n+3]>>>0)break;Se[F>>2]=X+1|0,Ae[D+X|0]=42;break r}while(0);Y(r,42)}else if(30==(0|o)){var j=Me[n+1],U=0==(0|j);do if(!U){var x=r+8|0,z=Me[x>>2];if(z>>>0>=Me[n+3]>>>0)break;Se[x>>2]=z+1|0,Ae[j+z|0]=38;break r}while(0);Y(r,38)}else if(31==(0|o)){var V=Me[n+1],B=0==(0|V);do if(!B){var v=(r+8|0)>>2,K=Me[v];if((K+8|0)>>>0>Me[n+3]>>>0)break;var G=V+K|0,W=0|G;oe=1886220131,Ae[W]=255&oe,oe>>=8,Ae[W+1]=255&oe,oe>>=8,Ae[W+2]=255&oe,oe>>=8,Ae[W+3]=255&oe;var Z=G+4|0;oe=544761196,Ae[Z]=255&oe,oe>>=8,Ae[Z+1]=255&oe,oe>>=8,Ae[Z+2]=255&oe,oe>>=8,Ae[Z+3]=255&oe;var q=Se[v]+8|0;Se[v]=q;break r}while(0);Q(r,0|He.__str150,8)}else if(32==(0|o)){var $=Me[n+1],J=0==(0|$);do if(!J){var i=(r+8|0)>>2,rr=Me[i];if((rr+10|0)>>>0>Me[n+3]>>>0)break;for(var ar=$+rr|0,c=0|He.__str151,h=ar,d=c+10;c<d;c++,h++)Ae[h]=Ae[c];var er=Se[i]+10|0;Se[i]=er;break r}while(0);Q(r,0|He.__str151,10)}else if(37==(0|o)){var ir=r+4|0,vr=Me[ir>>2],tr=0==(0|vr);do{if(!tr){var fr=r+8|0,_r=Me[fr>>2];if(0!=(0|_r)&&Ae[vr+(_r-1)|0]<<24>>24==40){s=42;break}if(_r>>>0>=Me[n+3]>>>0){s=41;break}Se[fr>>2]=_r+1|0,Ae[vr+_r|0]=32,s=42;break}s=41}while(0);41==s&&Y(r,32);var sr=Se[a+4>>2];H(r,sr);var nr=Me[ir>>2],or=0==(0|nr);do if(!or){var e=(r+8|0)>>2,lr=Me[e];if((lr+3|0)>>>0>Me[n+3]>>>0)break;var br=nr+lr|0;Ae[br]=Ae[0|He.__str135],Ae[br+1]=Ae[(0|He.__str135)+1],Ae[br+2]=Ae[(0|He.__str135)+2];var kr=Se[e]+3|0;Se[e]=kr;break r}while(0);Q(r,0|He.__str135,3)}else if(3==(0|o)){var ur=Se[a+4>>2];H(r,ur)}else H(r,a);while(0)}function J(r){var a=r+20|0,e=Se[a>>2];if((0|e)<(0|Se[r+24>>2])){var i=Se[r+16>>2]+12*e|0,v=e+1|0;Se[a>>2]=v;var t=i}else var t=0;var t;return t}function rr(r,a,e){var i,v,t,f,_=r>>2,s=e,t=s>>2,n=0;r:for(;;){var n,s,o=0==(0|s);do if(!o){if(0!=(0|Se[t+2]))break;var l=Se[Se[t+1]>>2];if(29==(0|l)||30==(0|l)){f=9;break r}if(22==(0|l)||23==(0|l)||24==(0|l)||28==(0|l)||31==(0|l)||32==(0|l)||37==(0|l)){var b=Se[_+1];f=12;break r}var s=Se[t],t=s>>2,n=1;continue r}while(0);if(0!=(0|Se[a+4>>2])&0==(0|n)){f=9;break}var k=0,u=r+4|0,v=u>>2;f=22;break}do if(9==f){var c=Se[_+1];if(0==(0|c)){f=17;break}var h=Se[_+2];if(0==(0|h)){var d=c;f=13;break}var w=Ae[c+(h-1)|0];if(w<<24>>24==40||w<<24>>24==42){f=18;break}var b=c;f=12;break}while(0);do if(12==f){var b;if(0==(0|b)){f=17;break}var d=b;f=13;break}while(0);do if(13==f){var d,p=r+8|0,E=Me[p>>2];if(0!=(0|E)&&Ae[d+(E-1)|0]<<24>>24==32){f=18;break}if(E>>>0>=Me[_+3]>>>0){f=17;break}Se[p>>2]=E+1|0,Ae[d+E|0]=32,f=18;break}while(0);do if(17==f){Y(r,32),f=18;break}while(0);r:do if(18==f){var A=r+4|0,g=Me[A>>2],y=0==(0|g);do if(!y){var m=r+8|0,S=Me[m>>2];if(S>>>0>=Me[_+3]>>>0)break;Se[m>>2]=S+1|0,Ae[g+S|0]=40;var k=1,u=A,v=u>>2;break r}while(0);Y(r,40);var k=1,u=A,v=u>>2}while(0);var u,k,i=(r+20|0)>>2,M=Se[i];Se[i]=0,vr(r,e,0);r:do if(k){var C=Me[v],R=0==(0|C);do if(!R){var T=r+8|0,O=Me[T>>2];if(O>>>0>=Me[_+3]>>>0)break;Se[T>>2]=O+1|0,Ae[C+O|0]=41;break r}while(0);Y(r,41)}while(0);var N=Me[v],I=0==(0|N);do{if(!I){var P=r+8|0,D=Me[P>>2];if(D>>>0>=Me[_+3]>>>0){f=30;break}Se[P>>2]=D+1|0,Ae[N+D|0]=40,f=31;break}f=30}while(0);30==f&&Y(r,40);var L=Se[a+8>>2];0!=(0|L)&&H(r,L);var F=Me[v],X=0==(0|F);do{if(!X){var j=r+8|0,U=Me[j>>2];if(U>>>0>=Me[_+3]>>>0){f=36;break}Se[j>>2]=U+1|0,Ae[F+U|0]=41,f=37;break}f=36}while(0);36==f&&Y(r,41),vr(r,e,1),Se[i]=M}function ar(r,a,e){var i,v,t,f=r>>2,_=0==(0|e);do{if(!_){var s=e,v=s>>2;r:for(;;){var s;if(0==(0|s)){var n=1;t=14;break}if(0==(0|Se[v+2])){var o=36==(0|Se[Se[v+1]>>2]),l=1&o^1;if(o){var n=l;t=14;break}var b=r+4|0,k=Me[b>>2],u=0==(0|k);do{if(!u){var i=(r+8|0)>>2,c=Me[i];if((c+2|0)>>>0>Me[f+3]>>>0){t=9;break}var h=k+c|0;oe=10272,Ae[h]=255&oe,oe>>=8,Ae[h+1]=255&oe;var d=Se[i]+2|0;Se[i]=d,vr(r,e,0),t=10;break}t=9}while(0);9==t&&(Q(r,0|He.__str140,2),vr(r,e,0));var w=Me[b>>2],p=0==(0|w);do if(!p){var E=r+8|0,A=Me[E>>2];if(A>>>0>=Me[f+3]>>>0)break;Se[E>>2]=A+1|0,Ae[w+A|0]=41;var g=l;t=15;break r}while(0);Y(r,41);var g=l;t=15;break}var s=Se[v],v=s>>2}if(14==t){var n;vr(r,e,0);var g=n}var g;if(0!=(0|g)){t=17;break}var y=r+4|0;t=21;break}t=17}while(0);r:do if(17==t){var m=r+4|0,S=Me[m>>2],M=0==(0|S);do if(!M){var C=r+8|0,R=Me[C>>2];if(R>>>0>=Me[f+3]>>>0)break;Se[C>>2]=R+1|0,Ae[S+R|0]=32;var y=m;break r}while(0);Y(r,32);var y=m}while(0);var y,T=Me[y>>2],O=0==(0|T);do{if(!O){var N=r+8|0,I=Me[N>>2];if(I>>>0>=Me[f+3]>>>0){t=24;break}Se[N>>2]=I+1|0,Ae[T+I|0]=91,t=25;break}t=24}while(0);24==t&&Y(r,91);var P=Se[a+4>>2];0!=(0|P)&&H(r,P);var D=Me[y>>2],L=0==(0|D);do{if(!L){var F=r+8|0,X=Me[F>>2];if(X>>>0>=Me[f+3]>>>0){t=30;break}Se[F>>2]=X+1|0,Ae[D+X|0]=93,t=31;break}t=30}while(0);30==t&&Y(r,93)}function er(r,a){var e,i,v,t,f,_,s=Oe;Oe+=8;var n,o=s,_=(a+4|0)>>2,l=Se[_];if(4==(0|Se[l>>2])){var f=(r+20|0)>>2,b=Se[f];Se[f]=0;var t=(r+16|0)>>2,k=Se[t],u=0|o;Se[u>>2]=k,Se[t]=o;var c=Se[_];Se[o+4>>2]=c;var h=Se[c+4>>2];H(r,h);var d=Se[u>>2];Se[t]=d;var v=(r+4|0)>>2,w=Me[v],p=0==(0|w);do{if(!p){var i=(r+8|0)>>2,E=Me[i],A=0==(0|E);do if(!A){if(Ae[w+(E-1)|0]<<24>>24!=60)break;E>>>0<Me[r+12>>2]>>>0?(Se[i]=E+1|0,Ae[w+E|0]=32):Y(r,32)}while(0);var g=Me[v];if(0==(0|g)){n=12;break}var y=Me[i];if(y>>>0>=Me[r+12>>2]>>>0){n=12;break}Se[i]=y+1|0,Ae[g+y|0]=60,n=13;break}n=12}while(0);12==n&&Y(r,60);var m=Se[Se[_]+8>>2];H(r,m);var S=Me[v],M=0==(0|S);do{if(!M){var e=(r+8|0)>>2,C=Me[e],R=0==(0|C);do if(!R){if(Ae[S+(C-1)|0]<<24>>24!=62)break;C>>>0<Me[r+12>>2]>>>0?(Se[e]=C+1|0,Ae[S+C|0]=32):Y(r,32)}while(0);var T=Me[v];if(0==(0|T)){n=22;break}var O=Me[e];if(O>>>0>=Me[r+12>>2]>>>0){n=22;break}Se[e]=O+1|0,Ae[T+O|0]=62,n=23;break}n=22}while(0);22==n&&Y(r,62),Se[f]=b}else H(r,l);Oe=s}function ir(r,a){var e,i=40==(0|Se[a>>2]);r:do if(i){var v=Me[r+4>>2],t=0==(0|v);do{if(!t){var e=(r+8|0)>>2,f=Me[e],_=a+4|0,s=Me[_>>2],n=Me[s+8>>2];if((n+f|0)>>>0>Me[r+12>>2]>>>0){var o=s,l=n;break}var b=v+f|0,k=Se[s+4>>2];Pa(b,k,n,1);var u=Se[e]+Se[Se[_>>2]+8>>2]|0;Se[e]=u;break r}var c=Me[a+4>>2],o=c,l=Se[c+8>>2]}while(0);var l,o,h=Se[o+4>>2];Q(r,h,l)}else H(r,a);while(0)}function vr(r,a,e){var i,v,t,f,_,f=(r+4|0)>>2,s=0==(0|e),t=(r+16|0)>>2;r:do if(s)for(var n=a;;){var n;if(0==(0|n)){_=29;break r}if(0==(0|Se[f])){_=29;break r}var o=n+8|0,l=0==(0|Se[o>>2]);do if(l){var b=n+4|0;if((Se[Se[b>>2]>>2]-25|0)>>>0<3)break;Se[o>>2]=1;var k=Me[t],u=Se[n+12>>2];Se[t]=u;var c=Me[b>>2],h=Se[c>>2];if(35==(0|h)){var d=n,w=k,p=c;_=14;break r}if(36==(0|h)){var E=n,A=k,g=c;_=15;break r}if(2==(0|h)){var y=k,m=b;_=16;break r}$(r,c),Se[t]=k}while(0);var n=Se[n>>2]}else for(var S=a;;){var S;if(0==(0|S)){_=29;break r}if(0==(0|Se[f])){_=29;break r}var M=S+8|0;if(0==(0|Se[M>>2])){Se[M>>2]=1;var C=Me[t],R=Se[S+12>>2];Se[t]=R;var T=S+4|0,O=Me[T>>2],N=Se[O>>2];if(35==(0|N)){var d=S,w=C,p=O;_=14;break r}if(36==(0|N)){var E=S,A=C,g=O;_=15;break r}if(2==(0|N)){var y=C,m=T;_=16;break r}$(r,O),Se[t]=C}var S=Se[S>>2]}while(0);if(14==_){var p,w,d,I=Se[d>>2];rr(r,p,I),Se[t]=w}else if(15==_){var g,A,E,P=Se[E>>2];ar(r,g,P),Se[t]=A}else if(16==_){var m,y,v=(r+20|0)>>2,D=Se[v];Se[v]=0;var L=Se[Se[m>>2]+4>>2];H(r,L),Se[v]=D;var F=0==(4&Se[r>>2]|0),X=Me[f],j=0!=(0|X);r:do if(F){do if(j){var i=(r+8|0)>>2,U=Me[i];if((U+2|0)>>>0>Me[r+12>>2]>>>0)break;var x=X+U|0;oe=14906,Ae[x]=255&oe,oe>>=8,Ae[x+1]=255&oe;var z=Se[i]+2|0;Se[i]=z;break r}while(0);Q(r,0|He.__str120,2)}else{do if(j){var V=r+8|0,B=Me[V>>2];if(B>>>0>=Me[r+12>>2]>>>0)break;Se[V>>2]=B+1|0,Ae[X+B|0]=46;break r}while(0);Y(r,46)}while(0);var K=Me[Se[m>>2]+8>>2],G=(Se[K>>2]-25|0)>>>0<3;r:do if(G)for(var W=K;;){var W,Z=Me[W+4>>2];if((Se[Z>>2]-25|0)>>>0>=3){var q=Z;break r}var W=Z}else var q=K;while(0);var q;H(r,q),Se[t]=y}}function tr(r,a){var e,e=(r+4|0)>>2,i=Se[e],v=0==(0|i);r:do if(!v){for(var t=Se[r+8>>2]+a|0,f=r+12|0,_=Se[f>>2],s=i;;){var s,_;if(t>>>0<=_>>>0)break r;var n=_<<1,o=fa(s,n);if(0==(0|o))break;Se[e]=o,Se[f>>2]=n;var _=n,s=o}var l=Se[e];va(l),Se[e]=0,Se[r+24>>2]=1}while(0)}function fr(r,a,e){var i,v=J(r),i=v>>2;return 0!=(0|v)&&(Se[i]=21,Se[i+1]=a,Se[i+2]=e),v}function _r(r){var a,a=(r+12|0)>>2,e=Se[a],i=Ae[e]<<24>>24;if(88==(0|i)){var v=e+1|0;Se[a]=v;var t=nr(r),f=Se[a],_=f+1|0;Se[a]=_;var s=Ae[f]<<24>>24==69?t:0,n=s}else if(76==(0|i))var o=or(r),n=o;else var l=N(r),n=l;var n;return n}function sr(r){var a,a=(r+12|0)>>2,e=Se[a],i=Ae[e];if(i<<24>>24==110){var v=e+1|0;Se[a]=v;var t=1,f=Ae[v],_=v}else var t=0,f=i,_=e;var _,f,t,s=(f-48&255&255)<10;r:do if(s)for(var n=f,o=0,l=_;;){var l,o,n,b=(n<<24>>24)-48+10*o|0,k=l+1|0;Se[a]=k;var u=ge[k];if((u-48&255&255)>=10){var c=b;break r}var n=u,o=b,l=k}else var c=0;while(0);var c,h=0==(0|t)?c:0|-c;return h}function nr(r){var a,e,a=(r+12|0)>>2,i=Se[a],v=Ae[i];do{if(v<<24>>24==76){var t=or(r),f=t;e=21;break}if(v<<24>>24==84){var _=x(r),f=_;e=21;break}if(v<<24>>24==115){if(Ae[i+1|0]<<24>>24!=114){e=8;break}var s=i+2|0;Se[a]=s;var n=N(r),o=br(r);if(Ae[Se[a]]<<24>>24==73){var l=z(r),b=D(r,4,o,l),k=D(r,1,n,b),f=k;e=21;break}var u=D(r,1,n,o),f=u;e=21;break}e=8}while(0);r:do if(8==e){var c=kr(r);if(0==(0|c)){var f=0;break}var h=0|c,d=Se[h>>2],w=40==(0|d);do{if(w){var p=c+4|0,E=r+48|0,A=Se[Se[p>>2]+8>>2]-2+Se[E>>2]|0;Se[E>>2]=A;var g=Se[h>>2];if(40!=(0|g)){var y=g;e=13;break}var m=Se[p>>2],S=Se[m>>2],M=Da(S,0|He.__str90);if(0!=(0|M)){var C=m;e=15;break}var R=N(r),T=D(r,43,c,R),f=T;break r}var y=d;e=13}while(0);do if(13==e){var y;if(40==(0|y)){var C=Se[c+4>>2];e=15;break}if(41==(0|y)){var O=c+4|0;e=17;break}if(42==(0|y)){e=18;break}var f=0;break r}while(0);do if(15==e){var C,O=C+12|0;e=17;break}while(0);do if(17==e){var O,I=Se[O>>2];if(1==(0|I))break;if(2==(0|I)){var P=nr(r),L=nr(r),F=D(r,45,P,L),X=D(r,44,c,F);return X}if(3==(0|I)){var j=nr(r),U=nr(r),V=nr(r),B=D(r,48,U,V),H=D(r,47,j,B),K=D(r,46,c,H);return K}var f=0;break r}while(0);var Y=nr(r),G=D(r,43,c,Y);return G}while(0);var f;return f}function or(r){var a,a=(r+12|0)>>2,e=Se[a],i=e+1|0;Se[a]=i;var v=Ae[e]<<24>>24==76;r:do if(v){if(Ae[i]<<24>>24==95)var t=T(r,0),f=t;else{var _=N(r);if(0==(0|_)){var s=0;break}var n=33==(0|Se[_>>2]);do if(n){var o=Se[_+4>>2];if(0==(0|Se[o+16>>2]))break;var l=r+48|0,b=Se[l>>2]-Se[o+4>>2]|0;Se[l>>2]=b}while(0);var k=Se[a];if(Ae[k]<<24>>24==110){var u=k+1|0;Se[a]=u;var c=50,h=u}else var c=49,h=k;for(var h,c,d=h;;){var d,w=Ae[d];if(w<<24>>24==69)break;if(w<<24>>24==0){var s=0;break r}var p=d+1|0;Se[a]=p;var d=p}var E=lr(r,h,d-h|0),A=D(r,c,_,E),f=A}var f,g=Se[a],y=g+1|0;Se[a]=y;var m=Ae[g]<<24>>24==69?f:0,s=m}else var s=0;while(0);var s;return s}function lr(r,a,e){var i=J(r),v=m(i,a,e),t=0==(0|v)?0:i;return t}function br(r){var a=r+12|0,e=Me[a>>2],i=ge[e],v=(i-48&255&255)<10;do if(v)var t=L(r),f=t;else if((i-97&255&255)<26){var _=kr(r);if(0==(0|_)){var f=0;break}if(40!=(0|Se[_>>2])){var f=_;break}var s=r+48|0,n=Se[Se[_+4>>2]+8>>2]+Se[s>>2]+7|0;Se[s>>2]=n;var f=_}else if(i<<24>>24==67||i<<24>>24==68)var o=hr(r),f=o;else{if(i<<24>>24!=76){var f=0;break}Se[a>>2]=e+1|0;var l=L(r);if(0==(0|l)){var f=0;break}var b=dr(r),k=0==(0|b)?0:l,f=k}while(0);var f;return f}function kr(r){var a,e,a=(r+12|0)>>2,i=Se[a],v=i+1|0;Se[a]=v;var t=ge[i],f=i+2|0;Se[a]=f;var _=ge[v];do{if(t<<24>>24==118){if((_-48&255&255)>=10){var s=49,n=0;e=6;break}var o=(_<<24>>24)-48|0,l=L(r),b=ur(r,o,l),k=b;e=14;break}if(t<<24>>24==99){if(_<<24>>24!=118){var s=49,n=0;e=6;break}var u=N(r),c=D(r,42,u,0),k=c;e=14;break}var s=49,n=0;e=6}while(0);r:do if(6==e){for(;;){var n,s,h=(s-n)/2+n|0,d=(h<<4)+ri|0,w=Se[d>>2],p=Ae[w],E=t<<24>>24==p<<24>>24;if(E&&_<<24>>24==Ae[w+1|0]<<24>>24)break;var A=t<<24>>24<p<<24>>24;do if(A)var g=h,y=n;else{if(E&&_<<24>>24<Ae[w+1|0]<<24>>24){var g=h,y=n;break}var g=s,y=h+1|0}while(0);var y,g;if((0|y)==(0|g)){var k=0;break r}var s=g,n=y}var m=cr(r,d),k=m}while(0);var k;return k}function ur(r,a,e){var i=J(r),v=S(i,a,e),t=0==(0|v)?0:i;return t}function cr(r,a){var e=J(r);return 0!=(0|e)&&(Se[e>>2]=40,Se[e+4>>2]=a),e}function hr(r){var a,e,i=Se[r+44>>2],e=i>>2,v=0==(0|i);do if(!v){var t=Se[e];if(0==(0|t)){var f=r+48|0,_=Se[f>>2]+Se[e+2]|0;Se[f>>2]=_}else{if(21!=(0|t))break;var s=r+48|0,n=Se[s>>2]+Se[e+2]|0;Se[s>>2]=n}}while(0);var a=(r+12|0)>>2,o=Se[a],l=o+1|0;Se[a]=l;var b=Ae[o]<<24>>24;do if(67==(0|b)){var k=o+2|0;Se[a]=k;var u=Ae[l]<<24>>24;if(49==(0|u))var c=1;else if(50==(0|u))var c=2;else{if(51!=(0|u)){var h=0;break}var c=3}var c,d=wr(r,c,i),h=d}else if(68==(0|b)){var w=o+2|0;Se[a]=w;var p=Ae[l]<<24>>24;if(48==(0|p))var E=1;else if(49==(0|p))var E=2;else{if(50!=(0|p)){var h=0;break}var E=3}var E,A=pr(r,E,i),h=A}else var h=0;while(0);var h;return h}function dr(r){var a=r+12|0,e=Se[a>>2];if(Ae[e]<<24>>24==95){var i=e+1|0;Se[a>>2]=i;var v=sr(r),t=v>>>31^1}else var t=1;var t;return t}function wr(r,a,e){var i=J(r),v=M(i,a,e),t=0==(0|v)?0:i;return t}function pr(r,a,e){var i=J(r),v=C(i,a,e),t=0==(0|v)?0:i;return t}function Er(r,a){var e=J(r);return 0!=(0|e)&&(Se[e>>2]=5,Se[e+4>>2]=a),e}function Ar(r){var a,a=(r+12|0)>>2,e=Se[a],i=Ae[e]<<24>>24;do if(78==(0|i))var v=gr(r),t=v;else if(90==(0|i))var f=yr(r),t=f;else if(76==(0|i))var _=br(r),t=_;else if(83==(0|i)){if(Ae[e+1|0]<<24>>24==116){var s=e+2|0;Se[a]=s;var n=lr(r,0|He.__str152,3),o=br(r),l=D(r,1,n,o),b=r+48|0,k=Se[b>>2]+3|0;Se[b>>2]=k;var u=0,c=l}else var h=V(r,0),u=1,c=h;var c,u;if(Ae[Se[a]]<<24>>24!=73){var t=c;break}if(0==(0|u)){var d=R(r,c);if(0==(0|d)){var t=0;break}}var w=z(r),p=D(r,4,c,w),t=p}else{var E=br(r);if(Ae[Se[a]]<<24>>24!=73){var t=E;break}var A=R(r,E);if(0==(0|A)){var t=0;break}var g=z(r),y=D(r,4,E,g),t=y}while(0);var t;return t}function gr(r){var a,e=Oe;Oe+=4;var i=e,a=(r+12|0)>>2,v=Se[a],t=v+1|0;Se[a]=t;var f=Ae[v]<<24>>24==78;do if(f){var _=I(r,i,1);if(0==(0|_)){var s=0;break}var n=mr(r);if(Se[_>>2]=n,0==(0|n)){var s=0;break}var o=Se[a],l=o+1|0;if(Se[a]=l,Ae[o]<<24>>24!=69){var s=0;break}var s=Se[i>>2]}else var s=0;while(0);var s;return Oe=e,s}function yr(r){var a,a=(r+12|0)>>2,e=Se[a],i=e+1|0;Se[a]=i;var v=Ae[e]<<24>>24==90;do if(v){var t=O(r,0),f=Se[a],_=f+1|0;if(Se[a]=_,Ae[f]<<24>>24!=69){var s=0;break}if(Ae[_]<<24>>24==115){var n=f+2|0;Se[a]=n;var o=dr(r);if(0==(0|o)){var s=0;break}var l=lr(r,0|He.__str168,14),b=D(r,2,t,l),s=b}else{var k=Ar(r),u=dr(r);if(0==(0|u)){var s=0;break}var c=D(r,2,t,k),s=c}}else var s=0;while(0);var s;return s}function mr(r){var a,e=r+12|0,i=0;r:for(;;){var i,v=ge[Se[e>>2]];if(v<<24>>24==0){var t=0;break}var f=(v-48&255&255)<10|(v-97&255&255)<26;do{if(!f){if(v<<24>>24==76||v<<24>>24==68||v<<24>>24==67){a=5;break}if(v<<24>>24==83){var _=V(r,1),s=_;a=10;break}if(v<<24>>24==73){if(0==(0|i)){var t=0;break r}var n=z(r),o=4,l=n;a=11;break}if(v<<24>>24==84){var b=x(r),s=b;a=10;break}if(v<<24>>24==69){var t=i;break r}var t=0;break r}a=5}while(0);do if(5==a){var k=br(r),s=k;a=10;break}while(0);do if(10==a){var s;if(0==(0|i)){var u=s;a=12;break}var o=1,l=s;a=11;break}while(0);if(11==a)var l,o,c=D(r,o,i,l),u=c;var u;if(v<<24>>24!=83)if(Ae[Se[e>>2]]<<24>>24!=69){var h=R(r,u);if(0==(0|h)){var t=0;break}var i=u}else var i=u;else var i=u}var t;return t}function Sr(r,a){var e,i,v=Oe;Oe+=4;var t=v,i=t>>2,e=(r+12|0)>>2,f=Se[e];if(Ae[f]<<24>>24==74){var _=f+1|0;Se[e]=_;var s=1}else var s=a;var s;Se[i]=0;var n=s,o=0,l=t;r:for(;;)for(var l,o,n,b=n,k=o;;){var k,b,u=Ae[Se[e]];if(u<<24>>24==0||u<<24>>24==69){var c=Se[i];if(0==(0|c)){var h=0;break r}var d=0==(0|Se[c+8>>2]);do if(d){var w=Se[c+4>>2];if(33!=(0|Se[w>>2])){var p=c;break}var E=Se[w+4>>2];if(9!=(0|Se[E+16>>2])){var p=c;break}var A=r+48|0,g=Se[A>>2]-Se[E+4>>2]|0;Se[A>>2]=g,Se[i]=0;var p=0}else var p=c;while(0);var p,y=D(r,35,k,p),h=y;break r}var m=N(r);if(0==(0|m)){var h=0;break r}if(0==(0|b)){var S=D(r,38,m,0);if(Se[l>>2]=S,0==(0|S)){var h=0;break r}var n=0,o=k,l=S+8|0;continue r}var b=0,k=m}var h;return Oe=v,h}function Mr(r){for(var a=r;;){var a;if(0==(0|a)){var e=0;break}var i=Se[a>>2];if(1!=(0|i)&&2!=(0|i)){if(6==(0|i)||7==(0|i)||42==(0|i)){var e=1;break}var e=0;break}var a=Se[a+8>>2]}var e;return e}function Cr(r){var a=r>>2;Se[a+3]=0,Se[a+2]=0,Se[a+1]=0,Se[a]=0,Se[a+4]=0}function Rr(r,a){var e,e=(r+12|0)>>2,i=Se[e],v=(Se[r+4>>2]-i|0)<(0|a);r:do if(v)var t=0;else{var f=i+a|0;Se[e]=f;var _=0==(4&Se[r+8>>2]|0);do if(!_){if(Ae[f]<<24>>24!=36)break;var s=a+(i+1)|0;Se[e]=s}while(0);var n=(0|a)>9;do if(n){var o=La(i,0|He.__str117,8);if(0!=(0|o))break;var l=Ae[i+8|0];if(l<<24>>24!=46&&l<<24>>24!=95&&l<<24>>24!=36)break;if(Ae[i+9|0]<<24>>24!=78)break;var b=r+48|0,k=22-a+Se[b>>2]|0;Se[b>>2]=k;var u=lr(r,0|He.__str169,21),t=u;break r}while(0);var c=lr(r,i,a),t=c}while(0);var t;return t}function Tr(r){var a,e,e=(r+48|0)>>2,i=Se[e],v=i+20|0;Se[e]=v;var a=(r+12|0)>>2,t=Se[a],f=t+1|0;Se[a]=f;var _=Ae[t];do if(_<<24>>24==84){var s=t+2|0;Se[a]=s;var n=Ae[f]<<24>>24;if(86==(0|n)){var o=i+15|0;Se[e]=o;var l=N(r),b=D(r,8,l,0),k=b}else if(84==(0|n)){var u=i+10|0;Se[e]=u;var c=N(r),h=D(r,9,c,0),k=h}else if(73==(0|n))var d=N(r),w=D(r,11,d,0),k=w;else if(83==(0|n))var p=N(r),E=D(r,12,p,0),k=E;else if(104==(0|n)){var A=Nr(r,104);if(0==(0|A)){var k=0;break}var g=O(r,0),y=D(r,14,g,0),k=y}else if(118==(0|n)){var m=Nr(r,118);if(0==(0|m)){var k=0;break}var S=O(r,0),M=D(r,15,S,0),k=M}else if(99==(0|n)){var C=Nr(r,0);if(0==(0|C)){var k=0;break}var R=Nr(r,0);if(0==(0|R)){var k=0;break}var T=O(r,0),I=D(r,16,T,0),k=I}else if(67==(0|n)){var P=N(r),L=sr(r);if((0|L)<0){var k=0;break}var F=Se[a],X=F+1|0;if(Se[a]=X,Ae[F]<<24>>24!=95){var k=0;break}var j=N(r),U=Se[e]+5|0;Se[e]=U;var x=D(r,10,j,P),k=x}else if(70==(0|n))var z=N(r),V=D(r,13,z,0),k=V;else{if(74!=(0|n)){var k=0;break}var B=N(r),H=D(r,17,B,0),k=H}}else if(_<<24>>24==71){var K=t+2|0;Se[a]=K;var Y=Ae[f]<<24>>24;if(86==(0|Y))var G=Ar(r),W=D(r,18,G,0),k=W;else if(82==(0|Y))var Z=Ar(r),Q=D(r,19,Z,0),k=Q;else{if(65!=(0|Y)){var k=0;break}var q=O(r,0),$=D(r,20,q,0),k=$}}else var k=0;while(0);var k;return k}function Or(r){for(var a,e=r,a=e>>2;;){var e;if(0==(0|e)){var i=0;break}var v=Se[a];if(4==(0|v)){var t=Se[a+1],f=Mr(t),i=0==(0|f)&1;break}if(25!=(0|v)&&26!=(0|v)&&27!=(0|v)){var i=0;break}var e=Se[a+1],a=e>>2}var i;return i}function Nr(r,a){var e;if(0==(0|a)){var i=r+12|0,v=Se[i>>2],t=v+1|0;Se[i>>2]=t;var f=Ae[v]<<24>>24}else var f=a;var f;do{if(104==(0|f)){var _=(sr(r),r+12|0);e=7;break}if(118==(0|f)){var s=(sr(r),r+12|0),n=Se[s>>2],o=n+1|0;if(Se[s>>2]=o,Ae[n]<<24>>24!=95){var l=0;e=8;break}var _=(sr(r),s);e=7;break}var l=0;e=8}while(0);if(7==e){var _,b=Se[_>>2],k=b+1|0;Se[_>>2]=k;var l=Ae[b]<<24>>24==95&1}var l;return l}function Ir(r){var a,e,i=r>>2,v=Oe;Oe+=56;var t,f=v,_=v+8,s=v+16,n=v+36,e=(0|r)>>2,o=Se[e],l=0==(8192&o|0);r:do{if(l){var a=(r+12|0)>>2,b=Se[a];if(Ae[b]<<24>>24!=63){var k=0;t=111;break}var u=b+1|0;Se[a]=u;var c=Ae[u];do if(c<<24>>24==63){if(Ae[b+2|0]<<24>>24==36){var h=b+3|0;if(Ae[h]<<24>>24!=63){var d=5;t=90;break}Se[a]=h;var w=6,p=h}else var w=0,p=u;var p,w,E=p+1|0;Se[a]=E;var A=Ae[E]<<24>>24;do if(48==(0|A)){var g=1;t=81}else{if(49==(0|A)){var g=2;t=81;break}if(50!=(0|A)){if(51==(0|A)){var y=0|He.__str2172,m=E;t=82;break}if(52==(0|A)){var y=0|He.__str3173,m=E;t=82;break}if(53==(0|A)){var y=0|He.__str4174,m=E;t=82;break}if(54==(0|A)){var y=0|He.__str5175,m=E;t=82;break}if(55==(0|A)){var y=0|He.__str6176,m=E;t=82;break}if(56==(0|A)){var y=0|He.__str7177,m=E;t=82;break}if(57==(0|A)){var y=0|He.__str8178,m=E;t=82;break}if(65==(0|A)){var y=0|He.__str9179,m=E;t=82;break}if(66==(0|A)){Se[a]=p+2|0;var S=0|He.__str10180,M=3;t=88;break}if(67==(0|A)){var y=0|He.__str11181,m=E;t=82;break}if(68==(0|A)){var y=0|He.__str12182,m=E;t=82;break}if(69==(0|A)){var y=0|He.__str13183,m=E;t=82;break}if(70==(0|A)){var y=0|He.__str14184,m=E;t=82;break}if(71==(0|A)){var y=0|He.__str15185,m=E;t=82;break}if(72==(0|A)){var y=0|He.__str16186,m=E;t=82;break}if(73==(0|A)){var y=0|He.__str17187,m=E;t=82;break}if(74==(0|A)){var y=0|He.__str18188,m=E;t=82;break}if(75==(0|A)){var y=0|He.__str19189,m=E;t=82;break}if(76==(0|A)){var y=0|He.__str20190,m=E;t=82;break}if(77==(0|A)){var y=0|He.__str21191,m=E;t=82;break}if(78==(0|A)){var y=0|He.__str22192,m=E;t=82;break}if(79==(0|A)){var y=0|He.__str23193,m=E;t=82;break}if(80==(0|A)){var y=0|He.__str24194,m=E;t=82;break}if(81==(0|A)){var y=0|He.__str25195,m=E;t=82;break}if(82==(0|A)){var y=0|He.__str26196,m=E;t=82;break}if(83==(0|A)){var y=0|He.__str27197,m=E;t=82;break}if(84==(0|A)){var y=0|He.__str28198,m=E;t=82;break}if(85==(0|A)){var y=0|He.__str29199,m=E;t=82;break}if(86==(0|A)){var y=0|He.__str30200,m=E;t=82;break}if(87==(0|A)){var y=0|He.__str31201,m=E;t=82;break}if(88==(0|A)){var y=0|He.__str32202,m=E;t=82;break}if(89==(0|A)){var y=0|He.__str33203,m=E;t=82;break}if(90==(0|A)){var y=0|He.__str34204,m=E;t=82;break}if(95==(0|A)){var C=p+2|0;Se[a]=C;var R=Ae[C]<<24>>24;if(48==(0|R)){var y=0|He.__str35205,m=C;t=82;break}if(49==(0|R)){var y=0|He.__str36206,m=C;t=82;break}if(50==(0|R)){var y=0|He.__str37207,m=C;t=82;break}if(51==(0|R)){var y=0|He.__str38208,m=C;t=82;break}if(52==(0|R)){var y=0|He.__str39209,m=C;t=82;break}if(53==(0|R)){var y=0|He.__str40210,m=C;t=82;break}if(54==(0|R)){var y=0|He.__str41211,m=C;t=82;break}if(55==(0|R)){var y=0|He.__str42212,m=C;t=82;break}if(56==(0|R)){var y=0|He.__str43213,m=C;t=82;break}if(57==(0|R)){var y=0|He.__str44214,m=C;t=82;break}if(65==(0|R)){var y=0|He.__str45215,m=C;t=82;break}if(66==(0|R)){var y=0|He.__str46216,m=C;t=82;break}if(67==(0|R)){Se[a]=p+3|0;var T=0|He.__str47217;t=84;break}if(68==(0|R)){var y=0|He.__str48218,m=C;t=82;break}if(69==(0|R)){var y=0|He.__str49219,m=C;t=82;break}if(70==(0|R)){var y=0|He.__str50220,m=C;t=82;break}if(71==(0|R)){var y=0|He.__str51221,m=C;t=82;break}if(72==(0|R)){var y=0|He.__str52222,m=C;t=82;break}if(73==(0|R)){var y=0|He.__str53223,m=C;t=82;break}if(74==(0|R)){var y=0|He.__str54224,m=C;t=82;break}if(75==(0|R)){var y=0|He.__str55225,m=C;t=82;break}if(76==(0|R)){var y=0|He.__str56226,m=C;t=82;break}if(77==(0|R)){var y=0|He.__str57227,m=C;t=82;break}if(78==(0|R)){var y=0|He.__str58228,m=C;t=82;break}if(79==(0|R)){var y=0|He.__str59229,m=C;t=82;break}if(82==(0|R)){var O=4|o;Se[e]=O;var N=p+3|0;Se[a]=N;var I=Ae[N]<<24>>24;if(48==(0|I)){Se[a]=p+4|0,Cr(s);var P=(Pr(r,_,s,0),Se[_>>2]),D=Se[_+4>>2],L=Dr(r,0|He.__str60230,(ne=Oe,Oe+=8,Se[ne>>2]=P,Se[ne+4>>2]=D,ne)),F=Se[a]-1|0;Se[a]=F;var y=L,m=F;t=82;break}if(49==(0|I)){Se[a]=p+4|0;var X=Lr(r),j=Lr(r),U=Lr(r),x=Lr(r),z=Se[a]-1|0;Se[a]=z;var V=Dr(r,0|He.__str61231,(ne=Oe,Oe+=16,Se[ne>>2]=X,Se[ne+4>>2]=j,Se[ne+8>>2]=U,Se[ne+12>>2]=x,ne)),y=V,m=Se[a];t=82;break}if(50==(0|I)){var y=0|He.__str62232,m=N;t=82;break}if(51==(0|I)){var y=0|He.__str63233,m=N;t=82;break}if(52==(0|I)){var y=0|He.__str64234,m=N;t=82;break}var y=0,m=N;t=82;break}if(83==(0|R)){var y=0|He.__str65235,m=C;t=82;break}if(84==(0|R)){var y=0|He.__str66236,m=C;t=82;break}if(85==(0|R)){var y=0|He.__str67237,m=C;t=82;break}if(86==(0|R)){var y=0|He.__str68238,m=C;t=82;break}if(88==(0|R)){var y=0|He.__str69239,m=C;t=82;break}if(89==(0|R)){var y=0|He.__str70240,m=C;t=82;break}var k=0;t=111;break r}var k=0;t=111;break r}var y=0|He.__str1171,m=E;t=82}while(0);do{if(81==t){var g;Se[a]=p+2|0;var B=g;t=83;break}if(82==t){var m,y;if(Se[a]=m+1|0,1==(0|w)||2==(0|w)){var B=w;t=83;break}if(4==(0|w)){var T=y;t=84;break}if(6!=(0|w)){var S=y,M=w;t=88;break}Cr(n);var H=Xr(r,n,0,60,62);if(0==(0|H))var K=y;else var Y=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=y,Se[ne+4>>2]=H,ne)),K=Y;var K;Se[i+6]=0;var S=K,M=w;t=88;break}}while(0);if(83==t){var B,G=r+40|0,W=Fr(r,0|He._symbol_demangle_dashed_null,-1,G);if(0==(0|W)){var k=0;t=111;break r}var d=B;t=90;break}if(84==t){var T;Se[i+4]=T;var Z=1,Q=T;t=109;break r}if(88==t){var M,S,q=r+40|0,$=Fr(r,S,-1,q);if(0==(0|$)){var k=0;t=111;break r}var d=M;t=90;break}}else{if(c<<24>>24==36){var J=b+2|0;Se[a]=J;var rr=jr(r);Se[i+4]=rr;var ar=0!=(0|rr)&1;t=107;break}var d=0;t=90}while(0);if(90==t){var d,er=Me[a],ir=Ae[er]<<24>>24;if(64==(0|ir))Se[a]=er+1|0;else if(36==(0|ir))t=93;else{var vr=zr(r);if(0==(0|vr)){var k=-1;t=111;break}}if(5==(0|d)){var tr=r+20|0,fr=Se[tr>>2]+1|0;Se[tr>>2]=fr}else if(1==(0|d)||2==(0|d)){if(Me[i+11]>>>0<2){var k=-1;t=111;break}var _r=r+56|0,sr=Me[_r>>2],nr=Se[sr+4>>2];if(1==(0|d))Se[sr>>2]=nr;else{var or=Dr(r,0|He.__str71241,(ne=Oe,Oe+=4,Se[ne>>2]=nr,ne)),lr=Se[_r>>2];Se[lr>>2]=or}var br=4|Se[e];Se[e]=br}else if(3==(0|d)){var kr=Se[e]&-5;Se[e]=kr}var ur=ge[Se[a]];if((ur-48&255&255)<10)var cr=Vr(r),ar=cr;else if((ur-65&255&255)<26)var hr=Br(r,3==(0|d)&1),ar=hr;else{if(ur<<24>>24!=36){var k=-1;t=111;break}var dr=Hr(r),ar=dr}}var ar;if(0==(0|ar)){var k=-1;t=111;break}var Z=ar,Q=Se[i+4];t=109;break}var wr=Pr(r,f,0,0);if(0==(0|wr)){var k=-1;t=111;break}var pr=Se[f>>2],Er=Se[f+4>>2],Ar=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=pr,Se[ne+4>>2]=Er,ne));Se[i+4]=Ar;var Z=1,Q=Ar;t=109;break}while(0);do if(109==t){var Q,Z;if(0!=(0|Q)){var k=Z;break}Xa(0|He.__str72242,1499,0|He.___func___symbol_demangle,0|He.__str73243);var k=Z}while(0);var k;return Oe=v,k}function Pr(r,a,e,i){var v,t,f,_=Oe;Oe+=24;var s=_,n=_+4,o=_+8,l=_+16,b=_+20;0==(0|a)&&Xa(0|He.__str72242,829,0|He.___func___demangle_datatype,0|He.__str121291);var f=(a+4|0)>>2;Se[f]=0;var t=(0|a)>>2;Se[t]=0;var v=(r+12|0)>>2,k=Me[v],u=k+1|0;Se[v]=u;var c=Ae[k],h=c<<24>>24;do if(95==(0|h)){Se[v]=k+2|0;var d=Ae[u],w=Zr(d);Se[t]=w}else if(67==(0|h)||68==(0|h)||69==(0|h)||70==(0|h)||71==(0|h)||72==(0|h)||73==(0|h)||74==(0|h)||75==(0|h)||77==(0|h)||78==(0|h)||79==(0|h)||88==(0|h)||90==(0|h)){var p=Qr(c);Se[t]=p}else if(84==(0|h)||85==(0|h)||86==(0|h)||89==(0|h)){var E=qr(r);if(0==(0|E))break;var A=0==(32768&Se[r>>2]|0);do if(A)if(84==(0|h))var g=0|He.__str122292;else if(85==(0|h))var g=0|He.__str123293;else if(86==(0|h))var g=0|He.__str124294;else{if(89!=(0|h)){var g=0;break}var g=0|He.__str125295}else var g=0;while(0);var g,y=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=g,Se[ne+4>>2]=E,ne));Se[t]=y}else if(63==(0|h))if(0==(0|i))$r(a,r,e,63,0);else{var m=Lr(r);if(0==(0|m))break;var S=Dr(r,0|He.__str126296,(ne=Oe,Oe+=4,Se[ne>>2]=m,ne));Se[t]=S}else if(65==(0|h)||66==(0|h))$r(a,r,e,c,i);else if(81==(0|h)||82==(0|h)||83==(0|h)){var M=0==(0|i)?80:c;$r(a,r,e,M,i)}else if(80==(0|h))if(((Ae[u]<<24>>24)-48|0)>>>0<10){var C=k+2|0;if(Se[v]=C,Ae[u]<<24>>24!=54)break;var R=r+44|0,T=Se[R>>2];Se[v]=k+3|0;var O=Ae[C],N=Se[r>>2]&-17,I=Ur(O,s,n,N);if(0==(0|I))break;var P=Pr(r,o,e,0);if(0==(0|P))break;var D=Xr(r,e,1,40,41);if(0==(0|D))break;Se[R>>2]=T;var L=Se[o>>2],F=Se[o+4>>2],X=Se[s>>2],j=Dr(r,0|He.__str127297,(ne=Oe,Oe+=12,Se[ne>>2]=L,Se[ne+4>>2]=F,Se[ne+8>>2]=X,ne));Se[t]=j;var U=Dr(r,0|He.__str128298,(ne=Oe,Oe+=4,Se[ne>>2]=D,ne));Se[f]=U}else $r(a,r,e,80,i);else if(87==(0|h)){if(Ae[u]<<24>>24!=52)break;Se[v]=k+2|0;var x=qr(r);if(0==(0|x))break;if(0==(32768&Se[r>>2]|0)){var z=Dr(r,0|He.__str129299,(ne=Oe,Oe+=4,Se[ne>>2]=x,ne));Se[t]=z}else Se[t]=x}else if(48==(0|h)||49==(0|h)||50==(0|h)||51==(0|h)||52==(0|h)||53==(0|h)||54==(0|h)||55==(0|h)||56==(0|h)||57==(0|h)){var V=h<<1,B=V-96|0,H=Yr(e,B);Se[t]=H;var K=V-95|0,Y=Yr(e,K);Se[f]=Y}else if(36==(0|h)){var G=k+2|0;Se[v]=G;var W=Ae[u]<<24>>24;if(48==(0|W)){var Z=Lr(r);Se[t]=Z}else if(68==(0|W)){var Q=Lr(r);if(0==(0|Q))break;var q=Dr(r,0|He.__str130300,(ne=Oe,Oe+=4,Se[ne>>2]=Q,ne));Se[t]=q}else if(70==(0|W)){var $=Lr(r);if(0==(0|$))break;var J=Lr(r);if(0==(0|J))break;var rr=Dr(r,0|He.__str131301,(ne=Oe,Oe+=8,Se[ne>>2]=$,Se[ne+4>>2]=J,ne));Se[t]=rr}else if(71==(0|W)){var ar=Lr(r);if(0==(0|ar))break;var er=Lr(r);if(0==(0|er))break;var ir=Lr(r);if(0==(0|ir))break;var vr=Dr(r,0|He.__str132302,(ne=Oe,Oe+=12,Se[ne>>2]=ar,Se[ne+4>>2]=er,Se[ne+8>>2]=ir,ne));Se[t]=vr}else if(81==(0|W)){var tr=Lr(r);if(0==(0|tr))break;var fr=Dr(r,0|He.__str133303,(ne=Oe,Oe+=4,Se[ne>>2]=tr,ne));Se[t]=fr}else{if(36!=(0|W))break;if(Ae[G]<<24>>24!=67)break;Se[v]=k+3|0;var _r=xr(r,l,b);if(0==(0|_r))break;var sr=Pr(r,a,e,i);if(0==(0|sr))break;var nr=Se[t],or=Se[l>>2],lr=Dr(r,0|He.__str83253,(ne=Oe,Oe+=8,Se[ne>>2]=nr,Se[ne+4>>2]=or,ne));Se[t]=lr}}while(0);var br=0!=(0|Se[t])&1;return Oe=_,br}function Dr(r,a){var e,i=Oe;Oe+=4;var v=i,e=v>>2,t=v;Se[t>>2]=arguments[Dr.length];var f=1,_=0;r:for(;;){var _,f,s=Ae[a+_|0];do{if(s<<24>>24==0)break r;if(s<<24>>24==37){var n=_+1|0,o=Ae[a+n|0]<<24>>24;if(115==(0|o)){var l=Se[e],b=l,k=l+4|0;Se[e]=k;var u=Se[b>>2];if(0==(0|u)){var c=f,h=n;break}var d=Ca(u),c=d+f|0,h=n;break}if(99==(0|o)){var w=Se[e]+4|0;Se[e]=w;var c=f+1|0,h=n;break}if(37==(0|o))var p=n;else var p=_;var p,c=f+1|0,h=p}else var c=f+1|0,h=_}while(0);var h,c,f=c,_=h+1|0}var E=Wr(r,f);if(0==(0|E))var A=0;else{Se[t>>2]=arguments[Dr.length];var g=E,y=0;r:for(;;){var y,g,m=Ae[a+y|0];do{if(m<<24>>24==0)break r;if(m<<24>>24==37){var S=y+1|0,M=Ae[a+S|0]<<24>>24;if(115==(0|M)){var C=Se[e],R=C,T=C+4|0;Se[e]=T;var O=Se[R>>2];if(0==(0|O)){var N=g,I=S;break}var P=Ca(O);Pa(g,O,P,1);var N=g+P|0,I=S;break}if(99==(0|M)){var D=Se[e],L=D,F=D+4|0;Se[e]=F,Ae[g]=255&Se[L>>2];var N=g+1|0,I=S;break}if(37==(0|M))var X=S;else var X=y;var X;Ae[g]=37;var N=g+1|0,I=X}else{Ae[g]=m;var N=g+1|0,I=y}}while(0);var I,N,g=N,y=I+1|0}Ae[g]=0;var A=E}var A;return Oe=i,A}function Lr(r){var a,a=(r+12|0)>>2,e=Se[a],i=Ae[e];if(i<<24>>24==63){var v=e+1|0;Se[a]=v;var t=1,f=v,_=Ae[v]}else var t=0,f=e,_=i;var _,f,t,s=(_-48&255&255)<9;do if(s){var n=Wr(r,3),o=0!=(0|t);o&&(Ae[n]=45);var l=Ae[Se[a]]+1&255;Ae[n+t|0]=l;var b=o?2:1;\nAe[n+b|0]=0;var k=Se[a]+1|0;Se[a]=k;var u=n}else if(_<<24>>24==57){var c=Wr(r,4),h=0!=(0|t);h&&(Ae[c]=45),Ae[c+t|0]=49;var d=h?2:1;Ae[c+d|0]=48;var w=h?3:2;Ae[c+w|0]=0;var p=Se[a]+1|0;Se[a]=p;var u=c}else{if((_-65&255&255)>=16){var u=0;break}for(var E=0,A=f;;){var A,E,g=A+1|0;Se[a]=g;var y=(Ae[A]<<24>>24)+((E<<4)-65)|0,m=ge[g];if((m-65&255&255)>=16)break;var E=y,A=g}if(m<<24>>24!=64){var u=0;break}var S=Wr(r,17),M=0!=(0|t)?0|He.__str119289:0|ii,C=(za(S,0|He.__str118288,(ne=Oe,Oe+=8,Se[ne>>2]=M,Se[ne+4>>2]=y,ne)),Se[a]+1|0);Se[a]=C;var u=S}while(0);var u;return u}function Fr(r,a,e,i){var v,t,f,_;0==(0|a)&&Xa(0|He.__str72242,212,0|He.___func___str_array_push,0|He.__str115285),0==(0|i)&&Xa(0|He.__str72242,213,0|He.___func___str_array_push,0|He.__str116286);var f=(i+12|0)>>2,s=Me[f],n=0==(0|s);do{if(n){Se[f]=32;var o=Wr(r,128);if(0==(0|o)){var l=0;_=17;break}Se[i+16>>2]=o,_=11;break}if(Me[i+8>>2]>>>0<s>>>0){_=11;break}var b=s<<3,k=Wr(r,b);if(0==(0|k)){var l=0;_=17;break}var u=k,c=i+16|0,h=Se[c>>2],d=Se[f]<<2;Pa(k,h,d,1);var w=Se[f]<<1;Se[f]=w,Se[c>>2]=u,_=11;break}while(0);do if(11==_){if((0|e)==-1)var p=Ca(a),E=p;else var E=e;var E,A=ja(a),g=E+1|0,y=Wr(r,g),t=(i+4|0)>>2,v=(i+16|0)>>2,m=(Se[t]<<2)+Se[v]|0;Se[m>>2]=y;var S=Se[Se[v]+(Se[t]<<2)>>2];if(0==(0|S)){Xa(0|He.__str72242,233,0|He.___func___str_array_push,0|He.__str117287);var M=Se[Se[v]+(Se[t]<<2)>>2]}else var M=S;var M;Pa(M,A,E,1),va(A),Ae[Se[Se[v]+(Se[t]<<2)>>2]+g|0]=0;var C=Se[t]+1|0;Se[t]=C;var R=i+8|0;if(C>>>0<Me[R>>2]>>>0){var l=1;break}Se[R>>2]=C;var l=1}while(0);var l;return l}function Xr(r,a,e,i,v){var t,f,_=Oe;Oe+=28;var s,n=_,o=_+8;Cr(o);var f=(r+12|0)>>2,l=0==(0|e),t=(0|n)>>2,b=n+4|0;r:do if(l)for(;;){var k=Se[f],u=Ae[k];if(u<<24>>24==0){s=12;break r}if(u<<24>>24==64){var c=k;s=7;break r}var h=Pr(r,n,a,1);if(0==(0|h)){var d=0;s=25;break r}var w=Se[t],p=Se[b>>2],E=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=w,Se[ne+4>>2]=p,ne)),A=Fr(r,E,-1,o);if(0==(0|A)){var d=0;s=25;break r}var g=Se[t],y=Da(g,0|He.__str110280);if(0==(0|y)){s=12;break r}}else for(;;){var m=Se[f],S=Ae[m];if(S<<24>>24==0){s=12;break r}if(S<<24>>24==64){var c=m;s=7;break r}var M=Pr(r,n,a,1);if(0==(0|M)){var d=0;s=25;break r}var C=Se[t],R=Da(C,0|He.__str84254);if(0==(0|R)){s=13;break r}var T=Se[b>>2],O=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=C,Se[ne+4>>2]=T,ne)),N=Fr(r,O,-1,o);if(0==(0|N)){var d=0;s=25;break r}var I=Se[t],P=Da(I,0|He.__str110280);if(0==(0|P)){s=12;break r}}while(0);do if(7==s){var c;Se[f]=c+1|0,s=12;break}while(0);do if(12==s){if(l){s=14;break}s=13;break}while(0);do if(13==s){var D=Se[f],L=D+1|0;if(Se[f]=L,Ae[D]<<24>>24==90){s=14;break}var d=0;s=25;break}while(0);r:do if(14==s){var F=o+4|0,X=Me[F>>2];do{if(0!=(0|X)){if(1==(0|X)){var j=o+16|0,U=Se[Se[j>>2]>>2],x=Da(U,0|He.__str84254);if(0==(0|x)){s=17;break}var z=j;s=20;break}var V=o+16|0;if(X>>>0<=1){var z=V;s=20;break}for(var B=0,H=1;;){var H,B,K=Se[Se[V>>2]+(H<<2)>>2],Y=Dr(r,0|He.__str112282,(ne=Oe,Oe+=8,Se[ne>>2]=B,Se[ne+4>>2]=K,ne)),G=H+1|0;if(G>>>0>=Me[F>>2]>>>0)break;var B=Y,H=G}if(0==(0|Y)){var z=V;s=20;break}var W=Y,Z=Y;s=21;break}s=17}while(0);if(17==s){var Q=i<<24>>24,q=v<<24>>24,$=Dr(r,0|He.__str111281,(ne=Oe,Oe+=8,Se[ne>>2]=Q,Se[ne+4>>2]=q,ne)),d=$;break}if(20==s)var z,W=Se[Se[z>>2]>>2],Z=0;var Z,W,J=v<<24>>24,rr=v<<24>>24==62;do if(rr){var ar=Ca(W);if(Ae[W+(ar-1)|0]<<24>>24!=62)break;var er=i<<24>>24,ir=Se[Se[o+16>>2]>>2],vr=Dr(r,0|He.__str113283,(ne=Oe,Oe+=16,Se[ne>>2]=er,Se[ne+4>>2]=ir,Se[ne+8>>2]=Z,Se[ne+12>>2]=J,ne)),d=vr;break r}while(0);var tr=i<<24>>24,fr=Se[Se[o+16>>2]>>2],_r=Dr(r,0|He.__str114284,(ne=Oe,Oe+=16,Se[ne>>2]=tr,Se[ne+4>>2]=fr,Se[ne+8>>2]=Z,Se[ne+12>>2]=J,ne)),d=_r}while(0);var d;return Oe=_,d}function jr(r){var a,e=Oe;Oe+=20;var i=e,v=r+24|0,t=Se[v>>2],a=(r+20|0)>>2,f=Se[a],_=r+44|0,s=Se[_>>2];Se[a]=t;var n=Kr(r);if(0==(0|n))var o=0;else{Cr(i);var l=Xr(r,i,0,60,62);if(0==(0|l))var b=n;else var k=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=n,Se[ne+4>>2]=l,ne)),b=k;var b;Se[v>>2]=t,Se[a]=f,Se[_>>2]=s;var o=b}var o;return Oe=e,o}function Ur(r,a,e,i){var v,t=a>>2;Se[e>>2]=0,Se[t]=0;var f=0==(18&i|0);do{if(f){var _=r<<24>>24,s=1==((_-65)%2|0);if(0==(1&i|0)){if(s?Se[e>>2]=0|He.__str95265:v=14,65==(0|_)||66==(0|_)){Se[t]=0|He.__str96266,v=21;break}if(67==(0|_)||68==(0|_)){Se[t]=0|He.__str97267,v=21;break}if(69==(0|_)||70==(0|_)){Se[t]=0|He.__str98268,v=21;break}if(71==(0|_)||72==(0|_)){Se[t]=0|He.__str99269,v=21;break}if(73==(0|_)||74==(0|_)){Se[t]=0|He.__str100270,v=21;break}if(75==(0|_)||76==(0|_)){v=21;break}if(77==(0|_)){Se[t]=0|He.__str101271,v=21;break}var n=0;v=22;break}if(s?Se[e>>2]=0|He.__str88258:v=5,65==(0|_)||66==(0|_)){Se[t]=0|He.__str89259,v=21;break}if(67==(0|_)||68==(0|_)){Se[t]=0|He.__str90260,v=21;break}if(69==(0|_)||70==(0|_)){Se[t]=0|He.__str91261,v=21;break}if(71==(0|_)||72==(0|_)){Se[t]=0|He.__str92262,v=21;break}if(73==(0|_)||74==(0|_)){Se[t]=0|He.__str93263,v=21;break}if(75==(0|_)||76==(0|_)){v=21;break}if(77==(0|_)){Se[t]=0|He.__str94264,v=21;break}var n=0;v=22;break}v=21}while(0);if(21==v)var n=1;var n;return n}function xr(r,a,e){var i;Se[e>>2]=0;var i=(r+12|0)>>2,v=Se[i];if(Ae[v]<<24>>24==69){Se[e>>2]=0|He.__str102272;var t=Se[i]+1|0;Se[i]=t;var f=t}else var f=v;var f;Se[i]=f+1|0;var _=Ae[f]<<24>>24;if(65==(0|_)){Se[a>>2]=0;var s=1}else if(66==(0|_)){Se[a>>2]=0|He.__str103273;var s=1}else if(67==(0|_)){Se[a>>2]=0|He.__str104274;var s=1}else if(68==(0|_)){Se[a>>2]=0|He.__str105275;var s=1}else var s=0;var s;return s}function zr(r){var a,e,a=(r+12|0)>>2,i=r+40|0,v=r+20|0,t=0|i,f=r+44|0,_=r+48|0,s=r+52|0,n=r+56|0,o=r+20|0,l=r+24|0,b=r+16|0,k=0;r:for(;;){var k,u=Se[a],c=Ae[u];if(c<<24>>24==64){var h=u+1|0;Se[a]=h;var d=1;break}var w=c<<24>>24;do{if(0==(0|w)){var d=0;break r}if(48==(0|w)||49==(0|w)||50==(0|w)||51==(0|w)||52==(0|w)||53==(0|w)||54==(0|w)||55==(0|w)||56==(0|w)||57==(0|w)){var p=u+1|0;Se[a]=p;var E=(Ae[u]<<24>>24)-48|0,A=Yr(v,E),g=A;e=14;break}if(63==(0|w)){var y=u+1|0;Se[a]=y;var m=Ae[y]<<24>>24;if(36==(0|m)){var S=u+2|0;Se[a]=S;var M=jr(r);if(0==(0|M)){var d=0;break r}var C=Fr(r,M,-1,v);if(0==(0|C)){var d=0;break r}var R=M;e=15;break}if(63==(0|m)){var T=Se[t>>2],O=Se[f>>2],N=Se[_>>2],I=Se[s>>2],P=Se[n>>2],D=Se[o>>2],L=Se[l>>2];Cr(i);var F=Ir(r);if(0==(0|F))var X=k;else var j=Se[b>>2],U=Dr(r,0|He.__str109279,(ne=Oe,Oe+=4,Se[ne>>2]=j,ne)),X=U;var X;Se[o>>2]=D,Se[l>>2]=L,Se[t>>2]=T,Se[f>>2]=O,Se[_>>2]=N,Se[s>>2]=I,Se[n>>2]=P;var g=X;e=14;break}var x=Lr(r);if(0==(0|x)){var d=0;break r}var z=Dr(r,0|He.__str109279,(ne=Oe,Oe+=4,Se[ne>>2]=x,ne)),g=z;e=14;break}var V=Kr(r),g=V;e=14;break}while(0);if(14==e){var g;if(0==(0|g)){var d=0;break}var R=g}var R,B=Fr(r,R,-1,i);if(0==(0|B)){var d=0;break}var k=R}var d;return d}function Vr(r){var a,e,i,v=Oe;Oe+=36;var t,f=v,i=f>>2,_=v+4,s=v+8,e=s>>2,n=v+16;Se[i]=0;var o=0|r,l=Se[o>>2],b=0==(128&l|0),k=r+12|0;do if(b){var u=Ae[Se[k>>2]]<<24>>24;if(48==(0|u))var c=0|He.__str76246,h=k,a=h>>2;else if(49==(0|u))var c=0|He.__str77247,h=k,a=h>>2;else{if(50!=(0|u)){var c=0,h=k,a=h>>2;break}var c=0|He.__str78248,h=k,a=h>>2}}else var c=0,h=k,a=h>>2;while(0);var h,c,d=0==(512&l|0);do if(d){if((Ae[Se[a]]-48&255&255)>=3){var w=0;break}var w=0|He.__str79249}else var w=0;while(0);var w,p=Gr(r,0),E=Se[a],A=E+1|0;Se[a]=A;var g=Ae[E]<<24>>24;do{if(48==(0|g)||49==(0|g)||50==(0|g)||51==(0|g)||52==(0|g)||53==(0|g)){var y=r+44|0,m=Se[y>>2];Cr(n);var S=Pr(r,s,n,0);if(0==(0|S)){var M=0;t=28;break}var C=xr(r,f,_);if(0==(0|C)){var M=0;t=28;break}var R=Se[i],T=0==(0|R),O=Se[_>>2];do if(T)Se[i]=O;else{if(0==(0|O))break;var N=Dr(r,0|He.__str83253,(ne=Oe,Oe+=8,Se[ne>>2]=R,Se[ne+4>>2]=O,ne));Se[i]=N}while(0);Se[y>>2]=m,t=22;break}if(54==(0|g)||55==(0|g)){var I=s+4|0;Se[I>>2]=0,Se[e]=0;var P=xr(r,f,_);if(0==(0|P)){var M=0;t=28;break}if(Ae[Se[a]]<<24>>24==64){t=22;break}var D=qr(r);if(0==(0|D)){var M=0;t=28;break}var L=Dr(r,0|He.__str107277,(ne=Oe,Oe+=4,Se[ne>>2]=D,ne));Se[I>>2]=L,t=22;break}if(56==(0|g)||57==(0|g)){Se[e+1]=0,Se[e]=0,Se[i]=0,t=22;break}var M=0;t=28}while(0);if(22==t){var F=0==(4096&Se[o>>2]|0);do{if(F){var X=Se[e],j=Se[i];if(0==(0|j)){var U=X;t=26;break}var x=0!=(0|X)?0|He.__str87257:0,z=0|He.__str87257,V=j,B=x,H=X;t=27;break}Se[i]=0,Se[e+1]=0,Se[e]=0;var U=0;t=26;break}while(0);if(26==t)var U,K=0!=(0|U)?0|He.__str87257:0,z=K,V=0,B=0,H=U;var H,B,V,z,Y=Se[e+1],G=Dr(r,0|He.__str108278,(ne=Oe,Oe+=32,Se[ne>>2]=c,Se[ne+4>>2]=w,Se[ne+8>>2]=H,Se[ne+12>>2]=B,Se[ne+16>>2]=V,Se[ne+20>>2]=z,Se[ne+24>>2]=p,Se[ne+28>>2]=Y,ne));Se[r+16>>2]=G;var M=1}var M;return Oe=v,M}function Br(r,a){var e,i,v,t,f=Oe;Oe+=44;var _,s=f,t=s>>2,n=f+8,o=f+12,v=o>>2,l=f+16,b=f+20,k=f+40;Se[v]=0;var i=(r+12|0)>>2,u=Se[i],c=u+1|0;Se[i]=c;var h=ge[u],d=h<<24>>24,w=(h-65&255&255)>25;r:do if(w)var p=0;else{var e=(0|r)>>2,E=Me[e],A=0==(128&E|0),g=d-65|0;do if(A){var y=g/8|0;if(0==(0|y))var m=0|He.__str76246,S=g;else if(1==(0|y))var m=0|He.__str77247,S=g;else{if(2!=(0|y)){var m=0,S=g;break}var m=0|He.__str78248,S=g}}else var m=0,S=g;while(0);var S,m,M=0==(512&E|0)&h<<24>>24<89,C=(0|S)%8;do if(M)if(2==(0|C)||3==(0|C))var R=m,T=0|He.__str79249;else if(4==(0|C)||5==(0|C))var R=m,T=0|He.__str80250;else{if(6!=(0|C)&&7!=(0|C)){var R=m,T=0;break}var O=Dr(r,0|He.__str81251,(ne=Oe,Oe+=4,Se[ne>>2]=m,ne)),R=O,T=0|He.__str80250}else var R=m,T=0;while(0);var T,R,N=Gr(r,0),I=6==(0|C);do{if(!I){if(7==((d-56)%8|0)){_=14;break}var P=N;_=15;break}_=14}while(0);if(14==_)var D=Lr(r),L=Dr(r,0|He.__str82252,(ne=Oe,Oe+=8,Se[ne>>2]=N,Se[ne+4>>2]=D,ne)),P=L;var P,F=h<<24>>24>88;do if(F)var X=0;else{if((C-2|0)>>>0<2){var X=0;break}var j=xr(r,o,k);if(0==(0|j)){var p=0;break r}var U=Me[v],x=Se[k>>2];if(0==(0|U)&0==(0|x)){var X=0;break}var z=Dr(r,0|He.__str83253,(ne=Oe,Oe+=8,Se[ne>>2]=U,Se[ne+4>>2]=x,ne));Se[v]=z;var X=z}while(0);var X,V=Se[i],B=V+1|0;Se[i]=B;var H=Ae[V],K=Se[e],Y=Ur(H,n,l,K);if(0==(0|Y)){var p=0;break}Cr(b);var G=Se[i];if(Ae[G]<<24>>24==64){Se[t]=0|He.__str84254,Se[t+1]=0;var W=G+1|0;Se[i]=W}else{var Z=Pr(r,s,b,0);if(0==(0|Z)){var p=0;break}}if(0!=(4&Se[e]|0)&&(Se[t+1]=0,Se[t]=0),0==(0|a))var Q=P;else{var q=0|s,$=Se[q>>2],J=s+4|0,rr=Se[J>>2],ar=Dr(r,0|He.__str85255,(ne=Oe,Oe+=12,Se[ne>>2]=P,Se[ne+4>>2]=$,Se[ne+8>>2]=rr,ne));Se[J>>2]=0,Se[q>>2]=0;var Q=ar}var Q,er=r+44|0,ir=Se[er>>2],vr=Xr(r,b,1,40,41);if(0==(0|vr)){var p=0;break}if(0==(4096&Se[e]|0))var tr=vr,fr=X;else{Se[v]=0;var tr=0,fr=0}var fr,tr;Se[er>>2]=ir;var _r=Se[t],sr=Se[t+1];if(0==(0|_r))var nr=0;else var or=0!=(0|sr)?0:0|He.__str87257,nr=or;var nr,lr=Se[n>>2],br=0!=(0|lr)?0|He.__str87257:0,kr=Se[l>>2],ur=Dr(r,0|He.__str86256,(ne=Oe,Oe+=44,Se[ne>>2]=R,Se[ne+4>>2]=T,Se[ne+8>>2]=_r,Se[ne+12>>2]=nr,Se[ne+16>>2]=lr,Se[ne+20>>2]=br,Se[ne+24>>2]=kr,Se[ne+28>>2]=Q,Se[ne+32>>2]=tr,Se[ne+36>>2]=fr,Se[ne+40>>2]=sr,ne));Se[r+16>>2]=ur;var p=1}while(0);var p;return Oe=f,p}function Hr(r){var a,a=(r+12|0)>>2,e=Se[a];if(Ae[e]<<24>>24==36)var i=e;else{Xa(0|He.__str72242,1252,0|He.___func___handle_template,0|He.__str74244);var i=Se[a]}var i;Se[a]=i+1|0;var v=Kr(r),t=0==(0|v);do if(t)var f=0;else{var _=Xr(r,0,0,60,62);if(0==(0|_)){var f=0;break}var s=Dr(r,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=v,Se[ne+4>>2]=_,ne));Se[r+16>>2]=s;var f=1}while(0);var f;return f}function Kr(r){for(var a,a=(r+12|0)>>2,e=Me[a],i=e,v=Ae[e];;){var v,i;if(!((v-65&255&255)<26|(v-97&255&255)<26|(v-48&255&255)<10)&&v<<24>>24!=95&&v<<24>>24!=36){var t=0;break}var f=i+1|0;Se[a]=f;var _=ge[f];if(_<<24>>24==64){Se[a]=i+2|0;var s=f-e|0,n=r+20|0,o=Fr(r,e,s,n);if(0==(0|o)){var t=0;break}var l=Se[r+24>>2]-1-Se[n>>2]|0,b=Yr(n,l),t=b;break}var i=f,v=_}var t;return t}function Yr(r,a){0==(0|r)&&Xa(0|He.__str72242,263,0|He.___func___str_array_get_ref,0|He.__str75245);var e=Se[r>>2]+a|0;if(e>>>0<Me[r+8>>2]>>>0)var i=Se[Se[r+16>>2]+(e<<2)>>2];else var i=0;var i;return i}function Gr(r,a){var e,e=(r+44|0)>>2,i=Me[e];if(i>>>0>a>>>0){for(var v=r+56|0,t=a,f=0,_=Se[v>>2],s=i;;){var s,_,f,t,n=Me[_+(t<<2)>>2];if(0==(0|n)){Xa(0|He.__str72242,680,0|He.___func___get_class_string,0|He.__str106276);var o=Se[v>>2],l=o,b=Se[o+(t<<2)>>2],k=Se[e]}else var l=_,b=n,k=s;var k,b,l,u=Ca(b),c=u+(f+2)|0,h=t+1|0;if(h>>>0>=k>>>0)break;var t=h,f=c,_=l,s=k}var d=c-1|0}else var d=-1;var d,w=Wr(r,d);if(0==(0|w))var p=0;else{var E=Se[e]-1|0,A=(0|E)<(0|a);r:do if(A)var g=0;else for(var y=r+56|0,m=0,S=E;;){var S,m,M=Se[Se[y>>2]+(S<<2)>>2],C=Ca(M),R=w+m|0;Pa(R,M,C,1);var T=C+m|0;if((0|S)>(0|a)){var O=T+1|0;Ae[w+T|0]=58;var N=T+2|0;Ae[w+O|0]=58;var I=N}else var I=T;var I,P=S-1|0;if((0|P)<(0|a)){var g=I;break r}var m=I,S=P}while(0);var g;Ae[w+g|0]=0;var p=w}var p;return p}function Wr(r,a){var e,i=a>>>0>1020;do if(i){var v=Se[r+4>>2],t=a+4|0,f=pe[v](t);if(0==(0|f)){var _=0;break}var s=r+60|0,n=Se[s>>2],o=f;Se[o>>2]=n,Se[s>>2]=f,Se[r+64>>2]=0;var _=f+4|0}else{var e=(r+64|0)>>2,l=Me[e];if(l>>>0<a>>>0){var b=Se[r+4>>2],k=pe[b](1024);if(0==(0|k)){var _=0;break}var u=r+60|0,c=Se[u>>2],h=k;Se[h>>2]=c,Se[u>>2]=k,Se[e]=1020;var d=1020,w=k}else var d=l,w=Se[r+60>>2];var w,d;Se[e]=d-a|0;var _=w+(1024-d)|0}while(0);var _;return _}function Zr(r){var a=r<<24>>24;if(68==(0|a))var e=0|He.__str157327;else if(69==(0|a))var e=0|He.__str158328;else if(70==(0|a))var e=0|He.__str159329;else if(71==(0|a))var e=0|He.__str160330;else if(72==(0|a))var e=0|He.__str161331;else if(73==(0|a))var e=0|He.__str162332;else if(74==(0|a))var e=0|He.__str163333;else if(75==(0|a))var e=0|He.__str164334;else if(76==(0|a))var e=0|He.__str165335;else if(77==(0|a))var e=0|He.__str166336;else if(78==(0|a))var e=0|He.__str167337;else if(87==(0|a))var e=0|He.__str168338;else var e=0;var e;return e}function Qr(r){var a=r<<24>>24;if(67==(0|a))var e=0|He.__str145315;else if(68==(0|a))var e=0|He.__str146316;else if(69==(0|a))var e=0|He.__str147317;else if(70==(0|a))var e=0|He.__str148318;else if(71==(0|a))var e=0|He.__str149319;else if(72==(0|a))var e=0|He.__str150320;else if(73==(0|a))var e=0|He.__str151321;else if(74==(0|a))var e=0|He.__str152322;else if(75==(0|a))var e=0|He.__str153323;else if(77==(0|a))var e=0|He.__str154324;else if(78==(0|a))var e=0|He.__str155325;else if(79==(0|a))var e=0|He.__str156326;else if(88==(0|a))var e=0|He.__str84254;else if(90==(0|a))var e=0|He.__str110280;else var e=0;var e;return e}function qr(r){var a=r+44|0,e=Se[a>>2],i=zr(r);if(0==(0|i))var v=0;else var t=Gr(r,e),v=t;var v;return Se[a>>2]=e,v}function $r(r,a,e,i,v){var t,f,_,s=Oe;Oe+=16;var n,o=s,_=o>>2,l=s+4,b=s+8,f=b>>2;Se[l>>2]=0|ii;var t=(a+12|0)>>2,k=Se[t];if(Ae[k]<<24>>24==69){Se[l>>2]=0|He.__str134304;var u=k+1|0;Se[t]=u;var c=0|He.__str134304}else var c=0|ii;var c,h=i<<24>>24;do{if(65==(0|h)){var d=Dr(a,0|He.__str135305,(ne=Oe,Oe+=4,Se[ne>>2]=c,ne)),w=d;n=10;break}if(66==(0|h)){var p=Dr(a,0|He.__str136306,(ne=Oe,Oe+=4,Se[ne>>2]=c,ne)),w=p;n=10;break}if(80==(0|h)){var E=Dr(a,0|He.__str137307,(ne=Oe,Oe+=4,Se[ne>>2]=c,ne)),w=E;n=10;break}if(81==(0|h)){var A=Dr(a,0|He.__str138308,(ne=Oe,Oe+=4,Se[ne>>2]=c,ne)),w=A;n=10;break}if(82==(0|h)){var g=Dr(a,0|He.__str139309,(ne=Oe,Oe+=4,Se[ne>>2]=c,ne)),w=g;n=10;break}if(83==(0|h)){var y=Dr(a,0|He.__str140310,(ne=Oe,Oe+=4,Se[ne>>2]=c,ne)),w=y;n=10;break}if(63==(0|h)){var w=0|ii;n=10}else n=31}while(0);r:do if(10==n){var w,m=xr(a,o,l);if(0==(0|m))break;var S=a+44|0,M=Se[S>>2],C=Se[t],R=Ae[C]<<24>>24==89;a:do if(R){var T=C+1|0;Se[t]=T;var O=Lr(a);if(0==(0|O))break r;var N=Ha(O),I=Ae[w]<<24>>24==32,P=Se[_],D=0==(0|P);do{if(I){if(!D){n=17;break}var L=w+1|0;n=18;break}if(D){var L=w;n=18;break}n=17;break}while(0);if(17==n){var F=Dr(a,0|He.__str141311,(ne=Oe,Oe+=8,Se[ne>>2]=P,Se[ne+4>>2]=w,ne));Se[_]=0;var X=F}else if(18==n)var L,j=Dr(a,0|He.__str142312,(ne=Oe,Oe+=4,Se[ne>>2]=L,ne)),X=j;var X;if(0==(0|N)){var U=X;break}for(var x=X,z=N;;){var z,x,V=z-1|0,B=Lr(a),H=Dr(a,0|He.__str143313,(ne=Oe,Oe+=8,Se[ne>>2]=x,Se[ne+4>>2]=B,ne));if(0==(0|V)){var U=H;break a}var x=H,z=V}}else var U=w;while(0);var U,K=Pr(a,b,e,0);if(0==(0|K))break;var Y=Se[_];if(0==(0|Y)){var G=0==(0|v);do if(G){if(Ae[U]<<24>>24==0){var W=U;break}var Z=U+1|0;if(Ae[Z]<<24>>24!=42){var W=U;break}var Q=Se[f],q=Ca(Q);if(Ae[Q+(q-1)|0]<<24>>24!=42){var W=U;break}var W=Z}else var W=U;while(0);var W,$=Se[f],J=Dr(a,0|He.__str170,(ne=Oe,Oe+=8,Se[ne>>2]=$,Se[ne+4>>2]=W,ne));Se[r>>2]=J}else{var rr=Se[f],ar=Dr(a,0|He.__str144314,(ne=Oe,Oe+=12,Se[ne>>2]=rr,Se[ne+4>>2]=Y,Se[ne+8>>2]=U,ne));Se[r>>2]=ar}var er=Se[f+1];Se[r+4>>2]=er,Se[S>>2]=M}while(0);Oe=s}function Jr(r){var a,e=r>>>0<245;do{if(e){if(r>>>0<11)var i=16;else var i=r+11&-8;var i,v=i>>>3,t=Me[vi>>2],f=t>>>(v>>>0);if(0!=(3&f|0)){var _=(1&f^1)+v|0,s=_<<1,n=(s<<2)+vi+40|0,o=(s+2<<2)+vi+40|0,l=Me[o>>2],b=l+8|0,k=Me[b>>2];if((0|n)==(0|k))Se[vi>>2]=t&(1<<_^-1);else{if(k>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[o>>2]=k,Se[k+12>>2]=n}var u=_<<3;Se[l+4>>2]=3|u;var c=l+(4|u)|0,h=1|Se[c>>2];Se[c>>2]=h;var d=b;a=38;break}if(i>>>0<=Me[vi+8>>2]>>>0){var w=i;a=30;break}if(0!=(0|f)){var p=2<<v,E=f<<v&(p|-p),A=(E&-E)-1|0,g=A>>>12&16,y=A>>>(g>>>0),m=y>>>5&8,S=y>>>(m>>>0),M=S>>>2&4,C=S>>>(M>>>0),R=C>>>1&2,T=C>>>(R>>>0),O=T>>>1&1,N=(m|g|M|R|O)+(T>>>(O>>>0))|0,I=N<<1,P=(I<<2)+vi+40|0,D=(I+2<<2)+vi+40|0,L=Me[D>>2],F=L+8|0,X=Me[F>>2];if((0|P)==(0|X))Se[vi>>2]=t&(1<<N^-1);else{if(X>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[D>>2]=X,Se[X+12>>2]=P}var j=N<<3,U=j-i|0;Se[L+4>>2]=3|i;var x=L,z=x+i|0;Se[x+(4|i)>>2]=1|U,Se[x+j>>2]=U;var V=Me[vi+8>>2];if(0!=(0|V)){var B=Se[vi+20>>2],H=V>>>2&1073741822,K=(H<<2)+vi+40|0,Y=Me[vi>>2],G=1<<(V>>>3),W=0==(Y&G|0);do{if(!W){var Z=(H+2<<2)+vi+40|0,Q=Me[Z>>2];if(Q>>>0>=Me[vi+16>>2]>>>0){var q=Q,$=Z;break}throw Ka(),\"Reached an unreachable!\"}Se[vi>>2]=Y|G;var q=K,$=(H+2<<2)+vi+40|0}while(0);var $,q;Se[$>>2]=B,Se[q+12>>2]=B;var J=B+8|0;Se[J>>2]=q;var rr=B+12|0;Se[rr>>2]=K}Se[vi+8>>2]=U,Se[vi+20>>2]=z;var d=F;a=38;break}if(0==(0|Se[vi+4>>2])){var w=i;a=30;break}var ar=ra(i);if(0==(0|ar)){var w=i;a=30;break}var d=ar;a=38;break}if(r>>>0>4294967231){var w=-1;a=30;break}var er=r+11&-8;if(0==(0|Se[vi+4>>2])){var w=er;a=30;break}var ir=ea(er);if(0==(0|ir)){var w=er;a=30;break}var d=ir;a=38;break}while(0);if(30==a){var w,vr=Me[vi+8>>2];if(w>>>0>vr>>>0){var tr=Me[vi+12>>2];if(w>>>0<tr>>>0){var fr=tr-w|0;Se[vi+12>>2]=fr;var _r=Me[vi+24>>2],sr=_r;Se[vi+24>>2]=sr+w|0,Se[w+(sr+4)>>2]=1|fr,Se[_r+4>>2]=3|w;var d=_r+8|0}else var nr=aa(w),d=nr}else{var or=vr-w|0,lr=Me[vi+20>>2];if(or>>>0>15){var br=lr;Se[vi+20>>2]=br+w|0,Se[vi+8>>2]=or,Se[w+(br+4)>>2]=1|or,Se[br+vr>>2]=or,Se[lr+4>>2]=3|w}else{Se[vi+8>>2]=0,Se[vi+20>>2]=0,Se[lr+4>>2]=3|vr;var kr=vr+(lr+4)|0,ur=1|Se[kr>>2];Se[kr>>2]=ur}var d=lr+8|0}}var d;return d}function ra(r){var a,e,i,v=Se[vi+4>>2],t=(v&-v)-1|0,f=t>>>12&16,_=t>>>(f>>>0),s=_>>>5&8,n=_>>>(s>>>0),o=n>>>2&4,l=n>>>(o>>>0),b=l>>>1&2,k=l>>>(b>>>0),u=k>>>1&1,c=Me[vi+((s|f|o|b|u)+(k>>>(u>>>0))<<2)+304>>2],h=c,e=h>>2,d=(Se[c+4>>2]&-8)-r|0;r:for(;;)for(var d,h,w=h;;){var w,p=Se[w+16>>2];if(0==(0|p)){var E=Se[w+20>>2];if(0==(0|E))break r;var A=E}else var A=p;var A,g=(Se[A+4>>2]&-8)-r|0;if(g>>>0<d>>>0){var h=A,e=h>>2,d=g;continue r}var w=A}var y=h,m=Me[vi+16>>2],S=y>>>0<m>>>0;do if(!S){var M=y+r|0,C=M;if(y>>>0>=M>>>0)break;var R=Me[e+6],T=Me[e+3],O=(0|T)==(0|h);do if(O){var N=h+20|0,I=Se[N>>2];if(0==(0|I)){var P=h+16|0,D=Se[P>>2];if(0==(0|D)){var L=0,a=L>>2;break}var F=P,X=D}else{var F=N,X=I;i=14}for(;;){var X,F,j=X+20|0,U=Se[j>>2];if(0==(0|U)){var x=X+16|0,z=Me[x>>2];if(0==(0|z))break;var F=x,X=z}else var F=j,X=U}if(F>>>0<m>>>0)throw Ka(),\"Reached an unreachable!\";Se[F>>2]=0;var L=X,a=L>>2}else{var V=Me[e+2];if(V>>>0<m>>>0)throw Ka(),\"Reached an unreachable!\";Se[V+12>>2]=T,Se[T+8>>2]=V;var L=T,a=L>>2}while(0);var L,B=0==(0|R);r:do if(!B){var H=h+28|0,K=(Se[H>>2]<<2)+vi+304|0,Y=(0|h)==(0|Se[K>>2]);do{if(Y){if(Se[K>>2]=L,0!=(0|L))break;var G=Se[vi+4>>2]&(1<<Se[H>>2]^-1);Se[vi+4>>2]=G;break r}if(R>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";var W=R+16|0;if((0|Se[W>>2])==(0|h)?Se[W>>2]=L:Se[R+20>>2]=L,0==(0|L))break r}while(0);if(L>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+6]=R;var Z=Me[e+4];if(0!=(0|Z)){if(Z>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+4]=Z,Se[Z+24>>2]=L}var Q=Me[e+5];if(0==(0|Q))break;if(Q>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+5]=Q,Se[Q+24>>2]=L}while(0);if(d>>>0<16){var q=d+r|0;Se[e+1]=3|q;var $=q+(y+4)|0,J=1|Se[$>>2];Se[$>>2]=J}else{Se[e+1]=3|r,Se[r+(y+4)>>2]=1|d,Se[y+d+r>>2]=d;var rr=Me[vi+8>>2];if(0!=(0|rr)){var ar=Me[vi+20>>2],er=rr>>>2&1073741822,ir=(er<<2)+vi+40|0,vr=Me[vi>>2],tr=1<<(rr>>>3),fr=0==(vr&tr|0);do{if(!fr){var _r=(er+2<<2)+vi+40|0,sr=Me[_r>>2];if(sr>>>0>=Me[vi+16>>2]>>>0){var nr=sr,or=_r;break}throw Ka(),\"Reached an unreachable!\"}Se[vi>>2]=vr|tr;var nr=ir,or=(er+2<<2)+vi+40|0}while(0);var or,nr;Se[or>>2]=ar,Se[nr+12>>2]=ar,Se[ar+8>>2]=nr,Se[ar+12>>2]=ir}Se[vi+8>>2]=d,Se[vi+20>>2]=C}return h+8|0}while(0);throw Ka(),\"Reached an unreachable!\"}function aa(r){var a,e;0==(0|Se[ti>>2])&&ba();var i=0==(4&Se[vi+440>>2]|0);do{if(i){var v=Se[vi+24>>2],t=0==(0|v);do{if(!t){var f=v,_=ua(f);if(0==(0|_)){e=6;break}var s=Se[ti+8>>2],n=r+47-Se[vi+12>>2]+s&-s;if(n>>>0>=2147483647){e=14;break}var o=re(n);if((0|o)==(Se[_>>2]+Se[_+4>>2]|0)){var l=o,b=n,k=o;e=13;break}var u=o,c=n;e=15;break}e=6}while(0);do if(6==e){var h=re(0);if((0|h)==-1){e=14;break}var d=Se[ti+8>>2],w=d+(r+47)&-d,p=h,E=Se[ti+4>>2],A=E-1|0;if(0==(A&p|0))var g=w;else var g=w-p+(A+p&-E)|0;var g;if(g>>>0>=2147483647){e=14;break}var y=re(g);if((0|y)==(0|h)){var l=h,b=g,k=y;e=13;break}var u=y,c=g;e=15;break}while(0);if(13==e){var k,b,l;if((0|l)!=-1){var m=b,S=l;e=26;break}var u=k,c=b}else if(14==e){var M=4|Se[vi+440>>2];Se[vi+440>>2]=M,e=23;break}var c,u,C=0|-c,R=(0|u)!=-1&c>>>0<2147483647;do{if(R){if(c>>>0>=(r+48|0)>>>0){var T=c;e=21;break}var O=Se[ti+8>>2],N=r+47-c+O&-O;if(N>>>0>=2147483647){var T=c;e=21;break}var I=re(N);if((0|I)==-1){re(C);e=22;break}var T=N+c|0;e=21;break}var T=c;e=21}while(0);if(21==e){var T;if((0|u)!=-1){var m=T,S=u;e=26;break}}var P=4|Se[vi+440>>2];Se[vi+440>>2]=P,e=23;break}e=23}while(0);do if(23==e){var D=Se[ti+8>>2],L=D+(r+47)&-D;if(L>>>0>=2147483647){e=49;break}var F=re(L),X=re(0);if(!((0|X)!=-1&(0|F)!=-1&F>>>0<X>>>0)){e=49;break}var j=X-F|0;if(j>>>0<=(r+40|0)>>>0|(0|F)==-1){e=49;break}var m=j,S=F;e=26;break}while(0);r:do if(26==e){var S,m,U=Se[vi+432>>2]+m|0;Se[vi+432>>2]=U,U>>>0>Me[vi+436>>2]>>>0&&(Se[vi+436>>2]=U);var x=Me[vi+24>>2],z=0==(0|x);a:do if(z){var V=Me[vi+16>>2];0==(0|V)|S>>>0<V>>>0&&(Se[vi+16>>2]=S),Se[vi+444>>2]=S,Se[vi+448>>2]=m,Se[vi+456>>2]=0;var B=Se[ti>>2];Se[vi+36>>2]=B,Se[vi+32>>2]=-1,ha(),ca(S,m-40|0)}else{for(var H=vi+444|0,a=H>>2;;){var H;if(0==(0|H))break;var K=Me[a],Y=H+4|0,G=Me[Y>>2],W=K+G|0;if((0|S)==(0|W)){if(0!=(8&Se[a+3]|0))break;var Z=x;if(!(Z>>>0>=K>>>0&Z>>>0<W>>>0))break;Se[Y>>2]=G+m|0;var Q=Se[vi+24>>2],q=Se[vi+12>>2]+m|0;ca(Q,q);break a}var H=Se[a+2],a=H>>2}S>>>0<Me[vi+16>>2]>>>0&&(Se[vi+16>>2]=S);for(var $=S+m|0,J=vi+444|0;;){var J;if(0==(0|J))break;var rr=0|J,ar=Me[rr>>2];if((0|ar)==(0|$)){if(0!=(8&Se[J+12>>2]|0))break;Se[rr>>2]=S;var er=J+4|0,ir=Se[er>>2]+m|0;Se[er>>2]=ir;var vr=da(S,ar,r),tr=vr;e=50;break r}var J=Se[J+8>>2]}Ma(S,m)}while(0);var fr=Me[vi+12>>2];if(fr>>>0<=r>>>0){e=49;break}var _r=fr-r|0;Se[vi+12>>2]=_r;var sr=Me[vi+24>>2],nr=sr;Se[vi+24>>2]=nr+r|0,Se[r+(nr+4)>>2]=1|_r,Se[sr+4>>2]=3|r;var tr=sr+8|0;e=50;break}while(0);if(49==e){var or=Je();Se[or>>2]=12;var tr=0}var tr;return tr}function ea(r){var a,e,i,v,t,f,_=r>>2,s=0|-r,n=r>>>8,o=0==(0|n);do if(o)var l=0;else{if(r>>>0>16777215){var l=31;break}var b=(n+1048320|0)>>>16&8,k=n<<b,u=(k+520192|0)>>>16&4,c=k<<u,h=(c+245760|0)>>>16&2,d=14-(u|b|h)+(c<<h>>>15)|0,l=r>>>((d+7|0)>>>0)&1|d<<1}while(0);var l,w=Me[vi+(l<<2)+304>>2],p=0==(0|w);r:do if(p)var E=0,A=s,g=0;else{if(31==(0|l))var y=0;else var y=25-(l>>>1)|0;for(var y,m=0,S=s,M=w,t=M>>2,C=r<<y,R=0;;){var R,C,M,S,m,T=Se[t+1]&-8,O=T-r|0;if(O>>>0<S>>>0){if((0|T)==(0|r)){var E=M,A=O,g=M;break r}var N=M,I=O}else var N=m,I=S;var I,N,P=Me[t+5],D=Me[((C>>>31<<2)+16>>2)+t],L=0==(0|P)|(0|P)==(0|D)?R:P;if(0==(0|D)){var E=N,A=I,g=L;break r}var m=N,S=I,M=D,t=M>>2,C=C<<1,R=L}}while(0);var g,A,E,F=0==(0|g)&0==(0|E);do if(F){var X=2<<l,j=Se[vi+4>>2]&(X|-X);if(0==(0|j)){var U=g;break}var x=(j&-j)-1|0,z=x>>>12&16,V=x>>>(z>>>0),B=V>>>5&8,H=V>>>(B>>>0),K=H>>>2&4,Y=H>>>(K>>>0),G=Y>>>1&2,W=Y>>>(G>>>0),Z=W>>>1&1,U=Se[vi+((B|z|K|G|Z)+(W>>>(Z>>>0))<<2)+304>>2]}else var U=g;while(0);var U,Q=0==(0|U);r:do if(Q)var q=A,$=E,v=$>>2;else for(var J=U,i=J>>2,rr=A,ar=E;;){var ar,rr,J,er=(Se[i+1]&-8)-r|0,ir=er>>>0<rr>>>0,vr=ir?er:rr,tr=ir?J:ar,fr=Me[i+4];if(0==(0|fr)){var _r=Me[i+5];if(0==(0|_r)){var q=vr,$=tr,v=$>>2;break r}var J=_r,i=J>>2,rr=vr,ar=tr}else var J=fr,i=J>>2,rr=vr,ar=tr}while(0);var $,q,sr=0==(0|$);r:do{if(!sr){if(q>>>0>=(Se[vi+8>>2]-r|0)>>>0){var nr=0;break}var or=$,e=or>>2,lr=Me[vi+16>>2],br=or>>>0<lr>>>0;do if(!br){var kr=or+r|0,ur=kr;if(or>>>0>=kr>>>0)break;var cr=Me[v+6],hr=Me[v+3],dr=(0|hr)==(0|$);do if(dr){var wr=$+20|0,pr=Se[wr>>2];if(0==(0|pr)){var Er=$+16|0,Ar=Se[Er>>2];if(0==(0|Ar)){var gr=0,a=gr>>2;break}var yr=Er,mr=Ar}else{var yr=wr,mr=pr;f=28}for(;;){var mr,yr,Sr=mr+20|0,Mr=Se[Sr>>2];if(0==(0|Mr)){var Cr=mr+16|0,Rr=Me[Cr>>2];if(0==(0|Rr))break;var yr=Cr,mr=Rr}else var yr=Sr,mr=Mr}if(yr>>>0<lr>>>0)throw Ka(),\"Reached an unreachable!\";Se[yr>>2]=0;var gr=mr,a=gr>>2}else{var Tr=Me[v+2];if(Tr>>>0<lr>>>0)throw Ka(),\"Reached an unreachable!\";Se[Tr+12>>2]=hr,Se[hr+8>>2]=Tr;var gr=hr,a=gr>>2}while(0);var gr,Or=0==(0|cr);a:do if(!Or){var Nr=$+28|0,Ir=(Se[Nr>>2]<<2)+vi+304|0,Pr=(0|$)==(0|Se[Ir>>2]);do{if(Pr){if(Se[Ir>>2]=gr,0!=(0|gr))break;var Dr=Se[vi+4>>2]&(1<<Se[Nr>>2]^-1);Se[vi+4>>2]=Dr;break a}if(cr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";var Lr=cr+16|0;if((0|Se[Lr>>2])==(0|$)?Se[Lr>>2]=gr:Se[cr+20>>2]=gr,0==(0|gr))break a}while(0);if(gr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+6]=cr;var Fr=Me[v+4];if(0!=(0|Fr)){if(Fr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+4]=Fr,Se[Fr+24>>2]=gr}var Xr=Me[v+5];if(0==(0|Xr))break;if(Xr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+5]=Xr,Se[Xr+24>>2]=gr}while(0);var jr=q>>>0<16;a:do if(jr){var Ur=q+r|0;Se[v+1]=3|Ur;var xr=Ur+(or+4)|0,zr=1|Se[xr>>2];Se[xr>>2]=zr}else if(Se[v+1]=3|r,Se[_+(e+1)]=1|q,Se[(q>>2)+e+_]=q,q>>>0<256){var Vr=q>>>2&1073741822,Br=(Vr<<2)+vi+40|0,Hr=Me[vi>>2],Kr=1<<(q>>>3),Yr=0==(Hr&Kr|0);do{if(!Yr){var Gr=(Vr+2<<2)+vi+40|0,Wr=Me[Gr>>2];if(Wr>>>0>=Me[vi+16>>2]>>>0){var Zr=Wr,Qr=Gr;break}throw Ka(),\"Reached an unreachable!\"}Se[vi>>2]=Hr|Kr;var Zr=Br,Qr=(Vr+2<<2)+vi+40|0}while(0);var Qr,Zr;Se[Qr>>2]=ur,Se[Zr+12>>2]=ur,Se[_+(e+2)]=Zr,Se[_+(e+3)]=Br}else{var qr=kr,$r=q>>>8,Jr=0==(0|$r);do if(Jr)var ra=0;else{if(q>>>0>16777215){var ra=31;break}var aa=($r+1048320|0)>>>16&8,ea=$r<<aa,ia=(ea+520192|0)>>>16&4,va=ea<<ia,ta=(va+245760|0)>>>16&2,fa=14-(ia|aa|ta)+(va<<ta>>>15)|0,ra=q>>>((fa+7|0)>>>0)&1|fa<<1}while(0);var ra,_a=(ra<<2)+vi+304|0;Se[_+(e+7)]=ra;var sa=r+(or+16)|0;Se[_+(e+5)]=0,Se[sa>>2]=0;var na=Se[vi+4>>2],oa=1<<ra;if(0==(na&oa|0)){var la=na|oa;Se[vi+4>>2]=la,Se[_a>>2]=qr,Se[_+(e+6)]=_a,Se[_+(e+3)]=qr,Se[_+(e+2)]=qr}else{if(31==(0|ra))var ba=0;else var ba=25-(ra>>>1)|0;for(var ba,ka=q<<ba,ua=Se[_a>>2];;){var ua,ka;if((Se[ua+4>>2]&-8|0)==(0|q)){var ca=ua+8|0,ha=Me[ca>>2],da=Me[vi+16>>2],wa=ua>>>0<da>>>0;do if(!wa){if(ha>>>0<da>>>0)break;Se[ha+12>>2]=qr,Se[ca>>2]=qr,Se[_+(e+2)]=ha,Se[_+(e+3)]=ua,Se[_+(e+6)]=0;break a}while(0);throw Ka(),\"Reached an unreachable!\"}var pa=(ka>>>31<<2)+ua+16|0,Ea=Me[pa>>2];if(0==(0|Ea)){if(pa>>>0>=Me[vi+16>>2]>>>0){Se[pa>>2]=qr,Se[_+(e+6)]=ua,Se[_+(e+3)]=qr,Se[_+(e+2)]=qr;break a}throw Ka(),\"Reached an unreachable!\"}var ka=ka<<1,ua=Ea}}}while(0);var nr=$+8|0;break r}while(0);throw Ka(),\"Reached an unreachable!\"}var nr=0}while(0);var nr;return nr}function ia(r){var a;0==(0|Se[ti>>2])&&ba();var e=r>>>0<4294967232;r:do if(e){var i=Me[vi+24>>2];if(0==(0|i)){var v=0;break}var t=Me[vi+12>>2],f=t>>>0>(r+40|0)>>>0;do if(f){var _=Me[ti+8>>2],s=-40-r-1+t+_|0,n=Math.floor((s>>>0)/(_>>>0)),o=(n-1)*_|0,l=i,b=ua(l);if(0!=(8&Se[b+12>>2]|0))break;var k=re(0),a=(b+4|0)>>2;if((0|k)!=(Se[b>>2]+Se[a]|0))break;var u=o>>>0>2147483646?-2147483648-_|0:o,c=0|-u,h=re(c),d=re(0);if(!((0|h)!=-1&d>>>0<k>>>0))break;var w=k-d|0;if((0|k)==(0|d))break;var p=Se[a]-w|0;Se[a]=p;var E=Se[vi+432>>2]-w|0;Se[vi+432>>2]=E;var A=Se[vi+24>>2],g=Se[vi+12>>2]-w|0;ca(A,g);var v=(0|k)!=(0|d);break r}while(0);if(Me[vi+12>>2]>>>0<=Me[vi+28>>2]>>>0){var v=0;break}Se[vi+28>>2]=-1;var v=0}else var v=0;while(0);var v;return 1&v}function va(r){var a,e,i,v,t,f,_,s=r>>2,n=0==(0|r);r:do if(!n){var o=r-8|0,l=o,b=Me[vi+16>>2],k=o>>>0<b>>>0;a:do if(!k){var u=Me[r-4>>2],c=3&u;if(1==(0|c))break;var h=u&-8,f=h>>2,d=r+(h-8)|0,w=d,p=0==(1&u|0);e:do if(p){var E=Me[o>>2];if(0==(0|c))break r;var A=-8-E|0,t=A>>2,g=r+A|0,y=g,m=E+h|0;if(g>>>0<b>>>0)break a;if((0|y)==(0|Se[vi+20>>2])){var v=(r+(h-4)|0)>>2;if(3!=(3&Se[v]|0)){var S=y,i=S>>2,M=m;break}Se[vi+8>>2]=m;var C=Se[v]&-2;Se[v]=C,Se[t+(s+1)]=1|m,Se[d>>2]=m;break r}if(E>>>0<256){var R=Me[t+(s+2)],T=Me[t+(s+3)];if((0|R)!=(0|T)){var O=((E>>>2&1073741822)<<2)+vi+40|0,N=(0|R)!=(0|O)&R>>>0<b>>>0;do if(!N){if(!((0|T)==(0|O)|T>>>0>=b>>>0))break;Se[R+12>>2]=T,Se[T+8>>2]=R;var S=y,i=S>>2,M=m;break e}while(0);throw Ka(),\"Reached an unreachable!\"}var I=Se[vi>>2]&(1<<(E>>>3)^-1);Se[vi>>2]=I;var S=y,i=S>>2,M=m}else{var P=g,D=Me[t+(s+6)],L=Me[t+(s+3)],F=(0|L)==(0|P);do if(F){var X=A+(r+20)|0,j=Se[X>>2];if(0==(0|j)){var U=A+(r+16)|0,x=Se[U>>2];if(0==(0|x)){var z=0,e=z>>2;break}var V=U,B=x}else{var V=X,B=j;_=21}for(;;){var B,V,H=B+20|0,K=Se[H>>2];if(0==(0|K)){var Y=B+16|0,G=Me[Y>>2];if(0==(0|G))break;var V=Y,B=G}else var V=H,B=K}if(V>>>0<b>>>0)throw Ka(),\"Reached an unreachable!\";Se[V>>2]=0;var z=B,e=z>>2}else{var W=Me[t+(s+2)];if(W>>>0<b>>>0)throw Ka(),\"Reached an unreachable!\";Se[W+12>>2]=L,Se[L+8>>2]=W;var z=L,e=z>>2}while(0);var z;if(0==(0|D)){var S=y,i=S>>2,M=m;break}var Z=A+(r+28)|0,Q=(Se[Z>>2]<<2)+vi+304|0,q=(0|P)==(0|Se[Q>>2]);do{if(q){if(Se[Q>>2]=z,0!=(0|z))break;var $=Se[vi+4>>2]&(1<<Se[Z>>2]^-1);Se[vi+4>>2]=$;var S=y,i=S>>2,M=m;break e}if(D>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";var J=D+16|0;if((0|Se[J>>2])==(0|P)?Se[J>>2]=z:Se[D+20>>2]=z,0==(0|z)){var S=y,i=S>>2,M=m;break e}}while(0);if(z>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[e+6]=D;var rr=Me[t+(s+4)];if(0!=(0|rr)){if(rr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[e+4]=rr,Se[rr+24>>2]=z}var ar=Me[t+(s+5)];if(0==(0|ar)){var S=y,i=S>>2,M=m;break}if(ar>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[e+5]=ar,Se[ar+24>>2]=z;var S=y,i=S>>2,M=m}}else var S=l,i=S>>2,M=h;while(0);var M,S,er=S;if(er>>>0>=d>>>0)break;var ir=r+(h-4)|0,vr=Me[ir>>2];if(0==(1&vr|0))break;var tr=0==(2&vr|0);do{if(tr){if((0|w)==(0|Se[vi+24>>2])){var fr=Se[vi+12>>2]+M|0;Se[vi+12>>2]=fr,Se[vi+24>>2]=S;var _r=1|fr;if(Se[i+1]=_r,(0|S)==(0|Se[vi+20>>2])&&(Se[vi+20>>2]=0,Se[vi+8>>2]=0),fr>>>0<=Me[vi+28>>2]>>>0)break r;ia(0);break r}if((0|w)==(0|Se[vi+20>>2])){var sr=Se[vi+8>>2]+M|0;Se[vi+8>>2]=sr,Se[vi+20>>2]=S;var nr=1|sr;Se[i+1]=nr;var or=er+sr|0;Se[or>>2]=sr;break r}var lr=(vr&-8)+M|0,br=vr>>>3,kr=vr>>>0<256;e:do if(kr){var ur=Me[s+f],cr=Me[((4|h)>>2)+s];if((0|ur)!=(0|cr)){var hr=((vr>>>2&1073741822)<<2)+vi+40|0,dr=(0|ur)==(0|hr);do{if(!dr){if(ur>>>0<Me[vi+16>>2]>>>0){_=66;break}_=63;break}_=63}while(0);do if(63==_){if((0|cr)!=(0|hr)&&cr>>>0<Me[vi+16>>2]>>>0)break;Se[ur+12>>2]=cr,Se[cr+8>>2]=ur;break e}while(0);throw Ka(),\"Reached an unreachable!\"}var wr=Se[vi>>2]&(1<<br^-1);Se[vi>>2]=wr}else{var pr=d,Er=Me[f+(s+4)],Ar=Me[((4|h)>>2)+s],gr=(0|Ar)==(0|pr);do if(gr){var yr=h+(r+12)|0,mr=Se[yr>>2];if(0==(0|mr)){var Sr=h+(r+8)|0,Mr=Se[Sr>>2];if(0==(0|Mr)){var Cr=0,a=Cr>>2;break}var Rr=Sr,Tr=Mr}else{var Rr=yr,Tr=mr;_=73}for(;;){var Tr,Rr,Or=Tr+20|0,Nr=Se[Or>>2];if(0==(0|Nr)){var Ir=Tr+16|0,Pr=Me[Ir>>2];if(0==(0|Pr))break;var Rr=Ir,Tr=Pr}else var Rr=Or,Tr=Nr}if(Rr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[Rr>>2]=0;var Cr=Tr,a=Cr>>2}else{var Dr=Me[s+f];if(Dr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[Dr+12>>2]=Ar,\nSe[Ar+8>>2]=Dr;var Cr=Ar,a=Cr>>2}while(0);var Cr;if(0==(0|Er))break;var Lr=h+(r+20)|0,Fr=(Se[Lr>>2]<<2)+vi+304|0,Xr=(0|pr)==(0|Se[Fr>>2]);do{if(Xr){if(Se[Fr>>2]=Cr,0!=(0|Cr))break;var jr=Se[vi+4>>2]&(1<<Se[Lr>>2]^-1);Se[vi+4>>2]=jr;break e}if(Er>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";var Ur=Er+16|0;if((0|Se[Ur>>2])==(0|pr)?Se[Ur>>2]=Cr:Se[Er+20>>2]=Cr,0==(0|Cr))break e}while(0);if(Cr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+6]=Er;var xr=Me[f+(s+2)];if(0!=(0|xr)){if(xr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+4]=xr,Se[xr+24>>2]=Cr}var zr=Me[f+(s+3)];if(0==(0|zr))break;if(zr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[a+5]=zr,Se[zr+24>>2]=Cr}while(0);if(Se[i+1]=1|lr,Se[er+lr>>2]=lr,(0|S)!=(0|Se[vi+20>>2])){var Vr=lr;break}Se[vi+8>>2]=lr;break r}Se[ir>>2]=vr&-2,Se[i+1]=1|M,Se[er+M>>2]=M;var Vr=M}while(0);var Vr;if(Vr>>>0<256){var Br=Vr>>>2&1073741822,Hr=(Br<<2)+vi+40|0,Kr=Me[vi>>2],Yr=1<<(Vr>>>3),Gr=0==(Kr&Yr|0);do{if(!Gr){var Wr=(Br+2<<2)+vi+40|0,Zr=Me[Wr>>2];if(Zr>>>0>=Me[vi+16>>2]>>>0){var Qr=Zr,qr=Wr;break}throw Ka(),\"Reached an unreachable!\"}Se[vi>>2]=Kr|Yr;var Qr=Hr,qr=(Br+2<<2)+vi+40|0}while(0);var qr,Qr;Se[qr>>2]=S,Se[Qr+12>>2]=S,Se[i+2]=Qr,Se[i+3]=Hr;break r}var $r=S,Jr=Vr>>>8,ra=0==(0|Jr);do if(ra)var aa=0;else{if(Vr>>>0>16777215){var aa=31;break}var ea=(Jr+1048320|0)>>>16&8,va=Jr<<ea,fa=(va+520192|0)>>>16&4,_a=va<<fa,sa=(_a+245760|0)>>>16&2,na=14-(fa|ea|sa)+(_a<<sa>>>15)|0,aa=Vr>>>((na+7|0)>>>0)&1|na<<1}while(0);var aa,oa=(aa<<2)+vi+304|0;Se[i+7]=aa,Se[i+5]=0,Se[i+4]=0;var la=Se[vi+4>>2],ba=1<<aa,ka=0==(la&ba|0);e:do if(ka){var ua=la|ba;Se[vi+4>>2]=ua,Se[oa>>2]=$r,Se[i+6]=oa,Se[i+3]=S,Se[i+2]=S}else{if(31==(0|aa))var ca=0;else var ca=25-(aa>>>1)|0;for(var ca,ha=Vr<<ca,da=Se[oa>>2];;){var da,ha;if((Se[da+4>>2]&-8|0)==(0|Vr)){var wa=da+8|0,pa=Me[wa>>2],Ea=Me[vi+16>>2],Aa=da>>>0<Ea>>>0;do if(!Aa){if(pa>>>0<Ea>>>0)break;Se[pa+12>>2]=$r,Se[wa>>2]=$r,Se[i+2]=pa,Se[i+3]=da,Se[i+6]=0;break e}while(0);throw Ka(),\"Reached an unreachable!\"}var ga=(ha>>>31<<2)+da+16|0,ya=Me[ga>>2];if(0==(0|ya)){if(ga>>>0>=Me[vi+16>>2]>>>0){Se[ga>>2]=$r,Se[i+6]=da,Se[i+3]=S,Se[i+2]=S;break e}throw Ka(),\"Reached an unreachable!\"}var ha=ha<<1,da=ya}}while(0);var ma=Se[vi+32>>2]-1|0;if(Se[vi+32>>2]=ma,0!=(0|ma))break r;ta();break r}while(0);throw Ka(),\"Reached an unreachable!\"}while(0)}function ta(){var r=Se[vi+452>>2],a=0==(0|r);r:do if(!a)for(var e=r;;){var e,i=Se[e+8>>2];if(0==(0|i))break r;var e=i}while(0);Se[vi+32>>2]=-1}function fa(r,a){if(0==(0|r))var e=Jr(a),i=e;else var v=la(r,a),i=v;var i;return i}function _a(r,a){var e,i=r>>>0<9;do if(i)var v=Jr(a),t=v;else{var f=r>>>0<16?16:r,_=0==(f-1&f|0);r:do if(_)var s=f;else{if(f>>>0<=16){var s=16;break}for(var n=16;;){var n,o=n<<1;if(o>>>0>=f>>>0){var s=o;break r}var n=o}}while(0);var s;if((-64-s|0)>>>0>a>>>0){if(a>>>0<11)var l=16;else var l=a+11&-8;var l,b=Jr(l+(s+12)|0);if(0==(0|b)){var t=0;break}var k=b-8|0;if(0==((b>>>0)%(s>>>0)|0))var u=k,c=0;else{var h=b+(s-1)&-s,d=h-8|0,w=k;if((d-w|0)>>>0>15)var p=d;else var p=h+(s-8)|0;var p,E=p-w|0,e=(b-4|0)>>2,A=Se[e],g=(A&-8)-E|0;if(0==(3&A|0)){var y=Se[k>>2]+E|0;Se[p>>2]=y,Se[p+4>>2]=g;var u=p,c=0}else{var m=p+4|0,S=g|1&Se[m>>2]|2;Se[m>>2]=S;var M=g+(p+4)|0,C=1|Se[M>>2];Se[M>>2]=C;var R=E|1&Se[e]|2;Se[e]=R;var T=b+(E-4)|0,O=1|Se[T>>2];Se[T>>2]=O;var u=p,c=b}}var c,u,N=u+4|0,I=Me[N>>2],P=0==(3&I|0);do if(P)var D=0;else{var L=I&-8;if(L>>>0<=(l+16|0)>>>0){var D=0;break}var F=L-l|0;Se[N>>2]=l|1&I|2,Se[u+(4|l)>>2]=3|F;var X=u+(4|L)|0,j=1|Se[X>>2];Se[X>>2]=j;var D=l+(u+8)|0}while(0);var D;0!=(0|c)&&va(c),0!=(0|D)&&va(D);var t=u+8|0}else{var U=Je();Se[U>>2]=12;var t=0}}while(0);var t;return t}function sa(r,a,e,i){var v,t;0==(0|Se[ti>>2])&&ba();var f=0==(0|i),_=0==(0|r);do{if(f){if(_){var s=Jr(0),n=s;t=30;break}var o=r<<2;if(o>>>0<11){var l=0,b=16;t=9;break}var l=0,b=o+11&-8;t=9;break}if(_){var n=i;t=30;break}var l=i,b=0;t=9;break}while(0);do if(9==t){var b,l,k=0==(1&e|0);r:do if(k){if(_){var u=0,c=0;break}for(var h=0,d=0;;){var d,h,w=Me[a+(d<<2)>>2];if(w>>>0<11)var p=16;else var p=w+11&-8;var p,E=p+h|0,A=d+1|0;if((0|A)==(0|r)){var u=0,c=E;break r}var h=E,d=A}}else{var g=Me[a>>2];if(g>>>0<11)var y=16;else var y=g+11&-8;var y,u=y,c=y*r|0}while(0);var c,u,m=Jr(b-4+c|0);if(0==(0|m)){var n=0;break}var S=m-8|0,M=Se[m-4>>2]&-8;if(0!=(2&e|0)){var C=-4-b+M|0;Fa(m,0,C,1)}if(0==(0|l)){var R=m+c|0,T=M-c|3;Se[m+(c-4)>>2]=T;var O=R,v=O>>2,N=c}else var O=l,v=O>>2,N=M;var N,O;Se[v]=m;var I=r-1|0,P=0==(0|I);r:do if(P)var D=S,L=N;else if(0==(0|u))for(var F=S,X=N,j=0;;){var j,X,F,U=Me[a+(j<<2)>>2];if(U>>>0<11)var x=16;else var x=U+11&-8;var x,z=X-x|0;Se[F+4>>2]=3|x;var V=F+x|0,B=j+1|0;if(Se[(B<<2>>2)+v]=x+(F+8)|0,(0|B)==(0|I)){var D=V,L=z;break r}var F=V,X=z,j=B}else for(var H=3|u,K=u+8|0,Y=S,G=N,W=0;;){var W,G,Y,Z=G-u|0;Se[Y+4>>2]=H;var Q=Y+u|0,q=W+1|0;if(Se[(q<<2>>2)+v]=Y+K|0,(0|q)==(0|I)){var D=Q,L=Z;break r}var Y=Q,G=Z,W=q}while(0);var L,D;Se[D+4>>2]=3|L;var n=O}while(0);var n;return n}function na(r){var a=r>>2;0==(0|Se[ti>>2])&&ba();var e=Me[vi+24>>2];if(0==(0|e))var i=0,v=0,t=0,f=0,_=0,s=0,n=0;else{for(var o=Me[vi+12>>2],l=o+40|0,b=vi+444|0,k=l,u=l,c=1;;){var c,u,k,b,h=Me[b>>2],d=h+8|0;if(0==(7&d|0))var w=0;else var w=7&-d;for(var w,p=b+4|0,E=h+w|0,A=c,g=u,y=k;;){var y,g,A,E;if(E>>>0<h>>>0)break;if(E>>>0>=(h+Se[p>>2]|0)>>>0|(0|E)==(0|e))break;var m=Se[E+4>>2];if(7==(0|m))break;var S=m&-8,M=S+y|0;if(1==(3&m|0))var C=A+1|0,R=S+g|0;else var C=A,R=g;var R,C,E=E+S|0,A=C,g=R,y=M}var T=Me[b+8>>2];if(0==(0|T))break;var b=T,k=y,u=g,c=A}var O=Se[vi+432>>2],i=y,v=A,t=o,f=g,_=O-y|0,s=Se[vi+436>>2],n=O-g|0}var n,s,_,f,t,v,i;Se[a]=i,Se[a+1]=v,Se[a+2]=0,Se[a+3]=0,Se[a+4]=_,Se[a+5]=s,Se[a+6]=0,Se[a+7]=n,Se[a+8]=f,Se[a+9]=t}function oa(){0==(0|Se[ti>>2])&&ba();var r=Me[vi+24>>2],a=0==(0|r);r:do if(a)var e=0,i=0,v=0;else for(var t=Se[vi+436>>2],f=Me[vi+432>>2],_=vi+444|0,s=f-40-Se[vi+12>>2]|0;;){var s,_,n=Me[_>>2],o=n+8|0;if(0==(7&o|0))var l=0;else var l=7&-o;for(var l,b=_+4|0,k=n+l|0,u=s;;){var u,k;if(k>>>0<n>>>0)break;if(k>>>0>=(n+Se[b>>2]|0)>>>0|(0|k)==(0|r))break;var c=Se[k+4>>2];if(7==(0|c))break;var h=c&-8,d=1==(3&c|0)?h:0,w=u-d|0,k=k+h|0,u=w}var p=Me[_+8>>2];if(0==(0|p)){var e=t,i=f,v=u;break r}var _=p,s=u}while(0);var v,i,e,E=Se[Se[qe>>2]+12>>2],A=(Qa(E,0|He.__str339,(ne=Oe,Oe+=4,Se[ne>>2]=e,ne)),Se[Se[qe>>2]+12>>2]),g=(Qa(A,0|He.__str1340,(ne=Oe,Oe+=4,Se[ne>>2]=i,ne)),Se[Se[qe>>2]+12>>2]);Qa(g,0|He.__str2341,(ne=Oe,Oe+=4,Se[ne>>2]=v,ne))}function la(r,a){var e,i,v,t=a>>>0>4294967231;r:do{if(!t){var f=r-8|0,_=f,i=(r-4|0)>>2,s=Me[i],n=s&-8,o=n-8|0,l=r+o|0,b=f>>>0<Me[vi+16>>2]>>>0;do if(!b){var k=3&s;if(!(1!=(0|k)&(0|o)>-8))break;var e=(r+(n-4)|0)>>2;if(0==(1&Se[e]|0))break;if(a>>>0<11)var u=16;else var u=a+11&-8;var u,c=0==(0|k);do{if(c){var h=ka(_,u),d=0,w=h;v=17;break}if(n>>>0<u>>>0){if((0|l)!=(0|Se[vi+24>>2])){v=21;break}var p=Se[vi+12>>2]+n|0;if(p>>>0<=u>>>0){v=21;break}var E=p-u|0,A=r+(u-8)|0;Se[i]=u|1&s|2;var g=1|E;Se[r+(u-4)>>2]=g,Se[vi+24>>2]=A,Se[vi+12>>2]=E;var d=0,w=_;v=17;break}var y=n-u|0;if(y>>>0<=15){var d=0,w=_;v=17;break}Se[i]=u|1&s|2,Se[r+(u-4)>>2]=3|y;var m=1|Se[e];Se[e]=m;var d=r+u|0,w=_;v=17;break}while(0);do if(17==v){var w,d;if(0==(0|w))break;0!=(0|d)&&va(d);var S=w+8|0;break r}while(0);var M=Jr(a);if(0==(0|M)){var S=0;break r}var C=0==(3&Se[i]|0)?8:4,R=n-C|0,T=R>>>0<a>>>0?R:a;Pa(M,r,T,1),va(r);var S=M;break r}while(0);throw Ka(),\"Reached an unreachable!\"}var O=Je();Se[O>>2]=12;var S=0}while(0);var S;return S}function ba(){if(0==(0|Se[ti>>2])){var r=qa(8);if(0!=(r-1&r|0))throw Ka(),\"Reached an unreachable!\";Se[ti+8>>2]=r,Se[ti+4>>2]=r,Se[ti+12>>2]=-1,Se[ti+16>>2]=2097152,Se[ti+20>>2]=0,Se[vi+440>>2]=0;var a=$a(0);Se[ti>>2]=a&-16^1431655768}}function ka(r,a){var e=Se[r+4>>2]&-8,i=a>>>0<256;do if(i)var v=0;else{if(e>>>0>=(a+4|0)>>>0&&(e-a|0)>>>0<=Se[ti+8>>2]<<1>>>0){var v=r;break}var v=0}while(0);var v;return v}function ua(r){for(var a,e=vi+444|0,a=e>>2;;){var e,i=Me[a];if(i>>>0<=r>>>0&&(i+Se[a+1]|0)>>>0>r>>>0){var v=e;break}var t=Me[a+2];if(0==(0|t)){var v=0;break}var e=t,a=e>>2}var v;return v}function ca(r,a){var e=r,i=r+8|0;if(0==(7&i|0))var v=0;else var v=7&-i;var v,t=a-v|0;Se[vi+24>>2]=e+v|0,Se[vi+12>>2]=t,Se[v+(e+4)>>2]=1|t,Se[a+(e+4)>>2]=40;var f=Se[ti+16>>2];Se[vi+28>>2]=f}function ha(){for(var r=0;;){var r,a=r<<1,e=(a<<2)+vi+40|0;Se[vi+(a+3<<2)+40>>2]=e,Se[vi+(a+2<<2)+40>>2]=e;var i=r+1|0;if(32==(0|i))break;var r=i}}function da(r,a,e){var i,v,t,f,_=a>>2,s=r>>2,n=r+8|0;if(0==(7&n|0))var o=0;else var o=7&-n;var o,l=a+8|0;if(0==(7&l|0))var b=0,t=b>>2;else var b=7&-l,t=b>>2;var b,k=a+b|0,u=k,c=o+e|0,v=c>>2,h=r+c|0,d=h,w=k-(r+o)-e|0;Se[(o+4>>2)+s]=3|e;var p=(0|u)==(0|Se[vi+24>>2]);r:do if(p){var E=Se[vi+12>>2]+w|0;Se[vi+12>>2]=E,Se[vi+24>>2]=d;var A=1|E;Se[v+(s+1)]=A}else if((0|u)==(0|Se[vi+20>>2])){var g=Se[vi+8>>2]+w|0;Se[vi+8>>2]=g,Se[vi+20>>2]=d;var y=1|g;Se[v+(s+1)]=y;var m=r+g+c|0;Se[m>>2]=g}else{var S=Me[t+(_+1)];if(1==(3&S|0)){var M=S&-8,C=S>>>3,R=S>>>0<256;a:do if(R){var T=Me[((8|b)>>2)+_],O=Me[t+(_+3)];if((0|T)!=(0|O)){var N=((S>>>2&1073741822)<<2)+vi+40|0,I=(0|T)==(0|N);do{if(!I){if(T>>>0<Me[vi+16>>2]>>>0){f=18;break}f=15;break}f=15}while(0);do if(15==f){if((0|O)!=(0|N)&&O>>>0<Me[vi+16>>2]>>>0)break;Se[T+12>>2]=O,Se[O+8>>2]=T;break a}while(0);throw Ka(),\"Reached an unreachable!\"}var P=Se[vi>>2]&(1<<C^-1);Se[vi>>2]=P}else{var D=k,L=Me[((24|b)>>2)+_],F=Me[t+(_+3)],X=(0|F)==(0|D);do if(X){var j=16|b,U=j+(a+4)|0,x=Se[U>>2];if(0==(0|x)){var z=a+j|0,V=Se[z>>2];if(0==(0|V)){var B=0,i=B>>2;break}var H=z,K=V}else{var H=U,K=x;f=25}for(;;){var K,H,Y=K+20|0,G=Se[Y>>2];if(0==(0|G)){var W=K+16|0,Z=Me[W>>2];if(0==(0|Z))break;var H=W,K=Z}else var H=Y,K=G}if(H>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[H>>2]=0;var B=K,i=B>>2}else{var Q=Me[((8|b)>>2)+_];if(Q>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[Q+12>>2]=F,Se[F+8>>2]=Q;var B=F,i=B>>2}while(0);var B;if(0==(0|L))break;var q=b+(a+28)|0,$=(Se[q>>2]<<2)+vi+304|0,J=(0|D)==(0|Se[$>>2]);do{if(J){if(Se[$>>2]=B,0!=(0|B))break;var rr=Se[vi+4>>2]&(1<<Se[q>>2]^-1);Se[vi+4>>2]=rr;break a}if(L>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";var ar=L+16|0;if((0|Se[ar>>2])==(0|D)?Se[ar>>2]=B:Se[L+20>>2]=B,0==(0|B))break a}while(0);if(B>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[i+6]=L;var er=16|b,ir=Me[(er>>2)+_];if(0!=(0|ir)){if(ir>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[i+4]=ir,Se[ir+24>>2]=B}var vr=Me[(er+4>>2)+_];if(0==(0|vr))break;if(vr>>>0<Me[vi+16>>2]>>>0)throw Ka(),\"Reached an unreachable!\";Se[i+5]=vr,Se[vr+24>>2]=B}while(0);var tr=a+(M|b)|0,fr=M+w|0}else var tr=u,fr=w;var fr,tr,_r=tr+4|0,sr=Se[_r>>2]&-2;if(Se[_r>>2]=sr,Se[v+(s+1)]=1|fr,Se[(fr>>2)+s+v]=fr,fr>>>0<256){var nr=fr>>>2&1073741822,or=(nr<<2)+vi+40|0,lr=Me[vi>>2],br=1<<(fr>>>3),kr=0==(lr&br|0);do{if(!kr){var ur=(nr+2<<2)+vi+40|0,cr=Me[ur>>2];if(cr>>>0>=Me[vi+16>>2]>>>0){var hr=cr,dr=ur;break}throw Ka(),\"Reached an unreachable!\"}Se[vi>>2]=lr|br;var hr=or,dr=(nr+2<<2)+vi+40|0}while(0);var dr,hr;Se[dr>>2]=d,Se[hr+12>>2]=d,Se[v+(s+2)]=hr,Se[v+(s+3)]=or}else{var wr=h,pr=fr>>>8,Er=0==(0|pr);do if(Er)var Ar=0;else{if(fr>>>0>16777215){var Ar=31;break}var gr=(pr+1048320|0)>>>16&8,yr=pr<<gr,mr=(yr+520192|0)>>>16&4,Sr=yr<<mr,Mr=(Sr+245760|0)>>>16&2,Cr=14-(mr|gr|Mr)+(Sr<<Mr>>>15)|0,Ar=fr>>>((Cr+7|0)>>>0)&1|Cr<<1}while(0);var Ar,Rr=(Ar<<2)+vi+304|0;Se[v+(s+7)]=Ar;var Tr=c+(r+16)|0;Se[v+(s+5)]=0,Se[Tr>>2]=0;var Or=Se[vi+4>>2],Nr=1<<Ar;if(0==(Or&Nr|0)){var Ir=Or|Nr;Se[vi+4>>2]=Ir,Se[Rr>>2]=wr,Se[v+(s+6)]=Rr,Se[v+(s+3)]=wr,Se[v+(s+2)]=wr}else{if(31==(0|Ar))var Pr=0;else var Pr=25-(Ar>>>1)|0;for(var Pr,Dr=fr<<Pr,Lr=Se[Rr>>2];;){var Lr,Dr;if((Se[Lr+4>>2]&-8|0)==(0|fr)){var Fr=Lr+8|0,Xr=Me[Fr>>2],jr=Me[vi+16>>2],Ur=Lr>>>0<jr>>>0;do if(!Ur){if(Xr>>>0<jr>>>0)break;Se[Xr+12>>2]=wr,Se[Fr>>2]=wr,Se[v+(s+2)]=Xr,Se[v+(s+3)]=Lr,Se[v+(s+6)]=0;break r}while(0);throw Ka(),\"Reached an unreachable!\"}var xr=(Dr>>>31<<2)+Lr+16|0,zr=Me[xr>>2];if(0==(0|zr)){if(xr>>>0>=Me[vi+16>>2]>>>0){Se[xr>>2]=wr,Se[v+(s+6)]=Lr,Se[v+(s+3)]=wr,Se[v+(s+2)]=wr;break r}throw Ka(),\"Reached an unreachable!\"}var Dr=Dr<<1,Lr=zr}}}}while(0);return r+(8|o)|0}function wa(r){return 0|He.__str3342}function pa(r){return 0|He.__str14343}function Ea(r){Se[r>>2]=si+8|0}function Aa(r){0!=(0|r)&&va(r)}function ga(r){ya(r);var a=r;Aa(a)}function ya(r){var a=0|r;Ye(a)}function ma(r){var a=0|r;Ea(a),Se[r>>2]=ni+8|0}function Sa(r){var a=0|r;ya(a);var e=r;Aa(e)}function Ma(r,a){var e,i,v=Me[vi+24>>2],i=v>>2,t=v,f=ua(t),_=Se[f>>2],s=Se[f+4>>2],n=_+s|0,o=_+(s-39)|0;if(0==(7&o|0))var l=0;else var l=7&-o;var l,b=_+(s-47)+l|0,k=b>>>0<(v+16|0)>>>0?t:b,u=k+8|0,e=u>>2,c=u,h=r,d=a-40|0;ca(h,d);var w=k+4|0;Se[w>>2]=27,Se[e]=Se[vi+444>>2],Se[e+1]=Se[vi+448>>2],Se[e+2]=Se[vi+452>>2],Se[e+3]=Se[vi+456>>2],Se[vi+444>>2]=r,Se[vi+448>>2]=a,Se[vi+456>>2]=0,Se[vi+452>>2]=c;var p=k+28|0;Se[p>>2]=7;var E=(k+32|0)>>>0<n>>>0;r:do if(E)for(var A=p;;){var A,g=A+4|0;if(Se[g>>2]=7,(A+8|0)>>>0>=n>>>0)break r;var A=g}while(0);var y=(0|k)==(0|t);r:do if(!y){var m=k-v|0,S=t+m|0,M=m+(t+4)|0,C=Se[M>>2]&-2;Se[M>>2]=C;var R=1|m;Se[i+1]=R;var T=S;if(Se[T>>2]=m,m>>>0<256){var O=m>>>2&1073741822,N=(O<<2)+vi+40|0,I=Me[vi>>2],P=1<<(m>>>3),D=0==(I&P|0);do{if(!D){var L=(O+2<<2)+vi+40|0,F=Me[L>>2];if(F>>>0>=Me[vi+16>>2]>>>0){var X=F,j=L;break}throw Ka(),\"Reached an unreachable!\"}var U=I|P;Se[vi>>2]=U;var X=N,j=(O+2<<2)+vi+40|0}while(0);var j,X;Se[j>>2]=v,Se[X+12>>2]=v,Se[i+2]=X,Se[i+3]=N}else{var x=v,z=m>>>8,V=0==(0|z);do if(V)var B=0;else{if(m>>>0>16777215){var B=31;break}var H=(z+1048320|0)>>>16&8,K=z<<H,Y=(K+520192|0)>>>16&4,G=K<<Y,W=(G+245760|0)>>>16&2,Z=14-(Y|H|W)+(G<<W>>>15)|0,B=m>>>((Z+7|0)>>>0)&1|Z<<1}while(0);var B,Q=(B<<2)+vi+304|0;Se[i+7]=B,Se[i+5]=0,Se[i+4]=0;var q=Se[vi+4>>2],$=1<<B;if(0==(q&$|0)){var J=q|$;Se[vi+4>>2]=J,Se[Q>>2]=x,Se[i+6]=Q,Se[i+3]=v,Se[i+2]=v}else{if(31==(0|B))var rr=0;else var rr=25-(B>>>1)|0;for(var rr,ar=m<<rr,er=Se[Q>>2];;){var er,ar;if((Se[er+4>>2]&-8|0)==(0|m)){var ir=er+8|0,vr=Me[ir>>2],tr=Me[vi+16>>2],fr=er>>>0<tr>>>0;do if(!fr){if(vr>>>0<tr>>>0)break;Se[vr+12>>2]=x,Se[ir>>2]=x,Se[i+2]=vr,Se[i+3]=er,Se[i+6]=0;break r}while(0);throw Ka(),\"Reached an unreachable!\"}var _r=(ar>>>31<<2)+er+16|0,sr=Me[_r>>2];if(0==(0|sr)){if(_r>>>0>=Me[vi+16>>2]>>>0){Se[_r>>2]=x,Se[i+6]=er,Se[i+3]=v,Se[i+2]=v;break r}throw Ka(),\"Reached an unreachable!\"}var ar=ar<<1,er=sr}}}}while(0)}function Ca(r){return d(r)}function Ra(r,a){var e=0;do Ae[r+e]=Ae[a+e],e++;while(0!=Ae[a+e-1]);return r}function Ta(){var r=Ta;return r.LLVM_SAVEDSTACKS||(r.LLVM_SAVEDSTACKS=[]),r.LLVM_SAVEDSTACKS.push(le.stackSave()),r.LLVM_SAVEDSTACKS.length-1}function Oa(r){var a=Ta,e=a.LLVM_SAVEDSTACKS[r];a.LLVM_SAVEDSTACKS.splice(r,1),le.stackRestore(e)}function Na(r,a,e){for(var i=0;i<e;){var v=Ae[r+i],t=Ae[a+i];if(v==t&&0==v)return 0;if(0==v)return-1;if(0==t)return 1;if(v!=t)return v>t?1:-1;i++}return 0}function Ia(r,a){var e=Ca(r),i=0;do Ae[r+e+i]=Ae[a+i],i++;while(0!=Ae[a+i-1]);return r}function Pa(r,a,e,i){if(e>=20&&a%2==r%2)if(a%4==r%4){for(var v=a+e;a%4;)Ae[r++]=Ae[a++];for(var t=a>>2,f=r>>2,_=v>>2;t<_;)Se[f++]=Se[t++];for(a=t<<2,r=f<<2;a<v;)Ae[r++]=Ae[a++]}else{var v=a+e;a%2&&(Ae[r++]=Ae[a++]);for(var s=a>>1,n=r>>1,o=v>>1;s<o;)ye[n++]=ye[s++];a=s<<1,r=n<<1,a<v&&(Ae[r++]=Ae[a++])}else for(;e--;)Ae[r++]=Ae[a++]}function Da(r,a){return Na(r,a,Le)}function La(r,a,e){for(var i=0;i<e;i++){var v=Ae[r+i],t=Ae[a+i];if(v!=t)return v>t?1:-1}return 0}function Fa(r,a,e,i){if(e>=20){for(var v=r+e;r%4;)Ae[r++]=a;a<0&&(a+=256);for(var t=r>>2,f=v>>2,_=a|a<<8|a<<16|a<<24;t<f;)Se[t++]=_;for(r=t<<2;r<v;)Ae[r++]=a}else for(;e--;)Ae[r++]=a}function Xa(r,a,e,i){throw\"Assertion failed: \"+s(i)+\", at: \"+[s(r),a,s(e)]}function ja(r){var a=d(r),e=Jr(a+1);return Pa(e,r,a,1),Ae[e+a]=0,e}function Ua(r,a){function e(r){var e;return\"double\"===r?(xe[0]=Se[a+_>>2],xe[1]=Se[a+_+4>>2],e=ze[0]):\"i64\"==r?e=[Se[a+_>>2],Se[a+_+4>>2]]:(r=\"i32\",e=Se[a+_>>2]),_+=le.getNativeFieldSize(r),e}for(var i,v,t,f=r,_=0,s=[];;){var n=f;if(i=Ae[f],0===i)break;if(v=Ae[f+1],i==\"%\".charCodeAt(0)){var o=!1,l=!1,b=!1,k=!1;r:for(;;){switch(v){case\"+\".charCodeAt(0):o=!0;break;case\"-\".charCodeAt(0):l=!0;break;case\"#\".charCodeAt(0):b=!0;break;case\"0\".charCodeAt(0):if(k)break r;k=!0;break;default:break r}f++,v=Ae[f+1]}var u=0;if(v==\"*\".charCodeAt(0))u=e(\"i32\"),f++,v=Ae[f+1];else for(;v>=\"0\".charCodeAt(0)&&v<=\"9\".charCodeAt(0);)u=10*u+(v-\"0\".charCodeAt(0)),f++,v=Ae[f+1];var c=!1;if(v==\".\".charCodeAt(0)){var h=0;if(c=!0,f++,v=Ae[f+1],v==\"*\".charCodeAt(0))h=e(\"i32\"),f++;else for(;;){var d=Ae[f+1];if(d<\"0\".charCodeAt(0)||d>\"9\".charCodeAt(0))break;h=10*h+(d-\"0\".charCodeAt(0)),f++}v=Ae[f+1]}else var h=6;var E;switch(String.fromCharCode(v)){case\"h\":var A=Ae[f+2];A==\"h\".charCodeAt(0)?(f++,E=1):E=2;break;case\"l\":var A=Ae[f+2];A==\"l\".charCodeAt(0)?(f++,E=8):E=4;break;case\"L\":case\"q\":case\"j\":E=8;break;case\"z\":case\"t\":case\"I\":E=4;break;default:E=null}if(E&&f++,v=Ae[f+1],[\"d\",\"i\",\"u\",\"o\",\"x\",\"X\",\"p\"].indexOf(String.fromCharCode(v))!=-1){var m=v==\"d\".charCodeAt(0)||v==\"i\".charCodeAt(0);E=E||4;var t=e(\"i\"+8*E);if(8==E&&(t=le.makeBigInt(t[0],t[1],v==\"u\".charCodeAt(0))),E<=4){var S=Math.pow(256,E)-1;t=(m?y:g)(t&S,8*E)}var M,C=Math.abs(t),R=\"\";if(v==\"d\".charCodeAt(0)||v==\"i\".charCodeAt(0))M=y(t,8*E,1).toString(10);else if(v==\"u\".charCodeAt(0))M=g(t,8*E,1).toString(10),t=Math.abs(t);else if(v==\"o\".charCodeAt(0))M=(b?\"0\":\"\")+C.toString(8);else if(v==\"x\".charCodeAt(0)||v==\"X\".charCodeAt(0)){if(R=b?\"0x\":\"\",t<0){t=-t,M=(C-1).toString(16);for(var T=[],O=0;O<M.length;O++)T.push((15-parseInt(M[O],16)).toString(16));for(M=T.join(\"\");M.length<2*E;)M=\"f\"+M}else M=C.toString(16);v==\"X\".charCodeAt(0)&&(R=R.toUpperCase(),M=M.toUpperCase())}else v==\"p\".charCodeAt(0)&&(0===C?M=\"(nil)\":(R=\"0x\",M=C.toString(16)));if(c)for(;M.length<h;)M=\"0\"+M;for(o&&(R=t<0?\"-\"+R:\"+\"+R);R.length+M.length<u;)l?M+=\" \":k?M=\"0\"+M:R=\" \"+R;M=R+M,M.split(\"\").forEach(function(r){s.push(r.charCodeAt(0))})}else if([\"f\",\"F\",\"e\",\"E\",\"g\",\"G\"].indexOf(String.fromCharCode(v))!=-1){var M,t=e(\"double\");if(isNaN(t))M=\"nan\",k=!1;else if(isFinite(t)){var N=!1,I=Math.min(h,20);if(v==\"g\".charCodeAt(0)||v==\"G\".charCodeAt(0)){N=!0,h=h||1;var P=parseInt(t.toExponential(I).split(\"e\")[1],10);h>P&&P>=-4?(v=(v==\"g\".charCodeAt(0)?\"f\":\"F\").charCodeAt(0),h-=P+1):(v=(v==\"g\".charCodeAt(0)?\"e\":\"E\").charCodeAt(0),h--),I=Math.min(h,20)}v==\"e\".charCodeAt(0)||v==\"E\".charCodeAt(0)?(M=t.toExponential(I),/[eE][-+]\\d$/.test(M)&&(M=M.slice(0,-1)+\"0\"+M.slice(-1))):v!=\"f\".charCodeAt(0)&&v!=\"F\".charCodeAt(0)||(M=t.toFixed(I));var D=M.split(\"e\");if(N&&!b)for(;D[0].length>1&&D[0].indexOf(\".\")!=-1&&(\"0\"==D[0].slice(-1)||\".\"==D[0].slice(-1));)D[0]=D[0].slice(0,-1);else for(b&&M.indexOf(\".\")==-1&&(D[0]+=\".\");h>I++;)D[0]+=\"0\";M=D[0]+(D.length>1?\"e\"+D[1]:\"\"),v==\"E\".charCodeAt(0)&&(M=M.toUpperCase()),o&&t>=0&&(M=\"+\"+M)}else M=(t<0?\"-\":\"\")+\"inf\",k=!1;for(;M.length<u;)l?M+=\" \":M=!k||\"-\"!=M[0]&&\"+\"!=M[0]?(k?\"0\":\" \")+M:M[0]+\"0\"+M.slice(1);v<\"a\".charCodeAt(0)&&(M=M.toUpperCase()),M.split(\"\").forEach(function(r){s.push(r.charCodeAt(0))})}else if(v==\"s\".charCodeAt(0)){var L,F=e(\"i8*\");if(F?(L=w(F),c&&L.length>h&&(L=L.slice(0,h))):L=p(\"(null)\",!0),!l)for(;L.length<u--;)s.push(\" \".charCodeAt(0));if(s=s.concat(L),l)for(;L.length<u--;)s.push(\" \".charCodeAt(0))}else if(v==\"c\".charCodeAt(0)){for(l&&s.push(e(\"i8\"));--u>0;)s.push(\" \".charCodeAt(0));l||s.push(e(\"i8\"))}else if(v==\"n\".charCodeAt(0)){var X=e(\"i32*\");Se[X>>2]=s.length}else if(v==\"%\".charCodeAt(0))s.push(i);else for(var O=n;O<f+2;O++)s.push(Ae[O]);f+=2}else s.push(i),f+=1}return s}function xa(r,a,e,i){for(var v=Ua(e,i),t=void 0===a?v.length:Math.min(v.length,a-1),f=0;f<t;f++)Ae[r+f]=v[f];return Ae[r+f]=0,v.length}function za(r,a,e){return xa(r,void 0,a,e)}function Va(r){return r in{32:0,9:0,10:0,11:0,12:0,13:0}}function Ba(r){return r>=\"0\".charCodeAt(0)&&r<=\"9\".charCodeAt(0)}function Ha(r){for(var a;(a=Ae[r])&&Va(a);)r++;if(!a||!Ba(a))return 0;for(var e=r;(a=Ae[e])&&Ba(a);)e++;return Math.floor(Number(s(r).substr(0,e-r)))}function Ka(r){throw ke=!0,\"ABORT: \"+r+\", at \"+(new Error).stack}function Ya(r){return Ya.ret||(Ya.ret=_([0],\"i32\",we)),Se[Ya.ret>>2]=r,r}function Ga(r,a,e,i){var v=$e.streams[r];if(!v||v.object.isDevice)return Ya(Ge.EBADF),-1;if(v.isWrite){if(v.object.isFolder)return Ya(Ge.EISDIR),-1;if(e<0||i<0)return Ya(Ge.EINVAL),-1;for(var t=v.object.contents;t.length<i;)t.push(0);for(var f=0;f<e;f++)t[i+f]=ge[a+f];return v.object.timestamp=Date.now(),f}return Ya(Ge.EACCES),-1}function Wa(r,a,e){var i=$e.streams[r];if(i){if(i.isWrite){if(e<0)return Ya(Ge.EINVAL),-1;if(i.object.isDevice){if(i.object.output){for(var v=0;v<e;v++)try{i.object.output(Ae[a+v])}catch(r){return Ya(Ge.EIO),-1}return i.object.timestamp=Date.now(),v}return Ya(Ge.ENXIO),-1}var t=Ga(r,a,e,i.position);return t!=-1&&(i.position+=t),t}return Ya(Ge.EACCES),-1}return Ya(Ge.EBADF),-1}function Za(r,a,e,i){var v=e*a;if(0==v)return 0;var t=Wa(i,r,v);return t==-1?($e.streams[i]&&($e.streams[i].error=!0),-1):Math.floor(t/a)}function Qa(r,a,e){var i=Ua(a,e),v=le.stackSave(),t=Za(_(i,\"i8\",de),1,i.length,r);return le.stackRestore(v),t}function qa(r){switch(r){case 8:return Pe;case 54:case 56:case 21:case 61:case 63:case 22:case 67:case 23:case 24:case 25:case 26:case 27:case 69:case 28:case 101:case 70:case 71:case 29:case 30:case 199:case 75:case 76:case 32:case 43:case 44:case 80:case 46:case 47:case 45:case 48:case 49:case 42:case 82:case 33:case 7:case 108:case 109:case 107:case 112:case 119:case 121:return 200809;case 13:case 104:case 94:case 95:case 34:case 35:case 77:case 81:case 83:case 84:case 85:case 86:case 87:case 88:case 89:case 90:case 91:case 94:case 95:case 110:case 111:case 113:case 114:case 115:case 116:case 117:case 118:case 120:case 40:case 16:case 79:case 19:return-1;case 92:case 93:case 5:case 72:case 6:case 74:case 92:case 93:case 96:case 97:case 98:case 99:case 102:case 103:case 105:return 1;case 38:case 66:case 50:case 51:case 4:return 1024;case 15:case 64:case 41:return 32;case 55:case 37:case 17:return 2147483647;case 18:case 1:return 47839;case 59:case 57:return 99;case 68:case 58:return 2048;case 0:return 2097152;case 3:return 65536;case 14:return 32768;case 73:return 32767;case 39:return 16384;case 60:return 1e3;case 106:return 700;case 52:return 256;case 62:return 255;case 2:return 100;case 65:return 64;case 36:return 20;case 100:return 16;case 20:return 6;case 53:return 4}return Ya(Ge.EINVAL),-1}function $a(r){var a=Math.floor(Date.now()/1e3);return r&&(Se[r>>2]=a),a}function Ja(){return Ya.ret}function re(r){var a=re;a.called||(Ie=o(Ie),a.called=!0);var e=Ie;return 0!=r&&le.staticAlloc(r),e}function ae(){return Se[ae.buf>>2]}function ee(r){r=r||Module.arguments,k();var a=null;return Module._main&&(a=Module.callMain(r),Module.noExitRuntime||u()),a}var ie=[],ve=false,te=\"object\"==typeof window,fe=\"function\"==typeof importScripts,_e=!te&&!ve&&!fe;if(ve){print=function(r){process.stdout.write(r+\"\\n\")},printErr=function(r){process.stderr.write(r+\"\\n\")};var se=require(\"fs\");read=function(r){var a=se.readFileSync(r).toString();return a||\"/\"==r[0]||(r=__dirname.split(\"/\").slice(0,-1).join(\"/\")+\"/src/\"+r,a=se.readFileSync(r).toString()),a},load=function(a){r(read(a))},ie=process.argv.slice(2)}else if(_e)this.read||(this.read=function(r){snarf(r)}),\"undefined\"!=typeof scriptArgs?ie=scriptArgs:\"undefined\"!=typeof arguments&&(ie=arguments);else if(te)this.print=printErr=function(r){console.log(r)},this.read=function(r){var a=new XMLHttpRequest;return a.open(\"GET\",r,!1),a.send(null),a.responseText},this.arguments&&(ie=arguments);else{if(!fe)throw\"Unknown runtime environment. Where are we?\";this.load=importScripts}\"undefined\"==typeof load&&\"undefined\"!=typeof read&&(this.load=function(a){r(read(a))}),\"undefined\"==typeof printErr&&(this.printErr=function(){}),\"undefined\"==typeof print&&(this.print=printErr);try{this.Module=Module}catch(r){this.Module=Module={}}Module.arguments||(Module.arguments=ie),Module.print&&(print=Module.print);var ne,oe,le={stackSave:function(){return Oe},stackRestore:function(r){Oe=r},forceAlign:function(r,a){if(a=a||4,1==a)return r;if(isNumber(r)&&isNumber(a))return Math.ceil(r/a)*a;if(isNumber(a)&&isPowerOfTwo(a)){var e=log2(a);return\"((((\"+r+\")+\"+(a-1)+\")>>\"+e+\")<<\"+e+\")\"}return\"Math.ceil((\"+r+\")/\"+a+\")*\"+a},isNumberType:function(r){return r in le.INT_TYPES||r in le.FLOAT_TYPES},isPointerType:function(r){return\"*\"==r[r.length-1]},isStructType:function(r){return!isPointerType(r)&&(!!/^\\[\\d+\\ x\\ (.*)\\]/.test(r)||(!!/<?{ [^}]* }>?/.test(r)||\"%\"==r[0]))},INT_TYPES:{i1:0,i8:0,i16:0,i32:0,i64:0},FLOAT_TYPES:{float:0,double:0},bitshift64:function(r,e,i,v){var t=Math.pow(2,v)-1;if(v<32)switch(i){case\"shl\":return[r<<v,e<<v|(r&t<<32-v)>>>32-v];case\"ashr\":return[(r>>>v|(e&t)<<32-v)>>0>>>0,e>>v>>>0];case\"lshr\":return[(r>>>v|(e&t)<<32-v)>>>0,e>>>v]}else if(32==v)switch(i){case\"shl\":return[0,r];case\"ashr\":return[e,(0|e)<0?t:0];case\"lshr\":return[e,0]}else switch(i){case\"shl\":return[0,r<<v-32];case\"ashr\":return[e>>v-32>>>0,(0|e)<0?t:0];case\"lshr\":return[e>>>v-32,0]}a(\"unknown bitshift64 op: \"+[value,i,v])},or64:function(r,a){var e=0|r|(0|a),i=4294967296*(Math.round(r/4294967296)|Math.round(a/4294967296));return e+i},and64:function(r,a){var e=(0|r)&(0|a),i=4294967296*(Math.round(r/4294967296)&Math.round(a/4294967296));return e+i},xor64:function(r,a){var e=(0|r)^(0|a),i=4294967296*(Math.round(r/4294967296)^Math.round(a/4294967296));return e+i},getNativeTypeSize:function(r,a){if(1==le.QUANTUM_SIZE)return 1;var i={\"%i1\":1,\"%i8\":1,\"%i16\":2,\"%i32\":4,\"%i64\":8,\"%float\":4,\"%double\":8}[\"%\"+r];if(!i)if(\"*\"==r[r.length-1])i=le.QUANTUM_SIZE;else if(\"i\"==r[0]){var v=parseInt(r.substr(1));e(v%8==0),i=v/8}return i},getNativeFieldSize:function(r){return Math.max(le.getNativeTypeSize(r),le.QUANTUM_SIZE)},dedup:function(r,a){var e={};return a?r.filter(function(r){return!e[r[a]]&&(e[r[a]]=!0,!0)}):r.filter(function(r){return!e[r]&&(e[r]=!0,!0)})},set:function(){for(var r=\"object\"==typeof arguments[0]?arguments[0]:arguments,a={},e=0;e<r.length;e++)a[r[e]]=0;return a},calculateStructAlignment:function(r){r.flatSize=0,r.alignSize=0;var a=[],e=-1;return r.flatIndexes=r.fields.map(function(i){var v,t;if(le.isNumberType(i)||le.isPointerType(i))v=le.getNativeTypeSize(i),t=v;else{if(!le.isStructType(i))throw\"Unclear type in struct: \"+i+\", in \"+r.name_+\" :: \"+dump(Types.types[r.name_]);v=Types.types[i].flatSize,t=Types.types[i].alignSize}t=r.packed?1:Math.min(t,le.QUANTUM_SIZE),r.alignSize=Math.max(r.alignSize,t);var f=le.alignMemory(r.flatSize,t);return r.flatSize=f+v,e>=0&&a.push(f-e),e=f,f}),r.flatSize=le.alignMemory(r.flatSize,r.alignSize),0==a.length?r.flatFactor=r.flatSize:1==le.dedup(a).length&&(r.flatFactor=a[0]),r.needsFlattening=1!=r.flatFactor,r.flatIndexes},generateStructInfo:function(r,a,i){var v,t;if(a){if(i=i||0,v=(\"undefined\"==typeof Types?le.typeInfo:Types.types)[a],!v)return null;e(v.fields.length===r.length,\"Number of named fields must match the type for \"+a),t=v.flatIndexes}else{var v={fields:r.map(function(r){return r[0]})};t=le.calculateStructAlignment(v)}var f={__size__:v.flatSize};return a?r.forEach(function(r,a){if(\"string\"==typeof r)f[r]=t[a]+i;else{var e;for(var _ in r)e=_;f[e]=le.generateStructInfo(r[e],v.fields[a],t[a])}}):r.forEach(function(r,a){f[r[1]]=t[a]}),f},stackAlloc:function(r){var a=Oe;return Oe+=r,Oe=Oe+3>>2<<2,a},staticAlloc:function(r){var a=Ie;return Ie+=r,Ie=Ie+3>>2<<2,Ie>=Le&&l(),a},alignMemory:function(r,a){var e=r=Math.ceil(r/(a?a:4))*(a?a:4);return e},makeBigInt:function(r,a,e){var i=e?(r>>>0)+4294967296*(a>>>0):(r>>>0)+4294967296*(0|a);return i},QUANTUM_SIZE:4,__dummy__:0},be={MAX_ALLOWED:0,corrections:0,sigs:{},note:function(r,e,i){e||(this.corrections++,this.corrections>=this.MAX_ALLOWED&&a(\"\\n\\nToo many corrections!\"))},print:function(){}},ke=!1,ue=0,ce=this;Module.ccall=i,Module.setValue=t,Module.getValue=f;var he=0,de=1,we=2;Module.ALLOC_NORMAL=he,Module.ALLOC_STACK=de,Module.ALLOC_STATIC=we,Module.allocate=_,Module.Pointer_stringify=s,Module.Array_stringify=n;var pe,Ee,Ae,ge,ye,me,Se,Me,Ce,Re,Te,Oe,Ne,Ie,Pe=4096,De=Module.TOTAL_STACK||5242880,Le=Module.TOTAL_MEMORY||10485760;Module.FAST_MEMORY||2097152;e(!!(Int32Array&&Float64Array&&new Int32Array(1).subarray&&new Int32Array(1).set),\"Cannot fallback to non-typed array case: Code is too specialized\");var Fe=new ArrayBuffer(Le);Ae=new Int8Array(Fe),ye=new Int16Array(Fe),Se=new Int32Array(Fe),ge=new Uint8Array(Fe),me=new Uint16Array(Fe),Me=new Uint32Array(Fe),Ce=new Float32Array(Fe),Re=new Float64Array(Fe),Se[0]=255,e(255===ge[0]&&0===ge[3],\"Typed arrays 2 must be run on a little-endian system\");var Xe=p(\"(null)\");Ie=Xe.length;for(var je=0;je<Xe.length;je++)Ae[je]=Xe[je];Module.HEAP=Ee,Module.HEAP8=Ae,Module.HEAP16=ye,Module.HEAP32=Se,Module.HEAPU8=ge,Module.HEAPU16=me,Module.HEAPU32=Me,Module.HEAPF32=Ce,Module.HEAPF64=Re,Te=Oe=le.alignMemory(Ie),Ne=Te+De;var Ue=le.alignMemory(Ne,8),xe=(Ae.subarray(Ue),Se.subarray(Ue>>2)),ze=(Ce.subarray(Ue>>2),Re.subarray(Ue>>3));Ne=Ue+8,Ie=o(Ne);var Ve=[],Be=[];Module.Array_copy=c,Module.TypedArray_copy=h,Module.String_len=d,Module.String_copy=w,Module.intArrayFromString=p,Module.intArrayToString=E,Module.writeStringToMemory=A;var He=[],Ke=0;O.X=1,N.X=1,V.X=1,H.X=1,G.X=1,W.X=1,q.X=1,$.X=1,rr.X=1,ar.X=1,er.X=1,vr.X=1,nr.X=1,or.X=1,kr.X=1,hr.X=1,Ar.X=1,Sr.X=1,Tr.X=1,Ir.X=1,Pr.X=1,Dr.X=1,Lr.X=1,Fr.X=1,Xr.X=1,zr.X=1,Vr.X=1,Br.X=1,Gr.X=1,$r.X=1,Module._malloc=Jr,Jr.X=1,ra.X=1,aa.X=1,ea.X=1,ia.X=1,Module._free=va,va.X=1,_a.X=1,sa.X=1,na.X=1,oa.X=1,la.X=1,da.X=1,Ma.X=1;var Ye,Ge={E2BIG:7,EACCES:13,EADDRINUSE:98,EADDRNOTAVAIL:99,EAFNOSUPPORT:97,EAGAIN:11,EALREADY:114,EBADF:9,EBADMSG:74,EBUSY:16,ECANCELED:125,ECHILD:10,ECONNABORTED:103,ECONNREFUSED:111,ECONNRESET:104,EDEADLK:35,EDESTADDRREQ:89,EDOM:33,EDQUOT:122,EEXIST:17,EFAULT:14,EFBIG:27,EHOSTUNREACH:113,EIDRM:43,EILSEQ:84,EINPROGRESS:115,EINTR:4,EINVAL:22,EIO:5,EISCONN:106,EISDIR:21,ELOOP:40,EMFILE:24,EMLINK:31,EMSGSIZE:90,EMULTIHOP:72,ENAMETOOLONG:36,ENETDOWN:100,ENETRESET:102,ENETUNREACH:101,ENFILE:23,ENOBUFS:105,ENODATA:61,ENODEV:19,ENOENT:2,ENOEXEC:8,ENOLCK:37,ENOLINK:67,ENOMEM:12,ENOMSG:42,ENOPROTOOPT:92,ENOSPC:28,ENOSR:63,ENOSTR:60,ENOSYS:38,ENOTCONN:107,ENOTDIR:20,ENOTEMPTY:39,ENOTRECOVERABLE:131,ENOTSOCK:88,ENOTSUP:95,ENOTTY:25,ENXIO:6,EOVERFLOW:75,EOWNERDEAD:130,EPERM:1,EPIPE:32,EPROTO:71,EPROTONOSUPPORT:93,EPROTOTYPE:91,ERANGE:34,EROFS:30,ESPIPE:29,ESRCH:3,ESTALE:116,ETIME:62,ETIMEDOUT:110,ETXTBSY:26,EWOULDBLOCK:11,EXDEV:18},We=0,Ze=0,Qe=0,qe=0,$e={currentPath:\"/\",nextInode:2,streams:[null],ignorePermissions:!0,absolutePath:function(r,a){if(\"string\"!=typeof r)return null;void 0===a&&(a=$e.currentPath),r&&\"/\"==r[0]&&(a=\"\");for(var e=a+\"/\"+r,i=e.split(\"/\").reverse(),v=[\"\"];i.length;){var t=i.pop();\"\"==t||\".\"==t||(\"..\"==t?v.length>1&&v.pop():v.push(t))}return 1==v.length?\"/\":v.join(\"/\")},analyzePath:function(r,a,e){var i={isRoot:!1,exists:!1,error:0,name:null,path:null,object:null,parentExists:!1,parentPath:null,parentObject:null};if(r=$e.absolutePath(r),\"/\"==r)i.isRoot=!0,i.exists=i.parentExists=!0,i.name=\"/\",i.path=i.parentPath=\"/\",i.object=i.parentObject=$e.root;else if(null!==r){e=e||0,r=r.slice(1).split(\"/\");for(var v=$e.root,t=[\"\"];r.length;){1==r.length&&v.isFolder&&(i.parentExists=!0,i.parentPath=1==t.length?\"/\":t.join(\"/\"),i.parentObject=v,i.name=r[0]);var f=r.shift();if(!v.isFolder){i.error=Ge.ENOTDIR;break}if(!v.read){i.error=Ge.EACCES;break}if(!v.contents.hasOwnProperty(f)){i.error=Ge.ENOENT;break}if(v=v.contents[f],v.link&&(!a||0!=r.length)){if(e>40){i.error=Ge.ELOOP;break}var _=$e.absolutePath(v.link,t.join(\"/\"));return $e.analyzePath([_].concat(r).join(\"/\"),a,e+1)}t.push(f),0==r.length&&(i.exists=!0,i.path=t.join(\"/\"),i.object=v)}return i}return i},findObject:function(r,a){$e.ensureRoot();var e=$e.analyzePath(r,a);return e.exists?e.object:(Ya(e.error),null)},createObject:function(r,a,e,i,v){if(r||(r=\"/\"),\"string\"==typeof r&&(r=$e.findObject(r)),!r)throw Ya(Ge.EACCES),new Error(\"Parent path must exist.\");if(!r.isFolder)throw Ya(Ge.ENOTDIR),\nnew Error(\"Parent must be a folder.\");if(!r.write&&!$e.ignorePermissions)throw Ya(Ge.EACCES),new Error(\"Parent folder must be writeable.\");if(!a||\".\"==a||\"..\"==a)throw Ya(Ge.ENOENT),new Error(\"Name must not be empty.\");if(r.contents.hasOwnProperty(a))throw Ya(Ge.EEXIST),new Error(\"Can't overwrite object.\");r.contents[a]={read:void 0===i||i,write:void 0!==v&&v,timestamp:Date.now(),inodeNumber:$e.nextInode++};for(var t in e)e.hasOwnProperty(t)&&(r.contents[a][t]=e[t]);return r.contents[a]},createFolder:function(r,a,e,i){var v={isFolder:!0,isDevice:!1,contents:{}};return $e.createObject(r,a,v,e,i)},createPath:function(r,a,e,i){var v=$e.findObject(r);if(null===v)throw new Error(\"Invalid parent.\");for(a=a.split(\"/\").reverse();a.length;){var t=a.pop();t&&(v.contents.hasOwnProperty(t)||$e.createFolder(v,t,e,i),v=v.contents[t])}return v},createFile:function(r,a,e,i,v){return e.isFolder=!1,$e.createObject(r,a,e,i,v)},createDataFile:function(r,a,e,i,v){if(\"string\"==typeof e){for(var t=new Array(e.length),f=0,_=e.length;f<_;++f)t[f]=e.charCodeAt(f);e=t}var s={isDevice:!1,contents:e};return $e.createFile(r,a,s,i,v)},createLazyFile:function(r,a,e,i,v){var t={isDevice:!1,url:e};return $e.createFile(r,a,t,i,v)},createLink:function(r,a,e,i,v){var t={isDevice:!1,link:e};return $e.createFile(r,a,t,i,v)},createDevice:function(r,a,e,i){if(!e&&!i)throw new Error(\"A device must have at least one callback defined.\");var v={isDevice:!0,input:e,output:i};return $e.createFile(r,a,v,Boolean(e),Boolean(i))},forceLoadFile:function(r){if(r.isDevice||r.isFolder||r.link||r.contents)return!0;var a=!0;if(\"undefined\"!=typeof XMLHttpRequest)e(\"Cannot do synchronous binary XHRs in modern browsers. Use --embed-file or --preload-file in emcc\");else{if(\"undefined\"==typeof read)throw new Error(\"Cannot load without read() or XMLHttpRequest.\");try{r.contents=p(read(r.url),!0)}catch(r){a=!1}}return a||Ya(Ge.EIO),a},ensureRoot:function(){$e.root||($e.root={read:!0,write:!0,isFolder:!0,isDevice:!1,timestamp:Date.now(),inodeNumber:1,contents:{}})},init:function(r,a,i){function v(r){null===r||r===\"\\n\".charCodeAt(0)?(a.printer(a.buffer.join(\"\")),a.buffer=[]):a.buffer.push(String.fromCharCode(r))}e(!$e.init.initialized,\"FS.init was previously called. If you want to initialize later with custom parameters, remove any earlier calls (note that one is automatically added to the generated code)\"),$e.init.initialized=!0,$e.ensureRoot(),r=r||Module.stdin,a=a||Module.stdout,i=i||Module.stderr;var t=!0,f=!0,s=!0;r||(t=!1,r=function(){if(!r.cache||!r.cache.length){var a;\"undefined\"!=typeof window&&\"function\"==typeof window.prompt?a=window.prompt(\"Input: \"):\"function\"==typeof readline&&(a=readline()),a||(a=\"\"),r.cache=p(a+\"\\n\",!0)}return r.cache.shift()}),a||(f=!1,a=v),a.printer||(a.printer=print),a.buffer||(a.buffer=[]),i||(s=!1,i=v),i.printer||(i.printer=print),i.buffer||(i.buffer=[]),$e.createFolder(\"/\",\"tmp\",!0,!0);var n=$e.createFolder(\"/\",\"dev\",!0,!0),o=$e.createDevice(n,\"stdin\",r),l=$e.createDevice(n,\"stdout\",null,a),b=$e.createDevice(n,\"stderr\",null,i);$e.createDevice(n,\"tty\",r,a),$e.streams[1]={path:\"/dev/stdin\",object:o,position:0,isRead:!0,isWrite:!1,isAppend:!1,isTerminal:!t,error:!1,eof:!1,ungotten:[]},$e.streams[2]={path:\"/dev/stdout\",object:l,position:0,isRead:!1,isWrite:!0,isAppend:!1,isTerminal:!f,error:!1,eof:!1,ungotten:[]},$e.streams[3]={path:\"/dev/stderr\",object:b,position:0,isRead:!1,isWrite:!0,isAppend:!1,isTerminal:!s,error:!1,eof:!1,ungotten:[]},We=_([1],\"void*\",we),Ze=_([2],\"void*\",we),Qe=_([3],\"void*\",we),$e.createPath(\"/\",\"dev/shm/tmp\",!0,!0),$e.streams[We]=$e.streams[1],$e.streams[Ze]=$e.streams[2],$e.streams[Qe]=$e.streams[3],qe=_([_([0,0,0,0,We,0,0,0,Ze,0,0,0,Qe,0,0,0],\"void*\",we)],\"void*\",we)},quit:function(){$e.init.initialized&&($e.streams[2]&&$e.streams[2].object.output.buffer.length>0&&$e.streams[2].object.output(\"\\n\".charCodeAt(0)),$e.streams[3]&&$e.streams[3].object.output.buffer.length>0&&$e.streams[3].object.output(\"\\n\".charCodeAt(0)))}},Je=Ja;Ve.unshift({func:function(){$e.ignorePermissions=!1,$e.init.initialized||$e.init()}}),Be.push({func:function(){$e.quit()}}),Ya(0),ae.buf=_(12,\"void*\",we),Module.callMain=function(r){function a(){for(var r=0;r<3;r++)i.push(0)}var e=r.length+1,i=[_(p(\"/bin/this.program\"),\"i8\",we)];a();for(var v=0;v<e-1;v+=1)i.push(_(p(r[v]),\"i8\",we)),a();return i.push(0),i=_(i,\"i32\",we),_main(e,i,0)};var ri,ai,ei,ii,vi,ti,qe,fi,_i,si,ni,oi,li,bi,ki,ui,ci,hi,di,wi;if(He.__str=_([97,78,0],\"i8\",we),He.__str1=_([38,61,0],\"i8\",we),He.__str2=_([97,83,0],\"i8\",we),He.__str3=_([61,0],\"i8\",we),He.__str4=_([97,97,0],\"i8\",we),He.__str5=_([38,38,0],\"i8\",we),He.__str6=_([97,100,0],\"i8\",we),He.__str7=_([38,0],\"i8\",we),He.__str8=_([97,110,0],\"i8\",we),He.__str9=_([99,108,0],\"i8\",we),He.__str10=_([40,41,0],\"i8\",we),He.__str11=_([99,109,0],\"i8\",we),He.__str12=_([44,0],\"i8\",we),He.__str13=_([99,111,0],\"i8\",we),He.__str14=_([126,0],\"i8\",we),He.__str15=_([100,86,0],\"i8\",we),He.__str16=_([47,61,0],\"i8\",we),He.__str17=_([100,97,0],\"i8\",we),He.__str18=_([100,101,108,101,116,101,91,93,0],\"i8\",we),He.__str19=_([100,101,0],\"i8\",we),He.__str20=_([42,0],\"i8\",we),He.__str21=_([100,108,0],\"i8\",we),He.__str22=_([100,101,108,101,116,101,0],\"i8\",we),He.__str23=_([100,118,0],\"i8\",we),He.__str24=_([47,0],\"i8\",we),He.__str25=_([101,79,0],\"i8\",we),He.__str26=_([94,61,0],\"i8\",we),He.__str27=_([101,111,0],\"i8\",we),He.__str28=_([94,0],\"i8\",we),He.__str29=_([101,113,0],\"i8\",we),He.__str30=_([61,61,0],\"i8\",we),He.__str31=_([103,101,0],\"i8\",we),He.__str32=_([62,61,0],\"i8\",we),He.__str33=_([103,116,0],\"i8\",we),He.__str34=_([62,0],\"i8\",we),He.__str35=_([105,120,0],\"i8\",we),He.__str36=_([91,93,0],\"i8\",we),He.__str37=_([108,83,0],\"i8\",we),He.__str38=_([60,60,61,0],\"i8\",we),He.__str39=_([108,101,0],\"i8\",we),He.__str40=_([60,61,0],\"i8\",we),He.__str41=_([108,115,0],\"i8\",we),He.__str42=_([60,60,0],\"i8\",we),He.__str43=_([108,116,0],\"i8\",we),He.__str44=_([60,0],\"i8\",we),He.__str45=_([109,73,0],\"i8\",we),He.__str46=_([45,61,0],\"i8\",we),He.__str47=_([109,76,0],\"i8\",we),He.__str48=_([42,61,0],\"i8\",we),He.__str49=_([109,105,0],\"i8\",we),He.__str51=_([109,108,0],\"i8\",we),He.__str52=_([109,109,0],\"i8\",we),He.__str53=_([45,45,0],\"i8\",we),He.__str54=_([110,97,0],\"i8\",we),He.__str55=_([110,101,119,91,93,0],\"i8\",we),He.__str56=_([110,101,0],\"i8\",we),He.__str57=_([33,61,0],\"i8\",we),He.__str58=_([110,103,0],\"i8\",we),He.__str59=_([110,116,0],\"i8\",we),He.__str60=_([33,0],\"i8\",we),He.__str61=_([110,119,0],\"i8\",we),He.__str62=_([110,101,119,0],\"i8\",we),He.__str63=_([111,82,0],\"i8\",we),He.__str64=_([124,61,0],\"i8\",we),He.__str65=_([111,111,0],\"i8\",we),He.__str66=_([124,124,0],\"i8\",we),He.__str67=_([111,114,0],\"i8\",we),He.__str68=_([124,0],\"i8\",we),He.__str69=_([112,76,0],\"i8\",we),He.__str70=_([43,61,0],\"i8\",we),He.__str71=_([112,108,0],\"i8\",we),He.__str72=_([43,0],\"i8\",we),He.__str73=_([112,109,0],\"i8\",we),He.__str74=_([45,62,42,0],\"i8\",we),He.__str75=_([112,112,0],\"i8\",we),He.__str76=_([43,43,0],\"i8\",we),He.__str77=_([112,115,0],\"i8\",we),He.__str78=_([112,116,0],\"i8\",we),He.__str79=_([45,62,0],\"i8\",we),He.__str80=_([113,117,0],\"i8\",we),He.__str81=_([63,0],\"i8\",we),He.__str82=_([114,77,0],\"i8\",we),He.__str83=_([37,61,0],\"i8\",we),He.__str84=_([114,83,0],\"i8\",we),He.__str85=_([62,62,61,0],\"i8\",we),He.__str86=_([114,109,0],\"i8\",we),He.__str87=_([37,0],\"i8\",we),He.__str88=_([114,115,0],\"i8\",we),He.__str89=_([62,62,0],\"i8\",we),He.__str90=_([115,116,0],\"i8\",we),He.__str91=_([115,105,122,101,111,102,32,0],\"i8\",we),He.__str92=_([115,122,0],\"i8\",we),ri=_([0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,8,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,6,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,3,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,5,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,3,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,3,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,3,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,3,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,7,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,7,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0],we),He.__str95=_([98,111,111,108,101,97,110,0],\"i8\",we),He.__str97=_([98,121,116,101,0],\"i8\",we),He.__str101=_([95,95,102,108,111,97,116,49,50,56,0],\"i8\",we),He.__str105=_([117,110,115,105,103,110,101,100,0],\"i8\",we),He.__str114=_([108,111,110,103,32,108,111,110,103,0],\"i8\",we),He.__str115=_([117,110,115,105,103,110,101,100,32,108,111,110,103,32,108,111,110,103,0],\"i8\",we),ai=_([0,0,0,0,11,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,7,0,0,0,7,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,0,0,0,0,6,0,0,0,0,0,0,0,6,0,0,0,8,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,11,0,0,0,8,0,0,0,0,0,0,0,5,0,0,0,0,0,0,0,5,0,0,0,8,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,10,0,0,0,8,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,0,0,0,0,3,0,0,0,0,0,0,0,3,0,0,0,1,0,0,0,0,0,0,0,12,0,0,0,0,0,0,0,8,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,4,0,0,0,3,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,13,0,0,0,4,0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,5,0,0,0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,4,0,0,0,9,0,0,0,0,0,0,0,7,0,0,0,0,0,0,0,4,0,0,0,0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,4,0,0,0,5,0,0,0,0,0,0,0,18,0,0,0,0,0,0,0,18,0,0,0,6,0,0,0,0,0,0,0,3,0,0,0,0,0,0,0,3,0,0,0,0,0,0,0],[\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0],we),He.__str117=_([95,71,76,79,66,65,76,95,0],\"i8\",we),He.__str118=_([103,108,111,98,97,108,32,99,111,110,115,116,114,117,99,116,111,114,115,32,107,101,121,101,100,32,116,111,32,0],\"i8\",we),He.__str119=_([103,108,111,98,97,108,32,100,101,115,116,114,117,99,116,111,114,115,32,107,101,121,101,100,32,116,111,32,0],\"i8\",we),He.__str120=_([58,58,0],\"i8\",we),He.__str121=_([118,116,97,98,108,101,32,102,111,114,32,0],\"i8\",we),He.__str122=_([86,84,84,32,102,111,114,32,0],\"i8\",we),He.__str123=_([99,111,110,115,116,114,117,99,116,105,111,110,32,118,116,97,98,108,101,32,102,111,114,32,0],\"i8\",we),He.__str124=_([45,105,110,45,0],\"i8\",we),He.__str125=_([116,121,112,101,105,110,102,111,32,102,111,114,32,0],\"i8\",we),He.__str126=_([116,121,112,101,105,110,102,111,32,110,97,109,101,32,102,111,114,32,0],\"i8\",we),He.__str127=_([116,121,112,101,105,110,102,111,32,102,110,32,102,111,114,32,0],\"i8\",we),He.__str128=_([110,111,110,45,118,105,114,116,117,97,108,32,116,104,117,110,107,32,116,111,32,0],\"i8\",we),He.__str129=_([118,105,114,116,117,97,108,32,116,104,117,110,107,32,116,111,32,0],\"i8\",we),He.__str130=_([99,111,118,97,114,105,97,110,116,32,114,101,116,117,114,110,32,116,104,117,110,107,32,116,111,32,0],\"i8\",we),He.__str131=_([106,97,118,97,32,67,108,97,115,115,32,102,111,114,32,0],\"i8\",we),He.__str132=_([103,117,97,114,100,32,118,97,114,105,97,98,108,101,32,102,111,114,32,0],\"i8\",we),He.__str133=_([114,101,102,101,114,101,110,99,101,32,116,101,109,112,111,114,97,114,121,32,102,111,114,32,0],\"i8\",we),He.__str134=_([104,105,100,100,101,110,32,97,108,105,97,115,32,102,111,114,32,0],\"i8\",we),He.__str135=_([58,58,42,0],\"i8\",we),He.__str136=_([44,32,0],\"i8\",we),He.__str137=_([111,112,101,114,97,116,111,114,0],\"i8\",we),He.__str139=_([41,32,0],\"i8\",we),He.__str140=_([32,40,0],\"i8\",we),He.__str141=_([41,32,58,32,40,0],\"i8\",we),He.__str142=_([117,108,0],\"i8\",we),He.__str143=_([108,108,0],\"i8\",we),He.__str144=_([117,108,108,0],\"i8\",we),He.__str145=_([102,97,108,115,101,0],\"i8\",we),He.__str146=_([116,114,117,101,0],\"i8\",we),He.__str147=_([32,114,101,115,116,114,105,99,116,0],\"i8\",we),He.__str148=_([32,118,111,108,97,116,105,108,101,0],\"i8\",we),He.__str149=_([32,99,111,110,115,116,0],\"i8\",we),He.__str150=_([99,111,109,112,108,101,120,32,0],\"i8\",we),He.__str151=_([105,109,97,103,105,110,97,114,121,32,0],\"i8\",we),ei=_([116,0,0,0,0,0,0,0,3,0,0,0,0,0,0,0,3,0,0,0,0,0,0,0,0,0,0,0,97,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,14,0,0,0,0,0,0,0,9,0,0,0,98,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,17,0,0,0,0,0,0,0,12,0,0,0,115,0,0,0,0,0,0,0,11,0,0,0,0,0,0,0,70,0,0,0,0,0,0,0,12,0,0,0,105,0,0,0,0,0,0,0,12,0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,13,0,0,0,111,0,0,0,0,0,0,0,12,0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,13,0,0,0,100,0,0,0,0,0,0,0,13,0,0,0,0,0,0,0,50,0,0,0,0,0,0,0,14,0,0,0],[\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i8\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0],we),He.__str152=_([115,116,100,0],\"i8\",we),He.__str153=_([115,116,100,58,58,97,108,108,111,99,97,116,111,114,0],\"i8\",we),He.__str154=_([97,108,108,111,99,97,116,111,114,0],\"i8\",we),He.__str155=_([115,116,100,58,58,98,97,115,105,99,95,115,116,114,105,110,103,0],\"i8\",we),He.__str156=_([98,97,115,105,99,95,115,116,114,105,110,103,0],\"i8\",we),He.__str157=_([115,116,100,58,58,115,116,114,105,110,103,0],\"i8\",we),He.__str158=_([115,116,100,58,58,98,97,115,105,99,95,115,116,114,105,110,103,60,99,104,97,114,44,32,115,116,100,58,58,99,104,97,114,95,116,114,97,105,116,115,60,99,104,97,114,62,44,32,115,116,100,58,58,97,108,108,111,99,97,116,111,114,60,99,104,97,114,62,32,62,0],\"i8\",we),He.__str159=_([115,116,100,58,58,105,115,116,114,101,97,109,0],\"i8\",we),He.__str160=_([115,116,100,58,58,98,97,115,105,99,95,105,115,116,114,101,97,109,60,99,104,97,114,44,32,115,116,100,58,58,99,104,97,114,95,116,114,97,105,116,115,60,99,104,97,114,62,32,62,0],\"i8\",we),He.__str161=_([98,97,115,105,99,95,105,115,116,114,101,97,109,0],\"i8\",we),He.__str162=_([115,116,100,58,58,111,115,116,114,101,97,109,0],\"i8\",we),He.__str163=_([115,116,100,58,58,98,97,115,105,99,95,111,115,116,114,101,97,109,60,99,104,97,114,44,32,115,116,100,58,58,99,104,97,114,95,116,114,97,105,116,115,60,99,104,97,114,62,32,62,0],\"i8\",we),He.__str164=_([98,97,115,105,99,95,111,115,116,114,101,97,109,0],\"i8\",we),He.__str165=_([115,116,100,58,58,105,111,115,116,114,101,97,109,0],\"i8\",we),He.__str166=_([115,116,100,58,58,98,97,115,105,99,95,105,111,115,116,114,101,97,109,60,99,104,97,114,44,32,115,116,100,58,58,99,104,97,114,95,116,114,97,105,116,115,60,99,104,97,114,62,32,62,0],\"i8\",we),He.__str167=_([98,97,115,105,99,95,105,111,115,116,114,101,97,109,0],\"i8\",we),He.__str168=_([115,116,114,105,110,103,32,108,105,116,101,114,97,108,0],\"i8\",we),He.__str169=_([40,97,110,111,110,121,109,111,117,115,32,110,97,109,101,115,112,97,99,101,41,0],\"i8\",we),He._symbol_demangle_dashed_null=_([45,45,110,117,108,108,45,45,0],\"i8\",we),He.__str170=_([37,115,37,115,0],\"i8\",we),He.__str1171=_([111,112,101,114,97,116,111,114,32,110,101,119,0],\"i8\",we),He.__str2172=_([111,112,101,114,97,116,111,114,32,100,101,108,101,116,101,0],\"i8\",we),He.__str3173=_([111,112,101,114,97,116,111,114,61,0],\"i8\",we),He.__str4174=_([111,112,101,114,97,116,111,114,62,62,0],\"i8\",we),He.__str5175=_([111,112,101,114,97,116,111,114,60,60,0],\"i8\",we),He.__str6176=_([111,112,101,114,97,116,111,114,33,0],\"i8\",we),He.__str7177=_([111,112,101,114,97,116,111,114,61,61,0],\"i8\",we),He.__str8178=_([111,112,101,114,97,116,111,114,33,61,0],\"i8\",we),He.__str9179=_([111,112,101,114,97,116,111,114,91,93,0],\"i8\",we),He.__str10180=_([111,112,101,114,97,116,111,114,32,0],\"i8\",we),He.__str11181=_([111,112,101,114,97,116,111,114,45,62,0],\"i8\",we),He.__str12182=_([111,112,101,114,97,116,111,114,42,0],\"i8\",we),He.__str13183=_([111,112,101,114,97,116,111,114,43,43,0],\"i8\",we),He.__str14184=_([111,112,101,114,97,116,111,114,45,45,0],\"i8\",we),He.__str15185=_([111,112,101,114,97,116,111,114,45,0],\"i8\",we),He.__str16186=_([111,112,101,114,97,116,111,114,43,0],\"i8\",we),He.__str17187=_([111,112,101,114,97,116,111,114,38,0],\"i8\",we),He.__str18188=_([111,112,101,114,97,116,111,114,45,62,42,0],\"i8\",we),He.__str19189=_([111,112,101,114,97,116,111,114,47,0],\"i8\",we),He.__str20190=_([111,112,101,114,97,116,111,114,37,0],\"i8\",we),He.__str21191=_([111,112,101,114,97,116,111,114,60,0],\"i8\",we),He.__str22192=_([111,112,101,114,97,116,111,114,60,61,0],\"i8\",we),He.__str23193=_([111,112,101,114,97,116,111,114,62,0],\"i8\",we),He.__str24194=_([111,112,101,114,97,116,111,114,62,61,0],\"i8\",we),He.__str25195=_([111,112,101,114,97,116,111,114,44,0],\"i8\",we),He.__str26196=_([111,112,101,114,97,116,111,114,40,41,0],\"i8\",we),He.__str27197=_([111,112,101,114,97,116,111,114,126,0],\"i8\",we),He.__str28198=_([111,112,101,114,97,116,111,114,94,0],\"i8\",we),He.__str29199=_([111,112,101,114,97,116,111,114,124,0],\"i8\",we),He.__str30200=_([111,112,101,114,97,116,111,114,38,38,0],\"i8\",we),He.__str31201=_([111,112,101,114,97,116,111,114,124,124,0],\"i8\",we),He.__str32202=_([111,112,101,114,97,116,111,114,42,61,0],\"i8\",we),He.__str33203=_([111,112,101,114,97,116,111,114,43,61,0],\"i8\",we),He.__str34204=_([111,112,101,114,97,116,111,114,45,61,0],\"i8\",we),He.__str35205=_([111,112,101,114,97,116,111,114,47,61,0],\"i8\",we),He.__str36206=_([111,112,101,114,97,116,111,114,37,61,0],\"i8\",we),He.__str37207=_([111,112,101,114,97,116,111,114,62,62,61,0],\"i8\",we),He.__str38208=_([111,112,101,114,97,116,111,114,60,60,61,0],\"i8\",we),He.__str39209=_([111,112,101,114,97,116,111,114,38,61,0],\"i8\",we),He.__str40210=_([111,112,101,114,97,116,111,114,124,61,0],\"i8\",we),He.__str41211=_([111,112,101,114,97,116,111,114,94,61,0],\"i8\",we),He.__str42212=_([96,118,102,116,97,98,108,101,39,0],\"i8\",we),He.__str43213=_([96,118,98,116,97,98,108,101,39,0],\"i8\",we),He.__str44214=_([96,118,99,97,108,108,39,0],\"i8\",we),He.__str45215=_([96,116,121,112,101,111,102,39,0],\"i8\",we),He.__str46216=_([96,108,111,99,97,108,32,115,116,97,116,105,99,32,103,117,97,114,100,39,0],\"i8\",we),He.__str47217=_([96,115,116,114,105,110,103,39,0],\"i8\",we),He.__str48218=_([96,118,98,97,115,101,32,100,101,115,116,114,117,99,116,111,114,39,0],\"i8\",we),He.__str49219=_([96,118,101,99,116,111,114,32,100,101,108,101,116,105,110,103,32,100,101,115,116,114,117,99,116,111,114,39,0],\"i8\",we),He.__str50220=_([96,100,101,102,97,117,108,116,32,99,111,110,115,116,114,117,99,116,111,114,32,99,108,111,115,117,114,101,39,0],\"i8\",we),He.__str51221=_([96,115,99,97,108,97,114,32,100,101,108,101,116,105,110,103,32,100,101,115,116,114,117,99,116,111,114,39,0],\"i8\",we),He.__str52222=_([96,118,101,99,116,111,114,32,99,111,110,115,116,114,117,99,116,111,114,32,105,116,101,114,97,116,111,114,39,0],\"i8\",we),He.__str53223=_([96,118,101,99,116,111,114,32,100,101,115,116,114,117,99,116,111,114,32,105,116,101,114,97,116,111,114,39,0],\"i8\",we),He.__str54224=_([96,118,101,99,116,111,114,32,118,98,97,115,101,32,99,111,110,115,116,114,117,99,116,111,114,32,105,116,101,114,97,116,111,114,39,0],\"i8\",we),He.__str55225=_([96,118,105,114,116,117,97,108,32,100,105,115,112,108,97,99,101,109,101,110,116,32,109,97,112,39,0],\"i8\",we),He.__str56226=_([96,101,104,32,118,101,99,116,111,114,32,99,111,110,115,116,114,117,99,116,111,114,32,105,116,101,114,97,116,111,114,39,0],\"i8\",we),He.__str57227=_([96,101,104,32,118,101,99,116,111,114,32,100,101,115,116,114,117,99,116,111,114,32,105,116,101,114,97,116,111,114,39,0],\"i8\",we),He.__str58228=_([96,101,104,32,118,101,99,116,111,114,32,118,98,97,115,101,32,99,111,110,115,116,114,117,99,116,111,114,32,105,116,101,114,97,116,111,114,39,0],\"i8\",we),He.__str59229=_([96,99,111,112,121,32,99,111,110,115,116,114,117,99,116,111,114,32,99,108,111,115,117,114,101,39,0],\"i8\",we),He.__str60230=_([37,115,37,115,32,96,82,84,84,73,32,84,121,112,101,32,68,101,115,99,114,105,112,116,111,114,39,0],\"i8\",we),He.__str61231=_([96,82,84,84,73,32,66,97,115,101,32,67,108,97,115,115,32,68,101,115,99,114,105,112,116,111,114,32,97,116,32,40,37,115,44,37,115,44,37,115,44,37,115,41,39,0],\"i8\",we),He.__str62232=_([96,82,84,84,73,32,66,97,115,101,32,67,108,97,115,115,32,65,114,114,97,121,39,0],\"i8\",we),He.__str63233=_([96,82,84,84,73,32,67,108,97,115,115,32,72,105,101,114,97,114,99,104,121,32,68,101,115,99,114,105,112,116,111,114,39,0],\"i8\",we),He.__str64234=_([96,82,84,84,73,32,67,111,109,112,108,101,116,101,32,79,98,106,101,99,116,32,76,111,99,97,116,111,114,39,0],\"i8\",we),He.__str65235=_([96,108,111,99,97,108,32,118,102,116,97,98,108,101,39,0],\"i8\",we),He.__str66236=_([96,108,111,99,97,108,32,118,102,116,97,98,108,101,32,99,111,110,115,116,114,117,99,116,111,114,32,99,108,111,115,117,114,101,39,0],\"i8\",we),He.__str67237=_([111,112,101,114,97,116,111,114,32,110,101,119,91,93,0],\"i8\",we),He.__str68238=_([111,112,101,114,97,116,111,114,32,100,101,108,101,116,101,91,93,0],\"i8\",we),He.__str69239=_([96,112,108,97,99,101,109,101,110,116,32,100,101,108,101,116,101,32,99,108,111,115,117,114,101,39,0],\"i8\",we),He.__str70240=_([96,112,108,97,99,101,109,101,110,116,32,100,101,108,101,116,101,91,93,32,99,108,111,115,117,114,101,39,0],\"i8\",we),He.__str71241=_([126,37,115,0],\"i8\",we),He.__str72242=_([117,110,100,110,97,109,101,46,99,0],\"i8\",we),He.___func___symbol_demangle=_([115,121,109,98,111,108,95,100,101,109,97,110,103,108,101,0],\"i8\",we),He.__str73243=_([115,121,109,45,62,114,101,115,117,108,116,0],\"i8\",we),He.___func___handle_template=_([104,97,110,100,108,101,95,116,101,109,112,108,97,116,101,0],\"i8\",we),He.__str74244=_([42,115,121,109,45,62,99,117,114,114,101,110,116,32,61,61,32,39,36,39,0],\"i8\",we),He.___func___str_array_get_ref=_([115,116,114,95,97,114,114,97,121,95,103,101,116,95,114,101,102,0],\"i8\",we),He.__str75245=_([99,114,101,102,0],\"i8\",we),He.__str76246=_([112,114,105,118,97,116,101,58,32,0],\"i8\",we),He.__str77247=_([112,114,111,116,101,99,116,101,100,58,32,0],\"i8\",we),He.__str78248=_([112,117,98,108,105,99,58,32,0],\"i8\",we),He.__str79249=_([115,116,97,116,105,99,32,0],\"i8\",we),He.__str80250=_([118,105,114,116,117,97,108,32,0],\"i8\",we),He.__str81251=_([91,116,104,117,110,107,93,58,37,115,0],\"i8\",we),He.__str82252=_([37,115,96,97,100,106,117,115,116,111,114,123,37,115,125,39,32,0],\"i8\",we),He.__str83253=_([37,115,32,37,115,0],\"i8\",we),He.__str84254=_([118,111,105,100,0],\"i8\",we),He.__str85255=_([37,115,37,115,37,115,0],\"i8\",we),He.__str86256=_([37,115,37,115,37,115,37,115,37,115,37,115,37,115,37,115,37,115,37,115,37,115,0],\"i8\",we),He.__str87257=_([32,0],\"i8\",we),He.__str88258=_([100,108,108,95,101,120,112,111,114,116,32,0],\"i8\",we),He.__str89259=_([99,100,101,99,108,0],\"i8\",we),He.__str90260=_([112,97,115,99,97,108,0],\"i8\",we),He.__str91261=_([116,104,105,115,99,97,108,108,0],\"i8\",we),He.__str92262=_([115,116,100,99,97,108,108,0],\"i8\",we),He.__str93263=_([102,97,115,116,99,97,108,108,0],\"i8\",we),He.__str94264=_([99,108,114,99,97,108,108,0],\"i8\",we),He.__str95265=_([95,95,100,108,108,95,101,120,112,111,114,116,32,0],\"i8\",we),He.__str96266=_([95,95,99,100,101,99,108,0],\"i8\",we),He.__str97267=_([95,95,112,97,115,99,97,108,0],\"i8\",we),He.__str98268=_([95,95,116,104,105,115,99,97,108,108,0],\"i8\",we),He.__str99269=_([95,95,115,116,100,99,97,108,108,0],\"i8\",we),He.__str100270=_([95,95,102,97,115,116,99,97,108,108,0],\"i8\",we),He.__str101271=_([95,95,99,108,114,99,97,108,108,0],\"i8\",we),He.__str102272=_([95,95,112,116,114,54,52,0],\"i8\",we),He.__str103273=_([99,111,110,115,116,0],\"i8\",we),He.__str104274=_([118,111,108,97,116,105,108,101,0],\"i8\",we),He.__str105275=_([99,111,110,115,116,32,118,111,108,97,116,105,108,101,0],\"i8\",we),He.___func___get_class_string=_([103,101,116,95,99,108,97,115,115,95,115,116,114,105,110,103,0],\"i8\",we),He.__str106276=_([97,45,62,101,108,116,115,91,105,93,0],\"i8\",we),He.__str107277=_([123,102,111,114,32,96,37,115,39,125,0],\"i8\",we),He.__str108278=_([37,115,37,115,37,115,37,115,37,115,37,115,37,115,37,115,0],\"i8\",we),He.__str109279=_([96,37,115,39,0],\"i8\",we),He.__str110280=_([46,46,46,0],\"i8\",we),He.__str111281=_([37,99,118,111,105,100,37,99,0],\"i8\",we),He.__str112282=_([37,115,44,37,115,0],\"i8\",we),He.__str113283=_([37,99,37,115,37,115,32,37,99,0],\"i8\",we),He.__str114284=_([37,99,37,115,37,115,37,99,0],\"i8\",we),He.___func___str_array_push=_([115,116,114,95,97,114,114,97,121,95,112,117,115,104,0],\"i8\",we),He.__str115285=_([112,116,114,0],\"i8\",we),He.__str116286=_([97,0],\"i8\",we),He.__str117287=_([97,45,62,101,108,116,115,91,97,45,62,110,117,109,93,0],\"i8\",we),He.__str118288=_([37,115,37,100,0],\"i8\",we),He.__str119289=_([45,0],\"i8\",we),ii=_(1,\"i8\",we),He.___func___demangle_datatype=_([100,101,109,97,110,103,108,101,95,100,97,116,97,116,121,112,101,0],\"i8\",we),He.__str121291=_([99,116,0],\"i8\",we),He.__str122292=_([117,110,105,111,110,32,0],\"i8\",we),He.__str123293=_([115,116,114,117,99,116,32,0],\"i8\",we),He.__str124294=_([99,108,97,115,115,32,0],\"i8\",we),He.__str125295=_([99,111,105,110,116,101,114,102,97,99,101,32,0],\"i8\",we),He.__str126296=_([96,116,101,109,112,108,97,116,101,45,112,97,114,97,109,101,116,101,114,45,37,115,39,0],\"i8\",we),He.__str127297=_([37,115,37,115,32,40,37,115,42,0],\"i8\",we),He.__str128298=_([41,37,115,0],\"i8\",we),He.__str129299=_([101,110,117,109,32,37,115,0],\"i8\",we),He.__str130300=_([96,116,101,109,112,108,97,116,101,45,112,97,114,97,109,101,116,101,114,37,115,39,0],\"i8\",we),He.__str131301=_([123,37,115,44,37,115,125,0],\"i8\",we),He.__str132302=_([123,37,115,44,37,115,44,37,115,125,0],\"i8\",we),He.__str133303=_([96,110,111,110,45,116,121,112,101,45,116,101,109,112,108,97,116,101,45,112,97,114,97,109,101,116,101,114,37,115,39,0],\"i8\",we),He.__str134304=_([32,95,95,112,116,114,54,52,0],\"i8\",we),He.__str135305=_([32,38,37,115,0],\"i8\",we),He.__str136306=_([32,38,37,115,32,118,111,108,97,116,105,108,101,0],\"i8\",we),He.__str137307=_([32,42,37,115,0],\"i8\",we),He.__str138308=_([32,42,37,115,32,99,111,110,115,116,0],\"i8\",we),He.__str139309=_([32,42,37,115,32,118,111,108,97,116,105,108,101,0],\"i8\",we),He.__str140310=_([32,42,37,115,32,99,111,110,115,116,32,118,111,108,97,116,105,108,101,0],\"i8\",we),He.__str141311=_([32,40,37,115,37,115,41,0],\"i8\",we),He.__str142312=_([32,40,37,115,41,0],\"i8\",we),He.__str143313=_([37,115,91,37,115,93,0],\"i8\",we),He.__str144314=_([37,115,32,37,115,37,115,0],\"i8\",we),He.__str145315=_([115,105,103,110,101,100,32,99,104,97,114,0],\"i8\",we),He.__str146316=_([99,104,97,114,0],\"i8\",we),He.__str147317=_([117,110,115,105,103,110,101,100,32,99,104,97,114,0],\"i8\",we),He.__str148318=_([115,104,111,114,116,0],\"i8\",we),He.__str149319=_([117,110,115,105,103,110,101,100,32,115,104,111,114,116,0],\"i8\",we),He.__str150320=_([105,110,116,0],\"i8\",we),He.__str151321=_([117,110,115,105,103,110,101,100,32,105,110,116,0],\"i8\",we),He.__str152322=_([108,111,110,103,0],\"i8\",we),He.__str153323=_([117,110,115,105,103,110,101,100,32,108,111,110,103,0],\"i8\",we),He.__str154324=_([102,108,111,97,116,0],\"i8\",we),He.__str155325=_([100,111,117,98,108,101,0],\"i8\",we),He.__str156326=_([108,111,110,103,32,100,111,117,98,108,101,0],\"i8\",we),He.__str157327=_([95,95,105,110,116,56,0],\"i8\",we),He.__str158328=_([117,110,115,105,103,110,101,100,32,95,95,105,110,116,56,0],\"i8\",we),He.__str159329=_([95,95,105,110,116,49,54,0],\"i8\",we),He.__str160330=_([117,110,115,105,103,110,101,100,32,95,95,105,110,116,49,54,0],\"i8\",we),He.__str161331=_([95,95,105,110,116,51,50,0],\"i8\",we),He.__str162332=_([117,110,115,105,103,110,101,100,32,95,95,105,110,116,51,50,0],\"i8\",we),He.__str163333=_([95,95,105,110,116,54,52,0],\"i8\",we),He.__str164334=_([117,110,115,105,103,110,101,100,32,95,95,105,110,116,54,52,0],\"i8\",we),\nHe.__str165335=_([95,95,105,110,116,49,50,56,0],\"i8\",we),He.__str166336=_([117,110,115,105,103,110,101,100,32,95,95,105,110,116,49,50,56,0],\"i8\",we),He.__str167337=_([98,111,111,108,0],\"i8\",we),He.__str168338=_([119,99,104,97,114,95,116,0],\"i8\",we),vi=_(468,[\"i32\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0,\"*\",0,0,0,\"i32\",0,0,0],we),ti=_(24,\"i32\",we),He.__str339=_([109,97,120,32,115,121,115,116,101,109,32,98,121,116,101,115,32,61,32,37,49,48,108,117,10,0],\"i8\",we),He.__str1340=_([115,121,115,116,101,109,32,98,121,116,101,115,32,32,32,32,32,61,32,37,49,48,108,117,10,0],\"i8\",we),He.__str2341=_([105,110,32,117,115,101,32,98,121,116,101,115,32,32,32,32,32,61,32,37,49,48,108,117,10,0],\"i8\",we),fi=_([ue],\"i8\",we),_i=_(1,\"void ()*\",we),si=_([0,0,0,0,0,0,0,0,6,0,0,0,8,0,0,0,10,0,0,0],[\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0],we),_(1,\"void*\",we),He.__str3342=_([115,116,100,58,58,98,97,100,95,97,108,108,111,99,0],\"i8\",we),ni=_([0,0,0,0,0,0,0,0,6,0,0,0,12,0,0,0,14,0,0,0],[\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0,\"*\",0,0,0],we),_(1,\"void*\",we),He.__str14343=_([98,97,100,95,97,114,114,97,121,95,110,101,119,95,108,101,110,103,116,104,0],\"i8\",we),He.__ZTSSt9bad_alloc=_([83,116,57,98,97,100,95,97,108,108,111,99,0],\"i8\",we),bi=_(12,\"*\",we),He.__ZTSSt20bad_array_new_length=_([83,116,50,48,98,97,100,95,97,114,114,97,121,95,110,101,119,95,108,101,110,103,116,104,0],\"i8\",we),ki=_(12,\"*\",we),Se[ri>>2]=0|He.__str,Se[ri+4>>2]=0|He.__str1,Se[ri+16>>2]=0|He.__str2,Se[ri+20>>2]=0|He.__str3,Se[ri+32>>2]=0|He.__str4,Se[ri+36>>2]=0|He.__str5,Se[ri+48>>2]=0|He.__str6,Se[ri+52>>2]=0|He.__str7,Se[ri+64>>2]=0|He.__str8,Se[ri+68>>2]=0|He.__str7,Se[ri+80>>2]=0|He.__str9,Se[ri+84>>2]=0|He.__str10,Se[ri+96>>2]=0|He.__str11,Se[ri+100>>2]=0|He.__str12,Se[ri+112>>2]=0|He.__str13,Se[ri+116>>2]=0|He.__str14,Se[ri+128>>2]=0|He.__str15,Se[ri+132>>2]=0|He.__str16,Se[ri+144>>2]=0|He.__str17,Se[ri+148>>2]=0|He.__str18,Se[ri+160>>2]=0|He.__str19,Se[ri+164>>2]=0|He.__str20,Se[ri+176>>2]=0|He.__str21,Se[ri+180>>2]=0|He.__str22,Se[ri+192>>2]=0|He.__str23,Se[ri+196>>2]=0|He.__str24,Se[ri+208>>2]=0|He.__str25,Se[ri+212>>2]=0|He.__str26,Se[ri+224>>2]=0|He.__str27,Se[ri+228>>2]=0|He.__str28,Se[ri+240>>2]=0|He.__str29,Se[ri+244>>2]=0|He.__str30,Se[ri+256>>2]=0|He.__str31,Se[ri+260>>2]=0|He.__str32,Se[ri+272>>2]=0|He.__str33,Se[ri+276>>2]=0|He.__str34,Se[ri+288>>2]=0|He.__str35,Se[ri+292>>2]=0|He.__str36,Se[ri+304>>2]=0|He.__str37,Se[ri+308>>2]=0|He.__str38,Se[ri+320>>2]=0|He.__str39,Se[ri+324>>2]=0|He.__str40,Se[ri+336>>2]=0|He.__str41,Se[ri+340>>2]=0|He.__str42,Se[ri+352>>2]=0|He.__str43,Se[ri+356>>2]=0|He.__str44,Se[ri+368>>2]=0|He.__str45,Se[ri+372>>2]=0|He.__str46,Se[ri+384>>2]=0|He.__str47,Se[ri+388>>2]=0|He.__str48,Se[ri+400>>2]=0|He.__str49,Se[ri+404>>2]=0|He.__str119289,Se[ri+416>>2]=0|He.__str51,Se[ri+420>>2]=0|He.__str20,Se[ri+432>>2]=0|He.__str52,Se[ri+436>>2]=0|He.__str53,Se[ri+448>>2]=0|He.__str54,Se[ri+452>>2]=0|He.__str55,Se[ri+464>>2]=0|He.__str56,Se[ri+468>>2]=0|He.__str57,Se[ri+480>>2]=0|He.__str58,Se[ri+484>>2]=0|He.__str119289,Se[ri+496>>2]=0|He.__str59,Se[ri+500>>2]=0|He.__str60,Se[ri+512>>2]=0|He.__str61,Se[ri+516>>2]=0|He.__str62,Se[ri+528>>2]=0|He.__str63,Se[ri+532>>2]=0|He.__str64,Se[ri+544>>2]=0|He.__str65,Se[ri+548>>2]=0|He.__str66,Se[ri+560>>2]=0|He.__str67,Se[ri+564>>2]=0|He.__str68,Se[ri+576>>2]=0|He.__str69,Se[ri+580>>2]=0|He.__str70,Se[ri+592>>2]=0|He.__str71,Se[ri+596>>2]=0|He.__str72,Se[ri+608>>2]=0|He.__str73,Se[ri+612>>2]=0|He.__str74,Se[ri+624>>2]=0|He.__str75,Se[ri+628>>2]=0|He.__str76,Se[ri+640>>2]=0|He.__str77,Se[ri+644>>2]=0|He.__str72,Se[ri+656>>2]=0|He.__str78,Se[ri+660>>2]=0|He.__str79,Se[ri+672>>2]=0|He.__str80,Se[ri+676>>2]=0|He.__str81,Se[ri+688>>2]=0|He.__str82,Se[ri+692>>2]=0|He.__str83,Se[ri+704>>2]=0|He.__str84,Se[ri+708>>2]=0|He.__str85,Se[ri+720>>2]=0|He.__str86,Se[ri+724>>2]=0|He.__str87,Se[ri+736>>2]=0|He.__str88,Se[ri+740>>2]=0|He.__str89,Se[ri+752>>2]=0|He.__str90,Se[ri+756>>2]=0|He.__str91,Se[ri+768>>2]=0|He.__str92,Se[ri+772>>2]=0|He.__str91,Se[ai>>2]=0|He.__str145315,Se[ai+8>>2]=0|He.__str145315,Se[ai+20>>2]=0|He.__str167337,Se[ai+28>>2]=0|He.__str95,Se[ai+40>>2]=0|He.__str146316,Se[ai+48>>2]=0|He.__str97,Se[ai+60>>2]=0|He.__str155325,Se[ai+68>>2]=0|He.__str155325,Se[ai+80>>2]=0|He.__str156326,Se[ai+88>>2]=0|He.__str156326,Se[ai+100>>2]=0|He.__str154324,Se[ai+108>>2]=0|He.__str154324,Se[ai+120>>2]=0|He.__str101,Se[ai+128>>2]=0|He.__str101,Se[ai+140>>2]=0|He.__str147317,Se[ai+148>>2]=0|He.__str147317,Se[ai+160>>2]=0|He.__str150320,Se[ai+168>>2]=0|He.__str150320,Se[ai+180>>2]=0|He.__str151321,Se[ai+188>>2]=0|He.__str105,Se[ai+220>>2]=0|He.__str152322,Se[ai+228>>2]=0|He.__str152322,Se[ai+240>>2]=0|He.__str153323,Se[ai+248>>2]=0|He.__str153323,Se[ai+260>>2]=0|He.__str165335,Se[ai+268>>2]=0|He.__str165335,Se[ai+280>>2]=0|He.__str166336,Se[ai+288>>2]=0|He.__str166336,Se[ai+360>>2]=0|He.__str148318,Se[ai+368>>2]=0|He.__str148318,Se[ai+380>>2]=0|He.__str149319,Se[ai+388>>2]=0|He.__str149319,Se[ai+420>>2]=0|He.__str84254,Se[ai+428>>2]=0|He.__str84254,Se[ai+440>>2]=0|He.__str168338,Se[ai+448>>2]=0|He.__str146316,Se[ai+460>>2]=0|He.__str114,Se[ai+468>>2]=0|He.__str152322,Se[ai+480>>2]=0|He.__str115,Se[ai+488>>2]=0|He.__str115,Se[ai+500>>2]=0|He.__str110280,Se[ai+508>>2]=0|He.__str110280,Se[ei+4>>2]=0|He.__str152,Se[ei+12>>2]=0|He.__str152,Se[ei+32>>2]=0|He.__str153,Se[ei+40>>2]=0|He.__str153,Se[ei+48>>2]=0|He.__str154,Se[ei+60>>2]=0|He.__str155,Se[ei+68>>2]=0|He.__str155,Se[ei+76>>2]=0|He.__str156,Se[ei+88>>2]=0|He.__str157,Se[ei+96>>2]=0|He.__str158,Se[ei+104>>2]=0|He.__str156,Se[ei+116>>2]=0|He.__str159,Se[ei+124>>2]=0|He.__str160,Se[ei+132>>2]=0|He.__str161,Se[ei+144>>2]=0|He.__str162,Se[ei+152>>2]=0|He.__str163,Se[ei+160>>2]=0|He.__str164,Se[ei+172>>2]=0|He.__str165,Se[ei+180>>2]=0|He.__str166,Se[ei+188>>2]=0|He.__str167,Se[si+4>>2]=bi,Se[ni+4>>2]=ki,oi=_([2,0,0,0,0],[\"i8*\",0,0,0,0],we),Se[bi>>2]=oi+8|0,Se[bi+4>>2]=0|He.__ZTSSt9bad_alloc,Se[bi+8>>2]=li,Se[ki>>2]=oi+8|0,Se[ki+4>>2]=0|He.__ZTSSt20bad_array_new_length,Se[ki+8>>2]=bi,ui=16,ci=6,hi=18,di=6,wi=6,pe=[0,0,Jr,0,va,0,ya,0,ga,0,wa,0,Sa,0,pa,0,Ea,0,ma,0],Module.FUNCTION_TABLE=pe,Module.run=ee,Module.preRun&&Module.preRun(),0==Ke){ee()}Module.postRun&&Module.postRun(),Module.___cxa_demangle=G;var pi=v(\"__cxa_demangle\",\"string\",[\"string\",\"string\",\"number\",\"number\"]);return function(r){return pi(r,\"\",1,0)}}();\n";
}, function (e, r, t) {
  "use strict";

  function n(e) {
    const r = [];
    return function e(t) {
      r.push({
        id: t.id,
        callFrame: {
          columnNumber: 0,
          functionName: t.functionName,
          lineNumber: t.lineNumber,
          scriptId: t.scriptId,
          url: t.url
        },
        hitCount: t.hitCount,
        children: t.children.map(e => e.id)
      }), t.children.forEach(e);
    }(e), r;
  }
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.chromeTreeToNodes = void 0, r.chromeTreeToNodes = function (e) {
    return {
      samples: e.samples,
      startTime: 1000000 * e.startTime,
      endTime: 1000000 * e.endTime,
      nodes: n(e.head),
      timeDeltas: (r = e.timestamps, t = e.startTime, r.map((e, n) => e - (0 === n ? 1000000 * t : r[n - 1])))
    };
    var r, t;
  };
}, function (e, r, t) {
  "use strict";

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.Flamechart = void 0;
  const n = t(53),
    a = t(190);
  r.Flamechart = class {
    constructor(e) {
      this.source = e, this.layers = [], this.totalWeight = 0, this.minFrameWidth = 1;
      const r = [];
      this.minFrameWidth = 1 / 0;
      this.totalWeight = e.getTotalWeight(), e.forEachCall((e, t) => {
        const a = n.lastOf(r),
          i = {
            node: e,
            parent: a,
            children: [],
            start: t,
            end: t
          };
        a && a.children.push(i), r.push(i);
      }, (e, t) => {
        console.assert(r.length > 0);
        const n = r.pop();
        if (n.end = t, n.end - n.start == 0) return;
        const a = r.length;
        for (; this.layers.length <= a;) this.layers.push([]);
        this.layers[a].push(n), this.minFrameWidth = Math.min(this.minFrameWidth, n.end - n.start);
      }), isFinite(this.minFrameWidth) || (this.minFrameWidth = 1);
    }
    getTotalWeight() {
      return this.totalWeight;
    }
    getLayers() {
      return this.layers;
    }
    getColorBucketForFrame(e) {
      return this.source.getColorBucketForFrame(e);
    }
    getMinFrameWidth() {
      return this.minFrameWidth;
    }
    formatValue(e) {
      return this.source.formatValue(e);
    }
    getClampedViewportWidth(e) {
      const r = this.getTotalWeight(),
        t = Math.pow(2, 40),
        n = a.clamp(3 * this.getMinFrameWidth(), r / t, r);
      return a.clamp(e, n, r);
    }
    getClampedConfigSpaceViewportRect({
      configSpaceViewportRect: e,
      renderInverted: r
    }) {
      const t = new a.Vec2(this.getTotalWeight(), this.getLayers().length),
        n = this.getClampedViewportWidth(e.size.x),
        i = e.size.withX(n),
        o = a.Vec2.clamp(e.origin, new a.Vec2(0, r ? 0 : -1), a.Vec2.max(a.Vec2.zero, t.minus(i).plus(new a.Vec2(0, 1))));
      return new a.Rect(o, e.size.withX(n));
    }
  };
}, function (e, r, t) {
  "use strict";

  function n(e, r, t) {
    return e < r ? r : e > t ? t : e;
  }
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.Rect = r.AffineTransform = r.Vec2 = r.clamp = void 0, r.clamp = n;
  let a = (() => {
    class e {
      constructor(e, r) {
        this.x = e, this.y = r;
      }
      withX(r) {
        return new e(r, this.y);
      }
      withY(r) {
        return new e(this.x, r);
      }
      plus(r) {
        return new e(this.x + r.x, this.y + r.y);
      }
      minus(r) {
        return new e(this.x - r.x, this.y - r.y);
      }
      times(r) {
        return new e(this.x * r, this.y * r);
      }
      timesPointwise(r) {
        return new e(this.x * r.x, this.y * r.y);
      }
      dividedByPointwise(r) {
        return new e(this.x / r.x, this.y / r.y);
      }
      dot(e) {
        return this.x * e.x + this.y * e.y;
      }
      equals(e) {
        return this.x === e.x && this.y === e.y;
      }
      approxEquals(e, r = 1e-9) {
        return Math.abs(this.x - e.x) < r && Math.abs(this.y - e.y) < r;
      }
      length2() {
        return this.dot(this);
      }
      length() {
        return Math.sqrt(this.length2());
      }
      abs() {
        return new e(Math.abs(this.x), Math.abs(this.y));
      }
      static min(r, t) {
        return new e(Math.min(r.x, t.x), Math.min(r.y, t.y));
      }
      static max(r, t) {
        return new e(Math.max(r.x, t.x), Math.max(r.y, t.y));
      }
      static clamp(r, t, a) {
        return new e(n(r.x, t.x, a.x), n(r.y, t.y, a.y));
      }
      flatten() {
        return [this.x, this.y];
      }
    }
    return e.zero = new e(0, 0), e.unit = new e(1, 1), e;
  })();
  r.Vec2 = a;
  class i {
    constructor(e = 1, r = 0, t = 0, n = 0, a = 1, i = 0) {
      this.m00 = e, this.m01 = r, this.m02 = t, this.m10 = n, this.m11 = a, this.m12 = i;
    }
    withScale(e) {
      let {
        m00: r,
        m01: t,
        m02: n,
        m10: a,
        m11: o,
        m12: s
      } = this;
      return r = e.x, o = e.y, new i(r, t, n, a, o, s);
    }
    static withScale(e) {
      return new i().withScale(e);
    }
    scaledBy(e) {
      return i.withScale(e).times(this);
    }
    getScale() {
      return new a(this.m00, this.m11);
    }
    withTranslation(e) {
      let {
        m00: r,
        m01: t,
        m02: n,
        m10: a,
        m11: o,
        m12: s
      } = this;
      return n = e.x, s = e.y, new i(r, t, n, a, o, s);
    }
    static withTranslation(e) {
      return new i().withTranslation(e);
    }
    getTranslation() {
      return new a(this.m02, this.m12);
    }
    translatedBy(e) {
      return i.withTranslation(e).times(this);
    }
    static betweenRects(e, r) {
      return i.withTranslation(e.origin.times(-1)).scaledBy(new a(r.size.x / e.size.x, r.size.y / e.size.y)).translatedBy(r.origin);
    }
    times(e) {
      const r = this.m00 * e.m00 + this.m01 * e.m10,
        t = this.m00 * e.m01 + this.m01 * e.m11,
        n = this.m00 * e.m02 + this.m01 * e.m12 + this.m02,
        a = this.m10 * e.m00 + this.m11 * e.m10,
        o = this.m10 * e.m01 + this.m11 * e.m11,
        s = this.m10 * e.m02 + this.m11 * e.m12 + this.m12;
      return new i(r, t, n, a, o, s);
    }
    equals(e) {
      return this.m00 == e.m00 && this.m01 == e.m01 && this.m02 == e.m02 && this.m10 == e.m10 && this.m11 == e.m11 && this.m12 == e.m12;
    }
    approxEquals(e, r = 1e-9) {
      return Math.abs(this.m00 - e.m00) < r && Math.abs(this.m01 - e.m01) < r && Math.abs(this.m02 - e.m02) < r && Math.abs(this.m10 - e.m10) < r && Math.abs(this.m11 - e.m11) < r && Math.abs(this.m12 - e.m12) < r;
    }
    timesScalar(e) {
      const {
        m00: r,
        m01: t,
        m02: n,
        m10: a,
        m11: o,
        m12: s
      } = this;
      return new i(e * r, e * t, e * n, e * a, e * o, e * s);
    }
    det() {
      const {
        m00: e,
        m01: r,
        m02: t,
        m10: n,
        m11: a,
        m12: i
      } = this;
      return e * (1 * a - 0 * i) - r * (1 * n - 0 * i) + t * (0 * n - 0 * a);
    }
    adj() {
      const {
        m00: e,
        m01: r,
        m02: t,
        m10: n,
        m11: a,
        m12: o
      } = this;
      return new i(+(1 * a - 0 * o), -(1 * r - 0 * t), +(r * o - t * a), -(1 * n - 0 * o), +(1 * e - 0 * t), -(e * o - t * n));
    }
    inverted() {
      const e = this.det();
      if (0 === e) return null;
      return this.adj().timesScalar(1 / e);
    }
    transformVector(e) {
      return new a(e.x * this.m00 + e.y * this.m01, e.x * this.m10 + e.y * this.m11);
    }
    inverseTransformVector(e) {
      const r = this.inverted();
      return r ? r.transformVector(e) : null;
    }
    transformPosition(e) {
      return new a(e.x * this.m00 + e.y * this.m01 + this.m02, e.x * this.m10 + e.y * this.m11 + this.m12);
    }
    inverseTransformPosition(e) {
      const r = this.inverted();
      return r ? r.transformPosition(e) : null;
    }
    transformRect(e) {
      const r = this.transformVector(e.size),
        t = this.transformPosition(e.origin);
      return r.x < 0 && r.y < 0 ? new o(t.plus(r), r.abs()) : r.x < 0 ? new o(t.withX(t.x + r.x), r.abs()) : r.y < 0 ? new o(t.withY(t.y + r.y), r.abs()) : new o(t, r);
    }
    inverseTransformRect(e) {
      const r = this.inverted();
      return r ? r.transformRect(e) : null;
    }
    flatten() {
      return [this.m00, this.m10, 0, this.m01, this.m11, 0, this.m02, this.m12, 1];
    }
  }
  r.AffineTransform = i;
  let o = (() => {
    class e {
      constructor(e, r) {
        this.origin = e, this.size = r;
      }
      isEmpty() {
        return 0 == this.width() || 0 == this.height();
      }
      width() {
        return this.size.x;
      }
      height() {
        return this.size.y;
      }
      left() {
        return this.origin.x;
      }
      right() {
        return this.left() + this.width();
      }
      top() {
        return this.origin.y;
      }
      bottom() {
        return this.top() + this.height();
      }
      topLeft() {
        return this.origin;
      }
      topRight() {
        return this.origin.plus(new a(this.width(), 0));
      }
      bottomRight() {
        return this.origin.plus(this.size);
      }
      bottomLeft() {
        return this.origin.plus(new a(0, this.height()));
      }
      withOrigin(r) {
        return new e(r, this.size);
      }
      withSize(r) {
        return new e(this.origin, r);
      }
      closestPointTo(e) {
        return new a(n(e.x, this.left(), this.right()), n(e.y, this.top(), this.bottom()));
      }
      distanceFrom(e) {
        return e.minus(this.closestPointTo(e)).length();
      }
      contains(e) {
        return 0 === this.distanceFrom(e);
      }
      hasIntersectionWith(e) {
        const r = Math.max(this.top(), e.top());
        if (Math.max(r, Math.min(this.bottom(), e.bottom())) - r == 0) return !1;
        const t = Math.max(this.left(), e.left());
        return Math.max(t, Math.min(this.right(), e.right())) - t != 0;
      }
      intersectWith(r) {
        const t = a.max(this.topLeft(), r.topLeft()),
          n = a.max(t, a.min(this.bottomRight(), r.bottomRight()));
        return new e(t, n.minus(t));
      }
      equals(e) {
        return this.origin.equals(e.origin) && this.size.equals(e.size);
      }
      approxEquals(e) {
        return this.origin.approxEquals(e.origin) && this.size.approxEquals(e.size);
      }
      area() {
        return this.size.x * this.size.y;
      }
    }
    return e.empty = new e(a.zero, a.zero), e.unit = new e(a.zero, a.unit), e.NDC = new e(new a(-1, -1), new a(2, 2)), e;
  })();
  r.Rect = o;
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Column___5Ol48 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0 1rem;\n}\n\n.Header___322Sm {\n  font-size: var(--font-size-sans-large);\n  margin-bottom: 0.5rem;\n}\n\n.Paragraph___22fN5 {\n  text-align: center;\n  margin: 0;\n}\n\n.Link___36nzP {\n  color: var(--color-link);\n}\n\n.LearnMoreRow___aWp1e {\n  margin-top: 1rem;\n  color: var(--color-dim);\n  font-size: var(--font-size-sans-small);\n}\n\n.Code___19uUo {\n  color: var(--color-bridge-version-number);\n}\n\n.MetaGKRow___1tKC1 {\n  background: var(--color-background-hover);\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  margin-top: 1rem;\n}", ""]), r.locals = {
    Column: "Column___5Ol48",
    Header: "Header___322Sm",
    Paragraph: "Paragraph___22fN5",
    Link: "Link___36nzP",
    LearnMoreRow: "LearnMoreRow___aWp1e",
    Code: "Code___19uUo",
    MetaGKRow: "MetaGKRow___1tKC1"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Content___2QeJf {\n  width: 100%;\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.Paragraph___svNsD {\n  text-align: center;\n}\n\n.ErrorMessage___1LWbq {\n  margin: 0.5rem 0;\n  color: var(--color-dim);\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n}\n\n.Row___1Veyi {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  flex-flow: wrap;\n}\n\n.EmptyStateContainer___2OQbO {\n  text-align: center;\n}\n\n.Header___2vzMq {\n  font-size: var(--font-size-sans-large);\n  margin-bottom: 0.5rem;\n}\n\n.WelcomeInstructionsList___2MNnw {\n}\n\n.WelcomeInstructionsListItem___3fOQr {\n  display: flex;\n  align-items: center;\n  line-height: 1.5rem;\n  counter-increment: li;\n}\n\n.WelcomeInstructionsListItem___3fOQr::before {\n  content: counter(li);\n  margin-right: 0.5rem;\n}\n\n.WelcomeInstructionsListItemLink___32D2G {\n  color: var(--color-link);\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n\n.ImportButtonLabel___1m4fC {\n  margin-left: 0.25rem;\n}", ""]), r.locals = {
    Content: "Content___2QeJf",
    Paragraph: "Paragraph___svNsD",
    ErrorMessage: "ErrorMessage___1LWbq",
    Row: "Row___1Veyi",
    EmptyStateContainer: "EmptyStateContainer___2OQbO",
    Header: "Header___2vzMq",
    WelcomeInstructionsList: "WelcomeInstructionsList___2MNnw",
    WelcomeInstructionsListItem: "WelcomeInstructionsListItem___3fOQr",
    WelcomeInstructionsListItemLink: "WelcomeInstructionsListItemLink___32D2G",
    ImportButtonLabel: "ImportButtonLabel___1m4fC"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Toolbar___1anMW {\n  height: 2.25rem;\n  padding: 0 0.5rem;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.Content___3KVRW {\n  padding: 0.5rem;\n  user-select: none;\n  overflow: auto;\n}\n\n.List___DLnbX {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.ListItem___3Uw7N {\n  flex: 1 1;\n  margin: 0 0 0.5rem;\n}\n\n.Label___9ImgF {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: bold;\n  flex: 1 1;\n}\n\n.Value___1E_uv {\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n}\n\n.Row___327lN {  \n  display: flex;  \n  flex-direction: row;  \n  align-items: center;\n  border-top: 1px solid var(--color-border);\n} \n\n.UnclickableSource___3Kp1w,\n.ClickableSource___1ExdQ {\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: var(--font-family-sans);\n  font-size: var(--font-size-sans-normal);\n}\n\n.UnclickableSource___3Kp1w {\n  color: var(--color-dim);\n}\n\n.ClickableSource___1ExdQ {\n  color: var(--color-text);\n}\n\n.ClickableSource___1ExdQ:focus,\n.ClickableSource___1ExdQ:hover {\n  background-color: var(--color-background-hover);\n}\n", ""]), r.locals = {
    Toolbar: "Toolbar___1anMW",
    Content: "Content___3KVRW",
    List: "List___DLnbX",
    ListItem: "ListItem___3Uw7N",
    Label: "Label___9ImgF",
    Value: "Value___1E_uv",
    Row: "Row___327lN",
    UnclickableSource: "UnclickableSource___3Kp1w",
    ClickableSource: "ClickableSource___1ExdQ"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".VRule___2XiHw {\n  height: 20px;\n  width: 1px;\n  border-left: 1px solid var(--color-border);\n  padding-left: 0.25rem;\n  margin-left: 0.25rem;\n}\n\n/**\n * https://developer.mozilla.org/en-US/docs/Web/API/File/Using_files_from_web_applications\n */\n.Input___2GKA7 {\n  position: absolute !important;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n  clip: rect(1px, 1px, 1px, 1px);\n}\n\n.ErrorMessage___3yR0b {\n  margin: 0.5rem 0;\n  color: var(--color-dim);\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n}\n", ""]), r.locals = {
    VRule: "VRule___2XiHw",
    Input: "Input___2GKA7",
    ErrorMessage: "ErrorMessage___3yR0b"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Outer___2YMUU {\n  user-select: none;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  padding-top: 4px;\n  padding-bottom: 1px;\n  display: flex;\n  align-items: flex-end;\n}\n.Outer___2YMUU:hover {\n  background-color: var(--color-background);\n}\n\n.Inner___TFCLU,\n.InnerSelected___2Qf2T {\n  width: 100%;\n  min-height: 2px;\n  background-color: var(--color-commit-did-not-render-fill);\n  color: var(--color-commit-did-not-render-fill-text);\n}\n\n.InnerSelected___2Qf2T {\n  background-color: var(--color-button-active);\n}", ""]), r.locals = {
    Outer: "Outer___2YMUU",
    Inner: "Inner___TFCLU",
    InnerSelected: "InnerSelected___2Qf2T"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".List___1_Mwa {\n  /**\n   * The decision to suppress the default (horizontal) scroll bars is intentional.\n   * The snapshot selector is small enough that the scrollbar renders it essentially useless.\n   * There are two alternative navigation mechanisms (arrow keys and arrow buttons).\n   * If necessary, we could also expand the click-and-drag mechanism to scroll.\n   */\n  overflow-x: hidden !important;\n}\n\n.Tooltip___2j_4b {\n  margin-top: 2.5rem;\n}\n\n.TooltipList___26ss7 {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.TooltipListItem___3xWli {\n  display: flex;\n}\n\n.TooltipLabel___2xbrN {\n  font-weight: bold;\n  margin-right: 0.25rem;\n}\n.TooltipLabel___2xbrN:after {\n  content: ':';\n}\n\n.TooltipValue___1nc1C {\n  flex-grow: 1;\n  text-align: end;\n}\n\n.DurationsWrapper___10A0R {\n  flex-grow: 1;\n}\n\n.DurationsList___NtAHH {\n  list-style: none;\n  margin: 0 0 0 1rem;\n  padding: 0;\n}\n\n.DurationsListItem___Q0jav {\n  display: flex;\n}\n\n.DurationsLabel___XxynS {\n  margin-right: 0.25rem;\n}\n.DurationsLabel___XxynS:after {\n  content: ':';\n}\n\n.DurationsValue___1FRM8 {\n  flex-grow: 1;\n  text-align: end;\n}", ""]), r.locals = {
    List: "List___1_Mwa",
    Tooltip: "Tooltip___2j_4b",
    TooltipList: "TooltipList___26ss7",
    TooltipListItem: "TooltipListItem___3xWli",
    TooltipLabel: "TooltipLabel___2xbrN",
    TooltipValue: "TooltipValue___1nc1C",
    DurationsWrapper: "DurationsWrapper___10A0R",
    DurationsList: "DurationsList___NtAHH",
    DurationsListItem: "DurationsListItem___Q0jav",
    DurationsLabel: "DurationsLabel___XxynS",
    DurationsValue: "DurationsValue___1FRM8"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Button___7tgtJ {\n  flex: 0 0 auto;\n  margin-left: 0.25rem;\n}\n\n.Commits___2KF5W {\n  height: 100%;\n  min-width: 30px;\n  margin-left: 0.25rem;\n  overflow: visible;\n}\n.Commits___2KF5W:focus {\n  outline: none;\n  background-color: var(--color-button-background-focus);\n}\n\n.IndexLabel___36CS7 {\n  flex: 0 0 auto;\n  white-space: nowrap;\n  font-family: var(--font-family-monospace);\n  margin-left: 0.25rem;\n}\n\n.NoCommits___3GzV1 {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-dim);\n}\n\n.Input___2QoRI {\n  background: none;\n  font-size: var(--font-size-sans-normal);\n  text-align: right;\n  font-family: var(--font-family-monospace);\n  border: 1px solid transparent;\n  border-radius: 0.125rem;\n  padding: 0.125rem;\n  color: var(--color-attribute-editable-value);\n}\n\n.Input___2QoRI:focus {\n  background-color: var(--color-button-background-focus);\n  outline: none;\n}\n", ""]), r.locals = {
    Button: "Button___7tgtJ",
    Commits: "Commits___2KF5W",
    IndexLabel: "IndexLabel___36CS7",
    NoCommits: "NoCommits___3GzV1",
    Input: "Input___2QoRI"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Updaters___ykaBk {\n  margin: 0 0 0.5rem;\n}\n\n.NoUpdaters___2ZO7w,\n.Updater___f5nQz,\n.UnmountedUpdater___2Smse {\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  padding: 0.25rem 0.5rem;\n  color: var(--color-text);\n}\n.Updater___f5nQz:focus,\n.Updater___f5nQz:hover {\n  outline: none;\n  background-color: var(--color-background-hover);\n}\n\n.NoUpdaters___2ZO7w,\n.UnmountedUpdater___2Smse {\n  color: var(--color-dim);\n}\n", ""]), r.locals = {
    Updaters: "Updaters___ykaBk",
    NoUpdaters: "NoUpdaters___2ZO7w",
    Updater: "Updater___f5nQz",
    UnmountedUpdater: "UnmountedUpdater___2Smse"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Toolbar___CuJgF {\n  height: 2.25rem;\n  padding: 0 0.5rem;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.Content___2tGS0 {\n  padding: 0.5rem;\n  user-select: none;\n  overflow: auto;\n}\n\n.List___2AC9R {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.ListItem___2wzT0 {\n  margin: 0 0 0.5rem;\n}\n\n.Label___3KINM {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: bold;\n}\n\n.Value___3wrFP {\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n}\n\n.NothingSelected___2Sj9L {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: var(--color-dim);\n}\n\n.DurationsList___19XUj {\n  list-style: none;\n  margin: 0.25rem 0 0 0;\n  padding: 0;\n  background: var(--color-background-inactive);\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n}\n\n.DurationsListItem___2UKVV {\n  margin: 0.25rem 0 0 0;\n}\n.DurationsListItem___2UKVV:first-of-type {\n  margin: 0;\n}\n", ""]), r.locals = {
    Toolbar: "Toolbar___CuJgF",
    Content: "Content___2tGS0",
    List: "List___2AC9R",
    ListItem: "ListItem___2wzT0",
    Label: "Label___3KINM",
    Value: "Value___3wrFP",
    NothingSelected: "NothingSelected___2Sj9L",
    DurationsList: "DurationsList___19XUj",
    DurationsListItem: "DurationsListItem___2UKVV"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Toolbar___2uBS2 {\n  height: 2.25rem;\n  padding: 0 0.5rem;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.Content___1WAA9 {\n  padding: 0.5rem;\n  user-select: none;\n  overflow-y: auto;\n}\n\n.WhatChanged___3T3Sx {\n  margin-bottom: 1rem;\n}\n\n.Component___1oc9o {\n  flex: 1;\n  color: var(--color-component-name);\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n.Label___buTyu {\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n}\n\n.CurrentCommit___2ZAl5,\n.Commit___2PAr5 {\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  padding: 0.25rem 0.5rem;\n  color: var(--color-text);\n}\n\n.Commit___2PAr5:focus,\n.Commit___2PAr5:hover {\n  outline: none;\n  background-color: var(--color-background-hover);\n}\n\n.CurrentCommit___2ZAl5 {\n  background-color: var(--color-background-selected);\n  color: var(--color-text-selected);\n}\n\n.CurrentCommit___2ZAl5:focus {\n  outline: none;\n}\n", ""]), r.locals = {
    Toolbar: "Toolbar___2uBS2",
    Content: "Content___1WAA9",
    WhatChanged: "WhatChanged___3T3Sx",
    Component: "Component___1oc9o",
    Label: "Label___buTyu",
    CurrentCommit: "CurrentCommit___2ZAl5",
    Commit: "Commit___2PAr5"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".ReactLogo___O8zf5 {\n  width: 1.75rem;\n  height: 1.75rem;\n  margin: 0 0.75rem 0 0.25rem;\n  color: var(--color-button-active);\n}\n", ""]), r.locals = {
    ReactLogo: "ReactLogo___O8zf5"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Column___3s3y6 { \n  display: flex;  \n  flex-direction: column; \n} \n\n.Title___2c8MM {  \n  font-size: var(--font-size-sans-large); \n  margin-bottom: 0.5rem;  \n} \n\n.ReleaseNotesLink___2PYAH { \n  color: var(--color-button-active);  \n}\n\n.Version___34HO3 {\n  color: var(--color-bridge-version-number);\n  font-weight: bold;\n}\n\n.NpmCommand___2lHg1 {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.25rem 0.25rem 0.25rem 0.5rem;\n  background-color: var(--color-bridge-version-npm-background);\n  color: var(--color-bridge-version-npm-text);\n  margin: 0;\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-large);\n}\n\n.Paragraph___3H72v {\n  margin: 0.5rem 0;\n}\n\n.Link___5TAEG {\n  color: var(--color-link);\n}", ""]), r.locals = {
    Column: "Column___3s3y6",
    Title: "Title___2c8MM",
    ReleaseNotesLink: "ReleaseNotesLink___2PYAH",
    Version: "Version___34HO3",
    NpmCommand: "NpmCommand___2lHg1",
    Paragraph: "Paragraph___3H72v",
    Link: "Link___5TAEG"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Row___3IwJ6 {  \n  display: flex;  \n  flex-direction: row;  \n  align-items: center;  \n} \n\n.Column___w9Fle { \n  display: flex;  \n  flex-direction: column; \n  align-items: center;  \n} \n\n.Title___1PTyg {  \n  font-size: var(--font-size-sans-large); \n  margin-bottom: 0.5rem;  \n} \n\n.ReleaseNotesLink___2_Y38 { \n  color: var(--color-button-active);  \n}", ""]), r.locals = {
    Row: "Row___3IwJ6",
    Column: "Column___w9Fle",
    Title: "Title___1PTyg",
    ReleaseNotesLink: "ReleaseNotesLink___2_Y38"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".Command___2iS3V {\n  background-color: var(--color-dimmest);\n  padding: 0.25rem 0.5rem;\n  display: block;\n  border-radius: 0.125rem;\n}\n", ""]), r.locals = {
    Command: "Command___2iS3V"
  };
}, function (e, r, t) {
  (r = e.exports = t(2)(!1)).push([e.i, ".DevTools___NAxvy {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--color-background);\n  color: var(--color-text);\n}\n\n.TabBar___2aDHU {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  padding: 0 0.5rem;\n  background-color: var(--color-background);\n  border-top: 1px solid var(--color-border);\n  font-family: var(--font-family-sans);\n  font-size: var(--font-size-sans-large);\n  user-select: none;\n\n  /* Electron drag area */\n  -webkit-app-region: drag;\n}\n\n.Spacer___1VPRF {\n  flex: 1;\n}\n\n.TabContent___27Qz1 {\n  flex: 1 1 100%;\n  overflow: auto;\n  -webkit-app-region: no-drag;\n}\n\n.DevToolsVersion___3_3UD {\n  font-size: var(--font-size-sans-normal);\n  margin-right: 0.5rem;\n}\n\n.DevToolsVersion___3_3UD:before {\n  font-size: var(--font-size-sans-large);\n  content: 'DevTools ';\n}\n\n@media screen and (max-width: 400px) {\n  .DevToolsVersion___3_3UD:before {\n    content: '';\n  }\n}\n\n@media screen and (max-width: 300px) {\n  .DevToolsVersion___3_3UD {\n    display: none;\n  }\n}\n\n.DevTools___NAxvy, .DevTools___NAxvy * {\n  box-sizing: border-box;\n  -webkit-font-smoothing: var(--font-smoothing);\n}\n", ""]), r.locals = {
    DevTools: "DevTools___NAxvy",
    TabBar: "TabBar___2aDHU",
    Spacer: "Spacer___1VPRF",
    TabContent: "TabContent___27Qz1",
    DevToolsVersion: "DevToolsVersion___3_3UD"
  };
}, function (e, r, t) {
  var n = t(207);
  "string" == typeof n && (n = [[e.i, n, ""]]);
  var a = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(3)(n, a);
  n.locals && (e.exports = n.locals);
}, function (e, r, t) {
  (e.exports = t(2)(!1)).push([e.i, ":root {\n  /* Font smoothing */\n  --font-smoothing: auto;\n\n  /* GitHub.com system fonts */\n  --font-family-monospace: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo,\n    Courier, monospace;\n  --font-family-sans: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica,\n    Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;\n}\n", ""]);
}, function (e, r, t) {
  "use strict";

  t.r(r);
  var n = {};
  t.r(n), t.d(n, "importFile", function () {
    return Bv;
  });
  var a = t(0),
    i = t(13),
    o = t(84);
  class s {
    constructor() {
      var e, r, t;
      e = this, r = "listenersMap", t = new Map(), r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t;
    }
    addListener(e, r) {
      const t = this.listenersMap.get(e);
      if (void 0 === t) this.listenersMap.set(e, [r]);else {
        t.indexOf(r) < 0 && t.push(r);
      }
    }
    emit(e, ...r) {
      const t = this.listenersMap.get(e);
      if (void 0 !== t) if (1 === t.length) {
        t[0].apply(null, r);
      } else {
        let e = !1,
          n = null;
        const a = Array.from(t);
        for (let t = 0; t < a.length; t++) {
          const i = a[t];
          try {
            i.apply(null, r);
          } catch (r) {
            null === n && (e = !0, n = r);
          }
        }
        if (e) throw n;
      }
    }
    removeAllListeners() {
      this.listenersMap.clear();
    }
    removeListener(e, r) {
      const t = this.listenersMap.get(e);
      if (void 0 !== t) {
        const e = t.indexOf(r);
        e >= 0 && t.splice(e, 1);
      }
    }
  }
  function l(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  const c = [{
      version: 0,
      minNpmVersion: "\"<4.11.0\"",
      maxNpmVersion: "\"<4.11.0\""
    }, {
      version: 1,
      minNpmVersion: "4.13.0",
      maxNpmVersion: "4.21.0"
    }, {
      version: 2,
      minNpmVersion: "4.22.0",
      maxNpmVersion: null
    }],
    u = c[c.length - 1];
  var f = class extends s {
      constructor(e) {
        super(), l(this, "_isShutdown", !1), l(this, "_messageQueue", []), l(this, "_timeoutID", null), l(this, "_wallUnlisten", null), l(this, "_flush", () => {
          if (null !== this._timeoutID && (clearTimeout(this._timeoutID), this._timeoutID = null), this._messageQueue.length) {
            for (let e = 0; e < this._messageQueue.length; e += 2) this._wall.send(this._messageQueue[e], ...this._messageQueue[e + 1]);
            this._messageQueue.length = 0, this._timeoutID = setTimeout(this._flush, 100);
          }
        }), l(this, "overrideValueAtPath", ({
          id: e,
          path: r,
          rendererID: t,
          type: n,
          value: a
        }) => {
          switch (n) {
            case "context":
              this.send("overrideContext", {
                id: e,
                path: r,
                rendererID: t,
                wasForwarded: !0,
                value: a
              });
              break;
            case "hooks":
              this.send("overrideHookState", {
                id: e,
                path: r,
                rendererID: t,
                wasForwarded: !0,
                value: a
              });
              break;
            case "props":
              this.send("overrideProps", {
                id: e,
                path: r,
                rendererID: t,
                wasForwarded: !0,
                value: a
              });
              break;
            case "state":
              this.send("overrideState", {
                id: e,
                path: r,
                rendererID: t,
                wasForwarded: !0,
                value: a
              });
          }
        }), this._wall = e, this._wallUnlisten = e.listen(e => {
          e && e.event && this.emit(e.event, e.payload);
        }) || null, this.addListener("overrideValueAtPath", this.overrideValueAtPath);
      }
      get wall() {
        return this._wall;
      }
      send(e, ...r) {
        this._isShutdown ? console.warn(`Cannot send message "${e}" through a Bridge that has been shutdown.`) : (this._messageQueue.push(e, r), this._timeoutID || (this._timeoutID = setTimeout(this._flush, 0)));
      }
      shutdown() {
        if (this._isShutdown) return void console.warn("Bridge was already shutdown.");
        this.send("shutdown"), this._isShutdown = !0, this.addListener = function () {}, this.emit = function () {}, this.removeAllListeners();
        const e = this._wallUnlisten;
        e && e();
        do {
          this._flush();
        } while (this._messageQueue.length);
        null !== this._timeoutID && (clearTimeout(this._timeoutID), this._timeoutID = null);
      }
    },
    d = t(85),
    v = t(1);
  var h = t(54),
    m = t.n(h),
    _ = t(23);
  Symbol.for("react.element"), Symbol.for("react.portal"), Symbol.for("react.fragment"), Symbol.for("react.strict_mode"), Symbol.for("react.profiler"), Symbol.for("react.provider"), Symbol.for("react.context"), Symbol.for("react.server_context"), Symbol.for("react.forward_ref"), Symbol.for("react.suspense");
  const p = Symbol.for("react.suspense_list"),
    g = (Symbol.for("react.memo"), Symbol.for("react.lazy"), Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode"), Symbol.for("react.offscreen"), Symbol.for("react.legacy_hidden"), Symbol.for("react.cache"), Symbol.for("react.tracing_marker"));
  Symbol.for("react.default_value"), Symbol.for("react.memo_cache_sentinel"), Symbol.iterator;
  function b(e) {
    try {
      return localStorage.getItem(e);
    } catch (e) {
      return null;
    }
  }
  function S(e, r) {
    try {
      return localStorage.setItem(e, r);
    } catch (e) {}
  }
  const E = {
    inspectable: Symbol("inspectable"),
    inspected: Symbol("inspected"),
    name: Symbol("name"),
    preview_long: Symbol("preview_long"),
    preview_short: Symbol("preview_short"),
    readonly: Symbol("readonly"),
    size: Symbol("size"),
    type: Symbol("type"),
    unserializable: Symbol("unserializable")
  };
  function w(e, r, t, n) {
    const a = z(e, t);
    if (null != a && (a[E.unserializable] || (delete a[E.inspectable], delete a[E.inspected], delete a[E.name], delete a[E.preview_long], delete a[E.preview_short], delete a[E.readonly], delete a[E.size], delete a[E.type])), null !== n && r.unserializable.length > 0) {
      const e = r.unserializable[0];
      let a = e.length === t.length;
      for (let r = 0; r < t.length; r++) if (t[r] !== e[r]) {
        a = !1;
        break;
      }
      a && k(n, n);
    }
    B(e, t, n);
  }
  function y(e, r, t) {
    return r.forEach(r => {
      const t = r.length,
        n = r[t - 1],
        a = z(e, r.slice(0, t - 1));
      if (!a || !a.hasOwnProperty(n)) return;
      const i = a[n];
      if (i) if ("infinity" === i.type) a[n] = 1 / 0;else if ("nan" === i.type) a[n] = NaN;else if ("undefined" === i.type) a[n] = void 0;else {
        const e = {};
        e[E.inspectable] = !!i.inspectable, e[E.inspected] = !1, e[E.name] = i.name, e[E.preview_long] = i.preview_long, e[E.preview_short] = i.preview_short, e[E.size] = i.size, e[E.readonly] = !!i.readonly, e[E.type] = i.type, a[n] = e;
      }
    }), t.forEach(r => {
      const t = r.length,
        n = r[t - 1],
        a = z(e, r.slice(0, t - 1));
      if (!a || !a.hasOwnProperty(n)) return;
      const i = a[n],
        o = {
          ...i
        };
      k(o, i), a[n] = o;
    }), e;
  }
  function k(e, r) {
    Object.defineProperties(e, {
      [E.inspected]: {
        configurable: !0,
        enumerable: !1,
        value: !!r.inspected
      },
      [E.name]: {
        configurable: !0,
        enumerable: !1,
        value: r.name
      },
      [E.preview_long]: {
        configurable: !0,
        enumerable: !1,
        value: r.preview_long
      },
      [E.preview_short]: {
        configurable: !0,
        enumerable: !1,
        value: r.preview_short
      },
      [E.size]: {
        configurable: !0,
        enumerable: !1,
        value: r.size
      },
      [E.readonly]: {
        configurable: !0,
        enumerable: !1,
        value: !!r.readonly
      },
      [E.type]: {
        configurable: !0,
        enumerable: !1,
        value: r.type
      },
      [E.unserializable]: {
        configurable: !0,
        enumerable: !1,
        value: !!r.unserializable
      }
    }), delete e.inspected, delete e.name, delete e.preview_long, delete e.preview_short, delete e.size, delete e.readonly, delete e.type, delete e.unserializable;
  }
  var C = Array.isArray;
  const D = Object.prototype.hasOwnProperty,
    A = new WeakMap();
  new m.a({
    max: 1000
  });
  function M(e, r) {
    return e.toString() > r.toString() ? 1 : r.toString() > e.toString() ? -1 : 0;
  }
  function x(e) {
    const r = new Set();
    let t = e;
    for (; null != t;) {
      const e = [...Object.keys(t), ...Object.getOwnPropertySymbols(t)],
        n = Object.getOwnPropertyDescriptors(t);
      e.forEach(e => {
        n[e].enumerable && r.add(e);
      }), t = Object.getPrototypeOf(t);
    }
    return r;
  }
  function O(e, r, t, n) {
    return e.displayName || `${t}(${T(r, n)})`;
  }
  function T(e, r = "Anonymous") {
    const t = A.get(e);
    if (null != t) return t;
    let n = r;
    return "string" == typeof e.displayName ? n = e.displayName : "string" == typeof e.name && "" !== e.name && (n = e.name), A.set(e, n), n;
  }
  function N(e) {
    let r = "";
    for (let t = 0; t < e.length; t++) {
      const n = e[t];
      r += String.fromCodePoint(n);
    }
    return r;
  }
  function R() {
    try {
      const e = b(v.h);
      if (null != e) return JSON.parse(e);
    } catch (e) {}
    return [{
      type: 1,
      value: 7,
      isEnabled: !0
    }];
  }
  function I(e) {
    S(v.h, JSON.stringify(e));
  }
  function H(e) {
    return "true" === e || "false" !== e && void 0;
  }
  function F(e) {
    if (!0 === e || !1 === e) return e;
  }
  function L(e, r) {
    if (null === e) return [null, null];
    let t = null;
    switch (r) {
      case 1:
      case 6:
      case 5:
      case 8:
        if (e.indexOf("(") >= 0) {
          const r = e.match(/[^()]+/g);
          null != r && (e = r.pop(), t = r);
        }
    }
    return [e, t];
  }
  function P(e, r) {
    for (const t in e) if (!(t in r)) return !0;
    for (const t in r) if (e[t] !== r[t]) return !0;
    return !1;
  }
  function z(e, r) {
    return r.reduce((e, r) => {
      if (e) {
        if (D.call(e, r)) return e[r];
        if ("function" == typeof e[Symbol.iterator]) return Array.from(e)[r];
      }
      return null;
    }, e);
  }
  function B(e, r, t) {
    const n = r.length,
      a = r[n - 1];
    if (null != e) {
      const i = z(e, r.slice(0, n - 1));
      i && (i[a] = t);
    }
  }
  function j(e) {
    if (null === e) return "null";
    if (void 0 === e) return "undefined";
    if (Object(_.isElement)(e)) return "react_element";
    if ("undefined" != typeof HTMLElement && e instanceof HTMLElement) return "html_element";
    switch (typeof e) {
      case "bigint":
        return "bigint";
      case "boolean":
        return "boolean";
      case "function":
        return "function";
      case "number":
        return Number.isNaN(e) ? "nan" : Number.isFinite(e) ? "number" : "infinity";
      case "object":
        if (C(e)) return "array";
        if (ArrayBuffer.isView(e)) return D.call(e.constructor, "BYTES_PER_ELEMENT") ? "typed_array" : "data_view";
        if (e.constructor && "ArrayBuffer" === e.constructor.name) return "array_buffer";
        if ("function" == typeof e[Symbol.iterator]) {
          const r = e[Symbol.iterator]();
          if (r) return r === e ? "opaque_iterator" : "iterator";
        } else {
          if (e.constructor && "RegExp" === e.constructor.name) return "regexp";
          {
            const r = Object.prototype.toString.call(e);
            if ("[object Date]" === r) return "date";
            if ("[object HTMLAllCollection]" === r) return "html_all_collection";
          }
        }
        return "object";
      case "string":
        return "string";
      case "symbol":
        return "symbol";
      case "undefined":
        return "[object HTMLAllCollection]" === Object.prototype.toString.call(e) ? "html_all_collection" : "undefined";
      default:
        return "unknown";
    }
  }
  function V(e) {
    switch (Object(_.typeOf)(e)) {
      case _.ContextConsumer:
        return "ContextConsumer";
      case _.ContextProvider:
        return "ContextProvider";
      case _.ForwardRef:
        return "ForwardRef";
      case _.Fragment:
        return "Fragment";
      case _.Lazy:
        return "Lazy";
      case _.Memo:
        return "Memo";
      case _.Portal:
        return "Portal";
      case _.Profiler:
        return "Profiler";
      case _.StrictMode:
        return "StrictMode";
      case _.Suspense:
        return "Suspense";
      case p:
        return "SuspenseList";
      case g:
        return "TracingMarker";
      default:
        const {
          type: r
        } = e;
        return "string" == typeof r ? r : "function" == typeof r ? T(r, "Anonymous") : null != r ? "NotImplementedInDevtools" : "Element";
    }
  }
  function U(e, r = 50) {
    return e.length > r ? e.substr(0, r) + "\u2026" : e;
  }
  function W(e, r) {
    if (null != e && D.call(e, E.type)) return r ? e[E.preview_long] : e[E.preview_short];
    switch (j(e)) {
      case "html_element":
        return `<${U(e.tagName.toLowerCase())} />`;
      case "function":
        return U(`ƒ ${"function" == typeof e.name ? "" : e.name}() {}`);
      case "string":
        return `"${e}"`;
      case "bigint":
        return U(e.toString() + "n");
      case "regexp":
      case "symbol":
        return U(e.toString());
      case "react_element":
        return `<${U(V(e) || "Unknown")} />`;
      case "array_buffer":
        return `ArrayBuffer(${e.byteLength})`;
      case "data_view":
        return `DataView(${e.buffer.byteLength})`;
      case "array":
        if (r) {
          let r = "";
          for (let t = 0; t < e.length && (t > 0 && (r += ", "), r += W(e[t], !1), !(r.length > 50)); t++);
          return `[${U(r)}]`;
        }
        return `Array(${D.call(e, E.size) ? e[E.size] : e.length})`;
      case "typed_array":
        const t = `${e.constructor.name}(${e.length})`;
        if (r) {
          let r = "";
          for (let t = 0; t < e.length && (t > 0 && (r += ", "), r += e[t], !(r.length > 50)); t++);
          return `${t} [${U(r)}]`;
        }
        return t;
      case "iterator":
        const n = e.constructor.name;
        if (r) {
          const r = Array.from(e);
          let t = "";
          for (let e = 0; e < r.length; e++) {
            const n = r[e];
            if (e > 0 && (t += ", "), C(n)) {
              t += `${W(n[0], !0)} => ${W(n[1], !1)}`;
            } else t += W(n, !1);
            if (t.length > 50) break;
          }
          return `${n}(${e.size}) {${U(t)}}`;
        }
        return `${n}(${e.size})`;
      case "opaque_iterator":
        return e[Symbol.toStringTag];
      case "date":
        return e.toString();
      case "object":
        if (r) {
          const r = Array.from(x(e)).sort(M);
          let t = "";
          for (let n = 0; n < r.length; n++) {
            const a = r[n];
            if (n > 0 && (t += ", "), t += `${a.toString()}: ${W(e[a], !1)}`, t.length > 50) break;
          }
          return `{${U(t)}}`;
        }
        return "{\u2026}";
      case "boolean":
      case "number":
      case "infinity":
      case "nan":
      case "null":
      case "undefined":
        return e;
      default:
        try {
          return U(String(e));
        } catch (e) {
          return "unserializable";
        }
    }
  }
  var $ = {
      Space_Separator: /[\u1680\u2000-\u200A\u202F\u205F\u3000]/,
      ID_Start: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]/,
      ID_Continue: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF9\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDE00-\uDE3E\uDE47\uDE50-\uDE83\uDE86-\uDE99\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
    },
    X = {
      isSpaceSeparator: e => "string" == typeof e && $.Space_Separator.test(e),
      isIdStartChar: e => "string" == typeof e && (e >= "a" && e <= "z" || e >= "A" && e <= "Z" || "$" === e || "_" === e || $.ID_Start.test(e)),
      isIdContinueChar: e => "string" == typeof e && (e >= "a" && e <= "z" || e >= "A" && e <= "Z" || e >= "0" && e <= "9" || "$" === e || "_" === e || "\u200C" === e || "\u200D" === e || $.ID_Continue.test(e)),
      isDigit: e => "string" == typeof e && /[0-9]/.test(e),
      isHexDigit: e => "string" == typeof e && /[0-9A-Fa-f]/.test(e)
    };
  let G, K, Y, q, Q, Z, J, ee, re;
  let te, ne, ae, ie, oe;
  function se() {
    for (te = "default", ne = "", ae = !1, ie = 1;;) {
      oe = le();
      const e = ue[te]();
      if (e) return e;
    }
  }
  function le() {
    if (G[q]) return String.fromCodePoint(G.codePointAt(q));
  }
  function ce() {
    const e = le();
    return "\n" === e ? (Q++, Z = 0) : e ? Z += e.length : Z++, e && (q += e.length), e;
  }
  const ue = {
    default() {
      switch (oe) {
        case "\t":
        case "\x0B":
        case "\f":
        case " ":
        case "\xA0":
        case "\uFEFF":
        case "\n":
        case "\r":
        case "\u2028":
        case "\u2029":
          return void ce();
        case "/":
          return ce(), void (te = "comment");
        case void 0:
          return ce(), fe("eof");
      }
      if (!X.isSpaceSeparator(oe)) return ue[K]();
      ce();
    },
    comment() {
      switch (oe) {
        case "*":
          return ce(), void (te = "multiLineComment");
        case "/":
          return ce(), void (te = "singleLineComment");
      }
      throw pe(ce());
    },
    multiLineComment() {
      switch (oe) {
        case "*":
          return ce(), void (te = "multiLineCommentAsterisk");
        case void 0:
          throw pe(ce());
      }
      ce();
    },
    multiLineCommentAsterisk() {
      switch (oe) {
        case "*":
          return void ce();
        case "/":
          return ce(), void (te = "default");
        case void 0:
          throw pe(ce());
      }
      ce(), te = "multiLineComment";
    },
    singleLineComment() {
      switch (oe) {
        case "\n":
        case "\r":
        case "\u2028":
        case "\u2029":
          return ce(), void (te = "default");
        case void 0:
          return ce(), fe("eof");
      }
      ce();
    },
    value() {
      switch (oe) {
        case "{":
        case "[":
          return fe("punctuator", ce());
        case "n":
          return ce(), de("ull"), fe("null", null);
        case "t":
          return ce(), de("rue"), fe("boolean", !0);
        case "f":
          return ce(), de("alse"), fe("boolean", !1);
        case "-":
        case "+":
          return "-" === ce() && (ie = -1), void (te = "sign");
        case ".":
          return ne = ce(), void (te = "decimalPointLeading");
        case "0":
          return ne = ce(), void (te = "zero");
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
          return ne = ce(), void (te = "decimalInteger");
        case "I":
          return ce(), de("nfinity"), fe("numeric", 1 / 0);
        case "N":
          return ce(), de("aN"), fe("numeric", NaN);
        case "\"":
        case "'":
          return ae = "\"" === ce(), ne = "", void (te = "string");
      }
      throw pe(ce());
    },
    identifierNameStartEscape() {
      if ("u" !== oe) throw pe(ce());
      ce();
      const e = ve();
      switch (e) {
        case "$":
        case "_":
          break;
        default:
          if (!X.isIdStartChar(e)) throw be();
      }
      ne += e, te = "identifierName";
    },
    identifierName() {
      switch (oe) {
        case "$":
        case "_":
        case "\u200C":
        case "\u200D":
          return void (ne += ce());
        case "\\":
          return ce(), void (te = "identifierNameEscape");
      }
      if (!X.isIdContinueChar(oe)) return fe("identifier", ne);
      ne += ce();
    },
    identifierNameEscape() {
      if ("u" !== oe) throw pe(ce());
      ce();
      const e = ve();
      switch (e) {
        case "$":
        case "_":
        case "\u200C":
        case "\u200D":
          break;
        default:
          if (!X.isIdContinueChar(e)) throw be();
      }
      ne += e, te = "identifierName";
    },
    sign() {
      switch (oe) {
        case ".":
          return ne = ce(), void (te = "decimalPointLeading");
        case "0":
          return ne = ce(), void (te = "zero");
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
          return ne = ce(), void (te = "decimalInteger");
        case "I":
          return ce(), de("nfinity"), fe("numeric", ie * (1 / 0));
        case "N":
          return ce(), de("aN"), fe("numeric", NaN);
      }
      throw pe(ce());
    },
    zero() {
      switch (oe) {
        case ".":
          return ne += ce(), void (te = "decimalPoint");
        case "e":
        case "E":
          return ne += ce(), void (te = "decimalExponent");
        case "x":
        case "X":
          return ne += ce(), void (te = "hexadecimal");
      }
      return fe("numeric", 0 * ie);
    },
    decimalInteger() {
      switch (oe) {
        case ".":
          return ne += ce(), void (te = "decimalPoint");
        case "e":
        case "E":
          return ne += ce(), void (te = "decimalExponent");
      }
      if (!X.isDigit(oe)) return fe("numeric", ie * Number(ne));
      ne += ce();
    },
    decimalPointLeading() {
      if (X.isDigit(oe)) return ne += ce(), void (te = "decimalFraction");
      throw pe(ce());
    },
    decimalPoint() {
      switch (oe) {
        case "e":
        case "E":
          return ne += ce(), void (te = "decimalExponent");
      }
      return X.isDigit(oe) ? (ne += ce(), void (te = "decimalFraction")) : fe("numeric", ie * Number(ne));
    },
    decimalFraction() {
      switch (oe) {
        case "e":
        case "E":
          return ne += ce(), void (te = "decimalExponent");
      }
      if (!X.isDigit(oe)) return fe("numeric", ie * Number(ne));
      ne += ce();
    },
    decimalExponent() {
      switch (oe) {
        case "+":
        case "-":
          return ne += ce(), void (te = "decimalExponentSign");
      }
      if (X.isDigit(oe)) return ne += ce(), void (te = "decimalExponentInteger");
      throw pe(ce());
    },
    decimalExponentSign() {
      if (X.isDigit(oe)) return ne += ce(), void (te = "decimalExponentInteger");
      throw pe(ce());
    },
    decimalExponentInteger() {
      if (!X.isDigit(oe)) return fe("numeric", ie * Number(ne));
      ne += ce();
    },
    hexadecimal() {
      if (X.isHexDigit(oe)) return ne += ce(), void (te = "hexadecimalInteger");
      throw pe(ce());
    },
    hexadecimalInteger() {
      if (!X.isHexDigit(oe)) return fe("numeric", ie * Number(ne));
      ne += ce();
    },
    string() {
      switch (oe) {
        case "\\":
          return ce(), void (ne += function () {
            switch (le()) {
              case "b":
                return ce(), "\b";
              case "f":
                return ce(), "\f";
              case "n":
                return ce(), "\n";
              case "r":
                return ce(), "\r";
              case "t":
                return ce(), "\t";
              case "v":
                return ce(), "\x0B";
              case "0":
                if (ce(), X.isDigit(le())) throw pe(ce());
                return "\0";
              case "x":
                return ce(), function () {
                  let e = "",
                    r = le();
                  if (!X.isHexDigit(r)) throw pe(ce());
                  if (e += ce(), r = le(), !X.isHexDigit(r)) throw pe(ce());
                  return e += ce(), String.fromCodePoint(parseInt(e, 16));
                }();
              case "u":
                return ce(), ve();
              case "\n":
              case "\u2028":
              case "\u2029":
                return ce(), "";
              case "\r":
                return ce(), "\n" === le() && ce(), "";
              case "1":
              case "2":
              case "3":
              case "4":
              case "5":
              case "6":
              case "7":
              case "8":
              case "9":
              case void 0:
                throw pe(ce());
            }
            return ce();
          }());
        case "\"":
          return ae ? (ce(), fe("string", ne)) : void (ne += ce());
        case "'":
          return ae ? void (ne += ce()) : (ce(), fe("string", ne));
        case "\n":
        case "\r":
          throw pe(ce());
        case "\u2028":
        case "\u2029":
          !function (e) {
            console.warn(`JSON5: '${Se(e)}' in strings is not valid ECMAScript; consider escaping`);
          }(oe);
          break;
        case void 0:
          throw pe(ce());
      }
      ne += ce();
    },
    start() {
      switch (oe) {
        case "{":
        case "[":
          return fe("punctuator", ce());
      }
      te = "value";
    },
    beforePropertyName() {
      switch (oe) {
        case "$":
        case "_":
          return ne = ce(), void (te = "identifierName");
        case "\\":
          return ce(), void (te = "identifierNameStartEscape");
        case "}":
          return fe("punctuator", ce());
        case "\"":
        case "'":
          return ae = "\"" === ce(), void (te = "string");
      }
      if (X.isIdStartChar(oe)) return ne += ce(), void (te = "identifierName");
      throw pe(ce());
    },
    afterPropertyName() {
      if (":" === oe) return fe("punctuator", ce());
      throw pe(ce());
    },
    beforePropertyValue() {
      te = "value";
    },
    afterPropertyValue() {
      switch (oe) {
        case ",":
        case "}":
          return fe("punctuator", ce());
      }
      throw pe(ce());
    },
    beforeArrayValue() {
      if ("]" === oe) return fe("punctuator", ce());
      te = "value";
    },
    afterArrayValue() {
      switch (oe) {
        case ",":
        case "]":
          return fe("punctuator", ce());
      }
      throw pe(ce());
    },
    end() {
      throw pe(ce());
    }
  };
  function fe(e, r) {
    return {
      type: e,
      value: r,
      line: Q,
      column: Z
    };
  }
  function de(e) {
    for (const r of e) {
      if (le() !== r) throw pe(ce());
      ce();
    }
  }
  function ve() {
    let e = "",
      r = 4;
    for (; r-- > 0;) {
      const r = le();
      if (!X.isHexDigit(r)) throw pe(ce());
      e += ce();
    }
    return String.fromCodePoint(parseInt(e, 16));
  }
  const he = {
    start() {
      if ("eof" === J.type) throw ge();
      me();
    },
    beforePropertyName() {
      switch (J.type) {
        case "identifier":
        case "string":
          return ee = J.value, void (K = "afterPropertyName");
        case "punctuator":
          return void _e();
        case "eof":
          throw ge();
      }
    },
    afterPropertyName() {
      if ("eof" === J.type) throw ge();
      K = "beforePropertyValue";
    },
    beforePropertyValue() {
      if ("eof" === J.type) throw ge();
      me();
    },
    beforeArrayValue() {
      if ("eof" === J.type) throw ge();
      "punctuator" !== J.type || "]" !== J.value ? me() : _e();
    },
    afterPropertyValue() {
      if ("eof" === J.type) throw ge();
      switch (J.value) {
        case ",":
          return void (K = "beforePropertyName");
        case "}":
          _e();
      }
    },
    afterArrayValue() {
      if ("eof" === J.type) throw ge();
      switch (J.value) {
        case ",":
          return void (K = "beforeArrayValue");
        case "]":
          _e();
      }
    },
    end() {}
  };
  function me() {
    let e;
    switch (J.type) {
      case "punctuator":
        switch (J.value) {
          case "{":
            e = {};
            break;
          case "[":
            e = [];
        }
        break;
      case "null":
      case "boolean":
      case "numeric":
      case "string":
        e = J.value;
    }
    if (void 0 === re) re = e;else {
      const r = Y[Y.length - 1];
      Array.isArray(r) ? r.push(e) : r[ee] = e;
    }
    if (null !== e && "object" == typeof e) Y.push(e), K = Array.isArray(e) ? "beforeArrayValue" : "beforePropertyName";else {
      const e = Y[Y.length - 1];
      K = null == e ? "end" : Array.isArray(e) ? "afterArrayValue" : "afterPropertyValue";
    }
  }
  function _e() {
    Y.pop();
    const e = Y[Y.length - 1];
    K = null == e ? "end" : Array.isArray(e) ? "afterArrayValue" : "afterPropertyValue";
  }
  function pe(e) {
    return Ee(void 0 === e ? `JSON5: invalid end of input at ${Q}:${Z}` : `JSON5: invalid character '${Se(e)}' at ${Q}:${Z}`);
  }
  function ge() {
    return Ee(`JSON5: invalid end of input at ${Q}:${Z}`);
  }
  function be() {
    return Z -= 5, Ee(`JSON5: invalid identifier character at ${Q}:${Z}`);
  }
  function Se(e) {
    const r = {
      "'": "\\'",
      "\"": "\\\"",
      "\\": "\\\\",
      "\b": "\\b",
      "\f": "\\f",
      "\n": "\\n",
      "\r": "\\r",
      "\t": "\\t",
      "\x0B": "\\v",
      "\0": "\\0",
      "\u2028": "\\u2028",
      "\u2029": "\\u2029"
    };
    if (r[e]) return r[e];
    if (e < " ") {
      const r = e.charCodeAt(0).toString(16);
      return "\\x" + ("00" + r).substring(r.length);
    }
    return e;
  }
  function Ee(e) {
    const r = new SyntaxError(e);
    return r.lineNumber = Q, r.columnNumber = Z, r;
  }
  var we = {
    parse: function (e, r) {
      G = String(e), K = "start", Y = [], q = 0, Q = 1, Z = 0, J = void 0, ee = void 0, re = void 0;
      do {
        J = se(), he[K]();
      } while ("eof" !== J.type);
      return "function" == typeof r ? function e(r, t, n) {
        const a = r[t];
        if (null != a && "object" == typeof a) for (const r in a) {
          const t = e(a, r, n);
          void 0 === t ? delete a[r] : a[r] = t;
        }
        return n.call(r, t, a);
      }({
        "": re
      }, "", r) : re;
    },
    stringify: function (e, r, t) {
      const n = [];
      let a,
        i,
        o,
        s = "",
        l = "";
      if (null == r || "object" != typeof r || Array.isArray(r) || (t = r.space, o = r.quote, r = r.replacer), "function" == typeof r) i = r;else if (Array.isArray(r)) {
        a = [];
        for (const e of r) {
          let r;
          "string" == typeof e ? r = e : ("number" == typeof e || e instanceof String || e instanceof Number) && (r = String(e)), void 0 !== r && a.indexOf(r) < 0 && a.push(r);
        }
      }
      return t instanceof Number ? t = Number(t) : t instanceof String && (t = String(t)), "number" == typeof t ? t > 0 && (t = Math.min(10, Math.floor(t)), l = "          ".substr(0, t)) : "string" == typeof t && (l = t.substr(0, 10)), c("", {
        "": e
      });
      function c(e, r) {
        let t = r[e];
        switch (null != t && ("function" == typeof t.toJSON5 ? t = t.toJSON5(e) : "function" == typeof t.toJSON && (t = t.toJSON(e))), i && (t = i.call(r, e, t)), t instanceof Number ? t = Number(t) : t instanceof String ? t = String(t) : t instanceof Boolean && (t = t.valueOf()), t) {
          case null:
            return "null";
          case !0:
            return "true";
          case !1:
            return "false";
        }
        return "string" == typeof t ? u(t) : "number" == typeof t ? String(t) : "object" == typeof t ? Array.isArray(t) ? function (e) {
          if (n.indexOf(e) >= 0) throw TypeError("Converting circular structure to JSON5");
          n.push(e);
          let r = s;
          s += l;
          let t,
            a = [];
          for (let r = 0; r < e.length; r++) {
            const t = c(String(r), e);
            a.push(void 0 !== t ? t : "null");
          }
          if (0 === a.length) t = "[]";else if ("" === l) {
            let e = a.join(",");
            t = "[" + e + "]";
          } else {
            let e = ",\n" + s,
              n = a.join(e);
            t = "[\n" + s + n + ",\n" + r + "]";
          }
          return n.pop(), s = r, t;
        }(t) : function (e) {
          if (n.indexOf(e) >= 0) throw TypeError("Converting circular structure to JSON5");
          n.push(e);
          let r = s;
          s += l;
          let t,
            i = a || Object.keys(e),
            o = [];
          for (const r of i) {
            const t = c(r, e);
            if (void 0 !== t) {
              let e = f(r) + ":";
              "" !== l && (e += " "), e += t, o.push(e);
            }
          }
          if (0 === o.length) t = "{}";else {
            let e;
            if ("" === l) e = o.join(","), t = "{" + e + "}";else {
              let n = ",\n" + s;
              e = o.join(n), t = "{\n" + s + e + ",\n" + r + "}";
            }
          }
          return n.pop(), s = r, t;
        }(t) : void 0;
      }
      function u(e) {
        const r = {
            "'": 0.1,
            "\"": 0.2
          },
          t = {
            "'": "\\'",
            "\"": "\\\"",
            "\\": "\\\\",
            "\b": "\\b",
            "\f": "\\f",
            "\n": "\\n",
            "\r": "\\r",
            "\t": "\\t",
            "\x0B": "\\v",
            "\0": "\\0",
            "\u2028": "\\u2028",
            "\u2029": "\\u2029"
          };
        let n = "";
        for (let a = 0; a < e.length; a++) {
          const i = e[a];
          switch (i) {
            case "'":
            case "\"":
              r[i]++, n += i;
              continue;
            case "\0":
              if (X.isDigit(e[a + 1])) {
                n += "\\x00";
                continue;
              }
          }
          if (t[i]) n += t[i];else if (i < " ") {
            let e = i.charCodeAt(0).toString(16);
            n += "\\x" + ("00" + e).substring(e.length);
          } else n += i;
        }
        const a = o || Object.keys(r).reduce((e, t) => r[e] < r[t] ? e : t);
        return n = n.replace(new RegExp(a, "g"), t[a]), a + n + a;
      }
      function f(e) {
        if (0 === e.length) return u(e);
        const r = String.fromCodePoint(e.codePointAt(0));
        if (!X.isIdStartChar(r)) return u(e);
        for (let t = r.length; t < e.length; t++) if (!X.isIdContinueChar(String.fromCodePoint(e.codePointAt(t)))) return u(e);
        return e;
      }
    }
  };
  function ye(e, r = !1) {
    let t = " ";
    e.children.length > 0 && (t = e.isCollapsed ? "\u25B8" : "\u25BE");
    let n = "";
    null !== e.key && (n = ` key="${e.key}"`);
    let a = null;
    null !== e.hocDisplayNames && (a = [...e.hocDisplayNames]);
    const i = null === a ? "" : ` [${a.join("][")}]`;
    let o = "";
    return r && (o = ` (${e.isCollapsed ? 1 : e.weight})`), `${"  ".repeat(e.depth + 1)}${t} <${e.displayName || "null"}${n}>${i}${o}`;
  }
  function ke(e) {
    return "string" == typeof e && e.length >= 2 && "'" === e.charAt(0) && "'" === e.charAt(e.length - 1) ? "\"" + e.substr(1, e.length - 2) + "\"" : e;
  }
  function Ce(e) {
    switch (e) {
      case "Infinity":
        return 1 / 0;
      case "NaN":
        return NaN;
      case "undefined":
        return;
      default:
        return we.parse(ke(e));
    }
  }
  function De(e) {
    if ("number" == typeof e) {
      if (Number.isNaN(e)) return "NaN";
      if (!Number.isFinite(e)) return "Infinity";
    } else if (void 0 === e) return "undefined";
    return JSON.stringify(e);
  }
  const Ae = /\n\s+at /,
    Me = /([^\s]+) \((.+):(.+):(.+)\)/;
  const xe = ["var(--color-commit-gradient-0)", "var(--color-commit-gradient-1)", "var(--color-commit-gradient-2)", "var(--color-commit-gradient-3)", "var(--color-commit-gradient-4)", "var(--color-commit-gradient-5)", "var(--color-commit-gradient-6)", "var(--color-commit-gradient-7)", "var(--color-commit-gradient-8)", "var(--color-commit-gradient-9)"];
  const Oe = e => {
      const r = xe.length - 1;
      let t;
      return t = Number.isNaN(e) ? 0 : Number.isFinite(e) ? Math.max(0, Math.min(r, e)) * r : r, xe[Math.round(t)];
    },
    Te = e => Math.round(10 * e) / 10 || "<0.1",
    Ne = e => Math.round(Math.round(e) / 100) / 10,
    Re = (e, r, t, n) => (a, i) => r - e == 0 ? i : (a - e) / (r - e) * (n - t),
    Ie = (e, ...r) => {
      v.F && console.log("%cCommitTreeBuilder %c" + e, "color: pink; font-weight: bold;", "font-weight: bold;", ...r);
    },
    He = new Map();
  function Fe({
    commitIndex: e,
    profilerStore: r,
    rootID: t
  }) {
    He.has(t) || He.set(t, []);
    const n = He.get(t);
    if (e < n.length) return n[e];
    const {
      profilingData: a
    } = r;
    if (null === a) throw Error("No profiling data available");
    const i = a.dataForRoots.get(t);
    if (null == i) throw Error(`Could not find profiling data for root "${t}"`);
    const {
      operations: o
    } = i;
    if (o.length <= e) throw Error(`getCommitTree(): Invalid commit "${e}" for root "${t}". There are only "${o.length}" commits.`);
    let s = null;
    for (let r = n.length; r <= e; r++) if (0 === r) {
      const e = new Map();
      Le(t, 0, e, i), null != o && r < o.length && (s = Pe({
        nodes: e,
        rootID: t
      }, o[r]), v.F && ze(s), n.push(s));
    } else {
      s = Pe(n[r - 1], o[r]), v.F && ze(s), n.push(s);
    }
    return s;
  }
  function Le(e, r, t, n) {
    const a = n.snapshots.get(e);
    null != a && (t.set(e, {
      id: e,
      children: a.children,
      displayName: a.displayName,
      hocDisplayNames: a.hocDisplayNames,
      key: a.key,
      parentID: r,
      treeBaseDuration: n.initialTreeBaseDurations.get(e),
      type: a.type
    }), a.children.forEach(r => Le(r, e, t, n)));
  }
  function Pe(e, r) {
    const t = new Map(e.nodes),
      n = e => {
        const r = Object.assign({}, t.get(e));
        return t.set(e, r), r;
      };
    let a = 2,
      i = null;
    const o = [null],
      s = r[a++],
      l = a + s;
    for (; a < l;) {
      const e = r[a++],
        t = N(r.slice(a, a + e));
      o.push(t), a += e;
    }
    for (; a < r.length;) {
      const e = r[a];
      switch (e) {
        case v.x:
          {
            i = r[a + 1];
            const e = r[a + 2];
            if (a += 3, t.has(i)) throw new Error(`Commit tree already contains fiber "${i}". This is a bug in React DevTools.`);
            if (11 === e) {
              a++, a++, a++, a++, v.F && Ie("Add", "new root fiber " + i);
              const r = {
                children: [],
                displayName: null,
                hocDisplayNames: null,
                id: i,
                key: null,
                parentID: 0,
                treeBaseDuration: 0,
                type: e
              };
              t.set(i, r);
            } else {
              const s = r[a];
              a++, a++;
              const l = o[r[a]];
              a++;
              const c = o[r[a]];
              a++, v.F && Ie("Add", `fiber ${i} (${l || "null"}) as child of ${s}`);
              const u = n(s);
              u.children = u.children.concat(i);
              const f = {
                children: [],
                displayName: l,
                hocDisplayNames: null,
                id: i,
                key: c,
                parentID: s,
                treeBaseDuration: 0,
                type: e
              };
              t.set(i, f);
            }
            break;
          }
        case v.y:
          {
            const e = r[a + 1];
            a += 2;
            for (let o = 0; o < e; o++) {
              if (i = r[a], a++, !t.has(i)) throw new Error(`Commit tree does not contain fiber "${i}". This is a bug in React DevTools.`);
              const e = n(i).parentID;
              if (t.delete(i), t.has(e)) {
                const r = n(e);
                v.F && Ie("Remove", `fiber ${i} from parent ${e}`), r.children = r.children.filter(e => e !== i);
              } else ;
            }
            break;
          }
        case v.z:
          throw Error("Operation REMOVE_ROOT is not supported while profiling.");
        case v.A:
          {
            i = r[a + 1];
            const e = r[a + 2],
              t = r.slice(a + 3, a + 3 + e);
            a = a + 3 + e, v.F && Ie("Re-order", `fiber ${i} children ${t.join(",")}`);
            n(i).children = Array.from(t);
            break;
          }
        case v.B:
          {
            i = r[a + 1];
            const e = r[a + 1];
            a += 3, v.F && Ie("Subtree mode", `Subtree with root ${i} set to mode ${e}`);
            break;
          }
        case v.D:
          {
            i = r[a + 1];
            const e = n(i);
            e.treeBaseDuration = r[a + 2] / 1000, v.F && Ie("Update", `fiber ${i} treeBaseDuration to ${e.treeBaseDuration}`), a += 3;
            break;
          }
        case v.C:
          {
            i = r[a + 1];
            const e = r[a + 2],
              t = r[a + 3];
            a += 4, v.F && Ie("Warnings and Errors update", `fiber ${i} has ${e} errors and ${t} warnings`);
            break;
          }
        default:
          throw Error(`Unsupported Bridge operation "${e}"`);
      }
    }
    return {
      nodes: t,
      rootID: e.rootID
    };
  }
  const ze = e => {
      if (v.F) {
        const {
          nodes: r,
          rootID: t
        } = e;
        console.group("__printTree()");
        const n = [t, 0];
        for (; n.length > 0;) {
          const e = n.shift(),
            t = n.shift(),
            a = r.get(e);
          if (null == a) throw Error(`Could not find node with id "${e}" in commit tree`);
          console.log(`${"\u2022".repeat(t)}${a.id}:${a.displayName || ""} ${a.key ? `key:"${a.key}"` : ""} (${a.treeBaseDuration})`), a.children.forEach(e => {
            n.push(e, t + 1);
          });
        }
        console.groupEnd();
      }
    },
    Be = new Map();
  const je = new Map();
  function Ve(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  class Ue {
    constructor(e) {
      Ve(this, "_fiberCommits", new Map()), Ve(this, "getCommitTree", ({
        commitIndex: e,
        rootID: r
      }) => Fe({
        commitIndex: e,
        profilerStore: this._profilerStore,
        rootID: r
      })), Ve(this, "getFiberCommits", ({
        fiberID: e,
        rootID: r
      }) => {
        const t = this._fiberCommits.get(e);
        if (null != t) return t;
        const n = [];
        return this._profilerStore.getDataForRoot(r).commitData.forEach((r, t) => {
          r.fiberActualDurations.has(e) && n.push(t);
        }), this._fiberCommits.set(e, n), n;
      }), Ve(this, "getFlamegraphChartData", ({
        commitIndex: e,
        commitTree: r,
        rootID: t
      }) => function ({
        commitIndex: e,
        commitTree: r,
        profilerStore: t,
        rootID: n
      }) {
        const a = t.getCommitData(n, e),
          {
            fiberActualDurations: i,
            fiberSelfDurations: o
          } = a,
          {
            nodes: s
          } = r,
          l = `${n}-${e}`;
        if (Be.has(l)) return Be.get(l);
        const c = new Map(),
          u = new Set(),
          f = [];
        let d = 0,
          v = 0;
        const h = (e, r, t) => {
          c.set(e, t);
          const n = s.get(e);
          if (null == n) throw Error(`Could not find node with id "${e}" in commit tree`);
          const {
              children: a,
              displayName: l,
              hocDisplayNames: u,
              key: m,
              treeBaseDuration: _
            } = n,
            p = i.get(e) || 0,
            g = o.get(e) || 0,
            b = i.has(e),
            S = l || "Anonymous",
            E = null !== m ? ` key="${m}"` : "";
          let w = "";
          null !== u && u.length > 0 && (w = ` (${u[0]})`);
          let y = `${S}${w}${E}`;
          b && (y += ` (${Te(g)}ms of ${Te(p)}ms)`), d = Math.max(d, t), v = Math.max(v, g);
          const k = {
            actualDuration: p,
            didRender: b,
            id: e,
            label: y,
            name: S,
            offset: r - _,
            selfDuration: g,
            treeBaseDuration: _
          };
          t > f.length ? f.push([k]) : f[t - 1].push(k);
          for (let e = a.length - 1; e >= 0; e--) {
            const n = a[e];
            r -= h(n, r, t + 1).treeBaseDuration;
          }
          return k;
        };
        let m = 0;
        if (s.size > 0) {
          const e = s.get(n);
          if (null == e) throw Error(`Could not find root node with id "${n}" in commit tree`);
          for (let r = e.children.length - 1; r >= 0; r--) {
            const t = e.children[r],
              n = s.get(t);
            if (null == n) throw Error(`Could not find node with id "${t}" in commit tree`);
            m += n.treeBaseDuration, h(t, m, 1);
          }
          i.forEach((e, r) => {
            let t = s.get(r);
            if (null != t) {
              let e = t.parentID;
              for (; 0 !== e && !u.has(e);) u.add(e), t = s.get(e), e = null != t ? t.parentID : 0;
            }
          });
        }
        const _ = {
          baseDuration: m,
          depth: d,
          idToDepthMap: c,
          maxSelfDuration: v,
          renderPathNodes: u,
          rows: f
        };
        return Be.set(l, _), _;
      }({
        commitIndex: e,
        commitTree: r,
        profilerStore: this._profilerStore,
        rootID: t
      })), Ve(this, "getRankedChartData", ({
        commitIndex: e,
        commitTree: r,
        rootID: t
      }) => function ({
        commitIndex: e,
        commitTree: r,
        profilerStore: t,
        rootID: n
      }) {
        const a = t.getCommitData(n, e),
          {
            fiberActualDurations: i,
            fiberSelfDurations: o
          } = a,
          {
            nodes: s
          } = r,
          l = `${n}-${e}`;
        if (je.has(l)) return je.get(l);
        let c = 0;
        const u = [];
        i.forEach((e, r) => {
          const t = s.get(r);
          if (null == t) throw Error(`Could not find node with id "${r}" in commit tree`);
          const {
            displayName: n,
            key: a,
            parentID: i,
            type: l
          } = t;
          if (0 === i) return;
          const f = o.get(r) || 0;
          c = Math.max(c, f);
          const d = n || "Anonymous";
          let v = "";
          6 === l ? v = " (ForwardRef)" : 8 === l && (v = " (Memo)");
          const h = `${d}${v}${null !== a ? ` key="${a}"` : ""} (${Te(f)}ms)`;
          u.push({
            id: r,
            label: h,
            name: d,
            value: f
          });
        });
        const f = {
          maxValue: c,
          nodes: u.sort((e, r) => r.value - e.value)
        };
        return je.set(l, f), f;
      }({
        commitIndex: e,
        commitTree: r,
        profilerStore: this._profilerStore,
        rootID: t
      })), this._profilerStore = e;
    }
    invalidate() {
      this._fiberCommits.clear(), He.clear(), Be.clear(), je.clear();
    }
  }
  function We(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  class $e extends s {
    constructor(e, r, t) {
      super(), We(this, "_dataBackends", []), We(this, "_dataFrontend", null), We(this, "_initialRendererIDs", new Set()), We(this, "_initialSnapshotsByRootID", new Map()), We(this, "_inProgressOperationsByRootID", new Map()), We(this, "_isProfiling", !1), We(this, "_rendererIDsThatReportedProfilingData", new Set()), We(this, "_rendererQueue", new Set()), We(this, "_takeProfilingSnapshotRecursive", (e, r) => {
        const t = this._store.getElementByID(e);
        if (null !== t) {
          const n = {
            id: e,
            children: t.children.slice(0),
            displayName: t.displayName,
            hocDisplayNames: t.hocDisplayNames,
            key: t.key,
            type: t.type
          };
          r.set(e, n), t.children.forEach(e => this._takeProfilingSnapshotRecursive(e, r));
        }
      }), We(this, "onBridgeOperations", e => {
        const r = e[0],
          t = e[1];
        if (this._isProfiling) {
          let n = this._inProgressOperationsByRootID.get(t);
          null == n ? (n = [e], this._inProgressOperationsByRootID.set(t, n)) : n.push(e), this._initialRendererIDs.has(r) || this._initialRendererIDs.add(r), this._initialSnapshotsByRootID.has(t) || this._initialSnapshotsByRootID.set(t, new Map()), this._rendererIDsThatReportedProfilingData.add(r);
        }
      }), We(this, "onBridgeProfilingData", e => {
        if (this._isProfiling) return;
        const {
          rendererID: r
        } = e;
        if (!this._rendererQueue.has(r)) throw Error(`Unexpected profiling data update from renderer "${r}"`);
        this._dataBackends.push(e), this._rendererQueue.delete(r), 0 === this._rendererQueue.size && (this._dataFrontend = function (e, r, t) {
          const n = new Map(),
            a = [];
          return e.forEach(e => {
            const {
              timelineData: i
            } = e;
            if (null != i) {
              const {
                batchUIDToMeasuresKeyValueArray: e,
                internalModuleSourceToRanges: r,
                laneToLabelKeyValueArray: t,
                laneToReactMeasureKeyValueArray: n,
                ...o
              } = i;
              a.push({
                ...o,
                batchUIDToMeasuresMap: new Map(e),
                internalModuleSourceToRanges: new Map(r),
                laneToLabelMap: new Map(t),
                laneToReactMeasureMap: new Map(n)
              });
            }
            e.dataForRoots.forEach(({
              commitData: e,
              displayName: a,
              initialTreeBaseDurations: i,
              rootID: o
            }) => {
              const s = r.get(o);
              if (null == s) throw Error(`Could not find profiling operations for root "${o}"`);
              const l = t.get(o);
              if (null == l) throw Error(`Could not find profiling snapshots for root "${o}"`);
              const c = e.map((e, r) => ({
                changeDescriptions: null != e.changeDescriptions ? new Map(e.changeDescriptions) : null,
                duration: e.duration,
                effectDuration: e.effectDuration,
                fiberActualDurations: new Map(e.fiberActualDurations),
                fiberSelfDurations: new Map(e.fiberSelfDurations),
                passiveEffectDuration: e.passiveEffectDuration,
                priorityLevel: e.priorityLevel,
                timestamp: e.timestamp,
                updaters: null !== e.updaters ? e.updaters.map(e => {
                  const [r, t] = L(e.displayName, e.type);
                  return {
                    ...e,
                    displayName: r,
                    hocDisplayNames: t
                  };
                }) : null
              }));
              n.set(o, {
                commitData: c,
                displayName: a,
                initialTreeBaseDurations: new Map(i),
                operations: s,
                rootID: o,
                snapshots: l
              });
            });
          }), {
            dataForRoots: n,
            imported: !1,
            timelineData: a
          };
        }(this._dataBackends, this._inProgressOperationsByRootID, this._initialSnapshotsByRootID), this._dataBackends.splice(0), this.emit("isProcessingData"));
      }), We(this, "onBridgeShutdown", () => {
        this._bridge.removeListener("operations", this.onBridgeOperations), this._bridge.removeListener("profilingData", this.onBridgeProfilingData), this._bridge.removeListener("profilingStatus", this.onProfilingStatus), this._bridge.removeListener("shutdown", this.onBridgeShutdown);
      }), We(this, "onProfilingStatus", e => {
        if (e) {
          this._dataBackends.splice(0), this._dataFrontend = null, this._initialRendererIDs.clear(), this._initialSnapshotsByRootID.clear(), this._inProgressOperationsByRootID.clear(), this._rendererIDsThatReportedProfilingData.clear(), this._rendererQueue.clear();
          for (const e of this._store.rootIDToRendererID.values()) this._initialRendererIDs.has(e) || this._initialRendererIDs.add(e);
          this._store.roots.forEach(e => {
            const r = new Map();
            this._initialSnapshotsByRootID.set(e, r), this._takeProfilingSnapshotRecursive(e, r);
          });
        }
        this._isProfiling !== e && (this._isProfiling = e, this._cache.invalidate(), this.emit("isProfiling"), e || (this._dataBackends.splice(0), this._rendererQueue.clear(), this._rendererIDsThatReportedProfilingData.forEach(e => {
          this._rendererQueue.has(e) || (this._rendererQueue.add(e), this._bridge.send("getProfilingData", {
            rendererID: e
          }));
        }), this.emit("isProcessingData")));
      }), this._bridge = e, this._isProfiling = t, this._store = r, e.addListener("operations", this.onBridgeOperations), e.addListener("profilingData", this.onBridgeProfilingData), e.addListener("profilingStatus", this.onProfilingStatus), e.addListener("shutdown", this.onBridgeShutdown), e.send("getProfilingStatus"), this._cache = new Ue(this);
    }
    getCommitData(e, r) {
      if (null !== this._dataFrontend) {
        const t = this._dataFrontend.dataForRoots.get(e);
        if (null != t) {
          const e = t.commitData[r];
          if (null != e) return e;
        }
      }
      throw Error(`Could not find commit data for root "${e}" and commit "${r}"`);
    }
    getDataForRoot(e) {
      if (null !== this._dataFrontend) {
        const r = this._dataFrontend.dataForRoots.get(e);
        if (null != r) return r;
      }
      throw Error(`Could not find commit data for root "${e}"`);
    }
    get didRecordCommits() {
      return null !== this._dataFrontend && this._dataFrontend.dataForRoots.size > 0;
    }
    get isProcessingData() {
      return this._rendererQueue.size > 0 || this._dataBackends.length > 0;
    }
    get isProfiling() {
      return this._isProfiling;
    }
    get profilingCache() {
      return this._cache;
    }
    get profilingData() {
      return this._dataFrontend;
    }
    set profilingData(e) {
      this._isProfiling ? console.warn("Profiling data cannot be updated while profiling is in progress.") : (this._dataBackends.splice(0), this._dataFrontend = e, this._initialRendererIDs.clear(), this._initialSnapshotsByRootID.clear(), this._inProgressOperationsByRootID.clear(), this._cache.invalidate(), this.emit("profilingData"));
    }
    clear() {
      this._dataBackends.splice(0), this._dataFrontend = null, this._initialRendererIDs.clear(), this._initialSnapshotsByRootID.clear(), this._inProgressOperationsByRootID.clear(), this._rendererQueue.clear(), this._cache.invalidate(), this.emit("profilingData");
    }
    startProfiling() {
      this._bridge.send("startProfiling", this._store.recordChangeDescriptions);
    }
    stopProfiling() {
      this._bridge.send("stopProfiling");
    }
  }
  class Xe extends Error {
    constructor(e) {
      super(e), Error.captureStackTrace && Error.captureStackTrace(this, Xe), this.name = "UnsupportedBridgeOperationError";
    }
  }
  function Ge(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  const Ke = (e, ...r) => {
    v.F && console.log("%cStore %c" + e, "color: green; font-weight: bold;", "font-weight: bold;", ...r);
  };
  class Ye extends s {
    constructor(e, r) {
      super(), Ge(this, "_backendVersion", null), Ge(this, "_cachedErrorCount", 0), Ge(this, "_cachedWarningCount", 0), Ge(this, "_cachedErrorAndWarningTuples", null), Ge(this, "_collapseNodesByDefault", !0), Ge(this, "_errorsAndWarnings", new Map()), Ge(this, "_hasOwnerMetadata", !1), Ge(this, "_idToElement", new Map()), Ge(this, "_isNativeStyleEditorSupported", !1), Ge(this, "_isBackendStorageAPISupported", !1), Ge(this, "_isSynchronousXHRSupported", !1), Ge(this, "_nativeStyleEditorValidAttributes", null), Ge(this, "_onBridgeProtocolTimeoutID", null), Ge(this, "_ownersMap", new Map()), Ge(this, "_recordChangeDescriptions", !1), Ge(this, "_revision", 0), Ge(this, "_roots", []), Ge(this, "_rootIDToCapabilities", new Map()), Ge(this, "_rootIDToRendererID", new Map()), Ge(this, "_supportsNativeInspection", !0), Ge(this, "_supportsProfiling", !1), Ge(this, "_supportsReloadAndProfile", !1), Ge(this, "_supportsTimeline", !1), Ge(this, "_supportsTraceUpdates", !1), Ge(this, "_rootSupportsBasicProfiling", !1), Ge(this, "_rootSupportsTimelineProfiling", !1), Ge(this, "_bridgeProtocol", null), Ge(this, "_unsupportedBridgeProtocolDetected", !1), Ge(this, "_unsupportedRendererVersionDetected", !1), Ge(this, "_weightAcrossRoots", 0), Ge(this, "_adjustParentTreeWeight", (e, r) => {
        let t = !1;
        for (; null != e;) {
          if (e.weight += r, e.isCollapsed) {
            t = !0;
            break;
          }
          e = this._idToElement.get(e.parentID);
        }
        t || (this._weightAcrossRoots += r);
      }), Ge(this, "onBridgeNativeStyleEditorSupported", ({
        isSupported: e,
        validAttributes: r
      }) => {
        this._isNativeStyleEditorSupported = e, this._nativeStyleEditorValidAttributes = r || null, this.emit("supportsNativeStyleEditor");
      }), Ge(this, "onBridgeOperations", e => {
        v.F && (console.groupCollapsed("onBridgeOperations"), Ke("onBridgeOperations", e.join(",")));
        let r = !1,
          t = !1;
        const n = e[0],
          a = [],
          i = new Map();
        let o = 2;
        const s = [null],
          l = e[o++],
          c = o + l;
        for (; o < c;) {
          const r = e[o++],
            t = N(e.slice(o, o + r));
          s.push(t), o += r;
        }
        for (; o < e.length;) {
          const l = e[o];
          switch (l) {
            case v.x:
              {
                const t = e[o + 1],
                  i = e[o + 2];
                o += 3, this._idToElement.has(t) && this._throwAndEmitError(Error(`Cannot add node "${t}" because a node with that id is already in the Store.`));
                let l = 0,
                  c = null;
                if (11 === i) {
                  v.F && Ke("Add", "new root node " + t);
                  const a = e[o] > 0;
                  o++;
                  const s = 0 != (e[o] & v.r),
                    l = 0 != (e[o] & v.s);
                  o++;
                  let c = !1,
                    u = !1;
                  (null === this._bridgeProtocol || this._bridgeProtocol.version >= 2) && (c = e[o] > 0, o++, u = e[o] > 0, o++), this._roots = this._roots.concat(t), this._rootIDToRendererID.set(t, n), this._rootIDToCapabilities.set(t, {
                    supportsBasicProfiling: s,
                    hasOwnerMetadata: u,
                    supportsStrictMode: c,
                    supportsTimeline: l
                  });
                  const f = !a && c;
                  this._idToElement.set(t, {
                    children: [],
                    depth: -1,
                    displayName: null,
                    hocDisplayNames: null,
                    id: t,
                    isCollapsed: !1,
                    isStrictModeNonCompliant: f,
                    key: null,
                    ownerID: 0,
                    parentID: 0,
                    type: i,
                    weight: 0
                  }), r = !0;
                } else {
                  c = e[o], o++, l = e[o], o++;
                  const r = s[e[o]];
                  o++;
                  const n = s[e[o]];
                  o++, v.F && Ke("Add", `node ${t} (${r || "null"}) as child of ${c}`), this._idToElement.has(c) || this._throwAndEmitError(Error(`Cannot add child "${t}" to parent "${c}" because parent node was not found in the Store.`));
                  const u = this._idToElement.get(c);
                  u.children.push(t);
                  const [f, d] = L(r, i),
                    h = {
                      children: [],
                      depth: u.depth + 1,
                      displayName: f,
                      hocDisplayNames: d,
                      id: t,
                      isCollapsed: this._collapseNodesByDefault,
                      isStrictModeNonCompliant: u.isStrictModeNonCompliant,
                      key: n,
                      ownerID: l,
                      parentID: c,
                      type: i,
                      weight: 1
                    };
                  if (this._idToElement.set(t, h), a.push(t), this._adjustParentTreeWeight(u, 1), l > 0) {
                    let e = this._ownersMap.get(l);
                    void 0 === e && (e = new Set(), this._ownersMap.set(l, e)), e.add(t);
                  }
                }
                break;
              }
            case v.y:
              {
                const n = e[o + 1];
                o += 2;
                for (let a = 0; a < n; a++) {
                  const n = e[o];
                  this._idToElement.has(n) || this._throwAndEmitError(Error(`Cannot remove node "${n}" because no matching node was found in the Store.`)), o += 1;
                  const a = this._idToElement.get(n),
                    {
                      children: s,
                      ownerID: l,
                      parentID: c,
                      weight: u
                    } = a;
                  s.length > 0 && this._throwAndEmitError(Error(`Node "${n}" was removed before its children.`)), this._idToElement.delete(n);
                  let f = null;
                  if (0 === c) v.F && Ke("Remove", `node ${n} root`), this._roots = this._roots.filter(e => e !== n), this._rootIDToRendererID.delete(n), this._rootIDToCapabilities.delete(n), r = !0;else {
                    v.F && Ke("Remove", `node ${n} from parent ${c}`), f = this._idToElement.get(c), void 0 === f && this._throwAndEmitError(Error(`Cannot remove node "${n}" from parent "${c}" because no matching node was found in the Store.`));
                    const e = f.children.indexOf(n);
                    f.children.splice(e, 1);
                  }
                  if (this._adjustParentTreeWeight(f, -u), i.set(n, c), this._ownersMap.delete(n), l > 0) {
                    const e = this._ownersMap.get(l);
                    void 0 !== e && e.delete(n);
                  }
                  this._errorsAndWarnings.has(n) && (this._errorsAndWarnings.delete(n), t = !0);
                }
                break;
              }
            case v.z:
              {
                o += 1;
                const r = e[1];
                v.F && Ke("Remove root " + r);
                const t = e => {
                    const r = this._idToElement.get(e);
                    if (this._idToElement.delete(e), r) for (let e = 0; e < r.children.length; e++) t(r.children[e]);
                  },
                  n = this._idToElement.get(r);
                t(r), this._rootIDToCapabilities.delete(r), this._rootIDToRendererID.delete(r), this._roots = this._roots.filter(e => e !== r), this._weightAcrossRoots -= n.weight;
                break;
              }
            case v.A:
              {
                const r = e[o + 1],
                  t = e[o + 2];
                o += 3, this._idToElement.has(r) || this._throwAndEmitError(Error(`Cannot reorder children for node "${r}" because no matching node was found in the Store.`));
                const n = this._idToElement.get(r).children;
                n.length !== t && this._throwAndEmitError(Error("Children cannot be added or removed during a reorder operation."));
                for (let r = 0; r < t; r++) {
                  const t = e[o + r];
                  n[r] = t;
                }
                o += t, v.F && Ke("Re-order", `Node ${r} children ${n.join(",")}`);
                break;
              }
            case v.B:
              {
                const r = e[o + 1],
                  t = e[o + 2];
                o += 3, 1 === t && this._recursivelyUpdateSubtree(r, e => {
                  e.isStrictModeNonCompliant = !1;
                }), v.F && Ke("Subtree mode", `Subtree with root ${r} set to mode ${t}`);
                break;
              }
            case v.D:
              o += 3;
              break;
            case v.C:
              const c = e[o + 1],
                u = e[o + 2],
                f = e[o + 3];
              o += 4, u > 0 || f > 0 ? this._errorsAndWarnings.set(c, {
                errorCount: u,
                warningCount: f
              }) : this._errorsAndWarnings.has(c) && this._errorsAndWarnings.delete(c), t = !0;
              break;
            default:
              this._throwAndEmitError(new Xe(`Unsupported Bridge operation "${l}"`));
          }
        }
        if (this._revision++, this._cachedErrorAndWarningTuples = null, t) {
          let e = 0,
            r = 0;
          this._errorsAndWarnings.forEach(t => {
            e += t.errorCount, r += t.warningCount;
          }), this._cachedErrorCount = e, this._cachedWarningCount = r;
        }
        if (r) {
          const e = this._rootSupportsBasicProfiling,
            r = this._rootSupportsTimelineProfiling;
          this._hasOwnerMetadata = !1, this._rootSupportsBasicProfiling = !1, this._rootSupportsTimelineProfiling = !1, this._rootIDToCapabilities.forEach(({
            supportsBasicProfiling: e,
            hasOwnerMetadata: r,
            supportsTimeline: t
          }) => {
            e && (this._rootSupportsBasicProfiling = !0), r && (this._hasOwnerMetadata = !0), t && (this._rootSupportsTimelineProfiling = !0);
          }), this.emit("roots"), this._rootSupportsBasicProfiling !== e && this.emit("rootSupportsBasicProfiling"), this._rootSupportsTimelineProfiling !== r && this.emit("rootSupportsTimelineProfiling");
        }
        v.F && (console.log(function (e, r = !1, t = null) {
          const n = [];
          let a = 0;
          function i(e) {
            return null === t ? "" : t.selectedElementIndex === e ? "\u2192" : " ";
          }
          function o(r) {
            const {
              errorCount: t,
              warningCount: n
            } = e.getErrorAndWarningCountForElementID(r.id);
            return 0 === t && 0 === n ? "" : ` ${t > 0 ? "\u2715" : ""}${n > 0 ? "\u26A0" : ""}`;
          }
          const s = null !== t ? t.ownerFlatTree : null;
          if (null !== s) n.push("[owners]" + (r ? ` (${s.length})` : "")), s.forEach((e, r) => {
            const t = i(r),
              a = ye(e, !1),
              s = o(e);
            n.push(`${t}${a}${s}`);
          });else {
            const t = e._errorsAndWarnings;
            if (t.size > 0) {
              let e = 0,
                r = 0;
              t.forEach(t => {
                e += t.errorCount, r += t.warningCount;
              }), n.push(`✕ ${e}, ⚠ ${r}`);
            }
            if (e.roots.forEach(t => {
              const {
                  weight: s
                } = e.getElementByID(t),
                l = r ? ` (${s})` : "";
              n.push("[root]" + l);
              for (let t = a; t < a + s; t++) {
                const a = e.getElementAtIndex(t);
                if (null == a) throw Error(`Could not find element at index "${t}"`);
                const s = i(t),
                  l = ye(a, r),
                  c = o(a);
                n.push(`${s}${l}${c}`);
              }
              a += s;
            }), a !== e.numElements) throw Error(`Inconsistent Store state. Individual root weights ("${a}") do not match total weight ("${e.numElements}")`);
            e.assertExpectedRootMapSizes();
          }
          return n.join("\n");
        }(this, !0)), console.groupEnd()), this.emit("mutated", [a, i]);
      }), Ge(this, "onBridgeOverrideComponentFilters", e => {
        this._componentFilters = e, I(e);
      }), Ge(this, "onBridgeShutdown", () => {
        v.F && Ke("onBridgeShutdown", "unsubscribing from Bridge");
        const e = this._bridge;
        e.removeListener("operations", this.onBridgeOperations), e.removeListener("overrideComponentFilters", this.onBridgeOverrideComponentFilters), e.removeListener("shutdown", this.onBridgeShutdown), e.removeListener("isBackendStorageAPISupported", this.onBackendStorageAPISupported), e.removeListener("isNativeStyleEditorSupported", this.onBridgeNativeStyleEditorSupported), e.removeListener("isSynchronousXHRSupported", this.onBridgeSynchronousXHRSupported), e.removeListener("unsupportedRendererVersion", this.onBridgeUnsupportedRendererVersion), e.removeListener("backendVersion", this.onBridgeBackendVersion), e.removeListener("bridgeProtocol", this.onBridgeProtocol), null !== this._onBridgeProtocolTimeoutID && (clearTimeout(this._onBridgeProtocolTimeoutID), this._onBridgeProtocolTimeoutID = null);
      }), Ge(this, "onBackendStorageAPISupported", e => {
        this._isBackendStorageAPISupported = e, this.emit("supportsReloadAndProfile");
      }), Ge(this, "onBridgeSynchronousXHRSupported", e => {
        this._isSynchronousXHRSupported = e, this.emit("supportsReloadAndProfile");
      }), Ge(this, "onBridgeUnsupportedRendererVersion", () => {
        this._unsupportedRendererVersionDetected = !0, this.emit("unsupportedRendererVersionDetected");
      }), Ge(this, "onBridgeBackendVersion", e => {
        this._backendVersion = e, this.emit("backendVersion");
      }), Ge(this, "onBridgeProtocol", e => {
        null !== this._onBridgeProtocolTimeoutID && (clearTimeout(this._onBridgeProtocolTimeoutID), this._onBridgeProtocolTimeoutID = null), this._bridgeProtocol = e, e.version, u.version;
      }), Ge(this, "onBridgeProtocolTimeout", () => {
        this._onBridgeProtocolTimeoutID = null, this._bridgeProtocol = c[0], this.emit("unsupportedBridgeProtocolDetected");
      }), v.F && Ke("constructor", "subscribing to Bridge"), this._collapseNodesByDefault = "true" === b("React::DevTools::collapseNodesByDefault"), this._recordChangeDescriptions = "true" === b("React::DevTools::recordChangeDescriptions"), this._componentFilters = R();
      let t = !1;
      if (null != r) {
        t = !0 === r.isProfiling;
        const {
          supportsNativeInspection: e,
          supportsProfiling: n,
          supportsReloadAndProfile: a,
          supportsTimeline: i,
          supportsTraceUpdates: o
        } = r;
        this._supportsNativeInspection = !1 !== e, n && (this._supportsProfiling = !0), a && (this._supportsReloadAndProfile = !0), i && (this._supportsTimeline = !0), o && (this._supportsTraceUpdates = !0);
      }
      this._bridge = e, e.addListener("operations", this.onBridgeOperations), e.addListener("overrideComponentFilters", this.onBridgeOverrideComponentFilters), e.addListener("shutdown", this.onBridgeShutdown), e.addListener("isBackendStorageAPISupported", this.onBackendStorageAPISupported), e.addListener("isNativeStyleEditorSupported", this.onBridgeNativeStyleEditorSupported), e.addListener("isSynchronousXHRSupported", this.onBridgeSynchronousXHRSupported), e.addListener("unsupportedRendererVersion", this.onBridgeUnsupportedRendererVersion), this._profilerStore = new $e(e, this, t), null != r && r.checkBridgeProtocolCompatibility && (this._onBridgeProtocolTimeoutID = setTimeout(this.onBridgeProtocolTimeout, 10000), e.addListener("bridgeProtocol", this.onBridgeProtocol), e.send("getBridgeProtocol")), e.addListener("backendVersion", this.onBridgeBackendVersion), e.send("getBackendVersion");
    }
    assertExpectedRootMapSizes() {
      0 === this.roots.length && (this.assertMapSizeMatchesRootCount(this._idToElement, "_idToElement"), this.assertMapSizeMatchesRootCount(this._ownersMap, "_ownersMap")), this.assertMapSizeMatchesRootCount(this._rootIDToCapabilities, "_rootIDToCapabilities"), this.assertMapSizeMatchesRootCount(this._rootIDToRendererID, "_rootIDToRendererID");
    }
    assertMapSizeMatchesRootCount(e, r) {
      const t = this.roots.length;
      e.size !== t && this._throwAndEmitError(Error(`Expected ${r} to contain ${t} items, but it contains ${e.size} items\n\n${Object(d.inspect)(e, {
        depth: 20
      })}`));
    }
    get backendVersion() {
      return this._backendVersion;
    }
    get collapseNodesByDefault() {
      return this._collapseNodesByDefault;
    }
    set collapseNodesByDefault(e) {
      this._collapseNodesByDefault = e, S("React::DevTools::collapseNodesByDefault", e ? "true" : "false"), this.emit("collapseNodesByDefault");
    }
    get componentFilters() {
      return this._componentFilters;
    }
    set componentFilters(e) {
      this._profilerStore.isProfiling && this._throwAndEmitError(Error("Cannot modify filter preferences while profiling"));
      const r = this._componentFilters.filter(e => e.isEnabled),
        t = e.filter(e => e.isEnabled);
      let n = r.length !== t.length;
      if (!n) for (let e = 0; e < t.length; e++) {
        if (P(r[e], t[e])) {
          n = !0;
          break;
        }
      }
      this._componentFilters = e, I(e), n && this._bridge.send("updateComponentFilters", e), this.emit("componentFilters");
    }
    get bridgeProtocol() {
      return this._bridgeProtocol;
    }
    get errorCount() {
      return this._cachedErrorCount;
    }
    get hasOwnerMetadata() {
      return this._hasOwnerMetadata;
    }
    get nativeStyleEditorValidAttributes() {
      return this._nativeStyleEditorValidAttributes;
    }
    get numElements() {
      return this._weightAcrossRoots;
    }
    get profilerStore() {
      return this._profilerStore;
    }
    get recordChangeDescriptions() {
      return this._recordChangeDescriptions;
    }
    set recordChangeDescriptions(e) {
      this._recordChangeDescriptions = e, S("React::DevTools::recordChangeDescriptions", e ? "true" : "false"), this.emit("recordChangeDescriptions");
    }
    get revision() {
      return this._revision;
    }
    get rootIDToRendererID() {
      return this._rootIDToRendererID;
    }
    get roots() {
      return this._roots;
    }
    get rootSupportsBasicProfiling() {
      return this._rootSupportsBasicProfiling;
    }
    get rootSupportsTimelineProfiling() {
      return this._rootSupportsTimelineProfiling;
    }
    get supportsNativeInspection() {
      return this._supportsNativeInspection;
    }
    get supportsNativeStyleEditor() {
      return this._isNativeStyleEditorSupported;
    }
    get supportsProfiling() {
      return this._supportsProfiling;
    }
    get supportsReloadAndProfile() {
      return this._supportsReloadAndProfile && this._isBackendStorageAPISupported && this._isSynchronousXHRSupported;
    }
    get supportsTimeline() {
      return this._supportsTimeline;
    }
    get supportsTraceUpdates() {
      return this._supportsTraceUpdates;
    }
    get unsupportedBridgeProtocolDetected() {
      return this._unsupportedBridgeProtocolDetected;
    }
    get unsupportedRendererVersionDetected() {
      return this._unsupportedRendererVersionDetected;
    }
    get warningCount() {
      return this._cachedWarningCount;
    }
    containsElement(e) {
      return null != this._idToElement.get(e);
    }
    getElementAtIndex(e) {
      if (e < 0 || e >= this.numElements) return console.warn(`Invalid index ${e} specified; store contains ${this.numElements} items.`), null;
      let r,
        t,
        n = 0;
      for (let a = 0; a < this._roots.length; a++) if (r = this._roots[a], t = this._idToElement.get(r), 0 !== t.children.length) {
        if (n + t.weight > e) break;
        n += t.weight;
      }
      let a = t,
        i = n - 1;
      for (; e !== i;) {
        const r = a.children.length;
        for (let t = 0; t < r; t++) {
          const r = a.children[t],
            n = this._idToElement.get(r),
            o = n.isCollapsed ? 1 : n.weight;
          if (e <= i + o) {
            i++, a = n;
            break;
          }
          i += o;
        }
      }
      return a || null;
    }
    getElementIDAtIndex(e) {
      const r = this.getElementAtIndex(e);
      return null === r ? null : r.id;
    }
    getElementByID(e) {
      const r = this._idToElement.get(e);
      return null == r ? (console.warn(`No element found with id "${e}"`), null) : r;
    }
    getElementsWithErrorsAndWarnings() {
      if (null !== this._cachedErrorAndWarningTuples) return this._cachedErrorAndWarningTuples;
      {
        const e = [];
        return this._errorsAndWarnings.forEach((r, t) => {
          const n = this.getIndexOfElementID(t);
          if (null !== n) {
            let r = 0,
              a = e.length;
            for (; r < a;) {
              const t = r + a >> 1;
              e[t].index > n ? a = t : r = t + 1;
            }
            e.splice(r, 0, {
              id: t,
              index: n
            });
          }
        }), this._cachedErrorAndWarningTuples = e, e;
      }
    }
    getErrorAndWarningCountForElementID(e) {
      return this._errorsAndWarnings.get(e) || {
        errorCount: 0,
        warningCount: 0
      };
    }
    getIndexOfElementID(e) {
      const r = this.getElementByID(e);
      if (null === r || 0 === r.parentID) return null;
      let t = e,
        n = r.parentID,
        a = 0;
      for (;;) {
        const e = this._idToElement.get(n),
          {
            children: r
          } = e;
        for (let e = 0; e < r.length; e++) {
          const n = r[e];
          if (n === t) break;
          const i = this._idToElement.get(n);
          a += i.isCollapsed ? 1 : i.weight;
        }
        if (0 === e.parentID) break;
        a++, t = e.id, n = e.parentID;
      }
      for (let e = 0; e < this._roots.length; e++) {
        const r = this._roots[e];
        if (r === n) break;
        a += this._idToElement.get(r).weight;
      }
      return a;
    }
    getOwnersListForElement(e) {
      const r = [],
        t = this._idToElement.get(e);
      if (null != t) {
        r.push({
          ...t,
          depth: 0
        });
        const n = this._ownersMap.get(e);
        if (void 0 !== n) {
          const t = new Map([[e, 0]]);
          Array.from(n).sort((e, r) => this.getIndexOfElementID(e) - this.getIndexOfElementID(r)).forEach(a => {
            const i = this._idToElement.get(a);
            if (null != i) {
              let o = i.parentID,
                s = 0;
              for (; o > 0;) {
                if (o === e || n.has(o)) {
                  s = t.get(o) + 1, t.set(a, s);
                  break;
                }
                const r = this._idToElement.get(o);
                if (null == r) break;
                o = r.parentID;
              }
              0 === s && this._throwAndEmitError(Error("Invalid owners list")), r.push({
                ...i,
                depth: s
              });
            }
          });
        }
      }
      return r;
    }
    getRendererIDForElement(e) {
      let r = this._idToElement.get(e);
      for (; null != r;) {
        if (0 === r.parentID) {
          const e = this._rootIDToRendererID.get(r.id);
          return null == e ? null : e;
        }
        r = this._idToElement.get(r.parentID);
      }
      return null;
    }
    getRootIDForElement(e) {
      let r = this._idToElement.get(e);
      for (; null != r;) {
        if (0 === r.parentID) return r.id;
        r = this._idToElement.get(r.parentID);
      }
      return null;
    }
    isInsideCollapsedSubTree(e) {
      let r = this._idToElement.get(e);
      for (; null != r;) {
        if (0 === r.parentID) return !1;
        if (r = this._idToElement.get(r.parentID), null != r && r.isCollapsed) return !0;
      }
      return !1;
    }
    toggleIsCollapsed(e, r) {
      let t = !1;
      const n = this.getElementByID(e);
      if (null !== n) {
        if (r) {
          if (11 === n.type && this._throwAndEmitError(Error("Root nodes cannot be collapsed")), !n.isCollapsed) {
            t = !0, n.isCollapsed = !0;
            const e = 1 - n.weight;
            let r = this._idToElement.get(n.parentID);
            for (; null != r;) r.weight += e, r = this._idToElement.get(r.parentID);
          }
        } else {
          let e = n;
          for (; null != e;) {
            const r = e.isCollapsed ? 1 : e.weight;
            if (e.isCollapsed) {
              t = !0, e.isCollapsed = !1;
              const n = (e.isCollapsed ? 1 : e.weight) - r;
              let a = this._idToElement.get(e.parentID);
              for (; null != a && (a.weight += n, !a.isCollapsed);) a = this._idToElement.get(a.parentID);
            }
            e = 0 !== e.parentID ? this.getElementByID(e.parentID) : null;
          }
        }
        if (t) {
          let e = 0;
          this._roots.forEach(r => {
            const {
              weight: t
            } = this.getElementByID(r);
            e += t;
          }), this._weightAcrossRoots = e, this.emit("mutated", [[], new Map()]);
        }
      }
    }
    _recursivelyUpdateSubtree(e, r) {
      const t = this._idToElement.get(e);
      t && (r(t), t.children.forEach(e => this._recursivelyUpdateSubtree(e, r)));
    }
    _throwAndEmitError(e) {
      throw this.emit("error", e), e;
    }
  }
  var qe = t(15),
    Qe = t(8);
  let Ze = null,
    Je = [];
  function er(e, r) {
    async function t(t) {
      if (Qe.b) if (null != Ze) {
        let n = null;
        null != t.metadata && (n = t.metadata, delete t.metadata), Ze.contentWindow.postMessage({
          source: "react-devtools-logging",
          event: t,
          context: {
            surface: e,
            version: "4.27.2-7f747b80e",
            metadata: null !== n ? JSON.stringify(n) : "",
            ...(null != r ? await r() : {})
          }
        }, "*");
      } else Je.push(t);
    }
    if (Qe.b) {
      const e = "null",
        r = document.body;
      if ("string" == typeof e && e.length > 0 && null != r) {
        Object(qe.b)(t);
        const n = document.createElement("iframe");
        n.src = e, n.onload = function (...e) {
          !function (e) {
            null == Ze && (Ze = e, Je.length > 0 && (Je.forEach(e => t(e)), Je = []));
          }(n);
        }, r.appendChild(n);
      }
    }
  }
  var rr = t(86),
    tr = t(40),
    nr = t(44),
    ar = t(11);
  const ir = (e, r) => {
      const t = sr(e),
        n = sr(r),
        a = t.pop(),
        i = n.pop(),
        o = fr(t, n);
      return 0 !== o ? o : a && i ? fr(a.split("."), i.split(".")) : a || i ? a ? -1 : 1 : 0;
    },
    or = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i,
    sr = e => {
      if ("string" != typeof e) throw new TypeError("Invalid argument expected string");
      const r = e.match(or);
      if (!r) throw new Error(`Invalid argument not valid semver ('${e}' received)`);
      return r.shift(), r;
    },
    lr = e => "*" === e || "x" === e || "X" === e,
    cr = e => {
      const r = parseInt(e, 10);
      return isNaN(r) ? e : r;
    },
    ur = (e, r) => {
      if (lr(e) || lr(r)) return 0;
      const [t, n] = ((e, r) => typeof e != typeof r ? [String(e), String(r)] : [e, r])(cr(e), cr(r));
      return t > n ? 1 : t < n ? -1 : 0;
    },
    fr = (e, r) => {
      for (let t = 0; t < Math.max(e.length, r.length); t++) {
        const n = ur(e[t] || "0", r[t] || "0");
        if (0 !== n) return n;
      }
      return 0;
    },
    dr = {
      ">": [1],
      ">=": [0, 1],
      "=": [0],
      "<=": [-1, 0],
      "<": [-1]
    },
    vr = (Object.keys(dr), Array.isArray);
  var hr = function (e) {
    return vr(e);
  };
  function mr(e = "", r = "") {
    return 1 === ir(e, r);
  }
  function _r(e = "", r = "") {
    return ir(e, r) > -1;
  }
  t(87);
  "function" == typeof Object.is && Object.is;
  var pr = Object.prototype.hasOwnProperty;
  new Map();
  let gr,
    br,
    Sr,
    Er,
    wr,
    yr,
    kr,
    Cr,
    Dr = 0;
  function Ar() {}
  function Mr(e, r) {
    if (void 0 === Cr) try {
      throw Error();
    } catch (e) {
      const r = e.stack.trim().match(/\n( *(at )?)/);
      Cr = r && r[1] || "";
    }
    return "\n" + Cr + e;
  }
  Ar.__reactDisabledLog = !0;
  let xr = !1;
  function Or(e, r, t) {
    if (!e || xr) return "";
    let n;
    const a = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0, xr = !0;
    const i = t.current;
    t.current = null, function () {
      if (0 === Dr) {
        gr = console.log, br = console.info, Sr = console.warn, Er = console.error, wr = console.group, yr = console.groupCollapsed, kr = console.groupEnd;
        const e = {
          configurable: !0,
          enumerable: !0,
          value: Ar,
          writable: !0
        };
        Object.defineProperties(console, {
          info: e,
          log: e,
          warn: e,
          error: e,
          group: e,
          groupCollapsed: e,
          groupEnd: e
        });
      }
      Dr++;
    }();
    try {
      if (r) {
        const r = function () {
          throw Error();
        };
        if (Object.defineProperty(r.prototype, "props", {
          set: function () {
            throw Error();
          }
        }), "object" == typeof Reflect && Reflect.construct) {
          try {
            Reflect.construct(r, []);
          } catch (e) {
            n = e;
          }
          Reflect.construct(e, [], r);
        } else {
          try {
            r.call();
          } catch (e) {
            n = e;
          }
          e.call(r.prototype);
        }
      } else {
        try {
          throw Error();
        } catch (e) {
          n = e;
        }
        e();
      }
    } catch (e) {
      if (e && n && "string" == typeof e.stack) {
        const r = e.stack.split("\n"),
          t = n.stack.split("\n");
        let a = r.length - 1,
          i = t.length - 1;
        for (; a >= 1 && i >= 0 && r[a] !== t[i];) i--;
        for (; a >= 1 && i >= 0; a--, i--) if (r[a] !== t[i]) {
          if (1 !== a || 1 !== i) do {
            if (a--, i--, i < 0 || r[a] !== t[i]) {
              return "\n" + r[a].replace(" at new ", " at ");
            }
          } while (a >= 1 && i >= 0);
          break;
        }
      }
    } finally {
      xr = !1, Error.prepareStackTrace = a, t.current = i, function () {
        if (Dr--, 0 === Dr) {
          const e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: {
              ...e,
              value: gr
            },
            info: {
              ...e,
              value: br
            },
            warn: {
              ...e,
              value: Sr
            },
            error: {
              ...e,
              value: Er
            },
            group: {
              ...e,
              value: wr
            },
            groupCollapsed: {
              ...e,
              value: yr
            },
            groupEnd: {
              ...e,
              value: kr
            }
          });
        }
        Dr < 0 && console.error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }();
    }
    const o = e ? e.displayName || e.name : "";
    return o ? Mr(o) : "";
  }
  function Tr(e, r, t) {
    return Or(e, !1, t);
  }
  function Nr(e, r, t) {
    const {
      HostComponent: n,
      LazyComponent: a,
      SuspenseComponent: i,
      SuspenseListComponent: o,
      FunctionComponent: s,
      IndeterminateComponent: l,
      SimpleMemoComponent: c,
      ForwardRef: u,
      ClassComponent: f
    } = e;
    switch (r.tag) {
      case n:
        return Mr(r.type);
      case a:
        return Mr("Lazy");
      case i:
        return Mr("Suspense");
      case o:
        return Mr("SuspenseList");
      case s:
      case l:
      case c:
        return Tr(r.type, 0, t);
      case u:
        return Tr(r.type.render, 0, t);
      case f:
        return function (e, r, t) {
          return Or(e, !0, t);
        }(r.type, 0, t);
      default:
        return "";
    }
  }
  function Rr(e, r, t) {
    try {
      let n = "",
        a = r;
      do {
        n += Nr(e, a, t), a = a.return;
      } while (a);
      return n;
    } catch (e) {
      return "\nError generating stack: " + e.message + "\n" + e.stack;
    }
  }
  let Ir = null,
    Hr = "undefined" != typeof performance && "function" == typeof performance.mark && "function" == typeof performance.clearMarks,
    Fr = !1;
  if (Hr) {
    const e = "__v3",
      r = {};
    Object.defineProperty(r, "startTime", {
      get: function () {
        return Fr = !0, 0;
      },
      set: function () {}
    });
    try {
      performance.mark(e, r);
    } catch (e) {} finally {
      performance.clearMarks(e);
    }
  }
  Fr && (Ir = performance);
  "object" == typeof performance && performance.now;
  "object" == typeof performance && performance.now;
  function Lr(e) {
    let r = {
      ImmediatePriority: 99,
      UserBlockingPriority: 98,
      NormalPriority: 97,
      LowPriority: 96,
      IdlePriority: 95,
      NoPriority: 90
    };
    mr(e, "17.0.2") && (r = {
      ImmediatePriority: 1,
      UserBlockingPriority: 2,
      NormalPriority: 3,
      LowPriority: 4,
      IdlePriority: 5,
      NoPriority: 0
    });
    let t = 0;
    _r(e, "18.0.0-alpha") ? t = 24 : _r(e, "16.9.0") ? t = 1 : _r(e, "16.3.0") && (t = 2);
    let n = null;
    function a(e) {
      const r = "object" == typeof e && null !== e ? e.$$typeof : e;
      return "symbol" == typeof r ? r.toString() : r;
    }
    n = mr(e, "17.0.1") ? {
      CacheComponent: 24,
      ClassComponent: 1,
      ContextConsumer: 9,
      ContextProvider: 10,
      CoroutineComponent: -1,
      CoroutineHandlerPhase: -1,
      DehydratedSuspenseComponent: 18,
      ForwardRef: 11,
      Fragment: 7,
      FunctionComponent: 0,
      HostComponent: 5,
      HostPortal: 4,
      HostRoot: 3,
      HostResource: 26,
      HostSingleton: 27,
      HostText: 6,
      IncompleteClassComponent: 17,
      IndeterminateComponent: 2,
      LazyComponent: 16,
      LegacyHiddenComponent: 23,
      MemoComponent: 14,
      Mode: 8,
      OffscreenComponent: 22,
      Profiler: 12,
      ScopeComponent: 21,
      SimpleMemoComponent: 15,
      SuspenseComponent: 13,
      SuspenseListComponent: 19,
      TracingMarkerComponent: 25,
      YieldComponent: -1
    } : _r(e, "17.0.0-alpha") ? {
      CacheComponent: -1,
      ClassComponent: 1,
      ContextConsumer: 9,
      ContextProvider: 10,
      CoroutineComponent: -1,
      CoroutineHandlerPhase: -1,
      DehydratedSuspenseComponent: 18,
      ForwardRef: 11,
      Fragment: 7,
      FunctionComponent: 0,
      HostComponent: 5,
      HostPortal: 4,
      HostRoot: 3,
      HostResource: -1,
      HostSingleton: -1,
      HostText: 6,
      IncompleteClassComponent: 17,
      IndeterminateComponent: 2,
      LazyComponent: 16,
      LegacyHiddenComponent: 24,
      MemoComponent: 14,
      Mode: 8,
      OffscreenComponent: 23,
      Profiler: 12,
      ScopeComponent: 21,
      SimpleMemoComponent: 15,
      SuspenseComponent: 13,
      SuspenseListComponent: 19,
      TracingMarkerComponent: -1,
      YieldComponent: -1
    } : _r(e, "16.6.0-beta.0") ? {
      CacheComponent: -1,
      ClassComponent: 1,
      ContextConsumer: 9,
      ContextProvider: 10,
      CoroutineComponent: -1,
      CoroutineHandlerPhase: -1,
      DehydratedSuspenseComponent: 18,
      ForwardRef: 11,
      Fragment: 7,
      FunctionComponent: 0,
      HostComponent: 5,
      HostPortal: 4,
      HostRoot: 3,
      HostResource: -1,
      HostSingleton: -1,
      HostText: 6,
      IncompleteClassComponent: 17,
      IndeterminateComponent: 2,
      LazyComponent: 16,
      LegacyHiddenComponent: -1,
      MemoComponent: 14,
      Mode: 8,
      OffscreenComponent: -1,
      Profiler: 12,
      ScopeComponent: -1,
      SimpleMemoComponent: 15,
      SuspenseComponent: 13,
      SuspenseListComponent: 19,
      TracingMarkerComponent: -1,
      YieldComponent: -1
    } : _r(e, "16.4.3-alpha") ? {
      CacheComponent: -1,
      ClassComponent: 2,
      ContextConsumer: 11,
      ContextProvider: 12,
      CoroutineComponent: -1,
      CoroutineHandlerPhase: -1,
      DehydratedSuspenseComponent: -1,
      ForwardRef: 13,
      Fragment: 9,
      FunctionComponent: 0,
      HostComponent: 7,
      HostPortal: 6,
      HostRoot: 5,
      HostResource: -1,
      HostSingleton: -1,
      HostText: 8,
      IncompleteClassComponent: -1,
      IndeterminateComponent: 4,
      LazyComponent: -1,
      LegacyHiddenComponent: -1,
      MemoComponent: -1,
      Mode: 10,
      OffscreenComponent: -1,
      Profiler: 15,
      ScopeComponent: -1,
      SimpleMemoComponent: -1,
      SuspenseComponent: 16,
      SuspenseListComponent: -1,
      TracingMarkerComponent: -1,
      YieldComponent: -1
    } : {
      CacheComponent: -1,
      ClassComponent: 2,
      ContextConsumer: 12,
      ContextProvider: 13,
      CoroutineComponent: 7,
      CoroutineHandlerPhase: 8,
      DehydratedSuspenseComponent: -1,
      ForwardRef: 14,
      Fragment: 10,
      FunctionComponent: 1,
      HostComponent: 5,
      HostPortal: 4,
      HostRoot: 3,
      HostResource: -1,
      HostSingleton: -1,
      HostText: 6,
      IncompleteClassComponent: -1,
      IndeterminateComponent: 0,
      LazyComponent: -1,
      LegacyHiddenComponent: -1,
      MemoComponent: -1,
      Mode: 11,
      OffscreenComponent: -1,
      Profiler: 15,
      ScopeComponent: -1,
      SimpleMemoComponent: -1,
      SuspenseComponent: 16,
      SuspenseListComponent: -1,
      TracingMarkerComponent: -1,
      YieldComponent: 9
    };
    const {
      CacheComponent: i,
      ClassComponent: o,
      IncompleteClassComponent: s,
      FunctionComponent: l,
      IndeterminateComponent: c,
      ForwardRef: u,
      HostRoot: f,
      HostResource: d,
      HostSingleton: v,
      HostComponent: h,
      HostPortal: m,
      HostText: _,
      Fragment: p,
      LazyComponent: g,
      LegacyHiddenComponent: b,
      MemoComponent: S,
      OffscreenComponent: E,
      Profiler: w,
      ScopeComponent: y,
      SimpleMemoComponent: k,
      SuspenseComponent: C,
      SuspenseListComponent: D,
      TracingMarkerComponent: A
    } = n;
    return {
      getDisplayNameForFiber: function (e) {
        const {
          elementType: r,
          type: t,
          tag: n
        } = e;
        let M = t;
        "object" == typeof t && null !== t && (M = function e(r) {
          switch (a(r)) {
            case 60115:
            case "Symbol(react.memo)":
              return e(r.type);
            case 60112:
            case "Symbol(react.forward_ref)":
              return r.render;
            default:
              return r;
          }
        }(t));
        let x = null;
        switch (n) {
          case i:
            return "Cache";
          case o:
          case s:
            return T(M);
          case l:
          case c:
            return T(M);
          case u:
            return O(r, M, "ForwardRef", "Anonymous");
          case f:
            const n = e.stateNode;
            return null != n && null !== n._debugRootType ? n._debugRootType : null;
          case h:
          case v:
          case d:
            return t;
          case m:
          case _:
            return null;
          case p:
            return "Fragment";
          case g:
            return "Lazy";
          case S:
          case k:
            return O(r, M, "Memo", "Anonymous");
          case C:
            return "Suspense";
          case b:
            return "LegacyHidden";
          case E:
            return "Offscreen";
          case y:
            return "Scope";
          case D:
            return "SuspenseList";
          case w:
            return "Profiler";
          case A:
            return "TracingMarker";
          default:
            switch (a(t)) {
              case 60111:
              case "Symbol(react.concurrent_mode)":
              case "Symbol(react.async_mode)":
                return null;
              case 60109:
              case "Symbol(react.provider)":
                return x = e.type._context || e.type.context, (x.displayName || "Context") + ".Provider";
              case 60110:
              case "Symbol(react.context)":
              case "Symbol(react.server_context)":
                return x = e.type._context || e.type, (x.displayName || "Context") + ".Consumer";
              case 60108:
              case "Symbol(react.strict_mode)":
                return null;
              case 60114:
              case "Symbol(react.profiler)":
                return `Profiler(${e.memoizedProps.id})`;
              case 60119:
              case "Symbol(react.scope)":
                return "Scope";
              default:
                return null;
            }
        }
      },
      getTypeSymbol: a,
      ReactPriorityLevels: r,
      ReactTypeOfWork: n,
      StrictModeBits: t
    };
  }
  new Map(), new Map();
  const Pr = ["error", "trace", "warn"],
    zr = /\s{4}(in|at)\s{1}/,
    Br = /:\d+:\d+(\n|$)/;
  const jr = /^%c/;
  function Vr(e, r) {
    return e.length >= 2 && jr.test(e[0]) && e[1] === "color: " + (Ur(r) || "");
  }
  function Ur(e) {
    switch (e) {
      case "warn":
        return "light" === qr.browserTheme ? "rgba(250, 180, 50, 0.75)" : "rgba(250, 180, 50, 0.5)";
      case "error":
        return "light" === qr.browserTheme ? "rgba(250, 123, 130, 0.75)" : "rgba(250, 123, 130, 0.5)";
      case "log":
      default:
        return "light" === qr.browserTheme ? "rgba(125, 125, 125, 0.75)" : "rgba(125, 125, 125, 0.5)";
    }
  }
  const Wr = new Map();
  let $r = console,
    Xr = {};
  for (const e in console) Xr[e] = console[e];
  let Gr = null,
    Kr = !1;
  try {
    Kr = void 0 === _global;
  } catch (e) {}
  function Yr(e, r) {
    const {
      currentDispatcherRef: t,
      getCurrentFiber: n,
      findFiberByHostInstance: a,
      version: i
    } = e;
    if ("function" == typeof a && null != t && "function" == typeof n) {
      const {
        ReactTypeOfWork: a
      } = Lr(i);
      Wr.set(e, {
        currentDispatcherRef: t,
        getCurrentFiber: n,
        workTagMap: a,
        onErrorOrWarning: r
      });
    }
  }
  const qr = {
    appendComponentStack: !1,
    breakOnConsoleErrors: !1,
    showInlineWarningsAndErrors: !1,
    hideConsoleLogsInStrictMode: !1,
    browserTheme: "dark"
  };
  function Qr({
    appendComponentStack: e,
    breakOnConsoleErrors: r,
    showInlineWarningsAndErrors: t,
    hideConsoleLogsInStrictMode: n,
    browserTheme: a
  }) {
    if (qr.appendComponentStack = e, qr.breakOnConsoleErrors = r, qr.showInlineWarningsAndErrors = t, qr.hideConsoleLogsInStrictMode = n, qr.browserTheme = a, e || r || t) {
      if (null !== Gr) return;
      const e = {};
      Gr = () => {
        for (const r in e) try {
          $r[r] = e[r];
        } catch (e) {}
      }, Pr.forEach(r => {
        try {
          const t = e[r] = $r[r].__REACT_DEVTOOLS_ORIGINAL_METHOD__ ? $r[r].__REACT_DEVTOOLS_ORIGINAL_METHOD__ : $r[r],
            n = (...e) => {
              let n = !1;
              if ("log" !== r && qr.appendComponentStack) {
                const r = e.length > 0 ? e[e.length - 1] : null;
                n = !("string" == typeof r && (a = r, zr.test(a) || Br.test(a)));
              }
              var a;
              const i = qr.showInlineWarningsAndErrors && ("error" === r || "warn" === r);
              for (const {
                currentDispatcherRef: t,
                getCurrentFiber: a,
                onErrorOrWarning: o,
                workTagMap: s
              } of Wr.values()) {
                const l = a();
                if (null != l) try {
                  if (i && "function" == typeof o && o(l, r, e.slice()), n) {
                    const n = Rr(s, l, t);
                    "" !== n && (Vr(e, r) ? (e[0] = e[0] + " %s", e.push(n)) : e.push(n));
                  }
                } catch (e) {
                  setTimeout(() => {
                    throw e;
                  }, 0);
                } finally {
                  break;
                }
              }
              qr.breakOnConsoleErrors, t(...e);
            };
          n.__REACT_DEVTOOLS_ORIGINAL_METHOD__ = t, t.__REACT_DEVTOOLS_OVERRIDE_METHOD__ = n, $r[r] = n;
        } catch (e) {}
      });
    } else null !== Gr && (Gr(), Gr = null);
  }
  function Zr() {
    var e, r, t, n, a;
    Qr({
      appendComponentStack: null === (e = F(window.__REACT_DEVTOOLS_APPEND_COMPONENT_STACK__)) || void 0 === e || e,
      breakOnConsoleErrors: null !== (r = F(window.__REACT_DEVTOOLS_BREAK_ON_CONSOLE_ERRORS__)) && void 0 !== r && r,
      showInlineWarningsAndErrors: null === (t = F(window.__REACT_DEVTOOLS_SHOW_INLINE_WARNINGS_AND_ERRORS__)) || void 0 === t || t,
      hideConsoleLogsInStrictMode: null !== (n = F(window.__REACT_DEVTOOLS_HIDE_CONSOLE_LOGS_IN_STRICT_MODE__)) && void 0 !== n && n,
      browserTheme: null !== (a = function (e) {
        if ("light" === e || "dark" === e || "auto" === e) return e;
      }(window.__REACT_DEVTOOLS_BROWSER_THEME__)) && void 0 !== a ? a : "dark"
    });
  }
  t(127), t(130);
  const Jr = Object(a.createContext)(null);
  Jr.displayName = "BridgeContext";
  const et = Object(a.createContext)(null);
  et.displayName = "StoreContext";
  const rt = Object(a.createContext)({
    isEnabledForInspectedElement: !1,
    viewAttributeSourceFunction: null
  });
  rt.displayName = "ContextMenuContext";
  const tt = Object(a.createContext)({
    readOnly: !1,
    hideSettings: !1,
    hideToggleErrorAction: !1,
    hideToggleSuspenseAction: !1,
    hideLogAction: !1,
    hideViewSourceAction: !1
  });
  var nt = function (e, r) {
      if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
    },
    at = function () {
      function e(e, r) {
        for (var t = 0; t < r.length; t++) {
          var n = r[t];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }
      return function (r, t, n) {
        return t && e(r.prototype, t), n && e(r, n), r;
      };
    }(),
    it = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    },
    ot = function (e, r) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !r || "object" != typeof r && "function" != typeof r ? e : r;
    },
    st = function (e, r) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, r) {
        var t = [],
          n = !0,
          a = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(n = (o = s.next()).done) && (t.push(o.value), !r || t.length !== r); n = !0);
        } catch (e) {
          a = !0, i = e;
        } finally {
          try {
            !n && s.return && s.return();
          } finally {
            if (a) throw i;
          }
        }
        return t;
      }(e, r);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    lt = void 0;
  lt = "undefined" != typeof window ? window : "undefined" != typeof self ? self : _global;
  var ct = null,
    ut = null,
    ft = lt.clearTimeout,
    dt = lt.setTimeout,
    vt = lt.cancelAnimationFrame || lt.mozCancelAnimationFrame || lt.webkitCancelAnimationFrame,
    ht = lt.requestAnimationFrame || lt.mozRequestAnimationFrame || lt.webkitRequestAnimationFrame;
  function mt(e) {
    var r = void 0,
      t = void 0,
      n = void 0,
      a = void 0,
      i = void 0,
      o = void 0,
      s = void 0,
      l = "undefined" != typeof document && document.attachEvent;
    if (!l) {
      o = function (e) {
        var r = e.__resizeTriggers__,
          t = r.firstElementChild,
          n = r.lastElementChild,
          a = t.firstElementChild;
        n.scrollLeft = n.scrollWidth, n.scrollTop = n.scrollHeight, a.style.width = t.offsetWidth + 1 + "px", a.style.height = t.offsetHeight + 1 + "px", t.scrollLeft = t.scrollWidth, t.scrollTop = t.scrollHeight;
      }, i = function (e) {
        return e.offsetWidth !== e.__resizeLast__.width || e.offsetHeight !== e.__resizeLast__.height;
      }, s = function (e) {
        if (!(e.target.className && "function" == typeof e.target.className.indexOf && e.target.className.indexOf("contract-trigger") < 0 && e.target.className.indexOf("expand-trigger") < 0)) {
          var r = this || _global;
          o(this || _global), (this || _global).__resizeRAF__ && ct((this || _global).__resizeRAF__), (this || _global).__resizeRAF__ = ut(function () {
            i(r) && (r.__resizeLast__.width = r.offsetWidth, r.__resizeLast__.height = r.offsetHeight, r.__resizeListeners__.forEach(function (t) {
              t.call(r, e);
            }));
          });
        }
      };
      var c = !1,
        u = "";
      n = "animationstart";
      var f = "Webkit Moz O ms".split(" "),
        d = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "),
        v = document.createElement("fakeelement");
      if (void 0 !== v.style.animationName && (c = !0), !1 === c) for (var h = 0; h < f.length; h++) if (void 0 !== v.style[f[h] + "AnimationName"]) {
        u = "-" + f[h].toLowerCase() + "-", n = d[h], c = !0;
        break;
      }
      r = "@" + u + "keyframes " + (t = "resizeanim") + " { from { opacity: 0; } to { opacity: 0; } } ", a = u + "animation: 1ms " + t + "; ";
    }
    return {
      addResizeListener: function (i, c) {
        if (l) i.attachEvent("onresize", c);else {
          if (!i.__resizeTriggers__) {
            var u = i.ownerDocument,
              f = lt.getComputedStyle(i);
            f && "static" === f.position && (i.style.position = "relative"), function (t) {
              if (!t.getElementById("detectElementResize")) {
                var n = (r || "") + ".resize-triggers { " + (a || "") + "visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }",
                  i = t.head || t.getElementsByTagName("head")[0],
                  o = t.createElement("style");
                o.id = "detectElementResize", o.type = "text/css", null != e && o.setAttribute("nonce", e), o.styleSheet ? o.styleSheet.cssText = n : o.appendChild(t.createTextNode(n)), i.appendChild(o);
              }
            }(u), i.__resizeLast__ = {}, i.__resizeListeners__ = [], (i.__resizeTriggers__ = u.createElement("div")).className = "resize-triggers";
            var d = u.createElement("div");
            d.className = "expand-trigger", d.appendChild(u.createElement("div"));
            var v = u.createElement("div");
            v.className = "contract-trigger", i.__resizeTriggers__.appendChild(d), i.__resizeTriggers__.appendChild(v), i.appendChild(i.__resizeTriggers__), o(i), i.addEventListener("scroll", s, !0), n && (i.__resizeTriggers__.__animationListener__ = function (e) {
              e.animationName === t && o(i);
            }, i.__resizeTriggers__.addEventListener(n, i.__resizeTriggers__.__animationListener__));
          }
          i.__resizeListeners__.push(c);
        }
      },
      removeResizeListener: function (e, r) {
        if (l) e.detachEvent("onresize", r);else if (e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(r), 1), !e.__resizeListeners__.length) {
          e.removeEventListener("scroll", s, !0), e.__resizeTriggers__.__animationListener__ && (e.__resizeTriggers__.removeEventListener(n, e.__resizeTriggers__.__animationListener__), e.__resizeTriggers__.__animationListener__ = null);
          try {
            e.__resizeTriggers__ = !e.removeChild(e.__resizeTriggers__);
          } catch (e) {}
        }
      }
    };
  }
  null == vt || null == ht ? (ct = ft, ut = function (e) {
    return dt(e, 20);
  }) : (ct = function (e) {
    var r = st(e, 2),
      t = r[0],
      n = r[1];
    vt(t), ft(n);
  }, ut = function (e) {
    var r = ht(function () {
        ft(t), e();
      }),
      t = dt(function () {
        vt(r), e();
      }, 20);
    return [r, t];
  });
  var _t = function (e) {
    function r() {
      var e, t, n;
      nt(this || _global, r);
      for (var a = arguments.length, i = Array(a), o = 0; o < a; o++) i[o] = arguments[o];
      return t = n = ot(this || _global, (e = r.__proto__ || Object.getPrototypeOf(r)).call.apply(e, [this || _global].concat(i))), n.state = {
        height: n.props.defaultHeight || 0,
        width: n.props.defaultWidth || 0
      }, n._onResize = function () {
        var e = n.props,
          r = e.disableHeight,
          t = e.disableWidth,
          a = e.onResize;
        if (n._parentNode) {
          var i = n._parentNode.offsetHeight || 0,
            o = n._parentNode.offsetWidth || 0,
            s = window.getComputedStyle(n._parentNode) || {},
            l = parseInt(s.paddingLeft, 10) || 0,
            c = parseInt(s.paddingRight, 10) || 0,
            u = parseInt(s.paddingTop, 10) || 0,
            f = parseInt(s.paddingBottom, 10) || 0,
            d = i - u - f,
            v = o - l - c;
          (!r && n.state.height !== d || !t && n.state.width !== v) && (n.setState({
            height: i - u - f,
            width: o - l - c
          }), a({
            height: i,
            width: o
          }));
        }
      }, n._setRef = function (e) {
        n._autoSizer = e;
      }, ot(n, t);
    }
    return function (e, r) {
      if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function, not " + typeof r);
      e.prototype = Object.create(r && r.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(e, r) : e.__proto__ = r);
    }(r, e), at(r, [{
      key: "componentDidMount",
      value: function () {
        var e = (this || _global).props.nonce;
        (this || _global)._autoSizer && (this || _global)._autoSizer.parentNode && (this || _global)._autoSizer.parentNode.ownerDocument && (this || _global)._autoSizer.parentNode.ownerDocument.defaultView && (this || _global)._autoSizer.parentNode instanceof (this || _global)._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement && ((this || _global)._parentNode = (this || _global)._autoSizer.parentNode, (this || _global)._detectElementResize = mt(e), (this || _global)._detectElementResize.addResizeListener((this || _global)._parentNode, (this || _global)._onResize), this._onResize());
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        (this || _global)._detectElementResize && (this || _global)._parentNode && (this || _global)._detectElementResize.removeResizeListener((this || _global)._parentNode, (this || _global)._onResize);
      }
    }, {
      key: "render",
      value: function () {
        var e = (this || _global).props,
          r = e.children,
          t = e.className,
          n = e.disableHeight,
          i = e.disableWidth,
          o = e.style,
          s = (this || _global).state,
          l = s.height,
          c = s.width,
          u = {
            overflow: "visible"
          },
          f = {},
          d = !1;
        return n || (0 === l && (d = !0), u.height = 0, f.height = l), i || (0 === c && (d = !0), u.width = 0, f.width = c), Object(a.createElement)("div", {
          className: t,
          ref: (this || _global)._setRef,
          style: it({}, u, o)
        }, !d && r(f));
      }
    }]), r;
  }(a.PureComponent);
  _t.defaultProps = {
    onResize: function () {},
    disableHeight: !1,
    disableWidth: !1,
    style: {}
  };
  var pt = _t;
  function gt() {
    return (gt = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }).apply(this || _global, arguments);
  }
  function bt(e, r) {
    e.prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
  }
  function St(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  var Et = function (e, r) {
      return e === r;
    },
    wt = function (e) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Et,
        t = void 0,
        n = [],
        a = void 0,
        i = !1,
        o = function (e, t) {
          return r(e, n[t]);
        },
        s = function () {
          for (var r = arguments.length, s = Array(r), l = 0; l < r; l++) s[l] = arguments[l];
          return i && t === (this || _global) && s.length === n.length && s.every(o) ? a : (i = !0, t = this || _global, n = s, a = e.apply(this || _global, s));
        };
      return s;
    };
  function yt(e, r) {
    if (null == e) return {};
    var t,
      n,
      a = {},
      i = Object.keys(e);
    for (n = 0; n < i.length; n++) t = i[n], r.indexOf(t) >= 0 || (a[t] = e[t]);
    return a;
  }
  var kt = "object" == typeof performance && "function" == typeof performance.now ? function () {
    return performance.now();
  } : function () {
    return Date.now();
  };
  function Ct(e) {
    cancelAnimationFrame(e.id);
  }
  function Dt(e, r) {
    var t = kt();
    var n = {
      id: requestAnimationFrame(function a() {
        kt() - t >= r ? e.call(null) : n.id = requestAnimationFrame(a);
      })
    };
    return n;
  }
  var At = null;
  function Mt(e) {
    if (void 0 === e && (e = !1), null === At || e) {
      var r = document.createElement("div"),
        t = r.style;
      t.width = "50px", t.height = "50px", t.overflow = "scroll", t.direction = "rtl";
      var n = document.createElement("div"),
        a = n.style;
      return a.width = "100px", a.height = "100px", r.appendChild(n), document.body.appendChild(r), r.scrollLeft > 0 ? At = "positive-descending" : (r.scrollLeft = 1, At = 0 === r.scrollLeft ? "negative" : "positive-ascending"), document.body.removeChild(r), At;
    }
    return At;
  }
  var xt = function (e, r) {
    return e;
  };
  function Ot(e) {
    var r,
      t,
      n = e.getItemOffset,
      o = e.getEstimatedTotalSize,
      s = e.getItemSize,
      l = e.getOffsetForIndexAndAlignment,
      c = e.getStartIndexForOffset,
      u = e.getStopIndexForStartIndex,
      f = e.initInstanceProps,
      d = e.shouldResetStyleCacheOnItemSizeChange,
      v = e.validateProps;
    return t = r = function (e) {
      function r(r) {
        var t;
        return (t = e.call(this || _global, r) || this || _global)._instanceProps = f(t.props, St(St(t))), t._outerRef = void 0, t._resetIsScrollingTimeoutId = null, t.state = {
          instance: St(St(t)),
          isScrolling: !1,
          scrollDirection: "forward",
          scrollOffset: "number" == typeof t.props.initialScrollOffset ? t.props.initialScrollOffset : 0,
          scrollUpdateWasRequested: !1
        }, t._callOnItemsRendered = void 0, t._callOnItemsRendered = wt(function (e, r, n, a) {
          return t.props.onItemsRendered({
            overscanStartIndex: e,
            overscanStopIndex: r,
            visibleStartIndex: n,
            visibleStopIndex: a
          });
        }), t._callOnScroll = void 0, t._callOnScroll = wt(function (e, r, n) {
          return t.props.onScroll({
            scrollDirection: e,
            scrollOffset: r,
            scrollUpdateWasRequested: n
          });
        }), t._getItemStyle = void 0, t._getItemStyle = function (e) {
          var r,
            a = t.props,
            i = a.direction,
            o = a.itemSize,
            l = a.layout,
            c = t._getItemStyleCache(d && o, d && l, d && i);
          if (c.hasOwnProperty(e)) r = c[e];else {
            var u,
              f = n(t.props, e, t._instanceProps),
              v = s(t.props, e, t._instanceProps),
              h = "horizontal" === i || "horizontal" === l;
            c[e] = ((u = {
              position: "absolute"
            })["rtl" === i ? "right" : "left"] = h ? f : 0, u.top = h ? 0 : f, u.height = h ? "100%" : v, u.width = h ? v : "100%", r = u);
          }
          return r;
        }, t._getItemStyleCache = void 0, t._getItemStyleCache = wt(function (e, r, t) {
          return {};
        }), t._onScrollHorizontal = function (e) {
          var r = e.currentTarget,
            n = r.clientWidth,
            a = r.scrollLeft,
            o = r.scrollWidth;
          Object(i.flushSync)(() => {
            t.setState(function (e) {
              if (e.scrollOffset === a) return null;
              var r = t.props.direction,
                i = a;
              if ("rtl" === r) switch (Mt()) {
                case "negative":
                  i = -a;
                  break;
                case "positive-descending":
                  i = o - n - a;
              }
              return i = Math.max(0, Math.min(i, o - n)), {
                isScrolling: !0,
                scrollDirection: e.scrollOffset < a ? "forward" : "backward",
                scrollOffset: i,
                scrollUpdateWasRequested: !1
              };
            }, t._resetIsScrollingDebounced);
          });
        }, t._onScrollVertical = function (e) {
          var r = e.currentTarget,
            n = r.clientHeight,
            a = r.scrollHeight,
            o = r.scrollTop;
          Object(i.flushSync)(() => {
            t.setState(function (e) {
              if (e.scrollOffset === o) return null;
              var r = Math.max(0, Math.min(o, a - n));
              return {
                isScrolling: !0,
                scrollDirection: e.scrollOffset < r ? "forward" : "backward",
                scrollOffset: r,
                scrollUpdateWasRequested: !1
              };
            }, t._resetIsScrollingDebounced);
          });
        }, t._outerRefSetter = function (e) {
          var r = t.props.outerRef;
          t._outerRef = e, "function" == typeof r ? r(e) : null != r && "object" == typeof r && r.hasOwnProperty("current") && (r.current = e);
        }, t._resetIsScrollingDebounced = function () {
          null !== t._resetIsScrollingTimeoutId && Ct(t._resetIsScrollingTimeoutId), t._resetIsScrollingTimeoutId = Dt(t._resetIsScrolling, 150);
        }, t._resetIsScrolling = function () {
          t._resetIsScrollingTimeoutId = null, t.setState({
            isScrolling: !1
          }, function () {
            t._getItemStyleCache(-1, null);
          });
        }, t;
      }
      bt(r, e), r.getDerivedStateFromProps = function (e, r) {
        return Tt(e, r), v(e), null;
      };
      var t = r.prototype;
      return t.scrollTo = function (e) {
        e = Math.max(0, e), this.setState(function (r) {
          return r.scrollOffset === e ? null : {
            scrollDirection: r.scrollOffset < e ? "forward" : "backward",
            scrollOffset: e,
            scrollUpdateWasRequested: !0
          };
        }, (this || _global)._resetIsScrollingDebounced);
      }, t.scrollToItem = function (e, r) {
        void 0 === r && (r = "auto");
        var t = (this || _global).props.itemCount,
          n = (this || _global).state.scrollOffset;
        e = Math.max(0, Math.min(e, t - 1)), this.scrollTo(l((this || _global).props, e, r, n, (this || _global)._instanceProps));
      }, t.componentDidMount = function () {
        var e = (this || _global).props,
          r = e.direction,
          t = e.initialScrollOffset,
          n = e.layout;
        if ("number" == typeof t && null != (this || _global)._outerRef) {
          var a = (this || _global)._outerRef;
          "horizontal" === r || "horizontal" === n ? a.scrollLeft = t : a.scrollTop = t;
        }
        this._callPropsCallbacks();
      }, t.componentDidUpdate = function () {
        var e = (this || _global).props,
          r = e.direction,
          t = e.layout,
          n = (this || _global).state,
          a = n.scrollOffset;
        if (n.scrollUpdateWasRequested && null != (this || _global)._outerRef) {
          var i = (this || _global)._outerRef;
          if ("horizontal" === r || "horizontal" === t) {
            if ("rtl" === r) switch (Mt()) {
              case "negative":
                i.scrollLeft = -a;
                break;
              case "positive-ascending":
                i.scrollLeft = a;
                break;
              default:
                var o = i.clientWidth,
                  s = i.scrollWidth;
                i.scrollLeft = s - o - a;
            } else i.scrollLeft = a;
          } else i.scrollTop = a;
        }
        this._callPropsCallbacks();
      }, t.componentWillUnmount = function () {
        null !== (this || _global)._resetIsScrollingTimeoutId && Ct((this || _global)._resetIsScrollingTimeoutId);
      }, t.render = function () {
        var e = (this || _global).props,
          r = e.children,
          t = e.className,
          n = e.direction,
          i = e.height,
          s = e.innerRef,
          l = e.innerElementType,
          c = e.innerTagName,
          u = e.itemCount,
          f = e.itemData,
          d = e.itemKey,
          v = void 0 === d ? xt : d,
          h = e.layout,
          m = e.outerElementType,
          _ = e.outerTagName,
          p = e.style,
          g = e.useIsScrolling,
          b = e.width,
          S = (this || _global).state.isScrolling,
          E = "horizontal" === n || "horizontal" === h,
          w = E ? (this || _global)._onScrollHorizontal : (this || _global)._onScrollVertical,
          y = this._getRangeToRender(),
          k = y[0],
          C = y[1],
          D = [];
        if (u > 0) for (var A = k; A <= C; A++) D.push(Object(a.createElement)(r, {
          data: f,
          key: v(A, f),
          index: A,
          isScrolling: g ? S : void 0,
          style: this._getItemStyle(A)
        }));
        var M = o((this || _global).props, (this || _global)._instanceProps);
        return Object(a.createElement)(m || _ || "div", {
          className: t,
          onScroll: w,
          ref: (this || _global)._outerRefSetter,
          style: gt({
            position: "relative",
            height: i,
            width: b,
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            willChange: "transform",
            direction: n
          }, p)
        }, Object(a.createElement)(l || c || "div", {
          children: D,
          ref: s,
          style: {
            height: E ? "100%" : M,
            pointerEvents: S ? "none" : void 0,
            width: E ? M : "100%"
          }
        }));
      }, t._callPropsCallbacks = function () {
        if ("function" == typeof (this || _global).props.onItemsRendered && (this || _global).props.itemCount > 0) {
          var e = this._getRangeToRender(),
            r = e[0],
            t = e[1],
            n = e[2],
            a = e[3];
          this._callOnItemsRendered(r, t, n, a);
        }
        if ("function" == typeof (this || _global).props.onScroll) {
          var i = (this || _global).state,
            o = i.scrollDirection,
            s = i.scrollOffset,
            l = i.scrollUpdateWasRequested;
          this._callOnScroll(o, s, l);
        }
      }, t._getRangeToRender = function () {
        var e = (this || _global).props,
          r = e.itemCount,
          t = e.overscanCount,
          n = (this || _global).state,
          a = n.isScrolling,
          i = n.scrollDirection,
          o = n.scrollOffset;
        if (0 === r) return [0, 0, 0, 0];
        var s = c((this || _global).props, o, (this || _global)._instanceProps),
          l = u((this || _global).props, s, o, (this || _global)._instanceProps),
          f = a && "backward" !== i ? 1 : Math.max(1, t),
          d = a && "forward" !== i ? 1 : Math.max(1, t);
        return [Math.max(0, s - f), Math.max(0, Math.min(r - 1, l + d)), s, l];
      }, r;
    }(a.PureComponent), r.defaultProps = {
      direction: "ltr",
      itemData: void 0,
      layout: "vertical",
      overscanCount: 2,
      useIsScrolling: !1
    }, t;
  }
  var Tt = function (e, r) {
      e.children, e.direction, e.height, e.layout, e.innerTagName, e.outerTagName, e.width, r.instance;
    },
    Nt = Ot({
      getItemOffset: function (e, r) {
        return r * e.itemSize;
      },
      getItemSize: function (e, r) {
        return e.itemSize;
      },
      getEstimatedTotalSize: function (e) {
        var r = e.itemCount;
        return e.itemSize * r;
      },
      getOffsetForIndexAndAlignment: function (e, r, t, n) {
        var a = e.direction,
          i = e.height,
          o = e.itemCount,
          s = e.itemSize,
          l = e.layout,
          c = e.width,
          u = "horizontal" === a || "horizontal" === l ? c : i,
          f = Math.max(0, o * s - u),
          d = Math.min(f, r * s),
          v = Math.max(0, r * s - u + s);
        switch ("smart" === t && (t = n >= v - u && n <= d + u ? "auto" : "center"), t) {
          case "start":
            return d;
          case "end":
            return v;
          case "center":
            var h = Math.round(v + (d - v) / 2);
            return h < Math.ceil(u / 2) ? 0 : h > f + Math.floor(u / 2) ? f : h;
          case "auto":
          default:
            return n >= v && n <= d ? n : n < v ? v : d;
        }
      },
      getStartIndexForOffset: function (e, r) {
        var t = e.itemCount,
          n = e.itemSize;
        return Math.max(0, Math.min(t - 1, Math.floor(r / n)));
      },
      getStopIndexForStartIndex: function (e, r, t) {
        var n = e.direction,
          a = e.height,
          i = e.itemCount,
          o = e.itemSize,
          s = e.layout,
          l = e.width,
          c = r * o,
          u = "horizontal" === n || "horizontal" === s ? l : a,
          f = Math.ceil((u + t - c) / o);
        return Math.max(0, Math.min(i - 1, r + f - 1));
      },
      initInstanceProps: function (e) {},
      shouldResetStyleCacheOnItemSizeChange: !0,
      validateProps: function (e) {
        e.itemSize;
      }
    });
  function Rt(e, r) {
    for (var t in e) if (!(t in r)) return !0;
    for (var n in r) if (e[n] !== r[n]) return !0;
    return !1;
  }
  function It(e, r) {
    var t = e.style,
      n = yt(e, ["style"]),
      a = r.style,
      i = yt(r, ["style"]);
    return !Rt(t, a) && !Rt(n, i);
  }
  var Ht = t(88),
    Ft = t.n(Ht);
  const Lt = Object.prototype.hasOwnProperty;
  function Pt(e, r) {
    const t = e[0],
      n = r[0];
    return String(+t) === t ? String(+n) !== n || +t < +n ? -1 : 1 : t < n ? -1 : 1;
  }
  function zt(e) {
    if ("/" === e[0]) {
      "/" === (e = e.substring(1))[e.length - 1] && (e = e.substring(0, e.length - 1));
      try {
        return new RegExp(e, "i");
      } catch (e) {
        return new RegExp(".^");
      }
    }
    function r(e) {
      return e.toLowerCase() !== e.toUpperCase();
    }
    function t(e) {
      return r(e) ? "[" + e.toLowerCase() + e.toUpperCase() + "]" : e;
    }
    const n = Ft()(e),
      a = n[0];
    let i = "";
    for (let e = 1; e < n.length; e++) i += t(n[e]);
    return r(a) ? new RegExp("(^" + t(a) + "|" + a.toUpperCase() + ")" + i) : new RegExp(a + i);
  }
  function Bt(e) {
    return Lt.call(e, E.preview_long) ? e[E.preview_long] : W(e, !0);
  }
  function jt(e) {
    for (const r in e) {
      const t = e[r];
      t && t[E.type] ? e[r] = Bt(t) : null != t && (C(t) || "object" == typeof t) && jt(t);
    }
  }
  function Vt(e) {
    const r = Object.assign({}, e);
    jt(r);
    try {
      return JSON.stringify(r, null, 2);
    } catch (e) {
      return "";
    }
  }
  let Ut = null;
  const Wt = Object(a.createContext)(null);
  Wt.displayName = "TreeStateContext";
  const $t = Object(a.createContext)(null);
  function Xt(e, r, t) {
    let {
      searchIndex: n,
      searchResults: a,
      searchText: i,
      selectedElementID: o,
      selectedElementIndex: s
    } = r;
    const l = r.ownerID,
      c = n,
      u = i,
      f = a.length;
    let d = !1;
    if (null === l) switch (t.type) {
      case "GO_TO_NEXT_SEARCH_RESULT":
        f > 0 && (d = !0, n = n + 1 < f ? n + 1 : 0);
        break;
      case "GO_TO_PREVIOUS_SEARCH_RESULT":
        f > 0 && (d = !0, n = n > 0 ? n - 1 : f - 1);
        break;
      case "HANDLE_STORE_MUTATION":
        if ("" !== i) {
          const [r, o] = t.payload;
          o.forEach((e, r) => {
            const t = a.indexOf(r);
            t >= 0 && (a = a.slice(0, t).concat(a.slice(t + 1)), 0 === a.length ? n = null : n >= a.length && (n = a.length - 1));
          }), r.forEach(r => {
            const t = e.getElementByID(r);
            if (null !== t) {
              const {
                  displayName: o
                } = t,
                s = zt(i);
              if (null !== o && s.test(o)) {
                const t = e.getIndexOfElementID(r);
                let i = !1;
                for (let r = 0; r < a.length; r++) {
                  const n = a[r];
                  if (t < e.getIndexOfElementID(n)) {
                    i = !0, a = a.slice(0, r).concat(n).concat(a.slice(r));
                    break;
                  }
                }
                i || (a = a.concat(r)), n = null === n ? 0 : n;
              }
            }
          });
        }
        break;
      case "SET_SEARCH_TEXT":
        if (n = null, a = [], i = t.payload, "" !== i) {
          const r = zt(i);
          e.roots.forEach(t => {
            !function e(r, t, n, a) {
              const {
                children: i,
                displayName: o,
                hocDisplayNames: s
              } = r.getElementByID(t);
              (null != o && !0 === n.test(o) || null != s && s.length > 0 && !0 === s.some(e => n.test(e))) && a.push(t);
              i.forEach(t => e(r, t, n, a));
            }(e, t, r, a);
          }), a.length > 0 && (n = null === c ? null !== s ? function (e, r, t) {
            const n = r.findIndex(r => {
              const n = e.getIndexOfElementID(r);
              return null !== n && n >= t;
            });
            return -1 === n ? 0 : n;
          }(e, a, s) : 0 : Math.min(c, a.length - 1));
        }
        break;
      default:
        return r;
    }
    if (i !== u) {
      const e = a.indexOf(o);
      -1 === e ? d = !0 : n = e;
    }
    return d && null !== n && (o = a[n], s = e.getIndexOfElementID(o)), {
      ...r,
      selectedElementID: o,
      selectedElementIndex: s,
      searchIndex: n,
      searchResults: a,
      searchText: i
    };
  }
  function Gt({
    children: e,
    defaultInspectedElementID: r,
    defaultOwnerID: t,
    defaultSelectedElementID: n,
    defaultSelectedElementIndex: i
  }) {
    const o = Object(a.useContext)(Jr),
      s = Object(a.useContext)(et),
      l = Object(a.useMemo)(() => s.revision, [s]),
      c = Object(a.useMemo)(() => (e, r) => {
        const {
          type: t
        } = r;
        switch (t) {
          case "GO_TO_NEXT_SEARCH_RESULT":
          case "GO_TO_PREVIOUS_SEARCH_RESULT":
          case "HANDLE_STORE_MUTATION":
          case "RESET_OWNER_STACK":
          case "SELECT_ELEMENT_AT_INDEX":
          case "SELECT_ELEMENT_BY_ID":
          case "SELECT_CHILD_ELEMENT_IN_TREE":
          case "SELECT_NEXT_ELEMENT_IN_TREE":
          case "SELECT_NEXT_ELEMENT_WITH_ERROR_OR_WARNING_IN_TREE":
          case "SELECT_NEXT_SIBLING_IN_TREE":
          case "SELECT_OWNER_LIST_NEXT_ELEMENT_IN_TREE":
          case "SELECT_OWNER_LIST_PREVIOUS_ELEMENT_IN_TREE":
          case "SELECT_PARENT_ELEMENT_IN_TREE":
          case "SELECT_PREVIOUS_ELEMENT_IN_TREE":
          case "SELECT_PREVIOUS_ELEMENT_WITH_ERROR_OR_WARNING_IN_TREE":
          case "SELECT_PREVIOUS_SIBLING_IN_TREE":
          case "SELECT_OWNER":
          case "UPDATE_INSPECTED_ELEMENT_ID":
          case "SET_SEARCH_TEXT":
            return e = function (e, r, t) {
              let {
                  numElements: n,
                  ownerSubtreeLeafElementID: a,
                  selectedElementIndex: i,
                  selectedElementID: o
                } = r,
                s = !0;
              if (null === r.ownerID) switch (t.type) {
                case "HANDLE_STORE_MUTATION":
                  n = e.numElements;
                  const l = t.payload[1];
                  for (; null !== o && l.has(o);) o = l.get(o);
                  0 === o && (i = null);
                  break;
                case "SELECT_CHILD_ELEMENT_IN_TREE":
                  if (a = null, null !== i) {
                    const r = e.getElementAtIndex(i);
                    if (null !== r && r.children.length > 0 && !r.isCollapsed) {
                      const t = r.children[0],
                        n = e.getIndexOfElementID(t);
                      null !== n && (i = n);
                    }
                  }
                  break;
                case "SELECT_ELEMENT_AT_INDEX":
                  a = null, i = t.payload;
                  break;
                case "SELECT_ELEMENT_BY_ID":
                  a = null, s = !1, o = t.payload, i = null === o ? null : e.getIndexOfElementID(o);
                  break;
                case "SELECT_NEXT_ELEMENT_IN_TREE":
                  a = null, null === i || i + 1 >= n ? i = 0 : i++;
                  break;
                case "SELECT_NEXT_SIBLING_IN_TREE":
                  if (a = null, null !== i) {
                    const r = e.getElementAtIndex(i);
                    if (null !== r && 0 !== r.parentID) {
                      const t = e.getElementByID(r.parentID);
                      if (null !== t) {
                        const {
                            children: n
                          } = t,
                          a = n.indexOf(r.id),
                          o = a < n.length - 1 ? n[a + 1] : n[0];
                        i = e.getIndexOfElementID(o);
                      }
                    }
                  }
                  break;
                case "SELECT_OWNER_LIST_NEXT_ELEMENT_IN_TREE":
                  if (null !== i && null !== a && a !== o) {
                    const r = e.getElementByID(a);
                    if (null !== r) {
                      let t = r;
                      for (; null !== t;) {
                        if (t.ownerID === o) {
                          i = e.getIndexOfElementID(t.id);
                          break;
                        }
                        0 !== t.ownerID && (t = e.getElementByID(t.ownerID));
                      }
                    }
                  }
                  break;
                case "SELECT_OWNER_LIST_PREVIOUS_ELEMENT_IN_TREE":
                  if (null !== i) {
                    null === a && (a = o);
                    const r = e.getElementAtIndex(i);
                    if (null !== r && 0 !== r.ownerID) {
                      const t = e.getIndexOfElementID(r.ownerID);
                      null !== t && (i = t);
                    }
                  }
                  break;
                case "SELECT_PARENT_ELEMENT_IN_TREE":
                  if (a = null, null !== i) {
                    const r = e.getElementAtIndex(i);
                    if (null !== r && 0 !== r.parentID) {
                      const t = e.getIndexOfElementID(r.parentID);
                      null !== t && (i = t);
                    }
                  }
                  break;
                case "SELECT_PREVIOUS_ELEMENT_IN_TREE":
                  a = null, null === i || 0 === i ? i = n - 1 : i--;
                  break;
                case "SELECT_PREVIOUS_SIBLING_IN_TREE":
                  if (a = null, null !== i) {
                    const r = e.getElementAtIndex(i);
                    if (null !== r && 0 !== r.parentID) {
                      const t = e.getElementByID(r.parentID);
                      if (null !== t) {
                        const {
                            children: n
                          } = t,
                          a = n.indexOf(r.id),
                          o = a > 0 ? n[a - 1] : n[n.length - 1];
                        i = e.getIndexOfElementID(o);
                      }
                    }
                  }
                  break;
                case "SELECT_PREVIOUS_ELEMENT_WITH_ERROR_OR_WARNING_IN_TREE":
                  {
                    const t = e.getElementsWithErrorsAndWarnings();
                    if (0 === t.length) return r;
                    let n,
                      a = 0;
                    if (null !== i) for (let e = t.length - 1; e >= 0; e--) {
                      const {
                        index: r
                      } = t[e];
                      if (!(r >= i)) break;
                      a = e;
                    }
                    0 === a ? (n = t[t.length - 1], o = n.id, i = n.index) : (n = t[a - 1], o = n.id, i = n.index), s = !1;
                    break;
                  }
                case "SELECT_NEXT_ELEMENT_WITH_ERROR_OR_WARNING_IN_TREE":
                  {
                    const t = e.getElementsWithErrorsAndWarnings();
                    if (0 === t.length) return r;
                    let n,
                      a = -1;
                    if (null !== i) for (let e = 0; e < t.length; e++) {
                      const {
                        index: r
                      } = t[e];
                      if (!(r <= i)) break;
                      a = e;
                    }
                    a >= t.length - 1 ? (n = t[0], o = n.id, i = n.index) : (n = t[a + 1], o = n.id, i = n.index), s = !1;
                    break;
                  }
                default:
                  return r;
              }
              return s && i !== r.selectedElementIndex && (o = null === i ? null : e.getElementIDAtIndex(i)), {
                ...r,
                numElements: n,
                ownerSubtreeLeafElementID: a,
                selectedElementIndex: i,
                selectedElementID: o
              };
            }(s, e, r), e = Xt(s, e, r), null !== (e = function (e, r, t) {
              const {
                type: n
              } = t;
              switch (n) {
                case "UPDATE_INSPECTED_ELEMENT_ID":
                  if (r.inspectedElementID !== r.selectedElementID) return {
                    ...r,
                    inspectedElementID: r.selectedElementID
                  };
              }
              return r;
            }(0, e = function (e, r, t) {
              let {
                numElements: n,
                selectedElementID: a,
                selectedElementIndex: i,
                ownerID: o,
                ownerFlatTree: s
              } = r;
              const {
                searchIndex: l,
                searchResults: c,
                searchText: u
              } = r;
              let f = i;
              switch (t.type) {
                case "HANDLE_STORE_MUTATION":
                  null !== o ? e.containsElement(o) ? (s = e.getOwnersListForElement(o), null !== a && (i = s.findIndex(e => e.id === a))) : (o = null, s = null, a = null) : null !== a && (i = e.getIndexOfElementID(a)), -1 === i && (i = null, a = null);
                  break;
                case "RESET_OWNER_STACK":
                  o = null, s = null, i = null !== a ? e.getIndexOfElementID(a) : null;
                  break;
                case "SELECT_ELEMENT_AT_INDEX":
                  null !== s && (i = t.payload);
                  break;
                case "SELECT_ELEMENT_BY_ID":
                  if (null !== s) {
                    const r = t.payload;
                    null === r ? i = null : (i = s.findIndex(e => e.id === r), null !== i && i < 0 && (o = null, s = null, i = e.getIndexOfElementID(r)));
                  }
                  break;
                case "SELECT_NEXT_ELEMENT_IN_TREE":
                  null !== s && s.length > 0 && (null === i ? i = 0 : i + 1 < s.length && i++);
                  break;
                case "SELECT_PREVIOUS_ELEMENT_IN_TREE":
                  null !== s && s.length > 0 && null !== i && i > 0 && i--;
                  break;
                case "SELECT_OWNER":
                  e.hasOwnerMetadata && (o = t.payload, s = e.getOwnersListForElement(o), i = 0, f = null);
                  break;
                default:
                  return r;
              }
              return s === r.ownerFlatTree && "HANDLE_STORE_MUTATION" !== t.type || (n = null === s ? e.numElements : s.length), i !== f && (null === i ? a = null : null !== s && (a = s[i].id)), {
                ...r,
                numElements: n,
                selectedElementID: a,
                selectedElementIndex: i,
                searchIndex: l,
                searchResults: c,
                searchText: u,
                ownerID: o,
                ownerFlatTree: s
              };
            }(s, e, r), r)).selectedElementID && s.isInsideCollapsedSubTree(e.selectedElementID) ? {
              ...e,
              selectedElementIndex: null
            } : e;
          default:
            throw new Error(`Unrecognized action "${t}"`);
        }
      }, [s]),
      [u, f] = Object(a.useReducer)(c, {
        numElements: s.numElements,
        ownerSubtreeLeafElementID: null,
        selectedElementID: null == n ? null : n,
        selectedElementIndex: null == i ? null : i,
        searchIndex: null,
        searchResults: [],
        searchText: "",
        ownerID: null == t ? null : t,
        ownerFlatTree: null,
        inspectedElementID: null == r ? null : r
      }),
      d = Object(a.useCallback)(e => {
        f(e), Object(a.startTransition)(() => {
          f({
            type: "UPDATE_INSPECTED_ELEMENT_ID"
          });
        });
      }, [f]);
    Object(a.useEffect)(() => {
      const e = e => d({
        type: "SELECT_ELEMENT_BY_ID",
        payload: e
      });
      return o.addListener("selectFiber", e), () => o.removeListener("selectFiber", e);
    }, [o, d]);
    const v = Object(a.useRef)(null);
    return Object(a.useLayoutEffect)(() => {
      if (u.selectedElementID !== v.current && (v.current = u.selectedElementID, null !== u.selectedElementID)) {
        const e = s.getElementByID(u.selectedElementID);
        null !== e && e.parentID > 0 && s.toggleIsCollapsed(e.parentID, !1);
      }
    }, [u.selectedElementID, s]), Object(a.useEffect)(() => {
      const e = ([e, r]) => {
        d({
          type: "HANDLE_STORE_MUTATION",
          payload: [e, r]
        });
      };
      return s.revision !== l && d({
        type: "HANDLE_STORE_MUTATION",
        payload: [[], new Map()]
      }), s.addListener("mutated", e), () => s.removeListener("mutated", e);
    }, [d, l, s]), a.createElement(Wt.Provider, {
      value: u
    }, a.createElement($t.Provider, {
      value: d
    }, e));
  }
  $t.displayName = "TreeDispatcherContext";
  var Kt = t(89),
    Yt = t.n(Kt);
  function qt({
    className: e = "",
    title: r = "",
    type: t
  }) {
    let n = null;
    switch (t) {
      case "arrow":
        n = Qt;
        break;
      case "bug":
        n = Zt;
        break;
      case "code":
        n = Jt;
        break;
      case "components":
        n = en;
        break;
      case "copy":
        n = rn;
        break;
      case "error":
        n = tn;
        break;
      case "facebook":
        n = nn;
        break;
      case "flame-chart":
        n = an;
        break;
      case "profiler":
        n = on;
        break;
      case "ranked-chart":
        n = cn;
        break;
      case "timeline":
        n = sn;
        break;
      case "search":
        n = ln;
        break;
      case "settings":
        n = un;
        break;
      case "store-as-global-variable":
        n = fn;
        break;
      case "strict-mode-non-compliant":
        n = dn;
        break;
      case "warning":
        n = vn;
        break;
      default:
        console.warn(`Unsupported type "${t}" specified for Icon`);
    }
    return a.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      className: `${Yt.a.Icon} ${e}`,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, r && a.createElement("title", null, r), a.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }), a.createElement("path", {
      fill: "currentColor",
      d: n
    }));
  }
  const Qt = "M8 5v14l11-7z",
    Zt = "\n  M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49\n  0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09\n  1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21\n  5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z\n",
    Jt = "\n  M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z\n  ",
    en = "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z",
    rn = "\n  M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3a2 2 0 0 0 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9a2 2 0 0 0-2\n  2v10a2 2 0 0 0 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z\n",
    tn = "M16.971 0h-9.942l-7.029 7.029v9.941l7.029 7.03h9.941l7.03-7.029v-9.942l-7.029-7.029zm-1.402 16.945l-3.554-3.521-3.518 3.568-1.418-1.418 3.507-3.566-3.586-3.472 1.418-1.417 3.581 3.458 3.539-3.583 1.431 1.431-3.535 3.568 3.566 3.522-1.431 1.43z",
    nn = "\n  M22,12c0-5.52-4.48-10-10-10S2,6.48,2,12c0,4.84,3.44,8.87,8,9.8V15H8v-3h2V9.5C10,7.57,11.57,6,13.5,6H16v3h-2 c-0.55,0-1,0.45-1,1v2h3v3h-3v6.95C18.05,21.45,22,17.19,22,12z\n",
    an = "\n  M10.0650893,21.5040462 C7.14020814,20.6850349 5,18.0558698 5,14.9390244 C5,14.017627\n  5,9.81707317 7.83333333,7.37804878 C7.83333333,7.37804878 7.58333333,11.199187 10,\n  10.6300813 C11.125,10.326087 13.0062497,7.63043487 8.91666667,2.5 C14.1666667,3.06910569\n  19,9.32926829 19,14.9390244 C19,18.0558698 16.8597919,20.6850349 13.9349107,21.5040462\n  C14.454014,21.0118505 14.7765152,20.3233394 14.7765152,19.5613412 C14.7765152,17.2826087\n  12,15.0875871 12,15.0875871 C12,15.0875871 9.22348485,17.2826087 9.22348485,19.5613412\n  C9.22348485,20.3233394 9.54598603,21.0118505 10.0650893,21.5040462 Z M12.0833333,20.6514763\n  C11.3814715,20.6514763 10.8125,20.1226027 10.8125,19.4702042 C10.8125,18.6069669\n  12.0833333,16.9347829 12.0833333,16.9347829 C12.0833333,16.9347829 13.3541667,18.6069669\n  13.3541667,19.4702042 C13.3541667,20.1226027 12.7851952,20.6514763 12.0833333,20.6514763 Z\n",
    on = "M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z",
    sn = "\n  M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0\n  16H5V9h14v10zm0-12H5V5h14v2zM7 11h5v5H7z\n",
    ln = "\n  M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91\n  16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99\n  5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\n",
    cn = "M3 5h18v3H3zM3 10.5h13v3H3zM3 16h8v3H3z",
    un = "\n  M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49\n  1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38\n  2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11\n  1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4\n  1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49\n  1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5\n  3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z\n",
    fn = "\n  M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41\n  3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04\n  1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6\n  8h-4v-2h4v2zm0-4h-4v-2h4v2z\n",
    dn = "\n  M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3zM12\n  14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z\n",
    vn = "M12 1l-12 22h24l-12-22zm-1 8h2v7h-2v-7zm1 11.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z";
  var hn = t(90),
    mn = t.n(hn);
  function _n(e, r) {
    switch (r.type) {
      case "RESET":
        return {
          ...e,
          editableValue: De(r.externalValue),
          externalValue: r.externalValue,
          hasPendingChanges: !1,
          isValid: !0,
          parsedValue: r.externalValue
        };
      case "UPDATE":
        let t,
          n = !1;
        try {
          t = Ce(r.editableValue), n = !0;
        } catch (e) {}
        return {
          ...e,
          editableValue: ke(r.editableValue),
          externalValue: r.externalValue,
          hasPendingChanges: De(r.externalValue) !== r.editableValue,
          isValid: n,
          parsedValue: n ? t : e.parsedValue
        };
      default:
        throw new Error(`Invalid action "${r.type}"`);
    }
  }
  function pn(e, r, t) {
    const n = Object(a.useCallback)(() => {
        try {
          const r = b(e);
          if (null != r) return JSON.parse(r);
        } catch (e) {
          console.log(e);
        }
        return "function" == typeof r ? r() : r;
      }, [r, e]),
      [i, o] = Object(a.useState)(n),
      s = Object(a.useCallback)(r => {
        try {
          const n = r instanceof Function ? r(i) : r;
          o(n), S(e, JSON.stringify(n)), window.dispatchEvent(new Event(e)), null != t && t(n, e);
        } catch (e) {
          console.log(e);
        }
      }, [e, i]);
    return Object(a.useLayoutEffect)(() => {
      const r = r => {
        const t = n();
        e === r.key && i !== t && s(t);
      };
      return window.addEventListener("storage", r), () => {
        window.removeEventListener("storage", r);
      };
    }, [n, e, i, s]), [i, s];
  }
  function gn(e, r, t = !0) {
    Object(a.useEffect)(() => {
      if (null === e.current) return () => {};
      const n = e => {
          "Escape" === e.key && r();
        },
        a = t => {
          null === e.current || e.current.contains(t.target) || (t.stopPropagation(), t.preventDefault(), r());
        };
      let i = null,
        o = setTimeout(() => {
          o = null;
          const r = e.current;
          null != r && (i = r.ownerDocument, i.addEventListener("keydown", n), t && i.addEventListener("click", a, !0));
        }, 0);
      return () => {
        null !== o && clearTimeout(o), null !== i && (i.removeEventListener("keydown", n), i.removeEventListener("click", a, !0));
      };
    }, [e, r, t]);
  }
  function bn({
    getCurrentValue: e,
    subscribe: r
  }) {
    const [t, n] = Object(a.useState)(() => ({
      getCurrentValue: e,
      subscribe: r,
      value: e()
    }));
    return t.getCurrentValue === e && t.subscribe === r || n({
      getCurrentValue: e,
      subscribe: r,
      value: e()
    }), Object(a.useEffect)(() => {
      let t = !1;
      const a = () => {
          t || n(t => {
            if (t.getCurrentValue !== e || t.subscribe !== r) return t;
            const n = e();
            return t.value === n ? t : {
              ...t,
              value: n
            };
          });
        },
        i = r(a);
      return a(), () => {
        t = !0, i();
      };
    }, [e, r]), t.value;
  }
  function Sn() {
    const e = Object(a.useContext)(Jr),
      r = Object(a.useContext)(et);
    return {
      highlightNativeElement: Object(a.useCallback)(t => {
        const n = r.getElementByID(t),
          a = r.getRendererIDForElement(t);
        null !== n && null !== a && e.send("highlightNativeElement", {
          displayName: n.displayName,
          hideAfterTimeout: !1,
          id: t,
          openNativeElementsPanel: !1,
          rendererID: a,
          scrollIntoView: !1
        });
      }, [r, e]),
      clearHighlightNativeElement: Object(a.useCallback)(() => {
        e.send("clearNativeElementHighlight");
      }, [e])
    };
  }
  const En = Object(a.createContext)(null);
  function wn(e, r) {
    return pn(e, r, (e, r) => {
      Object(qe.a)({
        event_name: "settings-changed",
        metadata: {
          source: "localStorage setter",
          key: r,
          value: e
        }
      });
    });
  }
  function yn({
    browserTheme: e,
    children: r,
    componentsPortalContainer: t,
    profilerPortalContainer: n
  }) {
    const i = Object(a.useContext)(Jr),
      [o, s] = wn("React::DevTools::displayDensity", "compact"),
      [l, c] = wn(v.g, "auto"),
      [u, f] = wn(v.m, !0),
      [d, h] = wn(v.n, !1),
      [m, _] = wn(v.l, !1),
      [p, g] = wn(v.j, !1),
      [b, S] = wn(v.o, !0),
      [E, w] = wn(v.p, !1),
      y = Object(a.useMemo)(() => {
        const e = [document.documentElement];
        return null != t && e.push(t.ownerDocument.documentElement), null != n && e.push(n.ownerDocument.documentElement), e;
      }, [t, n]);
    Object(a.useLayoutEffect)(() => {
      switch (o) {
        case "comfortable":
          kn("comfortable", y);
          break;
        case "compact":
          kn("compact", y);
          break;
        default:
          throw Error(`Unsupported displayDensity value "${o}"`);
      }
    }, [o, y]), Object(a.useLayoutEffect)(() => {
      switch (l) {
        case "light":
          Cn("light", y);
          break;
        case "dark":
          Cn("dark", y);
          break;
        case "auto":
          Cn(e, y);
          break;
        default:
          throw Error(`Unsupported theme value "${l}"`);
      }
    }, [e, l, y]), Object(a.useEffect)(() => {
      i.send("updateConsolePatchSettings", {
        appendComponentStack: u,
        breakOnConsoleErrors: d,
        showInlineWarningsAndErrors: b,
        hideConsoleLogsInStrictMode: p,
        browserTheme: e
      });
    }, [i, u, d, b, p, e]), Object(a.useEffect)(() => {
      i.send("setTraceUpdatesEnabled", E);
    }, [i, E]);
    const k = Object(a.useMemo)(() => ({
      appendComponentStack: u,
      breakOnConsoleErrors: d,
      displayDensity: o,
      lineHeight: "compact" === o ? v.d : v.c,
      parseHookNames: m,
      setAppendComponentStack: f,
      setBreakOnConsoleErrors: h,
      setDisplayDensity: s,
      setParseHookNames: _,
      setTheme: c,
      setTraceUpdatesEnabled: w,
      setShowInlineWarningsAndErrors: S,
      showInlineWarningsAndErrors: b,
      setHideConsoleLogsInStrictMode: g,
      hideConsoleLogsInStrictMode: p,
      theme: l,
      browserTheme: e,
      traceUpdatesEnabled: E
    }), [u, d, o, m, f, h, s, _, c, w, S, b, g, p, l, e, E]);
    return a.createElement(En.Provider, {
      value: k
    }, r);
  }
  function kn(e, r) {
    const t = getComputedStyle(document.body).getPropertyValue(`--${e}-root-font-size`);
    document.querySelector(":root").style.fontSize = t;
  }
  function Cn(e, r) {
    r.forEach(r => {
      r.style.scrollbarColor = `var(--${e}-color-scroll-thumb) var(--${e}-color-scroll-track)`;
    });
  }
  En.displayName = "SettingsContext";
  var Dn = t(67),
    An = t.n(Dn);
  function Mn({
    className: e,
    hocDisplayNames: r,
    type: t,
    children: n
  }) {
    if (null === r || 0 === r.length) return null;
    const i = r.length;
    return a.createElement(a.Fragment, null, a.createElement("div", {
      className: `${An.a.Badge} ${e || ""}`
    }, n), i > 1 && a.createElement("div", {
      className: An.a.ExtraLabel
    }, "+", i - 1));
  }
  var xn = t(91),
    On = t.n(xn);
  function Tn({
    className: e = "",
    type: r
  }) {
    let t = null;
    switch (r) {
      case "add":
        t = Nn;
        break;
      case "cancel":
        t = Rn;
        break;
      case "clear":
        t = In;
        break;
      case "close":
        t = Hn;
        break;
      case "collapsed":
        t = Fn;
        break;
      case "copy":
        t = Ln;
        break;
      case "delete":
        t = Pn;
        break;
      case "down":
        t = zn;
        break;
      case "editor":
        t = oa;
        break;
      case "expanded":
        t = Bn;
        break;
      case "export":
        t = jn;
        break;
      case "filter":
        t = Vn;
        break;
      case "import":
        t = Un;
        break;
      case "log-data":
        t = Wn;
        break;
      case "more":
        t = $n;
        break;
      case "next":
        t = Xn;
        break;
      case "parse-hook-names":
        t = Gn;
        break;
      case "previous":
        t = Kn;
        break;
      case "record":
        t = Yn;
        break;
      case "reload":
        t = qn;
        break;
      case "save":
        t = Qn;
        break;
      case "search":
        t = Zn;
        break;
      case "settings":
        t = Jn;
        break;
      case "error":
        t = ea;
        break;
      case "suspend":
        t = ra;
        break;
      case "undo":
        t = ta;
        break;
      case "up":
        t = na;
        break;
      case "view-dom":
        t = aa;
        break;
      case "view-source":
        t = ia;
        break;
      default:
        console.warn(`Unsupported type "${r}" specified for ButtonIcon`);
    }
    return a.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      className: `${On.a.ButtonIcon} ${e}`,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, a.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }), "string" == typeof t ? a.createElement("path", {
      fill: "currentColor",
      d: t
    }) : t);
  }
  const Nn = "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z",
    Rn = "\n  M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\n",
    In = "\n  M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69\n  16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z\n",
    Hn = "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
    Fn = "M10 17l5-5-5-5v10z",
    Ln = "\n  M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3a2 2 0 0 0 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9a2 2 0 0 0-2\n  2v10a2 2 0 0 0 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z\n",
    Pn = "\n  M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12\n  13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z\n",
    zn = "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z",
    Bn = "M7 10l5 5 5-5z",
    jn = "M15.82,2.14v7H21l-9,9L3,9.18H8.18v-7ZM3,20.13H21v1.73H3Z",
    Vn = "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z",
    Un = "M8.18,18.13v-7H3l9-8.95,9,9H15.82v7ZM3,20.13H21v1.73H3Z",
    Wn = "\n  M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41\n  3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04\n  1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6\n  8h-4v-2h4v2zm0-4h-4v-2h4v2z\n",
    $n = "\n  M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9\n  2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\n",
    Xn = "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z",
    Gn = a.createElement("g", null, a.createElement("polygon", {
      points: "20,7 20.94,4.94 23,4 20.94,3.06 20,1 19.06,3.06 17,4 19.06,4.94"
    }), a.createElement("polygon", {
      points: "8.5,7 9.44,4.94 11.5,4 9.44,3.06 8.5,1 7.56,3.06 5.5,4 7.56,4.94"
    }), a.createElement("polygon", {
      points: "20,12.5 19.06,14.56 17,15.5 19.06,16.44 20,18.5 20.94,16.44 23,15.5 20.94,14.56"
    }), a.createElement("path", {
      d: "M17.71,9.12l-2.83-2.83C14.68,6.1,14.43,6,14.17,6c-0.26,0-0.51,0.1-0.71,0.29L2.29,17.46c-0.39,0.39-0.39,1.02,0,1.41 l2.83,2.83C5.32,21.9,5.57,22,5.83,22s0.51-0.1,0.71-0.29l11.17-11.17C18.1,10.15,18.1,9.51,17.71,9.12z M14.17,8.42l1.41,1.41 L14.41,11L13,9.59L14.17,8.42z M5.83,19.59l-1.41-1.41L11.59,11L13,12.41L5.83,19.59z"
    })),
    Kn = "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z",
    Yn = "M4,12a8,8 0 1,0 16,0a8,8 0 1,0 -16,0",
    qn = "\n  M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0\n  6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0\n  3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z\n",
    Qn = "\n  M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z\n",
    Zn = "\n  M8.5,22H3.7l-1.4-1.5V3.8l1.3-1.5h17.2l1,1.5v4.9h-1.3V4.3l-0.4-0.6H4.2L3.6,4.3V20l0.7,0.7h4.2V22z\n  M23,13.9l-4.6,3.6l4.6,4.6l-1.1,1.1l-4.7-4.4l-3.3,4.4l-3.2-12.3L23,13.9z\n",
    Jn = "\n  M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49\n  1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38\n  2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11\n  1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4\n  1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49\n  1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5\n  3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z\n",
    ea = "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z",
    ra = "\n  M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97\n  0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z\n",
    ta = "\n  M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88\n  3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z\n",
    na = "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z",
    aa = "\n  M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12\n  17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3\n  3-1.34 3-3-1.34-3-3-3z\n",
    ia = "\n  M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z\n  ",
    oa = "\n  M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z\n";
  var sa = t(17),
    la = t.n(sa);
  function ca({
    data: e,
    index: r,
    style: t
  }) {
    const n = Object(a.useContext)(et),
      {
        ownerFlatTree: i,
        ownerID: o,
        selectedElementID: s
      } = Object(a.useContext)(Wt),
      l = Object(a.useContext)($t),
      {
        showInlineWarningsAndErrors: c
      } = a.useContext(En),
      u = null !== i ? i[r] : n.getElementAtIndex(r),
      [f, d] = Object(a.useState)(!1),
      {
        isNavigatingWithKeyboard: v,
        onElementMouseEnter: h,
        treeFocused: m
      } = e,
      _ = null === u ? null : u.id,
      p = s === _,
      g = Object(a.useMemo)(() => ({
        getCurrentValue: () => null === u ? {
          errorCount: 0,
          warningCount: 0
        } : n.getErrorAndWarningCountForElementID(u.id),
        subscribe: e => (n.addListener("mutated", e), () => n.removeListener("mutated", e))
      }), [n, u]),
      {
        errorCount: b,
        warningCount: S
      } = bn(g);
    if (null == u) return console.warn("<Element> Could not find element at index " + r), null;
    const {
        depth: E,
        displayName: w,
        hocDisplayNames: y,
        isStrictModeNonCompliant: k,
        key: C,
        type: D
      } = u,
      A = k && 0 === E;
    let M = la.a.Element;
    return p ? M = m ? la.a.SelectedElement : la.a.InactiveSelectedElement : f && !v && (M = la.a.HoveredElement), a.createElement("div", {
      className: M,
      onMouseEnter: () => {
        d(!0), null !== _ && h(_);
      },
      onMouseLeave: () => {
        d(!1);
      },
      onClick: ({
        metaKey: e
      }) => {
        null !== _ && (Object(qe.a)({
          event_name: "select-element",
          metadata: {
            source: "click-element"
          }
        }), l({
          type: "SELECT_ELEMENT_BY_ID",
          payload: e ? null : _
        }));
      },
      onDoubleClick: () => {
        null !== _ && l({
          type: "SELECT_OWNER",
          payload: _
        });
      },
      style: t,
      "data-testname": "ComponentTreeListItem",
      "data-depth": E
    }, a.createElement("div", {
      className: la.a.Wrapper,
      style: {
        transform: `translateX(calc(${E} * var(--indentation-size)))`
      }
    }, null === o ? a.createElement(fa, {
      element: u,
      store: n
    }) : null, a.createElement(da, {
      displayName: w,
      id: _
    }), C && a.createElement(a.Fragment, null, "\xA0", a.createElement("span", {
      className: la.a.KeyName
    }, "key"), "=\"", a.createElement("span", {
      className: la.a.KeyValue,
      title: C,
      onDoubleClick: e => {
        e.stopPropagation(), e.preventDefault();
      }
    }, C), "\""), null !== y && y.length > 0 ? a.createElement(Mn, {
      className: la.a.Badge,
      hocDisplayNames: y,
      type: D
    }, a.createElement(da, {
      displayName: y[0],
      id: _
    })) : null, c && b > 0 && a.createElement(qt, {
      type: "error",
      className: p && m ? la.a.ErrorIconContrast : la.a.ErrorIcon
    }), c && S > 0 && a.createElement(qt, {
      type: "warning",
      className: p && m ? la.a.WarningIconContrast : la.a.WarningIcon
    }), A && a.createElement(qt, {
      className: p && m ? la.a.StrictModeContrast : la.a.StrictMode,
      title: "This component is not running in StrictMode.",
      type: "strict-mode-non-compliant"
    })));
  }
  const ua = e => {
    e.preventDefault(), e.stopPropagation();
  };
  function fa({
    element: e,
    store: r
  }) {
    const {
      children: t,
      id: n,
      isCollapsed: i
    } = e;
    return 0 === t.length ? a.createElement("div", {
      className: la.a.ExpandCollapseToggle
    }) : a.createElement("div", {
      className: la.a.ExpandCollapseToggle,
      onMouseDown: e => {
        e.stopPropagation();
      },
      onClick: e => {
        e.preventDefault(), e.stopPropagation(), r.toggleIsCollapsed(n, !i);
      },
      onDoubleClick: ua
    }, a.createElement(Tn, {
      type: i ? "collapsed" : "expanded"
    }));
  }
  function da({
    displayName: e,
    id: r
  }) {
    const {
        searchIndex: t,
        searchResults: n,
        searchText: i
      } = Object(a.useContext)(Wt),
      o = Object(a.useMemo)(() => n.includes(r), [r, n]),
      s = null !== t && r === n[t];
    if (!o || null === e) return e;
    const l = zt(i).exec(e);
    if (null === l) return e;
    const c = l.index,
      u = c + l[0].length,
      f = [];
    return c > 0 && f.push(a.createElement("span", {
      key: "begin"
    }, e.slice(0, c))), f.push(a.createElement("mark", {
      key: "middle",
      className: s ? la.a.CurrentHighlight : la.a.Highlight
    }, e.slice(c, u))), u < e.length && f.push(a.createElement("span", {
      key: "end"
    }, e.slice(u))), f;
  }
  var va = t(45),
    ha = t.n(va);
  function ma() {
    return !("undefined" == typeof window || !window.document || !window.document.createElement);
  }
  var _a = ma() ? a.useLayoutEffect : a.useEffect,
    pa = !1,
    ga = 0,
    ba = function () {
      return ++ga;
    };
  function Sa(e) {
    var r = e || (pa ? ba() : null),
      t = Object(a.useState)(r),
      n = t[0],
      i = t[1];
    return _a(function () {
      null === n && i(ba());
    }, []), Object(a.useEffect)(function () {
      !1 === pa && (pa = !0);
    }, []), null != n ? String(n) : void 0;
  }
  function Ea(e) {
    return ma() ? e ? e.ownerDocument : document : null;
  }
  function wa() {
    for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++) r[t] = arguments[t];
    return r.filter(function (e) {
      return null != e;
    }).join("--");
  }
  function ya(e) {
    return !(!e || "[object Function]" != {}.toString.call(e));
  }
  function ka(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for (var t = 0, n = new Array(r); t < r; t++) n[t] = e[t];
    return n;
  }
  function Ca(e, r) {
    var t;
    if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
      if (Array.isArray(e) || (t = function (e, r) {
        if (e) {
          if ("string" == typeof e) return ka(e, r);
          var t = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? ka(e, r) : void 0;
        }
      }(e)) || r && e && "number" == typeof e.length) {
        t && (e = t);
        var n = 0;
        return function () {
          return n >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[n++]
          };
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    return (t = e[Symbol.iterator]()).next.bind(t);
  }
  function Da(e, r) {
    if (null != e) if (ya(e)) e(r);else try {
      e.current = r;
    } catch (t) {
      throw new Error("Cannot assign value \"" + r + "\" to ref \"" + e + "\"");
    }
  }
  function Aa() {
    for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++) r[t] = arguments[t];
    return Object(a.useCallback)(function (e) {
      for (var t, n = Ca(r); !(t = n()).done;) {
        Da(t.value, e);
      }
    }, r);
  }
  function Ma(e, r) {
    return function (t) {
      if (e && e(t), !t.defaultPrevented) return r(t);
    };
  }
  function xa() {
    var e = Object(a.useState)(Object.create(null))[1];
    return Object(a.useCallback)(function () {
      e(Object.create(null));
    }, []);
  }
  var Oa = function (e) {
    var r = e.children,
      t = e.type,
      n = void 0 === t ? "reach-portal" : t,
      o = Object(a.useRef)(null),
      s = Object(a.useRef)(null),
      l = xa();
    return _a(function () {
      if (o.current) {
        var e = o.current.ownerDocument;
        return s.current = null == e ? void 0 : e.createElement(n), e.body.appendChild(s.current), l(), function () {
          s.current && s.current.ownerDocument && s.current.ownerDocument.body.removeChild(s.current);
        };
      }
    }, [n, l]), s.current ? Object(i.createPortal)(r, s.current) : Object(a.createElement)("span", {
      ref: o
    });
  };
  t(52);
  function Ta() {
    return (Ta = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }).apply(this || _global, arguments);
  }
  var Na = ["as", "style"],
    Ra = Object(a.forwardRef)(function (e, r) {
      var t = e.as,
        n = void 0 === t ? "span" : t,
        i = e.style,
        o = void 0 === i ? {} : i,
        s = function (e, r) {
          if (null == e) return {};
          var t,
            n,
            a = {},
            i = Object.keys(e);
          for (n = 0; n < i.length; n++) t = i[n], r.indexOf(t) >= 0 || (a[t] = e[t]);
          return a;
        }(e, Na);
      return Object(a.createElement)(n, Ta({
        ref: r,
        style: Ta({
          border: 0,
          clip: "rect(0 0 0 0)",
          height: "1px",
          margin: "-1px",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap",
          wordWrap: "normal"
        }, o)
      }, s));
    });
  var Ia,
    Ha = ["bottom", "height", "left", "right", "top", "width"],
    Fa = new Map(),
    La = function e() {
      var r = [];
      Fa.forEach(function (e, t) {
        var n,
          a,
          i = t.getBoundingClientRect();
        n = i, a = e.rect, void 0 === n && (n = {}), void 0 === a && (a = {}), Ha.some(function (e) {
          return n[e] !== a[e];
        }) && (e.rect = i, r.push(e));
      }), r.forEach(function (e) {
        e.callbacks.forEach(function (r) {
          return r(e.rect);
        });
      }), Ia = window.requestAnimationFrame(e);
    };
  var Pa = function (e, r) {
    return {
      observe: function () {
        var t = 0 === Fa.size;
        Fa.has(e) ? Fa.get(e).callbacks.push(r) : Fa.set(e, {
          rect: void 0,
          hasRectChanged: !1,
          callbacks: [r]
        }), t && La();
      },
      unobserve: function () {
        var t = Fa.get(e);
        if (t) {
          var n = t.callbacks.indexOf(r);
          n >= 0 && t.callbacks.splice(n, 1), t.callbacks.length || Fa.delete(e), Fa.size || cancelAnimationFrame(Ia);
        }
      }
    };
  };
  function za(e, r, t) {
    var n, i, o;
    "boolean" == typeof r ? n = r : (n = null == (o = null == r ? void 0 : r.observe) || o, i = null == r ? void 0 : r.onChange);
    ya(t) && (i = t);
    var s = Object(a.useState)(e.current),
      l = s[0],
      c = s[1],
      u = Object(a.useRef)(!1),
      f = Object(a.useRef)(!1),
      d = Object(a.useState)(null),
      v = d[0],
      h = d[1],
      m = Object(a.useRef)(i);
    return _a(function () {
      m.current = i, e.current !== l && c(e.current);
    }), _a(function () {
      l && !u.current && (u.current = !0, h(l.getBoundingClientRect()));
    }, [l]), _a(function () {
      if (n) {
        var r = l;
        if (f.current || (f.current = !0, r = e.current), r) {
          var t = Pa(r, function (e) {
            null == m.current || m.current(e), h(e);
          });
          return t.observe(), function () {
            t.unobserve();
          };
        }
      }
    }, [n, l, e]), v;
  }
  function Ba() {
    return (Ba = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }).apply(this || _global, arguments);
  }
  function ja(e, r) {
    if (null == e) return {};
    var t,
      n,
      a = {},
      i = Object.keys(e);
    for (n = 0; n < i.length; n++) t = i[n], r.indexOf(t) >= 0 || (a[t] = e[t]);
    return a;
  }
  var Va,
    Ua,
    Wa,
    $a,
    Xa,
    Ga,
    Ka,
    Ya,
    qa = ["children", "label", "ariaLabel", "id", "DEBUG_STYLE"],
    Qa = ["label", "ariaLabel", "isVisible", "id"],
    Za = ["ariaLabel", "aria-label", "as", "id", "isVisible", "label", "position", "style", "triggerRect"],
    Ja = ["type"];
  !function (e) {
    e.Idle = "IDLE", e.Focused = "FOCUSED", e.Visible = "VISIBLE", e.LeavingVisible = "LEAVING_VISIBLE", e.Dismissed = "DISMISSED";
  }(Ka || (Ka = {})), function (e) {
    e.Blur = "BLUR", e.Focus = "FOCUS", e.GlobalMouseMove = "GLOBAL_MOUSE_MOVE", e.MouseDown = "MOUSE_DOWN", e.MouseEnter = "MOUSE_ENTER", e.MouseLeave = "MOUSE_LEAVE", e.MouseMove = "MOUSE_MOVE", e.Rest = "REST", e.SelectWithKeyboard = "SELECT_WITH_KEYBOARD", e.TimeComplete = "TIME_COMPLETE";
  }(Ya || (Ya = {}));
  var ei,
    ri,
    ti = {
      initial: Ka.Idle,
      states: (Ga = {}, Ga[Ka.Idle] = {
        enter: ii,
        on: (Va = {}, Va[Ya.MouseEnter] = Ka.Focused, Va[Ya.Focus] = Ka.Visible, Va)
      }, Ga[Ka.Focused] = {
        enter: function () {
          window.clearTimeout(ei), ei = window.setTimeout(function () {
            di({
              type: Ya.Rest
            });
          }, 100);
        },
        leave: function () {
          window.clearTimeout(ei);
        },
        on: (Ua = {}, Ua[Ya.MouseMove] = Ka.Focused, Ua[Ya.MouseLeave] = Ka.Idle, Ua[Ya.MouseDown] = Ka.Dismissed, Ua[Ya.Blur] = Ka.Idle, Ua[Ya.Rest] = Ka.Visible, Ua)
      }, Ga[Ka.Visible] = {
        on: (Wa = {}, Wa[Ya.Focus] = Ka.Focused, Wa[Ya.MouseEnter] = Ka.Focused, Wa[Ya.MouseLeave] = Ka.LeavingVisible, Wa[Ya.Blur] = Ka.LeavingVisible, Wa[Ya.MouseDown] = Ka.Dismissed, Wa[Ya.SelectWithKeyboard] = Ka.Dismissed, Wa[Ya.GlobalMouseMove] = Ka.LeavingVisible, Wa)
      }, Ga[Ka.LeavingVisible] = {
        enter: function () {
          window.clearTimeout(ri), ri = window.setTimeout(function () {
            return di({
              type: Ya.TimeComplete
            });
          }, 500);
        },
        leave: function () {
          window.clearTimeout(ri), ii();
        },
        on: ($a = {}, $a[Ya.MouseEnter] = Ka.Visible, $a[Ya.Focus] = Ka.Visible, $a[Ya.TimeComplete] = Ka.Idle, $a)
      }, Ga[Ka.Dismissed] = {
        leave: function () {
          ii();
        },
        on: (Xa = {}, Xa[Ya.MouseLeave] = Ka.Idle, Xa[Ya.Blur] = Ka.Idle, Xa)
      }, Ga)
    },
    ni = {
      value: ti.initial,
      context: {
        id: null
      }
    },
    ai = [];
  function ii() {
    ni.context.id = null;
  }
  function oi(e) {
    var r = void 0 === e ? {} : e,
      t = r.id,
      n = r.onPointerEnter,
      i = r.onPointerMove,
      o = r.onPointerLeave,
      s = r.onPointerDown,
      l = r.onMouseEnter,
      c = r.onMouseMove,
      u = r.onMouseLeave,
      f = r.onMouseDown,
      d = r.onFocus,
      v = r.onBlur,
      h = r.onKeyDown,
      m = r.disabled,
      _ = r.ref,
      p = r.DEBUG_STYLE,
      g = String(Sa(t)),
      b = Object(a.useState)(!!p || vi(g, !0)),
      S = b[0],
      E = b[1],
      w = Object(a.useRef)(null),
      y = Aa(_, w),
      k = za(w, {
        observe: S
      });
    function C(e, r) {
      return "undefined" != typeof window && "PointerEvent" in window ? e : Ma(e, r);
    }
    function D(e) {
      return function (r) {
        "mouse" === r.pointerType && e(r);
      };
    }
    function A() {
      di({
        type: Ya.MouseEnter,
        id: g
      });
    }
    function M() {
      di({
        type: Ya.MouseMove,
        id: g
      });
    }
    function x() {
      di({
        type: Ya.MouseLeave
      });
    }
    function O() {
      ni.context.id === g && di({
        type: Ya.MouseDown
      });
    }
    return Object(a.useEffect)(function () {
      return e = function () {
        E(vi(g));
      }, ai.push(e), function () {
        ai.splice(ai.indexOf(e), 1);
      };
      var e;
    }, [g]), Object(a.useEffect)(function () {
      var e = Ea(w.current);
      function r(e) {
        "Escape" !== e.key && "Esc" !== e.key || ni.value !== Ka.Visible || di({
          type: Ya.SelectWithKeyboard
        });
      }
      return e.addEventListener("keydown", r), function () {
        return e.removeEventListener("keydown", r);
      };
    }, []), function (e) {
      var r = e.disabled,
        t = e.isVisible,
        n = e.ref;
      Object(a.useEffect)(function () {
        if ("undefined" != typeof window && "PointerEvent" in window && r && t) {
          var e = Ea(n.current);
          return e.addEventListener("mousemove", a), function () {
            e.removeEventListener("mousemove", a);
          };
        }
        function a(e) {
          t && (e.target instanceof Element && e.target.closest("[data-reach-tooltip-trigger][data-state='tooltip-visible']") || di({
            type: Ya.GlobalMouseMove
          }));
        }
      }, [r, t, n]);
    }({
      disabled: m,
      isVisible: S,
      ref: w
    }), [{
      "aria-describedby": S ? wa("tooltip", g) : void 0,
      "data-state": S ? "tooltip-visible" : "tooltip-hidden",
      "data-reach-tooltip-trigger": "",
      ref: y,
      onPointerEnter: Ma(n, D(A)),
      onPointerMove: Ma(i, D(M)),
      onPointerLeave: Ma(o, D(x)),
      onPointerDown: Ma(s, D(O)),
      onMouseEnter: C(l, A),
      onMouseMove: C(c, M),
      onMouseLeave: C(u, x),
      onMouseDown: C(f, O),
      onFocus: Ma(d, function () {
        window.__REACH_DISABLE_TOOLTIPS || di({
          type: Ya.Focus,
          id: g
        });
      }),
      onBlur: Ma(v, function () {
        ni.context.id === g && di({
          type: Ya.Blur
        });
      }),
      onKeyDown: Ma(h, function (e) {
        "Enter" !== e.key && " " !== e.key || di({
          type: Ya.SelectWithKeyboard
        });
      })
    }, {
      id: g,
      triggerRect: k,
      isVisible: S
    }, S];
  }
  var si = Object(a.forwardRef)(function (e, r) {
    var t = e.children,
      n = e.label,
      i = e.ariaLabel,
      o = e.id,
      s = e.DEBUG_STYLE,
      l = ja(e, qa),
      c = a.Children.only(t),
      u = oi({
        id: o,
        onPointerEnter: c.props.onPointerEnter,
        onPointerMove: c.props.onPointerMove,
        onPointerLeave: c.props.onPointerLeave,
        onPointerDown: c.props.onPointerDown,
        onMouseEnter: c.props.onMouseEnter,
        onMouseMove: c.props.onMouseMove,
        onMouseLeave: c.props.onMouseLeave,
        onMouseDown: c.props.onMouseDown,
        onFocus: c.props.onFocus,
        onBlur: c.props.onBlur,
        onKeyDown: c.props.onKeyDown,
        disabled: c.props.disabled,
        ref: c.ref,
        DEBUG_STYLE: s
      }),
      f = u[0],
      d = u[1];
    return Object(a.createElement)(a.Fragment, null, Object(a.cloneElement)(c, f), Object(a.createElement)(li, Ba({
      ref: r,
      label: n,
      "aria-label": i
    }, d, l)));
  });
  var li = Object(a.forwardRef)(function (e, r) {
    var t = e.label,
      n = e.ariaLabel,
      i = e.isVisible,
      o = e.id,
      s = ja(e, Qa);
    return i ? Object(a.createElement)(Oa, null, Object(a.createElement)(ci, Ba({
      ref: r,
      label: t,
      "aria-label": n,
      isVisible: i
    }, s, {
      id: wa("tooltip", String(o))
    }))) : null;
  });
  var ci = Object(a.forwardRef)(function (e, r) {
    var t = e.ariaLabel,
      n = e["aria-label"],
      i = e.as,
      o = void 0 === i ? "div" : i,
      s = e.id,
      l = e.isVisible,
      c = e.label,
      u = e.position,
      f = void 0 === u ? fi : u,
      d = e.style,
      v = e.triggerRect,
      h = ja(e, Za),
      m = null != (n || t),
      _ = Object(a.useRef)(null),
      p = Aa(r, _),
      g = za(_, {
        observe: l
      });
    return Object(a.createElement)(a.Fragment, null, Object(a.createElement)(o, Ba({
      role: m ? void 0 : "tooltip"
    }, h, {
      ref: p,
      "data-reach-tooltip": "",
      id: m ? void 0 : s,
      style: Ba({}, d, ui(f, v, g))
    }), c), m && Object(a.createElement)(Ra, {
      role: "tooltip",
      id: s
    }, n || t));
  });
  function ui(e, r, t) {
    return !t ? {
      visibility: "hidden"
    } : e(r, t);
  }
  var fi = function (e, r, t) {
    void 0 === t && (t = 8);
    var n,
      a,
      i,
      o,
      s,
      l = (o = Ea(n), s = o.defaultView || window, o ? {
        width: null != (a = o.documentElement.clientWidth) ? a : s.innerWidth,
        height: null != (i = o.documentElement.clientHeight) ? i : s.innerHeight
      } : {
        width: 0,
        height: 0
      }),
      c = l.width,
      u = l.height;
    if (!e || !r) return {};
    var f = {
        top: e.top - r.height < 0,
        right: c < e.left + r.width,
        bottom: u < e.bottom + r.height + t,
        left: e.left - r.width < 0
      },
      d = f.bottom && !f.top;
    return {
      left: f.right && !f.left ? e.right - r.width + window.pageXOffset + "px" : e.left + window.pageXOffset + "px",
      top: d ? e.top - t - r.height + window.pageYOffset + "px" : e.top + t + e.height + window.pageYOffset + "px"
    };
  };
  function di(e) {
    var r = function (e, r) {
        var t = ti.states[e.value],
          n = t && t.on && t.on[r.type];
        if (!n) return Ba({}, e, {
          changed: !1
        });
        t && t.leave && t.leave(e.context, r);
        r.type;
        var a = ja(r, Ja),
          i = Ba({}, ni.context, a),
          o = "string" == typeof n ? n : n.target,
          s = ti.states[o];
        s && s.enter && s.enter(e.context, r);
        return {
          value: o,
          context: i,
          changed: !0
        };
      }(ni, e),
      t = r.value,
      n = r.context;
    r.changed && (ni = {
      value: t,
      context: n
    }, ai.forEach(function (e) {
      return e(ni);
    }));
  }
  function vi(e, r) {
    return ni.context.id === e && (r ? ni.value === Ka.Visible : ni.value === Ka.Visible || ni.value === Ka.LeavingVisible);
  }
  var hi = si,
    mi = t(92),
    _i = t.n(mi);
  var pi = () => {
    const {
      theme: e,
      displayDensity: r,
      browserTheme: t
    } = Object(a.useContext)(En);
    return Object(a.useMemo)(() => ({
      ...v.w[r],
      ...v.w["auto" === e ? t : e]
    }), [e, t, r]);
  };
  function gi() {
    return (gi = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }).apply(this || _global, arguments);
  }
  var bi = ({
    children: e,
    className: r = "",
    ...t
  }) => {
    const n = pi();
    return a.createElement(hi, gi({
      className: `${_i.a.Tooltip} ${r}`,
      style: n
    }, t), e);
  };
  function Si({
    children: e,
    className: r = "",
    isDisabled: t = !1,
    isChecked: n,
    onChange: i,
    testName: o,
    title: s
  }) {
    let l;
    l = t ? ha.a.ToggleDisabled : n ? ha.a.ToggleOn : ha.a.ToggleOff;
    const c = Object(a.useCallback)(() => i(!n), [n, i]);
    let u = a.createElement("button", {
      className: `${l} ${r}`,
      "data-testname": o,
      disabled: t,
      onClick: c
    }, a.createElement("span", {
      className: ha.a.ToggleContent,
      tabIndex: -1
    }, e));
    return s && (u = a.createElement(bi, {
      label: s
    }, u)), u;
  }
  function Ei() {
    const [e, r] = Object(a.useState)(!1),
      t = Object(a.useContext)(Jr),
      n = Object(a.useCallback)(e => {
        r(e), e ? (Object(qe.a)({
          event_name: "inspect-element-button-clicked"
        }), t.send("startInspectingNative")) : t.send("stopInspectingNative", !1);
      }, [t]);
    return Object(a.useEffect)(() => {
      const e = () => r(!1);
      return t.addListener("stopInspectingNative", e), () => t.removeListener("stopInspectingNative", e);
    }, [t]), a.createElement(Si, {
      onChange: n,
      isChecked: e,
      title: "Select an element in the page to inspect it"
    }, a.createElement(Tn, {
      type: "search"
    }));
  }
  var wi = t(68),
    yi = t.n(wi);
  function ki() {
    return (ki = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }).apply(this || _global, arguments);
  }
  function Ci({
    children: e,
    className: r = "",
    testName: t,
    title: n,
    ...i
  }) {
    let o = a.createElement("button", ki({
      className: `${yi.a.Button} ${r}`,
      "data-testname": t
    }, i), a.createElement("span", {
      className: `${yi.a.ButtonContent} ${r}`,
      tabIndex: -1
    }, e));
    return n && (o = a.createElement(bi, {
      label: n
    }, o)), o;
  }
  const Di = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
  function Ai(e) {
    const r = Di.current;
    if (null === r) throw new Error("react-cache: read and preload may only be called from within a component's render. They are not supported in event handlers or lifecycle methods.");
    return r.readContext(e);
  }
  const Mi = Object(a.createContext)(null),
    xi = new Map(),
    Oi = new Map();
  function Ti(e) {
    let r = xi.get(e);
    if (void 0 === r) {
      const t = Oi.get(e);
      r = void 0 !== t && t.useWeakMap ? new WeakMap() : new Map(), xi.set(e, r);
    }
    return r;
  }
  function Ni(e, r, t, n) {
    const a = Ti(e),
      i = a.get(n);
    if (void 0 === i) {
      const e = r(t);
      e.then(e => {
        if (0 === i.status) {
          const r = i;
          r.status = 1, r.value = e;
        }
      }, e => {
        if (0 === i.status) {
          const r = i;
          r.status = 2, r.value = e;
        }
      });
      const i = {
        status: 0,
        value: e
      };
      return a.set(n, i), i;
    }
    return i;
  }
  function Ri(e, r, t = {}) {
    const n = {
      clear() {
        xi.delete(n);
      },
      invalidate(e) {
        Ti(n).delete(e);
      },
      read(t) {
        Ai(Mi);
        const a = r(t),
          i = Ni(n, e, t, a);
        switch (i.status) {
          case 0:
            throw i.value;
          case 1:
            return i.value;
          case 2:
            throw i.value;
          default:
            return;
        }
      },
      preload(t) {
        Ai(Mi);
        const a = r(t);
        Ni(n, e, t, a);
      },
      write(e, r) {
        const t = {
          status: 1,
          value: r
        };
        Ti(n).set(e, t);
      }
    };
    return Oi.set(n, t), n;
  }
  const Ii = Object(a.createContext)(null);
  Ii.displayName = "OwnersListContext";
  const Hi = new WeakMap(),
    Fi = Ri(e => {
      const r = Hi.get(e);
      if (null != r) return r.promise;
      let t = null;
      const n = new Promise(e => {
        t = e;
      });
      return Hi.set(e, {
        promise: n,
        resolveFn: t
      }), n;
    }, e => e, {
      useWeakMap: !0
    });
  function Li({
    children: e
  }) {
    const r = Object(a.useContext)(Jr),
      t = Object(a.useContext)(et),
      {
        ownerID: n
      } = Object(a.useContext)(Wt),
      i = Object(a.useCallback)(e => {
        const r = t.getElementByID(e);
        return null !== r ? Fi.read(r) : null;
      }, [t]);
    return Object(a.useEffect)(() => {
      const e = e => {
        const r = e.id,
          n = t.getElementByID(r);
        if (null !== n) {
          const r = Hi.get(n);
          null != r && (Hi.delete(n), r.resolveFn(null === e.owners ? null : e.owners.map(e => {
            const [r, t] = L(e.displayName, e.type);
            return {
              ...e,
              displayName: r,
              hocDisplayNames: t
            };
          })));
        }
      };
      return r.addListener("ownersList", e), () => r.removeListener("ownersList", e);
    }, [r, t]), Object(a.useEffect)(() => {
      if (null !== n) {
        const e = t.getRendererIDForElement(n);
        null !== e && r.send("getOwnersList", {
          id: n,
          rendererID: e
        });
      }
      return () => {};
    }, [r, n, t]), a.createElement(Ii.Provider, {
      value: i
    }, e);
  }
  var Pi = t(30),
    zi = t.n(Pi);
  function Bi() {
    return (Bi = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }).apply(this || _global, arguments);
  }
  var ji = ["as", "targetRef", "position", "unstable_observableRefs"],
    Vi = Object(a.forwardRef)(function (e, r) {
      return Object(a.createElement)(Oa, null, Object(a.createElement)(Ui, Bi({
        ref: r
      }, e)));
    });
  var Ui = Object(a.forwardRef)(function (e, r) {
    var t = e.as,
      n = void 0 === t ? "div" : t,
      i = e.targetRef,
      o = e.position,
      s = void 0 === o ? Xi : o,
      l = e.unstable_observableRefs,
      c = void 0 === l ? [] : l,
      u = function (e, r) {
        if (null == e) return {};
        var t,
          n,
          a = {},
          i = Object.keys(e);
        for (n = 0; n < i.length; n++) t = i[n], r.indexOf(t) >= 0 || (a[t] = e[t]);
        return a;
      }(e, ji),
      f = Object(a.useRef)(null),
      d = za(f, {
        observe: !u.hidden
      }),
      v = za(i, {
        observe: !u.hidden
      }),
      h = Aa(f, r);
    return function (e, r) {
      var t = Ea(e.current);
      function n(n) {
        "Tab" === n.key && r.current && 0 === zi()(r.current).length || ("Tab" === n.key && n.shiftKey ? function (e) {
          if (!e.shiftKey) return;
          var r = i();
          return e.target === r;
        }(n) ? function (e) {
          var t = r.current && zi()(r.current),
            n = t && t[t.length - 1];
          n && (e.preventDefault(), n.focus());
        }(n) : function (e) {
          var t = r.current && zi()(r.current);
          if (t) return 0 !== t.length && e.target === t[0];
          return !1;
        }(n) ? function (r) {
          var t;
          r.preventDefault(), null == (t = e.current) || t.focus();
        }(n) : function (e) {
          return e.target === zi()(t)[0];
        }(n) && s() : "Tab" === n.key && (e.current && e.current === t.activeElement ? function (e) {
          var t = r.current && zi()(r.current);
          t && t[0] && (e.preventDefault(), t[0].focus());
        }(n) : function () {
          if (r.current && r.current.contains(t.activeElement || null)) {
            var e = r.current && zi()(r.current);
            return Boolean(e && e[e.length - 1] === t.activeElement);
          }
          return !1;
        }() ? function (e) {
          var r = i();
          r && (e.preventDefault(), r.focus());
        }(n) : function (e) {
          var n = r.current ? zi()(t).filter(function (e) {
            return !r.current.contains(e);
          }) : null;
          return !!n && e.target === n[n.length - 1];
        }(n) && s()));
      }
      function i() {
        var n = zi()(t),
          a = n && e.current ? n.indexOf(e.current) : -1,
          i = n && n[a + 1];
        return (!r.current || !r.current.contains(i || null)) && i;
      }
      Object(a.useEffect)(function () {
        return t.addEventListener("keydown", n), function () {
          t.removeEventListener("keydown", n);
        };
      }, []);
      var o = [];
      function s() {
        var e = r.current && zi()(r.current);
        e && (e.forEach(function (e) {
          o.push([e, e.tabIndex]), e.tabIndex = -1;
        }), t.addEventListener("focusin", l));
      }
      function l() {
        t.removeEventListener("focusin", l), o.forEach(function (e) {
          var r = e[0],
            t = e[1];
          r.tabIndex = t;
        });
      }
    }(i, f), Object(a.createElement)(n, Bi({
      "data-reach-popover": "",
      ref: h
    }, u, {
      style: Bi({
        position: "absolute"
      }, Wi.apply(void 0, [s, v, d].concat(c)), u.style)
    }));
  });
  function Wi(e, r, t) {
    for (var n = arguments.length, a = new Array(n > 3 ? n - 3 : 0), i = 3; i < n; i++) a[i - 3] = arguments[i];
    return t ? e.apply(void 0, [r, t].concat(a.map(function (e) {
      return e.current;
    }))) : {
      visibility: "hidden"
    };
  }
  function $i(e, r, t) {
    return {
      top: t ? e.top - r.height + window.pageYOffset + "px" : e.top + e.height + window.pageYOffset + "px"
    };
  }
  var Xi = function (e, r) {
    if (!e || !r) return {};
    var t = Gi(e, r),
      n = t.directionRight,
      a = t.directionUp;
    return Bi({
      left: n ? e.right - r.width + window.pageXOffset + "px" : e.left + window.pageXOffset + "px"
    }, $i(e, r, a));
  };
  function Gi(e, r, t, n) {
    void 0 === t && (t = 0), void 0 === n && (n = 0);
    var a = {
      top: e.top - r.height < 0,
      right: window.innerWidth < e.left + r.width - t,
      bottom: window.innerHeight < e.bottom + r.height - n,
      left: e.left + e.width - r.width < 0
    };
    return {
      directionRight: a.right && !a.left,
      directionLeft: a.left && !a.right,
      directionUp: a.bottom && !a.top,
      directionDown: a.top && !a.bottom
    };
  }
  function Ki(e, r) {
    return Object(a.createContext)(r);
  }
  function Yi() {}
  function qi() {
    return (qi = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }).apply(this || _global, arguments);
  }
  var Qi = ["element", "index"];
  function Zi(e, r) {
    void 0 === r && (r = {});
    return Ki(0, qi({
      descendants: [],
      registerDescendant: Yi,
      unregisterDescendant: Yi
    }, r));
  }
  function Ji(e) {
    var r = e.context,
      t = e.children,
      n = e.items,
      i = e.set,
      o = Object(a.useCallback)(function (e) {
        var r = e.element,
          t = e.index,
          n = function (e, r) {
            if (null == e) return {};
            var t,
              n,
              a = {},
              i = Object.keys(e);
            for (n = 0; n < i.length; n++) t = i[n], r.indexOf(t) >= 0 || (a[t] = e[t]);
            return a;
          }(e, Qi);
        r && i(function (e) {
          var a;
          if (null != t) return [].concat(e, [qi({}, n, {
            element: r,
            index: t
          })]).sort(function (e, r) {
            return e.index - r.index;
          });
          if (0 === e.length) a = [qi({}, n, {
            element: r,
            index: 0
          })];else if (e.find(function (e) {
            return e.element === r;
          })) a = e;else {
            var i = e.findIndex(function (e) {
                return !(!e.element || !r) && Boolean(e.element.compareDocumentPosition(r) & Node.DOCUMENT_POSITION_PRECEDING);
              }),
              o = qi({}, n, {
                element: r,
                index: i
              });
            a = -1 === i ? [].concat(e, [o]) : [].concat(e.slice(0, i), [o], e.slice(i));
          }
          return a.map(function (e, r) {
            return qi({}, e, {
              index: r
            });
          });
        });
      }, []),
      s = Object(a.useCallback)(function (e) {
        e && i(function (r) {
          return r.filter(function (r) {
            return e !== r.element;
          });
        });
      }, []);
    return Object(a.createElement)(r.Provider, {
      value: Object(a.useMemo)(function () {
        return {
          descendants: n,
          registerDescendant: o,
          unregisterDescendant: s
        };
      }, [n, o, s])
    }, t);
  }
  function eo(e) {
    return "which" in e ? 3 === e.which : "button" in e && 2 === e.button;
  }
  function ro(e) {
    var r = Object(a.useRef)(null);
    return Object(a.useEffect)(function () {
      r.current = e;
    }, [e]), r.current;
  }
  function to(e, r) {
    if (null == e) return {};
    var t,
      n,
      a = {},
      i = Object.keys(e);
    for (n = 0; n < i.length; n++) t = i[n], r.indexOf(t) >= 0 || (a[t] = e[t]);
    return a;
  }
  function no() {
    return (no = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }).apply(this || _global, arguments);
  }
  var ao = ["onKeyDown", "onMouseDown", "id", "ref"],
    io = ["index", "isLink", "onClick", "onDragStart", "onMouseDown", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseUp", "onSelect", "disabled", "onFocus", "valueText", "ref"],
    oo = ["id", "onKeyDown", "ref"],
    so = ["onBlur", "portal", "position", "ref"],
    lo = Zi(),
    co = Ki(0, {}),
    uo = {
      triggerId: null,
      isExpanded: !1,
      typeaheadQuery: "",
      selectionIndex: -1
    },
    fo = function (e) {
      var r = e.id,
        t = e.children,
        n = Object(a.useRef)(null),
        i = Object(a.useRef)(null),
        o = Object(a.useRef)(null),
        s = Object(a.useState)([]),
        l = s[0],
        c = s[1],
        u = Sa(r),
        f = r || wa("menu", u),
        d = wa("menu-button", f),
        v = Object(a.useReducer)(bo, no({}, uo, {
          triggerId: d
        })),
        h = v[0],
        m = v[1],
        _ = Object(a.useRef)(!1),
        p = Object(a.useRef)([]),
        g = Object(a.useRef)(!1),
        b = Object(a.useRef)({
          x: 0,
          y: 0
        }),
        S = {
          dispatch: m,
          dropdownId: f,
          dropdownRef: i,
          mouseDownStartPosRef: b,
          popoverRef: o,
          readyToSelect: g,
          selectCallbacks: p,
          state: h,
          triggerClickedRef: _,
          triggerRef: n
        };
      return Object(a.useEffect)(function () {
        h.isExpanded ? (window.__REACH_DISABLE_TOOLTIPS = !0, window.requestAnimationFrame(function () {
          go(i.current);
        })) : window.__REACH_DISABLE_TOOLTIPS = !1;
      }, [h.isExpanded]), Object(a.createElement)(Ji, {
        context: lo,
        items: l,
        set: c
      }, Object(a.createElement)(co.Provider, {
        value: S
      }, ya(t) ? t({
        isExpanded: h.isExpanded,
        isOpen: h.isExpanded
      }) : t));
    };
  function vo(e) {
    var r = e.onKeyDown,
      t = e.onMouseDown,
      n = e.id,
      i = e.ref,
      o = to(e, ao),
      s = So(),
      l = s.dispatch,
      c = s.dropdownId,
      u = s.mouseDownStartPosRef,
      f = s.triggerClickedRef,
      d = s.triggerRef,
      v = s.state,
      h = v.triggerId,
      m = v.isExpanded,
      _ = Aa(d, i),
      p = Eo(),
      g = Object(a.useMemo)(function () {
        return p.findIndex(function (e) {
          return !e.disabled;
        });
      }, [p]);
    return Object(a.useEffect)(function () {
      null != n && n !== h && l({
        type: "SET_BUTTON_ID",
        payload: n
      });
    }, [h, l, n]), {
      data: {
        isExpanded: m,
        controls: c
      },
      props: no({}, o, {
        ref: _,
        id: h || void 0,
        onKeyDown: Ma(r, function (e) {
          switch (e.key) {
            case "ArrowDown":
            case "ArrowUp":
              e.preventDefault(), l({
                type: "OPEN_MENU_AT_INDEX",
                payload: {
                  index: g
                }
              });
              break;
            case "Enter":
            case " ":
              l({
                type: "OPEN_MENU_AT_INDEX",
                payload: {
                  index: g
                }
              });
          }
        }),
        onMouseDown: Ma(t, function (e) {
          eo(e.nativeEvent) || (u.current = {
            x: e.clientX,
            y: e.clientY
          }, m || (f.current = !0), l(m ? {
            type: "CLOSE_MENU"
          } : {
            type: "OPEN_MENU_CLEARED"
          }));
        }),
        type: "button"
      })
    };
  }
  function ho(e) {
    var r = e.index,
      t = e.isLink,
      n = void 0 !== t && t,
      i = e.onClick,
      o = e.onDragStart,
      s = e.onMouseDown,
      l = e.onMouseEnter,
      c = e.onMouseLeave,
      u = e.onMouseMove,
      f = e.onMouseUp,
      d = e.onSelect,
      v = e.disabled,
      h = e.onFocus,
      m = e.valueText,
      _ = e.ref,
      p = to(e, io),
      g = So(),
      b = g.dispatch,
      S = g.dropdownRef,
      E = g.mouseDownStartPosRef,
      w = g.readyToSelect,
      y = g.selectCallbacks,
      k = g.triggerRef,
      C = g.state,
      D = C.selectionIndex,
      A = C.isExpanded,
      M = Object(a.useRef)(null),
      x = Object(a.useState)(m || ""),
      O = x[0],
      T = x[1],
      N = Object(a.useCallback)(function (e) {
        !m && null != e && e.textContent && T(e.textContent);
      }, [m]),
      R = Object(a.useRef)(!1),
      I = function (e, r) {
        var t = Object(a.useState)(r),
          n = t[0],
          i = t[1];
        return [n, Object(a.useCallback)(function (r) {
          e.current = r, i(r);
        }, [])];
      }(M, null),
      H = I[0],
      F = I[1],
      L = function (e, r, t) {
        var n = xa(),
          i = Object(a.useContext)(r),
          o = i.registerDescendant,
          s = i.unregisterDescendant,
          l = i.descendants,
          c = null != t ? t : l.findIndex(function (r) {
            return r.element === e.element;
          });
        return _a(function () {
          return e.element || n(), o(qi({}, e, {
            index: c
          })), function () {
            s(e.element);
          };
        }, [e, n, c, o, s].concat(Object.values(e))), c;
      }(Object(a.useMemo)(function () {
        return {
          element: H,
          key: O,
          disabled: v,
          isLink: n
        };
      }, [v, H, n, O]), lo, r),
      P = L === D && !v,
      z = Aa(_, F, N);
    function B() {
      go(k.current), d && d(), b({
        type: "CLICK_MENU_ITEM"
      });
    }
    return y.current[L] = d, Object(a.useEffect)(function () {
      if (A) {
        var e = window.setTimeout(function () {
          w.current = !0;
        }, 400);
        return function () {
          window.clearTimeout(e);
        };
      }
      w.current = !1;
    }, [A, w]), Object(a.useEffect)(function () {
      var e = Ea(M.current);
      return e.addEventListener("mouseup", r), function () {
        e.removeEventListener("mouseup", r);
      };
      function r() {
        R.current = !1;
      }
    }, []), {
      data: {
        disabled: v
      },
      props: no({
        id: po(L),
        tabIndex: -1
      }, p, {
        ref: z,
        "data-disabled": v ? "" : void 0,
        "data-selected": P ? "" : void 0,
        "data-valuetext": O,
        onClick: Ma(i, function (e) {
          eo(e.nativeEvent) || n && (v ? e.preventDefault() : B());
        }),
        onDragStart: Ma(o, function (e) {
          n && e.preventDefault();
        }),
        onMouseDown: Ma(s, function (e) {
          eo(e.nativeEvent) || (n ? R.current = !0 : e.preventDefault());
        }),
        onMouseEnter: Ma(l, function (e) {
          var r = Ea(S.current);
          P || null == L || v || (null != S && S.current && S.current !== r.activeElement && M.current !== r.activeElement && S.current.focus(), b({
            type: "SELECT_ITEM_AT_INDEX",
            payload: {
              index: L
            }
          }));
        }),
        onMouseLeave: Ma(c, function (e) {
          b({
            type: "CLEAR_SELECTION_INDEX"
          });
        }),
        onMouseMove: Ma(u, function (e) {
          if (!w.current) {
            var r = Math.abs(e.clientX - E.current.x),
              t = Math.abs(e.clientY - E.current.y);
            (r > 8 || t > 8) && (w.current = !0);
          }
          P || null == L || v || b({
            type: "SELECT_ITEM_AT_INDEX",
            payload: {
              index: L,
              dropdownRef: S
            }
          });
        }),
        onFocus: Ma(h, function () {
          w.current = !0, P || null == L || v || b({
            type: "SELECT_ITEM_AT_INDEX",
            payload: {
              index: L
            }
          });
        }),
        onMouseUp: Ma(f, function (e) {
          eo(e.nativeEvent) || (w.current ? n ? R.current ? R.current = !1 : M.current && M.current.click() : v || B() : w.current = !0);
        })
      })
    };
  }
  function mo(e) {
    e.id;
    var r = e.onKeyDown,
      t = e.ref,
      n = to(e, oo),
      i = So(),
      o = i.dispatch,
      s = i.triggerRef,
      l = i.dropdownRef,
      c = i.selectCallbacks,
      u = i.dropdownId,
      f = i.state,
      d = f.isExpanded,
      v = f.triggerId,
      h = f.selectionIndex,
      m = f.typeaheadQuery,
      _ = Eo(),
      p = Aa(l, t);
    Object(a.useEffect)(function () {
      var e = function (e, r) {
        void 0 === r && (r = "");
        if (!r) return null;
        var t = e.find(function (e) {
          var t, n, a;
          return !e.disabled && (null == (t = e.element) || null == (n = t.dataset) || null == (a = n.valuetext) ? void 0 : a.toLowerCase().startsWith(r));
        });
        return t ? e.indexOf(t) : null;
      }(_, m);
      m && null != e && o({
        type: "SELECT_ITEM_AT_INDEX",
        payload: {
          index: e,
          dropdownRef: l
        }
      });
      var r = window.setTimeout(function () {
        return m && o({
          type: "SEARCH_FOR_ITEM",
          payload: ""
        });
      }, 1000);
      return function () {
        return window.clearTimeout(r);
      };
    }, [o, _, m, l]);
    var g = ro(_.length),
      b = ro(_[h]),
      S = ro(h);
    Object(a.useEffect)(function () {
      h > _.length - 1 ? o({
        type: "SELECT_ITEM_AT_INDEX",
        payload: {
          index: _.length - 1,
          dropdownRef: l
        }
      }) : g !== _.length && h > -1 && b && S === h && _[h] !== b && o({
        type: "SELECT_ITEM_AT_INDEX",
        payload: {
          index: _.findIndex(function (e) {
            return e.key === (null == b ? void 0 : b.key);
          }),
          dropdownRef: l
        }
      });
    }, [l, o, _, g, b, S, h]);
    var E,
      w,
      y,
      k,
      C,
      D,
      A,
      M,
      x,
      O,
      T,
      N,
      R,
      I,
      H = Ma(function (e) {
        var r = e.key;
        if (d) switch (r) {
          case "Enter":
          case " ":
            var t = _.find(function (e) {
              return e.index === h;
            });
            t && !t.disabled && (e.preventDefault(), t.isLink && t.element ? t.element.click() : (go(s.current), c.current[t.index] && c.current[t.index](), o({
              type: "CLICK_MENU_ITEM"
            })));
            break;
          case "Escape":
            go(s.current), o({
              type: "CLOSE_MENU"
            });
            break;
          case "Tab":
            e.preventDefault();
            break;
          default:
            if ("string" == typeof r && 1 === r.length) {
              var n = m + r.toLowerCase();
              o({
                type: "SEARCH_FOR_ITEM",
                payload: n
              });
            }
        }
      }, (E = lo, w = {
        currentIndex: h,
        orientation: "vertical",
        rotate: !1,
        filter: function (e) {
          return !e.disabled;
        },
        callback: function (e) {
          o({
            type: "SELECT_ITEM_AT_INDEX",
            payload: {
              index: e,
              dropdownRef: l
            }
          });
        },
        key: "index"
      }, y = Object(a.useContext)(E).descendants, k = w.callback, C = w.currentIndex, D = w.filter, A = w.key, M = void 0 === A ? "index" : A, x = w.orientation, O = void 0 === x ? "vertical" : x, T = w.rotate, N = void 0 === T || T, R = w.rtl, I = void 0 !== R && R, function (e) {
        if (["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight", "PageUp", "PageDown", "Home", "End"].includes(e.key)) {
          var r = null != C ? C : -1,
            t = D ? y.filter(D) : y;
          if (t.length) {
            var n = t.findIndex(function (e) {
              return e.index === C;
            });
            switch (e.key) {
              case "ArrowDown":
                if ("vertical" === O || "both" === O) {
                  e.preventDefault();
                  var a = d();
                  k("option" === M ? a : a[M]);
                }
                break;
              case "ArrowUp":
                if ("vertical" === O || "both" === O) {
                  e.preventDefault();
                  var i = v();
                  k("option" === M ? i : i[M]);
                }
                break;
              case "ArrowLeft":
                if ("horizontal" === O || "both" === O) {
                  e.preventDefault();
                  var o = (I ? d : v)();
                  k("option" === M ? o : o[M]);
                }
                break;
              case "ArrowRight":
                if ("horizontal" === O || "both" === O) {
                  e.preventDefault();
                  var s = (I ? v : d)();
                  k("option" === M ? s : s[M]);
                }
                break;
              case "PageUp":
                e.preventDefault();
                var l = (e.ctrlKey ? v : h)();
                k("option" === M ? l : l[M]);
                break;
              case "Home":
                e.preventDefault();
                var c = h();
                k("option" === M ? c : c[M]);
                break;
              case "PageDown":
                e.preventDefault();
                var u = (e.ctrlKey ? d : m)();
                k("option" === M ? u : u[M]);
                break;
              case "End":
                e.preventDefault();
                var f = m();
                k("option" === M ? f : f[M]);
            }
          }
        }
        function d() {
          return r === m().index ? N ? h() : t[n] : t[(n + 1) % t.length];
        }
        function v() {
          return r === h().index ? N ? m() : t[n] : t[(n - 1 + t.length) % t.length];
        }
        function h() {
          return t[0];
        }
        function m() {
          return t[t.length - 1];
        }
      }));
    return {
      data: {
        activeDescendant: po(h) || void 0,
        triggerId: v
      },
      props: no({
        tabIndex: -1
      }, n, {
        ref: p,
        id: u,
        onKeyDown: Ma(r, H)
      })
    };
  }
  function _o(e) {
    var r = e.onBlur,
      t = e.portal,
      n = void 0 === t || t,
      i = e.position,
      o = e.ref,
      s = to(e, so),
      l = So(),
      c = l.triggerRef,
      u = l.triggerClickedRef,
      f = l.dispatch,
      d = l.dropdownRef,
      v = l.popoverRef,
      h = l.state.isExpanded,
      m = Aa(v, o);
    return Object(a.useEffect)(function () {
      if (h) {
        var e = Ea(v.current);
        return e.addEventListener("mousedown", r), function () {
          e.removeEventListener("mousedown", r);
        };
      }
      function r(e) {
        var r, t;
        u.current ? u.current = !1 : (r = v.current, t = e.target, r && r.contains(t) || f({
          type: "CLOSE_MENU"
        }));
      }
    }, [u, c, f, d, v, h]), {
      data: {
        portal: n,
        position: i,
        targetRef: c,
        isExpanded: h
      },
      props: no({
        ref: m,
        hidden: !h,
        onBlur: Ma(r, function (e) {
          e.currentTarget.contains(e.relatedTarget) || f({
            type: "CLOSE_MENU"
          });
        })
      }, s)
    };
  }
  function po(e) {
    var r = Object(a.useContext)(co).dropdownId;
    return null != e && e > -1 ? wa("option-" + e, r) : void 0;
  }
  function go(e) {
    e && e.focus();
  }
  function bo(e, r) {
    switch (void 0 === r && (r = {}), r.type) {
      case "CLICK_MENU_ITEM":
      case "CLOSE_MENU":
        return no({}, e, {
          isExpanded: !1,
          selectionIndex: -1
        });
      case "OPEN_MENU_AT_FIRST_ITEM":
        return no({}, e, {
          isExpanded: !0,
          selectionIndex: 0
        });
      case "OPEN_MENU_AT_INDEX":
        return no({}, e, {
          isExpanded: !0,
          selectionIndex: r.payload.index
        });
      case "OPEN_MENU_CLEARED":
        return no({}, e, {
          isExpanded: !0,
          selectionIndex: -1
        });
      case "SELECT_ITEM_AT_INDEX":
        var t = r.payload.dropdownRef,
          n = void 0 === t ? {
            current: null
          } : t;
        if (r.payload.index >= 0 && r.payload.index !== e.selectionIndex) {
          if (n.current) {
            var a = Ea(n.current);
            n.current !== (null == a ? void 0 : a.activeElement) && n.current.focus();
          }
          return no({}, e, {
            selectionIndex: null != r.payload.max ? Math.min(Math.max(r.payload.index, 0), r.payload.max) : Math.max(r.payload.index, 0)
          });
        }
        return e;
      case "CLEAR_SELECTION_INDEX":
        return no({}, e, {
          selectionIndex: -1
        });
      case "SET_BUTTON_ID":
        return no({}, e, {
          triggerId: r.payload
        });
      case "SEARCH_FOR_ITEM":
        return void 0 !== r.payload ? no({}, e, {
          typeaheadQuery: r.payload
        }) : e;
      default:
        return e;
    }
  }
  function So() {
    return Object(a.useContext)(co);
  }
  function Eo() {
    return e = lo, Object(a.useContext)(e).descendants;
    var e;
  }
  function wo() {
    return (wo = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }).apply(this || _global, arguments);
  }
  function yo(e, r) {
    if (null == e) return {};
    var t,
      n,
      a = {},
      i = Object.keys(e);
    for (n = 0; n < i.length; n++) t = i[n], r.indexOf(t) >= 0 || (a[t] = e[t]);
    return a;
  }
  var ko = ["as", "id", "children"],
    Co = ["as"],
    Do = ["as"],
    Ao = ["as"],
    Mo = ["as"],
    xo = ["portal"],
    Oo = ["as"],
    To = Object(a.forwardRef)(function (e, r) {
      var t = e.as,
        n = void 0 === t ? a.Fragment : t,
        i = e.id,
        o = e.children,
        s = yo(e, ko),
        l = Object(a.useMemo)(function () {
          try {
            return Object(_.isFragment)(Object(a.createElement)(n, null));
          } catch (e) {
            return !1;
          }
        }, [n]) ? {} : wo({
          ref: r,
          id: i,
          "data-reach-menu": ""
        }, s);
      return Object(a.createElement)(n, l, Object(a.createElement)(fo, {
        id: i,
        children: o
      }));
    });
  var No = Object(a.forwardRef)(function (e, r) {
    var t = e.as,
      n = void 0 === t ? "button" : t,
      i = vo(wo({}, yo(e, Co), {
        ref: r
      })),
      o = i.data,
      s = o.isExpanded,
      l = o.controls,
      c = i.props;
    return Object(a.createElement)(n, wo({
      "aria-expanded": !!s || void 0,
      "aria-haspopup": !0,
      "aria-controls": l
    }, c, {
      "data-reach-menu-button": ""
    }));
  });
  var Ro = Object(a.forwardRef)(function (e, r) {
      var t = e.as,
        n = void 0 === t ? "div" : t,
        i = ho(wo({}, yo(e, Do), {
          ref: r
        })),
        o = i.data.disabled,
        s = i.props;
      return Object(a.createElement)(n, wo({
        role: "menuitem"
      }, s, {
        "aria-disabled": o || void 0,
        "data-reach-menu-item": ""
      }));
    }),
    Io = Object(a.forwardRef)(function (e, r) {
      var t = e.as,
        n = void 0 === t ? "div" : t,
        i = yo(e, Ao);
      return Object(a.createElement)(Ro, wo({}, i, {
        ref: r,
        as: n
      }));
    });
  var Ho = Object(a.forwardRef)(function (e, r) {
    var t = e.as,
      n = void 0 === t ? "div" : t,
      i = mo(wo({}, yo(e, Mo), {
        ref: r
      })),
      o = i.data,
      s = o.activeDescendant,
      l = o.triggerId,
      c = i.props;
    return Object(a.createElement)(n, wo({
      "aria-activedescendant": s,
      "aria-labelledby": l || void 0,
      role: "menu"
    }, c, {
      "data-reach-menu-items": ""
    }));
  });
  var Fo = Object(a.forwardRef)(function (e, r) {
    var t = e.portal,
      n = void 0 === t || t,
      i = yo(e, xo);
    return Object(a.createElement)(Lo, {
      portal: n
    }, Object(a.createElement)(Ho, wo({}, i, {
      ref: r,
      "data-reach-menu-list": ""
    })));
  });
  var Lo = Object(a.forwardRef)(function (e, r) {
    var t = e.as,
      n = void 0 === t ? "div" : t,
      i = _o(wo({}, yo(e, Oo), {
        ref: r
      })),
      o = i.data,
      s = o.portal,
      l = o.targetRef,
      c = o.position,
      u = i.props,
      f = {
        "data-reach-menu-popover": ""
      };
    return s ? Object(a.createElement)(Vi, wo({}, u, f, {
      as: n,
      targetRef: l,
      position: c
    })) : Object(a.createElement)(n, wo({}, u, f));
  });
  function Po() {
    return (Po = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }).apply(this || _global, arguments);
  }
  const zo = ({
    children: e,
    ...r
  }) => {
    const t = pi();
    return a.createElement(Fo, Po({
      style: t
    }, r), e);
  };
  var Bo = t(24),
    jo = t.n(Bo);
  function Vo(e, r) {
    switch (r.type) {
      case "UPDATE_OWNER_ID":
        const t = r.owners.findIndex(e => e.id === r.ownerID);
        return {
          ownerID: r.ownerID,
          owners: r.owners,
          selectedIndex: t
        };
      case "UPDATE_SELECTED_INDEX":
        return {
          ...e,
          selectedIndex: r.selectedIndex
        };
      default:
        throw new Error(`Invalid action "${r.type}"`);
    }
  }
  function Uo() {
    const e = Object(a.useContext)(Ii),
      {
        ownerID: r
      } = Object(a.useContext)(Wt),
      t = Object(a.useContext)($t),
      [n, i] = Object(a.useReducer)(Vo, {
        ownerID: null,
        owners: [],
        selectedIndex: 0
      });
    if (null === r) i({
      type: "UPDATE_OWNER_ID",
      ownerID: null,
      owners: []
    });else if (r !== n.ownerID) {
      const t = n.owners.findIndex(e => e.id === r) >= 0;
      i({
        type: "UPDATE_OWNER_ID",
        ownerID: r,
        owners: t ? n.owners : e(r) || []
      });
    }
    const {
        owners: o,
        selectedIndex: s
      } = n,
      l = Object(a.useCallback)(e => {
        if (null !== e) {
          const r = o.indexOf(e);
          i({
            type: "UPDATE_SELECTED_INDEX",
            selectedIndex: r >= 0 ? r : 0
          }), t({
            type: "SELECT_OWNER",
            payload: e.id
          });
        } else i({
          type: "UPDATE_SELECTED_INDEX",
          selectedIndex: 0
        }), t({
          type: "RESET_OWNER_STACK"
        });
      }, [o, t]),
      [c, u] = Object(a.useState)(0),
      f = Object(a.useRef)(null),
      d = function (e, r) {
        const [t, n] = Object(a.useState)(!1);
        return Object(a.useLayoutEffect)(() => {
          if (null === e.current) return () => {};
          const t = e.current,
            a = mn()(() => n(t.clientWidth <= r), 100);
          a();
          const i = t.ownerDocument.defaultView;
          return i.addEventListener("resize", a), () => i.removeEventListener("resize", a);
        }, [e, r]), t;
      }(f, c),
      v = o[s];
    return Object(a.useLayoutEffect)(() => {
      if (null === f.current || d) return () => {};
      let e = 0;
      for (let r = 0; r < o.length; r++) {
        const t = f.current.children[r],
          n = getComputedStyle(t);
        e += t.offsetWidth + parseInt(n.marginLeft, 10) + parseInt(n.marginRight, 10);
      }
      u(e);
    }, [f, d, o.length]), a.createElement("div", {
      className: jo.a.OwnerStack
    }, a.createElement("div", {
      className: jo.a.Bar,
      ref: f
    }, d && a.createElement(a.Fragment, null, a.createElement(Wo, {
      owners: o,
      selectedIndex: s,
      selectOwner: l
    }), a.createElement(Xo, {
      owners: o,
      selectedIndex: s,
      selectOwner: l
    }), null != v && a.createElement($o, {
      owner: v,
      isSelected: !0,
      selectOwner: l
    })), !d && o.map((e, r) => a.createElement($o, {
      key: r,
      owner: e,
      isSelected: r === s,
      selectOwner: l
    }))), a.createElement("div", {
      className: jo.a.VRule
    }), a.createElement(Ci, {
      className: jo.a.IconButton,
      onClick: () => l(null),
      title: "Back to tree view"
    }, a.createElement(Tn, {
      type: "close"
    })));
  }
  function Wo({
    owners: e,
    selectedIndex: r,
    selectOwner: t
  }) {
    const n = Object(a.useContext)(et),
      i = [];
    for (let r = e.length - 1; r >= 0; r--) {
      const o = e[r],
        s = n.containsElement(o.id);
      i.push(a.createElement(Io, {
        key: o.id,
        className: `${jo.a.Component} ${s ? "" : jo.a.NotInStore}`,
        onSelect: () => s ? t(o) : null
      }, o.displayName, a.createElement(Mn, {
        className: jo.a.Badge,
        hocDisplayNames: o.hocDisplayNames,
        type: o.type
      })));
    }
    return a.createElement(To, null, a.createElement(No, {
      className: jo.a.MenuButton
    }, a.createElement(bi, {
      label: "Open elements dropdown"
    }, a.createElement("span", {
      className: jo.a.MenuButtonContent,
      tabIndex: -1
    }, a.createElement(Tn, {
      type: "more"
    })))), a.createElement(zo, {
      className: jo.a.Modal
    }, i));
  }
  function $o({
    isSelected: e,
    owner: r,
    selectOwner: t
  }) {
    const n = Object(a.useContext)(et),
      {
        displayName: i,
        hocDisplayNames: o,
        type: s
      } = r,
      l = n.containsElement(r.id),
      c = Object(a.useCallback)(() => {
        l && t(r);
      }, [l, t, r]);
    return a.createElement(Si, {
      className: `${jo.a.Component} ${l ? "" : jo.a.NotInStore}`,
      isChecked: e,
      onChange: c
    }, i, a.createElement(Mn, {
      className: jo.a.Badge,
      hocDisplayNames: o,
      type: s
    }));
  }
  function Xo({
    owners: e,
    selectedIndex: r,
    selectOwner: t
  }) {
    const n = Object(a.useContext)(et);
    if (r <= 0) return null;
    const i = e[r - 1],
      o = n.containsElement(i.id);
    return a.createElement(Ci, {
      className: o ? void 0 : jo.a.NotInStore,
      onClick: () => o ? t(i) : null,
      title: "Up to " + (i.displayName || "owner")
    }, a.createElement(Tn, {
      type: "previous"
    }));
  }
  var Go = t(31),
    Ko = t.n(Go);
  function Yo({
    goToNextResult: e,
    goToPreviousResult: r,
    placeholder: t,
    search: n,
    searchIndex: i,
    searchResultsCount: o,
    searchText: s,
    testName: l
  }) {
    const c = Object(a.useRef)(null);
    return Object(a.useEffect)(() => {
      if (null === c.current) return () => {};
      const e = e => {
          const {
            key: r,
            metaKey: t
          } = e;
          "f" === r && t && null !== c.current && (c.current.focus(), e.preventDefault(), e.stopPropagation());
        },
        r = c.current.ownerDocument;
      return r.addEventListener("keydown", e), () => r.removeEventListener("keydown", e);
    }, []), a.createElement("div", {
      className: Ko.a.SearchInput,
      "data-testname": l
    }, a.createElement(qt, {
      className: Ko.a.InputIcon,
      type: "search"
    }), a.createElement("input", {
      "data-testname": l ? l + "-Input" : void 0,
      className: Ko.a.Input,
      onChange: ({
        currentTarget: e
      }) => {
        n(e.value);
      },
      onKeyPress: ({
        key: t,
        shiftKey: n
      }) => {
        "Enter" === t && (n ? r() : e());
      },
      placeholder: t,
      ref: c,
      value: s
    }), !!s && a.createElement(a.Fragment, null, a.createElement("span", {
      className: Ko.a.IndexLabel,
      "data-testname": l ? l + "-ResultsCount" : void 0
    }, Math.min(i + 1, o), " |", " ", o), a.createElement("div", {
      className: Ko.a.LeftVRule
    }), a.createElement(Ci, {
      "data-testname": l ? l + "-PreviousButton" : void 0,
      className: Ko.a.IconButton,
      disabled: !s,
      onClick: r,
      title: a.createElement(a.Fragment, null, "Scroll to previous search result (", a.createElement("kbd", null, "Shift"), " +", " ", a.createElement("kbd", null, "Enter"), ")")
    }, a.createElement(Tn, {
      type: "up"
    })), a.createElement(Ci, {
      "data-testname": l ? l + "-NextButton" : void 0,
      className: Ko.a.IconButton,
      disabled: !s,
      onClick: e,
      title: a.createElement(a.Fragment, null, "Scroll to next search result (", a.createElement("kbd", null, "Enter"), ")")
    }, a.createElement(Tn, {
      type: "down"
    })), a.createElement(Ci, {
      "data-testname": l ? l + "-ResetButton" : void 0,
      className: Ko.a.IconButton,
      disabled: !s,
      onClick: () => n(""),
      title: "Reset search"
    }, a.createElement(Tn, {
      type: "close"
    }))));
  }
  function qo(e) {
    const {
        searchIndex: r,
        searchResults: t,
        searchText: n
      } = Object(a.useContext)(Wt),
      i = Object(a.useContext)($t);
    return a.createElement(Yo, {
      goToNextResult: () => i({
        type: "GO_TO_NEXT_SEARCH_RESULT"
      }),
      goToPreviousResult: () => i({
        type: "GO_TO_PREVIOUS_SEARCH_RESULT"
      }),
      placeholder: "Search (text or /regex/)",
      search: e => i({
        type: "SET_SEARCH_TEXT",
        payload: e
      }),
      searchIndex: r,
      searchResultsCount: t.length,
      searchText: n,
      testName: "ComponentSearchInput"
    });
  }
  const Qo = Object(a.createContext)(null);
  function Zo({
    children: e
  }) {
    const [r, t] = Object(a.useState)(!1),
      n = Object(a.useMemo)(() => ({
        isModalShowing: r,
        setIsModalShowing: t
      }), [r, t]);
    return a.createElement(Qo.Provider, {
      value: n
    }, e);
  }
  function Jo() {
    const {
        setIsModalShowing: e
      } = Object(a.useContext)(Qo),
      r = Object(a.useContext)(et),
      {
        profilerStore: t
      } = r,
      n = Object(a.useCallback)(() => e(!0), [e]),
      i = bn(Object(a.useMemo)(() => ({
        getCurrentValue: () => t.isProfiling,
        subscribe: e => (t.addListener("isProfiling", e), () => t.removeListener("isProfiling", e))
      }), [t]));
    return a.createElement(Ci, {
      disabled: i,
      onClick: n,
      title: "View settings"
    }, a.createElement(Tn, {
      type: "settings"
    }));
  }
  Qo.displayName = "SettingsModalContext";
  var es = Object(a.createContext)(!1),
    rs = t(69),
    ts = t.n(rs);
  function ns(e) {
    const {
        lineHeight: r
      } = Object(a.useContext)(En),
      t = Object(a.useContext)(et),
      n = Object(a.useContext)(es),
      {
        ownerID: i,
        selectedElementID: o
      } = Object(a.useContext)(Wt),
      s = bn(Object(a.useMemo)(() => ({
        getCurrentValue: () => {
          if (null === o || t.isInsideCollapsedSubTree(o)) return null;
          const e = t.getElementByID(o);
          if (null === e || e.isCollapsed || 0 === e.children.length) return null;
          const r = t.getIndexOfElementID(e.children[0]);
          if (null === r) return null;
          let n = null,
            a = e;
          for (; null !== a;) if (a.isCollapsed || 0 === a.children.length) n = t.getIndexOfElementID(a.id), a = null;else {
            const e = a.children[a.children.length - 1];
            a = t.getElementByID(e);
          }
          return null === n ? null : {
            startIndex: r,
            stopIndex: n
          };
        },
        subscribe: e => (t.addListener("mutated", e), () => {
          t.removeListener("mutated", e);
        })
      }), [o, t]));
    if (null !== i) return null;
    if (null === s) return null;
    const {
      startIndex: l,
      stopIndex: c
    } = s;
    return a.createElement("div", {
      className: n ? ts.a.Active : ts.a.Inactive,
      style: {
        position: "absolute",
        top: l * r + "px",
        height: (c + 1 - l) * r + "px"
      }
    });
  }
  class as extends Error {
    constructor(e) {
      super(e), Error.captureStackTrace && Error.captureStackTrace(this, as), this.name = "TimeoutError";
    }
  }
  function is({
    bridge: e,
    forceFullData: r,
    id: t,
    path: n,
    rendererID: a
  }) {
    const i = ss++,
      o = function (e, r, t, n) {
        return new Promise((a, i) => {
          const o = () => {
              t.removeListener(r, s), clearTimeout(l);
            },
            s = r => {
              r.responseID === e && (o(), a(r));
            };
          t.addListener(r, s);
          const l = setTimeout(() => {
            o(), i(new as(n));
          }, 5000);
        });
      }(i, "inspectedElement", e, `Timed out while inspecting element ${t}.`);
    return e.send("inspectElement", {
      forceFullData: r,
      id: t,
      path: n,
      rendererID: a,
      requestID: i
    }), o;
  }
  let os = 0;
  let ss = 0;
  function ls(e, r) {
    if (null !== e) {
      const {
        cleaned: t,
        data: n,
        unserializable: a
      } = e;
      if (r) {
        const {
          length: e
        } = r;
        if (e > 0) return y(n, t.map(r => r.slice(e)), a.map(r => r.slice(e)));
      }
      return y(n, t, a);
    }
    return null;
  }
  var cs = t(20),
    us = t.n(cs);
  function fs() {
    return (fs = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }).apply(this || _global, arguments);
  }
  function ds(e) {
    const r = Object(a.useContext)($t),
      {
        numElements: t,
        ownerID: n,
        searchIndex: i,
        searchResults: o,
        selectedElementID: s,
        selectedElementIndex: l
      } = Object(a.useContext)(Wt),
      c = Object(a.useContext)(Jr),
      u = Object(a.useContext)(et),
      {
        hideSettings: f
      } = Object(a.useContext)(tt),
      [d, v] = Object(a.useState)(!1),
      {
        highlightNativeElement: h,
        clearHighlightNativeElement: m
      } = Sn(),
      _ = Object(a.useRef)(null),
      p = Object(a.useRef)(null),
      [g, b] = Object(a.useState)(!1),
      {
        lineHeight: S,
        showInlineWarningsAndErrors: E
      } = Object(a.useContext)(En),
      w = Object(a.useCallback)(e => {
        null != e && null !== l && e.scrollToItem(l, "smart");
      }, [l]);
    Object(a.useEffect)(() => {
      function e(e) {
        e && null !== p.current && (p.current.focus(), Object(qe.a)({
          event_name: "select-element",
          metadata: {
            source: "inspector"
          }
        }));
      }
      return c.addListener("stopInspectingNative", e), () => c.removeListener("stopInspectingNative", e);
    }, [c]);
    const y = Object(a.useRef)(null);
    Object(a.useEffect)(() => {
      if (null === _.current) return () => {};
      const e = e => {
          if ("INPUT" === e.target.tagName || e.defaultPrevented) return;
          let t;
          switch (e.key) {
            case "ArrowDown":
              e.preventDefault(), e.altKey ? r({
                type: "SELECT_NEXT_SIBLING_IN_TREE"
              }) : r({
                type: "SELECT_NEXT_ELEMENT_IN_TREE"
              });
              break;
            case "ArrowLeft":
              e.preventDefault(), t = null !== s ? u.getElementByID(s) : null, null !== t && (e.altKey ? null !== t.ownerID && r({
                type: "SELECT_OWNER_LIST_PREVIOUS_ELEMENT_IN_TREE"
              }) : t.children.length > 0 && !t.isCollapsed ? u.toggleIsCollapsed(t.id, !0) : r({
                type: "SELECT_PARENT_ELEMENT_IN_TREE"
              }));
              break;
            case "ArrowRight":
              e.preventDefault(), t = null !== s ? u.getElementByID(s) : null, null !== t && (e.altKey ? r({
                type: "SELECT_OWNER_LIST_NEXT_ELEMENT_IN_TREE"
              }) : t.children.length > 0 && t.isCollapsed ? u.toggleIsCollapsed(t.id, !1) : r({
                type: "SELECT_CHILD_ELEMENT_IN_TREE"
              }));
              break;
            case "ArrowUp":
              e.preventDefault(), e.altKey ? r({
                type: "SELECT_PREVIOUS_SIBLING_IN_TREE"
              }) : r({
                type: "SELECT_PREVIOUS_ELEMENT_IN_TREE"
              });
              break;
            default:
              return;
          }
          v(!0);
        },
        t = _.current;
      return t.addEventListener("keydown", e), () => {
        t.removeEventListener("keydown", e);
      };
    }, [r, s, u]);
    const k = Object(a.useCallback)(() => b(!1), []),
      C = Object(a.useCallback)(() => {
        b(!0), null === l && t > 0 && r({
          type: "SELECT_ELEMENT_AT_INDEX",
          payload: 0
        });
      }, [r, t, l]),
      D = Object(a.useCallback)(e => {
        switch (e.key) {
          case "Enter":
          case " ":
            null !== s && r({
              type: "SELECT_OWNER",
              payload: s
            });
        }
      }, [r, s]),
      A = Object(a.useRef)({
        searchIndex: i,
        searchResults: o
      });
    Object(a.useEffect)(() => {
      let e = !1;
      A.current.searchIndex === i && A.current.searchResults === o || (A.current.searchIndex = i, A.current.searchResults = o, e = !0), (d || e) && (null !== s ? h(s) : m());
    }, [c, d, h, i, o, s]);
    const M = Object(a.useCallback)(e => {
        d || h(e);
      }, [d, h]),
      x = Object(a.useCallback)(() => {
        v(!1);
      }, []),
      O = m,
      T = Object(a.useMemo)(() => ({
        numElements: t,
        isNavigatingWithKeyboard: d,
        onElementMouseEnter: M,
        lastScrolledIDRef: y,
        treeFocused: g
      }), [t, d, M, y, g]),
      N = Object(a.useCallback)(e => u.getElementIDAtIndex(e), [u]),
      R = a.useCallback(() => {
        r({
          type: "SELECT_PREVIOUS_ELEMENT_WITH_ERROR_OR_WARNING_IN_TREE"
        });
      }, []),
      I = a.useCallback(() => {
        r({
          type: "SELECT_NEXT_ELEMENT_WITH_ERROR_OR_WARNING_IN_TREE"
        });
      }, []),
      H = Object(a.useMemo)(() => ({
        getCurrentValue: () => ({
          errors: u.errorCount,
          warnings: u.warningCount
        }),
        subscribe: e => (u.addListener("mutated", e), () => u.removeListener("mutated", e))
      }), [u]),
      {
        errors: F,
        warnings: L
      } = bn(H),
      P = a.createElement("div", {
        className: us.a.ZeroElementsNotice
      }, a.createElement("p", null, "Loading React Element Tree..."), a.createElement("p", null, "If this seems stuck, please follow the", " ", a.createElement("a", {
        className: us.a.Link,
        href: "https://github.com/facebook/react/tree/main/packages/react-devtools#the-issue-with-chrome-v101-and-earlier-versions",
        target: "_blank"
      }, "troubleshooting instructions"), "."));
    return a.createElement(es.Provider, {
      value: g
    }, a.createElement("div", {
      className: us.a.Tree,
      ref: _
    }, a.createElement("div", {
      className: us.a.SearchInput
    }, u.supportsNativeInspection && a.createElement(a.Fragment, null, a.createElement(Ei, null), a.createElement("div", {
      className: us.a.VRule
    })), a.createElement(a.Suspense, {
      fallback: a.createElement(hs, null)
    }, null !== n ? a.createElement(Uo, null) : a.createElement(qo, null)), E && null === n && (F > 0 || L > 0) && a.createElement(a.Fragment, null, a.createElement("div", {
      className: us.a.VRule
    }), F > 0 && a.createElement("div", {
      className: us.a.IconAndCount
    }, a.createElement(qt, {
      className: us.a.ErrorIcon,
      type: "error"
    }), F), L > 0 && a.createElement("div", {
      className: us.a.IconAndCount
    }, a.createElement(qt, {
      className: us.a.WarningIcon,
      type: "warning"
    }), L), a.createElement(Ci, {
      onClick: R,
      title: "Scroll to previous error or warning"
    }, a.createElement(Tn, {
      type: "up"
    })), a.createElement(Ci, {
      onClick: I,
      title: "Scroll to next error or warning"
    }, a.createElement(Tn, {
      type: "down"
    })), a.createElement(Ci, {
      onClick: () => {
        !function ({
          bridge: e,
          store: r
        }) {
          r.rootIDToRendererID.forEach(r => {
            e.send("clearErrorsAndWarnings", {
              rendererID: r
            });
          });
        }({
          bridge: c,
          store: u
        });
      },
      title: "Clear all errors and warnings"
    }, a.createElement(Tn, {
      type: "clear"
    }))), !f && a.createElement(a.Fragment, null, a.createElement("div", {
      className: us.a.VRule
    }), a.createElement(Jo, null))), 0 === t ? P : a.createElement("div", {
      className: us.a.AutoSizerWrapper,
      onBlur: k,
      onFocus: C,
      onKeyPress: D,
      onMouseMove: x,
      onMouseLeave: O,
      ref: p,
      tabIndex: 0
    }, a.createElement(pt, null, ({
      height: e,
      width: r
    }) => a.createElement(Nt, {
      className: us.a.List,
      height: e,
      innerElementType: vs,
      itemCount: t,
      itemData: T,
      itemKey: N,
      itemSize: S,
      ref: w,
      width: r
    }, ca)))));
  }
  function vs({
    children: e,
    style: r,
    ...t
  }) {
    const {
        ownerID: n
      } = Object(a.useContext)(Wt),
      i = Object(a.useMemo)(() => new WeakMap(), []),
      o = Object(a.useRef)(12),
      s = Object(a.useRef)(0),
      l = Object(a.useRef)(n),
      c = Object(a.useRef)(null);
    return n !== l.current && (l.current = n, o.current = 12), Object(a.useEffect)(() => {
      null !== c.current && function (e, r, t, n) {
        const a = e.parentElement,
          i = a.clientWidth;
        if (0 === i) return;
        i > n.current && (t.current = 12), n.current = i;
        let o = t.current;
        for (const t of e.children) {
          const e = parseInt(t.getAttribute("data-depth"), 10) || 0;
          let n = 0;
          const a = r.get(t);
          if (null != a) n = a;else {
            const {
              firstElementChild: e
            } = t;
            null != e && (n = e.clientWidth, r.set(t, n));
          }
          const s = Math.max(0, i - n);
          o = Math.min(o, s / e);
        }
        t.current = o, a.style.setProperty("--indentation-size", o + "px");
      }(c.current, i, o, s);
    }), a.createElement("div", fs({
      className: us.a.InnerElementType,
      ref: c,
      style: r
    }, t), a.createElement(ns, null), e);
  }
  function hs() {
    return a.createElement("div", {
      className: us.a.Loading
    }, "Loading...");
  }
  var ms = t(6),
    _s = t.n(ms);
  function ps({
    callStack: e,
    children: r,
    componentStack: t,
    errorMessage: n
  }) {
    return a.createElement("div", {
      className: _s.a.ErrorBoundary
    }, r, a.createElement("div", {
      className: _s.a.ErrorInfo
    }, a.createElement("div", {
      className: _s.a.HeaderRow
    }, a.createElement("div", {
      className: _s.a.ErrorHeader
    }, n || "Bridge protocol mismatch")), a.createElement("div", {
      className: _s.a.InfoBox
    }, "An incompatible version of ", a.createElement("code", null, "react-devtools-core"), " has been embedded in a renderer like React Native. To fix this, update the", " ", a.createElement("code", null, "react-devtools-core"), " package within the React Native application, or downgrade the ", a.createElement("code", null, "react-devtools"), " package you use to open the DevTools UI."), !!e && a.createElement("div", {
      className: _s.a.ErrorStack
    }, "The error was thrown ", e.trim())));
  }
  function gs({
    callStack: e,
    children: r,
    componentStack: t,
    dismissError: n = null,
    errorMessage: i
  }) {
    return a.createElement("div", {
      className: _s.a.ErrorBoundary
    }, r, a.createElement("div", {
      className: _s.a.ErrorInfo
    }, a.createElement("div", {
      className: _s.a.HeaderRow
    }, a.createElement("div", {
      className: _s.a.ErrorHeader
    }, "Uncaught Error: ", i || ""), null !== n && a.createElement(Ci, {
      className: _s.a.CloseButton,
      onClick: n
    }, "Dismiss", a.createElement(Tn, {
      className: _s.a.CloseButtonIcon,
      type: "close"
    }))), !!e && a.createElement("div", {
      className: _s.a.ErrorStack
    }, "The error was thrown ", e.trim()), !!t && a.createElement("div", {
      className: _s.a.ErrorStack
    }, "The error occurred ", t.trim())));
  }
  var bs = t(93),
    Ss = t.n(bs);
  function Es({
    className: e = ""
  }) {
    return a.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      className: `${Ss.a.Icon} ${e}`,
      width: "24",
      height: "24",
      viewBox: "0 0 100 100"
    }, a.createElement("path", {
      d: "M0 0h100v100H0z",
      fill: "none"
    }), a.createElement("circle", {
      fill: "currentColor",
      stroke: "none",
      cx: "20",
      cy: "50",
      r: "10"
    }, a.createElement("animate", {
      attributeName: "opacity",
      dur: "1s",
      values: "0;1;0",
      repeatCount: "indefinite",
      begin: "0.1"
    })), a.createElement("circle", {
      fill: "currentColor",
      stroke: "none",
      cx: "50",
      cy: "50",
      r: "10"
    }, a.createElement("animate", {
      attributeName: "opacity",
      dur: "1s",
      values: "0;1;0",
      repeatCount: "indefinite",
      begin: "0.2"
    })), a.createElement("circle", {
      fill: "currentColor",
      stroke: "none",
      cx: "80",
      cy: "50",
      r: "10"
    }, a.createElement("animate", {
      attributeName: "opacity",
      dur: "1s",
      values: "0;1;0",
      repeatCount: "indefinite",
      begin: "0.3"
    })));
  }
  function ws() {
    return a.createElement("div", {
      className: _s.a.GitHubLinkRow
    }, a.createElement(Es, {
      className: _s.a.LoadingIcon
    }), "Searching GitHub for reports of this error...");
  }
  function ys(e) {
    e = e.replace(/"[0-9]+"/g, "");
    return "https://api.github.com/search/issues?q=" + encodeURIComponent(e) + "%20" + ["in:title", "is:issue", "is:open", "is:public", "label:\"Component: Developer Tools\"", "repo:facebook/react"].map(encodeURIComponent).join("%20");
  }
  function ks() {
    return new Map();
  }
  function Cs(e) {
    e = function (e) {
      return e = e.replace(/"[0-9]+"/, "");
    }(e);
    const r = Object(a.unstable_getCacheForType)(ks);
    let t = r.get(e);
    if (!t) {
      const n = new Set(),
        a = () => {
          n.forEach(e => e()), n.clear();
        },
        i = t = {
          status: 0,
          value: {
            then(e) {
              n.add(e);
            },
            displayName: `Searching GitHub issues for error "${e}"`
          }
        };
      let o = !1;
      (async function (e) {
        const r = await fetch(ys(e)),
          t = await r.json();
        if (t.items.length > 0) {
          const e = t.items[0];
          return {
            title: e.title,
            url: e.html_url
          };
        }
        return null;
      })(e).then(e => {
        if (!o) {
          if (e) {
            const r = i;
            r.status = 1, r.value = e;
          } else {
            const e = i;
            e.status = 2, e.value = null;
          }
          a();
        }
      }).catch(e => {
        const r = i;
        r.status = 2, r.value = null, a();
      }), setTimeout(() => {
        o = !0;
        const e = i;
        e.status = 2, e.value = null, a();
      }, 3000), r.set(e, t);
    }
    return function (e) {
      if (1 === e.status) return e;
      if (2 === e.status) return e;
      throw e.value;
    }(t).value;
  }
  function Ds({
    gitHubIssue: e
  }) {
    const {
      title: r,
      url: t
    } = e;
    return a.createElement("div", {
      className: _s.a.GitHubLinkRow
    }, a.createElement(qt, {
      className: _s.a.ReportIcon,
      type: "bug"
    }), a.createElement("div", {
      className: _s.a.UpdateExistingIssuePrompt
    }, "Update existing issue:"), a.createElement("a", {
      className: _s.a.ReportLink,
      href: t,
      rel: "noopener noreferrer",
      target: "_blank",
      title: "Report bug"
    }, r));
  }
  const As = ["Component: Developer Tools", "Type: Bug", "Status: Unconfirmed"];
  function Ms({
    callStack: e,
    componentStack: r,
    errorMessage: t
  }) {
    let n = "https://github.com/facebook/react";
    if (!n) return null;
    const i = null !== t ? ys(t) : "(none)",
      o = "[DevTools Bug] " + (t || "");
    return n += "/issues/new?" + ["template=devtools_bug_report.yml", "labels=" + encodeURIComponent(As.join(",")), "title=" + encodeURIComponent(o), "automated_package=react-devtools-core", "automated_version=4.27.2-7f747b80e", "automated_error_message=" + encodeURIComponent(t || ""), "automated_call_stack=" + encodeURIComponent(e || ""), "automated_component_stack=" + encodeURIComponent(r || ""), "automated_github_query_string=" + i].join("&"), a.createElement("div", {
      className: _s.a.GitHubLinkRow
    }, a.createElement(qt, {
      className: _s.a.ReportIcon,
      type: "bug"
    }), a.createElement("a", {
      className: _s.a.ReportLink,
      href: n,
      rel: "noopener noreferrer",
      target: "_blank",
      title: "Report bug"
    }, "Report this issue"), a.createElement("div", {
      className: _s.a.ReproSteps
    }, "(Please include steps on how to reproduce it and the components used.)"));
  }
  function xs() {
    return Qe.g ? a.createElement("div", {
      className: _s.a.WorkplaceGroupRow
    }, a.createElement(qt, {
      className: _s.a.ReportIcon,
      type: "facebook"
    }), a.createElement("a", {
      className: _s.a.ReportLink,
      href: v.t,
      rel: "noopener noreferrer",
      target: "_blank",
      title: "Report bug"
    }, "Report this on Workplace"), a.createElement("div", {
      className: _s.a.FacebookOnly
    }, "(Facebook employees only.)")) : null;
  }
  function Os({
    callStack: e,
    componentStack: r,
    errorMessage: t
  }) {
    const n = null !== t ? Cs(t) : null;
    let i;
    return i = null != n ? a.createElement(Ds, {
      gitHubIssue: n
    }) : a.createElement(Ms, {
      callStack: e,
      componentStack: r,
      errorMessage: t
    }), a.createElement(a.Fragment, null, i, a.createElement(xs, null));
  }
  function Ts({
    callStack: e,
    children: r,
    componentStack: t,
    dismissError: n = null,
    errorMessage: i
  }) {
    return a.createElement("div", {
      className: _s.a.ErrorBoundary
    }, r, a.createElement("div", {
      className: _s.a.ErrorInfo
    }, a.createElement("div", {
      className: _s.a.HeaderRow
    }, a.createElement("div", {
      className: _s.a.TimeoutHeader
    }, i || "Timed out waiting"), a.createElement(Ci, {
      className: _s.a.CloseButton,
      onClick: n
    }, "Retry", a.createElement(Tn, {
      className: _s.a.CloseButtonIcon,
      type: "close"
    }))), !!t && a.createElement("div", {
      className: _s.a.TimeoutStack
    }, "The timeout occurred ", t.trim())));
  }
  function Ns({
    callStack: e,
    children: r,
    info: t,
    componentStack: n,
    errorMessage: i
  }) {
    return a.createElement("div", {
      className: _s.a.ErrorBoundary
    }, r, a.createElement("div", {
      className: _s.a.ErrorInfo
    }, a.createElement("div", {
      className: _s.a.HeaderRow
    }, a.createElement("div", {
      className: _s.a.ErrorHeader
    }, i)), !!t && a.createElement("div", {
      className: _s.a.InfoBox
    }, t), !!e && a.createElement("div", {
      className: _s.a.ErrorStack
    }, "The error was thrown ", e.trim())));
  }
  class Rs extends Error {
    constructor(e) {
      super(e), Error.captureStackTrace && Error.captureStackTrace(this, Rs), this.name = "UserError";
    }
  }
  class Is extends Error {
    constructor(e) {
      super(e), Error.captureStackTrace && Error.captureStackTrace(this, Is), this.name = "UnknownHookError";
    }
  }
  function Hs(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  const Fs = {
    callStack: null,
    canDismiss: !1,
    componentStack: null,
    errorMessage: null,
    hasError: !1,
    isUnsupportedBridgeOperationError: !1,
    isTimeout: !1,
    isUserError: !1,
    isUnknownHookError: !1
  };
  class Ls extends a.Component {
    constructor(...e) {
      super(...e), Hs(this, "state", Fs), Hs(this, "_logError", (e, r) => {
        var t, n;
        Object(qe.a)({
          event_name: "error",
          error_message: null !== (t = e.message) && void 0 !== t ? t : null,
          error_stack: null !== (n = e.stack) && void 0 !== n ? n : null,
          error_component_stack: null != r ? r : null
        });
      }), Hs(this, "_dismissError", () => {
        const e = this.props.onBeforeDismissCallback;
        "function" == typeof e && e(), this.setState(Fs);
      }), Hs(this, "_onStoreError", e => {
        this.state.hasError || (this._logError(e, null), this.setState({
          ...Ls.getDerivedStateFromError(e),
          canDismiss: !0
        }));
      });
    }
    static getDerivedStateFromError(e) {
      const r = "object" == typeof e && null !== e && "string" == typeof e.message ? e.message : null,
        t = e instanceof as,
        n = e instanceof Rs,
        a = e instanceof Is,
        i = e instanceof Xe;
      return {
        callStack: "object" == typeof e && null !== e && "string" == typeof e.stack ? e.stack.split("\n").slice(1).join("\n") : null,
        errorMessage: r,
        hasError: !0,
        isUnsupportedBridgeOperationError: i,
        isUnknownHookError: a,
        isTimeout: t,
        isUserError: n
      };
    }
    componentDidCatch(e, {
      componentStack: r
    }) {
      this._logError(e, r), this.setState({
        componentStack: r
      });
    }
    componentDidMount() {
      const {
        store: e
      } = this.props;
      null != e && e.addListener("error", this._onStoreError);
    }
    componentWillUnmount() {
      const {
        store: e
      } = this.props;
      null != e && e.removeListener("error", this._onStoreError);
    }
    render() {
      const {
          canDismiss: e,
          children: r
        } = this.props,
        {
          callStack: t,
          canDismiss: n,
          componentStack: i,
          errorMessage: o,
          hasError: s,
          isUnsupportedBridgeOperationError: l,
          isTimeout: c,
          isUserError: u,
          isUnknownHookError: f
        } = this.state;
      return s ? c ? a.createElement(Ts, {
        callStack: t,
        componentStack: i,
        dismissError: e || n ? this._dismissError : null,
        errorMessage: o
      }) : l ? a.createElement(ps, {
        callStack: t,
        componentStack: i,
        errorMessage: o
      }) : u ? a.createElement(Ns, {
        callStack: t,
        componentStack: i,
        errorMessage: o || "Error occured in inspected element",
        info: a.createElement(a.Fragment, null, "React DevTools encountered an error while trying to inspect the hooks. This is most likely caused by a developer error in the currently inspected element. Please see your console for logged error.")
      }) : f ? a.createElement(Ns, {
        callStack: t,
        componentStack: i,
        errorMessage: o || "Encountered an unknown hook",
        info: a.createElement(a.Fragment, null, "React DevTools encountered an unknown hook. This is probably because the react-debug-tools package is out of date. To fix, upgrade the React DevTools to the most recent version.")
      }) : a.createElement(gs, {
        callStack: t,
        componentStack: i,
        dismissError: e || n ? this._dismissError : null,
        errorMessage: o
      }, a.createElement(a.Suspense, {
        fallback: a.createElement(ws, null)
      }, a.createElement(Os, {
        callStack: t,
        componentStack: i,
        errorMessage: o
      }))) : r;
    }
  }
  var Ps = Ls;
  function zs({
    children: e
  }) {
    const r = pi(),
      t = a.useMemo(() => ({
        ...r,
        width: "100%",
        height: "100%"
      }), [r]);
    return a.createElement("div", {
      style: t
    }, e);
  }
  function Bs(e) {
    return function ({
      portalContainer: r,
      ...t
    }) {
      const n = Object(a.useContext)(et);
      let o = a.createElement(Ps, {
        store: n
      }, a.createElement(e, t));
      return null != r && (o = a.createElement(zs, null, a.createElement("div", {
        "data-react-devtools-portal-root": !0,
        style: {
          width: "100vw",
          height: "100vh"
        }
      }, o))), null != r ? Object(i.createPortal)(o, r) : o;
    };
  }
  const js = new m.a({
    max: 25
  });
  function Vs({
    bridge: e,
    element: r,
    path: t,
    rendererID: n
  }) {
    const {
      id: a
    } = r;
    return is({
      bridge: e,
      forceFullData: !js.has(a),
      id: a,
      path: t,
      rendererID: n
    }).then(e => {
      const {
        type: r
      } = e;
      let n;
      switch (r) {
        case "error":
          {
            const {
              message: r,
              stack: t,
              errorType: n
            } = e;
            let a;
            throw a = "user" === n ? new Rs(r) : "unknown-hook" === n ? new Is(r) : new Error(r), a.stack = t || a.stack, a;
          }
        case "no-change":
          if (n = js.get(a), null != n) return [n, r];
          throw Error(`Cached data for element "${a}" not found`);
        case "not-found":
          throw js.del(a), Error(`Element "${a}" not found`);
        case "full-data":
          return n = function (e) {
            const {
              canEditFunctionProps: r,
              canEditFunctionPropsDeletePaths: t,
              canEditFunctionPropsRenamePaths: n,
              canEditHooks: a,
              canEditHooksAndDeletePaths: i,
              canEditHooksAndRenamePaths: o,
              canToggleError: s,
              isErrored: l,
              targetErrorBoundaryID: c,
              canToggleSuspense: u,
              canViewSource: f,
              hasLegacyContext: d,
              id: v,
              source: h,
              type: m,
              owners: _,
              context: p,
              hooks: g,
              plugins: b,
              props: S,
              rendererPackageName: E,
              rendererVersion: w,
              rootType: y,
              state: k,
              key: C,
              errors: D,
              warnings: A
            } = e;
            return {
              canEditFunctionProps: r,
              canEditFunctionPropsDeletePaths: t,
              canEditFunctionPropsRenamePaths: n,
              canEditHooks: a,
              canEditHooksAndDeletePaths: i,
              canEditHooksAndRenamePaths: o,
              canToggleError: s,
              isErrored: l,
              targetErrorBoundaryID: c,
              canToggleSuspense: u,
              canViewSource: f,
              hasLegacyContext: d,
              id: v,
              key: C,
              plugins: b,
              rendererPackageName: E,
              rendererVersion: w,
              rootType: y,
              source: h,
              type: m,
              owners: null === _ ? null : _.map(e => {
                const [r, t] = L(e.displayName, e.type);
                return {
                  ...e,
                  displayName: r,
                  hocDisplayNames: t
                };
              }),
              context: ls(p),
              hooks: ls(g),
              props: ls(S),
              state: ls(k),
              errors: D,
              warnings: A
            };
          }(e.value), js.set(a, n), [n, r];
        case "hydrated-path":
          const i = e,
            {
              value: o
            } = i;
          if (n = js.get(a) || null, null !== n) return n = {
            ...n
          }, w(n, o, t, ls(o, t)), js.set(a, n), [n, r];
          break;
        default:
          0;
      }
      throw Error(`Unable to inspect element with id "${a}"`);
    });
  }
  function Us() {
    return new WeakMap();
  }
  function Ws(e, r, t, n) {
    const i = Object(a.unstable_getCacheForType)(Us);
    let o = i.get(e);
    if (!o) {
      const a = new Set(),
        s = {
          then(e) {
            a.add(e);
          },
          displayName: "Inspecting " + (e.displayName || "Unknown")
        },
        l = () => {
          a.forEach(e => e()), a.clear();
        },
        c = o = {
          status: 0,
          value: s
        },
        u = t.getRendererIDForElement(e.id);
      if (null == u) {
        const r = c;
        return r.status = 2, r.value = new Error(`Could not inspect element with id "${e.id}". No renderer found.`), i.set(e, o), null;
      }
      Vs({
        bridge: n,
        element: e,
        path: r,
        rendererID: u
      }).then(([e]) => {
        const r = c;
        r.status = 1, r.value = e, l();
      }, e => {
        console.error(e);
        const r = c;
        r.status = 2, r.value = e, l();
      }), i.set(e, o);
    }
    return function (e) {
      if (1 === e.status) return e;
      throw e.value;
    }(o).value;
  }
  function $s({
    bridge: e,
    element: r,
    refresh: t,
    store: n
  }) {
    const {
        id: i
      } = r,
      o = n.getRendererIDForElement(i);
    null != o && Vs({
      bridge: e,
      element: r,
      path: null,
      rendererID: o
    }).then(([e, n]) => {
      "full-data" === n && Object(a.startTransition)(() => {
        const [n, a] = function (e, r) {
          const t = {
              status: 1,
              value: r
            },
            n = Us();
          return n.set(e, t), [Us, n];
        }(r, e);
        t(n, a);
      });
    }, e => {
      console.error(e);
    });
  }
  var Xs = t(94),
    Gs = t.n(Xs);
  function Ks({
    children: e
  }) {
    const {
        selectedElementID: r
      } = Object(a.useContext)(Wt),
      t = Object(a.unstable_useCacheRefresh)(),
      n = Object(a.useCallback)(() => {
        !function (e) {
          Object(a.startTransition)(() => {
            const r = Us();
            e(Us, r);
          });
        }(t);
      }, [t]);
    return a.createElement("div", {
      className: Gs.a.Wrapper
    }, a.createElement(Ps, {
      key: r,
      canDismiss: !0,
      onBeforeDismissCallback: n
    }, e));
  }
  var Ys = t(42),
    qs = t.n(Ys);
  const Qs = Object(a.createContext)(null);
  function Zs(e, r) {
    switch (r.type) {
      case "HIDE":
        return {
          dialogs: e.dialogs.filter(e => e.id !== r.id)
        };
      case "SHOW":
        return {
          dialogs: [...e.dialogs, {
            canBeDismissed: !1 !== r.canBeDismissed,
            content: r.content,
            id: r.id,
            title: r.title || null
          }]
        };
      default:
        throw new Error(`Invalid action "${r.type}"`);
    }
  }
  function Js({
    children: e
  }) {
    const [r, t] = Object(a.useReducer)(Zs, {
        dialogs: []
      }),
      n = Object(a.useMemo)(() => ({
        dialogs: r.dialogs,
        dispatch: t
      }), [r, t]);
    return a.createElement(Qs.Provider, {
      value: n
    }, e);
  }
  function el(e) {
    const {
      dialogs: r,
      dispatch: t
    } = Object(a.useContext)(Qs);
    return 0 === r.length ? null : a.createElement("div", {
      className: qs.a.Background
    }, r.map(e => a.createElement(rl, {
      key: e.id,
      canBeDismissed: e.canBeDismissed,
      content: e.content,
      dispatch: t,
      id: e.id,
      title: e.title
    })));
  }
  function rl({
    canBeDismissed: e,
    content: r,
    dispatch: t,
    id: n,
    title: i
  }) {
    const o = Object(a.useCallback)(() => {
        e && t({
          type: "HIDE",
          id: n
        });
      }, [e, t]),
      s = Object(a.useRef)(null);
    gn(s, o, !1);
    return a.createElement("div", {
      ref: s,
      className: qs.a.Dialog,
      onClick: e => {
        e.stopPropagation();
      }
    }, null !== i && a.createElement("div", {
      className: qs.a.Title
    }, i), r, e && a.createElement("div", {
      className: qs.a.Buttons
    }, a.createElement(Ci, {
      autoFocus: !0,
      className: qs.a.Button,
      onClick: o
    }, "Okay")));
  }
  Qs.displayName = "ModalDialogContext";
  const tl = Object(a.createContext)(null);
  tl.displayName = "ViewElementSourceContext";
  var nl = tl;
  function al() {
    return !!Object(a.useContext)(et).componentFilters.find(e => 1 === e.type && 12 === e.value && e.isEnabled) ? a.createElement("div", null, "Suspended state cannot be toggled while Suspense components are hidden. Disable the filter and try again.") : a.createElement("div", null, "The selected element is not within a Suspense container. Suspending it would cause an error.");
  }
  const il = new Map(),
    ol = new Map();
  let sl = null,
    ll = null;
  function cl() {
    "function" == typeof sl && (sl(), "function" == typeof ll && ll(!1)), sl = null, ll = null;
  }
  const ul = Object(a.createContext)({
    hideMenu: cl,
    showMenu: function ({
      data: e,
      id: r,
      onChange: t,
      pageX: n,
      pageY: a
    }) {
      const i = il.get(r);
      "function" == typeof i && (cl(), sl = ol.get(r), i({
        data: e,
        pageX: n,
        pageY: a
      }), "function" == typeof t && (ll = t, t(!0)));
    },
    registerMenu: function (e, r, t) {
      if (il.has(e)) throw Error(`Context menu with id "${e}" already registered.`);
      return il.set(e, r), ol.set(e, t), function () {
        il.delete(e), ol.delete(e);
      };
    }
  });
  var fl = t(95),
    dl = t.n(fl);
  const vl = {
    data: null,
    isVisible: !1,
    pageX: 0,
    pageY: 0
  };
  function hl({
    children: e,
    id: r
  }) {
    const {
        hideMenu: t,
        registerMenu: n
      } = Object(a.useContext)(ul),
      [o, s] = Object(a.useState)(vl),
      l = Object(a.useRef)(null),
      c = Object(a.useRef)(null),
      u = Object(a.useRef)(null);
    if (Object(a.useEffect)(() => {
      const e = l.current;
      if (null !== e) {
        const r = e.ownerDocument;
        c.current = r.querySelector("[data-react-devtools-portal-root]"), null == c.current && console.warn("DevTools tooltip root node not found; context menus will be disabled.");
      }
    }, []), Object(a.useEffect)(() => n(r, ({
      data: e,
      pageX: r,
      pageY: t
    }) => {
      s({
        data: e,
        isVisible: !0,
        pageX: r,
        pageY: t
      });
    }, () => s(vl)), [r]), Object(a.useLayoutEffect)(() => {
      if (!o.isVisible) return;
      const e = u.current,
        r = c.current;
      if (null !== r) {
        const n = r => {
            e.contains(r.target) || t();
          },
          a = r.ownerDocument;
        a.addEventListener("mousedown", n), a.addEventListener("touchstart", n), a.addEventListener("keydown", n);
        const i = a.defaultView;
        return i.addEventListener("resize", t), function (e, r, t) {
          const n = e.ownerDocument.defaultView;
          null !== e && (t + e.offsetHeight >= n.innerHeight ? t - e.offsetHeight > 0 ? e.style.top = t - e.offsetHeight + "px" : e.style.top = "0px" : e.style.top = t + "px", r + e.offsetWidth >= n.innerWidth ? r - e.offsetWidth > 0 ? e.style.left = r - e.offsetWidth + "px" : e.style.left = "0px" : e.style.left = r + "px");
        }(e, o.pageX, o.pageY), () => {
          a.removeEventListener("mousedown", n), a.removeEventListener("touchstart", n), a.removeEventListener("keydown", n), i.removeEventListener("resize", t);
        };
      }
    }, [o]), o.isVisible) {
      const r = c.current;
      return null !== r ? Object(i.createPortal)(a.createElement("div", {
        ref: u,
        className: dl.a.ContextMenu
      }, e(o.data)), r) : null;
    }
    return a.createElement("div", {
      ref: l
    });
  }
  var ml = t(96),
    _l = t.n(ml);
  function pl({
    children: e,
    onClick: r,
    title: t
  }) {
    const {
        hideMenu: n
      } = Object(a.useContext)(ul),
      i = e => {
        r(), n();
      };
    return a.createElement("div", {
      className: _l.a.ContextMenuItem,
      onClick: i,
      onTouchEnd: i
    }, e);
  }
  var gl = t(70),
    bl = t.n(gl);
  function Sl({
    element: e
  }) {
    const {
      hocDisplayNames: r
    } = e;
    return null === r ? null : a.createElement("div", {
      className: bl.a.HocBadges
    }, null !== r && r.map(e => a.createElement("div", {
      key: e,
      className: bl.a.Badge
    }, e)));
  }
  var El = t(97),
    wl = t.n(El);
  function yl() {
    return (yl = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }).apply(this || _global, arguments);
  }
  function kl({
    className: e,
    onFocus: r,
    placeholder: t = "",
    testName: n,
    value: i,
    ...o
  }) {
    const s = "" === i || "\"\"" === i;
    return a.createElement("input", yl({
      className: [wl.a.Input, e].join(" "),
      "data-testname": n,
      onFocus: e => {
        const t = e.target;
        null !== t && (t.selectionStart = 0, t.selectionEnd = i.length), "function" == typeof r && r(e);
      },
      placeholder: t,
      style: {
        width: `calc(${s ? t.length : i.length}ch + 1px)`
      },
      value: s ? "" : i
    }, o));
  }
  var Cl = t(98),
    Dl = t.n(Cl);
  function Al({
    allowEmpty: e = !1,
    allowWhiteSpace: r = !1,
    autoFocus: t = !1,
    className: n = "",
    initialValue: i = "",
    overrideName: o,
    path: s,
    type: l
  }) {
    const [c, u] = Object(a.useState)(i),
      [f, d] = Object(a.useState)(!1),
      v = Object(a.useCallback)(({
        target: t
      }) => {
        let n = t.value;
        r || (n = n.trim()), d(!(!e && "" === n)), u(n);
      }, [o]),
      h = Object(a.useCallback)(e => {
        switch (e.stopPropagation(), e.key) {
          case "Enter":
          case "Tab":
            if (f) {
              const e = s.slice(0, s.length - 1);
              o([...e, i], [...e, c]);
            }
            break;
          case "Escape":
            u(i);
        }
      }, [c, u, f, i, o]);
    return a.createElement(kl, {
      autoFocus: t,
      className: [Dl.a.Input, n].join(" "),
      onChange: v,
      onKeyDown: h,
      placeholder: "new entry",
      testName: "EditableName",
      type: "text",
      value: c
    });
  }
  var Ml = t(55),
    xl = t.n(Ml);
  function Ol({
    className: e = "",
    overrideValue: r,
    path: t,
    value: n
  }) {
    const [i, o] = function (e) {
        const [r, t] = Object(a.useReducer)(_n, {
          editableValue: De(e),
          externalValue: e,
          hasPendingChanges: !1,
          isValid: !0,
          parsedValue: e
        });
        return Object.is(r.externalValue, e) || (r.hasPendingChanges ? t({
          type: "UPDATE",
          editableValue: r.editableValue,
          externalValue: e
        }) : t({
          type: "RESET",
          externalValue: e
        })), [r, t];
      }(n),
      {
        editableValue: s,
        hasPendingChanges: l,
        isValid: c,
        parsedValue: u
      } = i,
      f = () => {
        c && l && r(t, u);
      };
    let d = "";
    d = void 0 === s ? "(undefined)" : "Enter valid JSON";
    const v = !0 === u || !1 === u;
    return a.createElement(a.Fragment, null, a.createElement("input", {
      autoComplete: "new-password",
      className: `${c ? xl.a.Input : xl.a.Invalid} ${e}`,
      "data-testname": "EditableValue",
      onBlur: f,
      onChange: ({
        target: e
      }) => o({
        type: "UPDATE",
        editableValue: e.value,
        externalValue: n
      }),
      onKeyDown: e => {
        switch (e.stopPropagation(), e.key) {
          case "Enter":
            f();
            break;
          case "Escape":
            o({
              type: "RESET",
              externalValue: n
            });
        }
      },
      placeholder: d,
      type: "text",
      value: s
    }), v && a.createElement("input", {
      className: xl.a.Checkbox,
      checked: u,
      type: "checkbox",
      onChange: ({
        target: e
      }) => {
        o({
          type: "UPDATE",
          editableValue: e.checked,
          externalValue: n
        }), r(t, e.checked);
      }
    }));
  }
  function Tl(e) {
    let r = 0;
    for (let t = 0; t < e.length; t++) if ("value" === e[t]) {
      r = t + 1;
      break;
    }
    return e.slice(r);
  }
  var Nl = t(56),
    Rl = t.n(Nl);
  function Il({
    bridge: e,
    depth: r,
    hidden: t,
    hookID: n,
    index: i,
    inspectedElement: o,
    path: s,
    store: l,
    type: c
  }) {
    const [u, f] = Object(a.useState)(0),
      [d, v] = Object(a.useState)(!1);
    return a.createElement("div", {
      key: u,
      hidden: t,
      style: {
        paddingLeft: 0.75 * (r - 1) + "rem"
      }
    }, a.createElement("div", {
      className: Rl.a.NewArrayValue
    }, a.createElement(Al, {
      allowWhiteSpace: !0,
      autoFocus: u > 0,
      className: [Rl.a.EditableName, d && Rl.a.Invalid].join(" "),
      initialValue: "",
      overrideName: (r, t) => {
        const a = t[t.length - 1];
        let h,
          m = !0;
        try {
          h = Ce(a), m = !1;
        } catch (e) {}
        if (d !== m && v(m), !m) {
          f(u + 1);
          const {
              id: r
            } = o,
            t = l.getRendererIDForElement(r);
          if (null !== t) {
            let a = s;
            null != n && (a = Tl(a)), e.send("overrideValueAtPath", {
              type: c,
              hookID: n,
              id: r,
              path: [...a, i],
              rendererID: t,
              value: h
            });
          }
        }
      },
      path: s
    })));
  }
  var Hl = t(57),
    Fl = t.n(Hl);
  function Ll({
    bridge: e,
    depth: r,
    hidden: t,
    hookID: n,
    inspectedElement: i,
    path: o,
    store: s,
    type: l
  }) {
    const [c, u] = Object(a.useState)(0),
      [f, d] = Object(a.useState)("");
    return a.createElement("div", {
      key: c,
      hidden: t,
      style: {
        paddingLeft: 0.75 * (r - 1) + "rem"
      }
    }, a.createElement("div", {
      className: Fl.a.NewKeyValue
    }, a.createElement(Al, {
      autoFocus: c > 0,
      className: Fl.a.EditableName,
      overrideName: (e, r) => {
        d(r[r.length - 1]);
      },
      path: []
    }), ":\xA0", a.createElement(Ol, {
      className: Fl.a.EditableValue,
      overrideValue: (r, t) => {
        if (!f) return;
        d(""), u(c + 1);
        const {
            id: a
          } = i,
          o = s.getRendererIDForElement(a);
        if (null !== o) {
          let i = r;
          null != n && (i = Tl(i)), e.send("overrideValueAtPath", {
            type: l,
            hookID: n,
            id: a,
            path: i,
            rendererID: o,
            value: t
          });
        }
      },
      path: [...o, f],
      value: ""
    })));
  }
  var Pl = t(99),
    zl = t.n(Pl);
  function Bl({
    disabled: e,
    isOpen: r,
    setIsOpen: t
  }) {
    return a.createElement(Ci, {
      className: zl.a.ExpandCollapseToggle,
      disabled: e,
      onClick: () => t(e => !e),
      title: (r ? "Collapse" : "Expand") + " prop value"
    }, a.createElement(Tn, {
      type: r ? "expanded" : "collapsed"
    }));
  }
  function jl({
    data: e,
    id: r,
    onChange: t,
    ref: n
  }) {
    const {
      showMenu: i
    } = Object(a.useContext)(ul);
    Object(a.useEffect)(() => {
      if (null !== n.current) {
        const a = n => {
            n.preventDefault(), n.stopPropagation();
            const a = n.pageX || n.touches && n.touches[0].pageX,
              o = n.pageY || n.touches && n.touches[0].pageY;
            i({
              data: e,
              id: r,
              onChange: t,
              pageX: a,
              pageY: o
            });
          },
          o = n.current;
        return o.addEventListener("contextmenu", a), () => {
          o.removeEventListener("contextmenu", a);
        };
      }
    }, [e, r, i]);
  }
  var Vl = t(12),
    Ul = t.n(Vl),
    Wl = t(39);
  const $l = new Map();
  const Xl = Object(a.createContext)(null);
  Xl.displayName = "FetchFileWithCachingContext";
  var Gl = Xl;
  const Kl = Object(a.createContext)(null);
  Kl.displayName = "HookNamesModuleLoaderContext";
  var Yl = Kl;
  const ql = Object(a.createContext)(null);
  function Ql({
    children: e
  }) {
    const {
        selectedElementID: r
      } = Object(a.useContext)(Wt),
      t = Object(a.useContext)(Gl),
      n = Object(a.useContext)(Jr),
      i = Object(a.useContext)(et),
      {
        parseHookNames: o
      } = Object(a.useContext)(En),
      s = Object(a.useContext)(Yl),
      l = Object(a.unstable_useCacheRefresh)(),
      [c, u] = Object(a.useState)({
        element: null,
        path: null
      }),
      f = null !== r ? i.getElementByID(r) : null,
      d = null != f && Object(Wl.c)(f),
      [h, m] = Object(a.useState)(o || d),
      _ = null !== f && f !== c.element;
    _ && (u({
      element: f,
      path: null
    }), m(o || d));
    const p = Object(a.useRef)(null);
    let g = null,
      b = null;
    if (!_ && null !== f && (b = Ws(f, c.path, i, n), Qe.c && "function" == typeof s && (h || d))) {
      const e = function (e) {
        let r = $l.get(e);
        if (v.F && console.log(`[dynamicImportCache] loadModule("${e.name}")`), !r) {
          const t = new Set(),
            n = {
              then(e) {
                t.add(e);
              },
              displayName: `Loading module "${e.name}"`
            },
            a = () => {
              s && (clearTimeout(s), s = null), t.forEach(e => e()), t.clear();
            },
            i = r = {
              status: 0,
              value: n
            };
          let o = !1;
          e().then(r => {
            if (v.F && console.log(`[dynamicImportCache] loadModule("${e.name}") then()`), o) return;
            const t = i;
            t.status = 1, t.value = r, a();
          }, r => {
            if (v.F && console.log(`[dynamicImportCache] loadModule("${e.name}") catch()`), o) return;
            console.log(r);
            const t = i;
            t.status = 2, t.value = null, a();
          });
          let s = setTimeout(function () {
            v.F && console.log(`[dynamicImportCache] loadModule("${e.name}") onTimeout()`), s = null, o = !0;
            const r = i;
            r.status = 2, r.value = null, a();
          }, 30000);
          $l.set(e, r);
        }
        return function (e) {
          if (1 === e.status) return e;
          if (2 === e.status) return e;
          throw e.value;
        }(r).value;
      }(s);
      if (null !== e) {
        const {
          parseHookNames: r,
          purgeCachedMetadata: n
        } = e;
        p.current = n, null !== b && null !== b.hooks && null !== r && (g = Object(Wl.d)(f, b.hooks, r, t));
      }
    }
    const S = Object(a.useCallback)(() => {
        Object(a.startTransition)(() => {
          m(e => !e), l();
        });
      }, [m]),
      E = Object(a.useCallback)(e => {
        Object(a.startTransition)(() => {
          u({
            element: c.element,
            path: e
          }), l();
        });
      }, [u, c]),
      w = Object(a.useRef)(null);
    Object(a.useEffect)(() => {
      null !== b && null !== b.hooks && w.current !== b && (w.current = b);
    }, [b]), Object(a.useEffect)(() => {
      const e = p.current;
      if ("function" == typeof e) {
        const r = () => {
          Object(a.startTransition)(() => {
            Object(Wl.a)(), e(), l();
          });
        };
        return n.addListener("fastRefreshScheduled", r), () => n.removeListener("fastRefreshScheduled", r);
      }
    }, [n]), Object(a.useEffect)(() => {
      null !== c.path && u({
        element: c.element,
        path: null
      });
    }, [c]), Object(a.useEffect)(() => {
      if (null !== f) {
        const e = () => {
          $s({
            bridge: n,
            element: f,
            refresh: l,
            store: i
          }), r = setTimeout(e, 1000);
        };
        let r = setTimeout(e, 1000);
        return () => {
          clearTimeout(r);
        };
      }
    }, [f, g, b, c]);
    const y = Object(a.useMemo)(() => ({
      hookNames: g,
      inspectedElement: b,
      inspectPaths: E,
      parseHookNames: h,
      toggleParseHookNames: S
    }), [g, b, E, h, S]);
    return a.createElement(ql.Provider, {
      value: y
    }, e);
  }
  const Zl = ["file:///", "http://", "https://", "vscode://"],
    Jl = Object.prototype.hasOwnProperty;
  function ec({
    alphaSort: e,
    bridge: r,
    canDeletePaths: t,
    canEditValues: n,
    canRenamePaths: i,
    canRenamePathsAtDepth: o,
    depth: s,
    element: l,
    inspectedElement: c,
    isDirectChildOfAnArray: u,
    hidden: f,
    hookID: d,
    hookName: v,
    name: h,
    path: m,
    pathRoot: _,
    store: p,
    value: g
  }) {
    const {
      readOnly: b
    } = Object(a.useContext)(tt);
    t = !b && t, n = !b && n, i = !b && i;
    const {
        id: S
      } = c,
      [w, y] = Object(a.useState)(!1),
      k = Object(a.useRef)(null),
      {
        inspectPaths: D
      } = Object(a.useContext)(ql);
    let A = !1,
      M = !1;
    null !== g && "object" == typeof g && (A = g[E.inspectable] && 0 !== g[E.size], M = g[E.readonly]);
    const [x, O] = Object(a.useTransition)(),
      T = () => {
        w ? y(!1) : (y(!0), A && O(() => {
          D([_, ...m]);
        }));
      };
    jl({
      data: {
        path: [_, ...m],
        type: null !== g && "object" == typeof g && Jl.call(g, E.type) ? g[E.type] : typeof g
      },
      id: "InspectedElement",
      ref: k
    });
    const N = typeof g,
      R = "number" === N || "string" === N || "boolean" === N || null == g,
      I = {
        paddingLeft: 0.75 * (s - 1) + "rem"
      },
      H = (e, t) => {
        null != d && (e = Tl(e));
        const n = p.getRendererIDForElement(S);
        null !== n && r.send("overrideValueAtPath", {
          hookID: d,
          id: S,
          path: e,
          rendererID: n,
          type: _,
          value: t
        });
      },
      F = e => {
        null != d && (e = Tl(e));
        const t = p.getRendererIDForElement(S);
        null !== t && r.send("deletePath", {
          hookID: d,
          id: S,
          path: e,
          rendererID: t,
          type: _
        });
      },
      L = (e, n) => {
        if ("" === n[n.length - 1]) t && F(e);else {
          null != d && (e = Tl(e), n = Tl(n));
          const t = p.getRendererIDForElement(S);
          null !== t && r.send("renamePath", {
            hookID: d,
            id: S,
            newPath: n,
            oldPath: e,
            rendererID: t,
            type: _
          });
        }
      };
    let P,
      z = i;
    z && "function" == typeof o && (z = o(s)), P = u ? t ? a.createElement(rc, {
      name: h,
      deletePath: F,
      path: m
    }) : a.createElement("span", {
      className: Ul.a.Name
    }, h, !!v && a.createElement("span", {
      className: Ul.a.HookName
    }, "(", v, ")")) : z ? a.createElement(Al, {
      allowEmpty: t,
      className: Ul.a.EditableName,
      initialValue: h,
      overrideName: L,
      path: m
    }) : a.createElement("span", {
      className: Ul.a.Name,
      "data-testname": "NonEditableName"
    }, h, !!v && a.createElement("span", {
      className: Ul.a.HookName
    }, "(", v, ")"));
    let B = null;
    if (R) {
      let e = g;
      "string" === N ? e = `"${g}"` : "boolean" === N ? e = g ? "true" : "false" : null === g ? e = "null" : void 0 === g && (e = "undefined");
      let r = !1;
      "string" === N && Zl.some(e => g.startsWith(e)) && (r = !0), B = a.createElement("div", {
        key: "root",
        className: Ul.a.Item,
        hidden: f,
        ref: k,
        style: I
      }, a.createElement("div", {
        className: Ul.a.ExpandCollapseToggleSpacer
      }), P, a.createElement("div", {
        className: Ul.a.AfterName
      }, ":"), n ? a.createElement(Ol, {
        overrideValue: H,
        path: m,
        value: g
      }) : r ? a.createElement("a", {
        className: Ul.a.Link,
        href: g,
        target: "_blank",
        rel: "noopener noreferrer"
      }, e) : a.createElement("span", {
        className: Ul.a.Value,
        "data-testname": "NonEditableValue"
      }, e));
    } else if (Jl.call(g, E.type) && !Jl.call(g, E.unserializable)) B = a.createElement("div", {
      key: "root",
      className: Ul.a.Item,
      hidden: f,
      ref: k,
      style: I
    }, A ? a.createElement(Bl, {
      isOpen: w,
      setIsOpen: T
    }) : a.createElement("div", {
      className: Ul.a.ExpandCollapseToggleSpacer
    }), P, a.createElement("div", {
      className: Ul.a.AfterName
    }, ":"), a.createElement("span", {
      className: Ul.a.Value,
      onClick: A ? T : void 0
    }, Bt(g))), x && (B = a.createElement(a.Fragment, null, B, a.createElement("div", {
      className: Ul.a.Item,
      style: I
    }, a.createElement("div", {
      className: Ul.a.ExpandCollapseToggleSpacer
    }), a.createElement(Es, null))));else if (C(g)) {
      const u = g.length > 0 || n,
        v = Bt(g);
      B = g.map((u, v) => a.createElement(ec, {
        key: v,
        alphaSort: e,
        bridge: r,
        canDeletePaths: t && !M,
        canEditValues: n && !M,
        canRenamePaths: i && !M,
        canRenamePathsAtDepth: o,
        depth: s + 1,
        element: l,
        hookID: d,
        inspectedElement: c,
        isDirectChildOfAnArray: !0,
        hidden: f || !w,
        name: v,
        path: m.concat(v),
        pathRoot: _,
        store: p,
        value: g[v]
      })), n && !M && B.push(a.createElement(Il, {
        key: "NewKeyValue",
        bridge: r,
        depth: s + 1,
        hidden: f || !w,
        hookID: d,
        index: g.length,
        element: l,
        inspectedElement: c,
        path: m,
        store: p,
        type: _
      })), B.unshift(a.createElement("div", {
        key: s + "-root",
        className: Ul.a.Item,
        hidden: f,
        ref: k,
        style: I
      }, u ? a.createElement(Bl, {
        isOpen: w,
        setIsOpen: y
      }) : a.createElement("div", {
        className: Ul.a.ExpandCollapseToggleSpacer
      }), P, a.createElement("div", {
        className: Ul.a.AfterName
      }, ":"), a.createElement("span", {
        className: Ul.a.Value,
        onClick: u ? T : void 0
      }, v)));
    } else {
      const u = Object.entries(g);
      e && u.sort(Pt);
      const v = u.length > 0 || n,
        h = Bt(g);
      B = u.map(([u, v]) => a.createElement(ec, {
        key: u,
        alphaSort: e,
        bridge: r,
        canDeletePaths: t && !M,
        canEditValues: n && !M,
        canRenamePaths: i && !M,
        canRenamePathsAtDepth: o,
        depth: s + 1,
        element: l,
        hookID: d,
        inspectedElement: c,
        hidden: f || !w,
        name: u,
        path: m.concat(u),
        pathRoot: _,
        store: p,
        value: v
      })), n && !M && B.push(a.createElement(Ll, {
        key: "NewKeyValue",
        bridge: r,
        depth: s + 1,
        element: l,
        hidden: f || !w,
        hookID: d,
        inspectedElement: c,
        path: m,
        store: p,
        type: _
      })), B.unshift(a.createElement("div", {
        key: s + "-root",
        className: Ul.a.Item,
        hidden: f,
        ref: k,
        style: I
      }, v ? a.createElement(Bl, {
        isOpen: w,
        setIsOpen: y
      }) : a.createElement("div", {
        className: Ul.a.ExpandCollapseToggleSpacer
      }), P, a.createElement("div", {
        className: Ul.a.AfterName
      }, ":"), a.createElement("span", {
        className: Ul.a.Value,
        onClick: v ? T : void 0
      }, h)));
    }
    return B;
  }
  function rc({
    deletePath: e,
    name: r,
    path: t
  }) {
    return a.createElement(a.Fragment, null, a.createElement(Ci, {
      className: Ul.a.DeleteArrayItemButton,
      onClick: r => {
        r.stopPropagation(), e(t);
      },
      title: "Delete entry"
    }, a.createElement(Tn, {
      type: "delete"
    })), a.createElement("span", {
      className: Ul.a.Name
    }, r));
  }
  var tc = t(9),
    nc = t.n(tc);
  function ac({
    bridge: e,
    element: r,
    inspectedElement: t,
    store: n
  }) {
    const {
        hasLegacyContext: i,
        context: o,
        type: s
      } = t,
      l = 1 !== s && 5 !== s,
      c = null != o ? Object.entries(o) : null;
    null !== c && c.sort(Pt);
    const u = null === c || 0 === c.length,
      f = () => Object(ar.copy)(Vt(o)),
      d = e => e > 1;
    return u ? null : a.createElement("div", {
      className: nc.a.InspectedElementTree
    }, a.createElement("div", {
      className: nc.a.HeaderRow
    }, a.createElement("div", {
      className: nc.a.Header
    }, i ? "legacy context" : "context"), !u && a.createElement(Ci, {
      onClick: f,
      title: "Copy to clipboard"
    }, a.createElement(Tn, {
      type: "copy"
    }))), u && a.createElement("div", {
      className: nc.a.Empty
    }, "None"), !u && c.map(([i, o]) => a.createElement(ec, {
      key: i,
      alphaSort: !0,
      bridge: e,
      canDeletePaths: !l,
      canEditValues: !l,
      canRenamePaths: !l,
      canRenamePathsAtDepth: d,
      depth: 1,
      element: r,
      hidden: !1,
      inspectedElement: t,
      name: i,
      path: [i],
      pathRoot: "context",
      store: n,
      type: "context",
      value: o
    })));
  }
  var ic = t(32),
    oc = t.n(ic);
  function sc({
    bridge: e,
    inspectedElement: r,
    store: t
  }) {
    const n = Object(a.unstable_useCacheRefresh)(),
      [i, o] = Object(a.useTransition)(),
      [s, l] = Object(a.useTransition)(),
      {
        showInlineWarningsAndErrors: c
      } = Object(a.useContext)(En);
    if (!c) return null;
    const {
      errors: u,
      warnings: f
    } = r;
    return a.createElement(a.Fragment, null, u.length > 0 && a.createElement(lc, {
      badgeClassName: oc.a.ErrorBadge,
      bridge: e,
      className: oc.a.ErrorTree,
      clearMessages: () => {
        const {
            id: a
          } = r,
          i = t.getRendererIDForElement(a);
        null !== i && o(() => {
          !function ({
            bridge: e,
            id: r,
            rendererID: t
          }) {
            e.send("clearErrorsForFiberID", {
              rendererID: t,
              id: r
            });
          }({
            bridge: e,
            id: a,
            rendererID: i
          }), n();
        });
      },
      entries: u,
      isTransitionPending: i,
      label: "errors",
      messageClassName: oc.a.Error
    }), f.length > 0 && a.createElement(lc, {
      badgeClassName: oc.a.WarningBadge,
      bridge: e,
      className: oc.a.WarningTree,
      clearMessages: () => {
        const {
            id: a
          } = r,
          i = t.getRendererIDForElement(a);
        null !== i && l(() => {
          !function ({
            bridge: e,
            id: r,
            rendererID: t
          }) {
            e.send("clearWarningsForFiberID", {
              rendererID: t,
              id: r
            });
          }({
            bridge: e,
            id: a,
            rendererID: i
          }), n();
        });
      },
      entries: f,
      isTransitionPending: s,
      label: "warnings",
      messageClassName: oc.a.Warning
    }));
  }
  function lc({
    badgeClassName: e,
    actions: r,
    className: t,
    clearMessages: n,
    entries: i,
    isTransitionPending: o,
    label: s,
    messageClassName: l
  }) {
    return 0 === i.length ? null : a.createElement("div", {
      className: `${nc.a.InspectedElementTree} ${t}`
    }, a.createElement("div", {
      className: `${nc.a.HeaderRow} ${oc.a.HeaderRow}`
    }, a.createElement("div", {
      className: nc.a.Header
    }, s), a.createElement(Ci, {
      disabled: o,
      onClick: n,
      title: `Clear all ${s} for this component`
    }, a.createElement(Tn, {
      type: "clear"
    }))), i.map(([r, t], n) => a.createElement(cc, {
      key: `${s}-${n}`,
      badgeClassName: e,
      className: l,
      count: t,
      message: r
    })));
  }
  function cc({
    className: e,
    badgeClassName: r,
    count: t,
    message: n
  }) {
    return a.createElement("div", {
      className: e
    }, t > 1 && a.createElement("div", {
      className: r
    }, t), a.createElement("div", {
      className: oc.a.Message,
      title: n
    }, n));
  }
  var uc = t(14),
    fc = t.n(uc);
  function dc({
    bridge: e,
    element: r,
    hookNames: t,
    inspectedElement: n,
    parseHookNames: i,
    store: o,
    toggleParseHookNames: s
  }) {
    const {
        hooks: l,
        id: c
      } = n,
      [u, f] = Object(a.useState)(i),
      d = () => {
        f(!i), s();
      },
      v = Object(a.useContext)(Yl),
      h = i && null === t;
    let m;
    m = h ? "Hook parsing failed" : i ? "Parsing hook names ..." : "Parse hook names (may be slow)";
    const _ = () => Object(ar.copy)(function (e) {
      const r = Object.assign([], e),
        t = [...r];
      for (; t.length > 0;) {
        const e = t.pop();
        delete e.id, delete e.isStateEditable, e.subHooks.length > 0 && t.push(...e.subHooks);
      }
      jt(r);
      try {
        return JSON.stringify(r, null, 2);
      } catch (e) {
        return "";
      }
    }(l));
    return null === l ? null : a.createElement("div", {
      className: fc.a.HooksTreeView,
      "data-testname": "InspectedElementHooksTree"
    }, a.createElement("div", {
      className: fc.a.HeaderRow
    }, a.createElement("div", {
      className: fc.a.Header
    }, "hooks"), Qe.c && "function" == typeof v && (!i || h) && a.createElement(Si, {
      className: h ? fc.a.ToggleError : null,
      isChecked: u,
      isDisabled: u || h,
      onChange: d,
      testName: "LoadHookNamesButton",
      title: m
    }, a.createElement(Tn, {
      type: "parse-hook-names"
    })), a.createElement(Ci, {
      onClick: _,
      title: "Copy to clipboard"
    }, a.createElement(Tn, {
      type: "copy"
    }))), a.createElement(vc, {
      hookNames: t,
      hooks: l,
      id: c,
      element: r,
      inspectedElement: n,
      path: []
    }));
  }
  function vc({
    element: e,
    hookNames: r,
    hooks: t,
    id: n,
    inspectedElement: i,
    path: o
  }) {
    return t.map((s, l) => a.createElement(hc, {
      key: l,
      element: e,
      hook: t[l],
      hookNames: r,
      id: n,
      inspectedElement: i,
      path: o.concat([l])
    }));
  }
  function hc({
    element: e,
    hook: r,
    hookNames: t,
    id: n,
    inspectedElement: i,
    path: o
  }) {
    const {
        canEditHooks: s,
        canEditHooksAndDeletePaths: l,
        canEditHooksAndRenamePaths: c
      } = i,
      {
        id: u,
        isStateEditable: f,
        subHooks: d,
        value: v
      } = r,
      h = null == u || !f,
      m = !h && l,
      _ = !h && s,
      p = !h && c,
      g = Object(a.useContext)(Jr),
      b = Object(a.useContext)(et),
      [S, w] = Object(a.useState)(!1),
      y = Object(a.useCallback)(() => w(e => !e), []),
      k = Object(a.useRef)(null);
    if (jl({
      data: {
        path: ["hooks", ...o],
        type: null !== r && "object" == typeof r && r.hasOwnProperty(E.type) ? r[E.type] : typeof v
      },
      id: "InspectedElement",
      ref: k
    }), r.hasOwnProperty(E.inspected)) return a.createElement("div", {
      className: fc.a.Hook
    }, a.createElement("div", {
      className: fc.a.NameValueRow
    }, a.createElement("span", {
      className: fc.a.TruncationIndicator
    }, "...")));
    const D = e => f && e > 1,
      A = d.length > 0;
    let M = r.name;
    Qe.d && null !== u && (M = a.createElement(a.Fragment, null, a.createElement("span", {
      className: fc.a.PrimitiveHookNumber
    }, u + 1), M));
    const x = typeof v;
    let O,
      T = !1;
    const N = r.hookSource,
      R = null != t && null != N ? t.get(Object(Wl.b)(N)) : null,
      I = R ? a.createElement(a.Fragment, null, M, !!R && a.createElement("span", {
        className: fc.a.HookName
      }, "(", R, ")")) : M;
    if ("string" === x ? O = `"${v}"` : "boolean" === x ? O = v ? "true" : "false" : "number" === x ? O = v : null === v ? O = "null" : void 0 === v ? O = null : C(v) ? (T = !0, O = "Array") : "object" === x && (T = !0, O = "Object"), A) {
      const r = C(d) ? a.createElement(vc, {
        element: e,
        hooks: d,
        hookNames: t,
        id: n,
        inspectedElement: i,
        path: o.concat(["subHooks"])
      }) : a.createElement(ec, {
        alphaSort: !1,
        bridge: g,
        canDeletePaths: m,
        canEditValues: _,
        canRenamePaths: p,
        canRenamePathsAtDepth: D,
        depth: 1,
        element: e,
        hookID: u,
        hookName: R,
        inspectedElement: i,
        name: "subHooks",
        path: o.concat(["subHooks"]),
        store: b,
        type: "hooks",
        value: d
      });
      return T ? a.createElement("div", {
        className: fc.a.Hook
      }, a.createElement("div", {
        ref: k,
        className: fc.a.NameValueRow
      }, a.createElement(Bl, {
        isOpen: S,
        setIsOpen: w
      }), a.createElement("span", {
        onClick: y,
        className: "" !== M ? fc.a.Name : fc.a.NameAnonymous
      }, I || "Anonymous"), a.createElement("span", {
        className: fc.a.Value,
        onClick: y
      }, S || Bt(v))), a.createElement("div", {
        className: fc.a.Children,
        hidden: !S
      }, a.createElement(ec, {
        alphaSort: !1,
        bridge: g,
        canDeletePaths: m,
        canEditValues: _,
        canRenamePaths: p,
        canRenamePathsAtDepth: D,
        depth: 1,
        element: e,
        hookID: u,
        hookName: R,
        inspectedElement: i,
        name: "DebugValue",
        path: o.concat(["value"]),
        pathRoot: "hooks",
        store: b,
        value: v
      }), r)) : a.createElement("div", {
        className: fc.a.Hook
      }, a.createElement("div", {
        ref: k,
        className: fc.a.NameValueRow
      }, a.createElement(Bl, {
        isOpen: S,
        setIsOpen: w
      }), a.createElement("span", {
        onClick: y,
        className: "" !== M ? fc.a.Name : fc.a.NameAnonymous
      }, I || "Anonymous"), " ", a.createElement("span", {
        className: fc.a.Value,
        onClick: y
      }, O)), a.createElement("div", {
        className: fc.a.Children,
        hidden: !S
      }, r));
    }
    return T ? a.createElement("div", {
      className: fc.a.Hook
    }, a.createElement(ec, {
      alphaSort: !1,
      bridge: g,
      canDeletePaths: m,
      canEditValues: _,
      canRenamePaths: p,
      canRenamePathsAtDepth: D,
      depth: 1,
      element: e,
      hookID: u,
      hookName: R,
      inspectedElement: i,
      name: M,
      path: o.concat(["value"]),
      pathRoot: "hooks",
      store: b,
      value: v
    })) : a.createElement("div", {
      className: fc.a.Hook
    }, a.createElement(ec, {
      alphaSort: !1,
      bridge: g,
      canDeletePaths: !1,
      canEditValues: _,
      canRenamePaths: !1,
      depth: 1,
      element: e,
      hookID: u,
      hookName: R,
      inspectedElement: i,
      name: M,
      path: [],
      pathRoot: "hooks",
      store: b,
      value: v
    }));
  }
  var mc = a.memo(dc);
  function _c({
    bridge: e,
    element: r,
    inspectedElement: t,
    store: n
  }) {
    const {
        readOnly: i
      } = a.useContext(tt),
      {
        canEditFunctionProps: o,
        canEditFunctionPropsDeletePaths: s,
        canEditFunctionPropsRenamePaths: l,
        props: c,
        type: u
      } = t,
      f = 1 === u || s,
      d = !i && (1 === u || o),
      v = 1 === u || l,
      h = null != c ? Object.entries(c) : null;
    null !== h && h.sort(Pt);
    const m = null === h || 0 === h.length;
    return a.createElement("div", {
      className: nc.a.InspectedElementTree,
      "data-testname": "InspectedElementPropsTree"
    }, a.createElement("div", {
      className: nc.a.HeaderRow
    }, a.createElement("div", {
      className: nc.a.Header
    }, "props"), !m && a.createElement(Ci, {
      onClick: () => Object(ar.copy)(Vt(c)),
      title: "Copy to clipboard"
    }, a.createElement(Tn, {
      type: "copy"
    }))), !m && h.map(([i, o]) => a.createElement(ec, {
      key: i,
      alphaSort: !0,
      bridge: e,
      canDeletePaths: f,
      canEditValues: d,
      canRenamePaths: v,
      depth: 1,
      element: r,
      hidden: !1,
      inspectedElement: t,
      name: i,
      path: [i],
      pathRoot: "props",
      store: n,
      value: o
    })), d && a.createElement(Ll, {
      bridge: e,
      depth: 0,
      hidden: !1,
      inspectedElement: t,
      path: [],
      store: n,
      type: "props"
    }));
  }
  function pc({
    bridge: e,
    element: r,
    inspectedElement: t,
    store: n
  }) {
    const {
        state: i,
        type: o
      } = t,
      s = 7 === o,
      l = null != i ? Object.entries(i) : null,
      c = null === l || 0 === l.length;
    if (c || s) return null;
    null !== l && l.sort(Pt);
    return a.createElement("div", {
      className: nc.a.InspectedElementTree
    }, a.createElement("div", {
      className: nc.a.HeaderRow
    }, a.createElement("div", {
      className: nc.a.Header
    }, "state"), !c && a.createElement(Ci, {
      onClick: () => Object(ar.copy)(Vt(i)),
      title: "Copy to clipboard"
    }, a.createElement(Tn, {
      type: "copy"
    }))), c && a.createElement("div", {
      className: nc.a.Empty
    }, "None"), !c && l.map(([i, o]) => a.createElement(ec, {
      key: i,
      alphaSort: !0,
      bridge: e,
      canDeletePaths: !0,
      canEditValues: !0,
      canRenamePaths: !0,
      depth: 1,
      element: r,
      hidden: !1,
      inspectedElement: t,
      name: i,
      path: [i],
      pathRoot: "state",
      store: n,
      value: o
    })));
  }
  var gc = t(100),
    bc = t.n(gc);
  function Sc({
    bridge: e,
    element: r,
    inspectedElement: t,
    store: n
  }) {
    if (!Qe.f) return null;
    const i = t.plugins.stylex;
    if (null == i) return null;
    const {
      resolvedStyles: o,
      sources: s
    } = i;
    return a.createElement("div", {
      className: nc.a.InspectedElementTree
    }, a.createElement("div", {
      className: nc.a.HeaderRow
    }, a.createElement("div", {
      className: nc.a.Header
    }, "stylex")), s.map(e => a.createElement("div", {
      key: e,
      className: bc.a.Source
    }, e)), Object.entries(o).map(([i, o]) => a.createElement(ec, {
      key: i,
      alphaSort: !0,
      bridge: e,
      canDeletePaths: !1,
      canEditValues: !1,
      canRenamePaths: !1,
      depth: 1,
      element: r,
      hidden: !1,
      inspectedElement: t,
      name: i,
      path: [i],
      pathRoot: "stylex",
      store: n,
      value: o
    })));
  }
  function Ec({
    bridge: e,
    inspectedElement: r,
    store: t
  }) {
    const {
        readOnly: n
      } = a.useContext(tt),
      {
        id: i,
        state: o,
        type: s
      } = r,
      l = !n && r.canToggleSuspense;
    if (12 !== s) return null;
    const c = null !== o;
    return a.createElement("div", {
      className: nc.a.InspectedElementTree
    }, a.createElement("div", {
      className: nc.a.HeaderRow
    }, a.createElement("div", {
      className: nc.a.Header
    }, "suspense")), a.createElement("div", {
      className: nc.a.ToggleSuspenseRow
    }, a.createElement("span", {
      className: nc.a.Name
    }, "Suspended"), l ? a.createElement(Ol, {
      key: c,
      overrideValue: (r, n) => {
        const a = t.getRendererIDForElement(i);
        null !== a && e.send("overrideSuspense", {
          id: i,
          rendererID: a,
          forceFallback: n
        });
      },
      path: ["suspense", "Suspended"],
      value: c
    }) : a.createElement("span", {
      className: nc.a.Value
    }, c ? "true" : "false")));
  }
  const wc = Object(a.createContext)(null);
  wc.displayName = "NativeStyleContext";
  const yc = new WeakMap(),
    kc = Ri(e => {
      const r = yc.get(e);
      if (null != r) return r.promise;
      let t = null;
      const n = new Promise(e => {
        t = e;
      });
      return yc.set(e, {
        promise: n,
        resolveFn: t
      }), n;
    }, e => e, {
      useWeakMap: !0
    });
  function Cc({
    children: e
  }) {
    const r = Object(a.useContext)(Jr),
      t = Object(a.useContext)(et),
      n = Object(a.useCallback)(e => {
        const r = t.getElementByID(e);
        return null !== r ? kc.read(r) : null;
      }, [t]),
      {
        selectedElementID: o
      } = Object(a.useContext)(Wt),
      [s, l] = Object(a.useState)(null);
    Object(a.useEffect)(() => {
      const e = ({
        id: e,
        layout: r,
        style: n
      }) => {
        const a = t.getElementByID(e);
        if (null !== a) {
          const t = {
              layout: r,
              style: n
            },
            s = yc.get(a);
          null != s ? (yc.delete(a), Object(i.unstable_batchedUpdates)(() => {
            s.resolveFn(t), l(t);
          })) : (kc.write(a, t), e === o && l(t));
        }
      };
      return r.addListener("NativeStyleEditor_styleAndLayout", e), () => r.removeListener("NativeStyleEditor_styleAndLayout", e);
    }, [r, s, o, t]), Object(a.useEffect)(() => {
      if (null === o) return () => {};
      const e = t.getRendererIDForElement(o);
      let n = null;
      const a = () => {
        n = null, null !== e && r.send("NativeStyleEditor_measure", {
          id: o,
          rendererID: e
        });
      };
      a();
      const i = ({
        id: e
      }) => {
        e === o && (null !== n && clearTimeout(n), n = setTimeout(a, 1000));
      };
      return r.addListener("NativeStyleEditor_styleAndLayout", i), () => {
        r.removeListener("NativeStyleEditor_styleAndLayout", i), null !== n && clearTimeout(n);
      };
    }, [r, o, t]);
    const c = Object(a.useMemo)(() => ({
      getStyleAndLayout: n
    }), [s, n]);
    return a.createElement(wc.Provider, {
      value: c
    }, e);
  }
  var Dc = t(26),
    Ac = t.n(Dc);
  function Mc({
    id: e,
    layout: r
  }) {
    const {
      height: t,
      margin: n,
      padding: i,
      y: o,
      width: s,
      x: l
    } = r;
    return a.createElement("div", {
      className: Ac.a.LayoutViewer
    }, a.createElement("div", {
      className: Ac.a.Header
    }, "layout"), a.createElement("div", {
      className: Ac.a.DashedBox
    }, a.createElement("div", {
      className: Ac.a.LabelRow
    }, a.createElement("label", {
      className: Ac.a.Label
    }, "margin"), a.createElement("label", null, n.top || "-")), a.createElement("div", {
      className: Ac.a.BoxRow
    }, a.createElement("label", null, n.left || "-"), a.createElement("div", {
      className: Ac.a.SolidBox
    }, a.createElement("div", {
      className: Ac.a.LabelRow
    }, a.createElement("label", {
      className: Ac.a.Label
    }, "padding"), a.createElement("label", null, i.top || "-")), a.createElement("div", {
      className: Ac.a.BoxRow
    }, a.createElement("label", null, i.left || "-"), a.createElement("div", {
      className: Ac.a.DashedBox
    }, a.createElement("div", {
      className: Ac.a.LabelRow
    }, xc(s), " x ", xc(t), " (", xc(l), ", ", xc(o), ")")), a.createElement("label", null, i.right || "-")), a.createElement("label", null, i.bottom || "-")), a.createElement("label", null, n.right || "-")), a.createElement("label", null, n.bottom || "-")));
  }
  function xc(e) {
    return Math.round(e) === e ? e : e.toFixed(1);
  }
  var Oc = t(28),
    Tc = t.n(Oc);
  function Nc({
    id: e,
    style: r
  }) {
    const t = Object(a.useContext)(Jr),
      n = Object(a.useContext)(et),
      i = (r, a, i) => {
        const o = n.getRendererIDForElement(e);
        null !== o && t.send("NativeStyleEditor_renameAttribute", {
          id: e,
          rendererID: o,
          oldName: r,
          newName: a,
          value: i
        });
      },
      o = (r, a) => {
        const i = n.getRendererIDForElement(e);
        null !== i && t.send("NativeStyleEditor_setValue", {
          id: e,
          rendererID: i,
          name: r,
          value: a
        });
      },
      s = Object(a.useMemo)(() => Array.from(Object.keys(r)), [r]);
    return a.createElement("div", {
      className: Tc.a.StyleEditor
    }, a.createElement("div", {
      className: Tc.a.HeaderRow
    }, a.createElement("div", {
      className: Tc.a.Header
    }, a.createElement("div", {
      className: Tc.a.Brackets
    }, "style {")), a.createElement(Ci, {
      onClick: () => Object(ar.copy)(Vt(r)),
      title: "Copy to clipboard"
    }, a.createElement(Tn, {
      type: "copy"
    }))), s.length > 0 && s.map(e => a.createElement(Ic, {
      key: e,
      attribute: e,
      changeAttribute: i,
      changeValue: o,
      validAttributes: n.nativeStyleEditorValidAttributes,
      value: r[e]
    })), a.createElement(Rc, {
      changeAttribute: i,
      changeValue: o,
      validAttributes: n.nativeStyleEditorValidAttributes
    }), a.createElement("div", {
      className: Tc.a.Brackets
    }, "}"));
  }
  function Rc({
    changeAttribute: e,
    changeValue: r,
    validAttributes: t
  }) {
    const [n, i] = Object(a.useState)(0),
      o = Object(a.useRef)("");
    return a.createElement(Ic, {
      key: n,
      attribute: "",
      attributePlaceholder: "attribute",
      changeAttribute: (e, r, t) => {
        o.current = r;
      },
      changeValue: (e, t) => {
        "" !== o.current && ("" !== t && r(o.current, t), i(n + 1));
      },
      validAttributes: t,
      value: "",
      valuePlaceholder: "value"
    });
  }
  function Ic({
    attribute: e,
    attributePlaceholder: r,
    changeAttribute: t,
    changeValue: n,
    validAttributes: o,
    value: s,
    valuePlaceholder: l
  }) {
    const [c, u] = Object(a.useState)(e),
      [f, d] = Object(a.useState)(JSON.stringify(s)),
      [v, h] = Object(a.useState)(!0),
      [m, _] = Object(a.useState)(!0);
    return a.createElement("div", {
      className: Tc.a.Row
    }, a.createElement(Hc, {
      className: v ? Tc.a.Attribute : Tc.a.Invalid,
      onChange: e => {
        const r = "" === e || null === o || o.indexOf(e) >= 0;
        Object(i.unstable_batchedUpdates)(() => {
          u(e), h(r);
        });
      },
      onReset: () => {
        u(e);
      },
      onSubmit: () => {
        v && m && e !== c && t(e, c, s);
      },
      placeholder: r,
      value: c
    }), ":\xA0", a.createElement(Hc, {
      className: m ? Tc.a.Value : Tc.a.Invalid,
      onChange: e => {
        let r = !1;
        try {
          JSON.parse(ke(e)), r = !0;
        } catch (e) {}
        Object(i.unstable_batchedUpdates)(() => {
          d(e), _(r);
        });
      },
      onReset: () => {
        d(s);
      },
      onSubmit: () => {
        if (v && m) {
          const r = JSON.parse(ke(f));
          s !== r && n(e, r);
        }
      },
      placeholder: l,
      value: f
    }), ";");
  }
  function Hc({
    className: e,
    onChange: r,
    onReset: t,
    onSubmit: n,
    placeholder: i,
    value: o
  }) {
    return a.createElement(kl, {
      className: `${e} ${Tc.a.Input}`,
      onBlur: n,
      onChange: e => r(e.target.value),
      onKeyDown: e => {
        switch (e.key) {
          case "Enter":
            n();
            break;
          case "Escape":
            t();
            break;
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "ArrowUp":
            e.stopPropagation();
        }
      },
      placeholder: i,
      value: o
    });
  }
  function Fc(e) {
    const r = Object(a.useContext)(et);
    return bn(Object(a.useMemo)(() => ({
      getCurrentValue: () => r.supportsNativeStyleEditor,
      subscribe: e => (r.addListener("supportsNativeStyleEditor", e), () => {
        r.removeListener("supportsNativeStyleEditor", e);
      })
    }), [r])) ? a.createElement(Lc, null) : null;
  }
  function Lc(e) {
    const {
        getStyleAndLayout: r
      } = Object(a.useContext)(wc),
      {
        inspectedElementID: t
      } = Object(a.useContext)(Wt);
    if (null === t) return null;
    const n = r(t);
    if (null === n) return null;
    const {
      layout: i,
      style: o
    } = n;
    return a.createElement(a.Fragment, null, null !== i && a.createElement(Mc, {
      id: t,
      layout: i
    }), null !== o && a.createElement(Nc, {
      id: t,
      style: null !== o ? o : {}
    }));
  }
  var Pc = t(19),
    zc = t.n(Pc);
  function Bc({
    element: e,
    hookNames: r,
    inspectedElement: t,
    parseHookNames: n,
    toggleParseHookNames: i
  }) {
    const {
        id: o
      } = e,
      {
        owners: s,
        rendererPackageName: l,
        rendererVersion: c,
        rootType: u,
        source: f
      } = t,
      d = Object(a.useContext)(Jr),
      v = Object(a.useContext)(et),
      {
        isEnabledForInspectedElement: h,
        viewAttributeSourceFunction: m
      } = Object(a.useContext)(rt),
      _ = null !== l && null !== c ? `${l}@${c}` : null,
      p = null !== s && s.length > 0,
      g = p || null !== _ || null !== u;
    return a.createElement(a.Fragment, null, a.createElement("div", {
      className: zc.a.InspectedElement
    }, a.createElement(Sl, {
      element: e
    }), a.createElement(_c, {
      bridge: d,
      element: e,
      inspectedElement: t,
      store: v
    }), a.createElement(Ec, {
      bridge: d,
      inspectedElement: t,
      store: v
    }), a.createElement(pc, {
      bridge: d,
      element: e,
      inspectedElement: t,
      store: v
    }), a.createElement(mc, {
      bridge: d,
      element: e,
      hookNames: r,
      inspectedElement: t,
      parseHookNames: n,
      store: v,
      toggleParseHookNames: i
    }), a.createElement(ac, {
      bridge: d,
      element: e,
      inspectedElement: t,
      store: v
    }), Qe.f && a.createElement(Sc, {
      bridge: d,
      element: e,
      inspectedElement: t,
      store: v
    }), a.createElement(sc, {
      bridge: d,
      element: e,
      inspectedElement: t,
      store: v
    }), a.createElement(Fc, null), g && a.createElement("div", {
      className: zc.a.Owners,
      "data-testname": "InspectedElementView-Owners"
    }, a.createElement("div", {
      className: zc.a.OwnersHeader
    }, "rendered by"), p && s.map(e => a.createElement(Vc, {
      key: e.id,
      displayName: e.displayName || "Anonymous",
      hocDisplayNames: e.hocDisplayNames,
      id: e.id,
      isInStore: v.containsElement(e.id),
      type: e.type
    })), null !== u && a.createElement("div", {
      className: zc.a.OwnersMetaField
    }, u), null !== _ && a.createElement("div", {
      className: zc.a.OwnersMetaField
    }, _)), null !== f && a.createElement(jc, {
      fileName: f.fileName,
      lineNumber: f.lineNumber
    })), h && a.createElement(hl, {
      id: "InspectedElement"
    }, ({
      path: e,
      type: r
    }) => a.createElement(a.Fragment, null, a.createElement(pl, {
      onClick: () => {
        const r = v.getRendererIDForElement(o);
        null !== r && function ({
          bridge: e,
          id: r,
          path: t,
          rendererID: n
        }) {
          e.send("copyElementPath", {
            id: r,
            path: t,
            rendererID: n
          });
        }({
          bridge: d,
          id: o,
          path: e,
          rendererID: r
        });
      },
      title: "Copy value to clipboard"
    }, a.createElement(qt, {
      className: zc.a.ContextMenuIcon,
      type: "copy"
    }), " Copy value to clipboard"), a.createElement(pl, {
      onClick: () => {
        const r = v.getRendererIDForElement(o);
        null !== r && function ({
          bridge: e,
          id: r,
          path: t,
          rendererID: n
        }) {
          e.send("storeAsGlobal", {
            count: os++,
            id: r,
            path: t,
            rendererID: n
          });
        }({
          bridge: d,
          id: o,
          path: e,
          rendererID: r
        });
      },
      title: "Store as global variable"
    }, a.createElement(qt, {
      className: zc.a.ContextMenuIcon,
      type: "store-as-global-variable"
    }), " ", "Store as global variable"), null !== m && "function" === r && a.createElement(pl, {
      onClick: () => m(o, e),
      title: "Go to definition"
    }, a.createElement(qt, {
      className: zc.a.ContextMenuIcon,
      type: "code"
    }), " Go to definition"))));
  }
  function jc({
    fileName: e,
    lineNumber: r
  }) {
    return a.createElement("div", {
      className: zc.a.Source,
      "data-testname": "InspectedElementView-Source"
    }, a.createElement("div", {
      className: zc.a.SourceHeaderRow
    }, a.createElement("div", {
      className: zc.a.SourceHeader
    }, "source"), a.createElement(Ci, {
      onClick: () => Object(ar.copy)(`${e}:${r}`),
      title: "Copy to clipboard"
    }, a.createElement(Tn, {
      type: "copy"
    }))), a.createElement("div", {
      className: zc.a.SourceOneLiner
    }, function (e, r) {
      const t = /^(.*)[\\\/]/;
      let n = e.replace(t, "");
      if (/^index\./.test(n)) {
        const r = e.match(t);
        if (r) {
          const e = r[1];
          if (e) {
            n = e.replace(t, "") + "/" + n;
          }
        }
      }
      return `${n}:${r}`;
    }(e, r)));
  }
  function Vc({
    displayName: e,
    hocDisplayNames: r,
    id: t,
    isInStore: n,
    type: i
  }) {
    const o = Object(a.useContext)($t),
      {
        highlightNativeElement: s,
        clearHighlightNativeElement: l
      } = Sn(),
      c = Object(a.useCallback)(() => {
        Object(qe.a)({
          event_name: "select-element",
          metadata: {
            source: "owner-view"
          }
        }), o({
          type: "SELECT_ELEMENT_BY_ID",
          payload: t
        });
      }, [o, t]),
      u = l;
    return a.createElement(Ci, {
      key: t,
      className: zc.a.OwnerButton,
      disabled: !n,
      onClick: c,
      onMouseEnter: () => s(t),
      onMouseLeave: u
    }, a.createElement("span", {
      className: zc.a.OwnerContent
    }, a.createElement("span", {
      className: `${zc.a.Owner} ${n ? "" : zc.a.NotInStore}`,
      title: e
    }, e), a.createElement(Mn, {
      hocDisplayNames: r,
      type: i
    })));
  }
  var Uc = t(18),
    Wc = t.n(Uc);
  function $c(e) {
    const {
        inspectedElementID: r
      } = Object(a.useContext)(Wt),
      t = Object(a.useContext)($t),
      {
        canViewElementSourceFunction: n,
        viewElementSourceFunction: i
      } = Object(a.useContext)(nl),
      o = Object(a.useContext)(Jr),
      s = Object(a.useContext)(et),
      {
        hideToggleErrorAction: l,
        hideToggleSuspenseAction: c,
        hideLogAction: u,
        hideViewSourceAction: f
      } = Object(a.useContext)(tt),
      {
        dispatch: d
      } = Object(a.useContext)(Qs),
      {
        hookNames: h,
        inspectedElement: m,
        parseHookNames: _,
        toggleParseHookNames: p
      } = Object(a.useContext)(ql),
      g = null !== r ? s.getElementByID(r) : null,
      S = Object(a.useCallback)(() => {
        if (null !== g && null !== r) {
          const e = s.getRendererIDForElement(r);
          null !== e && o.send("highlightNativeElement", {
            displayName: g.displayName,
            hideAfterTimeout: !0,
            id: r,
            openNativeElementsPanel: !0,
            rendererID: e,
            scrollIntoView: !0
          });
        }
      }, [o, g, r, s]),
      E = Object(a.useCallback)(() => {
        if (null !== r) {
          const e = s.getRendererIDForElement(r);
          null !== e && o.send("logElementToConsole", {
            id: r,
            rendererID: e
          });
        }
      }, [o, r, s]),
      w = Object(a.useCallback)(() => {
        null != i && null !== m && i(m.id, m);
      }, [m, i]),
      y = null !== m && m.canViewSource && null !== i && (null === n || n(m)),
      k = null != m && m.isErrored,
      C = null != m ? m.targetErrorBoundaryID : null,
      D = null !== g && 12 === g.type && null != m && null != m.state,
      A = !l && null != m && m.canToggleError,
      M = !c && null != m && m.canToggleSuspense,
      x = Object(a.useSyncExternalStore)(function (e) {
        return window.addEventListener(v.k, e), function () {
          window.removeEventListener(v.k, e);
        };
      }, function () {
        return function () {
          try {
            const e = b(v.k);
            if (null != e) return JSON.parse(e);
          } catch (e) {}
          return "";
        }();
      }),
      O = x && null != m && null != m.source,
      T = Object(a.useCallback)(() => {
        if (null == m || null == C) return;
        const e = s.getRendererIDForElement(C);
        null !== e && (C !== m.id && t({
          type: "SELECT_ELEMENT_BY_ID",
          payload: C
        }), o.send("overrideError", {
          id: C,
          rendererID: e,
          forceError: !k
        }));
      }, [o, t, k, C]),
      N = Object(a.useCallback)(() => {
        let e = null,
          r = g;
        for (; null !== r;) {
          if (12 === r.type) {
            e = r;
            break;
          }
          r = r.parentID > 0 ? s.getElementByID(r.parentID) : null;
        }
        if (null === e) d({
          id: "InspectedElement",
          type: "SHOW",
          content: a.createElement(al, null)
        });else {
          const r = e.id;
          e !== g && t({
            type: "SELECT_ELEMENT_BY_ID",
            payload: r
          });
          const n = s.getRendererIDForElement(r);
          null !== n && o.send("overrideSuspense", {
            id: r,
            rendererID: n,
            forceFallback: !D
          });
        }
      }, [o, t, g, D, d, s]),
      R = Object(a.useCallback)(() => {
        const e = null == m ? void 0 : m.source;
        if (null == e || null == x) return;
        const r = new URL(x);
        r.href = r.href.replace("{path}", e.fileName), r.href = r.href.replace("{line}", String(e.lineNumber)), window.open(r);
      }, [m, x]);
    if (null === g) return a.createElement("div", {
      className: Wc.a.InspectedElement
    }, a.createElement("div", {
      className: Wc.a.TitleRow
    }));
    let I = null;
    return g.isStrictModeNonCompliant && (I = a.createElement("a", {
      className: Wc.a.StrictModeNonCompliant,
      href: "https://fb.me/devtools-strict-mode",
      rel: "noopener noreferrer",
      target: "_blank",
      title: "This component is not running in StrictMode. Click to learn more."
    }, a.createElement(qt, {
      type: "strict-mode-non-compliant"
    }))), a.createElement("div", {
      className: Wc.a.InspectedElement
    }, a.createElement("div", {
      className: Wc.a.TitleRow,
      "data-testname": "InspectedElement-Title"
    }, I, g.key && a.createElement(a.Fragment, null, a.createElement("div", {
      className: Wc.a.Key,
      title: `key "${g.key}"`
    }, g.key), a.createElement("div", {
      className: Wc.a.KeyArrow
    })), a.createElement("div", {
      className: Wc.a.SelectedComponentName
    }, a.createElement("div", {
      className: g.isStrictModeNonCompliant ? Wc.a.StrictModeNonCompliantComponent : Wc.a.Component,
      title: g.displayName
    }, g.displayName)), O && a.createElement(Ci, {
      className: Wc.a.IconButton,
      onClick: R,
      title: "Open in editor"
    }, a.createElement(Tn, {
      type: "editor"
    })), A && a.createElement(Si, {
      className: Wc.a.IconButton,
      isChecked: k,
      onChange: T,
      title: k ? "Clear the forced error" : "Force the selected component into an errored state"
    }, a.createElement(Tn, {
      type: "error"
    })), M && a.createElement(Si, {
      className: Wc.a.IconButton,
      isChecked: D,
      onChange: N,
      title: D ? "Unsuspend the selected component" : "Suspend the selected component"
    }, a.createElement(Tn, {
      type: "suspend"
    })), s.supportsNativeInspection && a.createElement(Ci, {
      className: Wc.a.IconButton,
      onClick: S,
      title: "Inspect the matching DOM element"
    }, a.createElement(Tn, {
      type: "view-dom"
    })), !u && a.createElement(Ci, {
      className: Wc.a.IconButton,
      onClick: E,
      title: "Log this component data to the console"
    }, a.createElement(Tn, {
      type: "log-data"
    })), !f && a.createElement(Ci, {
      className: Wc.a.IconButton,
      disabled: !y,
      onClick: w,
      title: "View source for this element"
    }, a.createElement(Tn, {
      type: "view-source"
    }))), null === m && a.createElement("div", {
      className: Wc.a.Loading
    }, "Loading..."), null !== m && a.createElement(Bc, {
      key: r,
      element: g,
      hookNames: h,
      inspectedElement: m,
      parseHookNames: _,
      toggleParseHookNames: p
    }));
  }
  var Xc = t(21),
    Gc = t.n(Xc);
  function Kc({
    currentTab: e,
    disabled: r = !1,
    id: t,
    selectTab: n,
    tabs: i,
    type: o
  }) {
    if (!i.some(r => null !== r && r.id === e)) {
      const e = i.find(e => null !== e);
      n(e.id);
    }
    const s = Object(a.useCallback)(({
        currentTarget: e
      }) => n(e.value), [n]),
      l = Object(a.useCallback)(e => {
        switch (e.key) {
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "ArrowUp":
            e.stopPropagation();
        }
      }, []);
    let c, u, f;
    switch (o) {
      case "navigation":
        c = Gc.a.IconSizeNavigation, u = Gc.a.TabLabelNavigation, f = Gc.a.TabSizeNavigation;
        break;
      case "profiler":
        c = Gc.a.IconSizeProfiler, u = Gc.a.TabLabelProfiler, f = Gc.a.TabSizeProfiler;
        break;
      case "settings":
        c = Gc.a.IconSizeSettings, u = Gc.a.TabLabelSettings, f = Gc.a.TabSizeSettings;
        break;
      default:
        throw Error(`Unsupported type "${o}"`);
    }
    return a.createElement(a.Fragment, null, i.map(i => {
      if (null === i) return a.createElement("div", {
        key: "VRule",
        className: Gc.a.VRule
      });
      const {
        icon: o,
        id: d,
        label: v,
        title: h
      } = i;
      let m = a.createElement("label", {
        className: [f, r ? Gc.a.TabDisabled : Gc.a.Tab, r || e !== d ? "" : Gc.a.TabCurrent].join(" "),
        "data-testname": "TabBarButton-" + d,
        key: d,
        onKeyDown: l,
        onMouseDown: () => n(d)
      }, a.createElement("input", {
        type: "radio",
        className: Gc.a.Input,
        checked: e === d,
        disabled: r,
        name: t,
        value: d,
        onChange: s
      }), a.createElement(qt, {
        className: `${r ? Gc.a.IconDisabled : ""} ${c}`,
        type: o
      }), a.createElement("span", {
        className: u
      }, v));
      return h && (m = a.createElement(bi, {
        key: d,
        label: h
      }, m)), m;
    }));
  }
  var Yc = t(5),
    qc = t.n(Yc);
  function Qc(e) {
    const r = Object(a.useContext)(et),
      {
        parseHookNames: t,
        setParseHookNames: n
      } = Object(a.useContext)(En),
      i = bn(Object(a.useMemo)(() => ({
        getCurrentValue: () => r.collapseNodesByDefault,
        subscribe: e => (r.addListener("collapseNodesByDefault", e), () => r.removeListener("collapseNodesByDefault", e))
      }), [r])),
      o = Object(a.useCallback)(({
        currentTarget: e
      }) => {
        r.collapseNodesByDefault = !e.checked;
      }, [r]),
      s = Object(a.useCallback)(({
        currentTarget: e
      }) => {
        n(e.checked);
      }, [n]),
      [l, c] = pn(v.k, ""),
      [u, f] = Object(a.useState)(() => [...r.componentFilters]),
      d = Object(a.useCallback)(() => {
        f(e => [...e, {
          type: 1,
          value: 7,
          isEnabled: !0
        }]);
      }, []),
      h = Object(a.useCallback)((e, r) => {
        f(t => {
          const n = [...t],
            a = t.indexOf(e);
          return a >= 0 && (1 === r ? n[a] = {
            type: 1,
            isEnabled: e.isEnabled,
            value: 7
          } : 2 === r ? n[a] = {
            type: 2,
            isEnabled: e.isEnabled,
            isValid: !0,
            value: ""
          } : 3 === r ? n[a] = {
            type: 3,
            isEnabled: e.isEnabled,
            isValid: !0,
            value: ""
          } : 4 === r && (n[a] = {
            type: 4,
            isEnabled: e.isEnabled,
            isValid: !0
          })), n;
        });
      }, []),
      m = Object(a.useCallback)((e, r) => {
        if (1 !== e.type) throw Error("Invalid value for element type filter");
        f(t => {
          const n = [...t];
          if (1 === e.type) {
            const a = t.indexOf(e);
            a >= 0 && (n[a] = {
              ...e,
              value: r
            });
          }
          return n;
        });
      }, []),
      _ = Object(a.useCallback)((e, r) => {
        if (1 === e.type) throw Error("Invalid value for element type filter");
        f(t => {
          const n = [...t];
          if (2 === e.type || 3 === e.type) {
            const a = t.indexOf(e);
            if (a >= 0) {
              let t = !0;
              try {
                new RegExp(r);
              } catch (e) {
                t = !1;
              }
              n[a] = {
                ...e,
                isValid: t,
                value: r
              };
            }
          }
          return n;
        });
      }, []),
      p = Object(a.useCallback)(e => {
        f(r => {
          const t = [...r];
          return t.splice(e, 1), t;
        });
      }, []),
      g = Object(a.useCallback)((e, r) => {
        f(t => {
          const n = [...t],
            a = t.indexOf(e);
          return a >= 0 && (1 === e.type || 2 === e.type || 3 === e.type || 4 === e.type) && (n[a] = {
            ...n[a],
            isEnabled: r
          }), n;
        });
      }, []),
      b = Object(a.useRef)(u);
    return Object(a.useEffect)(() => (b.current = u, () => {}), [u]), Object(a.useEffect)(() => () => {
      r.componentFilters = [...b.current];
    }, [r]), a.createElement("div", {
      className: qc.a.Settings
    }, a.createElement("label", {
      className: qc.a.Setting
    }, a.createElement("input", {
      type: "checkbox",
      checked: !i,
      onChange: o
    }), " ", "Expand component tree by default"), a.createElement("label", {
      className: qc.a.Setting
    }, a.createElement("input", {
      type: "checkbox",
      checked: t,
      onChange: s
    }), " ", "Always parse hook names from source", " ", a.createElement("span", {
      className: qc.a.Warning
    }, "(may be slow)")), a.createElement("label", {
      className: qc.a.OpenInURLSetting
    }, "Open in Editor URL:", " ", a.createElement("input", {
      className: qc.a.Input,
      type: "text",
      placeholder: null !== null ? null : "vscode://file/{path}:{line}",
      value: l,
      onChange: e => {
        c(e.target.value);
      }
    })), a.createElement("div", {
      className: qc.a.Header
    }, "Hide components where..."), a.createElement("table", {
      className: qc.a.Table
    }, a.createElement("tbody", null, 0 === u.length && a.createElement("tr", {
      className: qc.a.TableRow
    }, a.createElement("td", {
      className: qc.a.NoFiltersCell
    }, "No filters have been added.")), u.map((e, r) => a.createElement("tr", {
      className: qc.a.TableRow,
      key: r
    }, a.createElement("td", {
      className: qc.a.TableCell
    }, a.createElement(Si, {
      className: !1 !== e.isValid ? "" : qc.a.InvalidRegExp,
      isChecked: e.isEnabled,
      onChange: r => g(e, r),
      title: !1 === e.isValid ? "Filter invalid" : e.isEnabled ? "Filter enabled" : "Filter disabled"
    }, a.createElement(Zc, {
      isEnabled: e.isEnabled,
      isValid: null == e.isValid || !0 === e.isValid
    }))), a.createElement("td", {
      className: qc.a.TableCell
    }, a.createElement("select", {
      className: qc.a.Select,
      value: e.type,
      onChange: ({
        currentTarget: r
      }) => h(e, parseInt(r.value, 10))
    }, a.createElement("option", {
      value: 3
    }, "location"), a.createElement("option", {
      value: 2
    }, "name"), a.createElement("option", {
      value: 1
    }, "type"), a.createElement("option", {
      value: 4
    }, "hoc"))), a.createElement("td", {
      className: qc.a.TableCell
    }, 1 === e.type && "equals", (3 === e.type || 2 === e.type) && "matches"), a.createElement("td", {
      className: qc.a.TableCell
    }, 1 === e.type && a.createElement("select", {
      className: qc.a.Select,
      value: e.value,
      onChange: ({
        currentTarget: r
      }) => m(e, parseInt(r.value, 10))
    }, a.createElement("option", {
      value: 1
    }, "class"), a.createElement("option", {
      value: 2
    }, "context"), a.createElement("option", {
      value: 5
    }, "function"), a.createElement("option", {
      value: 6
    }, "forward ref"), a.createElement("option", {
      value: 7
    }, "dom nodes (e.g. <div>)"), a.createElement("option", {
      value: 8
    }, "memo"), a.createElement("option", {
      value: 9
    }, "other"), a.createElement("option", {
      value: 10
    }, "profiler"), a.createElement("option", {
      value: 12
    }, "suspense")), (3 === e.type || 2 === e.type) && a.createElement("input", {
      className: qc.a.Input,
      type: "text",
      placeholder: "Regular expression",
      onChange: ({
        currentTarget: r
      }) => _(e, r.value),
      value: e.value
    })), a.createElement("td", {
      className: qc.a.TableCell
    }, a.createElement(Ci, {
      onClick: () => p(r),
      title: "Delete filter"
    }, a.createElement(Tn, {
      type: "delete"
    }))))))), a.createElement(Ci, {
      onClick: d
    }, a.createElement(Tn, {
      className: qc.a.ButtonIcon,
      type: "add"
    }), "Add filter"));
  }
  function Zc({
    isEnabled: e,
    isValid: r
  }) {
    let t;
    return t = r ? e ? qc.a.ToggleOn : qc.a.ToggleOff : e ? qc.a.ToggleOnInvalid : qc.a.ToggleOffInvalid, a.createElement("div", {
      className: t
    }, a.createElement("div", {
      className: e ? qc.a.ToggleInsideOn : qc.a.ToggleInsideOff
    }));
  }
  function Jc(e) {
    const {
      appendComponentStack: r,
      breakOnConsoleErrors: t,
      hideConsoleLogsInStrictMode: n,
      setAppendComponentStack: i,
      setBreakOnConsoleErrors: o,
      setShowInlineWarningsAndErrors: s,
      showInlineWarningsAndErrors: l,
      setHideConsoleLogsInStrictMode: c
    } = Object(a.useContext)(En);
    return a.createElement("div", {
      className: qc.a.Settings
    }, a.createElement("div", {
      className: qc.a.Setting
    }, a.createElement("label", null, a.createElement("input", {
      type: "checkbox",
      checked: r,
      onChange: ({
        currentTarget: e
      }) => i(e.checked)
    }), " ", "Append component stacks to console warnings and errors.")), a.createElement("div", {
      className: qc.a.Setting
    }, a.createElement("label", null, a.createElement("input", {
      type: "checkbox",
      checked: l,
      onChange: ({
        currentTarget: e
      }) => s(e.checked)
    }), " ", "Show inline warnings and errors.")), a.createElement("div", {
      className: qc.a.Setting
    }, a.createElement("label", null, a.createElement("input", {
      type: "checkbox",
      checked: t,
      onChange: ({
        currentTarget: e
      }) => o(e.checked)
    }), " ", "Break on warnings")), a.createElement("div", {
      className: qc.a.Setting
    }, a.createElement("label", null, a.createElement("input", {
      type: "checkbox",
      checked: n,
      onChange: ({
        currentTarget: e
      }) => c(e.checked)
    }), " ", "Hide logs during second render in Strict Mode")));
  }
  function eu(e) {
    const {
        displayDensity: r,
        setDisplayDensity: t,
        setTheme: n,
        setTraceUpdatesEnabled: i,
        theme: o,
        traceUpdatesEnabled: s
      } = Object(a.useContext)(En),
      {
        backendVersion: l,
        supportsTraceUpdates: c
      } = Object(a.useContext)(et),
      u = l && "4.27.2-7f747b80e" !== l;
    return a.createElement("div", {
      className: qc.a.Settings
    }, a.createElement("div", {
      className: qc.a.Setting
    }, a.createElement("div", {
      className: qc.a.RadioLabel
    }, "Theme"), a.createElement("select", {
      className: qc.a.Select,
      value: o,
      onChange: ({
        currentTarget: e
      }) => n(e.value)
    }, a.createElement("option", {
      value: "auto"
    }, "Auto"), a.createElement("option", {
      value: "light"
    }, "Light"), a.createElement("option", {
      value: "dark"
    }, "Dark"))), a.createElement("div", {
      className: qc.a.Setting
    }, a.createElement("div", {
      className: qc.a.RadioLabel
    }, "Display density"), a.createElement("select", {
      className: qc.a.Select,
      value: r,
      onChange: ({
        currentTarget: e
      }) => t(e.value)
    }, a.createElement("option", {
      value: "compact"
    }, "Compact"), a.createElement("option", {
      value: "comfortable"
    }, "Comfortable"))), c && a.createElement("div", {
      className: qc.a.Setting
    }, a.createElement("label", null, a.createElement("input", {
      type: "checkbox",
      checked: s,
      onChange: ({
        currentTarget: e
      }) => i(e.checked)
    }), " ", "Highlight updates when components render.")), a.createElement("div", {
      className: qc.a.ReleaseNotes
    }, u && a.createElement("div", null, a.createElement("ul", {
      className: qc.a.VersionsList
    }, a.createElement("li", null, a.createElement(ru, {
      label: "DevTools backend version:",
      version: l
    })), a.createElement("li", null, a.createElement(ru, {
      label: "DevTools frontend version:",
      version: "4.27.2-7f747b80e"
    })))), !u && a.createElement(ru, {
      label: "DevTools version:",
      version: "4.27.2-7f747b80e"
    })));
  }
  function ru({
    label: e,
    version: r
  }) {
    const t = Object(a.useMemo)(() => function (e) {
      if (!e) return null;
      const r = e.replace(/^(\d+)\.(\d+)\.(\d+).*/, "$1$2$3");
      return `${v.a}#${r}`;
    }(r), [r]);
    return null == r ? null : a.createElement(a.Fragment, null, e, " ", a.createElement("a", {
      className: qc.a.ReleaseNotesLink,
      target: "_blank",
      rel: "noopener noreferrer",
      href: t
    }, r));
  }
  const tu = Object(a.createContext)(null);
  function nu({
    children: e
  }) {
    const r = Object(a.useContext)(et),
      {
        selectedElementID: t
      } = Object(a.useContext)(Wt),
      n = Object(a.useContext)($t),
      {
        profilerStore: o
      } = r,
      s = Object(a.useMemo)(() => ({
        getCurrentValue: () => ({
          didRecordCommits: o.didRecordCommits,
          isProcessingData: o.isProcessingData,
          isProfiling: o.isProfiling,
          profilingData: o.profilingData,
          supportsProfiling: r.rootSupportsBasicProfiling
        }),
        subscribe: e => (o.addListener("profilingData", e), o.addListener("isProcessingData", e), o.addListener("isProfiling", e), r.addListener("rootSupportsBasicProfiling", e), () => {
          o.removeListener("profilingData", e), o.removeListener("isProcessingData", e), o.removeListener("isProfiling", e), r.removeListener("rootSupportsBasicProfiling", e);
        })
      }), [o, r]),
      {
        didRecordCommits: l,
        isProcessingData: c,
        isProfiling: u,
        profilingData: f,
        supportsProfiling: d
      } = bn(s),
      [v, h] = Object(a.useState)(null),
      [m, _] = Object(a.useState)(null),
      [p, g] = Object(a.useState)(null),
      [b, S] = Object(a.useState)(null),
      E = Object(a.useCallback)((e, t) => {
        g(e), S(t), null !== e && null !== f && !1 === f.imported && r.containsElement(e) && n({
          type: "SELECT_ELEMENT_BY_ID",
          payload: e
        });
      }, [n, g, S, r, f]),
      w = Object(a.useCallback)(e => {
        E(null, null), _(e);
      }, [_, E]);
    v !== f && Object(i.unstable_batchedUpdates)(() => {
      h(f);
      const e = null !== f ? f.dataForRoots : null;
      if (null != e) {
        const n = e.keys().next().value || null;
        if (null === m || !e.has(m)) {
          let a = null;
          null !== t && (a = r.getRootIDForElement(t)), null !== a && e.has(a) ? w(a) : w(n);
        }
      }
    });
    const [y, k] = pn("React::DevTools::isCommitFilterEnabled", !1),
      [C, D] = pn("minCommitDuration", 0),
      [A, M] = Object(a.useState)(null),
      [x, O] = pn("React::DevTools::Profiler::defaultTab", "flame-chart", e => {
        Object(qe.a)({
          event_name: "profiler-tab-changed",
          metadata: {
            tabId: e
          }
        });
      }),
      T = Object(a.useCallback)(() => {
        Object(qe.a)({
          event_name: "profiling-start",
          metadata: {
            current_tab: x
          }
        }), r.profilerStore.startProfiling();
      }, [r, x]),
      N = Object(a.useCallback)(() => r.profilerStore.stopProfiling(), [r]);
    u && Object(i.unstable_batchedUpdates)(() => {
      null !== A && M(null), null !== p && (g(null), S(null));
    });
    const R = Object(a.useMemo)(() => ({
      selectedTabID: x,
      selectTab: O,
      didRecordCommits: l,
      isProcessingData: c,
      isProfiling: u,
      profilingData: f,
      startProfiling: T,
      stopProfiling: N,
      supportsProfiling: d,
      rootID: m,
      setRootID: w,
      isCommitFilterEnabled: y,
      setIsCommitFilterEnabled: k,
      minCommitDuration: C,
      setMinCommitDuration: D,
      selectedCommitIndex: A,
      selectCommitIndex: M,
      selectedFiberID: p,
      selectedFiberName: b,
      selectFiber: E
    }), [x, O, l, c, u, f, T, N, d, m, _, w, y, k, C, D, A, M, p, b, E]);
    return a.createElement(tu.Provider, {
      value: R
    }, e);
  }
  function au(e) {
    const {
        isCommitFilterEnabled: r,
        minCommitDuration: t,
        setIsCommitFilterEnabled: n,
        setMinCommitDuration: i
      } = Object(a.useContext)(tu),
      o = Object(a.useContext)(et),
      s = bn(Object(a.useMemo)(() => ({
        getCurrentValue: () => o.recordChangeDescriptions,
        subscribe: e => (o.addListener("recordChangeDescriptions", e), () => o.removeListener("recordChangeDescriptions", e))
      }), [o])),
      l = Object(a.useCallback)(({
        currentTarget: e
      }) => {
        o.recordChangeDescriptions = e.checked;
      }, [o]),
      c = Object(a.useCallback)(e => {
        const r = parseFloat(e.currentTarget.value);
        i(Number.isNaN(r) || r <= 0 ? 0 : r);
      }, [i]),
      u = Object(a.useCallback)(e => {
        const r = e.currentTarget.checked;
        n(r), r && null !== f.current && f.current.focus();
      }, [n]),
      f = Object(a.useRef)(null);
    return a.createElement("div", {
      className: qc.a.Settings
    }, a.createElement("div", {
      className: qc.a.Setting
    }, a.createElement("label", null, a.createElement("input", {
      type: "checkbox",
      checked: s,
      onChange: l
    }), " ", "Record why each component rendered while profiling.")), a.createElement("div", {
      className: qc.a.Setting
    }, a.createElement("label", null, a.createElement("input", {
      checked: r,
      onChange: u,
      type: "checkbox"
    }), " ", "Hide commits below"), " ", a.createElement("input", {
      className: qc.a.Input,
      onChange: c,
      ref: f,
      type: "number",
      value: t
    }), " ", "(ms)"));
  }
  tu.displayName = "ProfilerContext";
  var iu = t(43),
    ou = t.n(iu);
  function su(e) {
    const {
        isModalShowing: r,
        setIsModalShowing: t
      } = Object(a.useContext)(Qo),
      n = Object(a.useContext)(et),
      {
        profilerStore: i
      } = n;
    return bn(Object(a.useMemo)(() => ({
      getCurrentValue: () => i.isProfiling,
      subscribe: e => (i.addListener("isProfiling", e), () => i.removeListener("isProfiling", e))
    }), [i])) && r && t(!1), r ? a.createElement(lu, null) : null;
  }
  function lu(e) {
    const {
        setIsModalShowing: r
      } = Object(a.useContext)(Qo),
      t = Object(a.useCallback)(() => r(!1), [r]),
      [n, i] = pn("React::DevTools::selectedSettingsTabID", "general"),
      o = Object(a.useRef)(null);
    gn(o, t), Object(a.useEffect)(() => {
      null !== o.current && o.current.focus();
    }, [o]);
    let s = null;
    switch (n) {
      case "components":
        s = a.createElement(Qc, null);
        break;
      case "debugging":
        s = a.createElement(Jc, null);
        break;
      case "general":
        s = a.createElement(eu, null);
        break;
      case "profiler":
        s = a.createElement(au, null);
    }
    return a.createElement("div", {
      className: ou.a.Background
    }, a.createElement("div", {
      className: ou.a.Modal,
      ref: o
    }, a.createElement("div", {
      className: ou.a.Tabs
    }, a.createElement(Kc, {
      currentTab: n,
      id: "Settings",
      selectTab: i,
      tabs: cu,
      type: "settings"
    }), a.createElement("div", {
      className: ou.a.Spacer
    }), a.createElement(Ci, {
      onClick: t,
      title: "Close settings dialog"
    }, a.createElement(Tn, {
      type: "close"
    }))), a.createElement("div", {
      className: ou.a.Content
    }, s)));
  }
  const cu = [{
    id: "general",
    icon: "settings",
    label: "General"
  }, {
    id: "debugging",
    icon: "bug",
    label: "Debugging"
  }, {
    id: "components",
    icon: "components",
    label: "Components"
  }, {
    id: "profiler",
    icon: "profiler",
    label: "Profiler"
  }];
  var uu = t(35),
    fu = t.n(uu);
  function du() {
    return a.createElement("div", {
      className: fu.a.Loading
    }, "Loading...");
  }
  const vu = "React::DevTools::createResizeReducer",
    hu = 50;
  function mu() {
    let e = 0.65,
      r = 0.5;
    try {
      let t = b(vu);
      null != t && (t = JSON.parse(t), e = t.horizontalPercentage, r = t.verticalPercentage);
    } catch (e) {}
    return {
      horizontalPercentage: e,
      isResizing: !1,
      verticalPercentage: r
    };
  }
  function _u(e, r) {
    switch (r.type) {
      case "ACTION_SET_IS_RESIZING":
        return {
          ...e,
          isResizing: r.payload
        };
      case "ACTION_SET_HORIZONTAL_PERCENTAGE":
        return {
          ...e,
          horizontalPercentage: r.payload
        };
      case "ACTION_SET_VERTICAL_PERCENTAGE":
        return {
          ...e,
          verticalPercentage: r.payload
        };
      default:
        return e;
    }
  }
  function pu(e, r, t) {
    null !== e && null !== r && e.style.setProperty(`--${r}-resize-percentage`, t + "%");
  }
  var gu = Bs(function (e) {
    const r = Object(a.useRef)(null),
      t = Object(a.useRef)(null),
      [n, i] = Object(a.useReducer)(_u, null, mu),
      {
        horizontalPercentage: o,
        verticalPercentage: s
      } = n;
    Object(a.useLayoutEffect)(() => {
      const e = t.current;
      pu(e, "horizontal", 100 * o), pu(e, "vertical", 100 * s);
    }, []), Object(a.useEffect)(() => {
      const e = setTimeout(() => {
        S(vu, JSON.stringify({
          horizontalPercentage: o,
          verticalPercentage: s
        }));
      }, 500);
      return () => clearTimeout(e);
    }, [o, s]);
    const {
      isResizing: l
    } = n;
    let c, u;
    return l && (u = () => i({
      type: "ACTION_SET_IS_RESIZING",
      payload: !1
    }), c = e => {
      const n = t.current,
        a = r.current;
      if (!l || null === a || null === n) return;
      e.preventDefault();
      const o = function (e) {
          if (null != e) {
            const {
              width: r
            } = e.getBoundingClientRect();
            return r > 600 ? "horizontal" : "vertical";
          }
          return null;
        }(a),
        {
          height: s,
          width: c,
          left: u,
          top: f
        } = a.getBoundingClientRect(),
        d = "horizontal" === o ? e.clientX - u : e.clientY - f;
      if (d > hu && d < ("horizontal" === o ? c - hu : s - hu)) {
        const e = "horizontal" === o ? c : s,
          r = "horizontal" === o ? "ACTION_SET_HORIZONTAL_PERCENTAGE" : "ACTION_SET_VERTICAL_PERCENTAGE";
        pu(n, o, d / e * 100), i({
          type: r,
          payload: d / e
        });
      }
    }), a.createElement(Zo, null, a.createElement(Li, null, a.createElement("div", {
      ref: r,
      className: fu.a.Components,
      onMouseMove: c,
      onMouseLeave: u,
      onMouseUp: u
    }, a.createElement(a.Fragment, null, a.createElement("div", {
      ref: t,
      className: fu.a.TreeWrapper
    }, a.createElement(ds, null)), a.createElement("div", {
      className: fu.a.ResizeBarWrapper
    }, a.createElement("div", {
      onMouseDown: () => i({
        type: "ACTION_SET_IS_RESIZING",
        payload: !0
      }),
      className: fu.a.ResizeBar
    })), a.createElement("div", {
      className: fu.a.InspectedElementWrapper
    }, a.createElement(Cc, null, a.createElement(Ks, null, a.createElement(a.Suspense, {
      fallback: a.createElement(du, null)
    }, a.createElement(Ql, null, a.createElement($c, null)))))), a.createElement(el, null), a.createElement(su, null)))));
  });
  const bu = Object(a.createContext)(null);
  function Su({
    children: e
  }) {
    const r = Object(a.useRef)(null),
      [t, n] = Object(a.useState)(null),
      i = Object(a.useContext)(et),
      o = Object(a.useSyncExternalStore)(function (e) {
        return i.addListener("rootSupportsTimelineProfiling", e), function () {
          i.removeListener("rootSupportsTimelineProfiling", e);
        };
      }, function () {
        return i.rootSupportsTimelineProfiling;
      }),
      s = Object(a.useSyncExternalStore)(function (e) {
        return i.profilerStore.addListener("isProcessingData", e), i.profilerStore.addListener("profilingData", e), function () {
          i.profilerStore.removeListener("isProcessingData", e), i.profilerStore.removeListener("profilingData", e);
        };
      }, function () {
        var e;
        return (null === (e = i.profilerStore.profilingData) || void 0 === e ? void 0 : e.timelineData) || null;
      }),
      l = Object(a.useMemo)(() => {
        const e = new Set(),
          r = new Set(),
          t = {
            offset: 0,
            length: 0
          },
          n = {
            horizontalScrollState: t,
            onHorizontalScrollStateChange: r => {
              e.add(r);
            },
            onSearchRegExpStateChange: e => {
              r.add(e);
            },
            searchRegExp: null,
            updateHorizontalScrollState: r => {
              t.offset === r.offset && t.length === r.length || (t.offset = r.offset, t.length = r.length, e.forEach(e => {
                e(r);
              }));
            },
            updateSearchRegExpState: e => {
              n.searchRegExp = e, r.forEach(r => {
                r(e);
              });
            },
            viewToMutableViewStateMap: new Map()
          };
        return n;
      }, [t]),
      [c, u] = Object(a.useState)(null),
      f = Object(a.useMemo)(() => ({
        file: t,
        inMemoryTimelineData: s,
        isTimelineSupported: o,
        searchInputContainerRef: r,
        setFile: n,
        viewState: l,
        selectEvent: u,
        selectedEvent: c
      }), [t, s, o, n, l, u, c]);
    return a.createElement(bu.Provider, {
      value: f
    }, e);
  }
  function Eu() {
    const e = Object(a.useContext)(et),
      {
        didRecordCommits: r,
        isProfiling: t
      } = Object(a.useContext)(tu),
      {
        file: n,
        setFile: i
      } = Object(a.useContext)(bu),
      {
        profilerStore: o
      } = e,
      s = r,
      l = null !== n;
    return a.createElement(Ci, {
      disabled: t || !(s || l),
      onClick: () => {
        s && o.clear(), l && i(null);
      },
      title: "Clear profiling data"
    }, a.createElement(Tn, {
      type: "clear"
    }));
  }
  bu.displayName = "TimelineContext";
  var wu = t(58),
    yu = t.n(wu);
  function ku(e) {
    return a.createElement("div", {
      className: yu.a.NoCommitData
    }, a.createElement("div", {
      className: yu.a.Header
    }, "There is no data matching the current filter criteria."), a.createElement("div", {
      className: yu.a.FilterMessage
    }, "Try adjusting the commit filter in Profiler settings."));
  }
  var Cu = t(46),
    Du = t.n(Cu);
  function Au({
    color: e,
    height: r,
    isDimmed: t = !1,
    label: n,
    onClick: i,
    onMouseEnter: o,
    onMouseLeave: s,
    onDoubleClick: l,
    textStyle: c,
    width: u,
    x: f,
    y: d
  }) {
    return a.createElement("g", {
      className: Du.a.Group,
      transform: `translate(${f},${d})`
    }, a.createElement("rect", {
      width: u,
      height: r,
      fill: e,
      onClick: i,
      onMouseEnter: o,
      onMouseLeave: s,
      onDoubleClick: l,
      className: Du.a.Rect,
      style: {
        opacity: t ? 0.5 : 1
      }
    }), u >= 35 && a.createElement("foreignObject", {
      width: u,
      height: r,
      className: Du.a.ForeignObject,
      style: {
        paddingLeft: f < 0 ? -f : 0,
        opacity: t ? 0.75 : 1,
        display: u < 35 ? "none" : "block"
      },
      y: 0
    }, a.createElement("div", {
      className: Du.a.Div,
      style: c
    }, n)));
  }
  function Mu({
    data: e,
    index: r,
    style: t
  }) {
    const {
        chartData: n,
        onElementMouseEnter: i,
        onElementMouseLeave: o,
        scaleX: s,
        selectedChartNode: l,
        selectedChartNodeIndex: c,
        selectFiber: u,
        width: f
      } = e,
      {
        renderPathNodes: d,
        maxSelfDuration: v,
        rows: h
      } = n,
      {
        lineHeight: m
      } = Object(a.useContext)(En),
      _ = Object(a.useCallback)((e, r, t) => {
        e.stopPropagation(), u(r, t);
      }, [u]),
      p = () => {
        o();
      },
      g = parseInt(t.top, 10),
      b = h[r],
      S = s(null !== l ? l.offset : 0, f);
    return a.createElement(a.Fragment, null, b.map(e => {
      const {
          didRender: t,
          id: n,
          label: o,
          name: l,
          offset: u,
          selfDuration: h,
          treeBaseDuration: b
        } = e,
        E = s(u, f),
        w = s(b, f);
      if (w < 2) return null;
      if (E + w < S || E > S + f) return null;
      let y = "url(#didNotRenderPattern)",
        k = "var(--color-commit-did-not-render-pattern-text)";
      return t ? (y = Oe(h / v), k = "var(--color-commit-gradient-text)") : d.has(n) && (y = "var(--color-commit-did-not-render-fill)", k = "var(--color-commit-did-not-render-fill-text)"), a.createElement(Au, {
        color: y,
        height: m,
        isDimmed: r < c,
        key: n,
        label: o,
        onClick: e => _(e, n, l),
        onMouseEnter: () => (e => {
          const {
            id: r,
            name: t
          } = e;
          i({
            id: r,
            name: t
          });
        })(e),
        onMouseLeave: p,
        textStyle: {
          color: k
        },
        width: w,
        x: E - S,
        y: g
      });
    }));
  }
  var xu = Object(a.memo)(Mu, It),
    Ou = t(22),
    Tu = t.n(Ou);
  function Nu({
    fiberID: e
  }) {
    const {
        profilerStore: r
      } = Object(a.useContext)(et),
      {
        rootID: t,
        selectedCommitIndex: n
      } = Object(a.useContext)(tu);
    if (null === n) return null;
    const {
      changeDescriptions: i
    } = r.getCommitData(t, n);
    if (null === i) return null;
    const o = i.get(e);
    if (null == o) return null;
    const {
      context: s,
      didHooksChange: l,
      hooks: c,
      isFirstMount: u,
      props: f,
      state: d
    } = o;
    if (u) return a.createElement("div", {
      className: Tu.a.Component
    }, a.createElement("label", {
      className: Tu.a.Label
    }, "Why did this render?"), a.createElement("div", {
      className: Tu.a.Item
    }, "This is the first time the component rendered."));
    const v = [];
    return !0 === s ? v.push(a.createElement("div", {
      key: "context",
      className: Tu.a.Item
    }, "\u2022 Context changed")) : "object" == typeof s && null !== s && 0 !== s.length && v.push(a.createElement("div", {
      key: "context",
      className: Tu.a.Item
    }, "\u2022 Context changed:", s.map(e => a.createElement("span", {
      key: e,
      className: Tu.a.Key
    }, e)))), l && (Qe.d && Array.isArray(c) ? v.push(a.createElement("div", {
      key: "hooks",
      className: Tu.a.Item
    }, "\u2022 ", function (e) {
      const r = e.map(e => e + 1);
      switch (r.length) {
        case 0:
          return "No hooks changed";
        case 1:
          return `Hook ${r[0]} changed`;
        case 2:
          return `Hooks ${r[0]} and ${r[1]} changed`;
        default:
          return `Hooks ${r.slice(0, r.length - 1).join(", ")} and ${r[r.length - 1]} changed`;
      }
    }(c))) : v.push(a.createElement("div", {
      key: "hooks",
      className: Tu.a.Item
    }, "\u2022 Hooks changed"))), null !== f && 0 !== f.length && v.push(a.createElement("div", {
      key: "props",
      className: Tu.a.Item
    }, "\u2022 Props changed:", f.map(e => a.createElement("span", {
      key: e,
      className: Tu.a.Key
    }, e)))), null !== d && 0 !== d.length && v.push(a.createElement("div", {
      key: "state",
      className: Tu.a.Item
    }, "\u2022 State changed:", d.map(e => a.createElement("span", {
      key: e,
      className: Tu.a.Key
    }, e)))), 0 === v.length && v.push(a.createElement("div", {
      key: "nothing",
      className: Tu.a.Item
    }, "The parent component rendered.")), a.createElement("div", {
      className: Tu.a.Component
    }, a.createElement("label", {
      className: Tu.a.Label
    }, "Why did this render?"), v);
  }
  var Ru = t(47),
    Iu = t.n(Ru);
  function Hu({
    fiberData: e
  }) {
    const {
        profilerStore: r
      } = Object(a.useContext)(et),
      {
        rootID: t,
        selectedCommitIndex: n
      } = Object(a.useContext)(tu),
      {
        id: i,
        name: o
      } = e,
      {
        profilingCache: s
      } = r,
      l = s.getFiberCommits({
        fiberID: i,
        rootID: t
      });
    let c = null,
      u = 0;
    for (u = 0; u < l.length; u++) {
      const e = l[u];
      if (n === e) {
        const {
            fiberActualDurations: n,
            fiberSelfDurations: o
          } = r.getCommitData(t, e),
          s = n.get(i) || 0,
          l = o.get(i) || 0;
        c = a.createElement("div", {
          key: e,
          className: Iu.a.CurrentCommit
        }, Te(l), "ms of ", Te(s), "ms");
        break;
      }
    }
    return a.createElement(a.Fragment, null, a.createElement("div", {
      className: Iu.a.Toolbar
    }, a.createElement("div", {
      className: Iu.a.Component
    }, o)), a.createElement("div", {
      className: Iu.a.Content
    }, c || a.createElement("div", null, "Did not render."), a.createElement(Nu, {
      fiberID: i
    })));
  }
  var Fu = t(59),
    Lu = t.n(Fu);
  const Pu = {
    height: 0,
    mouseX: 0,
    mouseY: 0,
    width: 0
  };
  function zu({
    children: e,
    className: r,
    label: t,
    style: n
  }) {
    const i = Object(a.useRef)(null),
      o = Object(a.useRef)(null),
      s = e => {
        const r = o.current;
        if (null != r) {
          const t = function (e, r) {
              if (null !== e) {
                let t = e;
                for (; null != t.parentElement && "relative" !== t.style.position;) t = t.parentElement;
                const {
                    height: n,
                    left: a,
                    top: i,
                    width: o
                  } = t.getBoundingClientRect(),
                  s = r.clientX - a,
                  l = r.clientY - i;
                return {
                  height: n,
                  mouseX: s,
                  mouseY: l,
                  width: o
                };
              }
              return Pu;
            }(i.current, e),
            {
              left: n,
              top: a
            } = function (e, r) {
              const {
                height: t,
                mouseX: n,
                mouseY: a,
                width: i
              } = r;
              let o = 0,
                s = 0;
              o = a + 5 + e.offsetHeight >= t ? a - 5 - e.offsetHeight > 0 ? a - e.offsetHeight - 5 + "px" : "0px" : a + 5 + "px";
              s = n + 5 + e.offsetWidth >= i ? n - 5 - e.offsetWidth > 0 ? n - e.offsetWidth - 5 + "px" : "0px" : n + 10 + "px";
              return {
                left: s,
                top: o
              };
            }(r, t);
          r.style.left = n, r.style.top = a;
        }
      },
      l = null === t ? Lu.a.hidden : "";
    return a.createElement("div", {
      className: Lu.a.Container,
      onMouseMove: e => {
        s(e);
      },
      ref: i
    }, a.createElement("div", {
      className: `${Lu.a.Tooltip} ${l} ${r || ""}`,
      ref: o,
      style: n
    }, t), e);
  }
  var Bu = t(71),
    ju = t.n(Bu);
  function Vu() {
    return (Vu = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }).apply(this || _global, arguments);
  }
  function Uu(e) {
    const {
        profilerStore: r
      } = Object(a.useContext)(et),
      {
        rootID: t,
        selectedCommitIndex: n,
        selectFiber: i
      } = Object(a.useContext)(tu),
      {
        profilingCache: o
      } = r,
      s = Object(a.useCallback)(e => {
        e.stopPropagation(), i(null, null);
      }, [i]);
    let l = null,
      c = null;
    return null !== n && (l = o.getCommitTree({
      commitIndex: n,
      rootID: t
    }), c = o.getFlamegraphChartData({
      commitIndex: n,
      commitTree: l,
      rootID: t
    })), null != l && null != c && c.depth > 0 ? a.createElement("div", {
      className: ju.a.Container,
      onClick: s
    }, a.createElement(pt, null, ({
      height: e,
      width: r
    }) => a.createElement(Wu, {
      chartData: c,
      commitTree: l,
      height: e,
      width: r
    }))) : a.createElement(ku, null);
  }
  function Wu({
    chartData: e,
    commitTree: r,
    height: t,
    width: n
  }) {
    const [i, o] = Object(a.useState)(null),
      {
        lineHeight: s
      } = Object(a.useContext)(En),
      {
        selectFiber: l,
        selectedFiberID: c
      } = Object(a.useContext)(tu),
      {
        highlightNativeElement: u,
        clearHighlightNativeElement: f
      } = Sn(),
      d = Object(a.useMemo)(() => {
        if (null === c) return 0;
        const r = e.idToDepthMap.get(c);
        return void 0 !== r ? r - 1 : 0;
      }, [e, c]),
      v = Object(a.useMemo)(() => null !== c && e.rows[d].find(e => e.id === c) || null, [e, c, d]),
      h = Object(a.useCallback)(({
        id: e,
        name: r
      }) => {
        u(e), o({
          id: e,
          name: r
        });
      }, [u]),
      m = Object(a.useCallback)(() => {
        f(), o(null);
      }, [f]),
      _ = Object(a.useMemo)(() => ({
        chartData: e,
        onElementMouseEnter: h,
        onElementMouseLeave: m,
        scaleX: Re(0, null !== v ? v.treeBaseDuration : e.baseDuration, 0, n),
        selectedChartNode: v,
        selectedChartNodeIndex: d,
        selectFiber: l,
        width: n
      }), [e, h, m, v, d, l, n]),
      p = Object(a.useMemo)(() => null !== i ? a.createElement(Hu, {
        fiberData: i
      }) : null, [i]);
    return a.createElement(zu, {
      label: p
    }, a.createElement(Nt, {
      height: t,
      innerElementType: $u,
      itemCount: e.depth,
      itemData: _,
      itemSize: s,
      width: n
    }, xu));
  }
  const $u = Object(a.forwardRef)(({
    children: e,
    ...r
  }, t) => a.createElement("svg", Vu({
    ref: t
  }, r), a.createElement("defs", null, a.createElement("pattern", {
    id: "didNotRenderPattern",
    patternUnits: "userSpaceOnUse",
    width: "4",
    height: "4"
  }, a.createElement("path", {
    d: "M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2",
    className: ju.a.PatternPath
  }))), e));
  function Xu({
    data: e,
    index: r,
    style: t
  }) {
    const {
        chartData: n,
        onElementMouseEnter: i,
        onElementMouseLeave: o,
        scaleX: s,
        selectedFiberIndex: l,
        selectFiber: c,
        width: u
      } = e,
      f = n.nodes[r],
      {
        lineHeight: d
      } = Object(a.useContext)(En),
      v = Object(a.useCallback)(e => {
        e.stopPropagation();
        const {
          id: r,
          name: t
        } = f;
        c(r, t);
      }, [f, c]),
      h = parseInt(t.top, 10);
    return a.createElement(Au, {
      color: Oe(f.value / n.maxValue),
      height: d,
      isDimmed: r < l,
      key: f.id,
      label: f.label,
      onClick: v,
      onMouseEnter: () => {
        const {
          id: e,
          name: r
        } = f;
        i({
          id: e,
          name: r
        });
      },
      onMouseLeave: () => {
        o();
      },
      width: Math.max(5, s(f.value, u)),
      x: 0,
      y: h
    });
  }
  var Gu = Object(a.memo)(Xu, It),
    Ku = t(101),
    Yu = t.n(Ku);
  function qu(e) {
    const {
        profilerStore: r
      } = Object(a.useContext)(et),
      {
        rootID: t,
        selectedCommitIndex: n,
        selectFiber: i
      } = Object(a.useContext)(tu),
      {
        profilingCache: o
      } = r,
      s = Object(a.useCallback)(e => {
        e.stopPropagation(), i(null, null);
      }, [i]);
    let l = null,
      c = null;
    return null !== n && (l = o.getCommitTree({
      commitIndex: n,
      rootID: t
    }), c = o.getRankedChartData({
      commitIndex: n,
      commitTree: l,
      rootID: t
    })), null != l && null != c && c.nodes.length > 0 ? a.createElement("div", {
      className: Yu.a.Container,
      onClick: s
    }, a.createElement(pt, null, ({
      height: e,
      width: r
    }) => a.createElement(Qu, {
      chartData: c,
      commitTree: l,
      height: e,
      width: r
    }))) : a.createElement(ku, null);
  }
  function Qu({
    chartData: e,
    commitTree: r,
    height: t,
    width: n
  }) {
    const [i, o] = Object(a.useState)(null),
      {
        lineHeight: s
      } = Object(a.useContext)(En),
      {
        selectedFiberID: l,
        selectFiber: c
      } = Object(a.useContext)(tu),
      {
        highlightNativeElement: u,
        clearHighlightNativeElement: f
      } = Sn(),
      d = Object(a.useMemo)(() => Zu(e, l), [e, l]),
      v = Object(a.useCallback)(({
        id: e,
        name: r
      }) => {
        u(e), o({
          id: e,
          name: r
        });
      }, [u]),
      h = Object(a.useCallback)(() => {
        f(), o(null);
      }, [f]),
      m = Object(a.useMemo)(() => ({
        chartData: e,
        onElementMouseEnter: v,
        onElementMouseLeave: h,
        scaleX: Re(0, e.nodes[d].value, 0, n),
        selectedFiberID: l,
        selectedFiberIndex: d,
        selectFiber: c,
        width: n
      }), [e, v, h, l, d, c, n]),
      _ = Object(a.useMemo)(() => null !== i ? a.createElement(Hu, {
        fiberData: i
      }) : null, [i]);
    return a.createElement(zu, {
      label: _
    }, a.createElement(Nt, {
      height: t,
      innerElementType: "svg",
      itemCount: e.nodes.length,
      itemData: m,
      itemSize: s,
      width: n
    }, Gu));
  }
  const Zu = (e, r) => {
    if (null === r) return 0;
    const {
      nodes: t
    } = e;
    for (let e = 0; e < t.length; e++) if (t[e].id === r) return e;
    return 0;
  };
  var Ju = t(102),
    ef = t.n(Ju);
  function rf(e) {
    const {
        profilingData: r,
        rootID: t,
        setRootID: n
      } = Object(a.useContext)(tu),
      i = [];
    null !== r && r.dataForRoots.forEach((e, r) => {
      i.push(a.createElement("option", {
        key: r,
        value: r
      }, e.displayName));
    });
    const o = Object(a.useCallback)(({
      currentTarget: e
    }) => {
      n(parseInt(e.value, 10));
    }, [n]);
    return null === r || r.dataForRoots.size <= 1 ? null : a.createElement(a.Fragment, null, a.createElement("div", {
      className: ef.a.Spacer
    }), a.createElement("select", {
      value: t,
      onChange: o
    }, i));
  }
  var tf = t(60),
    nf = t.n(tf);
  function af({
    disabled: e
  }) {
    const {
      isProfiling: r,
      startProfiling: t,
      stopProfiling: n
    } = Object(a.useContext)(tu);
    let i = nf.a.InactiveRecordToggle;
    return e ? i = nf.a.DisabledRecordToggle : r && (i = nf.a.ActiveRecordToggle), a.createElement(Ci, {
      className: i,
      disabled: e,
      onClick: r ? n : t,
      testName: "ProfilerToggleButton",
      title: r ? "Stop profiling" : "Start profiling"
    }, a.createElement(Tn, {
      type: "record"
    }));
  }
  var of = t(7),
    sf = t.n(of);
  function lf() {
    return a.createElement("div", {
      className: sf.a.Column
    }, a.createElement("div", {
      className: sf.a.Header
    }, "No profiling data has been recorded."), a.createElement("div", {
      className: sf.a.Row
    }, "Click the record button ", a.createElement(af, null), " to start recording."), a.createElement("div", {
      className: `${sf.a.Row} ${sf.a.LearnMoreRow}`
    }, "Click", " ", a.createElement("a", {
      className: sf.a.LearnMoreLink,
      href: "https://fb.me/react-devtools-profiling",
      rel: "noopener noreferrer",
      target: "_blank"
    }, "here"), " ", "to learn more about profiling."));
  }
  function cf() {
    return a.createElement("div", {
      className: sf.a.Column
    }, a.createElement("div", {
      className: sf.a.Header
    }, "Profiling is in progress..."), a.createElement("div", {
      className: sf.a.Row
    }, "Click the record button ", a.createElement(af, null), " to stop recording."));
  }
  const uf = window.devicePixelRatio || 1,
    ff = 10,
    df = 1 / uf,
    vf = [1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000];
  let hf = {
    BACKGROUND: "",
    INTERNAL_MODULE_FRAME: "",
    INTERNAL_MODULE_FRAME_HOVER: "",
    INTERNAL_MODULE_FRAME_TEXT: "",
    NATIVE_EVENT: "",
    NATIVE_EVENT_HOVER: "",
    NETWORK_PRIMARY: "",
    NETWORK_PRIMARY_HOVER: "",
    NETWORK_SECONDARY: "",
    NETWORK_SECONDARY_HOVER: "",
    PRIORITY_BACKGROUND: "",
    PRIORITY_BORDER: "",
    PRIORITY_LABEL: "",
    USER_TIMING: "",
    USER_TIMING_HOVER: "",
    REACT_IDLE: "",
    REACT_IDLE_HOVER: "",
    REACT_RENDER: "",
    REACT_RENDER_HOVER: "",
    REACT_RENDER_TEXT: "",
    REACT_COMMIT: "",
    REACT_COMMIT_HOVER: "",
    REACT_COMMIT_TEXT: "",
    REACT_LAYOUT_EFFECTS: "",
    REACT_LAYOUT_EFFECTS_HOVER: "",
    REACT_LAYOUT_EFFECTS_TEXT: "",
    REACT_PASSIVE_EFFECTS: "",
    REACT_PASSIVE_EFFECTS_HOVER: "",
    REACT_PASSIVE_EFFECTS_TEXT: "",
    REACT_RESIZE_BAR: "",
    REACT_RESIZE_BAR_ACTIVE: "",
    REACT_RESIZE_BAR_BORDER: "",
    REACT_RESIZE_BAR_DOT: "",
    REACT_SCHEDULE: "",
    REACT_SCHEDULE_HOVER: "",
    REACT_SUSPENSE_REJECTED_EVENT: "",
    REACT_SUSPENSE_REJECTED_EVENT_HOVER: "",
    REACT_SUSPENSE_RESOLVED_EVENT: "",
    REACT_SUSPENSE_RESOLVED_EVENT_HOVER: "",
    REACT_SUSPENSE_UNRESOLVED_EVENT: "",
    REACT_SUSPENSE_UNRESOLVED_EVENT_HOVER: "",
    REACT_THROWN_ERROR: "",
    REACT_THROWN_ERROR_HOVER: "",
    REACT_WORK_BORDER: "",
    SCROLL_CARET: "",
    SCRUBBER_BACKGROUND: "",
    SCRUBBER_BORDER: "",
    SEARCH_RESULT_FILL: "",
    TEXT_COLOR: "",
    TEXT_DIM_COLOR: "",
    TIME_MARKER_LABEL: "",
    WARNING_BACKGROUND: "",
    WARNING_BACKGROUND_HOVER: "",
    WARNING_TEXT: "",
    WARNING_TEXT_INVERED: ""
  };
  var mf = t(41),
    _f = t.n(mf);
  function pf(e, r) {
    if (e.length !== r.length) return !1;
    for (var t = 0; t < e.length; t++) if (e[t] !== r[t]) return !1;
    return !0;
  }
  var gf = function (e, r) {
    var t;
    void 0 === r && (r = pf);
    var n,
      a = [],
      i = !1;
    return function () {
      for (var o = [], s = 0; s < arguments.length; s++) o[s] = arguments[s];
      return i && t === (this || _global) && r(o, a) || (n = e.apply(this || _global, o), i = !0, t = this || _global, a = o), n;
    };
  };
  const bf = Object.freeze({
      x: 0,
      y: 0
    }),
    Sf = Object.freeze({
      width: 0,
      height: 0
    }),
    Ef = Object.freeze({
      origin: bf,
      size: Sf
    });
  function wf(e, r) {
    return a = e.origin, i = r.origin, a.x === i.x && a.y === i.y && (t = e.size, n = r.size, t.width === n.width && t.height === n.height);
    var t, n, a, i;
  }
  function yf({
    width: e,
    height: r
  }) {
    return e >= 0 && r >= 0;
  }
  function kf(e) {
    return [e.origin.y, e.origin.x + e.size.width, e.origin.y + e.size.height, e.origin.x];
  }
  function Cf(e) {
    const [r, t, n, a] = e;
    return {
      origin: {
        x: a,
        y: r
      },
      size: {
        width: t - a,
        height: n - r
      }
    };
  }
  function Df(e, r) {
    if (0 === e.size.width || 0 === e.size.height || 0 === r.size.width || 0 === r.size.height) return !1;
    const [t, n, a, i] = kf(e),
      [o, s, l, c] = kf(r);
    return !(n < c || s < i || a < o || l < t);
  }
  function Af(e, r) {
    const [t, n, a, i] = kf(e),
      [o, s, l, c] = kf(r);
    return Cf([Math.max(t, o), Math.min(n, s), Math.min(a, l), Math.max(i, c)]);
  }
  function Mf({
    x: e,
    y: r
  }, t) {
    const [n, a, i, o] = kf(t);
    return o <= e && e <= a && n <= r && r <= i;
  }
  const xf = gf((e, r, t, n = !0) => {
    const a = e.getContext("2d", {
      alpha: !1
    });
    return n && (!function (e, r, t) {
      e.width = t * uf, e.height = r * uf, e.style.width = t + "px", e.style.height = r + "px";
    }(e, r, t), a.scale(uf, uf)), a;
  });
  class Of {
    constructor(e) {
      var r, t, n;
      n = {
        activeView: null,
        hoveredView: null
      }, (t = "_viewRefs") in (r = this) ? Object.defineProperty(r, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : r[t] = n, this._resetHoveredEvent = e;
    }
    hasActiveView() {
      return null !== this._viewRefs.activeView;
    }
    setCanvas(e, r) {
      this._context = xf(e, r.height, r.width), this._canvasSize = r, this.rootView && this.rootView.setNeedsDisplay();
    }
    displayIfNeeded() {
      const {
        rootView: e,
        _canvasSize: r,
        _context: t
      } = this;
      e && t && r && (e.setFrame({
        origin: bf,
        size: r
      }), e.setVisibleArea({
        origin: bf,
        size: r
      }), e.displayIfNeeded(t, this._viewRefs));
    }
    getCurrentCursor() {
      const {
        activeView: e,
        hoveredView: r
      } = this._viewRefs;
      return null !== e ? e.currentCursor : null !== r ? r.currentCursor : null;
    }
    handleInteraction(e) {
      const r = this.rootView;
      if (null != r) {
        const t = this._viewRefs;
        switch (e.type) {
          case "mousemove":
          case "wheel-control":
          case "wheel-meta":
          case "wheel-plain":
          case "wheel-shift":
            const n = t.hoveredView;
            t.hoveredView = null, r.handleInteractionAndPropagateToSubviews(e, t), null !== n && null === t.hoveredView && this._resetHoveredEvent();
            break;
          default:
            r.handleInteractionAndPropagateToSubviews(e, t);
        }
      }
    }
  }
  function Tf(e) {
    return {
      view: e,
      frame: e.frame
    };
  }
  const Nf = e => e,
    Rf = (e, r) => e.map(e => ({
      ...e,
      frame: r
    })),
    If = (e, r) => {
      let t = r.origin.y;
      return e.map(e => {
        const n = e.view.desiredSize(),
          a = n ? n.height : r.origin.y + r.size.height - t,
          i = {
            origin: {
              x: r.origin.x,
              y: t
            },
            size: {
              width: r.size.width,
              height: a
            }
          };
        return t += a, {
          ...e,
          frame: i
        };
      });
    };
  function Hf(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  class Ff {
    constructor(e, r, t = Nf, n = r, a = null) {
      Hf(this, "currentCursor", null), Hf(this, "subviews", []), Hf(this, "_needsDisplay", !0), Hf(this, "_subviewsNeedDisplay", !1), this._backgroundColor = a || null, this.surface = e, this.frame = r, this._layouter = t, this.visibleArea = n;
    }
    setNeedsDisplay() {
      this._needsDisplay = !0, this.superview && this.superview._setSubviewsNeedDisplay(), this.subviews.forEach(e => e.setNeedsDisplay());
    }
    _setSubviewsNeedDisplay() {
      this._subviewsNeedDisplay = !0, this.superview && this.superview._setSubviewsNeedDisplay();
    }
    setFrame(e) {
      wf(this.frame, e) || (this.frame = e, yf(e.size) ? this.frame = e : this.frame = Ef, this.setNeedsDisplay());
    }
    setVisibleArea(e) {
      wf(this.visibleArea, e) || (yf(e.size) ? this.visibleArea = e : this.visibleArea = Ef, this.setNeedsDisplay());
    }
    desiredSize() {
      this._needsDisplay && this.layoutSubviews();
      return function (...e) {
        if (0 === e.length) return Ef;
        const [r, ...t] = e;
        return Cf(t.map(kf).reduce((e, r) => {
          const [t, n, a, i] = e,
            [o, s, l, c] = r;
          return [Math.min(t, o), Math.max(n, s), Math.max(a, l), Math.min(i, c)];
        }, kf(r)));
      }(...this.subviews.map(e => e.frame)).size;
    }
    addSubview(e) {
      this.subviews.includes(e) || (this.subviews.push(e), e.superview = this);
    }
    removeSubview(e) {
      const r = this.subviews.indexOf(e);
      -1 !== r && (e.superview = void 0, this.subviews.splice(r, 1));
    }
    removeAllSubviews() {
      this.subviews.forEach(e => e.superview = void 0), this.subviews = [];
    }
    displayIfNeeded(e, r) {
      if ((this._needsDisplay || this._subviewsNeedDisplay) && Df(this.frame, this.visibleArea) && !function ({
        width: e,
        height: r
      }) {
        return e <= 0 || r <= 0;
      }(this.visibleArea.size)) {
        this.layoutSubviews(), this._needsDisplay && (this._needsDisplay = !1), this._subviewsNeedDisplay && (this._subviewsNeedDisplay = !1);
        const t = this.visibleArea,
          n = new Path2D();
        n.rect(t.origin.x, t.origin.y, t.size.width, t.size.height), e.save(), e.clip(n), e.beginPath(), this.draw(e, r), e.restore();
      }
    }
    layoutSubviews() {
      const {
        frame: e,
        _layouter: r,
        subviews: t,
        visibleArea: n
      } = this;
      const a = r(t.map(Tf), e);
      a.forEach(({
        view: e,
        frame: r
      }) => e.setFrame(r)), t.forEach((e, r) => {
        Df(n, e.frame) ? e.setVisibleArea(Af(n, e.frame)) : e.setVisibleArea(Ef);
      });
    }
    draw(e, r) {
      const {
        subviews: t,
        visibleArea: n
      } = this;
      t.forEach(t => {
        Df(n, t.visibleArea) && t.displayIfNeeded(e, r);
      });
      const a = this._backgroundColor;
      if (null !== a) {
        const r = this.desiredSize();
        n.size.height > r.height && (e.fillStyle = a, e.fillRect(n.origin.x, n.origin.y + r.height, n.size.width, n.size.height - r.height));
      }
    }
    handleInteraction(e, r) {}
    handleInteractionAndPropagateToSubviews(e, r) {
      const {
        subviews: t,
        visibleArea: n
      } = this;
      if (0 === n.size.height) return !1;
      for (let a = t.length - 1; a >= 0; a--) {
        const i = t[a];
        if (Df(n, i.visibleArea)) {
          if (!0 === i.handleInteractionAndPropagateToSubviews(e, r)) return !0;
        }
      }
      return !(!0 !== this.handleInteraction(e, r));
    }
  }
  class Lf extends Ff {
    draw(e) {
      const {
        visibleArea: r
      } = this;
      e.fillStyle = hf.BACKGROUND, e.fillRect(r.origin.x, r.origin.y, r.size.width, r.size.height);
    }
  }
  function Pf(e, r, t) {
    if (Number.isNaN(e) || Number.isNaN(r) || Number.isNaN(t)) throw new Error(`Clamp was called with NaN. Args: min: ${e}, max: ${r}, value: ${t}.`);
    return Math.min(r, Math.max(e, t));
  }
  function zf(e, r) {
    return {
      offset: Pf(-(e.length - r), 0, e.offset),
      length: e.length
    };
  }
  function Bf({
    state: e,
    minContentLength: r,
    maxContentLength: t,
    containerLength: n
  }) {
    return {
      offset: e.offset,
      length: Pf(Math.max(r, n), Math.max(n, t), e.length)
    };
  }
  function jf({
    state: e,
    minContentLength: r,
    maxContentLength: t,
    containerLength: n
  }) {
    return zf(Bf({
      state: e,
      minContentLength: r,
      maxContentLength: t,
      containerLength: n
    }), n);
  }
  function Vf({
    state: e,
    delta: r,
    containerLength: t
  }) {
    return zf({
      offset: e.offset + r,
      length: e.length
    }, t);
  }
  function Uf({
    state: e,
    rangeStart: r,
    rangeEnd: t,
    contentLength: n,
    minContentLength: a,
    maxContentLength: i,
    containerLength: o
  }) {
    const s = Bf({
      state: {
        offset: e.offset,
        length: n * (o / (t - r))
      },
      minContentLength: a,
      maxContentLength: i,
      containerLength: o
    });
    return zf({
      offset: -r * (s.length / n),
      length: s.length
    }, o);
  }
  function Wf(e, r) {
    return e.offset === r.offset && e.length === r.length;
  }
  class $f extends Ff {
    constructor(e, r, t, n, a) {
      var i, o, s;
      super(e, r), s = !1, (o = "_isPanning") in (i = this) ? Object.defineProperty(i, o, {
        value: s,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : i[o] = s, this._contentView = t, this._intrinsicContentWidth = n, this._viewState = a, a.onHorizontalScrollStateChange(e => {
        this.zoomToRange(e.offset, e.length);
      }), this.addSubview(t);
    }
    setScrollState(e) {
      Wf(jf({
        state: e,
        minContentLength: 0.25 * this._intrinsicContentWidth,
        maxContentLength: 1000 * this._intrinsicContentWidth,
        containerLength: this.frame.size.width
      }), this._viewState.horizontalScrollState) || this.setNeedsDisplay();
    }
    zoomToRange(e, r) {
      const t = Uf({
        state: this._viewState.horizontalScrollState,
        rangeStart: e,
        rangeEnd: r,
        contentLength: this._intrinsicContentWidth,
        minContentLength: 0.25 * this._intrinsicContentWidth,
        maxContentLength: 1000 * this._intrinsicContentWidth,
        containerLength: this.frame.size.width
      });
      this.setScrollState(t);
    }
    desiredSize() {
      return this._contentView.desiredSize();
    }
    layoutSubviews() {
      const {
          offset: e,
          length: r
        } = this._viewState.horizontalScrollState,
        t = {
          origin: {
            x: this.frame.origin.x + e,
            y: this.frame.origin.y
          },
          size: {
            width: r,
            height: this.frame.size.height
          }
        };
      this._contentView.setFrame(t), super.layoutSubviews();
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "mousedown":
          this._handleMouseDown(e, r);
          break;
        case "mousemove":
          this._handleMouseMove(e, r);
          break;
        case "mouseup":
          this._handleMouseUp(e, r);
          break;
        case "wheel-plain":
        case "wheel-shift":
          this._handleWheel(e);
      }
    }
    _handleMouseDown(e, r) {
      Mf(e.payload.location, this.frame) && (this._isPanning = !0, r.activeView = this, this.currentCursor = "grabbing");
    }
    _handleMouseMove(e, r) {
      const t = Mf(e.payload.location, this.frame);
      if (t && null === r.hoveredView && (r.hoveredView = this), r.activeView === this ? this.currentCursor = "grabbing" : t && (this.currentCursor = "grab"), !this._isPanning) return;
      const {
        movementX: n,
        movementY: a
      } = e.payload.event;
      if (Math.abs(n) < Math.abs(a)) return;
      const i = Vf({
        state: this._viewState.horizontalScrollState,
        delta: n,
        containerLength: this.frame.size.width
      });
      this._viewState.updateHorizontalScrollState(i);
    }
    _handleMouseUp(e, r) {
      this._isPanning && (this._isPanning = !1), r.activeView === this && (r.activeView = null);
    }
    _handleWheel(e) {
      const {
        location: r,
        delta: {
          deltaX: t,
          deltaY: n
        }
      } = e.payload;
      if (!Mf(r, this.frame)) return;
      const a = Math.abs(t),
        i = Math.abs(n);
      if (i > a) {
        if (i < 1) return;
        if ("wheel-shift" === e.type) return;
        const t = function ({
          state: e,
          multiplier: r,
          fixedPoint: t,
          minContentLength: n,
          maxContentLength: a,
          containerLength: i
        }) {
          const o = Bf({
            state: {
              offset: e.offset,
              length: e.length * r
            },
            minContentLength: n,
            maxContentLength: a,
            containerLength: i
          });
          return zf({
            offset: t + e.offset - t * (o.length / e.length),
            length: o.length
          }, i);
        }({
          state: this._viewState.horizontalScrollState,
          multiplier: 1 + 0.005 * -n,
          fixedPoint: r.x - this._viewState.horizontalScrollState.offset,
          minContentLength: 0.25 * this._intrinsicContentWidth,
          maxContentLength: 1000 * this._intrinsicContentWidth,
          containerLength: this.frame.size.width
        });
        this._viewState.updateHorizontalScrollState(t);
      } else {
        if (a < 1) return;
        const e = Vf({
          state: this._viewState.horizontalScrollState,
          delta: -t,
          containerLength: this.frame.size.width
        });
        this._viewState.updateHorizontalScrollState(e);
      }
    }
  }
  class Xf extends Ff {
    constructor(e, r, t, n, a) {
      super(e, r), this._contentView = t, this._isPanning = !1, this._mutableViewStateKey = a + ":VerticalScrollView", this._onChangeCallback = null, this._scrollState = {
        offset: 0,
        length: 0
      }, this._viewState = n, this.addSubview(t), this._restoreMutableViewState();
    }
    setFrame(e) {
      super.setFrame(e), this._setScrollState(this._scrollState);
    }
    desiredSize() {
      return this._contentView.desiredSize();
    }
    draw(e, r) {
      if (super.draw(e, r), this.frame.size.height > 15) {
        const r = this._scrollState.offset,
          t = this._contentView.desiredSize(),
          n = r,
          a = this.frame.size.height - t.height - r;
        if (n < 0 || a < 0) {
          const {
              visibleArea: r
            } = this,
            {
              x: t,
              y: i
            } = r.origin,
            {
              width: o,
              height: s
            } = r.size,
            l = t + o / 2,
            c = 5,
            u = l + c,
            f = l - c;
          if (n < 0) {
            const r = i + 3;
            e.beginPath(), e.moveTo(l, r), e.lineTo(u, r + 3), e.lineTo(f, r + 3), e.closePath(), e.fillStyle = hf.SCROLL_CARET, e.fill();
          }
          if (a < 0) {
            const r = i + s - 3;
            e.beginPath(), e.moveTo(l, r), e.lineTo(u, r - 3), e.lineTo(f, r - 3), e.closePath(), e.fillStyle = hf.SCROLL_CARET, e.fill();
          }
        }
      }
    }
    layoutSubviews() {
      const {
          offset: e
        } = this._scrollState,
        r = this._contentView.desiredSize(),
        t = this.frame.size.height,
        n = r ? r.height : 0,
        a = Math.max(n, t),
        i = {
          origin: {
            x: this.frame.origin.x,
            y: this.frame.origin.y + e
          },
          size: {
            width: this.frame.size.width,
            height: a
          }
        };
      this._contentView.setFrame(i), super.layoutSubviews();
    }
    handleInteraction(e) {
      switch (e.type) {
        case "mousedown":
          return this._handleMouseDown(e);
        case "mousemove":
          return this._handleMouseMove(e);
        case "mouseup":
          return this._handleMouseUp(e);
        case "wheel-shift":
          return this._handleWheelShift(e);
      }
    }
    onChange(e) {
      this._onChangeCallback = e;
    }
    scrollBy(e) {
      const r = Vf({
        state: this._scrollState,
        delta: -e,
        containerLength: this.frame.size.height
      });
      return this._setScrollState(r);
    }
    _handleMouseDown(e) {
      if (Mf(e.payload.location, this.frame)) {
        this.frame.size.height < this._contentView.desiredSize().height && (this._isPanning = !0);
      }
    }
    _handleMouseMove(e) {
      if (!this._isPanning) return;
      const {
        movementX: r,
        movementY: t
      } = e.payload.event;
      if (Math.abs(r) > Math.abs(t)) return;
      const n = Vf({
        state: this._scrollState,
        delta: e.payload.event.movementY,
        containerLength: this.frame.size.height
      });
      return this._setScrollState(n), !0;
    }
    _handleMouseUp(e) {
      this._isPanning && (this._isPanning = !1);
    }
    _handleWheelShift(e) {
      const {
        location: r,
        delta: {
          deltaX: t,
          deltaY: n
        }
      } = e.payload;
      if (!Mf(r, this.frame)) return !1;
      const a = Math.abs(t),
        i = Math.abs(n);
      return !(a > i) && !(i < 1) && this.scrollBy(n);
    }
    _restoreMutableViewState() {
      this._viewState.viewToMutableViewStateMap.has(this._mutableViewStateKey) ? this._scrollState = this._viewState.viewToMutableViewStateMap.get(this._mutableViewStateKey) : this._viewState.viewToMutableViewStateMap.set(this._mutableViewStateKey, this._scrollState), this.setNeedsDisplay();
    }
    _setScrollState(e) {
      const r = this._contentView.frame.size.height,
        t = this.frame.size.height,
        n = jf({
          state: e,
          minContentLength: r,
          maxContentLength: r,
          containerLength: t
        });
      return Wf(n, this._scrollState) ? r !== t : (this._scrollState.offset = n.offset, this._scrollState.length = n.length, this.setNeedsDisplay(), null !== this._onChangeCallback && this._onChangeCallback(n, this.frame.size.height), !0);
    }
  }
  const Gf = new Map();
  function Kf(e, r) {
    let t = Gf.get(r);
    return null == t && (t = e.measureText(r).width, Gf.set(r, t)), t;
  }
  function Yf(e, r, t, n, a) {
    const {
      fillStyle: i = hf.TEXT_COLOR,
      fontSize: o = ff,
      textAlign: s = "left"
    } = a || {};
    if (t.size.width > 6) {
      r.textAlign = s, r.textBaseline = "middle", r.font = o + "px sans-serif";
      const {
          x: a,
          y: l
        } = t.origin,
        c = function (e, r, t) {
          const n = r.length - 1;
          let a = 0,
            i = n,
            o = 0,
            s = null;
          for (; a <= i;) {
            const l = Math.floor((a + i) / 2),
              c = l === n ? r : r.substr(0, l) + "\u2026";
            Kf(e, c) <= t ? (o < l && (o = l, s = c), a = l + 1) : i = l - 1;
          }
          return s;
        }(r, e, t.size.width - 6 + (a < 0 ? a : 0));
      if (null !== c) {
        r.fillStyle = i;
        const e = !wf(n, t);
        let o;
        e && (r.save(), r.beginPath(), r.rect(n.origin.x, n.origin.y, n.size.width, n.size.height), r.closePath(), r.clip()), o = "center" === s ? a + t.size.width / 2 + 3 - (a < 0 ? a : 0) : a + 3 - (a < 0 ? a : 0);
        const u = l + t.size.height / 2;
        r.fillText(c, o, u), e && r.restore();
      }
    }
  }
  function qf(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  class Qf extends Ff {
    constructor(e, r, t) {
      super(e, r, Nf), qf(this, "_interactionState", "normal"), qf(this, "showLabel", !1), this._label = t;
    }
    desiredSize() {
      return this.showLabel ? {
        height: 16,
        width: 0
      } : {
        height: 8,
        width: 0
      };
    }
    draw(e, r) {
      const {
          frame: t
        } = this,
        {
          x: n,
          y: a
        } = t.origin,
        {
          width: i,
          height: o
        } = t.size,
        s = "dragging" === this._interactionState || "hovered" === this._interactionState && null === r.activeView;
      e.fillStyle = s ? hf.REACT_RESIZE_BAR_ACTIVE : hf.REACT_RESIZE_BAR, e.fillRect(n, a, i, o), e.fillStyle = hf.REACT_RESIZE_BAR_BORDER, e.fillRect(n, a, i, df), e.fillRect(n, a + o - df, i, df);
      const l = n + i / 2,
        c = a + o / 2;
      if (this.showLabel) {
        const r = {
          origin: {
            x: 0,
            y: a + o - 16
          },
          size: {
            width: t.size.width,
            height: 16
          }
        };
        Yf(this._label, e, r, t, {
          fillStyle: hf.REACT_RESIZE_BAR_DOT,
          textAlign: "center"
        });
      } else e.beginPath(), e.fillStyle = hf.REACT_RESIZE_BAR_DOT, e.arc(l, c, 1, 0, 2 * Math.PI), e.arc(l + 4, c, 1, 0, 2 * Math.PI), e.arc(l - 4, c, 1, 0, 2 * Math.PI), e.fill();
    }
    _setInteractionState(e) {
      this._interactionState !== e && (this._interactionState = e, this.setNeedsDisplay());
    }
    _handleMouseDown(e, r) {
      Mf(e.payload.location, this.frame) && (this._setInteractionState("dragging"), r.activeView = this);
    }
    _handleMouseMove(e, r) {
      const t = Mf(e.payload.location, this.frame);
      r.activeView === this ? this.currentCursor = "ns-resize" : t && (this.showLabel ? this.currentCursor = "pointer" : this.currentCursor = "ns-resize"), t && (r.hoveredView = this), "dragging" !== this._interactionState && this._setInteractionState(t ? "hovered" : "normal");
    }
    _handleMouseUp(e, r) {
      const t = Mf(e.payload.location, this.frame);
      "dragging" === this._interactionState && this._setInteractionState(t ? "hovered" : "normal"), r.activeView === this && (r.activeView = null);
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "mousedown":
          this._handleMouseDown(e, r);
          break;
        case "mousemove":
          this._handleMouseMove(e, r);
          break;
        case "mouseup":
          this._handleMouseUp(e, r);
      }
    }
  }
  const Zf = {
    origin: {
      x: 0,
      y: 0
    },
    size: {
      width: 0,
      height: 0
    }
  };
  class Jf extends Ff {
    constructor(e, r, t, n, a, i) {
      var o, s, l;
      super(e, r, Nf), l = null, (s = "_resizingState") in (o = this) ? Object.defineProperty(o, s, {
        value: l,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : o[s] = l, this._canvasRef = a, this._layoutState = {
        barOffsetY: 0
      }, this._mutableViewStateKey = i + ":ResizableView", this._subview = t, this._resizeBar = new Qf(e, r, i), this._viewState = n, this.addSubview(this._subview), this.addSubview(this._resizeBar), this._restoreMutableViewState();
    }
    desiredSize() {
      const e = this._subview.desiredSize();
      if (this._shouldRenderResizeBar()) {
        const e = this._resizeBar.desiredSize();
        return {
          width: this.frame.size.width,
          height: this._layoutState.barOffsetY + e.height
        };
      }
      return {
        width: this.frame.size.width,
        height: e.height
      };
    }
    layoutSubviews() {
      this._updateLayoutState(), this._updateSubviewFrames(), super.layoutSubviews();
    }
    _restoreMutableViewState() {
      if (this._viewState.viewToMutableViewStateMap.has(this._mutableViewStateKey)) this._layoutState = this._viewState.viewToMutableViewStateMap.get(this._mutableViewStateKey), this._updateLayoutStateAndResizeBar(this._layoutState.barOffsetY);else {
        this._viewState.viewToMutableViewStateMap.set(this._mutableViewStateKey, this._layoutState);
        const e = this._subview.desiredSize();
        this._updateLayoutStateAndResizeBar(null != e.maxInitialHeight ? Math.min(e.maxInitialHeight, e.height) : e.height);
      }
      this.setNeedsDisplay();
    }
    _shouldRenderResizeBar() {
      const e = this._subview.desiredSize();
      return null == e.hideScrollBarIfLessThanHeight || e.height > e.hideScrollBarIfLessThanHeight;
    }
    _updateLayoutStateAndResizeBar(e) {
      e <= 8 && (e = 0), this._layoutState.barOffsetY = e, this._resizeBar.showLabel = 0 === e;
    }
    _updateLayoutState() {
      const {
          frame: e,
          _resizingState: r
        } = this,
        t = this._subview.desiredSize().height;
      let n = this._layoutState.barOffsetY;
      if (r) {
        const {
          mouseY: t,
          cursorOffsetInBarFrame: a
        } = r;
        n = t - e.origin.y - a;
      }
      this._updateLayoutStateAndResizeBar(Pf(0, t, n));
    }
    _updateSubviewFrames() {
      const {
          frame: {
            origin: {
              x: e,
              y: r
            },
            size: {
              width: t
            }
          },
          _layoutState: {
            barOffsetY: n
          }
        } = this,
        a = this._resizeBar.desiredSize();
      0 === n ? this._subview.setFrame(Zf) : this._subview.setFrame({
        origin: {
          x: e,
          y: r
        },
        size: {
          width: t,
          height: n
        }
      }), this._resizeBar.setFrame({
        origin: {
          x: e,
          y: r + n
        },
        size: {
          width: t,
          height: a.height
        }
      });
    }
    _handleClick(e) {
      if (!this._shouldRenderResizeBar()) return;
      if (Mf(e.payload.location, this.frame) && 0 === this._layoutState.barOffsetY) {
        const e = this._subview.desiredSize();
        return this._updateLayoutStateAndResizeBar(e.height), this.setNeedsDisplay(), !0;
      }
    }
    _handleDoubleClick(e) {
      if (!this._shouldRenderResizeBar()) return;
      return Mf(e.payload.location, this.frame) && this._layoutState.barOffsetY > 0 ? (this._updateLayoutStateAndResizeBar(0), this.setNeedsDisplay(), !0) : void 0;
    }
    _handleMouseDown(e) {
      const r = e.payload.location,
        t = this._resizeBar.frame;
      if (Mf(r, t)) {
        const e = r.y;
        return this._resizingState = {
          cursorOffsetInBarFrame: e - t.origin.y,
          mouseY: e
        }, !0;
      }
    }
    _handleMouseMove(e) {
      const {
        _resizingState: r
      } = this;
      if (r) return this._resizingState = {
        ...r,
        mouseY: e.payload.location.y
      }, this.setNeedsDisplay(), !0;
    }
    _handleMouseUp(e) {
      this._resizingState && (this._resizingState = null);
    }
    getCursorActiveSubView(e) {
      return Mf(e.payload.location, this._resizeBar.frame) ? this : null;
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "click":
          return this._handleClick(e);
        case "double-click":
          return this._handleDoubleClick(e);
        case "mousedown":
          return this._handleMouseDown(e);
        case "mousemove":
          return this._handleMouseMove(e);
        case "mouseup":
          return this._handleMouseUp(e);
      }
    }
  }
  let ed = null;
  function rd(e, r) {
    const t = Object(a.useRef)(!1),
      n = Object(a.useRef)(!1);
    Object(a.useEffect)(() => {
      const a = e.current;
      if (!a) return;
      function i(e) {
        const r = function (e) {
          return ed && e.width === ed.width && e.height === ed.height || (ed = {
            width: e.width,
            height: e.height,
            rect: e.getBoundingClientRect()
          }), ed.rect;
        }(a);
        return {
          x: e.x - r.left,
          y: e.y - r.top
        };
      }
      const o = e => {
          n.current || r({
            type: "click",
            payload: {
              event: e,
              location: i({
                x: e.x,
                y: e.y
              })
            }
          });
        },
        s = e => {
          n.current || r({
            type: "double-click",
            payload: {
              event: e,
              location: i({
                x: e.x,
                y: e.y
              })
            }
          });
        },
        l = e => {
          n.current = !1, t.current = !0, r({
            type: "mousedown",
            payload: {
              event: e,
              location: i({
                x: e.x,
                y: e.y
              })
            }
          });
        },
        c = e => {
          t.current && (n.current = !0), r({
            type: "mousemove",
            payload: {
              event: e,
              location: i({
                x: e.x,
                y: e.y
              })
            }
          });
        },
        u = e => {
          t.current = !1, r({
            type: "mouseup",
            payload: {
              event: e,
              location: i({
                x: e.x,
                y: e.y
              })
            }
          });
        },
        f = e => {
          e.preventDefault(), e.stopPropagation();
          const t = i({
              x: e.x,
              y: e.y
            }),
            n = function (e) {
              let r = e.deltaX,
                t = e.deltaY;
              return e.deltaMode === WheelEvent.DOM_DELTA_LINE ? (r *= 40, t *= 40) : e.deltaMode === WheelEvent.DOM_DELTA_PAGE && (r *= 800, t *= 800), {
                deltaX: r,
                deltaY: t
              };
            }(e);
          return e.shiftKey ? r({
            type: "wheel-shift",
            payload: {
              event: e,
              location: t,
              delta: n
            }
          }) : e.ctrlKey ? r({
            type: "wheel-control",
            payload: {
              event: e,
              location: t,
              delta: n
            }
          }) : e.metaKey ? r({
            type: "wheel-meta",
            payload: {
              event: e,
              location: t,
              delta: n
            }
          }) : r({
            type: "wheel-plain",
            payload: {
              event: e,
              location: t,
              delta: n
            }
          }), !1;
        },
        d = a.ownerDocument;
      return d.addEventListener("mousemove", c), d.addEventListener("mouseup", u), a.addEventListener("click", o), a.addEventListener("dblclick", s), a.addEventListener("mousedown", l), a.addEventListener("wheel", f), () => {
        d.removeEventListener("mousemove", c), d.removeEventListener("mouseup", u), a.removeEventListener("click", o), a.removeEventListener("dblclick", s), a.removeEventListener("mousedown", l), a.removeEventListener("wheel", f);
      };
    }, [e, r]);
  }
  const td = (e, r) => {
    const [t, n] = e,
      a = t.view.desiredSize().height > r.size.height ? n.view.desiredSize().width : 0,
      i = {
        ...t,
        frame: {
          origin: t.view.frame.origin,
          size: {
            width: r.size.width - a,
            height: r.size.height
          }
        }
      };
    return [i, {
      ...n,
      frame: {
        origin: {
          x: i.frame.origin.x + i.frame.size.width,
          y: r.origin.y
        },
        size: {
          width: a,
          height: r.size.height
        }
      }
    }];
  };
  function nd(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  class ad extends Ff {
    constructor(e, r, t, n) {
      super(e, r, td), nd(this, "_isProcessingOnChange", !1), nd(this, "_isScrolling", !1), nd(this, "_scrollOffset", 0), nd(this, "_onVerticalScrollViewChange", (e, r) => {
        const t = e.length - r;
        if (0 === t) return;
        const n = Math.abs(e.offset) / t,
          a = this._scrollBarView.getMaxScrollThumbY();
        this._isProcessingOnChange = !0, this._scrollBarView.setScrollThumbY(n * a), this._isProcessingOnChange = !1;
      }), this._contentView = t, this._verticalScrollView = new Xf(e, r, t, n, "VerticalScrollOverflowView"), this._verticalScrollView.onChange(this._onVerticalScrollViewChange), this._scrollBarView = new sd(e, r, this), this.addSubview(this._verticalScrollView), this.addSubview(this._scrollBarView);
    }
    layoutSubviews() {
      super.layoutSubviews();
      const e = this._contentView.desiredSize();
      this._scrollBarView.setContentHeight(e.height);
    }
    setScrollOffset(e, r) {
      const t = e - this._scrollOffset;
      this._isProcessingOnChange || this._verticalScrollView.scrollBy(-t), this._scrollOffset = e, this.setNeedsDisplay();
    }
  }
  function id(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  const od = {
    origin: {
      x: 0,
      y: 0
    },
    size: {
      width: 0,
      height: 0
    }
  };
  class sd extends Ff {
    constructor(e, r, t) {
      super(e, r), id(this, "_contentHeight", 0), id(this, "_isScrolling", !1), id(this, "_scrollBarRect", od), id(this, "_scrollThumbRect", od), this._verticalScrollOverflowView = t;
    }
    desiredSize() {
      return {
        width: 14,
        height: 0
      };
    }
    getMaxScrollThumbY() {
      const {
        height: e
      } = this.frame.size;
      return e - this._scrollThumbRect.size.height;
    }
    setContentHeight(e) {
      this._contentHeight = e;
      const {
          height: r,
          width: t
        } = this.frame.size,
        n = {
          origin: {
            x: this.frame.origin.x,
            y: this._scrollThumbRect.origin.y
          },
          size: {
            width: t,
            height: r * (r / e)
          }
        };
      wf(this._scrollThumbRect, n) || (this._scrollThumbRect = n, this.setNeedsDisplay());
    }
    setScrollThumbY(e) {
      const {
          height: r
        } = this.frame.size,
        t = this.getMaxScrollThumbY(),
        n = Math.max(0, Math.min(t, e));
      this._scrollThumbRect = {
        ...this._scrollThumbRect,
        origin: {
          x: this.frame.origin.x,
          y: n
        }
      };
      const a = n / t * (this._contentHeight - r) * -1;
      this._verticalScrollOverflowView.setScrollOffset(a, t);
    }
    draw(e, r) {
      const {
          x: t,
          y: n
        } = this.frame.origin,
        {
          width: a,
          height: i
        } = this.frame.size;
      e.fillStyle = hf.REACT_RESIZE_BAR, e.fillRect(t, n, a, i), e.fillStyle = hf.SCROLL_CARET, e.fillRect(this._scrollThumbRect.origin.x, this._scrollThumbRect.origin.y, this._scrollThumbRect.size.width, this._scrollThumbRect.size.height), e.fillStyle = hf.REACT_RESIZE_BAR_BORDER, e.fillRect(t, n, df, i);
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "click":
          this._handleClick(e, r);
          break;
        case "mousedown":
          this._handleMouseDown(e, r);
          break;
        case "mousemove":
          this._handleMouseMove(e, r);
          break;
        case "mouseup":
          this._handleMouseUp(e, r);
      }
    }
    _handleClick(e, r) {
      const {
        location: t
      } = e.payload;
      if (Mf(t, this.frame)) {
        if (Mf(t, this._scrollThumbRect)) return;
        const e = this._scrollThumbRect.origin.y,
          r = t.y,
          {
            height: n
          } = this.frame.size,
          a = n / this._contentHeight * n * 0.8;
        this.setScrollThumbY(r > e ? this._scrollThumbRect.origin.y + a : this._scrollThumbRect.origin.y - a);
      }
    }
    _handleMouseDown(e, r) {
      const {
        location: t
      } = e.payload;
      Mf(t, this._scrollThumbRect) && (r.activeView = this, this.currentCursor = "default", this._isScrolling = !0, this.setNeedsDisplay());
    }
    _handleMouseMove(e, r) {
      const {
        event: t,
        location: n
      } = e.payload;
      Mf(n, this.frame) && (r.hoveredView !== this && (r.hoveredView = this), this.currentCursor = "default"), r.activeView === this && (this.currentCursor = "default", this.setScrollThumbY(this._scrollThumbRect.origin.y + t.movementY));
    }
    _handleMouseUp(e, r) {
      r.activeView === this && (r.activeView = null), this._isScrolling && (this._isScrolling = !1, this.setNeedsDisplay());
    }
  }
  function ld(e, r) {
    return r.size.width / e;
  }
  function cd(e, r, t) {
    return t.origin.x + e * r;
  }
  function ud(e, r, t) {
    return (e - t.origin.x) / r;
  }
  function fd(e, r) {
    return e * r;
  }
  function dd(e, r) {
    return e / r;
  }
  function vd(e) {
    return e.toLocaleString(void 0, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    }) + "ms";
  }
  function hd(e) {
    return _f()(e, {
      millisecondsDecimalDigits: 1
    });
  }
  function md(e, r) {
    return e.length > r ? e.substr(0, r - 1) + "\u2026" : e;
  }
  function _d(e) {
    switch (e.type) {
      case "schedule-render":
        return "render scheduled";
      case "schedule-state-update":
        return "state update scheduled";
      case "schedule-force-update":
        return "force update scheduled";
      default:
        return null;
    }
  }
  function pd(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  const gd = 14 + df;
  class bd extends Ff {
    constructor(e, r, t, n) {
      super(e, r), pd(this, "_cachedSearchRegExp", null), pd(this, "_hoveredComponentMeasure", null), pd(this, "onHover", null), this._profilerData = t, this._viewState = n, this._cachedSearchMatches = new Map(), this._cachedSearchRegExp = null, n.onSearchRegExpStateChange(() => {
        this.setNeedsDisplay();
      }), this._intrinsicSize = {
        width: t.duration,
        height: gd
      };
    }
    desiredSize() {
      return this._intrinsicSize;
    }
    setHoveredEvent(e) {
      this._hoveredComponentMeasure !== e && (this._hoveredComponentMeasure = e, this.setNeedsDisplay());
    }
    _drawSingleReactComponentMeasure(e, r, t, n, a) {
      const {
          frame: i
        } = this,
        {
          componentName: o,
          duration: s,
          timestamp: l,
          type: c,
          warning: u
        } = t,
        f = cd(l, n, i),
        d = cd(l + s, n, i),
        v = {
          origin: {
            x: f,
            y: i.origin.y
          },
          size: {
            width: d - f,
            height: 14
          }
        };
      if (!Df(v, r)) return !1;
      if (fd(s, n) < 1) return !1;
      let h = null,
        m = null;
      const _ = Af(v, r);
      if (e.beginPath(), null !== u) e.fillStyle = a ? hf.WARNING_BACKGROUND_HOVER : hf.WARNING_BACKGROUND;else switch (c) {
        case "render":
          e.fillStyle = a ? hf.REACT_RENDER_HOVER : hf.REACT_RENDER, h = hf.REACT_RENDER_TEXT, m = "rendered";
          break;
        case "layout-effect-mount":
          e.fillStyle = a ? hf.REACT_LAYOUT_EFFECTS_HOVER : hf.REACT_LAYOUT_EFFECTS, h = hf.REACT_LAYOUT_EFFECTS_TEXT, m = "mounted layout effect";
          break;
        case "layout-effect-unmount":
          e.fillStyle = a ? hf.REACT_LAYOUT_EFFECTS_HOVER : hf.REACT_LAYOUT_EFFECTS, h = hf.REACT_LAYOUT_EFFECTS_TEXT, m = "unmounted layout effect";
          break;
        case "passive-effect-mount":
          e.fillStyle = a ? hf.REACT_PASSIVE_EFFECTS_HOVER : hf.REACT_PASSIVE_EFFECTS, h = hf.REACT_PASSIVE_EFFECTS_TEXT, m = "mounted passive effect";
          break;
        case "passive-effect-unmount":
          e.fillStyle = a ? hf.REACT_PASSIVE_EFFECTS_HOVER : hf.REACT_PASSIVE_EFFECTS, h = hf.REACT_PASSIVE_EFFECTS_TEXT, m = "unmounted passive effect";
      }
      let p = !1;
      const g = this._cachedSearchRegExp;
      if (null !== g) {
        const e = this._cachedSearchMatches,
          r = e.get(o);
        null != r ? p = r : (p = null !== o.match(g), e.set(o, p));
      }
      p && (e.fillStyle = hf.SEARCH_RESULT_FILL), e.fillRect(_.origin.x, _.origin.y, _.size.width, _.size.height);
      return Yf(`${o} ${m} - ${hd(s)}`, e, v, _, {
        fillStyle: h
      }), !0;
    }
    draw(e) {
      const {
          frame: r,
          _profilerData: {
            componentMeasures: t
          },
          _hoveredComponentMeasure: n,
          visibleArea: a
        } = this,
        i = this._viewState.searchRegExp;
      this._cachedSearchRegExp !== i && (this._cachedSearchMatches = new Map(), this._cachedSearchRegExp = i), e.fillStyle = hf.BACKGROUND, e.fillRect(a.origin.x, a.origin.y, a.size.width, a.size.height);
      const o = ld(this._intrinsicSize.width, r);
      let s = !1;
      t.forEach(r => {
        s = this._drawSingleReactComponentMeasure(e, a, r, o, r === n) || s;
      }), s || Yf("(zoom or pan to see React components)", e, a, a, {
        fillStyle: hf.TEXT_DIM_COLOR,
        textAlign: "center"
      }), e.fillStyle = hf.PRIORITY_BORDER, e.fillRect(a.origin.x, a.origin.y + gd - df, a.size.width, df);
    }
    _handleMouseMove(e, r) {
      const {
        frame: t,
        _intrinsicSize: n,
        onHover: a,
        visibleArea: i
      } = this;
      if (!a) return;
      const {
        location: o
      } = e.payload;
      if (!Mf(o, i)) return void a(null);
      const s = ld(n.width, t),
        l = ud(o.x, s, t),
        c = this._profilerData.componentMeasures;
      for (let e = c.length - 1; e >= 0; e--) {
        const t = c[e],
          {
            duration: n,
            timestamp: i
          } = t;
        if (l >= i && l <= i + n) return this.currentCursor = "context-menu", r.hoveredView = this, void a(t);
      }
      a(null);
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "mousemove":
          this._handleMouseMove(e, r);
      }
    }
  }
  function Sd(e, r) {
    const {
      locationColumn: t,
      locationLine: n,
      scriptUrl: a
    } = r;
    if (null == a || null == t || null == n) return !1;
    if (a.includes("/react-devtools") || a.includes("/react_devtools") || a.includes(v.b) || a.includes(v.e) || a.includes(v.f)) return !0;
    const i = e.get(a);
    if (null != i) for (let e = 0; e < i.length; e++) {
      const [r, a] = i[e],
        o = n > r.lineNumber || n === r.lineNumber && t >= r.columnNumber,
        s = n < a.lineNumber || n === a.lineNumber && t <= a.columnNumber;
      if (o && s) return !0;
    }
    return !1;
  }
  function Ed({
    h: e,
    s: r,
    l: t,
    a: n
  }) {
    return `hsl(${e}deg ${r}% ${t}% / ${n})`;
  }
  function wd(e, r) {
    if ("number" == typeof r) return r;
    const t = r.count || r.max - r.min;
    return e %= t, r.min + Math.floor(e / (t - 1) * (r.max - r.min));
  }
  function yd(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  const kd = new class {
    constructor(e, r, t, n) {
      this._hueSpace = e || {
        min: 0,
        max: 360
      }, this._satSpace = r || 67, this._lightnessSpace = t || 80, this._alphaSpace = n || 1, this._colors = new Map();
    }
    setColorForID(e, r) {
      this._colors.set(e, r);
    }
    colorForID(e) {
      const r = this._colors.get(e);
      if (r) return r;
      const t = this._generateColorForID(e);
      return this._colors.set(e, t), t;
    }
    _generateColorForID(e) {
      const r = function (e) {
        const r = 4294967291;
        let t = 0,
          n = 1;
        for (let a = 0; a < e.length; a++) {
          t = (t + n * (1506996573 * e.charCodeAt(a))) % r, n = 1345575271 * n % r;
        }
        return t = (t + n * (r - 1)) % r, Math.abs(0 | t);
      }(e);
      return {
        h: wd(r, this._hueSpace),
        s: wd(r >> 8, this._satSpace),
        l: wd(r >> 16, this._lightnessSpace),
        a: wd(r >> 24, this._alphaSpace)
      };
    }
  }({
    min: 30,
    max: 330
  }, {
    min: 50,
    max: 80,
    count: 3
  }, 85);
  function Cd({
    scriptUrl: e
  }) {
    return kd.colorForID(null != e ? e : "");
  }
  function Dd(e) {
    return Ed(Cd(e));
  }
  function Ad(e) {
    return Ed(function (e, r) {
      return {
        ...e,
        l: e.l - r
      };
    }(Cd(e), 5));
  }
  kd.setColorForID("", {
    h: 43.6,
    s: 45.8,
    l: 90.6,
    a: 100
  });
  class Md extends Ff {
    constructor(e, r, t, n, a) {
      super(e, r), yd(this, "_hoveredStackFrame", null), yd(this, "_onHover", null), yd(this, "_didGrab", !1), this._stackLayer = t, this._stackFrameSet = new Set(t), this._internalModuleSourceToRanges = n, this._intrinsicSize = {
        width: a,
        height: 14
      };
    }
    desiredSize() {
      return this._intrinsicSize;
    }
    setHoveredFlamechartStackFrame(e) {
      if (this._hoveredStackFrame === e) return;
      const r = e && this._stackFrameSet.has(e) ? e : null;
      this._hoveredStackFrame !== r && (this._hoveredStackFrame = r, this.setNeedsDisplay());
    }
    draw(e) {
      const {
        frame: r,
        _stackLayer: t,
        _hoveredStackFrame: n,
        _intrinsicSize: a,
        visibleArea: i
      } = this;
      e.fillStyle = hf.PRIORITY_BACKGROUND, e.fillRect(i.origin.x, i.origin.y, i.size.width, i.size.height);
      const o = ld(a.width, r);
      for (let a = 0; a < t.length; a++) {
        const s = t[a],
          {
            name: l,
            timestamp: c,
            duration: u
          } = s,
          f = fd(u, o);
        if (f < 1) continue;
        const d = {
          origin: {
            x: Math.floor(cd(c, o, r)),
            y: r.origin.y
          },
          size: {
            width: Math.floor(f - df),
            height: Math.floor(14 - df)
          }
        };
        if (!Df(d, i)) continue;
        const v = n === t[a];
        let h;
        Sd(this._internalModuleSourceToRanges, s) ? (e.fillStyle = v ? hf.INTERNAL_MODULE_FRAME_HOVER : hf.INTERNAL_MODULE_FRAME, h = hf.INTERNAL_MODULE_FRAME_TEXT) : (e.fillStyle = v ? Ad(s) : Dd(s), h = hf.TEXT_COLOR);
        const m = Af(d, i);
        e.fillRect(m.origin.x, m.origin.y, m.size.width, m.size.height), Yf(l, e, d, m, {
          fillStyle: h
        });
      }
      const s = {
        origin: {
          x: r.origin.x,
          y: r.origin.y + 14 - df
        },
        size: {
          width: r.size.width,
          height: df
        }
      };
      if (Df(s, i)) {
        const r = Af(s, i);
        e.fillStyle = hf.PRIORITY_BORDER, e.fillRect(r.origin.x, r.origin.y, r.size.width, r.size.height);
      }
    }
    _handleMouseMove(e, r) {
      const {
          _stackLayer: t,
          frame: n,
          _intrinsicSize: a,
          _onHover: i,
          visibleArea: o
        } = this,
        {
          location: s
        } = e.payload;
      if (!i || !Mf(s, o)) return;
      const l = ld(a.width, n);
      let c = 0,
        u = t.length - 1;
      for (; c <= u;) {
        const e = Math.floor((c + u) / 2),
          a = t[e],
          {
            timestamp: o,
            duration: f
          } = a,
          d = Math.floor(cd(o, l, n)),
          v = fd(f, l);
        if (Math.floor(v - df) >= 1 && d <= s.x && d + v >= s.x) return this.currentCursor = "context-menu", r.hoveredView = this, void i(a);
        d > s.x ? u = e - 1 : c = e + 1;
      }
      i(null);
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "mousemove":
          this._handleMouseMove(e, r);
      }
    }
  }
  class xd extends Ff {
    constructor(e, r, t, n, a) {
      super(e, r, Rf), yd(this, "_flamechartRowViews", []), yd(this, "_hoveredStackFrame", null), yd(this, "_onHover", null), this.setDataAndUpdateSubviews(t, n, a);
    }
    setDataAndUpdateSubviews(e, r, t) {
      const {
        surface: n,
        frame: a,
        _onHover: i,
        _hoveredStackFrame: o
      } = this;
      this._verticalStackView && (this.removeAllSubviews(), this._flamechartRowViews = []), this._verticalStackView = new Ff(n, a, If), this._flamechartRowViews = e.map(e => {
        const s = new Md(n, a, e, r, t);
        return this._verticalStackView.addSubview(s), s._onHover = i, s.setHoveredFlamechartStackFrame(o), s;
      }), this.addSubview(new Lf(n, a)), this.addSubview(this._verticalStackView);
    }
    setHoveredFlamechartStackFrame(e) {
      this._hoveredStackFrame = e, this._flamechartRowViews.forEach(r => r.setHoveredFlamechartStackFrame(e));
    }
    setOnHover(e) {
      this._onHover = e, this._flamechartRowViews.forEach(r => r._onHover = e);
    }
    desiredSize() {
      return {
        ...this._verticalStackView.desiredSize(),
        maxInitialHeight: 0
      };
    }
    _handleMouseMove(e) {
      const {
        _onHover: r,
        visibleArea: t
      } = this;
      if (!r) return;
      const {
        location: n
      } = e.payload;
      Mf(n, t) || r(null);
    }
    handleInteraction(e) {
      switch (e.type) {
        case "mousemove":
          this._handleMouseMove(e);
      }
    }
  }
  function Od(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  const Td = 14 + df;
  class Nd extends Ff {
    constructor(e, r, t) {
      super(e, r), Od(this, "_hoveredEvent", null), Od(this, "_maxDepth", 0), Od(this, "onHover", null), this._profilerData = t, this._performPreflightComputations();
    }
    _performPreflightComputations() {
      this._depthToNativeEvent = new Map();
      const {
        duration: e,
        nativeEvents: r
      } = this._profilerData;
      r.forEach(e => {
        const r = e.depth;
        this._maxDepth = Math.max(this._maxDepth, r), this._depthToNativeEvent.has(r) ? this._depthToNativeEvent.get(r).push(e) : this._depthToNativeEvent.set(r, [e]);
      }), this._intrinsicSize = {
        width: e,
        height: (this._maxDepth + 1) * Td,
        hideScrollBarIfLessThanHeight: Td
      };
    }
    desiredSize() {
      return this._intrinsicSize;
    }
    setHoveredEvent(e) {
      this._hoveredEvent !== e && (this._hoveredEvent = e, this.setNeedsDisplay());
    }
    _drawSingleNativeEvent(e, r, t, n, a, i) {
      const {
          frame: o
        } = this,
        {
          depth: s,
          duration: l,
          timestamp: c,
          type: u,
          warning: f
        } = t;
      n += s * Td;
      const d = cd(c, a, o),
        v = {
          origin: {
            x: d,
            y: n
          },
          size: {
            width: cd(c + l, a, o) - d,
            height: 14
          }
        };
      if (!Df(v, r)) return;
      if (fd(l, a) < 1) return;
      const h = Af(v, r);
      e.beginPath(), e.fillStyle = null !== f ? i ? hf.WARNING_BACKGROUND_HOVER : hf.WARNING_BACKGROUND : i ? hf.NATIVE_EVENT_HOVER : hf.NATIVE_EVENT, e.fillRect(h.origin.x, h.origin.y, h.size.width, h.size.height);
      Yf(`${u} - ${hd(l)}`, e, v, h);
    }
    draw(e) {
      const {
        frame: r,
        _profilerData: {
          nativeEvents: t
        },
        _hoveredEvent: n,
        visibleArea: a
      } = this;
      e.fillStyle = hf.PRIORITY_BACKGROUND, e.fillRect(a.origin.x, a.origin.y, a.size.width, a.size.height);
      const i = ld(this._intrinsicSize.width, r);
      t.forEach(t => {
        this._drawSingleNativeEvent(e, a, t, r.origin.y, i, t === n);
      });
      for (let t = 0; t <= this._maxDepth; t++) {
        const t = {
          origin: {
            x: r.origin.x,
            y: r.origin.y + 14
          },
          size: {
            width: r.size.width,
            height: df
          }
        };
        if (Df(t, a)) {
          const r = Af(t, a);
          e.fillStyle = hf.PRIORITY_BORDER, e.fillRect(r.origin.x, r.origin.y, r.size.width, r.size.height);
        }
      }
    }
    _handleMouseMove(e, r) {
      const {
        frame: t,
        _intrinsicSize: n,
        onHover: a,
        visibleArea: i
      } = this;
      if (!a) return;
      const {
        location: o
      } = e.payload;
      if (!Mf(o, i)) return void a(null);
      const s = ld(n.width, t),
        l = ud(o.x, s, t),
        c = o.y - t.origin.y,
        u = Math.floor(c / Td),
        f = this._depthToNativeEvent.get(u);
      if (f) for (let e = f.length - 1; e >= 0; e--) {
        const t = f[e],
          {
            duration: n,
            timestamp: i
          } = t;
        if (l >= i && l <= i + n) return r.hoveredView = this, void a(t);
      }
      a(null);
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "mousemove":
          this._handleMouseMove(e, r);
      }
    }
  }
  function Rd(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  const Id = 14 + df,
    Hd = /([^:]+:\/\/[^\/]+)/;
  class Fd extends Ff {
    constructor(e, r, t) {
      super(e, r), Rd(this, "_hoveredNetworkMeasure", null), Rd(this, "_maxDepth", 0), Rd(this, "onHover", null), this._profilerData = t, this._performPreflightComputations();
    }
    _performPreflightComputations() {
      this._depthToNetworkMeasure = new Map();
      const {
        duration: e,
        networkMeasures: r
      } = this._profilerData;
      r.forEach(e => {
        const r = e.depth;
        this._maxDepth = Math.max(this._maxDepth, r), this._depthToNetworkMeasure.has(r) ? this._depthToNetworkMeasure.get(r).push(e) : this._depthToNetworkMeasure.set(r, [e]);
      }), this._intrinsicSize = {
        width: e,
        height: (this._maxDepth + 1) * Id,
        maxInitialHeight: 0
      };
    }
    desiredSize() {
      return this._intrinsicSize;
    }
    setHoveredEvent(e) {
      this._hoveredNetworkMeasure !== e && (this._hoveredNetworkMeasure = e, this.setNeedsDisplay());
    }
    _drawSingleNetworkMeasure(e, r, t, n, a) {
      const {
          frame: i,
          visibleArea: o
        } = this,
        {
          depth: s,
          finishTimestamp: l,
          firstReceivedDataTimestamp: c,
          lastReceivedDataTimestamp: u,
          receiveResponseTimestamp: f,
          sendRequestTimestamp: d,
          url: v
        } = r,
        h = this._profilerData.duration,
        m = l || u || h,
        _ = f || c || m,
        p = cd(d, n, i),
        g = cd(_, n, i),
        b = cd(m, n, i);
      if (fd(b - p, n) < 1) return;
      const S = {
        origin: {
          x: p,
          y: t += s * Id
        },
        size: {
          width: b - p,
          height: 14
        }
      };
      if (!Df(S, o)) return;
      let E = {
        origin: {
          x: p,
          y: t
        },
        size: {
          width: b - p,
          height: 14
        }
      };
      Df(E, o) && (e.beginPath(), e.fillStyle = this._hoveredNetworkMeasure === r ? hf.NETWORK_SECONDARY_HOVER : hf.NETWORK_SECONDARY, e.fillRect(E.origin.x, E.origin.y, E.size.width, E.size.height)), E = {
        origin: {
          x: p + df,
          y: t + df
        },
        size: {
          width: g - p - df,
          height: 14 - 2 * df
        }
      }, Df(E, o) && (e.beginPath(), e.fillStyle = this._hoveredNetworkMeasure === r ? hf.NETWORK_PRIMARY_HOVER : hf.NETWORK_PRIMARY, e.fillRect(E.origin.x, E.origin.y, E.size.width, E.size.height));
      const w = v.match(Hd),
        y = null !== w ? w[1] : v;
      Yf((0 !== l ? hd(l - d) + " - " : "") + y, e, S, o);
    }
    draw(e) {
      const {
        frame: r,
        _profilerData: {
          networkMeasures: t
        },
        _hoveredNetworkMeasure: n,
        visibleArea: a
      } = this;
      e.fillStyle = hf.PRIORITY_BACKGROUND, e.fillRect(a.origin.x, a.origin.y, a.size.width, a.size.height);
      const i = ld(this._intrinsicSize.width, r);
      t.forEach(t => {
        this._drawSingleNetworkMeasure(e, t, r.origin.y, i, t === n);
      });
      for (let t = 0; t <= this._maxDepth; t++) {
        const n = {
          origin: {
            x: r.origin.x,
            y: r.origin.y + (t + 1) * Id - df
          },
          size: {
            width: r.size.width,
            height: df
          }
        };
        if (Df(n, a)) {
          const r = Af(n, a);
          e.fillStyle = hf.PRIORITY_BORDER, e.fillRect(r.origin.x, r.origin.y, r.size.width, r.size.height);
        }
      }
    }
    _handleMouseMove(e, r) {
      const {
        frame: t,
        _intrinsicSize: n,
        onHover: a,
        visibleArea: i
      } = this;
      if (!a) return;
      const {
        location: o
      } = e.payload;
      if (!Mf(o, i)) return void a(null);
      const s = ld(n.width, t),
        l = ud(o.x, s, t),
        c = o.y - t.origin.y,
        u = Math.floor(c / Id),
        f = this._depthToNetworkMeasure.get(u),
        d = this._profilerData.duration;
      if (f) for (let e = f.length - 1; e >= 0; e--) {
        const t = f[e],
          {
            finishTimestamp: n,
            lastReceivedDataTimestamp: i,
            sendRequestTimestamp: o
          } = t,
          s = n || i || d;
        if (l >= o && l <= s) return this.currentCursor = "context-menu", r.hoveredView = this, void a(t);
      }
      r.hoveredView === this && (r.hoveredView = null), a(null);
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "mousemove":
          this._handleMouseMove(e, r);
      }
    }
  }
  function Ld(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  const Pd = 14 + df;
  class zd extends Ff {
    constructor(e, r, t) {
      super(e, r), Ld(this, "_hoveredMeasure", null), Ld(this, "onHover", null), this._profilerData = t, this._performPreflightComputations();
    }
    _performPreflightComputations() {
      this._lanesToRender = [];
      for (const [e, r] of this._profilerData.laneToReactMeasureMap) r.length > 0 && this._lanesToRender.push(e);
      this._intrinsicSize = {
        width: this._profilerData.duration,
        height: this._lanesToRender.length * Pd,
        hideScrollBarIfLessThanHeight: Pd,
        maxInitialHeight: 5 * Pd
      };
    }
    desiredSize() {
      return this._intrinsicSize;
    }
    setHoveredMeasure(e) {
      this._hoveredMeasure !== e && (this._hoveredMeasure = e, this.setNeedsDisplay());
    }
    _drawSingleReactMeasure(e, r, t, n, a, i, o, s) {
      const {
          frame: l,
          visibleArea: c
        } = this,
        {
          timestamp: u,
          type: f,
          duration: d
        } = t;
      let v = null,
        h = null,
        m = null,
        _ = null;
      const p = fd(d, i);
      if (p <= 0) return;
      const g = cd(u, i, l),
        b = {
          origin: {
            x: g,
            y: a
          },
          size: {
            width: p,
            height: 14
          }
        };
      if (!Df(b, r)) return;
      const S = Af(b, r);
      let E = b;
      switch (f) {
        case "commit":
          v = hf.REACT_COMMIT, h = hf.REACT_COMMIT_HOVER, m = hf.REACT_COMMIT_HOVER, _ = hf.REACT_COMMIT_TEXT, null != n && n.timestamp < t.timestamp + t.duration && (E = {
            ...b,
            size: {
              width: cd(n.timestamp, i, l) - g,
              height: 14
            }
          });
          break;
        case "render-idle":
          v = hf.REACT_IDLE, h = hf.REACT_IDLE_HOVER, m = hf.REACT_IDLE_HOVER;
          break;
        case "render":
          v = hf.REACT_RENDER, h = hf.REACT_RENDER_HOVER, m = hf.REACT_RENDER_HOVER, _ = hf.REACT_RENDER_TEXT;
          break;
        case "layout-effects":
          v = hf.REACT_LAYOUT_EFFECTS, h = hf.REACT_LAYOUT_EFFECTS_HOVER, m = hf.REACT_LAYOUT_EFFECTS_HOVER, _ = hf.REACT_LAYOUT_EFFECTS_TEXT;
          break;
        case "passive-effects":
          v = hf.REACT_PASSIVE_EFFECTS, h = hf.REACT_PASSIVE_EFFECTS_HOVER, m = hf.REACT_PASSIVE_EFFECTS_HOVER, _ = hf.REACT_PASSIVE_EFFECTS_TEXT;
          break;
        default:
          throw new Error(`Unexpected measure type "${f}"`);
      }
      e.fillStyle = s ? h : o ? m : v, e.fillRect(S.origin.x, S.origin.y, S.size.width, S.size.height), null !== _ && Yf(hd(d), e, E, c, {
        fillStyle: _
      });
    }
    draw(e) {
      const {
        frame: r,
        _hoveredMeasure: t,
        _lanesToRender: n,
        _profilerData: a,
        visibleArea: i
      } = this;
      e.fillStyle = hf.PRIORITY_BACKGROUND, e.fillRect(i.origin.x, i.origin.y, i.size.width, i.size.height);
      const o = ld(this._intrinsicSize.width, r);
      for (let s = 0; s < n.length; s++) {
        const l = n[s],
          c = r.origin.y + s * Pd,
          u = a.laneToReactMeasureMap.get(l);
        if (!u) throw new Error("No measures found for a React lane! This is a bug in this profiler tool. Please file an issue.");
        const f = a.laneToLabelMap.get(l);
        if (null == f) console.warn(`Could not find label for lane ${l}.`);else {
          Yf(f, e, {
            origin: {
              x: i.origin.x,
              y: c
            },
            size: {
              width: i.size.width,
              height: Pd
            }
          }, i, {
            fillStyle: hf.TEXT_DIM_COLOR
          });
        }
        for (let r = 0; r < u.length; r++) {
          const n = u[r],
            a = t === n,
            s = !!t && t.batchUID === n.batchUID;
          this._drawSingleReactMeasure(e, i, n, u[r + 1] || null, c, o, s, a);
        }
        const d = {
          origin: {
            x: r.origin.x,
            y: r.origin.y + (s + 1) * Pd - df
          },
          size: {
            width: r.size.width,
            height: df
          }
        };
        if (Df(d, i)) {
          const r = Af(d, i);
          e.fillStyle = hf.PRIORITY_BORDER, e.fillRect(r.origin.x, r.origin.y, r.size.width, r.size.height);
        }
      }
    }
    _handleMouseMove(e, r) {
      const {
        frame: t,
        _intrinsicSize: n,
        _lanesToRender: a,
        onHover: i,
        _profilerData: o,
        visibleArea: s
      } = this;
      if (!i) return;
      const {
        location: l
      } = e.payload;
      if (!Mf(l, s)) return void i(null);
      const c = l.y - t.origin.y,
        u = Math.floor(c / Pd);
      if (u < 0 || u >= a.length) return void i(null);
      const f = a[u],
        d = ld(n.width, t),
        v = ud(l.x, d, t),
        h = o.laneToReactMeasureMap.get(f);
      if (h) {
        for (let e = h.length - 1; e >= 0; e--) {
          const t = h[e],
            {
              duration: n,
              timestamp: a
            } = t;
          if (v >= a && v <= a + n) return this.currentCursor = "context-menu", r.hoveredView = this, void i(t);
        }
        i(null);
      } else i(null);
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "mousemove":
          this._handleMouseMove(e, r);
      }
    }
  }
  function Bd(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  class jd extends Ff {
    constructor(e, r, t) {
      super(e, r), Bd(this, "_hoveredEvent", null), Bd(this, "onHover", null), Bd(this, "onClick", null), this._profilerData = t, this._intrinsicSize = {
        width: this._profilerData.duration,
        height: 14
      };
    }
    desiredSize() {
      return this._intrinsicSize;
    }
    setHoveredEvent(e) {
      this._hoveredEvent !== e && (this._hoveredEvent = e, this.setNeedsDisplay());
    }
    _drawSingleSchedulingEvent(e, r, t, n, a, i) {
      const {
          frame: o
        } = this,
        {
          timestamp: s,
          type: l,
          warning: c
        } = t,
        u = cd(s, a, o),
        f = {
          origin: {
            x: u - 3,
            y: n
          },
          size: {
            width: 6,
            height: 6
          }
        };
      if (!Df(f, r)) return;
      let d = null;
      if (null !== c) d = i ? hf.WARNING_BACKGROUND_HOVER : hf.WARNING_BACKGROUND;else switch (l) {
        case "schedule-render":
        case "schedule-state-update":
        case "schedule-force-update":
          d = i ? hf.REACT_SCHEDULE_HOVER : hf.REACT_SCHEDULE;
          break;
        default:
          0;
      }
      if (null !== d) {
        const r = f.origin.y + 3;
        e.beginPath(), e.fillStyle = d, e.arc(u, r, 3, 0, 2 * Math.PI), e.fill();
      }
    }
    draw(e) {
      const {
        frame: r,
        _profilerData: {
          schedulingEvents: t
        },
        _hoveredEvent: n,
        visibleArea: a
      } = this;
      e.fillStyle = hf.BACKGROUND, e.fillRect(a.origin.x, a.origin.y, a.size.width, a.size.height);
      const i = r.origin.y + 4,
        o = ld(this._intrinsicSize.width, r),
        s = [];
      t.forEach(r => {
        r !== n ? this._drawSingleSchedulingEvent(e, a, r, i, o, !1) : s.push(r);
      }), s.forEach(r => {
        this._drawSingleSchedulingEvent(e, a, r, i, o, !0);
      });
      const l = {
        origin: {
          x: r.origin.x,
          y: r.origin.y + 14 - df
        },
        size: {
          width: r.size.width,
          height: df
        }
      };
      if (Df(l, a)) {
        const r = Af(l, a);
        e.fillStyle = hf.REACT_WORK_BORDER, e.fillRect(r.origin.x, r.origin.y, r.size.width, r.size.height);
      }
    }
    _handleMouseMove(e, r) {
      const {
        frame: t,
        onHover: n,
        visibleArea: a
      } = this;
      if (!n) return;
      const {
        location: i
      } = e.payload;
      if (!Mf(i, a)) return void n(null);
      const {
          _profilerData: {
            schedulingEvents: o
          }
        } = this,
        s = ld(this._intrinsicSize.width, t),
        l = ud(i.x, s, t),
        c = dd(3, s);
      for (let e = o.length - 1; e >= 0; e--) {
        const t = o[e],
          {
            timestamp: a
          } = t;
        if (a - c <= l && l <= a + c) return this.currentCursor = "pointer", r.hoveredView = this, void n(t);
      }
      n(null);
    }
    _handleClick(e) {
      const {
        onClick: r
      } = this;
      if (r) {
        const {
            _profilerData: {
              schedulingEvents: e
            }
          } = this,
          t = e.findIndex(e => e === this._hoveredEvent);
        r(this._hoveredEvent, t >= 0 ? t : null);
      }
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "mousemove":
          this._handleMouseMove(e, r);
          break;
        case "click":
          this._handleClick(e);
      }
    }
  }
  function Vd(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  class Ud extends Ff {
    constructor(e, r, t) {
      super(e, r), Vd(this, "_hoverLocation", null), Vd(this, "onHover", null), this._intrinsicSize = {
        width: t.duration,
        height: t.snapshotHeight
      }, this._profilerData = t;
    }
    desiredSize() {
      return this._intrinsicSize;
    }
    draw(e) {
      const r = this._profilerData.snapshotHeight,
        {
          visibleArea: t
        } = this;
      e.fillStyle = hf.BACKGROUND, e.fillRect(t.origin.x, t.origin.y, t.size.width, t.size.height);
      const n = t.origin.y;
      let a = t.origin.x;
      for (; a < t.origin.x + t.size.width;) {
        const t = this._findClosestSnapshot(a);
        if (null === t) break;
        const i = r,
          o = t.width * r / t.height,
          s = {
            origin: {
              x: a,
              y: n
            },
            size: {
              width: o,
              height: i
            }
          };
        if (null === t.image) {
          const r = t.image = new Image();
          r.onload = () => {
            this._drawSnapshotImage(e, t, s);
          }, r.src = t.imageSource;
        } else this._drawSnapshotImage(e, t, s);
        a += o + df;
      }
      const i = this._hoverLocation;
      if (null !== i) {
        const r = 3 + 2 * df,
          n = r / 2;
        e.fillStyle = hf.SCRUBBER_BORDER, e.fillRect(i.x - n, t.origin.y, r, t.size.height), e.fillStyle = hf.SCRUBBER_BACKGROUND, e.fillRect(i.x - n + df, t.origin.y, 3, t.size.height);
      }
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "mousemove":
        case "wheel-control":
        case "wheel-meta":
        case "wheel-plain":
        case "wheel-shift":
          this._updateHover(e.payload.location, r);
      }
    }
    _drawSnapshotImage(e, r, t) {
      const n = this.visibleArea,
        a = !wf(t, n);
      if (a) {
        const r = Af(t, n);
        e.save(), e.beginPath(), e.rect(r.origin.x, r.origin.y, r.size.width, r.size.height), e.closePath(), e.clip();
      }
      e.fillStyle = hf.REACT_RESIZE_BAR_BORDER, e.fillRect(t.origin.x, t.origin.y, t.size.width, t.size.height), e.drawImage(r.image, 0, 0, r.width, r.height, t.origin.x + df, t.origin.y + df, t.size.width - 2 * df, t.size.height - 2 * df), a && e.restore();
    }
    _findClosestSnapshot(e) {
      const r = this.frame,
        t = ld(this._intrinsicSize.width, r),
        n = this._profilerData.snapshots;
      let a = 0,
        i = n.length - 1;
      for (; a <= i;) {
        const o = Math.floor((a + i) / 2),
          s = n[o],
          {
            timestamp: l
          } = s;
        e < Math.floor(cd(l, t, r)) ? i = o - 1 : a = o + 1;
      }
      return n[i] || null;
    }
    _updateHover(e, r) {
      const {
        onHover: t,
        visibleArea: n
      } = this;
      if (!t) return;
      if (!Mf(e, n)) return null !== this._hoverLocation && (this._hoverLocation = null, this.setNeedsDisplay()), void t(null);
      const a = this._findClosestSnapshot(e.x);
      null !== a ? (this._hoverLocation = e, t(a)) : (this._hoverLocation = null, t(null)), this.setNeedsDisplay();
    }
  }
  function Wd(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  const $d = 14 + df;
  class Xd extends Ff {
    constructor(e, r, t) {
      super(e, r), Wd(this, "_hoveredEvent", null), Wd(this, "_maxDepth", 0), Wd(this, "onHover", null), this._profilerData = t, this._performPreflightComputations();
    }
    _performPreflightComputations() {
      this._depthToSuspenseEvent = new Map();
      const {
        duration: e,
        suspenseEvents: r
      } = this._profilerData;
      r.forEach(e => {
        const r = e.depth;
        this._maxDepth = Math.max(this._maxDepth, r), this._depthToSuspenseEvent.has(r) ? this._depthToSuspenseEvent.get(r).push(e) : this._depthToSuspenseEvent.set(r, [e]);
      }), this._intrinsicSize = {
        width: e,
        height: (this._maxDepth + 1) * $d,
        hideScrollBarIfLessThanHeight: $d,
        maxInitialHeight: 3 * $d
      };
    }
    desiredSize() {
      return this._intrinsicSize;
    }
    setHoveredEvent(e) {
      this._hoveredEvent !== e && (this._hoveredEvent = e, this.setNeedsDisplay());
    }
    _drawSingleSuspenseEvent(e, r, t, n, a, i) {
      const {
          frame: o
        } = this,
        {
          componentName: s,
          depth: l,
          duration: c,
          phase: u,
          promiseName: f,
          resolution: d,
          timestamp: v,
          warning: h
        } = t;
      n += l * $d;
      let m = null;
      if (null !== h) m = i ? hf.WARNING_BACKGROUND_HOVER : hf.WARNING_BACKGROUND;else switch (d) {
        case "rejected":
          m = i ? hf.REACT_SUSPENSE_REJECTED_EVENT_HOVER : hf.REACT_SUSPENSE_REJECTED_EVENT;
          break;
        case "resolved":
          m = i ? hf.REACT_SUSPENSE_RESOLVED_EVENT_HOVER : hf.REACT_SUSPENSE_RESOLVED_EVENT;
          break;
        case "unresolved":
          m = i ? hf.REACT_SUSPENSE_UNRESOLVED_EVENT_HOVER : hf.REACT_SUSPENSE_UNRESOLVED_EVENT;
      }
      const _ = cd(v, a, o);
      if (null === c) {
        const t = 8,
          a = t / 2,
          i = (n += 3) + a;
        if (!Df({
          origin: {
            x: _ - a,
            y: n
          },
          size: {
            width: t,
            height: t
          }
        }, r)) return;
        e.beginPath(), e.fillStyle = m, e.moveTo(_, i - a), e.lineTo(_ + a, i), e.lineTo(_, i + a), e.lineTo(_ - a, i), e.fill();
      } else {
        const t = {
          origin: {
            x: _,
            y: n
          },
          size: {
            width: cd(v + c, a, o) - _,
            height: 14
          }
        };
        if (!Df(t, r)) return;
        if (fd(c, a) < 1) return;
        const i = Af(t, r);
        e.beginPath(), e.fillStyle = m, e.fillRect(i.origin.x, i.origin.y, i.size.width, i.size.height);
        let l = "suspended";
        null != f ? l = f : null != s && (l = `${s} ${l}`), null !== u && (l += " during " + u), "unresolved" !== d && (l += " - " + hd(c)), Yf(l, e, t, i);
      }
    }
    draw(e) {
      const {
        frame: r,
        _profilerData: {
          suspenseEvents: t
        },
        _hoveredEvent: n,
        visibleArea: a
      } = this;
      e.fillStyle = hf.PRIORITY_BACKGROUND, e.fillRect(a.origin.x, a.origin.y, a.size.width, a.size.height);
      const i = ld(this._intrinsicSize.width, r);
      t.forEach(t => {
        this._drawSingleSuspenseEvent(e, a, t, r.origin.y, i, t === n);
      });
      for (let t = 0; t <= this._maxDepth; t++) {
        const n = {
          origin: {
            x: r.origin.x,
            y: r.origin.y + (t + 1) * $d - df
          },
          size: {
            width: r.size.width,
            height: df
          }
        };
        if (Df(n, a)) {
          const r = Af(n, a);
          e.fillStyle = hf.REACT_WORK_BORDER, e.fillRect(r.origin.x, r.origin.y, r.size.width, r.size.height);
        }
      }
    }
    _handleMouseMove(e, r) {
      const {
        frame: t,
        _intrinsicSize: n,
        onHover: a,
        visibleArea: i
      } = this;
      if (!a) return;
      const {
        location: o
      } = e.payload;
      if (!Mf(o, i)) return void a(null);
      const s = ld(n.width, t),
        l = ud(o.x, s, t),
        c = o.y - t.origin.y,
        u = Math.floor(c / $d),
        f = this._depthToSuspenseEvent.get(u);
      if (f) for (let e = f.length - 1; e >= 0; e--) {
        const t = f[e],
          {
            duration: n,
            timestamp: i
          } = t;
        if (null === n) {
          const e = dd(4, s);
          if (i - e <= l && l <= i + e) return this.currentCursor = "context-menu", r.hoveredView = this, void a(t);
        } else if (l >= i && l <= i + n) return this.currentCursor = "context-menu", r.hoveredView = this, void a(t);
      }
      a(null);
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "mousemove":
          this._handleMouseMove(e, r);
      }
    }
  }
  function Gd(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  class Kd extends Ff {
    constructor(e, r, t) {
      super(e, r), Gd(this, "_hoveredEvent", null), Gd(this, "onHover", null), this._profilerData = t, this._intrinsicSize = {
        width: this._profilerData.duration,
        height: 14
      };
    }
    desiredSize() {
      return this._intrinsicSize;
    }
    setHoveredEvent(e) {
      this._hoveredEvent !== e && (this._hoveredEvent = e, this.setNeedsDisplay());
    }
    _drawSingleThrownError(e, r, t, n, a, i) {
      const {
          frame: o
        } = this,
        {
          timestamp: s
        } = t,
        l = cd(s, a, o),
        c = {
          origin: {
            x: l - 3,
            y: n
          },
          size: {
            width: 6,
            height: 6
          }
        };
      if (!Df(c, r)) return;
      const u = i ? hf.REACT_THROWN_ERROR_HOVER : hf.REACT_THROWN_ERROR,
        f = c.origin.y + 3;
      e.beginPath(), e.fillStyle = u, e.arc(l, f, 3, 0, 2 * Math.PI), e.fill();
    }
    draw(e) {
      const {
        frame: r,
        _profilerData: {
          thrownErrors: t
        },
        _hoveredEvent: n,
        visibleArea: a
      } = this;
      e.fillStyle = hf.BACKGROUND, e.fillRect(a.origin.x, a.origin.y, a.size.width, a.size.height);
      const i = r.origin.y + 4,
        o = ld(this._intrinsicSize.width, r),
        s = [];
      t.forEach(r => {
        r !== n ? this._drawSingleThrownError(e, a, r, i, o, !1) : s.push(r);
      }), s.forEach(r => {
        this._drawSingleThrownError(e, a, r, i, o, !0);
      });
      const l = {
        origin: {
          x: r.origin.x,
          y: r.origin.y + 14 - df
        },
        size: {
          width: r.size.width,
          height: df
        }
      };
      if (Df(l, a)) {
        const r = Af(l, a);
        e.fillStyle = hf.REACT_WORK_BORDER, e.fillRect(r.origin.x, r.origin.y, r.size.width, r.size.height);
      }
    }
    _handleMouseMove(e, r) {
      const {
        frame: t,
        onHover: n,
        visibleArea: a
      } = this;
      if (!n) return;
      const {
        location: i
      } = e.payload;
      if (!Mf(i, a)) return void n(null);
      const {
          _profilerData: {
            thrownErrors: o
          }
        } = this,
        s = ld(this._intrinsicSize.width, t),
        l = ud(i.x, s, t),
        c = dd(3, s);
      for (let e = o.length - 1; e >= 0; e--) {
        const t = o[e],
          {
            timestamp: a
          } = t;
        if (a - c <= l && l <= a + c) return this.currentCursor = "context-menu", r.hoveredView = this, void n(t);
      }
      n(null);
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "mousemove":
          this._handleMouseMove(e, r);
      }
    }
  }
  const Yd = 20 + df,
    qd = 80 + df;
  class Qd extends Ff {
    constructor(e, r, t) {
      super(e, r), this._totalDuration = t, this._intrinsicSize = {
        width: this._totalDuration,
        height: Yd
      };
    }
    desiredSize() {
      return this._intrinsicSize;
    }
    _getTimeTickInterval(e) {
      for (let r = 0; r < vf.length; r++) {
        const t = vf[r];
        if (fd(t, e) > 70) return t;
      }
      return vf[0];
    }
    draw(e) {
      const {
          frame: r,
          _intrinsicSize: t,
          visibleArea: n
        } = this,
        a = {
          origin: r.origin,
          size: {
            width: r.size.width,
            height: t.height
          }
        },
        i = Af(a, n);
      e.fillStyle = hf.BACKGROUND, e.fillRect(i.origin.x, i.origin.y, i.size.width, i.size.height);
      const o = ld(t.width, a),
        s = this._getTimeTickInterval(o);
      for (let r = Math.ceil(ud(i.origin.x - qd, o, a) / s) * s;; r += s) {
        if (r <= 0) continue;
        const t = cd(r, o, a);
        if (t > i.origin.x + i.size.width) break;
        const n = Math.round(r);
        e.fillStyle = hf.PRIORITY_BORDER, e.fillRect(t, i.origin.y + 20 - 8, df, 8), e.fillStyle = hf.TIME_MARKER_LABEL, e.textAlign = "right", e.textBaseline = "middle", e.font = ff + "px sans-serif", e.fillText(n + "ms", t - 8, 10);
      }
      const l = {
        origin: {
          x: a.origin.x,
          y: a.origin.y + a.size.height - df
        },
        size: {
          width: a.size.width,
          height: df
        }
      };
      if (Df(l, n)) {
        const r = Af(l, n);
        e.fillStyle = hf.PRIORITY_BORDER, e.fillRect(r.origin.x, r.origin.y, r.size.width, r.size.height);
      }
    }
  }
  function Zd(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  class Jd extends Ff {
    constructor(e, r, t, n) {
      super(e, r), Zd(this, "_hoveredMark", null), Zd(this, "onHover", null), this._marks = t, this._intrinsicSize = {
        width: n,
        height: 16
      };
    }
    desiredSize() {
      return this._intrinsicSize;
    }
    setHoveredMark(e) {
      this._hoveredMark !== e && (this._hoveredMark = e, this.setNeedsDisplay());
    }
    _drawSingleMark(e, r, t, n, a, i) {
      const {
          frame: o
        } = this,
        {
          timestamp: s
        } = t,
        l = cd(s, a, o);
      if (!Df({
        origin: {
          x: l - 4,
          y: n
        },
        size: {
          width: 8,
          height: 8
        }
      }, r)) return;
      const c = i ? hf.USER_TIMING_HOVER : hf.USER_TIMING;
      if (null !== c) {
        const r = n + 4;
        e.beginPath(), e.fillStyle = c, e.moveTo(l, r - 4), e.lineTo(l + 4, r), e.lineTo(l, r + 4), e.lineTo(l - 4, r), e.fill();
      }
    }
    draw(e) {
      const {
        frame: r,
        _marks: t,
        _hoveredMark: n,
        visibleArea: a
      } = this;
      e.fillStyle = hf.BACKGROUND, e.fillRect(a.origin.x, a.origin.y, a.size.width, a.size.height);
      const i = r.origin.y + 4,
        o = ld(this._intrinsicSize.width, r);
      t.forEach(r => {
        r !== n && this._drawSingleMark(e, a, r, i, o, !1);
      }), null !== n && this._drawSingleMark(e, a, n, i, o, !0);
      const s = {
        origin: {
          x: r.origin.x,
          y: r.origin.y + 16 - df
        },
        size: {
          width: r.size.width,
          height: df
        }
      };
      if (Df(s, a)) {
        const r = Af(s, a);
        e.fillStyle = hf.PRIORITY_BORDER, e.fillRect(r.origin.x, r.origin.y, r.size.width, r.size.height);
      }
    }
    _handleMouseMove(e, r) {
      const {
        frame: t,
        onHover: n,
        visibleArea: a
      } = this;
      if (!n) return;
      const {
        location: i
      } = e.payload;
      if (!Mf(i, a)) return void n(null);
      const {
          _marks: o
        } = this,
        s = ld(this._intrinsicSize.width, t),
        l = ud(i.x, s, t),
        c = dd(4, s);
      for (let e = o.length - 1; e >= 0; e--) {
        const t = o[e],
          {
            timestamp: a
          } = t;
        if (a - c <= l && l <= a + c) return r.hoveredView = this, void n(t);
      }
      n(null);
    }
    handleInteraction(e, r) {
      switch (e.type) {
        case "mousemove":
          this._handleMouseMove(e, r);
      }
    }
  }
  const ev = gf(function (e, r, t = 0) {
    const n = r.batchUIDToMeasuresMap.get(e);
    if (null == n || 0 === n.length) throw Error(`Could not find measures with batch UID "${e}"`);
    const a = n[n.length - 1],
      i = a.timestamp + a.duration;
    if (i < t) return [0, 0];
    let o = t;
    for (let e = 0; e < n.length; e++) {
      const r = n[e];
      if (r.timestamp >= t) {
        o = r.timestamp;
        break;
      }
    }
    return [o, i];
  });
  var rv = t(4),
    tv = t.n(rv);
  function nv({
    canvasRef: e,
    data: r,
    height: t,
    hoveredEvent: n,
    origin: i,
    width: o
  }) {
    const s = function ({
      canvasRef: e,
      mouseX: r,
      mouseY: t
    }) {
      const n = Object(a.useRef)(null);
      let i = window.innerHeight,
        o = window.innerWidth;
      const s = e.current;
      if (null !== s) {
        const e = s.getBoundingClientRect();
        i = e.top + e.height, o = e.left + e.width;
      }
      return Object(a.useLayoutEffect)(() => {
        const e = n.current;
        null !== e && (t + 10 + e.offsetHeight >= i ? t - 5 - e.offsetHeight > 0 ? e.style.top = t - e.offsetHeight - 5 + "px" : e.style.top = "0px" : e.style.top = t + 10 + "px", r + 10 + e.offsetWidth >= o ? r - 5 - e.offsetWidth > 0 ? e.style.left = r - e.offsetWidth - 5 + "px" : e.style.left = "0px" : e.style.left = r + 10 + "px");
      }), n;
    }({
      canvasRef: e,
      mouseX: i.x,
      mouseY: i.y
    });
    if (null === n) return null;
    const {
      componentMeasure: l,
      flamechartStackFrame: c,
      measure: u,
      nativeEvent: f,
      networkMeasure: d,
      schedulingEvent: v,
      snapshot: h,
      suspenseEvent: m,
      thrownError: _,
      userTimingMark: p
    } = n;
    let g = null;
    return null !== l ? g = a.createElement(av, {
      componentMeasure: l
    }) : null !== f ? g = a.createElement(ov, {
      nativeEvent: f
    }) : null !== d ? g = a.createElement(sv, {
      networkMeasure: d
    }) : null !== v ? g = a.createElement(lv, {
      data: r,
      schedulingEvent: v
    }) : null !== h ? g = a.createElement(cv, {
      height: t,
      snapshot: h,
      width: o
    }) : null !== m ? g = a.createElement(uv, {
      suspenseEvent: m
    }) : null !== u ? g = a.createElement(fv, {
      data: r,
      measure: u
    }) : null !== c ? g = a.createElement(iv, {
      stackFrame: c
    }) : null !== p ? g = a.createElement(dv, {
      mark: p
    }) : null !== _ && (g = a.createElement(vv, {
      thrownError: _
    })), null !== g ? a.createElement("div", {
      className: tv.a.Tooltip,
      ref: s
    }, g) : null;
  }
  const av = ({
      componentMeasure: e
    }) => {
      const {
        componentName: r,
        duration: t,
        timestamp: n,
        type: i,
        warning: o
      } = e;
      let s = r;
      switch (i) {
        case "render":
          s += " rendered";
          break;
        case "layout-effect-mount":
          s += " mounted layout effect";
          break;
        case "layout-effect-unmount":
          s += " unmounted layout effect";
          break;
        case "passive-effect-mount":
          s += " mounted passive effect";
          break;
        case "passive-effect-unmount":
          s += " unmounted passive effect";
      }
      return a.createElement(a.Fragment, null, a.createElement("div", {
        className: tv.a.TooltipSection
      }, md(s, 768), a.createElement("div", {
        className: tv.a.Divider
      }), a.createElement("div", {
        className: tv.a.DetailsGrid
      }, a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Timestamp:"), a.createElement("div", null, vd(n)), a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Duration:"), a.createElement("div", null, hd(t)))), null !== o && a.createElement("div", {
        className: tv.a.TooltipWarningSection
      }, a.createElement("div", {
        className: tv.a.WarningText
      }, o)));
    },
    iv = ({
      stackFrame: e
    }) => {
      const {
        name: r,
        timestamp: t,
        duration: n,
        locationLine: i,
        locationColumn: o
      } = e;
      return a.createElement("div", {
        className: tv.a.TooltipSection
      }, a.createElement("span", {
        className: tv.a.FlamechartStackFrameName
      }, r), a.createElement("div", {
        className: tv.a.DetailsGrid
      }, a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Timestamp:"), a.createElement("div", null, vd(t)), a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Duration:"), a.createElement("div", null, hd(n)), (void 0 !== i || void 0 !== o) && a.createElement(a.Fragment, null, a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Location:"), a.createElement("div", null, "line ", i, ", column ", o))));
    },
    ov = ({
      nativeEvent: e
    }) => {
      const {
        duration: r,
        timestamp: t,
        type: n,
        warning: i
      } = e;
      return a.createElement(a.Fragment, null, a.createElement("div", {
        className: tv.a.TooltipSection
      }, a.createElement("span", {
        className: tv.a.NativeEventName
      }, md(n, 768)), "event", a.createElement("div", {
        className: tv.a.Divider
      }), a.createElement("div", {
        className: tv.a.DetailsGrid
      }, a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Timestamp:"), a.createElement("div", null, vd(t)), a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Duration:"), a.createElement("div", null, hd(r)))), null !== i && a.createElement("div", {
        className: tv.a.TooltipWarningSection
      }, a.createElement("div", {
        className: tv.a.WarningText
      }, i)));
    },
    sv = ({
      networkMeasure: e
    }) => {
      const {
        finishTimestamp: r,
        lastReceivedDataTimestamp: t,
        priority: n,
        sendRequestTimestamp: i,
        url: o
      } = e;
      let s = o;
      if (s.length > 60) {
        const e = Math.floor(30);
        s = o.substr(0, e) + "\u2026" + o.substr(o.length - e);
      }
      const l = (r || t) > 0 ? hd(r - i) : "(incomplete)";
      return a.createElement("div", {
        className: tv.a.SingleLineTextSection
      }, l, " ", a.createElement("span", {
        className: tv.a.DimText
      }, n), " ", s);
    },
    lv = ({
      data: e,
      schedulingEvent: r
    }) => {
      const t = _d(r);
      if (!t) return null;
      let n = null,
        i = null;
      switch (r.type) {
        case "schedule-render":
        case "schedule-state-update":
        case "schedule-force-update":
          i = r.lanes, n = i.map(r => e.laneToLabelMap.get(r));
      }
      const {
        componentName: o,
        timestamp: s,
        warning: l
      } = r;
      return a.createElement(a.Fragment, null, a.createElement("div", {
        className: tv.a.TooltipSection
      }, o && a.createElement("span", {
        className: tv.a.ComponentName
      }, md(o, 100)), t, a.createElement("div", {
        className: tv.a.Divider
      }), a.createElement("div", {
        className: tv.a.DetailsGrid
      }, null !== n && null !== i && a.createElement(a.Fragment, null, a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Lanes:"), a.createElement("div", null, n.join(", "), " (", i.join(", "), ")")), a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Timestamp:"), a.createElement("div", null, vd(s)))), null !== l && a.createElement("div", {
        className: tv.a.TooltipWarningSection
      }, a.createElement("div", {
        className: tv.a.WarningText
      }, l)));
    },
    cv = ({
      height: e,
      snapshot: r,
      width: t
    }) => {
      const n = r.width / r.height;
      let i = r.width,
        o = r.height;
      return i > t && (i = t, o = i / n), o > e && (o = e, i = o * n), a.createElement("img", {
        className: tv.a.Image,
        src: r.imageSource,
        style: {
          height: o,
          width: i
        }
      });
    },
    uv = ({
      suspenseEvent: e
    }) => {
      const {
        componentName: r,
        duration: t,
        phase: n,
        promiseName: i,
        resolution: o,
        timestamp: s,
        warning: l
      } = e;
      let c = "suspended";
      return null !== n && (c += " during " + n), a.createElement(a.Fragment, null, a.createElement("div", {
        className: tv.a.TooltipSection
      }, r && a.createElement("span", {
        className: tv.a.ComponentName
      }, md(r, 100)), c, a.createElement("div", {
        className: tv.a.Divider
      }), a.createElement("div", {
        className: tv.a.DetailsGrid
      }, null !== i && a.createElement(a.Fragment, null, a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Resource:"), a.createElement("div", {
        className: tv.a.DetailsGridLongValue
      }, i)), a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Status:"), a.createElement("div", null, o), a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Timestamp:"), a.createElement("div", null, vd(s)), null !== t && a.createElement(a.Fragment, null, a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Duration:"), a.createElement("div", null, hd(t))))), null !== l && a.createElement("div", {
        className: tv.a.TooltipWarningSection
      }, a.createElement("div", {
        className: tv.a.WarningText
      }, l)));
    },
    fv = ({
      data: e,
      measure: r
    }) => {
      const t = function (e) {
        switch (e) {
          case "commit":
            return "react commit";
          case "render-idle":
            return "react idle";
          case "render":
            return "react render";
          case "layout-effects":
            return "react layout effects";
          case "passive-effects":
            return "react passive effects";
          default:
            return null;
        }
      }(r.type);
      if (!t) return null;
      const {
          batchUID: n,
          duration: i,
          timestamp: o,
          lanes: s
        } = r,
        [l, c] = ev(n, e),
        u = s.map(r => e.laneToLabelMap.get(r));
      return a.createElement("div", {
        className: tv.a.TooltipSection
      }, a.createElement("span", {
        className: tv.a.ReactMeasureLabel
      }, t), a.createElement("div", {
        className: tv.a.Divider
      }), a.createElement("div", {
        className: tv.a.DetailsGrid
      }, a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Timestamp:"), a.createElement("div", null, vd(o)), "render-idle" !== r.type && a.createElement(a.Fragment, null, a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Duration:"), a.createElement("div", null, hd(i))), a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Batch duration:"), a.createElement("div", null, hd(c - l)), a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Lane", 1 === s.length ? "" : "s", ":"), a.createElement("div", null, u.length > 0 ? `${u.join(", ")} (${s.join(", ")})` : s.join(", "))));
    },
    dv = ({
      mark: e
    }) => {
      const {
        name: r,
        timestamp: t
      } = e;
      return a.createElement("div", {
        className: tv.a.TooltipSection
      }, a.createElement("span", {
        className: tv.a.UserTimingLabel
      }, r), a.createElement("div", {
        className: tv.a.Divider
      }), a.createElement("div", {
        className: tv.a.DetailsGrid
      }, a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Timestamp:"), a.createElement("div", null, vd(t))));
    },
    vv = ({
      thrownError: e
    }) => {
      const {
          componentName: r,
          message: t,
          phase: n,
          timestamp: i
        } = e,
        o = "threw an error during " + n;
      return a.createElement("div", {
        className: tv.a.TooltipSection
      }, r && a.createElement("span", {
        className: tv.a.ComponentName
      }, md(r, 100)), a.createElement("span", {
        className: tv.a.UserTimingLabel
      }, o), a.createElement("div", {
        className: tv.a.Divider
      }), a.createElement("div", {
        className: tv.a.DetailsGrid
      }, a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Timestamp:"), a.createElement("div", null, vd(i)), "" !== t && a.createElement(a.Fragment, null, a.createElement("div", {
        className: tv.a.DetailsGridLabel
      }, "Error:"), a.createElement("div", null, t))));
    },
    hv = [];
  function mv(e, r) {
    let {
      searchIndex: t,
      searchRegExp: n,
      searchResults: a,
      searchText: i
    } = e;
    switch (r.type) {
      case "GO_TO_NEXT_SEARCH_RESULT":
        a.length > 0 && (-1 === t || t + 1 === a.length ? t = 0 : t++);
        break;
      case "GO_TO_PREVIOUS_SEARCH_RESULT":
        a.length > 0 && (-1 === t || 0 === t ? t = a.length - 1 : t--);
        break;
      case "SET_SEARCH_TEXT":
        if (i = r.payload, n = null, a = [], "" !== i) {
          const r = i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          n = new RegExp("^" + r, "i");
          let o = null;
          t >= 0 && a.length > t && (o = a[t]);
          const s = e.profilerData.componentMeasures;
          let l = -1;
          for (let e = 0; e < s.length; e++) {
            const r = s[e];
            r.componentName.match(n) && (a.push(r), r === o && (l = a.length - 1));
          }
          t = l >= 0 ? l : 0;
        }
    }
    return {
      profilerData: e.profilerData,
      searchIndex: t,
      searchRegExp: n,
      searchResults: a,
      searchText: i
    };
  }
  const _v = Object(a.createContext)(null);
  function pv({
    children: e,
    profilerData: r,
    viewState: t
  }) {
    const [n, i] = Object(a.useReducer)(mv, {
        profilerData: r,
        searchIndex: -1,
        searchRegExp: null,
        searchResults: hv,
        searchText: ""
      }),
      o = Object(a.useMemo)(() => ({
        ...n,
        dispatch: i
      }), [n]);
    return a.createElement(_v.Provider, {
      value: o
    }, e);
  }
  _v.displayName = "TimelineSearchContext";
  var gv = t(103),
    bv = t.n(gv);
  const Sv = {
    componentMeasure: null,
    flamechartStackFrame: null,
    measure: null,
    nativeEvent: null,
    networkMeasure: null,
    schedulingEvent: null,
    snapshot: null,
    suspenseEvent: null,
    thrownError: null,
    userTimingMark: null
  };
  function Ev({
    data: e,
    height: r,
    viewState: t,
    width: n
  }) {
    const i = Object(a.useRef)(null),
      [o, s] = Object(a.useState)(!1),
      [l, c] = Object(a.useState)(bf),
      [u, f] = Object(a.useState)(null),
      d = Object(a.useCallback)(() => f(Sv), []),
      {
        searchIndex: v,
        searchRegExp: h,
        searchResults: m
      } = Object(a.useContext)(_v);
    Object(a.useLayoutEffect)(() => {
      t.updateSearchRegExpState(h);
      const r = m.length > 0 ? m[v] : null;
      if (null != r) {
        const a = Uf({
          state: t.horizontalScrollState,
          rangeStart: r.timestamp,
          rangeEnd: r.timestamp + r.duration,
          contentLength: e.duration,
          minContentLength: 0.25 * e.duration,
          maxContentLength: 1000 * e.duration,
          containerLength: n
        });
        t.updateHorizontalScrollState(a);
      }
      _.current.displayIfNeeded();
    }, [v, h, m, t]);
    const _ = Object(a.useRef)(new Of(d)),
      p = Object(a.useRef)(null),
      g = Object(a.useRef)(null),
      b = Object(a.useRef)(null),
      S = Object(a.useRef)(null),
      E = Object(a.useRef)(null),
      w = Object(a.useRef)(null),
      y = Object(a.useRef)(null),
      k = Object(a.useRef)(null),
      C = Object(a.useRef)(null),
      D = Object(a.useRef)(null),
      {
        hideMenu: A
      } = Object(a.useContext)(ul);
    Object(a.useLayoutEffect)(() => {
      const a = _.current,
        o = {
          origin: bf,
          size: {
            width: n,
            height: r
          }
        };
      function s(r, n, s = !1, l = !1) {
        let c = null;
        s && (c = new Xf(a, o, r, t, n));
        const u = new $f(a, o, null !== c ? c : r, e.duration, t);
        let f = null;
        return l && (f = new Jf(a, o, u, t, i, n)), f || u;
      }
      t.onHorizontalScrollStateChange(e => {
        A();
      }), t.updateHorizontalScrollState(jf({
        state: t.horizontalScrollState,
        minContentLength: 0.25 * e.duration,
        maxContentLength: 1000 * e.duration,
        containerLength: o.size.width
      }));
      const l = s(new Qd(a, o, e.duration), "time");
      let c = null;
      if (e.otherUserTimingMarks.length > 0) {
        const r = new Jd(a, o, e.otherUserTimingMarks, e.duration);
        p.current = r, c = s(r, "user timing api");
      }
      let u = null;
      if (e.nativeEvents.length > 0) {
        const r = new Nd(a, o, e);
        g.current = r, u = s(r, "events", !0, !0);
      }
      let f = null;
      if (e.thrownErrors.length > 0) {
        const r = new Kd(a, o, e);
        D.current = r, f = s(r, "thrown errors");
      }
      let d = null;
      if (e.schedulingEvents.length > 0) {
        const r = new jd(a, o, e);
        b.current = r, d = s(r, "react updates");
      }
      let v = null;
      if (e.suspenseEvents.length > 0) {
        const r = new Xd(a, o, e);
        S.current = r, v = s(r, "suspense", !0, !0);
      }
      const h = new zd(a, o, e);
      w.current = h;
      const m = s(h, "react scheduling", !0, !0);
      let M = null;
      if (e.componentMeasures.length > 0) {
        const r = new bd(a, o, e, t);
        E.current = r, M = s(r, "react components");
      }
      let x = null;
      if (e.snapshots.length > 0) {
        const r = new Ud(a, o, e);
        C.current = r, x = s(r, "snapshots", !0, !0);
      }
      let O = null;
      if (e.snapshots.length > 0) {
        const r = new Fd(a, o, e);
        k.current = r, O = s(r, "network", !0, !0);
      }
      let T = null;
      if (e.flamechart.length > 0) {
        const r = new xd(a, o, e.flamechart, e.internalModuleSourceToRanges, e.duration);
        y.current = r, T = s(r, "flamechart", !0, !0);
      }
      const N = new Ff(a, o, If, o, hf.BACKGROUND);
      N.addSubview(l), null !== c && N.addSubview(c), null !== u && N.addSubview(u), null !== d && N.addSubview(d), null !== f && N.addSubview(f), null !== v && N.addSubview(v), null !== m && N.addSubview(m), null !== M && N.addSubview(M), null !== x && N.addSubview(x), null !== O && N.addSubview(O), null !== T && N.addSubview(T);
      const R = new ad(a, o, N, t);
      _.current.rootView = R;
    }, [e]), Object(a.useLayoutEffect)(() => {
      i.current && _.current.setCanvas(i.current, {
        width: n,
        height: r
      });
    }, [n, r]);
    const M = Object(a.useCallback)(e => {
      const r = i.current;
      if (null === r) return;
      const t = _.current;
      t.handleInteraction(e), t.displayIfNeeded(), r.style.cursor = t.getCurrentCursor() || "default", c({
        x: e.payload.event.x,
        y: e.payload.event.y
      });
    }, []);
    rd(i, M), jl({
      data: {
        data: e,
        hoveredEvent: u
      },
      id: "canvas",
      onChange: s,
      ref: i
    });
    const {
      selectEvent: x
    } = Object(a.useContext)(bu);
    return Object(a.useEffect)(() => {
      const {
        current: e
      } = p;
      e && (e.onHover = e => {
        u && u.userTimingMark === e || f({
          ...Sv,
          userTimingMark: e
        });
      });
      const {
        current: r
      } = g;
      r && (r.onHover = e => {
        u && u.nativeEvent === e || f({
          ...Sv,
          nativeEvent: e
        });
      });
      const {
        current: t
      } = b;
      t && (t.onHover = e => {
        u && u.schedulingEvent === e || f({
          ...Sv,
          schedulingEvent: e
        });
      }, t.onClick = e => {
        x({
          ...Sv,
          schedulingEvent: e
        });
      });
      const {
        current: n
      } = S;
      n && (n.onHover = e => {
        u && u.suspenseEvent === e || f({
          ...Sv,
          suspenseEvent: e
        });
      });
      const {
        current: a
      } = w;
      a && (a.onHover = e => {
        u && u.measure === e || f({
          ...Sv,
          measure: e
        });
      });
      const {
        current: i
      } = E;
      i && (i.onHover = e => {
        u && u.componentMeasure === e || f({
          ...Sv,
          componentMeasure: e
        });
      });
      const {
        current: o
      } = C;
      o && (o.onHover = e => {
        u && u.snapshot === e || f({
          ...Sv,
          snapshot: e
        });
      });
      const {
        current: s
      } = y;
      s && s.setOnHover(e => {
        u && u.flamechartStackFrame === e || f({
          ...Sv,
          flamechartStackFrame: e
        });
      });
      const {
        current: l
      } = k;
      l && (l.onHover = e => {
        u && u.networkMeasure === e || f({
          ...Sv,
          networkMeasure: e
        });
      });
      const {
        current: c
      } = D;
      c && (c.onHover = e => {
        u && u.thrownError === e || f({
          ...Sv,
          thrownError: e
        });
      });
    }, [u, e]), Object(a.useLayoutEffect)(() => {
      const e = p.current;
      e && e.setHoveredMark(u ? u.userTimingMark : null);
      const r = g.current;
      r && r.setHoveredEvent(u ? u.nativeEvent : null);
      const t = b.current;
      t && t.setHoveredEvent(u ? u.schedulingEvent : null);
      const n = S.current;
      n && n.setHoveredEvent(u ? u.suspenseEvent : null);
      const a = w.current;
      a && a.setHoveredMeasure(u ? u.measure : null);
      const i = y.current;
      i && i.setHoveredFlamechartStackFrame(u ? u.flamechartStackFrame : null);
      const o = k.current;
      o && o.setHoveredEvent(u ? u.networkMeasure : null);
    }, [u]), Object(a.useLayoutEffect)(() => {
      _.current.displayIfNeeded();
    }), a.createElement(a.Fragment, null, a.createElement("canvas", {
      ref: i,
      height: r,
      width: n
    }), a.createElement(hl, {
      id: "canvas"
    }, e => {
      if (null == e.hoveredEvent) return null;
      const {
        componentMeasure: r,
        flamechartStackFrame: i,
        measure: o,
        networkMeasure: s,
        schedulingEvent: l,
        suspenseEvent: c
      } = e.hoveredEvent;
      return a.createElement(a.Fragment, null, null !== r && a.createElement(pl, {
        onClick: () => Object(ar.copy)(r.componentName),
        title: "Copy component name"
      }, "Copy component name"), null !== s && a.createElement(pl, {
        onClick: () => Object(ar.copy)(s.url),
        title: "Copy URL"
      }, "Copy URL"), null !== l && a.createElement(pl, {
        onClick: () => Object(ar.copy)(l.componentName),
        title: "Copy component name"
      }, "Copy component name"), null !== c && a.createElement(pl, {
        onClick: () => Object(ar.copy)(c.componentName),
        title: "Copy component name"
      }, "Copy component name"), null !== o && a.createElement(pl, {
        onClick: () => ((e, r, t, n) => {
          const {
              batchUID: a
            } = r,
            [i, o] = ev(a, e),
            s = Uf({
              state: t.horizontalScrollState,
              rangeStart: i,
              rangeEnd: o,
              contentLength: e.duration,
              minContentLength: 0.25 * e.duration,
              maxContentLength: 1000 * e.duration,
              containerLength: n
            });
          t.updateHorizontalScrollState(s);
        })(e.data, o, t, n),
        title: "Zoom to batch"
      }, "Zoom to batch"), null !== o && a.createElement(pl, {
        onClick: () => ((e, r) => {
          const {
              batchUID: t,
              duration: n,
              timestamp: a,
              type: i
            } = r,
            [o, s] = ev(t, e);
          Object(ar.copy)(JSON.stringify({
            type: i,
            timestamp: _f()(a),
            duration: _f()(n),
            batchDuration: _f()(s - o)
          }));
        })(e.data, o),
        title: "Copy summary"
      }, "Copy summary"), null !== i && a.createElement(pl, {
        onClick: () => Object(ar.copy)(i.scriptUrl),
        title: "Copy file path"
      }, "Copy file path"), null !== i && a.createElement(pl, {
        onClick: () => {
          var e, r;
          return Object(ar.copy)(`line ${null !== (e = i.locationLine) && void 0 !== e ? e : ""}, column ${null !== (r = i.locationColumn) && void 0 !== r ? r : ""}`);
        },
        title: "Copy location"
      }, "Copy location"));
    }), !o && !_.current.hasActiveView() && a.createElement(nv, {
      canvasRef: i,
      data: e,
      height: r,
      hoveredEvent: u,
      origin: l,
      width: n
    }));
  }
  var wv = function ({
      profilerData: e,
      viewState: r
    }) {
      return a.createElement("div", {
        className: bv.a.CanvasPage,
        style: {
          backgroundColor: hf.BACKGROUND
        }
      }, a.createElement(pt, null, ({
        height: t,
        width: n
      }) => a.createElement(Ev, {
        data: e,
        height: t,
        viewState: r,
        width: n
      })));
    },
    yv = (t(184), t(72));
  class kv extends Error {}
  var Cv = t(66),
    Dv = t.n(Cv);
  const Av = "An event handler scheduled a big update with React. Consider using the Transition API to defer some of this work.",
    Mv = "A component suspended during an update which caused a fallback to be shown. Consider using the Transition API to avoid hiding components after they've been mounted.";
  function xv(e) {
    const r = parseInt(e, 10);
    if (r < 0) return [];
    const t = [];
    let n = 0;
    for (; n <= 31;) 1 << n & r && t.push(n), n++;
    return t;
  }
  let Ov = null;
  function Tv(e, r, t, n, a) {
    const {
        batchUID: i,
        measureStack: o
      } = a,
      s = function (e) {
        if (e.length > 0) {
          const {
            depth: r,
            type: t
          } = e[e.length - 1];
          return "render-idle" === t ? r : r + 1;
        }
        return 0;
      }(o),
      l = {
        type: e,
        batchUID: i,
        depth: s,
        lanes: t,
        timestamp: r,
        duration: 0
      };
    a.measureStack.push({
      depth: s,
      measure: l,
      startTime: r,
      type: e
    });
    const c = n.batchUIDToMeasuresMap.get(i);
    null != c ? c.push(l) : n.batchUIDToMeasuresMap.set(a.batchUID, [l]), t.forEach(e => {
      n.laneToReactMeasureMap.get(e).push(l);
    });
  }
  function Nv(e, r, t, n) {
    if (0 === n.length) return void console.error("Unexpected type \"%s\" completed at %sms while stack is empty.", e, r);
    const a = n[n.length - 1];
    a.type !== e && console.error("Unexpected type \"%s\" completed at %sms before \"%s\" completed.", e, r, a.type);
    const {
      measure: i,
      startTime: o
    } = n.pop();
    i || console.error("Could not find matching measure for type \"%s\".", e), i.duration = r - o;
  }
  function Rv(e, r, t) {
    const {
        cat: n,
        name: a,
        ts: i,
        ph: o
      } = e,
      s = (i - r.startTime) / 1000;
    switch (n) {
      case "disabled-by-default-devtools.screenshot":
        !function (e, r, t, n) {
          const a = {
            height: 0,
            image: null,
            imageSource: "data:image/png;base64," + e.args.snapshot,
            timestamp: r,
            width: 0
          };
          let i = null;
          n.asyncProcessingPromises.push(new Promise(e => {
            i = e;
          })), fetch(a.imageSource).then(e => e.blob()).then(e => {
            createImageBitmap(e).then(e => {
              a.height = e.height, a.width = e.width, i();
            });
          }), t.snapshots.push(a);
        }(e, s, r, t);
        break;
      case "devtools.timeline":
        switch (a) {
          case "EventDispatch":
            !function (e, r, t, n) {
              const a = e.args.data,
                i = a.type;
              if (i.startsWith("react-")) {
                const e = a.stackTrace;
                if (e) {
                  if (e[e.length - 1].url.includes("/react-dom.")) return;
                }
              }
              if ("blur" === i || "click" === i || "input" === i || i.startsWith("focus") || i.startsWith("key") || i.startsWith("mouse") || i.startsWith("pointer")) {
                const a = e.dur / 1000;
                let o = 0;
                for (; n.nativeEventStack.length > 0;) {
                  const e = n.nativeEventStack[n.nativeEventStack.length - 1];
                  if (r < e.timestamp + e.duration) {
                    o = e.depth + 1;
                    break;
                  }
                  n.nativeEventStack.pop();
                }
                const s = {
                  depth: o,
                  duration: a,
                  timestamp: r,
                  type: i,
                  warning: null
                };
                t.nativeEvents.push(s), n.nativeEventStack.push(s);
              }
            }(e, s, r, t);
            break;
          case "ResourceFinish":
            !function (e, r, t, n) {
              const a = e.args.data.requestId,
                i = n.requestIdToNetworkMeasureMap.get(a);
              null != i && (i.finishTimestamp = r, 0 === i.firstReceivedDataTimestamp && (i.firstReceivedDataTimestamp = r), 0 === i.lastReceivedDataTimestamp && (i.lastReceivedDataTimestamp = r), n.requestIdToNetworkMeasureMap.delete(e.args.data.requestId));
            }(e, s, 0, t);
            break;
          case "ResourceReceivedData":
            !function (e, r, t, n) {
              const a = e.args.data.requestId,
                i = n.requestIdToNetworkMeasureMap.get(a);
              null != i && (0 === i.firstReceivedDataTimestamp && (i.firstReceivedDataTimestamp = r), i.lastReceivedDataTimestamp = r, i.finishTimestamp = r);
            }(e, s, 0, t);
            break;
          case "ResourceReceiveResponse":
            !function (e, r, t, n) {
              const a = e.args.data.requestId,
                i = n.requestIdToNetworkMeasureMap.get(a);
              null != i && (i.receiveResponseTimestamp = r);
            }(e, s, 0, t);
            break;
          case "ResourceSendRequest":
            !function (e, r, t, n) {
              const a = e.args.data,
                i = a.requestId,
                o = new Array(n.requestIdToNetworkMeasureMap.size + 1).fill(!0);
              n.requestIdToNetworkMeasureMap.forEach(({
                depth: e
              }) => {
                o[e] = !1;
              });
              let s = 0;
              for (let e = 0; e < o.length; e++) if (o[e]) {
                s = e;
                break;
              }
              const l = {
                depth: s,
                finishTimestamp: 0,
                firstReceivedDataTimestamp: 0,
                lastReceivedDataTimestamp: 0,
                requestId: i,
                requestMethod: a.requestMethod,
                priority: a.priority,
                sendRequestTimestamp: r,
                receiveResponseTimestamp: 0,
                url: a.url
              };
              n.requestIdToNetworkMeasureMap.set(i, l), t.networkMeasures.push(l), l.sendRequestTimestamp = r;
            }(e, s, r, t);
        }
        break;
      case "blink.user_timing":
        if (a.startsWith("--react-version-")) {
          const [e] = a.substr(16).split("-");
          r.reactVersion = e;
        } else if (a.startsWith("--profiler-version-")) {
          const [e] = a.substr(19).split("-");
          if (Ov = parseInt(e, 10), 1 !== Ov) throw new kv(`This version of profiling data (${e}) is not supported by the current profiler.`);
        } else if (a.startsWith("--react-lane-labels-")) {
          const [e] = a.substr(20).split("-");
          !function (e, r) {
            if (0 === e.laneToLabelMap.size) {
              const t = r.split(",");
              for (let r = 0; r < t.length; r++) e.laneToLabelMap.set(r, t[r]);
            }
          }(r, e);
        } else if (a.startsWith("--component-")) !function (e, r, t, n) {
          if (e.startsWith("--component-render-start-")) {
            const [t] = e.substr(25).split("-");
            Iv(n), n.currentReactComponentMeasure = {
              componentName: t,
              timestamp: r,
              duration: 0,
              type: "render",
              warning: null
            };
          } else if ("--component-render-stop" === e) {
            if (Hv(n, "render"), null !== n.currentReactComponentMeasure) {
              const e = n.currentReactComponentMeasure;
              e.duration = r - e.timestamp, n.currentReactComponentMeasure = null, t.componentMeasures.push(e);
            }
          } else if (e.startsWith("--component-layout-effect-mount-start-")) {
            const [t] = e.substr(38).split("-");
            Iv(n), n.currentReactComponentMeasure = {
              componentName: t,
              timestamp: r,
              duration: 0,
              type: "layout-effect-mount",
              warning: null
            };
          } else if ("--component-layout-effect-mount-stop" === e) {
            if (Hv(n, "layout-effect-mount"), null !== n.currentReactComponentMeasure) {
              const e = n.currentReactComponentMeasure;
              e.duration = r - e.timestamp, n.currentReactComponentMeasure = null, t.componentMeasures.push(e);
            }
          } else if (e.startsWith("--component-layout-effect-unmount-start-")) {
            const [t] = e.substr(40).split("-");
            Iv(n), n.currentReactComponentMeasure = {
              componentName: t,
              timestamp: r,
              duration: 0,
              type: "layout-effect-unmount",
              warning: null
            };
          } else if ("--component-layout-effect-unmount-stop" === e) {
            if (Hv(n, "layout-effect-unmount"), null !== n.currentReactComponentMeasure) {
              const e = n.currentReactComponentMeasure;
              e.duration = r - e.timestamp, n.currentReactComponentMeasure = null, t.componentMeasures.push(e);
            }
          } else if (e.startsWith("--component-passive-effect-mount-start-")) {
            const [t] = e.substr(39).split("-");
            Iv(n), n.currentReactComponentMeasure = {
              componentName: t,
              timestamp: r,
              duration: 0,
              type: "passive-effect-mount",
              warning: null
            };
          } else if ("--component-passive-effect-mount-stop" === e) {
            if (Hv(n, "passive-effect-mount"), null !== n.currentReactComponentMeasure) {
              const e = n.currentReactComponentMeasure;
              e.duration = r - e.timestamp, n.currentReactComponentMeasure = null, t.componentMeasures.push(e);
            }
          } else if (e.startsWith("--component-passive-effect-unmount-start-")) {
            const [t] = e.substr(41).split("-");
            Iv(n), n.currentReactComponentMeasure = {
              componentName: t,
              timestamp: r,
              duration: 0,
              type: "passive-effect-unmount",
              warning: null
            };
          } else if ("--component-passive-effect-unmount-stop" === e && (Hv(n, "passive-effect-unmount"), null !== n.currentReactComponentMeasure)) {
            const e = n.currentReactComponentMeasure;
            e.duration = r - e.timestamp, n.currentReactComponentMeasure = null, t.componentMeasures.push(e);
          }
        }(a, s, r, t);else if (a.startsWith("--schedule-render-")) {
          const [e] = a.substr(18).split("-");
          r.schedulingEvents.push({
            type: "schedule-render",
            lanes: xv(e),
            timestamp: s,
            warning: null
          });
        } else if (a.startsWith("--schedule-forced-update-")) {
          const [e, n] = a.substr(25).split("-"),
            i = {
              type: "schedule-force-update",
              lanes: xv(e),
              componentName: n,
              timestamp: s,
              warning: null
            };
          t.measureStack.find(({
            type: e
          }) => "commit" === e) && (t.potentialLongNestedUpdate = i), r.schedulingEvents.push(i);
        } else if (a.startsWith("--schedule-state-update-")) {
          const [e, n] = a.substr(24).split("-"),
            i = {
              type: "schedule-state-update",
              lanes: xv(e),
              componentName: n,
              timestamp: s,
              warning: null
            };
          t.measureStack.find(({
            type: e
          }) => "commit" === e) && (t.potentialLongNestedUpdate = i), r.schedulingEvents.push(i);
        } else if (a.startsWith("--error-")) {
          const [e, t, n] = a.substr(8).split("-");
          r.thrownErrors.push({
            componentName: e,
            message: n,
            phase: t,
            timestamp: s,
            type: "thrown-error"
          });
        } else if (a.startsWith("--suspense-suspend-")) {
          const [e, n, i, o, l] = a.substr(19).split("-"),
            c = xv(o),
            u = new Array(t.unresolvedSuspenseEvents.size + 1).fill(!0);
          t.unresolvedSuspenseEvents.forEach(({
            depth: e
          }) => {
            u[e] = !1;
          });
          let f = 0;
          for (let e = 0; e < u.length; e++) if (u[e]) {
            f = e;
            break;
          }
          const d = {
            componentName: n,
            depth: f,
            duration: null,
            id: e,
            phase: i,
            promiseName: l || null,
            resolution: "unresolved",
            timestamp: s,
            type: "suspense",
            warning: null
          };
          "update" === i && t.potentialSuspenseEventsOutsideOfTransition.push([d, c]), r.suspenseEvents.push(d), t.unresolvedSuspenseEvents.set(e, d);
        } else if (a.startsWith("--suspense-resolved-")) {
          const [e] = a.substr(20).split("-"),
            r = t.unresolvedSuspenseEvents.get(e);
          null != r && (t.unresolvedSuspenseEvents.delete(e), r.duration = s - r.timestamp, r.resolution = "resolved");
        } else if (a.startsWith("--suspense-rejected-")) {
          const [e] = a.substr(20).split("-"),
            r = t.unresolvedSuspenseEvents.get(e);
          null != r && (t.unresolvedSuspenseEvents.delete(e), r.duration = s - r.timestamp, r.resolution = "rejected");
        } else if (a.startsWith("--render-start-")) {
          t.nextRenderShouldGenerateNewBatchID && (t.nextRenderShouldGenerateNewBatchID = !1, t.batchUID = t.uidCounter++), null !== t.potentialLongNestedUpdate && (t.potentialLongNestedUpdates.push([t.potentialLongNestedUpdate, t.batchUID]), t.potentialLongNestedUpdate = null);
          const [e] = a.substr(15).split("-");
          !function (e, r) {
            const t = r.length - 1;
            if (t >= 0) {
              const n = r[t];
              if (void 0 === n.stopTime && n.type === e) throw new kv(`Unexpected type "${e}" started before "${n.type}" completed.`);
            }
          }("render", t.measureStack), "render-idle" !== function (e) {
            if (e.length > 0) {
              const {
                type: r
              } = e[e.length - 1];
              return r;
            }
            return null;
          }(t.measureStack) && Tv("render-idle", s, xv(e), r, t), Tv("render", s, xv(e), r, t);
          for (let e = 0; e < t.nativeEventStack.length; e++) {
            const r = t.nativeEventStack[e];
            r.timestamp + r.duration > s && t.potentialLongEvents.push([r, t.batchUID]);
          }
        } else if (a.startsWith("--render-stop") || a.startsWith("--render-yield")) Nv("render", s, 0, t.measureStack);else if (a.startsWith("--commit-start-")) {
          t.nextRenderShouldGenerateNewBatchID = !0;
          const [e] = a.substr(15).split("-");
          Tv("commit", s, xv(e), r, t);
        } else if (a.startsWith("--commit-stop")) Nv("commit", s, 0, t.measureStack), Nv("render-idle", s, 0, t.measureStack);else if (a.startsWith("--layout-effects-start-")) {
          const [e] = a.substr(23).split("-");
          Tv("layout-effects", s, xv(e), r, t);
        } else if (a.startsWith("--layout-effects-stop")) Nv("layout-effects", s, 0, t.measureStack);else if (a.startsWith("--passive-effects-start-")) {
          const [e] = a.substr(24).split("-");
          Tv("passive-effects", s, xv(e), r, t);
        } else if (a.startsWith("--passive-effects-stop")) Nv("passive-effects", s, 0, t.measureStack);else if (a.startsWith("--react-internal-module-start-")) {
          const e = a.substr(30);
          if (!t.internalModuleStackStringSet.has(e)) {
            t.internalModuleStackStringSet.add(e);
            const r = Fv(e);
            t.internalModuleCurrentStackFrame = r;
          }
        } else if (a.startsWith("--react-internal-module-stop-")) {
          const e = a.substr(29);
          if (!t.internalModuleStackStringSet.has(e)) {
            t.internalModuleStackStringSet.add(e);
            const n = Fv(e);
            if (null !== n && null !== t.internalModuleCurrentStackFrame) {
              const e = t.internalModuleCurrentStackFrame;
              t.internalModuleCurrentStackFrame = null;
              const a = [e, n],
                i = r.internalModuleSourceToRanges.get(e.fileName);
              null == i ? r.internalModuleSourceToRanges.set(e.fileName, [a]) : i.push(a);
            }
          }
        } else if ("R" === o || "n" === o) r.otherUserTimingMarks.push({
          name: a,
          timestamp: s
        });else if ("b" === o) ;else if ("e" === o) ;else if ("i" !== o && "I" !== o) throw new kv(`Unrecognized event ${JSON.stringify(e)}! This is likely a bug in this profiler tool.`);
    }
  }
  function Iv(e) {
    null !== e.currentReactComponentMeasure && console.error("Component measure started while another measure in progress:", e.currentReactComponentMeasure);
  }
  function Hv(e, r) {
    null === e.currentReactComponentMeasure ? console.error(`Component measure type "${r}" stopped while no measure was in progress`) : e.currentReactComponentMeasure.type !== r && console.error(`Component measure type "${r}" stopped while type ${e.currentReactComponentMeasure.type} in progress`);
  }
  function Fv(e) {
    const r = new Error();
    r.stack = e;
    const t = Dv.a.parse(r);
    return 1 === t.length ? t[0] : null;
  }
  async function Lv(e) {
    const r = function (e) {
        let r;
        try {
          r = Object(yv.importFromChromeTimeline)(e, "react-devtools");
        } catch (e) {
          const r = new kv(e.message);
          throw r.stack = e.stack, r;
        }
        const t = r.profiles[0];
        return new yv.Flamechart({
          getTotalWeight: t.getTotalWeight.bind(t),
          forEachCall: t.forEachCall.bind(t),
          formatValue: t.formatValue.bind(t),
          getColorBucketForFrame: () => 0
        }).getLayers().map(e => e.map(({
          start: e,
          end: r,
          node: {
            frame: {
              name: t,
              file: n,
              line: a,
              col: i
            }
          }
        }) => ({
          name: t,
          timestamp: e / 1000,
          duration: (r - e) / 1000,
          scriptUrl: n,
          locationLine: a,
          locationColumn: i
        })));
      }(e),
      t = new Map();
    for (let e = 0; e < 31; e++) t.set(e, []);
    const n = {
        batchUIDToMeasuresMap: new Map(),
        componentMeasures: [],
        duration: 0,
        flamechart: r,
        internalModuleSourceToRanges: new Map(),
        laneToLabelMap: new Map(),
        laneToReactMeasureMap: t,
        nativeEvents: [],
        networkMeasures: [],
        otherUserTimingMarks: [],
        reactVersion: null,
        schedulingEvents: [],
        snapshots: [],
        snapshotHeight: 0,
        startTime: 0,
        suspenseEvents: [],
        thrownErrors: []
      },
      a = (e = e.filter(Boolean).sort((e, r) => e.ts > r.ts ? 1 : -1)).findIndex(e => "Profile" === e.name);
    if (-1 === a) return n;
    n.startTime = e[a].args.data.startTime, n.duration = (e[e.length - 1].ts - n.startTime) / 1000;
    const i = {
      asyncProcessingPromises: [],
      batchUID: 0,
      currentReactComponentMeasure: null,
      internalModuleCurrentStackFrame: null,
      internalModuleStackStringSet: new Set(),
      measureStack: [],
      nativeEventStack: [],
      nextRenderShouldGenerateNewBatchID: !0,
      potentialLongEvents: [],
      potentialLongNestedUpdate: null,
      potentialLongNestedUpdates: [],
      potentialSuspenseEventsOutsideOfTransition: [],
      requestIdToNetworkMeasureMap: new Map(),
      uidCounter: 0,
      unresolvedSuspenseEvents: new Map()
    };
    if (e.forEach(e => Rv(e, n, i)), null === Ov) {
      if (0 === n.schedulingEvents.length && 0 === n.batchUIDToMeasuresMap.size) throw new kv("No React marks were found in the provided profile. Please provide profiling data from an React application running in development or profiling mode.");
      throw new kv("This version of profiling data is not supported by the current profiler.");
    }
    const {
      measureStack: o
    } = i;
    if (o.length > 0 && console.error("Incomplete events or measures", o), i.potentialLongEvents.forEach(([e, r]) => {
      const [t, a] = ev(r, n, e.timestamp);
      a - t > 20 && (e.warning = Av);
    }), i.potentialLongNestedUpdates.forEach(([e, r]) => {
      const [t, a] = ev(r, n);
      a - t > 20 && e.lanes.some(e => "Transition" === n.laneToLabelMap.get(e));
    }), i.potentialSuspenseEventsOutsideOfTransition.forEach(([e, r]) => {
      r.some(e => "Transition" === n.laneToLabelMap.get(e)) || (e.warning = Mv);
    }), await Promise.all(i.asyncProcessingPromises), n.snapshots.length > 0) {
      const e = n.snapshots[0];
      n.snapshotHeight = Math.min(e.height, 60);
    }
    return n;
  }
  var Pv = t(104),
    zv = t.n(Pv);
  async function Bv(e) {
    try {
      const r = await (e => {
          if (!e.name.endsWith(".json")) throw new kv("Invalid file type. Only JSON performance profiles are supported");
          const r = new FileReader();
          return new Promise((t, n) => {
            r.onload = () => {
              const e = zv()(r.result);
              "string" == typeof e && t(e), n(new kv("Input file was not read as a string"));
            }, r.onerror = () => n(r.error), r.readAsText(e);
          });
        })(e),
        t = JSON.parse(r);
      if (0 === t.length) throw new kv("No profiling data found in file.");
      return {
        status: "SUCCESS",
        processedData: await Lv(t)
      };
    } catch (e) {
      return e instanceof kv ? {
        status: "INVALID_PROFILE_ERROR",
        error: e
      } : {
        status: "UNEXPECTED_ERROR",
        error: e
      };
    }
  }
  var jv = t(105),
    Vv = t.n(jv);
  const Uv = window.Worker ? Vv()() : n,
    Wv = new Map();
  function $v(e) {
    const r = e.name;
    let t = Wv.get(r);
    if (!t) {
      const n = new Set(),
        a = () => {
          n.forEach(e => e()), n.clear();
        },
        i = t = {
          status: 0,
          value: {
            then(e) {
              n.add(e);
            },
            displayName: `Importing file "${r}"`
          }
        };
      (e => Uv.importFile(e))(e).then(e => {
        switch (e.status) {
          case "SUCCESS":
            const r = i;
            r.status = 1, r.value = e.processedData;
            break;
          case "INVALID_PROFILE_ERROR":
          case "UNEXPECTED_ERROR":
            const t = i;
            t.status = 2, t.value = e.error;
        }
        a();
      }), Wv.set(r, t);
    }
    return function (e) {
      if (1 === e.status) return e;
      if (2 === e.status) return e;
      throw e.value;
    }(t).value;
  }
  function Xv(e) {
    const {
        searchInputContainerRef: r
      } = Object(a.useContext)(bu),
      {
        dispatch: t,
        searchIndex: n,
        searchResults: o,
        searchText: s
      } = Object(a.useContext)(_v);
    if (null === r.current) return null;
    return Object(i.createPortal)(a.createElement(Yo, {
      goToNextResult: () => t({
        type: "GO_TO_NEXT_SEARCH_RESULT"
      }),
      goToPreviousResult: () => t({
        type: "GO_TO_PREVIOUS_SEARCH_RESULT"
      }),
      placeholder: "Search components by name",
      search: e => t({
        type: "SET_SEARCH_TEXT",
        payload: e
      }),
      searchIndex: n,
      searchResultsCount: o.length,
      searchText: s
    }), r.current);
  }
  var Gv = t(33),
    Kv = t.n(Gv);
  function Yv() {
    return a.createElement("div", {
      className: Kv.a.Column
    }, a.createElement("div", {
      className: Kv.a.Header
    }, "Timeline profiling not supported."), a.createElement("p", {
      className: Kv.a.Paragraph
    }, a.createElement("span", null, "Timeline profiler requires a development or profiling build of", " ", a.createElement("code", {
      className: Kv.a.Code
    }, "react-dom@^18"), ".")), a.createElement("div", {
      className: Kv.a.LearnMoreRow
    }, "Click", " ", a.createElement("a", {
      className: Kv.a.Link,
      href: "https://fb.me/react-devtools-profiling",
      rel: "noopener noreferrer",
      target: "_blank"
    }, "here"), " ", "to learn more about profiling."), Qe.g && a.createElement("div", {
      className: Kv.a.MetaGKRow
    }, a.createElement("strong", null, "Meta only"), ": Enable the", " ", a.createElement("a", {
      className: Kv.a.Link,
      href: "https://fburl.com/react-devtools-scheduling-profiler-gk",
      rel: "noopener noreferrer",
      target: "_blank"
    }, "react_enable_scheduling_profiler GK"), "."));
  }
  var qv = t(29),
    Qv = t.n(qv);
  function Zv(e) {
    const {
        file: r,
        inMemoryTimelineData: t,
        isTimelineSupported: n,
        setFile: i,
        viewState: o
      } = Object(a.useContext)(bu),
      {
        didRecordCommits: s,
        isProfiling: l
      } = Object(a.useContext)(tu),
      c = Object(a.useRef)(null),
      {
        theme: u
      } = Object(a.useContext)(En),
      f = Object(a.useDeferredValue)(u),
      [d, v] = Object(a.useState)(u);
    Object(a.useLayoutEffect)(() => {
      const e = setInterval(() => {
        (function (e) {
          const r = getComputedStyle(e);
          return null != r.getPropertyValue("--color-background") && (hf = {
            BACKGROUND: r.getPropertyValue("--color-background"),
            INTERNAL_MODULE_FRAME: r.getPropertyValue("--color-timeline-internal-module"),
            INTERNAL_MODULE_FRAME_HOVER: r.getPropertyValue("--color-timeline-internal-module-hover"),
            INTERNAL_MODULE_FRAME_TEXT: r.getPropertyValue("--color-timeline-internal-module-text"),
            NATIVE_EVENT: r.getPropertyValue("--color-timeline-native-event"),
            NATIVE_EVENT_HOVER: r.getPropertyValue("--color-timeline-native-event-hover"),
            NETWORK_PRIMARY: r.getPropertyValue("--color-timeline-network-primary"),
            NETWORK_PRIMARY_HOVER: r.getPropertyValue("--color-timeline-network-primary-hover"),
            NETWORK_SECONDARY: r.getPropertyValue("--color-timeline-network-secondary"),
            NETWORK_SECONDARY_HOVER: r.getPropertyValue("--color-timeline-network-secondary-hover"),
            PRIORITY_BACKGROUND: r.getPropertyValue("--color-timeline-priority-background"),
            PRIORITY_BORDER: r.getPropertyValue("--color-timeline-priority-border"),
            PRIORITY_LABEL: r.getPropertyValue("--color-text"),
            USER_TIMING: r.getPropertyValue("--color-timeline-user-timing"),
            USER_TIMING_HOVER: r.getPropertyValue("--color-timeline-user-timing-hover"),
            REACT_IDLE: r.getPropertyValue("--color-timeline-react-idle"),
            REACT_IDLE_HOVER: r.getPropertyValue("--color-timeline-react-idle-hover"),
            REACT_RENDER: r.getPropertyValue("--color-timeline-react-render"),
            REACT_RENDER_HOVER: r.getPropertyValue("--color-timeline-react-render-hover"),
            REACT_RENDER_TEXT: r.getPropertyValue("--color-timeline-react-render-text"),
            REACT_COMMIT: r.getPropertyValue("--color-timeline-react-commit"),
            REACT_COMMIT_HOVER: r.getPropertyValue("--color-timeline-react-commit-hover"),
            REACT_COMMIT_TEXT: r.getPropertyValue("--color-timeline-react-commit-text"),
            REACT_LAYOUT_EFFECTS: r.getPropertyValue("--color-timeline-react-layout-effects"),
            REACT_LAYOUT_EFFECTS_HOVER: r.getPropertyValue("--color-timeline-react-layout-effects-hover"),
            REACT_LAYOUT_EFFECTS_TEXT: r.getPropertyValue("--color-timeline-react-layout-effects-text"),
            REACT_PASSIVE_EFFECTS: r.getPropertyValue("--color-timeline-react-passive-effects"),
            REACT_PASSIVE_EFFECTS_HOVER: r.getPropertyValue("--color-timeline-react-passive-effects-hover"),
            REACT_PASSIVE_EFFECTS_TEXT: r.getPropertyValue("--color-timeline-react-passive-effects-text"),
            REACT_RESIZE_BAR: r.getPropertyValue("--color-resize-bar"),
            REACT_RESIZE_BAR_ACTIVE: r.getPropertyValue("--color-resize-bar-active"),
            REACT_RESIZE_BAR_BORDER: r.getPropertyValue("--color-resize-bar-border"),
            REACT_RESIZE_BAR_DOT: r.getPropertyValue("--color-resize-bar-dot"),
            REACT_SCHEDULE: r.getPropertyValue("--color-timeline-react-schedule"),
            REACT_SCHEDULE_HOVER: r.getPropertyValue("--color-timeline-react-schedule-hover"),
            REACT_SUSPENSE_REJECTED_EVENT: r.getPropertyValue("--color-timeline-react-suspense-rejected"),
            REACT_SUSPENSE_REJECTED_EVENT_HOVER: r.getPropertyValue("--color-timeline-react-suspense-rejected-hover"),
            REACT_SUSPENSE_RESOLVED_EVENT: r.getPropertyValue("--color-timeline-react-suspense-resolved"),
            REACT_SUSPENSE_RESOLVED_EVENT_HOVER: r.getPropertyValue("--color-timeline-react-suspense-resolved-hover"),
            REACT_SUSPENSE_UNRESOLVED_EVENT: r.getPropertyValue("--color-timeline-react-suspense-unresolved"),
            REACT_SUSPENSE_UNRESOLVED_EVENT_HOVER: r.getPropertyValue("--color-timeline-react-suspense-unresolved-hover"),
            REACT_THROWN_ERROR: r.getPropertyValue("--color-timeline-thrown-error"),
            REACT_THROWN_ERROR_HOVER: r.getPropertyValue("--color-timeline-thrown-error-hover"),
            REACT_WORK_BORDER: r.getPropertyValue("--color-timeline-react-work-border"),
            SCROLL_CARET: r.getPropertyValue("--color-scroll-caret"),
            SCRUBBER_BACKGROUND: r.getPropertyValue("--color-timeline-react-suspense-rejected"),
            SEARCH_RESULT_FILL: r.getPropertyValue("--color-timeline-react-suspense-rejected"),
            SCRUBBER_BORDER: r.getPropertyValue("--color-timeline-text-color"),
            TEXT_COLOR: r.getPropertyValue("--color-timeline-text-color"),
            TEXT_DIM_COLOR: r.getPropertyValue("--color-timeline-text-dim-color"),
            TIME_MARKER_LABEL: r.getPropertyValue("--color-text"),
            WARNING_BACKGROUND: r.getPropertyValue("--color-warning-background"),
            WARNING_BACKGROUND_HOVER: r.getPropertyValue("--color-warning-background-hover"),
            WARNING_TEXT: r.getPropertyValue("--color-warning-text-color"),
            WARNING_TEXT_INVERED: r.getPropertyValue("--color-warning-text-color-inverted")
          }, !0);
        })(c.current) && (clearInterval(e), v(f));
      }, 50);
      return () => {
        clearInterval(e);
      };
    }, [f]);
    let h = null;
    if (l) h = a.createElement(cf, null);else if (t && t.length > 0) {
      const e = t[0];
      h = a.createElement(pv, {
        profilerData: e,
        viewState: o
      }, a.createElement(Xv, null), a.createElement(wv, {
        profilerData: e,
        viewState: o
      }));
    } else h = r ? a.createElement(a.Suspense, {
      fallback: a.createElement(Jv, null)
    }, a.createElement(th, {
      file: r,
      key: d,
      onFileSelect: i,
      viewState: o
    })) : s ? a.createElement(rh, null) : n ? a.createElement(lf, null) : a.createElement(Yv, null);
    return a.createElement("div", {
      className: Qv.a.Content,
      ref: c
    }, h);
  }
  const Jv = () => a.createElement("div", {
      className: Qv.a.EmptyStateContainer
    }, a.createElement("div", {
      className: Qv.a.Header
    }, "Processing data..."), a.createElement("div", {
      className: Qv.a.Row
    }, "This should only take a minute.")),
    eh = ({
      error: e,
      onFileSelect: r
    }) => a.createElement("div", {
      className: Qv.a.EmptyStateContainer
    }, a.createElement("div", {
      className: Qv.a.Header
    }, "Could not load profile"), e.message && a.createElement("div", {
      className: Qv.a.Row
    }, a.createElement("div", {
      className: Qv.a.ErrorMessage
    }, e.message)), a.createElement("div", {
      className: Qv.a.Row
    }, "Try importing another Chrome performance profile.")),
    rh = () => a.createElement("div", {
      className: Qv.a.EmptyStateContainer
    }, a.createElement("div", {
      className: Qv.a.Row
    }, "This current profile does not contain timeline data.")),
    th = ({
      file: e,
      onFileSelect: r,
      viewState: t
    }) => {
      if (null === e) return null;
      const n = $v(e);
      return n instanceof Error ? a.createElement(eh, {
        error: n,
        onFileSelect: r
      }) : a.createElement(pv, {
        profilerData: n,
        viewState: t
      }, a.createElement(Xv, null), a.createElement(wv, {
        profilerData: n,
        viewState: t
      }));
    },
    nh = Object(a.createContext)(null);
  nh.displayName = "ViewSourceContext";
  var ah = nh,
    ih = t(27),
    oh = t.n(ih);
  function sh({
    eventInfo: e
  }) {
    const {
        viewUrlSourceFunction: r
      } = Object(a.useContext)(ah),
      {
        componentName: t,
        timestamp: n
      } = e,
      i = e.componentStack || null;
    return a.createElement(a.Fragment, null, a.createElement("div", {
      className: oh.a.Toolbar
    }, t, " ", _d(e)), a.createElement("div", {
      className: oh.a.Content,
      tabIndex: 0
    }, a.createElement("ul", {
      className: oh.a.List
    }, a.createElement("li", {
      className: oh.a.ListItem
    }, a.createElement("label", {
      className: oh.a.Label
    }, "Timestamp"), ":", " ", a.createElement("span", {
      className: oh.a.Value
    }, vd(n))), i && a.createElement("li", {
      className: oh.a.ListItem
    }, a.createElement("div", {
      className: oh.a.Row
    }, a.createElement("label", {
      className: oh.a.Label
    }, "Rendered by"), a.createElement(Ci, {
      onClick: () => Object(ar.copy)(i),
      title: "Copy component stack to clipboard"
    }, a.createElement(Tn, {
      type: "copy"
    }))), a.createElement("ul", {
      className: oh.a.List
    }, function (e) {
      const r = [];
      return e.split(Ae).slice(1).forEach(e => {
        const t = Me.exec(e);
        if (t) {
          const [, e, n, a, i] = t;
          r.push([e, [n, parseInt(a, 10), parseInt(i, 10)]]);
        } else r.push([e, null]);
      }), r;
    }(i).map(([e, t], n) => a.createElement("li", {
      key: n
    }, a.createElement(Ci, {
      className: t ? oh.a.ClickableSource : oh.a.UnclickableSource,
      disabled: !t,
      onClick: () => (e => {
        null != r && null != e && r(...e);
      })(t)
    }, e))))))));
  }
  function lh(e) {
    const {
      selectedEvent: r
    } = Object(a.useContext)(bu);
    return r && r.schedulingEvent ? a.createElement(sh, {
      eventInfo: r.schedulingEvent
    }) : null;
  }
  function ch({
    disabled: e
  }) {
    const r = Object(a.useContext)(Jr),
      t = Object(a.useContext)(et),
      n = Object(a.useMemo)(() => ({
        getCurrentValue: () => ({
          recordChangeDescriptions: t.recordChangeDescriptions,
          supportsReloadAndProfile: t.supportsReloadAndProfile
        }),
        subscribe: e => (t.addListener("recordChangeDescriptions", e), t.addListener("supportsReloadAndProfile", e), () => {
          t.removeListener("recordChangeDescriptions", e), t.removeListener("supportsReloadAndProfile", e);
        })
      }), [t]),
      {
        recordChangeDescriptions: i,
        supportsReloadAndProfile: o
      } = bn(n),
      s = Object(a.useCallback)(() => {
        r.send("reloadAndProfile", i);
      }, [r, i]);
    return o ? a.createElement(Ci, {
      disabled: e,
      onClick: s,
      title: "Reload and start profiling"
    }, a.createElement(Tn, {
      type: "reload"
    })) : null;
  }
  var uh = t(48),
    fh = t.n(uh);
  function dh() {
    const {
        isProfiling: e,
        profilingData: r,
        rootID: t
      } = Object(a.useContext)(tu),
      {
        setFile: n
      } = Object(a.useContext)(bu),
      i = Object(a.useContext)(et),
      {
        profilerStore: o
      } = i,
      s = Object(a.useRef)(null),
      l = Object(a.useRef)(null),
      {
        dispatch: c
      } = Object(a.useContext)(Qs),
      u = o.didRecordCommits,
      f = Object(a.useCallback)(() => {
        if (null === t) return;
        const e = l.current;
        if (null !== r && null !== e) {
          const t = function (e) {
              const r = e.timelineData.map(({
                  batchUIDToMeasuresMap: e,
                  componentMeasures: r,
                  duration: t,
                  flamechart: n,
                  internalModuleSourceToRanges: a,
                  laneToLabelMap: i,
                  laneToReactMeasureMap: o,
                  nativeEvents: s,
                  networkMeasures: l,
                  otherUserTimingMarks: c,
                  reactVersion: u,
                  schedulingEvents: f,
                  snapshots: d,
                  snapshotHeight: v,
                  startTime: h,
                  suspenseEvents: m,
                  thrownErrors: _
                }) => ({
                  batchUIDToMeasuresKeyValueArray: Array.from(e.entries()),
                  componentMeasures: r,
                  duration: t,
                  flamechart: n,
                  internalModuleSourceToRanges: Array.from(a.entries()),
                  laneToLabelKeyValueArray: Array.from(i.entries()),
                  laneToReactMeasureKeyValueArray: Array.from(o.entries()),
                  nativeEvents: s,
                  networkMeasures: l,
                  otherUserTimingMarks: c,
                  reactVersion: u,
                  schedulingEvents: f,
                  snapshots: d,
                  snapshotHeight: v,
                  startTime: h,
                  suspenseEvents: m,
                  thrownErrors: _
                })),
                t = [];
              return e.dataForRoots.forEach(({
                commitData: e,
                displayName: r,
                initialTreeBaseDurations: n,
                operations: a,
                rootID: i,
                snapshots: o
              }) => {
                t.push({
                  commitData: e.map(({
                    changeDescriptions: e,
                    duration: r,
                    effectDuration: t,
                    fiberActualDurations: n,
                    fiberSelfDurations: a,
                    passiveEffectDuration: i,
                    priorityLevel: o,
                    timestamp: s,
                    updaters: l
                  }) => ({
                    changeDescriptions: null != e ? Array.from(e.entries()) : null,
                    duration: r,
                    effectDuration: t,
                    fiberActualDurations: Array.from(n.entries()),
                    fiberSelfDurations: Array.from(a.entries()),
                    passiveEffectDuration: i,
                    priorityLevel: o,
                    timestamp: s,
                    updaters: l
                  })),
                  displayName: r,
                  initialTreeBaseDurations: Array.from(n.entries()),
                  operations: a,
                  rootID: i,
                  snapshots: Array.from(o.entries())
                });
              }), {
                version: v.q,
                dataForRoots: t,
                timelineData: r
              };
            }(r),
            n = new Date();
          !function (e, r, t) {
            const n = new Blob([t], {
              type: "text/plain;charset=utf-8"
            });
            null !== Ut && URL.revokeObjectURL(Ut), Ut = URL.createObjectURL(n), e.setAttribute("href", Ut), e.setAttribute("download", r), e.click();
          }(e, `profiling-data.${n.toLocaleDateString(void 0, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          }).replace(/\//g, "-")}.${n.toLocaleTimeString(void 0, {
            hour12: !1
          }).replace(/:/g, "-")}.json`, JSON.stringify(t, null, 2));
        }
      }, [t, r]),
      d = Object(a.useCallback)(() => {
        null !== s.current && s.current.click();
      }, []);
    return a.createElement(a.Fragment, null, a.createElement("div", {
      className: fh.a.VRule
    }), a.createElement("input", {
      ref: s,
      className: fh.a.Input,
      type: "file",
      accept: ".json",
      onChange: () => {
        const e = s.current;
        if (null !== e && e.files.length > 0) {
          const r = e.files[0],
            t = new FileReader();
          t.addEventListener("load", () => {
            const e = t.result,
              i = JSON.parse(e);
            if (!hr(i) && pr.call(i, "version")) {
              n(null);
              try {
                const e = i;
                o.profilingData = function (e) {
                  const {
                    version: r
                  } = e;
                  if (r !== v.q) throw Error(`Unsupported profile export version "${r}". Supported version is "${v.q}".`);
                  const t = e.timelineData ? e.timelineData.map(({
                      batchUIDToMeasuresKeyValueArray: e,
                      componentMeasures: r,
                      duration: t,
                      flamechart: n,
                      internalModuleSourceToRanges: a,
                      laneToLabelKeyValueArray: i,
                      laneToReactMeasureKeyValueArray: o,
                      nativeEvents: s,
                      networkMeasures: l,
                      otherUserTimingMarks: c,
                      reactVersion: u,
                      schedulingEvents: f,
                      snapshots: d,
                      snapshotHeight: v,
                      startTime: h,
                      suspenseEvents: m,
                      thrownErrors: _
                    }) => ({
                      batchUIDToMeasuresMap: new Map(e),
                      componentMeasures: r,
                      duration: t,
                      flamechart: n,
                      internalModuleSourceToRanges: new Map(a),
                      laneToLabelMap: new Map(i),
                      laneToReactMeasureMap: new Map(o),
                      nativeEvents: s,
                      networkMeasures: l,
                      otherUserTimingMarks: c,
                      reactVersion: u,
                      schedulingEvents: f,
                      snapshots: d,
                      snapshotHeight: v,
                      startTime: h,
                      suspenseEvents: m,
                      thrownErrors: _
                    })) : [],
                    n = new Map();
                  return e.dataForRoots.forEach(({
                    commitData: e,
                    displayName: r,
                    initialTreeBaseDurations: t,
                    operations: a,
                    rootID: i,
                    snapshots: o
                  }) => {
                    n.set(i, {
                      commitData: e.map(({
                        changeDescriptions: e,
                        duration: r,
                        effectDuration: t,
                        fiberActualDurations: n,
                        fiberSelfDurations: a,
                        passiveEffectDuration: i,
                        priorityLevel: o,
                        timestamp: s,
                        updaters: l
                      }) => ({
                        changeDescriptions: null != e ? new Map(e) : null,
                        duration: r,
                        effectDuration: t,
                        fiberActualDurations: new Map(n),
                        fiberSelfDurations: new Map(a),
                        passiveEffectDuration: i,
                        priorityLevel: o,
                        timestamp: s,
                        updaters: l
                      })),
                      displayName: r,
                      initialTreeBaseDurations: new Map(t),
                      operations: a,
                      rootID: i,
                      snapshots: new Map(o)
                    });
                  }), {
                    dataForRoots: n,
                    imported: !0,
                    timelineData: t
                  };
                }(e);
              } catch (e) {
                c({
                  id: "ProfilingImportExportButtons",
                  type: "SHOW",
                  title: "Import failed",
                  content: a.createElement(a.Fragment, null, a.createElement("div", null, "The profiling data you selected cannot be imported."), null !== e && a.createElement("div", {
                    className: fh.a.ErrorMessage
                  }, e.message))
                });
              }
            } else o.clear(), n(r);
          }), t.readAsText(r);
        }
      },
      tabIndex: -1
    }), a.createElement("a", {
      ref: l,
      className: fh.a.Input
    }), a.createElement(Ci, {
      disabled: e,
      onClick: d,
      title: "Load profile..."
    }, a.createElement(Tn, {
      type: "import"
    })), a.createElement(Ci, {
      disabled: e || !u,
      onClick: f,
      title: "Save profile..."
    }, a.createElement(Tn, {
      type: "export"
    })));
  }
  var vh = t(61),
    hh = t.n(vh);
  function mh({
    data: e,
    index: r,
    style: t
  }) {
    const {
        filteredCommitIndices: n,
        maxDuration: i,
        selectedCommitIndex: o,
        selectCommitIndex: s,
        setHoveredCommitIndex: l,
        startCommitDrag: c,
        totalDurations: u
      } = e,
      f = u[r = n[r]],
      d = Math.min(1, Math.max(0, Math.cbrt(f) / Math.cbrt(i))) || 0,
      v = Math.min(1, Math.max(0, f / i)) || 0,
      h = o === r,
      m = parseFloat(t.width) - 1;
    let _;
    return !h && f > 0 && (_ = Oe(v)), a.createElement("div", {
      className: hh.a.Outer,
      onMouseDown: ({
        buttons: e,
        target: n
      }) => {
        1 === e && (s(r), c({
          commitIndex: r,
          left: n.getBoundingClientRect().left,
          sizeIncrement: parseFloat(t.width)
        }));
      },
      onMouseEnter: () => l(r),
      style: {
        ...t,
        width: m,
        borderBottom: h ? "3px solid var(--color-tab-selected-border)" : void 0
      }
    }, a.createElement("div", {
      className: h ? hh.a.InnerSelected : hh.a.Inner,
      style: {
        height: Math.round(100 * d) + "%",
        backgroundColor: _
      }
    }));
  }
  var _h = Object(a.memo)(mh, It),
    ph = t(16),
    gh = t.n(ph);
  function bh({
    commitData: e,
    commitTimes: r,
    filteredCommitIndices: t,
    selectedCommitIndex: n,
    selectedFilteredCommitIndex: i,
    selectCommitIndex: o,
    totalDurations: s
  }) {
    return a.createElement(pt, null, ({
      height: l,
      width: c
    }) => a.createElement(Sh, {
      commitData: e,
      commitTimes: r,
      height: l,
      filteredCommitIndices: t,
      selectedCommitIndex: n,
      selectedFilteredCommitIndex: i,
      selectCommitIndex: o,
      totalDurations: s,
      width: c
    }));
  }
  function Sh({
    commitData: e,
    selectedCommitIndex: r,
    commitTimes: t,
    height: n,
    filteredCommitIndices: i,
    selectedFilteredCommitIndex: o,
    selectCommitIndex: s,
    totalDurations: l,
    width: c
  }) {
    const u = Object(a.useRef)(null),
      f = Object(a.useRef)(null),
      d = Object(a.useRef)(null);
    Object(a.useEffect)(() => {
      o !== d.current && (d.current = o, null !== o && null !== u.current && u.current.scrollToItem(o));
    }, [u, o]);
    const v = Object(a.useMemo)(() => Math.max(5, c / i.length), [i, c]),
      h = Object(a.useMemo)(() => l.reduce((e, r) => Math.max(e, r), 0), [l]),
      m = i.length - 1,
      [_, p] = Object(a.useState)(null),
      g = ({
        buttons: e,
        pageX: r
      }) => {
        if (0 !== e) {
          if (null !== _) {
            const {
              commitIndex: e,
              left: t,
              sizeIncrement: n
            } = _;
            let a = e,
              i = t;
            if (r < i) for (; r < i;) i -= n, a -= 1;else {
              let e = i + n;
              for (; r > e;) e += n, a += 1;
            }
            a < 0 ? a = 0 : a > m && (a = m), s(a);
          }
        } else p(null);
      };
    Object(a.useEffect)(() => {
      if (null === _) return;
      const e = f.current;
      if (null !== e) {
        const r = e.ownerDocument;
        return r.addEventListener("mousemove", g), () => {
          r.removeEventListener("mousemove", g);
        };
      }
    }, [_]);
    const [b, S] = Object(a.useState)(null),
      E = Object(a.useMemo)(() => ({
        commitTimes: t,
        filteredCommitIndices: i,
        maxDuration: h,
        selectedCommitIndex: r,
        selectedFilteredCommitIndex: o,
        selectCommitIndex: s,
        setHoveredCommitIndex: S,
        startCommitDrag: p,
        totalDurations: l
      }), [t, i, h, r, o, s, S, l]);
    let w = null;
    if (null !== b) {
      const {
        duration: r,
        effectDuration: t,
        passiveEffectDuration: n,
        priorityLevel: i,
        timestamp: o
      } = e[b];
      w = null !== t || null !== n || null !== i ? a.createElement("ul", {
        className: gh.a.TooltipList
      }, null !== i && a.createElement("li", {
        className: gh.a.TooltipListItem
      }, a.createElement("label", {
        className: gh.a.TooltipLabel
      }, "Priority"), a.createElement("span", {
        className: gh.a.TooltipValue
      }, i)), a.createElement("li", {
        className: gh.a.TooltipListItem
      }, a.createElement("label", {
        className: gh.a.TooltipLabel
      }, "Committed at"), a.createElement("span", {
        className: gh.a.TooltipValue
      }, Ne(o), "s")), a.createElement("li", {
        className: gh.a.TooltipListItem
      }, a.createElement("div", {
        className: gh.a.DurationsWrapper
      }, a.createElement("label", {
        className: gh.a.TooltipLabel
      }, "Durations"), a.createElement("ul", {
        className: gh.a.DurationsList
      }, a.createElement("li", {
        className: gh.a.DurationsListItem
      }, a.createElement("label", {
        className: gh.a.DurationsLabel
      }, "Render"), a.createElement("span", {
        className: gh.a.DurationsValue
      }, Te(r), "ms")), null !== t && a.createElement("li", {
        className: gh.a.DurationsListItem
      }, a.createElement("label", {
        className: gh.a.DurationsLabel
      }, "Layout effects"), a.createElement("span", {
        className: gh.a.DurationsValue
      }, Te(t), "ms")), null !== n && a.createElement("li", {
        className: gh.a.DurationsListItem
      }, a.createElement("label", {
        className: gh.a.DurationsLabel
      }, "Passive effects"), a.createElement("span", {
        className: gh.a.DurationsValue
      }, Te(n), "ms")))))) : `${Te(r)}ms at ${Ne(o)}s`;
    }
    return a.createElement(zu, {
      className: gh.a.Tooltip,
      label: w
    }, a.createElement("div", {
      ref: f,
      style: {
        height: n,
        width: c
      },
      onMouseLeave: () => S(null)
    }, a.createElement(Nt, {
      className: gh.a.List,
      layout: "horizontal",
      height: n,
      itemCount: i.length,
      itemData: E,
      itemSize: v,
      ref: u,
      width: c
    }, _h)));
  }
  var Eh = t(36),
    wh = t.n(Eh);
  function yh(e) {
    const {
        isCommitFilterEnabled: r,
        minCommitDuration: t,
        rootID: n,
        selectedCommitIndex: i,
        selectCommitIndex: o
      } = Object(a.useContext)(tu),
      {
        profilerStore: s
      } = Object(a.useContext)(et),
      {
        commitData: l
      } = s.getDataForRoot(n),
      c = [],
      u = [];
    l.forEach(e => {
      c.push(e.duration + (e.effectDuration || 0) + (e.passiveEffectDuration || 0)), u.push(e.timestamp);
    });
    const f = Object(a.useMemo)(() => l.reduce((e, n, a) => ((!r || n.duration >= t) && e.push(a), e), []), [l, r, t]),
      d = f.length,
      v = Object(a.useMemo)(() => {
        if (null !== i) for (let e = 0; e < f.length; e++) if (f[e] === i) return e;
        return null;
      }, [f, i]);
    null === v ? o(d > 0 ? 0 : null) : v >= d && o(0 === d ? null : d - 1);
    let h = null;
    if (d > 0) {
      const e = e => {
          const r = parseInt(e.currentTarget.value, 10);
          if (!isNaN(r)) {
            const e = Math.min(Math.max(r - 1, 0), d - 1);
            o(f[e]);
          }
        },
        r = e => {
          e.currentTarget.select();
        },
        t = e => {
          switch (e.key) {
            case "ArrowDown":
              _(), e.stopPropagation();
              break;
            case "ArrowUp":
              m(), e.stopPropagation();
          }
        },
        n = a.createElement("input", {
          className: wh.a.Input,
          "data-testname": "SnapshotSelector-Input",
          type: "text",
          inputMode: "numeric",
          pattern: "[0-9]*",
          value: v + 1,
          size: ("" + d).length,
          onChange: e,
          onClick: r,
          onKeyDown: t
        });
      h = a.createElement(a.Fragment, null, n, " / ", d);
    }
    const m = () => {
        let e = v + 1;
        e === f.length && (e = 0), o(f[e]);
      },
      _ = () => {
        let e = v - 1;
        e < 0 && (e = f.length - 1), o(f[e]);
      };
    return 0 === l.length ? null : a.createElement(a.Fragment, null, a.createElement("span", {
      className: wh.a.IndexLabel,
      "data-testname": "SnapshotSelector-Label"
    }, h), a.createElement(Ci, {
      className: wh.a.Button,
      "data-testname": "SnapshotSelector-PreviousButton",
      disabled: 0 === d,
      onClick: _,
      title: "Select previous commit"
    }, a.createElement(Tn, {
      type: "previous"
    })), a.createElement("div", {
      className: wh.a.Commits,
      onKeyDown: e => {
        switch (e.key) {
          case "ArrowLeft":
            _(), e.stopPropagation();
            break;
          case "ArrowRight":
            m(), e.stopPropagation();
        }
      },
      style: {
        flex: d > 0 ? "1 1 auto" : "0 0 auto",
        maxWidth: d > 0 ? 30 * d : void 0
      },
      tabIndex: 0
    }, d > 0 && a.createElement(bh, {
      commitData: l,
      commitTimes: u,
      filteredCommitIndices: f,
      selectedCommitIndex: i,
      selectedFilteredCommitIndex: v,
      selectCommitIndex: o,
      totalDurations: c
    }), 0 === d && a.createElement("div", {
      className: wh.a.NoCommits
    }, "No commits")), a.createElement(Ci, {
      className: wh.a.Button,
      "data-testname": "SnapshotSelector-NextButton",
      disabled: 0 === d,
      onClick: m,
      title: "Select next commit"
    }, a.createElement(Tn, {
      type: "next"
    })));
  }
  var kh = t(49),
    Ch = t.n(kh);
  function Dh({
    commitTree: e,
    updaters: r
  }) {
    const {
        selectFiber: t
      } = Object(a.useContext)(tu),
      n = r.length > 0 ? r.map(r => {
        const {
          displayName: n,
          id: i,
          key: o,
          type: s
        } = r;
        return e.nodes.has(i) && 11 !== s ? a.createElement("button", {
          key: i,
          className: Ch.a.Updater,
          onClick: () => t(i, n)
        }, n, " ", o ? `key="${o}"` : "") : a.createElement("div", {
          key: i,
          className: Ch.a.UnmountedUpdater
        }, n, " ", o ? `key="${o}"` : "");
      }) : a.createElement("div", {
        key: "none",
        className: Ch.a.NoUpdaters
      }, "(unknown)");
    return a.createElement("div", {
      className: Ch.a.Updaters
    }, n);
  }
  var Ah = t(10),
    Mh = t.n(Ah);
  function xh(e) {
    const {
        selectedCommitIndex: r,
        rootID: t
      } = Object(a.useContext)(tu),
      {
        profilerStore: n
      } = Object(a.useContext)(et);
    if (null === t || null === r) return a.createElement("div", {
      className: Mh.a.NothingSelected
    }, "Nothing selected");
    const {
        duration: i,
        effectDuration: o,
        passiveEffectDuration: s,
        priorityLevel: l,
        timestamp: c,
        updaters: u
      } = n.getCommitData(t, r),
      f = null !== o || null !== s,
      d = null !== u ? Fe({
        commitIndex: r,
        profilerStore: n,
        rootID: t
      }) : null;
    return a.createElement(a.Fragment, null, a.createElement("div", {
      className: Mh.a.Toolbar
    }, "Commit information"), a.createElement("div", {
      className: Mh.a.Content
    }, a.createElement("ul", {
      className: Mh.a.List
    }, null !== l && a.createElement("li", {
      className: Mh.a.ListItem
    }, a.createElement("label", {
      className: Mh.a.Label
    }, "Priority"), ":", " ", a.createElement("span", {
      className: Mh.a.Value
    }, l)), a.createElement("li", {
      className: Mh.a.ListItem
    }, a.createElement("label", {
      className: Mh.a.Label
    }, "Committed at"), ":", " ", a.createElement("span", {
      className: Mh.a.Value
    }, Ne(c), "s")), !f && a.createElement("li", {
      className: Mh.a.ListItem
    }, a.createElement("label", {
      className: Mh.a.Label
    }, "Render duration"), ":", " ", a.createElement("span", {
      className: Mh.a.Value
    }, Te(i), "ms")), f && a.createElement("li", {
      className: Mh.a.ListItem
    }, a.createElement("label", {
      className: Mh.a.Label
    }, "Durations"), a.createElement("ul", {
      className: Mh.a.DurationsList
    }, a.createElement("li", {
      className: Mh.a.DurationsListItem
    }, a.createElement("label", {
      className: Mh.a.Label
    }, "Render"), ":", " ", a.createElement("span", {
      className: Mh.a.Value
    }, Te(i), "ms")), null !== o && a.createElement("li", {
      className: Mh.a.DurationsListItem
    }, a.createElement("label", {
      className: Mh.a.Label
    }, "Layout effects"), ":", " ", a.createElement("span", {
      className: Mh.a.Value
    }, Te(o), "ms")), null !== s && a.createElement("li", {
      className: Mh.a.DurationsListItem
    }, a.createElement("label", {
      className: Mh.a.Label
    }, "Passive effects"), ":", " ", a.createElement("span", {
      className: Mh.a.Value
    }, Te(s), "ms")))), null !== u && null !== d && a.createElement("li", {
      className: Mh.a.ListItem
    }, a.createElement("label", {
      className: Mh.a.Label
    }, "What caused this update"), "?", a.createElement(Dh, {
      commitTree: d,
      updaters: u
    })))));
  }
  function Oh() {
    return a.createElement("div", {
      className: sf.a.Column
    }, a.createElement("div", {
      className: sf.a.Header
    }, "Processing data..."), a.createElement("div", {
      className: sf.a.Row
    }, "This should only take a minute."));
  }
  function Th() {
    return a.createElement("div", {
      className: sf.a.Column
    }, a.createElement("div", {
      className: sf.a.Header
    }, "Profiling not supported."), a.createElement("p", {
      className: sf.a.Paragraph
    }, "Profiling support requires either a development or profiling build of React v16.5+."), a.createElement("p", {
      className: sf.a.Paragraph
    }, "Learn more at", " ", a.createElement("a", {
      className: sf.a.Link,
      href: "https://fb.me/react-devtools-profiling",
      rel: "noopener noreferrer",
      target: "_blank"
    }, "reactjs.org/link/profiling"), "."));
  }
  var Nh = t(34),
    Rh = t.n(Nh);
  function Ih(e) {
    const {
        profilerStore: r
      } = Object(a.useContext)(et),
      {
        rootID: t,
        selectCommitIndex: n,
        selectedCommitIndex: i,
        selectedFiberID: o,
        selectedFiberName: s,
        selectFiber: l
      } = Object(a.useContext)(tu),
      {
        profilingCache: c
      } = r,
      u = Object(a.useRef)(null),
      f = c.getFiberCommits({
        fiberID: o,
        rootID: t
      });
    Object(a.useEffect)(() => {
      const e = u.current;
      null !== e && "function" == typeof e.scrollIntoView && e.scrollIntoView({
        block: "nearest",
        inline: "nearest"
      });
    }, [i]);
    const d = [];
    let v = 0;
    for (v = 0; v < f.length; v++) {
      const e = f[v],
        {
          duration: o,
          timestamp: s
        } = r.getCommitData(t, e);
      d.push(a.createElement("button", {
        key: e,
        ref: i === e ? u : null,
        className: i === e ? Rh.a.CurrentCommit : Rh.a.Commit,
        onClick: () => n(e)
      }, Ne(s), "s for ", Te(o), "ms"));
    }
    return a.createElement(a.Fragment, null, a.createElement("div", {
      className: Rh.a.Toolbar
    }, a.createElement("div", {
      className: Rh.a.Component
    }, s || "Selected component"), a.createElement(Ci, {
      className: Rh.a.IconButton,
      onClick: () => l(null, null),
      title: "Back to commit view"
    }, a.createElement(Tn, {
      type: "close"
    }))), a.createElement("div", {
      className: Rh.a.Content,
      onKeyDown: e => {
        switch (e.key) {
          case "ArrowUp":
            if (null !== i) {
              const e = f.indexOf(i),
                r = e > 0 ? e - 1 : f.length - 1;
              n(f[r]);
            }
            e.preventDefault();
            break;
          case "ArrowDown":
            if (null !== i) {
              const e = f.indexOf(i),
                r = e < f.length - 1 ? e + 1 : 0;
              n(f[r]);
            }
            e.preventDefault();
        }
      },
      tabIndex: 0
    }, a.createElement(Nu, {
      fiberID: o
    }), d.length > 0 && a.createElement(a.Fragment, null, a.createElement("label", {
      className: Rh.a.Label
    }, "Rendered at"), ": ", d), 0 === d.length && a.createElement("div", null, "Did not render during this profiling session.")));
  }
  const Hh = () => a.createElement("div", {
      className: sf.a.Column
    }, a.createElement("div", {
      className: sf.a.Header
    }, "Timeline only"), a.createElement("div", {
      className: sf.a.Row
    }, "The current profile contains only Timeline data.")),
    Fh = [{
      id: "flame-chart",
      icon: "flame-chart",
      label: "Flamegraph",
      title: "Flamegraph chart"
    }, {
      id: "ranked-chart",
      icon: "ranked-chart",
      label: "Ranked",
      title: "Ranked chart"
    }],
    Lh = [...Fh, null, {
      id: "timeline",
      icon: "timeline",
      label: "Timeline",
      title: "Timeline"
    }];
  var Ph = Bs(function (e) {
      const {
          didRecordCommits: r,
          isProcessingData: t,
          isProfiling: n,
          selectedCommitIndex: i,
          selectedFiberID: o,
          selectedTabID: s,
          selectTab: l,
          supportsProfiling: c
        } = Object(a.useContext)(tu),
        {
          file: u,
          searchInputContainerRef: f
        } = Object(a.useContext)(bu),
        {
          supportsTimeline: d
        } = Object(a.useContext)(et),
        v = "timeline" !== s,
        h = v || Qe.e;
      let m = null;
      if (r || "timeline" === s) switch (s) {
        case "flame-chart":
          m = a.createElement(Uu, null);
          break;
        case "ranked-chart":
          m = a.createElement(qu, null);
          break;
        case "timeline":
          m = a.createElement(Zv, null);
      } else m = n ? a.createElement(cf, null) : t ? a.createElement(Oh, null) : u ? a.createElement(Hh, null) : c ? a.createElement(lf, null) : a.createElement(Th, null);
      let _ = null;
      if (!n && !t && r) switch (s) {
        case "flame-chart":
        case "ranked-chart":
          null !== i && (_ = null !== o ? a.createElement(Ih, null) : a.createElement(xh, null));
          break;
        case "timeline":
          _ = a.createElement(lh, null);
      }
      return a.createElement(Zo, null, a.createElement("div", {
        className: sf.a.Profiler
      }, a.createElement("div", {
        className: sf.a.LeftColumn
      }, a.createElement("div", {
        className: sf.a.Toolbar
      }, a.createElement(af, {
        disabled: !c
      }), a.createElement(ch, {
        disabled: !c
      }), a.createElement(Eu, null), a.createElement(dh, null), a.createElement("div", {
        className: sf.a.VRule
      }), a.createElement(Kc, {
        currentTab: s,
        id: "Profiler",
        selectTab: l,
        tabs: d ? Lh : Fh,
        type: "profiler"
      }), a.createElement(rf, null), a.createElement("div", {
        className: sf.a.Spacer
      }), !v && a.createElement("div", {
        ref: f,
        className: sf.a.TimelineSearchInputContainer
      }), a.createElement(Jo, null), v && r && a.createElement(a.Fragment, null, a.createElement("div", {
        className: sf.a.VRule
      }), a.createElement(yh, null))), a.createElement("div", {
        className: sf.a.Content
      }, m, a.createElement(el, null))), h && a.createElement("div", {
        className: sf.a.RightColumn
      }, _), a.createElement(su, null)));
    }),
    zh = t(106),
    Bh = t.n(zh);
  function jh({
    className: e
  }) {
    return a.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      className: `${Bh.a.ReactLogo} ${e || ""}`,
      viewBox: "-11.5 -10.23174 23 20.46348"
    }, a.createElement("circle", {
      cx: "0",
      cy: "0",
      r: "2.05",
      fill: "currentColor"
    }), a.createElement("g", {
      stroke: "currentColor",
      strokeWidth: "1",
      fill: "none"
    }, a.createElement("ellipse", {
      rx: "11",
      ry: "4.2"
    }), a.createElement("ellipse", {
      rx: "11",
      ry: "4.2",
      transform: "rotate(60)"
    }), a.createElement("ellipse", {
      rx: "11",
      ry: "4.2",
      transform: "rotate(120)"
    })));
  }
  var Vh = t(25),
    Uh = t.n(Vh);
  const Wh = "UnsupportedBridgeProtocolDialog";
  function $h(e) {
    const {
        dialogs: r,
        dispatch: t
      } = Object(a.useContext)(Qs),
      n = Object(a.useContext)(et),
      i = !!r.find(e => e.id === Wh);
    return Object(a.useEffect)(() => {
      const e = () => {
        i ? n.unsupportedBridgeProtocolDetected || t({
          type: "HIDE",
          id: Wh
        }) : n.unsupportedBridgeProtocolDetected && t({
          canBeDismissed: !1,
          id: Wh,
          type: "SHOW",
          content: a.createElement(Xh, {
            unsupportedBridgeProtocol: n.bridgeProtocol
          })
        });
      };
      return e(), n.addListener("unsupportedBridgeProtocolDetected", e), () => {
        n.removeListener("unsupportedBridgeProtocolDetected", e);
      };
    }, [i, n]), null;
  }
  function Xh({
    unsupportedBridgeProtocol: e
  }) {
    const {
      version: r,
      minNpmVersion: t,
      maxNpmVersion: n
    } = e;
    let i;
    if (null === n) {
      const e = "npm i -g react-devtools@^" + t;
      i = a.createElement(a.Fragment, null, a.createElement("p", {
        className: Uh.a.Paragraph
      }, "To fix this, upgrade the DevTools NPM package:"), a.createElement("pre", {
        className: Uh.a.NpmCommand
      }, e, a.createElement(Ci, {
        onClick: () => Object(ar.copy)(e),
        title: "Copy upgrade command to clipboard"
      }, a.createElement(Tn, {
        type: "copy"
      }))));
    } else {
      const e = "npm i -g react-devtools@" + n;
      i = a.createElement(a.Fragment, null, a.createElement("p", {
        className: Uh.a.Paragraph
      }, "To fix this, downgrade the DevTools NPM package:"), a.createElement("pre", {
        className: Uh.a.NpmCommand
      }, e, a.createElement(Ci, {
        onClick: () => Object(ar.copy)(e),
        title: "Copy downgrade command to clipboard"
      }, a.createElement(Tn, {
        type: "copy"
      }))));
    }
    return a.createElement(a.Fragment, null, a.createElement("div", {
      className: Uh.a.Column
    }, a.createElement("div", {
      className: Uh.a.Title
    }, "Unsupported DevTools backend version"), a.createElement("p", {
      className: Uh.a.Paragraph
    }, "You are running ", a.createElement("code", null, "react-devtools"), " version", " ", a.createElement("span", {
      className: Uh.a.Version
    }, "4.27.2-7f747b80e"), "."), a.createElement("p", {
      className: Uh.a.Paragraph
    }, "This requires bridge protocol", " ", a.createElement("span", {
      className: Uh.a.Version
    }, "version ", u.version), ". However the current backend version uses bridge protocol", " ", a.createElement("span", {
      className: Uh.a.Version
    }, "version ", r), "."), i, a.createElement("p", {
      className: Uh.a.Paragraph
    }, "Or", " ", a.createElement("a", {
      className: Uh.a.Link,
      href: "https://fb.me/devtools-unsupported-bridge-protocol",
      target: "_blank"
    }, "click here"), " ", "for more information.")));
  }
  var Gh = t(62),
    Kh = t.n(Gh);
  function Yh(e) {
    const {
        dispatch: r
      } = Object(a.useContext)(Qs),
      t = Object(a.useContext)(et),
      [n, o] = Object(a.useState)("dialog-not-shown");
    return Object(a.useEffect)(() => {
      if ("dialog-not-shown" === n) {
        const e = () => {
          Object(i.unstable_batchedUpdates)(() => {
            o("show-dialog"), r({
              canBeDismissed: !0,
              id: "UnsupportedVersionDialog",
              type: "SHOW",
              content: a.createElement(qh, null)
            });
          });
        };
        if (!t.unsupportedRendererVersionDetected) return t.addListener("unsupportedRendererVersionDetected", e), () => {
          t.removeListener("unsupportedRendererVersionDetected", e);
        };
        e();
      }
    }, [n, t]), null;
  }
  function qh(e) {
    return a.createElement(a.Fragment, null, a.createElement("div", {
      className: Kh.a.Row
    }, a.createElement("div", null, a.createElement("div", {
      className: Kh.a.Title
    }, "Unsupported React version detected"), a.createElement("p", null, "This version of React DevTools supports React DOM v15+ and React Native v61+."), a.createElement("p", null, "In order to use DevTools with an older version of React, you'll need to", " ", a.createElement("a", {
      className: Kh.a.ReleaseNotesLink,
      target: "_blank",
      rel: "noopener noreferrer",
      href: v.E
    }, "install an older version of the extension"), "."))));
  }
  var Qh = t(107),
    Zh = t.n(Qh);
  function Jh(e) {
    const r = Object(a.useContext)(Jr),
      {
        dispatch: t
      } = Object(a.useContext)(Qs);
    return Object(a.useEffect)(() => {
      let e = r.wall.listen(r => {
        switch (r.type) {
          case "call":
          case "event":
          case "many-events":
            t({
              canBeDismissed: !1,
              id: "WarnIfLegacyBackendDetected",
              type: "SHOW",
              title: "DevTools v4 is incompatible with this version of React",
              content: a.createElement(em, null)
            }), "function" == typeof e && (e(), e = null);
        }
        switch (r.event) {
          case "isBackendStorageAPISupported":
          case "isNativeStyleEditorSupported":
          case "operations":
          case "overrideComponentFilters":
            "function" == typeof e && (e(), e = null);
        }
      });
      return () => {
        "function" == typeof e && (e(), e = null);
      };
    }, [r, t]), null;
  }
  function em(e) {
    return a.createElement(a.Fragment, null, a.createElement("p", null, "Either upgrade React or install React DevTools v3:"), a.createElement("code", {
      className: Zh.a.Command
    }, "npm install -d react-devtools@^3"));
  }
  var rm = t(37),
    tm = t.n(rm);
  t(206);
  const nm = [{
    id: "components",
    icon: "components",
    label: "Components",
    title: "React Components"
  }, {
    id: "profiler",
    icon: "profiler",
    label: "Profiler",
    title: "React Profiler"
  }];
  function am({
    bridge: e,
    browserTheme: r = "light",
    canViewElementSourceFunction: t,
    componentsPortalContainer: n,
    defaultTab: i = "components",
    enabledInspectedElementContextMenu: o = !1,
    fetchFileWithCaching: s,
    hookNamesModuleLoaderFunction: l,
    overrideTab: c,
    profilerPortalContainer: u,
    showTabBar: f = !1,
    store: d,
    warnIfLegacyBackendDetected: h = !1,
    warnIfUnsupportedVersionDetected: m = !1,
    viewAttributeSourceFunction: _,
    viewElementSourceFunction: p,
    viewUrlSourceFunction: g,
    readOnly: b,
    hideSettings: S,
    hideToggleErrorAction: E,
    hideToggleSuspenseAction: w,
    hideLogAction: y,
    hideViewSourceAction: k
  }) {
    const [C, D] = pn(v.i, i);
    let A = C;
    null != c && (A = c);
    const M = Object(a.useCallback)(e => {
        !0 === f && ("components" === e ? Object(qe.a)({
          event_name: "selected-components-tab"
        }) : Object(qe.a)({
          event_name: "selected-profiler-tab"
        })), D(e);
      }, [D, f]),
      x = Object(a.useMemo)(() => ({
        readOnly: b || !1,
        hideSettings: S || !1,
        hideToggleErrorAction: E || !1,
        hideToggleSuspenseAction: w || !1,
        hideLogAction: y || !1,
        hideViewSourceAction: k || !1
      }), [b, S, E, w, y, k]),
      O = Object(a.useMemo)(() => ({
        canViewElementSourceFunction: t || null,
        viewElementSourceFunction: p || null
      }), [t, p]),
      T = Object(a.useMemo)(() => ({
        viewUrlSourceFunction: g || null
      }), [g]),
      N = Object(a.useMemo)(() => ({
        isEnabledForInspectedElement: o,
        viewAttributeSourceFunction: _ || null
      }), [o, _]),
      R = Object(a.useRef)(null);
    return Object(a.useEffect)(() => {
      if (!f) return;
      const e = R.current;
      if (null === e) return;
      const r = e.ownerDocument.defaultView,
        t = e => {
          if (e.ctrlKey || e.metaKey) switch (e.key) {
            case "1":
              M(nm[0].id), e.preventDefault(), e.stopPropagation();
              break;
            case "2":
              M(nm[1].id), e.preventDefault(), e.stopPropagation();
          }
        };
      return r.addEventListener("keydown", t), () => {
        r.removeEventListener("keydown", t);
      };
    }, [f]), Object(a.useLayoutEffect)(() => () => {
      try {
        e.shutdown();
      } catch (e) {}
    }, [e]), Object(a.useEffect)(() => {
      Object(qe.a)({
        event_name: "loaded-dev-tools"
      });
    }, []), a.createElement(Jr.Provider, {
      value: e
    }, a.createElement(et.Provider, {
      value: d
    }, a.createElement(tt.Provider, {
      value: x
    }, a.createElement(rt.Provider, {
      value: N
    }, a.createElement(Js, null, a.createElement(yn, {
      browserTheme: r,
      componentsPortalContainer: n,
      profilerPortalContainer: u
    }, a.createElement(nl.Provider, {
      value: O
    }, a.createElement(ah.Provider, {
      value: T
    }, a.createElement(Yl.Provider, {
      value: l || null
    }, a.createElement(Gl.Provider, {
      value: s || null
    }, a.createElement(Gt, null, a.createElement(nu, null, a.createElement(Su, null, a.createElement(zs, null, a.createElement("div", {
      className: tm.a.DevTools,
      ref: R,
      "data-react-devtools-portal-root": !0
    }, f && a.createElement("div", {
      className: tm.a.TabBar
    }, a.createElement(jh, null), a.createElement("span", {
      className: tm.a.DevToolsVersion
    }, "4.27.2-7f747b80e"), a.createElement("div", {
      className: tm.a.Spacer
    }), a.createElement(Kc, {
      currentTab: A,
      id: "DevTools",
      selectTab: M,
      tabs: nm,
      type: "navigation"
    })), a.createElement("div", {
      className: tm.a.TabContent,
      hidden: "components" !== A
    }, a.createElement(gu, {
      portalContainer: n
    })), a.createElement("div", {
      className: tm.a.TabContent,
      hidden: "profiler" !== A
    }, a.createElement(Ph, {
      portalContainer: u
    })))))))))))), a.createElement($h, null), h && a.createElement(Jh, null), m && a.createElement(Yh, null))))));
  }
  var im = t(63),
    om = t(108);
  const sm = {
    "/Applications/Atom.app/Contents/MacOS/Atom": "atom",
    "/Applications/Atom Beta.app/Contents/MacOS/Atom Beta": "/Applications/Atom Beta.app/Contents/MacOS/Atom Beta",
    "/Applications/Sublime Text.app/Contents/MacOS/Sublime Text": "/Applications/Sublime Text.app/Contents/SharedSupport/bin/subl",
    "/Applications/Sublime Text 2.app/Contents/MacOS/Sublime Text 2": "/Applications/Sublime Text 2.app/Contents/SharedSupport/bin/subl",
    "/Applications/Visual Studio Code.app/Contents/MacOS/Electron": "code"
  };
  let lm = null;
  function cm(e, r) {
    if (Object(tr.isAbsolute)(e)) {
      if (Object(nr.existsSync)(e)) return e;
    } else for (let t = 0; t < r.length; t++) {
      const n = r[t],
        a = Object(tr.join)(n, e);
      if (Object(nr.existsSync)(a)) return a;
    }
    return null;
  }
  function um(e, r, t) {
    const n = cm(e, t);
    if (null === n) return;
    if (r && isNaN(r)) return;
    const [a, ...i] = function () {
      if (process.env.REACT_EDITOR) return Object(om.parse)(process.env.REACT_EDITOR);
      if ("darwin" === process.platform) try {
        const e = Object(im.execSync)("ps x").toString(),
          r = Object.keys(sm);
        for (let t = 0; t < r.length; t++) {
          const n = r[t];
          if (-1 !== e.indexOf(n)) return [sm[n]];
        }
      } catch (e) {}
      return process.env.VISUAL ? [process.env.VISUAL] : process.env.EDITOR ? [process.env.EDITOR] : [];
    }();
    if (!a) return;
    let o = i;
    r ? o = o.concat(function (e, r, t) {
      switch (Object(tr.basename)(e)) {
        case "vim":
        case "mvim":
          return [r, "+" + t];
        case "atom":
        case "Atom":
        case "Atom Beta":
        case "subl":
        case "sublime":
        case "wstorm":
        case "appcode":
        case "charm":
        case "idea":
          return [r + ":" + t];
        case "joe":
        case "emacs":
        case "emacsclient":
          return ["+" + t, r];
        case "rmate":
        case "mate":
        case "mine":
          return ["--line", t + "", r];
        case "code":
          return ["-g", r + ":" + t];
        default:
          return [r];
      }
    }(a, n, r)) : o.push(n), lm && function (e) {
      switch (e) {
        case "vim":
        case "emacs":
        case "nano":
          return !0;
        default:
          return !1;
      }
    }(a) && lm.kill("SIGKILL"), lm = "win32" === process.platform ? Object(im.spawn)("cmd.exe", ["/C", a].concat(o), {
      stdio: "inherit"
    }) : Object(im.spawn)(a, o, {
      stdio: "inherit"
    }), lm.on("error", function () {}), lm.on("exit", function (e) {
      lm = null;
    });
  }
  !function (e) {
    if (e.hasOwnProperty("__REACT_DEVTOOLS_GLOBAL_HOOK__")) return null;
    let r = console,
      t = {};
    for (const e in console) t[e] = console[e];
    let n = null;
    function a({
      hideConsoleLogsInStrictMode: e,
      browserTheme: t
    }) {
      if (null !== n) return;
      const a = {};
      n = () => {
        for (const e in a) try {
          r[e] = a[e];
        } catch (e) {}
      }, ["error", "group", "groupCollapsed", "info", "log", "trace", "warn"].forEach(n => {
        try {
          const i = a[n] = r[n].__REACT_DEVTOOLS_STRICT_MODE_ORIGINAL_METHOD__ ? r[n].__REACT_DEVTOOLS_STRICT_MODE_ORIGINAL_METHOD__ : r[n],
            o = (...r) => {
              if (!e) {
                let e;
                switch (n) {
                  case "warn":
                    e = "light" === t ? "rgba(250, 180, 50, 0.75)" : "rgba(250, 180, 50, 0.5)";
                    break;
                  case "error":
                    e = "light" === t ? "rgba(250, 123, 130, 0.75)" : "rgba(250, 123, 130, 0.5)";
                    break;
                  case "log":
                  default:
                    e = "light" === t ? "rgba(125, 125, 125, 0.75)" : "rgba(125, 125, 125, 0.5)";
                }
                if (!e) throw Error("Console color is not defined");
                i(...(a = r, o = "color: " + e, null == a || 0 === a.length || "string" == typeof a[0] && a[0].match(/([^%]|^)(%c)/g) || void 0 === o ? a : "string" == typeof a[0] && a[0].match(/([^%]|^)((%%)*)(%([oOdisf]))/g) ? ["%c" + a[0], o, ...a.slice(1)] : [a.reduce((e, r, t) => {
                  switch (t > 0 && (e += " "), typeof r) {
                    case "string":
                    case "boolean":
                    case "symbol":
                      return e + "%s";
                    case "number":
                      return e + (Number.isInteger(r) ? "%i" : "%f");
                    default:
                      return e + "%o";
                  }
                }, "%c"), o, ...a]));
              }
              var a, o;
            };
          o.__REACT_DEVTOOLS_STRICT_MODE_ORIGINAL_METHOD__ = i, i.__REACT_DEVTOOLS_STRICT_MODE_OVERRIDE_METHOD__ = o, r[n] = o;
        } catch (e) {}
      });
    }
    let i = 0,
      o = !1;
    const s = [],
      l = [];
    function c(e) {
      const r = e.stack.split("\n");
      return r.length > 1 ? r[1] : null;
    }
    const u = {},
      f = new Map(),
      d = {},
      v = new Map(),
      h = {
        rendererInterfaces: f,
        listeners: d,
        renderers: v,
        emit: function (e, r) {
          d[e] && d[e].map(e => e(r));
        },
        getFiberRoots: function (e) {
          const r = u;
          return r[e] || (r[e] = new Set()), r[e];
        },
        inject: function (r) {
          const t = ++i;
          v.set(t, r);
          const n = o ? "deadcode" : function (e) {
            try {
              if ("string" == typeof e.version) return e.bundleType > 0 ? "development" : "production";
              const r = Function.prototype.toString;
              if (e.Mount && e.Mount._renderNewRootComponent) {
                const t = r.call(e.Mount._renderNewRootComponent);
                return 0 !== t.indexOf("function") ? "production" : -1 !== t.indexOf("storedMeasure") ? "development" : -1 !== t.indexOf("should be a pure function") ? -1 !== t.indexOf("NODE_ENV") || -1 !== t.indexOf("development") || -1 !== t.indexOf("true") ? "development" : -1 !== t.indexOf("nextElement") || -1 !== t.indexOf("nextComponent") ? "unminified" : "development" : -1 !== t.indexOf("nextElement") || -1 !== t.indexOf("nextComponent") ? "unminified" : "outdated";
              }
            } catch (e) {}
            return "production";
          }(r);
          try {
            Yr(r), Zr();
          } catch (e) {}
          const a = e.__REACT_DEVTOOLS_ATTACH__;
          if ("function" == typeof a) {
            const n = a(h, t, r, e);
            h.rendererInterfaces.set(t, n);
          }
          return h.emit("renderer", {
            id: t,
            renderer: r,
            reactBuildType: n
          }), t;
        },
        on: function (e, r) {
          d[e] || (d[e] = []), d[e].push(r);
        },
        off: function (e, r) {
          if (!d[e]) return;
          const t = d[e].indexOf(r);
          -1 !== t && d[e].splice(t, 1), d[e].length || delete d[e];
        },
        sub: function (e, r) {
          return h.on(e, r), () => h.off(e, r);
        },
        supportsFiber: !0,
        checkDCE: function (e) {
          try {
            const r = Function.prototype.toString;
            r.call(e).indexOf("^_^") > -1 && (o = !0, setTimeout(function () {
              throw new Error("React is running in production mode, but dead code elimination has not been applied. Read how to correctly configure React for production: https://reactjs.org/link/perf-use-production-build");
            }));
          } catch (e) {}
        },
        onCommitFiberUnmount: function (e, r) {
          const t = f.get(e);
          null != t && t.handleCommitFiberUnmount(r);
        },
        onCommitFiberRoot: function (e, r, t) {
          const n = h.getFiberRoots(e),
            a = r.current,
            i = n.has(r),
            o = null == a.memoizedState || null == a.memoizedState.element;
          i || o ? i && o && n.delete(r) : n.add(r);
          const s = f.get(e);
          null != s && s.handleCommitFiberRoot(r, t);
        },
        onPostCommitFiberRoot: function (e, r) {
          const t = f.get(e);
          null != t && t.handlePostCommitFiberRoot(r);
        },
        setStrictMode: function (e, r) {
          const t = f.get(e);
          if (null != t) r ? t.patchConsoleForStrictMode() : t.unpatchConsoleForStrictMode();else if (r) {
            a({
              hideConsoleLogsInStrictMode: !0 === window.__REACT_DEVTOOLS_HIDE_CONSOLE_LOGS_IN_STRICT_MODE__,
              browserTheme: window.__REACT_DEVTOOLS_BROWSER_THEME__
            });
          } else null !== n && (n(), n = null);
        },
        getInternalModuleRanges: function () {
          return l;
        },
        registerInternalModuleStart: function (e) {
          const r = c(e);
          null !== r && s.push(r);
        },
        registerInternalModuleStop: function (e) {
          if (s.length > 0) {
            const r = s.pop(),
              t = c(e);
            null !== t && l.push([r, t]);
          }
        }
      };
    Object.defineProperty(e, "__REACT_DEVTOOLS_GLOBAL_HOOK__", {
      configurable: !1,
      enumerable: !1,
      get: () => h
    });
  }(window);
  let fm = null,
    dm = "",
    vm = [],
    hm = (e, r) => {},
    mm = () => {};
  function _m() {
    return t.e(0).then(t.bind(null, 210));
  }
  let pm = null,
    gm = null,
    bm = null;
  const Sm = (...e) => console.log("[React DevTools]", ...e);
  function Em() {
    Object(i.flushSync)(() => {
      null !== bm && (bm.unmount(), bm = null);
    });
  }
  function wm() {
    Em(), fm.innerHTML = "", setTimeout(() => {
      bm = Object(o.createRoot)(fm), bm.render(Object(a.createElement)(am, {
        bridge: pm,
        canViewElementSourceFunction: ym,
        hookNamesModuleLoaderFunction: _m,
        showTabBar: !0,
        store: gm,
        warnIfLegacyBackendDetected: !0,
        viewElementSourceFunction: km
      }));
    }, 100);
  }
  function ym(e) {
    if (!1 === e.canViewSource || null === e.source) return !1;
    const {
      source: r
    } = e;
    return null !== cm(r.fileName, vm);
  }
  function km(e, r) {
    const {
      source: t
    } = r;
    null !== t ? um(t.fileName, t.lineNumber, vm) : Sm.error("Cannot inspect element", e);
  }
  function Cm() {
    Em(), fm.innerHTML = dm, mm();
  }
  function Dm({
    code: e,
    message: r
  }) {
    Em(), fm.innerHTML = "EADDRINUSE" === e ? "\n      <div class=\"box\">\n        <div class=\"box-header\">\n          Another instance of DevTools is running.\n        </div>\n        <div class=\"box-content\">\n          Only one copy of DevTools can be used at a time.\n        </div>\n      </div>\n    " : `\n      <div class="box">\n        <div class="box-header">\n          Unknown error\n        </div>\n        <div class="box-content">\n          ${r}\n        </div>\n      </div>\n    `;
  }
  function Am(e) {
    const r = [];
    e.onmessage = e => {
      let t;
      try {
        if ("string" != typeof e.data) throw Error();
        t = JSON.parse(e.data), v.F && function (e, ...r) {
          v.F && console.log("%c[core/standalone] %c" + e, "color: teal; font-weight: bold;", "font-weight: bold;", ...r);
        }("WebSocket.onmessage", t);
      } catch (r) {
        return void Sm.error("Failed to parse JSON", e.data);
      }
      r.forEach(e => {
        try {
          e(t);
        } catch (e) {
          throw Sm.error("Error calling listener", t), e;
        }
      });
    }, pm = new f({
      listen: e => (r.push(e), () => {
        const t = r.indexOf(e);
        t >= 0 && r.splice(t, 1);
      }),
      send(r, t, n) {
        e.readyState === e.OPEN && e.send(JSON.stringify({
          event: r,
          payload: t
        }));
      }
    }), pm.addListener("shutdown", () => {
      e.close();
    }), gm = new Ye(pm, {
      checkBridgeProtocolCompatibility: !0,
      supportsNativeInspection: !0,
      supportsTraceUpdates: !0
    }), Sm("Connected"), hm("DevTools initialized.", "devtools-connected"), wm();
  }
  Sm.warn = (...e) => console.warn("[React DevTools]", ...e), Sm.error = (...e) => console.error("[React DevTools]", ...e);
  let Mm = null;
  const xm = {
    connectToSocket: function (e) {
      return e.onerror = e => {
        Cm(), Sm.error("Error with websocket connection", e);
      }, e.onclose = () => {
        Cm(), Sm("Connection to RN closed");
      }, Am(e), {
        close: function () {
          Cm();
        }
      };
    },
    setContentDOMNode: function (e) {
      return fm = e, dm = fm.innerHTML, xm;
    },
    setProjectRoots: function (e) {
      vm = e;
    },
    setStatusListener: function (e) {
      return hm = e, xm;
    },
    setDisconnectedCallback: function (e) {
      return mm = e, xm;
    },
    startServer: function e(r = 8097, n = "localhost", a, i) {
      var o;
      er(null !== (o = null == i ? void 0 : i.surface) && void 0 !== o ? o : "standalone");
      const s = !!a,
        l = s ? t(77).createServer(a) : t(64).createServer(),
        c = new rr.Server({
          server: l
        });
      let u = null;
      return c.on("connection", e => {
        null !== u && (u.close(), Sm.warn("Only one connection allowed at a time.", "Closing the previous connection")), u = e, e.onerror = e => {
          u = null, Cm(), Sm.error("Error with websocket connection", e);
        }, e.onclose = () => {
          u = null, Cm(), Sm("Connection to RN closed");
        }, Am(e);
      }), c.on("error", t => {
        Dm(t), Sm.error("Failed to start the DevTools server", t), Mm = setTimeout(() => e(r), 1000);
      }), l.on("request", (e, t) => {
        const a = Object(nr.readFileSync)(Object(tr.join)(new URL(import.meta.url.slice(0, import.meta.url.lastIndexOf("/"))).pathname, "backend.js")),
          i = `\n      window.__REACT_DEVTOOLS_APPEND_COMPONENT_STACK__ = ${JSON.stringify(null === (u = H(b(v.m))) || void 0 === u || u)};\n      window.__REACT_DEVTOOLS_BREAK_ON_CONSOLE_ERRORS__ = ${JSON.stringify(null !== (c = H(b(v.n))) && void 0 !== c && c)};\n      window.__REACT_DEVTOOLS_COMPONENT_FILTERS__ = ${JSON.stringify(R())};\n      window.__REACT_DEVTOOLS_SHOW_INLINE_WARNINGS_AND_ERRORS__ = ${JSON.stringify(null === (l = H(b(v.o))) || void 0 === l || l)};\n      window.__REACT_DEVTOOLS_HIDE_CONSOLE_LOGS_IN_STRICT_MODE__ = ${JSON.stringify(null !== (o = H(b(v.j))) && void 0 !== o && o)};`;
        var o, l, c, u;
        t.end(i + "\n;" + a.toString() + "\n;" + `ReactDevToolsBackend.connectToDevTools({port: ${r}, host: '${n}', useHttps: ${s ? "true" : "false"}});`);
      }), l.on("error", t => {
        Dm(t), hm("Failed to start the server.", "error"), Mm = setTimeout(() => e(r), 1000);
      }), l.listen(r, () => {
        hm("The server is listening on the port " + r + ".", "server-connected");
      }), {
        close: function () {
          u = null, Cm(), null !== Mm && clearTimeout(Mm), c.close(), l.close();
        }
      };
    },
    openProfiler: function () {
      pm = new f({
        listen: () => {},
        send: () => {}
      }), gm = new Ye(pm, {}), S(v.i, JSON.stringify("profiler")), wm();
    }
  };
  r.default = xm;
}]);
//# sourceMappingURL=standalone.js.map
export default exports;